(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@deck.gl/core"), require("@deck.gl/geo-layers"), require("@deck.gl/google-maps"), require("@deck.gl/layers"), require("@ionic/core"), require("@ionic/vue"), require("dayjs"), require("dtg-firebase/modules/building"), require("dtg-firebase/modules/document"), require("dtg-firebase/modules/legal-obligation"), require("dtg-firebase/modules/report"), require("dtg-shared-report"), require("dtg-shared/composables/use-cancelable-action"), require("dtg-shared/composables/use-form"), require("dtg-shared/composables/use-injected-state"), require("dtg-shared/pdfjs"), require("dtg-shared/utils/array"), require("dtg-shared/utils/create-service"), require("dtg-shared/utils/date"), require("dtg-shared/utils/deferred"), require("dtg-shared/utils/double-raf"), require("dtg-shared/utils/event-to-prop-name"), require("dtg-shared/utils/format-bytes"), require("dtg-shared/utils/get-element-from-ref"), require("dtg-shared/utils/number"), require("dtg-shared/utils/object"), require("dtg-shared/utils/price"), require("dtg-shared/utils/promise"), require("dtg-shared/utils/prop-validator"), require("dtg-shared/utils/read-blob"), require("dtg-shared/utils/refs"), require("dtg-shared/utils/scroll"), require("dtg-shared/utils/string"), require("dtg-shared/utils/truthy"), require("dtg-shared/utils/wrap-pending"), require("dtg-shared/validation"), require("lodash/debounce"), require("lodash/escape"), require("lodash/escapeRegExp"), require("lodash/isEqual"), require("lodash/merge"), require("lodash/omit"), require("lodash/partition"), require("vue-router/dist/vue-router.mjs"), require("yup"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["@deck.gl/core", "@deck.gl/geo-layers", "@deck.gl/google-maps", "@deck.gl/layers", "@ionic/core", "@ionic/vue", "dayjs", "dtg-firebase/modules/building", "dtg-firebase/modules/document", "dtg-firebase/modules/legal-obligation", "dtg-firebase/modules/report", "dtg-shared-report", "dtg-shared/composables/use-cancelable-action", "dtg-shared/composables/use-form", "dtg-shared/composables/use-injected-state", "dtg-shared/pdfjs", "dtg-shared/utils/array", "dtg-shared/utils/create-service", "dtg-shared/utils/date", "dtg-shared/utils/deferred", "dtg-shared/utils/double-raf", "dtg-shared/utils/event-to-prop-name", "dtg-shared/utils/format-bytes", "dtg-shared/utils/get-element-from-ref", "dtg-shared/utils/number", "dtg-shared/utils/object", "dtg-shared/utils/price", "dtg-shared/utils/promise", "dtg-shared/utils/prop-validator", "dtg-shared/utils/read-blob", "dtg-shared/utils/refs", "dtg-shared/utils/scroll", "dtg-shared/utils/string", "dtg-shared/utils/truthy", "dtg-shared/utils/wrap-pending", "dtg-shared/validation", "lodash/debounce", "lodash/escape", "lodash/escapeRegExp", "lodash/isEqual", "lodash/merge", "lodash/omit", "lodash/partition", "vue-router/dist/vue-router.mjs", "yup", ], factory);
	else if(typeof exports === 'object')
		exports["dtg-components"] = factory(require("@deck.gl/core"), require("@deck.gl/geo-layers"), require("@deck.gl/google-maps"), require("@deck.gl/layers"), require("@ionic/core"), require("@ionic/vue"), require("dayjs"), require("dtg-firebase/modules/building"), require("dtg-firebase/modules/document"), require("dtg-firebase/modules/legal-obligation"), require("dtg-firebase/modules/report"), require("dtg-shared-report"), require("dtg-shared/composables/use-cancelable-action"), require("dtg-shared/composables/use-form"), require("dtg-shared/composables/use-injected-state"), require("dtg-shared/pdfjs"), require("dtg-shared/utils/array"), require("dtg-shared/utils/create-service"), require("dtg-shared/utils/date"), require("dtg-shared/utils/deferred"), require("dtg-shared/utils/double-raf"), require("dtg-shared/utils/event-to-prop-name"), require("dtg-shared/utils/format-bytes"), require("dtg-shared/utils/get-element-from-ref"), require("dtg-shared/utils/number"), require("dtg-shared/utils/object"), require("dtg-shared/utils/price"), require("dtg-shared/utils/promise"), require("dtg-shared/utils/prop-validator"), require("dtg-shared/utils/read-blob"), require("dtg-shared/utils/refs"), require("dtg-shared/utils/scroll"), require("dtg-shared/utils/string"), require("dtg-shared/utils/truthy"), require("dtg-shared/utils/wrap-pending"), require("dtg-shared/validation"), require("lodash/debounce"), require("lodash/escape"), require("lodash/escapeRegExp"), require("lodash/isEqual"), require("lodash/merge"), require("lodash/omit"), require("lodash/partition"), require("vue-router/dist/vue-router.mjs"), require("yup"), require("vue"));
	else
		root["dtg-components"] = factory(root["@deck.gl/core"], root["@deck.gl/geo-layers"], root["@deck.gl/google-maps"], root["@deck.gl/layers"], root["@ionic/core"], root["@ionic/vue"], root["dayjs"], root["dtg-firebase/modules/building"], root["dtg-firebase/modules/document"], root["dtg-firebase/modules/legal-obligation"], root["dtg-firebase/modules/report"], root["dtg-shared-report"], root["dtg-shared/composables/use-cancelable-action"], root["dtg-shared/composables/use-form"], root["dtg-shared/composables/use-injected-state"], root["dtg-shared/pdfjs"], root["dtg-shared/utils/array"], root["dtg-shared/utils/create-service"], root["dtg-shared/utils/date"], root["dtg-shared/utils/deferred"], root["dtg-shared/utils/double-raf"], root["dtg-shared/utils/event-to-prop-name"], root["dtg-shared/utils/format-bytes"], root["dtg-shared/utils/get-element-from-ref"], root["dtg-shared/utils/number"], root["dtg-shared/utils/object"], root["dtg-shared/utils/price"], root["dtg-shared/utils/promise"], root["dtg-shared/utils/prop-validator"], root["dtg-shared/utils/read-blob"], root["dtg-shared/utils/refs"], root["dtg-shared/utils/scroll"], root["dtg-shared/utils/string"], root["dtg-shared/utils/truthy"], root["dtg-shared/utils/wrap-pending"], root["dtg-shared/validation"], root["lodash/debounce"], root["lodash/escape"], root["lodash/escapeRegExp"], root["lodash/isEqual"], root["lodash/merge"], root["lodash/omit"], root["lodash/partition"], root["vue-router/dist/vue-router.mjs"], root["yup"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__5360__, __WEBPACK_EXTERNAL_MODULE__8529__, __WEBPACK_EXTERNAL_MODULE__7684__, __WEBPACK_EXTERNAL_MODULE__9241__, __WEBPACK_EXTERNAL_MODULE__9640__, __WEBPACK_EXTERNAL_MODULE__2613__, __WEBPACK_EXTERNAL_MODULE__9185__, __WEBPACK_EXTERNAL_MODULE__1088__, __WEBPACK_EXTERNAL_MODULE__2161__, __WEBPACK_EXTERNAL_MODULE__1152__, __WEBPACK_EXTERNAL_MODULE__422__, __WEBPACK_EXTERNAL_MODULE__8502__, __WEBPACK_EXTERNAL_MODULE__3750__, __WEBPACK_EXTERNAL_MODULE__7165__, __WEBPACK_EXTERNAL_MODULE__535__, __WEBPACK_EXTERNAL_MODULE__1031__, __WEBPACK_EXTERNAL_MODULE__7749__, __WEBPACK_EXTERNAL_MODULE__8334__, __WEBPACK_EXTERNAL_MODULE__9488__, __WEBPACK_EXTERNAL_MODULE__4223__, __WEBPACK_EXTERNAL_MODULE__4949__, __WEBPACK_EXTERNAL_MODULE__1600__, __WEBPACK_EXTERNAL_MODULE__3993__, __WEBPACK_EXTERNAL_MODULE__9848__, __WEBPACK_EXTERNAL_MODULE__2249__, __WEBPACK_EXTERNAL_MODULE__7055__, __WEBPACK_EXTERNAL_MODULE__5213__, __WEBPACK_EXTERNAL_MODULE__5661__, __WEBPACK_EXTERNAL_MODULE__1718__, __WEBPACK_EXTERNAL_MODULE__6156__, __WEBPACK_EXTERNAL_MODULE__7614__, __WEBPACK_EXTERNAL_MODULE__3021__, __WEBPACK_EXTERNAL_MODULE__5933__, __WEBPACK_EXTERNAL_MODULE__2160__, __WEBPACK_EXTERNAL_MODULE__1334__, __WEBPACK_EXTERNAL_MODULE__4457__, __WEBPACK_EXTERNAL_MODULE__5257__, __WEBPACK_EXTERNAL_MODULE__4297__, __WEBPACK_EXTERNAL_MODULE__1460__, __WEBPACK_EXTERNAL_MODULE__2162__, __WEBPACK_EXTERNAL_MODULE__9374__, __WEBPACK_EXTERNAL_MODULE__3895__, __WEBPACK_EXTERNAL_MODULE__9172__, __WEBPACK_EXTERNAL_MODULE__4076__, __WEBPACK_EXTERNAL_MODULE__474__, __WEBPACK_EXTERNAL_MODULE__9274__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 462
(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * @module helpers
 */
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */
exports.earthRadius = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 *
 * @memberof helpers
 * @type {Object}
 */
exports.factors = {
    centimeters: exports.earthRadius * 100,
    centimetres: exports.earthRadius * 100,
    degrees: exports.earthRadius / 111325,
    feet: exports.earthRadius * 3.28084,
    inches: exports.earthRadius * 39.37,
    kilometers: exports.earthRadius / 1000,
    kilometres: exports.earthRadius / 1000,
    meters: exports.earthRadius,
    metres: exports.earthRadius,
    miles: exports.earthRadius / 1609.344,
    millimeters: exports.earthRadius * 1000,
    millimetres: exports.earthRadius * 1000,
    nauticalmiles: exports.earthRadius / 1852,
    radians: 1,
    yards: exports.earthRadius * 1.0936,
};
/**
 * Units of measurement factors based on 1 meter.
 *
 * @memberof helpers
 * @type {Object}
 */
exports.unitsFactors = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 1 / 1000,
    kilometres: 1 / 1000,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / exports.earthRadius,
    yards: 1.0936133,
};
/**
 * Area of measurement factors based on 1 square meter.
 *
 * @memberof helpers
 * @type {Object}
 */
exports.areaFactors = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046,
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */
function feature(geom, properties, options) {
    if (options === void 0) { options = {}; }
    var feat = { type: "Feature" };
    if (options.id === 0 || options.id) {
        feat.id = options.id;
    }
    if (options.bbox) {
        feat.bbox = options.bbox;
    }
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
exports.feature = feature;
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<any>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = "Point";
 * var coordinates = [110, 50];
 * var geometry = turf.geometry(type, coordinates);
 * // => geometry
 */
function geometry(type, coordinates, _options) {
    if (_options === void 0) { _options = {}; }
    switch (type) {
        case "Point":
            return point(coordinates).geometry;
        case "LineString":
            return lineString(coordinates).geometry;
        case "Polygon":
            return polygon(coordinates).geometry;
        case "MultiPoint":
            return multiPoint(coordinates).geometry;
        case "MultiLineString":
            return multiLineString(coordinates).geometry;
        case "MultiPolygon":
            return multiPolygon(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
exports.geometry = geometry;
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */
function point(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    if (!coordinates) {
        throw new Error("coordinates is required");
    }
    if (!Array.isArray(coordinates)) {
        throw new Error("coordinates must be an Array");
    }
    if (coordinates.length < 2) {
        throw new Error("coordinates must be at least 2 numbers long");
    }
    if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) {
        throw new Error("coordinates must contain numbers");
    }
    var geom = {
        type: "Point",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.point = point;
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */
function points(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return point(coords, properties);
    }), options);
}
exports.points = points;
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */
function polygon(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
        var ring = coordinates_1[_i];
        if (ring.length < 4) {
            throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        }
        for (var j = 0; j < ring[ring.length - 1].length; j++) {
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) {
                throw new Error("First and last Position are not equivalent.");
            }
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.polygon = polygon;
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */
function polygons(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return polygon(coords, properties);
    }), options);
}
exports.polygons = polygons;
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */
function lineString(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    if (coordinates.length < 2) {
        throw new Error("coordinates must be an array of two or more positions");
    }
    var geom = {
        type: "LineString",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.lineString = lineString;
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */
function lineStrings(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return lineString(coords, properties);
    }), options);
}
exports.lineStrings = lineStrings;
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */
function featureCollection(features, options) {
    if (options === void 0) { options = {}; }
    var fc = { type: "FeatureCollection" };
    if (options.id) {
        fc.id = options.id;
    }
    if (options.bbox) {
        fc.bbox = options.bbox;
    }
    fc.features = features;
    return fc;
}
exports.featureCollection = featureCollection;
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */
function multiLineString(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.multiLineString = multiLineString;
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */
function multiPoint(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.multiPoint = multiPoint;
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */
function multiPolygon(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.multiPolygon = multiPolygon;
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = turf.geometry("Point", [100, 0]);
 * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
 * var collection = turf.geometryCollection([pt, line]);
 *
 * // => collection
 */
function geometryCollection(geometries, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "GeometryCollection",
        geometries: geometries,
    };
    return feature(geom, properties, options);
}
exports.geometryCollection = geometryCollection;
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */
function round(num, precision) {
    if (precision === void 0) { precision = 0; }
    if (precision && !(precision >= 0)) {
        throw new Error("precision must be a positive number");
    }
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
exports.round = round;
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} distance
 */
function radiansToLength(radians, units) {
    if (units === void 0) { units = "kilometers"; }
    var factor = exports.factors[units];
    if (!factor) {
        throw new Error(units + " units is invalid");
    }
    return radians * factor;
}
exports.radiansToLength = radiansToLength;
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} radians
 */
function lengthToRadians(distance, units) {
    if (units === void 0) { units = "kilometers"; }
    var factor = exports.factors[units];
    if (!factor) {
        throw new Error(units + " units is invalid");
    }
    return distance / factor;
}
exports.lengthToRadians = lengthToRadians;
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} degrees
 */
function lengthToDegrees(distance, units) {
    return radiansToDegrees(lengthToRadians(distance, units));
}
exports.lengthToDegrees = lengthToDegrees;
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */
function bearingToAzimuth(bearing) {
    var angle = bearing % 360;
    if (angle < 0) {
        angle += 360;
    }
    return angle;
}
exports.bearingToAzimuth = bearingToAzimuth;
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */
function radiansToDegrees(radians) {
    var degrees = radians % (2 * Math.PI);
    return (degrees * 180) / Math.PI;
}
exports.radiansToDegrees = radiansToDegrees;
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */
function degreesToRadians(degrees) {
    var radians = degrees % 360;
    return (radians * Math.PI) / 180;
}
exports.degreesToRadians = degreesToRadians;
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {Units} [originalUnit="kilometers"] of the length
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted length
 */
function convertLength(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) { originalUnit = "kilometers"; }
    if (finalUnit === void 0) { finalUnit = "kilometers"; }
    if (!(length >= 0)) {
        throw new Error("length must be a positive number");
    }
    return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
}
exports.convertLength = convertLength;
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches, hectares
 * @param {number} area to be converted
 * @param {Units} [originalUnit="meters"] of the distance
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted area
 */
function convertArea(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) { originalUnit = "meters"; }
    if (finalUnit === void 0) { finalUnit = "kilometers"; }
    if (!(area >= 0)) {
        throw new Error("area must be a positive number");
    }
    var startFactor = exports.areaFactors[originalUnit];
    if (!startFactor) {
        throw new Error("invalid original units");
    }
    var finalFactor = exports.areaFactors[finalUnit];
    if (!finalFactor) {
        throw new Error("invalid final units");
    }
    return (area / startFactor) * finalFactor;
}
exports.convertArea = convertArea;
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */
function isNumber(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
exports.isNumber = isNumber;
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */
function isObject(input) {
    return !!input && input.constructor === Object;
}
exports.isObject = isObject;
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */
function validateBBox(bbox) {
    if (!bbox) {
        throw new Error("bbox is required");
    }
    if (!Array.isArray(bbox)) {
        throw new Error("bbox must be an Array");
    }
    if (bbox.length !== 4 && bbox.length !== 6) {
        throw new Error("bbox must be an Array of 4 or 6 numbers");
    }
    bbox.forEach(function (num) {
        if (!isNumber(num)) {
            throw new Error("bbox must only contain numbers");
        }
    });
}
exports.validateBBox = validateBBox;
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */
function validateId(id) {
    if (!id) {
        throw new Error("id is required");
    }
    if (["string", "number"].indexOf(typeof id) === -1) {
        throw new Error("id must be a number or a string");
    }
}
exports.validateId = validateId;


/***/ },

/***/ 4262
(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var helpers = __webpack_require__(462);

/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */

/**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */
function coordEach(geojson, callback, excludeWrapCoord) {
  // Handles null Geometry -- Skips this GeoJSON
  if (geojson === null) return;
  var j,
    k,
    l,
    geometry,
    stopG,
    coords,
    geometryMaybeCollection,
    wrapShrink = 0,
    coordIndex = 0,
    isGeometryCollection,
    type = geojson.type,
    isFeatureCollection = type === "FeatureCollection",
    isFeature = type === "Feature",
    stop = isFeatureCollection ? geojson.features.length : 1;

  // This logic may look a little weird. The reason why it is that way
  // is because it's trying to be fast. GeoJSON supports multiple kinds
  // of objects at its root: FeatureCollection, Features, Geometries.
  // This function has the responsibility of handling all of them, and that
  // means that some of the `for` loops you see below actually just don't apply
  // to certain inputs. For instance, if you give this just a
  // Point geometry, then both loops are short-circuited and all we do
  // is gradually rename the input until it's called 'geometry'.
  //
  // This also aims to allocate as few resources as possible: just a
  // few numbers and booleans, rather than any temporary arrays as would
  // be required with the normalization approach.
  for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
    geometryMaybeCollection = isFeatureCollection
      ? geojson.features[featureIndex].geometry
      : isFeature
      ? geojson.geometry
      : geojson;
    isGeometryCollection = geometryMaybeCollection
      ? geometryMaybeCollection.type === "GeometryCollection"
      : false;
    stopG = isGeometryCollection
      ? geometryMaybeCollection.geometries.length
      : 1;

    for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
      var multiFeatureIndex = 0;
      var geometryIndex = 0;
      geometry = isGeometryCollection
        ? geometryMaybeCollection.geometries[geomIndex]
        : geometryMaybeCollection;

      // Handles null Geometry -- Skips this geometry
      if (geometry === null) continue;
      coords = geometry.coordinates;
      var geomType = geometry.type;

      wrapShrink =
        excludeWrapCoord &&
        (geomType === "Polygon" || geomType === "MultiPolygon")
          ? 1
          : 0;

      switch (geomType) {
        case null:
          break;
        case "Point":
          if (
            callback(
              coords,
              coordIndex,
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false
          )
            return false;
          coordIndex++;
          multiFeatureIndex++;
          break;
        case "LineString":
        case "MultiPoint":
          for (j = 0; j < coords.length; j++) {
            if (
              callback(
                coords[j],
                coordIndex,
                featureIndex,
                multiFeatureIndex,
                geometryIndex
              ) === false
            )
              return false;
            coordIndex++;
            if (geomType === "MultiPoint") multiFeatureIndex++;
          }
          if (geomType === "LineString") multiFeatureIndex++;
          break;
        case "Polygon":
        case "MultiLineString":
          for (j = 0; j < coords.length; j++) {
            for (k = 0; k < coords[j].length - wrapShrink; k++) {
              if (
                callback(
                  coords[j][k],
                  coordIndex,
                  featureIndex,
                  multiFeatureIndex,
                  geometryIndex
                ) === false
              )
                return false;
              coordIndex++;
            }
            if (geomType === "MultiLineString") multiFeatureIndex++;
            if (geomType === "Polygon") geometryIndex++;
          }
          if (geomType === "Polygon") multiFeatureIndex++;
          break;
        case "MultiPolygon":
          for (j = 0; j < coords.length; j++) {
            geometryIndex = 0;
            for (k = 0; k < coords[j].length; k++) {
              for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
                if (
                  callback(
                    coords[j][k][l],
                    coordIndex,
                    featureIndex,
                    multiFeatureIndex,
                    geometryIndex
                  ) === false
                )
                  return false;
                coordIndex++;
              }
              geometryIndex++;
            }
            multiFeatureIndex++;
          }
          break;
        case "GeometryCollection":
          for (j = 0; j < geometry.geometries.length; j++)
            if (
              coordEach(geometry.geometries[j], callback, excludeWrapCoord) ===
              false
            )
              return false;
          break;
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
  }
}

/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */

/**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */
function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
  var previousValue = initialValue;
  coordEach(
    geojson,
    function (
      currentCoord,
      coordIndex,
      featureIndex,
      multiFeatureIndex,
      geometryIndex
    ) {
      if (coordIndex === 0 && initialValue === undefined)
        previousValue = currentCoord;
      else
        previousValue = callback(
          previousValue,
          currentCoord,
          coordIndex,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    },
    excludeWrapCoord
  );
  return previousValue;
}

/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */
function propEach(geojson, callback) {
  var i;
  switch (geojson.type) {
    case "FeatureCollection":
      for (i = 0; i < geojson.features.length; i++) {
        if (callback(geojson.features[i].properties, i) === false) break;
      }
      break;
    case "Feature":
      callback(geojson.properties, 0);
      break;
  }
}

/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */
function propReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  propEach(geojson, function (currentProperties, featureIndex) {
    if (featureIndex === 0 && initialValue === undefined)
      previousValue = currentProperties;
    else
      previousValue = callback(previousValue, currentProperties, featureIndex);
  });
  return previousValue;
}

/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */
function featureEach(geojson, callback) {
  if (geojson.type === "Feature") {
    callback(geojson, 0);
  } else if (geojson.type === "FeatureCollection") {
    for (var i = 0; i < geojson.features.length; i++) {
      if (callback(geojson.features[i], i) === false) break;
    }
  }
}

/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */
function featureReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  featureEach(geojson, function (currentFeature, featureIndex) {
    if (featureIndex === 0 && initialValue === undefined)
      previousValue = currentFeature;
    else previousValue = callback(previousValue, currentFeature, featureIndex);
  });
  return previousValue;
}

/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */
function coordAll(geojson) {
  var coords = [];
  coordEach(geojson, function (coord) {
    coords.push(coord);
  });
  return coords;
}

/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */

/**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */
function geomEach(geojson, callback) {
  var i,
    j,
    g,
    geometry,
    stopG,
    geometryMaybeCollection,
    isGeometryCollection,
    featureProperties,
    featureBBox,
    featureId,
    featureIndex = 0,
    isFeatureCollection = geojson.type === "FeatureCollection",
    isFeature = geojson.type === "Feature",
    stop = isFeatureCollection ? geojson.features.length : 1;

  // This logic may look a little weird. The reason why it is that way
  // is because it's trying to be fast. GeoJSON supports multiple kinds
  // of objects at its root: FeatureCollection, Features, Geometries.
  // This function has the responsibility of handling all of them, and that
  // means that some of the `for` loops you see below actually just don't apply
  // to certain inputs. For instance, if you give this just a
  // Point geometry, then both loops are short-circuited and all we do
  // is gradually rename the input until it's called 'geometry'.
  //
  // This also aims to allocate as few resources as possible: just a
  // few numbers and booleans, rather than any temporary arrays as would
  // be required with the normalization approach.
  for (i = 0; i < stop; i++) {
    geometryMaybeCollection = isFeatureCollection
      ? geojson.features[i].geometry
      : isFeature
      ? geojson.geometry
      : geojson;
    featureProperties = isFeatureCollection
      ? geojson.features[i].properties
      : isFeature
      ? geojson.properties
      : {};
    featureBBox = isFeatureCollection
      ? geojson.features[i].bbox
      : isFeature
      ? geojson.bbox
      : undefined;
    featureId = isFeatureCollection
      ? geojson.features[i].id
      : isFeature
      ? geojson.id
      : undefined;
    isGeometryCollection = geometryMaybeCollection
      ? geometryMaybeCollection.type === "GeometryCollection"
      : false;
    stopG = isGeometryCollection
      ? geometryMaybeCollection.geometries.length
      : 1;

    for (g = 0; g < stopG; g++) {
      geometry = isGeometryCollection
        ? geometryMaybeCollection.geometries[g]
        : geometryMaybeCollection;

      // Handle null Geometry
      if (geometry === null) {
        if (
          callback(
            null,
            featureIndex,
            featureProperties,
            featureBBox,
            featureId
          ) === false
        )
          return false;
        continue;
      }
      switch (geometry.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (
            callback(
              geometry,
              featureIndex,
              featureProperties,
              featureBBox,
              featureId
            ) === false
          )
            return false;
          break;
        }
        case "GeometryCollection": {
          for (j = 0; j < geometry.geometries.length; j++) {
            if (
              callback(
                geometry.geometries[j],
                featureIndex,
                featureProperties,
                featureBBox,
                featureId
              ) === false
            )
              return false;
          }
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    // Only increase `featureIndex` per each feature
    featureIndex++;
  }
}

/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */

/**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */
function geomReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  geomEach(
    geojson,
    function (
      currentGeometry,
      featureIndex,
      featureProperties,
      featureBBox,
      featureId
    ) {
      if (featureIndex === 0 && initialValue === undefined)
        previousValue = currentGeometry;
      else
        previousValue = callback(
          previousValue,
          currentGeometry,
          featureIndex,
          featureProperties,
          featureBBox,
          featureId
        );
    }
  );
  return previousValue;
}

/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */

/**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */
function flattenEach(geojson, callback) {
  geomEach(geojson, function (geometry, featureIndex, properties, bbox, id) {
    // Callback for single geometry
    var type = geometry === null ? null : geometry.type;
    switch (type) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        if (
          callback(
            helpers.feature(geometry, properties, { bbox: bbox, id: id }),
            featureIndex,
            0
          ) === false
        )
          return false;
        return;
    }

    var geomType;

    // Callback for multi-geometry
    switch (type) {
      case "MultiPoint":
        geomType = "Point";
        break;
      case "MultiLineString":
        geomType = "LineString";
        break;
      case "MultiPolygon":
        geomType = "Polygon";
        break;
    }

    for (
      var multiFeatureIndex = 0;
      multiFeatureIndex < geometry.coordinates.length;
      multiFeatureIndex++
    ) {
      var coordinate = geometry.coordinates[multiFeatureIndex];
      var geom = {
        type: geomType,
        coordinates: coordinate,
      };
      if (
        callback(helpers.feature(geom, properties), featureIndex, multiFeatureIndex) ===
        false
      )
        return false;
    }
  });
}

/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */

/**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */
function flattenReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  flattenEach(
    geojson,
    function (currentFeature, featureIndex, multiFeatureIndex) {
      if (
        featureIndex === 0 &&
        multiFeatureIndex === 0 &&
        initialValue === undefined
      )
        previousValue = currentFeature;
      else
        previousValue = callback(
          previousValue,
          currentFeature,
          featureIndex,
          multiFeatureIndex
        );
    }
  );
  return previousValue;
}

/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */

/**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */
function segmentEach(geojson, callback) {
  flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
    var segmentIndex = 0;

    // Exclude null Geometries
    if (!feature.geometry) return;
    // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
    var type = feature.geometry.type;
    if (type === "Point" || type === "MultiPoint") return;

    // Generate 2-vertex line segments
    var previousCoords;
    var previousFeatureIndex = 0;
    var previousMultiIndex = 0;
    var prevGeomIndex = 0;
    if (
      coordEach(
        feature,
        function (
          currentCoord,
          coordIndex,
          featureIndexCoord,
          multiPartIndexCoord,
          geometryIndex
        ) {
          // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
          if (
            previousCoords === undefined ||
            featureIndex > previousFeatureIndex ||
            multiPartIndexCoord > previousMultiIndex ||
            geometryIndex > prevGeomIndex
          ) {
            previousCoords = currentCoord;
            previousFeatureIndex = featureIndex;
            previousMultiIndex = multiPartIndexCoord;
            prevGeomIndex = geometryIndex;
            segmentIndex = 0;
            return;
          }
          var currentSegment = helpers.lineString(
            [previousCoords, currentCoord],
            feature.properties
          );
          if (
            callback(
              currentSegment,
              featureIndex,
              multiFeatureIndex,
              geometryIndex,
              segmentIndex
            ) === false
          )
            return false;
          segmentIndex++;
          previousCoords = currentCoord;
        }
      ) === false
    )
      return false;
  });
}

/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */

/**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentIndex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */
function segmentReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  var started = false;
  segmentEach(
    geojson,
    function (
      currentSegment,
      featureIndex,
      multiFeatureIndex,
      geometryIndex,
      segmentIndex
    ) {
      if (started === false && initialValue === undefined)
        previousValue = currentSegment;
      else
        previousValue = callback(
          previousValue,
          currentSegment,
          featureIndex,
          multiFeatureIndex,
          geometryIndex,
          segmentIndex
        );
      started = true;
    }
  );
  return previousValue;
}

/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */

/**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */
function lineEach(geojson, callback) {
  // validation
  if (!geojson) throw new Error("geojson is required");

  flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
    if (feature.geometry === null) return;
    var type = feature.geometry.type;
    var coords = feature.geometry.coordinates;
    switch (type) {
      case "LineString":
        if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false)
          return false;
        break;
      case "Polygon":
        for (
          var geometryIndex = 0;
          geometryIndex < coords.length;
          geometryIndex++
        ) {
          if (
            callback(
              helpers.lineString(coords[geometryIndex], feature.properties),
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false
          )
            return false;
        }
        break;
    }
  });
}

/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */

/**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */
function lineReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  lineEach(
    geojson,
    function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
      if (featureIndex === 0 && initialValue === undefined)
        previousValue = currentLine;
      else
        previousValue = callback(
          previousValue,
          currentLine,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    }
  );
  return previousValue;
}

/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */
function findSegment(geojson, options) {
  // Optional Parameters
  options = options || {};
  if (!helpers.isObject(options)) throw new Error("options is invalid");
  var featureIndex = options.featureIndex || 0;
  var multiFeatureIndex = options.multiFeatureIndex || 0;
  var geometryIndex = options.geometryIndex || 0;
  var segmentIndex = options.segmentIndex || 0;

  // Find FeatureIndex
  var properties = options.properties;
  var geometry;

  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }

  // Find SegmentIndex
  if (geometry === null) return null;
  var coords = geometry.coordinates;
  switch (geometry.type) {
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
      if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
      return helpers.lineString(
        [coords[segmentIndex], coords[segmentIndex + 1]],
        properties,
        options
      );
    case "Polygon":
      if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
      return helpers.lineString(
        [
          coords[geometryIndex][segmentIndex],
          coords[geometryIndex][segmentIndex + 1],
        ],
        properties,
        options
      );
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
      return helpers.lineString(
        [
          coords[multiFeatureIndex][segmentIndex],
          coords[multiFeatureIndex][segmentIndex + 1],
        ],
        properties,
        options
      );
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex =
          coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
      return helpers.lineString(
        [
          coords[multiFeatureIndex][geometryIndex][segmentIndex],
          coords[multiFeatureIndex][geometryIndex][segmentIndex + 1],
        ],
        properties,
        options
      );
  }
  throw new Error("geojson is invalid");
}

/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */
function findPoint(geojson, options) {
  // Optional Parameters
  options = options || {};
  if (!helpers.isObject(options)) throw new Error("options is invalid");
  var featureIndex = options.featureIndex || 0;
  var multiFeatureIndex = options.multiFeatureIndex || 0;
  var geometryIndex = options.geometryIndex || 0;
  var coordIndex = options.coordIndex || 0;

  // Find FeatureIndex
  var properties = options.properties;
  var geometry;

  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }

  // Find Coord Index
  if (geometry === null) return null;
  var coords = geometry.coordinates;
  switch (geometry.type) {
    case "Point":
      return helpers.point(coords, properties, options);
    case "MultiPoint":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      return helpers.point(coords[multiFeatureIndex], properties, options);
    case "LineString":
      if (coordIndex < 0) coordIndex = coords.length + coordIndex;
      return helpers.point(coords[coordIndex], properties, options);
    case "Polygon":
      if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
      if (coordIndex < 0)
        coordIndex = coords[geometryIndex].length + coordIndex;
      return helpers.point(coords[geometryIndex][coordIndex], properties, options);
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (coordIndex < 0)
        coordIndex = coords[multiFeatureIndex].length + coordIndex;
      return helpers.point(coords[multiFeatureIndex][coordIndex], properties, options);
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (coordIndex < 0)
        coordIndex =
          coords[multiFeatureIndex][geometryIndex].length - coordIndex;
      return helpers.point(
        coords[multiFeatureIndex][geometryIndex][coordIndex],
        properties,
        options
      );
  }
  throw new Error("geojson is invalid");
}

exports.coordAll = coordAll;
exports.coordEach = coordEach;
exports.coordReduce = coordReduce;
exports.featureEach = featureEach;
exports.featureReduce = featureReduce;
exports.findPoint = findPoint;
exports.findSegment = findSegment;
exports.flattenEach = flattenEach;
exports.flattenReduce = flattenReduce;
exports.geomEach = geomEach;
exports.geomReduce = geomReduce;
exports.lineEach = lineEach;
exports.lineReduce = lineReduce;
exports.propEach = propEach;
exports.propReduce = propReduce;
exports.segmentEach = segmentEach;
exports.segmentReduce = segmentReduce;


/***/ },

/***/ 611
(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var isDev = "production" !== 'production';
var settings = {
    elementDelimiter: '__',
    modifierDelimiter: '_',
    throwOnError: false
};
/**
 * Base function for bem naming with css modules
 * @param {Object} cssModule. Imported css module
 * @param {String} name. BEM name
 * @param {String} [element]
 * @param {Object} [mods]
 * @param {Object} [states]
 * @return {String}
 */
function block(cssModule, name, elementParam, modsParam, statesParam) {
    var isElementAsModes = elementParam && typeof elementParam === 'object';
    var mods = isElementAsModes ? elementParam : modsParam;
    var states = isElementAsModes ? modsParam : statesParam;
    var element = isElementAsModes ? '' : elementParam;
    var modifierDelimiter = settings.modifierDelimiter, elementDelimiter = settings.elementDelimiter, throwOnError = settings.throwOnError;
    var baseBlock = element ? "".concat(name).concat(elementDelimiter).concat(element) : name;
    var result = cssModule[baseBlock] || '';
    if (isDev && (!result && !mods)) {
        var message = "There is no ".concat(name).concat(elementDelimiter).concat(element, " in cssModule");
        if (throwOnError) {
            throw Error(message);
        }
        else {
            /* eslint-disable-next-line no-console */
            console.warn(message);
            return '';
        }
    }
    if (mods) {
        result = Object.keys(mods)
            .reduce(function (acc, next) {
            var modValue = mods[next];
            var mod;
            if (modValue === undefined) {
                return acc;
            }
            if (typeof modValue === 'boolean') {
                if (isDev && !("".concat(baseBlock).concat(modifierDelimiter).concat(next) in cssModule)) {
                    var message = "There is no ".concat(baseBlock).concat(modifierDelimiter).concat(next, " in cssModule");
                    if (throwOnError) {
                        throw Error(message);
                    }
                    else {
                        /* eslint-disable-next-line no-console */
                        console.warn(message);
                        return acc;
                    }
                }
                if (modValue) {
                    mod = cssModule["".concat(baseBlock).concat(modifierDelimiter).concat(next)];
                }
                else {
                    return acc;
                }
            }
            else {
                var currentMode = "".concat(baseBlock).concat(modifierDelimiter).concat(next).concat(modifierDelimiter).concat(mods[next]);
                if (isDev && !(currentMode in cssModule)) {
                    var message = "There is no ".concat(currentMode, " in cssModule");
                    if (throwOnError) {
                        throw Error(message);
                    }
                    else {
                        /* eslint-disable-next-line no-console */
                        console.warn(message);
                        return acc;
                    }
                }
                mod = cssModule[currentMode];
            }
            return "".concat(acc, " ").concat(mod);
        }, result);
    }
    if (states) {
        result = Object.keys(states)
            .reduce(function (acc, next) {
            if (!states[next]) {
                return acc;
            }
            var state = cssModule["is-".concat(next)];
            if (!state) {
                var message = "There is no is-".concat(next, " in cssModule");
                if (throwOnError) {
                    throw Error(message);
                }
                else {
                    /* eslint-disable-next-line no-console */
                    console.warn(message);
                    return acc;
                }
            }
            return "".concat(acc, " ").concat(state);
        }, result);
    }
    return result.trim();
}
var extractModuleName = function (cssModule) {
    if (isDev && (!cssModule || typeof cssModule !== 'object' || Array.isArray(cssModule))) {
        var message = 'cssModule object should be an Object with keys';
        if (settings.throwOnError) {
            throw Error(message);
        }
        else {
            /* eslint-disable-next-line no-console */
            console.warn(message);
            return '';
        }
    }
    var name = Object.keys(cssModule)[0];
    if (isDev && !name) {
        var message = 'cssModule has no keys';
        if (settings.throwOnError) {
            throw Error(message);
        }
        else {
            /* eslint-disable-next-line no-console */
            console.warn(message);
            return '';
        }
    }
    var indexElement = name.indexOf(settings.elementDelimiter);
    if (indexElement !== -1) {
        name = name.slice(0, indexElement);
    }
    var indexModifier = name.indexOf(settings.modifierDelimiter);
    if (indexModifier !== -1) {
        name = name.slice(0, indexModifier);
    }
    return name;
};
var bem = function (cssModule, name) {
    return block.bind(null, cssModule, name || extractModuleName(cssModule));
};
bem.setSettings = function (newSettings) {
    return Object.assign(settings, newSettings);
};
exports.A = bem;


/***/ },

/***/ 8165
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(9138);

var $apply = __webpack_require__(6095);
var $call = __webpack_require__(4531);
var $reflectApply = __webpack_require__(7196);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ },

/***/ 2012
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(9138);
var $apply = __webpack_require__(6095);
var actualApply = __webpack_require__(8165);

/** @type {import('./applyBind')} */
module.exports = function applyBind() {
	return actualApply(bind, $apply, arguments);
};


/***/ },

/***/ 6095
(module) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ },

/***/ 4531
(module) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ },

/***/ 9903
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(9138);
var $TypeError = __webpack_require__(3468);

var $call = __webpack_require__(4531);
var $actualApply = __webpack_require__(8165);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ },

/***/ 7196
(module) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ },

/***/ 8498
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var setFunctionLength = __webpack_require__(6108);

var $defineProperty = __webpack_require__(4940);

var callBindBasic = __webpack_require__(9903);
var applyBind = __webpack_require__(2012);

module.exports = function callBind(originalFunction) {
	var func = callBindBasic(arguments);
	var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
	return setFunctionLength(
		func,
		adjustedLength > 0 ? adjustedLength : 0,
		true
	);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ },

/***/ 4607
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(528);

var callBindBasic = __webpack_require__(9903);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ },

/***/ 4969
(module, __unused_webpack_exports, __webpack_require__) {

var objectKeys = __webpack_require__(9228);
var isArguments = __webpack_require__(5387);
var is = __webpack_require__(5968);
var isRegex = __webpack_require__(2672);
var flags = __webpack_require__(1026);
var isDate = __webpack_require__(9543);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ },

/***/ 686
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(4940);

var $SyntaxError = __webpack_require__(5731);
var $TypeError = __webpack_require__(3468);

var gopd = __webpack_require__(9336);

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ },

/***/ 1857
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(9228);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = __webpack_require__(686);

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var supportsDescriptors = __webpack_require__(7239)();

var defineProperty = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}

	if (supportsDescriptors) {
		defineDataProperty(object, name, value, true);
	} else {
		defineDataProperty(object, name, value);
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ },

/***/ 8136
(module) {

/**
 * DBSCAN - Density based clustering
 *
 * @author Lukasz Krawczyk <contact@lukaszkrawczyk.eu>
 * @copyright MIT
 */

/**
 * DBSCAN class construcotr
 * @constructor
 *
 * @param {Array} dataset
 * @param {number} epsilon
 * @param {number} minPts
 * @param {function} distanceFunction
 * @returns {DBSCAN}
 */
function DBSCAN(dataset, epsilon, minPts, distanceFunction) {
  /** @type {Array} */
  this.dataset = [];
  /** @type {number} */
  this.epsilon = 1;
  /** @type {number} */
  this.minPts = 2;
  /** @type {function} */
  this.distance = this._euclideanDistance;
  /** @type {Array} */
  this.clusters = [];
  /** @type {Array} */
  this.noise = [];

  // temporary variables used during computation

  /** @type {Array} */
  this._visited = [];
  /** @type {Array} */
  this._assigned = [];
  /** @type {number} */
  this._datasetLength = 0;

  this._init(dataset, epsilon, minPts, distanceFunction);
};

/******************************************************************************/
// public functions

/**
 * Start clustering
 *
 * @param {Array} dataset
 * @param {number} epsilon
 * @param {number} minPts
 * @param {function} distanceFunction
 * @returns {undefined}
 * @access public
 */
DBSCAN.prototype.run = function(dataset, epsilon, minPts, distanceFunction) {
  this._init(dataset, epsilon, minPts, distanceFunction);

  for (var pointId = 0; pointId < this._datasetLength; pointId++) {
    // if point is not visited, check if it forms a cluster
    if (this._visited[pointId] !== 1) {
      this._visited[pointId] = 1;

      // if closest neighborhood is too small to form a cluster, mark as noise
      var neighbors = this._regionQuery(pointId);

      if (neighbors.length < this.minPts) {
        this.noise.push(pointId);
      } else {
        // create new cluster and add point
        var clusterId = this.clusters.length;
        this.clusters.push([]);
        this._addToCluster(pointId, clusterId);

        this._expandCluster(clusterId, neighbors);
      }
    }
  }

  return this.clusters;
};

/******************************************************************************/
// protected functions

/**
 * Set object properties
 *
 * @param {Array} dataset
 * @param {number} epsilon
 * @param {number} minPts
 * @param {function} distance
 * @returns {undefined}
 * @access protected
 */
DBSCAN.prototype._init = function(dataset, epsilon, minPts, distance) {

  if (dataset) {

    if (!(dataset instanceof Array)) {
      throw Error('Dataset must be of type array, ' +
        typeof dataset + ' given');
    }

    this.dataset = dataset;
    this.clusters = [];
    this.noise = [];

    this._datasetLength = dataset.length;
    this._visited = new Array(this._datasetLength);
    this._assigned = new Array(this._datasetLength);
  }

  if (epsilon) {
    this.epsilon = epsilon;
  }

  if (minPts) {
    this.minPts = minPts;
  }

  if (distance) {
    this.distance = distance;
  }
};

/**
 * Expand cluster to closest points of given neighborhood
 *
 * @param {number} clusterId
 * @param {Array} neighbors
 * @returns {undefined}
 * @access protected
 */
DBSCAN.prototype._expandCluster = function(clusterId, neighbors) {

  /**
   * It's very important to calculate length of neighbors array each time,
   * as the number of elements changes over time
   */
  for (var i = 0; i < neighbors.length; i++) {
    var pointId2 = neighbors[i];

    if (this._visited[pointId2] !== 1) {
      this._visited[pointId2] = 1;
      var neighbors2 = this._regionQuery(pointId2);

      if (neighbors2.length >= this.minPts) {
        neighbors = this._mergeArrays(neighbors, neighbors2);
      }
    }

    // add to cluster
    if (this._assigned[pointId2] !== 1) {
      this._addToCluster(pointId2, clusterId);
    }
  }
};

/**
 * Add new point to cluster
 *
 * @param {number} pointId
 * @param {number} clusterId
 */
DBSCAN.prototype._addToCluster = function(pointId, clusterId) {
  this.clusters[clusterId].push(pointId);
  this._assigned[pointId] = 1;
};

/**
 * Find all neighbors around given point
 *
 * @param {number} pointId,
 * @param {number} epsilon
 * @returns {Array}
 * @access protected
 */
DBSCAN.prototype._regionQuery = function(pointId) {
  var neighbors = [];

  for (var id = 0; id < this._datasetLength; id++) {
    var dist = this.distance(this.dataset[pointId], this.dataset[id]);
    if (dist < this.epsilon) {
      neighbors.push(id);
    }
  }

  return neighbors;
};

/******************************************************************************/
// helpers

/**
 * @param {Array} a
 * @param {Array} b
 * @returns {Array}
 * @access protected
 */
DBSCAN.prototype._mergeArrays = function(a, b) {
  var len = b.length;

  for (var i = 0; i < len; i++) {
    var P = b[i];
    if (a.indexOf(P) < 0) {
      a.push(P);
    }
  }

  return a;
};

/**
 * Calculate euclidean distance in multidimensional space
 *
 * @param {Array} p
 * @param {Array} q
 * @returns {number}
 * @access protected
 */
DBSCAN.prototype._euclideanDistance = function(p, q) {
  var sum = 0;
  var i = Math.min(p.length, q.length);

  while (i--) {
    sum += (p[i] - q[i]) * (p[i] - q[i]);
  }

  return Math.sqrt(sum);
};

if ( true && module.exports) {
  module.exports = DBSCAN;
}


/***/ },

/***/ 9190
(module) {

/**
 * KMEANS clustering
 *
 * @author Lukasz Krawczyk <contact@lukaszkrawczyk.eu>
 * @copyright MIT
 */

/**
 * KMEANS class constructor
 * @constructor
 *
 * @param {Array} dataset
 * @param {number} k - number of clusters
 * @param {function} distance - distance function
 * @returns {KMEANS}
 */
 function KMEANS(dataset, k, distance) {
  this.k = 3; // number of clusters
  this.dataset = []; // set of feature vectors
  this.assignments = []; // set of associated clusters for each feature vector
  this.centroids = []; // vectors for our clusters

  this.init(dataset, k, distance);
}

/**
 * @returns {undefined}
 */
KMEANS.prototype.init = function(dataset, k, distance) {
  this.assignments = [];
  this.centroids = [];

  if (typeof dataset !== 'undefined') {
    this.dataset = dataset;
  }

  if (typeof k !== 'undefined') {
    this.k = k;
  }

  if (typeof distance !== 'undefined') {
    this.distance = distance;
  }
};

/**
 * @returns {undefined}
 */
KMEANS.prototype.run = function(dataset, k) {
  this.init(dataset, k);

  var len = this.dataset.length;

  // initialize centroids
  for (var i = 0; i < this.k; i++) {
    this.centroids[i] = this.randomCentroid();
	}

  var change = true;
  while(change) {

    // assign feature vectors to clusters
    change = this.assign();

    // adjust location of centroids
    for (var centroidId = 0; centroidId < this.k; centroidId++) {
      var mean = new Array(maxDim);
      var count = 0;

      // init mean vector
      for (var dim = 0; dim < maxDim; dim++) {
        mean[dim] = 0;
      }

      for (var j = 0; j < len; j++) {
        var maxDim = this.dataset[j].length;

        // if current cluster id is assigned to point
        if (centroidId === this.assignments[j]) {
          for (var dim = 0; dim < maxDim; dim++) {
            mean[dim] += this.dataset[j][dim];
          }
          count++;
        }
      }

      if (count > 0) {
        // if cluster contain points, adjust centroid position
        for (var dim = 0; dim < maxDim; dim++) {
          mean[dim] /= count;
        }
        this.centroids[centroidId] = mean;
      } else {
        // if cluster is empty, generate new random centroid
        this.centroids[centroidId] = this.randomCentroid();
        change = true;
      }
    }
  }

  return this.getClusters();
};

/**
 * Generate random centroid
 *
 * @returns {Array}
 */
KMEANS.prototype.randomCentroid = function() {
  var maxId = this.dataset.length -1;
  var centroid;
  var id;

  do {
    id = Math.round(Math.random() * maxId);
    centroid = this.dataset[id];
  } while (this.centroids.indexOf(centroid) >= 0);

  return centroid;
}

/**
 * Assign points to clusters
 *
 * @returns {boolean}
 */
KMEANS.prototype.assign = function() {
  var change = false;
  var len = this.dataset.length;
  var closestCentroid;

  for (var i = 0; i < len; i++) {
    closestCentroid = this.argmin(this.dataset[i], this.centroids, this.distance);

    if (closestCentroid != this.assignments[i]) {
      this.assignments[i] = closestCentroid;
      change = true;
    }
  }

  return change;
}

/**
 * Extract information about clusters
 *
 * @returns {undefined}
 */
KMEANS.prototype.getClusters = function() {
  var clusters = new Array(this.k);
  var centroidId;

  for (var pointId = 0; pointId < this.assignments.length; pointId++) {
    centroidId = this.assignments[pointId];

    // init empty cluster
    if (typeof clusters[centroidId] === 'undefined') {
      clusters[centroidId] = [];
    }

    clusters[centroidId].push(pointId);
  }

  return clusters;
};

// utils

/**
 * @params {Array} point
 * @params {Array.<Array>} set
 * @params {Function} f
 * @returns {number}
 */
KMEANS.prototype.argmin = function(point, set, f) {
  var min = Number.MAX_VALUE;
  var arg = 0;
  var len = set.length;
  var d;

  for (var i = 0; i < len; i++) {
    d = f(point, set[i]);
    if (d < min) {
      min = d;
      arg = i;
    }
  }

  return arg;
};

/**
 * Euclidean distance
 *
 * @params {number} p
 * @params {number} q
 * @returns {number}
 */
KMEANS.prototype.distance = function(p, q) {
  var sum = 0;
  var i = Math.min(p.length, q.length);

  while (i--) {
    var diff = p[i] - q[i];
    sum += diff * diff;
  }

  return Math.sqrt(sum);
};

if ( true && module.exports) {
  module.exports = KMEANS;
}


/***/ },

/***/ 2037
(module, __unused_webpack_exports, __webpack_require__) {


/**
 * @requires ./PriorityQueue.js
 */

if ( true && module.exports) {
      var PriorityQueue = __webpack_require__(624);
}

/**
 * OPTICS - Ordering points to identify the clustering structure
 *
 * @author Lukasz Krawczyk <contact@lukaszkrawczyk.eu>
 * @copyright MIT
 */

/**
 * OPTICS class constructor
 * @constructor
 *
 * @param {Array} dataset
 * @param {number} epsilon
 * @param {number} minPts
 * @param {function} distanceFunction
 * @returns {OPTICS}
 */
function OPTICS(dataset, epsilon, minPts, distanceFunction) {
  /** @type {number} */
  this.epsilon = 1;
  /** @type {number} */
  this.minPts = 1;
  /** @type {function} */
  this.distance = this._euclideanDistance;

  // temporary variables used during computation

  /** @type {Array} */
  this._reachability = [];
  /** @type {Array} */
  this._processed = [];
  /** @type {number} */
  this._coreDistance = 0;
  /** @type {Array} */
  this._orderedList = [];

  this._init(dataset, epsilon, minPts, distanceFunction);
}

/******************************************************************************/
// pulic functions

/**
 * Start clustering
 *
 * @param {Array} dataset
 * @returns {undefined}
 * @access public
 */
OPTICS.prototype.run = function(dataset, epsilon, minPts, distanceFunction) {
  this._init(dataset, epsilon, minPts, distanceFunction);

  for (var pointId = 0, l = this.dataset.length; pointId < l; pointId++) {
    if (this._processed[pointId] !== 1) {
      this._processed[pointId] = 1;
      this.clusters.push([pointId]);
      var clusterId = this.clusters.length - 1;

      this._orderedList.push(pointId);
      var priorityQueue = new PriorityQueue(null, null, 'asc');
      var neighbors = this._regionQuery(pointId);

      // using priority queue assign elements to new cluster
      if (this._distanceToCore(pointId) !== undefined) {
        this._updateQueue(pointId, neighbors, priorityQueue);
        this._expandCluster(clusterId, priorityQueue);
      }
    }
  }

  return this.clusters;
};

/**
 * Generate reachability plot for all points
 *
 * @returns {array}
 * @access public
 */
OPTICS.prototype.getReachabilityPlot = function() {
  var reachabilityPlot = [];

  for (var i = 0, l = this._orderedList.length; i < l; i++) {
    var pointId = this._orderedList[i];
    var distance = this._reachability[pointId];

    reachabilityPlot.push([pointId, distance]);
  }

  return reachabilityPlot;
};

/******************************************************************************/
// protected functions

/**
 * Set object properties
 *
 * @param {Array} dataset
 * @param {number} epsilon
 * @param {number} minPts
 * @param {function} distance
 * @returns {undefined}
 * @access protected
 */
OPTICS.prototype._init = function(dataset, epsilon, minPts, distance) {

  if (dataset) {

    if (!(dataset instanceof Array)) {
      throw Error('Dataset must be of type array, ' +
        typeof dataset + ' given');
    }

    this.dataset = dataset;
    this.clusters = [];
    this._reachability = new Array(this.dataset.length);
    this._processed = new Array(this.dataset.length);
    this._coreDistance = 0;
    this._orderedList = [];
  }

  if (epsilon) {
    this.epsilon = epsilon;
  }

  if (minPts) {
    this.minPts = minPts;
  }

  if (distance) {
    this.distance = distance;
  }
};

/**
 * Update information in queue
 *
 * @param {number} pointId
 * @param {Array} neighbors
 * @param {PriorityQueue} queue
 * @returns {undefined}
 * @access protected
 */
OPTICS.prototype._updateQueue = function(pointId, neighbors, queue) {
  var self = this;

  this._coreDistance = this._distanceToCore(pointId);
  neighbors.forEach(function(pointId2) {
    if (self._processed[pointId2] === undefined) {
      var dist = self.distance(self.dataset[pointId], self.dataset[pointId2]);
      var newReachableDistance = Math.max(self._coreDistance, dist);

      if (self._reachability[pointId2] === undefined) {
        self._reachability[pointId2] = newReachableDistance;
        queue.insert(pointId2, newReachableDistance);
      } else {
        if (newReachableDistance < self._reachability[pointId2]) {
          self._reachability[pointId2] = newReachableDistance;
          queue.remove(pointId2);
          queue.insert(pointId2, newReachableDistance);
        }
      }
    }
  });
};

/**
 * Expand cluster
 *
 * @param {number} clusterId
 * @param {PriorityQueue} queue
 * @returns {undefined}
 * @access protected
 */
OPTICS.prototype._expandCluster = function(clusterId, queue) {
  var queueElements = queue.getElements();

  for (var p = 0, l = queueElements.length; p < l; p++) {
    var pointId = queueElements[p];
    if (this._processed[pointId] === undefined) {
      var neighbors = this._regionQuery(pointId);
      this._processed[pointId] = 1;

      this.clusters[clusterId].push(pointId);
      this._orderedList.push(pointId);

      if (this._distanceToCore(pointId) !== undefined) {
        this._updateQueue(pointId, neighbors, queue);
        this._expandCluster(clusterId, queue);
      }
    }
  }
};

/**
 * Calculating distance to cluster core
 *
 * @param {number} pointId
 * @returns {number}
 * @access protected
 */
OPTICS.prototype._distanceToCore = function(pointId) {
  var l = this.epsilon;
  for (var coreDistCand = 0; coreDistCand < l; coreDistCand++) {
    var neighbors = this._regionQuery(pointId, coreDistCand);
    if (neighbors.length >= this.minPts) {
      return coreDistCand;
    }
  }

  return;
};

/**
 * Find all neighbors around given point
 *
 * @param {number} pointId
 * @param {number} epsilon
 * @returns {Array}
 * @access protected
 */
OPTICS.prototype._regionQuery = function(pointId, epsilon) {
  epsilon = epsilon || this.epsilon;
  var neighbors = [];

  for (var id = 0, l = this.dataset.length; id < l; id++) {
    if (this.distance(this.dataset[pointId], this.dataset[id]) < epsilon) {
      neighbors.push(id);
    }
  }

  return neighbors;
};

/******************************************************************************/
// helpers

/**
 * Calculate euclidean distance in multidimensional space
 *
 * @param {Array} p
 * @param {Array} q
 * @returns {number}
 * @access protected
 */
OPTICS.prototype._euclideanDistance = function(p, q) {
  var sum = 0;
  var i = Math.min(p.length, q.length);

  while (i--) {
    sum += (p[i] - q[i]) * (p[i] - q[i]);
  }

  return Math.sqrt(sum);
};

if ( true && module.exports) {
  module.exports = OPTICS;
}


/***/ },

/***/ 624
(module) {

/**
 * PriorityQueue
 * Elements in this queue are sorted according to their value
 *
 * @author Lukasz Krawczyk <contact@lukaszkrawczyk.eu>
 * @copyright MIT
 */

/**
 * PriorityQueue class construcotr
 * @constructor
 *
 * @example
 * queue: [1,2,3,4]
 * priorities: [4,1,2,3]
 * > result = [1,4,2,3]
 *
 * @param {Array} elements
 * @param {Array} priorities
 * @param {string} sorting - asc / desc
 * @returns {PriorityQueue}
 */
function PriorityQueue(elements, priorities, sorting) {
  /** @type {Array} */
  this._queue = [];
  /** @type {Array} */
  this._priorities = [];
  /** @type {string} */
  this._sorting = 'desc';

  this._init(elements, priorities, sorting);
};

/**
 * Insert element
 *
 * @param {Object} ele
 * @param {Object} priority
 * @returns {undefined}
 * @access public
 */
PriorityQueue.prototype.insert = function(ele, priority) {
  var indexToInsert = this._queue.length;
  var index = indexToInsert;

  while (index--) {
    var priority2 = this._priorities[index];
    if (this._sorting === 'desc') {
      if (priority > priority2) {
        indexToInsert = index;
      }
    } else {
      if (priority < priority2) {
        indexToInsert = index;
      }
    }
  }

  this._insertAt(ele, priority, indexToInsert);
};

/**
 * Remove element
 *
 * @param {Object} ele
 * @returns {undefined}
 * @access public
 */
PriorityQueue.prototype.remove = function(ele) {
  var index = this._queue.length;

  while (index--) {
    var ele2 = this._queue[index];
    if (ele === ele2) {
      this._queue.splice(index, 1);
      this._priorities.splice(index, 1);
      break;
    }
  }
};

/**
 * For each loop wrapper
 *
 * @param {function} func
 * @returs {undefined}
 * @access public
 */
PriorityQueue.prototype.forEach = function(func) {
  this._queue.forEach(func);
};

/**
 * @returns {Array}
 * @access public
 */
PriorityQueue.prototype.getElements = function() {
  return this._queue;
};

/**
 * @param {number} index
 * @returns {Object}
 * @access public
 */
PriorityQueue.prototype.getElementPriority = function(index) {
  return this._priorities[index];
};

/**
 * @returns {Array}
 * @access public
 */
PriorityQueue.prototype.getPriorities = function() {
  return this._priorities;
};

/**
 * @returns {Array}
 * @access public
 */
PriorityQueue.prototype.getElementsWithPriorities = function() {
  var result = [];

  for (var i = 0, l = this._queue.length; i < l; i++) {
    result.push([this._queue[i], this._priorities[i]]);
  }

  return result;
};

/**
 * Set object properties
 *
 * @param {Array} elements
 * @param {Array} priorities
 * @returns {undefined}
 * @access protected
 */
PriorityQueue.prototype._init = function(elements, priorities, sorting) {

  if (elements && priorities) {
    this._queue = [];
    this._priorities = [];

    if (elements.length !== priorities.length) {
      throw new Error('Arrays must have the same length');
    }

    for (var i = 0; i < elements.length; i++) {
      this.insert(elements[i], priorities[i]);
    }
  }

  if (sorting) {
    this._sorting = sorting;
  }
};

/**
 * Insert element at given position
 *
 * @param {Object} ele
 * @param {number} index
 * @returns {undefined}
 * @access protected
 */
PriorityQueue.prototype._insertAt = function(ele, priority, index) {
  if (this._queue.length === index) {
    this._queue.push(ele);
    this._priorities.push(priority);
  } else {
    this._queue.splice(index, 0, ele);
    this._priorities.splice(index, 0, priority);
  }
};

if ( true && module.exports) {
  module.exports = PriorityQueue;
}


/***/ },

/***/ 1631
(module, __unused_webpack_exports, __webpack_require__) {


if ( true && module.exports) {
    module.exports = {
      DBSCAN: __webpack_require__(8136),
      KMEANS: __webpack_require__(9190),
      OPTICS: __webpack_require__(2037),
      PriorityQueue: __webpack_require__(624)
    };
}


/***/ },

/***/ 6423
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(9903);
var gOPD = __webpack_require__(9336);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ },

/***/ 1767
(module) {

"use strict";


module.exports = earcut;
module.exports["default"] = earcut;

function earcut(data, holeIndices, dim) {

    dim = dim || 2;

    var hasHoles = holeIndices && holeIndices.length,
        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
        outerNode = linkedList(data, 0, outerLen, dim, true),
        triangles = [];

    if (!outerNode || outerNode.next === outerNode.prev) return triangles;

    var minX, minY, maxX, maxY, x, y, invSize;

    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);

    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];

        for (var i = dim; i < outerLen; i += dim) {
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }

        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }

    earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);

    return triangles;
}

// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    var i, last;

    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
    } else {
        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
    }

    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }

    return last;
}

// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;

    var p = start,
        again;
    do {
        again = false;

        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;

        } else {
            p = p.next;
        }
    } while (again || p !== end);

    return end;
}

// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;

    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);

    var stop = ear,
        prev, next;

    // iterate through ears, slicing them one by one
    while (ear.prev !== ear.next) {
        prev = ear.prev;
        next = ear.next;

        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);

            removeNode(ear);

            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;

            continue;
        }

        ear = next;

        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) {
                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);

            // if this didn't work, try curing all small self-intersections locally
            } else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);

            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) {
                splitEarcut(ear, triangles, dim, minX, minY, invSize);
            }

            break;
        }
    }
}

// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? (ax < cx ? ax : cx) : (bx < cx ? bx : cx),
        y0 = ay < by ? (ay < cy ? ay : cy) : (by < cy ? by : cy),
        x1 = ax > bx ? (ax > cx ? ax : cx) : (bx > cx ? bx : cx),
        y1 = ay > by ? (ay > cy ? ay : cy) : (by > cy ? by : cy);

    var p = c.next;
    while (p !== a) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 &&
            pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }

    return true;
}

function isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? (ax < cx ? ax : cx) : (bx < cx ? bx : cx),
        y0 = ay < by ? (ay < cy ? ay : cy) : (by < cy ? by : cy),
        x1 = ax > bx ? (ax > cx ? ax : cx) : (bx > cx ? bx : cx),
        y1 = ay > by ? (ay > cy ? ay : cy) : (by > cy ? by : cy);

    // z-order range for the current triangle bbox;
    var minZ = zOrder(x0, y0, minX, minY, invSize),
        maxZ = zOrder(x1, y1, minX, minY, invSize);

    var p = ear.prevZ,
        n = ear.nextZ;

    // look for points inside the triangle in both directions
    while (p && p.z >= minZ && n && n.z <= maxZ) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;

        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    // look for remaining points in decreasing z-order
    while (p && p.z >= minZ) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }

    // look for remaining points in increasing z-order
    while (n && n.z <= maxZ) {
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    return true;
}

// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev,
            b = p.next.next;

        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {

            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);

            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);

            p = start = b;
        }
        p = p.next;
    } while (p !== start);

    return filterPoints(p);
}

// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while (b !== a.prev) {
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = splitPolygon(a, b);

                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);

                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    } while (a !== start);
}

// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [],
        i, len, start, end, list;

    for (i = 0, len = holeIndices.length; i < len; i++) {
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }

    queue.sort(compareX);

    // process holes from left to right
    for (i = 0; i < queue.length; i++) {
        outerNode = eliminateHole(queue[i], outerNode);
    }

    return outerNode;
}

function compareX(a, b) {
    return a.x - b.x;
}

// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    var bridge = findHoleBridge(hole, outerNode);
    if (!bridge) {
        return outerNode;
    }

    var bridgeReverse = splitPolygon(bridge, hole);

    // filter collinear points around the cuts
    filterPoints(bridgeReverse, bridgeReverse.next);
    return filterPoints(bridge, bridge.next);
}

// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    var p = outerNode,
        hx = hole.x,
        hy = hole.y,
        qx = -Infinity,
        m;

    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    } while (p !== outerNode);

    if (!m) return null;

    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point

    var stop = m,
        mx = m.x,
        my = m.y,
        tanMin = Infinity,
        tan;

    p = m;

    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x &&
                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {

            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

            if (locallyInside(p, hole) &&
                (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
                m = p;
                tanMin = tan;
            }
        }

        p = p.next;
    } while (p !== stop);

    return m;
}

// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}

// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    } while (p !== start);

    p.prevZ.nextZ = null;
    p.prevZ = null;

    sortLinked(p);
}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize,
        inSize = 1;

    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;

        while (p) {
            numMerges++;
            q = p;
            pSize = 0;
            for (i = 0; i < inSize; i++) {
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;

            while (pSize > 0 || (qSize > 0 && q)) {

                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }

                if (tail) tail.nextZ = e;
                else list = e;

                e.prevZ = tail;
                tail = e;
            }

            p = q;
        }

        tail.nextZ = null;
        inSize *= 2;

    } while (numMerges > 1);

    return list;
}

// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;

    x = (x | (x << 8)) & 0x00FF00FF;
    x = (x | (x << 4)) & 0x0F0F0F0F;
    x = (x | (x << 2)) & 0x33333333;
    x = (x | (x << 1)) & 0x55555555;

    y = (y | (y << 8)) & 0x00FF00FF;
    y = (y | (y << 4)) & 0x0F0F0F0F;
    y = (y | (y << 2)) & 0x33333333;
    y = (y | (y << 1)) & 0x55555555;

    return x | (y << 1);
}

// find the leftmost node of a polygon ring
function getLeftmost(start) {
    var p = start,
        leftmost = start;
    do {
        if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y)) leftmost = p;
        p = p.next;
    } while (p !== start);

    return leftmost;
}

// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) &&
           (ax - px) * (by - py) >= (bx - px) * (ay - py) &&
           (bx - px) * (cy - py) >= (cx - px) * (by - py);
}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
           (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
            (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
            equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}

// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}

// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}

// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    var o1 = sign(area(p1, q1, p2));
    var o2 = sign(area(p1, q1, q2));
    var o3 = sign(area(p2, q2, p1));
    var o4 = sign(area(p2, q2, q1));

    if (o1 !== o2 && o3 !== o4) return true; // general case

    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2

    return false;
}

// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}

function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}

// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
                intersects(p, p.next, a, b)) return true;
        p = p.next;
    } while (p !== a);

    return false;
}

// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ?
        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}

// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    var p = a,
        inside = false,
        px = (a.x + b.x) / 2,
        py = (a.y + b.y) / 2;
    do {
        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
            inside = !inside;
        p = p.next;
    } while (p !== a);

    return inside;
}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    var a2 = new Node(a.i, a.x, a.y),
        b2 = new Node(b.i, b.x, b.y),
        an = a.next,
        bp = b.prev;

    a.next = b;
    b.prev = a;

    a2.next = an;
    an.prev = a2;

    b2.next = a2;
    a2.prev = b2;

    bp.next = b2;
    b2.prev = bp;

    return b2;
}

// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    var p = new Node(i, x, y);

    if (!last) {
        p.prev = p;
        p.next = p;

    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}

function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;

    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}

function Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;

    // vertex coordinates
    this.x = x;
    this.y = y;

    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;

    // z-order curve value
    this.z = 0;

    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;

    // indicates whether this is a steiner point
    this.steiner = false;
}

// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
earcut.deviation = function (data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;

    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
    if (hasHoles) {
        for (var i = 0, len = holeIndices.length; i < len; i++) {
            var start = holeIndices[i] * dim;
            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
            polygonArea -= Math.abs(signedArea(data, start, end, dim));
        }
    }

    var trianglesArea = 0;
    for (i = 0; i < triangles.length; i += 3) {
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs(
            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }

    return polygonArea === 0 && trianglesArea === 0 ? 0 :
        Math.abs((trianglesArea - polygonArea) / polygonArea);
};

function signedArea(data, start, end, dim) {
    var sum = 0;
    for (var i = start, j = end - dim; i < end; i += dim) {
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}

// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
earcut.flatten = function (data) {
    var dim = data[0][0].length,
        result = {vertices: [], holes: [], dimensions: dim},
        holeIndex = 0;

    for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].length; j++) {
            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
        }
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};


/***/ },

/***/ 4940
(module) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ },

/***/ 9110
(module) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ },

/***/ 9838
(module) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ },

/***/ 1155
(module) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ },

/***/ 4943
(module) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ },

/***/ 5731
(module) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ },

/***/ 3468
(module) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ },

/***/ 2140
(module) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ },

/***/ 9629
(module) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ },

/***/ 8794
(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ },

/***/ 9138
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(8794);

module.exports = Function.prototype.bind || implementation;


/***/ },

/***/ 8993
(module) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;


/***/ },

/***/ 3084
(module, __unused_webpack_exports, __webpack_require__) {

//index.js
var deepEqual = __webpack_require__(4969);

var Equality = function(opt) {
  this.precision = opt && opt.precision ? opt.precision : 17;
  this.direction = opt && opt.direction ? opt.direction : false;
  this.pseudoNode = opt && opt.pseudoNode ? opt.pseudoNode : false;
  this.objectComparator = opt && opt.objectComparator ? opt.objectComparator : objectComparator;
};

Equality.prototype.compare = function(g1,g2) {
  if (g1.type !== g2.type || !sameLength(g1,g2)) return false;

  switch(g1.type) {
  case 'Point':
    return this.compareCoord(g1.coordinates, g2.coordinates);
    // removed by dead control flow

  case 'LineString':
    return this.compareLine(g1.coordinates, g2.coordinates,0,false);
    // removed by dead control flow

  case 'Polygon':
    return this.comparePolygon(g1,g2);
    // removed by dead control flow

  case 'Feature':
    return this.compareFeature(g1, g2);
  default:
    if (g1.type.indexOf('Multi') === 0) {
      var context = this;
      var g1s = explode(g1);
      var g2s = explode(g2);
      return g1s.every(function(g1part) {
        return this.some(function(g2part) {
          return context.compare(g1part,g2part);
        });
      },g2s);
    }
  }
  return false;
};

function explode(g) {
  return g.coordinates.map(function(part) {
    return {
      type: g.type.replace('Multi', ''),
      coordinates: part}
  });
}
//compare length of coordinates/array
function sameLength(g1,g2) {
   return g1.hasOwnProperty('coordinates') ?
    g1.coordinates.length === g2.coordinates.length
    : g1.length === g2.length;
}

// compare the two coordinates [x,y]
Equality.prototype.compareCoord = function(c1,c2) {
  if (c1.length !== c2.length) {
    return false;
  }

  for (var i=0; i < c1.length; i++) {
    if (c1[i].toFixed(this.precision) !== c2[i].toFixed(this.precision)) {
      return false;
    }
  }
  return true;
};

Equality.prototype.compareLine = function(path1,path2,ind,isPoly) {
  if (!sameLength(path1,path2)) return false;
  var p1 = this.pseudoNode ? path1 : this.removePseudo(path1);
  var p2 = this.pseudoNode ? path2 : this.removePseudo(path2);
  if (isPoly && !this.compareCoord(p1[0],p2[0])) {
    // fix start index of both to same point
    p2 = this.fixStartIndex(p2,p1);
    if(!p2) return;
  }
  // for linestring ind =0 and for polygon ind =1
  var sameDirection = this.compareCoord(p1[ind],p2[ind]);
  if (this.direction || sameDirection
  ) {
    return this.comparePath(p1, p2);
  } else {
    if (this.compareCoord(p1[ind],p2[p2.length - (1+ind)])
    ) {
      return this.comparePath(p1.slice().reverse(), p2);
    }
    return false;
  }
};
Equality.prototype.fixStartIndex = function(sourcePath,targetPath) {
  //make sourcePath first point same as of targetPath
  var correctPath,ind = -1;
  for (var i=0; i< sourcePath.length; i++) {
    if(this.compareCoord(sourcePath[i],targetPath[0])) {
      ind = i;
      break;
    }
  }
  if (ind >= 0) {
    correctPath = [].concat(
      sourcePath.slice(ind,sourcePath.length),
      sourcePath.slice(1,ind+1));
  }
  return correctPath;
};
Equality.prototype.comparePath = function (p1,p2) {
  var cont = this;
  return p1.every(function(c,i) {
    return cont.compareCoord(c,this[i]);
  },p2);
};

Equality.prototype.comparePolygon = function(g1,g2) {
  if (this.compareLine(g1.coordinates[0],g2.coordinates[0],1,true)) {
    var holes1 = g1.coordinates.slice(1,g1.coordinates.length);
    var holes2 = g2.coordinates.slice(1,g2.coordinates.length);
    var cont = this;
    return holes1.every(function(h1) {
      return this.some(function(h2) {
        return cont.compareLine(h1,h2,1,true);
      });
    },holes2);
  } else {
    return false;
  }
};

Equality.prototype.compareFeature = function(g1,g2) {
  if (
    g1.id !== g2.id ||
    !this.objectComparator(g1.properties, g2.properties) ||
    !this.compareBBox(g1,g2)
  ) {
    return false;
  }
  return this.compare(g1.geometry, g2.geometry);
};

Equality.prototype.compareBBox = function(g1,g2) {
  if (
    (!g1.bbox && !g2.bbox) || 
    (
      g1.bbox && g2.bbox &&
      this.compareCoord(g1.bbox, g2.bbox)
    )
  )  {
    return true;
  }
  return false;
};
Equality.prototype.removePseudo = function(path) {
  //TODO to be implement
  return path;
};

function objectComparator(obj1, obj2) {
  return deepEqual(obj1, obj2, {strict: true});
}

module.exports = Equality;


/***/ },

/***/ 6032
(module, __unused_webpack_exports, __webpack_require__) {

var rbush = __webpack_require__(8918);
var helpers = __webpack_require__(462);
var meta = __webpack_require__(4262);
var turfBBox = (__webpack_require__(287)/* ["default"] */ .Ay);
var featureEach = meta.featureEach;
var coordEach = meta.coordEach;
var polygon = helpers.polygon;
var featureCollection = helpers.featureCollection;

/**
 * GeoJSON implementation of [RBush](https://github.com/mourner/rbush#rbush) spatial index.
 *
 * @name rbush
 * @param {number} [maxEntries=9] defines the maximum number of entries in a tree node. 9 (used by default) is a
 * reasonable choice for most applications. Higher value means faster insertion and slower search, and vice versa.
 * @returns {RBush} GeoJSON RBush
 * @example
 * var geojsonRbush = require('geojson-rbush').default;
 * var tree = geojsonRbush();
 */
function geojsonRbush(maxEntries) {
    var tree = new rbush(maxEntries);
    /**
     * [insert](https://github.com/mourner/rbush#data-format)
     *
     * @param {Feature} feature insert single GeoJSON Feature
     * @returns {RBush} GeoJSON RBush
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     * tree.insert(poly)
     */
    tree.insert = function (feature) {
        if (feature.type !== 'Feature') throw new Error('invalid feature');
        feature.bbox = feature.bbox ? feature.bbox : turfBBox(feature);
        return rbush.prototype.insert.call(this, feature);
    };

    /**
     * [load](https://github.com/mourner/rbush#bulk-inserting-data)
     *
     * @param {FeatureCollection|Array<Feature>} features load entire GeoJSON FeatureCollection
     * @returns {RBush} GeoJSON RBush
     * @example
     * var polys = turf.polygons([
     *     [[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]],
     *     [[[-93, 32], [-83, 32], [-83, 39], [-93, 39], [-93, 32]]]
     * ]);
     * tree.load(polys);
     */
    tree.load = function (features) {
        var load = [];
        // Load an Array of Features
        if (Array.isArray(features)) {
            features.forEach(function (feature) {
                if (feature.type !== 'Feature') throw new Error('invalid features');
                feature.bbox = feature.bbox ? feature.bbox : turfBBox(feature);
                load.push(feature);
            });
        } else {
            // Load a FeatureCollection
            featureEach(features, function (feature) {
                if (feature.type !== 'Feature') throw new Error('invalid features');
                feature.bbox = feature.bbox ? feature.bbox : turfBBox(feature);
                load.push(feature);
            });
        }
        return rbush.prototype.load.call(this, load);
    };

    /**
     * [remove](https://github.com/mourner/rbush#removing-data)
     *
     * @param {Feature} feature remove single GeoJSON Feature
     * @param {Function} equals Pass a custom equals function to compare by value for removal.
     * @returns {RBush} GeoJSON RBush
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     *
     * tree.remove(poly);
     */
    tree.remove = function (feature, equals) {
        if (feature.type !== 'Feature') throw new Error('invalid feature');
        feature.bbox = feature.bbox ? feature.bbox : turfBBox(feature);
        return rbush.prototype.remove.call(this, feature, equals);
    };

    /**
     * [clear](https://github.com/mourner/rbush#removing-data)
     *
     * @returns {RBush} GeoJSON Rbush
     * @example
     * tree.clear()
     */
    tree.clear = function () {
        return rbush.prototype.clear.call(this);
    };

    /**
     * [search](https://github.com/mourner/rbush#search)
     *
     * @param {BBox|FeatureCollection|Feature} geojson search with GeoJSON
     * @returns {FeatureCollection} all features that intersects with the given GeoJSON.
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     *
     * tree.search(poly);
     */
    tree.search = function (geojson) {
        var features = rbush.prototype.search.call(this, this.toBBox(geojson));
        return featureCollection(features);
    };

    /**
     * [collides](https://github.com/mourner/rbush#collisions)
     *
     * @param {BBox|FeatureCollection|Feature} geojson collides with GeoJSON
     * @returns {boolean} true if there are any items intersecting the given GeoJSON, otherwise false.
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     *
     * tree.collides(poly);
     */
    tree.collides = function (geojson) {
        return rbush.prototype.collides.call(this, this.toBBox(geojson));
    };

    /**
     * [all](https://github.com/mourner/rbush#search)
     *
     * @returns {FeatureCollection} all the features in RBush
     * @example
     * tree.all()
     */
    tree.all = function () {
        var features = rbush.prototype.all.call(this);
        return featureCollection(features);
    };

    /**
     * [toJSON](https://github.com/mourner/rbush#export-and-import)
     *
     * @returns {any} export data as JSON object
     * @example
     * var exported = tree.toJSON()
     */
    tree.toJSON = function () {
        return rbush.prototype.toJSON.call(this);
    };

    /**
     * [fromJSON](https://github.com/mourner/rbush#export-and-import)
     *
     * @param {any} json import previously exported data
     * @returns {RBush} GeoJSON RBush
     * @example
     * var exported = {
     *   "children": [
     *     {
     *       "type": "Feature",
     *       "geometry": {
     *         "type": "Point",
     *         "coordinates": [110, 50]
     *       },
     *       "properties": {},
     *       "bbox": [110, 50, 110, 50]
     *     }
     *   ],
     *   "height": 1,
     *   "leaf": true,
     *   "minX": 110,
     *   "minY": 50,
     *   "maxX": 110,
     *   "maxY": 50
     * }
     * tree.fromJSON(exported)
     */
    tree.fromJSON = function (json) {
        return rbush.prototype.fromJSON.call(this, json);
    };

    /**
     * Converts GeoJSON to {minX, minY, maxX, maxY} schema
     *
     * @private
     * @param {BBox|FeatureCollection|Feature} geojson feature(s) to retrieve BBox from
     * @returns {Object} converted to {minX, minY, maxX, maxY}
     */
    tree.toBBox = function (geojson) {
        var bbox;
        if (geojson.bbox) bbox = geojson.bbox;
        else if (Array.isArray(geojson) && geojson.length === 4) bbox = geojson;
        else if (Array.isArray(geojson) && geojson.length === 6) bbox = [geojson[0], geojson[1], geojson[3], geojson[4]];
        else if (geojson.type === 'Feature') bbox = turfBBox(geojson);
        else if (geojson.type === 'FeatureCollection') bbox = turfBBox(geojson);
        else throw new Error('invalid geojson')

        return {
            minX: bbox[0],
            minY: bbox[1],
            maxX: bbox[2],
            maxY: bbox[3]
        };
    };
    return tree;
}

module.exports = geojsonRbush;
module.exports["default"] = geojsonRbush;


/***/ },

/***/ 8918
(module) {

!function(t,i){ true?module.exports=i():0}(this,function(){"use strict";function t(t,r,e,a,h){!function t(n,r,e,a,h){for(;a>e;){if(a-e>600){var o=a-e+1,s=r-e+1,l=Math.log(o),f=.5*Math.exp(2*l/3),u=.5*Math.sqrt(l*f*(o-f)/o)*(s-o/2<0?-1:1),m=Math.max(e,Math.floor(r-s*f/o+u)),c=Math.min(a,Math.floor(r+(o-s)*f/o+u));t(n,r,m,c,h)}var p=n[r],d=e,x=a;for(i(n,e,r),h(n[a],p)>0&&i(n,e,a);d<x;){for(i(n,d,x),d++,x--;h(n[d],p)<0;)d++;for(;h(n[x],p)>0;)x--}0===h(n[e],p)?i(n,e,x):i(n,++x,a),x<=r&&(e=x+1),r<=x&&(a=x-1)}}(t,r,e||0,a||t.length-1,h||n)}function i(t,i,n){var r=t[i];t[i]=t[n],t[n]=r}function n(t,i){return t<i?-1:t>i?1:0}var r=function(t){void 0===t&&(t=9),this._maxEntries=Math.max(4,t),this._minEntries=Math.max(2,Math.ceil(.4*this._maxEntries)),this.clear()};function e(t,i,n){if(!n)return i.indexOf(t);for(var r=0;r<i.length;r++)if(n(t,i[r]))return r;return-1}function a(t,i){h(t,0,t.children.length,i,t)}function h(t,i,n,r,e){e||(e=p(null)),e.minX=1/0,e.minY=1/0,e.maxX=-1/0,e.maxY=-1/0;for(var a=i;a<n;a++){var h=t.children[a];o(e,t.leaf?r(h):h)}return e}function o(t,i){return t.minX=Math.min(t.minX,i.minX),t.minY=Math.min(t.minY,i.minY),t.maxX=Math.max(t.maxX,i.maxX),t.maxY=Math.max(t.maxY,i.maxY),t}function s(t,i){return t.minX-i.minX}function l(t,i){return t.minY-i.minY}function f(t){return(t.maxX-t.minX)*(t.maxY-t.minY)}function u(t){return t.maxX-t.minX+(t.maxY-t.minY)}function m(t,i){return t.minX<=i.minX&&t.minY<=i.minY&&i.maxX<=t.maxX&&i.maxY<=t.maxY}function c(t,i){return i.minX<=t.maxX&&i.minY<=t.maxY&&i.maxX>=t.minX&&i.maxY>=t.minY}function p(t){return{children:t,height:1,leaf:!0,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0}}function d(i,n,r,e,a){for(var h=[n,r];h.length;)if(!((r=h.pop())-(n=h.pop())<=e)){var o=n+Math.ceil((r-n)/e/2)*e;t(i,o,n,r,a),h.push(n,o,o,r)}}return r.prototype.all=function(){return this._all(this.data,[])},r.prototype.search=function(t){var i=this.data,n=[];if(!c(t,i))return n;for(var r=this.toBBox,e=[];i;){for(var a=0;a<i.children.length;a++){var h=i.children[a],o=i.leaf?r(h):h;c(t,o)&&(i.leaf?n.push(h):m(t,o)?this._all(h,n):e.push(h))}i=e.pop()}return n},r.prototype.collides=function(t){var i=this.data;if(!c(t,i))return!1;for(var n=[];i;){for(var r=0;r<i.children.length;r++){var e=i.children[r],a=i.leaf?this.toBBox(e):e;if(c(t,a)){if(i.leaf||m(t,a))return!0;n.push(e)}}i=n.pop()}return!1},r.prototype.load=function(t){if(!t||!t.length)return this;if(t.length<this._minEntries){for(var i=0;i<t.length;i++)this.insert(t[i]);return this}var n=this._build(t.slice(),0,t.length-1,0);if(this.data.children.length)if(this.data.height===n.height)this._splitRoot(this.data,n);else{if(this.data.height<n.height){var r=this.data;this.data=n,n=r}this._insert(n,this.data.height-n.height-1,!0)}else this.data=n;return this},r.prototype.insert=function(t){return t&&this._insert(t,this.data.height-1),this},r.prototype.clear=function(){return this.data=p([]),this},r.prototype.remove=function(t,i){if(!t)return this;for(var n,r,a,h=this.data,o=this.toBBox(t),s=[],l=[];h||s.length;){if(h||(h=s.pop(),r=s[s.length-1],n=l.pop(),a=!0),h.leaf){var f=e(t,h.children,i);if(-1!==f)return h.children.splice(f,1),s.push(h),this._condense(s),this}a||h.leaf||!m(h,o)?r?(n++,h=r.children[n],a=!1):h=null:(s.push(h),l.push(n),n=0,r=h,h=h.children[0])}return this},r.prototype.toBBox=function(t){return t},r.prototype.compareMinX=function(t,i){return t.minX-i.minX},r.prototype.compareMinY=function(t,i){return t.minY-i.minY},r.prototype.toJSON=function(){return this.data},r.prototype.fromJSON=function(t){return this.data=t,this},r.prototype._all=function(t,i){for(var n=[];t;)t.leaf?i.push.apply(i,t.children):n.push.apply(n,t.children),t=n.pop();return i},r.prototype._build=function(t,i,n,r){var e,h=n-i+1,o=this._maxEntries;if(h<=o)return a(e=p(t.slice(i,n+1)),this.toBBox),e;r||(r=Math.ceil(Math.log(h)/Math.log(o)),o=Math.ceil(h/Math.pow(o,r-1))),(e=p([])).leaf=!1,e.height=r;var s=Math.ceil(h/o),l=s*Math.ceil(Math.sqrt(o));d(t,i,n,l,this.compareMinX);for(var f=i;f<=n;f+=l){var u=Math.min(f+l-1,n);d(t,f,u,s,this.compareMinY);for(var m=f;m<=u;m+=s){var c=Math.min(m+s-1,u);e.children.push(this._build(t,m,c,r-1))}}return a(e,this.toBBox),e},r.prototype._chooseSubtree=function(t,i,n,r){for(;r.push(i),!i.leaf&&r.length-1!==n;){for(var e=1/0,a=1/0,h=void 0,o=0;o<i.children.length;o++){var s=i.children[o],l=f(s),u=(m=t,c=s,(Math.max(c.maxX,m.maxX)-Math.min(c.minX,m.minX))*(Math.max(c.maxY,m.maxY)-Math.min(c.minY,m.minY))-l);u<a?(a=u,e=l<e?l:e,h=s):u===a&&l<e&&(e=l,h=s)}i=h||i.children[0]}var m,c;return i},r.prototype._insert=function(t,i,n){var r=n?t:this.toBBox(t),e=[],a=this._chooseSubtree(r,this.data,i,e);for(a.children.push(t),o(a,r);i>=0&&e[i].children.length>this._maxEntries;)this._split(e,i),i--;this._adjustParentBBoxes(r,e,i)},r.prototype._split=function(t,i){var n=t[i],r=n.children.length,e=this._minEntries;this._chooseSplitAxis(n,e,r);var h=this._chooseSplitIndex(n,e,r),o=p(n.children.splice(h,n.children.length-h));o.height=n.height,o.leaf=n.leaf,a(n,this.toBBox),a(o,this.toBBox),i?t[i-1].children.push(o):this._splitRoot(n,o)},r.prototype._splitRoot=function(t,i){this.data=p([t,i]),this.data.height=t.height+1,this.data.leaf=!1,a(this.data,this.toBBox)},r.prototype._chooseSplitIndex=function(t,i,n){for(var r,e,a,o,s,l,u,m=1/0,c=1/0,p=i;p<=n-i;p++){var d=h(t,0,p,this.toBBox),x=h(t,p,n,this.toBBox),v=(e=d,a=x,o=void 0,s=void 0,l=void 0,u=void 0,o=Math.max(e.minX,a.minX),s=Math.max(e.minY,a.minY),l=Math.min(e.maxX,a.maxX),u=Math.min(e.maxY,a.maxY),Math.max(0,l-o)*Math.max(0,u-s)),M=f(d)+f(x);v<m?(m=v,r=p,c=M<c?M:c):v===m&&M<c&&(c=M,r=p)}return r||n-i},r.prototype._chooseSplitAxis=function(t,i,n){var r=t.leaf?this.compareMinX:s,e=t.leaf?this.compareMinY:l;this._allDistMargin(t,i,n,r)<this._allDistMargin(t,i,n,e)&&t.children.sort(r)},r.prototype._allDistMargin=function(t,i,n,r){t.children.sort(r);for(var e=this.toBBox,a=h(t,0,i,e),s=h(t,n-i,n,e),l=u(a)+u(s),f=i;f<n-i;f++){var m=t.children[f];o(a,t.leaf?e(m):m),l+=u(a)}for(var c=n-i-1;c>=i;c--){var p=t.children[c];o(s,t.leaf?e(p):p),l+=u(s)}return l},r.prototype._adjustParentBBoxes=function(t,i,n){for(var r=n;r>=0;r--)o(i[r],t)},r.prototype._condense=function(t){for(var i=t.length-1,n=void 0;i>=0;i--)0===t[i].children.length?i>0?(n=t[i-1].children).splice(n.indexOf(t[i]),1):this.clear():a(t[i],this.toBBox)},r});


/***/ },

/***/ 528
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(9629);

var $Error = __webpack_require__(9838);
var $EvalError = __webpack_require__(9110);
var $RangeError = __webpack_require__(1155);
var $ReferenceError = __webpack_require__(4943);
var $SyntaxError = __webpack_require__(5731);
var $TypeError = __webpack_require__(3468);
var $URIError = __webpack_require__(2140);

var abs = __webpack_require__(8479);
var floor = __webpack_require__(8449);
var max = __webpack_require__(8129);
var min = __webpack_require__(2387);
var pow = __webpack_require__(5865);
var round = __webpack_require__(1319);
var sign = __webpack_require__(6882);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(9336);
var $defineProperty = __webpack_require__(4940);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(3558)();

var getProto = __webpack_require__(6369);
var $ObjectGPO = __webpack_require__(7345);
var $ReflectGPO = __webpack_require__(7859);

var $apply = __webpack_require__(6095);
var $call = __webpack_require__(4531);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(9138);
var hasOwn = __webpack_require__(8554);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ },

/***/ 7345
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(9629);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ },

/***/ 7859
(module) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ },

/***/ 6369
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(7859);
var originalGetProto = __webpack_require__(7345);

var getDunderProto = __webpack_require__(6423);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ },

/***/ 1292
(module) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ },

/***/ 9336
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(1292);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ },

/***/ 7239
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(4940);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ },

/***/ 3558
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(2908);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ },

/***/ 2908
(module) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ },

/***/ 1913
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(2908);

/** @type {import('.')} */
module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ },

/***/ 8554
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(9138);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ },

/***/ 5387
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(1913)();
var callBound = __webpack_require__(4607);

var $toString = callBound('Object.prototype.toString');

/** @type {import('.')} */
var isStandardArguments = function isArguments(value) {
	if (
		hasToStringTag
		&& value
		&& typeof value === 'object'
		&& Symbol.toStringTag in value
	) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

/** @type {import('.')} */
var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null
		&& typeof value === 'object'
		&& 'length' in value
		&& typeof value.length === 'number'
		&& value.length >= 0
		&& $toString(value) !== '[object Array]'
		&& 'callee' in value
		&& $toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

// @ts-expect-error TODO make this not error
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

/** @type {import('.')} */
module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },

/***/ 9543
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(4607);

var getDay = callBound('Date.prototype.getDay');
/** @type {import('.')} */
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay(value);
		return true;
	} catch (e) {
		return false;
	}
};

/** @type {(value: unknown) => string} */
var toStr = callBound('Object.prototype.toString');
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(1913)();

/** @type {import('.')} */
module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr(value) === dateClass;
};


/***/ },

/***/ 2672
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(4607);
var hasToStringTag = __webpack_require__(1913)();
var hasOwn = __webpack_require__(8554);
var gOPD = __webpack_require__(9336);

/** @type {import('.')} */
var fn;

if (hasToStringTag) {
	/** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */
	var $exec = callBound('RegExp.prototype.exec');
	/** @type {object} */
	var isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	/** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */
	var badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}

	/** @type {import('.')} */
	// @ts-expect-error TS can't figure out that the $exec call always throws
	// eslint-disable-next-line consistent-return
	fn = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {NonNullable<typeof gOPD>} */ (gOPD)(/** @type {{ lastIndex?: unknown }} */ (value), 'lastIndex');
		var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			// eslint-disable-next-line no-extra-parens
			$exec(value, /** @type {string} */ (/** @type {unknown} */ (badStringifier)));
		} catch (e) {
			return e === isRegexMarker;
		}
	};
} else {
	/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */
	var $toString = callBound('Object.prototype.toString');
	/** @const @type {'[object RegExp]'} */
	var regexClass = '[object RegExp]';

	/** @type {import('.')} */
	fn = function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};
}

module.exports = fn;


/***/ },

/***/ 8479
(module) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ },

/***/ 8449
(module) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ },

/***/ 2422
(module) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ },

/***/ 8129
(module) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ },

/***/ 2387
(module) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ },

/***/ 5865
(module) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ },

/***/ 1319
(module) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ },

/***/ 6882
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(2422);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ },

/***/ 1513
(module) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ },

/***/ 2372
(module) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ },

/***/ 5968
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(1857);
var callBind = __webpack_require__(8498);

var implementation = __webpack_require__(2372);
var getPolyfill = __webpack_require__(1937);
var shim = __webpack_require__(5087);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ },

/***/ 1937
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(2372);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ },

/***/ 5087
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(1937);
var define = __webpack_require__(1857);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ },

/***/ 8160
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(968); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ },

/***/ 9228
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(968);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(8160);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ },

/***/ 968
(module) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ },

/***/ 6232
(module) {

module.exports = function pointInPolygonFlat (point, vs, start, end) {
    var x = point[0], y = point[1];
    var inside = false;
    if (start === undefined) start = 0;
    if (end === undefined) end = vs.length;
    var len = (end-start)/2;
    for (var i = 0, j = len - 1; i < len; j = i++) {
        var xi = vs[start+i*2+0], yi = vs[start+i*2+1];
        var xj = vs[start+j*2+0], yj = vs[start+j*2+1];
        var intersect = ((yi > y) !== (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }
    return inside;
};


/***/ },

/***/ 3071
(module, __unused_webpack_exports, __webpack_require__) {

var pointInPolygonFlat = __webpack_require__(6232)
var pointInPolygonNested = __webpack_require__(7100)

module.exports = function pointInPolygon (point, vs, start, end) {
    if (vs.length > 0 && Array.isArray(vs[0])) {
        return pointInPolygonNested(point, vs, start, end);
    } else {
        return pointInPolygonFlat(point, vs, start, end);
    }
}
module.exports.nested = pointInPolygonNested
module.exports.flat = pointInPolygonFlat


/***/ },

/***/ 7100
(module) {

// ray-casting algorithm based on
// https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html

module.exports = function pointInPolygonNested (point, vs, start, end) {
    var x = point[0], y = point[1];
    var inside = false;
    if (start === undefined) start = 0;
    if (end === undefined) end = vs.length;
    var len = end - start;
    for (var i = 0, j = len - 1; i < len; j = i++) {
        var xi = vs[i+start][0], yi = vs[i+start][1];
        var xj = vs[j+start][0], yj = vs[j+start][1];
        var intersect = ((yi > y) !== (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }
    return inside;
};


/***/ },

/***/ 2235
(module) {

(function (global, factory) {
     true ? module.exports = factory() :
    0;
})(this, (function () { 'use strict';

    /**
     * splaytree v3.1.2
     * Fast Splay tree for Node and browser
     *
     * @author Alexander Milevski <info@w8r.name>
     * @license MIT
     * @preserve
     */

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    function __generator(thisArg, body) {
      var _ = {
          label: 0,
          sent: function () {
            if (t[0] & 1) throw t[1];
            return t[1];
          },
          trys: [],
          ops: []
        },
        f,
        y,
        t,
        g;
      return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
      }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
        return this;
      }), g;
      function verb(n) {
        return function (v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _.label++;
              return {
                value: op[1],
                done: false
              };
            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _.ops.pop();
              _.trys.pop();
              continue;
            default:
              if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }
              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                _.label = op[1];
                break;
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }
              if (t && _.label < t[2]) {
                _.label = t[2];
                _.ops.push(op);
                break;
              }
              if (t[2]) _.ops.pop();
              _.trys.pop();
              continue;
          }
          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
          value: op[0] ? op[1] : void 0,
          done: true
        };
      }
    }
    var Node = /** @class */function () {
      function Node(key, data) {
        this.next = null;
        this.key = key;
        this.data = data;
        this.left = null;
        this.right = null;
      }
      return Node;
    }();

    /* follows "An implementation of top-down splaying"
     * by D. Sleator <sleator@cs.cmu.edu> March 1992
     */
    function DEFAULT_COMPARE(a, b) {
      return a > b ? 1 : a < b ? -1 : 0;
    }
    /**
     * Simple top down splay, not requiring i to be in the tree t.
     */
    function splay(i, t, comparator) {
      var N = new Node(null, null);
      var l = N;
      var r = N;
      while (true) {
        var cmp = comparator(i, t.key);
        //if (i < t.key) {
        if (cmp < 0) {
          if (t.left === null) break;
          //if (i < t.left.key) {
          if (comparator(i, t.left.key) < 0) {
            var y = t.left; /* rotate right */
            t.left = y.right;
            y.right = t;
            t = y;
            if (t.left === null) break;
          }
          r.left = t; /* link right */
          r = t;
          t = t.left;
          //} else if (i > t.key) {
        } else if (cmp > 0) {
          if (t.right === null) break;
          //if (i > t.right.key) {
          if (comparator(i, t.right.key) > 0) {
            var y = t.right; /* rotate left */
            t.right = y.left;
            y.left = t;
            t = y;
            if (t.right === null) break;
          }
          l.right = t; /* link left */
          l = t;
          t = t.right;
        } else break;
      }
      /* assemble */
      l.right = t.left;
      r.left = t.right;
      t.left = N.right;
      t.right = N.left;
      return t;
    }
    function insert(i, data, t, comparator) {
      var node = new Node(i, data);
      if (t === null) {
        node.left = node.right = null;
        return node;
      }
      t = splay(i, t, comparator);
      var cmp = comparator(i, t.key);
      if (cmp < 0) {
        node.left = t.left;
        node.right = t;
        t.left = null;
      } else if (cmp >= 0) {
        node.right = t.right;
        node.left = t;
        t.right = null;
      }
      return node;
    }
    function split(key, v, comparator) {
      var left = null;
      var right = null;
      if (v) {
        v = splay(key, v, comparator);
        var cmp = comparator(v.key, key);
        if (cmp === 0) {
          left = v.left;
          right = v.right;
        } else if (cmp < 0) {
          right = v.right;
          v.right = null;
          left = v;
        } else {
          left = v.left;
          v.left = null;
          right = v;
        }
      }
      return {
        left: left,
        right: right
      };
    }
    function merge(left, right, comparator) {
      if (right === null) return left;
      if (left === null) return right;
      right = splay(left.key, right, comparator);
      right.left = left;
      return right;
    }
    /**
     * Prints level of the tree
     */
    function printRow(root, prefix, isTail, out, printNode) {
      if (root) {
        out("" + prefix + (isTail ? '└── ' : '├── ') + printNode(root) + "\n");
        var indent = prefix + (isTail ? '    ' : '│   ');
        if (root.left) printRow(root.left, indent, false, out, printNode);
        if (root.right) printRow(root.right, indent, true, out, printNode);
      }
    }
    var Tree = /** @class */function () {
      function Tree(comparator) {
        if (comparator === void 0) {
          comparator = DEFAULT_COMPARE;
        }
        this._root = null;
        this._size = 0;
        this._comparator = comparator;
      }
      /**
       * Inserts a key, allows duplicates
       */
      Tree.prototype.insert = function (key, data) {
        this._size++;
        return this._root = insert(key, data, this._root, this._comparator);
      };
      /**
       * Adds a key, if it is not present in the tree
       */
      Tree.prototype.add = function (key, data) {
        var node = new Node(key, data);
        if (this._root === null) {
          node.left = node.right = null;
          this._size++;
          this._root = node;
        }
        var comparator = this._comparator;
        var t = splay(key, this._root, comparator);
        var cmp = comparator(key, t.key);
        if (cmp === 0) this._root = t;else {
          if (cmp < 0) {
            node.left = t.left;
            node.right = t;
            t.left = null;
          } else if (cmp > 0) {
            node.right = t.right;
            node.left = t;
            t.right = null;
          }
          this._size++;
          this._root = node;
        }
        return this._root;
      };
      /**
       * @param  {Key} key
       * @return {Node|null}
       */
      Tree.prototype.remove = function (key) {
        this._root = this._remove(key, this._root, this._comparator);
      };
      /**
       * Deletes i from the tree if it's there
       */
      Tree.prototype._remove = function (i, t, comparator) {
        var x;
        if (t === null) return null;
        t = splay(i, t, comparator);
        var cmp = comparator(i, t.key);
        if (cmp === 0) {
          /* found it */
          if (t.left === null) {
            x = t.right;
          } else {
            x = splay(i, t.left, comparator);
            x.right = t.right;
          }
          this._size--;
          return x;
        }
        return t; /* It wasn't there */
      };
      /**
       * Removes and returns the node with smallest key
       */
      Tree.prototype.pop = function () {
        var node = this._root;
        if (node) {
          while (node.left) node = node.left;
          this._root = splay(node.key, this._root, this._comparator);
          this._root = this._remove(node.key, this._root, this._comparator);
          return {
            key: node.key,
            data: node.data
          };
        }
        return null;
      };
      /**
       * Find without splaying
       */
      Tree.prototype.findStatic = function (key) {
        var current = this._root;
        var compare = this._comparator;
        while (current) {
          var cmp = compare(key, current.key);
          if (cmp === 0) return current;else if (cmp < 0) current = current.left;else current = current.right;
        }
        return null;
      };
      Tree.prototype.find = function (key) {
        if (this._root) {
          this._root = splay(key, this._root, this._comparator);
          if (this._comparator(key, this._root.key) !== 0) return null;
        }
        return this._root;
      };
      Tree.prototype.contains = function (key) {
        var current = this._root;
        var compare = this._comparator;
        while (current) {
          var cmp = compare(key, current.key);
          if (cmp === 0) return true;else if (cmp < 0) current = current.left;else current = current.right;
        }
        return false;
      };
      Tree.prototype.forEach = function (visitor, ctx) {
        var current = this._root;
        var Q = []; /* Initialize stack s */
        var done = false;
        while (!done) {
          if (current !== null) {
            Q.push(current);
            current = current.left;
          } else {
            if (Q.length !== 0) {
              current = Q.pop();
              visitor.call(ctx, current);
              current = current.right;
            } else done = true;
          }
        }
        return this;
      };
      /**
       * Walk key range from `low` to `high`. Stops if `fn` returns a value.
       */
      Tree.prototype.range = function (low, high, fn, ctx) {
        var Q = [];
        var compare = this._comparator;
        var node = this._root;
        var cmp;
        while (Q.length !== 0 || node) {
          if (node) {
            Q.push(node);
            node = node.left;
          } else {
            node = Q.pop();
            cmp = compare(node.key, high);
            if (cmp > 0) {
              break;
            } else if (compare(node.key, low) >= 0) {
              if (fn.call(ctx, node)) return this; // stop if smth is returned
            }
            node = node.right;
          }
        }
        return this;
      };
      /**
       * Returns array of keys
       */
      Tree.prototype.keys = function () {
        var keys = [];
        this.forEach(function (_a) {
          var key = _a.key;
          return keys.push(key);
        });
        return keys;
      };
      /**
       * Returns array of all the data in the nodes
       */
      Tree.prototype.values = function () {
        var values = [];
        this.forEach(function (_a) {
          var data = _a.data;
          return values.push(data);
        });
        return values;
      };
      Tree.prototype.min = function () {
        if (this._root) return this.minNode(this._root).key;
        return null;
      };
      Tree.prototype.max = function () {
        if (this._root) return this.maxNode(this._root).key;
        return null;
      };
      Tree.prototype.minNode = function (t) {
        if (t === void 0) {
          t = this._root;
        }
        if (t) while (t.left) t = t.left;
        return t;
      };
      Tree.prototype.maxNode = function (t) {
        if (t === void 0) {
          t = this._root;
        }
        if (t) while (t.right) t = t.right;
        return t;
      };
      /**
       * Returns node at given index
       */
      Tree.prototype.at = function (index) {
        var current = this._root;
        var done = false;
        var i = 0;
        var Q = [];
        while (!done) {
          if (current) {
            Q.push(current);
            current = current.left;
          } else {
            if (Q.length > 0) {
              current = Q.pop();
              if (i === index) return current;
              i++;
              current = current.right;
            } else done = true;
          }
        }
        return null;
      };
      Tree.prototype.next = function (d) {
        var root = this._root;
        var successor = null;
        if (d.right) {
          successor = d.right;
          while (successor.left) successor = successor.left;
          return successor;
        }
        var comparator = this._comparator;
        while (root) {
          var cmp = comparator(d.key, root.key);
          if (cmp === 0) break;else if (cmp < 0) {
            successor = root;
            root = root.left;
          } else root = root.right;
        }
        return successor;
      };
      Tree.prototype.prev = function (d) {
        var root = this._root;
        var predecessor = null;
        if (d.left !== null) {
          predecessor = d.left;
          while (predecessor.right) predecessor = predecessor.right;
          return predecessor;
        }
        var comparator = this._comparator;
        while (root) {
          var cmp = comparator(d.key, root.key);
          if (cmp === 0) break;else if (cmp < 0) root = root.left;else {
            predecessor = root;
            root = root.right;
          }
        }
        return predecessor;
      };
      Tree.prototype.clear = function () {
        this._root = null;
        this._size = 0;
        return this;
      };
      Tree.prototype.toList = function () {
        return toList(this._root);
      };
      /**
       * Bulk-load items. Both array have to be same size
       */
      Tree.prototype.load = function (keys, values, presort) {
        if (values === void 0) {
          values = [];
        }
        if (presort === void 0) {
          presort = false;
        }
        var size = keys.length;
        var comparator = this._comparator;
        // sort if needed
        if (presort) sort(keys, values, 0, size - 1, comparator);
        if (this._root === null) {
          // empty tree
          this._root = loadRecursive(keys, values, 0, size);
          this._size = size;
        } else {
          // that re-builds the whole tree from two in-order traversals
          var mergedList = mergeLists(this.toList(), createList(keys, values), comparator);
          size = this._size + size;
          this._root = sortedListToBST({
            head: mergedList
          }, 0, size);
        }
        return this;
      };
      Tree.prototype.isEmpty = function () {
        return this._root === null;
      };
      Object.defineProperty(Tree.prototype, "size", {
        get: function () {
          return this._size;
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(Tree.prototype, "root", {
        get: function () {
          return this._root;
        },
        enumerable: true,
        configurable: true
      });
      Tree.prototype.toString = function (printNode) {
        if (printNode === void 0) {
          printNode = function (n) {
            return String(n.key);
          };
        }
        var out = [];
        printRow(this._root, '', true, function (v) {
          return out.push(v);
        }, printNode);
        return out.join('');
      };
      Tree.prototype.update = function (key, newKey, newData) {
        var comparator = this._comparator;
        var _a = split(key, this._root, comparator),
          left = _a.left,
          right = _a.right;
        if (comparator(key, newKey) < 0) {
          right = insert(newKey, newData, right, comparator);
        } else {
          left = insert(newKey, newData, left, comparator);
        }
        this._root = merge(left, right, comparator);
      };
      Tree.prototype.split = function (key) {
        return split(key, this._root, this._comparator);
      };
      Tree.prototype[Symbol.iterator] = function () {
        var current, Q, done;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              current = this._root;
              Q = [];
              done = false;
              _a.label = 1;
            case 1:
              if (!!done) return [3 /*break*/, 6];
              if (!(current !== null)) return [3 /*break*/, 2];
              Q.push(current);
              current = current.left;
              return [3 /*break*/, 5];
            case 2:
              if (!(Q.length !== 0)) return [3 /*break*/, 4];
              current = Q.pop();
              return [4 /*yield*/, current];
            case 3:
              _a.sent();
              current = current.right;
              return [3 /*break*/, 5];
            case 4:
              done = true;
              _a.label = 5;
            case 5:
              return [3 /*break*/, 1];
            case 6:
              return [2 /*return*/];
          }
        });
      };
      return Tree;
    }();
    function loadRecursive(keys, values, start, end) {
      var size = end - start;
      if (size > 0) {
        var middle = start + Math.floor(size / 2);
        var key = keys[middle];
        var data = values[middle];
        var node = new Node(key, data);
        node.left = loadRecursive(keys, values, start, middle);
        node.right = loadRecursive(keys, values, middle + 1, end);
        return node;
      }
      return null;
    }
    function createList(keys, values) {
      var head = new Node(null, null);
      var p = head;
      for (var i = 0; i < keys.length; i++) {
        p = p.next = new Node(keys[i], values[i]);
      }
      p.next = null;
      return head.next;
    }
    function toList(root) {
      var current = root;
      var Q = [];
      var done = false;
      var head = new Node(null, null);
      var p = head;
      while (!done) {
        if (current) {
          Q.push(current);
          current = current.left;
        } else {
          if (Q.length > 0) {
            current = p = p.next = Q.pop();
            current = current.right;
          } else done = true;
        }
      }
      p.next = null; // that'll work even if the tree was empty
      return head.next;
    }
    function sortedListToBST(list, start, end) {
      var size = end - start;
      if (size > 0) {
        var middle = start + Math.floor(size / 2);
        var left = sortedListToBST(list, start, middle);
        var root = list.head;
        root.left = left;
        list.head = list.head.next;
        root.right = sortedListToBST(list, middle + 1, end);
        return root;
      }
      return null;
    }
    function mergeLists(l1, l2, compare) {
      var head = new Node(null, null); // dummy
      var p = head;
      var p1 = l1;
      var p2 = l2;
      while (p1 !== null && p2 !== null) {
        if (compare(p1.key, p2.key) < 0) {
          p.next = p1;
          p1 = p1.next;
        } else {
          p.next = p2;
          p2 = p2.next;
        }
        p = p.next;
      }
      if (p1 !== null) {
        p.next = p1;
      } else if (p2 !== null) {
        p.next = p2;
      }
      return head.next;
    }
    function sort(keys, values, left, right, compare) {
      if (left >= right) return;
      var pivot = keys[left + right >> 1];
      var i = left - 1;
      var j = right + 1;
      while (true) {
        do i++; while (compare(keys[i], pivot) < 0);
        do j--; while (compare(keys[j], pivot) > 0);
        if (i >= j) break;
        var tmp = keys[i];
        keys[i] = keys[j];
        keys[j] = tmp;
        tmp = values[i];
        values[i] = values[j];
        values[j] = tmp;
      }
      sort(keys, values, left, j, compare);
      sort(keys, values, j + 1, right, compare);
    }

    /**
     * A bounding box has the format:
     *
     *  { ll: { x: xmin, y: ymin }, ur: { x: xmax, y: ymax } }
     *
     */

    const isInBbox = (bbox, point) => {
      return bbox.ll.x <= point.x && point.x <= bbox.ur.x && bbox.ll.y <= point.y && point.y <= bbox.ur.y;
    };

    /* Returns either null, or a bbox (aka an ordered pair of points)
     * If there is only one point of overlap, a bbox with identical points
     * will be returned */
    const getBboxOverlap = (b1, b2) => {
      // check if the bboxes overlap at all
      if (b2.ur.x < b1.ll.x || b1.ur.x < b2.ll.x || b2.ur.y < b1.ll.y || b1.ur.y < b2.ll.y) return null;

      // find the middle two X values
      const lowerX = b1.ll.x < b2.ll.x ? b2.ll.x : b1.ll.x;
      const upperX = b1.ur.x < b2.ur.x ? b1.ur.x : b2.ur.x;

      // find the middle two Y values
      const lowerY = b1.ll.y < b2.ll.y ? b2.ll.y : b1.ll.y;
      const upperY = b1.ur.y < b2.ur.y ? b1.ur.y : b2.ur.y;

      // put those middle values together to get the overlap
      return {
        ll: {
          x: lowerX,
          y: lowerY
        },
        ur: {
          x: upperX,
          y: upperY
        }
      };
    };

    /* Javascript doesn't do integer math. Everything is
     * floating point with percision Number.EPSILON.
     *
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/EPSILON
     */

    let epsilon$1 = Number.EPSILON;

    // IE Polyfill
    if (epsilon$1 === undefined) epsilon$1 = Math.pow(2, -52);
    const EPSILON_SQ = epsilon$1 * epsilon$1;

    /* FLP comparator */
    const cmp = (a, b) => {
      // check if they're both 0
      if (-epsilon$1 < a && a < epsilon$1) {
        if (-epsilon$1 < b && b < epsilon$1) {
          return 0;
        }
      }

      // check if they're flp equal
      const ab = a - b;
      if (ab * ab < EPSILON_SQ * a * b) {
        return 0;
      }

      // normal comparison
      return a < b ? -1 : 1;
    };

    /**
     * This class rounds incoming values sufficiently so that
     * floating points problems are, for the most part, avoided.
     *
     * Incoming points are have their x & y values tested against
     * all previously seen x & y values. If either is 'too close'
     * to a previously seen value, it's value is 'snapped' to the
     * previously seen value.
     *
     * All points should be rounded by this class before being
     * stored in any data structures in the rest of this algorithm.
     */

    class PtRounder {
      constructor() {
        this.reset();
      }
      reset() {
        this.xRounder = new CoordRounder();
        this.yRounder = new CoordRounder();
      }
      round(x, y) {
        return {
          x: this.xRounder.round(x),
          y: this.yRounder.round(y)
        };
      }
    }
    class CoordRounder {
      constructor() {
        this.tree = new Tree();
        // preseed with 0 so we don't end up with values < Number.EPSILON
        this.round(0);
      }

      // Note: this can rounds input values backwards or forwards.
      //       You might ask, why not restrict this to just rounding
      //       forwards? Wouldn't that allow left endpoints to always
      //       remain left endpoints during splitting (never change to
      //       right). No - it wouldn't, because we snap intersections
      //       to endpoints (to establish independence from the segment
      //       angle for t-intersections).
      round(coord) {
        const node = this.tree.add(coord);
        const prevNode = this.tree.prev(node);
        if (prevNode !== null && cmp(node.key, prevNode.key) === 0) {
          this.tree.remove(coord);
          return prevNode.key;
        }
        const nextNode = this.tree.next(node);
        if (nextNode !== null && cmp(node.key, nextNode.key) === 0) {
          this.tree.remove(coord);
          return nextNode.key;
        }
        return coord;
      }
    }

    // singleton available by import
    const rounder = new PtRounder();

    const epsilon = 1.1102230246251565e-16;
    const splitter = 134217729;
    const resulterrbound = (3 + 8 * epsilon) * epsilon;

    // fast_expansion_sum_zeroelim routine from oritinal code
    function sum(elen, e, flen, f, h) {
      let Q, Qnew, hh, bvirt;
      let enow = e[0];
      let fnow = f[0];
      let eindex = 0;
      let findex = 0;
      if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
      } else {
        Q = fnow;
        fnow = f[++findex];
      }
      let hindex = 0;
      if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
          Qnew = enow + Q;
          hh = Q - (Qnew - enow);
          enow = e[++eindex];
        } else {
          Qnew = fnow + Q;
          hh = Q - (Qnew - fnow);
          fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) {
          h[hindex++] = hh;
        }
        while (eindex < elen && findex < flen) {
          if (fnow > enow === fnow > -enow) {
            Qnew = Q + enow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (enow - bvirt);
            enow = e[++eindex];
          } else {
            Qnew = Q + fnow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (fnow - bvirt);
            fnow = f[++findex];
          }
          Q = Qnew;
          if (hh !== 0) {
            h[hindex++] = hh;
          }
        }
      }
      while (eindex < elen) {
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) {
          h[hindex++] = hh;
        }
      }
      while (findex < flen) {
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) {
          h[hindex++] = hh;
        }
      }
      if (Q !== 0 || hindex === 0) {
        h[hindex++] = Q;
      }
      return hindex;
    }
    function estimate(elen, e) {
      let Q = e[0];
      for (let i = 1; i < elen; i++) Q += e[i];
      return Q;
    }
    function vec(n) {
      return new Float64Array(n);
    }

    const ccwerrboundA = (3 + 16 * epsilon) * epsilon;
    const ccwerrboundB = (2 + 12 * epsilon) * epsilon;
    const ccwerrboundC = (9 + 64 * epsilon) * epsilon * epsilon;
    const B = vec(4);
    const C1 = vec(8);
    const C2 = vec(12);
    const D = vec(16);
    const u = vec(4);
    function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
      let acxtail, acytail, bcxtail, bcytail;
      let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
      const acx = ax - cx;
      const bcx = bx - cx;
      const acy = ay - cy;
      const bcy = by - cy;
      s1 = acx * bcy;
      c = splitter * acx;
      ahi = c - (c - acx);
      alo = acx - ahi;
      c = splitter * bcy;
      bhi = c - (c - bcy);
      blo = bcy - bhi;
      s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
      t1 = acy * bcx;
      c = splitter * acy;
      ahi = c - (c - acy);
      alo = acy - ahi;
      c = splitter * bcx;
      bhi = c - (c - bcx);
      blo = bcx - bhi;
      t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
      _i = s0 - t0;
      bvirt = s0 - _i;
      B[0] = s0 - (_i + bvirt) + (bvirt - t0);
      _j = s1 + _i;
      bvirt = _j - s1;
      _0 = s1 - (_j - bvirt) + (_i - bvirt);
      _i = _0 - t1;
      bvirt = _0 - _i;
      B[1] = _0 - (_i + bvirt) + (bvirt - t1);
      u3 = _j + _i;
      bvirt = u3 - _j;
      B[2] = _j - (u3 - bvirt) + (_i - bvirt);
      B[3] = u3;
      let det = estimate(4, B);
      let errbound = ccwerrboundB * detsum;
      if (det >= errbound || -det >= errbound) {
        return det;
      }
      bvirt = ax - acx;
      acxtail = ax - (acx + bvirt) + (bvirt - cx);
      bvirt = bx - bcx;
      bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
      bvirt = ay - acy;
      acytail = ay - (acy + bvirt) + (bvirt - cy);
      bvirt = by - bcy;
      bcytail = by - (bcy + bvirt) + (bvirt - cy);
      if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) {
        return det;
      }
      errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
      det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
      if (det >= errbound || -det >= errbound) return det;
      s1 = acxtail * bcy;
      c = splitter * acxtail;
      ahi = c - (c - acxtail);
      alo = acxtail - ahi;
      c = splitter * bcy;
      bhi = c - (c - bcy);
      blo = bcy - bhi;
      s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
      t1 = acytail * bcx;
      c = splitter * acytail;
      ahi = c - (c - acytail);
      alo = acytail - ahi;
      c = splitter * bcx;
      bhi = c - (c - bcx);
      blo = bcx - bhi;
      t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
      _i = s0 - t0;
      bvirt = s0 - _i;
      u[0] = s0 - (_i + bvirt) + (bvirt - t0);
      _j = s1 + _i;
      bvirt = _j - s1;
      _0 = s1 - (_j - bvirt) + (_i - bvirt);
      _i = _0 - t1;
      bvirt = _0 - _i;
      u[1] = _0 - (_i + bvirt) + (bvirt - t1);
      u3 = _j + _i;
      bvirt = u3 - _j;
      u[2] = _j - (u3 - bvirt) + (_i - bvirt);
      u[3] = u3;
      const C1len = sum(4, B, 4, u, C1);
      s1 = acx * bcytail;
      c = splitter * acx;
      ahi = c - (c - acx);
      alo = acx - ahi;
      c = splitter * bcytail;
      bhi = c - (c - bcytail);
      blo = bcytail - bhi;
      s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
      t1 = acy * bcxtail;
      c = splitter * acy;
      ahi = c - (c - acy);
      alo = acy - ahi;
      c = splitter * bcxtail;
      bhi = c - (c - bcxtail);
      blo = bcxtail - bhi;
      t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
      _i = s0 - t0;
      bvirt = s0 - _i;
      u[0] = s0 - (_i + bvirt) + (bvirt - t0);
      _j = s1 + _i;
      bvirt = _j - s1;
      _0 = s1 - (_j - bvirt) + (_i - bvirt);
      _i = _0 - t1;
      bvirt = _0 - _i;
      u[1] = _0 - (_i + bvirt) + (bvirt - t1);
      u3 = _j + _i;
      bvirt = u3 - _j;
      u[2] = _j - (u3 - bvirt) + (_i - bvirt);
      u[3] = u3;
      const C2len = sum(C1len, C1, 4, u, C2);
      s1 = acxtail * bcytail;
      c = splitter * acxtail;
      ahi = c - (c - acxtail);
      alo = acxtail - ahi;
      c = splitter * bcytail;
      bhi = c - (c - bcytail);
      blo = bcytail - bhi;
      s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
      t1 = acytail * bcxtail;
      c = splitter * acytail;
      ahi = c - (c - acytail);
      alo = acytail - ahi;
      c = splitter * bcxtail;
      bhi = c - (c - bcxtail);
      blo = bcxtail - bhi;
      t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
      _i = s0 - t0;
      bvirt = s0 - _i;
      u[0] = s0 - (_i + bvirt) + (bvirt - t0);
      _j = s1 + _i;
      bvirt = _j - s1;
      _0 = s1 - (_j - bvirt) + (_i - bvirt);
      _i = _0 - t1;
      bvirt = _0 - _i;
      u[1] = _0 - (_i + bvirt) + (bvirt - t1);
      u3 = _j + _i;
      bvirt = u3 - _j;
      u[2] = _j - (u3 - bvirt) + (_i - bvirt);
      u[3] = u3;
      const Dlen = sum(C2len, C2, 4, u, D);
      return D[Dlen - 1];
    }
    function orient2d(ax, ay, bx, by, cx, cy) {
      const detleft = (ay - cy) * (bx - cx);
      const detright = (ax - cx) * (by - cy);
      const det = detleft - detright;
      const detsum = Math.abs(detleft + detright);
      if (Math.abs(det) >= ccwerrboundA * detsum) return det;
      return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
    }

    /* Cross Product of two vectors with first point at origin */
    const crossProduct = (a, b) => a.x * b.y - a.y * b.x;

    /* Dot Product of two vectors with first point at origin */
    const dotProduct = (a, b) => a.x * b.x + a.y * b.y;

    /* Comparator for two vectors with same starting point */
    const compareVectorAngles = (basePt, endPt1, endPt2) => {
      const res = orient2d(basePt.x, basePt.y, endPt1.x, endPt1.y, endPt2.x, endPt2.y);
      if (res > 0) return -1;
      if (res < 0) return 1;
      return 0;
    };
    const length = v => Math.sqrt(dotProduct(v, v));

    /* Get the sine of the angle from pShared -> pAngle to pShaed -> pBase */
    const sineOfAngle = (pShared, pBase, pAngle) => {
      const vBase = {
        x: pBase.x - pShared.x,
        y: pBase.y - pShared.y
      };
      const vAngle = {
        x: pAngle.x - pShared.x,
        y: pAngle.y - pShared.y
      };
      return crossProduct(vAngle, vBase) / length(vAngle) / length(vBase);
    };

    /* Get the cosine of the angle from pShared -> pAngle to pShaed -> pBase */
    const cosineOfAngle = (pShared, pBase, pAngle) => {
      const vBase = {
        x: pBase.x - pShared.x,
        y: pBase.y - pShared.y
      };
      const vAngle = {
        x: pAngle.x - pShared.x,
        y: pAngle.y - pShared.y
      };
      return dotProduct(vAngle, vBase) / length(vAngle) / length(vBase);
    };

    /* Get the x coordinate where the given line (defined by a point and vector)
     * crosses the horizontal line with the given y coordiante.
     * In the case of parrallel lines (including overlapping ones) returns null. */
    const horizontalIntersection = (pt, v, y) => {
      if (v.y === 0) return null;
      return {
        x: pt.x + v.x / v.y * (y - pt.y),
        y: y
      };
    };

    /* Get the y coordinate where the given line (defined by a point and vector)
     * crosses the vertical line with the given x coordiante.
     * In the case of parrallel lines (including overlapping ones) returns null. */
    const verticalIntersection = (pt, v, x) => {
      if (v.x === 0) return null;
      return {
        x: x,
        y: pt.y + v.y / v.x * (x - pt.x)
      };
    };

    /* Get the intersection of two lines, each defined by a base point and a vector.
     * In the case of parrallel lines (including overlapping ones) returns null. */
    const intersection$1 = (pt1, v1, pt2, v2) => {
      // take some shortcuts for vertical and horizontal lines
      // this also ensures we don't calculate an intersection and then discover
      // it's actually outside the bounding box of the line
      if (v1.x === 0) return verticalIntersection(pt2, v2, pt1.x);
      if (v2.x === 0) return verticalIntersection(pt1, v1, pt2.x);
      if (v1.y === 0) return horizontalIntersection(pt2, v2, pt1.y);
      if (v2.y === 0) return horizontalIntersection(pt1, v1, pt2.y);

      // General case for non-overlapping segments.
      // This algorithm is based on Schneider and Eberly.
      // http://www.cimec.org.ar/~ncalvo/Schneider_Eberly.pdf - pg 244

      const kross = crossProduct(v1, v2);
      if (kross == 0) return null;
      const ve = {
        x: pt2.x - pt1.x,
        y: pt2.y - pt1.y
      };
      const d1 = crossProduct(ve, v1) / kross;
      const d2 = crossProduct(ve, v2) / kross;

      // take the average of the two calculations to minimize rounding error
      const x1 = pt1.x + d2 * v1.x,
        x2 = pt2.x + d1 * v2.x;
      const y1 = pt1.y + d2 * v1.y,
        y2 = pt2.y + d1 * v2.y;
      const x = (x1 + x2) / 2;
      const y = (y1 + y2) / 2;
      return {
        x: x,
        y: y
      };
    };

    class SweepEvent {
      // for ordering sweep events in the sweep event queue
      static compare(a, b) {
        // favor event with a point that the sweep line hits first
        const ptCmp = SweepEvent.comparePoints(a.point, b.point);
        if (ptCmp !== 0) return ptCmp;

        // the points are the same, so link them if needed
        if (a.point !== b.point) a.link(b);

        // favor right events over left
        if (a.isLeft !== b.isLeft) return a.isLeft ? 1 : -1;

        // we have two matching left or right endpoints
        // ordering of this case is the same as for their segments
        return Segment.compare(a.segment, b.segment);
      }

      // for ordering points in sweep line order
      static comparePoints(aPt, bPt) {
        if (aPt.x < bPt.x) return -1;
        if (aPt.x > bPt.x) return 1;
        if (aPt.y < bPt.y) return -1;
        if (aPt.y > bPt.y) return 1;
        return 0;
      }

      // Warning: 'point' input will be modified and re-used (for performance)
      constructor(point, isLeft) {
        if (point.events === undefined) point.events = [this];else point.events.push(this);
        this.point = point;
        this.isLeft = isLeft;
        // this.segment, this.otherSE set by factory
      }
      link(other) {
        if (other.point === this.point) {
          throw new Error("Tried to link already linked events");
        }
        const otherEvents = other.point.events;
        for (let i = 0, iMax = otherEvents.length; i < iMax; i++) {
          const evt = otherEvents[i];
          this.point.events.push(evt);
          evt.point = this.point;
        }
        this.checkForConsuming();
      }

      /* Do a pass over our linked events and check to see if any pair
       * of segments match, and should be consumed. */
      checkForConsuming() {
        // FIXME: The loops in this method run O(n^2) => no good.
        //        Maintain little ordered sweep event trees?
        //        Can we maintaining an ordering that avoids the need
        //        for the re-sorting with getLeftmostComparator in geom-out?

        // Compare each pair of events to see if other events also match
        const numEvents = this.point.events.length;
        for (let i = 0; i < numEvents; i++) {
          const evt1 = this.point.events[i];
          if (evt1.segment.consumedBy !== undefined) continue;
          for (let j = i + 1; j < numEvents; j++) {
            const evt2 = this.point.events[j];
            if (evt2.consumedBy !== undefined) continue;
            if (evt1.otherSE.point.events !== evt2.otherSE.point.events) continue;
            evt1.segment.consume(evt2.segment);
          }
        }
      }
      getAvailableLinkedEvents() {
        // point.events is always of length 2 or greater
        const events = [];
        for (let i = 0, iMax = this.point.events.length; i < iMax; i++) {
          const evt = this.point.events[i];
          if (evt !== this && !evt.segment.ringOut && evt.segment.isInResult()) {
            events.push(evt);
          }
        }
        return events;
      }

      /**
       * Returns a comparator function for sorting linked events that will
       * favor the event that will give us the smallest left-side angle.
       * All ring construction starts as low as possible heading to the right,
       * so by always turning left as sharp as possible we'll get polygons
       * without uncessary loops & holes.
       *
       * The comparator function has a compute cache such that it avoids
       * re-computing already-computed values.
       */
      getLeftmostComparator(baseEvent) {
        const cache = new Map();
        const fillCache = linkedEvent => {
          const nextEvent = linkedEvent.otherSE;
          cache.set(linkedEvent, {
            sine: sineOfAngle(this.point, baseEvent.point, nextEvent.point),
            cosine: cosineOfAngle(this.point, baseEvent.point, nextEvent.point)
          });
        };
        return (a, b) => {
          if (!cache.has(a)) fillCache(a);
          if (!cache.has(b)) fillCache(b);
          const {
            sine: asine,
            cosine: acosine
          } = cache.get(a);
          const {
            sine: bsine,
            cosine: bcosine
          } = cache.get(b);

          // both on or above x-axis
          if (asine >= 0 && bsine >= 0) {
            if (acosine < bcosine) return 1;
            if (acosine > bcosine) return -1;
            return 0;
          }

          // both below x-axis
          if (asine < 0 && bsine < 0) {
            if (acosine < bcosine) return -1;
            if (acosine > bcosine) return 1;
            return 0;
          }

          // one above x-axis, one below
          if (bsine < asine) return -1;
          if (bsine > asine) return 1;
          return 0;
        };
      }
    }

    // Give segments unique ID's to get consistent sorting of
    // segments and sweep events when all else is identical
    let segmentId = 0;
    class Segment {
      /* This compare() function is for ordering segments in the sweep
       * line tree, and does so according to the following criteria:
       *
       * Consider the vertical line that lies an infinestimal step to the
       * right of the right-more of the two left endpoints of the input
       * segments. Imagine slowly moving a point up from negative infinity
       * in the increasing y direction. Which of the two segments will that
       * point intersect first? That segment comes 'before' the other one.
       *
       * If neither segment would be intersected by such a line, (if one
       * or more of the segments are vertical) then the line to be considered
       * is directly on the right-more of the two left inputs.
       */
      static compare(a, b) {
        const alx = a.leftSE.point.x;
        const blx = b.leftSE.point.x;
        const arx = a.rightSE.point.x;
        const brx = b.rightSE.point.x;

        // check if they're even in the same vertical plane
        if (brx < alx) return 1;
        if (arx < blx) return -1;
        const aly = a.leftSE.point.y;
        const bly = b.leftSE.point.y;
        const ary = a.rightSE.point.y;
        const bry = b.rightSE.point.y;

        // is left endpoint of segment B the right-more?
        if (alx < blx) {
          // are the two segments in the same horizontal plane?
          if (bly < aly && bly < ary) return 1;
          if (bly > aly && bly > ary) return -1;

          // is the B left endpoint colinear to segment A?
          const aCmpBLeft = a.comparePoint(b.leftSE.point);
          if (aCmpBLeft < 0) return 1;
          if (aCmpBLeft > 0) return -1;

          // is the A right endpoint colinear to segment B ?
          const bCmpARight = b.comparePoint(a.rightSE.point);
          if (bCmpARight !== 0) return bCmpARight;

          // colinear segments, consider the one with left-more
          // left endpoint to be first (arbitrary?)
          return -1;
        }

        // is left endpoint of segment A the right-more?
        if (alx > blx) {
          if (aly < bly && aly < bry) return -1;
          if (aly > bly && aly > bry) return 1;

          // is the A left endpoint colinear to segment B?
          const bCmpALeft = b.comparePoint(a.leftSE.point);
          if (bCmpALeft !== 0) return bCmpALeft;

          // is the B right endpoint colinear to segment A?
          const aCmpBRight = a.comparePoint(b.rightSE.point);
          if (aCmpBRight < 0) return 1;
          if (aCmpBRight > 0) return -1;

          // colinear segments, consider the one with left-more
          // left endpoint to be first (arbitrary?)
          return 1;
        }

        // if we get here, the two left endpoints are in the same
        // vertical plane, ie alx === blx

        // consider the lower left-endpoint to come first
        if (aly < bly) return -1;
        if (aly > bly) return 1;

        // left endpoints are identical
        // check for colinearity by using the left-more right endpoint

        // is the A right endpoint more left-more?
        if (arx < brx) {
          const bCmpARight = b.comparePoint(a.rightSE.point);
          if (bCmpARight !== 0) return bCmpARight;
        }

        // is the B right endpoint more left-more?
        if (arx > brx) {
          const aCmpBRight = a.comparePoint(b.rightSE.point);
          if (aCmpBRight < 0) return 1;
          if (aCmpBRight > 0) return -1;
        }
        if (arx !== brx) {
          // are these two [almost] vertical segments with opposite orientation?
          // if so, the one with the lower right endpoint comes first
          const ay = ary - aly;
          const ax = arx - alx;
          const by = bry - bly;
          const bx = brx - blx;
          if (ay > ax && by < bx) return 1;
          if (ay < ax && by > bx) return -1;
        }

        // we have colinear segments with matching orientation
        // consider the one with more left-more right endpoint to be first
        if (arx > brx) return 1;
        if (arx < brx) return -1;

        // if we get here, two two right endpoints are in the same
        // vertical plane, ie arx === brx

        // consider the lower right-endpoint to come first
        if (ary < bry) return -1;
        if (ary > bry) return 1;

        // right endpoints identical as well, so the segments are idential
        // fall back on creation order as consistent tie-breaker
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;

        // identical segment, ie a === b
        return 0;
      }

      /* Warning: a reference to ringWindings input will be stored,
       *  and possibly will be later modified */
      constructor(leftSE, rightSE, rings, windings) {
        this.id = ++segmentId;
        this.leftSE = leftSE;
        leftSE.segment = this;
        leftSE.otherSE = rightSE;
        this.rightSE = rightSE;
        rightSE.segment = this;
        rightSE.otherSE = leftSE;
        this.rings = rings;
        this.windings = windings;
        // left unset for performance, set later in algorithm
        // this.ringOut, this.consumedBy, this.prev
      }
      static fromRing(pt1, pt2, ring) {
        let leftPt, rightPt, winding;

        // ordering the two points according to sweep line ordering
        const cmpPts = SweepEvent.comparePoints(pt1, pt2);
        if (cmpPts < 0) {
          leftPt = pt1;
          rightPt = pt2;
          winding = 1;
        } else if (cmpPts > 0) {
          leftPt = pt2;
          rightPt = pt1;
          winding = -1;
        } else throw new Error(`Tried to create degenerate segment at [${pt1.x}, ${pt1.y}]`);
        const leftSE = new SweepEvent(leftPt, true);
        const rightSE = new SweepEvent(rightPt, false);
        return new Segment(leftSE, rightSE, [ring], [winding]);
      }

      /* When a segment is split, the rightSE is replaced with a new sweep event */
      replaceRightSE(newRightSE) {
        this.rightSE = newRightSE;
        this.rightSE.segment = this;
        this.rightSE.otherSE = this.leftSE;
        this.leftSE.otherSE = this.rightSE;
      }
      bbox() {
        const y1 = this.leftSE.point.y;
        const y2 = this.rightSE.point.y;
        return {
          ll: {
            x: this.leftSE.point.x,
            y: y1 < y2 ? y1 : y2
          },
          ur: {
            x: this.rightSE.point.x,
            y: y1 > y2 ? y1 : y2
          }
        };
      }

      /* A vector from the left point to the right */
      vector() {
        return {
          x: this.rightSE.point.x - this.leftSE.point.x,
          y: this.rightSE.point.y - this.leftSE.point.y
        };
      }
      isAnEndpoint(pt) {
        return pt.x === this.leftSE.point.x && pt.y === this.leftSE.point.y || pt.x === this.rightSE.point.x && pt.y === this.rightSE.point.y;
      }

      /* Compare this segment with a point.
       *
       * A point P is considered to be colinear to a segment if there
       * exists a distance D such that if we travel along the segment
       * from one * endpoint towards the other a distance D, we find
       * ourselves at point P.
       *
       * Return value indicates:
       *
       *   1: point lies above the segment (to the left of vertical)
       *   0: point is colinear to segment
       *  -1: point lies below the segment (to the right of vertical)
       */
      comparePoint(point) {
        if (this.isAnEndpoint(point)) return 0;
        const lPt = this.leftSE.point;
        const rPt = this.rightSE.point;
        const v = this.vector();

        // Exactly vertical segments.
        if (lPt.x === rPt.x) {
          if (point.x === lPt.x) return 0;
          return point.x < lPt.x ? 1 : -1;
        }

        // Nearly vertical segments with an intersection.
        // Check to see where a point on the line with matching Y coordinate is.
        const yDist = (point.y - lPt.y) / v.y;
        const xFromYDist = lPt.x + yDist * v.x;
        if (point.x === xFromYDist) return 0;

        // General case.
        // Check to see where a point on the line with matching X coordinate is.
        const xDist = (point.x - lPt.x) / v.x;
        const yFromXDist = lPt.y + xDist * v.y;
        if (point.y === yFromXDist) return 0;
        return point.y < yFromXDist ? -1 : 1;
      }

      /**
       * Given another segment, returns the first non-trivial intersection
       * between the two segments (in terms of sweep line ordering), if it exists.
       *
       * A 'non-trivial' intersection is one that will cause one or both of the
       * segments to be split(). As such, 'trivial' vs. 'non-trivial' intersection:
       *
       *   * endpoint of segA with endpoint of segB --> trivial
       *   * endpoint of segA with point along segB --> non-trivial
       *   * endpoint of segB with point along segA --> non-trivial
       *   * point along segA with point along segB --> non-trivial
       *
       * If no non-trivial intersection exists, return null
       * Else, return null.
       */
      getIntersection(other) {
        // If bboxes don't overlap, there can't be any intersections
        const tBbox = this.bbox();
        const oBbox = other.bbox();
        const bboxOverlap = getBboxOverlap(tBbox, oBbox);
        if (bboxOverlap === null) return null;

        // We first check to see if the endpoints can be considered intersections.
        // This will 'snap' intersections to endpoints if possible, and will
        // handle cases of colinearity.

        const tlp = this.leftSE.point;
        const trp = this.rightSE.point;
        const olp = other.leftSE.point;
        const orp = other.rightSE.point;

        // does each endpoint touch the other segment?
        // note that we restrict the 'touching' definition to only allow segments
        // to touch endpoints that lie forward from where we are in the sweep line pass
        const touchesOtherLSE = isInBbox(tBbox, olp) && this.comparePoint(olp) === 0;
        const touchesThisLSE = isInBbox(oBbox, tlp) && other.comparePoint(tlp) === 0;
        const touchesOtherRSE = isInBbox(tBbox, orp) && this.comparePoint(orp) === 0;
        const touchesThisRSE = isInBbox(oBbox, trp) && other.comparePoint(trp) === 0;

        // do left endpoints match?
        if (touchesThisLSE && touchesOtherLSE) {
          // these two cases are for colinear segments with matching left
          // endpoints, and one segment being longer than the other
          if (touchesThisRSE && !touchesOtherRSE) return trp;
          if (!touchesThisRSE && touchesOtherRSE) return orp;
          // either the two segments match exactly (two trival intersections)
          // or just on their left endpoint (one trivial intersection
          return null;
        }

        // does this left endpoint matches (other doesn't)
        if (touchesThisLSE) {
          // check for segments that just intersect on opposing endpoints
          if (touchesOtherRSE) {
            if (tlp.x === orp.x && tlp.y === orp.y) return null;
          }
          // t-intersection on left endpoint
          return tlp;
        }

        // does other left endpoint matches (this doesn't)
        if (touchesOtherLSE) {
          // check for segments that just intersect on opposing endpoints
          if (touchesThisRSE) {
            if (trp.x === olp.x && trp.y === olp.y) return null;
          }
          // t-intersection on left endpoint
          return olp;
        }

        // trivial intersection on right endpoints
        if (touchesThisRSE && touchesOtherRSE) return null;

        // t-intersections on just one right endpoint
        if (touchesThisRSE) return trp;
        if (touchesOtherRSE) return orp;

        // None of our endpoints intersect. Look for a general intersection between
        // infinite lines laid over the segments
        const pt = intersection$1(tlp, this.vector(), olp, other.vector());

        // are the segments parrallel? Note that if they were colinear with overlap,
        // they would have an endpoint intersection and that case was already handled above
        if (pt === null) return null;

        // is the intersection found between the lines not on the segments?
        if (!isInBbox(bboxOverlap, pt)) return null;

        // round the the computed point if needed
        return rounder.round(pt.x, pt.y);
      }

      /**
       * Split the given segment into multiple segments on the given points.
       *  * Each existing segment will retain its leftSE and a new rightSE will be
       *    generated for it.
       *  * A new segment will be generated which will adopt the original segment's
       *    rightSE, and a new leftSE will be generated for it.
       *  * If there are more than two points given to split on, new segments
       *    in the middle will be generated with new leftSE and rightSE's.
       *  * An array of the newly generated SweepEvents will be returned.
       *
       * Warning: input array of points is modified
       */
      split(point) {
        const newEvents = [];
        const alreadyLinked = point.events !== undefined;
        const newLeftSE = new SweepEvent(point, true);
        const newRightSE = new SweepEvent(point, false);
        const oldRightSE = this.rightSE;
        this.replaceRightSE(newRightSE);
        newEvents.push(newRightSE);
        newEvents.push(newLeftSE);
        const newSeg = new Segment(newLeftSE, oldRightSE, this.rings.slice(), this.windings.slice());

        // when splitting a nearly vertical downward-facing segment,
        // sometimes one of the resulting new segments is vertical, in which
        // case its left and right events may need to be swapped
        if (SweepEvent.comparePoints(newSeg.leftSE.point, newSeg.rightSE.point) > 0) {
          newSeg.swapEvents();
        }
        if (SweepEvent.comparePoints(this.leftSE.point, this.rightSE.point) > 0) {
          this.swapEvents();
        }

        // in the point we just used to create new sweep events with was already
        // linked to other events, we need to check if either of the affected
        // segments should be consumed
        if (alreadyLinked) {
          newLeftSE.checkForConsuming();
          newRightSE.checkForConsuming();
        }
        return newEvents;
      }

      /* Swap which event is left and right */
      swapEvents() {
        const tmpEvt = this.rightSE;
        this.rightSE = this.leftSE;
        this.leftSE = tmpEvt;
        this.leftSE.isLeft = true;
        this.rightSE.isLeft = false;
        for (let i = 0, iMax = this.windings.length; i < iMax; i++) {
          this.windings[i] *= -1;
        }
      }

      /* Consume another segment. We take their rings under our wing
       * and mark them as consumed. Use for perfectly overlapping segments */
      consume(other) {
        let consumer = this;
        let consumee = other;
        while (consumer.consumedBy) consumer = consumer.consumedBy;
        while (consumee.consumedBy) consumee = consumee.consumedBy;
        const cmp = Segment.compare(consumer, consumee);
        if (cmp === 0) return; // already consumed
        // the winner of the consumption is the earlier segment
        // according to sweep line ordering
        if (cmp > 0) {
          const tmp = consumer;
          consumer = consumee;
          consumee = tmp;
        }

        // make sure a segment doesn't consume it's prev
        if (consumer.prev === consumee) {
          const tmp = consumer;
          consumer = consumee;
          consumee = tmp;
        }
        for (let i = 0, iMax = consumee.rings.length; i < iMax; i++) {
          const ring = consumee.rings[i];
          const winding = consumee.windings[i];
          const index = consumer.rings.indexOf(ring);
          if (index === -1) {
            consumer.rings.push(ring);
            consumer.windings.push(winding);
          } else consumer.windings[index] += winding;
        }
        consumee.rings = null;
        consumee.windings = null;
        consumee.consumedBy = consumer;

        // mark sweep events consumed as to maintain ordering in sweep event queue
        consumee.leftSE.consumedBy = consumer.leftSE;
        consumee.rightSE.consumedBy = consumer.rightSE;
      }

      /* The first segment previous segment chain that is in the result */
      prevInResult() {
        if (this._prevInResult !== undefined) return this._prevInResult;
        if (!this.prev) this._prevInResult = null;else if (this.prev.isInResult()) this._prevInResult = this.prev;else this._prevInResult = this.prev.prevInResult();
        return this._prevInResult;
      }
      beforeState() {
        if (this._beforeState !== undefined) return this._beforeState;
        if (!this.prev) this._beforeState = {
          rings: [],
          windings: [],
          multiPolys: []
        };else {
          const seg = this.prev.consumedBy || this.prev;
          this._beforeState = seg.afterState();
        }
        return this._beforeState;
      }
      afterState() {
        if (this._afterState !== undefined) return this._afterState;
        const beforeState = this.beforeState();
        this._afterState = {
          rings: beforeState.rings.slice(0),
          windings: beforeState.windings.slice(0),
          multiPolys: []
        };
        const ringsAfter = this._afterState.rings;
        const windingsAfter = this._afterState.windings;
        const mpsAfter = this._afterState.multiPolys;

        // calculate ringsAfter, windingsAfter
        for (let i = 0, iMax = this.rings.length; i < iMax; i++) {
          const ring = this.rings[i];
          const winding = this.windings[i];
          const index = ringsAfter.indexOf(ring);
          if (index === -1) {
            ringsAfter.push(ring);
            windingsAfter.push(winding);
          } else windingsAfter[index] += winding;
        }

        // calcualte polysAfter
        const polysAfter = [];
        const polysExclude = [];
        for (let i = 0, iMax = ringsAfter.length; i < iMax; i++) {
          if (windingsAfter[i] === 0) continue; // non-zero rule
          const ring = ringsAfter[i];
          const poly = ring.poly;
          if (polysExclude.indexOf(poly) !== -1) continue;
          if (ring.isExterior) polysAfter.push(poly);else {
            if (polysExclude.indexOf(poly) === -1) polysExclude.push(poly);
            const index = polysAfter.indexOf(ring.poly);
            if (index !== -1) polysAfter.splice(index, 1);
          }
        }

        // calculate multiPolysAfter
        for (let i = 0, iMax = polysAfter.length; i < iMax; i++) {
          const mp = polysAfter[i].multiPoly;
          if (mpsAfter.indexOf(mp) === -1) mpsAfter.push(mp);
        }
        return this._afterState;
      }

      /* Is this segment part of the final result? */
      isInResult() {
        // if we've been consumed, we're not in the result
        if (this.consumedBy) return false;
        if (this._isInResult !== undefined) return this._isInResult;
        const mpsBefore = this.beforeState().multiPolys;
        const mpsAfter = this.afterState().multiPolys;
        switch (operation.type) {
          case "union":
            {
              // UNION - included iff:
              //  * On one side of us there is 0 poly interiors AND
              //  * On the other side there is 1 or more.
              const noBefores = mpsBefore.length === 0;
              const noAfters = mpsAfter.length === 0;
              this._isInResult = noBefores !== noAfters;
              break;
            }
          case "intersection":
            {
              // INTERSECTION - included iff:
              //  * on one side of us all multipolys are rep. with poly interiors AND
              //  * on the other side of us, not all multipolys are repsented
              //    with poly interiors
              let least;
              let most;
              if (mpsBefore.length < mpsAfter.length) {
                least = mpsBefore.length;
                most = mpsAfter.length;
              } else {
                least = mpsAfter.length;
                most = mpsBefore.length;
              }
              this._isInResult = most === operation.numMultiPolys && least < most;
              break;
            }
          case "xor":
            {
              // XOR - included iff:
              //  * the difference between the number of multipolys represented
              //    with poly interiors on our two sides is an odd number
              const diff = Math.abs(mpsBefore.length - mpsAfter.length);
              this._isInResult = diff % 2 === 1;
              break;
            }
          case "difference":
            {
              // DIFFERENCE included iff:
              //  * on exactly one side, we have just the subject
              const isJustSubject = mps => mps.length === 1 && mps[0].isSubject;
              this._isInResult = isJustSubject(mpsBefore) !== isJustSubject(mpsAfter);
              break;
            }
          default:
            throw new Error(`Unrecognized operation type found ${operation.type}`);
        }
        return this._isInResult;
      }
    }

    class RingIn {
      constructor(geomRing, poly, isExterior) {
        if (!Array.isArray(geomRing) || geomRing.length === 0) {
          throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        }
        this.poly = poly;
        this.isExterior = isExterior;
        this.segments = [];
        if (typeof geomRing[0][0] !== "number" || typeof geomRing[0][1] !== "number") {
          throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        }
        const firstPoint = rounder.round(geomRing[0][0], geomRing[0][1]);
        this.bbox = {
          ll: {
            x: firstPoint.x,
            y: firstPoint.y
          },
          ur: {
            x: firstPoint.x,
            y: firstPoint.y
          }
        };
        let prevPoint = firstPoint;
        for (let i = 1, iMax = geomRing.length; i < iMax; i++) {
          if (typeof geomRing[i][0] !== "number" || typeof geomRing[i][1] !== "number") {
            throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
          }
          let point = rounder.round(geomRing[i][0], geomRing[i][1]);
          // skip repeated points
          if (point.x === prevPoint.x && point.y === prevPoint.y) continue;
          this.segments.push(Segment.fromRing(prevPoint, point, this));
          if (point.x < this.bbox.ll.x) this.bbox.ll.x = point.x;
          if (point.y < this.bbox.ll.y) this.bbox.ll.y = point.y;
          if (point.x > this.bbox.ur.x) this.bbox.ur.x = point.x;
          if (point.y > this.bbox.ur.y) this.bbox.ur.y = point.y;
          prevPoint = point;
        }
        // add segment from last to first if last is not the same as first
        if (firstPoint.x !== prevPoint.x || firstPoint.y !== prevPoint.y) {
          this.segments.push(Segment.fromRing(prevPoint, firstPoint, this));
        }
      }
      getSweepEvents() {
        const sweepEvents = [];
        for (let i = 0, iMax = this.segments.length; i < iMax; i++) {
          const segment = this.segments[i];
          sweepEvents.push(segment.leftSE);
          sweepEvents.push(segment.rightSE);
        }
        return sweepEvents;
      }
    }
    class PolyIn {
      constructor(geomPoly, multiPoly) {
        if (!Array.isArray(geomPoly)) {
          throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        }
        this.exteriorRing = new RingIn(geomPoly[0], this, true);
        // copy by value
        this.bbox = {
          ll: {
            x: this.exteriorRing.bbox.ll.x,
            y: this.exteriorRing.bbox.ll.y
          },
          ur: {
            x: this.exteriorRing.bbox.ur.x,
            y: this.exteriorRing.bbox.ur.y
          }
        };
        this.interiorRings = [];
        for (let i = 1, iMax = geomPoly.length; i < iMax; i++) {
          const ring = new RingIn(geomPoly[i], this, false);
          if (ring.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = ring.bbox.ll.x;
          if (ring.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = ring.bbox.ll.y;
          if (ring.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = ring.bbox.ur.x;
          if (ring.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = ring.bbox.ur.y;
          this.interiorRings.push(ring);
        }
        this.multiPoly = multiPoly;
      }
      getSweepEvents() {
        const sweepEvents = this.exteriorRing.getSweepEvents();
        for (let i = 0, iMax = this.interiorRings.length; i < iMax; i++) {
          const ringSweepEvents = this.interiorRings[i].getSweepEvents();
          for (let j = 0, jMax = ringSweepEvents.length; j < jMax; j++) {
            sweepEvents.push(ringSweepEvents[j]);
          }
        }
        return sweepEvents;
      }
    }
    class MultiPolyIn {
      constructor(geom, isSubject) {
        if (!Array.isArray(geom)) {
          throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        }
        try {
          // if the input looks like a polygon, convert it to a multipolygon
          if (typeof geom[0][0][0] === "number") geom = [geom];
        } catch (ex) {
          // The input is either malformed or has empty arrays.
          // In either case, it will be handled later on.
        }
        this.polys = [];
        this.bbox = {
          ll: {
            x: Number.POSITIVE_INFINITY,
            y: Number.POSITIVE_INFINITY
          },
          ur: {
            x: Number.NEGATIVE_INFINITY,
            y: Number.NEGATIVE_INFINITY
          }
        };
        for (let i = 0, iMax = geom.length; i < iMax; i++) {
          const poly = new PolyIn(geom[i], this);
          if (poly.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = poly.bbox.ll.x;
          if (poly.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = poly.bbox.ll.y;
          if (poly.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = poly.bbox.ur.x;
          if (poly.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = poly.bbox.ur.y;
          this.polys.push(poly);
        }
        this.isSubject = isSubject;
      }
      getSweepEvents() {
        const sweepEvents = [];
        for (let i = 0, iMax = this.polys.length; i < iMax; i++) {
          const polySweepEvents = this.polys[i].getSweepEvents();
          for (let j = 0, jMax = polySweepEvents.length; j < jMax; j++) {
            sweepEvents.push(polySweepEvents[j]);
          }
        }
        return sweepEvents;
      }
    }

    class RingOut {
      /* Given the segments from the sweep line pass, compute & return a series
       * of closed rings from all the segments marked to be part of the result */
      static factory(allSegments) {
        const ringsOut = [];
        for (let i = 0, iMax = allSegments.length; i < iMax; i++) {
          const segment = allSegments[i];
          if (!segment.isInResult() || segment.ringOut) continue;
          let prevEvent = null;
          let event = segment.leftSE;
          let nextEvent = segment.rightSE;
          const events = [event];
          const startingPoint = event.point;
          const intersectionLEs = [];

          /* Walk the chain of linked events to form a closed ring */
          while (true) {
            prevEvent = event;
            event = nextEvent;
            events.push(event);

            /* Is the ring complete? */
            if (event.point === startingPoint) break;
            while (true) {
              const availableLEs = event.getAvailableLinkedEvents();

              /* Did we hit a dead end? This shouldn't happen.
               * Indicates some earlier part of the algorithm malfunctioned. */
              if (availableLEs.length === 0) {
                const firstPt = events[0].point;
                const lastPt = events[events.length - 1].point;
                throw new Error(`Unable to complete output ring starting at [${firstPt.x},` + ` ${firstPt.y}]. Last matching segment found ends at` + ` [${lastPt.x}, ${lastPt.y}].`);
              }

              /* Only one way to go, so cotinue on the path */
              if (availableLEs.length === 1) {
                nextEvent = availableLEs[0].otherSE;
                break;
              }

              /* We must have an intersection. Check for a completed loop */
              let indexLE = null;
              for (let j = 0, jMax = intersectionLEs.length; j < jMax; j++) {
                if (intersectionLEs[j].point === event.point) {
                  indexLE = j;
                  break;
                }
              }
              /* Found a completed loop. Cut that off and make a ring */
              if (indexLE !== null) {
                const intersectionLE = intersectionLEs.splice(indexLE)[0];
                const ringEvents = events.splice(intersectionLE.index);
                ringEvents.unshift(ringEvents[0].otherSE);
                ringsOut.push(new RingOut(ringEvents.reverse()));
                continue;
              }
              /* register the intersection */
              intersectionLEs.push({
                index: events.length,
                point: event.point
              });
              /* Choose the left-most option to continue the walk */
              const comparator = event.getLeftmostComparator(prevEvent);
              nextEvent = availableLEs.sort(comparator)[0].otherSE;
              break;
            }
          }
          ringsOut.push(new RingOut(events));
        }
        return ringsOut;
      }
      constructor(events) {
        this.events = events;
        for (let i = 0, iMax = events.length; i < iMax; i++) {
          events[i].segment.ringOut = this;
        }
        this.poly = null;
      }
      getGeom() {
        // Remove superfluous points (ie extra points along a straight line),
        let prevPt = this.events[0].point;
        const points = [prevPt];
        for (let i = 1, iMax = this.events.length - 1; i < iMax; i++) {
          const pt = this.events[i].point;
          const nextPt = this.events[i + 1].point;
          if (compareVectorAngles(pt, prevPt, nextPt) === 0) continue;
          points.push(pt);
          prevPt = pt;
        }

        // ring was all (within rounding error of angle calc) colinear points
        if (points.length === 1) return null;

        // check if the starting point is necessary
        const pt = points[0];
        const nextPt = points[1];
        if (compareVectorAngles(pt, prevPt, nextPt) === 0) points.shift();
        points.push(points[0]);
        const step = this.isExteriorRing() ? 1 : -1;
        const iStart = this.isExteriorRing() ? 0 : points.length - 1;
        const iEnd = this.isExteriorRing() ? points.length : -1;
        const orderedPoints = [];
        for (let i = iStart; i != iEnd; i += step) orderedPoints.push([points[i].x, points[i].y]);
        return orderedPoints;
      }
      isExteriorRing() {
        if (this._isExteriorRing === undefined) {
          const enclosing = this.enclosingRing();
          this._isExteriorRing = enclosing ? !enclosing.isExteriorRing() : true;
        }
        return this._isExteriorRing;
      }
      enclosingRing() {
        if (this._enclosingRing === undefined) {
          this._enclosingRing = this._calcEnclosingRing();
        }
        return this._enclosingRing;
      }

      /* Returns the ring that encloses this one, if any */
      _calcEnclosingRing() {
        // start with the ealier sweep line event so that the prevSeg
        // chain doesn't lead us inside of a loop of ours
        let leftMostEvt = this.events[0];
        for (let i = 1, iMax = this.events.length; i < iMax; i++) {
          const evt = this.events[i];
          if (SweepEvent.compare(leftMostEvt, evt) > 0) leftMostEvt = evt;
        }
        let prevSeg = leftMostEvt.segment.prevInResult();
        let prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
        while (true) {
          // no segment found, thus no ring can enclose us
          if (!prevSeg) return null;

          // no segments below prev segment found, thus the ring of the prev
          // segment must loop back around and enclose us
          if (!prevPrevSeg) return prevSeg.ringOut;

          // if the two segments are of different rings, the ring of the prev
          // segment must either loop around us or the ring of the prev prev
          // seg, which would make us and the ring of the prev peers
          if (prevPrevSeg.ringOut !== prevSeg.ringOut) {
            if (prevPrevSeg.ringOut.enclosingRing() !== prevSeg.ringOut) {
              return prevSeg.ringOut;
            } else return prevSeg.ringOut.enclosingRing();
          }

          // two segments are from the same ring, so this was a penisula
          // of that ring. iterate downward, keep searching
          prevSeg = prevPrevSeg.prevInResult();
          prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
        }
      }
    }
    class PolyOut {
      constructor(exteriorRing) {
        this.exteriorRing = exteriorRing;
        exteriorRing.poly = this;
        this.interiorRings = [];
      }
      addInterior(ring) {
        this.interiorRings.push(ring);
        ring.poly = this;
      }
      getGeom() {
        const geom = [this.exteriorRing.getGeom()];
        // exterior ring was all (within rounding error of angle calc) colinear points
        if (geom[0] === null) return null;
        for (let i = 0, iMax = this.interiorRings.length; i < iMax; i++) {
          const ringGeom = this.interiorRings[i].getGeom();
          // interior ring was all (within rounding error of angle calc) colinear points
          if (ringGeom === null) continue;
          geom.push(ringGeom);
        }
        return geom;
      }
    }
    class MultiPolyOut {
      constructor(rings) {
        this.rings = rings;
        this.polys = this._composePolys(rings);
      }
      getGeom() {
        const geom = [];
        for (let i = 0, iMax = this.polys.length; i < iMax; i++) {
          const polyGeom = this.polys[i].getGeom();
          // exterior ring was all (within rounding error of angle calc) colinear points
          if (polyGeom === null) continue;
          geom.push(polyGeom);
        }
        return geom;
      }
      _composePolys(rings) {
        const polys = [];
        for (let i = 0, iMax = rings.length; i < iMax; i++) {
          const ring = rings[i];
          if (ring.poly) continue;
          if (ring.isExteriorRing()) polys.push(new PolyOut(ring));else {
            const enclosingRing = ring.enclosingRing();
            if (!enclosingRing.poly) polys.push(new PolyOut(enclosingRing));
            enclosingRing.poly.addInterior(ring);
          }
        }
        return polys;
      }
    }

    /**
     * NOTE:  We must be careful not to change any segments while
     *        they are in the SplayTree. AFAIK, there's no way to tell
     *        the tree to rebalance itself - thus before splitting
     *        a segment that's in the tree, we remove it from the tree,
     *        do the split, then re-insert it. (Even though splitting a
     *        segment *shouldn't* change its correct position in the
     *        sweep line tree, the reality is because of rounding errors,
     *        it sometimes does.)
     */

    class SweepLine {
      constructor(queue) {
        let comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Segment.compare;
        this.queue = queue;
        this.tree = new Tree(comparator);
        this.segments = [];
      }
      process(event) {
        const segment = event.segment;
        const newEvents = [];

        // if we've already been consumed by another segment,
        // clean up our body parts and get out
        if (event.consumedBy) {
          if (event.isLeft) this.queue.remove(event.otherSE);else this.tree.remove(segment);
          return newEvents;
        }
        const node = event.isLeft ? this.tree.add(segment) : this.tree.find(segment);
        if (!node) throw new Error(`Unable to find segment #${segment.id} ` + `[${segment.leftSE.point.x}, ${segment.leftSE.point.y}] -> ` + `[${segment.rightSE.point.x}, ${segment.rightSE.point.y}] ` + "in SweepLine tree.");
        let prevNode = node;
        let nextNode = node;
        let prevSeg = undefined;
        let nextSeg = undefined;

        // skip consumed segments still in tree
        while (prevSeg === undefined) {
          prevNode = this.tree.prev(prevNode);
          if (prevNode === null) prevSeg = null;else if (prevNode.key.consumedBy === undefined) prevSeg = prevNode.key;
        }

        // skip consumed segments still in tree
        while (nextSeg === undefined) {
          nextNode = this.tree.next(nextNode);
          if (nextNode === null) nextSeg = null;else if (nextNode.key.consumedBy === undefined) nextSeg = nextNode.key;
        }
        if (event.isLeft) {
          // Check for intersections against the previous segment in the sweep line
          let prevMySplitter = null;
          if (prevSeg) {
            const prevInter = prevSeg.getIntersection(segment);
            if (prevInter !== null) {
              if (!segment.isAnEndpoint(prevInter)) prevMySplitter = prevInter;
              if (!prevSeg.isAnEndpoint(prevInter)) {
                const newEventsFromSplit = this._splitSafely(prevSeg, prevInter);
                for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
                  newEvents.push(newEventsFromSplit[i]);
                }
              }
            }
          }

          // Check for intersections against the next segment in the sweep line
          let nextMySplitter = null;
          if (nextSeg) {
            const nextInter = nextSeg.getIntersection(segment);
            if (nextInter !== null) {
              if (!segment.isAnEndpoint(nextInter)) nextMySplitter = nextInter;
              if (!nextSeg.isAnEndpoint(nextInter)) {
                const newEventsFromSplit = this._splitSafely(nextSeg, nextInter);
                for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
                  newEvents.push(newEventsFromSplit[i]);
                }
              }
            }
          }

          // For simplicity, even if we find more than one intersection we only
          // spilt on the 'earliest' (sweep-line style) of the intersections.
          // The other intersection will be handled in a future process().
          if (prevMySplitter !== null || nextMySplitter !== null) {
            let mySplitter = null;
            if (prevMySplitter === null) mySplitter = nextMySplitter;else if (nextMySplitter === null) mySplitter = prevMySplitter;else {
              const cmpSplitters = SweepEvent.comparePoints(prevMySplitter, nextMySplitter);
              mySplitter = cmpSplitters <= 0 ? prevMySplitter : nextMySplitter;
            }

            // Rounding errors can cause changes in ordering,
            // so remove afected segments and right sweep events before splitting
            this.queue.remove(segment.rightSE);
            newEvents.push(segment.rightSE);
            const newEventsFromSplit = segment.split(mySplitter);
            for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
              newEvents.push(newEventsFromSplit[i]);
            }
          }
          if (newEvents.length > 0) {
            // We found some intersections, so re-do the current event to
            // make sure sweep line ordering is totally consistent for later
            // use with the segment 'prev' pointers
            this.tree.remove(segment);
            newEvents.push(event);
          } else {
            // done with left event
            this.segments.push(segment);
            segment.prev = prevSeg;
          }
        } else {
          // event.isRight

          // since we're about to be removed from the sweep line, check for
          // intersections between our previous and next segments
          if (prevSeg && nextSeg) {
            const inter = prevSeg.getIntersection(nextSeg);
            if (inter !== null) {
              if (!prevSeg.isAnEndpoint(inter)) {
                const newEventsFromSplit = this._splitSafely(prevSeg, inter);
                for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
                  newEvents.push(newEventsFromSplit[i]);
                }
              }
              if (!nextSeg.isAnEndpoint(inter)) {
                const newEventsFromSplit = this._splitSafely(nextSeg, inter);
                for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
                  newEvents.push(newEventsFromSplit[i]);
                }
              }
            }
          }
          this.tree.remove(segment);
        }
        return newEvents;
      }

      /* Safely split a segment that is currently in the datastructures
       * IE - a segment other than the one that is currently being processed. */
      _splitSafely(seg, pt) {
        // Rounding errors can cause changes in ordering,
        // so remove afected segments and right sweep events before splitting
        // removeNode() doesn't work, so have re-find the seg
        // https://github.com/w8r/splay-tree/pull/5
        this.tree.remove(seg);
        const rightSE = seg.rightSE;
        this.queue.remove(rightSE);
        const newEvents = seg.split(pt);
        newEvents.push(rightSE);
        // splitting can trigger consumption
        if (seg.consumedBy === undefined) this.tree.add(seg);
        return newEvents;
      }
    }

    // Limits on iterative processes to prevent infinite loops - usually caused by floating-point math round-off errors.
    const POLYGON_CLIPPING_MAX_QUEUE_SIZE = typeof process !== "undefined" && ({"VUE_APP_DEFAULT_EMAIL":"","VUE_APP_API_BASE_URL":"https://api.mydtg.fr","VUE_APP_GOOGLE_MAPS_API_KEY":"AIzaSyBT3RBWx4uuPj9AQZdpKn4WHkLsGMTe6GM","VUE_APP_VERSION":"v2.20.1.31","VUE_APP_COOKIES_DOMAIN":"mydtg.fr","VUE_APP_DEEP_LINK_URL":"https://app.mydtg.fr","VUE_APP_TOKEN_MANAGER_ACCESS_KEY":"accessTokenProd","VUE_APP_GENERATE_REPORT_URL":"https://app.mydtg.fr","VUE_APP_SENTRY_TRACE_SAMPLE_RATE":"0","VUE_APP_FIREBASE_CONFIG":"{\"apiKey\": \"AIzaSyBT3RBWx4uuPj9AQZdpKn4WHkLsGMTe6GM\", \"authDomain\": \"dtg-app-prod-5f3a0.firebaseapp.com\", \"databaseURL\": \"https://dtg-app-prod-5f3a0-default-rtdb.firebaseio.com\", \"projectId\": \"dtg-app-prod-5f3a0\", \"storageBucket\": \"dtg-app-prod-5f3a0.appspot.com\", \"messagingSenderId\": \"831618248435\", \"appId\": \"1:831618248435:web:73611e2cf233adebb89186\", \"measurementId\": \"G-L6Z72033MY\"}","VUE_APP_SENTRY_TRACING_ORIGINS":"[\"testdev-api.mydtg.fr\", \"preprod-api.mydtg.fr\", \"api.mydtg.fr\"]","VUE_APP_SENTRY_ENABLED":"0","VUE_APP_PERSISTENCE_ENABLED":"0","VUE_APP_BUILD_ID":"415-ba0448174880da394df2c805974fdc3abcf347d5","VUE_APP_BACKOFFICE_URL":"https://backoffice.mydtg.fr","VUE_APP_TOKEN_MANAGER_REFRESH_KEY":"refreshTokenProd","VUE_APP_SENTRY_DSN":"https://cb8765c6810c4523b11b88320aff121f@o4505317713313792.ingest.sentry.io/4505317811879936","VUE_APP_DEFAULT_PASSWORD":"","VUE_APP_SENTRY_ENV":"prod","NODE_ENV":"production","BASE_URL":"/"}).POLYGON_CLIPPING_MAX_QUEUE_SIZE || 1000000;
    const POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS = typeof process !== "undefined" && ({"VUE_APP_DEFAULT_EMAIL":"","VUE_APP_API_BASE_URL":"https://api.mydtg.fr","VUE_APP_GOOGLE_MAPS_API_KEY":"AIzaSyBT3RBWx4uuPj9AQZdpKn4WHkLsGMTe6GM","VUE_APP_VERSION":"v2.20.1.31","VUE_APP_COOKIES_DOMAIN":"mydtg.fr","VUE_APP_DEEP_LINK_URL":"https://app.mydtg.fr","VUE_APP_TOKEN_MANAGER_ACCESS_KEY":"accessTokenProd","VUE_APP_GENERATE_REPORT_URL":"https://app.mydtg.fr","VUE_APP_SENTRY_TRACE_SAMPLE_RATE":"0","VUE_APP_FIREBASE_CONFIG":"{\"apiKey\": \"AIzaSyBT3RBWx4uuPj9AQZdpKn4WHkLsGMTe6GM\", \"authDomain\": \"dtg-app-prod-5f3a0.firebaseapp.com\", \"databaseURL\": \"https://dtg-app-prod-5f3a0-default-rtdb.firebaseio.com\", \"projectId\": \"dtg-app-prod-5f3a0\", \"storageBucket\": \"dtg-app-prod-5f3a0.appspot.com\", \"messagingSenderId\": \"831618248435\", \"appId\": \"1:831618248435:web:73611e2cf233adebb89186\", \"measurementId\": \"G-L6Z72033MY\"}","VUE_APP_SENTRY_TRACING_ORIGINS":"[\"testdev-api.mydtg.fr\", \"preprod-api.mydtg.fr\", \"api.mydtg.fr\"]","VUE_APP_SENTRY_ENABLED":"0","VUE_APP_PERSISTENCE_ENABLED":"0","VUE_APP_BUILD_ID":"415-ba0448174880da394df2c805974fdc3abcf347d5","VUE_APP_BACKOFFICE_URL":"https://backoffice.mydtg.fr","VUE_APP_TOKEN_MANAGER_REFRESH_KEY":"refreshTokenProd","VUE_APP_SENTRY_DSN":"https://cb8765c6810c4523b11b88320aff121f@o4505317713313792.ingest.sentry.io/4505317811879936","VUE_APP_DEFAULT_PASSWORD":"","VUE_APP_SENTRY_ENV":"prod","NODE_ENV":"production","BASE_URL":"/"}).POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS || 1000000;
    class Operation {
      run(type, geom, moreGeoms) {
        operation.type = type;
        rounder.reset();

        /* Convert inputs to MultiPoly objects */
        const multipolys = [new MultiPolyIn(geom, true)];
        for (let i = 0, iMax = moreGeoms.length; i < iMax; i++) {
          multipolys.push(new MultiPolyIn(moreGeoms[i], false));
        }
        operation.numMultiPolys = multipolys.length;

        /* BBox optimization for difference operation
         * If the bbox of a multipolygon that's part of the clipping doesn't
         * intersect the bbox of the subject at all, we can just drop that
         * multiploygon. */
        if (operation.type === "difference") {
          // in place removal
          const subject = multipolys[0];
          let i = 1;
          while (i < multipolys.length) {
            if (getBboxOverlap(multipolys[i].bbox, subject.bbox) !== null) i++;else multipolys.splice(i, 1);
          }
        }

        /* BBox optimization for intersection operation
         * If we can find any pair of multipolygons whose bbox does not overlap,
         * then the result will be empty. */
        if (operation.type === "intersection") {
          // TODO: this is O(n^2) in number of polygons. By sorting the bboxes,
          //       it could be optimized to O(n * ln(n))
          for (let i = 0, iMax = multipolys.length; i < iMax; i++) {
            const mpA = multipolys[i];
            for (let j = i + 1, jMax = multipolys.length; j < jMax; j++) {
              if (getBboxOverlap(mpA.bbox, multipolys[j].bbox) === null) return [];
            }
          }
        }

        /* Put segment endpoints in a priority queue */
        const queue = new Tree(SweepEvent.compare);
        for (let i = 0, iMax = multipolys.length; i < iMax; i++) {
          const sweepEvents = multipolys[i].getSweepEvents();
          for (let j = 0, jMax = sweepEvents.length; j < jMax; j++) {
            queue.insert(sweepEvents[j]);
            if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) {
              // prevents an infinite loop, an otherwise common manifestation of bugs
              throw new Error("Infinite loop when putting segment endpoints in a priority queue " + "(queue size too big).");
            }
          }
        }

        /* Pass the sweep line over those endpoints */
        const sweepLine = new SweepLine(queue);
        let prevQueueSize = queue.size;
        let node = queue.pop();
        while (node) {
          const evt = node.key;
          if (queue.size === prevQueueSize) {
            // prevents an infinite loop, an otherwise common manifestation of bugs
            const seg = evt.segment;
            throw new Error(`Unable to pop() ${evt.isLeft ? "left" : "right"} SweepEvent ` + `[${evt.point.x}, ${evt.point.y}] from segment #${seg.id} ` + `[${seg.leftSE.point.x}, ${seg.leftSE.point.y}] -> ` + `[${seg.rightSE.point.x}, ${seg.rightSE.point.y}] from queue.`);
          }
          if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) {
            // prevents an infinite loop, an otherwise common manifestation of bugs
            throw new Error("Infinite loop when passing sweep line over endpoints " + "(queue size too big).");
          }
          if (sweepLine.segments.length > POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS) {
            // prevents an infinite loop, an otherwise common manifestation of bugs
            throw new Error("Infinite loop when passing sweep line over endpoints " + "(too many sweep line segments).");
          }
          const newEvents = sweepLine.process(evt);
          for (let i = 0, iMax = newEvents.length; i < iMax; i++) {
            const evt = newEvents[i];
            if (evt.consumedBy === undefined) queue.insert(evt);
          }
          prevQueueSize = queue.size;
          node = queue.pop();
        }

        // free some memory we don't need anymore
        rounder.reset();

        /* Collect and compile segments we're keeping into a multipolygon */
        const ringsOut = RingOut.factory(sweepLine.segments);
        const result = new MultiPolyOut(ringsOut);
        return result.getGeom();
      }
    }

    // singleton available by import
    const operation = new Operation();

    const union = function (geom) {
      for (var _len = arguments.length, moreGeoms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        moreGeoms[_key - 1] = arguments[_key];
      }
      return operation.run("union", geom, moreGeoms);
    };
    const intersection = function (geom) {
      for (var _len2 = arguments.length, moreGeoms = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        moreGeoms[_key2 - 1] = arguments[_key2];
      }
      return operation.run("intersection", geom, moreGeoms);
    };
    const xor = function (geom) {
      for (var _len3 = arguments.length, moreGeoms = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        moreGeoms[_key3 - 1] = arguments[_key3];
      }
      return operation.run("xor", geom, moreGeoms);
    };
    const difference = function (subjectGeom) {
      for (var _len4 = arguments.length, clippingGeoms = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        clippingGeoms[_key4 - 1] = arguments[_key4];
      }
      return operation.run("difference", subjectGeom, clippingGeoms);
    };
    var index = {
      union: union,
      intersection: intersection,
      xor: xor,
      difference: difference
    };

    return index;

}));


/***/ },

/***/ 2982
(module) {

(function (global, factory) {
	 true ? module.exports = factory() :
	0;
}(this, (function () { 'use strict';

function quickselect(arr, k, left, right, compare) {
    quickselectStep(arr, k, left || 0, right || (arr.length - 1), compare || defaultCompare);
}

function quickselectStep(arr, k, left, right, compare) {

    while (right > left) {
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselectStep(arr, k, newLeft, newRight, compare);
        }

        var t = arr[k];
        var i = left;
        var j = right;

        swap(arr, left, k);
        if (compare(arr[right], t) > 0) swap(arr, left, right);

        while (i < j) {
            swap(arr, i, j);
            i++;
            j--;
            while (compare(arr[i], t) < 0) i++;
            while (compare(arr[j], t) > 0) j--;
        }

        if (compare(arr[left], t) === 0) swap(arr, left, j);
        else {
            j++;
            swap(arr, j, right);
        }

        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}

function swap(arr, i, j) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}

function defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

return quickselect;

})));


/***/ },

/***/ 4026
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = rbush;
module.exports["default"] = rbush;

var quickselect = __webpack_require__(2982);

function rbush(maxEntries, format) {
    if (!(this instanceof rbush)) return new rbush(maxEntries, format);

    // max entries in a node is 9 by default; min node fill is 40% for best performance
    this._maxEntries = Math.max(4, maxEntries || 9);
    this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));

    if (format) {
        this._initFormat(format);
    }

    this.clear();
}

rbush.prototype = {

    all: function () {
        return this._all(this.data, []);
    },

    search: function (bbox) {

        var node = this.data,
            result = [],
            toBBox = this.toBBox;

        if (!intersects(bbox, node)) return result;

        var nodesToSearch = [],
            i, len, child, childBBox;

        while (node) {
            for (i = 0, len = node.children.length; i < len; i++) {

                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;

                if (intersects(bbox, childBBox)) {
                    if (node.leaf) result.push(child);
                    else if (contains(bbox, childBBox)) this._all(child, result);
                    else nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }

        return result;
    },

    collides: function (bbox) {

        var node = this.data,
            toBBox = this.toBBox;

        if (!intersects(bbox, node)) return false;

        var nodesToSearch = [],
            i, len, child, childBBox;

        while (node) {
            for (i = 0, len = node.children.length; i < len; i++) {

                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;

                if (intersects(bbox, childBBox)) {
                    if (node.leaf || contains(bbox, childBBox)) return true;
                    nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }

        return false;
    },

    load: function (data) {
        if (!(data && data.length)) return this;

        if (data.length < this._minEntries) {
            for (var i = 0, len = data.length; i < len; i++) {
                this.insert(data[i]);
            }
            return this;
        }

        // recursively build the tree with the given data from scratch using OMT algorithm
        var node = this._build(data.slice(), 0, data.length - 1, 0);

        if (!this.data.children.length) {
            // save as is if tree is empty
            this.data = node;

        } else if (this.data.height === node.height) {
            // split root if trees have the same height
            this._splitRoot(this.data, node);

        } else {
            if (this.data.height < node.height) {
                // swap trees if inserted one is bigger
                var tmpNode = this.data;
                this.data = node;
                node = tmpNode;
            }

            // insert the small tree into the large tree at appropriate level
            this._insert(node, this.data.height - node.height - 1, true);
        }

        return this;
    },

    insert: function (item) {
        if (item) this._insert(item, this.data.height - 1);
        return this;
    },

    clear: function () {
        this.data = createNode([]);
        return this;
    },

    remove: function (item, equalsFn) {
        if (!item) return this;

        var node = this.data,
            bbox = this.toBBox(item),
            path = [],
            indexes = [],
            i, parent, index, goingUp;

        // depth-first iterative tree traversal
        while (node || path.length) {

            if (!node) { // go up
                node = path.pop();
                parent = path[path.length - 1];
                i = indexes.pop();
                goingUp = true;
            }

            if (node.leaf) { // check current node
                index = findItem(item, node.children, equalsFn);

                if (index !== -1) {
                    // item found, remove the item and condense tree upwards
                    node.children.splice(index, 1);
                    path.push(node);
                    this._condense(path);
                    return this;
                }
            }

            if (!goingUp && !node.leaf && contains(node, bbox)) { // go down
                path.push(node);
                indexes.push(i);
                i = 0;
                parent = node;
                node = node.children[0];

            } else if (parent) { // go right
                i++;
                node = parent.children[i];
                goingUp = false;

            } else node = null; // nothing found
        }

        return this;
    },

    toBBox: function (item) { return item; },

    compareMinX: compareNodeMinX,
    compareMinY: compareNodeMinY,

    toJSON: function () { return this.data; },

    fromJSON: function (data) {
        this.data = data;
        return this;
    },

    _all: function (node, result) {
        var nodesToSearch = [];
        while (node) {
            if (node.leaf) result.push.apply(result, node.children);
            else nodesToSearch.push.apply(nodesToSearch, node.children);

            node = nodesToSearch.pop();
        }
        return result;
    },

    _build: function (items, left, right, height) {

        var N = right - left + 1,
            M = this._maxEntries,
            node;

        if (N <= M) {
            // reached leaf level; return leaf
            node = createNode(items.slice(left, right + 1));
            calcBBox(node, this.toBBox);
            return node;
        }

        if (!height) {
            // target height of the bulk-loaded tree
            height = Math.ceil(Math.log(N) / Math.log(M));

            // target number of root entries to maximize storage utilization
            M = Math.ceil(N / Math.pow(M, height - 1));
        }

        node = createNode([]);
        node.leaf = false;
        node.height = height;

        // split the items into M mostly square tiles

        var N2 = Math.ceil(N / M),
            N1 = N2 * Math.ceil(Math.sqrt(M)),
            i, j, right2, right3;

        multiSelect(items, left, right, N1, this.compareMinX);

        for (i = left; i <= right; i += N1) {

            right2 = Math.min(i + N1 - 1, right);

            multiSelect(items, i, right2, N2, this.compareMinY);

            for (j = i; j <= right2; j += N2) {

                right3 = Math.min(j + N2 - 1, right2);

                // pack each entry recursively
                node.children.push(this._build(items, j, right3, height - 1));
            }
        }

        calcBBox(node, this.toBBox);

        return node;
    },

    _chooseSubtree: function (bbox, node, level, path) {

        var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;

        while (true) {
            path.push(node);

            if (node.leaf || path.length - 1 === level) break;

            minArea = minEnlargement = Infinity;

            for (i = 0, len = node.children.length; i < len; i++) {
                child = node.children[i];
                area = bboxArea(child);
                enlargement = enlargedArea(bbox, child) - area;

                // choose entry with the least area enlargement
                if (enlargement < minEnlargement) {
                    minEnlargement = enlargement;
                    minArea = area < minArea ? area : minArea;
                    targetNode = child;

                } else if (enlargement === minEnlargement) {
                    // otherwise choose one with the smallest area
                    if (area < minArea) {
                        minArea = area;
                        targetNode = child;
                    }
                }
            }

            node = targetNode || node.children[0];
        }

        return node;
    },

    _insert: function (item, level, isNode) {

        var toBBox = this.toBBox,
            bbox = isNode ? item : toBBox(item),
            insertPath = [];

        // find the best node for accommodating the item, saving all nodes along the path too
        var node = this._chooseSubtree(bbox, this.data, level, insertPath);

        // put the item into the node
        node.children.push(item);
        extend(node, bbox);

        // split on node overflow; propagate upwards if necessary
        while (level >= 0) {
            if (insertPath[level].children.length > this._maxEntries) {
                this._split(insertPath, level);
                level--;
            } else break;
        }

        // adjust bboxes along the insertion path
        this._adjustParentBBoxes(bbox, insertPath, level);
    },

    // split overflowed node into two
    _split: function (insertPath, level) {

        var node = insertPath[level],
            M = node.children.length,
            m = this._minEntries;

        this._chooseSplitAxis(node, m, M);

        var splitIndex = this._chooseSplitIndex(node, m, M);

        var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
        newNode.height = node.height;
        newNode.leaf = node.leaf;

        calcBBox(node, this.toBBox);
        calcBBox(newNode, this.toBBox);

        if (level) insertPath[level - 1].children.push(newNode);
        else this._splitRoot(node, newNode);
    },

    _splitRoot: function (node, newNode) {
        // split root node
        this.data = createNode([node, newNode]);
        this.data.height = node.height + 1;
        this.data.leaf = false;
        calcBBox(this.data, this.toBBox);
    },

    _chooseSplitIndex: function (node, m, M) {

        var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;

        minOverlap = minArea = Infinity;

        for (i = m; i <= M - m; i++) {
            bbox1 = distBBox(node, 0, i, this.toBBox);
            bbox2 = distBBox(node, i, M, this.toBBox);

            overlap = intersectionArea(bbox1, bbox2);
            area = bboxArea(bbox1) + bboxArea(bbox2);

            // choose distribution with minimum overlap
            if (overlap < minOverlap) {
                minOverlap = overlap;
                index = i;

                minArea = area < minArea ? area : minArea;

            } else if (overlap === minOverlap) {
                // otherwise choose distribution with minimum area
                if (area < minArea) {
                    minArea = area;
                    index = i;
                }
            }
        }

        return index;
    },

    // sorts node children by the best axis for split
    _chooseSplitAxis: function (node, m, M) {

        var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX,
            compareMinY = node.leaf ? this.compareMinY : compareNodeMinY,
            xMargin = this._allDistMargin(node, m, M, compareMinX),
            yMargin = this._allDistMargin(node, m, M, compareMinY);

        // if total distributions margin value is minimal for x, sort by minX,
        // otherwise it's already sorted by minY
        if (xMargin < yMargin) node.children.sort(compareMinX);
    },

    // total margin of all possible split distributions where each node is at least m full
    _allDistMargin: function (node, m, M, compare) {

        node.children.sort(compare);

        var toBBox = this.toBBox,
            leftBBox = distBBox(node, 0, m, toBBox),
            rightBBox = distBBox(node, M - m, M, toBBox),
            margin = bboxMargin(leftBBox) + bboxMargin(rightBBox),
            i, child;

        for (i = m; i < M - m; i++) {
            child = node.children[i];
            extend(leftBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(leftBBox);
        }

        for (i = M - m - 1; i >= m; i--) {
            child = node.children[i];
            extend(rightBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(rightBBox);
        }

        return margin;
    },

    _adjustParentBBoxes: function (bbox, path, level) {
        // adjust bboxes along the given tree path
        for (var i = level; i >= 0; i--) {
            extend(path[i], bbox);
        }
    },

    _condense: function (path) {
        // go through the path, removing empty nodes and updating bboxes
        for (var i = path.length - 1, siblings; i >= 0; i--) {
            if (path[i].children.length === 0) {
                if (i > 0) {
                    siblings = path[i - 1].children;
                    siblings.splice(siblings.indexOf(path[i]), 1);

                } else this.clear();

            } else calcBBox(path[i], this.toBBox);
        }
    },

    _initFormat: function (format) {
        // data format (minX, minY, maxX, maxY accessors)

        // uses eval-type function compilation instead of just accepting a toBBox function
        // because the algorithms are very sensitive to sorting functions performance,
        // so they should be dead simple and without inner calls

        var compareArr = ['return a', ' - b', ';'];

        this.compareMinX = new Function('a', 'b', compareArr.join(format[0]));
        this.compareMinY = new Function('a', 'b', compareArr.join(format[1]));

        this.toBBox = new Function('a',
            'return {minX: a' + format[0] +
            ', minY: a' + format[1] +
            ', maxX: a' + format[2] +
            ', maxY: a' + format[3] + '};');
    }
};

function findItem(item, items, equalsFn) {
    if (!equalsFn) return items.indexOf(item);

    for (var i = 0; i < items.length; i++) {
        if (equalsFn(item, items[i])) return i;
    }
    return -1;
}

// calculate node's bbox from bboxes of its children
function calcBBox(node, toBBox) {
    distBBox(node, 0, node.children.length, toBBox, node);
}

// min bounding rectangle of node children from k to p-1
function distBBox(node, k, p, toBBox, destNode) {
    if (!destNode) destNode = createNode(null);
    destNode.minX = Infinity;
    destNode.minY = Infinity;
    destNode.maxX = -Infinity;
    destNode.maxY = -Infinity;

    for (var i = k, child; i < p; i++) {
        child = node.children[i];
        extend(destNode, node.leaf ? toBBox(child) : child);
    }

    return destNode;
}

function extend(a, b) {
    a.minX = Math.min(a.minX, b.minX);
    a.minY = Math.min(a.minY, b.minY);
    a.maxX = Math.max(a.maxX, b.maxX);
    a.maxY = Math.max(a.maxY, b.maxY);
    return a;
}

function compareNodeMinX(a, b) { return a.minX - b.minX; }
function compareNodeMinY(a, b) { return a.minY - b.minY; }

function bboxArea(a)   { return (a.maxX - a.minX) * (a.maxY - a.minY); }
function bboxMargin(a) { return (a.maxX - a.minX) + (a.maxY - a.minY); }

function enlargedArea(a, b) {
    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) *
           (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
}

function intersectionArea(a, b) {
    var minX = Math.max(a.minX, b.minX),
        minY = Math.max(a.minY, b.minY),
        maxX = Math.min(a.maxX, b.maxX),
        maxY = Math.min(a.maxY, b.maxY);

    return Math.max(0, maxX - minX) *
           Math.max(0, maxY - minY);
}

function contains(a, b) {
    return a.minX <= b.minX &&
           a.minY <= b.minY &&
           b.maxX <= a.maxX &&
           b.maxY <= a.maxY;
}

function intersects(a, b) {
    return b.minX <= a.maxX &&
           b.minY <= a.maxY &&
           b.maxX >= a.minX &&
           b.maxY >= a.minY;
}

function createNode(children) {
    return {
        children: children,
        height: 1,
        leaf: true,
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity
    };
}

// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
// combines selection algorithm with binary divide & conquer approach

function multiSelect(arr, left, right, n, compare) {
    var stack = [left, right],
        mid;

    while (stack.length) {
        right = stack.pop();
        left = stack.pop();

        if (right - left <= n) continue;

        mid = left + Math.ceil((right - left) / n / 2) * n;
        quickselect(arr, mid, left, right, compare);

        stack.push(left, mid, mid, right);
    }
}


/***/ },

/***/ 8394
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var setFunctionName = __webpack_require__(9343);
var $TypeError = __webpack_require__(3468);

var $Object = Object;

module.exports = setFunctionName(function flags() {
	if (this == null || this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.unicodeSets) {
		result += 'v';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
}, 'get flags', true);



/***/ },

/***/ 1026
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(1857);
var callBind = __webpack_require__(8498);

var implementation = __webpack_require__(8394);
var getPolyfill = __webpack_require__(243);
var shim = __webpack_require__(9669);

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ },

/***/ 243
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(8394);

var supportsDescriptors = (__webpack_require__(1857).supportsDescriptors);
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& 'dotAll' in RegExp.prototype
			&& 'hasIndices' in RegExp.prototype
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});

			descriptor.get.call(o);

			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation;
};


/***/ },

/***/ 9669
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var supportsDescriptors = (__webpack_require__(1857).supportsDescriptors);
var getPolyfill = __webpack_require__(243);
var gOPD = __webpack_require__(9336);
var defineProperty = Object.defineProperty;
var $TypeError = __webpack_require__(9838);
var getProto = __webpack_require__(6369);
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ },

/***/ 6108
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(528);
var define = __webpack_require__(686);
var hasDescriptors = __webpack_require__(7239)();
var gOPD = __webpack_require__(9336);

var $TypeError = __webpack_require__(3468);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};


/***/ },

/***/ 9343
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(686);
var hasDescriptors = __webpack_require__(7239)();
var functionsHaveConfigurableNames = (__webpack_require__(8993).functionsHaveConfigurableNames)();

var $TypeError = __webpack_require__(3468);

/** @type {import('.')} */
module.exports = function setFunctionName(fn, name) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	var loose = arguments.length > 2 && !!arguments[2];
	if (!loose || functionsHaveConfigurableNames) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'name', name, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'name', name);
		}
	}
	return fn;
};


/***/ },

/***/ 7449
(module) {

"use strict";


module.exports = {
	/**
  * Euclidean distance
  */
	eudist: function eudist(v1, v2, sqrt) {
		var len = v1.length;
		var sum = 0;

		for (var i = 0; i < len; i++) {
			var d = (v1[i] || 0) - (v2[i] || 0);
			sum += d * d;
		}
		// Square root not really needed
		return sqrt ? Math.sqrt(sum) : sum;
	},
	mandist: function mandist(v1, v2, sqrt) {
		var len = v1.length;
		var sum = 0;

		for (var i = 0; i < len; i++) {
			sum += Math.abs((v1[i] || 0) - (v2[i] || 0));
		}

		// Square root not really needed
		return sqrt ? Math.sqrt(sum) : sum;
	},


	/**
  * Unidimensional distance
  */
	dist: function dist(v1, v2, sqrt) {
		var d = Math.abs(v1 - v2);
		return sqrt ? d : d * d;
	}
};
//# sourceMappingURL=distance.js.map


/***/ },

/***/ 339
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Distance = __webpack_require__(7449),
    eudist = Distance.eudist,
    dist = Distance.dist;

module.exports = {
	kmrand: function kmrand(data, k) {
		var map = {},
		    ks = [],
		    t = k << 2;
		var len = data.length;
		var multi = data[0].length > 0;

		while (ks.length < k && t-- > 0) {
			var d = data[Math.floor(Math.random() * len)];
			var key = multi ? d.join("_") : "" + d;
			if (!map[key]) {
				map[key] = true;
				ks.push(d);
			}
		}

		if (ks.length < k) throw new Error("Error initializating clusters");else return ks;
	},


	/**
  * K-means++ initial centroid selection
  */
	kmpp: function kmpp(data, k) {
		var distance = data[0].length ? eudist : dist;
		var ks = [],
		    len = data.length;
		var multi = data[0].length > 0;
		var map = {};

		// First random centroid
		var c = data[Math.floor(Math.random() * len)];
		var key = multi ? c.join("_") : "" + c;
		ks.push(c);
		map[key] = true;

		// Retrieve next centroids
		while (ks.length < k) {
			// Min Distances between current centroids and data points
			var dists = [],
			    lk = ks.length;
			var dsum = 0,
			    prs = [];

			for (var i = 0; i < len; i++) {
				var min = Infinity;
				for (var j = 0; j < lk; j++) {
					var _dist = distance(data[i], ks[j]);
					if (_dist <= min) min = _dist;
				}
				dists[i] = min;
			}

			// Sum all min distances
			for (var _i = 0; _i < len; _i++) {
				dsum += dists[_i];
			}

			// Probabilities and cummulative prob (cumsum)
			for (var _i2 = 0; _i2 < len; _i2++) {
				prs[_i2] = { i: _i2, v: data[_i2], pr: dists[_i2] / dsum, cs: 0 };
			}

			// Sort Probabilities
			prs.sort(function (a, b) {
				return a.pr - b.pr;
			});

			// Cummulative Probabilities
			prs[0].cs = prs[0].pr;
			for (var _i3 = 1; _i3 < len; _i3++) {
				prs[_i3].cs = prs[_i3 - 1].cs + prs[_i3].pr;
			}

			// Randomize
			var rnd = Math.random();

			// Gets only the items whose cumsum >= rnd
			var idx = 0;
			while (idx < len - 1 && prs[idx++].cs < rnd) {}
			ks.push(prs[idx - 1].v);
			/*
   let done = false;
   while(!done) {
   	// this is our new centroid
   	c = prs[idx-1].v
   	key = multi? c.join("_") : `${c}`;
   	if(!map[key]) {
   		map[key] = true;
   		ks.push(c);
   		done = true;
   	}
   	else {
   		idx++;
   	}
   }
   */
		}

		return ks;
	}
};
//# sourceMappingURL=kinit.js.map


/***/ },

/***/ 3883
(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/*jshint esversion: 6 */

var Distance = __webpack_require__(7449),
    ClusterInit = __webpack_require__(339),
    eudist = Distance.eudist,
    mandist = Distance.mandist,
    dist = Distance.dist,
    kmrand = ClusterInit.kmrand,
    kmpp = ClusterInit.kmpp;

var MAX = 10000;

/**
 * Inits an array with values
 */
function init(len, val, v) {
	v = v || [];
	for (var i = 0; i < len; i++) {
		v[i] = val;
	}return v;
}

function skmeans(data, k, initial, maxit) {
	var ks = [],
	    old = [],
	    idxs = [],
	    dist = [];
	var conv = false,
	    it = maxit || MAX;
	var len = data.length,
	    vlen = data[0].length,
	    multi = vlen > 0;
	var count = [];

	if (!initial) {
		var _idxs = {};
		while (ks.length < k) {
			var idx = Math.floor(Math.random() * len);
			if (!_idxs[idx]) {
				_idxs[idx] = true;
				ks.push(data[idx]);
			}
		}
	} else if (initial == "kmrand") {
		ks = kmrand(data, k);
	} else if (initial == "kmpp") {
		ks = kmpp(data, k);
	} else {
		ks = initial;
	}

	do {
		// Reset k count
		init(k, 0, count);

		// For each value in data, find the nearest centroid
		for (var i = 0; i < len; i++) {
			var min = Infinity,
			    _idx = 0;
			for (var j = 0; j < k; j++) {
				// Multidimensional or unidimensional
				var dist = multi ? eudist(data[i], ks[j]) : Math.abs(data[i] - ks[j]);
				if (dist <= min) {
					min = dist;
					_idx = j;
				}
			}
			idxs[i] = _idx; // Index of the selected centroid for that value
			count[_idx]++; // Number of values for this centroid
		}

		// Recalculate centroids
		var sum = [],
		    old = [],
		    dif = 0;
		for (var _j = 0; _j < k; _j++) {
			// Multidimensional or unidimensional
			sum[_j] = multi ? init(vlen, 0, sum[_j]) : 0;
			old[_j] = ks[_j];
		}

		// If multidimensional
		if (multi) {
			for (var _j2 = 0; _j2 < k; _j2++) {
				ks[_j2] = [];
			} // Sum values and count for each centroid
			for (var _i = 0; _i < len; _i++) {
				var _idx2 = idxs[_i],
				    // Centroid for that item
				vsum = sum[_idx2],
				    // Sum values for this centroid
				vect = data[_i]; // Current vector

				// Accumulate value on the centroid for current vector
				for (var h = 0; h < vlen; h++) {
					vsum[h] += vect[h];
				}
			}
			// Calculate the average for each centroid
			conv = true;
			for (var _j3 = 0; _j3 < k; _j3++) {
				var ksj = ks[_j3],
				    // Current centroid
				sumj = sum[_j3],
				    // Accumulated centroid values
				oldj = old[_j3],
				    // Old centroid value
				cj = count[_j3]; // Number of elements for this centroid

				// New average
				for (var _h = 0; _h < vlen; _h++) {
					ksj[_h] = sumj[_h] / cj || 0; // New centroid
				}

				// Find if centroids have moved
				if (conv) {
					for (var _h2 = 0; _h2 < vlen; _h2++) {
						if (oldj[_h2] != ksj[_h2]) {
							conv = false;
							break;
						}
					}
				}
			}
		}
		// If unidimensional
		else {
				// Sum values and count for each centroid
				for (var _i2 = 0; _i2 < len; _i2++) {
					var _idx3 = idxs[_i2];
					sum[_idx3] += data[_i2];
				}
				// Calculate the average for each centroid
				for (var _j4 = 0; _j4 < k; _j4++) {
					ks[_j4] = sum[_j4] / count[_j4] || 0; // New centroid
				}
				// Find if centroids have moved
				conv = true;
				for (var _j5 = 0; _j5 < k; _j5++) {
					if (old[_j5] != ks[_j5]) {
						conv = false;
						break;
					}
				}
			}

		conv = conv || --it <= 0;
	} while (!conv);

	return {
		it: MAX - it,
		k: k,
		idxs: idxs,
		centroids: ks
	};
}

module.exports = skmeans;
//# sourceMappingURL=main.js.map


/***/ },

/***/ 4712
(__unused_webpack_module, exports) {

!function(t,e){ true?e(exports):0}(this,function(t){"use strict";function e(){}function n(t){this.message=t||""}function i(t){this.message=t||""}function r(t){this.message=t||""}function o(){}function s(t){return null===t?Mt:t.color}function a(t){return null===t?null:t.parent}function u(t,e){null!==t&&(t.color=e)}function l(t){return null===t?null:t.left}function c(t){return null===t?null:t.right}function p(){this.root_=null,this.size_=0}function h(){}function f(){this.array_=[],arguments[0]instanceof It&&this.addAll(arguments[0])}function g(){}function d(t){this.message=t||""}function y(){this.array_=[]}"fill"in Array.prototype||Object.defineProperty(Array.prototype,"fill",{configurable:!0,value:function(t){if(void 0===this||null===this)throw new TypeError(this+" is not an object");var e=Object(this),n=Math.max(Math.min(e.length,9007199254740991),0)||0,i=1 in arguments?parseInt(Number(arguments[1]),10)||0:0;i=i<0?Math.max(n+i,0):Math.min(i,n);var r=2 in arguments&&void 0!==arguments[2]?parseInt(Number(arguments[2]),10)||0:n;for(r=r<0?Math.max(n+arguments[2],0):Math.min(r,n);i<r;)e[i]=t,++i;return e},writable:!0}),Number.isFinite=Number.isFinite||function(t){return"number"==typeof t&&isFinite(t)},Number.isInteger=Number.isInteger||function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t},Number.parseFloat=Number.parseFloat||parseFloat,Number.isNaN=Number.isNaN||function(t){return t!=t},Math.trunc=Math.trunc||function(t){return t<0?Math.ceil(t):Math.floor(t)};var _=function(){};_.prototype.interfaces_=function(){return[]},_.prototype.getClass=function(){return _},_.prototype.equalsWithTolerance=function(t,e,n){return Math.abs(t-e)<=n};var m=function(t){function e(e){t.call(this,e),this.name="IllegalArgumentException",this.message=e,this.stack=(new t).stack}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Error),v=function(){},I={MAX_VALUE:{configurable:!0}};v.isNaN=function(t){return Number.isNaN(t)},v.doubleToLongBits=function(t){return t},v.longBitsToDouble=function(t){return t},v.isInfinite=function(t){return!Number.isFinite(t)},I.MAX_VALUE.get=function(){return Number.MAX_VALUE},Object.defineProperties(v,I);var E=function(){},x=function(){},N=function(){},C=function t(){if(this.x=null,this.y=null,this.z=null,0===arguments.length)this.x=0,this.y=0,this.z=t.NULL_ORDINATE;else if(1===arguments.length){var e=arguments[0];this.x=e.x,this.y=e.y,this.z=e.z}else 2===arguments.length?(this.x=arguments[0],this.y=arguments[1],this.z=t.NULL_ORDINATE):3===arguments.length&&(this.x=arguments[0],this.y=arguments[1],this.z=arguments[2])},S={DimensionalComparator:{configurable:!0},serialVersionUID:{configurable:!0},NULL_ORDINATE:{configurable:!0},X:{configurable:!0},Y:{configurable:!0},Z:{configurable:!0}};C.prototype.setOrdinate=function(t,e){switch(t){case C.X:this.x=e;break;case C.Y:this.y=e;break;case C.Z:this.z=e;break;default:throw new m("Invalid ordinate index: "+t)}},C.prototype.equals2D=function(){if(1===arguments.length){var t=arguments[0];return this.x===t.x&&this.y===t.y}if(2===arguments.length){var e=arguments[0],n=arguments[1];return!!_.equalsWithTolerance(this.x,e.x,n)&&!!_.equalsWithTolerance(this.y,e.y,n)}},C.prototype.getOrdinate=function(t){switch(t){case C.X:return this.x;case C.Y:return this.y;case C.Z:return this.z}throw new m("Invalid ordinate index: "+t)},C.prototype.equals3D=function(t){return this.x===t.x&&this.y===t.y&&(this.z===t.z||v.isNaN(this.z))&&v.isNaN(t.z)},C.prototype.equals=function(t){return t instanceof C&&this.equals2D(t)},C.prototype.equalInZ=function(t,e){return _.equalsWithTolerance(this.z,t.z,e)},C.prototype.compareTo=function(t){var e=t;return this.x<e.x?-1:this.x>e.x?1:this.y<e.y?-1:this.y>e.y?1:0},C.prototype.clone=function(){},C.prototype.copy=function(){return new C(this)},C.prototype.toString=function(){return"("+this.x+", "+this.y+", "+this.z+")"},C.prototype.distance3D=function(t){var e=this.x-t.x,n=this.y-t.y,i=this.z-t.z;return Math.sqrt(e*e+n*n+i*i)},C.prototype.distance=function(t){var e=this.x-t.x,n=this.y-t.y;return Math.sqrt(e*e+n*n)},C.prototype.hashCode=function(){var t=17;return t=37*t+C.hashCode(this.x),t=37*t+C.hashCode(this.y)},C.prototype.setCoordinate=function(t){this.x=t.x,this.y=t.y,this.z=t.z},C.prototype.interfaces_=function(){return[E,x,e]},C.prototype.getClass=function(){return C},C.hashCode=function(){if(1===arguments.length){var t=arguments[0],e=v.doubleToLongBits(t);return Math.trunc((e^e)>>>32)}},S.DimensionalComparator.get=function(){return L},S.serialVersionUID.get=function(){return 0x5cbf2c235c7e5800},S.NULL_ORDINATE.get=function(){return v.NaN},S.X.get=function(){return 0},S.Y.get=function(){return 1},S.Z.get=function(){return 2},Object.defineProperties(C,S);var L=function(t){if(this._dimensionsToTest=2,0===arguments.length);else if(1===arguments.length){var e=arguments[0];if(2!==e&&3!==e)throw new m("only 2 or 3 dimensions may be specified");this._dimensionsToTest=e}};L.prototype.compare=function(t,e){var n=t,i=e,r=L.compare(n.x,i.x);if(0!==r)return r;var o=L.compare(n.y,i.y);if(0!==o)return o;if(this._dimensionsToTest<=2)return 0;return L.compare(n.z,i.z)},L.prototype.interfaces_=function(){return[N]},L.prototype.getClass=function(){return L},L.compare=function(t,e){return t<e?-1:t>e?1:v.isNaN(t)?v.isNaN(e)?0:-1:v.isNaN(e)?1:0};var b=function(){};b.prototype.create=function(){},b.prototype.interfaces_=function(){return[]},b.prototype.getClass=function(){return b};var w=function(){},O={INTERIOR:{configurable:!0},BOUNDARY:{configurable:!0},EXTERIOR:{configurable:!0},NONE:{configurable:!0}};w.prototype.interfaces_=function(){return[]},w.prototype.getClass=function(){return w},w.toLocationSymbol=function(t){switch(t){case w.EXTERIOR:return"e";case w.BOUNDARY:return"b";case w.INTERIOR:return"i";case w.NONE:return"-"}throw new m("Unknown location value: "+t)},O.INTERIOR.get=function(){return 0},O.BOUNDARY.get=function(){return 1},O.EXTERIOR.get=function(){return 2},O.NONE.get=function(){return-1},Object.defineProperties(w,O);var T=function(t,e){return t.interfaces_&&t.interfaces_().indexOf(e)>-1},R=function(){},P={LOG_10:{configurable:!0}};R.prototype.interfaces_=function(){return[]},R.prototype.getClass=function(){return R},R.log10=function(t){var e=Math.log(t);return v.isInfinite(e)?e:v.isNaN(e)?e:e/R.LOG_10},R.min=function(t,e,n,i){var r=t;return e<r&&(r=e),n<r&&(r=n),i<r&&(r=i),r},R.clamp=function(){if("number"==typeof arguments[2]&&"number"==typeof arguments[0]&&"number"==typeof arguments[1]){var t=arguments[0],e=arguments[1],n=arguments[2];return t<e?e:t>n?n:t}if(Number.isInteger(arguments[2])&&Number.isInteger(arguments[0])&&Number.isInteger(arguments[1])){var i=arguments[0],r=arguments[1],o=arguments[2];return i<r?r:i>o?o:i}},R.wrap=function(t,e){return t<0?e- -t%e:t%e},R.max=function(){if(3===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2],i=t;return e>i&&(i=e),n>i&&(i=n),i}if(4===arguments.length){var r=arguments[0],o=arguments[1],s=arguments[2],a=arguments[3],u=r;return o>u&&(u=o),s>u&&(u=s),a>u&&(u=a),u}},R.average=function(t,e){return(t+e)/2},P.LOG_10.get=function(){return Math.log(10)},Object.defineProperties(R,P);var D=function(t){this.str=t};D.prototype.append=function(t){this.str+=t},D.prototype.setCharAt=function(t,e){this.str=this.str.substr(0,t)+e+this.str.substr(t+1)},D.prototype.toString=function(t){return this.str};var M=function(t){this.value=t};M.prototype.intValue=function(){return this.value},M.prototype.compareTo=function(t){return this.value<t?-1:this.value>t?1:0},M.isNaN=function(t){return Number.isNaN(t)};var A=function(){};A.isWhitespace=function(t){return t<=32&&t>=0||127===t},A.toUpperCase=function(t){return t.toUpperCase()};var F=function t(){if(this._hi=0,this._lo=0,0===arguments.length)this.init(0);else if(1===arguments.length){if("number"==typeof arguments[0]){var e=arguments[0];this.init(e)}else if(arguments[0]instanceof t){var n=arguments[0];this.init(n)}else if("string"==typeof arguments[0]){var i=arguments[0];t.call(this,t.parse(i))}}else if(2===arguments.length){var r=arguments[0],o=arguments[1];this.init(r,o)}},G={PI:{configurable:!0},TWO_PI:{configurable:!0},PI_2:{configurable:!0},E:{configurable:!0},NaN:{configurable:!0},EPS:{configurable:!0},SPLIT:{configurable:!0},MAX_PRINT_DIGITS:{configurable:!0},TEN:{configurable:!0},ONE:{configurable:!0},SCI_NOT_EXPONENT_CHAR:{configurable:!0},SCI_NOT_ZERO:{configurable:!0}};F.prototype.le=function(t){return(this._hi<t._hi||this._hi===t._hi)&&this._lo<=t._lo},F.prototype.extractSignificantDigits=function(t,e){var n=this.abs(),i=F.magnitude(n._hi),r=F.TEN.pow(i);(n=n.divide(r)).gt(F.TEN)?(n=n.divide(F.TEN),i+=1):n.lt(F.ONE)&&(n=n.multiply(F.TEN),i-=1);for(var o=i+1,s=new D,a=F.MAX_PRINT_DIGITS-1,u=0;u<=a;u++){t&&u===o&&s.append(".");var l=Math.trunc(n._hi);if(l<0)break;var c=!1,p=0;l>9?(c=!0,p="9"):p="0"+l,s.append(p),n=n.subtract(F.valueOf(l)).multiply(F.TEN),c&&n.selfAdd(F.TEN);var h=!0,f=F.magnitude(n._hi);if(f<0&&Math.abs(f)>=a-u&&(h=!1),!h)break}return e[0]=i,s.toString()},F.prototype.sqr=function(){return this.multiply(this)},F.prototype.doubleValue=function(){return this._hi+this._lo},F.prototype.subtract=function(){if(arguments[0]instanceof F){var t=arguments[0];return this.add(t.negate())}if("number"==typeof arguments[0]){var e=arguments[0];return this.add(-e)}},F.prototype.equals=function(){if(1===arguments.length){var t=arguments[0];return this._hi===t._hi&&this._lo===t._lo}},F.prototype.isZero=function(){return 0===this._hi&&0===this._lo},F.prototype.selfSubtract=function(){if(arguments[0]instanceof F){var t=arguments[0];return this.isNaN()?this:this.selfAdd(-t._hi,-t._lo)}if("number"==typeof arguments[0]){var e=arguments[0];return this.isNaN()?this:this.selfAdd(-e,0)}},F.prototype.getSpecialNumberString=function(){return this.isZero()?"0.0":this.isNaN()?"NaN ":null},F.prototype.min=function(t){return this.le(t)?this:t},F.prototype.selfDivide=function(){if(1===arguments.length){if(arguments[0]instanceof F){var t=arguments[0];return this.selfDivide(t._hi,t._lo)}if("number"==typeof arguments[0]){var e=arguments[0];return this.selfDivide(e,0)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1],r=null,o=null,s=null,a=null,u=null,l=null,c=null,p=null;return u=this._hi/n,l=F.SPLIT*u,r=l-u,p=F.SPLIT*n,r=l-r,o=u-r,s=p-n,c=u*n,s=p-s,a=n-s,p=r*s-c+r*a+o*s+o*a,l=(this._hi-c-p+this._lo-u*i)/n,p=u+l,this._hi=p,this._lo=u-p+l,this}},F.prototype.dump=function(){return"DD<"+this._hi+", "+this._lo+">"},F.prototype.divide=function(){if(arguments[0]instanceof F){var t=arguments[0],e=null,n=null,i=null,r=null,o=null,s=null,a=null,u=null;n=(o=this._hi/t._hi)-(e=(s=F.SPLIT*o)-(e=s-o)),u=e*(i=(u=F.SPLIT*t._hi)-(i=u-t._hi))-(a=o*t._hi)+e*(r=t._hi-i)+n*i+n*r,s=(this._hi-a-u+this._lo-o*t._lo)/t._hi;return new F(u=o+s,o-u+s)}if("number"==typeof arguments[0]){var l=arguments[0];return v.isNaN(l)?F.createNaN():F.copy(this).selfDivide(l,0)}},F.prototype.ge=function(t){return(this._hi>t._hi||this._hi===t._hi)&&this._lo>=t._lo},F.prototype.pow=function(t){if(0===t)return F.valueOf(1);var e=new F(this),n=F.valueOf(1),i=Math.abs(t);if(i>1)for(;i>0;)i%2==1&&n.selfMultiply(e),(i/=2)>0&&(e=e.sqr());else n=e;return t<0?n.reciprocal():n},F.prototype.ceil=function(){if(this.isNaN())return F.NaN;var t=Math.ceil(this._hi),e=0;return t===this._hi&&(e=Math.ceil(this._lo)),new F(t,e)},F.prototype.compareTo=function(t){var e=t;return this._hi<e._hi?-1:this._hi>e._hi?1:this._lo<e._lo?-1:this._lo>e._lo?1:0},F.prototype.rint=function(){if(this.isNaN())return this;return this.add(.5).floor()},F.prototype.setValue=function(){if(arguments[0]instanceof F){var t=arguments[0];return this.init(t),this}if("number"==typeof arguments[0]){var e=arguments[0];return this.init(e),this}},F.prototype.max=function(t){return this.ge(t)?this:t},F.prototype.sqrt=function(){if(this.isZero())return F.valueOf(0);if(this.isNegative())return F.NaN;var t=1/Math.sqrt(this._hi),e=this._hi*t,n=F.valueOf(e),i=this.subtract(n.sqr())._hi*(.5*t);return n.add(i)},F.prototype.selfAdd=function(){if(1===arguments.length){if(arguments[0]instanceof F){var t=arguments[0];return this.selfAdd(t._hi,t._lo)}if("number"==typeof arguments[0]){var e=arguments[0],n=null,i=null,r=null,o=null,s=null,a=null;return r=this._hi+e,s=r-this._hi,o=r-s,o=e-s+(this._hi-o),a=o+this._lo,n=r+a,i=a+(r-n),this._hi=n+i,this._lo=i+(n-this._hi),this}}else if(2===arguments.length){var u=arguments[0],l=arguments[1],c=null,p=null,h=null,f=null,g=null,d=null,y=null;f=this._hi+u,p=this._lo+l,g=f-(d=f-this._hi),h=p-(y=p-this._lo);var _=(c=f+(d=(g=u-d+(this._hi-g))+p))+(d=(h=l-y+(this._lo-h))+(d+(f-c))),m=d+(c-_);return this._hi=_,this._lo=m,this}},F.prototype.selfMultiply=function(){if(1===arguments.length){if(arguments[0]instanceof F){var t=arguments[0];return this.selfMultiply(t._hi,t._lo)}if("number"==typeof arguments[0]){var e=arguments[0];return this.selfMultiply(e,0)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1],r=null,o=null,s=null,a=null,u=null,l=null;r=(u=F.SPLIT*this._hi)-this._hi,l=F.SPLIT*n,r=u-r,o=this._hi-r,s=l-n;var c=(u=this._hi*n)+(l=r*(s=l-s)-u+r*(a=n-s)+o*s+o*a+(this._hi*i+this._lo*n)),p=l+(r=u-c);return this._hi=c,this._lo=p,this}},F.prototype.selfSqr=function(){return this.selfMultiply(this)},F.prototype.floor=function(){if(this.isNaN())return F.NaN;var t=Math.floor(this._hi),e=0;return t===this._hi&&(e=Math.floor(this._lo)),new F(t,e)},F.prototype.negate=function(){return this.isNaN()?this:new F(-this._hi,-this._lo)},F.prototype.clone=function(){},F.prototype.multiply=function(){if(arguments[0]instanceof F){var t=arguments[0];return t.isNaN()?F.createNaN():F.copy(this).selfMultiply(t)}if("number"==typeof arguments[0]){var e=arguments[0];return v.isNaN(e)?F.createNaN():F.copy(this).selfMultiply(e,0)}},F.prototype.isNaN=function(){return v.isNaN(this._hi)},F.prototype.intValue=function(){return Math.trunc(this._hi)},F.prototype.toString=function(){var t=F.magnitude(this._hi);return t>=-3&&t<=20?this.toStandardNotation():this.toSciNotation()},F.prototype.toStandardNotation=function(){var t=this.getSpecialNumberString();if(null!==t)return t;var e=new Array(1).fill(null),n=this.extractSignificantDigits(!0,e),i=e[0]+1,r=n;if("."===n.charAt(0))r="0"+n;else if(i<0)r="0."+F.stringOfChar("0",-i)+n;else if(-1===n.indexOf(".")){var o=i-n.length;r=n+F.stringOfChar("0",o)+".0"}return this.isNegative()?"-"+r:r},F.prototype.reciprocal=function(){var t=null,e=null,n=null,i=null,r=null,o=null,s=null,a=null;e=(r=1/this._hi)-(t=(o=F.SPLIT*r)-(t=o-r)),n=(a=F.SPLIT*this._hi)-this._hi;var u=r+(o=(1-(s=r*this._hi)-(a=t*(n=a-n)-s+t*(i=this._hi-n)+e*n+e*i)-r*this._lo)/this._hi);return new F(u,r-u+o)},F.prototype.toSciNotation=function(){if(this.isZero())return F.SCI_NOT_ZERO;var t=this.getSpecialNumberString();if(null!==t)return t;var e=new Array(1).fill(null),n=this.extractSignificantDigits(!1,e),i=F.SCI_NOT_EXPONENT_CHAR+e[0];if("0"===n.charAt(0))throw new Error("Found leading zero: "+n);var r="";n.length>1&&(r=n.substring(1));var o=n.charAt(0)+"."+r;return this.isNegative()?"-"+o+i:o+i},F.prototype.abs=function(){return this.isNaN()?F.NaN:this.isNegative()?this.negate():new F(this)},F.prototype.isPositive=function(){return(this._hi>0||0===this._hi)&&this._lo>0},F.prototype.lt=function(t){return(this._hi<t._hi||this._hi===t._hi)&&this._lo<t._lo},F.prototype.add=function(){if(arguments[0]instanceof F){var t=arguments[0];return F.copy(this).selfAdd(t)}if("number"==typeof arguments[0]){var e=arguments[0];return F.copy(this).selfAdd(e)}},F.prototype.init=function(){if(1===arguments.length){if("number"==typeof arguments[0]){var t=arguments[0];this._hi=t,this._lo=0}else if(arguments[0]instanceof F){var e=arguments[0];this._hi=e._hi,this._lo=e._lo}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this._hi=n,this._lo=i}},F.prototype.gt=function(t){return(this._hi>t._hi||this._hi===t._hi)&&this._lo>t._lo},F.prototype.isNegative=function(){return(this._hi<0||0===this._hi)&&this._lo<0},F.prototype.trunc=function(){return this.isNaN()?F.NaN:this.isPositive()?this.floor():this.ceil()},F.prototype.signum=function(){return this._hi>0?1:this._hi<0?-1:this._lo>0?1:this._lo<0?-1:0},F.prototype.interfaces_=function(){return[e,E,x]},F.prototype.getClass=function(){return F},F.sqr=function(t){return F.valueOf(t).selfMultiply(t)},F.valueOf=function(){if("string"==typeof arguments[0]){var t=arguments[0];return F.parse(t)}if("number"==typeof arguments[0]){var e=arguments[0];return new F(e)}},F.sqrt=function(t){return F.valueOf(t).sqrt()},F.parse=function(t){for(var e=0,n=t.length;A.isWhitespace(t.charAt(e));)e++;var i=!1;if(e<n){var r=t.charAt(e);"-"!==r&&"+"!==r||(e++,"-"===r&&(i=!0))}for(var o=new F,s=0,a=0,u=0;!(e>=n);){var l=t.charAt(e);if(e++,A.isDigit(l)){var c=l-"0";o.selfMultiply(F.TEN),o.selfAdd(c),s++}else{if("."!==l){if("e"===l||"E"===l){var p=t.substring(e);try{u=M.parseInt(p)}catch(e){throw e instanceof Error?new Error("Invalid exponent "+p+" in string "+t):e}break}throw new Error("Unexpected character '"+l+"' at position "+e+" in string "+t)}a=s}}var h=o,f=s-a-u;if(0===f)h=o;else if(f>0){var g=F.TEN.pow(f);h=o.divide(g)}else if(f<0){var d=F.TEN.pow(-f);h=o.multiply(d)}return i?h.negate():h},F.createNaN=function(){return new F(v.NaN,v.NaN)},F.copy=function(t){return new F(t)},F.magnitude=function(t){var e=Math.abs(t),n=Math.log(e)/Math.log(10),i=Math.trunc(Math.floor(n));return 10*Math.pow(10,i)<=e&&(i+=1),i},F.stringOfChar=function(t,e){for(var n=new D,i=0;i<e;i++)n.append(t);return n.toString()},G.PI.get=function(){return new F(3.141592653589793,1.2246467991473532e-16)},G.TWO_PI.get=function(){return new F(6.283185307179586,2.4492935982947064e-16)},G.PI_2.get=function(){return new F(1.5707963267948966,6.123233995736766e-17)},G.E.get=function(){return new F(2.718281828459045,1.4456468917292502e-16)},G.NaN.get=function(){return new F(v.NaN,v.NaN)},G.EPS.get=function(){return 1.23259516440783e-32},G.SPLIT.get=function(){return 134217729},G.MAX_PRINT_DIGITS.get=function(){return 32},G.TEN.get=function(){return F.valueOf(10)},G.ONE.get=function(){return F.valueOf(1)},G.SCI_NOT_EXPONENT_CHAR.get=function(){return"E"},G.SCI_NOT_ZERO.get=function(){return"0.0E0"},Object.defineProperties(F,G);var q=function(){},B={DP_SAFE_EPSILON:{configurable:!0}};q.prototype.interfaces_=function(){return[]},q.prototype.getClass=function(){return q},q.orientationIndex=function(t,e,n){var i=q.orientationIndexFilter(t,e,n);if(i<=1)return i;var r=F.valueOf(e.x).selfAdd(-t.x),o=F.valueOf(e.y).selfAdd(-t.y),s=F.valueOf(n.x).selfAdd(-e.x),a=F.valueOf(n.y).selfAdd(-e.y);return r.selfMultiply(a).selfSubtract(o.selfMultiply(s)).signum()},q.signOfDet2x2=function(t,e,n,i){return t.multiply(i).selfSubtract(e.multiply(n)).signum()},q.intersection=function(t,e,n,i){var r=F.valueOf(i.y).selfSubtract(n.y).selfMultiply(F.valueOf(e.x).selfSubtract(t.x)),o=F.valueOf(i.x).selfSubtract(n.x).selfMultiply(F.valueOf(e.y).selfSubtract(t.y)),s=r.subtract(o),a=F.valueOf(i.x).selfSubtract(n.x).selfMultiply(F.valueOf(t.y).selfSubtract(n.y)),u=F.valueOf(i.y).selfSubtract(n.y).selfMultiply(F.valueOf(t.x).selfSubtract(n.x)),l=a.subtract(u).selfDivide(s).doubleValue(),c=F.valueOf(t.x).selfAdd(F.valueOf(e.x).selfSubtract(t.x).selfMultiply(l)).doubleValue(),p=F.valueOf(e.x).selfSubtract(t.x).selfMultiply(F.valueOf(t.y).selfSubtract(n.y)),h=F.valueOf(e.y).selfSubtract(t.y).selfMultiply(F.valueOf(t.x).selfSubtract(n.x)),f=p.subtract(h).selfDivide(s).doubleValue(),g=F.valueOf(n.y).selfAdd(F.valueOf(i.y).selfSubtract(n.y).selfMultiply(f)).doubleValue();return new C(c,g)},q.orientationIndexFilter=function(t,e,n){var i=null,r=(t.x-n.x)*(e.y-n.y),o=(t.y-n.y)*(e.x-n.x),s=r-o;if(r>0){if(o<=0)return q.signum(s);i=r+o}else{if(!(r<0))return q.signum(s);if(o>=0)return q.signum(s);i=-r-o}var a=q.DP_SAFE_EPSILON*i;return s>=a||-s>=a?q.signum(s):2},q.signum=function(t){return t>0?1:t<0?-1:0},B.DP_SAFE_EPSILON.get=function(){return 1e-15},Object.defineProperties(q,B);var V=function(){},U={X:{configurable:!0},Y:{configurable:!0},Z:{configurable:!0},M:{configurable:!0}};U.X.get=function(){return 0},U.Y.get=function(){return 1},U.Z.get=function(){return 2},U.M.get=function(){return 3},V.prototype.setOrdinate=function(t,e,n){},V.prototype.size=function(){},V.prototype.getOrdinate=function(t,e){},V.prototype.getCoordinate=function(){},V.prototype.getCoordinateCopy=function(t){},V.prototype.getDimension=function(){},V.prototype.getX=function(t){},V.prototype.clone=function(){},V.prototype.expandEnvelope=function(t){},V.prototype.copy=function(){},V.prototype.getY=function(t){},V.prototype.toCoordinateArray=function(){},V.prototype.interfaces_=function(){return[x]},V.prototype.getClass=function(){return V},Object.defineProperties(V,U);var z=function(){},X=function(t){function e(){t.call(this,"Projective point not representable on the Cartesian plane.")}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(z),Y=function(){};Y.arraycopy=function(t,e,n,i,r){for(var o=0,s=e;s<e+r;s++)n[i+o]=t[s],o++},Y.getProperty=function(t){return{"line.separator":"\n"}[t]};var k=function t(){if(this.x=null,this.y=null,this.w=null,0===arguments.length)this.x=0,this.y=0,this.w=1;else if(1===arguments.length){var e=arguments[0];this.x=e.x,this.y=e.y,this.w=1}else if(2===arguments.length){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){var n=arguments[0],i=arguments[1];this.x=n,this.y=i,this.w=1}else if(arguments[0]instanceof t&&arguments[1]instanceof t){var r=arguments[0],o=arguments[1];this.x=r.y*o.w-o.y*r.w,this.y=o.x*r.w-r.x*o.w,this.w=r.x*o.y-o.x*r.y}else if(arguments[0]instanceof C&&arguments[1]instanceof C){var s=arguments[0],a=arguments[1];this.x=s.y-a.y,this.y=a.x-s.x,this.w=s.x*a.y-a.x*s.y}}else if(3===arguments.length){var u=arguments[0],l=arguments[1],c=arguments[2];this.x=u,this.y=l,this.w=c}else if(4===arguments.length){var p=arguments[0],h=arguments[1],f=arguments[2],g=arguments[3],d=p.y-h.y,y=h.x-p.x,_=p.x*h.y-h.x*p.y,m=f.y-g.y,v=g.x-f.x,I=f.x*g.y-g.x*f.y;this.x=y*I-v*_,this.y=m*_-d*I,this.w=d*v-m*y}};k.prototype.getY=function(){var t=this.y/this.w;if(v.isNaN(t)||v.isInfinite(t))throw new X;return t},k.prototype.getX=function(){var t=this.x/this.w;if(v.isNaN(t)||v.isInfinite(t))throw new X;return t},k.prototype.getCoordinate=function(){var t=new C;return t.x=this.getX(),t.y=this.getY(),t},k.prototype.interfaces_=function(){return[]},k.prototype.getClass=function(){return k},k.intersection=function(t,e,n,i){var r=t.y-e.y,o=e.x-t.x,s=t.x*e.y-e.x*t.y,a=n.y-i.y,u=i.x-n.x,l=n.x*i.y-i.x*n.y,c=r*u-a*o,p=(o*l-u*s)/c,h=(a*s-r*l)/c;if(v.isNaN(p)||v.isInfinite(p)||v.isNaN(h)||v.isInfinite(h))throw new X;return new C(p,h)};var j=function t(){if(this._minx=null,this._maxx=null,this._miny=null,this._maxy=null,0===arguments.length)this.init();else if(1===arguments.length){if(arguments[0]instanceof C){var e=arguments[0];this.init(e.x,e.x,e.y,e.y)}else if(arguments[0]instanceof t){var n=arguments[0];this.init(n)}}else if(2===arguments.length){var i=arguments[0],r=arguments[1];this.init(i.x,r.x,i.y,r.y)}else if(4===arguments.length){var o=arguments[0],s=arguments[1],a=arguments[2],u=arguments[3];this.init(o,s,a,u)}},H={serialVersionUID:{configurable:!0}};j.prototype.getArea=function(){return this.getWidth()*this.getHeight()},j.prototype.equals=function(t){if(!(t instanceof j))return!1;var e=t;return this.isNull()?e.isNull():this._maxx===e.getMaxX()&&this._maxy===e.getMaxY()&&this._minx===e.getMinX()&&this._miny===e.getMinY()},j.prototype.intersection=function(t){if(this.isNull()||t.isNull()||!this.intersects(t))return new j;var e=this._minx>t._minx?this._minx:t._minx,n=this._miny>t._miny?this._miny:t._miny,i=this._maxx<t._maxx?this._maxx:t._maxx,r=this._maxy<t._maxy?this._maxy:t._maxy;return new j(e,i,n,r)},j.prototype.isNull=function(){return this._maxx<this._minx},j.prototype.getMaxX=function(){return this._maxx},j.prototype.covers=function(){if(1===arguments.length){if(arguments[0]instanceof C){var t=arguments[0];return this.covers(t.x,t.y)}if(arguments[0]instanceof j){var e=arguments[0];return!this.isNull()&&!e.isNull()&&(e.getMinX()>=this._minx&&e.getMaxX()<=this._maxx&&e.getMinY()>=this._miny&&e.getMaxY()<=this._maxy)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];return!this.isNull()&&(n>=this._minx&&n<=this._maxx&&i>=this._miny&&i<=this._maxy)}},j.prototype.intersects=function(){if(1===arguments.length){if(arguments[0]instanceof j){var t=arguments[0];return!this.isNull()&&!t.isNull()&&!(t._minx>this._maxx||t._maxx<this._minx||t._miny>this._maxy||t._maxy<this._miny)}if(arguments[0]instanceof C){var e=arguments[0];return this.intersects(e.x,e.y)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];return!this.isNull()&&!(n>this._maxx||n<this._minx||i>this._maxy||i<this._miny)}},j.prototype.getMinY=function(){return this._miny},j.prototype.getMinX=function(){return this._minx},j.prototype.expandToInclude=function(){if(1===arguments.length){if(arguments[0]instanceof C){var t=arguments[0];this.expandToInclude(t.x,t.y)}else if(arguments[0]instanceof j){var e=arguments[0];if(e.isNull())return null;this.isNull()?(this._minx=e.getMinX(),this._maxx=e.getMaxX(),this._miny=e.getMinY(),this._maxy=e.getMaxY()):(e._minx<this._minx&&(this._minx=e._minx),e._maxx>this._maxx&&(this._maxx=e._maxx),e._miny<this._miny&&(this._miny=e._miny),e._maxy>this._maxy&&(this._maxy=e._maxy))}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this.isNull()?(this._minx=n,this._maxx=n,this._miny=i,this._maxy=i):(n<this._minx&&(this._minx=n),n>this._maxx&&(this._maxx=n),i<this._miny&&(this._miny=i),i>this._maxy&&(this._maxy=i))}},j.prototype.minExtent=function(){if(this.isNull())return 0;var t=this.getWidth(),e=this.getHeight();return t<e?t:e},j.prototype.getWidth=function(){return this.isNull()?0:this._maxx-this._minx},j.prototype.compareTo=function(t){var e=t;return this.isNull()?e.isNull()?0:-1:e.isNull()?1:this._minx<e._minx?-1:this._minx>e._minx?1:this._miny<e._miny?-1:this._miny>e._miny?1:this._maxx<e._maxx?-1:this._maxx>e._maxx?1:this._maxy<e._maxy?-1:this._maxy>e._maxy?1:0},j.prototype.translate=function(t,e){if(this.isNull())return null;this.init(this.getMinX()+t,this.getMaxX()+t,this.getMinY()+e,this.getMaxY()+e)},j.prototype.toString=function(){return"Env["+this._minx+" : "+this._maxx+", "+this._miny+" : "+this._maxy+"]"},j.prototype.setToNull=function(){this._minx=0,this._maxx=-1,this._miny=0,this._maxy=-1},j.prototype.getHeight=function(){return this.isNull()?0:this._maxy-this._miny},j.prototype.maxExtent=function(){if(this.isNull())return 0;var t=this.getWidth(),e=this.getHeight();return t>e?t:e},j.prototype.expandBy=function(){if(1===arguments.length){var t=arguments[0];this.expandBy(t,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(this.isNull())return null;this._minx-=e,this._maxx+=e,this._miny-=n,this._maxy+=n,(this._minx>this._maxx||this._miny>this._maxy)&&this.setToNull()}},j.prototype.contains=function(){if(1===arguments.length){if(arguments[0]instanceof j){var t=arguments[0];return this.covers(t)}if(arguments[0]instanceof C){var e=arguments[0];return this.covers(e)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];return this.covers(n,i)}},j.prototype.centre=function(){return this.isNull()?null:new C((this.getMinX()+this.getMaxX())/2,(this.getMinY()+this.getMaxY())/2)},j.prototype.init=function(){if(0===arguments.length)this.setToNull();else if(1===arguments.length){if(arguments[0]instanceof C){var t=arguments[0];this.init(t.x,t.x,t.y,t.y)}else if(arguments[0]instanceof j){var e=arguments[0];this._minx=e._minx,this._maxx=e._maxx,this._miny=e._miny,this._maxy=e._maxy}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this.init(n.x,i.x,n.y,i.y)}else if(4===arguments.length){var r=arguments[0],o=arguments[1],s=arguments[2],a=arguments[3];r<o?(this._minx=r,this._maxx=o):(this._minx=o,this._maxx=r),s<a?(this._miny=s,this._maxy=a):(this._miny=a,this._maxy=s)}},j.prototype.getMaxY=function(){return this._maxy},j.prototype.distance=function(t){if(this.intersects(t))return 0;var e=0;this._maxx<t._minx?e=t._minx-this._maxx:this._minx>t._maxx&&(e=this._minx-t._maxx);var n=0;return this._maxy<t._miny?n=t._miny-this._maxy:this._miny>t._maxy&&(n=this._miny-t._maxy),0===e?n:0===n?e:Math.sqrt(e*e+n*n)},j.prototype.hashCode=function(){var t=17;return t=37*t+C.hashCode(this._minx),t=37*t+C.hashCode(this._maxx),t=37*t+C.hashCode(this._miny),t=37*t+C.hashCode(this._maxy)},j.prototype.interfaces_=function(){return[E,e]},j.prototype.getClass=function(){return j},j.intersects=function(){if(3===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2];return n.x>=(t.x<e.x?t.x:e.x)&&n.x<=(t.x>e.x?t.x:e.x)&&n.y>=(t.y<e.y?t.y:e.y)&&n.y<=(t.y>e.y?t.y:e.y)}if(4===arguments.length){var i=arguments[0],r=arguments[1],o=arguments[2],s=arguments[3],a=Math.min(o.x,s.x),u=Math.max(o.x,s.x),l=Math.min(i.x,r.x),c=Math.max(i.x,r.x);return!(l>u)&&(!(c<a)&&(a=Math.min(o.y,s.y),u=Math.max(o.y,s.y),l=Math.min(i.y,r.y),c=Math.max(i.y,r.y),!(l>u)&&!(c<a)))}},H.serialVersionUID.get=function(){return 0x51845cd552189800},Object.defineProperties(j,H);var W={typeStr:/^\s*(\w+)\s*\(\s*(.*)\s*\)\s*$/,emptyTypeStr:/^\s*(\w+)\s*EMPTY\s*$/,spaces:/\s+/,parenComma:/\)\s*,\s*\(/,doubleParenComma:/\)\s*\)\s*,\s*\(\s*\(/,trimParens:/^\s*\(?(.*?)\)?\s*$/},K=function(t){this.geometryFactory=t||new _e};K.prototype.read=function(t){var e,n,i;t=t.replace(/[\n\r]/g," ");var r=W.typeStr.exec(t);if(-1!==t.search("EMPTY")&&((r=W.emptyTypeStr.exec(t))[2]=void 0),r&&(n=r[1].toLowerCase(),i=r[2],Q[n]&&(e=Q[n].apply(this,[i]))),void 0===e)throw new Error("Could not parse WKT "+t);return e},K.prototype.write=function(t){return this.extractGeometry(t)},K.prototype.extractGeometry=function(t){var e=t.getGeometryType().toLowerCase();if(!J[e])return null;var n=e.toUpperCase();return t.isEmpty()?n+" EMPTY":n+"("+J[e].apply(this,[t])+")"};var J={coordinate:function(t){return t.x+" "+t.y},point:function(t){return J.coordinate.call(this,t._coordinates._coordinates[0])},multipoint:function(t){for(var e=[],n=0,i=t._geometries.length;n<i;++n)e.push("("+J.point.apply(this,[t._geometries[n]])+")");return e.join(",")},linestring:function(t){for(var e=[],n=0,i=t._points._coordinates.length;n<i;++n)e.push(J.coordinate.apply(this,[t._points._coordinates[n]]));return e.join(",")},linearring:function(t){for(var e=[],n=0,i=t._points._coordinates.length;n<i;++n)e.push(J.coordinate.apply(this,[t._points._coordinates[n]]));return e.join(",")},multilinestring:function(t){for(var e=[],n=0,i=t._geometries.length;n<i;++n)e.push("("+J.linestring.apply(this,[t._geometries[n]])+")");return e.join(",")},polygon:function(t){var e=[];e.push("("+J.linestring.apply(this,[t._shell])+")");for(var n=0,i=t._holes.length;n<i;++n)e.push("("+J.linestring.apply(this,[t._holes[n]])+")");return e.join(",")},multipolygon:function(t){for(var e=[],n=0,i=t._geometries.length;n<i;++n)e.push("("+J.polygon.apply(this,[t._geometries[n]])+")");return e.join(",")},geometrycollection:function(t){for(var e=[],n=0,i=t._geometries.length;n<i;++n)e.push(this.extractGeometry(t._geometries[n]));return e.join(",")}},Q={point:function(t){if(void 0===t)return this.geometryFactory.createPoint();var e=t.trim().split(W.spaces);return this.geometryFactory.createPoint(new C(Number.parseFloat(e[0]),Number.parseFloat(e[1])))},multipoint:function(t){if(void 0===t)return this.geometryFactory.createMultiPoint();for(var e,n=t.trim().split(","),i=[],r=0,o=n.length;r<o;++r)e=n[r].replace(W.trimParens,"$1"),i.push(Q.point.apply(this,[e]));return this.geometryFactory.createMultiPoint(i)},linestring:function(t){if(void 0===t)return this.geometryFactory.createLineString();for(var e,n=t.trim().split(","),i=[],r=0,o=n.length;r<o;++r)e=n[r].trim().split(W.spaces),i.push(new C(Number.parseFloat(e[0]),Number.parseFloat(e[1])));return this.geometryFactory.createLineString(i)},linearring:function(t){if(void 0===t)return this.geometryFactory.createLinearRing();for(var e,n=t.trim().split(","),i=[],r=0,o=n.length;r<o;++r)e=n[r].trim().split(W.spaces),i.push(new C(Number.parseFloat(e[0]),Number.parseFloat(e[1])));return this.geometryFactory.createLinearRing(i)},multilinestring:function(t){if(void 0===t)return this.geometryFactory.createMultiLineString();for(var e,n=t.trim().split(W.parenComma),i=[],r=0,o=n.length;r<o;++r)e=n[r].replace(W.trimParens,"$1"),i.push(Q.linestring.apply(this,[e]));return this.geometryFactory.createMultiLineString(i)},polygon:function(t){if(void 0===t)return this.geometryFactory.createPolygon();for(var e,n,i,r,o=t.trim().split(W.parenComma),s=[],a=0,u=o.length;a<u;++a)e=o[a].replace(W.trimParens,"$1"),n=Q.linestring.apply(this,[e]),i=this.geometryFactory.createLinearRing(n._points),0===a?r=i:s.push(i);return this.geometryFactory.createPolygon(r,s)},multipolygon:function(t){if(void 0===t)return this.geometryFactory.createMultiPolygon();for(var e,n=t.trim().split(W.doubleParenComma),i=[],r=0,o=n.length;r<o;++r)e=n[r].replace(W.trimParens,"$1"),i.push(Q.polygon.apply(this,[e]));return this.geometryFactory.createMultiPolygon(i)},geometrycollection:function(t){if(void 0===t)return this.geometryFactory.createGeometryCollection();for(var e=(t=t.replace(/,\s*([A-Za-z])/g,"|$1")).trim().split("|"),n=[],i=0,r=e.length;i<r;++i)n.push(this.read(e[i]));return this.geometryFactory.createGeometryCollection(n)}},Z=function(t){this.parser=new K(t)};Z.prototype.write=function(t){return this.parser.write(t)},Z.toLineString=function(t,e){if(2!==arguments.length)throw new Error("Not implemented");return"LINESTRING ( "+t.x+" "+t.y+", "+e.x+" "+e.y+" )"};var $=function(t){function e(e){t.call(this,e),this.name="RuntimeException",this.message=e,this.stack=(new t).stack}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Error),tt=function(t){function e(){if(t.call(this),0===arguments.length)t.call(this);else if(1===arguments.length){var e=arguments[0];t.call(this,e)}}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}($),et=function(){};et.prototype.interfaces_=function(){return[]},et.prototype.getClass=function(){return et},et.shouldNeverReachHere=function(){if(0===arguments.length)et.shouldNeverReachHere(null);else if(1===arguments.length){var t=arguments[0];throw new tt("Should never reach here"+(null!==t?": "+t:""))}},et.isTrue=function(){var t,e;if(1===arguments.length)t=arguments[0],et.isTrue(t,null);else if(2===arguments.length&&(t=arguments[0],e=arguments[1],!t))throw null===e?new tt:new tt(e)},et.equals=function(){var t,e,n;if(2===arguments.length)t=arguments[0],e=arguments[1],et.equals(t,e,null);else if(3===arguments.length&&(t=arguments[0],e=arguments[1],n=arguments[2],!e.equals(t)))throw new tt("Expected "+t+" but encountered "+e+(null!==n?": "+n:""))};var nt=function(){this._result=null,this._inputLines=Array(2).fill().map(function(){return Array(2)}),this._intPt=new Array(2).fill(null),this._intLineIndex=null,this._isProper=null,this._pa=null,this._pb=null,this._precisionModel=null,this._intPt[0]=new C,this._intPt[1]=new C,this._pa=this._intPt[0],this._pb=this._intPt[1],this._result=0},it={DONT_INTERSECT:{configurable:!0},DO_INTERSECT:{configurable:!0},COLLINEAR:{configurable:!0},NO_INTERSECTION:{configurable:!0},POINT_INTERSECTION:{configurable:!0},COLLINEAR_INTERSECTION:{configurable:!0}};nt.prototype.getIndexAlongSegment=function(t,e){return this.computeIntLineIndex(),this._intLineIndex[t][e]},nt.prototype.getTopologySummary=function(){var t=new D;return this.isEndPoint()&&t.append(" endpoint"),this._isProper&&t.append(" proper"),this.isCollinear()&&t.append(" collinear"),t.toString()},nt.prototype.computeIntersection=function(t,e,n,i){this._inputLines[0][0]=t,this._inputLines[0][1]=e,this._inputLines[1][0]=n,this._inputLines[1][1]=i,this._result=this.computeIntersect(t,e,n,i)},nt.prototype.getIntersectionNum=function(){return this._result},nt.prototype.computeIntLineIndex=function(){if(0===arguments.length)null===this._intLineIndex&&(this._intLineIndex=Array(2).fill().map(function(){return Array(2)}),this.computeIntLineIndex(0),this.computeIntLineIndex(1));else if(1===arguments.length){var t=arguments[0];this.getEdgeDistance(t,0)>this.getEdgeDistance(t,1)?(this._intLineIndex[t][0]=0,this._intLineIndex[t][1]=1):(this._intLineIndex[t][0]=1,this._intLineIndex[t][1]=0)}},nt.prototype.isProper=function(){return this.hasIntersection()&&this._isProper},nt.prototype.setPrecisionModel=function(t){this._precisionModel=t},nt.prototype.isInteriorIntersection=function(){if(0===arguments.length)return!!this.isInteriorIntersection(0)||!!this.isInteriorIntersection(1);if(1===arguments.length){for(var t=arguments[0],e=0;e<this._result;e++)if(!this._intPt[e].equals2D(this._inputLines[t][0])&&!this._intPt[e].equals2D(this._inputLines[t][1]))return!0;return!1}},nt.prototype.getIntersection=function(t){return this._intPt[t]},nt.prototype.isEndPoint=function(){return this.hasIntersection()&&!this._isProper},nt.prototype.hasIntersection=function(){return this._result!==nt.NO_INTERSECTION},nt.prototype.getEdgeDistance=function(t,e){return nt.computeEdgeDistance(this._intPt[e],this._inputLines[t][0],this._inputLines[t][1])},nt.prototype.isCollinear=function(){return this._result===nt.COLLINEAR_INTERSECTION},nt.prototype.toString=function(){return Z.toLineString(this._inputLines[0][0],this._inputLines[0][1])+" - "+Z.toLineString(this._inputLines[1][0],this._inputLines[1][1])+this.getTopologySummary()},nt.prototype.getEndpoint=function(t,e){return this._inputLines[t][e]},nt.prototype.isIntersection=function(t){for(var e=0;e<this._result;e++)if(this._intPt[e].equals2D(t))return!0;return!1},nt.prototype.getIntersectionAlongSegment=function(t,e){return this.computeIntLineIndex(),this._intPt[this._intLineIndex[t][e]]},nt.prototype.interfaces_=function(){return[]},nt.prototype.getClass=function(){return nt},nt.computeEdgeDistance=function(t,e,n){var i=Math.abs(n.x-e.x),r=Math.abs(n.y-e.y),o=-1;if(t.equals(e))o=0;else if(t.equals(n))o=i>r?i:r;else{var s=Math.abs(t.x-e.x),a=Math.abs(t.y-e.y);0!==(o=i>r?s:a)||t.equals(e)||(o=Math.max(s,a))}return et.isTrue(!(0===o&&!t.equals(e)),"Bad distance calculation"),o},nt.nonRobustComputeEdgeDistance=function(t,e,n){var i=t.x-e.x,r=t.y-e.y,o=Math.sqrt(i*i+r*r);return et.isTrue(!(0===o&&!t.equals(e)),"Invalid distance calculation"),o},it.DONT_INTERSECT.get=function(){return 0},it.DO_INTERSECT.get=function(){return 1},it.COLLINEAR.get=function(){return 2},it.NO_INTERSECTION.get=function(){return 0},it.POINT_INTERSECTION.get=function(){return 1},it.COLLINEAR_INTERSECTION.get=function(){return 2},Object.defineProperties(nt,it);var rt=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.isInSegmentEnvelopes=function(t){var e=new j(this._inputLines[0][0],this._inputLines[0][1]),n=new j(this._inputLines[1][0],this._inputLines[1][1]);return e.contains(t)&&n.contains(t)},e.prototype.computeIntersection=function(){if(3!==arguments.length)return t.prototype.computeIntersection.apply(this,arguments);var e=arguments[0],n=arguments[1],i=arguments[2];if(this._isProper=!1,j.intersects(n,i,e)&&0===at.orientationIndex(n,i,e)&&0===at.orientationIndex(i,n,e))return this._isProper=!0,(e.equals(n)||e.equals(i))&&(this._isProper=!1),this._result=t.POINT_INTERSECTION,null;this._result=t.NO_INTERSECTION},e.prototype.normalizeToMinimum=function(t,e,n,i,r){r.x=this.smallestInAbsValue(t.x,e.x,n.x,i.x),r.y=this.smallestInAbsValue(t.y,e.y,n.y,i.y),t.x-=r.x,t.y-=r.y,e.x-=r.x,e.y-=r.y,n.x-=r.x,n.y-=r.y,i.x-=r.x,i.y-=r.y},e.prototype.safeHCoordinateIntersection=function(t,n,i,r){var o=null;try{o=k.intersection(t,n,i,r)}catch(s){if(!(s instanceof X))throw s;o=e.nearestEndpoint(t,n,i,r)}return o},e.prototype.intersection=function(t,n,i,r){var o=this.intersectionWithNormalization(t,n,i,r);return this.isInSegmentEnvelopes(o)||(o=new C(e.nearestEndpoint(t,n,i,r))),null!==this._precisionModel&&this._precisionModel.makePrecise(o),o},e.prototype.smallestInAbsValue=function(t,e,n,i){var r=t,o=Math.abs(r);return Math.abs(e)<o&&(r=e,o=Math.abs(e)),Math.abs(n)<o&&(r=n,o=Math.abs(n)),Math.abs(i)<o&&(r=i),r},e.prototype.checkDD=function(t,e,n,i,r){var o=q.intersection(t,e,n,i),s=this.isInSegmentEnvelopes(o);Y.out.println("DD in env = "+s+"  --------------------- "+o),r.distance(o)>1e-4&&Y.out.println("Distance = "+r.distance(o))},e.prototype.intersectionWithNormalization=function(t,e,n,i){var r=new C(t),o=new C(e),s=new C(n),a=new C(i),u=new C;this.normalizeToEnvCentre(r,o,s,a,u);var l=this.safeHCoordinateIntersection(r,o,s,a);return l.x+=u.x,l.y+=u.y,l},e.prototype.computeCollinearIntersection=function(e,n,i,r){var o=j.intersects(e,n,i),s=j.intersects(e,n,r),a=j.intersects(i,r,e),u=j.intersects(i,r,n);return o&&s?(this._intPt[0]=i,this._intPt[1]=r,t.COLLINEAR_INTERSECTION):a&&u?(this._intPt[0]=e,this._intPt[1]=n,t.COLLINEAR_INTERSECTION):o&&a?(this._intPt[0]=i,this._intPt[1]=e,!i.equals(e)||s||u?t.COLLINEAR_INTERSECTION:t.POINT_INTERSECTION):o&&u?(this._intPt[0]=i,this._intPt[1]=n,!i.equals(n)||s||a?t.COLLINEAR_INTERSECTION:t.POINT_INTERSECTION):s&&a?(this._intPt[0]=r,this._intPt[1]=e,!r.equals(e)||o||u?t.COLLINEAR_INTERSECTION:t.POINT_INTERSECTION):s&&u?(this._intPt[0]=r,this._intPt[1]=n,!r.equals(n)||o||a?t.COLLINEAR_INTERSECTION:t.POINT_INTERSECTION):t.NO_INTERSECTION},e.prototype.normalizeToEnvCentre=function(t,e,n,i,r){var o=t.x<e.x?t.x:e.x,s=t.y<e.y?t.y:e.y,a=t.x>e.x?t.x:e.x,u=t.y>e.y?t.y:e.y,l=n.x<i.x?n.x:i.x,c=n.y<i.y?n.y:i.y,p=n.x>i.x?n.x:i.x,h=n.y>i.y?n.y:i.y,f=((o>l?o:l)+(a<p?a:p))/2,g=((s>c?s:c)+(u<h?u:h))/2;r.x=f,r.y=g,t.x-=r.x,t.y-=r.y,e.x-=r.x,e.y-=r.y,n.x-=r.x,n.y-=r.y,i.x-=r.x,i.y-=r.y},e.prototype.computeIntersect=function(e,n,i,r){if(this._isProper=!1,!j.intersects(e,n,i,r))return t.NO_INTERSECTION;var o=at.orientationIndex(e,n,i),s=at.orientationIndex(e,n,r);if(o>0&&s>0||o<0&&s<0)return t.NO_INTERSECTION;var a=at.orientationIndex(i,r,e),u=at.orientationIndex(i,r,n);if(a>0&&u>0||a<0&&u<0)return t.NO_INTERSECTION;return 0===o&&0===s&&0===a&&0===u?this.computeCollinearIntersection(e,n,i,r):(0===o||0===s||0===a||0===u?(this._isProper=!1,e.equals2D(i)||e.equals2D(r)?this._intPt[0]=e:n.equals2D(i)||n.equals2D(r)?this._intPt[0]=n:0===o?this._intPt[0]=new C(i):0===s?this._intPt[0]=new C(r):0===a?this._intPt[0]=new C(e):0===u&&(this._intPt[0]=new C(n))):(this._isProper=!0,this._intPt[0]=this.intersection(e,n,i,r)),t.POINT_INTERSECTION)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e.nearestEndpoint=function(t,e,n,i){var r=t,o=at.distancePointLine(t,n,i),s=at.distancePointLine(e,n,i);return s<o&&(o=s,r=e),(s=at.distancePointLine(n,t,e))<o&&(o=s,r=n),(s=at.distancePointLine(i,t,e))<o&&(o=s,r=i),r},e}(nt),ot=function(){};ot.prototype.interfaces_=function(){return[]},ot.prototype.getClass=function(){return ot},ot.orientationIndex=function(t,e,n){var i=e.x-t.x,r=e.y-t.y,o=n.x-e.x,s=n.y-e.y;return ot.signOfDet2x2(i,r,o,s)},ot.signOfDet2x2=function(t,e,n,i){var r=null,o=null,s=null;if(r=1,0===t||0===i)return 0===e||0===n?0:e>0?n>0?-r:r:n>0?r:-r;if(0===e||0===n)return i>0?t>0?r:-r:t>0?-r:r;if(e>0?i>0?e<=i||(r=-r,o=t,t=n,n=o,o=e,e=i,i=o):e<=-i?(r=-r,n=-n,i=-i):(o=t,t=-n,n=o,o=e,e=-i,i=o):i>0?-e<=i?(r=-r,t=-t,e=-e):(o=-t,t=n,n=o,o=-e,e=i,i=o):e>=i?(t=-t,e=-e,n=-n,i=-i):(r=-r,o=-t,t=-n,n=o,o=-e,e=-i,i=o),t>0){if(!(n>0))return r;if(!(t<=n))return r}else{if(n>0)return-r;if(!(t>=n))return-r;r=-r,t=-t,n=-n}for(;;){if(s=Math.floor(n/t),n-=s*t,(i-=s*e)<0)return-r;if(i>e)return r;if(t>n+n){if(e<i+i)return r}else{if(e>i+i)return-r;n=t-n,i=e-i,r=-r}if(0===i)return 0===n?0:-r;if(0===n)return r;if(s=Math.floor(t/n),t-=s*n,(e-=s*i)<0)return r;if(e>i)return-r;if(n>t+t){if(i<e+e)return-r}else{if(i>e+e)return r;t=n-t,e=i-e,r=-r}if(0===e)return 0===t?0:r;if(0===t)return-r}};var st=function(){this._p=null,this._crossingCount=0,this._isPointOnSegment=!1;var t=arguments[0];this._p=t};st.prototype.countSegment=function(t,e){if(t.x<this._p.x&&e.x<this._p.x)return null;if(this._p.x===e.x&&this._p.y===e.y)return this._isPointOnSegment=!0,null;if(t.y===this._p.y&&e.y===this._p.y){var n=t.x,i=e.x;return n>i&&(n=e.x,i=t.x),this._p.x>=n&&this._p.x<=i&&(this._isPointOnSegment=!0),null}if(t.y>this._p.y&&e.y<=this._p.y||e.y>this._p.y&&t.y<=this._p.y){var r=t.x-this._p.x,o=t.y-this._p.y,s=e.x-this._p.x,a=e.y-this._p.y,u=ot.signOfDet2x2(r,o,s,a);if(0===u)return this._isPointOnSegment=!0,null;a<o&&(u=-u),u>0&&this._crossingCount++}},st.prototype.isPointInPolygon=function(){return this.getLocation()!==w.EXTERIOR},st.prototype.getLocation=function(){return this._isPointOnSegment?w.BOUNDARY:this._crossingCount%2==1?w.INTERIOR:w.EXTERIOR},st.prototype.isOnSegment=function(){return this._isPointOnSegment},st.prototype.interfaces_=function(){return[]},st.prototype.getClass=function(){return st},st.locatePointInRing=function(){if(arguments[0]instanceof C&&T(arguments[1],V)){for(var t=arguments[0],e=arguments[1],n=new st(t),i=new C,r=new C,o=1;o<e.size();o++)if(e.getCoordinate(o,i),e.getCoordinate(o-1,r),n.countSegment(i,r),n.isOnSegment())return n.getLocation();return n.getLocation()}if(arguments[0]instanceof C&&arguments[1]instanceof Array){for(var s=arguments[0],a=arguments[1],u=new st(s),l=1;l<a.length;l++){var c=a[l],p=a[l-1];if(u.countSegment(c,p),u.isOnSegment())return u.getLocation()}return u.getLocation()}};var at=function(){},ut={CLOCKWISE:{configurable:!0},RIGHT:{configurable:!0},COUNTERCLOCKWISE:{configurable:!0},LEFT:{configurable:!0},COLLINEAR:{configurable:!0},STRAIGHT:{configurable:!0}};at.prototype.interfaces_=function(){return[]},at.prototype.getClass=function(){return at},at.orientationIndex=function(t,e,n){return q.orientationIndex(t,e,n)},at.signedArea=function(){if(arguments[0]instanceof Array){var t=arguments[0];if(t.length<3)return 0;for(var e=0,n=t[0].x,i=1;i<t.length-1;i++){var r=t[i].x-n,o=t[i+1].y;e+=r*(t[i-1].y-o)}return e/2}if(T(arguments[0],V)){var s=arguments[0],a=s.size();if(a<3)return 0;var u=new C,l=new C,c=new C;s.getCoordinate(0,l),s.getCoordinate(1,c);var p=l.x;c.x-=p;for(var h=0,f=1;f<a-1;f++)u.y=l.y,l.x=c.x,l.y=c.y,s.getCoordinate(f+1,c),c.x-=p,h+=l.x*(u.y-c.y);return h/2}},at.distanceLineLine=function(t,e,n,i){if(t.equals(e))return at.distancePointLine(t,n,i);if(n.equals(i))return at.distancePointLine(i,t,e);var r=!1;if(j.intersects(t,e,n,i)){var o=(e.x-t.x)*(i.y-n.y)-(e.y-t.y)*(i.x-n.x);if(0===o)r=!0;else{var s=(t.y-n.y)*(i.x-n.x)-(t.x-n.x)*(i.y-n.y),a=((t.y-n.y)*(e.x-t.x)-(t.x-n.x)*(e.y-t.y))/o,u=s/o;(u<0||u>1||a<0||a>1)&&(r=!0)}}else r=!0;return r?R.min(at.distancePointLine(t,n,i),at.distancePointLine(e,n,i),at.distancePointLine(n,t,e),at.distancePointLine(i,t,e)):0},at.isPointInRing=function(t,e){return at.locatePointInRing(t,e)!==w.EXTERIOR},at.computeLength=function(t){var e=t.size();if(e<=1)return 0;var n=0,i=new C;t.getCoordinate(0,i);for(var r=i.x,o=i.y,s=1;s<e;s++){t.getCoordinate(s,i);var a=i.x,u=i.y,l=a-r,c=u-o;n+=Math.sqrt(l*l+c*c),r=a,o=u}return n},at.isCCW=function(t){var e=t.length-1;if(e<3)throw new m("Ring has fewer than 4 points, so orientation cannot be determined");for(var n=t[0],i=0,r=1;r<=e;r++){var o=t[r];o.y>n.y&&(n=o,i=r)}var s=i;do{(s-=1)<0&&(s=e)}while(t[s].equals2D(n)&&s!==i);var a=i;do{a=(a+1)%e}while(t[a].equals2D(n)&&a!==i);var u=t[s],l=t[a];if(u.equals2D(n)||l.equals2D(n)||u.equals2D(l))return!1;var c=at.computeOrientation(u,n,l),p=!1;return p=0===c?u.x>l.x:c>0,p},at.locatePointInRing=function(t,e){return st.locatePointInRing(t,e)},at.distancePointLinePerpendicular=function(t,e,n){var i=(n.x-e.x)*(n.x-e.x)+(n.y-e.y)*(n.y-e.y),r=((e.y-t.y)*(n.x-e.x)-(e.x-t.x)*(n.y-e.y))/i;return Math.abs(r)*Math.sqrt(i)},at.computeOrientation=function(t,e,n){return at.orientationIndex(t,e,n)},at.distancePointLine=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];if(0===e.length)throw new m("Line array must contain at least one vertex");for(var n=t.distance(e[0]),i=0;i<e.length-1;i++){var r=at.distancePointLine(t,e[i],e[i+1]);r<n&&(n=r)}return n}if(3===arguments.length){var o=arguments[0],s=arguments[1],a=arguments[2];if(s.x===a.x&&s.y===a.y)return o.distance(s);var u=(a.x-s.x)*(a.x-s.x)+(a.y-s.y)*(a.y-s.y),l=((o.x-s.x)*(a.x-s.x)+(o.y-s.y)*(a.y-s.y))/u;if(l<=0)return o.distance(s);if(l>=1)return o.distance(a);var c=((s.y-o.y)*(a.x-s.x)-(s.x-o.x)*(a.y-s.y))/u;return Math.abs(c)*Math.sqrt(u)}},at.isOnLine=function(t,e){for(var n=new rt,i=1;i<e.length;i++){var r=e[i-1],o=e[i];if(n.computeIntersection(t,r,o),n.hasIntersection())return!0}return!1},ut.CLOCKWISE.get=function(){return-1},ut.RIGHT.get=function(){return at.CLOCKWISE},ut.COUNTERCLOCKWISE.get=function(){return 1},ut.LEFT.get=function(){return at.COUNTERCLOCKWISE},ut.COLLINEAR.get=function(){return 0},ut.STRAIGHT.get=function(){return at.COLLINEAR},Object.defineProperties(at,ut);var lt=function(){};lt.prototype.filter=function(t){},lt.prototype.interfaces_=function(){return[]},lt.prototype.getClass=function(){return lt};var ct=function(){var t=arguments[0];this._envelope=null,this._factory=null,this._SRID=null,this._userData=null,this._factory=t,this._SRID=t.getSRID()},pt={serialVersionUID:{configurable:!0},SORTINDEX_POINT:{configurable:!0},SORTINDEX_MULTIPOINT:{configurable:!0},SORTINDEX_LINESTRING:{configurable:!0},SORTINDEX_LINEARRING:{configurable:!0},SORTINDEX_MULTILINESTRING:{configurable:!0},SORTINDEX_POLYGON:{configurable:!0},SORTINDEX_MULTIPOLYGON:{configurable:!0},SORTINDEX_GEOMETRYCOLLECTION:{configurable:!0},geometryChangedFilter:{configurable:!0}};ct.prototype.isGeometryCollection=function(){return this.getSortIndex()===ct.SORTINDEX_GEOMETRYCOLLECTION},ct.prototype.getFactory=function(){return this._factory},ct.prototype.getGeometryN=function(t){return this},ct.prototype.getArea=function(){return 0},ct.prototype.isRectangle=function(){return!1},ct.prototype.equals=function(){if(arguments[0]instanceof ct){var t=arguments[0];return null!==t&&this.equalsTopo(t)}if(arguments[0]instanceof Object){var e=arguments[0];if(!(e instanceof ct))return!1;var n=e;return this.equalsExact(n)}},ct.prototype.equalsExact=function(t){return this===t||this.equalsExact(t,0)},ct.prototype.geometryChanged=function(){this.apply(ct.geometryChangedFilter)},ct.prototype.geometryChangedAction=function(){this._envelope=null},ct.prototype.equalsNorm=function(t){return null!==t&&this.norm().equalsExact(t.norm())},ct.prototype.getLength=function(){return 0},ct.prototype.getNumGeometries=function(){return 1},ct.prototype.compareTo=function(){if(1===arguments.length){var t=arguments[0],e=t;return this.getSortIndex()!==e.getSortIndex()?this.getSortIndex()-e.getSortIndex():this.isEmpty()&&e.isEmpty()?0:this.isEmpty()?-1:e.isEmpty()?1:this.compareToSameClass(t)}if(2===arguments.length){var n=arguments[0],i=arguments[1];return this.getSortIndex()!==n.getSortIndex()?this.getSortIndex()-n.getSortIndex():this.isEmpty()&&n.isEmpty()?0:this.isEmpty()?-1:n.isEmpty()?1:this.compareToSameClass(n,i)}},ct.prototype.getUserData=function(){return this._userData},ct.prototype.getSRID=function(){return this._SRID},ct.prototype.getEnvelope=function(){return this.getFactory().toGeometry(this.getEnvelopeInternal())},ct.prototype.checkNotGeometryCollection=function(t){if(t.getSortIndex()===ct.SORTINDEX_GEOMETRYCOLLECTION)throw new m("This method does not support GeometryCollection arguments")},ct.prototype.equal=function(t,e,n){return 0===n?t.equals(e):t.distance(e)<=n},ct.prototype.norm=function(){var t=this.copy();return t.normalize(),t},ct.prototype.getPrecisionModel=function(){return this._factory.getPrecisionModel()},ct.prototype.getEnvelopeInternal=function(){return null===this._envelope&&(this._envelope=this.computeEnvelopeInternal()),new j(this._envelope)},ct.prototype.setSRID=function(t){this._SRID=t},ct.prototype.setUserData=function(t){this._userData=t},ct.prototype.compare=function(t,e){for(var n=t.iterator(),i=e.iterator();n.hasNext()&&i.hasNext();){var r=n.next(),o=i.next(),s=r.compareTo(o);if(0!==s)return s}return n.hasNext()?1:i.hasNext()?-1:0},ct.prototype.hashCode=function(){return this.getEnvelopeInternal().hashCode()},ct.prototype.isGeometryCollectionOrDerived=function(){return this.getSortIndex()===ct.SORTINDEX_GEOMETRYCOLLECTION||this.getSortIndex()===ct.SORTINDEX_MULTIPOINT||this.getSortIndex()===ct.SORTINDEX_MULTILINESTRING||this.getSortIndex()===ct.SORTINDEX_MULTIPOLYGON},ct.prototype.interfaces_=function(){return[x,E,e]},ct.prototype.getClass=function(){return ct},ct.hasNonEmptyElements=function(t){for(var e=0;e<t.length;e++)if(!t[e].isEmpty())return!0;return!1},ct.hasNullElements=function(t){for(var e=0;e<t.length;e++)if(null===t[e])return!0;return!1},pt.serialVersionUID.get=function(){return 0x799ea46522854c00},pt.SORTINDEX_POINT.get=function(){return 0},pt.SORTINDEX_MULTIPOINT.get=function(){return 1},pt.SORTINDEX_LINESTRING.get=function(){return 2},pt.SORTINDEX_LINEARRING.get=function(){return 3},pt.SORTINDEX_MULTILINESTRING.get=function(){return 4},pt.SORTINDEX_POLYGON.get=function(){return 5},pt.SORTINDEX_MULTIPOLYGON.get=function(){return 6},pt.SORTINDEX_GEOMETRYCOLLECTION.get=function(){return 7},pt.geometryChangedFilter.get=function(){return ht},Object.defineProperties(ct,pt);var ht=function(){};ht.interfaces_=function(){return[lt]},ht.filter=function(t){t.geometryChangedAction()};var ft=function(){};ft.prototype.filter=function(t){},ft.prototype.interfaces_=function(){return[]},ft.prototype.getClass=function(){return ft};var gt=function(){},dt={Mod2BoundaryNodeRule:{configurable:!0},EndPointBoundaryNodeRule:{configurable:!0},MultiValentEndPointBoundaryNodeRule:{configurable:!0},MonoValentEndPointBoundaryNodeRule:{configurable:!0},MOD2_BOUNDARY_RULE:{configurable:!0},ENDPOINT_BOUNDARY_RULE:{configurable:!0},MULTIVALENT_ENDPOINT_BOUNDARY_RULE:{configurable:!0},MONOVALENT_ENDPOINT_BOUNDARY_RULE:{configurable:!0},OGC_SFS_BOUNDARY_RULE:{configurable:!0}};gt.prototype.isInBoundary=function(t){},gt.prototype.interfaces_=function(){return[]},gt.prototype.getClass=function(){return gt},dt.Mod2BoundaryNodeRule.get=function(){return yt},dt.EndPointBoundaryNodeRule.get=function(){return _t},dt.MultiValentEndPointBoundaryNodeRule.get=function(){return mt},dt.MonoValentEndPointBoundaryNodeRule.get=function(){return vt},dt.MOD2_BOUNDARY_RULE.get=function(){return new yt},dt.ENDPOINT_BOUNDARY_RULE.get=function(){return new _t},dt.MULTIVALENT_ENDPOINT_BOUNDARY_RULE.get=function(){return new mt},dt.MONOVALENT_ENDPOINT_BOUNDARY_RULE.get=function(){return new vt},dt.OGC_SFS_BOUNDARY_RULE.get=function(){return gt.MOD2_BOUNDARY_RULE},Object.defineProperties(gt,dt);var yt=function(){};yt.prototype.isInBoundary=function(t){return t%2==1},yt.prototype.interfaces_=function(){return[gt]},yt.prototype.getClass=function(){return yt};var _t=function(){};_t.prototype.isInBoundary=function(t){return t>0},_t.prototype.interfaces_=function(){return[gt]},_t.prototype.getClass=function(){return _t};var mt=function(){};mt.prototype.isInBoundary=function(t){return t>1},mt.prototype.interfaces_=function(){return[gt]},mt.prototype.getClass=function(){return mt};var vt=function(){};vt.prototype.isInBoundary=function(t){return 1===t},vt.prototype.interfaces_=function(){return[gt]},vt.prototype.getClass=function(){return vt};var It=function(){};It.prototype.add=function(){},It.prototype.addAll=function(){},It.prototype.isEmpty=function(){},It.prototype.iterator=function(){},It.prototype.size=function(){},It.prototype.toArray=function(){},It.prototype.remove=function(){},(n.prototype=new Error).name="IndexOutOfBoundsException";var Et=function(){};Et.prototype.hasNext=function(){},Et.prototype.next=function(){},Et.prototype.remove=function(){};var xt=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(){},e.prototype.set=function(){},e.prototype.isEmpty=function(){},e}(It);(i.prototype=new Error).name="NoSuchElementException";var Nt=function(t){function e(){t.call(this),this.array_=[],arguments[0]instanceof It&&this.addAll(arguments[0])}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.ensureCapacity=function(){},e.prototype.interfaces_=function(){return[t,It]},e.prototype.add=function(t){return 1===arguments.length?this.array_.push(t):this.array_.splice(arguments[0],arguments[1]),!0},e.prototype.clear=function(){this.array_=[]},e.prototype.addAll=function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next());return!0},e.prototype.set=function(t,e){var n=this.array_[t];return this.array_[t]=e,n},e.prototype.iterator=function(){return new Ct(this)},e.prototype.get=function(t){if(t<0||t>=this.size())throw new n;return this.array_[t]},e.prototype.isEmpty=function(){return 0===this.array_.length},e.prototype.size=function(){return this.array_.length},e.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;e<n;e++)t.push(this.array_[e]);return t},e.prototype.remove=function(t){for(var e=!1,n=0,i=this.array_.length;n<i;n++)if(this.array_[n]===t){this.array_.splice(n,1),e=!0;break}return e},e}(xt),Ct=function(t){function e(e){t.call(this),this.arrayList_=e,this.position_=0}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.next=function(){if(this.position_===this.arrayList_.size())throw new i;return this.arrayList_.get(this.position_++)},e.prototype.hasNext=function(){return this.position_<this.arrayList_.size()},e.prototype.set=function(t){return this.arrayList_.set(this.position_-1,t)},e.prototype.remove=function(){this.arrayList_.remove(this.arrayList_.get(this.position_))},e}(Et),St=function(t){function e(){if(t.call(this),0===arguments.length);else if(1===arguments.length){var e=arguments[0];this.ensureCapacity(e.length),this.add(e,!0)}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this.ensureCapacity(n.length),this.add(n,i)}}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={coordArrayType:{configurable:!0}};return n.coordArrayType.get=function(){return new Array(0).fill(null)},e.prototype.getCoordinate=function(t){return this.get(t)},e.prototype.addAll=function(){if(2===arguments.length){for(var e=arguments[0],n=arguments[1],i=!1,r=e.iterator();r.hasNext();)this.add(r.next(),n),i=!0;return i}return t.prototype.addAll.apply(this,arguments)},e.prototype.clone=function(){for(var e=t.prototype.clone.call(this),n=0;n<this.size();n++)e.add(n,this.get(n).copy());return e},e.prototype.toCoordinateArray=function(){return this.toArray(e.coordArrayType)},e.prototype.add=function(){if(1===arguments.length){var e=arguments[0];t.prototype.add.call(this,e)}else if(2===arguments.length){if(arguments[0]instanceof Array&&"boolean"==typeof arguments[1]){var n=arguments[0],i=arguments[1];return this.add(n,i,!0),!0}if(arguments[0]instanceof C&&"boolean"==typeof arguments[1]){var r=arguments[0];if(!arguments[1]&&this.size()>=1){if(this.get(this.size()-1).equals2D(r))return null}t.prototype.add.call(this,r)}else if(arguments[0]instanceof Object&&"boolean"==typeof arguments[1]){var o=arguments[0],s=arguments[1];return this.add(o,s),!0}}else if(3===arguments.length){if("boolean"==typeof arguments[2]&&arguments[0]instanceof Array&&"boolean"==typeof arguments[1]){var a=arguments[0],u=arguments[1];if(arguments[2])for(var l=0;l<a.length;l++)this.add(a[l],u);else for(var c=a.length-1;c>=0;c--)this.add(a[c],u);return!0}if("boolean"==typeof arguments[2]&&Number.isInteger(arguments[0])&&arguments[1]instanceof C){var p=arguments[0],h=arguments[1];if(!arguments[2]){var f=this.size();if(f>0){if(p>0){if(this.get(p-1).equals2D(h))return null}if(p<f){if(this.get(p).equals2D(h))return null}}}t.prototype.add.call(this,p,h)}}else if(4===arguments.length){var g=arguments[0],d=arguments[1],y=arguments[2],_=arguments[3],m=1;y>_&&(m=-1);for(var v=y;v!==_;v+=m)this.add(g[v],d);return!0}},e.prototype.closeRing=function(){this.size()>0&&this.add(new C(this.get(0)),!1)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},Object.defineProperties(e,n),e}(Nt),Lt=function(){},bt={ForwardComparator:{configurable:!0},BidirectionalComparator:{configurable:!0},coordArrayType:{configurable:!0}};bt.ForwardComparator.get=function(){return wt},bt.BidirectionalComparator.get=function(){return Ot},bt.coordArrayType.get=function(){return new Array(0).fill(null)},Lt.prototype.interfaces_=function(){return[]},Lt.prototype.getClass=function(){return Lt},Lt.isRing=function(t){return!(t.length<4)&&!!t[0].equals2D(t[t.length-1])},Lt.ptNotInList=function(t,e){for(var n=0;n<t.length;n++){var i=t[n];if(Lt.indexOf(i,e)<0)return i}return null},Lt.scroll=function(t,e){var n=Lt.indexOf(e,t);if(n<0)return null;var i=new Array(t.length).fill(null);Y.arraycopy(t,n,i,0,t.length-n),Y.arraycopy(t,0,i,t.length-n,n),Y.arraycopy(i,0,t,0,t.length)},Lt.equals=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];if(t===e)return!0;if(null===t||null===e)return!1;if(t.length!==e.length)return!1;for(var n=0;n<t.length;n++)if(!t[n].equals(e[n]))return!1;return!0}if(3===arguments.length){var i=arguments[0],r=arguments[1],o=arguments[2];if(i===r)return!0;if(null===i||null===r)return!1;if(i.length!==r.length)return!1;for(var s=0;s<i.length;s++)if(0!==o.compare(i[s],r[s]))return!1;return!0}},Lt.intersection=function(t,e){for(var n=new St,i=0;i<t.length;i++)e.intersects(t[i])&&n.add(t[i],!0);return n.toCoordinateArray()},Lt.hasRepeatedPoints=function(t){for(var e=1;e<t.length;e++)if(t[e-1].equals(t[e]))return!0;return!1},Lt.removeRepeatedPoints=function(t){if(!Lt.hasRepeatedPoints(t))return t;return new St(t,!1).toCoordinateArray()},Lt.reverse=function(t){for(var e=t.length-1,n=Math.trunc(e/2),i=0;i<=n;i++){var r=t[i];t[i]=t[e-i],t[e-i]=r}},Lt.removeNull=function(t){for(var e=0,n=0;n<t.length;n++)null!==t[n]&&e++;var i=new Array(e).fill(null);if(0===e)return i;for(var r=0,o=0;o<t.length;o++)null!==t[o]&&(i[r++]=t[o]);return i},Lt.copyDeep=function(){if(1===arguments.length){for(var t=arguments[0],e=new Array(t.length).fill(null),n=0;n<t.length;n++)e[n]=new C(t[n]);return e}if(5===arguments.length)for(var i=arguments[0],r=arguments[1],o=arguments[2],s=arguments[3],a=arguments[4],u=0;u<a;u++)o[s+u]=new C(i[r+u])},Lt.isEqualReversed=function(t,e){for(var n=0;n<t.length;n++){var i=t[n],r=e[t.length-n-1];if(0!==i.compareTo(r))return!1}return!0},Lt.envelope=function(t){for(var e=new j,n=0;n<t.length;n++)e.expandToInclude(t[n]);return e},Lt.toCoordinateArray=function(t){return t.toArray(Lt.coordArrayType)},Lt.atLeastNCoordinatesOrNothing=function(t,e){return e.length>=t?e:[]},Lt.indexOf=function(t,e){for(var n=0;n<e.length;n++)if(t.equals(e[n]))return n;return-1},Lt.increasingDirection=function(t){for(var e=0;e<Math.trunc(t.length/2);e++){var n=t.length-1-e,i=t[e].compareTo(t[n]);if(0!==i)return i}return 1},Lt.compare=function(t,e){for(var n=0;n<t.length&&n<e.length;){var i=t[n].compareTo(e[n]);if(0!==i)return i;n++}return n<e.length?-1:n<t.length?1:0},Lt.minCoordinate=function(t){for(var e=null,n=0;n<t.length;n++)(null===e||e.compareTo(t[n])>0)&&(e=t[n]);return e},Lt.extract=function(t,e,n){e=R.clamp(e,0,t.length);var i=(n=R.clamp(n,-1,t.length))-e+1;n<0&&(i=0),e>=t.length&&(i=0),n<e&&(i=0);var r=new Array(i).fill(null);if(0===i)return r;for(var o=0,s=e;s<=n;s++)r[o++]=t[s];return r},Object.defineProperties(Lt,bt);var wt=function(){};wt.prototype.compare=function(t,e){return Lt.compare(t,e)},wt.prototype.interfaces_=function(){return[N]},wt.prototype.getClass=function(){return wt};var Ot=function(){};Ot.prototype.compare=function(t,e){var n=t,i=e;if(n.length<i.length)return-1;if(n.length>i.length)return 1;if(0===n.length)return 0;var r=Lt.compare(n,i);return Lt.isEqualReversed(n,i)?0:r},Ot.prototype.OLDcompare=function(t,e){var n=t,i=e;if(n.length<i.length)return-1;if(n.length>i.length)return 1;if(0===n.length)return 0;for(var r=Lt.increasingDirection(n),o=Lt.increasingDirection(i),s=r>0?0:n.length-1,a=o>0?0:n.length-1,u=0;u<n.length;u++){var l=n[s].compareTo(i[a]);if(0!==l)return l;s+=r,a+=o}return 0},Ot.prototype.interfaces_=function(){return[N]},Ot.prototype.getClass=function(){return Ot};var Tt=function(){};Tt.prototype.get=function(){},Tt.prototype.put=function(){},Tt.prototype.size=function(){},Tt.prototype.values=function(){},Tt.prototype.entrySet=function(){};var Rt=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Tt);(r.prototype=new Error).name="OperationNotSupported",(o.prototype=new It).contains=function(){};var Pt=function(t){function e(){t.call(this),this.array_=[],arguments[0]instanceof It&&this.addAll(arguments[0])}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.contains=function(t){for(var e=0,n=this.array_.length;e<n;e++){if(this.array_[e]===t)return!0}return!1},e.prototype.add=function(t){return!this.contains(t)&&(this.array_.push(t),!0)},e.prototype.addAll=function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next());return!0},e.prototype.remove=function(t){throw new Error},e.prototype.size=function(){return this.array_.length},e.prototype.isEmpty=function(){return 0===this.array_.length},e.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;e<n;e++)t.push(this.array_[e]);return t},e.prototype.iterator=function(){return new Dt(this)},e}(o),Dt=function(t){function e(e){t.call(this),this.hashSet_=e,this.position_=0}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.next=function(){if(this.position_===this.hashSet_.size())throw new i;return this.hashSet_.array_[this.position_++]},e.prototype.hasNext=function(){return this.position_<this.hashSet_.size()},e.prototype.remove=function(){throw new r},e}(Et),Mt=0;(p.prototype=new Rt).get=function(t){for(var e=this.root_;null!==e;){var n=t.compareTo(e.key);if(n<0)e=e.left;else{if(!(n>0))return e.value;e=e.right}}return null},p.prototype.put=function(t,e){if(null===this.root_)return this.root_={key:t,value:e,left:null,right:null,parent:null,color:Mt,getValue:function(){return this.value},getKey:function(){return this.key}},this.size_=1,null;var n,i,r=this.root_;do{if(n=r,(i=t.compareTo(r.key))<0)r=r.left;else{if(!(i>0)){var o=r.value;return r.value=e,o}r=r.right}}while(null!==r);var s={key:t,left:null,right:null,value:e,parent:n,color:Mt,getValue:function(){return this.value},getKey:function(){return this.key}};return i<0?n.left=s:n.right=s,this.fixAfterInsertion(s),this.size_++,null},p.prototype.fixAfterInsertion=function(t){for(t.color=1;null!=t&&t!==this.root_&&1===t.parent.color;)if(a(t)===l(a(a(t)))){var e=c(a(a(t)));1===s(e)?(u(a(t),Mt),u(e,Mt),u(a(a(t)),1),t=a(a(t))):(t===c(a(t))&&(t=a(t),this.rotateLeft(t)),u(a(t),Mt),u(a(a(t)),1),this.rotateRight(a(a(t))))}else{var n=l(a(a(t)));1===s(n)?(u(a(t),Mt),u(n,Mt),u(a(a(t)),1),t=a(a(t))):(t===l(a(t))&&(t=a(t),this.rotateRight(t)),u(a(t),Mt),u(a(a(t)),1),this.rotateLeft(a(a(t))))}this.root_.color=Mt},p.prototype.values=function(){var t=new Nt,e=this.getFirstEntry();if(null!==e)for(t.add(e.value);null!==(e=p.successor(e));)t.add(e.value);return t},p.prototype.entrySet=function(){var t=new Pt,e=this.getFirstEntry();if(null!==e)for(t.add(e);null!==(e=p.successor(e));)t.add(e);return t},p.prototype.rotateLeft=function(t){if(null!=t){var e=t.right;t.right=e.left,null!=e.left&&(e.left.parent=t),e.parent=t.parent,null===t.parent?this.root_=e:t.parent.left===t?t.parent.left=e:t.parent.right=e,e.left=t,t.parent=e}},p.prototype.rotateRight=function(t){if(null!=t){var e=t.left;t.left=e.right,null!=e.right&&(e.right.parent=t),e.parent=t.parent,null===t.parent?this.root_=e:t.parent.right===t?t.parent.right=e:t.parent.left=e,e.right=t,t.parent=e}},p.prototype.getFirstEntry=function(){var t=this.root_;if(null!=t)for(;null!=t.left;)t=t.left;return t},p.successor=function(t){if(null===t)return null;if(null!==t.right){for(var e=t.right;null!==e.left;)e=e.left;return e}for(var n=t.parent,i=t;null!==n&&i===n.right;)i=n,n=n.parent;return n},p.prototype.size=function(){return this.size_};var At=function(){};At.prototype.interfaces_=function(){return[]},At.prototype.getClass=function(){return At},h.prototype=new o,(f.prototype=new h).contains=function(t){for(var e=0,n=this.array_.length;e<n;e++){if(0===this.array_[e].compareTo(t))return!0}return!1},f.prototype.add=function(t){if(this.contains(t))return!1;for(var e=0,n=this.array_.length;e<n;e++){if(1===this.array_[e].compareTo(t))return this.array_.splice(e,0,t),!0}return this.array_.push(t),!0},f.prototype.addAll=function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next());return!0},f.prototype.remove=function(t){throw new r},f.prototype.size=function(){return this.array_.length},f.prototype.isEmpty=function(){return 0===this.array_.length},f.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;e<n;e++)t.push(this.array_[e]);return t},f.prototype.iterator=function(){return new Ft(this)};var Ft=function(t){this.treeSet_=t,this.position_=0};Ft.prototype.next=function(){if(this.position_===this.treeSet_.size())throw new i;return this.treeSet_.array_[this.position_++]},Ft.prototype.hasNext=function(){return this.position_<this.treeSet_.size()},Ft.prototype.remove=function(){throw new r};var Gt=function(){};Gt.sort=function(){var t,e,n,i,r=arguments[0];if(1===arguments.length)i=function(t,e){return t.compareTo(e)},r.sort(i);else if(2===arguments.length)n=arguments[1],i=function(t,e){return n.compare(t,e)},r.sort(i);else if(3===arguments.length){(e=r.slice(arguments[1],arguments[2])).sort();var o=r.slice(0,arguments[1]).concat(e,r.slice(arguments[2],r.length));for(r.splice(0,r.length),t=0;t<o.length;t++)r.push(o[t])}else if(4===arguments.length)for(e=r.slice(arguments[1],arguments[2]),n=arguments[3],i=function(t,e){return n.compare(t,e)},e.sort(i),o=r.slice(0,arguments[1]).concat(e,r.slice(arguments[2],r.length)),r.splice(0,r.length),t=0;t<o.length;t++)r.push(o[t])},Gt.asList=function(t){for(var e=new Nt,n=0,i=t.length;n<i;n++)e.add(t[n]);return e};var qt=function(){},Bt={P:{configurable:!0},L:{configurable:!0},A:{configurable:!0},FALSE:{configurable:!0},TRUE:{configurable:!0},DONTCARE:{configurable:!0},SYM_FALSE:{configurable:!0},SYM_TRUE:{configurable:!0},SYM_DONTCARE:{configurable:!0},SYM_P:{configurable:!0},SYM_L:{configurable:!0},SYM_A:{configurable:!0}};Bt.P.get=function(){return 0},Bt.L.get=function(){return 1},Bt.A.get=function(){return 2},Bt.FALSE.get=function(){return-1},Bt.TRUE.get=function(){return-2},Bt.DONTCARE.get=function(){return-3},Bt.SYM_FALSE.get=function(){return"F"},Bt.SYM_TRUE.get=function(){return"T"},Bt.SYM_DONTCARE.get=function(){return"*"},Bt.SYM_P.get=function(){return"0"},Bt.SYM_L.get=function(){return"1"},Bt.SYM_A.get=function(){return"2"},qt.prototype.interfaces_=function(){return[]},qt.prototype.getClass=function(){return qt},qt.toDimensionSymbol=function(t){switch(t){case qt.FALSE:return qt.SYM_FALSE;case qt.TRUE:return qt.SYM_TRUE;case qt.DONTCARE:return qt.SYM_DONTCARE;case qt.P:return qt.SYM_P;case qt.L:return qt.SYM_L;case qt.A:return qt.SYM_A}throw new m("Unknown dimension value: "+t)},qt.toDimensionValue=function(t){switch(A.toUpperCase(t)){case qt.SYM_FALSE:return qt.FALSE;case qt.SYM_TRUE:return qt.TRUE;case qt.SYM_DONTCARE:return qt.DONTCARE;case qt.SYM_P:return qt.P;case qt.SYM_L:return qt.L;case qt.SYM_A:return qt.A}throw new m("Unknown dimension symbol: "+t)},Object.defineProperties(qt,Bt);var Vt=function(){};Vt.prototype.filter=function(t){},Vt.prototype.interfaces_=function(){return[]},Vt.prototype.getClass=function(){return Vt};var Ut=function(){};Ut.prototype.filter=function(t,e){},Ut.prototype.isDone=function(){},Ut.prototype.isGeometryChanged=function(){},Ut.prototype.interfaces_=function(){return[]},Ut.prototype.getClass=function(){return Ut};var zt=function(t){function e(e,n){if(t.call(this,n),this._geometries=e||[],t.hasNullElements(this._geometries))throw new m("geometries must not contain null elements")}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.computeEnvelopeInternal=function(){for(var t=new j,e=0;e<this._geometries.length;e++)t.expandToInclude(this._geometries[e].getEnvelopeInternal());return t},e.prototype.getGeometryN=function(t){return this._geometries[t]},e.prototype.getSortIndex=function(){return t.SORTINDEX_GEOMETRYCOLLECTION},e.prototype.getCoordinates=function(){for(var t=new Array(this.getNumPoints()).fill(null),e=-1,n=0;n<this._geometries.length;n++)for(var i=this._geometries[n].getCoordinates(),r=0;r<i.length;r++)t[++e]=i[r];return t},e.prototype.getArea=function(){for(var t=0,e=0;e<this._geometries.length;e++)t+=this._geometries[e].getArea();return t},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];if(!this.isEquivalentClass(e))return!1;var i=e;if(this._geometries.length!==i._geometries.length)return!1;for(var r=0;r<this._geometries.length;r++)if(!this._geometries[r].equalsExact(i._geometries[r],n))return!1;return!0}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.normalize=function(){for(var t=0;t<this._geometries.length;t++)this._geometries[t].normalize();Gt.sort(this._geometries)},e.prototype.getCoordinate=function(){return this.isEmpty()?null:this._geometries[0].getCoordinate()},e.prototype.getBoundaryDimension=function(){for(var t=qt.FALSE,e=0;e<this._geometries.length;e++)t=Math.max(t,this._geometries[e].getBoundaryDimension());return t},e.prototype.getDimension=function(){for(var t=qt.FALSE,e=0;e<this._geometries.length;e++)t=Math.max(t,this._geometries[e].getDimension());return t},e.prototype.getLength=function(){for(var t=0,e=0;e<this._geometries.length;e++)t+=this._geometries[e].getLength();return t},e.prototype.getNumPoints=function(){for(var t=0,e=0;e<this._geometries.length;e++)t+=this._geometries[e].getNumPoints();return t},e.prototype.getNumGeometries=function(){return this._geometries.length},e.prototype.reverse=function(){for(var t=this._geometries.length,e=new Array(t).fill(null),n=0;n<this._geometries.length;n++)e[n]=this._geometries[n].reverse();return this.getFactory().createGeometryCollection(e)},e.prototype.compareToSameClass=function(){if(1===arguments.length){var t=arguments[0],e=new f(Gt.asList(this._geometries)),n=new f(Gt.asList(t._geometries));return this.compare(e,n)}if(2===arguments.length){for(var i=arguments[0],r=arguments[1],o=i,s=this.getNumGeometries(),a=o.getNumGeometries(),u=0;u<s&&u<a;){var l=this.getGeometryN(u),c=o.getGeometryN(u),p=l.compareToSameClass(c,r);if(0!==p)return p;u++}return u<s?1:u<a?-1:0}},e.prototype.apply=function(){if(T(arguments[0],ft))for(var t=arguments[0],e=0;e<this._geometries.length;e++)this._geometries[e].apply(t);else if(T(arguments[0],Ut)){var n=arguments[0];if(0===this._geometries.length)return null;for(var i=0;i<this._geometries.length&&(this._geometries[i].apply(n),!n.isDone());i++);n.isGeometryChanged()&&this.geometryChanged()}else if(T(arguments[0],Vt)){var r=arguments[0];r.filter(this);for(var o=0;o<this._geometries.length;o++)this._geometries[o].apply(r)}else if(T(arguments[0],lt)){var s=arguments[0];s.filter(this);for(var a=0;a<this._geometries.length;a++)this._geometries[a].apply(s)}},e.prototype.getBoundary=function(){return this.checkNotGeometryCollection(this),et.shouldNeverReachHere(),null},e.prototype.clone=function(){var e=t.prototype.clone.call(this);e._geometries=new Array(this._geometries.length).fill(null);for(var n=0;n<this._geometries.length;n++)e._geometries[n]=this._geometries[n].clone();return e},e.prototype.getGeometryType=function(){return"GeometryCollection"},e.prototype.copy=function(){for(var t=new Array(this._geometries.length).fill(null),n=0;n<t.length;n++)t[n]=this._geometries[n].copy();return new e(t,this._factory)},e.prototype.isEmpty=function(){for(var t=0;t<this._geometries.length;t++)if(!this._geometries[t].isEmpty())return!1;return!0},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return-0x4f07bcb1f857d800},Object.defineProperties(e,n),e}(ct),Xt=function(t){function e(){t.apply(this,arguments)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.getSortIndex=function(){return ct.SORTINDEX_MULTILINESTRING},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];return!!this.isEquivalentClass(e)&&t.prototype.equalsExact.call(this,e,n)}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.getBoundaryDimension=function(){return this.isClosed()?qt.FALSE:0},e.prototype.isClosed=function(){if(this.isEmpty())return!1;for(var t=0;t<this._geometries.length;t++)if(!this._geometries[t].isClosed())return!1;return!0},e.prototype.getDimension=function(){return 1},e.prototype.reverse=function(){for(var t=this._geometries.length,e=new Array(t).fill(null),n=0;n<this._geometries.length;n++)e[t-1-n]=this._geometries[n].reverse();return this.getFactory().createMultiLineString(e)},e.prototype.getBoundary=function(){return new Yt(this).getBoundary()},e.prototype.getGeometryType=function(){return"MultiLineString"},e.prototype.copy=function(){for(var t=new Array(this._geometries.length).fill(null),n=0;n<t.length;n++)t[n]=this._geometries[n].copy();return new e(t,this._factory)},e.prototype.interfaces_=function(){return[At]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return 0x7155d2ab4afa8000},Object.defineProperties(e,n),e}(zt),Yt=function(){if(this._geom=null,this._geomFact=null,this._bnRule=null,this._endpointMap=null,1===arguments.length){var t=arguments[0],e=gt.MOD2_BOUNDARY_RULE;this._geom=t,this._geomFact=t.getFactory(),this._bnRule=e}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this._geom=n,this._geomFact=n.getFactory(),this._bnRule=i}};Yt.prototype.boundaryMultiLineString=function(t){if(this._geom.isEmpty())return this.getEmptyMultiPoint();var e=this.computeBoundaryCoordinates(t);return 1===e.length?this._geomFact.createPoint(e[0]):this._geomFact.createMultiPointFromCoords(e)},Yt.prototype.getBoundary=function(){return this._geom instanceof Kt?this.boundaryLineString(this._geom):this._geom instanceof Xt?this.boundaryMultiLineString(this._geom):this._geom.getBoundary()},Yt.prototype.boundaryLineString=function(t){if(this._geom.isEmpty())return this.getEmptyMultiPoint();if(t.isClosed()){return this._bnRule.isInBoundary(2)?t.getStartPoint():this._geomFact.createMultiPoint()}return this._geomFact.createMultiPoint([t.getStartPoint(),t.getEndPoint()])},Yt.prototype.getEmptyMultiPoint=function(){return this._geomFact.createMultiPoint()},Yt.prototype.computeBoundaryCoordinates=function(t){var e=new Nt;this._endpointMap=new p;for(var n=0;n<t.getNumGeometries();n++){var i=t.getGeometryN(n);0!==i.getNumPoints()&&(this.addEndpoint(i.getCoordinateN(0)),this.addEndpoint(i.getCoordinateN(i.getNumPoints()-1)))}for(var r=this._endpointMap.entrySet().iterator();r.hasNext();){var o=r.next(),s=o.getValue().count;this._bnRule.isInBoundary(s)&&e.add(o.getKey())}return Lt.toCoordinateArray(e)},Yt.prototype.addEndpoint=function(t){var e=this._endpointMap.get(t);null===e&&(e=new kt,this._endpointMap.put(t,e)),e.count++},Yt.prototype.interfaces_=function(){return[]},Yt.prototype.getClass=function(){return Yt},Yt.getBoundary=function(){if(1===arguments.length){var t=arguments[0];return new Yt(t).getBoundary()}if(2===arguments.length){var e=arguments[0],n=arguments[1];return new Yt(e,n).getBoundary()}};var kt=function(){this.count=null};kt.prototype.interfaces_=function(){return[]},kt.prototype.getClass=function(){return kt};var jt=function(){},Ht={NEWLINE:{configurable:!0},SIMPLE_ORDINATE_FORMAT:{configurable:!0}};jt.prototype.interfaces_=function(){return[]},jt.prototype.getClass=function(){return jt},jt.chars=function(t,e){for(var n=new Array(e).fill(null),i=0;i<e;i++)n[i]=t;return String(n)},jt.getStackTrace=function(){if(1===arguments.length){var t=arguments[0],e=new function(){},n=new function(){}(e);return t.printStackTrace(n),e.toString()}if(2===arguments.length){for(var i=arguments[0],r=arguments[1],o="",s=new function(){}(new function(){}(jt.getStackTrace(i))),a=0;a<r;a++)try{o+=s.readLine()+jt.NEWLINE}catch(t){if(!(t instanceof g))throw t;et.shouldNeverReachHere()}return o}},jt.split=function(t,e){for(var n=e.length,i=new Nt,r=""+t,o=r.indexOf(e);o>=0;){var s=r.substring(0,o);i.add(s),o=(r=r.substring(o+n)).indexOf(e)}r.length>0&&i.add(r);for(var a=new Array(i.size()).fill(null),u=0;u<a.length;u++)a[u]=i.get(u);return a},jt.toString=function(){if(1===arguments.length){var t=arguments[0];return jt.SIMPLE_ORDINATE_FORMAT.format(t)}},jt.spaces=function(t){return jt.chars(" ",t)},Ht.NEWLINE.get=function(){return Y.getProperty("line.separator")},Ht.SIMPLE_ORDINATE_FORMAT.get=function(){return new function(){}("0.#")},Object.defineProperties(jt,Ht);var Wt=function(){};Wt.prototype.interfaces_=function(){return[]},Wt.prototype.getClass=function(){return Wt},Wt.copyCoord=function(t,e,n,i){for(var r=Math.min(t.getDimension(),n.getDimension()),o=0;o<r;o++)n.setOrdinate(i,o,t.getOrdinate(e,o))},Wt.isRing=function(t){var e=t.size();return 0===e||!(e<=3)&&(t.getOrdinate(0,V.X)===t.getOrdinate(e-1,V.X)&&t.getOrdinate(0,V.Y)===t.getOrdinate(e-1,V.Y))},Wt.isEqual=function(t,e){var n=t.size();if(n!==e.size())return!1;for(var i=Math.min(t.getDimension(),e.getDimension()),r=0;r<n;r++)for(var o=0;o<i;o++){var s=t.getOrdinate(r,o),a=e.getOrdinate(r,o);if(t.getOrdinate(r,o)!==e.getOrdinate(r,o)&&(!v.isNaN(s)||!v.isNaN(a)))return!1}return!0},Wt.extend=function(t,e,n){var i=t.create(n,e.getDimension()),r=e.size();if(Wt.copy(e,0,i,0,r),r>0)for(var o=r;o<n;o++)Wt.copy(e,r-1,i,o,1);return i},Wt.reverse=function(t){for(var e=t.size()-1,n=Math.trunc(e/2),i=0;i<=n;i++)Wt.swap(t,i,e-i)},Wt.swap=function(t,e,n){if(e===n)return null;for(var i=0;i<t.getDimension();i++){var r=t.getOrdinate(e,i);t.setOrdinate(e,i,t.getOrdinate(n,i)),t.setOrdinate(n,i,r)}},Wt.copy=function(t,e,n,i,r){for(var o=0;o<r;o++)Wt.copyCoord(t,e+o,n,i+o)},Wt.toString=function(){if(1===arguments.length){var t=arguments[0],e=t.size();if(0===e)return"()";var n=t.getDimension(),i=new D;i.append("(");for(var r=0;r<e;r++){r>0&&i.append(" ");for(var o=0;o<n;o++)o>0&&i.append(","),i.append(jt.toString(t.getOrdinate(r,o)))}return i.append(")"),i.toString()}},Wt.ensureValidRing=function(t,e){var n=e.size();if(0===n)return e;if(n<=3)return Wt.createClosedRing(t,e,4);return e.getOrdinate(0,V.X)===e.getOrdinate(n-1,V.X)&&e.getOrdinate(0,V.Y)===e.getOrdinate(n-1,V.Y)?e:Wt.createClosedRing(t,e,n+1)},Wt.createClosedRing=function(t,e,n){var i=t.create(n,e.getDimension()),r=e.size();Wt.copy(e,0,i,0,r);for(var o=r;o<n;o++)Wt.copy(e,0,i,o,1);return i};var Kt=function(t){function e(e,n){t.call(this,n),this._points=null,this.init(e)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.computeEnvelopeInternal=function(){return this.isEmpty()?new j:this._points.expandEnvelope(new j)},e.prototype.isRing=function(){return this.isClosed()&&this.isSimple()},e.prototype.getSortIndex=function(){return t.SORTINDEX_LINESTRING},e.prototype.getCoordinates=function(){return this._points.toCoordinateArray()},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];if(!this.isEquivalentClass(e))return!1;var i=e;if(this._points.size()!==i._points.size())return!1;for(var r=0;r<this._points.size();r++)if(!this.equal(this._points.getCoordinate(r),i._points.getCoordinate(r),n))return!1;return!0}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.normalize=function(){for(var t=0;t<Math.trunc(this._points.size()/2);t++){var e=this._points.size()-1-t;if(!this._points.getCoordinate(t).equals(this._points.getCoordinate(e)))return this._points.getCoordinate(t).compareTo(this._points.getCoordinate(e))>0&&Wt.reverse(this._points),null}},e.prototype.getCoordinate=function(){return this.isEmpty()?null:this._points.getCoordinate(0)},e.prototype.getBoundaryDimension=function(){return this.isClosed()?qt.FALSE:0},e.prototype.isClosed=function(){return!this.isEmpty()&&this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints()-1))},e.prototype.getEndPoint=function(){return this.isEmpty()?null:this.getPointN(this.getNumPoints()-1)},e.prototype.getDimension=function(){return 1},e.prototype.getLength=function(){return at.computeLength(this._points)},e.prototype.getNumPoints=function(){return this._points.size()},e.prototype.reverse=function(){var t=this._points.copy();Wt.reverse(t);return this.getFactory().createLineString(t)},e.prototype.compareToSameClass=function(){if(1===arguments.length){for(var t=arguments[0],e=0,n=0;e<this._points.size()&&n<t._points.size();){var i=this._points.getCoordinate(e).compareTo(t._points.getCoordinate(n));if(0!==i)return i;e++,n++}return e<this._points.size()?1:n<t._points.size()?-1:0}if(2===arguments.length){var r=arguments[0];return arguments[1].compare(this._points,r._points)}},e.prototype.apply=function(){if(T(arguments[0],ft))for(var t=arguments[0],e=0;e<this._points.size();e++)t.filter(this._points.getCoordinate(e));else if(T(arguments[0],Ut)){var n=arguments[0];if(0===this._points.size())return null;for(var i=0;i<this._points.size()&&(n.filter(this._points,i),!n.isDone());i++);n.isGeometryChanged()&&this.geometryChanged()}else if(T(arguments[0],Vt)){arguments[0].filter(this)}else if(T(arguments[0],lt)){arguments[0].filter(this)}},e.prototype.getBoundary=function(){return new Yt(this).getBoundary()},e.prototype.isEquivalentClass=function(t){return t instanceof e},e.prototype.clone=function(){var e=t.prototype.clone.call(this);return e._points=this._points.clone(),e},e.prototype.getCoordinateN=function(t){return this._points.getCoordinate(t)},e.prototype.getGeometryType=function(){return"LineString"},e.prototype.copy=function(){return new e(this._points.copy(),this._factory)},e.prototype.getCoordinateSequence=function(){return this._points},e.prototype.isEmpty=function(){return 0===this._points.size()},e.prototype.init=function(t){if(null===t&&(t=this.getFactory().getCoordinateSequenceFactory().create([])),1===t.size())throw new m("Invalid number of points in LineString (found "+t.size()+" - must be 0 or >= 2)");this._points=t},e.prototype.isCoordinate=function(t){for(var e=0;e<this._points.size();e++)if(this._points.getCoordinate(e).equals(t))return!0;return!1},e.prototype.getStartPoint=function(){return this.isEmpty()?null:this.getPointN(0)},e.prototype.getPointN=function(t){return this.getFactory().createPoint(this._points.getCoordinate(t))},e.prototype.interfaces_=function(){return[At]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return 0x2b2b51ba435c8e00},Object.defineProperties(e,n),e}(ct),Jt=function(){};Jt.prototype.interfaces_=function(){return[]},Jt.prototype.getClass=function(){return Jt};var Qt=function(t){function e(e,n){t.call(this,n),this._coordinates=e||null,this.init(this._coordinates)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.computeEnvelopeInternal=function(){if(this.isEmpty())return new j;var t=new j;return t.expandToInclude(this._coordinates.getX(0),this._coordinates.getY(0)),t},e.prototype.getSortIndex=function(){return t.SORTINDEX_POINT},e.prototype.getCoordinates=function(){return this.isEmpty()?[]:[this.getCoordinate()]},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];return!!this.isEquivalentClass(e)&&(!(!this.isEmpty()||!e.isEmpty())||this.isEmpty()===e.isEmpty()&&this.equal(e.getCoordinate(),this.getCoordinate(),n))}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.normalize=function(){},e.prototype.getCoordinate=function(){return 0!==this._coordinates.size()?this._coordinates.getCoordinate(0):null},e.prototype.getBoundaryDimension=function(){return qt.FALSE},e.prototype.getDimension=function(){return 0},e.prototype.getNumPoints=function(){return this.isEmpty()?0:1},e.prototype.reverse=function(){return this.copy()},e.prototype.getX=function(){if(null===this.getCoordinate())throw new Error("getX called on empty Point");return this.getCoordinate().x},e.prototype.compareToSameClass=function(){if(1===arguments.length){var t=arguments[0];return this.getCoordinate().compareTo(t.getCoordinate())}if(2===arguments.length){var e=arguments[0];return arguments[1].compare(this._coordinates,e._coordinates)}},e.prototype.apply=function(){if(T(arguments[0],ft)){var t=arguments[0];if(this.isEmpty())return null;t.filter(this.getCoordinate())}else if(T(arguments[0],Ut)){var e=arguments[0];if(this.isEmpty())return null;e.filter(this._coordinates,0),e.isGeometryChanged()&&this.geometryChanged()}else if(T(arguments[0],Vt)){arguments[0].filter(this)}else if(T(arguments[0],lt)){arguments[0].filter(this)}},e.prototype.getBoundary=function(){return this.getFactory().createGeometryCollection(null)},e.prototype.clone=function(){var e=t.prototype.clone.call(this);return e._coordinates=this._coordinates.clone(),e},e.prototype.getGeometryType=function(){return"Point"},e.prototype.copy=function(){return new e(this._coordinates.copy(),this._factory)},e.prototype.getCoordinateSequence=function(){return this._coordinates},e.prototype.getY=function(){if(null===this.getCoordinate())throw new Error("getY called on empty Point");return this.getCoordinate().y},e.prototype.isEmpty=function(){return 0===this._coordinates.size()},e.prototype.init=function(t){null===t&&(t=this.getFactory().getCoordinateSequenceFactory().create([])),et.isTrue(t.size()<=1),this._coordinates=t},e.prototype.isSimple=function(){return!0},e.prototype.interfaces_=function(){return[Jt]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return 0x44077bad161cbc00},Object.defineProperties(e,n),e}(ct),Zt=function(){};Zt.prototype.interfaces_=function(){return[]},Zt.prototype.getClass=function(){return Zt};var $t=function(t){function e(e,n,i){if(t.call(this,i),this._shell=null,this._holes=null,null===e&&(e=this.getFactory().createLinearRing()),null===n&&(n=[]),t.hasNullElements(n))throw new m("holes must not contain null elements");if(e.isEmpty()&&t.hasNonEmptyElements(n))throw new m("shell is empty but holes are not");this._shell=e,this._holes=n}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.computeEnvelopeInternal=function(){return this._shell.getEnvelopeInternal()},e.prototype.getSortIndex=function(){return t.SORTINDEX_POLYGON},e.prototype.getCoordinates=function(){if(this.isEmpty())return[];for(var t=new Array(this.getNumPoints()).fill(null),e=-1,n=this._shell.getCoordinates(),i=0;i<n.length;i++)t[++e]=n[i];for(var r=0;r<this._holes.length;r++)for(var o=this._holes[r].getCoordinates(),s=0;s<o.length;s++)t[++e]=o[s];return t},e.prototype.getArea=function(){var t=0;t+=Math.abs(at.signedArea(this._shell.getCoordinateSequence()));for(var e=0;e<this._holes.length;e++)t-=Math.abs(at.signedArea(this._holes[e].getCoordinateSequence()));return t},e.prototype.isRectangle=function(){if(0!==this.getNumInteriorRing())return!1;if(null===this._shell)return!1;if(5!==this._shell.getNumPoints())return!1;for(var t=this._shell.getCoordinateSequence(),e=this.getEnvelopeInternal(),n=0;n<5;n++){var i=t.getX(n);if(i!==e.getMinX()&&i!==e.getMaxX())return!1;var r=t.getY(n);if(r!==e.getMinY()&&r!==e.getMaxY())return!1}for(var o=t.getX(0),s=t.getY(0),a=1;a<=4;a++){var u=t.getX(a),l=t.getY(a);if(u!==o===(l!==s))return!1;o=u,s=l}return!0},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];if(!this.isEquivalentClass(e))return!1;var i=e,r=this._shell,o=i._shell;if(!r.equalsExact(o,n))return!1;if(this._holes.length!==i._holes.length)return!1;for(var s=0;s<this._holes.length;s++)if(!this._holes[s].equalsExact(i._holes[s],n))return!1;return!0}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.normalize=function(){if(0===arguments.length){this.normalize(this._shell,!0);for(var t=0;t<this._holes.length;t++)this.normalize(this._holes[t],!1);Gt.sort(this._holes)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(e.isEmpty())return null;var i=new Array(e.getCoordinates().length-1).fill(null);Y.arraycopy(e.getCoordinates(),0,i,0,i.length);var r=Lt.minCoordinate(e.getCoordinates());Lt.scroll(i,r),Y.arraycopy(i,0,e.getCoordinates(),0,i.length),e.getCoordinates()[i.length]=i[0],at.isCCW(e.getCoordinates())===n&&Lt.reverse(e.getCoordinates())}},e.prototype.getCoordinate=function(){return this._shell.getCoordinate()},e.prototype.getNumInteriorRing=function(){return this._holes.length},e.prototype.getBoundaryDimension=function(){return 1},e.prototype.getDimension=function(){return 2},e.prototype.getLength=function(){var t=0;t+=this._shell.getLength();for(var e=0;e<this._holes.length;e++)t+=this._holes[e].getLength();return t},e.prototype.getNumPoints=function(){for(var t=this._shell.getNumPoints(),e=0;e<this._holes.length;e++)t+=this._holes[e].getNumPoints();return t},e.prototype.reverse=function(){var t=this.copy();t._shell=this._shell.copy().reverse(),t._holes=new Array(this._holes.length).fill(null);for(var e=0;e<this._holes.length;e++)t._holes[e]=this._holes[e].copy().reverse();return t},e.prototype.convexHull=function(){return this.getExteriorRing().convexHull()},e.prototype.compareToSameClass=function(){if(1===arguments.length){var t=arguments[0],e=this._shell,n=t._shell;return e.compareToSameClass(n)}if(2===arguments.length){var i=arguments[0],r=arguments[1],o=i,s=this._shell,a=o._shell,u=s.compareToSameClass(a,r);if(0!==u)return u;for(var l=this.getNumInteriorRing(),c=o.getNumInteriorRing(),p=0;p<l&&p<c;){var h=this.getInteriorRingN(p),f=o.getInteriorRingN(p),g=h.compareToSameClass(f,r);if(0!==g)return g;p++}return p<l?1:p<c?-1:0}},e.prototype.apply=function(t){if(T(t,ft)){this._shell.apply(t);for(var e=0;e<this._holes.length;e++)this._holes[e].apply(t)}else if(T(t,Ut)){if(this._shell.apply(t),!t.isDone())for(var n=0;n<this._holes.length&&(this._holes[n].apply(t),!t.isDone());n++);t.isGeometryChanged()&&this.geometryChanged()}else if(T(t,Vt))t.filter(this);else if(T(t,lt)){t.filter(this),this._shell.apply(t);for(var i=0;i<this._holes.length;i++)this._holes[i].apply(t)}},e.prototype.getBoundary=function(){if(this.isEmpty())return this.getFactory().createMultiLineString();var t=new Array(this._holes.length+1).fill(null);t[0]=this._shell;for(var e=0;e<this._holes.length;e++)t[e+1]=this._holes[e];return t.length<=1?this.getFactory().createLinearRing(t[0].getCoordinateSequence()):this.getFactory().createMultiLineString(t)},e.prototype.clone=function(){var e=t.prototype.clone.call(this);e._shell=this._shell.clone(),e._holes=new Array(this._holes.length).fill(null);for(var n=0;n<this._holes.length;n++)e._holes[n]=this._holes[n].clone();return e},e.prototype.getGeometryType=function(){return"Polygon"},e.prototype.copy=function(){for(var t=this._shell.copy(),n=new Array(this._holes.length).fill(null),i=0;i<n.length;i++)n[i]=this._holes[i].copy();return new e(t,n,this._factory)},e.prototype.getExteriorRing=function(){return this._shell},e.prototype.isEmpty=function(){return this._shell.isEmpty()},e.prototype.getInteriorRingN=function(t){return this._holes[t]},e.prototype.interfaces_=function(){return[Zt]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return-0x307ffefd8dc97200},Object.defineProperties(e,n),e}(ct),te=function(t){function e(){t.apply(this,arguments)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.getSortIndex=function(){return ct.SORTINDEX_MULTIPOINT},e.prototype.isValid=function(){return!0},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];return!!this.isEquivalentClass(e)&&t.prototype.equalsExact.call(this,e,n)}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.getCoordinate=function(){if(1===arguments.length){var e=arguments[0];return this._geometries[e].getCoordinate()}return t.prototype.getCoordinate.apply(this,arguments)},e.prototype.getBoundaryDimension=function(){return qt.FALSE},e.prototype.getDimension=function(){return 0},e.prototype.getBoundary=function(){return this.getFactory().createGeometryCollection(null)},e.prototype.getGeometryType=function(){return"MultiPoint"},e.prototype.copy=function(){for(var t=new Array(this._geometries.length).fill(null),n=0;n<t.length;n++)t[n]=this._geometries[n].copy();return new e(t,this._factory)},e.prototype.interfaces_=function(){return[Jt]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return-0x6fb1ed4162e0fc00},Object.defineProperties(e,n),e}(zt),ee=function(t){function e(e,n){e instanceof C&&n instanceof _e&&(e=n.getCoordinateSequenceFactory().create(e)),t.call(this,e,n),this.validateConstruction()}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={MINIMUM_VALID_SIZE:{configurable:!0},serialVersionUID:{configurable:!0}};return e.prototype.getSortIndex=function(){return ct.SORTINDEX_LINEARRING},e.prototype.getBoundaryDimension=function(){return qt.FALSE},e.prototype.isClosed=function(){return!!this.isEmpty()||t.prototype.isClosed.call(this)},e.prototype.reverse=function(){var t=this._points.copy();Wt.reverse(t);return this.getFactory().createLinearRing(t)},e.prototype.validateConstruction=function(){if(!this.isEmpty()&&!t.prototype.isClosed.call(this))throw new m("Points of LinearRing do not form a closed linestring");if(this.getCoordinateSequence().size()>=1&&this.getCoordinateSequence().size()<e.MINIMUM_VALID_SIZE)throw new m("Invalid number of points in LinearRing (found "+this.getCoordinateSequence().size()+" - must be 0 or >= 4)")},e.prototype.getGeometryType=function(){return"LinearRing"},e.prototype.copy=function(){return new e(this._points.copy(),this._factory)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},n.MINIMUM_VALID_SIZE.get=function(){return 4},n.serialVersionUID.get=function(){return-0x3b229e262367a600},Object.defineProperties(e,n),e}(Kt),ne=function(t){function e(){t.apply(this,arguments)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={serialVersionUID:{configurable:!0}};return e.prototype.getSortIndex=function(){return ct.SORTINDEX_MULTIPOLYGON},e.prototype.equalsExact=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];return!!this.isEquivalentClass(e)&&t.prototype.equalsExact.call(this,e,n)}return t.prototype.equalsExact.apply(this,arguments)},e.prototype.getBoundaryDimension=function(){return 1},e.prototype.getDimension=function(){return 2},e.prototype.reverse=function(){for(var t=this._geometries.length,e=new Array(t).fill(null),n=0;n<this._geometries.length;n++)e[n]=this._geometries[n].reverse();return this.getFactory().createMultiPolygon(e)},e.prototype.getBoundary=function(){if(this.isEmpty())return this.getFactory().createMultiLineString();for(var t=new Nt,e=0;e<this._geometries.length;e++)for(var n=this._geometries[e].getBoundary(),i=0;i<n.getNumGeometries();i++)t.add(n.getGeometryN(i));var r=new Array(t.size()).fill(null);return this.getFactory().createMultiLineString(t.toArray(r))},e.prototype.getGeometryType=function(){return"MultiPolygon"},e.prototype.copy=function(){for(var t=new Array(this._geometries.length).fill(null),n=0;n<t.length;n++)t[n]=this._geometries[n].copy();return new e(t,this._factory)},e.prototype.interfaces_=function(){return[Zt]},e.prototype.getClass=function(){return e},n.serialVersionUID.get=function(){return-0x7a5aa1369171980},Object.defineProperties(e,n),e}(zt),ie=function(t){this._factory=t||null,this._isUserDataCopied=!1},re={NoOpGeometryOperation:{configurable:!0},CoordinateOperation:{configurable:!0},CoordinateSequenceOperation:{configurable:!0}};ie.prototype.setCopyUserData=function(t){this._isUserDataCopied=t},ie.prototype.edit=function(t,e){if(null===t)return null;var n=this.editInternal(t,e);return this._isUserDataCopied&&n.setUserData(t.getUserData()),n},ie.prototype.editInternal=function(t,e){return null===this._factory&&(this._factory=t.getFactory()),t instanceof zt?this.editGeometryCollection(t,e):t instanceof $t?this.editPolygon(t,e):t instanceof Qt?e.edit(t,this._factory):t instanceof Kt?e.edit(t,this._factory):(et.shouldNeverReachHere("Unsupported Geometry class: "+t.getClass().getName()),null)},ie.prototype.editGeometryCollection=function(t,e){for(var n=e.edit(t,this._factory),i=new Nt,r=0;r<n.getNumGeometries();r++){var o=this.edit(n.getGeometryN(r),e);null===o||o.isEmpty()||i.add(o)}return n.getClass()===te?this._factory.createMultiPoint(i.toArray([])):n.getClass()===Xt?this._factory.createMultiLineString(i.toArray([])):n.getClass()===ne?this._factory.createMultiPolygon(i.toArray([])):this._factory.createGeometryCollection(i.toArray([]))},ie.prototype.editPolygon=function(t,e){var n=e.edit(t,this._factory);if(null===n&&(n=this._factory.createPolygon(null)),n.isEmpty())return n;var i=this.edit(n.getExteriorRing(),e);if(null===i||i.isEmpty())return this._factory.createPolygon();for(var r=new Nt,o=0;o<n.getNumInteriorRing();o++){var s=this.edit(n.getInteriorRingN(o),e);null===s||s.isEmpty()||r.add(s)}return this._factory.createPolygon(i,r.toArray([]))},ie.prototype.interfaces_=function(){return[]},ie.prototype.getClass=function(){return ie},ie.GeometryEditorOperation=function(){},re.NoOpGeometryOperation.get=function(){return oe},re.CoordinateOperation.get=function(){return se},re.CoordinateSequenceOperation.get=function(){return ae},Object.defineProperties(ie,re);var oe=function(){};oe.prototype.edit=function(t,e){return t},oe.prototype.interfaces_=function(){return[ie.GeometryEditorOperation]},oe.prototype.getClass=function(){return oe};var se=function(){};se.prototype.edit=function(t,e){var n=this.editCoordinates(t.getCoordinates(),t);return null===n?t:t instanceof ee?e.createLinearRing(n):t instanceof Kt?e.createLineString(n):t instanceof Qt?n.length>0?e.createPoint(n[0]):e.createPoint():t},se.prototype.interfaces_=function(){return[ie.GeometryEditorOperation]},se.prototype.getClass=function(){return se};var ae=function(){};ae.prototype.edit=function(t,e){return t instanceof ee?e.createLinearRing(this.edit(t.getCoordinateSequence(),t)):t instanceof Kt?e.createLineString(this.edit(t.getCoordinateSequence(),t)):t instanceof Qt?e.createPoint(this.edit(t.getCoordinateSequence(),t)):t},ae.prototype.interfaces_=function(){return[ie.GeometryEditorOperation]},ae.prototype.getClass=function(){return ae};var ue=function(){if(this._dimension=3,this._coordinates=null,1===arguments.length){if(arguments[0]instanceof Array)this._coordinates=arguments[0],this._dimension=3;else if(Number.isInteger(arguments[0])){var t=arguments[0];this._coordinates=new Array(t).fill(null);for(var e=0;e<t;e++)this._coordinates[e]=new C}else if(T(arguments[0],V)){var n=arguments[0];if(null===n)return this._coordinates=new Array(0).fill(null),null;this._dimension=n.getDimension(),this._coordinates=new Array(n.size()).fill(null);for(var i=0;i<this._coordinates.length;i++)this._coordinates[i]=n.getCoordinateCopy(i)}}else if(2===arguments.length)if(arguments[0]instanceof Array&&Number.isInteger(arguments[1])){var r=arguments[0],o=arguments[1];this._coordinates=r,this._dimension=o,null===r&&(this._coordinates=new Array(0).fill(null))}else if(Number.isInteger(arguments[0])&&Number.isInteger(arguments[1])){var s=arguments[0],a=arguments[1];this._coordinates=new Array(s).fill(null),this._dimension=a;for(var u=0;u<s;u++)this._coordinates[u]=new C}},le={serialVersionUID:{configurable:!0}};ue.prototype.setOrdinate=function(t,e,n){switch(e){case V.X:this._coordinates[t].x=n;break;case V.Y:this._coordinates[t].y=n;break;case V.Z:this._coordinates[t].z=n;break;default:throw new m("invalid ordinateIndex")}},ue.prototype.size=function(){return this._coordinates.length},ue.prototype.getOrdinate=function(t,e){switch(e){case V.X:return this._coordinates[t].x;case V.Y:return this._coordinates[t].y;case V.Z:return this._coordinates[t].z}return v.NaN},ue.prototype.getCoordinate=function(){if(1===arguments.length){var t=arguments[0];return this._coordinates[t]}if(2===arguments.length){var e=arguments[0],n=arguments[1];n.x=this._coordinates[e].x,n.y=this._coordinates[e].y,n.z=this._coordinates[e].z}},ue.prototype.getCoordinateCopy=function(t){return new C(this._coordinates[t])},ue.prototype.getDimension=function(){return this._dimension},ue.prototype.getX=function(t){return this._coordinates[t].x},ue.prototype.clone=function(){for(var t=new Array(this.size()).fill(null),e=0;e<this._coordinates.length;e++)t[e]=this._coordinates[e].clone();return new ue(t,this._dimension)},ue.prototype.expandEnvelope=function(t){for(var e=0;e<this._coordinates.length;e++)t.expandToInclude(this._coordinates[e]);return t},ue.prototype.copy=function(){for(var t=new Array(this.size()).fill(null),e=0;e<this._coordinates.length;e++)t[e]=this._coordinates[e].copy();return new ue(t,this._dimension)},ue.prototype.toString=function(){if(this._coordinates.length>0){var t=new D(17*this._coordinates.length);t.append("("),t.append(this._coordinates[0]);for(var e=1;e<this._coordinates.length;e++)t.append(", "),t.append(this._coordinates[e]);return t.append(")"),t.toString()}return"()"},ue.prototype.getY=function(t){return this._coordinates[t].y},ue.prototype.toCoordinateArray=function(){return this._coordinates},ue.prototype.interfaces_=function(){return[V,e]},ue.prototype.getClass=function(){return ue},le.serialVersionUID.get=function(){return-0xcb44a778db18e00},Object.defineProperties(ue,le);var ce=function(){},pe={serialVersionUID:{configurable:!0},instanceObject:{configurable:!0}};ce.prototype.readResolve=function(){return ce.instance()},ce.prototype.create=function(){if(1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];return new ue(t)}if(T(arguments[0],V)){var e=arguments[0];return new ue(e)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];return i>3&&(i=3),i<2?new ue(n):new ue(n,i)}},ce.prototype.interfaces_=function(){return[b,e]},ce.prototype.getClass=function(){return ce},ce.instance=function(){return ce.instanceObject},pe.serialVersionUID.get=function(){return-0x38e49fa6cf6f2e00},pe.instanceObject.get=function(){return new ce},Object.defineProperties(ce,pe);var he=function(t){function e(){t.call(this),this.map_=new Map}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return this.map_.get(t)||null},e.prototype.put=function(t,e){return this.map_.set(t,e),e},e.prototype.values=function(){for(var t=new Nt,e=this.map_.values(),n=e.next();!n.done;)t.add(n.value),n=e.next();return t},e.prototype.entrySet=function(){var t=new Pt;return this.map_.entries().forEach(function(e){return t.add(e)}),t},e.prototype.size=function(){return this.map_.size()},e}(Tt),fe=function t(){if(this._modelType=null,this._scale=null,0===arguments.length)this._modelType=t.FLOATING;else if(1===arguments.length)if(arguments[0]instanceof de){var e=arguments[0];this._modelType=e,e===t.FIXED&&this.setScale(1)}else if("number"==typeof arguments[0]){var n=arguments[0];this._modelType=t.FIXED,this.setScale(n)}else if(arguments[0]instanceof t){var i=arguments[0];this._modelType=i._modelType,this._scale=i._scale}},ge={serialVersionUID:{configurable:!0},maximumPreciseValue:{configurable:!0}};fe.prototype.equals=function(t){if(!(t instanceof fe))return!1;var e=t;return this._modelType===e._modelType&&this._scale===e._scale},fe.prototype.compareTo=function(t){var e=t,n=this.getMaximumSignificantDigits(),i=e.getMaximumSignificantDigits();return new M(n).compareTo(new M(i))},fe.prototype.getScale=function(){return this._scale},fe.prototype.isFloating=function(){return this._modelType===fe.FLOATING||this._modelType===fe.FLOATING_SINGLE},fe.prototype.getType=function(){return this._modelType},fe.prototype.toString=function(){var t="UNKNOWN";return this._modelType===fe.FLOATING?t="Floating":this._modelType===fe.FLOATING_SINGLE?t="Floating-Single":this._modelType===fe.FIXED&&(t="Fixed (Scale="+this.getScale()+")"),t},fe.prototype.makePrecise=function(){if("number"==typeof arguments[0]){var t=arguments[0];if(v.isNaN(t))return t;if(this._modelType===fe.FLOATING_SINGLE){return t}return this._modelType===fe.FIXED?Math.round(t*this._scale)/this._scale:t}if(arguments[0]instanceof C){var e=arguments[0];if(this._modelType===fe.FLOATING)return null;e.x=this.makePrecise(e.x),e.y=this.makePrecise(e.y)}},fe.prototype.getMaximumSignificantDigits=function(){var t=16;return this._modelType===fe.FLOATING?t=16:this._modelType===fe.FLOATING_SINGLE?t=6:this._modelType===fe.FIXED&&(t=1+Math.trunc(Math.ceil(Math.log(this.getScale())/Math.log(10)))),t},fe.prototype.setScale=function(t){this._scale=Math.abs(t)},fe.prototype.interfaces_=function(){return[e,E]},fe.prototype.getClass=function(){return fe},fe.mostPrecise=function(t,e){return t.compareTo(e)>=0?t:e},ge.serialVersionUID.get=function(){return 0x6bee6404e9a25c00},ge.maximumPreciseValue.get=function(){return 9007199254740992},Object.defineProperties(fe,ge);var de=function t(e){this._name=e||null,t.nameToTypeMap.put(e,this)},ye={serialVersionUID:{configurable:!0},nameToTypeMap:{configurable:!0}};de.prototype.readResolve=function(){return de.nameToTypeMap.get(this._name)},de.prototype.toString=function(){return this._name},de.prototype.interfaces_=function(){return[e]},de.prototype.getClass=function(){return de},ye.serialVersionUID.get=function(){return-552860263173159e4},ye.nameToTypeMap.get=function(){return new he},Object.defineProperties(de,ye),fe.Type=de,fe.FIXED=new de("FIXED"),fe.FLOATING=new de("FLOATING"),fe.FLOATING_SINGLE=new de("FLOATING SINGLE");var _e=function t(){this._precisionModel=new fe,this._SRID=0,this._coordinateSequenceFactory=t.getDefaultCoordinateSequenceFactory(),0===arguments.length||(1===arguments.length?T(arguments[0],b)?this._coordinateSequenceFactory=arguments[0]:arguments[0]instanceof fe&&(this._precisionModel=arguments[0]):2===arguments.length?(this._precisionModel=arguments[0],this._SRID=arguments[1]):3===arguments.length&&(this._precisionModel=arguments[0],this._SRID=arguments[1],this._coordinateSequenceFactory=arguments[2]))},me={serialVersionUID:{configurable:!0}};_e.prototype.toGeometry=function(t){return t.isNull()?this.createPoint(null):t.getMinX()===t.getMaxX()&&t.getMinY()===t.getMaxY()?this.createPoint(new C(t.getMinX(),t.getMinY())):t.getMinX()===t.getMaxX()||t.getMinY()===t.getMaxY()?this.createLineString([new C(t.getMinX(),t.getMinY()),new C(t.getMaxX(),t.getMaxY())]):this.createPolygon(this.createLinearRing([new C(t.getMinX(),t.getMinY()),new C(t.getMinX(),t.getMaxY()),new C(t.getMaxX(),t.getMaxY()),new C(t.getMaxX(),t.getMinY()),new C(t.getMinX(),t.getMinY())]),null)},_e.prototype.createLineString=function(t){return t?t instanceof Array?new Kt(this.getCoordinateSequenceFactory().create(t),this):T(t,V)?new Kt(t,this):void 0:new Kt(this.getCoordinateSequenceFactory().create([]),this)},_e.prototype.createMultiLineString=function(){if(0===arguments.length)return new Xt(null,this);if(1===arguments.length){var t=arguments[0];return new Xt(t,this)}},_e.prototype.buildGeometry=function(t){for(var e=null,n=!1,i=!1,r=t.iterator();r.hasNext();){var o=r.next(),s=o.getClass();null===e&&(e=s),s!==e&&(n=!0),o.isGeometryCollectionOrDerived()&&(i=!0)}if(null===e)return this.createGeometryCollection();if(n||i)return this.createGeometryCollection(_e.toGeometryArray(t));var a=t.iterator().next();if(t.size()>1){if(a instanceof $t)return this.createMultiPolygon(_e.toPolygonArray(t));if(a instanceof Kt)return this.createMultiLineString(_e.toLineStringArray(t));if(a instanceof Qt)return this.createMultiPoint(_e.toPointArray(t));et.shouldNeverReachHere("Unhandled class: "+a.getClass().getName())}return a},_e.prototype.createMultiPointFromCoords=function(t){return this.createMultiPoint(null!==t?this.getCoordinateSequenceFactory().create(t):null)},_e.prototype.createPoint=function(){if(0===arguments.length)return this.createPoint(this.getCoordinateSequenceFactory().create([]));if(1===arguments.length){if(arguments[0]instanceof C){var t=arguments[0];return this.createPoint(null!==t?this.getCoordinateSequenceFactory().create([t]):null)}if(T(arguments[0],V)){var e=arguments[0];return new Qt(e,this)}}},_e.prototype.getCoordinateSequenceFactory=function(){return this._coordinateSequenceFactory},_e.prototype.createPolygon=function(){if(0===arguments.length)return new $t(null,null,this);if(1===arguments.length){if(T(arguments[0],V)){var t=arguments[0];return this.createPolygon(this.createLinearRing(t))}if(arguments[0]instanceof Array){var e=arguments[0];return this.createPolygon(this.createLinearRing(e))}if(arguments[0]instanceof ee){var n=arguments[0];return this.createPolygon(n,null)}}else if(2===arguments.length){var i=arguments[0],r=arguments[1];return new $t(i,r,this)}},_e.prototype.getSRID=function(){return this._SRID},_e.prototype.createGeometryCollection=function(){if(0===arguments.length)return new zt(null,this);if(1===arguments.length){var t=arguments[0];return new zt(t,this)}},_e.prototype.createGeometry=function(t){return new ie(this).edit(t,{edit:function(){if(2===arguments.length){var t=arguments[0];return this._coordinateSequenceFactory.create(t)}}})},_e.prototype.getPrecisionModel=function(){return this._precisionModel},_e.prototype.createLinearRing=function(){if(0===arguments.length)return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));if(1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];return this.createLinearRing(null!==t?this.getCoordinateSequenceFactory().create(t):null)}if(T(arguments[0],V)){var e=arguments[0];return new ee(e,this)}}},_e.prototype.createMultiPolygon=function(){if(0===arguments.length)return new ne(null,this);if(1===arguments.length){var t=arguments[0];return new ne(t,this)}},_e.prototype.createMultiPoint=function(){if(0===arguments.length)return new te(null,this);if(1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];return new te(t,this)}if(arguments[0]instanceof Array){var e=arguments[0];return this.createMultiPoint(null!==e?this.getCoordinateSequenceFactory().create(e):null)}if(T(arguments[0],V)){var n=arguments[0];if(null===n)return this.createMultiPoint(new Array(0).fill(null));for(var i=new Array(n.size()).fill(null),r=0;r<n.size();r++){var o=this.getCoordinateSequenceFactory().create(1,n.getDimension());Wt.copy(n,r,o,0,1),i[r]=this.createPoint(o)}return this.createMultiPoint(i)}}},_e.prototype.interfaces_=function(){return[e]},_e.prototype.getClass=function(){return _e},_e.toMultiPolygonArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_e.toGeometryArray=function(t){if(null===t)return null;var e=new Array(t.size()).fill(null);return t.toArray(e)},_e.getDefaultCoordinateSequenceFactory=function(){return ce.instance()},_e.toMultiLineStringArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_e.toLineStringArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_e.toMultiPointArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_e.toLinearRingArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_e.toPointArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_e.toPolygonArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},_e.createPointFromInternalCoord=function(t,e){return e.getPrecisionModel().makePrecise(t),e.getFactory().createPoint(t)},me.serialVersionUID.get=function(){return-0x5ea75f2051eeb400},Object.defineProperties(_e,me);var ve=["Point","MultiPoint","LineString","MultiLineString","Polygon","MultiPolygon"],Ie=function(t){this.geometryFactory=t||new _e};Ie.prototype.read=function(t){var e,n=(e="string"==typeof t?JSON.parse(t):t).type;if(!Ee[n])throw new Error("Unknown GeoJSON type: "+e.type);return-1!==ve.indexOf(n)?Ee[n].apply(this,[e.coordinates]):"GeometryCollection"===n?Ee[n].apply(this,[e.geometries]):Ee[n].apply(this,[e])},Ie.prototype.write=function(t){var e=t.getGeometryType();if(!xe[e])throw new Error("Geometry is not supported");return xe[e].apply(this,[t])};var Ee={Feature:function(t){var e={};for(var n in t)e[n]=t[n];if(t.geometry){var i=t.geometry.type;if(!Ee[i])throw new Error("Unknown GeoJSON type: "+t.type);e.geometry=this.read(t.geometry)}return t.bbox&&(e.bbox=Ee.bbox.apply(this,[t.bbox])),e},FeatureCollection:function(t){var e={};if(t.features){e.features=[];for(var n=0;n<t.features.length;++n)e.features.push(this.read(t.features[n]))}return t.bbox&&(e.bbox=this.parse.bbox.apply(this,[t.bbox])),e},coordinates:function(t){for(var e=[],n=0;n<t.length;++n){var i=t[n];e.push(new C(i[0],i[1]))}return e},bbox:function(t){return this.geometryFactory.createLinearRing([new C(t[0],t[1]),new C(t[2],t[1]),new C(t[2],t[3]),new C(t[0],t[3]),new C(t[0],t[1])])},Point:function(t){var e=new C(t[0],t[1]);return this.geometryFactory.createPoint(e)},MultiPoint:function(t){for(var e=[],n=0;n<t.length;++n)e.push(Ee.Point.apply(this,[t[n]]));return this.geometryFactory.createMultiPoint(e)},LineString:function(t){var e=Ee.coordinates.apply(this,[t]);return this.geometryFactory.createLineString(e)},MultiLineString:function(t){for(var e=[],n=0;n<t.length;++n)e.push(Ee.LineString.apply(this,[t[n]]));return this.geometryFactory.createMultiLineString(e)},Polygon:function(t){for(var e=Ee.coordinates.apply(this,[t[0]]),n=this.geometryFactory.createLinearRing(e),i=[],r=1;r<t.length;++r){var o=t[r],s=Ee.coordinates.apply(this,[o]),a=this.geometryFactory.createLinearRing(s);i.push(a)}return this.geometryFactory.createPolygon(n,i)},MultiPolygon:function(t){for(var e=[],n=0;n<t.length;++n){var i=t[n];e.push(Ee.Polygon.apply(this,[i]))}return this.geometryFactory.createMultiPolygon(e)},GeometryCollection:function(t){for(var e=[],n=0;n<t.length;++n){var i=t[n];e.push(this.read(i))}return this.geometryFactory.createGeometryCollection(e)}},xe={coordinate:function(t){return[t.x,t.y]},Point:function(t){return{type:"Point",coordinates:xe.coordinate.apply(this,[t.getCoordinate()])}},MultiPoint:function(t){for(var e=[],n=0;n<t._geometries.length;++n){var i=t._geometries[n],r=xe.Point.apply(this,[i]);e.push(r.coordinates)}return{type:"MultiPoint",coordinates:e}},LineString:function(t){for(var e=[],n=t.getCoordinates(),i=0;i<n.length;++i){var r=n[i];e.push(xe.coordinate.apply(this,[r]))}return{type:"LineString",coordinates:e}},MultiLineString:function(t){for(var e=[],n=0;n<t._geometries.length;++n){var i=t._geometries[n],r=xe.LineString.apply(this,[i]);e.push(r.coordinates)}return{type:"MultiLineString",coordinates:e}},Polygon:function(t){var e=[],n=xe.LineString.apply(this,[t._shell]);e.push(n.coordinates);for(var i=0;i<t._holes.length;++i){var r=t._holes[i],o=xe.LineString.apply(this,[r]);e.push(o.coordinates)}return{type:"Polygon",coordinates:e}},MultiPolygon:function(t){for(var e=[],n=0;n<t._geometries.length;++n){var i=t._geometries[n],r=xe.Polygon.apply(this,[i]);e.push(r.coordinates)}return{type:"MultiPolygon",coordinates:e}},GeometryCollection:function(t){for(var e=[],n=0;n<t._geometries.length;++n){var i=t._geometries[n],r=i.getGeometryType();e.push(xe[r].apply(this,[i]))}return{type:"GeometryCollection",geometries:e}}},Ne=function(t){this.geometryFactory=t||new _e,this.precisionModel=this.geometryFactory.getPrecisionModel(),this.parser=new Ie(this.geometryFactory)};Ne.prototype.read=function(t){var e=this.parser.read(t);return this.precisionModel.getType()===fe.FIXED&&this.reducePrecision(e),e},Ne.prototype.reducePrecision=function(t){var e,n;if(t.coordinate)this.precisionModel.makePrecise(t.coordinate);else if(t.points)for(e=0,n=t.points.length;e<n;e++)this.precisionModel.makePrecise(t.points[e]);else if(t.geometries)for(e=0,n=t.geometries.length;e<n;e++)this.reducePrecision(t.geometries[e])};var Ce=function(){this.parser=new Ie(this.geometryFactory)};Ce.prototype.write=function(t){return this.parser.write(t)};var Se=function(){},Le={ON:{configurable:!0},LEFT:{configurable:!0},RIGHT:{configurable:!0}};Se.prototype.interfaces_=function(){return[]},Se.prototype.getClass=function(){return Se},Se.opposite=function(t){return t===Se.LEFT?Se.RIGHT:t===Se.RIGHT?Se.LEFT:t},Le.ON.get=function(){return 0},Le.LEFT.get=function(){return 1},Le.RIGHT.get=function(){return 2},Object.defineProperties(Se,Le),(d.prototype=new Error).name="EmptyStackException",(y.prototype=new xt).add=function(t){return this.array_.push(t),!0},y.prototype.get=function(t){if(t<0||t>=this.size())throw new Error;return this.array_[t]},y.prototype.push=function(t){return this.array_.push(t),t},y.prototype.pop=function(t){if(0===this.array_.length)throw new d;return this.array_.pop()},y.prototype.peek=function(){if(0===this.array_.length)throw new d;return this.array_[this.array_.length-1]},y.prototype.empty=function(){return 0===this.array_.length},y.prototype.isEmpty=function(){return this.empty()},y.prototype.search=function(t){return this.array_.indexOf(t)},y.prototype.size=function(){return this.array_.length},y.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;e<n;e++)t.push(this.array_[e]);return t};var be=function(){this._minIndex=-1,this._minCoord=null,this._minDe=null,this._orientedDe=null};be.prototype.getCoordinate=function(){return this._minCoord},be.prototype.getRightmostSide=function(t,e){var n=this.getRightmostSideOfSegment(t,e);return n<0&&(n=this.getRightmostSideOfSegment(t,e-1)),n<0&&(this._minCoord=null,this.checkForRightmostCoordinate(t)),n},be.prototype.findRightmostEdgeAtVertex=function(){var t=this._minDe.getEdge().getCoordinates();et.isTrue(this._minIndex>0&&this._minIndex<t.length,"rightmost point expected to be interior vertex of edge");var e=t[this._minIndex-1],n=t[this._minIndex+1],i=at.computeOrientation(this._minCoord,n,e),r=!1;e.y<this._minCoord.y&&n.y<this._minCoord.y&&i===at.COUNTERCLOCKWISE?r=!0:e.y>this._minCoord.y&&n.y>this._minCoord.y&&i===at.CLOCKWISE&&(r=!0),r&&(this._minIndex=this._minIndex-1)},be.prototype.getRightmostSideOfSegment=function(t,e){var n=t.getEdge().getCoordinates();if(e<0||e+1>=n.length)return-1;if(n[e].y===n[e+1].y)return-1;var i=Se.LEFT;return n[e].y<n[e+1].y&&(i=Se.RIGHT),i},be.prototype.getEdge=function(){return this._orientedDe},be.prototype.checkForRightmostCoordinate=function(t){for(var e=t.getEdge().getCoordinates(),n=0;n<e.length-1;n++)(null===this._minCoord||e[n].x>this._minCoord.x)&&(this._minDe=t,this._minIndex=n,this._minCoord=e[n])},be.prototype.findRightmostEdgeAtNode=function(){var t=this._minDe.getNode().getEdges();this._minDe=t.getRightmostEdge(),this._minDe.isForward()||(this._minDe=this._minDe.getSym(),this._minIndex=this._minDe.getEdge().getCoordinates().length-1)},be.prototype.findEdge=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();n.isForward()&&this.checkForRightmostCoordinate(n)}et.isTrue(0!==this._minIndex||this._minCoord.equals(this._minDe.getCoordinate()),"inconsistency in rightmost processing"),0===this._minIndex?this.findRightmostEdgeAtNode():this.findRightmostEdgeAtVertex(),this._orientedDe=this._minDe;this.getRightmostSide(this._minDe,this._minIndex)===Se.LEFT&&(this._orientedDe=this._minDe.getSym())},be.prototype.interfaces_=function(){return[]},be.prototype.getClass=function(){return be};var we=function(t){function e(n,i){t.call(this,e.msgWithCoord(n,i)),this.pt=i?new C(i):null,this.name="TopologyException"}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getCoordinate=function(){return this.pt},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e.msgWithCoord=function(t,e){return e?t:t+" [ "+e+" ]"},e}($),Oe=function(){this.array_=[]};Oe.prototype.addLast=function(t){this.array_.push(t)},Oe.prototype.removeFirst=function(){return this.array_.shift()},Oe.prototype.isEmpty=function(){return 0===this.array_.length};var Te=function(){this._finder=null,this._dirEdgeList=new Nt,this._nodes=new Nt,this._rightMostCoord=null,this._env=null,this._finder=new be};Te.prototype.clearVisitedEdges=function(){for(var t=this._dirEdgeList.iterator();t.hasNext();){t.next().setVisited(!1)}},Te.prototype.getRightmostCoordinate=function(){return this._rightMostCoord},Te.prototype.computeNodeDepth=function(t){for(var e=null,n=t.getEdges().iterator();n.hasNext();){var i=n.next();if(i.isVisited()||i.getSym().isVisited()){e=i;break}}if(null===e)throw new we("unable to find edge to compute depths at "+t.getCoordinate());t.getEdges().computeDepths(e);for(var r=t.getEdges().iterator();r.hasNext();){var o=r.next();o.setVisited(!0),this.copySymDepths(o)}},Te.prototype.computeDepth=function(t){this.clearVisitedEdges();var e=this._finder.getEdge();e.setEdgeDepths(Se.RIGHT,t),this.copySymDepths(e),this.computeDepths(e)},Te.prototype.create=function(t){this.addReachable(t),this._finder.findEdge(this._dirEdgeList),this._rightMostCoord=this._finder.getCoordinate()},Te.prototype.findResultEdges=function(){for(var t=this._dirEdgeList.iterator();t.hasNext();){var e=t.next();e.getDepth(Se.RIGHT)>=1&&e.getDepth(Se.LEFT)<=0&&!e.isInteriorAreaEdge()&&e.setInResult(!0)}},Te.prototype.computeDepths=function(t){var e=new Pt,n=new Oe,i=t.getNode();for(n.addLast(i),e.add(i),t.setVisited(!0);!n.isEmpty();){var r=n.removeFirst();e.add(r),this.computeNodeDepth(r);for(var o=r.getEdges().iterator();o.hasNext();){var s=o.next().getSym();if(!s.isVisited()){var a=s.getNode();e.contains(a)||(n.addLast(a),e.add(a))}}}},Te.prototype.compareTo=function(t){var e=t;return this._rightMostCoord.x<e._rightMostCoord.x?-1:this._rightMostCoord.x>e._rightMostCoord.x?1:0},Te.prototype.getEnvelope=function(){if(null===this._env){for(var t=new j,e=this._dirEdgeList.iterator();e.hasNext();)for(var n=e.next().getEdge().getCoordinates(),i=0;i<n.length-1;i++)t.expandToInclude(n[i]);this._env=t}return this._env},Te.prototype.addReachable=function(t){var e=new y;for(e.add(t);!e.empty();){var n=e.pop();this.add(n,e)}},Te.prototype.copySymDepths=function(t){var e=t.getSym();e.setDepth(Se.LEFT,t.getDepth(Se.RIGHT)),e.setDepth(Se.RIGHT,t.getDepth(Se.LEFT))},Te.prototype.add=function(t,e){t.setVisited(!0),this._nodes.add(t);for(var n=t.getEdges().iterator();n.hasNext();){var i=n.next();this._dirEdgeList.add(i);var r=i.getSym().getNode();r.isVisited()||e.push(r)}},Te.prototype.getNodes=function(){return this._nodes},Te.prototype.getDirectedEdges=function(){return this._dirEdgeList},Te.prototype.interfaces_=function(){return[E]},Te.prototype.getClass=function(){return Te};var Re=function t(){if(this.location=null,1===arguments.length){if(arguments[0]instanceof Array){var e=arguments[0];this.init(e.length)}else if(Number.isInteger(arguments[0])){var n=arguments[0];this.init(1),this.location[Se.ON]=n}else if(arguments[0]instanceof t){var i=arguments[0];if(this.init(i.location.length),null!==i)for(var r=0;r<this.location.length;r++)this.location[r]=i.location[r]}}else if(3===arguments.length){var o=arguments[0],s=arguments[1],a=arguments[2];this.init(3),this.location[Se.ON]=o,this.location[Se.LEFT]=s,this.location[Se.RIGHT]=a}};Re.prototype.setAllLocations=function(t){for(var e=0;e<this.location.length;e++)this.location[e]=t},Re.prototype.isNull=function(){for(var t=0;t<this.location.length;t++)if(this.location[t]!==w.NONE)return!1;return!0},Re.prototype.setAllLocationsIfNull=function(t){for(var e=0;e<this.location.length;e++)this.location[e]===w.NONE&&(this.location[e]=t)},Re.prototype.isLine=function(){return 1===this.location.length},Re.prototype.merge=function(t){if(t.location.length>this.location.length){var e=new Array(3).fill(null);e[Se.ON]=this.location[Se.ON],e[Se.LEFT]=w.NONE,e[Se.RIGHT]=w.NONE,this.location=e}for(var n=0;n<this.location.length;n++)this.location[n]===w.NONE&&n<t.location.length&&(this.location[n]=t.location[n])},Re.prototype.getLocations=function(){return this.location},Re.prototype.flip=function(){if(this.location.length<=1)return null;var t=this.location[Se.LEFT];this.location[Se.LEFT]=this.location[Se.RIGHT],this.location[Se.RIGHT]=t},Re.prototype.toString=function(){var t=new D;return this.location.length>1&&t.append(w.toLocationSymbol(this.location[Se.LEFT])),t.append(w.toLocationSymbol(this.location[Se.ON])),this.location.length>1&&t.append(w.toLocationSymbol(this.location[Se.RIGHT])),t.toString()},Re.prototype.setLocations=function(t,e,n){this.location[Se.ON]=t,this.location[Se.LEFT]=e,this.location[Se.RIGHT]=n},Re.prototype.get=function(t){return t<this.location.length?this.location[t]:w.NONE},Re.prototype.isArea=function(){return this.location.length>1},Re.prototype.isAnyNull=function(){for(var t=0;t<this.location.length;t++)if(this.location[t]===w.NONE)return!0;return!1},Re.prototype.setLocation=function(){if(1===arguments.length){var t=arguments[0];this.setLocation(Se.ON,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.location[e]=n}},Re.prototype.init=function(t){this.location=new Array(t).fill(null),this.setAllLocations(w.NONE)},Re.prototype.isEqualOnSide=function(t,e){return this.location[e]===t.location[e]},Re.prototype.allPositionsEqual=function(t){for(var e=0;e<this.location.length;e++)if(this.location[e]!==t)return!1;return!0},Re.prototype.interfaces_=function(){return[]},Re.prototype.getClass=function(){return Re};var Pe=function t(){if(this.elt=new Array(2).fill(null),1===arguments.length){if(Number.isInteger(arguments[0])){var e=arguments[0];this.elt[0]=new Re(e),this.elt[1]=new Re(e)}else if(arguments[0]instanceof t){var n=arguments[0];this.elt[0]=new Re(n.elt[0]),this.elt[1]=new Re(n.elt[1])}}else if(2===arguments.length){var i=arguments[0],r=arguments[1];this.elt[0]=new Re(w.NONE),this.elt[1]=new Re(w.NONE),this.elt[i].setLocation(r)}else if(3===arguments.length){var o=arguments[0],s=arguments[1],a=arguments[2];this.elt[0]=new Re(o,s,a),this.elt[1]=new Re(o,s,a)}else if(4===arguments.length){var u=arguments[0],l=arguments[1],c=arguments[2],p=arguments[3];this.elt[0]=new Re(w.NONE,w.NONE,w.NONE),this.elt[1]=new Re(w.NONE,w.NONE,w.NONE),this.elt[u].setLocations(l,c,p)}};Pe.prototype.getGeometryCount=function(){var t=0;return this.elt[0].isNull()||t++,this.elt[1].isNull()||t++,t},Pe.prototype.setAllLocations=function(t,e){this.elt[t].setAllLocations(e)},Pe.prototype.isNull=function(t){return this.elt[t].isNull()},Pe.prototype.setAllLocationsIfNull=function(){if(1===arguments.length){var t=arguments[0];this.setAllLocationsIfNull(0,t),this.setAllLocationsIfNull(1,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.elt[e].setAllLocationsIfNull(n)}},Pe.prototype.isLine=function(t){return this.elt[t].isLine()},Pe.prototype.merge=function(t){for(var e=0;e<2;e++)null===this.elt[e]&&null!==t.elt[e]?this.elt[e]=new Re(t.elt[e]):this.elt[e].merge(t.elt[e])},Pe.prototype.flip=function(){this.elt[0].flip(),this.elt[1].flip()},Pe.prototype.getLocation=function(){if(1===arguments.length){var t=arguments[0];return this.elt[t].get(Se.ON)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return this.elt[e].get(n)}},Pe.prototype.toString=function(){var t=new D;return null!==this.elt[0]&&(t.append("A:"),t.append(this.elt[0].toString())),null!==this.elt[1]&&(t.append(" B:"),t.append(this.elt[1].toString())),t.toString()},Pe.prototype.isArea=function(){if(0===arguments.length)return this.elt[0].isArea()||this.elt[1].isArea();if(1===arguments.length){var t=arguments[0];return this.elt[t].isArea()}},Pe.prototype.isAnyNull=function(t){return this.elt[t].isAnyNull()},Pe.prototype.setLocation=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];this.elt[t].setLocation(Se.ON,e)}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];this.elt[n].setLocation(i,r)}},Pe.prototype.isEqualOnSide=function(t,e){return this.elt[0].isEqualOnSide(t.elt[0],e)&&this.elt[1].isEqualOnSide(t.elt[1],e)},Pe.prototype.allPositionsEqual=function(t,e){return this.elt[t].allPositionsEqual(e)},Pe.prototype.toLine=function(t){this.elt[t].isArea()&&(this.elt[t]=new Re(this.elt[t].location[0]))},Pe.prototype.interfaces_=function(){return[]},Pe.prototype.getClass=function(){return Pe},Pe.toLineLabel=function(t){for(var e=new Pe(w.NONE),n=0;n<2;n++)e.setLocation(n,t.getLocation(n));return e};var De=function(){this._startDe=null,this._maxNodeDegree=-1,this._edges=new Nt,this._pts=new Nt,this._label=new Pe(w.NONE),this._ring=null,this._isHole=null,this._shell=null,this._holes=new Nt,this._geometryFactory=null;var t=arguments[0],e=arguments[1];this._geometryFactory=e,this.computePoints(t),this.computeRing()};De.prototype.computeRing=function(){if(null!==this._ring)return null;for(var t=new Array(this._pts.size()).fill(null),e=0;e<this._pts.size();e++)t[e]=this._pts.get(e);this._ring=this._geometryFactory.createLinearRing(t),this._isHole=at.isCCW(this._ring.getCoordinates())},De.prototype.isIsolated=function(){return 1===this._label.getGeometryCount()},De.prototype.computePoints=function(t){this._startDe=t;var e=t,n=!0;do{if(null===e)throw new we("Found null DirectedEdge");if(e.getEdgeRing()===this)throw new we("Directed Edge visited twice during ring-building at "+e.getCoordinate());this._edges.add(e);var i=e.getLabel();et.isTrue(i.isArea()),this.mergeLabel(i),this.addPoints(e.getEdge(),e.isForward(),n),n=!1,this.setEdgeRing(e,this),e=this.getNext(e)}while(e!==this._startDe)},De.prototype.getLinearRing=function(){return this._ring},De.prototype.getCoordinate=function(t){return this._pts.get(t)},De.prototype.computeMaxNodeDegree=function(){this._maxNodeDegree=0;var t=this._startDe;do{var e=t.getNode().getEdges().getOutgoingDegree(this);e>this._maxNodeDegree&&(this._maxNodeDegree=e),t=this.getNext(t)}while(t!==this._startDe);this._maxNodeDegree*=2},De.prototype.addPoints=function(t,e,n){var i=t.getCoordinates();if(e){var r=1;n&&(r=0);for(var o=r;o<i.length;o++)this._pts.add(i[o])}else{var s=i.length-2;n&&(s=i.length-1);for(var a=s;a>=0;a--)this._pts.add(i[a])}},De.prototype.isHole=function(){return this._isHole},De.prototype.setInResult=function(){var t=this._startDe;do{t.getEdge().setInResult(!0),t=t.getNext()}while(t!==this._startDe)},De.prototype.containsPoint=function(t){var e=this.getLinearRing();if(!e.getEnvelopeInternal().contains(t))return!1;if(!at.isPointInRing(t,e.getCoordinates()))return!1;for(var n=this._holes.iterator();n.hasNext();){if(n.next().containsPoint(t))return!1}return!0},De.prototype.addHole=function(t){this._holes.add(t)},De.prototype.isShell=function(){return null===this._shell},De.prototype.getLabel=function(){return this._label},De.prototype.getEdges=function(){return this._edges},De.prototype.getMaxNodeDegree=function(){return this._maxNodeDegree<0&&this.computeMaxNodeDegree(),this._maxNodeDegree},De.prototype.getShell=function(){return this._shell},De.prototype.mergeLabel=function(){if(1===arguments.length){var t=arguments[0];this.mergeLabel(t,0),this.mergeLabel(t,1)}else if(2===arguments.length){var e=arguments[0],n=arguments[1],i=e.getLocation(n,Se.RIGHT);if(i===w.NONE)return null;if(this._label.getLocation(n)===w.NONE)return this._label.setLocation(n,i),null}},De.prototype.setShell=function(t){this._shell=t,null!==t&&t.addHole(this)},De.prototype.toPolygon=function(t){for(var e=new Array(this._holes.size()).fill(null),n=0;n<this._holes.size();n++)e[n]=this._holes.get(n).getLinearRing();return t.createPolygon(this.getLinearRing(),e)},De.prototype.interfaces_=function(){return[]},De.prototype.getClass=function(){return De};var Me=function(t){function e(){var e=arguments[0],n=arguments[1];t.call(this,e,n)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.setEdgeRing=function(t,e){t.setMinEdgeRing(e)},e.prototype.getNext=function(t){return t.getNextMin()},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(De),Ae=function(t){function e(){var e=arguments[0],n=arguments[1];t.call(this,e,n)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.buildMinimalRings=function(){var t=new Nt,e=this._startDe;do{if(null===e.getMinEdgeRing()){var n=new Me(e,this._geometryFactory);t.add(n)}e=e.getNext()}while(e!==this._startDe);return t},e.prototype.setEdgeRing=function(t,e){t.setEdgeRing(e)},e.prototype.linkDirectedEdgesForMinimalEdgeRings=function(){var t=this._startDe;do{t.getNode().getEdges().linkMinimalDirectedEdges(this),t=t.getNext()}while(t!==this._startDe)},e.prototype.getNext=function(t){return t.getNext()},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(De),Fe=function(){if(this._label=null,this._isInResult=!1,this._isCovered=!1,this._isCoveredSet=!1,this._isVisited=!1,0===arguments.length);else if(1===arguments.length){var t=arguments[0];this._label=t}};Fe.prototype.setVisited=function(t){this._isVisited=t},Fe.prototype.setInResult=function(t){this._isInResult=t},Fe.prototype.isCovered=function(){return this._isCovered},Fe.prototype.isCoveredSet=function(){return this._isCoveredSet},Fe.prototype.setLabel=function(t){this._label=t},Fe.prototype.getLabel=function(){return this._label},Fe.prototype.setCovered=function(t){this._isCovered=t,this._isCoveredSet=!0},Fe.prototype.updateIM=function(t){et.isTrue(this._label.getGeometryCount()>=2,"found partial label"),this.computeIM(t)},Fe.prototype.isInResult=function(){return this._isInResult},Fe.prototype.isVisited=function(){return this._isVisited},Fe.prototype.interfaces_=function(){return[]},Fe.prototype.getClass=function(){return Fe};var Ge=function(t){function e(){t.call(this),this._coord=null,this._edges=null;var e=arguments[0],n=arguments[1];this._coord=e,this._edges=n,this._label=new Pe(0,w.NONE)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.isIncidentEdgeInResult=function(){for(var t=this.getEdges().getEdges().iterator();t.hasNext();){if(t.next().getEdge().isInResult())return!0}return!1},e.prototype.isIsolated=function(){return 1===this._label.getGeometryCount()},e.prototype.getCoordinate=function(){return this._coord},e.prototype.print=function(t){t.println("node "+this._coord+" lbl: "+this._label)},e.prototype.computeIM=function(t){},e.prototype.computeMergedLocation=function(t,e){var n=w.NONE;if(n=this._label.getLocation(e),!t.isNull(e)){var i=t.getLocation(e);n!==w.BOUNDARY&&(n=i)}return n},e.prototype.setLabel=function(){if(2!==arguments.length)return t.prototype.setLabel.apply(this,arguments);var e=arguments[0],n=arguments[1];null===this._label?this._label=new Pe(e,n):this._label.setLocation(e,n)},e.prototype.getEdges=function(){return this._edges},e.prototype.mergeLabel=function(){if(arguments[0]instanceof e){var t=arguments[0];this.mergeLabel(t._label)}else if(arguments[0]instanceof Pe)for(var n=arguments[0],i=0;i<2;i++){var r=this.computeMergedLocation(n,i);this._label.getLocation(i)===w.NONE&&this._label.setLocation(i,r)}},e.prototype.add=function(t){this._edges.insert(t),t.setNode(this)},e.prototype.setLabelBoundary=function(t){if(null===this._label)return null;var e=w.NONE;null!==this._label&&(e=this._label.getLocation(t));var n=null;switch(e){case w.BOUNDARY:n=w.INTERIOR;break;case w.INTERIOR:default:n=w.BOUNDARY}this._label.setLocation(t,n)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Fe),qe=function(){this.nodeMap=new p,this.nodeFact=null;var t=arguments[0];this.nodeFact=t};qe.prototype.find=function(t){return this.nodeMap.get(t)},qe.prototype.addNode=function(){if(arguments[0]instanceof C){var t=arguments[0],e=this.nodeMap.get(t);return null===e&&(e=this.nodeFact.createNode(t),this.nodeMap.put(t,e)),e}if(arguments[0]instanceof Ge){var n=arguments[0],i=this.nodeMap.get(n.getCoordinate());return null===i?(this.nodeMap.put(n.getCoordinate(),n),n):(i.mergeLabel(n),i)}},qe.prototype.print=function(t){for(var e=this.iterator();e.hasNext();){e.next().print(t)}},qe.prototype.iterator=function(){return this.nodeMap.values().iterator()},qe.prototype.values=function(){return this.nodeMap.values()},qe.prototype.getBoundaryNodes=function(t){for(var e=new Nt,n=this.iterator();n.hasNext();){var i=n.next();i.getLabel().getLocation(t)===w.BOUNDARY&&e.add(i)}return e},qe.prototype.add=function(t){var e=t.getCoordinate();this.addNode(e).add(t)},qe.prototype.interfaces_=function(){return[]},qe.prototype.getClass=function(){return qe};var Be=function(){},Ve={NE:{configurable:!0},NW:{configurable:!0},SW:{configurable:!0},SE:{configurable:!0}};Be.prototype.interfaces_=function(){return[]},Be.prototype.getClass=function(){return Be},Be.isNorthern=function(t){return t===Be.NE||t===Be.NW},Be.isOpposite=function(t,e){if(t===e)return!1;return 2===(t-e+4)%4},Be.commonHalfPlane=function(t,e){if(t===e)return t;if(2===(t-e+4)%4)return-1;var n=t<e?t:e;return 0===n&&3===(t>e?t:e)?3:n},Be.isInHalfPlane=function(t,e){return e===Be.SE?t===Be.SE||t===Be.SW:t===e||t===e+1},Be.quadrant=function(){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){var t=arguments[0],e=arguments[1];if(0===t&&0===e)throw new m("Cannot compute the quadrant for point ( "+t+", "+e+" )");return t>=0?e>=0?Be.NE:Be.SE:e>=0?Be.NW:Be.SW}if(arguments[0]instanceof C&&arguments[1]instanceof C){var n=arguments[0],i=arguments[1];if(i.x===n.x&&i.y===n.y)throw new m("Cannot compute the quadrant for two identical points "+n);return i.x>=n.x?i.y>=n.y?Be.NE:Be.SE:i.y>=n.y?Be.NW:Be.SW}},Ve.NE.get=function(){return 0},Ve.NW.get=function(){return 1},Ve.SW.get=function(){return 2},Ve.SE.get=function(){return 3},Object.defineProperties(Be,Ve);var Ue=function(){if(this._edge=null,this._label=null,this._node=null,this._p0=null,this._p1=null,this._dx=null,this._dy=null,this._quadrant=null,1===arguments.length){var t=arguments[0];this._edge=t}else if(3===arguments.length){var e=arguments[0],n=arguments[1],i=arguments[2];this._edge=e,this.init(n,i),this._label=null}else if(4===arguments.length){var r=arguments[0],o=arguments[1],s=arguments[2],a=arguments[3];this._edge=r,this.init(o,s),this._label=a}};Ue.prototype.compareDirection=function(t){return this._dx===t._dx&&this._dy===t._dy?0:this._quadrant>t._quadrant?1:this._quadrant<t._quadrant?-1:at.computeOrientation(t._p0,t._p1,this._p1)},Ue.prototype.getDy=function(){return this._dy},Ue.prototype.getCoordinate=function(){return this._p0},Ue.prototype.setNode=function(t){this._node=t},Ue.prototype.print=function(t){var e=Math.atan2(this._dy,this._dx),n=this.getClass().getName(),i=n.lastIndexOf("."),r=n.substring(i+1);t.print("  "+r+": "+this._p0+" - "+this._p1+" "+this._quadrant+":"+e+"   "+this._label)},Ue.prototype.compareTo=function(t){var e=t;return this.compareDirection(e)},Ue.prototype.getDirectedCoordinate=function(){return this._p1},Ue.prototype.getDx=function(){return this._dx},Ue.prototype.getLabel=function(){return this._label},Ue.prototype.getEdge=function(){return this._edge},Ue.prototype.getQuadrant=function(){return this._quadrant},Ue.prototype.getNode=function(){return this._node},Ue.prototype.toString=function(){var t=Math.atan2(this._dy,this._dx),e=this.getClass().getName(),n=e.lastIndexOf(".");return"  "+e.substring(n+1)+": "+this._p0+" - "+this._p1+" "+this._quadrant+":"+t+"   "+this._label},Ue.prototype.computeLabel=function(t){},Ue.prototype.init=function(t,e){this._p0=t,this._p1=e,this._dx=e.x-t.x,this._dy=e.y-t.y,this._quadrant=Be.quadrant(this._dx,this._dy),et.isTrue(!(0===this._dx&&0===this._dy),"EdgeEnd with identical endpoints found")},Ue.prototype.interfaces_=function(){return[E]},Ue.prototype.getClass=function(){return Ue};var ze=function(t){function e(){var e=arguments[0],n=arguments[1];if(t.call(this,e),this._isForward=null,this._isInResult=!1,this._isVisited=!1,this._sym=null,this._next=null,this._nextMin=null,this._edgeRing=null,this._minEdgeRing=null,this._depth=[0,-999,-999],this._isForward=n,n)this.init(e.getCoordinate(0),e.getCoordinate(1));else{var i=e.getNumPoints()-1;this.init(e.getCoordinate(i),e.getCoordinate(i-1))}this.computeDirectedLabel()}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getNextMin=function(){return this._nextMin},e.prototype.getDepth=function(t){return this._depth[t]},e.prototype.setVisited=function(t){this._isVisited=t},e.prototype.computeDirectedLabel=function(){this._label=new Pe(this._edge.getLabel()),this._isForward||this._label.flip()},e.prototype.getNext=function(){return this._next},e.prototype.setDepth=function(t,e){if(-999!==this._depth[t]&&this._depth[t]!==e)throw new we("assigned depths do not match",this.getCoordinate());this._depth[t]=e},e.prototype.isInteriorAreaEdge=function(){for(var t=!0,e=0;e<2;e++)this._label.isArea(e)&&this._label.getLocation(e,Se.LEFT)===w.INTERIOR&&this._label.getLocation(e,Se.RIGHT)===w.INTERIOR||(t=!1);return t},e.prototype.setNextMin=function(t){this._nextMin=t},e.prototype.print=function(e){t.prototype.print.call(this,e),e.print(" "+this._depth[Se.LEFT]+"/"+this._depth[Se.RIGHT]),e.print(" ("+this.getDepthDelta()+")"),this._isInResult&&e.print(" inResult")},e.prototype.setMinEdgeRing=function(t){this._minEdgeRing=t},e.prototype.isLineEdge=function(){var t=this._label.isLine(0)||this._label.isLine(1),e=!this._label.isArea(0)||this._label.allPositionsEqual(0,w.EXTERIOR),n=!this._label.isArea(1)||this._label.allPositionsEqual(1,w.EXTERIOR);return t&&e&&n},e.prototype.setEdgeRing=function(t){this._edgeRing=t},e.prototype.getMinEdgeRing=function(){return this._minEdgeRing},e.prototype.getDepthDelta=function(){var t=this._edge.getDepthDelta();return this._isForward||(t=-t),t},e.prototype.setInResult=function(t){this._isInResult=t},e.prototype.getSym=function(){return this._sym},e.prototype.isForward=function(){return this._isForward},e.prototype.getEdge=function(){return this._edge},e.prototype.printEdge=function(t){this.print(t),t.print(" "),this._isForward?this._edge.print(t):this._edge.printReverse(t)},e.prototype.setSym=function(t){this._sym=t},e.prototype.setVisitedEdge=function(t){this.setVisited(t),this._sym.setVisited(t)},e.prototype.setEdgeDepths=function(t,e){var n=this.getEdge().getDepthDelta();this._isForward||(n=-n);var i=1;t===Se.LEFT&&(i=-1);var r=Se.opposite(t),o=e+n*i;this.setDepth(t,e),this.setDepth(r,o)},e.prototype.getEdgeRing=function(){return this._edgeRing},e.prototype.isInResult=function(){return this._isInResult},e.prototype.setNext=function(t){this._next=t},e.prototype.isVisited=function(){return this._isVisited},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e.depthFactor=function(t,e){return t===w.EXTERIOR&&e===w.INTERIOR?1:t===w.INTERIOR&&e===w.EXTERIOR?-1:0},e}(Ue),Xe=function(){};Xe.prototype.createNode=function(t){return new Ge(t,null)},Xe.prototype.interfaces_=function(){return[]},Xe.prototype.getClass=function(){return Xe};var Ye=function(){if(this._edges=new Nt,this._nodes=null,this._edgeEndList=new Nt,0===arguments.length)this._nodes=new qe(new Xe);else if(1===arguments.length){var t=arguments[0];this._nodes=new qe(t)}};Ye.prototype.printEdges=function(t){t.println("Edges:");for(var e=0;e<this._edges.size();e++){t.println("edge "+e+":");var n=this._edges.get(e);n.print(t),n.eiList.print(t)}},Ye.prototype.find=function(t){return this._nodes.find(t)},Ye.prototype.addNode=function(){if(arguments[0]instanceof Ge){var t=arguments[0];return this._nodes.addNode(t)}if(arguments[0]instanceof C){var e=arguments[0];return this._nodes.addNode(e)}},Ye.prototype.getNodeIterator=function(){return this._nodes.iterator()},Ye.prototype.linkResultDirectedEdges=function(){for(var t=this._nodes.iterator();t.hasNext();){t.next().getEdges().linkResultDirectedEdges()}},Ye.prototype.debugPrintln=function(t){Y.out.println(t)},Ye.prototype.isBoundaryNode=function(t,e){var n=this._nodes.find(e);if(null===n)return!1;var i=n.getLabel();return null!==i&&i.getLocation(t)===w.BOUNDARY},Ye.prototype.linkAllDirectedEdges=function(){for(var t=this._nodes.iterator();t.hasNext();){t.next().getEdges().linkAllDirectedEdges()}},Ye.prototype.matchInSameDirection=function(t,e,n,i){return!!t.equals(n)&&(at.computeOrientation(t,e,i)===at.COLLINEAR&&Be.quadrant(t,e)===Be.quadrant(n,i))},Ye.prototype.getEdgeEnds=function(){return this._edgeEndList},Ye.prototype.debugPrint=function(t){Y.out.print(t)},Ye.prototype.getEdgeIterator=function(){return this._edges.iterator()},Ye.prototype.findEdgeInSameDirection=function(t,e){for(var n=0;n<this._edges.size();n++){var i=this._edges.get(n),r=i.getCoordinates();if(this.matchInSameDirection(t,e,r[0],r[1]))return i;if(this.matchInSameDirection(t,e,r[r.length-1],r[r.length-2]))return i}return null},Ye.prototype.insertEdge=function(t){this._edges.add(t)},Ye.prototype.findEdgeEnd=function(t){for(var e=this.getEdgeEnds().iterator();e.hasNext();){var n=e.next();if(n.getEdge()===t)return n}return null},Ye.prototype.addEdges=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();this._edges.add(n);var i=new ze(n,!0),r=new ze(n,!1);i.setSym(r),r.setSym(i),this.add(i),this.add(r)}},Ye.prototype.add=function(t){this._nodes.add(t),this._edgeEndList.add(t)},Ye.prototype.getNodes=function(){return this._nodes.values()},Ye.prototype.findEdge=function(t,e){for(var n=0;n<this._edges.size();n++){var i=this._edges.get(n),r=i.getCoordinates();if(t.equals(r[0])&&e.equals(r[1]))return i}return null},Ye.prototype.interfaces_=function(){return[]},Ye.prototype.getClass=function(){return Ye},Ye.linkResultDirectedEdges=function(t){for(var e=t.iterator();e.hasNext();){e.next().getEdges().linkResultDirectedEdges()}};var ke=function(){this._geometryFactory=null,this._shellList=new Nt;var t=arguments[0];this._geometryFactory=t};ke.prototype.sortShellsAndHoles=function(t,e,n){for(var i=t.iterator();i.hasNext();){var r=i.next();r.isHole()?n.add(r):e.add(r)}},ke.prototype.computePolygons=function(t){for(var e=new Nt,n=t.iterator();n.hasNext();){var i=n.next().toPolygon(this._geometryFactory);e.add(i)}return e},ke.prototype.placeFreeHoles=function(t,e){for(var n=e.iterator();n.hasNext();){var i=n.next();if(null===i.getShell()){var r=this.findEdgeRingContaining(i,t);if(null===r)throw new we("unable to assign hole to a shell",i.getCoordinate(0));i.setShell(r)}}},ke.prototype.buildMinimalEdgeRings=function(t,e,n){for(var i=new Nt,r=t.iterator();r.hasNext();){var o=r.next();if(o.getMaxNodeDegree()>2){o.linkDirectedEdgesForMinimalEdgeRings();var s=o.buildMinimalRings(),a=this.findShell(s);null!==a?(this.placePolygonHoles(a,s),e.add(a)):n.addAll(s)}else i.add(o)}return i},ke.prototype.containsPoint=function(t){for(var e=this._shellList.iterator();e.hasNext();){if(e.next().containsPoint(t))return!0}return!1},ke.prototype.buildMaximalEdgeRings=function(t){for(var e=new Nt,n=t.iterator();n.hasNext();){var i=n.next();if(i.isInResult()&&i.getLabel().isArea()&&null===i.getEdgeRing()){var r=new Ae(i,this._geometryFactory);e.add(r),r.setInResult()}}return e},ke.prototype.placePolygonHoles=function(t,e){for(var n=e.iterator();n.hasNext();){var i=n.next();i.isHole()&&i.setShell(t)}},ke.prototype.getPolygons=function(){return this.computePolygons(this._shellList)},ke.prototype.findEdgeRingContaining=function(t,e){for(var n=t.getLinearRing(),i=n.getEnvelopeInternal(),r=n.getCoordinateN(0),o=null,s=null,a=e.iterator();a.hasNext();){var u=a.next(),l=u.getLinearRing(),c=l.getEnvelopeInternal();null!==o&&(s=o.getLinearRing().getEnvelopeInternal());var p=!1;c.contains(i)&&at.isPointInRing(r,l.getCoordinates())&&(p=!0),p&&(null===o||s.contains(c))&&(o=u)}return o},ke.prototype.findShell=function(t){for(var e=0,n=null,i=t.iterator();i.hasNext();){var r=i.next();r.isHole()||(n=r,e++)}return et.isTrue(e<=1,"found two shells in MinimalEdgeRing list"),n},ke.prototype.add=function(){if(1===arguments.length){var t=arguments[0];this.add(t.getEdgeEnds(),t.getNodes())}else if(2===arguments.length){var e=arguments[0],n=arguments[1];Ye.linkResultDirectedEdges(n);var i=this.buildMaximalEdgeRings(e),r=new Nt,o=this.buildMinimalEdgeRings(i,this._shellList,r);this.sortShellsAndHoles(o,this._shellList,r),this.placeFreeHoles(this._shellList,r)}},ke.prototype.interfaces_=function(){return[]},ke.prototype.getClass=function(){return ke};var je=function(){};je.prototype.getBounds=function(){},je.prototype.interfaces_=function(){return[]},je.prototype.getClass=function(){return je};var He=function(){this._bounds=null,this._item=null;var t=arguments[0],e=arguments[1];this._bounds=t,this._item=e};He.prototype.getItem=function(){return this._item},He.prototype.getBounds=function(){return this._bounds},He.prototype.interfaces_=function(){return[je,e]},He.prototype.getClass=function(){return He};var We=function(){this._size=null,this._items=null,this._size=0,this._items=new Nt,this._items.add(null)};We.prototype.poll=function(){if(this.isEmpty())return null;var t=this._items.get(1);return this._items.set(1,this._items.get(this._size)),this._size-=1,this.reorder(1),t},We.prototype.size=function(){return this._size},We.prototype.reorder=function(t){for(var e=null,n=this._items.get(t);2*t<=this._size&&((e=2*t)!==this._size&&this._items.get(e+1).compareTo(this._items.get(e))<0&&e++,this._items.get(e).compareTo(n)<0);t=e)this._items.set(t,this._items.get(e));this._items.set(t,n)},We.prototype.clear=function(){this._size=0,this._items.clear()},We.prototype.isEmpty=function(){return 0===this._size},We.prototype.add=function(t){this._items.add(null),this._size+=1;var e=this._size;for(this._items.set(0,t);t.compareTo(this._items.get(Math.trunc(e/2)))<0;e/=2)this._items.set(e,this._items.get(Math.trunc(e/2)));this._items.set(e,t)},We.prototype.interfaces_=function(){return[]},We.prototype.getClass=function(){return We};var Ke=function(){};Ke.prototype.visitItem=function(t){},Ke.prototype.interfaces_=function(){return[]},Ke.prototype.getClass=function(){return Ke};var Je=function(){};Je.prototype.insert=function(t,e){},Je.prototype.remove=function(t,e){},Je.prototype.query=function(){},Je.prototype.interfaces_=function(){return[]},Je.prototype.getClass=function(){return Je};var Qe=function(){if(this._childBoundables=new Nt,this._bounds=null,this._level=null,0===arguments.length);else if(1===arguments.length){var t=arguments[0];this._level=t}},Ze={serialVersionUID:{configurable:!0}};Qe.prototype.getLevel=function(){return this._level},Qe.prototype.size=function(){return this._childBoundables.size()},Qe.prototype.getChildBoundables=function(){return this._childBoundables},Qe.prototype.addChildBoundable=function(t){et.isTrue(null===this._bounds),this._childBoundables.add(t)},Qe.prototype.isEmpty=function(){return this._childBoundables.isEmpty()},Qe.prototype.getBounds=function(){return null===this._bounds&&(this._bounds=this.computeBounds()),this._bounds},Qe.prototype.interfaces_=function(){return[je,e]},Qe.prototype.getClass=function(){return Qe},Ze.serialVersionUID.get=function(){return 0x5a1e55ec41369800},Object.defineProperties(Qe,Ze);var $e=function(){};$e.reverseOrder=function(){return{compare:function(t,e){return e.compareTo(t)}}},$e.min=function(t){return $e.sort(t),t.get(0)},$e.sort=function(t,e){var n=t.toArray();e?Gt.sort(n,e):Gt.sort(n);for(var i=t.iterator(),r=0,o=n.length;r<o;r++)i.next(),i.set(n[r])},$e.singletonList=function(t){var e=new Nt;return e.add(t),e};var tn=function(){this._boundable1=null,this._boundable2=null,this._distance=null,this._itemDistance=null;var t=arguments[0],e=arguments[1],n=arguments[2];this._boundable1=t,this._boundable2=e,this._itemDistance=n,this._distance=this.distance()};tn.prototype.expandToQueue=function(t,e){var n=tn.isComposite(this._boundable1),i=tn.isComposite(this._boundable2);if(n&&i)return tn.area(this._boundable1)>tn.area(this._boundable2)?(this.expand(this._boundable1,this._boundable2,t,e),null):(this.expand(this._boundable2,this._boundable1,t,e),null);if(n)return this.expand(this._boundable1,this._boundable2,t,e),null;if(i)return this.expand(this._boundable2,this._boundable1,t,e),null;throw new m("neither boundable is composite")},tn.prototype.isLeaves=function(){return!(tn.isComposite(this._boundable1)||tn.isComposite(this._boundable2))},tn.prototype.compareTo=function(t){var e=t;return this._distance<e._distance?-1:this._distance>e._distance?1:0},tn.prototype.expand=function(t,e,n,i){for(var r=t.getChildBoundables().iterator();r.hasNext();){var o=r.next(),s=new tn(o,e,this._itemDistance);s.getDistance()<i&&n.add(s)}},tn.prototype.getBoundable=function(t){return 0===t?this._boundable1:this._boundable2},tn.prototype.getDistance=function(){return this._distance},tn.prototype.distance=function(){return this.isLeaves()?this._itemDistance.distance(this._boundable1,this._boundable2):this._boundable1.getBounds().distance(this._boundable2.getBounds())},tn.prototype.interfaces_=function(){return[E]},tn.prototype.getClass=function(){return tn},tn.area=function(t){return t.getBounds().getArea()},tn.isComposite=function(t){return t instanceof Qe};var en=function t(){if(this._root=null,this._built=!1,this._itemBoundables=new Nt,this._nodeCapacity=null,0===arguments.length){var e=t.DEFAULT_NODE_CAPACITY;this._nodeCapacity=e}else if(1===arguments.length){var n=arguments[0];et.isTrue(n>1,"Node capacity must be greater than 1"),this._nodeCapacity=n}},nn={IntersectsOp:{configurable:!0},serialVersionUID:{configurable:!0},DEFAULT_NODE_CAPACITY:{configurable:!0}};en.prototype.getNodeCapacity=function(){return this._nodeCapacity},en.prototype.lastNode=function(t){return t.get(t.size()-1)},en.prototype.size=function(){if(0===arguments.length)return this.isEmpty()?0:(this.build(),this.size(this._root));if(1===arguments.length){for(var t=0,e=arguments[0].getChildBoundables().iterator();e.hasNext();){var n=e.next();n instanceof Qe?t+=this.size(n):n instanceof He&&(t+=1)}return t}},en.prototype.removeItem=function(t,e){for(var n=null,i=t.getChildBoundables().iterator();i.hasNext();){var r=i.next();r instanceof He&&r.getItem()===e&&(n=r)}return null!==n&&(t.getChildBoundables().remove(n),!0)},en.prototype.itemsTree=function(){if(0===arguments.length){this.build();var t=this.itemsTree(this._root);return null===t?new Nt:t}if(1===arguments.length){for(var e=arguments[0],n=new Nt,i=e.getChildBoundables().iterator();i.hasNext();){var r=i.next();if(r instanceof Qe){var o=this.itemsTree(r);null!==o&&n.add(o)}else r instanceof He?n.add(r.getItem()):et.shouldNeverReachHere()}return n.size()<=0?null:n}},en.prototype.insert=function(t,e){et.isTrue(!this._built,"Cannot insert items into an STR packed R-tree after it has been built."),this._itemBoundables.add(new He(t,e))},en.prototype.boundablesAtLevel=function(){if(1===arguments.length){var t=arguments[0],e=new Nt;return this.boundablesAtLevel(t,this._root,e),e}if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];if(et.isTrue(n>-2),i.getLevel()===n)return r.add(i),null;for(var o=i.getChildBoundables().iterator();o.hasNext();){var s=o.next();s instanceof Qe?this.boundablesAtLevel(n,s,r):(et.isTrue(s instanceof He),-1===n&&r.add(s))}return null}},en.prototype.query=function(){if(1===arguments.length){var t=arguments[0];this.build();var e=new Nt;return this.isEmpty()?e:(this.getIntersectsOp().intersects(this._root.getBounds(),t)&&this.query(t,this._root,e),e)}if(2===arguments.length){var n=arguments[0],i=arguments[1];if(this.build(),this.isEmpty())return null;this.getIntersectsOp().intersects(this._root.getBounds(),n)&&this.query(n,this._root,i)}else if(3===arguments.length)if(T(arguments[2],Ke)&&arguments[0]instanceof Object&&arguments[1]instanceof Qe)for(var r=arguments[0],o=arguments[1],s=arguments[2],a=o.getChildBoundables(),u=0;u<a.size();u++){var l=a.get(u);this.getIntersectsOp().intersects(l.getBounds(),r)&&(l instanceof Qe?this.query(r,l,s):l instanceof He?s.visitItem(l.getItem()):et.shouldNeverReachHere())}else if(T(arguments[2],xt)&&arguments[0]instanceof Object&&arguments[1]instanceof Qe)for(var c=arguments[0],p=arguments[1],h=arguments[2],f=p.getChildBoundables(),g=0;g<f.size();g++){var d=f.get(g);this.getIntersectsOp().intersects(d.getBounds(),c)&&(d instanceof Qe?this.query(c,d,h):d instanceof He?h.add(d.getItem()):et.shouldNeverReachHere())}},en.prototype.build=function(){if(this._built)return null;this._root=this._itemBoundables.isEmpty()?this.createNode(0):this.createHigherLevels(this._itemBoundables,-1),this._itemBoundables=null,this._built=!0},en.prototype.getRoot=function(){return this.build(),this._root},en.prototype.remove=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return this.build(),!!this.getIntersectsOp().intersects(this._root.getBounds(),t)&&this.remove(t,this._root,e)}if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2],o=this.removeItem(i,r);if(o)return!0;for(var s=null,a=i.getChildBoundables().iterator();a.hasNext();){var u=a.next();if(this.getIntersectsOp().intersects(u.getBounds(),n)&&(u instanceof Qe&&(o=this.remove(n,u,r)))){s=u;break}}return null!==s&&s.getChildBoundables().isEmpty()&&i.getChildBoundables().remove(s),o}},en.prototype.createHigherLevels=function(t,e){et.isTrue(!t.isEmpty());var n=this.createParentBoundables(t,e+1);return 1===n.size()?n.get(0):this.createHigherLevels(n,e+1)},en.prototype.depth=function(){if(0===arguments.length)return this.isEmpty()?0:(this.build(),this.depth(this._root));if(1===arguments.length){for(var t=0,e=arguments[0].getChildBoundables().iterator();e.hasNext();){var n=e.next();if(n instanceof Qe){var i=this.depth(n);i>t&&(t=i)}}return t+1}},en.prototype.createParentBoundables=function(t,e){et.isTrue(!t.isEmpty());var n=new Nt;n.add(this.createNode(e));var i=new Nt(t);$e.sort(i,this.getComparator());for(var r=i.iterator();r.hasNext();){var o=r.next();this.lastNode(n).getChildBoundables().size()===this.getNodeCapacity()&&n.add(this.createNode(e)),this.lastNode(n).addChildBoundable(o)}return n},en.prototype.isEmpty=function(){return this._built?this._root.isEmpty():this._itemBoundables.isEmpty()},en.prototype.interfaces_=function(){return[e]},en.prototype.getClass=function(){return en},en.compareDoubles=function(t,e){return t>e?1:t<e?-1:0},nn.IntersectsOp.get=function(){return rn},nn.serialVersionUID.get=function(){return-0x35ef64c82d4c5400},nn.DEFAULT_NODE_CAPACITY.get=function(){return 10},Object.defineProperties(en,nn);var rn=function(){},on=function(){};on.prototype.distance=function(t,e){},on.prototype.interfaces_=function(){return[]},on.prototype.getClass=function(){return on};var sn=function(t){function n(e){e=e||n.DEFAULT_NODE_CAPACITY,t.call(this,e)}t&&(n.__proto__=t),(n.prototype=Object.create(t&&t.prototype)).constructor=n;var i={STRtreeNode:{configurable:!0},serialVersionUID:{configurable:!0},xComparator:{configurable:!0},yComparator:{configurable:!0},intersectsOp:{configurable:!0},DEFAULT_NODE_CAPACITY:{configurable:!0}};return n.prototype.createParentBoundablesFromVerticalSlices=function(t,e){et.isTrue(t.length>0);for(var n=new Nt,i=0;i<t.length;i++)n.addAll(this.createParentBoundablesFromVerticalSlice(t[i],e));return n},n.prototype.createNode=function(t){return new an(t)},n.prototype.size=function(){return 0===arguments.length?t.prototype.size.call(this):t.prototype.size.apply(this,arguments)},n.prototype.insert=function(){if(2!==arguments.length)return t.prototype.insert.apply(this,arguments);var e=arguments[0],n=arguments[1];if(e.isNull())return null;t.prototype.insert.call(this,e,n)},n.prototype.getIntersectsOp=function(){return n.intersectsOp},n.prototype.verticalSlices=function(t,e){for(var n=Math.trunc(Math.ceil(t.size()/e)),i=new Array(e).fill(null),r=t.iterator(),o=0;o<e;o++){i[o]=new Nt;for(var s=0;r.hasNext()&&s<n;){var a=r.next();i[o].add(a),s++}}return i},n.prototype.query=function(){if(1===arguments.length){var e=arguments[0];return t.prototype.query.call(this,e)}if(2===arguments.length){var n=arguments[0],i=arguments[1];t.prototype.query.call(this,n,i)}else if(3===arguments.length)if(T(arguments[2],Ke)&&arguments[0]instanceof Object&&arguments[1]instanceof Qe){var r=arguments[0],o=arguments[1],s=arguments[2];t.prototype.query.call(this,r,o,s)}else if(T(arguments[2],xt)&&arguments[0]instanceof Object&&arguments[1]instanceof Qe){var a=arguments[0],u=arguments[1],l=arguments[2];t.prototype.query.call(this,a,u,l)}},n.prototype.getComparator=function(){return n.yComparator},n.prototype.createParentBoundablesFromVerticalSlice=function(e,n){return t.prototype.createParentBoundables.call(this,e,n)},n.prototype.remove=function(){if(2===arguments.length){var e=arguments[0],n=arguments[1];return t.prototype.remove.call(this,e,n)}return t.prototype.remove.apply(this,arguments)},n.prototype.depth=function(){return 0===arguments.length?t.prototype.depth.call(this):t.prototype.depth.apply(this,arguments)},n.prototype.createParentBoundables=function(t,e){et.isTrue(!t.isEmpty());var i=Math.trunc(Math.ceil(t.size()/this.getNodeCapacity())),r=new Nt(t);$e.sort(r,n.xComparator);var o=this.verticalSlices(r,Math.trunc(Math.ceil(Math.sqrt(i))));return this.createParentBoundablesFromVerticalSlices(o,e)},n.prototype.nearestNeighbour=function(){if(1===arguments.length){if(T(arguments[0],on)){var t=arguments[0],e=new tn(this.getRoot(),this.getRoot(),t);return this.nearestNeighbour(e)}if(arguments[0]instanceof tn){var i=arguments[0];return this.nearestNeighbour(i,v.POSITIVE_INFINITY)}}else if(2===arguments.length){if(arguments[0]instanceof n&&T(arguments[1],on)){var r=arguments[0],o=arguments[1],s=new tn(this.getRoot(),r.getRoot(),o);return this.nearestNeighbour(s)}if(arguments[0]instanceof tn&&"number"==typeof arguments[1]){var a=arguments[0],u=arguments[1],l=null,c=new We;for(c.add(a);!c.isEmpty()&&u>0;){var p=c.poll(),h=p.getDistance();if(h>=u)break;p.isLeaves()?(u=h,l=p):p.expandToQueue(c,u)}return[l.getBoundable(0).getItem(),l.getBoundable(1).getItem()]}}else if(3===arguments.length){var f=arguments[0],g=arguments[1],d=arguments[2],y=new He(f,g),_=new tn(this.getRoot(),y,d);return this.nearestNeighbour(_)[0]}},n.prototype.interfaces_=function(){return[Je,e]},n.prototype.getClass=function(){return n},n.centreX=function(t){return n.avg(t.getMinX(),t.getMaxX())},n.avg=function(t,e){return(t+e)/2},n.centreY=function(t){return n.avg(t.getMinY(),t.getMaxY())},i.STRtreeNode.get=function(){return an},i.serialVersionUID.get=function(){return 0x39920f7d5f261e0},i.xComparator.get=function(){return{interfaces_:function(){return[N]},compare:function(e,i){return t.compareDoubles(n.centreX(e.getBounds()),n.centreX(i.getBounds()))}}},i.yComparator.get=function(){return{interfaces_:function(){return[N]},compare:function(e,i){return t.compareDoubles(n.centreY(e.getBounds()),n.centreY(i.getBounds()))}}},i.intersectsOp.get=function(){return{interfaces_:function(){return[t.IntersectsOp]},intersects:function(t,e){return t.intersects(e)}}},i.DEFAULT_NODE_CAPACITY.get=function(){return 10},Object.defineProperties(n,i),n}(en),an=function(t){function e(){var e=arguments[0];t.call(this,e)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.computeBounds=function(){for(var t=null,e=this.getChildBoundables().iterator();e.hasNext();){var n=e.next();null===t?t=new j(n.getBounds()):t.expandToInclude(n.getBounds())}return t},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Qe),un=function(){};un.prototype.interfaces_=function(){return[]},un.prototype.getClass=function(){return un},un.relativeSign=function(t,e){return t<e?-1:t>e?1:0},un.compare=function(t,e,n){if(e.equals2D(n))return 0;var i=un.relativeSign(e.x,n.x),r=un.relativeSign(e.y,n.y);switch(t){case 0:return un.compareValue(i,r);case 1:return un.compareValue(r,i);case 2:return un.compareValue(r,-i);case 3:return un.compareValue(-i,r);case 4:return un.compareValue(-i,-r);case 5:return un.compareValue(-r,-i);case 6:return un.compareValue(-r,i);case 7:return un.compareValue(i,-r)}return et.shouldNeverReachHere("invalid octant value"),0},un.compareValue=function(t,e){return t<0?-1:t>0?1:e<0?-1:e>0?1:0};var ln=function(){this._segString=null,this.coord=null,this.segmentIndex=null,this._segmentOctant=null,this._isInterior=null;var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3];this._segString=t,this.coord=new C(e),this.segmentIndex=n,this._segmentOctant=i,this._isInterior=!e.equals2D(t.getCoordinate(n))};ln.prototype.getCoordinate=function(){return this.coord},ln.prototype.print=function(t){t.print(this.coord),t.print(" seg # = "+this.segmentIndex)},ln.prototype.compareTo=function(t){var e=t;return this.segmentIndex<e.segmentIndex?-1:this.segmentIndex>e.segmentIndex?1:this.coord.equals2D(e.coord)?0:un.compare(this._segmentOctant,this.coord,e.coord)},ln.prototype.isEndPoint=function(t){return 0===this.segmentIndex&&!this._isInterior||this.segmentIndex===t},ln.prototype.isInterior=function(){return this._isInterior},ln.prototype.interfaces_=function(){return[E]},ln.prototype.getClass=function(){return ln};var cn=function(){this._nodeMap=new p,this._edge=null;var t=arguments[0];this._edge=t};cn.prototype.getSplitCoordinates=function(){var t=new St;this.addEndpoints();for(var e=this.iterator(),n=e.next();e.hasNext();){var i=e.next();this.addEdgeCoordinates(n,i,t),n=i}return t.toCoordinateArray()},cn.prototype.addCollapsedNodes=function(){var t=new Nt;this.findCollapsesFromInsertedNodes(t),this.findCollapsesFromExistingVertices(t);for(var e=t.iterator();e.hasNext();){var n=e.next().intValue();this.add(this._edge.getCoordinate(n),n)}},cn.prototype.print=function(t){t.println("Intersections:");for(var e=this.iterator();e.hasNext();){e.next().print(t)}},cn.prototype.findCollapsesFromExistingVertices=function(t){for(var e=0;e<this._edge.size()-2;e++){var n=this._edge.getCoordinate(e),i=this._edge.getCoordinate(e+2);n.equals2D(i)&&t.add(new M(e+1))}},cn.prototype.addEdgeCoordinates=function(t,e,n){var i=this._edge.getCoordinate(e.segmentIndex),r=e.isInterior()||!e.coord.equals2D(i);n.add(new C(t.coord),!1);for(var o=t.segmentIndex+1;o<=e.segmentIndex;o++)n.add(this._edge.getCoordinate(o));r&&n.add(new C(e.coord))},cn.prototype.iterator=function(){return this._nodeMap.values().iterator()},cn.prototype.addSplitEdges=function(t){this.addEndpoints(),this.addCollapsedNodes();for(var e=this.iterator(),n=e.next();e.hasNext();){var i=e.next(),r=this.createSplitEdge(n,i);t.add(r),n=i}},cn.prototype.findCollapseIndex=function(t,e,n){if(!t.coord.equals2D(e.coord))return!1;var i=e.segmentIndex-t.segmentIndex;return e.isInterior()||i--,1===i&&(n[0]=t.segmentIndex+1,!0)},cn.prototype.findCollapsesFromInsertedNodes=function(t){for(var e=new Array(1).fill(null),n=this.iterator(),i=n.next();n.hasNext();){var r=n.next();this.findCollapseIndex(i,r,e)&&t.add(new M(e[0])),i=r}},cn.prototype.getEdge=function(){return this._edge},cn.prototype.addEndpoints=function(){var t=this._edge.size()-1;this.add(this._edge.getCoordinate(0),0),this.add(this._edge.getCoordinate(t),t)},cn.prototype.createSplitEdge=function(t,e){var n=e.segmentIndex-t.segmentIndex+2,i=this._edge.getCoordinate(e.segmentIndex),r=e.isInterior()||!e.coord.equals2D(i);r||n--;var o=new Array(n).fill(null),s=0;o[s++]=new C(t.coord);for(var a=t.segmentIndex+1;a<=e.segmentIndex;a++)o[s++]=this._edge.getCoordinate(a);return r&&(o[s]=new C(e.coord)),new gn(o,this._edge.getData())},cn.prototype.add=function(t,e){var n=new ln(this._edge,t,e,this._edge.getSegmentOctant(e)),i=this._nodeMap.get(n);return null!==i?(et.isTrue(i.coord.equals2D(t),"Found equal nodes with different coordinates"),i):(this._nodeMap.put(n,n),n)},cn.prototype.checkSplitEdgesCorrectness=function(t){var e=this._edge.getCoordinates(),n=t.get(0).getCoordinate(0);if(!n.equals2D(e[0]))throw new $("bad split edge start point at "+n);var i=t.get(t.size()-1).getCoordinates(),r=i[i.length-1];if(!r.equals2D(e[e.length-1]))throw new $("bad split edge end point at "+r)},cn.prototype.interfaces_=function(){return[]},cn.prototype.getClass=function(){return cn};var pn=function(){};pn.prototype.interfaces_=function(){return[]},pn.prototype.getClass=function(){return pn},pn.octant=function(){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){var t=arguments[0],e=arguments[1];if(0===t&&0===e)throw new m("Cannot compute the octant for point ( "+t+", "+e+" )");var n=Math.abs(t),i=Math.abs(e);return t>=0?e>=0?n>=i?0:1:n>=i?7:6:e>=0?n>=i?3:2:n>=i?4:5}if(arguments[0]instanceof C&&arguments[1]instanceof C){var r=arguments[0],o=arguments[1],s=o.x-r.x,a=o.y-r.y;if(0===s&&0===a)throw new m("Cannot compute the octant for two identical points "+r);return pn.octant(s,a)}};var hn=function(){};hn.prototype.getCoordinates=function(){},hn.prototype.size=function(){},hn.prototype.getCoordinate=function(t){},hn.prototype.isClosed=function(){},hn.prototype.setData=function(t){},hn.prototype.getData=function(){},hn.prototype.interfaces_=function(){return[]},hn.prototype.getClass=function(){return hn};var fn=function(){};fn.prototype.addIntersection=function(t,e){},fn.prototype.interfaces_=function(){return[hn]},fn.prototype.getClass=function(){return fn};var gn=function(){this._nodeList=new cn(this),this._pts=null,this._data=null;var t=arguments[0],e=arguments[1];this._pts=t,this._data=e};gn.prototype.getCoordinates=function(){return this._pts},gn.prototype.size=function(){return this._pts.length},gn.prototype.getCoordinate=function(t){return this._pts[t]},gn.prototype.isClosed=function(){return this._pts[0].equals(this._pts[this._pts.length-1])},gn.prototype.getSegmentOctant=function(t){return t===this._pts.length-1?-1:this.safeOctant(this.getCoordinate(t),this.getCoordinate(t+1))},gn.prototype.setData=function(t){this._data=t},gn.prototype.safeOctant=function(t,e){return t.equals2D(e)?0:pn.octant(t,e)},gn.prototype.getData=function(){return this._data},gn.prototype.addIntersection=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];this.addIntersectionNode(t,e)}else if(4===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[3],o=new C(n.getIntersection(r));this.addIntersection(o,i)}},gn.prototype.toString=function(){return Z.toLineString(new ue(this._pts))},gn.prototype.getNodeList=function(){return this._nodeList},gn.prototype.addIntersectionNode=function(t,e){var n=e,i=n+1;if(i<this._pts.length){var r=this._pts[i];t.equals2D(r)&&(n=i)}return this._nodeList.add(t,n)},gn.prototype.addIntersections=function(t,e,n){for(var i=0;i<t.getIntersectionNum();i++)this.addIntersection(t,e,n,i)},gn.prototype.interfaces_=function(){return[fn]},gn.prototype.getClass=function(){return gn},gn.getNodedSubstrings=function(){if(1===arguments.length){var t=arguments[0],e=new Nt;return gn.getNodedSubstrings(t,e),e}if(2===arguments.length)for(var n=arguments[0],i=arguments[1],r=n.iterator();r.hasNext();){r.next().getNodeList().addSplitEdges(i)}};var dn=function(){if(this.p0=null,this.p1=null,0===arguments.length)this.p0=new C,this.p1=new C;else if(1===arguments.length){var t=arguments[0];this.p0=new C(t.p0),this.p1=new C(t.p1)}else if(2===arguments.length)this.p0=arguments[0],this.p1=arguments[1];else if(4===arguments.length){var e=arguments[0],n=arguments[1],i=arguments[2],r=arguments[3];this.p0=new C(e,n),this.p1=new C(i,r)}},yn={serialVersionUID:{configurable:!0}};dn.prototype.minX=function(){return Math.min(this.p0.x,this.p1.x)},dn.prototype.orientationIndex=function(){if(arguments[0]instanceof dn){var t=arguments[0],e=at.orientationIndex(this.p0,this.p1,t.p0),n=at.orientationIndex(this.p0,this.p1,t.p1);return e>=0&&n>=0?Math.max(e,n):e<=0&&n<=0?Math.max(e,n):0}if(arguments[0]instanceof C){var i=arguments[0];return at.orientationIndex(this.p0,this.p1,i)}},dn.prototype.toGeometry=function(t){return t.createLineString([this.p0,this.p1])},dn.prototype.isVertical=function(){return this.p0.x===this.p1.x},dn.prototype.equals=function(t){if(!(t instanceof dn))return!1;var e=t;return this.p0.equals(e.p0)&&this.p1.equals(e.p1)},dn.prototype.intersection=function(t){var e=new rt;return e.computeIntersection(this.p0,this.p1,t.p0,t.p1),e.hasIntersection()?e.getIntersection(0):null},dn.prototype.project=function(){if(arguments[0]instanceof C){var t=arguments[0];if(t.equals(this.p0)||t.equals(this.p1))return new C(t);var e=this.projectionFactor(t),n=new C;return n.x=this.p0.x+e*(this.p1.x-this.p0.x),n.y=this.p0.y+e*(this.p1.y-this.p0.y),n}if(arguments[0]instanceof dn){var i=arguments[0],r=this.projectionFactor(i.p0),o=this.projectionFactor(i.p1);if(r>=1&&o>=1)return null;if(r<=0&&o<=0)return null;var s=this.project(i.p0);r<0&&(s=this.p0),r>1&&(s=this.p1);var a=this.project(i.p1);return o<0&&(a=this.p0),o>1&&(a=this.p1),new dn(s,a)}},dn.prototype.normalize=function(){this.p1.compareTo(this.p0)<0&&this.reverse()},dn.prototype.angle=function(){return Math.atan2(this.p1.y-this.p0.y,this.p1.x-this.p0.x)},dn.prototype.getCoordinate=function(t){return 0===t?this.p0:this.p1},dn.prototype.distancePerpendicular=function(t){return at.distancePointLinePerpendicular(t,this.p0,this.p1)},dn.prototype.minY=function(){return Math.min(this.p0.y,this.p1.y)},dn.prototype.midPoint=function(){return dn.midPoint(this.p0,this.p1)},dn.prototype.projectionFactor=function(t){if(t.equals(this.p0))return 0;if(t.equals(this.p1))return 1;var e=this.p1.x-this.p0.x,n=this.p1.y-this.p0.y,i=e*e+n*n;if(i<=0)return v.NaN;return((t.x-this.p0.x)*e+(t.y-this.p0.y)*n)/i},dn.prototype.closestPoints=function(t){var e=this.intersection(t);if(null!==e)return[e,e];var n=new Array(2).fill(null),i=v.MAX_VALUE,r=null,o=this.closestPoint(t.p0);i=o.distance(t.p0),n[0]=o,n[1]=t.p0;var s=this.closestPoint(t.p1);(r=s.distance(t.p1))<i&&(i=r,n[0]=s,n[1]=t.p1);var a=t.closestPoint(this.p0);(r=a.distance(this.p0))<i&&(i=r,n[0]=this.p0,n[1]=a);var u=t.closestPoint(this.p1);return(r=u.distance(this.p1))<i&&(i=r,n[0]=this.p1,n[1]=u),n},dn.prototype.closestPoint=function(t){var e=this.projectionFactor(t);if(e>0&&e<1)return this.project(t);return this.p0.distance(t)<this.p1.distance(t)?this.p0:this.p1},dn.prototype.maxX=function(){return Math.max(this.p0.x,this.p1.x)},dn.prototype.getLength=function(){return this.p0.distance(this.p1)},dn.prototype.compareTo=function(t){var e=t,n=this.p0.compareTo(e.p0);return 0!==n?n:this.p1.compareTo(e.p1)},dn.prototype.reverse=function(){var t=this.p0;this.p0=this.p1,this.p1=t},dn.prototype.equalsTopo=function(t){return this.p0.equals(t.p0)&&(this.p1.equals(t.p1)||this.p0.equals(t.p1))&&this.p1.equals(t.p0)},dn.prototype.lineIntersection=function(t){try{return k.intersection(this.p0,this.p1,t.p0,t.p1)}catch(t){if(!(t instanceof X))throw t}return null},dn.prototype.maxY=function(){return Math.max(this.p0.y,this.p1.y)},dn.prototype.pointAlongOffset=function(t,e){var n=this.p0.x+t*(this.p1.x-this.p0.x),i=this.p0.y+t*(this.p1.y-this.p0.y),r=this.p1.x-this.p0.x,o=this.p1.y-this.p0.y,s=Math.sqrt(r*r+o*o),a=0,u=0;if(0!==e){if(s<=0)throw new Error("Cannot compute offset from zero-length line segment");a=e*r/s,u=e*o/s}return new C(n-u,i+a)},dn.prototype.setCoordinates=function(){if(1===arguments.length){var t=arguments[0];this.setCoordinates(t.p0,t.p1)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.p0.x=e.x,this.p0.y=e.y,this.p1.x=n.x,this.p1.y=n.y}},dn.prototype.segmentFraction=function(t){var e=this.projectionFactor(t);return e<0?e=0:(e>1||v.isNaN(e))&&(e=1),e},dn.prototype.toString=function(){return"LINESTRING( "+this.p0.x+" "+this.p0.y+", "+this.p1.x+" "+this.p1.y+")"},dn.prototype.isHorizontal=function(){return this.p0.y===this.p1.y},dn.prototype.distance=function(){if(arguments[0]instanceof dn){var t=arguments[0];return at.distanceLineLine(this.p0,this.p1,t.p0,t.p1)}if(arguments[0]instanceof C){var e=arguments[0];return at.distancePointLine(e,this.p0,this.p1)}},dn.prototype.pointAlong=function(t){var e=new C;return e.x=this.p0.x+t*(this.p1.x-this.p0.x),e.y=this.p0.y+t*(this.p1.y-this.p0.y),e},dn.prototype.hashCode=function(){var t=v.doubleToLongBits(this.p0.x);t^=31*v.doubleToLongBits(this.p0.y);var e=Math.trunc(t)^Math.trunc(t>>32),n=v.doubleToLongBits(this.p1.x);n^=31*v.doubleToLongBits(this.p1.y);return e^(Math.trunc(n)^Math.trunc(n>>32))},dn.prototype.interfaces_=function(){return[E,e]},dn.prototype.getClass=function(){return dn},dn.midPoint=function(t,e){return new C((t.x+e.x)/2,(t.y+e.y)/2)},yn.serialVersionUID.get=function(){return 0x2d2172135f411c00},Object.defineProperties(dn,yn);var _n=function(){this.tempEnv1=new j,this.tempEnv2=new j,this._overlapSeg1=new dn,this._overlapSeg2=new dn};_n.prototype.overlap=function(){if(2===arguments.length);else if(4===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3];t.getLineSegment(e,this._overlapSeg1),n.getLineSegment(i,this._overlapSeg2),this.overlap(this._overlapSeg1,this._overlapSeg2)}},_n.prototype.interfaces_=function(){return[]},_n.prototype.getClass=function(){return _n};var mn=function(){this._pts=null,this._start=null,this._end=null,this._env=null,this._context=null,this._id=null;var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3];this._pts=t,this._start=e,this._end=n,this._context=i};mn.prototype.getLineSegment=function(t,e){e.p0=this._pts[t],e.p1=this._pts[t+1]},mn.prototype.computeSelect=function(t,e,n,i){var r=this._pts[e],o=this._pts[n];if(i.tempEnv1.init(r,o),n-e==1)return i.select(this,e),null;if(!t.intersects(i.tempEnv1))return null;var s=Math.trunc((e+n)/2);e<s&&this.computeSelect(t,e,s,i),s<n&&this.computeSelect(t,s,n,i)},mn.prototype.getCoordinates=function(){for(var t=new Array(this._end-this._start+1).fill(null),e=0,n=this._start;n<=this._end;n++)t[e++]=this._pts[n];return t},mn.prototype.computeOverlaps=function(t,e){this.computeOverlapsInternal(this._start,this._end,t,t._start,t._end,e)},mn.prototype.setId=function(t){this._id=t},mn.prototype.select=function(t,e){this.computeSelect(t,this._start,this._end,e)},mn.prototype.getEnvelope=function(){if(null===this._env){var t=this._pts[this._start],e=this._pts[this._end];this._env=new j(t,e)}return this._env},mn.prototype.getEndIndex=function(){return this._end},mn.prototype.getStartIndex=function(){return this._start},mn.prototype.getContext=function(){return this._context},mn.prototype.getId=function(){return this._id},mn.prototype.computeOverlapsInternal=function(t,e,n,i,r,o){var s=this._pts[t],a=this._pts[e],u=n._pts[i],l=n._pts[r];if(e-t==1&&r-i==1)return o.overlap(this,t,n,i),null;if(o.tempEnv1.init(s,a),o.tempEnv2.init(u,l),!o.tempEnv1.intersects(o.tempEnv2))return null;var c=Math.trunc((t+e)/2),p=Math.trunc((i+r)/2);t<c&&(i<p&&this.computeOverlapsInternal(t,c,n,i,p,o),p<r&&this.computeOverlapsInternal(t,c,n,p,r,o)),c<e&&(i<p&&this.computeOverlapsInternal(c,e,n,i,p,o),p<r&&this.computeOverlapsInternal(c,e,n,p,r,o))},mn.prototype.interfaces_=function(){return[]},mn.prototype.getClass=function(){return mn};var vn=function(){};vn.prototype.interfaces_=function(){return[]},vn.prototype.getClass=function(){return vn},vn.getChainStartIndices=function(t){var e=0,n=new Nt;n.add(new M(e));do{var i=vn.findChainEnd(t,e);n.add(new M(i)),e=i}while(e<t.length-1);return vn.toIntArray(n)},vn.findChainEnd=function(t,e){for(var n=e;n<t.length-1&&t[n].equals2D(t[n+1]);)n++;if(n>=t.length-1)return t.length-1;for(var i=Be.quadrant(t[n],t[n+1]),r=e+1;r<t.length;){if(!t[r-1].equals2D(t[r])){if(Be.quadrant(t[r-1],t[r])!==i)break}r++}return r-1},vn.getChains=function(){if(1===arguments.length){var t=arguments[0];return vn.getChains(t,null)}if(2===arguments.length){for(var e=arguments[0],n=arguments[1],i=new Nt,r=vn.getChainStartIndices(e),o=0;o<r.length-1;o++){var s=new mn(e,r[o],r[o+1],n);i.add(s)}return i}},vn.toIntArray=function(t){for(var e=new Array(t.size()).fill(null),n=0;n<e.length;n++)e[n]=t.get(n).intValue();return e};var In=function(){};In.prototype.computeNodes=function(t){},In.prototype.getNodedSubstrings=function(){},In.prototype.interfaces_=function(){return[]},In.prototype.getClass=function(){return In};var En=function(){if(this._segInt=null,0===arguments.length);else if(1===arguments.length){var t=arguments[0];this.setSegmentIntersector(t)}};En.prototype.setSegmentIntersector=function(t){this._segInt=t},En.prototype.interfaces_=function(){return[In]},En.prototype.getClass=function(){return En};var xn=function(t){function e(e){e?t.call(this,e):t.call(this),this._monoChains=new Nt,this._index=new sn,this._idCounter=0,this._nodedSegStrings=null,this._nOverlaps=0}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var n={SegmentOverlapAction:{configurable:!0}};return e.prototype.getMonotoneChains=function(){return this._monoChains},e.prototype.getNodedSubstrings=function(){return gn.getNodedSubstrings(this._nodedSegStrings)},e.prototype.getIndex=function(){return this._index},e.prototype.add=function(t){for(var e=vn.getChains(t.getCoordinates(),t).iterator();e.hasNext();){var n=e.next();n.setId(this._idCounter++),this._index.insert(n.getEnvelope(),n),this._monoChains.add(n)}},e.prototype.computeNodes=function(t){this._nodedSegStrings=t;for(var e=t.iterator();e.hasNext();)this.add(e.next());this.intersectChains()},e.prototype.intersectChains=function(){for(var t=new Nn(this._segInt),e=this._monoChains.iterator();e.hasNext();)for(var n=e.next(),i=this._index.query(n.getEnvelope()).iterator();i.hasNext();){var r=i.next();if(r.getId()>n.getId()&&(n.computeOverlaps(r,t),this._nOverlaps++),this._segInt.isDone())return null}},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},n.SegmentOverlapAction.get=function(){return Nn},Object.defineProperties(e,n),e}(En),Nn=function(t){function e(){t.call(this),this._si=null;var e=arguments[0];this._si=e}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.overlap=function(){if(4!==arguments.length)return t.prototype.overlap.apply(this,arguments);var e=arguments[0],n=arguments[1],i=arguments[2],r=arguments[3],o=e.getContext(),s=i.getContext();this._si.processIntersections(o,n,s,r)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(_n),Cn=function t(){if(this._quadrantSegments=t.DEFAULT_QUADRANT_SEGMENTS,this._endCapStyle=t.CAP_ROUND,this._joinStyle=t.JOIN_ROUND,this._mitreLimit=t.DEFAULT_MITRE_LIMIT,this._isSingleSided=!1,this._simplifyFactor=t.DEFAULT_SIMPLIFY_FACTOR,0===arguments.length);else if(1===arguments.length){var e=arguments[0];this.setQuadrantSegments(e)}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this.setQuadrantSegments(n),this.setEndCapStyle(i)}else if(4===arguments.length){var r=arguments[0],o=arguments[1],s=arguments[2],a=arguments[3];this.setQuadrantSegments(r),this.setEndCapStyle(o),this.setJoinStyle(s),this.setMitreLimit(a)}},Sn={CAP_ROUND:{configurable:!0},CAP_FLAT:{configurable:!0},CAP_SQUARE:{configurable:!0},JOIN_ROUND:{configurable:!0},JOIN_MITRE:{configurable:!0},JOIN_BEVEL:{configurable:!0},DEFAULT_QUADRANT_SEGMENTS:{configurable:!0},DEFAULT_MITRE_LIMIT:{configurable:!0},DEFAULT_SIMPLIFY_FACTOR:{configurable:!0}};Cn.prototype.getEndCapStyle=function(){return this._endCapStyle},Cn.prototype.isSingleSided=function(){return this._isSingleSided},Cn.prototype.setQuadrantSegments=function(t){this._quadrantSegments=t,0===this._quadrantSegments&&(this._joinStyle=Cn.JOIN_BEVEL),this._quadrantSegments<0&&(this._joinStyle=Cn.JOIN_MITRE,this._mitreLimit=Math.abs(this._quadrantSegments)),t<=0&&(this._quadrantSegments=1),this._joinStyle!==Cn.JOIN_ROUND&&(this._quadrantSegments=Cn.DEFAULT_QUADRANT_SEGMENTS)},Cn.prototype.getJoinStyle=function(){return this._joinStyle},Cn.prototype.setJoinStyle=function(t){this._joinStyle=t},Cn.prototype.setSimplifyFactor=function(t){this._simplifyFactor=t<0?0:t},Cn.prototype.getSimplifyFactor=function(){return this._simplifyFactor},Cn.prototype.getQuadrantSegments=function(){return this._quadrantSegments},Cn.prototype.setEndCapStyle=function(t){this._endCapStyle=t},Cn.prototype.getMitreLimit=function(){return this._mitreLimit},Cn.prototype.setMitreLimit=function(t){this._mitreLimit=t},Cn.prototype.setSingleSided=function(t){this._isSingleSided=t},Cn.prototype.interfaces_=function(){return[]},Cn.prototype.getClass=function(){return Cn},Cn.bufferDistanceError=function(t){var e=Math.PI/2/t;return 1-Math.cos(e/2)},Sn.CAP_ROUND.get=function(){return 1},Sn.CAP_FLAT.get=function(){return 2},Sn.CAP_SQUARE.get=function(){return 3},Sn.JOIN_ROUND.get=function(){return 1},Sn.JOIN_MITRE.get=function(){return 2},Sn.JOIN_BEVEL.get=function(){return 3},Sn.DEFAULT_QUADRANT_SEGMENTS.get=function(){return 8},Sn.DEFAULT_MITRE_LIMIT.get=function(){return 5},Sn.DEFAULT_SIMPLIFY_FACTOR.get=function(){return.01},Object.defineProperties(Cn,Sn);var Ln=function(t){this._distanceTol=null,this._isDeleted=null,this._angleOrientation=at.COUNTERCLOCKWISE,this._inputLine=t||null},bn={INIT:{configurable:!0},DELETE:{configurable:!0},KEEP:{configurable:!0},NUM_PTS_TO_CHECK:{configurable:!0}};Ln.prototype.isDeletable=function(t,e,n,i){var r=this._inputLine[t],o=this._inputLine[e],s=this._inputLine[n];return!!this.isConcave(r,o,s)&&(!!this.isShallow(r,o,s,i)&&this.isShallowSampled(r,o,t,n,i))},Ln.prototype.deleteShallowConcavities=function(){for(var t=1,e=this.findNextNonDeletedIndex(t),n=this.findNextNonDeletedIndex(e),i=!1;n<this._inputLine.length;){var r=!1;this.isDeletable(t,e,n,this._distanceTol)&&(this._isDeleted[e]=Ln.DELETE,r=!0,i=!0),t=r?n:e,e=this.findNextNonDeletedIndex(t),n=this.findNextNonDeletedIndex(e)}return i},Ln.prototype.isShallowConcavity=function(t,e,n,i){if(!(at.computeOrientation(t,e,n)===this._angleOrientation))return!1;return at.distancePointLine(e,t,n)<i},Ln.prototype.isShallowSampled=function(t,e,n,i,r){var o=Math.trunc((i-n)/Ln.NUM_PTS_TO_CHECK);o<=0&&(o=1);for(var s=n;s<i;s+=o)if(!this.isShallow(t,e,this._inputLine[s],r))return!1;return!0},Ln.prototype.isConcave=function(t,e,n){var i=at.computeOrientation(t,e,n)===this._angleOrientation;return i},Ln.prototype.simplify=function(t){this._distanceTol=Math.abs(t),t<0&&(this._angleOrientation=at.CLOCKWISE),this._isDeleted=new Array(this._inputLine.length).fill(null);var e=!1;do{e=this.deleteShallowConcavities()}while(e);return this.collapseLine()},Ln.prototype.findNextNonDeletedIndex=function(t){for(var e=t+1;e<this._inputLine.length&&this._isDeleted[e]===Ln.DELETE;)e++;return e},Ln.prototype.isShallow=function(t,e,n,i){return at.distancePointLine(e,t,n)<i},Ln.prototype.collapseLine=function(){for(var t=new St,e=0;e<this._inputLine.length;e++)this._isDeleted[e]!==Ln.DELETE&&t.add(this._inputLine[e]);return t.toCoordinateArray()},Ln.prototype.interfaces_=function(){return[]},Ln.prototype.getClass=function(){return Ln},Ln.simplify=function(t,e){return new Ln(t).simplify(e)},bn.INIT.get=function(){return 0},bn.DELETE.get=function(){return 1},bn.KEEP.get=function(){return 1},bn.NUM_PTS_TO_CHECK.get=function(){return 10},Object.defineProperties(Ln,bn);var wn=function(){this._ptList=null,this._precisionModel=null,this._minimimVertexDistance=0,this._ptList=new Nt},On={COORDINATE_ARRAY_TYPE:{configurable:!0}};wn.prototype.getCoordinates=function(){return this._ptList.toArray(wn.COORDINATE_ARRAY_TYPE)},wn.prototype.setPrecisionModel=function(t){this._precisionModel=t},wn.prototype.addPt=function(t){var e=new C(t);if(this._precisionModel.makePrecise(e),this.isRedundant(e))return null;this._ptList.add(e)},wn.prototype.revere=function(){},wn.prototype.addPts=function(t,e){if(e)for(var n=0;n<t.length;n++)this.addPt(t[n]);else for(var i=t.length-1;i>=0;i--)this.addPt(t[i])},wn.prototype.isRedundant=function(t){if(this._ptList.size()<1)return!1;var e=this._ptList.get(this._ptList.size()-1);return t.distance(e)<this._minimimVertexDistance},wn.prototype.toString=function(){return(new _e).createLineString(this.getCoordinates()).toString()},wn.prototype.closeRing=function(){if(this._ptList.size()<1)return null;var t=new C(this._ptList.get(0)),e=this._ptList.get(this._ptList.size()-1);if(t.equals(e))return null;this._ptList.add(t)},wn.prototype.setMinimumVertexDistance=function(t){this._minimimVertexDistance=t},wn.prototype.interfaces_=function(){return[]},wn.prototype.getClass=function(){return wn},On.COORDINATE_ARRAY_TYPE.get=function(){return new Array(0).fill(null)},Object.defineProperties(wn,On);var Tn=function(){},Rn={PI_TIMES_2:{configurable:!0},PI_OVER_2:{configurable:!0},PI_OVER_4:{configurable:!0},COUNTERCLOCKWISE:{configurable:!0},CLOCKWISE:{configurable:!0},NONE:{configurable:!0}};Tn.prototype.interfaces_=function(){return[]},Tn.prototype.getClass=function(){return Tn},Tn.toDegrees=function(t){return 180*t/Math.PI},Tn.normalize=function(t){for(;t>Math.PI;)t-=Tn.PI_TIMES_2;for(;t<=-Math.PI;)t+=Tn.PI_TIMES_2;return t},Tn.angle=function(){if(1===arguments.length){var t=arguments[0];return Math.atan2(t.y,t.x)}if(2===arguments.length){var e=arguments[0],n=arguments[1],i=n.x-e.x,r=n.y-e.y;return Math.atan2(r,i)}},Tn.isAcute=function(t,e,n){var i=t.x-e.x,r=t.y-e.y;return i*(n.x-e.x)+r*(n.y-e.y)>0},Tn.isObtuse=function(t,e,n){var i=t.x-e.x,r=t.y-e.y;return i*(n.x-e.x)+r*(n.y-e.y)<0},Tn.interiorAngle=function(t,e,n){var i=Tn.angle(e,t),r=Tn.angle(e,n);return Math.abs(r-i)},Tn.normalizePositive=function(t){if(t<0){for(;t<0;)t+=Tn.PI_TIMES_2;t>=Tn.PI_TIMES_2&&(t=0)}else{for(;t>=Tn.PI_TIMES_2;)t-=Tn.PI_TIMES_2;t<0&&(t=0)}return t},Tn.angleBetween=function(t,e,n){var i=Tn.angle(e,t),r=Tn.angle(e,n);return Tn.diff(i,r)},Tn.diff=function(t,e){var n=null;return(n=t<e?e-t:t-e)>Math.PI&&(n=2*Math.PI-n),n},Tn.toRadians=function(t){return t*Math.PI/180},Tn.getTurn=function(t,e){var n=Math.sin(e-t);return n>0?Tn.COUNTERCLOCKWISE:n<0?Tn.CLOCKWISE:Tn.NONE},Tn.angleBetweenOriented=function(t,e,n){var i=Tn.angle(e,t),r=Tn.angle(e,n)-i;return r<=-Math.PI?r+Tn.PI_TIMES_2:r>Math.PI?r-Tn.PI_TIMES_2:r},Rn.PI_TIMES_2.get=function(){return 2*Math.PI},Rn.PI_OVER_2.get=function(){return Math.PI/2},Rn.PI_OVER_4.get=function(){return Math.PI/4},Rn.COUNTERCLOCKWISE.get=function(){return at.COUNTERCLOCKWISE},Rn.CLOCKWISE.get=function(){return at.CLOCKWISE},Rn.NONE.get=function(){return at.COLLINEAR},Object.defineProperties(Tn,Rn);var Pn=function t(){this._maxCurveSegmentError=0,this._filletAngleQuantum=null,this._closingSegLengthFactor=1,this._segList=null,this._distance=0,this._precisionModel=null,this._bufParams=null,this._li=null,this._s0=null,this._s1=null,this._s2=null,this._seg0=new dn,this._seg1=new dn,this._offset0=new dn,this._offset1=new dn,this._side=0,this._hasNarrowConcaveAngle=!1;var e=arguments[0],n=arguments[1],i=arguments[2];this._precisionModel=e,this._bufParams=n,this._li=new rt,this._filletAngleQuantum=Math.PI/2/n.getQuadrantSegments(),n.getQuadrantSegments()>=8&&n.getJoinStyle()===Cn.JOIN_ROUND&&(this._closingSegLengthFactor=t.MAX_CLOSING_SEG_LEN_FACTOR),this.init(i)},Dn={OFFSET_SEGMENT_SEPARATION_FACTOR:{configurable:!0},INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR:{configurable:!0},CURVE_VERTEX_SNAP_DISTANCE_FACTOR:{configurable:!0},MAX_CLOSING_SEG_LEN_FACTOR:{configurable:!0}};Pn.prototype.addNextSegment=function(t,e){if(this._s0=this._s1,this._s1=this._s2,this._s2=t,this._seg0.setCoordinates(this._s0,this._s1),this.computeOffsetSegment(this._seg0,this._side,this._distance,this._offset0),this._seg1.setCoordinates(this._s1,this._s2),this.computeOffsetSegment(this._seg1,this._side,this._distance,this._offset1),this._s1.equals(this._s2))return null;var n=at.computeOrientation(this._s0,this._s1,this._s2),i=n===at.CLOCKWISE&&this._side===Se.LEFT||n===at.COUNTERCLOCKWISE&&this._side===Se.RIGHT;0===n?this.addCollinear(e):i?this.addOutsideTurn(n,e):this.addInsideTurn(n,e)},Pn.prototype.addLineEndCap=function(t,e){var n=new dn(t,e),i=new dn;this.computeOffsetSegment(n,Se.LEFT,this._distance,i);var r=new dn;this.computeOffsetSegment(n,Se.RIGHT,this._distance,r);var o=e.x-t.x,s=e.y-t.y,a=Math.atan2(s,o);switch(this._bufParams.getEndCapStyle()){case Cn.CAP_ROUND:this._segList.addPt(i.p1),this.addFilletArc(e,a+Math.PI/2,a-Math.PI/2,at.CLOCKWISE,this._distance),this._segList.addPt(r.p1);break;case Cn.CAP_FLAT:this._segList.addPt(i.p1),this._segList.addPt(r.p1);break;case Cn.CAP_SQUARE:var u=new C;u.x=Math.abs(this._distance)*Math.cos(a),u.y=Math.abs(this._distance)*Math.sin(a);var l=new C(i.p1.x+u.x,i.p1.y+u.y),c=new C(r.p1.x+u.x,r.p1.y+u.y);this._segList.addPt(l),this._segList.addPt(c)}},Pn.prototype.getCoordinates=function(){return this._segList.getCoordinates()},Pn.prototype.addMitreJoin=function(t,e,n,i){var r=!0,o=null;try{o=k.intersection(e.p0,e.p1,n.p0,n.p1);(i<=0?1:o.distance(t)/Math.abs(i))>this._bufParams.getMitreLimit()&&(r=!1)}catch(t){if(!(t instanceof X))throw t;o=new C(0,0),r=!1}r?this._segList.addPt(o):this.addLimitedMitreJoin(e,n,i,this._bufParams.getMitreLimit())},Pn.prototype.addFilletCorner=function(t,e,n,i,r){var o=e.x-t.x,s=e.y-t.y,a=Math.atan2(s,o),u=n.x-t.x,l=n.y-t.y,c=Math.atan2(l,u);i===at.CLOCKWISE?a<=c&&(a+=2*Math.PI):a>=c&&(a-=2*Math.PI),this._segList.addPt(e),this.addFilletArc(t,a,c,i,r),this._segList.addPt(n)},Pn.prototype.addOutsideTurn=function(t,e){if(this._offset0.p1.distance(this._offset1.p0)<this._distance*Pn.OFFSET_SEGMENT_SEPARATION_FACTOR)return this._segList.addPt(this._offset0.p1),null;this._bufParams.getJoinStyle()===Cn.JOIN_MITRE?this.addMitreJoin(this._s1,this._offset0,this._offset1,this._distance):this._bufParams.getJoinStyle()===Cn.JOIN_BEVEL?this.addBevelJoin(this._offset0,this._offset1):(e&&this._segList.addPt(this._offset0.p1),this.addFilletCorner(this._s1,this._offset0.p1,this._offset1.p0,t,this._distance),this._segList.addPt(this._offset1.p0))},Pn.prototype.createSquare=function(t){this._segList.addPt(new C(t.x+this._distance,t.y+this._distance)),this._segList.addPt(new C(t.x+this._distance,t.y-this._distance)),this._segList.addPt(new C(t.x-this._distance,t.y-this._distance)),this._segList.addPt(new C(t.x-this._distance,t.y+this._distance)),this._segList.closeRing()},Pn.prototype.addSegments=function(t,e){this._segList.addPts(t,e)},Pn.prototype.addFirstSegment=function(){this._segList.addPt(this._offset1.p0)},Pn.prototype.addLastSegment=function(){this._segList.addPt(this._offset1.p1)},Pn.prototype.initSideSegments=function(t,e,n){this._s1=t,this._s2=e,this._side=n,this._seg1.setCoordinates(t,e),this.computeOffsetSegment(this._seg1,n,this._distance,this._offset1)},Pn.prototype.addLimitedMitreJoin=function(t,e,n,i){var r=this._seg0.p1,o=Tn.angle(r,this._seg0.p0),s=Tn.angleBetweenOriented(this._seg0.p0,r,this._seg1.p1)/2,a=Tn.normalize(o+s),u=Tn.normalize(a+Math.PI),l=i*n,c=n-l*Math.abs(Math.sin(s)),p=r.x+l*Math.cos(u),h=r.y+l*Math.sin(u),f=new C(p,h),g=new dn(r,f),d=g.pointAlongOffset(1,c),y=g.pointAlongOffset(1,-c);this._side===Se.LEFT?(this._segList.addPt(d),this._segList.addPt(y)):(this._segList.addPt(y),this._segList.addPt(d))},Pn.prototype.computeOffsetSegment=function(t,e,n,i){var r=e===Se.LEFT?1:-1,o=t.p1.x-t.p0.x,s=t.p1.y-t.p0.y,a=Math.sqrt(o*o+s*s),u=r*n*o/a,l=r*n*s/a;i.p0.x=t.p0.x-l,i.p0.y=t.p0.y+u,i.p1.x=t.p1.x-l,i.p1.y=t.p1.y+u},Pn.prototype.addFilletArc=function(t,e,n,i,r){var o=i===at.CLOCKWISE?-1:1,s=Math.abs(e-n),a=Math.trunc(s/this._filletAngleQuantum+.5);if(a<1)return null;for(var u=s/a,l=0,c=new C;l<s;){var p=e+o*l;c.x=t.x+r*Math.cos(p),c.y=t.y+r*Math.sin(p),this._segList.addPt(c),l+=u}},Pn.prototype.addInsideTurn=function(t,e){if(this._li.computeIntersection(this._offset0.p0,this._offset0.p1,this._offset1.p0,this._offset1.p1),this._li.hasIntersection())this._segList.addPt(this._li.getIntersection(0));else if(this._hasNarrowConcaveAngle=!0,this._offset0.p1.distance(this._offset1.p0)<this._distance*Pn.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR)this._segList.addPt(this._offset0.p1);else{if(this._segList.addPt(this._offset0.p1),this._closingSegLengthFactor>0){var n=new C((this._closingSegLengthFactor*this._offset0.p1.x+this._s1.x)/(this._closingSegLengthFactor+1),(this._closingSegLengthFactor*this._offset0.p1.y+this._s1.y)/(this._closingSegLengthFactor+1));this._segList.addPt(n);var i=new C((this._closingSegLengthFactor*this._offset1.p0.x+this._s1.x)/(this._closingSegLengthFactor+1),(this._closingSegLengthFactor*this._offset1.p0.y+this._s1.y)/(this._closingSegLengthFactor+1));this._segList.addPt(i)}else this._segList.addPt(this._s1);this._segList.addPt(this._offset1.p0)}},Pn.prototype.createCircle=function(t){var e=new C(t.x+this._distance,t.y);this._segList.addPt(e),this.addFilletArc(t,0,2*Math.PI,-1,this._distance),this._segList.closeRing()},Pn.prototype.addBevelJoin=function(t,e){this._segList.addPt(t.p1),this._segList.addPt(e.p0)},Pn.prototype.init=function(t){this._distance=t,this._maxCurveSegmentError=t*(1-Math.cos(this._filletAngleQuantum/2)),this._segList=new wn,this._segList.setPrecisionModel(this._precisionModel),this._segList.setMinimumVertexDistance(t*Pn.CURVE_VERTEX_SNAP_DISTANCE_FACTOR)},Pn.prototype.addCollinear=function(t){this._li.computeIntersection(this._s0,this._s1,this._s1,this._s2);this._li.getIntersectionNum()>=2&&(this._bufParams.getJoinStyle()===Cn.JOIN_BEVEL||this._bufParams.getJoinStyle()===Cn.JOIN_MITRE?(t&&this._segList.addPt(this._offset0.p1),this._segList.addPt(this._offset1.p0)):this.addFilletCorner(this._s1,this._offset0.p1,this._offset1.p0,at.CLOCKWISE,this._distance))},Pn.prototype.closeRing=function(){this._segList.closeRing()},Pn.prototype.hasNarrowConcaveAngle=function(){return this._hasNarrowConcaveAngle},Pn.prototype.interfaces_=function(){return[]},Pn.prototype.getClass=function(){return Pn},Dn.OFFSET_SEGMENT_SEPARATION_FACTOR.get=function(){return.001},Dn.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR.get=function(){return.001},Dn.CURVE_VERTEX_SNAP_DISTANCE_FACTOR.get=function(){return 1e-6},Dn.MAX_CLOSING_SEG_LEN_FACTOR.get=function(){return 80},Object.defineProperties(Pn,Dn);var Mn=function(){this._distance=0,this._precisionModel=null,this._bufParams=null;var t=arguments[0],e=arguments[1];this._precisionModel=t,this._bufParams=e};Mn.prototype.getOffsetCurve=function(t,e){if(this._distance=e,0===e)return null;var n=e<0,i=Math.abs(e),r=this.getSegGen(i);t.length<=1?this.computePointCurve(t[0],r):this.computeOffsetCurve(t,n,r);var o=r.getCoordinates();return n&&Lt.reverse(o),o},Mn.prototype.computeSingleSidedBufferCurve=function(t,e,n){var i=this.simplifyTolerance(this._distance);if(e){n.addSegments(t,!0);var r=Ln.simplify(t,-i),o=r.length-1;n.initSideSegments(r[o],r[o-1],Se.LEFT),n.addFirstSegment();for(var s=o-2;s>=0;s--)n.addNextSegment(r[s],!0)}else{n.addSegments(t,!1);var a=Ln.simplify(t,i),u=a.length-1;n.initSideSegments(a[0],a[1],Se.LEFT),n.addFirstSegment();for(var l=2;l<=u;l++)n.addNextSegment(a[l],!0)}n.addLastSegment(),n.closeRing()},Mn.prototype.computeRingBufferCurve=function(t,e,n){var i=this.simplifyTolerance(this._distance);e===Se.RIGHT&&(i=-i);var r=Ln.simplify(t,i),o=r.length-1;n.initSideSegments(r[o-1],r[0],e);for(var s=1;s<=o;s++){var a=1!==s;n.addNextSegment(r[s],a)}n.closeRing()},Mn.prototype.computeLineBufferCurve=function(t,e){var n=this.simplifyTolerance(this._distance),i=Ln.simplify(t,n),r=i.length-1;e.initSideSegments(i[0],i[1],Se.LEFT);for(var o=2;o<=r;o++)e.addNextSegment(i[o],!0);e.addLastSegment(),e.addLineEndCap(i[r-1],i[r]);var s=Ln.simplify(t,-n),a=s.length-1;e.initSideSegments(s[a],s[a-1],Se.LEFT);for(var u=a-2;u>=0;u--)e.addNextSegment(s[u],!0);e.addLastSegment(),e.addLineEndCap(s[1],s[0]),e.closeRing()},Mn.prototype.computePointCurve=function(t,e){switch(this._bufParams.getEndCapStyle()){case Cn.CAP_ROUND:e.createCircle(t);break;case Cn.CAP_SQUARE:e.createSquare(t)}},Mn.prototype.getLineCurve=function(t,e){if(this._distance=e,e<0&&!this._bufParams.isSingleSided())return null;if(0===e)return null;var n=Math.abs(e),i=this.getSegGen(n);if(t.length<=1)this.computePointCurve(t[0],i);else if(this._bufParams.isSingleSided()){var r=e<0;this.computeSingleSidedBufferCurve(t,r,i)}else this.computeLineBufferCurve(t,i);return i.getCoordinates()},Mn.prototype.getBufferParameters=function(){return this._bufParams},Mn.prototype.simplifyTolerance=function(t){return t*this._bufParams.getSimplifyFactor()},Mn.prototype.getRingCurve=function(t,e,n){if(this._distance=n,t.length<=2)return this.getLineCurve(t,n);if(0===n)return Mn.copyCoordinates(t);var i=this.getSegGen(n);return this.computeRingBufferCurve(t,e,i),i.getCoordinates()},Mn.prototype.computeOffsetCurve=function(t,e,n){var i=this.simplifyTolerance(this._distance);if(e){var r=Ln.simplify(t,-i),o=r.length-1;n.initSideSegments(r[o],r[o-1],Se.LEFT),n.addFirstSegment();for(var s=o-2;s>=0;s--)n.addNextSegment(r[s],!0)}else{var a=Ln.simplify(t,i),u=a.length-1;n.initSideSegments(a[0],a[1],Se.LEFT),n.addFirstSegment();for(var l=2;l<=u;l++)n.addNextSegment(a[l],!0)}n.addLastSegment()},Mn.prototype.getSegGen=function(t){return new Pn(this._precisionModel,this._bufParams,t)},Mn.prototype.interfaces_=function(){return[]},Mn.prototype.getClass=function(){return Mn},Mn.copyCoordinates=function(t){for(var e=new Array(t.length).fill(null),n=0;n<e.length;n++)e[n]=new C(t[n]);return e};var An=function(){this._subgraphs=null,this._seg=new dn,this._cga=new at;var t=arguments[0];this._subgraphs=t},Fn={DepthSegment:{configurable:!0}};An.prototype.findStabbedSegments=function(){if(1===arguments.length){for(var t=arguments[0],e=new Nt,n=this._subgraphs.iterator();n.hasNext();){var i=n.next(),r=i.getEnvelope();t.y<r.getMinY()||t.y>r.getMaxY()||this.findStabbedSegments(t,i.getDirectedEdges(),e)}return e}if(3===arguments.length)if(T(arguments[2],xt)&&arguments[0]instanceof C&&arguments[1]instanceof ze)for(var o=arguments[0],s=arguments[1],a=arguments[2],u=s.getEdge().getCoordinates(),l=0;l<u.length-1;l++){this._seg.p0=u[l],this._seg.p1=u[l+1],this._seg.p0.y>this._seg.p1.y&&this._seg.reverse();if(!(Math.max(this._seg.p0.x,this._seg.p1.x)<o.x)&&!(this._seg.isHorizontal()||o.y<this._seg.p0.y||o.y>this._seg.p1.y||at.computeOrientation(this._seg.p0,this._seg.p1,o)===at.RIGHT)){var c=s.getDepth(Se.LEFT);this._seg.p0.equals(u[l])||(c=s.getDepth(Se.RIGHT));var p=new Gn(this._seg,c);a.add(p)}}else if(T(arguments[2],xt)&&arguments[0]instanceof C&&T(arguments[1],xt))for(var h=arguments[0],f=arguments[1],g=arguments[2],d=f.iterator();d.hasNext();){var y=d.next();y.isForward()&&this.findStabbedSegments(h,y,g)}},An.prototype.getDepth=function(t){var e=this.findStabbedSegments(t);if(0===e.size())return 0;return $e.min(e)._leftDepth},An.prototype.interfaces_=function(){return[]},An.prototype.getClass=function(){return An},Fn.DepthSegment.get=function(){return Gn},Object.defineProperties(An,Fn);var Gn=function(){this._upwardSeg=null,this._leftDepth=null;var t=arguments[0],e=arguments[1];this._upwardSeg=new dn(t),this._leftDepth=e};Gn.prototype.compareTo=function(t){var e=t;if(this._upwardSeg.minX()>=e._upwardSeg.maxX())return 1;if(this._upwardSeg.maxX()<=e._upwardSeg.minX())return-1;var n=this._upwardSeg.orientationIndex(e._upwardSeg);return 0!==n?n:0!=(n=-1*e._upwardSeg.orientationIndex(this._upwardSeg))?n:this._upwardSeg.compareTo(e._upwardSeg)},Gn.prototype.compareX=function(t,e){var n=t.p0.compareTo(e.p0);return 0!==n?n:t.p1.compareTo(e.p1)},Gn.prototype.toString=function(){return this._upwardSeg.toString()},Gn.prototype.interfaces_=function(){return[E]},Gn.prototype.getClass=function(){return Gn};var qn=function(t,e,n){this.p0=t||null,this.p1=e||null,this.p2=n||null};qn.prototype.area=function(){return qn.area(this.p0,this.p1,this.p2)},qn.prototype.signedArea=function(){return qn.signedArea(this.p0,this.p1,this.p2)},qn.prototype.interpolateZ=function(t){if(null===t)throw new m("Supplied point is null.");return qn.interpolateZ(t,this.p0,this.p1,this.p2)},qn.prototype.longestSideLength=function(){return qn.longestSideLength(this.p0,this.p1,this.p2)},qn.prototype.isAcute=function(){return qn.isAcute(this.p0,this.p1,this.p2)},qn.prototype.circumcentre=function(){return qn.circumcentre(this.p0,this.p1,this.p2)},qn.prototype.area3D=function(){return qn.area3D(this.p0,this.p1,this.p2)},qn.prototype.centroid=function(){return qn.centroid(this.p0,this.p1,this.p2)},qn.prototype.inCentre=function(){return qn.inCentre(this.p0,this.p1,this.p2)},qn.prototype.interfaces_=function(){return[]},qn.prototype.getClass=function(){return qn},qn.area=function(t,e,n){return Math.abs(((n.x-t.x)*(e.y-t.y)-(e.x-t.x)*(n.y-t.y))/2)},qn.signedArea=function(t,e,n){return((n.x-t.x)*(e.y-t.y)-(e.x-t.x)*(n.y-t.y))/2},qn.det=function(t,e,n,i){return t*i-e*n},qn.interpolateZ=function(t,e,n,i){var r=e.x,o=e.y,s=n.x-r,a=i.x-r,u=n.y-o,l=i.y-o,c=s*l-a*u,p=t.x-r,h=t.y-o,f=(l*p-a*h)/c,g=(-u*p+s*h)/c;return e.z+f*(n.z-e.z)+g*(i.z-e.z)},qn.longestSideLength=function(t,e,n){var i=t.distance(e),r=e.distance(n),o=n.distance(t),s=i;return r>s&&(s=r),o>s&&(s=o),s},qn.isAcute=function(t,e,n){return!!Tn.isAcute(t,e,n)&&(!!Tn.isAcute(e,n,t)&&!!Tn.isAcute(n,t,e))},qn.circumcentre=function(t,e,n){var i=n.x,r=n.y,o=t.x-i,s=t.y-r,a=e.x-i,u=e.y-r,l=2*qn.det(o,s,a,u),c=qn.det(s,o*o+s*s,u,a*a+u*u),p=qn.det(o,o*o+s*s,a,a*a+u*u);return new C(i-c/l,r+p/l)},qn.perpendicularBisector=function(t,e){var n=e.x-t.x,i=e.y-t.y,r=new k(t.x+n/2,t.y+i/2,1),o=new k(t.x-i+n/2,t.y+n+i/2,1);return new k(r,o)},qn.angleBisector=function(t,e,n){var i=e.distance(t),r=i/(i+e.distance(n)),o=n.x-t.x,s=n.y-t.y;return new C(t.x+r*o,t.y+r*s)},qn.area3D=function(t,e,n){var i=e.x-t.x,r=e.y-t.y,o=e.z-t.z,s=n.x-t.x,a=n.y-t.y,u=n.z-t.z,l=r*u-o*a,c=o*s-i*u,p=i*a-r*s,h=l*l+c*c+p*p,f=Math.sqrt(h)/2;return f},qn.centroid=function(t,e,n){var i=(t.x+e.x+n.x)/3,r=(t.y+e.y+n.y)/3;return new C(i,r)},qn.inCentre=function(t,e,n){var i=e.distance(n),r=t.distance(n),o=t.distance(e),s=i+r+o,a=(i*t.x+r*e.x+o*n.x)/s,u=(i*t.y+r*e.y+o*n.y)/s;return new C(a,u)};var Bn=function(){this._inputGeom=null,this._distance=null,this._curveBuilder=null,this._curveList=new Nt;var t=arguments[0],e=arguments[1],n=arguments[2];this._inputGeom=t,this._distance=e,this._curveBuilder=n};Bn.prototype.addPoint=function(t){if(this._distance<=0)return null;var e=t.getCoordinates(),n=this._curveBuilder.getLineCurve(e,this._distance);this.addCurve(n,w.EXTERIOR,w.INTERIOR)},Bn.prototype.addPolygon=function(t){var e=this._distance,n=Se.LEFT;this._distance<0&&(e=-this._distance,n=Se.RIGHT);var i=t.getExteriorRing(),r=Lt.removeRepeatedPoints(i.getCoordinates());if(this._distance<0&&this.isErodedCompletely(i,this._distance))return null;if(this._distance<=0&&r.length<3)return null;this.addPolygonRing(r,e,n,w.EXTERIOR,w.INTERIOR);for(var o=0;o<t.getNumInteriorRing();o++){var s=t.getInteriorRingN(o),a=Lt.removeRepeatedPoints(s.getCoordinates());this._distance>0&&this.isErodedCompletely(s,-this._distance)||this.addPolygonRing(a,e,Se.opposite(n),w.INTERIOR,w.EXTERIOR)}},Bn.prototype.isTriangleErodedCompletely=function(t,e){var n=new qn(t[0],t[1],t[2]),i=n.inCentre();return at.distancePointLine(i,n.p0,n.p1)<Math.abs(e)},Bn.prototype.addLineString=function(t){if(this._distance<=0&&!this._curveBuilder.getBufferParameters().isSingleSided())return null;var e=Lt.removeRepeatedPoints(t.getCoordinates()),n=this._curveBuilder.getLineCurve(e,this._distance);this.addCurve(n,w.EXTERIOR,w.INTERIOR)},Bn.prototype.addCurve=function(t,e,n){if(null===t||t.length<2)return null;var i=new gn(t,new Pe(0,w.BOUNDARY,e,n));this._curveList.add(i)},Bn.prototype.getCurves=function(){return this.add(this._inputGeom),this._curveList},Bn.prototype.addPolygonRing=function(t,e,n,i,r){if(0===e&&t.length<ee.MINIMUM_VALID_SIZE)return null;var o=i,s=r;t.length>=ee.MINIMUM_VALID_SIZE&&at.isCCW(t)&&(o=r,s=i,n=Se.opposite(n));var a=this._curveBuilder.getRingCurve(t,n,e);this.addCurve(a,o,s)},Bn.prototype.add=function(t){if(t.isEmpty())return null;t instanceof $t?this.addPolygon(t):t instanceof Kt?this.addLineString(t):t instanceof Qt?this.addPoint(t):t instanceof te?this.addCollection(t):t instanceof Xt?this.addCollection(t):t instanceof ne?this.addCollection(t):t instanceof zt&&this.addCollection(t)},Bn.prototype.isErodedCompletely=function(t,e){var n=t.getCoordinates();if(n.length<4)return e<0;if(4===n.length)return this.isTriangleErodedCompletely(n,e);var i=t.getEnvelopeInternal(),r=Math.min(i.getHeight(),i.getWidth());return e<0&&2*Math.abs(e)>r},Bn.prototype.addCollection=function(t){for(var e=0;e<t.getNumGeometries();e++){var n=t.getGeometryN(e);this.add(n)}},Bn.prototype.interfaces_=function(){return[]},Bn.prototype.getClass=function(){return Bn};var Vn=function(){};Vn.prototype.locate=function(t){},Vn.prototype.interfaces_=function(){return[]},Vn.prototype.getClass=function(){return Vn};var Un=function(){this._parent=null,this._atStart=null,this._max=null,this._index=null,this._subcollectionIterator=null;var t=arguments[0];this._parent=t,this._atStart=!0,this._index=0,this._max=t.getNumGeometries()};Un.prototype.next=function(){if(this._atStart)return this._atStart=!1,Un.isAtomic(this._parent)&&this._index++,this._parent;if(null!==this._subcollectionIterator){if(this._subcollectionIterator.hasNext())return this._subcollectionIterator.next();this._subcollectionIterator=null}if(this._index>=this._max)throw new i;var t=this._parent.getGeometryN(this._index++);return t instanceof zt?(this._subcollectionIterator=new Un(t),this._subcollectionIterator.next()):t},Un.prototype.remove=function(){throw new Error(this.getClass().getName())},Un.prototype.hasNext=function(){if(this._atStart)return!0;if(null!==this._subcollectionIterator){if(this._subcollectionIterator.hasNext())return!0;this._subcollectionIterator=null}return!(this._index>=this._max)},Un.prototype.interfaces_=function(){return[Et]},Un.prototype.getClass=function(){return Un},Un.isAtomic=function(t){return!(t instanceof zt)};var zn=function(){this._geom=null;var t=arguments[0];this._geom=t};zn.prototype.locate=function(t){return zn.locate(t,this._geom)},zn.prototype.interfaces_=function(){return[Vn]},zn.prototype.getClass=function(){return zn},zn.isPointInRing=function(t,e){return!!e.getEnvelopeInternal().intersects(t)&&at.isPointInRing(t,e.getCoordinates())},zn.containsPointInPolygon=function(t,e){if(e.isEmpty())return!1;var n=e.getExteriorRing();if(!zn.isPointInRing(t,n))return!1;for(var i=0;i<e.getNumInteriorRing();i++){var r=e.getInteriorRingN(i);if(zn.isPointInRing(t,r))return!1}return!0},zn.containsPoint=function(t,e){if(e instanceof $t)return zn.containsPointInPolygon(t,e);if(e instanceof zt)for(var n=new Un(e);n.hasNext();){var i=n.next();if(i!==e&&zn.containsPoint(t,i))return!0}return!1},zn.locate=function(t,e){return e.isEmpty()?w.EXTERIOR:zn.containsPoint(t,e)?w.INTERIOR:w.EXTERIOR};var Xn=function(){this._edgeMap=new p,this._edgeList=null,this._ptInAreaLocation=[w.NONE,w.NONE]};Xn.prototype.getNextCW=function(t){this.getEdges();var e=this._edgeList.indexOf(t),n=e-1;return 0===e&&(n=this._edgeList.size()-1),this._edgeList.get(n)},Xn.prototype.propagateSideLabels=function(t){for(var e=w.NONE,n=this.iterator();n.hasNext();){var i=n.next().getLabel();i.isArea(t)&&i.getLocation(t,Se.LEFT)!==w.NONE&&(e=i.getLocation(t,Se.LEFT))}if(e===w.NONE)return null;for(var r=e,o=this.iterator();o.hasNext();){var s=o.next(),a=s.getLabel();if(a.getLocation(t,Se.ON)===w.NONE&&a.setLocation(t,Se.ON,r),a.isArea(t)){var u=a.getLocation(t,Se.LEFT),l=a.getLocation(t,Se.RIGHT);if(l!==w.NONE){if(l!==r)throw new we("side location conflict",s.getCoordinate());u===w.NONE&&et.shouldNeverReachHere("found single null side (at "+s.getCoordinate()+")"),r=u}else et.isTrue(a.getLocation(t,Se.LEFT)===w.NONE,"found single null side"),a.setLocation(t,Se.RIGHT,r),a.setLocation(t,Se.LEFT,r)}}},Xn.prototype.getCoordinate=function(){var t=this.iterator();if(!t.hasNext())return null;return t.next().getCoordinate()},Xn.prototype.print=function(t){Y.out.println("EdgeEndStar:   "+this.getCoordinate());for(var e=this.iterator();e.hasNext();){e.next().print(t)}},Xn.prototype.isAreaLabelsConsistent=function(t){return this.computeEdgeEndLabels(t.getBoundaryNodeRule()),this.checkAreaLabelsConsistent(0)},Xn.prototype.checkAreaLabelsConsistent=function(t){var e=this.getEdges();if(e.size()<=0)return!0;var n=e.size()-1,i=e.get(n).getLabel().getLocation(t,Se.LEFT);et.isTrue(i!==w.NONE,"Found unlabelled area edge");for(var r=i,o=this.iterator();o.hasNext();){var s=o.next().getLabel();et.isTrue(s.isArea(t),"Found non-area edge");var a=s.getLocation(t,Se.LEFT),u=s.getLocation(t,Se.RIGHT);if(a===u)return!1;if(u!==r)return!1;r=a}return!0},Xn.prototype.findIndex=function(t){this.iterator();for(var e=0;e<this._edgeList.size();e++){if(this._edgeList.get(e)===t)return e}return-1},Xn.prototype.iterator=function(){return this.getEdges().iterator()},Xn.prototype.getEdges=function(){return null===this._edgeList&&(this._edgeList=new Nt(this._edgeMap.values())),this._edgeList},Xn.prototype.getLocation=function(t,e,n){return this._ptInAreaLocation[t]===w.NONE&&(this._ptInAreaLocation[t]=zn.locate(e,n[t].getGeometry())),this._ptInAreaLocation[t]},Xn.prototype.toString=function(){var t=new D;t.append("EdgeEndStar:   "+this.getCoordinate()),t.append("\n");for(var e=this.iterator();e.hasNext();){var n=e.next();t.append(n),t.append("\n")}return t.toString()},Xn.prototype.computeEdgeEndLabels=function(t){for(var e=this.iterator();e.hasNext();){e.next().computeLabel(t)}},Xn.prototype.computeLabelling=function(t){this.computeEdgeEndLabels(t[0].getBoundaryNodeRule()),this.propagateSideLabels(0),this.propagateSideLabels(1);for(var e=[!1,!1],n=this.iterator();n.hasNext();)for(var i=n.next().getLabel(),r=0;r<2;r++)i.isLine(r)&&i.getLocation(r)===w.BOUNDARY&&(e[r]=!0);for(var o=this.iterator();o.hasNext();)for(var s=o.next(),a=s.getLabel(),u=0;u<2;u++)if(a.isAnyNull(u)){var l=w.NONE;if(e[u])l=w.EXTERIOR;else{var c=s.getCoordinate();l=this.getLocation(u,c,t)}a.setAllLocationsIfNull(u,l)}},Xn.prototype.getDegree=function(){return this._edgeMap.size()},Xn.prototype.insertEdgeEnd=function(t,e){this._edgeMap.put(t,e),this._edgeList=null},Xn.prototype.interfaces_=function(){return[]},Xn.prototype.getClass=function(){return Xn};var Yn=function(t){function e(){t.call(this),this._resultAreaEdgeList=null,this._label=null,this._SCANNING_FOR_INCOMING=1,this._LINKING_TO_OUTGOING=2}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.linkResultDirectedEdges=function(){this.getResultAreaEdges();for(var t=null,e=null,n=this._SCANNING_FOR_INCOMING,i=0;i<this._resultAreaEdgeList.size();i++){var r=this._resultAreaEdgeList.get(i),o=r.getSym();if(r.getLabel().isArea())switch(null===t&&r.isInResult()&&(t=r),n){case this._SCANNING_FOR_INCOMING:if(!o.isInResult())continue;e=o,n=this._LINKING_TO_OUTGOING;break;case this._LINKING_TO_OUTGOING:if(!r.isInResult())continue;e.setNext(r),n=this._SCANNING_FOR_INCOMING}}if(n===this._LINKING_TO_OUTGOING){if(null===t)throw new we("no outgoing dirEdge found",this.getCoordinate());et.isTrue(t.isInResult(),"unable to link last incoming dirEdge"),e.setNext(t)}},e.prototype.insert=function(t){var e=t;this.insertEdgeEnd(e,e)},e.prototype.getRightmostEdge=function(){var t=this.getEdges(),e=t.size();if(e<1)return null;var n=t.get(0);if(1===e)return n;var i=t.get(e-1),r=n.getQuadrant(),o=i.getQuadrant();return Be.isNorthern(r)&&Be.isNorthern(o)?n:Be.isNorthern(r)||Be.isNorthern(o)?0!==n.getDy()?n:0!==i.getDy()?i:(et.shouldNeverReachHere("found two horizontal edges incident on node"),null):i},e.prototype.print=function(t){Y.out.println("DirectedEdgeStar: "+this.getCoordinate());for(var e=this.iterator();e.hasNext();){var n=e.next();t.print("out "),n.print(t),t.println(),t.print("in "),n.getSym().print(t),t.println()}},e.prototype.getResultAreaEdges=function(){if(null!==this._resultAreaEdgeList)return this._resultAreaEdgeList;this._resultAreaEdgeList=new Nt;for(var t=this.iterator();t.hasNext();){var e=t.next();(e.isInResult()||e.getSym().isInResult())&&this._resultAreaEdgeList.add(e)}return this._resultAreaEdgeList},e.prototype.updateLabelling=function(t){for(var e=this.iterator();e.hasNext();){var n=e.next().getLabel();n.setAllLocationsIfNull(0,t.getLocation(0)),n.setAllLocationsIfNull(1,t.getLocation(1))}},e.prototype.linkAllDirectedEdges=function(){this.getEdges();for(var t=null,e=null,n=this._edgeList.size()-1;n>=0;n--){var i=this._edgeList.get(n),r=i.getSym();null===e&&(e=r),null!==t&&r.setNext(t),t=i}e.setNext(t)},e.prototype.computeDepths=function(){if(1===arguments.length){var t=arguments[0],e=this.findIndex(t),n=t.getDepth(Se.LEFT),i=t.getDepth(Se.RIGHT),r=this.computeDepths(e+1,this._edgeList.size(),n);if(this.computeDepths(0,e,r)!==i)throw new we("depth mismatch at "+t.getCoordinate())}else if(3===arguments.length){for(var o=arguments[0],s=arguments[1],a=arguments[2],u=o;u<s;u++){var l=this._edgeList.get(u);l.setEdgeDepths(Se.RIGHT,a),a=l.getDepth(Se.LEFT)}return a}},e.prototype.mergeSymLabels=function(){for(var t=this.iterator();t.hasNext();){var e=t.next();e.getLabel().merge(e.getSym().getLabel())}},e.prototype.linkMinimalDirectedEdges=function(t){for(var e=null,n=null,i=this._SCANNING_FOR_INCOMING,r=this._resultAreaEdgeList.size()-1;r>=0;r--){var o=this._resultAreaEdgeList.get(r),s=o.getSym();switch(null===e&&o.getEdgeRing()===t&&(e=o),i){case this._SCANNING_FOR_INCOMING:if(s.getEdgeRing()!==t)continue;n=s,i=this._LINKING_TO_OUTGOING;break;case this._LINKING_TO_OUTGOING:if(o.getEdgeRing()!==t)continue;n.setNextMin(o),i=this._SCANNING_FOR_INCOMING}}i===this._LINKING_TO_OUTGOING&&(et.isTrue(null!==e,"found null for first outgoing dirEdge"),et.isTrue(e.getEdgeRing()===t,"unable to link last incoming dirEdge"),n.setNextMin(e))},e.prototype.getOutgoingDegree=function(){if(0===arguments.length){for(var t=0,e=this.iterator();e.hasNext();){e.next().isInResult()&&t++}return t}if(1===arguments.length){for(var n=arguments[0],i=0,r=this.iterator();r.hasNext();){r.next().getEdgeRing()===n&&i++}return i}},e.prototype.getLabel=function(){return this._label},e.prototype.findCoveredLineEdges=function(){for(var t=w.NONE,e=this.iterator();e.hasNext();){var n=e.next(),i=n.getSym();if(!n.isLineEdge()){if(n.isInResult()){t=w.INTERIOR;break}if(i.isInResult()){t=w.EXTERIOR;break}}}if(t===w.NONE)return null;for(var r=t,o=this.iterator();o.hasNext();){var s=o.next(),a=s.getSym();s.isLineEdge()?s.getEdge().setCovered(r===w.INTERIOR):(s.isInResult()&&(r=w.EXTERIOR),a.isInResult()&&(r=w.INTERIOR))}},e.prototype.computeLabelling=function(e){t.prototype.computeLabelling.call(this,e),this._label=new Pe(w.NONE);for(var n=this.iterator();n.hasNext();)for(var i=n.next().getEdge().getLabel(),r=0;r<2;r++){var o=i.getLocation(r);o!==w.INTERIOR&&o!==w.BOUNDARY||this._label.setLocation(r,w.INTERIOR)}},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Xn),kn=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createNode=function(t){return new Ge(t,new Yn)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Xe),jn=function t(){this._pts=null,this._orientation=null;var e=arguments[0];this._pts=e,this._orientation=t.orientation(e)};jn.prototype.compareTo=function(t){var e=t;return jn.compareOriented(this._pts,this._orientation,e._pts,e._orientation)},jn.prototype.interfaces_=function(){return[E]},jn.prototype.getClass=function(){return jn},jn.orientation=function(t){return 1===Lt.increasingDirection(t)},jn.compareOriented=function(t,e,n,i){for(var r=e?1:-1,o=i?1:-1,s=e?t.length:-1,a=i?n.length:-1,u=e?0:t.length-1,l=i?0:n.length-1;;){var c=t[u].compareTo(n[l]);if(0!==c)return c;var p=(u+=r)===s,h=(l+=o)===a;if(p&&!h)return-1;if(!p&&h)return 1;if(p&&h)return 0}};var Hn=function(){this._edges=new Nt,this._ocaMap=new p};Hn.prototype.print=function(t){t.print("MULTILINESTRING ( ");for(var e=0;e<this._edges.size();e++){var n=this._edges.get(e);e>0&&t.print(","),t.print("(");for(var i=n.getCoordinates(),r=0;r<i.length;r++)r>0&&t.print(","),t.print(i[r].x+" "+i[r].y);t.println(")")}t.print(")  ")},Hn.prototype.addAll=function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next())},Hn.prototype.findEdgeIndex=function(t){for(var e=0;e<this._edges.size();e++)if(this._edges.get(e).equals(t))return e;return-1},Hn.prototype.iterator=function(){return this._edges.iterator()},Hn.prototype.getEdges=function(){return this._edges},Hn.prototype.get=function(t){return this._edges.get(t)},Hn.prototype.findEqualEdge=function(t){var e=new jn(t.getCoordinates());return this._ocaMap.get(e)},Hn.prototype.add=function(t){this._edges.add(t);var e=new jn(t.getCoordinates());this._ocaMap.put(e,t)},Hn.prototype.interfaces_=function(){return[]},Hn.prototype.getClass=function(){return Hn};var Wn=function(){};Wn.prototype.processIntersections=function(t,e,n,i){},Wn.prototype.isDone=function(){},Wn.prototype.interfaces_=function(){return[]},Wn.prototype.getClass=function(){return Wn};var Kn=function(){this._hasIntersection=!1,this._hasProper=!1,this._hasProperInterior=!1,this._hasInterior=!1,this._properIntersectionPoint=null,this._li=null,this._isSelfIntersection=null,this.numIntersections=0,this.numInteriorIntersections=0,this.numProperIntersections=0,this.numTests=0;var t=arguments[0];this._li=t};Kn.prototype.isTrivialIntersection=function(t,e,n,i){if(t===n&&1===this._li.getIntersectionNum()){if(Kn.isAdjacentSegments(e,i))return!0;if(t.isClosed()){var r=t.size()-1;if(0===e&&i===r||0===i&&e===r)return!0}}return!1},Kn.prototype.getProperIntersectionPoint=function(){return this._properIntersectionPoint},Kn.prototype.hasProperInteriorIntersection=function(){return this._hasProperInterior},Kn.prototype.getLineIntersector=function(){return this._li},Kn.prototype.hasProperIntersection=function(){return this._hasProper},Kn.prototype.processIntersections=function(t,e,n,i){if(t===n&&e===i)return null;this.numTests++;var r=t.getCoordinates()[e],o=t.getCoordinates()[e+1],s=n.getCoordinates()[i],a=n.getCoordinates()[i+1];this._li.computeIntersection(r,o,s,a),this._li.hasIntersection()&&(this.numIntersections++,this._li.isInteriorIntersection()&&(this.numInteriorIntersections++,this._hasInterior=!0),this.isTrivialIntersection(t,e,n,i)||(this._hasIntersection=!0,t.addIntersections(this._li,e,0),n.addIntersections(this._li,i,1),this._li.isProper()&&(this.numProperIntersections++,this._hasProper=!0,this._hasProperInterior=!0)))},Kn.prototype.hasIntersection=function(){return this._hasIntersection},Kn.prototype.isDone=function(){return!1},Kn.prototype.hasInteriorIntersection=function(){return this._hasInterior},Kn.prototype.interfaces_=function(){return[Wn]},Kn.prototype.getClass=function(){return Kn},Kn.isAdjacentSegments=function(t,e){return 1===Math.abs(t-e)};var Jn=function(){this.coord=null,this.segmentIndex=null,this.dist=null;var t=arguments[0],e=arguments[1],n=arguments[2];this.coord=new C(t),this.segmentIndex=e,this.dist=n};Jn.prototype.getSegmentIndex=function(){return this.segmentIndex},Jn.prototype.getCoordinate=function(){return this.coord},Jn.prototype.print=function(t){t.print(this.coord),t.print(" seg # = "+this.segmentIndex),t.println(" dist = "+this.dist)},Jn.prototype.compareTo=function(t){var e=t;return this.compare(e.segmentIndex,e.dist)},Jn.prototype.isEndPoint=function(t){return 0===this.segmentIndex&&0===this.dist||this.segmentIndex===t},Jn.prototype.toString=function(){return this.coord+" seg # = "+this.segmentIndex+" dist = "+this.dist},Jn.prototype.getDistance=function(){return this.dist},Jn.prototype.compare=function(t,e){return this.segmentIndex<t?-1:this.segmentIndex>t?1:this.dist<e?-1:this.dist>e?1:0},Jn.prototype.interfaces_=function(){return[E]},Jn.prototype.getClass=function(){return Jn};var Qn=function(){this._nodeMap=new p,this.edge=null;var t=arguments[0];this.edge=t};Qn.prototype.print=function(t){t.println("Intersections:");for(var e=this.iterator();e.hasNext();){e.next().print(t)}},Qn.prototype.iterator=function(){return this._nodeMap.values().iterator()},Qn.prototype.addSplitEdges=function(t){this.addEndpoints();for(var e=this.iterator(),n=e.next();e.hasNext();){var i=e.next(),r=this.createSplitEdge(n,i);t.add(r),n=i}},Qn.prototype.addEndpoints=function(){var t=this.edge.pts.length-1;this.add(this.edge.pts[0],0,0),this.add(this.edge.pts[t],t,0)},Qn.prototype.createSplitEdge=function(t,e){var n=e.segmentIndex-t.segmentIndex+2,i=this.edge.pts[e.segmentIndex],r=e.dist>0||!e.coord.equals2D(i);r||n--;var o=new Array(n).fill(null),s=0;o[s++]=new C(t.coord);for(var a=t.segmentIndex+1;a<=e.segmentIndex;a++)o[s++]=this.edge.pts[a];return r&&(o[s]=e.coord),new ni(o,new Pe(this.edge._label))},Qn.prototype.add=function(t,e,n){var i=new Jn(t,e,n),r=this._nodeMap.get(i);return null!==r?r:(this._nodeMap.put(i,i),i)},Qn.prototype.isIntersection=function(t){for(var e=this.iterator();e.hasNext();){if(e.next().coord.equals(t))return!0}return!1},Qn.prototype.interfaces_=function(){return[]},Qn.prototype.getClass=function(){return Qn};var Zn=function(){};Zn.prototype.getChainStartIndices=function(t){var e=0,n=new Nt;n.add(new M(e));do{var i=this.findChainEnd(t,e);n.add(new M(i)),e=i}while(e<t.length-1);return Zn.toIntArray(n)},Zn.prototype.findChainEnd=function(t,e){for(var n=Be.quadrant(t[e],t[e+1]),i=e+1;i<t.length;){if(Be.quadrant(t[i-1],t[i])!==n)break;i++}return i-1},Zn.prototype.interfaces_=function(){return[]},Zn.prototype.getClass=function(){return Zn},Zn.toIntArray=function(t){for(var e=new Array(t.size()).fill(null),n=0;n<e.length;n++)e[n]=t.get(n).intValue();return e};var $n=function(){this.e=null,this.pts=null,this.startIndex=null,this.env1=new j,this.env2=new j;var t=arguments[0];this.e=t,this.pts=t.getCoordinates();var e=new Zn;this.startIndex=e.getChainStartIndices(this.pts)};$n.prototype.getCoordinates=function(){return this.pts},$n.prototype.getMaxX=function(t){var e=this.pts[this.startIndex[t]].x,n=this.pts[this.startIndex[t+1]].x;return e>n?e:n},$n.prototype.getMinX=function(t){var e=this.pts[this.startIndex[t]].x,n=this.pts[this.startIndex[t+1]].x;return e<n?e:n},$n.prototype.computeIntersectsForChain=function(){if(4===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3];this.computeIntersectsForChain(this.startIndex[t],this.startIndex[t+1],e,e.startIndex[n],e.startIndex[n+1],i)}else if(6===arguments.length){var r=arguments[0],o=arguments[1],s=arguments[2],a=arguments[3],u=arguments[4],l=arguments[5],c=this.pts[r],p=this.pts[o],h=s.pts[a],f=s.pts[u];if(o-r==1&&u-a==1)return l.addIntersections(this.e,r,s.e,a),null;if(this.env1.init(c,p),this.env2.init(h,f),!this.env1.intersects(this.env2))return null;var g=Math.trunc((r+o)/2),d=Math.trunc((a+u)/2);r<g&&(a<d&&this.computeIntersectsForChain(r,g,s,a,d,l),d<u&&this.computeIntersectsForChain(r,g,s,d,u,l)),g<o&&(a<d&&this.computeIntersectsForChain(g,o,s,a,d,l),d<u&&this.computeIntersectsForChain(g,o,s,d,u,l))}},$n.prototype.getStartIndexes=function(){return this.startIndex},$n.prototype.computeIntersects=function(t,e){for(var n=0;n<this.startIndex.length-1;n++)for(var i=0;i<t.startIndex.length-1;i++)this.computeIntersectsForChain(n,t,i,e)},$n.prototype.interfaces_=function(){return[]},$n.prototype.getClass=function(){return $n};var ti=function t(){this._depth=Array(2).fill().map(function(){return Array(3)});for(var e=0;e<2;e++)for(var n=0;n<3;n++)this._depth[e][n]=t.NULL_VALUE},ei={NULL_VALUE:{configurable:!0}};ti.prototype.getDepth=function(t,e){return this._depth[t][e]},ti.prototype.setDepth=function(t,e,n){this._depth[t][e]=n},ti.prototype.isNull=function(){if(0===arguments.length){for(var t=0;t<2;t++)for(var e=0;e<3;e++)if(this._depth[t][e]!==ti.NULL_VALUE)return!1;return!0}if(1===arguments.length){var n=arguments[0];return this._depth[n][1]===ti.NULL_VALUE}if(2===arguments.length){var i=arguments[0],r=arguments[1];return this._depth[i][r]===ti.NULL_VALUE}},ti.prototype.normalize=function(){for(var t=0;t<2;t++)if(!this.isNull(t)){var e=this._depth[t][1];this._depth[t][2]<e&&(e=this._depth[t][2]),e<0&&(e=0);for(var n=1;n<3;n++){var i=0;this._depth[t][n]>e&&(i=1),this._depth[t][n]=i}}},ti.prototype.getDelta=function(t){return this._depth[t][Se.RIGHT]-this._depth[t][Se.LEFT]},ti.prototype.getLocation=function(t,e){return this._depth[t][e]<=0?w.EXTERIOR:w.INTERIOR},ti.prototype.toString=function(){return"A: "+this._depth[0][1]+","+this._depth[0][2]+" B: "+this._depth[1][1]+","+this._depth[1][2]},ti.prototype.add=function(){if(1===arguments.length)for(var t=arguments[0],e=0;e<2;e++)for(var n=1;n<3;n++){var i=t.getLocation(e,n);i!==w.EXTERIOR&&i!==w.INTERIOR||(this.isNull(e,n)?this._depth[e][n]=ti.depthAtLocation(i):this._depth[e][n]+=ti.depthAtLocation(i))}else if(3===arguments.length){var r=arguments[0],o=arguments[1];arguments[2]===w.INTERIOR&&this._depth[r][o]++}},ti.prototype.interfaces_=function(){return[]},ti.prototype.getClass=function(){return ti},ti.depthAtLocation=function(t){return t===w.EXTERIOR?0:t===w.INTERIOR?1:ti.NULL_VALUE},ei.NULL_VALUE.get=function(){return-1},Object.defineProperties(ti,ei);var ni=function(t){function e(){if(t.call(this),this.pts=null,this._env=null,this.eiList=new Qn(this),this._name=null,this._mce=null,this._isIsolated=!0,this._depth=new ti,this._depthDelta=0,1===arguments.length){var n=arguments[0];e.call(this,n,null)}else if(2===arguments.length){var i=arguments[0],r=arguments[1];this.pts=i,this._label=r}}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDepth=function(){return this._depth},e.prototype.getCollapsedEdge=function(){var t=new Array(2).fill(null);t[0]=this.pts[0],t[1]=this.pts[1];return new e(t,Pe.toLineLabel(this._label))},e.prototype.isIsolated=function(){return this._isIsolated},e.prototype.getCoordinates=function(){return this.pts},e.prototype.setIsolated=function(t){this._isIsolated=t},e.prototype.setName=function(t){this._name=t},e.prototype.equals=function(t){if(!(t instanceof e))return!1;var n=t;if(this.pts.length!==n.pts.length)return!1;for(var i=!0,r=!0,o=this.pts.length,s=0;s<this.pts.length;s++)if(this.pts[s].equals2D(n.pts[s])||(i=!1),this.pts[s].equals2D(n.pts[--o])||(r=!1),!i&&!r)return!1;return!0},e.prototype.getCoordinate=function(){if(0===arguments.length)return this.pts.length>0?this.pts[0]:null;if(1===arguments.length){var t=arguments[0];return this.pts[t]}},e.prototype.print=function(t){t.print("edge "+this._name+": "),t.print("LINESTRING (");for(var e=0;e<this.pts.length;e++)e>0&&t.print(","),t.print(this.pts[e].x+" "+this.pts[e].y);t.print(")  "+this._label+" "+this._depthDelta)},e.prototype.computeIM=function(t){e.updateIM(this._label,t)},e.prototype.isCollapsed=function(){return!!this._label.isArea()&&(3===this.pts.length&&!!this.pts[0].equals(this.pts[2]))},e.prototype.isClosed=function(){return this.pts[0].equals(this.pts[this.pts.length-1])},e.prototype.getMaximumSegmentIndex=function(){return this.pts.length-1},e.prototype.getDepthDelta=function(){return this._depthDelta},e.prototype.getNumPoints=function(){return this.pts.length},e.prototype.printReverse=function(t){t.print("edge "+this._name+": ");for(var e=this.pts.length-1;e>=0;e--)t.print(this.pts[e]+" ");t.println("")},e.prototype.getMonotoneChainEdge=function(){return null===this._mce&&(this._mce=new $n(this)),this._mce},e.prototype.getEnvelope=function(){if(null===this._env){this._env=new j;for(var t=0;t<this.pts.length;t++)this._env.expandToInclude(this.pts[t])}return this._env},e.prototype.addIntersection=function(t,e,n,i){var r=new C(t.getIntersection(i)),o=e,s=t.getEdgeDistance(n,i),a=o+1;if(a<this.pts.length){var u=this.pts[a];r.equals2D(u)&&(o=a,s=0)}this.eiList.add(r,o,s)},e.prototype.toString=function(){var t=new D;t.append("edge "+this._name+": "),t.append("LINESTRING (");for(var e=0;e<this.pts.length;e++)e>0&&t.append(","),t.append(this.pts[e].x+" "+this.pts[e].y);return t.append(")  "+this._label+" "+this._depthDelta),t.toString()},e.prototype.isPointwiseEqual=function(t){if(this.pts.length!==t.pts.length)return!1;for(var e=0;e<this.pts.length;e++)if(!this.pts[e].equals2D(t.pts[e]))return!1;return!0},e.prototype.setDepthDelta=function(t){this._depthDelta=t},e.prototype.getEdgeIntersectionList=function(){return this.eiList},e.prototype.addIntersections=function(t,e,n){for(var i=0;i<t.getIntersectionNum();i++)this.addIntersection(t,e,n,i)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e.updateIM=function(){if(2!==arguments.length)return t.prototype.updateIM.apply(this,arguments);var e=arguments[0],n=arguments[1];n.setAtLeastIfValid(e.getLocation(0,Se.ON),e.getLocation(1,Se.ON),1),e.isArea()&&(n.setAtLeastIfValid(e.getLocation(0,Se.LEFT),e.getLocation(1,Se.LEFT),2),n.setAtLeastIfValid(e.getLocation(0,Se.RIGHT),e.getLocation(1,Se.RIGHT),2))},e}(Fe),ii=function(t){this._workingPrecisionModel=null,this._workingNoder=null,this._geomFact=null,this._graph=null,this._edgeList=new Hn,this._bufParams=t||null};ii.prototype.setWorkingPrecisionModel=function(t){this._workingPrecisionModel=t},ii.prototype.insertUniqueEdge=function(t){var e=this._edgeList.findEqualEdge(t);if(null!==e){var n=e.getLabel(),i=t.getLabel();e.isPointwiseEqual(t)||(i=new Pe(t.getLabel())).flip(),n.merge(i);var r=ii.depthDelta(i),o=e.getDepthDelta()+r;e.setDepthDelta(o)}else this._edgeList.add(t),t.setDepthDelta(ii.depthDelta(t.getLabel()))},ii.prototype.buildSubgraphs=function(t,e){for(var n=new Nt,i=t.iterator();i.hasNext();){var r=i.next(),o=r.getRightmostCoordinate(),s=new An(n).getDepth(o);r.computeDepth(s),r.findResultEdges(),n.add(r),e.add(r.getDirectedEdges(),r.getNodes())}},ii.prototype.createSubgraphs=function(t){for(var e=new Nt,n=t.getNodes().iterator();n.hasNext();){var i=n.next();if(!i.isVisited()){var r=new Te;r.create(i),e.add(r)}}return $e.sort(e,$e.reverseOrder()),e},ii.prototype.createEmptyResultGeometry=function(){return this._geomFact.createPolygon()},ii.prototype.getNoder=function(t){if(null!==this._workingNoder)return this._workingNoder;var e=new xn,n=new rt;return n.setPrecisionModel(t),e.setSegmentIntersector(new Kn(n)),e},ii.prototype.buffer=function(t,e){var n=this._workingPrecisionModel;null===n&&(n=t.getPrecisionModel()),this._geomFact=t.getFactory();var i=new Mn(n,this._bufParams),r=new Bn(t,e,i).getCurves();if(r.size()<=0)return this.createEmptyResultGeometry();this.computeNodedEdges(r,n),this._graph=new Ye(new kn),this._graph.addEdges(this._edgeList.getEdges());var o=this.createSubgraphs(this._graph),s=new ke(this._geomFact);this.buildSubgraphs(o,s);var a=s.getPolygons();if(a.size()<=0)return this.createEmptyResultGeometry();return this._geomFact.buildGeometry(a)},ii.prototype.computeNodedEdges=function(t,e){var n=this.getNoder(e);n.computeNodes(t);for(var i=n.getNodedSubstrings().iterator();i.hasNext();){var r=i.next(),o=r.getCoordinates();if(2!==o.length||!o[0].equals2D(o[1])){var s=r.getData(),a=new ni(r.getCoordinates(),new Pe(s));this.insertUniqueEdge(a)}}},ii.prototype.setNoder=function(t){this._workingNoder=t},ii.prototype.interfaces_=function(){return[]},ii.prototype.getClass=function(){return ii},ii.depthDelta=function(t){var e=t.getLocation(0,Se.LEFT),n=t.getLocation(0,Se.RIGHT);return e===w.INTERIOR&&n===w.EXTERIOR?1:e===w.EXTERIOR&&n===w.INTERIOR?-1:0},ii.convertSegStrings=function(t){for(var e=new _e,n=new Nt;t.hasNext();){var i=t.next(),r=e.createLineString(i.getCoordinates());n.add(r)}return e.buildGeometry(n)};var ri=function(){if(this._noder=null,this._scaleFactor=null,this._offsetX=null,this._offsetY=null,this._isScaled=!1,2===arguments.length){var t=arguments[0],e=arguments[1];this._noder=t,this._scaleFactor=e,this._offsetX=0,this._offsetY=0,this._isScaled=!this.isIntegerPrecision()}else if(4===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2],o=arguments[3];this._noder=n,this._scaleFactor=i,this._offsetX=r,this._offsetY=o,this._isScaled=!this.isIntegerPrecision()}};ri.prototype.rescale=function(){if(T(arguments[0],It))for(var t=arguments[0].iterator();t.hasNext();){var e=t.next();this.rescale(e.getCoordinates())}else if(arguments[0]instanceof Array){for(var n=arguments[0],i=0;i<n.length;i++)n[i].x=n[i].x/this._scaleFactor+this._offsetX,n[i].y=n[i].y/this._scaleFactor+this._offsetY;2===n.length&&n[0].equals2D(n[1])&&Y.out.println(n)}},ri.prototype.scale=function(){if(T(arguments[0],It)){for(var t=arguments[0],e=new Nt,n=t.iterator();n.hasNext();){var i=n.next();e.add(new gn(this.scale(i.getCoordinates()),i.getData()))}return e}if(arguments[0]instanceof Array){for(var r=arguments[0],o=new Array(r.length).fill(null),s=0;s<r.length;s++)o[s]=new C(Math.round((r[s].x-this._offsetX)*this._scaleFactor),Math.round((r[s].y-this._offsetY)*this._scaleFactor),r[s].z);return Lt.removeRepeatedPoints(o)}},ri.prototype.isIntegerPrecision=function(){return 1===this._scaleFactor},ri.prototype.getNodedSubstrings=function(){var t=this._noder.getNodedSubstrings();return this._isScaled&&this.rescale(t),t},ri.prototype.computeNodes=function(t){var e=t;this._isScaled&&(e=this.scale(t)),this._noder.computeNodes(e)},ri.prototype.interfaces_=function(){return[In]},ri.prototype.getClass=function(){return ri};var oi=function(){this._li=new rt,this._segStrings=null;var t=arguments[0];this._segStrings=t},si={fact:{configurable:!0}};oi.prototype.checkEndPtVertexIntersections=function(){if(0===arguments.length)for(var t=this._segStrings.iterator();t.hasNext();){var e=t.next().getCoordinates();this.checkEndPtVertexIntersections(e[0],this._segStrings),this.checkEndPtVertexIntersections(e[e.length-1],this._segStrings)}else if(2===arguments.length)for(var n=arguments[0],i=arguments[1].iterator();i.hasNext();)for(var r=i.next().getCoordinates(),o=1;o<r.length-1;o++)if(r[o].equals(n))throw new $("found endpt/interior pt intersection at index "+o+" :pt "+n)},oi.prototype.checkInteriorIntersections=function(){if(0===arguments.length)for(var t=this._segStrings.iterator();t.hasNext();)for(var e=t.next(),n=this._segStrings.iterator();n.hasNext();){var i=n.next();this.checkInteriorIntersections(e,i)}else if(2===arguments.length)for(var r=arguments[0],o=arguments[1],s=r.getCoordinates(),a=o.getCoordinates(),u=0;u<s.length-1;u++)for(var l=0;l<a.length-1;l++)this.checkInteriorIntersections(r,u,o,l);else if(4===arguments.length){var c=arguments[0],p=arguments[1],h=arguments[2],f=arguments[3];if(c===h&&p===f)return null;var g=c.getCoordinates()[p],d=c.getCoordinates()[p+1],y=h.getCoordinates()[f],_=h.getCoordinates()[f+1];if(this._li.computeIntersection(g,d,y,_),this._li.hasIntersection()&&(this._li.isProper()||this.hasInteriorIntersection(this._li,g,d)||this.hasInteriorIntersection(this._li,y,_)))throw new $("found non-noded intersection at "+g+"-"+d+" and "+y+"-"+_)}},oi.prototype.checkValid=function(){this.checkEndPtVertexIntersections(),this.checkInteriorIntersections(),this.checkCollapses()},oi.prototype.checkCollapses=function(){if(0===arguments.length)for(var t=this._segStrings.iterator();t.hasNext();){var e=t.next();this.checkCollapses(e)}else if(1===arguments.length)for(var n=arguments[0].getCoordinates(),i=0;i<n.length-2;i++)this.checkCollapse(n[i],n[i+1],n[i+2])},oi.prototype.hasInteriorIntersection=function(t,e,n){for(var i=0;i<t.getIntersectionNum();i++){var r=t.getIntersection(i);if(!r.equals(e)&&!r.equals(n))return!0}return!1},oi.prototype.checkCollapse=function(t,e,n){if(t.equals(n))throw new $("found non-noded collapse at "+oi.fact.createLineString([t,e,n]))},oi.prototype.interfaces_=function(){return[]},oi.prototype.getClass=function(){return oi},si.fact.get=function(){return new _e},Object.defineProperties(oi,si);var ai=function(){this._li=null,this._pt=null,this._originalPt=null,this._ptScaled=null,this._p0Scaled=null,this._p1Scaled=null,this._scaleFactor=null,this._minx=null,this._maxx=null,this._miny=null,this._maxy=null,this._corner=new Array(4).fill(null),this._safeEnv=null;var t=arguments[0],e=arguments[1],n=arguments[2];if(this._originalPt=t,this._pt=t,this._scaleFactor=e,this._li=n,e<=0)throw new m("Scale factor must be non-zero");1!==e&&(this._pt=new C(this.scale(t.x),this.scale(t.y)),this._p0Scaled=new C,this._p1Scaled=new C),this.initCorners(this._pt)},ui={SAFE_ENV_EXPANSION_FACTOR:{configurable:!0}};ai.prototype.intersectsScaled=function(t,e){var n=Math.min(t.x,e.x),i=Math.max(t.x,e.x),r=Math.min(t.y,e.y),o=Math.max(t.y,e.y),s=this._maxx<n||this._minx>i||this._maxy<r||this._miny>o;if(s)return!1;var a=this.intersectsToleranceSquare(t,e);return et.isTrue(!(s&&a),"Found bad envelope test"),a},ai.prototype.initCorners=function(t){this._minx=t.x-.5,this._maxx=t.x+.5,this._miny=t.y-.5,this._maxy=t.y+.5,this._corner[0]=new C(this._maxx,this._maxy),this._corner[1]=new C(this._minx,this._maxy),this._corner[2]=new C(this._minx,this._miny),this._corner[3]=new C(this._maxx,this._miny)},ai.prototype.intersects=function(t,e){return 1===this._scaleFactor?this.intersectsScaled(t,e):(this.copyScaled(t,this._p0Scaled),this.copyScaled(e,this._p1Scaled),this.intersectsScaled(this._p0Scaled,this._p1Scaled))},ai.prototype.scale=function(t){return Math.round(t*this._scaleFactor)},ai.prototype.getCoordinate=function(){return this._originalPt},ai.prototype.copyScaled=function(t,e){e.x=this.scale(t.x),e.y=this.scale(t.y)},ai.prototype.getSafeEnvelope=function(){if(null===this._safeEnv){var t=ai.SAFE_ENV_EXPANSION_FACTOR/this._scaleFactor;this._safeEnv=new j(this._originalPt.x-t,this._originalPt.x+t,this._originalPt.y-t,this._originalPt.y+t)}return this._safeEnv},ai.prototype.intersectsPixelClosure=function(t,e){return this._li.computeIntersection(t,e,this._corner[0],this._corner[1]),!!this._li.hasIntersection()||(this._li.computeIntersection(t,e,this._corner[1],this._corner[2]),!!this._li.hasIntersection()||(this._li.computeIntersection(t,e,this._corner[2],this._corner[3]),!!this._li.hasIntersection()||(this._li.computeIntersection(t,e,this._corner[3],this._corner[0]),!!this._li.hasIntersection())))},ai.prototype.intersectsToleranceSquare=function(t,e){var n=!1,i=!1;return this._li.computeIntersection(t,e,this._corner[0],this._corner[1]),!!this._li.isProper()||(this._li.computeIntersection(t,e,this._corner[1],this._corner[2]),!!this._li.isProper()||(this._li.hasIntersection()&&(n=!0),this._li.computeIntersection(t,e,this._corner[2],this._corner[3]),!!this._li.isProper()||(this._li.hasIntersection()&&(i=!0),this._li.computeIntersection(t,e,this._corner[3],this._corner[0]),!!this._li.isProper()||(!(!n||!i)||(!!t.equals(this._pt)||!!e.equals(this._pt))))))},ai.prototype.addSnappedNode=function(t,e){var n=t.getCoordinate(e),i=t.getCoordinate(e+1);return!!this.intersects(n,i)&&(t.addIntersection(this.getCoordinate(),e),!0)},ai.prototype.interfaces_=function(){return[]},ai.prototype.getClass=function(){return ai},ui.SAFE_ENV_EXPANSION_FACTOR.get=function(){return.75},Object.defineProperties(ai,ui);var li=function(){this.tempEnv1=new j,this.selectedSegment=new dn};li.prototype.select=function(){if(1===arguments.length);else if(2===arguments.length){var t=arguments[0],e=arguments[1];t.getLineSegment(e,this.selectedSegment),this.select(this.selectedSegment)}},li.prototype.interfaces_=function(){return[]},li.prototype.getClass=function(){return li};var ci=function(){this._index=null;var t=arguments[0];this._index=t},pi={HotPixelSnapAction:{configurable:!0}};ci.prototype.snap=function(){if(1===arguments.length){var t=arguments[0];return this.snap(t,null,-1)}if(3===arguments.length){var e=arguments[0],n=arguments[1],i=arguments[2],r=e.getSafeEnvelope(),o=new hi(e,n,i);return this._index.query(r,{interfaces_:function(){return[Ke]},visitItem:function(t){t.select(r,o)}}),o.isNodeAdded()}},ci.prototype.interfaces_=function(){return[]},ci.prototype.getClass=function(){return ci},pi.HotPixelSnapAction.get=function(){return hi},Object.defineProperties(ci,pi);var hi=function(t){function e(){t.call(this),this._hotPixel=null,this._parentEdge=null,this._hotPixelVertexIndex=null,this._isNodeAdded=!1;var e=arguments[0],n=arguments[1],i=arguments[2];this._hotPixel=e,this._parentEdge=n,this._hotPixelVertexIndex=i}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.isNodeAdded=function(){return this._isNodeAdded},e.prototype.select=function(){if(2!==arguments.length)return t.prototype.select.apply(this,arguments);var e=arguments[0],n=arguments[1],i=e.getContext();if(null!==this._parentEdge&&i===this._parentEdge&&n===this._hotPixelVertexIndex)return null;this._isNodeAdded=this._hotPixel.addSnappedNode(i,n)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(li),fi=function(){this._li=null,this._interiorIntersections=null;var t=arguments[0];this._li=t,this._interiorIntersections=new Nt};fi.prototype.processIntersections=function(t,e,n,i){if(t===n&&e===i)return null;var r=t.getCoordinates()[e],o=t.getCoordinates()[e+1],s=n.getCoordinates()[i],a=n.getCoordinates()[i+1];if(this._li.computeIntersection(r,o,s,a),this._li.hasIntersection()&&this._li.isInteriorIntersection()){for(var u=0;u<this._li.getIntersectionNum();u++)this._interiorIntersections.add(this._li.getIntersection(u));t.addIntersections(this._li,e,0),n.addIntersections(this._li,i,1)}},fi.prototype.isDone=function(){return!1},fi.prototype.getInteriorIntersections=function(){return this._interiorIntersections},fi.prototype.interfaces_=function(){return[Wn]},fi.prototype.getClass=function(){return fi};var gi=function(){this._pm=null,this._li=null,this._scaleFactor=null,this._noder=null,this._pointSnapper=null,this._nodedSegStrings=null;var t=arguments[0];this._pm=t,this._li=new rt,this._li.setPrecisionModel(t),this._scaleFactor=t.getScale()};gi.prototype.checkCorrectness=function(t){var e=gn.getNodedSubstrings(t),n=new oi(e);try{n.checkValid()}catch(t){if(!(t instanceof z))throw t;t.printStackTrace()}},gi.prototype.getNodedSubstrings=function(){return gn.getNodedSubstrings(this._nodedSegStrings)},gi.prototype.snapRound=function(t,e){var n=this.findInteriorIntersections(t,e);this.computeIntersectionSnaps(n),this.computeVertexSnaps(t)},gi.prototype.findInteriorIntersections=function(t,e){var n=new fi(e);return this._noder.setSegmentIntersector(n),this._noder.computeNodes(t),n.getInteriorIntersections()},gi.prototype.computeVertexSnaps=function(){if(T(arguments[0],It))for(var t=arguments[0].iterator();t.hasNext();){var e=t.next();this.computeVertexSnaps(e)}else if(arguments[0]instanceof gn)for(var n=arguments[0],i=n.getCoordinates(),r=0;r<i.length;r++){var o=new ai(i[r],this._scaleFactor,this._li);this._pointSnapper.snap(o,n,r)&&n.addIntersection(i[r],r)}},gi.prototype.computeNodes=function(t){this._nodedSegStrings=t,this._noder=new xn,this._pointSnapper=new ci(this._noder.getIndex()),this.snapRound(t,this._li)},gi.prototype.computeIntersectionSnaps=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next(),i=new ai(n,this._scaleFactor,this._li);this._pointSnapper.snap(i)}},gi.prototype.interfaces_=function(){return[In]},gi.prototype.getClass=function(){return gi};var di=function(){if(this._argGeom=null,this._distance=null,this._bufParams=new Cn,this._resultGeometry=null,this._saveException=null,1===arguments.length){var t=arguments[0];this._argGeom=t}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this._argGeom=e,this._bufParams=n}},yi={CAP_ROUND:{configurable:!0},CAP_BUTT:{configurable:!0},CAP_FLAT:{configurable:!0},CAP_SQUARE:{configurable:!0},MAX_PRECISION_DIGITS:{configurable:!0}};di.prototype.bufferFixedPrecision=function(t){var e=new ri(new gi(new fe(1)),t.getScale()),n=new ii(this._bufParams);n.setWorkingPrecisionModel(t),n.setNoder(e),this._resultGeometry=n.buffer(this._argGeom,this._distance)},di.prototype.bufferReducedPrecision=function(){var t=this;if(0===arguments.length){for(var e=di.MAX_PRECISION_DIGITS;e>=0;e--){try{t.bufferReducedPrecision(e)}catch(e){if(!(e instanceof we))throw e;t._saveException=e}if(null!==t._resultGeometry)return null}throw this._saveException}if(1===arguments.length){var n=arguments[0],i=di.precisionScaleFactor(this._argGeom,this._distance,n),r=new fe(i);this.bufferFixedPrecision(r)}},di.prototype.computeGeometry=function(){if(this.bufferOriginalPrecision(),null!==this._resultGeometry)return null;var t=this._argGeom.getFactory().getPrecisionModel();t.getType()===fe.FIXED?this.bufferFixedPrecision(t):this.bufferReducedPrecision()},di.prototype.setQuadrantSegments=function(t){this._bufParams.setQuadrantSegments(t)},di.prototype.bufferOriginalPrecision=function(){try{var t=new ii(this._bufParams);this._resultGeometry=t.buffer(this._argGeom,this._distance)}catch(t){if(!(t instanceof $))throw t;this._saveException=t}},di.prototype.getResultGeometry=function(t){return this._distance=t,this.computeGeometry(),this._resultGeometry},di.prototype.setEndCapStyle=function(t){this._bufParams.setEndCapStyle(t)},di.prototype.interfaces_=function(){return[]},di.prototype.getClass=function(){return di},di.bufferOp=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return new di(t).getResultGeometry(e)}if(3===arguments.length){if(Number.isInteger(arguments[2])&&arguments[0]instanceof ct&&"number"==typeof arguments[1]){var n=arguments[0],i=arguments[1],r=arguments[2],o=new di(n);o.setQuadrantSegments(r);return o.getResultGeometry(i)}if(arguments[2]instanceof Cn&&arguments[0]instanceof ct&&"number"==typeof arguments[1]){var s=arguments[0],a=arguments[1],u=arguments[2];return new di(s,u).getResultGeometry(a)}}else if(4===arguments.length){var l=arguments[0],c=arguments[1],p=arguments[2],h=arguments[3],f=new di(l);f.setQuadrantSegments(p),f.setEndCapStyle(h);return f.getResultGeometry(c)}},di.precisionScaleFactor=function(t,e,n){var i=t.getEnvelopeInternal(),r=R.max(Math.abs(i.getMaxX()),Math.abs(i.getMaxY()),Math.abs(i.getMinX()),Math.abs(i.getMinY()))+2*(e>0?e:0),o=n-Math.trunc(Math.log(r)/Math.log(10)+1);return Math.pow(10,o)},yi.CAP_ROUND.get=function(){return Cn.CAP_ROUND},yi.CAP_BUTT.get=function(){return Cn.CAP_FLAT},yi.CAP_FLAT.get=function(){return Cn.CAP_FLAT},yi.CAP_SQUARE.get=function(){return Cn.CAP_SQUARE},yi.MAX_PRECISION_DIGITS.get=function(){return 12},Object.defineProperties(di,yi);var _i=function(){this._pt=[new C,new C],this._distance=v.NaN,this._isNull=!0};_i.prototype.getCoordinates=function(){return this._pt},_i.prototype.getCoordinate=function(t){return this._pt[t]},_i.prototype.setMinimum=function(){if(1===arguments.length){var t=arguments[0];this.setMinimum(t._pt[0],t._pt[1])}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(this._isNull)return this.initialize(e,n),null;var i=e.distance(n);i<this._distance&&this.initialize(e,n,i)}},_i.prototype.initialize=function(){if(0===arguments.length)this._isNull=!0;else if(2===arguments.length){var t=arguments[0],e=arguments[1];this._pt[0].setCoordinate(t),this._pt[1].setCoordinate(e),this._distance=t.distance(e),this._isNull=!1}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];this._pt[0].setCoordinate(n),this._pt[1].setCoordinate(i),this._distance=r,this._isNull=!1}},_i.prototype.getDistance=function(){return this._distance},_i.prototype.setMaximum=function(){if(1===arguments.length){var t=arguments[0];this.setMaximum(t._pt[0],t._pt[1])}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(this._isNull)return this.initialize(e,n),null;var i=e.distance(n);i>this._distance&&this.initialize(e,n,i)}},_i.prototype.interfaces_=function(){return[]},_i.prototype.getClass=function(){return _i};var mi=function(){};mi.prototype.interfaces_=function(){return[]},mi.prototype.getClass=function(){return mi},mi.computeDistance=function(){if(arguments[2]instanceof _i&&arguments[0]instanceof Kt&&arguments[1]instanceof C)for(var t=arguments[0],e=arguments[1],n=arguments[2],i=t.getCoordinates(),r=new dn,o=0;o<i.length-1;o++){r.setCoordinates(i[o],i[o+1]);var s=r.closestPoint(e);n.setMinimum(s,e)}else if(arguments[2]instanceof _i&&arguments[0]instanceof $t&&arguments[1]instanceof C){var a=arguments[0],u=arguments[1],l=arguments[2];mi.computeDistance(a.getExteriorRing(),u,l);for(var c=0;c<a.getNumInteriorRing();c++)mi.computeDistance(a.getInteriorRingN(c),u,l)}else if(arguments[2]instanceof _i&&arguments[0]instanceof ct&&arguments[1]instanceof C){var p=arguments[0],h=arguments[1],f=arguments[2];if(p instanceof Kt)mi.computeDistance(p,h,f);else if(p instanceof $t)mi.computeDistance(p,h,f);else if(p instanceof zt)for(var g=p,d=0;d<g.getNumGeometries();d++){var y=g.getGeometryN(d);mi.computeDistance(y,h,f)}else f.setMinimum(p.getCoordinate(),h)}else if(arguments[2]instanceof _i&&arguments[0]instanceof dn&&arguments[1]instanceof C){var _=arguments[0],m=arguments[1],v=arguments[2],I=_.closestPoint(m);v.setMinimum(I,m)}};var vi=function(t){this._maxPtDist=new _i,this._inputGeom=t||null},Ii={MaxPointDistanceFilter:{configurable:!0},MaxMidpointDistanceFilter:{configurable:!0}};vi.prototype.computeMaxMidpointDistance=function(t){var e=new xi(this._inputGeom);t.apply(e),this._maxPtDist.setMaximum(e.getMaxPointDistance())},vi.prototype.computeMaxVertexDistance=function(t){var e=new Ei(this._inputGeom);t.apply(e),this._maxPtDist.setMaximum(e.getMaxPointDistance())},vi.prototype.findDistance=function(t){return this.computeMaxVertexDistance(t),this.computeMaxMidpointDistance(t),this._maxPtDist.getDistance()},vi.prototype.getDistancePoints=function(){return this._maxPtDist},vi.prototype.interfaces_=function(){return[]},vi.prototype.getClass=function(){return vi},Ii.MaxPointDistanceFilter.get=function(){return Ei},Ii.MaxMidpointDistanceFilter.get=function(){return xi},Object.defineProperties(vi,Ii);var Ei=function(t){this._maxPtDist=new _i,this._minPtDist=new _i,this._geom=t||null};Ei.prototype.filter=function(t){this._minPtDist.initialize(),mi.computeDistance(this._geom,t,this._minPtDist),this._maxPtDist.setMaximum(this._minPtDist)},Ei.prototype.getMaxPointDistance=function(){return this._maxPtDist},Ei.prototype.interfaces_=function(){return[ft]},Ei.prototype.getClass=function(){return Ei};var xi=function(t){this._maxPtDist=new _i,this._minPtDist=new _i,this._geom=t||null};xi.prototype.filter=function(t,e){if(0===e)return null;var n=t.getCoordinate(e-1),i=t.getCoordinate(e),r=new C((n.x+i.x)/2,(n.y+i.y)/2);this._minPtDist.initialize(),mi.computeDistance(this._geom,r,this._minPtDist),this._maxPtDist.setMaximum(this._minPtDist)},xi.prototype.isDone=function(){return!1},xi.prototype.isGeometryChanged=function(){return!1},xi.prototype.getMaxPointDistance=function(){return this._maxPtDist},xi.prototype.interfaces_=function(){return[Ut]},xi.prototype.getClass=function(){return xi};var Ni=function(t){this._comps=t||null};Ni.prototype.filter=function(t){t instanceof $t&&this._comps.add(t)},Ni.prototype.interfaces_=function(){return[Vt]},Ni.prototype.getClass=function(){return Ni},Ni.getPolygons=function(){if(1===arguments.length){var t=arguments[0];return Ni.getPolygons(t,new Nt)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return e instanceof $t?n.add(e):e instanceof zt&&e.apply(new Ni(n)),n}};var Ci=function(){if(this._lines=null,this._isForcedToLineString=!1,1===arguments.length){var t=arguments[0];this._lines=t}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this._lines=e,this._isForcedToLineString=n}};Ci.prototype.filter=function(t){if(this._isForcedToLineString&&t instanceof ee){var e=t.getFactory().createLineString(t.getCoordinateSequence());return this._lines.add(e),null}t instanceof Kt&&this._lines.add(t)},Ci.prototype.setForceToLineString=function(t){this._isForcedToLineString=t},Ci.prototype.interfaces_=function(){return[lt]},Ci.prototype.getClass=function(){return Ci},Ci.getGeometry=function(){if(1===arguments.length){var t=arguments[0];return t.getFactory().buildGeometry(Ci.getLines(t))}if(2===arguments.length){var e=arguments[0],n=arguments[1];return e.getFactory().buildGeometry(Ci.getLines(e,n))}},Ci.getLines=function(){if(1===arguments.length){var t=arguments[0];return Ci.getLines(t,!1)}if(2===arguments.length){if(T(arguments[0],It)&&T(arguments[1],It)){for(var e=arguments[0],n=arguments[1],i=e.iterator();i.hasNext();){var r=i.next();Ci.getLines(r,n)}return n}if(arguments[0]instanceof ct&&"boolean"==typeof arguments[1]){var o=arguments[0],s=arguments[1],a=new Nt;return o.apply(new Ci(a,s)),a}if(arguments[0]instanceof ct&&T(arguments[1],It)){var u=arguments[0],l=arguments[1];return u instanceof Kt?l.add(u):u.apply(new Ci(l)),l}}else if(3===arguments.length){if("boolean"==typeof arguments[2]&&T(arguments[0],It)&&T(arguments[1],It)){for(var c=arguments[0],p=arguments[1],h=arguments[2],f=c.iterator();f.hasNext();){var g=f.next();Ci.getLines(g,p,h)}return p}if("boolean"==typeof arguments[2]&&arguments[0]instanceof ct&&T(arguments[1],It)){var d=arguments[0],y=arguments[1],_=arguments[2];return d.apply(new Ci(y,_)),y}}};var Si=function(){if(this._boundaryRule=gt.OGC_SFS_BOUNDARY_RULE,this._isIn=null,this._numBoundaries=null,0===arguments.length);else if(1===arguments.length){var t=arguments[0];if(null===t)throw new m("Rule must be non-null");this._boundaryRule=t}};Si.prototype.locateInternal=function(){if(arguments[0]instanceof C&&arguments[1]instanceof $t){var t=arguments[0],e=arguments[1];if(e.isEmpty())return w.EXTERIOR;var n=e.getExteriorRing(),i=this.locateInPolygonRing(t,n);if(i===w.EXTERIOR)return w.EXTERIOR;if(i===w.BOUNDARY)return w.BOUNDARY;for(var r=0;r<e.getNumInteriorRing();r++){var o=e.getInteriorRingN(r),s=this.locateInPolygonRing(t,o);if(s===w.INTERIOR)return w.EXTERIOR;if(s===w.BOUNDARY)return w.BOUNDARY}return w.INTERIOR}if(arguments[0]instanceof C&&arguments[1]instanceof Kt){var a=arguments[0],u=arguments[1];if(!u.getEnvelopeInternal().intersects(a))return w.EXTERIOR;var l=u.getCoordinates();return u.isClosed()||!a.equals(l[0])&&!a.equals(l[l.length-1])?at.isOnLine(a,l)?w.INTERIOR:w.EXTERIOR:w.BOUNDARY}if(arguments[0]instanceof C&&arguments[1]instanceof Qt){var c=arguments[0];return arguments[1].getCoordinate().equals2D(c)?w.INTERIOR:w.EXTERIOR}},Si.prototype.locateInPolygonRing=function(t,e){return e.getEnvelopeInternal().intersects(t)?at.locatePointInRing(t,e.getCoordinates()):w.EXTERIOR},Si.prototype.intersects=function(t,e){return this.locate(t,e)!==w.EXTERIOR},Si.prototype.updateLocationInfo=function(t){t===w.INTERIOR&&(this._isIn=!0),t===w.BOUNDARY&&this._numBoundaries++},Si.prototype.computeLocation=function(t,e){if(e instanceof Qt&&this.updateLocationInfo(this.locateInternal(t,e)),e instanceof Kt)this.updateLocationInfo(this.locateInternal(t,e));else if(e instanceof $t)this.updateLocationInfo(this.locateInternal(t,e));else if(e instanceof Xt)for(var n=e,i=0;i<n.getNumGeometries();i++){var r=n.getGeometryN(i);this.updateLocationInfo(this.locateInternal(t,r))}else if(e instanceof ne)for(var o=e,s=0;s<o.getNumGeometries();s++){var a=o.getGeometryN(s);this.updateLocationInfo(this.locateInternal(t,a))}else if(e instanceof zt)for(var u=new Un(e);u.hasNext();){var l=u.next();l!==e&&this.computeLocation(t,l)}},Si.prototype.locate=function(t,e){return e.isEmpty()?w.EXTERIOR:e instanceof Kt?this.locateInternal(t,e):e instanceof $t?this.locateInternal(t,e):(this._isIn=!1,this._numBoundaries=0,this.computeLocation(t,e),this._boundaryRule.isInBoundary(this._numBoundaries)?w.BOUNDARY:this._numBoundaries>0||this._isIn?w.INTERIOR:w.EXTERIOR)},Si.prototype.interfaces_=function(){return[]},Si.prototype.getClass=function(){return Si};var Li=function t(){if(this._component=null,this._segIndex=null,this._pt=null,2===arguments.length){var e=arguments[0],n=arguments[1];t.call(this,e,t.INSIDE_AREA,n)}else if(3===arguments.length){var i=arguments[0],r=arguments[1],o=arguments[2];this._component=i,this._segIndex=r,this._pt=o}},bi={INSIDE_AREA:{configurable:!0}};Li.prototype.isInsideArea=function(){return this._segIndex===Li.INSIDE_AREA},Li.prototype.getCoordinate=function(){return this._pt},Li.prototype.getGeometryComponent=function(){return this._component},Li.prototype.getSegmentIndex=function(){return this._segIndex},Li.prototype.interfaces_=function(){return[]},Li.prototype.getClass=function(){return Li},bi.INSIDE_AREA.get=function(){return-1},Object.defineProperties(Li,bi);var wi=function(t){this._pts=t||null};wi.prototype.filter=function(t){t instanceof Qt&&this._pts.add(t)},wi.prototype.interfaces_=function(){return[Vt]},wi.prototype.getClass=function(){return wi},wi.getPoints=function(){if(1===arguments.length){var t=arguments[0];return t instanceof Qt?$e.singletonList(t):wi.getPoints(t,new Nt)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return e instanceof Qt?n.add(e):e instanceof zt&&e.apply(new wi(n)),n}};var Oi=function(){this._locations=null;var t=arguments[0];this._locations=t};Oi.prototype.filter=function(t){(t instanceof Qt||t instanceof Kt||t instanceof $t)&&this._locations.add(new Li(t,0,t.getCoordinate()))},Oi.prototype.interfaces_=function(){return[Vt]},Oi.prototype.getClass=function(){return Oi},Oi.getLocations=function(t){var e=new Nt;return t.apply(new Oi(e)),e};var Ti=function(){if(this._geom=null,this._terminateDistance=0,this._ptLocator=new Si,this._minDistanceLocation=null,this._minDistance=v.MAX_VALUE,2===arguments.length){var t=arguments[0],e=arguments[1];this._geom=[t,e],this._terminateDistance=0}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];this._geom=new Array(2).fill(null),this._geom[0]=n,this._geom[1]=i,this._terminateDistance=r}};Ti.prototype.computeContainmentDistance=function(){if(0===arguments.length){var t=new Array(2).fill(null);if(this.computeContainmentDistance(0,t),this._minDistance<=this._terminateDistance)return null;this.computeContainmentDistance(1,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1],i=1-e,r=Ni.getPolygons(this._geom[e]);if(r.size()>0){var o=Oi.getLocations(this._geom[i]);if(this.computeContainmentDistance(o,r,n),this._minDistance<=this._terminateDistance)return this._minDistanceLocation[i]=n[0],this._minDistanceLocation[e]=n[1],null}}else if(3===arguments.length)if(arguments[2]instanceof Array&&T(arguments[0],xt)&&T(arguments[1],xt)){for(var s=arguments[0],a=arguments[1],u=arguments[2],l=0;l<s.size();l++)for(var c=s.get(l),p=0;p<a.size();p++)if(this.computeContainmentDistance(c,a.get(p),u),this._minDistance<=this._terminateDistance)return null}else if(arguments[2]instanceof Array&&arguments[0]instanceof Li&&arguments[1]instanceof $t){var h=arguments[0],f=arguments[1],g=arguments[2],d=h.getCoordinate();if(w.EXTERIOR!==this._ptLocator.locate(d,f))return this._minDistance=0,g[0]=h,g[1]=new Li(f,d),null}},Ti.prototype.computeMinDistanceLinesPoints=function(t,e,n){for(var i=0;i<t.size();i++)for(var r=t.get(i),o=0;o<e.size();o++){var s=e.get(o);if(this.computeMinDistance(r,s,n),this._minDistance<=this._terminateDistance)return null}},Ti.prototype.computeFacetDistance=function(){var t=new Array(2).fill(null),e=Ci.getLines(this._geom[0]),n=Ci.getLines(this._geom[1]),i=wi.getPoints(this._geom[0]),r=wi.getPoints(this._geom[1]);return this.computeMinDistanceLines(e,n,t),this.updateMinDistance(t,!1),this._minDistance<=this._terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistanceLinesPoints(e,r,t),this.updateMinDistance(t,!1),this._minDistance<=this._terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistanceLinesPoints(n,i,t),this.updateMinDistance(t,!0),this._minDistance<=this._terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistancePoints(i,r,t),void this.updateMinDistance(t,!1))))},Ti.prototype.nearestLocations=function(){return this.computeMinDistance(),this._minDistanceLocation},Ti.prototype.updateMinDistance=function(t,e){if(null===t[0])return null;e?(this._minDistanceLocation[0]=t[1],this._minDistanceLocation[1]=t[0]):(this._minDistanceLocation[0]=t[0],this._minDistanceLocation[1]=t[1])},Ti.prototype.nearestPoints=function(){this.computeMinDistance();return[this._minDistanceLocation[0].getCoordinate(),this._minDistanceLocation[1].getCoordinate()]},Ti.prototype.computeMinDistance=function(){if(0===arguments.length){if(null!==this._minDistanceLocation)return null;if(this._minDistanceLocation=new Array(2).fill(null),this.computeContainmentDistance(),this._minDistance<=this._terminateDistance)return null;this.computeFacetDistance()}else if(3===arguments.length)if(arguments[2]instanceof Array&&arguments[0]instanceof Kt&&arguments[1]instanceof Qt){var t=arguments[0],e=arguments[1],n=arguments[2];if(t.getEnvelopeInternal().distance(e.getEnvelopeInternal())>this._minDistance)return null;for(var i=t.getCoordinates(),r=e.getCoordinate(),o=0;o<i.length-1;o++){var s=at.distancePointLine(r,i[o],i[o+1]);if(s<this._minDistance){this._minDistance=s;var a=new dn(i[o],i[o+1]).closestPoint(r);n[0]=new Li(t,o,a),n[1]=new Li(e,0,r)}if(this._minDistance<=this._terminateDistance)return null}}else if(arguments[2]instanceof Array&&arguments[0]instanceof Kt&&arguments[1]instanceof Kt){var u=arguments[0],l=arguments[1],c=arguments[2];if(u.getEnvelopeInternal().distance(l.getEnvelopeInternal())>this._minDistance)return null;for(var p=u.getCoordinates(),h=l.getCoordinates(),f=0;f<p.length-1;f++)for(var g=0;g<h.length-1;g++){var d=at.distanceLineLine(p[f],p[f+1],h[g],h[g+1]);if(d<this._minDistance){this._minDistance=d;var y=new dn(p[f],p[f+1]),_=new dn(h[g],h[g+1]),m=y.closestPoints(_);c[0]=new Li(u,f,m[0]),c[1]=new Li(l,g,m[1])}if(this._minDistance<=this._terminateDistance)return null}}},Ti.prototype.computeMinDistancePoints=function(t,e,n){for(var i=0;i<t.size();i++)for(var r=t.get(i),o=0;o<e.size();o++){var s=e.get(o),a=r.getCoordinate().distance(s.getCoordinate());if(a<this._minDistance&&(this._minDistance=a,n[0]=new Li(r,0,r.getCoordinate()),n[1]=new Li(s,0,s.getCoordinate())),this._minDistance<=this._terminateDistance)return null}},Ti.prototype.distance=function(){if(null===this._geom[0]||null===this._geom[1])throw new m("null geometries are not supported");return this._geom[0].isEmpty()||this._geom[1].isEmpty()?0:(this.computeMinDistance(),this._minDistance)},Ti.prototype.computeMinDistanceLines=function(t,e,n){for(var i=0;i<t.size();i++)for(var r=t.get(i),o=0;o<e.size();o++){var s=e.get(o);if(this.computeMinDistance(r,s,n),this._minDistance<=this._terminateDistance)return null}},Ti.prototype.interfaces_=function(){return[]},Ti.prototype.getClass=function(){return Ti},Ti.distance=function(t,e){return new Ti(t,e).distance()},Ti.isWithinDistance=function(t,e,n){return new Ti(t,e,n).distance()<=n},Ti.nearestPoints=function(t,e){return new Ti(t,e).nearestPoints()};var Ri=function(){this._pt=[new C,new C],this._distance=v.NaN,this._isNull=!0};Ri.prototype.getCoordinates=function(){return this._pt},Ri.prototype.getCoordinate=function(t){return this._pt[t]},Ri.prototype.setMinimum=function(){if(1===arguments.length){var t=arguments[0];this.setMinimum(t._pt[0],t._pt[1])}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(this._isNull)return this.initialize(e,n),null;var i=e.distance(n);i<this._distance&&this.initialize(e,n,i)}},Ri.prototype.initialize=function(){if(0===arguments.length)this._isNull=!0;else if(2===arguments.length){var t=arguments[0],e=arguments[1];this._pt[0].setCoordinate(t),this._pt[1].setCoordinate(e),this._distance=t.distance(e),this._isNull=!1}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];this._pt[0].setCoordinate(n),this._pt[1].setCoordinate(i),this._distance=r,this._isNull=!1}},Ri.prototype.toString=function(){return Z.toLineString(this._pt[0],this._pt[1])},Ri.prototype.getDistance=function(){return this._distance},Ri.prototype.setMaximum=function(){if(1===arguments.length){var t=arguments[0];this.setMaximum(t._pt[0],t._pt[1])}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(this._isNull)return this.initialize(e,n),null;var i=e.distance(n);i>this._distance&&this.initialize(e,n,i)}},Ri.prototype.interfaces_=function(){return[]},Ri.prototype.getClass=function(){return Ri};var Pi=function(){};Pi.prototype.interfaces_=function(){return[]},Pi.prototype.getClass=function(){return Pi},Pi.computeDistance=function(){if(arguments[2]instanceof Ri&&arguments[0]instanceof Kt&&arguments[1]instanceof C)for(var t=arguments[0],e=arguments[1],n=arguments[2],i=new dn,r=t.getCoordinates(),o=0;o<r.length-1;o++){i.setCoordinates(r[o],r[o+1]);var s=i.closestPoint(e);n.setMinimum(s,e)}else if(arguments[2]instanceof Ri&&arguments[0]instanceof $t&&arguments[1]instanceof C){var a=arguments[0],u=arguments[1],l=arguments[2];Pi.computeDistance(a.getExteriorRing(),u,l);for(var c=0;c<a.getNumInteriorRing();c++)Pi.computeDistance(a.getInteriorRingN(c),u,l)}else if(arguments[2]instanceof Ri&&arguments[0]instanceof ct&&arguments[1]instanceof C){var p=arguments[0],h=arguments[1],f=arguments[2];if(p instanceof Kt)Pi.computeDistance(p,h,f);else if(p instanceof $t)Pi.computeDistance(p,h,f);else if(p instanceof zt)for(var g=p,d=0;d<g.getNumGeometries();d++){var y=g.getGeometryN(d);Pi.computeDistance(y,h,f)}else f.setMinimum(p.getCoordinate(),h)}else if(arguments[2]instanceof Ri&&arguments[0]instanceof dn&&arguments[1]instanceof C){var _=arguments[0],m=arguments[1],v=arguments[2],I=_.closestPoint(m);v.setMinimum(I,m)}};var Di=function(){this._g0=null,this._g1=null,this._ptDist=new Ri,this._densifyFrac=0;var t=arguments[0],e=arguments[1];this._g0=t,this._g1=e},Mi={MaxPointDistanceFilter:{configurable:!0},MaxDensifiedByFractionDistanceFilter:{configurable:!0}};Di.prototype.getCoordinates=function(){return this._ptDist.getCoordinates()},Di.prototype.setDensifyFraction=function(t){if(t>1||t<=0)throw new m("Fraction is not in range (0.0 - 1.0]");this._densifyFrac=t},Di.prototype.compute=function(t,e){this.computeOrientedDistance(t,e,this._ptDist),this.computeOrientedDistance(e,t,this._ptDist)},Di.prototype.distance=function(){return this.compute(this._g0,this._g1),this._ptDist.getDistance()},Di.prototype.computeOrientedDistance=function(t,e,n){var i=new Ai(e);if(t.apply(i),n.setMaximum(i.getMaxPointDistance()),this._densifyFrac>0){var r=new Fi(e,this._densifyFrac);t.apply(r),n.setMaximum(r.getMaxPointDistance())}},Di.prototype.orientedDistance=function(){return this.computeOrientedDistance(this._g0,this._g1,this._ptDist),this._ptDist.getDistance()},Di.prototype.interfaces_=function(){return[]},Di.prototype.getClass=function(){return Di},Di.distance=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return new Di(t,e).distance()}if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2],o=new Di(n,i);return o.setDensifyFraction(r),o.distance()}},Mi.MaxPointDistanceFilter.get=function(){return Ai},Mi.MaxDensifiedByFractionDistanceFilter.get=function(){return Fi},Object.defineProperties(Di,Mi);var Ai=function(){this._maxPtDist=new Ri,this._minPtDist=new Ri,this._euclideanDist=new Pi,this._geom=null;var t=arguments[0];this._geom=t};Ai.prototype.filter=function(t){this._minPtDist.initialize(),Pi.computeDistance(this._geom,t,this._minPtDist),this._maxPtDist.setMaximum(this._minPtDist)},Ai.prototype.getMaxPointDistance=function(){return this._maxPtDist},Ai.prototype.interfaces_=function(){return[ft]},Ai.prototype.getClass=function(){return Ai};var Fi=function(){this._maxPtDist=new Ri,this._minPtDist=new Ri,this._geom=null,this._numSubSegs=0;var t=arguments[0],e=arguments[1];this._geom=t,this._numSubSegs=Math.trunc(Math.round(1/e))};Fi.prototype.filter=function(t,e){if(0===e)return null;for(var n=t.getCoordinate(e-1),i=t.getCoordinate(e),r=(i.x-n.x)/this._numSubSegs,o=(i.y-n.y)/this._numSubSegs,s=0;s<this._numSubSegs;s++){var a=n.x+s*r,u=n.y+s*o,l=new C(a,u);this._minPtDist.initialize(),Pi.computeDistance(this._geom,l,this._minPtDist),this._maxPtDist.setMaximum(this._minPtDist)}},Fi.prototype.isDone=function(){return!1},Fi.prototype.isGeometryChanged=function(){return!1},Fi.prototype.getMaxPointDistance=function(){return this._maxPtDist},Fi.prototype.interfaces_=function(){return[Ut]},Fi.prototype.getClass=function(){return Fi};var Gi=function(t,e,n){this._minValidDistance=null,this._maxValidDistance=null,this._minDistanceFound=null,this._maxDistanceFound=null,this._isValid=!0,this._errMsg=null,this._errorLocation=null,this._errorIndicator=null,this._input=t||null,this._bufDistance=e||null,this._result=n||null},qi={VERBOSE:{configurable:!0},MAX_DISTANCE_DIFF_FRAC:{configurable:!0}};Gi.prototype.checkMaximumDistance=function(t,e,n){var i=new Di(e,t);if(i.setDensifyFraction(.25),this._maxDistanceFound=i.orientedDistance(),this._maxDistanceFound>n){this._isValid=!1;var r=i.getCoordinates();this._errorLocation=r[1],this._errorIndicator=t.getFactory().createLineString(r),this._errMsg="Distance between buffer curve and input is too large ("+this._maxDistanceFound+" at "+Z.toLineString(r[0],r[1])+")"}},Gi.prototype.isValid=function(){var t=Math.abs(this._bufDistance),e=Gi.MAX_DISTANCE_DIFF_FRAC*t;return this._minValidDistance=t-e,this._maxValidDistance=t+e,!(!this._input.isEmpty()&&!this._result.isEmpty())||(this._bufDistance>0?this.checkPositiveValid():this.checkNegativeValid(),Gi.VERBOSE&&Y.out.println("Min Dist= "+this._minDistanceFound+"  err= "+(1-this._minDistanceFound/this._bufDistance)+"  Max Dist= "+this._maxDistanceFound+"  err= "+(this._maxDistanceFound/this._bufDistance-1)),this._isValid)},Gi.prototype.checkNegativeValid=function(){if(!(this._input instanceof $t||this._input instanceof ne||this._input instanceof zt))return null;var t=this.getPolygonLines(this._input);if(this.checkMinimumDistance(t,this._result,this._minValidDistance),!this._isValid)return null;this.checkMaximumDistance(t,this._result,this._maxValidDistance)},Gi.prototype.getErrorIndicator=function(){return this._errorIndicator},Gi.prototype.checkMinimumDistance=function(t,e,n){var i=new Ti(t,e,n);if(this._minDistanceFound=i.distance(),this._minDistanceFound<n){this._isValid=!1;var r=i.nearestPoints();this._errorLocation=i.nearestPoints()[1],this._errorIndicator=t.getFactory().createLineString(r),this._errMsg="Distance between buffer curve and input is too small ("+this._minDistanceFound+" at "+Z.toLineString(r[0],r[1])+" )"}},Gi.prototype.checkPositiveValid=function(){var t=this._result.getBoundary();if(this.checkMinimumDistance(this._input,t,this._minValidDistance),!this._isValid)return null;this.checkMaximumDistance(this._input,t,this._maxValidDistance)},Gi.prototype.getErrorLocation=function(){return this._errorLocation},Gi.prototype.getPolygonLines=function(t){for(var e=new Nt,n=new Ci(e),i=Ni.getPolygons(t).iterator();i.hasNext();){i.next().apply(n)}return t.getFactory().buildGeometry(e)},Gi.prototype.getErrorMessage=function(){return this._errMsg},Gi.prototype.interfaces_=function(){return[]},Gi.prototype.getClass=function(){return Gi},qi.VERBOSE.get=function(){return!1},qi.MAX_DISTANCE_DIFF_FRAC.get=function(){return.012},Object.defineProperties(Gi,qi);var Bi=function(t,e,n){this._isValid=!0,this._errorMsg=null,this._errorLocation=null,this._errorIndicator=null,this._input=t||null,this._distance=e||null,this._result=n||null},Vi={VERBOSE:{configurable:!0},MAX_ENV_DIFF_FRAC:{configurable:!0}};Bi.prototype.isValid=function(){return this.checkPolygonal(),this._isValid?(this.checkExpectedEmpty(),this._isValid?(this.checkEnvelope(),this._isValid?(this.checkArea(),this._isValid?(this.checkDistance(),this._isValid):this._isValid):this._isValid):this._isValid):this._isValid},Bi.prototype.checkEnvelope=function(){if(this._distance<0)return null;var t=this._distance*Bi.MAX_ENV_DIFF_FRAC;0===t&&(t=.001);var e=new j(this._input.getEnvelopeInternal());e.expandBy(this._distance);var n=new j(this._result.getEnvelopeInternal());n.expandBy(t),n.contains(e)||(this._isValid=!1,this._errorMsg="Buffer envelope is incorrect",this._errorIndicator=this._input.getFactory().toGeometry(n)),this.report("Envelope")},Bi.prototype.checkDistance=function(){var t=new Gi(this._input,this._distance,this._result);t.isValid()||(this._isValid=!1,this._errorMsg=t.getErrorMessage(),this._errorLocation=t.getErrorLocation(),this._errorIndicator=t.getErrorIndicator()),this.report("Distance")},Bi.prototype.checkArea=function(){var t=this._input.getArea(),e=this._result.getArea();this._distance>0&&t>e&&(this._isValid=!1,this._errorMsg="Area of positive buffer is smaller than input",this._errorIndicator=this._result),this._distance<0&&t<e&&(this._isValid=!1,this._errorMsg="Area of negative buffer is larger than input",this._errorIndicator=this._result),this.report("Area")},Bi.prototype.checkPolygonal=function(){this._result instanceof $t||this._result instanceof ne||(this._isValid=!1),this._errorMsg="Result is not polygonal",this._errorIndicator=this._result,this.report("Polygonal")},Bi.prototype.getErrorIndicator=function(){return this._errorIndicator},Bi.prototype.getErrorLocation=function(){return this._errorLocation},Bi.prototype.checkExpectedEmpty=function(){return this._input.getDimension()>=2?null:this._distance>0?null:(this._result.isEmpty()||(this._isValid=!1,this._errorMsg="Result is non-empty",this._errorIndicator=this._result),void this.report("ExpectedEmpty"))},Bi.prototype.report=function(t){if(!Bi.VERBOSE)return null;Y.out.println("Check "+t+": "+(this._isValid?"passed":"FAILED"))},Bi.prototype.getErrorMessage=function(){return this._errorMsg},Bi.prototype.interfaces_=function(){return[]},Bi.prototype.getClass=function(){return Bi},Bi.isValidMsg=function(t,e,n){var i=new Bi(t,e,n);return i.isValid()?null:i.getErrorMessage()},Bi.isValid=function(t,e,n){return!!new Bi(t,e,n).isValid()},Vi.VERBOSE.get=function(){return!1},Vi.MAX_ENV_DIFF_FRAC.get=function(){return.012},Object.defineProperties(Bi,Vi);var Ui=function(){this._pts=null,this._data=null;var t=arguments[0],e=arguments[1];this._pts=t,this._data=e};Ui.prototype.getCoordinates=function(){return this._pts},Ui.prototype.size=function(){return this._pts.length},Ui.prototype.getCoordinate=function(t){return this._pts[t]},Ui.prototype.isClosed=function(){return this._pts[0].equals(this._pts[this._pts.length-1])},Ui.prototype.getSegmentOctant=function(t){return t===this._pts.length-1?-1:pn.octant(this.getCoordinate(t),this.getCoordinate(t+1))},Ui.prototype.setData=function(t){this._data=t},Ui.prototype.getData=function(){return this._data},Ui.prototype.toString=function(){return Z.toLineString(new ue(this._pts))},Ui.prototype.interfaces_=function(){return[hn]},Ui.prototype.getClass=function(){return Ui};var zi=function(){this._findAllIntersections=!1,this._isCheckEndSegmentsOnly=!1,this._li=null,this._interiorIntersection=null,this._intSegments=null,this._intersections=new Nt,this._intersectionCount=0,this._keepIntersections=!0;var t=arguments[0];this._li=t,this._interiorIntersection=null};zi.prototype.getInteriorIntersection=function(){return this._interiorIntersection},zi.prototype.setCheckEndSegmentsOnly=function(t){this._isCheckEndSegmentsOnly=t},zi.prototype.getIntersectionSegments=function(){return this._intSegments},zi.prototype.count=function(){return this._intersectionCount},zi.prototype.getIntersections=function(){return this._intersections},zi.prototype.setFindAllIntersections=function(t){this._findAllIntersections=t},zi.prototype.setKeepIntersections=function(t){this._keepIntersections=t},zi.prototype.processIntersections=function(t,e,n,i){if(!this._findAllIntersections&&this.hasIntersection())return null;if(t===n&&e===i)return null;if(this._isCheckEndSegmentsOnly){if(!(this.isEndSegment(t,e)||this.isEndSegment(n,i)))return null}var r=t.getCoordinates()[e],o=t.getCoordinates()[e+1],s=n.getCoordinates()[i],a=n.getCoordinates()[i+1];this._li.computeIntersection(r,o,s,a),this._li.hasIntersection()&&this._li.isInteriorIntersection()&&(this._intSegments=new Array(4).fill(null),this._intSegments[0]=r,this._intSegments[1]=o,this._intSegments[2]=s,this._intSegments[3]=a,this._interiorIntersection=this._li.getIntersection(0),this._keepIntersections&&this._intersections.add(this._interiorIntersection),this._intersectionCount++)},zi.prototype.isEndSegment=function(t,e){return 0===e||e>=t.size()-2},zi.prototype.hasIntersection=function(){return null!==this._interiorIntersection},zi.prototype.isDone=function(){return!this._findAllIntersections&&null!==this._interiorIntersection},zi.prototype.interfaces_=function(){return[Wn]},zi.prototype.getClass=function(){return zi},zi.createAllIntersectionsFinder=function(t){var e=new zi(t);return e.setFindAllIntersections(!0),e},zi.createAnyIntersectionFinder=function(t){return new zi(t)},zi.createIntersectionCounter=function(t){var e=new zi(t);return e.setFindAllIntersections(!0),e.setKeepIntersections(!1),e};var Xi=function(){this._li=new rt,this._segStrings=null,this._findAllIntersections=!1,this._segInt=null,this._isValid=!0;var t=arguments[0];this._segStrings=t};Xi.prototype.execute=function(){if(null!==this._segInt)return null;this.checkInteriorIntersections()},Xi.prototype.getIntersections=function(){return this._segInt.getIntersections()},Xi.prototype.isValid=function(){return this.execute(),this._isValid},Xi.prototype.setFindAllIntersections=function(t){this._findAllIntersections=t},Xi.prototype.checkInteriorIntersections=function(){this._isValid=!0,this._segInt=new zi(this._li),this._segInt.setFindAllIntersections(this._findAllIntersections);var t=new xn;if(t.setSegmentIntersector(this._segInt),t.computeNodes(this._segStrings),this._segInt.hasIntersection())return this._isValid=!1,null},Xi.prototype.checkValid=function(){if(this.execute(),!this._isValid)throw new we(this.getErrorMessage(),this._segInt.getInteriorIntersection())},Xi.prototype.getErrorMessage=function(){if(this._isValid)return"no intersections found";var t=this._segInt.getIntersectionSegments();return"found non-noded intersection between "+Z.toLineString(t[0],t[1])+" and "+Z.toLineString(t[2],t[3])},Xi.prototype.interfaces_=function(){return[]},Xi.prototype.getClass=function(){return Xi},Xi.computeIntersections=function(t){var e=new Xi(t);return e.setFindAllIntersections(!0),e.isValid(),e.getIntersections()};var Yi=function t(){this._nv=null;var e=arguments[0];this._nv=new Xi(t.toSegmentStrings(e))};Yi.prototype.checkValid=function(){this._nv.checkValid()},Yi.prototype.interfaces_=function(){return[]},Yi.prototype.getClass=function(){return Yi},Yi.toSegmentStrings=function(t){for(var e=new Nt,n=t.iterator();n.hasNext();){var i=n.next();e.add(new Ui(i.getCoordinates(),i))}return e},Yi.checkValid=function(t){new Yi(t).checkValid()};var ki=function(t){this._mapOp=t};ki.prototype.map=function(t){for(var e=new Nt,n=0;n<t.getNumGeometries();n++){var i=this._mapOp.map(t.getGeometryN(n));i.isEmpty()||e.add(i)}return t.getFactory().createGeometryCollection(_e.toGeometryArray(e))},ki.prototype.interfaces_=function(){return[]},ki.prototype.getClass=function(){return ki},ki.map=function(t,e){return new ki(e).map(t)};var ji=function(){this._op=null,this._geometryFactory=null,this._ptLocator=null,this._lineEdgesList=new Nt,this._resultLineList=new Nt;var t=arguments[0],e=arguments[1],n=arguments[2];this._op=t,this._geometryFactory=e,this._ptLocator=n};ji.prototype.collectLines=function(t){for(var e=this._op.getGraph().getEdgeEnds().iterator();e.hasNext();){var n=e.next();this.collectLineEdge(n,t,this._lineEdgesList),this.collectBoundaryTouchEdge(n,t,this._lineEdgesList)}},ji.prototype.labelIsolatedLine=function(t,e){var n=this._ptLocator.locate(t.getCoordinate(),this._op.getArgGeometry(e));t.getLabel().setLocation(e,n)},ji.prototype.build=function(t){return this.findCoveredLineEdges(),this.collectLines(t),this.buildLines(t),this._resultLineList},ji.prototype.collectLineEdge=function(t,e,n){var i=t.getLabel(),r=t.getEdge();t.isLineEdge()&&(t.isVisited()||!Lr.isResultOfOp(i,e)||r.isCovered()||(n.add(r),t.setVisitedEdge(!0)))},ji.prototype.findCoveredLineEdges=function(){for(var t=this._op.getGraph().getNodes().iterator();t.hasNext();){t.next().getEdges().findCoveredLineEdges()}for(var e=this._op.getGraph().getEdgeEnds().iterator();e.hasNext();){var n=e.next(),i=n.getEdge();if(n.isLineEdge()&&!i.isCoveredSet()){var r=this._op.isCoveredByA(n.getCoordinate());i.setCovered(r)}}},ji.prototype.labelIsolatedLines=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next(),i=n.getLabel();n.isIsolated()&&(i.isNull(0)?this.labelIsolatedLine(n,0):this.labelIsolatedLine(n,1))}},ji.prototype.buildLines=function(t){for(var e=this._lineEdgesList.iterator();e.hasNext();){var n=e.next(),i=this._geometryFactory.createLineString(n.getCoordinates());this._resultLineList.add(i),n.setInResult(!0)}},ji.prototype.collectBoundaryTouchEdge=function(t,e,n){var i=t.getLabel();return t.isLineEdge()?null:t.isVisited()?null:t.isInteriorAreaEdge()?null:t.getEdge().isInResult()?null:(et.isTrue(!(t.isInResult()||t.getSym().isInResult())||!t.getEdge().isInResult()),void(Lr.isResultOfOp(i,e)&&e===Lr.INTERSECTION&&(n.add(t.getEdge()),t.setVisitedEdge(!0))))},ji.prototype.interfaces_=function(){return[]},ji.prototype.getClass=function(){return ji};var Hi=function(){this._op=null,this._geometryFactory=null,this._resultPointList=new Nt;var t=arguments[0],e=arguments[1];this._op=t,this._geometryFactory=e};Hi.prototype.filterCoveredNodeToPoint=function(t){var e=t.getCoordinate();if(!this._op.isCoveredByLA(e)){var n=this._geometryFactory.createPoint(e);this._resultPointList.add(n)}},Hi.prototype.extractNonCoveredResultNodes=function(t){for(var e=this._op.getGraph().getNodes().iterator();e.hasNext();){var n=e.next();if(!n.isInResult()&&(!n.isIncidentEdgeInResult()&&(0===n.getEdges().getDegree()||t===Lr.INTERSECTION))){var i=n.getLabel();Lr.isResultOfOp(i,t)&&this.filterCoveredNodeToPoint(n)}}},Hi.prototype.build=function(t){return this.extractNonCoveredResultNodes(t),this._resultPointList},Hi.prototype.interfaces_=function(){return[]},Hi.prototype.getClass=function(){return Hi};var Wi=function(){this._inputGeom=null,this._factory=null,this._pruneEmptyGeometry=!0,this._preserveGeometryCollectionType=!0,this._preserveCollections=!1,this._preserveType=!1};Wi.prototype.transformPoint=function(t,e){return this._factory.createPoint(this.transformCoordinates(t.getCoordinateSequence(),t))},Wi.prototype.transformPolygon=function(t,e){var n=!0,i=this.transformLinearRing(t.getExteriorRing(),t);null!==i&&i instanceof ee&&!i.isEmpty()||(n=!1);for(var r=new Nt,o=0;o<t.getNumInteriorRing();o++){var s=this.transformLinearRing(t.getInteriorRingN(o),t);null===s||s.isEmpty()||(s instanceof ee||(n=!1),r.add(s))}if(n)return this._factory.createPolygon(i,r.toArray([]));var a=new Nt;return null!==i&&a.add(i),a.addAll(r),this._factory.buildGeometry(a)},Wi.prototype.createCoordinateSequence=function(t){return this._factory.getCoordinateSequenceFactory().create(t)},Wi.prototype.getInputGeometry=function(){return this._inputGeom},Wi.prototype.transformMultiLineString=function(t,e){for(var n=new Nt,i=0;i<t.getNumGeometries();i++){var r=this.transformLineString(t.getGeometryN(i),t);null!==r&&(r.isEmpty()||n.add(r))}return this._factory.buildGeometry(n)},Wi.prototype.transformCoordinates=function(t,e){return this.copy(t)},Wi.prototype.transformLineString=function(t,e){return this._factory.createLineString(this.transformCoordinates(t.getCoordinateSequence(),t))},Wi.prototype.transformMultiPoint=function(t,e){for(var n=new Nt,i=0;i<t.getNumGeometries();i++){var r=this.transformPoint(t.getGeometryN(i),t);null!==r&&(r.isEmpty()||n.add(r))}return this._factory.buildGeometry(n)},Wi.prototype.transformMultiPolygon=function(t,e){for(var n=new Nt,i=0;i<t.getNumGeometries();i++){var r=this.transformPolygon(t.getGeometryN(i),t);null!==r&&(r.isEmpty()||n.add(r))}return this._factory.buildGeometry(n)},Wi.prototype.copy=function(t){return t.copy()},Wi.prototype.transformGeometryCollection=function(t,e){for(var n=new Nt,i=0;i<t.getNumGeometries();i++){var r=this.transform(t.getGeometryN(i));null!==r&&(this._pruneEmptyGeometry&&r.isEmpty()||n.add(r))}return this._preserveGeometryCollectionType?this._factory.createGeometryCollection(_e.toGeometryArray(n)):this._factory.buildGeometry(n)},Wi.prototype.transform=function(t){if(this._inputGeom=t,this._factory=t.getFactory(),t instanceof Qt)return this.transformPoint(t,null);if(t instanceof te)return this.transformMultiPoint(t,null);if(t instanceof ee)return this.transformLinearRing(t,null);if(t instanceof Kt)return this.transformLineString(t,null);if(t instanceof Xt)return this.transformMultiLineString(t,null);if(t instanceof $t)return this.transformPolygon(t,null);if(t instanceof ne)return this.transformMultiPolygon(t,null);if(t instanceof zt)return this.transformGeometryCollection(t,null);throw new m("Unknown Geometry subtype: "+t.getClass().getName())},Wi.prototype.transformLinearRing=function(t,e){var n=this.transformCoordinates(t.getCoordinateSequence(),t);if(null===n)return this._factory.createLinearRing(null);var i=n.size();return i>0&&i<4&&!this._preserveType?this._factory.createLineString(n):this._factory.createLinearRing(n)},Wi.prototype.interfaces_=function(){return[]},Wi.prototype.getClass=function(){return Wi};var Ki=function t(){if(this._snapTolerance=0,this._srcPts=null,this._seg=new dn,this._allowSnappingToSourceVertices=!1,this._isClosed=!1,arguments[0]instanceof Kt&&"number"==typeof arguments[1]){var e=arguments[0],n=arguments[1];t.call(this,e.getCoordinates(),n)}else if(arguments[0]instanceof Array&&"number"==typeof arguments[1]){var i=arguments[0],r=arguments[1];this._srcPts=i,this._isClosed=t.isClosed(i),this._snapTolerance=r}};Ki.prototype.snapVertices=function(t,e){for(var n=this._isClosed?t.size()-1:t.size(),i=0;i<n;i++){var r=t.get(i),o=this.findSnapForVertex(r,e);null!==o&&(t.set(i,new C(o)),0===i&&this._isClosed&&t.set(t.size()-1,new C(o)))}},Ki.prototype.findSnapForVertex=function(t,e){for(var n=0;n<e.length;n++){if(t.equals2D(e[n]))return null;if(t.distance(e[n])<this._snapTolerance)return e[n]}return null},Ki.prototype.snapTo=function(t){var e=new St(this._srcPts);this.snapVertices(e,t),this.snapSegments(e,t);return e.toCoordinateArray()},Ki.prototype.snapSegments=function(t,e){if(0===e.length)return null;var n=e.length;e[0].equals2D(e[e.length-1])&&(n=e.length-1);for(var i=0;i<n;i++){var r=e[i],o=this.findSegmentIndexToSnap(r,t);o>=0&&t.add(o+1,new C(r),!1)}},Ki.prototype.findSegmentIndexToSnap=function(t,e){for(var n=v.MAX_VALUE,i=-1,r=0;r<e.size()-1;r++){if(this._seg.p0=e.get(r),this._seg.p1=e.get(r+1),this._seg.p0.equals2D(t)||this._seg.p1.equals2D(t)){if(this._allowSnappingToSourceVertices)continue;return-1}var o=this._seg.distance(t);o<this._snapTolerance&&o<n&&(n=o,i=r)}return i},Ki.prototype.setAllowSnappingToSourceVertices=function(t){this._allowSnappingToSourceVertices=t},Ki.prototype.interfaces_=function(){return[]},Ki.prototype.getClass=function(){return Ki},Ki.isClosed=function(t){return!(t.length<=1)&&t[0].equals2D(t[t.length-1])};var Ji=function(t){this._srcGeom=t||null},Qi={SNAP_PRECISION_FACTOR:{configurable:!0}};Ji.prototype.snapTo=function(t,e){var n=this.extractTargetCoordinates(t);return new Zi(e,n).transform(this._srcGeom)},Ji.prototype.snapToSelf=function(t,e){var n=this.extractTargetCoordinates(this._srcGeom),i=new Zi(t,n,!0).transform(this._srcGeom),r=i;return e&&T(r,Zt)&&(r=i.buffer(0)),r},Ji.prototype.computeSnapTolerance=function(t){return this.computeMinimumSegmentLength(t)/10},Ji.prototype.extractTargetCoordinates=function(t){for(var e=new f,n=t.getCoordinates(),i=0;i<n.length;i++)e.add(n[i]);return e.toArray(new Array(0).fill(null))},Ji.prototype.computeMinimumSegmentLength=function(t){for(var e=v.MAX_VALUE,n=0;n<t.length-1;n++){var i=t[n].distance(t[n+1]);i<e&&(e=i)}return e},Ji.prototype.interfaces_=function(){return[]},Ji.prototype.getClass=function(){return Ji},Ji.snap=function(t,e,n){var i=new Array(2).fill(null),r=new Ji(t);i[0]=r.snapTo(e,n);var o=new Ji(e);return i[1]=o.snapTo(i[0],n),i},Ji.computeOverlaySnapTolerance=function(){if(1===arguments.length){var t=arguments[0],e=Ji.computeSizeBasedSnapTolerance(t),n=t.getPrecisionModel();if(n.getType()===fe.FIXED){var i=1/n.getScale()*2/1.415;i>e&&(e=i)}return e}if(2===arguments.length){var r=arguments[0],o=arguments[1];return Math.min(Ji.computeOverlaySnapTolerance(r),Ji.computeOverlaySnapTolerance(o))}},Ji.computeSizeBasedSnapTolerance=function(t){var e=t.getEnvelopeInternal();return Math.min(e.getHeight(),e.getWidth())*Ji.SNAP_PRECISION_FACTOR},Ji.snapToSelf=function(t,e,n){return new Ji(t).snapToSelf(e,n)},Qi.SNAP_PRECISION_FACTOR.get=function(){return 1e-9},Object.defineProperties(Ji,Qi);var Zi=function(t){function e(e,n,i){t.call(this),this._snapTolerance=e||null,this._snapPts=n||null,this._isSelfSnap=void 0!==i&&i}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.snapLine=function(t,e){var n=new Ki(t,this._snapTolerance);return n.setAllowSnappingToSourceVertices(this._isSelfSnap),n.snapTo(e)},e.prototype.transformCoordinates=function(t,e){var n=t.toCoordinateArray(),i=this.snapLine(n,this._snapPts);return this._factory.getCoordinateSequenceFactory().create(i)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Wi),$i=function(){this._isFirst=!0,this._commonMantissaBitsCount=53,this._commonBits=0,this._commonSignExp=null};$i.prototype.getCommon=function(){return v.longBitsToDouble(this._commonBits)},$i.prototype.add=function(t){var e=v.doubleToLongBits(t);if(this._isFirst)return this._commonBits=e,this._commonSignExp=$i.signExpBits(this._commonBits),this._isFirst=!1,null;if($i.signExpBits(e)!==this._commonSignExp)return this._commonBits=0,null;this._commonMantissaBitsCount=$i.numCommonMostSigMantissaBits(this._commonBits,e),this._commonBits=$i.zeroLowerBits(this._commonBits,64-(12+this._commonMantissaBitsCount))},$i.prototype.toString=function(){if(1===arguments.length){var t=arguments[0],e=v.longBitsToDouble(t),n="0000000000000000000000000000000000000000000000000000000000000000"+v.toBinaryString(t),i=n.substring(n.length-64);return i.substring(0,1)+"  "+i.substring(1,12)+"(exp) "+i.substring(12)+" [ "+e+" ]"}},$i.prototype.interfaces_=function(){return[]},$i.prototype.getClass=function(){return $i},$i.getBit=function(t,e){return 0!=(t&1<<e)?1:0},$i.signExpBits=function(t){return t>>52},$i.zeroLowerBits=function(t,e){return t&~((1<<e)-1)},$i.numCommonMostSigMantissaBits=function(t,e){for(var n=0,i=52;i>=0;i--){if($i.getBit(t,i)!==$i.getBit(e,i))return n;n++}return 52};var tr=function(){this._commonCoord=null,this._ccFilter=new nr},er={CommonCoordinateFilter:{configurable:!0},Translater:{configurable:!0}};tr.prototype.addCommonBits=function(t){var e=new ir(this._commonCoord);t.apply(e),t.geometryChanged()},tr.prototype.removeCommonBits=function(t){if(0===this._commonCoord.x&&0===this._commonCoord.y)return t;var e=new C(this._commonCoord);e.x=-e.x,e.y=-e.y;var n=new ir(e);return t.apply(n),t.geometryChanged(),t},tr.prototype.getCommonCoordinate=function(){return this._commonCoord},tr.prototype.add=function(t){t.apply(this._ccFilter),this._commonCoord=this._ccFilter.getCommonCoordinate()},tr.prototype.interfaces_=function(){return[]},tr.prototype.getClass=function(){return tr},er.CommonCoordinateFilter.get=function(){return nr},er.Translater.get=function(){return ir},Object.defineProperties(tr,er);var nr=function(){this._commonBitsX=new $i,this._commonBitsY=new $i};nr.prototype.filter=function(t){this._commonBitsX.add(t.x),this._commonBitsY.add(t.y)},nr.prototype.getCommonCoordinate=function(){return new C(this._commonBitsX.getCommon(),this._commonBitsY.getCommon())},nr.prototype.interfaces_=function(){return[ft]},nr.prototype.getClass=function(){return nr};var ir=function(){this.trans=null;var t=arguments[0];this.trans=t};ir.prototype.filter=function(t,e){var n=t.getOrdinate(e,0)+this.trans.x,i=t.getOrdinate(e,1)+this.trans.y;t.setOrdinate(e,0,n),t.setOrdinate(e,1,i)},ir.prototype.isDone=function(){return!1},ir.prototype.isGeometryChanged=function(){return!0},ir.prototype.interfaces_=function(){return[Ut]},ir.prototype.getClass=function(){return ir};var rr=function(t,e){this._geom=new Array(2).fill(null),this._snapTolerance=null,this._cbr=null,this._geom[0]=t,this._geom[1]=e,this.computeSnapTolerance()};rr.prototype.selfSnap=function(t){return new Ji(t).snapTo(t,this._snapTolerance)},rr.prototype.removeCommonBits=function(t){this._cbr=new tr,this._cbr.add(t[0]),this._cbr.add(t[1]);var e=new Array(2).fill(null);return e[0]=this._cbr.removeCommonBits(t[0].copy()),e[1]=this._cbr.removeCommonBits(t[1].copy()),e},rr.prototype.prepareResult=function(t){return this._cbr.addCommonBits(t),t},rr.prototype.getResultGeometry=function(t){var e=this.snap(this._geom),n=Lr.overlayOp(e[0],e[1],t);return this.prepareResult(n)},rr.prototype.checkValid=function(t){t.isValid()||Y.out.println("Snapped geometry is invalid")},rr.prototype.computeSnapTolerance=function(){this._snapTolerance=Ji.computeOverlaySnapTolerance(this._geom[0],this._geom[1])},rr.prototype.snap=function(t){var e=this.removeCommonBits(t);return Ji.snap(e[0],e[1],this._snapTolerance)},rr.prototype.interfaces_=function(){return[]},rr.prototype.getClass=function(){return rr},rr.overlayOp=function(t,e,n){return new rr(t,e).getResultGeometry(n)},rr.union=function(t,e){return rr.overlayOp(t,e,Lr.UNION)},rr.intersection=function(t,e){return rr.overlayOp(t,e,Lr.INTERSECTION)},rr.symDifference=function(t,e){return rr.overlayOp(t,e,Lr.SYMDIFFERENCE)},rr.difference=function(t,e){return rr.overlayOp(t,e,Lr.DIFFERENCE)};var or=function(t,e){this._geom=new Array(2).fill(null),this._geom[0]=t,this._geom[1]=e};or.prototype.getResultGeometry=function(t){var e=null,n=!1,i=null;try{e=Lr.overlayOp(this._geom[0],this._geom[1],t);n=!0}catch(t){if(!(t instanceof $))throw t;i=t}if(!n)try{e=rr.overlayOp(this._geom[0],this._geom[1],t)}catch(t){throw t instanceof $?i:t}return e},or.prototype.interfaces_=function(){return[]},or.prototype.getClass=function(){return or},or.overlayOp=function(t,e,n){return new or(t,e).getResultGeometry(n)},or.union=function(t,e){return or.overlayOp(t,e,Lr.UNION)},or.intersection=function(t,e){return or.overlayOp(t,e,Lr.INTERSECTION)},or.symDifference=function(t,e){return or.overlayOp(t,e,Lr.SYMDIFFERENCE)},or.difference=function(t,e){return or.overlayOp(t,e,Lr.DIFFERENCE)};var sr=function(){this.mce=null,this.chainIndex=null;var t=arguments[0],e=arguments[1];this.mce=t,this.chainIndex=e};sr.prototype.computeIntersections=function(t,e){this.mce.computeIntersectsForChain(this.chainIndex,t.mce,t.chainIndex,e)},sr.prototype.interfaces_=function(){return[]},sr.prototype.getClass=function(){return sr};var ar=function t(){if(this._label=null,this._xValue=null,this._eventType=null,this._insertEvent=null,this._deleteEventIndex=null,this._obj=null,2===arguments.length){var e=arguments[0],n=arguments[1];this._eventType=t.DELETE,this._xValue=e,this._insertEvent=n}else if(3===arguments.length){var i=arguments[0],r=arguments[1],o=arguments[2];this._eventType=t.INSERT,this._label=i,this._xValue=r,this._obj=o}},ur={INSERT:{configurable:!0},DELETE:{configurable:!0}};ar.prototype.isDelete=function(){return this._eventType===ar.DELETE},ar.prototype.setDeleteEventIndex=function(t){this._deleteEventIndex=t},ar.prototype.getObject=function(){return this._obj},ar.prototype.compareTo=function(t){var e=t;return this._xValue<e._xValue?-1:this._xValue>e._xValue?1:this._eventType<e._eventType?-1:this._eventType>e._eventType?1:0},ar.prototype.getInsertEvent=function(){return this._insertEvent},ar.prototype.isInsert=function(){return this._eventType===ar.INSERT},ar.prototype.isSameLabel=function(t){return null!==this._label&&this._label===t._label},ar.prototype.getDeleteEventIndex=function(){return this._deleteEventIndex},ar.prototype.interfaces_=function(){return[E]},ar.prototype.getClass=function(){return ar},ur.INSERT.get=function(){return 1},ur.DELETE.get=function(){return 2},Object.defineProperties(ar,ur);var lr=function(){};lr.prototype.interfaces_=function(){return[]},lr.prototype.getClass=function(){return lr};var cr=function(){this._hasIntersection=!1,this._hasProper=!1,this._hasProperInterior=!1,this._properIntersectionPoint=null,this._li=null,this._includeProper=null,this._recordIsolated=null,this._isSelfIntersection=null,this._numIntersections=0,this.numTests=0,this._bdyNodes=null,this._isDone=!1,this._isDoneWhenProperInt=!1;var t=arguments[0],e=arguments[1],n=arguments[2];this._li=t,this._includeProper=e,this._recordIsolated=n};cr.prototype.isTrivialIntersection=function(t,e,n,i){if(t===n&&1===this._li.getIntersectionNum()){if(cr.isAdjacentSegments(e,i))return!0;if(t.isClosed()){var r=t.getNumPoints()-1;if(0===e&&i===r||0===i&&e===r)return!0}}return!1},cr.prototype.getProperIntersectionPoint=function(){return this._properIntersectionPoint},cr.prototype.setIsDoneIfProperInt=function(t){this._isDoneWhenProperInt=t},cr.prototype.hasProperInteriorIntersection=function(){return this._hasProperInterior},cr.prototype.isBoundaryPointInternal=function(t,e){for(var n=e.iterator();n.hasNext();){var i=n.next().getCoordinate();if(t.isIntersection(i))return!0}return!1},cr.prototype.hasProperIntersection=function(){return this._hasProper},cr.prototype.hasIntersection=function(){return this._hasIntersection},cr.prototype.isDone=function(){return this._isDone},cr.prototype.isBoundaryPoint=function(t,e){return null!==e&&(!!this.isBoundaryPointInternal(t,e[0])||!!this.isBoundaryPointInternal(t,e[1]))},cr.prototype.setBoundaryNodes=function(t,e){this._bdyNodes=new Array(2).fill(null),this._bdyNodes[0]=t,this._bdyNodes[1]=e},cr.prototype.addIntersections=function(t,e,n,i){if(t===n&&e===i)return null;this.numTests++;var r=t.getCoordinates()[e],o=t.getCoordinates()[e+1],s=n.getCoordinates()[i],a=n.getCoordinates()[i+1];this._li.computeIntersection(r,o,s,a),this._li.hasIntersection()&&(this._recordIsolated&&(t.setIsolated(!1),n.setIsolated(!1)),this._numIntersections++,this.isTrivialIntersection(t,e,n,i)||(this._hasIntersection=!0,!this._includeProper&&this._li.isProper()||(t.addIntersections(this._li,e,0),n.addIntersections(this._li,i,1)),this._li.isProper()&&(this._properIntersectionPoint=this._li.getIntersection(0).copy(),this._hasProper=!0,this._isDoneWhenProperInt&&(this._isDone=!0),this.isBoundaryPoint(this._li,this._bdyNodes)||(this._hasProperInterior=!0))))},cr.prototype.interfaces_=function(){return[]},cr.prototype.getClass=function(){return cr},cr.isAdjacentSegments=function(t,e){return 1===Math.abs(t-e)};var pr=function(t){function e(){t.call(this),this.events=new Nt,this.nOverlaps=null}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.prepareEvents=function(){$e.sort(this.events);for(var t=0;t<this.events.size();t++){var e=this.events.get(t);e.isDelete()&&e.getInsertEvent().setDeleteEventIndex(t)}},e.prototype.computeIntersections=function(){if(1===arguments.length){var t=arguments[0];this.nOverlaps=0,this.prepareEvents();for(var e=0;e<this.events.size();e++){var n=this.events.get(e);if(n.isInsert()&&this.processOverlaps(e,n.getDeleteEventIndex(),n,t),t.isDone())break}}else if(3===arguments.length)if(arguments[2]instanceof cr&&T(arguments[0],xt)&&T(arguments[1],xt)){var i=arguments[0],r=arguments[1],o=arguments[2];this.addEdges(i,i),this.addEdges(r,r),this.computeIntersections(o)}else if("boolean"==typeof arguments[2]&&T(arguments[0],xt)&&arguments[1]instanceof cr){var s=arguments[0],a=arguments[1];arguments[2]?this.addEdges(s,null):this.addEdges(s),this.computeIntersections(a)}},e.prototype.addEdge=function(t,e){for(var n=t.getMonotoneChainEdge(),i=n.getStartIndexes(),r=0;r<i.length-1;r++){var o=new sr(n,r),s=new ar(e,n.getMinX(r),o);this.events.add(s),this.events.add(new ar(n.getMaxX(r),s))}},e.prototype.processOverlaps=function(t,e,n,i){for(var r=n.getObject(),o=t;o<e;o++){var s=this.events.get(o);if(s.isInsert()){var a=s.getObject();n.isSameLabel(s)||(r.computeIntersections(a,i),this.nOverlaps++)}}},e.prototype.addEdges=function(){if(1===arguments.length)for(var t=arguments[0].iterator();t.hasNext();){var e=t.next();this.addEdge(e,e)}else if(2===arguments.length)for(var n=arguments[0],i=arguments[1],r=n.iterator();r.hasNext();){var o=r.next();this.addEdge(o,i)}},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(lr),hr=function(){this._min=v.POSITIVE_INFINITY,this._max=v.NEGATIVE_INFINITY},fr={NodeComparator:{configurable:!0}};hr.prototype.getMin=function(){return this._min},hr.prototype.intersects=function(t,e){return!(this._min>e||this._max<t)},hr.prototype.getMax=function(){return this._max},hr.prototype.toString=function(){return Z.toLineString(new C(this._min,0),new C(this._max,0))},hr.prototype.interfaces_=function(){return[]},hr.prototype.getClass=function(){return hr},fr.NodeComparator.get=function(){return gr},Object.defineProperties(hr,fr);var gr=function(){};gr.prototype.compare=function(t,e){var n=t,i=e,r=(n._min+n._max)/2,o=(i._min+i._max)/2;return r<o?-1:r>o?1:0},gr.prototype.interfaces_=function(){return[N]},gr.prototype.getClass=function(){return gr};var dr=function(t){function e(){t.call(this),this._item=null;var e=arguments[0],n=arguments[1],i=arguments[2];this._min=e,this._max=n,this._item=i}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.query=function(t,e,n){if(!this.intersects(t,e))return null;n.visitItem(this._item)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(hr),yr=function(t){function e(){t.call(this),this._node1=null,this._node2=null;var e=arguments[0],n=arguments[1];this._node1=e,this._node2=n,this.buildExtent(this._node1,this._node2)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.buildExtent=function(t,e){this._min=Math.min(t._min,e._min),this._max=Math.max(t._max,e._max)},e.prototype.query=function(t,e,n){if(!this.intersects(t,e))return null;null!==this._node1&&this._node1.query(t,e,n),null!==this._node2&&this._node2.query(t,e,n)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(hr),_r=function(){this._leaves=new Nt,this._root=null,this._level=0};_r.prototype.buildTree=function(){$e.sort(this._leaves,new hr.NodeComparator);for(var t=this._leaves,e=null,n=new Nt;;){if(this.buildLevel(t,n),1===n.size())return n.get(0);e=t,t=n,n=e}},_r.prototype.insert=function(t,e,n){if(null!==this._root)throw new Error("Index cannot be added to once it has been queried");this._leaves.add(new dr(t,e,n))},_r.prototype.query=function(t,e,n){this.init(),this._root.query(t,e,n)},_r.prototype.buildRoot=function(){if(null!==this._root)return null;this._root=this.buildTree()},_r.prototype.printNode=function(t){Y.out.println(Z.toLineString(new C(t._min,this._level),new C(t._max,this._level)))},_r.prototype.init=function(){if(null!==this._root)return null;this.buildRoot()},_r.prototype.buildLevel=function(t,e){this._level++,e.clear();for(var n=0;n<t.size();n+=2){var i=t.get(n);if(null===(n+1<t.size()?t.get(n):null))e.add(i);else{var r=new yr(t.get(n),t.get(n+1));e.add(r)}}},_r.prototype.interfaces_=function(){return[]},_r.prototype.getClass=function(){return _r};var mr=function(){this._items=new Nt};mr.prototype.visitItem=function(t){this._items.add(t)},mr.prototype.getItems=function(){return this._items},mr.prototype.interfaces_=function(){return[Ke]},mr.prototype.getClass=function(){return mr};var vr=function(){this._index=null;var t=arguments[0];if(!T(t,Zt))throw new m("Argument must be Polygonal");this._index=new xr(t)},Ir={SegmentVisitor:{configurable:!0},IntervalIndexedGeometry:{configurable:!0}};vr.prototype.locate=function(t){var e=new st(t),n=new Er(e);return this._index.query(t.y,t.y,n),e.getLocation()},vr.prototype.interfaces_=function(){return[Vn]},vr.prototype.getClass=function(){return vr},Ir.SegmentVisitor.get=function(){return Er},Ir.IntervalIndexedGeometry.get=function(){return xr},Object.defineProperties(vr,Ir);var Er=function(){this._counter=null;var t=arguments[0];this._counter=t};Er.prototype.visitItem=function(t){var e=t;this._counter.countSegment(e.getCoordinate(0),e.getCoordinate(1))},Er.prototype.interfaces_=function(){return[Ke]},Er.prototype.getClass=function(){return Er};var xr=function(){this._index=new _r;var t=arguments[0];this.init(t)};xr.prototype.init=function(t){for(var e=Ci.getLines(t).iterator();e.hasNext();){var n=e.next().getCoordinates();this.addLine(n)}},xr.prototype.addLine=function(t){for(var e=1;e<t.length;e++){var n=new dn(t[e-1],t[e]),i=Math.min(n.p0.y,n.p1.y),r=Math.max(n.p0.y,n.p1.y);this._index.insert(i,r,n)}},xr.prototype.query=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1],n=new mr;return this._index.query(t,e,n),n.getItems()}if(3===arguments.length){var i=arguments[0],r=arguments[1],o=arguments[2];this._index.query(i,r,o)}},xr.prototype.interfaces_=function(){return[]},xr.prototype.getClass=function(){return xr};var Nr=function(t){function e(){if(t.call(this),this._parentGeom=null,this._lineEdgeMap=new he,this._boundaryNodeRule=null,this._useBoundaryDeterminationRule=!0,this._argIndex=null,this._boundaryNodes=null,this._hasTooFewPoints=!1,this._invalidPoint=null,this._areaPtLocator=null,this._ptLocator=new Si,2===arguments.length){var e=arguments[0],n=arguments[1],i=gt.OGC_SFS_BOUNDARY_RULE;this._argIndex=e,this._parentGeom=n,this._boundaryNodeRule=i,null!==n&&this.add(n)}else if(3===arguments.length){var r=arguments[0],o=arguments[1],s=arguments[2];this._argIndex=r,this._parentGeom=o,this._boundaryNodeRule=s,null!==o&&this.add(o)}}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.insertBoundaryPoint=function(t,n){var i=this._nodes.addNode(n).getLabel(),r=1;w.NONE;i.getLocation(t,Se.ON)===w.BOUNDARY&&r++;var o=e.determineBoundary(this._boundaryNodeRule,r);i.setLocation(t,o)},e.prototype.computeSelfNodes=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return this.computeSelfNodes(t,e,!1)}if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2],o=new cr(n,!0,!1);o.setIsDoneIfProperInt(r);var s=this.createEdgeSetIntersector(),a=this._parentGeom instanceof ee||this._parentGeom instanceof $t||this._parentGeom instanceof ne,u=i||!a;return s.computeIntersections(this._edges,o,u),this.addSelfIntersectionNodes(this._argIndex),o}},e.prototype.computeSplitEdges=function(t){for(var e=this._edges.iterator();e.hasNext();){e.next().eiList.addSplitEdges(t)}},e.prototype.computeEdgeIntersections=function(t,e,n){var i=new cr(e,n,!0);i.setBoundaryNodes(this.getBoundaryNodes(),t.getBoundaryNodes());return this.createEdgeSetIntersector().computeIntersections(this._edges,t._edges,i),i},e.prototype.getGeometry=function(){return this._parentGeom},e.prototype.getBoundaryNodeRule=function(){return this._boundaryNodeRule},e.prototype.hasTooFewPoints=function(){return this._hasTooFewPoints},e.prototype.addPoint=function(){if(arguments[0]instanceof Qt){var t=arguments[0].getCoordinate();this.insertPoint(this._argIndex,t,w.INTERIOR)}else if(arguments[0]instanceof C){var e=arguments[0];this.insertPoint(this._argIndex,e,w.INTERIOR)}},e.prototype.addPolygon=function(t){this.addPolygonRing(t.getExteriorRing(),w.EXTERIOR,w.INTERIOR);for(var e=0;e<t.getNumInteriorRing();e++){var n=t.getInteriorRingN(e);this.addPolygonRing(n,w.INTERIOR,w.EXTERIOR)}},e.prototype.addEdge=function(t){this.insertEdge(t);var e=t.getCoordinates();this.insertPoint(this._argIndex,e[0],w.BOUNDARY),this.insertPoint(this._argIndex,e[e.length-1],w.BOUNDARY)},e.prototype.addLineString=function(t){var e=Lt.removeRepeatedPoints(t.getCoordinates());if(e.length<2)return this._hasTooFewPoints=!0,this._invalidPoint=e[0],null;var n=new ni(e,new Pe(this._argIndex,w.INTERIOR));this._lineEdgeMap.put(t,n),this.insertEdge(n),et.isTrue(e.length>=2,"found LineString with single point"),this.insertBoundaryPoint(this._argIndex,e[0]),this.insertBoundaryPoint(this._argIndex,e[e.length-1])},e.prototype.getInvalidPoint=function(){return this._invalidPoint},e.prototype.getBoundaryPoints=function(){for(var t=this.getBoundaryNodes(),e=new Array(t.size()).fill(null),n=0,i=t.iterator();i.hasNext();){var r=i.next();e[n++]=r.getCoordinate().copy()}return e},e.prototype.getBoundaryNodes=function(){return null===this._boundaryNodes&&(this._boundaryNodes=this._nodes.getBoundaryNodes(this._argIndex)),this._boundaryNodes},e.prototype.addSelfIntersectionNode=function(t,e,n){if(this.isBoundaryNode(t,e))return null;n===w.BOUNDARY&&this._useBoundaryDeterminationRule?this.insertBoundaryPoint(t,e):this.insertPoint(t,e,n)},e.prototype.addPolygonRing=function(t,e,n){if(t.isEmpty())return null;var i=Lt.removeRepeatedPoints(t.getCoordinates());if(i.length<4)return this._hasTooFewPoints=!0,this._invalidPoint=i[0],null;var r=e,o=n;at.isCCW(i)&&(r=n,o=e);var s=new ni(i,new Pe(this._argIndex,w.BOUNDARY,r,o));this._lineEdgeMap.put(t,s),this.insertEdge(s),this.insertPoint(this._argIndex,i[0],w.BOUNDARY)},e.prototype.insertPoint=function(t,e,n){var i=this._nodes.addNode(e),r=i.getLabel();null===r?i._label=new Pe(t,n):r.setLocation(t,n)},e.prototype.createEdgeSetIntersector=function(){return new pr},e.prototype.addSelfIntersectionNodes=function(t){for(var e=this._edges.iterator();e.hasNext();)for(var n=e.next(),i=n.getLabel().getLocation(t),r=n.eiList.iterator();r.hasNext();){var o=r.next();this.addSelfIntersectionNode(t,o.coord,i)}},e.prototype.add=function(){if(1!==arguments.length)return t.prototype.add.apply(this,arguments);var e=arguments[0];if(e.isEmpty())return null;if(e instanceof ne&&(this._useBoundaryDeterminationRule=!1),e instanceof $t)this.addPolygon(e);else if(e instanceof Kt)this.addLineString(e);else if(e instanceof Qt)this.addPoint(e);else if(e instanceof te)this.addCollection(e);else if(e instanceof Xt)this.addCollection(e);else if(e instanceof ne)this.addCollection(e);else{if(!(e instanceof zt))throw new Error(e.getClass().getName());this.addCollection(e)}},e.prototype.addCollection=function(t){for(var e=0;e<t.getNumGeometries();e++){var n=t.getGeometryN(e);this.add(n)}},e.prototype.locate=function(t){return T(this._parentGeom,Zt)&&this._parentGeom.getNumGeometries()>50?(null===this._areaPtLocator&&(this._areaPtLocator=new vr(this._parentGeom)),this._areaPtLocator.locate(t)):this._ptLocator.locate(t,this._parentGeom)},e.prototype.findEdge=function(){if(1===arguments.length){var e=arguments[0];return this._lineEdgeMap.get(e)}return t.prototype.findEdge.apply(this,arguments)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e.determineBoundary=function(t,e){return t.isInBoundary(e)?w.BOUNDARY:w.INTERIOR},e}(Ye),Cr=function(){if(this._li=new rt,this._resultPrecisionModel=null,this._arg=null,1===arguments.length){var t=arguments[0];this.setComputationPrecision(t.getPrecisionModel()),this._arg=new Array(1).fill(null),this._arg[0]=new Nr(0,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1],i=gt.OGC_SFS_BOUNDARY_RULE;e.getPrecisionModel().compareTo(n.getPrecisionModel())>=0?this.setComputationPrecision(e.getPrecisionModel()):this.setComputationPrecision(n.getPrecisionModel()),this._arg=new Array(2).fill(null),this._arg[0]=new Nr(0,e,i),this._arg[1]=new Nr(1,n,i)}else if(3===arguments.length){var r=arguments[0],o=arguments[1],s=arguments[2];r.getPrecisionModel().compareTo(o.getPrecisionModel())>=0?this.setComputationPrecision(r.getPrecisionModel()):this.setComputationPrecision(o.getPrecisionModel()),this._arg=new Array(2).fill(null),this._arg[0]=new Nr(0,r,s),this._arg[1]=new Nr(1,o,s)}};Cr.prototype.getArgGeometry=function(t){return this._arg[t].getGeometry()},Cr.prototype.setComputationPrecision=function(t){this._resultPrecisionModel=t,this._li.setPrecisionModel(this._resultPrecisionModel)},Cr.prototype.interfaces_=function(){return[]},Cr.prototype.getClass=function(){return Cr};var Sr=function(){};Sr.prototype.interfaces_=function(){return[]},Sr.prototype.getClass=function(){return Sr},Sr.map=function(){if(arguments[0]instanceof ct&&T(arguments[1],Sr.MapOp)){for(var t=arguments[0],e=arguments[1],n=new Nt,i=0;i<t.getNumGeometries();i++){var r=e.map(t.getGeometryN(i));null!==r&&n.add(r)}return t.getFactory().buildGeometry(n)}if(T(arguments[0],It)&&T(arguments[1],Sr.MapOp)){for(var o=arguments[0],s=arguments[1],a=new Nt,u=o.iterator();u.hasNext();){var l=u.next(),c=s.map(l);null!==c&&a.add(c)}return a}},Sr.MapOp=function(){};var Lr=function(t){function e(){var e=arguments[0],n=arguments[1];t.call(this,e,n),this._ptLocator=new Si,this._geomFact=null,this._resultGeom=null,this._graph=null,this._edgeList=new Hn,this._resultPolyList=new Nt,this._resultLineList=new Nt,this._resultPointList=new Nt,this._graph=new Ye(new kn),this._geomFact=e.getFactory()}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.insertUniqueEdge=function(t){var e=this._edgeList.findEqualEdge(t);if(null!==e){var n=e.getLabel(),i=t.getLabel();e.isPointwiseEqual(t)||(i=new Pe(t.getLabel())).flip();var r=e.getDepth();r.isNull()&&r.add(n),r.add(i),n.merge(i)}else this._edgeList.add(t)},e.prototype.getGraph=function(){return this._graph},e.prototype.cancelDuplicateResultEdges=function(){for(var t=this._graph.getEdgeEnds().iterator();t.hasNext();){var e=t.next(),n=e.getSym();e.isInResult()&&n.isInResult()&&(e.setInResult(!1),n.setInResult(!1))}},e.prototype.isCoveredByLA=function(t){return!!this.isCovered(t,this._resultLineList)||!!this.isCovered(t,this._resultPolyList)},e.prototype.computeGeometry=function(t,n,i,r){var o=new Nt;return o.addAll(t),o.addAll(n),o.addAll(i),o.isEmpty()?e.createEmptyResult(r,this._arg[0].getGeometry(),this._arg[1].getGeometry(),this._geomFact):this._geomFact.buildGeometry(o)},e.prototype.mergeSymLabels=function(){for(var t=this._graph.getNodes().iterator();t.hasNext();){t.next().getEdges().mergeSymLabels()}},e.prototype.isCovered=function(t,e){for(var n=e.iterator();n.hasNext();){var i=n.next();if(this._ptLocator.locate(t,i)!==w.EXTERIOR)return!0}return!1},e.prototype.replaceCollapsedEdges=function(){for(var t=new Nt,e=this._edgeList.iterator();e.hasNext();){var n=e.next();n.isCollapsed()&&(e.remove(),t.add(n.getCollapsedEdge()))}this._edgeList.addAll(t)},e.prototype.updateNodeLabelling=function(){for(var t=this._graph.getNodes().iterator();t.hasNext();){var e=t.next(),n=e.getEdges().getLabel();e.getLabel().merge(n)}},e.prototype.getResultGeometry=function(t){return this.computeOverlay(t),this._resultGeom},e.prototype.insertUniqueEdges=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();this.insertUniqueEdge(n)}},e.prototype.computeOverlay=function(t){this.copyPoints(0),this.copyPoints(1),this._arg[0].computeSelfNodes(this._li,!1),this._arg[1].computeSelfNodes(this._li,!1),this._arg[0].computeEdgeIntersections(this._arg[1],this._li,!0);var e=new Nt;this._arg[0].computeSplitEdges(e),this._arg[1].computeSplitEdges(e),this.insertUniqueEdges(e),this.computeLabelsFromDepths(),this.replaceCollapsedEdges(),Yi.checkValid(this._edgeList.getEdges()),this._graph.addEdges(this._edgeList.getEdges()),this.computeLabelling(),this.labelIncompleteNodes(),this.findResultAreaEdges(t),this.cancelDuplicateResultEdges();var n=new ke(this._geomFact);n.add(this._graph),this._resultPolyList=n.getPolygons();var i=new ji(this,this._geomFact,this._ptLocator);this._resultLineList=i.build(t);var r=new Hi(this,this._geomFact,this._ptLocator);this._resultPointList=r.build(t),this._resultGeom=this.computeGeometry(this._resultPointList,this._resultLineList,this._resultPolyList,t)},e.prototype.labelIncompleteNode=function(t,e){var n=this._ptLocator.locate(t.getCoordinate(),this._arg[e].getGeometry());t.getLabel().setLocation(e,n)},e.prototype.copyPoints=function(t){for(var e=this._arg[t].getNodeIterator();e.hasNext();){var n=e.next();this._graph.addNode(n.getCoordinate()).setLabel(t,n.getLabel().getLocation(t))}},e.prototype.findResultAreaEdges=function(t){for(var n=this._graph.getEdgeEnds().iterator();n.hasNext();){var i=n.next(),r=i.getLabel();r.isArea()&&!i.isInteriorAreaEdge()&&e.isResultOfOp(r.getLocation(0,Se.RIGHT),r.getLocation(1,Se.RIGHT),t)&&i.setInResult(!0)}},e.prototype.computeLabelsFromDepths=function(){for(var t=this._edgeList.iterator();t.hasNext();){var e=t.next(),n=e.getLabel(),i=e.getDepth();if(!i.isNull()){i.normalize();for(var r=0;r<2;r++)n.isNull(r)||!n.isArea()||i.isNull(r)||(0===i.getDelta(r)?n.toLine(r):(et.isTrue(!i.isNull(r,Se.LEFT),"depth of LEFT side has not been initialized"),n.setLocation(r,Se.LEFT,i.getLocation(r,Se.LEFT)),et.isTrue(!i.isNull(r,Se.RIGHT),"depth of RIGHT side has not been initialized"),n.setLocation(r,Se.RIGHT,i.getLocation(r,Se.RIGHT))))}}},e.prototype.computeLabelling=function(){for(var t=this._graph.getNodes().iterator();t.hasNext();){t.next().getEdges().computeLabelling(this._arg)}this.mergeSymLabels(),this.updateNodeLabelling()},e.prototype.labelIncompleteNodes=function(){for(var t=this._graph.getNodes().iterator();t.hasNext();){var e=t.next(),n=e.getLabel();e.isIsolated()&&(n.isNull(0)?this.labelIncompleteNode(e,0):this.labelIncompleteNode(e,1)),e.getEdges().updateLabelling(n)}},e.prototype.isCoveredByA=function(t){return!!this.isCovered(t,this._resultPolyList)},e.prototype.interfaces_=function(){return[]},e.prototype.getClass=function(){return e},e}(Cr);Lr.overlayOp=function(t,e,n){return new Lr(t,e).getResultGeometry(n)},Lr.intersection=function(t,e){if(t.isEmpty()||e.isEmpty())return Lr.createEmptyResult(Lr.INTERSECTION,t,e,t.getFactory());if(t.isGeometryCollection()){var n=e;return ki.map(t,{interfaces_:function(){return[Sr.MapOp]},map:function(t){return t.intersection(n)}})}return t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),or.overlayOp(t,e,Lr.INTERSECTION)},Lr.symDifference=function(t,e){if(t.isEmpty()||e.isEmpty()){if(t.isEmpty()&&e.isEmpty())return Lr.createEmptyResult(Lr.SYMDIFFERENCE,t,e,t.getFactory());if(t.isEmpty())return e.copy();if(e.isEmpty())return t.copy()}return t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),or.overlayOp(t,e,Lr.SYMDIFFERENCE)},Lr.resultDimension=function(t,e,n){var i=e.getDimension(),r=n.getDimension(),o=-1;switch(t){case Lr.INTERSECTION:o=Math.min(i,r);break;case Lr.UNION:o=Math.max(i,r);break;case Lr.DIFFERENCE:o=i;break;case Lr.SYMDIFFERENCE:o=Math.max(i,r)}return o},Lr.createEmptyResult=function(t,e,n,i){var r=null;switch(Lr.resultDimension(t,e,n)){case-1:r=i.createGeometryCollection(new Array(0).fill(null));break;case 0:r=i.createPoint();break;case 1:r=i.createLineString();break;case 2:r=i.createPolygon()}return r},Lr.difference=function(t,e){return t.isEmpty()?Lr.createEmptyResult(Lr.DIFFERENCE,t,e,t.getFactory()):e.isEmpty()?t.copy():(t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),or.overlayOp(t,e,Lr.DIFFERENCE))},Lr.isResultOfOp=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1],n=t.getLocation(0),i=t.getLocation(1);return Lr.isResultOfOp(n,i,e)}if(3===arguments.length){var r=arguments[0],o=arguments[1],s=arguments[2];switch(r===w.BOUNDARY&&(r=w.INTERIOR),o===w.BOUNDARY&&(o=w.INTERIOR),s){case Lr.INTERSECTION:return r===w.INTERIOR&&o===w.INTERIOR;case Lr.UNION:return r===w.INTERIOR||o===w.INTERIOR;case Lr.DIFFERENCE:return r===w.INTERIOR&&o!==w.INTERIOR;case Lr.SYMDIFFERENCE:return r===w.INTERIOR&&o!==w.INTERIOR||r!==w.INTERIOR&&o===w.INTERIOR}return!1}},Lr.INTERSECTION=1,Lr.UNION=2,Lr.DIFFERENCE=3,Lr.SYMDIFFERENCE=4;var br=function(){this._g=null,this._boundaryDistanceTolerance=null,this._linework=null,this._ptLocator=new Si,this._seg=new dn;var t=arguments[0],e=arguments[1];this._g=t,this._boundaryDistanceTolerance=e,this._linework=this.extractLinework(t)};br.prototype.isWithinToleranceOfBoundary=function(t){for(var e=0;e<this._linework.getNumGeometries();e++)for(var n=this._linework.getGeometryN(e).getCoordinateSequence(),i=0;i<n.size()-1;i++){n.getCoordinate(i,this._seg.p0),n.getCoordinate(i+1,this._seg.p1);if(this._seg.distance(t)<=this._boundaryDistanceTolerance)return!0}return!1},br.prototype.getLocation=function(t){return this.isWithinToleranceOfBoundary(t)?w.BOUNDARY:this._ptLocator.locate(t,this._g)},br.prototype.extractLinework=function(t){var e=new wr;t.apply(e);var n=e.getLinework(),i=_e.toLineStringArray(n);return t.getFactory().createMultiLineString(i)},br.prototype.interfaces_=function(){return[]},br.prototype.getClass=function(){return br};var wr=function(){this._linework=null,this._linework=new Nt};wr.prototype.getLinework=function(){return this._linework},wr.prototype.filter=function(t){if(t instanceof $t){var e=t;this._linework.add(e.getExteriorRing());for(var n=0;n<e.getNumInteriorRing();n++)this._linework.add(e.getInteriorRingN(n))}},wr.prototype.interfaces_=function(){return[Vt]},wr.prototype.getClass=function(){return wr};var Or=function(){this._g=null,this._doLeft=!0,this._doRight=!0;var t=arguments[0];this._g=t};Or.prototype.extractPoints=function(t,e,n){for(var i=t.getCoordinates(),r=0;r<i.length-1;r++)this.computeOffsetPoints(i[r],i[r+1],e,n)},Or.prototype.setSidesToGenerate=function(t,e){this._doLeft=t,this._doRight=e},Or.prototype.getPoints=function(t){for(var e=new Nt,n=Ci.getLines(this._g).iterator();n.hasNext();){var i=n.next();this.extractPoints(i,t,e)}return e},Or.prototype.computeOffsetPoints=function(t,e,n,i){var r=e.x-t.x,o=e.y-t.y,s=Math.sqrt(r*r+o*o),a=n*r/s,u=n*o/s,l=(e.x+t.x)/2,c=(e.y+t.y)/2;if(this._doLeft){var p=new C(l-u,c+a);i.add(p)}if(this._doRight){var h=new C(l+u,c-a);i.add(h)}},Or.prototype.interfaces_=function(){return[]},Or.prototype.getClass=function(){return Or};var Tr=function t(){this._geom=null,this._locFinder=null,this._location=new Array(3).fill(null),this._invalidLocation=null,this._boundaryDistanceTolerance=t.TOLERANCE,this._testCoords=new Nt;var e=arguments[0],n=arguments[1],i=arguments[2];this._boundaryDistanceTolerance=t.computeBoundaryDistanceTolerance(e,n),this._geom=[e,n,i],this._locFinder=[new br(this._geom[0],this._boundaryDistanceTolerance),new br(this._geom[1],this._boundaryDistanceTolerance),new br(this._geom[2],this._boundaryDistanceTolerance)]},Rr={TOLERANCE:{configurable:!0}};Tr.prototype.reportResult=function(t,e,n){Y.out.println("Overlay result invalid - A:"+w.toLocationSymbol(e[0])+" B:"+w.toLocationSymbol(e[1])+" expected:"+(n?"i":"e")+" actual:"+w.toLocationSymbol(e[2]))},Tr.prototype.isValid=function(t){this.addTestPts(this._geom[0]),this.addTestPts(this._geom[1]);var e=this.checkValid(t);return e},Tr.prototype.checkValid=function(){if(1===arguments.length){for(var t=arguments[0],e=0;e<this._testCoords.size();e++){var n=this._testCoords.get(e);if(!this.checkValid(t,n))return this._invalidLocation=n,!1}return!0}if(2===arguments.length){var i=arguments[0],r=arguments[1];return this._location[0]=this._locFinder[0].getLocation(r),this._location[1]=this._locFinder[1].getLocation(r),this._location[2]=this._locFinder[2].getLocation(r),!!Tr.hasLocation(this._location,w.BOUNDARY)||this.isValidResult(i,this._location)}},Tr.prototype.addTestPts=function(t){var e=new Or(t);this._testCoords.addAll(e.getPoints(5*this._boundaryDistanceTolerance))},Tr.prototype.isValidResult=function(t,e){var n=Lr.isResultOfOp(e[0],e[1],t),i=!(n^e[2]===w.INTERIOR);return i||this.reportResult(t,e,n),i},Tr.prototype.getInvalidLocation=function(){return this._invalidLocation},Tr.prototype.interfaces_=function(){return[]},Tr.prototype.getClass=function(){return Tr},Tr.hasLocation=function(t,e){for(var n=0;n<3;n++)if(t[n]===e)return!0;return!1},Tr.computeBoundaryDistanceTolerance=function(t,e){return Math.min(Ji.computeSizeBasedSnapTolerance(t),Ji.computeSizeBasedSnapTolerance(e))},Tr.isValid=function(t,e,n,i){return new Tr(t,e,i).isValid(n)},Rr.TOLERANCE.get=function(){return 1e-6},Object.defineProperties(Tr,Rr);var Pr=function t(e){this._geomFactory=null,this._skipEmpty=!1,this._inputGeoms=null,this._geomFactory=t.extractFactory(e),this._inputGeoms=e};Pr.prototype.extractElements=function(t,e){if(null===t)return null;for(var n=0;n<t.getNumGeometries();n++){var i=t.getGeometryN(n);this._skipEmpty&&i.isEmpty()||e.add(i)}},Pr.prototype.combine=function(){for(var t=new Nt,e=this._inputGeoms.iterator();e.hasNext();){var n=e.next();this.extractElements(n,t)}return 0===t.size()?null!==this._geomFactory?this._geomFactory.createGeometryCollection(null):null:this._geomFactory.buildGeometry(t)},Pr.prototype.interfaces_=function(){return[]},Pr.prototype.getClass=function(){return Pr},Pr.combine=function(){if(1===arguments.length){var t=arguments[0];return new Pr(t).combine()}if(2===arguments.length){var e=arguments[0],n=arguments[1];return new Pr(Pr.createList(e,n)).combine()}if(3===arguments.length){var i=arguments[0],r=arguments[1],o=arguments[2];return new Pr(Pr.createList(i,r,o)).combine()}},Pr.extractFactory=function(t){return t.isEmpty()?null:t.iterator().next().getFactory()},Pr.createList=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1],n=new Nt;return n.add(t),n.add(e),n}if(3===arguments.length){var i=arguments[0],r=arguments[1],o=arguments[2],s=new Nt;return s.add(i),s.add(r),s.add(o),s}};var Dr=function(){this._inputPolys=null,this._geomFactory=null;var t=arguments[0];this._inputPolys=t,null===this._inputPolys&&(this._inputPolys=new Nt)},Mr={STRTREE_NODE_CAPACITY:{configurable:!0}};Dr.prototype.reduceToGeometries=function(t){for(var e=new Nt,n=t.iterator();n.hasNext();){var i=n.next(),r=null;T(i,xt)?r=this.unionTree(i):i instanceof ct&&(r=i),e.add(r)}return e},Dr.prototype.extractByEnvelope=function(t,e,n){for(var i=new Nt,r=0;r<e.getNumGeometries();r++){var o=e.getGeometryN(r);o.getEnvelopeInternal().intersects(t)?i.add(o):n.add(o)}return this._geomFactory.buildGeometry(i)},Dr.prototype.unionOptimized=function(t,e){var n=t.getEnvelopeInternal(),i=e.getEnvelopeInternal();if(!n.intersects(i)){return Pr.combine(t,e)}if(t.getNumGeometries()<=1&&e.getNumGeometries()<=1)return this.unionActual(t,e);var r=n.intersection(i);return this.unionUsingEnvelopeIntersection(t,e,r)},Dr.prototype.union=function(){if(null===this._inputPolys)throw new Error("union() method cannot be called twice");if(this._inputPolys.isEmpty())return null;this._geomFactory=this._inputPolys.iterator().next().getFactory();for(var t=new sn(Dr.STRTREE_NODE_CAPACITY),e=this._inputPolys.iterator();e.hasNext();){var n=e.next();t.insert(n.getEnvelopeInternal(),n)}this._inputPolys=null;var i=t.itemsTree();return this.unionTree(i)},Dr.prototype.binaryUnion=function(){if(1===arguments.length){var t=arguments[0];return this.binaryUnion(t,0,t.size())}if(3===arguments.length){var e=arguments[0],n=arguments[1],i=arguments[2];if(i-n<=1){var r=Dr.getGeometry(e,n);return this.unionSafe(r,null)}if(i-n==2)return this.unionSafe(Dr.getGeometry(e,n),Dr.getGeometry(e,n+1));var o=Math.trunc((i+n)/2),s=this.binaryUnion(e,n,o),a=this.binaryUnion(e,o,i);return this.unionSafe(s,a)}},Dr.prototype.repeatedUnion=function(t){for(var e=null,n=t.iterator();n.hasNext();){var i=n.next();e=null===e?i.copy():e.union(i)}return e},Dr.prototype.unionSafe=function(t,e){return null===t&&null===e?null:null===t?e.copy():null===e?t.copy():this.unionOptimized(t,e)},Dr.prototype.unionActual=function(t,e){return Dr.restrictToPolygons(t.union(e))},Dr.prototype.unionTree=function(t){var e=this.reduceToGeometries(t);return this.binaryUnion(e)},Dr.prototype.unionUsingEnvelopeIntersection=function(t,e,n){var i=new Nt,r=this.extractByEnvelope(n,t,i),o=this.extractByEnvelope(n,e,i),s=this.unionActual(r,o);i.add(s);return Pr.combine(i)},Dr.prototype.bufferUnion=function(){if(1===arguments.length){var t=arguments[0];return t.get(0).getFactory().buildGeometry(t).buffer(0)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return e.getFactory().createGeometryCollection([e,n]).buffer(0)}},Dr.prototype.interfaces_=function(){return[]},Dr.prototype.getClass=function(){return Dr},Dr.restrictToPolygons=function(t){if(T(t,Zt))return t;var e=Ni.getPolygons(t);return 1===e.size()?e.get(0):t.getFactory().createMultiPolygon(_e.toPolygonArray(e))},Dr.getGeometry=function(t,e){return e>=t.size()?null:t.get(e)},Dr.union=function(t){return new Dr(t).union()},Mr.STRTREE_NODE_CAPACITY.get=function(){return 4},Object.defineProperties(Dr,Mr);var Ar=function(){};Ar.prototype.interfaces_=function(){return[]},Ar.prototype.getClass=function(){return Ar},Ar.union=function(t,e){if(t.isEmpty()||e.isEmpty()){if(t.isEmpty()&&e.isEmpty())return Lr.createEmptyResult(Lr.UNION,t,e,t.getFactory());if(t.isEmpty())return e.copy();if(e.isEmpty())return t.copy()}return t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),or.overlayOp(t,e,Lr.UNION)},t.GeoJSONReader=Ne,t.GeoJSONWriter=Ce,t.OverlayOp=Lr,t.UnionOp=Ar,t.BufferOp=di,Object.defineProperty(t,"__esModule",{value:!0})});


/***/ },

/***/ 7433
(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.A = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ },

/***/ 5360
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__5360__;

/***/ },

/***/ 8529
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__8529__;

/***/ },

/***/ 7684
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7684__;

/***/ },

/***/ 9241
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9241__;

/***/ },

/***/ 9640
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9640__;

/***/ },

/***/ 2613
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__2613__;

/***/ },

/***/ 9185
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9185__;

/***/ },

/***/ 1088
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__1088__;

/***/ },

/***/ 2161
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__2161__;

/***/ },

/***/ 1152
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__1152__;

/***/ },

/***/ 422
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__422__;

/***/ },

/***/ 8502
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__8502__;

/***/ },

/***/ 3750
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3750__;

/***/ },

/***/ 7165
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7165__;

/***/ },

/***/ 535
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__535__;

/***/ },

/***/ 1031
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__1031__;

/***/ },

/***/ 7749
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7749__;

/***/ },

/***/ 8334
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__8334__;

/***/ },

/***/ 9488
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9488__;

/***/ },

/***/ 4223
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__4223__;

/***/ },

/***/ 4949
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__4949__;

/***/ },

/***/ 1600
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__1600__;

/***/ },

/***/ 3993
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3993__;

/***/ },

/***/ 9848
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9848__;

/***/ },

/***/ 2249
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__2249__;

/***/ },

/***/ 7055
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7055__;

/***/ },

/***/ 5213
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__5213__;

/***/ },

/***/ 5661
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__5661__;

/***/ },

/***/ 1718
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__1718__;

/***/ },

/***/ 6156
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__6156__;

/***/ },

/***/ 7614
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7614__;

/***/ },

/***/ 3021
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3021__;

/***/ },

/***/ 5933
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__5933__;

/***/ },

/***/ 2160
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__2160__;

/***/ },

/***/ 1334
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__1334__;

/***/ },

/***/ 4457
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__4457__;

/***/ },

/***/ 5257
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__5257__;

/***/ },

/***/ 4297
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__4297__;

/***/ },

/***/ 1460
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__1460__;

/***/ },

/***/ 2162
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__2162__;

/***/ },

/***/ 9374
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9374__;

/***/ },

/***/ 3895
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3895__;

/***/ },

/***/ 9172
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9172__;

/***/ },

/***/ 4076
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__4076__;

/***/ },

/***/ 474
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__474__;

/***/ },

/***/ 9274
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9274__;

/***/ },

/***/ 287
(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value: true});// index.ts
var _meta = __webpack_require__(9554);
function bbox(geojson, options = {}) {
  if (geojson.bbox != null && true !== options.recompute) {
    return geojson.bbox;
  }
  const result = [Infinity, Infinity, -Infinity, -Infinity];
  _meta.coordEach.call(void 0, geojson, (coord) => {
    if (result[0] > coord[0]) {
      result[0] = coord[0];
    }
    if (result[1] > coord[1]) {
      result[1] = coord[1];
    }
    if (result[2] < coord[0]) {
      result[2] = coord[0];
    }
    if (result[3] < coord[1]) {
      result[3] = coord[1];
    }
  });
  return result;
}
var index_default = bbox;



__webpack_unused_export__ = bbox; exports.Ay = index_default;
//# sourceMappingURL=index.cjs.map

/***/ },

/***/ 9570
(__unused_webpack_module, exports) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true}));// index.ts
var earthRadius = 63710088e-1;
var factors = {
  centimeters: earthRadius * 100,
  centimetres: earthRadius * 100,
  degrees: 360 / (2 * Math.PI),
  feet: earthRadius * 3.28084,
  inches: earthRadius * 39.37,
  kilometers: earthRadius / 1e3,
  kilometres: earthRadius / 1e3,
  meters: earthRadius,
  metres: earthRadius,
  miles: earthRadius / 1609.344,
  millimeters: earthRadius * 1e3,
  millimetres: earthRadius * 1e3,
  nauticalmiles: earthRadius / 1852,
  radians: 1,
  yards: earthRadius * 1.0936
};
var areaFactors = {
  acres: 247105e-9,
  centimeters: 1e4,
  centimetres: 1e4,
  feet: 10.763910417,
  hectares: 1e-4,
  inches: 1550.003100006,
  kilometers: 1e-6,
  kilometres: 1e-6,
  meters: 1,
  metres: 1,
  miles: 386e-9,
  nauticalmiles: 29155334959812285e-23,
  millimeters: 1e6,
  millimetres: 1e6,
  yards: 1.195990046
};
function feature(geom, properties, options = {}) {
  const feat = { type: "Feature" };
  if (options.id === 0 || options.id) {
    feat.id = options.id;
  }
  if (options.bbox) {
    feat.bbox = options.bbox;
  }
  feat.properties = properties || {};
  feat.geometry = geom;
  return feat;
}
function geometry(type, coordinates, _options = {}) {
  switch (type) {
    case "Point":
      return point(coordinates).geometry;
    case "LineString":
      return lineString(coordinates).geometry;
    case "Polygon":
      return polygon(coordinates).geometry;
    case "MultiPoint":
      return multiPoint(coordinates).geometry;
    case "MultiLineString":
      return multiLineString(coordinates).geometry;
    case "MultiPolygon":
      return multiPolygon(coordinates).geometry;
    default:
      throw new Error(type + " is invalid");
  }
}
function point(coordinates, properties, options = {}) {
  if (!coordinates) {
    throw new Error("coordinates is required");
  }
  if (!Array.isArray(coordinates)) {
    throw new Error("coordinates must be an Array");
  }
  if (coordinates.length < 2) {
    throw new Error("coordinates must be at least 2 numbers long");
  }
  if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) {
    throw new Error("coordinates must contain numbers");
  }
  const geom = {
    type: "Point",
    coordinates
  };
  return feature(geom, properties, options);
}
function points(coordinates, properties, options = {}) {
  return featureCollection(
    coordinates.map((coords) => {
      return point(coords, properties);
    }),
    options
  );
}
function polygon(coordinates, properties, options = {}) {
  for (const ring of coordinates) {
    if (ring.length < 4) {
      throw new Error(
        "Each LinearRing of a Polygon must have 4 or more Positions."
      );
    }
    if (ring[ring.length - 1].length !== ring[0].length) {
      throw new Error("First and last Position are not equivalent.");
    }
    for (let j = 0; j < ring[ring.length - 1].length; j++) {
      if (ring[ring.length - 1][j] !== ring[0][j]) {
        throw new Error("First and last Position are not equivalent.");
      }
    }
  }
  const geom = {
    type: "Polygon",
    coordinates
  };
  return feature(geom, properties, options);
}
function polygons(coordinates, properties, options = {}) {
  return featureCollection(
    coordinates.map((coords) => {
      return polygon(coords, properties);
    }),
    options
  );
}
function lineString(coordinates, properties, options = {}) {
  if (coordinates.length < 2) {
    throw new Error("coordinates must be an array of two or more positions");
  }
  const geom = {
    type: "LineString",
    coordinates
  };
  return feature(geom, properties, options);
}
function lineStrings(coordinates, properties, options = {}) {
  return featureCollection(
    coordinates.map((coords) => {
      return lineString(coords, properties);
    }),
    options
  );
}
function featureCollection(features, options = {}) {
  const fc = { type: "FeatureCollection" };
  if (options.id) {
    fc.id = options.id;
  }
  if (options.bbox) {
    fc.bbox = options.bbox;
  }
  fc.features = features;
  return fc;
}
function multiLineString(coordinates, properties, options = {}) {
  const geom = {
    type: "MultiLineString",
    coordinates
  };
  return feature(geom, properties, options);
}
function multiPoint(coordinates, properties, options = {}) {
  const geom = {
    type: "MultiPoint",
    coordinates
  };
  return feature(geom, properties, options);
}
function multiPolygon(coordinates, properties, options = {}) {
  const geom = {
    type: "MultiPolygon",
    coordinates
  };
  return feature(geom, properties, options);
}
function geometryCollection(geometries, properties, options = {}) {
  const geom = {
    type: "GeometryCollection",
    geometries
  };
  return feature(geom, properties, options);
}
function round(num, precision = 0) {
  if (precision && !(precision >= 0)) {
    throw new Error("precision must be a positive number");
  }
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(num * multiplier) / multiplier;
}
function radiansToLength(radians, units = "kilometers") {
  const factor = factors[units];
  if (!factor) {
    throw new Error(units + " units is invalid");
  }
  return radians * factor;
}
function lengthToRadians(distance, units = "kilometers") {
  const factor = factors[units];
  if (!factor) {
    throw new Error(units + " units is invalid");
  }
  return distance / factor;
}
function lengthToDegrees(distance, units) {
  return radiansToDegrees(lengthToRadians(distance, units));
}
function bearingToAzimuth(bearing) {
  let angle = bearing % 360;
  if (angle < 0) {
    angle += 360;
  }
  return angle;
}
function azimuthToBearing(angle) {
  angle = angle % 360;
  if (angle > 180) {
    return angle - 360;
  } else if (angle < -180) {
    return angle + 360;
  }
  return angle;
}
function radiansToDegrees(radians) {
  const normalisedRadians = radians % (2 * Math.PI);
  return normalisedRadians * 180 / Math.PI;
}
function degreesToRadians(degrees) {
  const normalisedDegrees = degrees % 360;
  return normalisedDegrees * Math.PI / 180;
}
function convertLength(length, originalUnit = "kilometers", finalUnit = "kilometers") {
  if (!(length >= 0)) {
    throw new Error("length must be a positive number");
  }
  return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
}
function convertArea(area, originalUnit = "meters", finalUnit = "kilometers") {
  if (!(area >= 0)) {
    throw new Error("area must be a positive number");
  }
  const startFactor = areaFactors[originalUnit];
  if (!startFactor) {
    throw new Error("invalid original units");
  }
  const finalFactor = areaFactors[finalUnit];
  if (!finalFactor) {
    throw new Error("invalid final units");
  }
  return area / startFactor * finalFactor;
}
function isNumber(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject(input) {
  return input !== null && typeof input === "object" && !Array.isArray(input);
}
function validateBBox(bbox) {
  if (!bbox) {
    throw new Error("bbox is required");
  }
  if (!Array.isArray(bbox)) {
    throw new Error("bbox must be an Array");
  }
  if (bbox.length !== 4 && bbox.length !== 6) {
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  }
  bbox.forEach((num) => {
    if (!isNumber(num)) {
      throw new Error("bbox must only contain numbers");
    }
  });
}
function validateId(id) {
  if (!id) {
    throw new Error("id is required");
  }
  if (["string", "number"].indexOf(typeof id) === -1) {
    throw new Error("id must be a number or a string");
  }
}































exports.areaFactors = areaFactors; exports.azimuthToBearing = azimuthToBearing; exports.bearingToAzimuth = bearingToAzimuth; exports.convertArea = convertArea; exports.convertLength = convertLength; exports.degreesToRadians = degreesToRadians; exports.earthRadius = earthRadius; exports.factors = factors; exports.feature = feature; exports.featureCollection = featureCollection; exports.geometry = geometry; exports.geometryCollection = geometryCollection; exports.isNumber = isNumber; exports.isObject = isObject; exports.lengthToDegrees = lengthToDegrees; exports.lengthToRadians = lengthToRadians; exports.lineString = lineString; exports.lineStrings = lineStrings; exports.multiLineString = multiLineString; exports.multiPoint = multiPoint; exports.multiPolygon = multiPolygon; exports.point = point; exports.points = points; exports.polygon = polygon; exports.polygons = polygons; exports.radiansToDegrees = radiansToDegrees; exports.radiansToLength = radiansToLength; exports.round = round; exports.validateBBox = validateBBox; exports.validateId = validateId;
//# sourceMappingURL=index.cjs.map

/***/ },

/***/ 9554
(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true}));// index.ts
var _helpers = __webpack_require__(9570);
function coordEach(geojson, callback, excludeWrapCoord) {
  if (geojson === null) return;
  var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
    geometryMaybeCollection = isFeatureCollection ? (
      // @ts-expect-error: Known type conflict
      geojson.features[featureIndex].geometry
    ) : isFeature ? (
      // @ts-expect-error: Known type conflict
      geojson.geometry
    ) : geojson;
    isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
    for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
      var multiFeatureIndex = 0;
      var geometryIndex = 0;
      geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
      if (geometry === null) continue;
      coords = geometry.coordinates;
      var geomType = geometry.type;
      wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
      switch (geomType) {
        case null:
          break;
        case "Point":
          if (
            // @ts-expect-error: Known type conflict
            callback(
              coords,
              coordIndex,
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false
          )
            return false;
          coordIndex++;
          multiFeatureIndex++;
          break;
        case "LineString":
        case "MultiPoint":
          for (j = 0; j < coords.length; j++) {
            if (
              // @ts-expect-error: Known type conflict
              callback(
                coords[j],
                coordIndex,
                featureIndex,
                multiFeatureIndex,
                geometryIndex
              ) === false
            )
              return false;
            coordIndex++;
            if (geomType === "MultiPoint") multiFeatureIndex++;
          }
          if (geomType === "LineString") multiFeatureIndex++;
          break;
        case "Polygon":
        case "MultiLineString":
          for (j = 0; j < coords.length; j++) {
            for (k = 0; k < coords[j].length - wrapShrink; k++) {
              if (
                // @ts-expect-error: Known type conflict
                callback(
                  coords[j][k],
                  coordIndex,
                  featureIndex,
                  multiFeatureIndex,
                  geometryIndex
                ) === false
              )
                return false;
              coordIndex++;
            }
            if (geomType === "MultiLineString") multiFeatureIndex++;
            if (geomType === "Polygon") geometryIndex++;
          }
          if (geomType === "Polygon") multiFeatureIndex++;
          break;
        case "MultiPolygon":
          for (j = 0; j < coords.length; j++) {
            geometryIndex = 0;
            for (k = 0; k < coords[j].length; k++) {
              for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
                if (
                  // @ts-expect-error: Known type conflict
                  callback(
                    coords[j][k][l],
                    coordIndex,
                    featureIndex,
                    multiFeatureIndex,
                    geometryIndex
                  ) === false
                )
                  return false;
                coordIndex++;
              }
              geometryIndex++;
            }
            multiFeatureIndex++;
          }
          break;
        case "GeometryCollection":
          for (j = 0; j < geometry.geometries.length; j++)
            if (
              // @ts-expect-error: Known type conflict
              coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false
            )
              return false;
          break;
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
  }
}
function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
  var previousValue = initialValue;
  coordEach(
    geojson,
    function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
      if (coordIndex === 0 && initialValue === void 0)
        previousValue = currentCoord;
      else
        previousValue = callback(
          // @ts-expect-error: Known type conflict
          previousValue,
          currentCoord,
          coordIndex,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    },
    excludeWrapCoord
  );
  return previousValue;
}
function propEach(geojson, callback) {
  var i;
  switch (geojson.type) {
    case "FeatureCollection":
      for (i = 0; i < geojson.features.length; i++) {
        if (callback(geojson.features[i].properties, i) === false) break;
      }
      break;
    case "Feature":
      callback(geojson.properties, 0);
      break;
  }
}
function propReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  propEach(geojson, function(currentProperties, featureIndex) {
    if (featureIndex === 0 && initialValue === void 0)
      previousValue = currentProperties;
    else
      previousValue = callback(previousValue, currentProperties, featureIndex);
  });
  return previousValue;
}
function featureEach(geojson, callback) {
  if (geojson.type === "Feature") {
    callback(geojson, 0);
  } else if (geojson.type === "FeatureCollection") {
    for (var i = 0; i < geojson.features.length; i++) {
      if (callback(geojson.features[i], i) === false) break;
    }
  }
}
function featureReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  featureEach(geojson, function(currentFeature, featureIndex) {
    if (featureIndex === 0 && initialValue === void 0)
      previousValue = currentFeature;
    else previousValue = callback(previousValue, currentFeature, featureIndex);
  });
  return previousValue;
}
function coordAll(geojson) {
  var coords = [];
  coordEach(geojson, function(coord) {
    coords.push(coord);
  });
  return coords;
}
function geomEach(geojson, callback) {
  var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (i = 0; i < stop; i++) {
    geometryMaybeCollection = isFeatureCollection ? (
      // @ts-expect-error: Known type conflict
      geojson.features[i].geometry
    ) : isFeature ? (
      // @ts-expect-error: Known type conflict
      geojson.geometry
    ) : geojson;
    featureProperties = isFeatureCollection ? (
      // @ts-expect-error: Known type conflict
      geojson.features[i].properties
    ) : isFeature ? (
      // @ts-expect-error: Known type conflict
      geojson.properties
    ) : {};
    featureBBox = isFeatureCollection ? (
      // @ts-expect-error: Known type conflict
      geojson.features[i].bbox
    ) : isFeature ? (
      // @ts-expect-error: Known type conflict
      geojson.bbox
    ) : void 0;
    featureId = isFeatureCollection ? (
      // @ts-expect-error: Known type conflict
      geojson.features[i].id
    ) : isFeature ? (
      // @ts-expect-error: Known type conflict
      geojson.id
    ) : void 0;
    isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
    for (g = 0; g < stopG; g++) {
      geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
      if (geometry === null) {
        if (
          // @ts-expect-error: Known type conflict
          callback(
            // @ts-expect-error: Known type conflict
            null,
            featureIndex,
            featureProperties,
            featureBBox,
            featureId
          ) === false
        )
          return false;
        continue;
      }
      switch (geometry.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (
            // @ts-expect-error: Known type conflict
            callback(
              geometry,
              featureIndex,
              featureProperties,
              featureBBox,
              featureId
            ) === false
          )
            return false;
          break;
        }
        case "GeometryCollection": {
          for (j = 0; j < geometry.geometries.length; j++) {
            if (
              // @ts-expect-error: Known type conflict
              callback(
                geometry.geometries[j],
                featureIndex,
                featureProperties,
                featureBBox,
                featureId
              ) === false
            )
              return false;
          }
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    featureIndex++;
  }
}
function geomReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  geomEach(
    geojson,
    function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
      if (featureIndex === 0 && initialValue === void 0)
        previousValue = currentGeometry;
      else
        previousValue = callback(
          // @ts-expect-error: Known type conflict
          previousValue,
          currentGeometry,
          featureIndex,
          featureProperties,
          featureBBox,
          featureId
        );
    }
  );
  return previousValue;
}
function flattenEach(geojson, callback) {
  geomEach(geojson, function(geometry, featureIndex, properties, bbox, id) {
    var type = geometry === null ? null : geometry.type;
    switch (type) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        if (
          // @ts-expect-error: Known type conflict
          callback(
            _helpers.feature.call(void 0, geometry, properties, { bbox, id }),
            featureIndex,
            0
          ) === false
        )
          return false;
        return;
    }
    var geomType;
    switch (type) {
      case "MultiPoint":
        geomType = "Point";
        break;
      case "MultiLineString":
        geomType = "LineString";
        break;
      case "MultiPolygon":
        geomType = "Polygon";
        break;
    }
    for (
      var multiFeatureIndex = 0;
      // @ts-expect-error: Known type conflict
      multiFeatureIndex < geometry.coordinates.length;
      multiFeatureIndex++
    ) {
      var coordinate = geometry.coordinates[multiFeatureIndex];
      var geom = {
        type: geomType,
        coordinates: coordinate
      };
      if (
        // @ts-expect-error: Known type conflict
        callback(_helpers.feature.call(void 0, geom, properties), featureIndex, multiFeatureIndex) === false
      )
        return false;
    }
  });
}
function flattenReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  flattenEach(
    geojson,
    function(currentFeature, featureIndex, multiFeatureIndex) {
      if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0)
        previousValue = currentFeature;
      else
        previousValue = callback(
          // @ts-expect-error: Known type conflict
          previousValue,
          currentFeature,
          featureIndex,
          multiFeatureIndex
        );
    }
  );
  return previousValue;
}
function segmentEach(geojson, callback) {
  flattenEach(geojson, function(feature2, featureIndex, multiFeatureIndex) {
    var segmentIndex = 0;
    if (!feature2.geometry) return;
    var type = feature2.geometry.type;
    if (type === "Point" || type === "MultiPoint") return;
    var previousCoords;
    var previousFeatureIndex = 0;
    var previousMultiIndex = 0;
    var prevGeomIndex = 0;
    if (
      // @ts-expect-error: Known type conflict
      coordEach(
        feature2,
        function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
          if (
            // @ts-expect-error: Known type conflict
            previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex
          ) {
            previousCoords = currentCoord;
            previousFeatureIndex = featureIndex;
            previousMultiIndex = multiPartIndexCoord;
            prevGeomIndex = geometryIndex;
            segmentIndex = 0;
            return;
          }
          var currentSegment = _helpers.lineString.call(void 0, 
            // @ts-expect-error: Known type conflict
            [previousCoords, currentCoord],
            feature2.properties
          );
          if (
            // @ts-expect-error: Known type conflict
            callback(
              // @ts-expect-error: Known type conflict
              currentSegment,
              featureIndex,
              multiFeatureIndex,
              geometryIndex,
              segmentIndex
            ) === false
          )
            return false;
          segmentIndex++;
          previousCoords = currentCoord;
        }
      ) === false
    )
      return false;
  });
}
function segmentReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  var started = false;
  segmentEach(
    geojson,
    function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
      if (started === false && initialValue === void 0)
        previousValue = currentSegment;
      else
        previousValue = callback(
          previousValue,
          // @ts-expect-error: Known type conflict
          currentSegment,
          featureIndex,
          multiFeatureIndex,
          geometryIndex,
          segmentIndex
        );
      started = true;
    }
  );
  return previousValue;
}
function lineEach(geojson, callback) {
  if (!geojson) throw new Error("geojson is required");
  flattenEach(geojson, function(feature2, featureIndex, multiFeatureIndex) {
    if (feature2.geometry === null) return;
    var type = feature2.geometry.type;
    var coords = feature2.geometry.coordinates;
    switch (type) {
      case "LineString":
        if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false)
          return false;
        break;
      case "Polygon":
        for (var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++) {
          if (
            // @ts-expect-error: Known type conflict
            callback(
              // @ts-expect-error: Known type conflict
              _helpers.lineString.call(void 0, coords[geometryIndex], feature2.properties),
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false
          )
            return false;
        }
        break;
    }
  });
}
function lineReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  lineEach(
    geojson,
    function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
      if (featureIndex === 0 && initialValue === void 0)
        previousValue = currentLine;
      else
        previousValue = callback(
          previousValue,
          currentLine,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    }
  );
  return previousValue;
}
function findSegment(geojson, options) {
  options = options || {};
  if (!_helpers.isObject.call(void 0, options)) throw new Error("options is invalid");
  var featureIndex = options.featureIndex || 0;
  var multiFeatureIndex = options.multiFeatureIndex || 0;
  var geometryIndex = options.geometryIndex || 0;
  var segmentIndex = options.segmentIndex || 0;
  var properties = options.properties;
  var geometry;
  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }
  if (geometry === null) return null;
  var coords = geometry.coordinates;
  switch (geometry.type) {
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
      if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
      return _helpers.lineString.call(void 0, 
        // @ts-expect-error: Known type conflict
        [coords[segmentIndex], coords[segmentIndex + 1]],
        properties,
        options
      );
    case "Polygon":
      if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
      return _helpers.lineString.call(void 0, 
        [
          // @ts-expect-error: Known type conflict
          coords[geometryIndex][segmentIndex],
          // @ts-expect-error: Known type conflict
          coords[geometryIndex][segmentIndex + 1]
        ],
        properties,
        options
      );
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
      return _helpers.lineString.call(void 0, 
        [
          // @ts-expect-error: Known type conflict
          coords[multiFeatureIndex][segmentIndex],
          // @ts-expect-error: Known type conflict
          coords[multiFeatureIndex][segmentIndex + 1]
        ],
        properties,
        options
      );
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex = // @ts-expect-error: Known type conflict
        coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
      return _helpers.lineString.call(void 0, 
        [
          // @ts-expect-error: Known type conflict
          coords[multiFeatureIndex][geometryIndex][segmentIndex],
          // @ts-expect-error: Known type conflict
          coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
        ],
        properties,
        options
      );
  }
  throw new Error("geojson is invalid");
}
function findPoint(geojson, options) {
  options = options || {};
  if (!_helpers.isObject.call(void 0, options)) throw new Error("options is invalid");
  var featureIndex = options.featureIndex || 0;
  var multiFeatureIndex = options.multiFeatureIndex || 0;
  var geometryIndex = options.geometryIndex || 0;
  var coordIndex = options.coordIndex || 0;
  var properties = options.properties;
  var geometry;
  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }
  if (geometry === null) return null;
  var coords = geometry.coordinates;
  switch (geometry.type) {
    case "Point":
      return _helpers.point.call(void 0, coords, properties, options);
    case "MultiPoint":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      return _helpers.point.call(void 0, coords[multiFeatureIndex], properties, options);
    case "LineString":
      if (coordIndex < 0) coordIndex = coords.length + coordIndex;
      return _helpers.point.call(void 0, coords[coordIndex], properties, options);
    case "Polygon":
      if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
      if (coordIndex < 0)
        coordIndex = coords[geometryIndex].length + coordIndex;
      return _helpers.point.call(void 0, coords[geometryIndex][coordIndex], properties, options);
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (coordIndex < 0)
        coordIndex = coords[multiFeatureIndex].length + coordIndex;
      return _helpers.point.call(void 0, coords[multiFeatureIndex][coordIndex], properties, options);
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (coordIndex < 0)
        coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
      return _helpers.point.call(void 0, 
        coords[multiFeatureIndex][geometryIndex][coordIndex],
        properties,
        options
      );
  }
  throw new Error("geojson is invalid");
}


















exports.coordAll = coordAll; exports.coordEach = coordEach; exports.coordReduce = coordReduce; exports.featureEach = featureEach; exports.featureReduce = featureReduce; exports.findPoint = findPoint; exports.findSegment = findSegment; exports.flattenEach = flattenEach; exports.flattenReduce = flattenReduce; exports.geomEach = geomEach; exports.geomReduce = geomReduce; exports.lineEach = lineEach; exports.lineReduce = lineReduce; exports.propEach = propEach; exports.propReduce = propReduce; exports.segmentEach = segmentEach; exports.segmentReduce = segmentReduce;
//# sourceMappingURL=index.cjs.map

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  CONSUMPTION_CLASSES: () => (/* reexport */ CONSUMPTION_CLASSES),
  DEFAULT_POSITION: () => (/* reexport */ DEFAULT_POSITION),
  DtgAction: () => (/* reexport */ action_component),
  DtgAvatar: () => (/* reexport */ avatar_component),
  DtgBuildingSelector: () => (/* reexport */ building_selector_component),
  DtgBuildingSelectorSize: () => (/* reexport */ DtgBuildingSelectorSize),
  DtgBuildingSelectorView: () => (/* reexport */ DtgBuildingSelectorView),
  DtgBuildingTabs: () => (/* reexport */ building_tabs_component),
  DtgButton: () => (/* reexport */ button_component),
  DtgButtonAdd: () => (/* reexport */ button_add_component),
  DtgButtonAddView: () => (/* reexport */ DtgButtonAddView),
  DtgButtonAlign: () => (/* reexport */ DtgButtonAlign),
  DtgButtonBase: () => (/* reexport */ component),
  DtgButtonElement: () => (/* reexport */ button_element_component),
  DtgButtonElementAlign: () => (/* reexport */ DtgButtonElementAlign),
  DtgButtonElementSize: () => (/* reexport */ DtgButtonElementSize),
  DtgButtonElementView: () => (/* reexport */ DtgButtonElementView),
  DtgButtonSize: () => (/* reexport */ DtgButtonSize),
  DtgButtonView: () => (/* reexport */ DtgButtonView),
  DtgCard: () => (/* reexport */ card_component),
  DtgCardAction: () => (/* reexport */ card_action_component),
  DtgCardActionView: () => (/* reexport */ DtgCardActionView),
  DtgCardBase: () => (/* reexport */ card_base_component),
  DtgCardDivider: () => (/* reexport */ card_divider_component),
  DtgCardDocument: () => (/* reexport */ card_document_component),
  DtgCardLine: () => (/* reexport */ card_line_component),
  DtgCardMosaic: () => (/* reexport */ card_mosaic_component),
  DtgCardMosaicView: () => (/* reexport */ DtgCardMosaicView),
  DtgCardObligation: () => (/* reexport */ card_obligation_component),
  DtgCardRow: () => (/* reexport */ card_row_component),
  DtgCardRowIconView: () => (/* reexport */ DtgCardRowIconView),
  DtgCardSection: () => (/* reexport */ card_section_component),
  DtgCardSectionAlign: () => (/* reexport */ DtgCardSectionAlign),
  DtgCardSupport: () => (/* reexport */ card_support_component),
  DtgCardTile: () => (/* reexport */ card_tile_component),
  DtgCardTitle: () => (/* reexport */ card_title_component),
  DtgCheckbox: () => (/* reexport */ checkbox_component),
  DtgCheckboxGroup: () => (/* reexport */ checkbox_group_component),
  DtgCheckboxGroupView: () => (/* reexport */ DtgCheckboxGroupView),
  DtgChoice: () => (/* reexport */ choice_component),
  DtgChoiceType: () => (/* reexport */ DtgChoiceType),
  DtgCol: () => (/* reexport */ col),
  DtgContent: () => (/* reexport */ content_component),
  DtgCounter: () => (/* reexport */ counter_component),
  DtgDatepicker: () => (/* reexport */ datepicker_component),
  DtgDiagnosticAudit: () => (/* reexport */ diagnostic_audit_component),
  DtgDiagnosticDpe: () => (/* reexport */ diagnostic_dpe_component),
  DtgDivider: () => (/* reexport */ divider_component),
  DtgDividerView: () => (/* reexport */ DtgDividerView),
  DtgDocumentFile: () => (/* reexport */ document_file_component),
  DtgDocumentPage: () => (/* reexport */ document_page_component),
  DtgDropdown: () => (/* reexport */ dropdown_component),
  DtgDropdownItem: () => (/* reexport */ dropdown_item_component),
  DtgDropzone: () => (/* reexport */ dropzone_component),
  DtgElementList: () => (/* reexport */ element_list_component),
  DtgField: () => (/* reexport */ field_component),
  DtgFieldLabel: () => (/* reexport */ field_label_component),
  DtgFieldset: () => (/* reexport */ fieldset_component),
  DtgFieldsetHeader: () => (/* reexport */ fieldset_header_component),
  DtgFieldsetSpoiler: () => (/* reexport */ fieldset_spoiler_component),
  DtgFileChooser: () => (/* reexport */ file_chooser_component),
  DtgFileChooserAcceptedTypes: () => (/* reexport */ DtgFileChooserAcceptedTypes),
  DtgFileDropzone: () => (/* reexport */ file_dropzone_component),
  DtgForm: () => (/* reexport */ form_component),
  DtgFormBuildingPlans: () => (/* reexport */ form_building_plans_component),
  DtgFormBuildings: () => (/* reexport */ form_buildings_component),
  DtgFormEnergyBalance: () => (/* reexport */ form_energy_balance_component),
  DtgFormEnergyScenario: () => (/* reexport */ form_energy_scenario_component),
  DtgFormLogin: () => (/* reexport */ form_login_component),
  DtgFormPasswordChoose: () => (/* reexport */ form_password_choose_component),
  DtgFormPasswordReset: () => (/* reexport */ form_password_reset_component),
  DtgGrid: () => (/* reexport */ grid),
  DtgGridPadding: () => (/* reexport */ DtgGridPadding),
  DtgIcon: () => (/* reexport */ icon_component),
  DtgIconAction: () => (/* reexport */ icon_action_component),
  DtgInfiniteScroll: () => (/* reexport */ infinite_scroll_component),
  DtgInfoBox: () => (/* reexport */ info_box_component),
  DtgInput: () => (/* reexport */ input_component),
  DtgInputColor: () => (/* reexport */ input_color_component),
  DtgInputCurrency: () => (/* reexport */ input_currency_component),
  DtgInputDate: () => (/* reexport */ input_date_component),
  DtgInputEmail: () => (/* reexport */ input_email_component),
  DtgInputFile: () => (/* reexport */ input_file_component),
  DtgInputFreeDate: () => (/* reexport */ input_free_date_component),
  DtgInputMode: () => (/* reexport */ DtgInputMode),
  DtgInputNumber: () => (/* reexport */ input_number_component),
  DtgInputPassword: () => (/* reexport */ input_password_component),
  DtgInputTel: () => (/* reexport */ input_tel_component),
  DtgInputType: () => (/* reexport */ DtgInputType),
  DtgInputView: () => (/* reexport */ DtgInputView),
  DtgLayoutAuth: () => (/* reexport */ layout_auth_component),
  DtgLayoutStorybook: () => (/* reexport */ layout_storybook_component),
  DtgLink: () => (/* reexport */ link_component),
  DtgLinkBase: () => (/* reexport */ link_base_component),
  DtgMap: () => (/* reexport */ map_component),
  DtgMark: () => (/* reexport */ mark_component),
  DtgMarkSize: () => (/* reexport */ DtgMarkSize),
  DtgMarkView: () => (/* reexport */ DtgMarkView),
  DtgModalComment: () => (/* reexport */ modal_comment_component),
  DtgModalConfirm: () => (/* reexport */ modal_confirm_component),
  DtgModalContent: () => (/* reexport */ modal_content_component),
  DtgModalContentScrollable: () => (/* reexport */ modal_content_scrollable_component),
  DtgModalCustomDocument: () => (/* reexport */ modal_custom_document_component),
  DtgModalMessage: () => (/* reexport */ modal_message_component),
  DtgModalReport: () => (/* reexport */ modal_report_component),
  DtgModalWeakCredentials: () => (/* reexport */ modal_weak_credentials_component),
  DtgObligationFilter: () => (/* reexport */ obligation_filter_component),
  DtgParcelsMap: () => (/* reexport */ parcels_map_component),
  DtgPasswordRequirements: () => (/* reexport */ password_requirements_component),
  DtgPdfPreview: () => (/* reexport */ pdf_preview_component),
  DtgPrivacyPolicy: () => (/* reexport */ privacy_policy_component),
  DtgProgress: () => (/* reexport */ progress_component),
  DtgProgressSize: () => (/* reexport */ DtgProgressSize),
  DtgProgressType: () => (/* reexport */ DtgProgressType),
  DtgRadio: () => (/* reexport */ radio_component),
  DtgRadioButton: () => (/* reexport */ radio_button_component),
  DtgRadioGroup: () => (/* reexport */ radio_group_component),
  DtgRadioGroupView: () => (/* reexport */ DtgRadioGroupView),
  DtgRow: () => (/* reexport */ row),
  DtgRowCol: () => (/* reexport */ row_col),
  DtgScrollable: () => (/* reexport */ scrollable_component),
  DtgSection: () => (/* reexport */ section_component),
  DtgSelect: () => (/* reexport */ select_component),
  DtgSelectFreeOptionBehavior: () => (/* reexport */ DtgSelectFreeOptionBehavior),
  DtgSelectLocation: () => (/* reexport */ select_location_component),
  DtgSelectSelectBehavior: () => (/* reexport */ DtgSelectSelectBehavior),
  DtgSelectType: () => (/* reexport */ DtgSelectType),
  DtgSelectYesNo: () => (/* reexport */ select_yes_no_component),
  DtgSpinner: () => (/* reexport */ spinner_component),
  DtgSpinnerView: () => (/* reexport */ DtgSpinnerView),
  DtgSpoiler: () => (/* reexport */ spoiler_component),
  DtgTabs: () => (/* reexport */ tabs_component),
  DtgTag: () => (/* reexport */ tag_component),
  DtgTermsOfSales: () => (/* reexport */ terms_of_sales_component),
  DtgTermsOfService: () => (/* reexport */ terms_of_service_component),
  DtgTextEditable: () => (/* reexport */ text_editable_component),
  DtgTextEditableValueType: () => (/* reexport */ DtgTextEditableValueType),
  DtgTextarea: () => (/* reexport */ textarea_component),
  DtgTitle: () => (/* reexport */ title_component),
  DtgToggle: () => (/* reexport */ toggle_component),
  DtgTransitionGroupStack: () => (/* reexport */ transition_group_stack_component),
  DtgTransitionStack: () => (/* reexport */ transition_stack_component),
  EMISSION_CLASSES: () => (/* reexport */ EMISSION_CLASSES),
  MAP_ID: () => (/* reexport */ MAP_ID),
  MultiselectMode: () => (/* reexport */ MultiselectMode),
  OverlayType: () => (/* reexport */ OverlayType),
  addressSuggestionsService: () => (/* reexport */ addressSuggestionsService),
  between: () => (/* reexport */ between),
  breakpointsHeight: () => (/* reexport */ breakpointsHeight),
  breakpointsWidth: () => (/* reexport */ breakpointsWidth),
  detectCaptureSupported: () => (/* reexport */ detectCaptureSupported),
  dtgFileChooserFile: () => (/* reexport */ dtgFileChooserFile),
  dtgSelectEvents: () => (/* reexport */ dtgSelectEvents),
  events: () => (/* reexport */ events),
  from: () => (/* reexport */ from),
  getGmapsApiConfig: () => (/* reexport */ getGmapsApiConfig),
  getGmapsPromise: () => (/* reexport */ getGmapsPromise),
  getName: () => (/* reexport */ getName),
  iconNames: () => (/* reexport */ iconNames),
  imask: () => (/* reexport */ imask),
  inArray: () => (/* reexport */ inArray),
  inRecord: () => (/* reexport */ inRecord),
  inRecordKeys: () => (/* reexport */ inRecordKeys),
  isMatchingMimeType: () => (/* reexport */ isMatchingMimeType),
  longClick: () => (/* reexport */ longClick),
  matches: () => (/* reexport */ matches),
  nextMapIdle: () => (/* reexport */ nextMapIdle),
  openErrorToast: () => (/* reexport */ openErrorToast),
  openFileDownloadToast: () => (/* reexport */ openFileDownloadToast),
  openToast: () => (/* reexport */ openToast),
  positionPopover: () => (/* reexport */ positionPopover),
  propInternal: () => (/* reexport */ propInternal),
  props: () => (/* reexport */ modal_comment_props_props),
  provideOverlayElement: () => (/* reexport */ provideOverlayElement),
  provideScroll: () => (/* reexport */ provideScroll),
  setGmapsApiConfig: () => (/* reexport */ setGmapsApiConfig),
  till: () => (/* reexport */ till),
  useBem: () => (/* reexport */ useBem),
  useBp: () => (/* reexport */ useBp),
  useCustomDocuments: () => (/* reexport */ useCustomDocuments),
  useCustomObligations: () => (/* reexport */ useCustomObligations),
  useDocumentDisabledByDtgType: () => (/* reexport */ useDocumentDisabledByDtgType),
  useDocumentPagination: () => (/* reexport */ useDocumentPagination),
  useElementPosition: () => (/* reexport */ useElementPosition),
  useExternalNavigationGuard: () => (/* reexport */ useExternalNavigationGuard),
  useFileReader: () => (/* reexport */ useFileReader),
  useFocus: () => (/* reexport */ useFocus),
  useFocusPropagation: () => (/* reexport */ useFocusPropagation),
  useGmapsApi: () => (/* reexport */ useGmapsApi),
  useHeightTransition: () => (/* reexport */ useHeightTransition),
  useHover: () => (/* reexport */ useHover),
  useInternalNavigationGuard: () => (/* reexport */ useInternalNavigationGuard),
  useModalComment: () => (/* reexport */ useModalComment),
  useModalConfirm: () => (/* reexport */ useModalConfirm),
  useModalConfirmDelete: () => (/* reexport */ useModalConfirmDelete),
  useModalCustomDocument: () => (/* reexport */ useModalCustomDocument),
  useModalCustomObligation: () => (/* reexport */ useModalCustomObligation),
  useModalMessage: () => (/* reexport */ useModalMessage),
  useModalObligationSituation: () => (/* reexport */ useModalObligationSituation),
  useModalReport: () => (/* reexport */ useModalReport),
  useModalWeakCredentials: () => (/* reexport */ useModalWeakCredentials),
  useObligationDisabledByDtgType: () => (/* reexport */ useObligationDisabledByDtgType),
  useObligationsPagination: () => (/* reexport */ useObligationsPagination),
  useOverlay: () => (/* reexport */ useOverlay),
  useOverlayElement: () => (/* reexport */ useOverlayElement),
  usePaginatedArray: () => (/* reexport */ usePaginatedArray),
  useScroll: () => (/* reexport */ useScroll),
  useScrollRestoration: () => (/* reexport */ useScrollRestoration),
  useScrollSidebar: () => (/* reexport */ useScrollSidebar),
  useSplitAttrs: () => (/* reexport */ useSplitAttrs),
  useTemplateRefsArray: () => (/* reexport */ useTemplateRefsArray),
  wrapMapReady: () => (/* reexport */ wrapMapReady)
});

;// ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) // removed by dead control flow
{ var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// ./src/styles/index.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles = ({});
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(9274);
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/action/component.vue?vue&type=template&id=59730edc&ts=true

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDynamicComponent)(_ctx.component), null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    _: 3
  });
}
;// ./src/components/atoms/action/component.vue?vue&type=template&id=59730edc&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/button-base/component.vue?vue&type=template&id=6e548860&ts=true

const _hoisted_1 = ["type"];
function componentvue_type_template_id_6e548860_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("button", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: _ctx.b(),
    type: _ctx.type
  }, {
    ..._ctx.$attrs,
    ..._ctx.buttonAttrs
  }), [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 16, _hoisted_1);
}
;// ./src/components/atoms/button-base/component.vue?vue&type=template&id=6e548860&ts=true

// EXTERNAL MODULE: ../../node_modules/bem-css-modules/dist/bem-css-modules.js
var bem_css_modules = __webpack_require__(611);
;// ./src/composables/use-bem/composable.ts

const elementDelimiter = '__';
const modifierDelimiter = '_';
bem_css_modules/* default */.A.setSettings({
  throwOnError: false,
  elementDelimiter,
  modifierDelimiter
});
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useBem(styles) {
  let generator = null;
  // eslint-disable-next-line func-style
  const b = (...args) => {
    if (!generator) {
      generator = (0,bem_css_modules/* default */.A)(styles);
    }
    // @ts-expect-error wrapping function
    return generator(...args);
  };
  return b;
}
function getName(styles) {
  let [name] = Object.keys(styles);
  if (!name) {
    throw new Error('Empty css module');
  }
  const indexElement = name.indexOf(elementDelimiter);
  if (indexElement !== -1) {
    name = name.slice(0, indexElement);
  }
  const indexModifier = name.indexOf(modifierDelimiter);
  if (indexModifier !== -1) {
    name = name.slice(0, indexModifier);
  }
  return name;
}
;// ./src/composables/use-bem/index.ts


;// ./src/components/atoms/button-base/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const style_module = ({"dtg-button-base":"lib_dtg-button-base_EIdO0"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/button-base/component.vue?vue&type=script&lang=ts



/* harmony default export */ const componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(style_module),
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const buttonAttrs = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        disabled
      } = props;
      return disabled ? {
        disabled
      } : {};
    });
    return {
      b: useBem(style_module),
      buttonAttrs
    };
  }
}));
;// ./src/components/atoms/button-base/component.vue?vue&type=script&lang=ts
 
// EXTERNAL MODULE: ../../node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(7433);
;// ./src/components/atoms/button-base/component.vue




;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.A)(componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_6e548860_ts_true_render]])

/* harmony default export */ const component = (__exports__);
;// ./src/components/atoms/button-base/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/link-base/component.vue?vue&type=template&id=51cfa900&ts=true

function componentvue_type_template_id_51cfa900_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDynamicComponent)(_ctx.component), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: _ctx.b()
  }, {
    ..._ctx.$attrs,
    ..._ctx.linkProps
  }), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    _: 3
  }, 16, ["class"]);
}
;// ./src/components/atoms/link-base/component.vue?vue&type=template&id=51cfa900&ts=true

;// ./src/components/atoms/link-base/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const link_base_style_module = ({"dtg-link-base":"lib_dtg-link-base_hT3MR"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/link-base/component.vue?vue&type=script&lang=ts



/* harmony default export */ const link_base_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(link_base_style_module),
  inheritAttrs: false,
  props: {
    routed: {
      type: Boolean,
      default: false
    },
    href: {
      type: [String, Object],
      default: null
    },
    target: {
      type: String,
      default: null
    },
    rel: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const component = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      if (props.disabled) {
        return 'span';
      }
      return props.routed ? 'router-link' : 'a';
    });
    const relInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        target,
        rel
      } = props;
      return target === '_blank' ? 'noopener noreferrer' : rel;
    });
    const linkProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        disabled,
        href,
        target,
        routed
      } = props;
      const rel = relInternal.value;
      const routeKey = routed ? 'to' : 'href';
      const attrs = {
        target,
        rel,
        [routeKey]: href
      };
      if (disabled) {
        Object.assign(attrs, {
          disabled: true
        });
      }
      return attrs;
    });
    return {
      b: useBem(link_base_style_module),
      component,
      linkProps
    };
  }
}));
;// ./src/components/atoms/link-base/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/link-base/component.vue




;
const component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(link_base_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_51cfa900_ts_true_render]])

/* harmony default export */ const link_base_component = (component_exports_);
;// ./src/components/atoms/link-base/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/action/component.vue?vue&type=script&lang=ts



/* harmony default export */ const action_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-action',
  components: {
    DtgLinkBase: link_base_component,
    DtgButtonBase: component
  },
  setup(props, {
    attrs
  }) {
    const component = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => attrs.href ? 'dtg-link-base' : 'dtg-button-base');
    return {
      component
    };
  }
}));
;// ./src/components/atoms/action/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/action/component.vue




;
const action_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(action_componentvue_type_script_lang_ts, [['render',render]])

/* harmony default export */ const action_component = (action_component_exports_);
;// ./src/components/atoms/action/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/avatar/component.vue?vue&type=template&id=1ac31818&ts=true

const componentvue_type_template_id_1ac31818_ts_true_hoisted_1 = ["src"];
function componentvue_type_template_id_1ac31818_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('image')),
    src: _ctx.src
  }, null, 10, componentvue_type_template_id_1ac31818_ts_true_hoisted_1)], 2);
}
;// ./src/components/atoms/avatar/component.vue?vue&type=template&id=1ac31818&ts=true

;// ./src/components/atoms/avatar/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const avatar_style_module = ({"dtg-avatar":"lib_dtg-avatar_cl_oT","dtg-avatar__image":"lib_dtg-avatar__image_Ml2fX"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/avatar/component.vue?vue&type=script&lang=ts



/* harmony default export */ const avatar_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(avatar_style_module),
  props: {
    src: {
      type: String,
      required: true
    }
  },
  setup() {
    return {
      b: useBem(avatar_style_module)
    };
  }
}));
;// ./src/components/atoms/avatar/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/avatar/component.vue




;
const avatar_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(avatar_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_1ac31818_ts_true_render]])

/* harmony default export */ const avatar_component = (avatar_component_exports_);
;// ./src/components/atoms/avatar/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/button/component.vue?vue&type=template&id=6735f70a&ts=true

function componentvue_type_template_id_6735f70a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_spinner = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-spinner");
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_mark = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-mark");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: _ctx.b(_ctx.mods)
  }, _ctx.$attrs, {
    disabled: _ctx.disabledInternal
  }), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('inner'))
    }, [_ctx.$slots.default ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.icon || _ctx.marked || _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon-wrapper'))
    }, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_spinner, {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon'))
    }, null, 8, ["class"])) : _ctx.icon ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_icon, {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon')),
      name: _ctx.icon
    }, null, 8, ["class", "name"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.marked && !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_mark, {
      key: 2,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('mark')),
      view: _ctx.markView
    }, null, 8, ["class", "view"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)]),
    _: 3
  }, 16, ["class", "disabled"]);
}
;// ./src/components/atoms/button/component.vue?vue&type=template&id=6735f70a&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/icon/component.vue?vue&type=template&id=7c95b0e3&ts=true

function componentvue_type_template_id_7c95b0e3_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      [_ctx.icon]: true
    }))
  }, null, 2);
}
;// ./src/components/atoms/icon/component.vue?vue&type=template&id=7c95b0e3&ts=true

// EXTERNAL MODULE: external "dtg-shared/utils/prop-validator"
var prop_validator_ = __webpack_require__(1718);
;// ./src/utils/prop-validators.ts
/* Higher order functions to be used in the validator field of props */

// Make sure to specify TValue, otherwise the component will fail to compile due to TS errors D:
function inRecord(record) {
  return (0,prop_validator_.propValidator)(value => Object.values(record).includes(value), record);
}
function inRecordKeys(record) {
  return (0,prop_validator_.propValidator)(value => Object.keys(record).includes(value), Object.keys(record));
}
function inArray(array) {
  return (0,prop_validator_.propValidator)(value => array.includes(value), array);
}
;// ./src/components/atoms/icon/icons.ts
// TODO: remove icons duplicates and choose better names
const icons = {
  add: 'plus',
  save: 'save',
  close: 'cross-bold',
  closeCircle: 'circle-cross',
  trash: 'trash',
  duplicate: 'duplicate',
  download: 'download',
  edit: 'pen',
  reload: 'photo-switch-medium',
  turnOff: 'logout',
  folder: 'file',
  logOut: 'sent-validation',
  arrowLeftRounded: 'arrow-circle-to-left',
  arrowRightRounded: 'arrow-circle-to-right',
  eye: 'view-medium',
  eyeCrossed: 'hide-medium',
  grid: 'menu',
  camera: 'photo',
  home: 'house',
  mail: 'mail',
  pageUnvisitedLocations: 'not-visited',
  pageControlPoints: 'pinpoint',
  pageDocuments: 'list-documents',
  pageEnergyBalance: 'energy-balance',
  pageBuildingComplex: 'house',
  pageImprovements: 'upgrade',
  pageInformation: 'file',
  pageLegalObligations: 'legal',
  pageLocation: 'flag',
  pageOverview: 'synthesis',
  pagePhotos: 'photo',
  chevron: 'dropdown-arrow-bold',
  facture: 'billing',
  calendar: 'calendar',
  call: 'phone',
  staircase: 'basement',
  navigate: 'route',
  alert: 'alert',
  checkmark: 'check-bold',
  checkmarkCircle: 'circle-chek',
  warning: 'warning',
  location: 'flag',
  comment: 'speachbubble',
  previous: 'previous',
  next: 'next',
  energy: 'energy',
  filter: 'filter',
  information: 'information',
  photo: 'photo',
  addPhoto: 'add-photo-medium',
  user: 'user',
  warningBg: 'warning-bg',
  arrowCircleToBottom: 'arrow-circle-to-bottom',
  arrowCircleToTop: 'arrow-circle-to-top',
  arrowBottom: 'arrow-to-bottom',
  arrowLeft: 'arrow-to-left',
  arrowRight: 'arrow-to-right',
  arrowTop: 'arrow-to-top',
  exterior: 'outside-medium',
  table: 'table',
  list: 'list',
  support: 'support',
  logoCopro: 'logo-marque-ce',
  logoMyDtg: 'logo-mydtg',
  pictogramMyDtg: 'picto-my-dtg',
  pictogramSepteo: 'picto-septeo',
  rotateRight: 'rotate-right-medium',
  rotateLeft: 'rotate-left-medium',
  kebab: 'more-option',
  stopwatch: 'chrono-medium',
  flag: 'flag-medium',
  dashboard: 'dashboard-medium',
  calculator: 'calculator-medium',
  picture: 'picture-medium',
  settings: 'settings-medium',
  historic: 'historic-medium',
  filter2: 'filter-2-medium',
  filter3: 'filter-3-medium',
  unarchive: 'unarchive2-medium',
  archive: 'archive2-medium',
  arrowBack: 'arrow-back',
  arrowForward: 'arrow-forward',
  addBuilding: 'add-building',
  addControlPoint: 'add-pdc',
  magicStick: 'magical-mode',
  search: 'search',
  total: 'element',
  addControlPointTotal: 'new-point-element',
  exit: 'out-magical-mode',
  controlPointRecap: 'recap-point',
  lockOpen: 'lock-open'
};
const iconNames = Object.keys(icons);

;// ./src/components/atoms/icon/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const icon_style_module = ({"dtg-icon":"lib_dtg-icon_DlYuZ","dtg-icon_photo-switch-medium":"lib_dtg-icon_photo-switch-medium_F_Zi_","dtg-icon_hide-medium":"lib_dtg-icon_hide-medium_aBYwr","dtg-icon_view-medium":"lib_dtg-icon_view-medium_qO3Fl","dtg-icon_previous":"lib_dtg-icon_previous_l5k83","dtg-icon_next":"lib_dtg-icon_next_aprTw","dtg-icon_menu":"lib_dtg-icon_menu_ORjO5","dtg-icon_legal":"lib_dtg-icon_legal_osCIG","dtg-icon_circle-cross":"lib_dtg-icon_circle-cross_ZMkhS","dtg-icon_cross-bold":"lib_dtg-icon_cross-bold_oJNUv","dtg-icon_download":"lib_dtg-icon_download_HOkey","dtg-icon_dropdown-arrow-bold":"lib_dtg-icon_dropdown-arrow-bold_U7jZr","dtg-icon_duplicate":"lib_dtg-icon_duplicate_kcz4Q","dtg-icon_energy":"lib_dtg-icon_energy_ZaDlw","dtg-icon_energy-balance":"lib_dtg-icon_energy-balance_JbeVM","dtg-icon_file":"lib_dtg-icon_file_LxVJP","dtg-icon_filter":"lib_dtg-icon_filter_Qff8B","dtg-icon_flag":"lib_dtg-icon_flag_uANJZ","dtg-icon_house":"lib_dtg-icon_house_se17n","dtg-icon_information":"lib_dtg-icon_information_gBBg6","dtg-icon_list-documents":"lib_dtg-icon_list-documents_flXrZ","dtg-icon_logout":"lib_dtg-icon_logout__EMmS","dtg-icon_mail":"lib_dtg-icon_mail_p9lxq","dtg-icon_not-visited":"lib_dtg-icon_not-visited_AxVhY","dtg-icon_pen":"lib_dtg-icon_pen_THdGF","dtg-icon_phone":"lib_dtg-icon_phone_PhYZb","dtg-icon_photo":"lib_dtg-icon_photo_RPatX","dtg-icon_add-photo-medium":"lib_dtg-icon_add-photo-medium_Q2Lcy","dtg-icon_pinpoint":"lib_dtg-icon_pinpoint_OSjIR","dtg-icon_plus":"lib_dtg-icon_plus_BNoGi","dtg-icon_route":"lib_dtg-icon_route_rlwCe","dtg-icon_save":"lib_dtg-icon_save_STl7R","dtg-icon_sent-validation":"lib_dtg-icon_sent-validation_WF5sq","dtg-icon_speachbubble":"lib_dtg-icon_speachbubble_h9cIm","dtg-icon_synthesis":"lib_dtg-icon_synthesis_EM862","dtg-icon_trash":"lib_dtg-icon_trash_HthJS","dtg-icon_upgrade":"lib_dtg-icon_upgrade_GmxK3","dtg-icon_user":"lib_dtg-icon_user_c2csZ","dtg-icon_warning":"lib_dtg-icon_warning_t2BwS","dtg-icon_warning-bg":"lib_dtg-icon_warning-bg_yb38f","dtg-icon_alert":"lib_dtg-icon_alert_wgtYR","dtg-icon_arrow-circle-to-bottom":"lib_dtg-icon_arrow-circle-to-bottom_auc0r","dtg-icon_arrow-circle-to-left":"lib_dtg-icon_arrow-circle-to-left_VjK7E","dtg-icon_arrow-circle-to-right":"lib_dtg-icon_arrow-circle-to-right_lD7TS","dtg-icon_arrow-circle-to-top":"lib_dtg-icon_arrow-circle-to-top_b67zv","dtg-icon_arrow-to-bottom":"lib_dtg-icon_arrow-to-bottom_T056D","dtg-icon_arrow-to-left":"lib_dtg-icon_arrow-to-left_XyhzP","dtg-icon_arrow-to-right":"lib_dtg-icon_arrow-to-right_ScML1","dtg-icon_arrow-to-top":"lib_dtg-icon_arrow-to-top_G3ggH","dtg-icon_outside-medium":"lib_dtg-icon_outside-medium_HFCRB","dtg-icon_basement":"lib_dtg-icon_basement_KuyvX","dtg-icon_billing":"lib_dtg-icon_billing_JBIId","dtg-icon_calendar":"lib_dtg-icon_calendar_rPzvO","dtg-icon_check-bold":"lib_dtg-icon_check-bold_CmAuL","dtg-icon_checklist":"lib_dtg-icon_checklist_kkTr_","dtg-icon_circle-chek":"lib_dtg-icon_circle-chek_KtjtX","dtg-icon_table":"lib_dtg-icon_table_rSVii","dtg-icon_list":"lib_dtg-icon_list_e6GEy","dtg-icon_logo-marque-ce":"lib_dtg-icon_logo-marque-ce_mhSIM","dtg-icon_logo-mydtg":"lib_dtg-icon_logo-mydtg_jfaRw","dtg-icon_picto-my-dtg":"lib_dtg-icon_picto-my-dtg_OsNaw","dtg-icon_picto-septeo":"lib_dtg-icon_picto-septeo_OTq0a","dtg-icon_rotate-right-medium":"lib_dtg-icon_rotate-right-medium_nxn8T","dtg-icon_rotate-left-medium":"lib_dtg-icon_rotate-left-medium_IlucB","dtg-icon_more-option":"lib_dtg-icon_more-option_N57t6","dtg-icon_chrono-medium":"lib_dtg-icon_chrono-medium_unwWK","dtg-icon_flag-medium":"lib_dtg-icon_flag-medium_WL8zL","dtg-icon_dashboard-medium":"lib_dtg-icon_dashboard-medium_KrVg_","dtg-icon_calculator-medium":"lib_dtg-icon_calculator-medium_fiez6","dtg-icon_picture-medium":"lib_dtg-icon_picture-medium_TH0DJ","dtg-icon_settings-medium":"lib_dtg-icon_settings-medium_NuroA","dtg-icon_historic-medium":"lib_dtg-icon_historic-medium_Jyy2Q","dtg-icon_filter-3-medium":"lib_dtg-icon_filter-3-medium_OTWYm","dtg-icon_filter-2-medium":"lib_dtg-icon_filter-2-medium_vX_w0","dtg-icon_unarchive2-medium":"lib_dtg-icon_unarchive2-medium_x5dcF","dtg-icon_archive2-medium":"lib_dtg-icon_archive2-medium_q2hzP","dtg-icon_support":"lib_dtg-icon_support_jHdk0","dtg-icon_arrow-back":"lib_dtg-icon_arrow-back_yPu4v","dtg-icon_arrow-forward":"lib_dtg-icon_arrow-forward_pTMRJ","dtg-icon_add-pdc":"lib_dtg-icon_add-pdc_r2Bou","dtg-icon_add-building":"lib_dtg-icon_add-building_Xaiw9","dtg-icon_magic-stick":"lib_dtg-icon_magic-stick_og_V1","dtg-icon_recap-point":"lib_dtg-icon_recap-point_IZb6Y","dtg-icon_element":"lib_dtg-icon_element_VKKPv","dtg-icon_magical-mode":"lib_dtg-icon_magical-mode_Zctb2","dtg-icon_new-point-element":"lib_dtg-icon_new-point-element_LFw6f","dtg-icon_out-magical-mode":"lib_dtg-icon_out-magical-mode_qJq89","dtg-icon_search":"lib_dtg-icon_search_CRTWs","dtg-icon_lock-open":"lib_dtg-icon_lock-open_CYtjT"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/icon/component.vue?vue&type=script&lang=ts





/* harmony default export */ const icon_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(icon_style_module),
  props: {
    name: {
      type: String,
      required: true,
      validator: inArray(iconNames)
    },
    fallbackName: {
      type: String,
      default: 'close',
      validator: inArray(iconNames)
    }
  },
  setup(props) {
    const icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        name,
        fallbackName
      } = props;
      return iconNames.includes(name) ? icons[name] : icons[fallbackName];
    });
    return {
      b: useBem(icon_style_module),
      icon
    };
  }
}));
;// ./src/components/atoms/icon/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/icon/component.vue




;
const icon_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(icon_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_7c95b0e3_ts_true_render]])

/* harmony default export */ const icon_component = (icon_component_exports_);
;// ./src/components/atoms/icon/index.ts




;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/mark/component.vue?vue&type=template&id=212f214a&ts=true

function componentvue_type_template_id_212f214a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      view: _ctx.view,
      size: _ctx.size,
      border: _ctx.border
    }))
  }, [_ctx.icon ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_icon, {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon')),
    name: _ctx.icon
  }, null, 8, ["class", "name"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// ./src/components/atoms/mark/component.vue?vue&type=template&id=212f214a&ts=true

;// ./src/components/atoms/mark/types.ts
var DtgMarkView;
(function (DtgMarkView) {
  DtgMarkView["clear"] = "clear";
  DtgMarkView["neutral"] = "neutral";
  DtgMarkView["notice"] = "notice";
  DtgMarkView["success"] = "success";
  DtgMarkView["warning"] = "warning";
  DtgMarkView["disabled"] = "disabled";
})(DtgMarkView || (DtgMarkView = {}));
var DtgMarkSize;
(function (DtgMarkSize) {
  DtgMarkSize["s"] = "s";
  DtgMarkSize["m"] = "m";
  DtgMarkSize["l"] = "l";
})(DtgMarkSize || (DtgMarkSize = {}));
;// ./src/components/atoms/mark/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const mark_style_module = ({"dtg-mark":"lib_dtg-mark_Ce5qq","dtg-mark_border":"lib_dtg-mark_border_sHotd","dtg-mark_view_notice":"lib_dtg-mark_view_notice_ZnrPk","dtg-mark_view_neutral":"lib_dtg-mark_view_neutral_V5GUR","dtg-mark_view_success":"lib_dtg-mark_view_success_M6hUw","dtg-mark_view_warning":"lib_dtg-mark_view_warning_HYn3K","dtg-mark_view_disabled":"lib_dtg-mark_view_disabled_h4fLI","dtg-mark_view_clear":"lib_dtg-mark_view_clear__cnFm","dtg-mark_size_s":"lib_dtg-mark_size_s_M9rzJ","dtg-mark_size_m":"lib_dtg-mark_size_m_jfvrl","dtg-mark_size_l":"lib_dtg-mark_size_l_Ud9qh","dtg-mark__icon":"lib_dtg-mark__icon_W24YT"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/mark/component.vue?vue&type=script&lang=ts






/* harmony default export */ const mark_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(mark_style_module),
  components: {
    DtgIcon: icon_component
  },
  props: {
    view: {
      type: String,
      default: DtgMarkView.notice,
      validator: inRecord(DtgMarkView)
    },
    size: {
      type: String,
      default: DtgMarkSize.m,
      validator: inRecord(DtgMarkSize)
    },
    border: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    }
  },
  setup() {
    return {
      b: useBem(mark_style_module)
    };
  }
}));
;// ./src/components/atoms/mark/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/mark/component.vue




;
const mark_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(mark_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_212f214a_ts_true_render]])

/* harmony default export */ const mark_component = (mark_component_exports_);
;// ./src/components/atoms/mark/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/spinner/component.vue?vue&type=template&id=5084f174&ts=true

const componentvue_type_template_id_5084f174_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("circle", {
  cx: "48",
  cy: "48",
  r: "20"
}, null, -1);
const _hoisted_2 = [componentvue_type_template_id_5084f174_ts_true_hoisted_1];
function componentvue_type_template_id_5084f174_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      view: _ctx.view,
      disabled: _ctx.disabled
    }))
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('spinner')),
    viewBox: "24 24 48 48"
  }, _hoisted_2, 2))], 2);
}
;// ./src/components/atoms/spinner/component.vue?vue&type=template&id=5084f174&ts=true

;// ./src/components/atoms/spinner/types.ts
var DtgSpinnerView;
(function (DtgSpinnerView) {
  DtgSpinnerView["regular"] = "regular";
  DtgSpinnerView["big"] = "big";
})(DtgSpinnerView || (DtgSpinnerView = {}));
;// ./src/components/atoms/spinner/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const spinner_style_module = ({"dtg-spinner":"lib_dtg-spinner_ALTLv","dtg-spinner__spinner":"lib_dtg-spinner__spinner_OVsOD","spinner":"lib_spinner_eBq9b","dtg-spinner_view_big":"lib_dtg-spinner_view_big__iwXa","spinner-inner":"lib_spinner-inner_BBpzY","dtg-spinner_disabled":"lib_dtg-spinner_disabled_pJ9i_"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/spinner/component.vue?vue&type=script&lang=ts





/* harmony default export */ const spinner_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(spinner_style_module),
  props: {
    view: {
      type: String,
      default: DtgSpinnerView.regular,
      validator: inRecord(DtgSpinnerView)
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      b: useBem(spinner_style_module)
    };
  }
}));
;// ./src/components/atoms/spinner/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/spinner/component.vue




;
const spinner_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(spinner_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_5084f174_ts_true_render]])

/* harmony default export */ const spinner_component = (spinner_component_exports_);
;// ./src/components/atoms/spinner/index.ts



;// ./src/components/atoms/button/types.ts
var DtgButtonView;
(function (DtgButtonView) {
  DtgButtonView["regular"] = "regular";
  DtgButtonView["inverted"] = "inverted";
  DtgButtonView["clear"] = "clear";
})(DtgButtonView || (DtgButtonView = {}));
var DtgButtonSize;
(function (DtgButtonSize) {
  DtgButtonSize["m"] = "m";
  DtgButtonSize["s"] = "s";
})(DtgButtonSize || (DtgButtonSize = {}));
var DtgButtonAlign;
(function (DtgButtonAlign) {
  DtgButtonAlign["left"] = "left";
  DtgButtonAlign["center"] = "center";
  DtgButtonAlign["right"] = "right";
})(DtgButtonAlign || (DtgButtonAlign = {}));
;// ./src/components/atoms/button/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const button_style_module = ({"dtg-button_view_regular":"lib_dtg-button_view_regular_RZ9Cq","dtg-button__icon":"lib_dtg-button__icon_LzVOT","dtg-button_view_inverted":"lib_dtg-button_view_inverted_RXa9K","dtg-button_view_clear":"lib_dtg-button_view_clear_dZk81","dtg-button_iconLeft":"lib_dtg-button_iconLeft_ehL_s","dtg-button__text":"lib_dtg-button__text_rgPpL","dtg-button__icon-wrapper":"lib_dtg-button__icon-wrapper_n6u9m","dtg-button_size_m":"lib_dtg-button_size_m_GL8Mt","dtg-button_size_s":"lib_dtg-button_size_s_IKDyy","dtg-button__inner":"lib_dtg-button__inner_DCiKd","dtg-button":"lib_dtg-button_XuQZx","dtg-button_fullwidth":"lib_dtg-button_fullwidth_EDU5G","dtg-button_align_center":"lib_dtg-button_align_center_Up6M2","dtg-button_align_left":"lib_dtg-button_align_left_b1dm2","dtg-button_align_right":"lib_dtg-button_align_right_RQy5n","dtg-button_disabled":"lib_dtg-button_disabled_yOd1L","dtg-button_noInteraction":"lib_dtg-button_noInteraction_sa9sc","dtg-button_icon":"lib_dtg-button_icon_YltoT","dtg-button__mark":"lib_dtg-button__mark_H1dS3","dtg-button_notice":"lib_dtg-button_notice_kFPQW","dtg-button_colorText":"lib_dtg-button_colorText_FxZcN","dtg-button_colorIcon":"lib_dtg-button_colorIcon_t6Zji"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/button/component.vue?vue&type=script&lang=ts









/* harmony default export */ const button_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(button_style_module),
  components: {
    DtgSpinner: spinner_component,
    DtgAction: action_component,
    DtgIcon: icon_component,
    DtgMark: mark_component
  },
  inheritAttrs: false,
  props: {
    view: {
      type: String,
      default: DtgButtonView.regular,
      validator: inRecord(DtgButtonView)
    },
    size: {
      type: String,
      default: DtgButtonSize.m,
      validator: inRecord(DtgButtonSize)
    },
    icon: {
      type: String,
      default: null,
      validator: inArray(iconNames)
    },
    iconLeft: {
      type: Boolean,
      default: false
    },
    noInteraction: {
      type: Boolean,
      default: false
    },
    marked: {
      type: Boolean,
      default: false
    },
    markView: {
      type: String,
      default: DtgMarkView.notice
    },
    notice: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    fullwidth: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: DtgButtonAlign.center,
      validator: inRecord(DtgButtonAlign)
    },
    colorText: {
      type: Boolean,
      default: false
    },
    colorIcon: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const mods = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        view,
        size,
        disabled,
        notice,
        icon,
        loading,
        iconLeft,
        noInteraction,
        fullwidth,
        align,
        colorText,
        colorIcon
      } = props;
      return {
        view,
        size,
        disabled,
        notice,
        icon: Boolean(icon ?? loading),
        iconLeft,
        noInteraction,
        fullwidth,
        align,
        colorText,
        colorIcon
      };
    });
    const disabledInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        noInteraction,
        disabled
      } = props;
      return noInteraction || disabled || null;
    });
    return {
      mods,
      disabledInternal,
      b: useBem(button_style_module)
    };
  }
}));
;// ./src/components/atoms/button/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/button/component.vue




;
const button_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(button_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_6735f70a_ts_true_render]])

/* harmony default export */ const button_component = (button_component_exports_);
;// ./src/components/atoms/button/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/card-base/component.vue?vue&type=template&id=31412564&ts=true

function componentvue_type_template_id_31412564_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("article", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2);
}
;// ./src/components/atoms/card-base/component.vue?vue&type=template&id=31412564&ts=true

;// ./src/components/atoms/card-base/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_base_style_module = ({"dtg-card-base":"lib_dtg-card-base_NEx6x"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/card-base/component.vue?vue&type=script&lang=ts



/* harmony default export */ const card_base_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_base_style_module),
  setup() {
    return {
      b: useBem(card_base_style_module)
    };
  }
}));
;// ./src/components/atoms/card-base/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/card-base/component.vue




;
const card_base_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_base_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_31412564_ts_true_render]])

/* harmony default export */ const card_base_component = (card_base_component_exports_);
;// ./src/components/atoms/card-base/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/card-divider/component.vue?vue&type=template&id=11f34235&ts=true

function componentvue_type_template_id_11f34235_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_divider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-divider");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_divider, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b()),
    view: "custom"
  }, null, 8, ["class"]);
}
;// ./src/components/atoms/card-divider/component.vue?vue&type=template&id=11f34235&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/divider/component.vue?vue&type=template&id=95f662be&ts=true

function componentvue_type_template_id_95f662be_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("hr", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      view: _ctx.view,
      inputAligned: _ctx.inputAligned
    }))
  }, null, 2);
}
;// ./src/components/atoms/divider/component.vue?vue&type=template&id=95f662be&ts=true

;// ./src/components/atoms/divider/types.ts
var DtgDividerView;
(function (DtgDividerView) {
  DtgDividerView["fullwidth"] = "fullwidth";
  DtgDividerView["long"] = "long";
  DtgDividerView["short"] = "short";
  DtgDividerView["custom"] = "custom";
  DtgDividerView["vertical"] = "vertical";
})(DtgDividerView || (DtgDividerView = {}));
;// ./src/components/atoms/divider/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const divider_style_module = ({"dtg-divider_view_fullwidth":"lib_dtg-divider_view_fullwidth_WA3Aj","dtg-divider_view_short":"lib_dtg-divider_view_short_x7oAA","dtg-divider_view_long":"lib_dtg-divider_view_long_zwfSD","dtg-divider_view_vertical":"lib_dtg-divider_view_vertical_ZkkHV","dtg-divider_inputAligned":"lib_dtg-divider_inputAligned_fzTk6"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/divider/component.vue?vue&type=script&lang=ts





/* harmony default export */ const divider_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(divider_style_module),
  props: {
    view: {
      type: String,
      default: DtgDividerView.long,
      validator: inRecord(DtgDividerView)
    },
    // Use to align vertically with inputs and buttons
    inputAligned: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      b: useBem(divider_style_module)
    };
  }
}));
;// ./src/components/atoms/divider/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/divider/component.vue




;
const divider_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(divider_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_95f662be_ts_true_render]])

/* harmony default export */ const divider_component = (divider_component_exports_);
;// ./src/components/atoms/divider/index.ts



;// ./src/components/atoms/card-divider/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_divider_style_module = ({"dtg-card-divider":"lib_dtg-card-divider_gFgpk"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/card-divider/component.vue?vue&type=script&lang=ts




/* harmony default export */ const card_divider_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_divider_style_module),
  components: {
    DtgDivider: divider_component
  },
  setup() {
    return {
      b: useBem(card_divider_style_module)
    };
  }
}));
;// ./src/components/atoms/card-divider/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/card-divider/component.vue




;
const card_divider_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_divider_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_11f34235_ts_true_render]])

/* harmony default export */ const card_divider_component = (card_divider_component_exports_);
;// ./src/components/atoms/card-divider/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/card-row/component.vue?vue&type=template&id=233b44a8&ts=true

function componentvue_type_template_id_233b44a8_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: _ctx.b()
  }, _ctx.splitAttrs.root), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
      class: _ctx.b('label', {
        fullwidth: _ctx.labelFullwidth
      })
    }, _ctx.labelProps), {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.icon ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
            key: 0,
            size: "auto"
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
              class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon', {
                view: _ctx.iconView
              })),
              name: _ctx.icon
            }, null, 8, ["class", "name"])]),
            _: 1
          })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label-text'))
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "label", {}, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 1)])]),
            _: 3
          }, 8, ["class"])]),
          _: 3
        })]),
        _: 3
      })]),
      _: 3
    }, 16, ["class"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content', {
        right: _ctx.contentRight
      }))
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
      _: 3
    }, 8, ["class"]), _ctx.$slots.actions || _ctx.$slots.action ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
      key: 0,
      size: "auto"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "actions"), _ctx.$slots.action ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
            key: 0
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "action")]),
            _: 3
          })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
          _: 3
        })]),
        _: 3
      })]),
      _: 3
    })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 3
  }, 16, ["class"]);
}
;// ./src/components/atoms/card-row/component.vue?vue&type=template&id=233b44a8&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/grid/col.vue?vue&type=template&id=333da886&ts=true

function colvue_type_template_id_333da886_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    ref: "root",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('col'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2);
}
;// ./src/components/atoms/grid/col.vue?vue&type=template&id=333da886&ts=true

// EXTERNAL MODULE: external "dtg-shared/utils/truthy"
var truthy_ = __webpack_require__(2160);
;// ./src/utils/reactive-media-query/index.ts
/*
 * Reactive matchMedia.
 *
 * Features:
 *  - Can be used in computed
 *  - Aliases for min-width/height, max-width/height and their combinations
 *  - `screen and` is added to each query automatically
 *
 * Usage:
 *  - matches(query)            - same as matchMedia(`screen and ${query}`)
 *  - from/till(width, height?) - same as matchMedia(`(min/max-width/height: ${width/height})`) accounting for -1px
 *  - between                   - same as from(widthFrom, heightFrom) && till(widthTill, heightTill)
 */


const queryStates = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)({});
function from(width, height, operator) {
  return getCachedQueryState(fromQuery(width, height, operator));
}
function till(width, height, operator) {
  return getCachedQueryState(tillQuery(width, height, operator));
}
function between(widthFrom, widthTill) {
  return getCachedQueryState(betweenQuery(widthFrom, widthTill));
}
function matches(query) {
  return getCachedQueryState(appendScreenQuery(query));
}
function fromQuery(width, height, operator = 'both') {
  return joinQuery(fromQueryParts(width, height), operator);
}
function tillQuery(width, height, operator = 'either') {
  return joinQuery(tillQueryParts(width, height), operator);
}
function betweenQuery(widthFrom, widthTill) {
  const [widthFromQuery] = fromQueryParts(widthFrom);
  const [widthTillQuery] = tillQueryParts(widthTill);
  return joinQuery([widthFromQuery, widthTillQuery], 'both');
}
function fromQueryParts(width, height) {
  const widthQuery = `(min-width: ${width}px)`;
  const heightQuery = height ? `(min-height: ${height}px)` : null;
  return [widthQuery, heightQuery];
}
function tillQueryParts(width, height) {
  const widthQuery = `(max-width: ${width - 1}px)`;
  const heightQuery = height ? `(max-height: ${height - 1}px)` : null;
  return [widthQuery, heightQuery];
}
function joinQuery(queries, operator) {
  return queries.filter(truthy_.truthy).map((query, index) => appendScreenQuery(query, index, operator)).join(` ${formatOperator(operator)} `);
}
function appendScreenQuery(query, index = 0, operator = 'both') {
  return operator === 'either' || index === 0 ? `screen and ${query}` : query;
}
function formatOperator(operator) {
  return operator === 'both' ? 'and' : ',';
}
function getCachedQueryState(query) {
  if (!(query in queryStates.value)) {
    setQueryState(query, initQueryState(query));
  }
  return getQueryState(query);
}
function initQueryState(query) {
  const queryObject = window.matchMedia(query);
  queryObject.addListener(() => {
    setQueryState(query, queryObject.matches);
  });
  return queryObject.matches;
}
function getQueryState(query) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return queryStates.value[query];
}
function setQueryState(query, value) {
  queryStates.value = {
    ...queryStates.value,
    [query]: value
  };
}

;// ./src/composables/use-bp/_bp.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const _bp = ({"xs":"0","sm":"576px","md":"768px","lg":"992px","xl":"1200px","xsHeight":"0","mdHeight":"600px","lgHeight":"768px"});
;// ./src/composables/use-bp/index.ts


const {
  xs,
  sm,
  md,
  lg,
  xl,
  xsHeight,
  mdHeight,
  lgHeight
} = parseBreakpoints(_bp);
const breakpointsWidthMap = {
  xs,
  sm,
  md,
  lg,
  xl
};
const breakpointsHeightMap = {
  xsHeight,
  mdHeight,
  lgHeight
};
const breakpointsWidth = Object.keys(breakpointsWidthMap);
const breakpointsHeight = Object.keys(breakpointsHeightMap);
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const list = {
  ...breakpointsWidthMap,
  ...breakpointsHeightMap
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useBp() {
  return {
    from: from,
    till: till,
    between: between,
    ...list
  };
}
function parseBreakpoints(breakpoints) {
  return Object.fromEntries(Object.entries(breakpoints).map(([key, value]) => {
    return [key, parseInt(value, 10)];
  }));
}
// EXTERNAL MODULE: external "dtg-shared/utils/object"
var object_ = __webpack_require__(7055);
// EXTERNAL MODULE: external "dtg-shared/utils/string"
var string_ = __webpack_require__(5933);
;// ./src/components/atoms/grid/utils.ts



const BREAKPOINTS = ['', ...breakpointsWidth];
const COLUMNS_TOTAL = 12;
const SIZE_PROPS = (0,object_.objFromEntries)(BREAKPOINTS.map(breakpoint => {
  // eslint-disable-next-line no-undefined
  return [getSizePropName(breakpoint), {
    type: [String, Number],
    default: undefined
  }];
}));
function getSizePropName(breakpoint) {
  return `size${(0,string_.capitalizeSentence)(breakpoint)}`;
}
;// ./src/components/atoms/grid/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const grid_style_module = ({"dtg-grid":"lib_dtg-grid_P5ojI","dtg-grid__row":"lib_dtg-grid__row_AMQil","dtg-grid__col":"lib_dtg-grid__col_L_Zgg","dtg-grid_padding_double":"lib_dtg-grid_padding_double_HX1kk","dtg-grid_outerPadding":"lib_dtg-grid_outerPadding_DFnnx","dtg-grid_padding_oneandhalf":"lib_dtg-grid_padding_oneandhalf_XBKpB","dtg-grid_padding_regular":"lib_dtg-grid_padding_regular_AXuNc","dtg-grid_padding_half":"lib_dtg-grid_padding_half_GPT5Z","dtg-grid_padding_quarter":"lib_dtg-grid_padding_quarter_ndQid","dtg-grid_padding_none":"lib_dtg-grid_padding_none_QAEJl"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/grid/col.vue?vue&type=script&lang=ts
/* eslint-disable @typescript-eslint/naming-convention */





/* harmony default export */ const colvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-col',
  props: {
    align: {
      type: String,
      default: null
    },
    ...SIZE_PROPS
  },
  setup(props) {
    const bp = useBp();
    const root = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const style = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
      'align-self': props.align,
      ...calculateSize()
    }));
    // Assign styles directly to the HTML element for better performance
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      if (!root.value) {
        return;
      }
      Object.assign(root.value.style, style.value);
    }, {
      flush: 'post'
    });
    function getColumns() {
      let matchedColumns = null;
      // Find the last matching breakpoint that has a size prop set for it
      for (const breakpoint of BREAKPOINTS) {
        const isMatching = breakpoint === '' ? true : bp.from(bp[breakpoint]);
        if (!isMatching) {
          continue;
        }
        const columns = props[getSizePropName(breakpoint)];
        const columnsString = typeof columns === 'number' ? String(columns) : columns;
        if (typeof columnsString !== 'undefined') {
          matchedColumns = columnsString;
        }
      }
      return matchedColumns;
    }
    function calculateSize() {
      const columns = getColumns();
      // If no size prop was set or if a size prop was set without a value
      // i.e. <dtg-col size-md> or <dtg-col>
      // then we clear all styles
      if (!columns) {
        return {
          'flex': null,
          'width': null,
          'max-width': null
        };
      }
      // If the size is set to auto then don't calculate it
      const colSize = columns === 'auto' ? 'auto' : `calc(calc(${columns} / ${COLUMNS_TOTAL}) * 100%)`;
      return {
        'flex': `0 0 ${colSize}`,
        'width': `${colSize}`,
        'max-width': `${colSize}`
      };
    }
    return {
      b: useBem(grid_style_module),
      root
    };
  }
}));
;// ./src/components/atoms/grid/col.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/grid/col.vue




;
const col_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(colvue_type_script_lang_ts, [['render',colvue_type_template_id_333da886_ts_true_render]])

/* harmony default export */ const col = (col_exports_);
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/grid/grid.vue?vue&type=template&id=8e279ca4&ts=true

function gridvue_type_template_id_8e279ca4_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      padding: _ctx.padding,
      outerPadding: _ctx.outerPadding
    })),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.inlineStyles)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 6);
}
;// ./src/components/atoms/grid/grid.vue?vue&type=template&id=8e279ca4&ts=true

;// ./src/components/atoms/grid/types.ts
var DtgGridPadding;
(function (DtgGridPadding) {
  DtgGridPadding["double"] = "double";
  DtgGridPadding["oneandhalf"] = "oneandhalf";
  DtgGridPadding["regular"] = "regular";
  DtgGridPadding["half"] = "half";
  DtgGridPadding["quarter"] = "quarter";
  DtgGridPadding["none"] = "none";
})(DtgGridPadding || (DtgGridPadding = {}));
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/grid/grid.vue?vue&type=script&lang=ts





/* harmony default export */ const gridvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(grid_style_module),
  props: {
    padding: {
      type: String,
      default: DtgGridPadding.regular,
      validator: inRecord(DtgGridPadding)
    },
    outerPadding: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const inlineStyles = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        align
      } = props;
      if (!align) {
        return {};
      }
      const [alignItems, justifyContent] = align.split(' ');
      return {
        alignItems,
        justifyContent
      };
    });
    return {
      b: useBem(grid_style_module),
      inlineStyles
    };
  }
}));
;// ./src/components/atoms/grid/grid.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/grid/grid.vue




;
const grid_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(gridvue_type_script_lang_ts, [['render',gridvue_type_template_id_8e279ca4_ts_true_render]])

/* harmony default export */ const grid = (grid_exports_);
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/grid/row.vue?vue&type=template&id=6c53286b&ts=true

function rowvue_type_template_id_6c53286b_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('row')),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.inlineStyles)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 6);
}
;// ./src/components/atoms/grid/row.vue?vue&type=template&id=6c53286b&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/grid/row.vue?vue&type=script&lang=ts



/* harmony default export */ const rowvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-row',
  props: {
    align: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const inlineStyles = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        align
      } = props;
      if (!align) {
        return {};
      }
      const [alignItems, justifyContent] = align.split(' ');
      return {
        alignItems,
        justifyContent
      };
    });
    return {
      b: useBem(grid_style_module),
      inlineStyles
    };
  }
}));
;// ./src/components/atoms/grid/row.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/grid/row.vue




;
const row_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(rowvue_type_script_lang_ts, [['render',rowvue_type_template_id_6c53286b_ts_true_render]])

/* harmony default export */ const row = (row_exports_);
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/grid/row-col.vue?vue&type=template&id=61b74841&ts=true

function row_colvue_type_template_id_61b74841_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.splitAttrs.root)), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)({
      ..._ctx.splitAttrs.attrs,
      ..._ctx.splitAttrs.listeners
    })), {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
      _: 3
    }, 16)]),
    _: 3
  }, 16);
}
;// ./src/components/atoms/grid/row-col.vue?vue&type=template&id=61b74841&ts=true

;// ./src/composables/use-split-attrs.ts

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useSplitAttrs(combinedAttrs) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    const {
      class: className,
      style,
      ...rest
    } = combinedAttrs;
    const {
      attrs,
      listeners
    } = Object.entries(rest).reduce(({
      attrs,
      listeners
    }, [key, value]) => {
      if (/^on/.exec(key)) {
        listeners[key] = value;
      } else {
        attrs[key] = value;
      }
      return {
        attrs,
        listeners
      };
    }, {
      attrs: {},
      listeners: {}
    });
    return {
      root: {
        class: className,
        style
      },
      attrs,
      listeners
    };
  });
}
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/grid/row-col.vue?vue&type=script&lang=ts



/* harmony default export */ const row_colvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-row-col',
  components: {
    DtgRow: row,
    DtgCol: col
  },
  inheritAttrs: false,
  setup(props, {
    attrs
  }) {
    const splitAttrs = useSplitAttrs(attrs);
    return {
      splitAttrs
    };
  }
}));
;// ./src/components/atoms/grid/row-col.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/grid/row-col.vue




;
const row_col_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(row_colvue_type_script_lang_ts, [['render',row_colvue_type_template_id_61b74841_ts_true_render]])

/* harmony default export */ const row_col = (row_col_exports_);
;// ./src/components/atoms/grid/index.ts






;// ./src/components/atoms/card-row/types.ts
var DtgCardRowIconView;
(function (DtgCardRowIconView) {
  DtgCardRowIconView["success"] = "success";
  DtgCardRowIconView["warning"] = "warning";
})(DtgCardRowIconView || (DtgCardRowIconView = {}));
;// ./src/components/atoms/card-row/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_row_style_module = ({"dtg-card-row":"lib_dtg-card-row_vJDKO","dtg-card-row__label":"lib_dtg-card-row__label_eNW1j","dtg-card-row__label_fullwidth":"lib_dtg-card-row__label_fullwidth_slL0N","dtg-card-row__label-text":"lib_dtg-card-row__label-text_sNqkX","dtg-card-row__content":"lib_dtg-card-row__content_t4nO8","dtg-card-row__content_right":"lib_dtg-card-row__content_right_kLQ18","dtg-card-row__icon_view_success":"lib_dtg-card-row__icon_view_success_vcvML","dtg-card-row__icon_view_warning":"lib_dtg-card-row__icon_view_warning_TK_RX"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/card-row/component.vue?vue&type=script&lang=ts









/* harmony default export */ const card_row_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_row_style_module),
  components: {
    DtgGrid: grid,
    DtgRow: row,
    DtgCol: col,
    DtgIcon: icon_component
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null
    },
    labelWide: {
      type: Boolean,
      default: false
    },
    contentRight: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null,
      validator: inArray(iconNames)
    },
    iconView: {
      type: String,
      default: DtgCardRowIconView.success,
      validator: inRecord(DtgCardRowIconView)
    }
  },
  setup(props, {
    attrs
  }) {
    const splitAttrs = useSplitAttrs(attrs);
    const bp = useBp();
    const labelFullwidth = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        labelWide
      } = props;
      return labelWide ? bp.till(bp.md) || bp.between(bp.lg, bp.xl) : bp.till(bp.sm);
    });
    const labelSize = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        labelWide
      } = props;
      switch (true) {
        case labelFullwidth.value:
          return 12;
        case labelWide:
          return 6;
        default:
          return 4.8;
      }
    });
    const labelProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const size = labelSize.value;
      return {
        size,
        ...splitAttrs.value.attrs
      };
    });
    return {
      b: useBem(card_row_style_module),
      splitAttrs,
      labelProps,
      labelFullwidth
    };
  }
}));
;// ./src/components/atoms/card-row/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/card-row/component.vue




;
const card_row_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_row_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_233b44a8_ts_true_render]])

/* harmony default export */ const card_row_component = (card_row_component_exports_);
;// ./src/components/atoms/card-row/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/card-section/component.vue?vue&type=template&id=6d8b83d4&ts=true

function componentvue_type_template_id_6d8b83d4_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      align: _ctx.align,
      noDivider: _ctx.noDivider
    }))
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    _: 3
  }, 8, ["class"]);
}
;// ./src/components/atoms/card-section/component.vue?vue&type=template&id=6d8b83d4&ts=true

;// ./src/components/atoms/card-section/types.ts
var DtgCardSectionAlign;
(function (DtgCardSectionAlign) {
  DtgCardSectionAlign["left"] = "left";
  DtgCardSectionAlign["center"] = "center";
  DtgCardSectionAlign["right"] = "right";
})(DtgCardSectionAlign || (DtgCardSectionAlign = {}));
;// ./src/components/atoms/card-section/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_section_style_module = ({"dtg-card-section":"lib_dtg-card-section_BU8J1","dtg-card-section_noDivider":"lib_dtg-card-section_noDivider_ldgME","dtg-card-section_align_left":"lib_dtg-card-section_align_left_DO8Sv","dtg-card-section_align_center":"lib_dtg-card-section_align_center_BdE8e","dtg-card-section_align_right":"lib_dtg-card-section_align_right_dM4Gt"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/card-section/component.vue?vue&type=script&lang=ts






/* harmony default export */ const card_section_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_section_style_module),
  components: {
    DtgCol: col
  },
  props: {
    noDivider: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: DtgCardSectionAlign.center,
      validator: inRecord(DtgCardSectionAlign)
    }
  },
  setup() {
    return {
      b: useBem(card_section_style_module)
    };
  }
}));
;// ./src/components/atoms/card-section/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/card-section/component.vue




;
const card_section_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_section_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_6d8b83d4_ts_true_render]])

/* harmony default export */ const card_section_component = (card_section_component_exports_);
;// ./src/components/atoms/card-section/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/card-title/component.vue?vue&type=template&id=60c3c536&ts=true

function componentvue_type_template_id_60c3c536_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row, {
    align: "center"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
        view: "3",
        "no-margin": ""
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
        _: 3
      })]),
      _: 3
    }), _ctx.$slots.action ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
      key: 0,
      size: "auto"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "action")]),
      _: 3
    })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 3
  });
}
;// ./src/components/atoms/card-title/component.vue?vue&type=template&id=60c3c536&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/title/component.vue?vue&type=template&id=2332a1af&ts=true

function componentvue_type_template_id_2332a1af_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDynamicComponent)(_ctx.tag), {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      view: _ctx.view,
      noMargin: _ctx.noMargin
    }))
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    _: 3
  }, 8, ["class"]);
}
;// ./src/components/atoms/title/component.vue?vue&type=template&id=2332a1af&ts=true

;// ./src/components/atoms/title/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const title_style_module = ({"dtg-title":"lib_dtg-title_Ze3bF","dtg-title_view_1":"lib_dtg-title_view_1_Dihe7","dtg-title_view_2":"lib_dtg-title_view_2_V1O_9","dtg-title_view_3":"lib_dtg-title_view_3_rDcP5","dtg-title_view_4":"lib_dtg-title_view_4_vf3Kd","dtg-title_view_5":"lib_dtg-title_view_5_H1uKq","dtg-title_noMargin":"lib_dtg-title_noMargin_w9Tks"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/title/component.vue?vue&type=script&lang=ts




const VIEWS = [1, 2, 3, 4, 5];
/* harmony default export */ const title_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(title_style_module),
  props: {
    view: {
      type: [String, Number],
      default: 1,
      validator: (0,prop_validator_.propValidator)(value => VIEWS.includes(parseInt(String(value), 10)), VIEWS)
    },
    noMargin: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const tag = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => `h${props.view}`);
    return {
      b: useBem(title_style_module),
      tag
    };
  }
}));
;// ./src/components/atoms/title/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/title/component.vue




;
const title_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(title_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_2332a1af_ts_true_render]])

/* harmony default export */ const title_component = (title_component_exports_);
;// ./src/components/atoms/title/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/card-title/component.vue?vue&type=script&lang=ts



/* harmony default export */ const card_title_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-card-title',
  components: {
    DtgRow: row,
    DtgCol: col,
    DtgTitle: title_component
  }
}));
;// ./src/components/atoms/card-title/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/card-title/component.vue




;
const card_title_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_title_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_60c3c536_ts_true_render]])

/* harmony default export */ const card_title_component = (card_title_component_exports_);
;// ./src/components/atoms/card-title/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/checkbox/component.vue?vue&type=template&id=2c42a24b&ts=true

function componentvue_type_template_id_2c42a24b_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_choice = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-choice");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_choice, {
    ref: "inputRef",
    modelValue: _ctx.modelValueInternal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
    disabled: _ctx.disabled,
    name: _ctx.name,
    type: "checkbox"
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
    _: 2
  }, [_ctx.$slots.default ? {
    name: "default",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    key: "0"
  } : undefined]), 1032, ["modelValue", "disabled", "name"]);
}
;// ./src/components/atoms/checkbox/component.vue?vue&type=template&id=2c42a24b&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/choice/component.vue?vue&type=template&id=ab95f614&ts=true

const componentvue_type_template_id_ab95f614_ts_true_hoisted_1 = ["type", "name", "value", "disabled"];
function componentvue_type_template_id_ab95f614_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: _ctx.b({
      type: _ctx.type,
      disabled: _ctx.disabled,
      focusVisible: _ctx.focusVisible
    })
  }, _ctx.splitAttrs.root), [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('inner'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    ref: "inputRef",
    class: _ctx.b('input'),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
    type: _ctx.type,
    name: _ctx.name,
    value: _ctx.value,
    disabled: _ctx.disabled
  }, {
    ..._ctx.splitAttrs.attrs,
    ..._ctx.splitAttrs.listeners
  }), null, 16, componentvue_type_template_id_ab95f614_ts_true_hoisted_1), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vModelDynamic, _ctx.modelValueInternal]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('view'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('mark'))
  }, null, 2)], 2), _ctx.$slots.default ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)], 16);
}
;// ./src/components/atoms/choice/component.vue?vue&type=template&id=ab95f614&ts=true

// EXTERNAL MODULE: external "dtg-shared/utils/double-raf"
var double_raf_ = __webpack_require__(4949);
// EXTERNAL MODULE: external "dtg-shared/utils/get-element-from-ref"
var get_element_from_ref_ = __webpack_require__(9848);
;// ./src/composables/use-focus.ts



/*
 * Used to add focus/blur methods to a component that wraps an HTMLInputElement,
 * as well as lets the component monitor its focused state.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useFocus(elementRef, {
  autoFocus = false,
  selectOnFocus = false,
  clickToFocus = true
} = {}) {
  const focused = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
  // Set to true when element is focused using the focus function exported from this composable
  // Needed to force focused state for elements for which :focus-visible doesn't apply (like checkboxes)
  const focusVisible = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
  const elementRefInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => (0,get_element_from_ref_.getElementFromRef)(elementRef.value));
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
    const element = elementRefInternal.value;
    if (element) {
      addEventListeners(element);
      if (autoFocus) {
        void (0,double_raf_.doubleRAF)().then(focus);
      }
    }
  });
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onUnmounted)(() => {
    const element = elementRefInternal.value;
    if (element) {
      removeEventListeners(element);
    }
  });
  // Won't work without user action
  function focus() {
    const element = elementRefInternal.value;
    if (!element) {
      return;
    }
    const {
      selectionStart,
      selectionEnd
    } = element;
    element.focus();
    focusVisible.value = true;
    if (checkIfNeedClickEvent(element) && clickToFocus) {
      element.click();
      void (0,double_raf_.doubleRAF)().then(() => {
        try {
          element.selectionStart = selectionStart ?? 0;
          element.selectionEnd = selectionEnd ?? selectionStart ?? 0;
        } catch {
          // Some input types don't allow setting selection
        }
      });
    }
  }
  function blur() {
    elementRefInternal.value?.blur();
    focusVisible.value = false;
  }
  function onFocus(event) {
    event.stopPropagation();
    focused.value = true;
    if (selectOnFocus) {
      elementRefInternal.value?.select();
    }
  }
  function onBlur(event) {
    event.stopPropagation();
    focused.value = false;
    focusVisible.value = false;
  }
  function addEventListeners(element) {
    const needClickEvent = checkIfNeedClickEvent(element) && clickToFocus;
    if (needClickEvent) {
      element.addEventListener('click', onFocus, false);
    }
    element.addEventListener('focus', onFocus, false);
    element.addEventListener('blur', onBlur, false);
  }
  function removeEventListeners(element) {
    element.removeEventListener('click', onFocus);
    element.removeEventListener('focus', onFocus);
    element.removeEventListener('blur', onBlur);
  }
  return {
    focused: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.readonly)(focused),
    focusVisible: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.readonly)(focusVisible),
    focus,
    blur
  };
}
/*
 * Used to add focus and blur methods to components that wrap the components
 * with those methods defined by the composable above.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useFocusPropagation(inputRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)()) {
  function focus() {
    const {
      value
    } = inputRef;
    if (Array.isArray(value)) {
      const [el] = value;
      el?.focus?.();
    } else if (value) {
      value.focus?.();
    }
  }
  function blur() {
    const {
      value
    } = inputRef;
    if (Array.isArray(value)) {
      const [el] = value;
      el?.blur?.();
    } else if (value) {
      value.blur?.();
    }
  }
  return {
    inputRef,
    focus,
    blur
  };
}
// blur event doesn't work on these types of input,
// so we can't set focused on click
const inputTypesWithoutClickEvent = ['checkbox', 'radio'];
function checkIfNeedClickEvent(element) {
  const tag = element.tagName.toLowerCase();
  const type = element.getAttribute('type');
  return tag !== 'input' || !type || !inputTypesWithoutClickEvent.includes(type);
}
// EXTERNAL MODULE: external "lodash/isEqual"
var isEqual_ = __webpack_require__(2162);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual_);
;// ./src/utils/prop-internal.ts


/**
 * Returns a settable computed with the value of props[key].
 * Use for working with v-model props.
 *
 * @example
 * const modelValueInternal = propInternal(props, 'modelValue', emit);
 */
function propInternal(props, key, emit, equalityCheck = (isEqual_default())) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
    get: () => props[key],
    set: value => {
      if (!equalityCheck(value, props[key])) {
        emit(`update:${key}`, value);
      }
    }
  });
}
;// ./src/components/atoms/choice/types.ts
var DtgChoiceType;
(function (DtgChoiceType) {
  DtgChoiceType["checkbox"] = "checkbox";
  DtgChoiceType["radio"] = "radio";
})(DtgChoiceType || (DtgChoiceType = {}));
;// ./src/components/atoms/choice/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const choice_style_module = ({"dtg-choice_type_checkbox":"lib_dtg-choice_type_checkbox_H9wb1","dtg-choice__view":"lib_dtg-choice__view_HkptB","dtg-choice_type_radio":"lib_dtg-choice_type_radio_Lyoq9","dtg-choice__mark":"lib_dtg-choice__mark_oTOxJ","dtg-choice__inner":"lib_dtg-choice__inner_bM3VI","dtg-choice":"lib_dtg-choice_L83dl","dtg-choice_disabled":"lib_dtg-choice_disabled_c4Vlh","dtg-choice__input":"lib_dtg-choice__input_Ng_aS","dtg-choice_focusVisible":"lib_dtg-choice_focusVisible_CJqfg","dtg-choice__label":"lib_dtg-choice__label_u9Ade"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/choice/component.vue?vue&type=script&lang=ts








/* harmony default export */ const choice_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(choice_style_module),
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      required: true,
      validator: inRecord(DtgChoiceType)
    },
    modelValue: {
      type: [String, Number, Boolean, Array, Object],
      default: null
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: null
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'focus', 'blur'],
  setup(props, {
    attrs,
    emit
  }) {
    const inputRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const {
      focusVisible,
      focus,
      blur
    } = useFocus(inputRef);
    const splitAttrs = useSplitAttrs(attrs);
    const modelValueInternal = propInternal(props, 'modelValue', emit);
    return {
      b: useBem(choice_style_module),
      inputRef,
      splitAttrs,
      modelValueInternal,
      focusVisible,
      /** @public */
      focus,
      /** @public */
      blur
    };
  }
}));
;// ./src/components/atoms/choice/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/choice/component.vue




;
const choice_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(choice_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_ab95f614_ts_true_render]])

/* harmony default export */ const choice_component = (choice_component_exports_);
;// ./src/components/atoms/choice/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/checkbox/component.vue?vue&type=script&lang=ts



/* harmony default export */ const checkbox_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-checkbox',
  components: {
    DtgChoice: choice_component
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: null
    },
    modelValue: {
      type: [Array, Boolean],
      default: false
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const modelValueInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
      get: getIsChecked,
      set: checked => {
        emit('update:modelValue', getUpdatedValue(checked));
      }
    });
    function getIsChecked() {
      const {
        modelValue,
        value
      } = props;
      return Array.isArray(modelValue) ? modelValue.includes(value) : modelValue;
    }
    function getUpdatedValue(checked) {
      const {
        modelValue,
        value
      } = props;
      if (Array.isArray(modelValue)) {
        const newModelValue = modelValue.filter(otherValue => otherValue !== value);
        return checked ? [...newModelValue, value] : newModelValue;
      }
      return checked;
    }
    return {
      modelValueInternal,
      ...useFocusPropagation()
    };
  }
}));
;// ./src/components/atoms/checkbox/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/checkbox/component.vue




;
const checkbox_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(checkbox_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_2c42a24b_ts_true_render]])

/* harmony default export */ const checkbox_component = (checkbox_component_exports_);
;// ./src/components/atoms/checkbox/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/checkbox-group/component.vue?vue&type=template&id=1a01bed2&ts=true

function componentvue_type_template_id_1a01bed2_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_checkbox = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-checkbox");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_grid, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.splitAttrs.root, {
    align: "flex-start center"
  }), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.optionsInternal, option => {
        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
          key: option.id,
          size: _ctx.size
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_checkbox, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
            ref_for: true,
            ref: _ctx.setRef,
            class: option.cssClass ?? null
          }, {
            ..._ctx.splitAttrs.attrs,
            ..._ctx.splitAttrs.listeners
          }, {
            modelValue: _ctx.modelValueInternal,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
            name: _ctx.name,
            value: option.id,
            disabled: option.disabled
          }), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(option.value), 1)]),
            _: 2
          }, 1040, ["class", "modelValue", "name", "value", "disabled"])]),
          _: 2
        }, 1032, ["size"]);
      }), 128))]),
      _: 1
    })]),
    _: 1
  }, 16);
}
;// ./src/components/atoms/checkbox-group/component.vue?vue&type=template&id=1a01bed2&ts=true

;// ./src/composables/use-template-refs-array.ts

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useTemplateRefsArray() {
  const refs = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
  function setRef(el) {
    if (el) {
      refs.value.push(el);
    }
  }
  function setRefByIndex(index) {
    return function setRefByIndexInner(el) {
      if (el) {
        refs.value[index] = el;
      }
    };
  }
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeUpdate)(() => {
    refs.value = [];
  });
  return {
    refs: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.shallowReadonly)(refs),
    setRef,
    setRefByIndex
  };
}
;// ./src/components/atoms/checkbox-group/types.ts
var DtgCheckboxGroupView;
(function (DtgCheckboxGroupView) {
  DtgCheckboxGroupView["inline"] = "inline";
  DtgCheckboxGroupView["multiline"] = "multiline";
})(DtgCheckboxGroupView || (DtgCheckboxGroupView = {}));
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/checkbox-group/component.vue?vue&type=script&lang=ts









/* harmony default export */ const checkbox_group_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-checkbox-group',
  components: {
    DtgGrid: grid,
    DtgRow: row,
    DtgCol: col,
    DtgCheckbox: checkbox_component
  },
  inheritAttrs: false,
  props: {
    view: {
      type: String,
      default: DtgCheckboxGroupView.inline,
      validator: inRecord(DtgCheckboxGroupView)
    },
    modelValue: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    trackByValue: {
      type: Boolean,
      default: false
    },
    object: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: Infinity
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    attrs,
    emit
  }) {
    const {
      refs,
      setRef
    } = useTemplateRefsArray();
    const splitAttrs = useSplitAttrs(attrs);
    const size = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.view === DtgCheckboxGroupView.inline ? 'auto' : 12;
    });
    const modelValueInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
      get: getCurrentModelValue,
      set: value => {
        emit('update:modelValue', getUpdatedModelValue(value));
      }
    });
    const optionsInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.options.map(option => {
        const id = getValue(option);
        const isOptionSelected = modelValueInternal.value.includes(id);
        const maxReached = modelValueInternal.value.length >= props.max;
        const disabled = option.disabled || props.disabled || maxReached && !isOptionSelected;
        return {
          ...option,
          id,
          disabled
        };
      });
    });
    function getCurrentModelValue() {
      const {
        modelValue
      } = props;
      return modelValue.map(value => {
        return typeof value === 'object' ? getValue(value) : value;
      });
    }
    function getUpdatedModelValue(selectedOptions) {
      const {
        options,
        object
      } = props;
      if (!object) {
        return selectedOptions;
      }
      return selectedOptions.map(option => {
        return options.find(otherOption => getValue(otherOption) === option);
      }).filter(truthy_.truthy);
    }
    function getValue(option) {
      return props.trackByValue ? option.value : option.id;
    }
    return {
      setRef,
      splitAttrs,
      modelValueInternal,
      size,
      optionsInternal,
      ...useFocusPropagation(refs)
    };
  }
}));
;// ./src/components/atoms/checkbox-group/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/checkbox-group/component.vue




;
const checkbox_group_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(checkbox_group_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_1a01bed2_ts_true_render]])

/* harmony default export */ const checkbox_group_component = (checkbox_group_component_exports_);
;// ./src/components/atoms/checkbox-group/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/content/component.vue?vue&type=template&id=2f52d627&ts=true

function componentvue_type_template_id_2f52d627_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("main", {
    ref: "scrollable",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([_ctx.b('scroll'), _ctx.scrollableClass])
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)], 2);
}
;// ./src/components/atoms/content/component.vue?vue&type=template&id=2f52d627&ts=true

// EXTERNAL MODULE: external "dtg-shared/composables/use-injected-state"
var use_injected_state_ = __webpack_require__(535);
// EXTERNAL MODULE: external "dtg-shared/utils/scroll"
var scroll_ = __webpack_require__(3021);
;// ./src/composables/use-scroll.ts




const rootState = {
  scrollRef: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null),
  scrollTop: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(0)
};
const {
  provideState,
  useState
} = (0,use_injected_state_.createInjectedState)('scrollState');
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useScroll() {
  const {
    scrollRef,
    scrollTop
  } = useState(rootState);
  function setScrollInternal(options) {
    (0,scroll_.setScroll)(scrollRef.value, options);
  }
  function scrollToInternal(options) {
    (0,scroll_.scrollTo)(scrollRef.value, options);
  }
  function scrollByInternal(options) {
    (0,scroll_.scrollBy)(scrollRef.value, options);
  }
  function scrollToTop() {
    scrollToInternal({
      top: 0
    });
  }
  function scrollToBottom() {
    scrollToInternal({
      left: 0
    });
  }
  return {
    scrollTop: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.readonly)(scrollTop),
    scrollEl: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => (0,get_element_from_ref_.getElementFromRef)(scrollRef.value)),
    scrollToTop,
    scrollToBottom,
    setScroll: setScrollInternal,
    scrollTo: scrollToInternal,
    scrollBy: scrollByInternal
  };
}
function provideScroll(scrollRef, isRoot = false) {
  const scrollTop = isRoot ? rootState.scrollTop : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(0);
  provideState({
    scrollTop,
    scrollRef
  });
  watchScroll();
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onActivated)(() => {
    watchScroll();
  });
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onDeactivated)(() => {
    unwatchScroll();
  });
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeUnmount)(() => {
    unwatchScroll();
  });
  function watchScroll() {
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(scrollRef, scrollRef => {
      const scrollEl = (0,get_element_from_ref_.getElementFromRef)(scrollRef);
      if (!scrollEl) {
        return;
      }
      if (isRoot) {
        rootState.scrollRef.value = scrollEl;
      }
      scrollEl.addEventListener('scroll', onScroll);
      onScroll();
    }, {
      flush: 'post',
      immediate: true
    });
  }
  function unwatchScroll() {
    if (isRoot && rootState.scrollRef.value === scrollRef.value) {
      rootState.scrollRef.value = null;
    }
    const scrollEl = (0,get_element_from_ref_.getElementFromRef)(scrollRef.value);
    if (scrollEl) {
      scrollEl.removeEventListener('scroll', onScroll);
    }
  }
  function onScroll() {
    const scrollEl = (0,get_element_from_ref_.getElementFromRef)(scrollRef.value);
    if (scrollEl) {
      scrollTop.value = scrollEl.scrollTop;
    }
  }
}
;// ./src/components/atoms/content/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const content_style_module = ({"dtg-content":"lib_dtg-content_TGDox","dtg-content__scroll":"lib_dtg-content__scroll_rwzlp"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/content/component.vue?vue&type=script&lang=ts




/* harmony default export */ const content_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(content_style_module),
  props: {
    root: {
      type: Boolean,
      default: false
    },
    scrollableClass: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const scrollable = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    provideScroll(scrollable, props.root);
    return {
      b: useBem(content_style_module),
      scrollable
    };
  }
}));
;// ./src/components/atoms/content/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/content/component.vue




;
const content_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(content_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_2f52d627_ts_true_render]])

/* harmony default export */ const content_component = (content_component_exports_);
;// ./src/components/atoms/content/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/counter/component.vue?vue&type=template&id=9a6f62ec&ts=true

function componentvue_type_template_id_9a6f62ec_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('counter'))
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.counter), 3)], 2);
}
;// ./src/components/atoms/counter/component.vue?vue&type=template&id=9a6f62ec&ts=true

;// ./src/components/atoms/counter/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const counter_style_module = ({"dtg-counter":"lib_dtg-counter_eR7vc","dtg-counter__counter":"lib_dtg-counter__counter_BhNfR"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/counter/component.vue?vue&type=script&lang=ts



/* harmony default export */ const counter_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(counter_style_module),
  props: {
    counter: {
      type: Number,
      required: true
    }
  },
  setup() {
    return {
      b: useBem(counter_style_module)
    };
  }
}));
;// ./src/components/atoms/counter/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/counter/component.vue




;
const counter_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(counter_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_9a6f62ec_ts_true_render]])

/* harmony default export */ const counter_component = (counter_component_exports_);
;// ./src/components/atoms/counter/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker/component.vue?vue&type=template&id=a1192c2a&ts=true

function componentvue_type_template_id_a1192c2a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_datepicker_year = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-datepicker-year");
  const _component_dtg_datepicker_month = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-datepicker-month");
  const _component_dtg_datepicker_day = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-datepicker-day");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [_ctx.isShown('year') ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_datepicker_year, {
    key: 0,
    pageDate: _ctx.pageDate,
    "onUpdate:pageDate": _cache[0] || (_cache[0] = $event => _ctx.pageDate = $event),
    selected: _ctx.selectedDate,
    "clear-disabled": _ctx.clearDisabled,
    "extra-action": _ctx.extraAction,
    "confirm-text": _ctx.confirmText,
    "hide-selection": _ctx.shouldHideSelected('year'),
    onSelect: _cache[1] || (_cache[1] = $event => _ctx.onYear($event)),
    onClear: _cache[2] || (_cache[2] = $event => _ctx.onClear()),
    onToday: _cache[3] || (_cache[3] = $event => _ctx.onToday()),
    onConfirm: _cache[4] || (_cache[4] = $event => _ctx.onConfirm())
  }, null, 8, ["pageDate", "selected", "clear-disabled", "extra-action", "confirm-text", "hide-selection"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.isShown('month') ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_datepicker_month, {
    key: 1,
    pageDate: _ctx.pageDate,
    "onUpdate:pageDate": _cache[5] || (_cache[5] = $event => _ctx.pageDate = $event),
    selected: _ctx.selectedDate,
    format: _ctx.monthListFormat,
    "clear-disabled": _ctx.clearDisabled,
    "extra-action": _ctx.extraAction,
    "confirm-text": _ctx.confirmText,
    "hide-selection": _ctx.shouldHideSelected('month'),
    onSelect: _cache[6] || (_cache[6] = $event => _ctx.onMonth($event)),
    onBack: _cache[7] || (_cache[7] = $event => _ctx.onBack('month')),
    onClear: _cache[8] || (_cache[8] = $event => _ctx.onClear()),
    onToday: _cache[9] || (_cache[9] = $event => _ctx.onToday()),
    onConfirm: _cache[10] || (_cache[10] = $event => _ctx.onConfirm())
  }, null, 8, ["pageDate", "selected", "format", "clear-disabled", "extra-action", "confirm-text", "hide-selection"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.isShown('day') ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_datepicker_day, {
    key: 2,
    pageDate: _ctx.pageDate,
    "onUpdate:pageDate": _cache[11] || (_cache[11] = $event => _ctx.pageDate = $event),
    selected: _ctx.selectedDate,
    "weekday-format": _ctx.weekdayFormat,
    "clear-disabled": _ctx.clearDisabled,
    "extra-action": _ctx.extraAction,
    "confirm-text": _ctx.confirmText,
    "hide-selection": _ctx.shouldHideSelected('day'),
    onSelect: _cache[12] || (_cache[12] = $event => _ctx.onDay($event)),
    onBack: _cache[13] || (_cache[13] = $event => _ctx.onBack('day')),
    onClear: _cache[14] || (_cache[14] = $event => _ctx.onClear()),
    onToday: _cache[15] || (_cache[15] = $event => _ctx.onToday()),
    onConfirm: _cache[16] || (_cache[16] = $event => _ctx.onConfirm())
  }, null, 8, ["pageDate", "selected", "weekday-format", "clear-disabled", "extra-action", "confirm-text", "hide-selection"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]);
}
;// ./src/components/atoms/datepicker/component.vue?vue&type=template&id=a1192c2a&ts=true

// EXTERNAL MODULE: external "dtg-shared/utils/date"
var date_ = __webpack_require__(9488);
// EXTERNAL MODULE: external "dtg-shared/utils/refs"
var refs_ = __webpack_require__(7614);
// EXTERNAL MODULE: external "dtg-shared/utils/array"
var array_ = __webpack_require__(7749);
;// ./src/components/atoms/datepicker/composables/use-partial-dates.ts




// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function usePartialDates({
  currentView,
  selectedDate,
  pageDate,
  allowSelectOn,
  selectionVisibilityLimit
}) {
  const props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    const today = (0,date_.createUtcDate)();
    const isTodaySelectedAndVisible = currentView.value === 'day' && today.isSame(selectedDate.value, 'day') && today.isSame(pageDate.value, 'month');
    if (isAllowedToSelectOnly('day')) {
      return isTodaySelectedAndVisible ? {
        action: 'confirm',
        label: '',
        date: null
      } : {
        action: 'today',
        label: '',
        date: null
      };
    }
    const props = calculateProps();
    if (!props) {
      return null;
    }
    const [selectedView, date, format] = props;
    return {
      action: 'confirm',
      date: {
        unit: selectedView,
        date
      },
      label: date.format(format)
    };
  });
  const extraAction = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.value?.action ?? null);
  const confirmText = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ['Confirmé', props.value?.label].filter(truthy_.truthy).join(' '));
  const partialDate = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return props.value?.date ?? null;
  });
  // Show confirmation button for selected day, month or year for the current view or above,
  // depending on which parts of the date can be or are selected
  // For days we can show `Confirm 1 may 2000`, `Confirm may 2000`, `Confirm 2000` or nothing
  // For month `Confirm may 2000`, `Confirm 2000` or nothing
  // For year `Confirm 2000` or nothing
  // eslint-disable-next-line complexity
  function calculateProps() {
    const view = currentView.value;
    const visibleDate = selectedDate.value ?? pageDate.value;
    switch (true) {
      case view === 'year' && !shouldHideSelected('year') && isAllowedToSelect('year') && isSelectedDateVisibleInDecade():
        return ['year', visibleDate, 'YYYY'];
      case view === 'month' && !shouldHideSelected('month') && isAllowedToSelect('month') && isSelectedDateVisibleIn('year'):
        return ['month', visibleDate, 'MMM YYYY'];
      case view === 'day' && !shouldHideSelected('day') && isAllowedToSelect('day') && isSelectedDateVisibleIn('month'):
        return ['day', visibleDate, 'DD MMM YYYY'];
      case view === 'day' && isAllowedToSelect('month'):
        return ['month', pageDate.value, 'MMM YYYY'];
      case ['day', 'month'].includes(view) && isAllowedToSelect('year'):
        return ['year', pageDate.value, 'YYYY'];
      default:
        return null;
    }
  }
  function isAllowedToSelect(view) {
    return allowSelectOn.value.some(option => (0,array_.arrayify)(view).includes(option));
  }
  function isAllowedToSelectOnly(view) {
    return allowSelectOn.value.every(option => option === view);
  }
  function isSelectedDateVisibleIn(unit) {
    return (0,truthy_.truthy)(selectedDate.value) && pageDate.value.isSame(selectedDate.value, unit);
  }
  function isSelectedDateVisibleInDecade() {
    return (0,truthy_.truthy)(selectedDate.value) && (0,date_.isSameDecade)(selectedDate.value, pageDate.value);
  }
  function shouldHideSelected(view) {
    switch (selectionVisibilityLimit.value) {
      case 'month':
        return view === 'day';
      case 'year':
        return ['day', 'month'].includes(view);
      default:
        return false;
    }
  }
  return {
    partialDate,
    extraAction,
    confirmText,
    isAllowedToSelect,
    shouldHideSelected
  };
}
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker/elems/datepicker-day/component.vue?vue&type=template&id=66545af1&ts=true

function componentvue_type_template_id_66545af1_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_datepicker_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-datepicker-base");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_datepicker_base, {
    items: _ctx.days,
    "heading-clickable": "",
    onLeft: _cache[0] || (_cache[0] = $event => _ctx.onPrevClick()),
    onRight: _cache[1] || (_cache[1] = $event => _ctx.onNextClick()),
    onHeading: _cache[2] || (_cache[2] = $event => _ctx.onHeadingClick()),
    onItemClick: _cache[3] || (_cache[3] = $event => _ctx.onItemClick($event))
  }, {
    heading: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.heading), 1)]),
    subheading: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.weekDays, day => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
        key: day
      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(day), 1);
    }), 128))]),
    _: 1
  }, 8, ["items"]);
}
;// ./src/components/atoms/datepicker/elems/datepicker-day/component.vue?vue&type=template&id=66545af1&ts=true

// EXTERNAL MODULE: external "dayjs"
var external_dayjs_ = __webpack_require__(9185);
var external_dayjs_default = /*#__PURE__*/__webpack_require__.n(external_dayjs_);
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker/elems/datepicker-base/component.vue?vue&type=template&id=4fe71754&ts=true

const componentvue_type_template_id_4fe71754_ts_true_hoisted_1 = {
  key: 2
};
function componentvue_type_template_id_4fe71754_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  const _component_dtg_divider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-divider");
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b()),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.rootStyle)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('heading'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_action, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('heading-button')),
    disabled: _ctx.leftDisabled,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onLeftClick())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('heading-icon', {
        left: true
      })),
      name: "chevron"
    }, null, 8, ["class"])]),
    _: 1
  }, 8, ["class", "disabled"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_action, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('heading-center')),
    disabled: !_ctx.headingClickable,
    onClick: _cache[1] || (_cache[1] = $event => _ctx.onHeadingClick())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "heading")]),
    _: 3
  }, 8, ["class", "disabled"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_action, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('heading-button')),
    disabled: _ctx.rightDisabled,
    onClick: _cache[2] || (_cache[2] = $event => _ctx.onRightClick())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('heading-icon', {
        right: true
      })),
      name: "chevron"
    }, null, 8, ["class"])]),
    _: 1
  }, 8, ["class", "disabled"])], 2), _ctx.$slots.subheading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 0
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('subheading'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "subheading")], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_divider, {
    view: "fullwidth"
  })], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('items'))
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.items, item => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, {
      key: item.key,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('item', {
        selected: item.selected && !_ctx.hideSelection
      })),
      disabled: item.disabled,
      onClick: $event => _ctx.onItemClick(item.value)
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('item-text'))
      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.display), 3)]),
      _: 2
    }, 1032, ["class", "disabled", "onClick"]);
  }), 128))], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('footer'))
  }, [_ctx.extraAction === 'confirm' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_button, {
    key: 0,
    size: "s",
    icon: "checkmark",
    "icon-left": "",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.onConfirmClick())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.confirmText ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: 0
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.confirmText), 1)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 1
  })) : _ctx.extraAction === 'today' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_button, {
    key: 1,
    size: "s",
    icon: "calendar",
    "icon-left": "",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.onTodayClick())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Aujourd'hui ")]),
    _: 1
  })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", componentvue_type_template_id_4fe71754_ts_true_hoisted_1)), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
    disabled: _ctx.clearDisabled,
    size: "s",
    icon: "trash",
    notice: "",
    onClick: _cache[5] || (_cache[5] = $event => _ctx.onClearClick())
  }, null, 8, ["disabled"])], 2)], 6);
}
;// ./src/components/atoms/datepicker/elems/datepicker-base/component.vue?vue&type=template&id=4fe71754&ts=true

;// ./src/components/atoms/datepicker/elems/datepicker-base/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const datepicker_base_style_module = ({"dtg-datepicker-base":"lib_dtg-datepicker-base_CAEA2","dtg-datepicker-base__heading":"lib_dtg-datepicker-base__heading__EdLa","dtg-datepicker-base__heading-center":"lib_dtg-datepicker-base__heading-center_OHxHr","dtg-datepicker-base__heading-button":"lib_dtg-datepicker-base__heading-button_haiCl","dtg-datepicker-base__heading-icon":"lib_dtg-datepicker-base__heading-icon_ZMU2U","dtg-datepicker-base__heading-icon_left":"lib_dtg-datepicker-base__heading-icon_left_L3A9_","dtg-datepicker-base__heading-icon_right":"lib_dtg-datepicker-base__heading-icon_right_cjXSP","dtg-datepicker-base__subheading":"lib_dtg-datepicker-base__subheading_IW1na","dtg-datepicker-base__items":"lib_dtg-datepicker-base__items_V9hcv","dtg-datepicker-base__divider":"lib_dtg-datepicker-base__divider_K3iXk","dtg-datepicker-base__item":"lib_dtg-datepicker-base__item_aFXYZ","dtg-datepicker-base__item-text":"lib_dtg-datepicker-base__item-text_ez5Fa","dtg-datepicker-base__item_selected":"lib_dtg-datepicker-base__item_selected_t2ogP","dtg-datepicker-base__footer":"lib_dtg-datepicker-base__footer_awVkS"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker/elems/datepicker-base/component.vue?vue&type=script&lang=ts







/* harmony default export */ const datepicker_base_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(datepicker_base_style_module),
  components: {
    DtgAction: action_component,
    DtgIcon: icon_component,
    DtgDivider: divider_component,
    DtgButton: button_component
  },
  props: {
    headingClickable: {
      type: Boolean,
      default: false
    },
    leftDisabled: {
      type: Boolean,
      default: false
    },
    rightDisabled: {
      type: Boolean,
      default: false
    },
    columnCount: {
      type: Number,
      default: 7
    },
    items: {
      type: Array,
      required: true
    },
    clearDisabled: {
      type: Boolean,
      default: false
    },
    extraAction: {
      type: String,
      default: null
    },
    confirmText: {
      type: String,
      default: null
    },
    hideSelection: {
      type: Boolean,
      default: false
    }
  },
  emits: ['itemClick', 'left', 'right', 'heading', 'clear', 'today', 'confirm'],
  setup(props, {
    emit
  }) {
    const rootStyle = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        columnCount
      } = props;
      return {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '--dtg-datepicker-column-definition': `repeat(${columnCount}, 1fr)`
      };
    });
    function onLeftClick() {
      emit('left');
    }
    function onRightClick() {
      emit('right');
    }
    function onHeadingClick() {
      emit('heading');
    }
    function onItemClick(date) {
      emit('itemClick', date);
    }
    function onClearClick() {
      emit('clear');
    }
    function onTodayClick() {
      emit('today');
    }
    function onConfirmClick() {
      emit('confirm');
    }
    return {
      b: useBem(datepicker_base_style_module),
      rootStyle,
      onLeftClick,
      onRightClick,
      onHeadingClick,
      onItemClick,
      onClearClick,
      onTodayClick,
      onConfirmClick
    };
  }
}));
;// ./src/components/atoms/datepicker/elems/datepicker-base/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/datepicker/elems/datepicker-base/component.vue




;
const datepicker_base_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(datepicker_base_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_4fe71754_ts_true_render]])

/* harmony default export */ const datepicker_base_component = (datepicker_base_component_exports_);
;// ./src/components/atoms/datepicker/elems/datepicker-base/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker/elems/datepicker-day/component.vue?vue&type=script&lang=ts






/* harmony default export */ const datepicker_day_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-datepicker-day',
  components: {
    DtgDatepickerBase: datepicker_base_component
  },
  props: {
    selected: {
      type: Object,
      default: null
    },
    pageDate: {
      type: Object,
      required: true
    },
    format: {
      type: String,
      required: false,
      default: 'D'
    },
    headingFormat: {
      type: String,
      required: false,
      default: 'MMMM YYYY'
    },
    weekdayFormat: {
      type: String,
      required: false,
      default: 'dd'
    }
  },
  emits: ['update:pageDate', 'select', 'back'],
  setup(props, {
    emit
  }) {
    const monthStart = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.pageDate.startOf('month'));
    const monthEnd = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.pageDate.endOf('month'));
    const currentMonth = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
      start: monthStart.value,
      end: monthEnd.value
    }));
    const displayedInterval = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
      start: monthStart.value.startOf('week'),
      end: monthEnd.value.endOf('week')
    }));
    const weekDays = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return (0,array_.range)(7).map(i => (1 + i) % 7).map(day => external_dayjs_default().utc().day(day)).map(date => date.format(props.weekdayFormat));
    });
    const days = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return (0,date_.eachDateOfInterval)(displayedInterval.value, 'day').map(value => {
        return {
          value,
          display: value.format(props.format),
          selected: (0,truthy_.truthy)(props.selected) && props.selected.isSame(value, 'day'),
          disabled: value.isBefore(currentMonth.value.start) || value.isAfter(currentMonth.value.end),
          key: value.format('YYYY-MM-DD')
        };
      });
    });
    const heading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.pageDate.format(props.headingFormat));
    function onPrevClick() {
      emit('update:pageDate', props.pageDate.subtract(1, 'month'));
    }
    function onNextClick() {
      emit('update:pageDate', props.pageDate.add(1, 'month'));
    }
    function onHeadingClick() {
      emit('back');
    }
    function onItemClick(date) {
      emit('select', date);
    }
    return {
      weekDays,
      days,
      heading,
      onPrevClick,
      onNextClick,
      onHeadingClick,
      onItemClick
    };
  }
}));
;// ./src/components/atoms/datepicker/elems/datepicker-day/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/datepicker/elems/datepicker-day/component.vue




;
const datepicker_day_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(datepicker_day_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_66545af1_ts_true_render]])

/* harmony default export */ const datepicker_day_component = (datepicker_day_component_exports_);
;// ./src/components/atoms/datepicker/elems/datepicker-day/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker/elems/datepicker-month/component.vue?vue&type=template&id=60d75b5c&ts=true

function componentvue_type_template_id_60d75b5c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_datepicker_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-datepicker-base");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_datepicker_base, {
    "column-count": 3,
    items: _ctx.months,
    "heading-clickable": "",
    onLeft: _cache[0] || (_cache[0] = $event => _ctx.onPrevClick()),
    onRight: _cache[1] || (_cache[1] = $event => _ctx.onNextClick()),
    onHeading: _cache[2] || (_cache[2] = $event => _ctx.onHeadingClick()),
    onItemClick: _cache[3] || (_cache[3] = $event => _ctx.onItemClick($event))
  }, {
    heading: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.heading), 1)]),
    _: 1
  }, 8, ["items"]);
}
;// ./src/components/atoms/datepicker/elems/datepicker-month/component.vue?vue&type=template&id=60d75b5c&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker/elems/datepicker-month/component.vue?vue&type=script&lang=ts




/* harmony default export */ const datepicker_month_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-datepicker-month',
  components: {
    DtgDatepickerBase: datepicker_base_component
  },
  props: {
    selected: {
      type: Object,
      default: null
    },
    pageDate: {
      type: Object,
      required: true
    },
    format: {
      type: String,
      default: 'MMM'
    }
  },
  emits: ['update:pageDate', 'select', 'back'],
  setup(props, {
    emit
  }) {
    const from = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.pageDate.startOf('year'));
    const to = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.pageDate.endOf('year'));
    const months = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return (0,date_.eachDateOfInterval)({
        start: from.value,
        end: to.value
      }, 'month').map(value => {
        return {
          value,
          display: value.format(props.format),
          key: value.format(props.format),
          selected: (0,truthy_.truthy)(props.selected) && props.selected.isSame(value, 'month'),
          disabled: false
        };
      });
    });
    const heading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => from.value.year());
    function onPrevClick() {
      emit('update:pageDate', props.pageDate.subtract(1, 'year'));
    }
    function onNextClick() {
      emit('update:pageDate', props.pageDate.add(1, 'year'));
    }
    function onHeadingClick() {
      emit('back');
    }
    function onItemClick(date) {
      emit('select', date);
    }
    return {
      months,
      heading,
      onPrevClick,
      onNextClick,
      onHeadingClick,
      onItemClick
    };
  }
}));
;// ./src/components/atoms/datepicker/elems/datepicker-month/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/datepicker/elems/datepicker-month/component.vue




;
const datepicker_month_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(datepicker_month_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_60d75b5c_ts_true_render]])

/* harmony default export */ const datepicker_month_component = (datepicker_month_component_exports_);
;// ./src/components/atoms/datepicker/elems/datepicker-month/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker/elems/datepicker-year/component.vue?vue&type=template&id=e1f7e07c&ts=true

function componentvue_type_template_id_e1f7e07c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_datepicker_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-datepicker-base");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_datepicker_base, {
    "column-count": 3,
    items: _ctx.years,
    onLeft: _cache[0] || (_cache[0] = $event => _ctx.onPrevClick()),
    onRight: _cache[1] || (_cache[1] = $event => _ctx.onNextClick()),
    onItemClick: _cache[2] || (_cache[2] = $event => _ctx.onItemClick($event))
  }, {
    heading: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.heading), 1)]),
    _: 1
  }, 8, ["items"]);
}
;// ./src/components/atoms/datepicker/elems/datepicker-year/component.vue?vue&type=template&id=e1f7e07c&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker/elems/datepicker-year/component.vue?vue&type=script&lang=ts




/* harmony default export */ const datepicker_year_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-datepicker-year',
  components: {
    DtgDatepickerBase: datepicker_base_component
  },
  props: {
    selected: {
      type: Object,
      default: null
    },
    pageDate: {
      type: Object,
      required: true
    }
  },
  emits: ['update:pageDate', 'select'],
  setup(props, {
    emit
  }) {
    const from = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => (0,date_.startOfDecade)(props.pageDate));
    const to = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => (0,date_.endOfDecade)(props.pageDate));
    const years = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return (0,date_.eachDateOfInterval)({
        start: from.value,
        end: to.value
      }, 'year').map(value => {
        return {
          value,
          key: String(value.year()),
          display: value.year(),
          selected: (0,truthy_.truthy)(props.selected) && value.isSame(props.selected, 'year'),
          disabled: false
        };
      });
    });
    const heading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const start = from.value.year();
      const end = to.value.year();
      return `${start} - ${end}`;
    });
    function onPrevClick() {
      emit('update:pageDate', props.pageDate.subtract(10, 'year'));
    }
    function onNextClick() {
      emit('update:pageDate', props.pageDate.add(10, 'year'));
    }
    function onItemClick(date) {
      emit('select', date);
    }
    return {
      years,
      heading,
      onPrevClick,
      onNextClick,
      onItemClick
    };
  }
}));
;// ./src/components/atoms/datepicker/elems/datepicker-year/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/datepicker/elems/datepicker-year/component.vue




;
const datepicker_year_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(datepicker_year_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_e1f7e07c_ts_true_render]])

/* harmony default export */ const datepicker_year_component = (datepicker_year_component_exports_);
;// ./src/components/atoms/datepicker/elems/datepicker-year/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker/component.vue?vue&type=script&lang=ts








/* harmony default export */ const datepicker_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-datepicker',
  components: {
    DtgDatepickerDay: datepicker_day_component,
    DtgDatepickerMonth: datepicker_month_component,
    DtgDatepickerYear: datepicker_year_component
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    startingView: {
      type: String,
      default: 'day',
      validate: inArray(['year', 'month', 'day'])
    },
    monthHeadingFormat: {
      type: String,
      default: 'MMMM YYYY'
    },
    monthListFormat: {
      type: String,
      default: 'MMM'
    },
    weekdayFormat: {
      type: String,
      default: 'ddd'
    },
    allowSelectOn: {
      type: Array,
      default: () => ['day']
    },
    limitSelectionVisibility: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'focus', 'blur', 'select', 'selectPartial', 'today'],
  setup(props, {
    emit
  }) {
    const {
      allowSelectOn
    } = (0,refs_.toReadonlyRefs)(props);
    const currentView = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.startingView);
    const pageDate = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.modelValue ? (0,date_.createUtcDate)(props.modelValue) : (0,date_.createUtcDate)());
    const selectedDate = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
      get: () => {
        const {
          modelValue
        } = props;
        return modelValue ? (0,date_.createUtcDate)(modelValue) : null;
      },
      set: date => {
        emit('update:modelValue', convertValue(date));
      }
    });
    const clearDisabled = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => !selectedDate.value);
    const selectionVisibilityLimit = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.limitSelectionVisibility ? props.startingView : null;
    });
    const {
      partialDate,
      extraAction,
      confirmText,
      isAllowedToSelect,
      shouldHideSelected
    } = usePartialDates({
      currentView,
      selectedDate,
      pageDate,
      allowSelectOn,
      selectionVisibilityLimit
    });
    function convertValue(date) {
      return date?.toISOString() ?? null;
    }
    function onYear(date) {
      pageDate.value = date;
      if (isAllowedToSelect(['month', 'day'])) {
        currentView.value = 'month';
      } else {
        selectDate(date);
      }
      if (isAllowedToSelect('year')) {
        selectPartialDate({
          unit: 'year',
          date
        });
      }
    }
    function onMonth(date) {
      pageDate.value = date;
      if (isAllowedToSelect('day')) {
        currentView.value = 'day';
      } else {
        selectDate(date);
      }
      if (isAllowedToSelect('month')) {
        selectPartialDate({
          unit: 'month',
          date
        });
      }
    }
    function onDay(date) {
      pageDate.value = date;
      selectDate(date);
      selectPartialDate({
        unit: 'day',
        date
      }, true);
    }
    function isShown(view) {
      return currentView.value === view;
    }
    function onBack(view) {
      switch (view) {
        case 'day':
          currentView.value = 'month';
          break;
        case 'month':
          currentView.value = 'year';
          break;
      }
    }
    function onClear() {
      selectDate(null);
    }
    function onToday() {
      pageDate.value = (0,date_.createUtcDate)();
      currentView.value = 'day';
      selectDate(pageDate.value, 'today');
    }
    function onConfirm() {
      const date = selectedDate.value;
      if (partialDate.value) {
        selectPartialDate(partialDate.value, true);
      } else if (date) {
        selectDate(date);
      }
    }
    function selectDate(date, event = 'select') {
      selectedDate.value = date;
      emit(event, convertValue(date));
    }
    function selectPartialDate({
      unit,
      date
    }, confirmed = false) {
      const partialDate = {
        unit,
        date: date.toISOString(),
        confirmed
      };
      emit('selectPartial', partialDate);
    }
    return {
      pageDate,
      selectedDate,
      clearDisabled,
      extraAction,
      confirmText,
      isShown,
      shouldHideSelected,
      onYear,
      onMonth,
      onDay,
      onToday,
      onBack,
      onClear,
      onConfirm
    };
  }
}));
;// ./src/components/atoms/datepicker/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/datepicker/component.vue




;
const datepicker_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(datepicker_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_a1192c2a_ts_true_render]])

/* harmony default export */ const datepicker_component = (datepicker_component_exports_);
;// ./src/components/atoms/datepicker/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/dropdown/component.vue?vue&type=template&id=5b1b2df9&ts=true

function componentvue_type_template_id_5b1b2df9_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("ul", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b()),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onCloseClick())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2);
}
;// ./src/components/atoms/dropdown/component.vue?vue&type=template&id=5b1b2df9&ts=true

;// ./src/composables/use-overlay/utils/position-popover.ts
const defaultPosition = {
  horizontal: 'left',
  vertical: 'bottom'
};
/**
 * Hack to position popovers, since Ionic 5 doesn't provide an option for that.
 * Pass the return value as the second argument to {@link useOverlay}().open() or its wrappers.
 *
 * @example
 * const popover = useSomePopover();
 *
 * function onClick(event: Event) {
 *     popover.open({}, event);
 * }
 */
function positionPopover(event, {
  position = {},
  popoverWidth = 250,
  popoverHeight = 0
} = {}) {
  const mergedPosition = {
    ...defaultPosition,
    ...position
  };
  const {
    left,
    bottom,
    width,
    height
  } = event.currentTarget.getBoundingClientRect();
  const leftWithOffset = left + width - popoverWidth;
  const bottomWithOffset = bottom - height - popoverHeight;
  const offset = {
    left: mergedPosition.horizontal === 'left' ? leftWithOffset : left,
    bottom: mergedPosition.vertical === 'top' ? bottomWithOffset : bottom
  };
  return {
    target: {
      getBoundingClientRect: () => offset
    }
  };
}
// EXTERNAL MODULE: external "@ionic/vue"
var vue_ = __webpack_require__(2613);
// EXTERNAL MODULE: external "dtg-shared/composables/use-cancelable-action"
var use_cancelable_action_ = __webpack_require__(3750);
// EXTERNAL MODULE: external "dtg-shared/utils/deferred"
var deferred_ = __webpack_require__(4223);
;// ./src/composables/use-overlay/types.ts
var OverlayType;
(function (OverlayType) {
  OverlayType["modal"] = "modal";
  OverlayType["popover"] = "popover";
})(OverlayType || (OverlayType = {}));
;// ./src/composables/use-overlay/composable.ts






const OVERLAY_CONTROLLERS = {
  [OverlayType.modal]: vue_.modalController,
  [OverlayType.popover]: vue_.popoverController
};
const {
  useStateOrThrow: useOverlayElement,
  provideState: provideOverlayElement
} = (0,use_injected_state_.createInjectedState)('overlayElement');

function useOverlay({
  component,
  cssClass,
  backdropDismiss = true,
  overlayType = OverlayType.modal,
  defaultProps = {}
}) {
  const isOpen = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
  let overlayPromise = null;
  const creation = (0,use_cancelable_action_.useCancelableAction)();
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onUnmounted)(() => {
    void destroyOverlayAndCancelCreate();
  });
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onDeactivated)(() => {
    void destroyOverlayAndCancelCreate();
  });
  /** Private methods */
  async function createOverlay(props, event) {
    if (await creation.wasCanceledDuring(destroyOverlay())) {
      return;
    }
    const overlay = await setOverlayPromise(createOverlayComponent(props, event));
    void overlay.onWillDismiss().then(() => {
      clearOverlayPromise();
      if (props.onClose) {
        props.onClose();
      }
    });
    void overlay.onDidDismiss().then(() => {
      if (props.onCloseFully) {
        props.onCloseFully();
      }
    });
    await overlay.present();
  }
  async function createOverlayComponent(props, event) {
    const overlayToProvide = (0,deferred_.createDeferred)();
    const combinedProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)({
      ...defaultProps,
      ...props,
      onClose: () => {
        void destroyOverlayAndCancelCreate();
      }
    });
    const componentWrapper = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.h)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
      name: 'dtg-overlay-content-wrapper',
      setup() {
        provideOverlayElement(overlayToProvide.promise);
        return () => {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.h)(component, combinedProps);
        };
      }
    }));
    const controller = OVERLAY_CONTROLLERS[overlayType];
    const promise = controller.create({
      cssClass,
      backdropDismiss,
      // eslint-disable-next-line @typescript-eslint/ban-types
      component: componentWrapper,
      event,
      translucent: true,
      showBackdrop: false,
      keyboardClose: false
    });
    void promise.then(overlayToProvide.resolve);
    return promise;
  }
  // To destroy an overlay we need to wait for it to initialize
  async function destroyOverlay() {
    if (!overlayPromise) {
      return;
    }
    const overlay = await overlayPromise;
    await overlay.dismiss();
  }
  async function destroyOverlayAndCancelCreate() {
    creation.cancel();
    await destroyOverlay();
  }
  async function setOverlayPromise(nextPromise) {
    overlayPromise = nextPromise;
    isOpen.value = true;
    return overlayPromise;
  }
  function clearOverlayPromise() {
    overlayPromise = null;
    isOpen.value = false;
  }
  /** Public methods */
  function open(props, event) {
    void createOverlay(props, event);
  }
  function close() {
    void destroyOverlayAndCancelCreate();
  }
  async function closeAndWait() {
    await destroyOverlayAndCancelCreate();
  }
  return {
    isOpen: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.readonly)(isOpen),
    open,
    close,
    closeAndWait
  };
}
;// ./src/composables/use-overlay/index.ts




;// ./src/components/atoms/dropdown/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const dropdown_style_module = ({"dtg-dropdown":"lib_dtg-dropdown_fc4up"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/dropdown/component.vue?vue&type=script&lang=ts




/* harmony default export */ const dropdown_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(dropdown_style_module),
  emits: ['willClose', 'didClose'],
  setup(props, {
    emit
  }) {
    const overlay = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const overlayPromise = useOverlayElement();
    void overlayPromise.then(overlayToSet => {
      void overlayToSet.onWillDismiss().then(() => {
        emit('willClose');
      });
      void overlayToSet.onDidDismiss().then(() => {
        emit('didClose');
      });
      overlay.value = overlayToSet;
    });
    function onCloseClick() {
      void overlay.value?.dismiss();
    }
    return {
      b: useBem(dropdown_style_module),
      onCloseClick
    };
  }
}));
;// ./src/components/atoms/dropdown/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/dropdown/component.vue




;
const dropdown_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(dropdown_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_5b1b2df9_ts_true_render]])

/* harmony default export */ const dropdown_component = (dropdown_component_exports_);
;// ./src/components/atoms/dropdown/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/dropdown-item/component.vue?vue&type=template&id=8b793e22&ts=true

function componentvue_type_template_id_8b793e22_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: _ctx.b({
      disabled: _ctx.disabled
    })
  }, _ctx.splitAttrs.root), [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_action, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: _ctx.b('action'),
    disabled: _ctx.disabled
  }, {
    ..._ctx.splitAttrs.attrs,
    ..._ctx.splitAttrs.listeners
  }), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon')),
      name: _ctx.icon
    }, null, 8, ["class", "name"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)]),
    _: 3
  }, 16, ["class", "disabled"])], 16);
}
;// ./src/components/atoms/dropdown-item/component.vue?vue&type=template&id=8b793e22&ts=true

;// ./src/components/atoms/dropdown-item/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const dropdown_item_style_module = ({"dtg-dropdown-item":"lib_dtg-dropdown-item_Ak_f1","dtg-dropdown-item__action":"lib_dtg-dropdown-item__action_GdtUN","dtg-dropdown-item__icon":"lib_dtg-dropdown-item__icon_UWrDG","dtg-dropdown-item_disabled":"lib_dtg-dropdown-item_disabled_gwmlK","dtg-dropdown-item__item_disabled":"lib_dtg-dropdown-item__item_disabled_beFH5","dtg-dropdown-item__text":"lib_dtg-dropdown-item__text_vNSON"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/dropdown-item/component.vue?vue&type=script&lang=ts






/* harmony default export */ const dropdown_item_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(dropdown_item_style_module),
  components: {
    DtgAction: action_component,
    DtgIcon: icon_component
  },
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    attrs
  }) {
    const splitAttrs = useSplitAttrs(attrs);
    return {
      b: useBem(dropdown_item_style_module),
      splitAttrs
    };
  }
}));
;// ./src/components/atoms/dropdown-item/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/dropdown-item/component.vue




;
const dropdown_item_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(dropdown_item_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_8b793e22_ts_true_render]])

/* harmony default export */ const dropdown_item_component = (dropdown_item_component_exports_);
;// ./src/components/atoms/dropdown-item/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/dropzone/component.vue?vue&type=template&id=a9fd70ce&ts=true

const componentvue_type_template_id_a9fd70ce_ts_true_hoisted_1 = {
  ref: "dropzoneElementRef"
};
function componentvue_type_template_id_a9fd70ce_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", componentvue_type_template_id_a9fd70ce_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)({
    dropTarget: _ctx.isDropTarget,
    disabled: _ctx.disabledInternal,
    processing: _ctx.processing
  })))], 512);
}
;// ./src/components/atoms/dropzone/component.vue?vue&type=template&id=a9fd70ce&ts=true

// EXTERNAL MODULE: external "dtg-shared/utils/read-blob"
var read_blob_ = __webpack_require__(6156);
// EXTERNAL MODULE: external "dtg-shared/utils/wrap-pending"
var wrap_pending_ = __webpack_require__(1334);
// EXTERNAL MODULE: external "@ionic/core"
var core_ = __webpack_require__(9640);
;// ./src/utils/toast.ts


const DEFAULT_ERROR_MESSAGE = 'Erreur';
async function openToast(message, {
  header,
  duration = 2000,
  position = 'bottom',
  buttons = []
} = {}) {
  const modifiedButtons = buttons.map(button => {
    const cssClass = ['ion-toast-button', button.cssClass].flat().filter(truthy_.truthy);
    return {
      ...button,
      cssClass
    };
  });
  const toast = await core_.toastController.create({
    header,
    message,
    duration,
    position,
    buttons: modifiedButtons
  });
  void toast.present();
  return toast;
}
async function openErrorToast(message, options) {
  return openToast(message ?? DEFAULT_ERROR_MESSAGE, options);
}
async function openFileDownloadToast({
  filename,
  url
}) {
  const toastTitle = ['Le document', filename, 'est prêt à être téléchargé.'].filter(truthy_.truthy).join(' ');
  const toast = await openToast(toastTitle, {
    duration: 10000,
    buttons: [{
      text: 'Télécharger',
      handler: () => {
        window.open(url, '_blank', 'noopener noreferrer');
        void toast.dismiss();
      }
    }, {
      text: 'Fermer',
      handler: () => {
        void toast.dismiss();
      }
    }]
  });
  return toast;
}
;// ./src/composables/use-file-reader.ts



// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useFileReader({
  format
}) {
  async function readFiles(files) {
    const filePromises = files.map(async file => {
      return readFile(file).catch(() => {
        void openToast(`Impossible d’ouvrir le fichier ${file.name}`, {
          header: 'Erreur'
        });
        return null;
      });
    });
    return Promise.all(filePromises).then(files => {
      return files.filter(truthy_.truthy);
    });
  }
  async function readFile(file) {
    const {
      name
    } = file;
    return (0,read_blob_.readBlob)(file, format).then(data => {
      return {
        type: format,
        mimeType: file.type,
        size: file.size,
        name,
        data
      };
    });
  }
  return {
    readFiles,
    readFile
  };
}
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/dropzone/component.vue?vue&type=script&lang=ts





/* harmony default export */ const dropzone_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-dropzone',
  props: {
    format: {
      type: String,
      required: true,
      validator: inRecord(read_blob_.BlobFormat)
    },
    accept: {
      type: String,
      default: null
    },
    max: {
      type: Number,
      default: Infinity
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['files'],
  setup(props, {
    emit
  }) {
    const isDropTarget = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const dropzoneElementRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const {
      readFiles
    } = useFileReader({
      format: props.format
    });
    const disabledInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.disabled || props.max <= 0;
    });
    const processing = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    let dragOverCounter = 0;
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      if (dropzoneElementRef.value) {
        if (disabledInternal.value) {
          destroy();
        } else {
          init();
        }
      }
    }, {
      flush: 'post'
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onUnmounted)(() => {
      destroy();
    });
    function init() {
      if (!dropzoneElementRef.value) {
        return;
      }
      dropzoneElementRef.value.addEventListener('dragenter', onDragEnter);
      dropzoneElementRef.value.addEventListener('dragover', onDragOver);
      dropzoneElementRef.value.addEventListener('drop', onDrop);
      dropzoneElementRef.value.addEventListener('dragend', onDragEnd);
      dropzoneElementRef.value.addEventListener('dragleave', onDragLeave);
    }
    function destroy() {
      if (!dropzoneElementRef.value) {
        return;
      }
      dropzoneElementRef.value.removeEventListener('dragenter', onDragEnter);
      dropzoneElementRef.value.removeEventListener('dragover', onDragOver);
      dropzoneElementRef.value.removeEventListener('drop', onDrop);
      dropzoneElementRef.value.removeEventListener('dragend', onDragEnd);
      dropzoneElementRef.value.removeEventListener('dragleave', onDragLeave);
    }
    function onDragEnter(event) {
      noPropagation(event);
      dragOverCounter += 1;
      isDropTarget.value = true;
    }
    function onDragOver(event) {
      noPropagation(event);
      isDropTarget.value = true;
    }
    async function onDrop(event) {
      noPropagation(event);
      dragOverCounter = 0;
      isDropTarget.value = false;
      if (!event.dataTransfer) {
        return;
      }
      const {
        files
      } = event.dataTransfer;
      const {
        accept
      } = props;
      const filesAccepted = Array.from(files).filter(file => {
        return accept === null || accept.includes(file.type);
      });
      const filesLimited = Array.from(filesAccepted).slice(0, props.max);
      const filesRead = await (0,wrap_pending_.wrapPending)(readFiles(filesLimited), processing);
      emit('files', filesRead);
    }
    function onDragEnd() {
      dragOverCounter = 0;
      isDropTarget.value = false;
    }
    function onDragLeave() {
      dragOverCounter = Math.max(dragOverCounter - 1, 0);
      if (dragOverCounter === 0) {
        isDropTarget.value = false;
      }
    }
    function containsFiles(event) {
      return Boolean(event.dataTransfer?.types.some(type => type === 'Files'));
    }
    function noPropagation(event) {
      if (!containsFiles(event)) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
    }
    return {
      isDropTarget,
      disabledInternal,
      dropzoneElementRef,
      processing
    };
  }
}));
;// ./src/components/atoms/dropzone/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/dropzone/component.vue




;
const dropzone_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(dropzone_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_a9fd70ce_ts_true_render]])

/* harmony default export */ const dropzone_component = (dropzone_component_exports_);
;// ./src/components/atoms/dropzone/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/field/component.vue?vue&type=template&id=01869a50&ts=true

function componentvue_type_template_id_01869a50_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_field_label = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field-label");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('top'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field_label, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('labels')),
    label: _ctx.label,
    required: _ctx.required,
    "error-message": _ctx.errorMessage,
    touched: _ctx.touched,
    "sub-label": _ctx.subLabel,
    disabled: _ctx.disabled
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
    _: 2
  }, [_ctx.$slots.subLabelSlot ? {
    name: "subLabelSlot",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "subLabelSlot")]),
    key: "0"
  } : undefined]), 1032, ["class", "label", "required", "error-message", "touched", "sub-label", "disabled"]), _ctx.$slots.actions ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('actions'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, {
    padding: "half"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "actions")]),
      _: 3
    })]),
    _: 3
  })], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)], 2);
}
;// ./src/components/atoms/field/component.vue?vue&type=template&id=01869a50&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/field-label/component.vue?vue&type=template&id=0be2c690&ts=true

function componentvue_type_template_id_0be2c690_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [_ctx.label || _ctx.$slots.default ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 1)])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.subLabelInternal || _ctx.$slots.subLabelSlot ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('sub-label', {
      error: _ctx.hasError
    }))
  }, [_ctx.hasError ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 0
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.subLabelInternal), 1)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "subLabelSlot", {
    key: 1
  }, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.subLabelInternal), 1)])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]);
}
;// ./src/components/atoms/field-label/component.vue?vue&type=template&id=0be2c690&ts=true

;// ./src/components/atoms/field-label/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const field_label_style_module = ({"dtg-field-label__label":"lib_dtg-field-label__label_lEJLa","dtg-field-label__sub-label":"lib_dtg-field-label__sub-label_S4G2X","dtg-field-label__sub-label_error":"lib_dtg-field-label__sub-label_error_WShPv"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/field-label/component.vue?vue&type=script&lang=ts




/* harmony default export */ const field_label_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(field_label_style_module),
  props: {
    label: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    touched: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    },
    subLabel: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const requiredText = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      switch (props.required) {
        case true:
          return 'Obligatoire';
        case false:
          return props.disabled ? 'Non requis' : 'Facultatif';
        default:
          return null;
      }
    });
    const errorMessageInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        errorMessage
      } = props;
      if (!errorMessage) {
        return null;
      }
      return (0,string_.capitalizeSentence)(errorMessage);
    });
    const subLabelInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        subLabel,
        touched
      } = props;
      const errorMessage = errorMessageInternal.value;
      if (errorMessage && touched) {
        return errorMessage;
      }
      return [requiredText.value, subLabel].filter(Boolean).join(', ');
    });
    const hasError = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => Boolean(props.errorMessage && props.touched));
    return {
      b: useBem(field_label_style_module),
      hasError,
      subLabelInternal
    };
  }
}));
;// ./src/components/atoms/field-label/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/field-label/component.vue




;
const field_label_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(field_label_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_0be2c690_ts_true_render]])

/* harmony default export */ const field_label_component = (field_label_component_exports_);
;// ./src/components/atoms/field-label/index.ts


;// ./src/components/atoms/field/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const field_style_module = ({"dtg-field":"lib_dtg-field_tcVdJ","dtg-field__top":"lib_dtg-field__top_xcrpa","dtg-field__labels":"lib_dtg-field__labels_hJrby","dtg-field__actions":"lib_dtg-field__actions_TNdfu","dtg-field__content":"lib_dtg-field__content_jc062"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/field/component.vue?vue&type=script&lang=ts





/* harmony default export */ const field_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(field_style_module),
  components: {
    DtgGrid: grid,
    DtgRow: row,
    DtgFieldLabel: field_label_component
  },
  props: {
    label: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    touched: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    },
    subLabel: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      b: useBem(field_style_module)
    };
  }
}));
;// ./src/components/atoms/field/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/field/component.vue




;
const field_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(field_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_01869a50_ts_true_render]])

/* harmony default export */ const field_component = (field_component_exports_);
;// ./src/components/atoms/field/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/fieldset/component.vue?vue&type=template&id=3dd2515c&ts=true

function componentvue_type_template_id_3dd2515c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2);
}
;// ./src/components/atoms/fieldset/component.vue?vue&type=template&id=3dd2515c&ts=true

;// ./src/components/atoms/fieldset/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const fieldset_style_module = ({"dtg-fieldset":"lib_dtg-fieldset_pmAdh"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/fieldset/component.vue?vue&type=script&lang=ts



/* harmony default export */ const fieldset_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(fieldset_style_module),
  setup() {
    return {
      b: useBem(fieldset_style_module)
    };
  }
}));
;// ./src/components/atoms/fieldset/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/fieldset/component.vue




;
const fieldset_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(fieldset_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_3dd2515c_ts_true_render]])

/* harmony default export */ const fieldset_component = (fieldset_component_exports_);
;// ./src/components/atoms/fieldset/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/file-chooser/component.vue?vue&type=template&id=5168cd4c&ts=true

const componentvue_type_template_id_5168cd4c_ts_true_hoisted_1 = ["multiple", "accept"];
function componentvue_type_template_id_5168cd4c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    ref: "input",
    class: _ctx.b()
  }, _ctx.$attrs, {
    multiple: _ctx.multiple,
    accept: _ctx.accept,
    type: "file",
    onChange: _cache[0] || (_cache[0] = $event => _ctx.onChange())
  }), null, 16, componentvue_type_template_id_5168cd4c_ts_true_hoisted_1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)({
    openFileChooser: _ctx.openFileChooser,
    processing: _ctx.processing,
    isCaptureSupported: _ctx.isCaptureSupported
  })))], 64);
}
;// ./src/components/atoms/file-chooser/component.vue?vue&type=template&id=5168cd4c&ts=true

// EXTERNAL MODULE: external "lodash/partition"
var partition_ = __webpack_require__(9172);
var partition_default = /*#__PURE__*/__webpack_require__.n(partition_);
;// ./src/utils/events.ts
/* eslint-disable @typescript-eslint/no-explicit-any */
/* Usage inside defineComponent:
 * type Events = { event1: (payload: PayloadType) => void; event2: () => void };
 * events: events(['event1', 'event2'])<Events>();
 */
function events(events) {
  return () => {
    return events;
  };
}
;// ./src/components/atoms/file-chooser/utils.ts


function detectCaptureSupported() {
  const attr = 'capture';
  const element = document.createElement('input');
  element.setAttribute(attr, 'user');
  return Boolean(element[attr]);
}
function isMatchingMimeType(mimeType, acceptedTypes) {
  return (0,array_.arrayify)(acceptedTypes).join(',').split(',').includes((0,string_.normalizeString)(mimeType));
}
;// ./src/components/atoms/file-chooser/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const file_chooser_style_module = ({"dtg-file-chooser":"lib_dtg-file-chooser_KCeKs"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/file-chooser/component.vue?vue&type=script&lang=ts









/* harmony default export */ const file_chooser_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(file_chooser_style_module),
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true
    },
    format: {
      type: String,
      default: read_blob_.BlobFormat.binaryString,
      validator: inRecord(read_blob_.BlobFormat)
    },
    max: {
      type: Number,
      default: 1
    },
    accept: {
      type: String,
      default: null
    }
  },
  emits: events(['file', 'files', 'processing', 'error'])(),
  setup(props, {
    emit
  }) {
    const isCaptureSupported = detectCaptureSupported();
    const {
      readFiles
    } = useFileReader({
      format: props.format
    });
    const processing = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const multiple = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.max > 1);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(processing, value => {
      emit('processing', value);
    });
    function onChange() {
      const files = input.value?.files;
      if (!files || files.length === 0) {
        return;
      }
      const [supportedFiles, unsupportedFiles] = partition_default()(Array.from(files), file => isAcceptedFileType(file.type));
      if (unsupportedFiles.length > 0) {
        const unsupportedTypes = unsupportedFiles.map(file => file.type).join(', ');
        if (unsupportedFiles.length === 1) {
          emit('error', `Le format du fichier sélectionné n'est pas supporté : ${unsupportedTypes}`);
        } else {
          emit('error', `Le format des fichiers sélectionnés n'est pas supporté : ${unsupportedTypes}`);
        }
      }
      processing.value = true;
      const toUpload = supportedFiles.slice(0, props.max);
      readFiles(toUpload).then(files => {
        if (files.length > 0) {
          emit('files', files);
        }
        files.forEach(file => {
          emit('file', file);
        });
      }).finally(() => {
        if (input.value) {
          input.value.value = '';
        }
        processing.value = false;
      });
    }
    function isAcceptedFileType(type) {
      if (!props.accept || props.accept === '*') {
        return true;
      }
      return props.accept.includes(type);
    }
    function openFileChooser() {
      if (!input.value || processing.value) {
        return;
      }
      input.value.click();
    }
    return {
      b: useBem(file_chooser_style_module),
      processing,
      multiple,
      input,
      isCaptureSupported,
      onChange,
      openFileChooser
    };
  }
}));
;// ./src/components/atoms/file-chooser/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/file-chooser/component.vue




;
const file_chooser_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(file_chooser_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_5168cd4c_ts_true_render]])

/* harmony default export */ const file_chooser_component = (file_chooser_component_exports_);
;// ./src/components/atoms/file-chooser/types.ts
var DtgFileChooserAcceptedTypes;
(function (DtgFileChooserAcceptedTypes) {
  DtgFileChooserAcceptedTypes["image"] = "image/png,image/x-png,image/gif,image/jpeg,image/jpg";
  DtgFileChooserAcceptedTypes["pdf"] = "application/pdf";
  DtgFileChooserAcceptedTypes["wordDocument"] = "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
})(DtgFileChooserAcceptedTypes || (DtgFileChooserAcceptedTypes = {}));
// EXTERNAL MODULE: external "yup"
var external_yup_ = __webpack_require__(474);
// EXTERNAL MODULE: external "dtg-shared/utils/format-bytes"
var format_bytes_ = __webpack_require__(3993);
// EXTERNAL MODULE: external "dtg-shared/validation"
var validation_ = __webpack_require__(4457);
;// ./src/components/atoms/file-chooser/validation.ts




function dtgFileChooserFile(maxSize = Infinity) {
  const when = (0,validation_.makeConditionsOf)();
  const dataConditional = when({
    key: 'type',
    is: value => [read_blob_.BlobFormat.text, read_blob_.BlobFormat.dataUrl, read_blob_.BlobFormat.binaryString].includes(value),
    then: (0,external_yup_.string)().defined(),
    otherwise: (0,validation_.objectSchema)().defined()
  });
  const sizeLabel = (0,format_bytes_.formatBytes)(maxSize);
  return (0,validation_.defineSchema)({
    name: (0,external_yup_.string)().defined(),
    type: (0,external_yup_.mixed)().oneOf(Object.values(read_blob_.BlobFormat)).defined(),
    size: (0,external_yup_.number)().defined(),
    mimeType: (0,external_yup_.string)().defined(),
    data: (0,external_yup_.mixed)().when(...dataConditional.apply())
  }).test('maxSize', `Le fichier ne peut pas dépasser ${sizeLabel}`,
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  value => !value || typeof value.size === 'undefined' || value.size <= maxSize);
}
;// ./src/components/atoms/file-chooser/index.ts





;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/form/component.vue?vue&type=template&id=fe33c986&ts=true

const componentvue_type_template_id_fe33c986_ts_true_hoisted_1 = ["id"];
function componentvue_type_template_id_fe33c986_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("form", {
    id: _ctx.id,
    onSubmit: _cache[0] || (_cache[0] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => _ctx.onSubmit($event), ["prevent"]))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 40, componentvue_type_template_id_fe33c986_ts_true_hoisted_1);
}
;// ./src/components/atoms/form/component.vue?vue&type=template&id=fe33c986&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/form/component.vue?vue&type=script&lang=ts

/* harmony default export */ const form_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-form',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  emits: ['submit'],
  setup(props, {
    emit
  }) {
    function onSubmit(event) {
      emit('submit', event);
    }
    return {
      onSubmit
    };
  }
}));
;// ./src/components/atoms/form/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/form/component.vue




;
const form_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(form_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_fe33c986_ts_true_render]])

/* harmony default export */ const form_component = (form_component_exports_);
;// ./src/components/atoms/form/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/icon-action/component.vue?vue&type=template&id=632ff230&ts=true

function componentvue_type_template_id_632ff230_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      notice: _ctx.notice
    }))
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      name: _ctx.name
    }, null, 8, ["name"])]),
    _: 1
  }, 8, ["class"]);
}
;// ./src/components/atoms/icon-action/component.vue?vue&type=template&id=632ff230&ts=true

;// ./src/components/atoms/icon-action/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const icon_action_style_module = ({"dtg-icon-action":"lib_dtg-icon-action_tkUCY","dtg-icon-action_notice":"lib_dtg-icon-action_notice_ll8hI"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/icon-action/component.vue?vue&type=script&lang=ts






/* harmony default export */ const icon_action_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(icon_action_style_module),
  components: {
    DtgIcon: icon_component,
    DtgAction: action_component
  },
  props: {
    name: {
      type: String,
      required: true,
      validator: inArray(iconNames)
    },
    notice: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      b: useBem(icon_action_style_module)
    };
  }
}));
;// ./src/components/atoms/icon-action/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/icon-action/component.vue




;
const icon_action_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(icon_action_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_632ff230_ts_true_render]])

/* harmony default export */ const icon_action_component = (icon_action_component_exports_);
;// ./src/components/atoms/icon-action/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/infinite-scroll/component.vue?vue&type=template&id=59ffcf7c&ts=true

function componentvue_type_template_id_59ffcf7c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_spinner = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-spinner");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    ref: "rootRef",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      disabled: _ctx.disabled
    }))
  }, [!_ctx.invisible ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_spinner, {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('spinner')),
    view: "big"
  }, null, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// ./src/components/atoms/infinite-scroll/component.vue?vue&type=template&id=59ffcf7c&ts=true

;// ./src/components/atoms/infinite-scroll/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const infinite_scroll_style_module = ({"dtg-infinite-scroll_disabled":"lib_dtg-infinite-scroll_disabled_YHGws","dtg-infinite-scroll__spinner":"lib_dtg-infinite-scroll__spinner_qhR57"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/infinite-scroll/component.vue?vue&type=script&lang=ts







/* harmony default export */ const infinite_scroll_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(infinite_scroll_style_module),
  components: {
    DtgSpinner: spinner_component
  },
  props: {
    threshold: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: false
    },
    invisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['trigger'],
  setup(props, {
    emit
  }) {
    const {
      disabled
    } = (0,refs_.toReadonlyRefs)(props);
    const {
      scrollEl
    } = useScroll();
    const loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const active = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(true);
    const rootRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    let observer = null;
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      observer = new IntersectionObserver(entries => {
        const intersecting = entries.some(({
          isIntersecting
        }) => isIntersecting);
        if (intersecting) {
          onIntersecting();
        }
      }, {
        root: scrollEl.value,
        rootMargin: `${props.threshold}px`
      });
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)([disabled, loading, active, rootRef], () => {
        onUpdate();
      }, {
        // Ensure intersection observer is re-triggered
        // when e.g. loading is changed to true and back in a single tick
        flush: 'sync',
        immediate: true
      });
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onUnmounted)(() => {
      observer?.disconnect();
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onActivated)(() => {
      active.value = true;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onDeactivated)(() => {
      active.value = false;
    });
    function onIntersecting() {
      loading.value = true;
      emit('trigger', onComplete);
    }
    function onUpdate() {
      const el = rootRef.value;
      const enabled = !disabled.value && !loading.value && active.value && (0,truthy_.truthy)(el);
      if (enabled) {
        observer?.observe(el);
      } else if (el) {
        observer?.unobserve(el);
      }
    }
    function onComplete() {
      loading.value = false;
    }
    return {
      b: useBem(infinite_scroll_style_module),
      rootRef
    };
  }
}));
;// ./src/components/atoms/infinite-scroll/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/infinite-scroll/component.vue




;
const infinite_scroll_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(infinite_scroll_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_59ffcf7c_ts_true_render]])

/* harmony default export */ const infinite_scroll_component = (infinite_scroll_component_exports_);
;// ./src/components/atoms/infinite-scroll/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/info-box/component.vue?vue&type=template&id=352f685e&ts=true

function componentvue_type_template_id_352f685e_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      color: _ctx.color,
      view: _ctx.view,
      size: _ctx.size
    }))
  }, [_ctx.icon ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_icon, {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon')),
    name: _ctx.icon
  }, null, 8, ["class", "name"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)], 2);
}
;// ./src/components/atoms/info-box/component.vue?vue&type=template&id=352f685e&ts=true

;// ./src/components/atoms/info-box/types.ts
var DtgInfoBoxColor;
(function (DtgInfoBoxColor) {
  DtgInfoBoxColor["regular"] = "regular";
  DtgInfoBoxColor["warning"] = "warning";
  DtgInfoBoxColor["notice"] = "notice";
})(DtgInfoBoxColor || (DtgInfoBoxColor = {}));
var DtgInfoBoxView;
(function (DtgInfoBoxView) {
  DtgInfoBoxView["regular"] = "regular";
  DtgInfoBoxView["filled"] = "filled";
})(DtgInfoBoxView || (DtgInfoBoxView = {}));
var DtgInfoBoxSize;
(function (DtgInfoBoxSize) {
  DtgInfoBoxSize["s"] = "s";
  DtgInfoBoxSize["m"] = "m";
})(DtgInfoBoxSize || (DtgInfoBoxSize = {}));
;// ./src/components/atoms/info-box/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const info_box_style_module = ({"dtg-info-box_view_filled":"lib_dtg-info-box_view_filled_NJgGw","dtg-info-box_color_regular":"lib_dtg-info-box_color_regular_DdTOK","dtg-info-box_color_notice":"lib_dtg-info-box_color_notice_FXCCW","dtg-info-box_color_warning":"lib_dtg-info-box_color_warning_jPaDe","dtg-info-box_view_regular":"lib_dtg-info-box_view_regular_gVK4M","dtg-info-box_size_s":"lib_dtg-info-box_size_s_bbkvk","dtg-info-box_size_m":"lib_dtg-info-box_size_m_SMkPQ","dtg-info-box":"lib_dtg-info-box_juSLJ","dtg-info-box__icon":"lib_dtg-info-box__icon_Zu5cN","dtg-info-box__text":"lib_dtg-info-box__text_B8JG6"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/info-box/component.vue?vue&type=script&lang=ts






/* harmony default export */ const info_box_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(info_box_style_module),
  components: {
    DtgIcon: icon_component
  },
  props: {
    view: {
      type: String,
      default: DtgInfoBoxView.regular,
      validator: inRecord(DtgInfoBoxView)
    },
    size: {
      type: String,
      default: DtgInfoBoxSize.m,
      validator: inRecord(DtgInfoBoxSize)
    },
    color: {
      type: String,
      default: DtgInfoBoxColor.regular,
      validator: inRecord(DtgInfoBoxColor)
    },
    icon: {
      type: String,
      default: null,
      validator: inArray(iconNames)
    }
  },
  setup() {
    return {
      b: useBem(info_box_style_module)
    };
  }
}));
;// ./src/components/atoms/info-box/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/info-box/component.vue




;
const info_box_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(info_box_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_352f685e_ts_true_render]])

/* harmony default export */ const info_box_component = (info_box_component_exports_);
;// ./src/components/atoms/info-box/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input/component.vue?vue&type=template&id=acbb8a42&ts=true

const componentvue_type_template_id_acbb8a42_ts_true_hoisted_1 = ["name", "type", "inputmode", "disabled", "autocomplete", "tabindex", "maxlength", "readonly"];
function componentvue_type_template_id_acbb8a42_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _directive_imask = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("imask");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: _ctx.b(_ctx.getMods())
  }, _ctx.splitAttrs.root), [_ctx.placeholderShown ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('placeholder'))
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.placeholder), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    ref: "inputRef",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
    class: _ctx.b('input'),
    style: _ctx.inputStyle,
    name: _ctx.name,
    type: _ctx.type,
    inputmode: _ctx.mode,
    disabled: _ctx.disabled,
    autocomplete: _ctx.autocompleteInternal,
    tabindex: _ctx.tabindexInternal,
    maxlength: _ctx.maxLength,
    readonly: _ctx.readonly,
    autocorrect: "off",
    spellcheck: "false",
    autocapitalize: "off"
  }, {
    ..._ctx.splitAttrs.attrs,
    ..._ctx.splitAttrs.listeners
  }, {
    onAccept: _cache[1] || (_cache[1] = $event => _ctx.onAccept($event)),
    onComplete: _cache[2] || (_cache[2] = $event => _ctx.onComplete($event))
  }), null, 16, componentvue_type_template_id_acbb8a42_ts_true_hoisted_1), [[_directive_imask, _ctx.maskInternal], [external_commonjs_vue_commonjs2_vue_root_Vue_.vModelDynamic, _ctx.modelValueInternal]]), _ctx.icon ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
    name: _ctx.icon
  }, null, 8, ["name"])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.extra ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 2,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('extra'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "extra")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.action ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 3,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('action'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "action")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.unit ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 4,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('unit'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "unit")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 16);
}
;// ./src/components/atoms/input/component.vue?vue&type=template&id=acbb8a42&ts=true

;// ../../node_modules/imask/esm/_rollupPluginBabelHelpers-67bba7fb.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }

      return desc.value;
    };
  }

  return _get.apply(this, arguments);
}

function set(target, property, value, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.set) {
    set = Reflect.set;
  } else {
    set = function set(target, property, value, receiver) {
      var base = _superPropBase(target, property);

      var desc;

      if (base) {
        desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.set) {
          desc.set.call(receiver, value);
          return true;
        } else if (!desc.writable) {
          return false;
        }
      }

      desc = Object.getOwnPropertyDescriptor(receiver, property);

      if (desc) {
        if (!desc.writable) {
          return false;
        }

        desc.value = value;
        Object.defineProperty(receiver, property, desc);
      } else {
        _defineProperty(receiver, property, value);
      }

      return true;
    };
  }

  return set(target, property, value, receiver);
}

function _set(target, property, value, receiver, isStrict) {
  var s = set(target, property, value, receiver || target);

  if (!s && isStrict) {
    throw new Error('failed to set property');
  }

  return value;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



;// ../../node_modules/imask/esm/core/change-details.js


/**
  Provides details of changing model value
  @param {Object} [details]
  @param {string} [details.inserted] - Inserted symbols
  @param {boolean} [details.skip] - Can skip chars
  @param {number} [details.removeCount] - Removed symbols count
  @param {number} [details.tailShift] - Additional offset if any changes occurred before tail
*/
var ChangeDetails = /*#__PURE__*/function () {
  /** Inserted symbols */

  /** Can skip chars */

  /** Additional offset if any changes occurred before tail */

  /** Raw inserted is used by dynamic mask */
  function ChangeDetails(details) {
    _classCallCheck(this, ChangeDetails);

    Object.assign(this, {
      inserted: '',
      rawInserted: '',
      skip: false,
      tailShift: 0
    }, details);
  }
  /**
    Aggregate changes
    @returns {ChangeDetails} `this`
  */


  _createClass(ChangeDetails, [{
    key: "aggregate",
    value: function aggregate(details) {
      this.rawInserted += details.rawInserted;
      this.skip = this.skip || details.skip;
      this.inserted += details.inserted;
      this.tailShift += details.tailShift;
      return this;
    }
    /** Total offset considering all changes */

  }, {
    key: "offset",
    get: function get() {
      return this.tailShift + this.inserted.length;
    }
  }]);

  return ChangeDetails;
}();



;// ../../node_modules/imask/esm/core/utils.js



/** Checks if value is string */

function isString(str) {
  return typeof str === 'string' || str instanceof String;
}
/**
  Direction
  @prop {string} NONE
  @prop {string} LEFT
  @prop {string} FORCE_LEFT
  @prop {string} RIGHT
  @prop {string} FORCE_RIGHT
*/

var DIRECTION = {
  NONE: 'NONE',
  LEFT: 'LEFT',
  FORCE_LEFT: 'FORCE_LEFT',
  RIGHT: 'RIGHT',
  FORCE_RIGHT: 'FORCE_RIGHT'
};
/**
  Direction
  @enum {string}
*/

/** Returns next char index in direction */
function indexInDirection(pos, direction) {
  if (direction === DIRECTION.LEFT) --pos;
  return pos;
}
/** Returns next char position in direction */

function posInDirection(pos, direction) {
  switch (direction) {
    case DIRECTION.LEFT:
    case DIRECTION.FORCE_LEFT:
      return --pos;

    case DIRECTION.RIGHT:
    case DIRECTION.FORCE_RIGHT:
      return ++pos;

    default:
      return pos;
  }
}
/** */

function forceDirection(direction) {
  switch (direction) {
    case DIRECTION.LEFT:
      return DIRECTION.FORCE_LEFT;

    case DIRECTION.RIGHT:
      return DIRECTION.FORCE_RIGHT;

    default:
      return direction;
  }
}
/** Escapes regular expression control chars */

function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
}
function normalizePrepare(prep) {
  return Array.isArray(prep) ? prep : [prep, new ChangeDetails()];
} // cloned from https://github.com/epoberezkin/fast-deep-equal with small changes

function objectIncludes(b, a) {
  if (a === b) return true;
  var arrA = Array.isArray(a),
      arrB = Array.isArray(b),
      i;

  if (arrA && arrB) {
    if (a.length != b.length) return false;

    for (i = 0; i < a.length; i++) {
      if (!objectIncludes(a[i], b[i])) return false;
    }

    return true;
  }

  if (arrA != arrB) return false;

  if (a && b && _typeof(a) === 'object' && _typeof(b) === 'object') {
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA && dateB) return a.getTime() == b.getTime();
    if (dateA != dateB) return false;
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA && regexpB) return a.toString() == b.toString();
    if (regexpA != regexpB) return false;
    var keys = Object.keys(a); // if (keys.length !== Object.keys(b).length) return false;

    for (i = 0; i < keys.length; i++) {
      // $FlowFixMe ... ???
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    }

    for (i = 0; i < keys.length; i++) {
      if (!objectIncludes(b[keys[i]], a[keys[i]])) return false;
    }

    return true;
  } else if (a && b && typeof a === 'function' && typeof b === 'function') {
    return a.toString() === b.toString();
  }

  return false;
}
/** Selection range */



;// ../../node_modules/imask/esm/core/action-details.js




/** Provides details of changing input */

var ActionDetails = /*#__PURE__*/function () {
  /** Current input value */

  /** Current cursor position */

  /** Old input value */

  /** Old selection */
  function ActionDetails(value, cursorPos, oldValue, oldSelection) {
    _classCallCheck(this, ActionDetails);

    this.value = value;
    this.cursorPos = cursorPos;
    this.oldValue = oldValue;
    this.oldSelection = oldSelection; // double check if left part was changed (autofilling, other non-standard input triggers)

    while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) {
      --this.oldSelection.start;
    }
  }
  /**
    Start changing position
    @readonly
  */


  _createClass(ActionDetails, [{
    key: "startChangePos",
    get: function get() {
      return Math.min(this.cursorPos, this.oldSelection.start);
    }
    /**
      Inserted symbols count
      @readonly
    */

  }, {
    key: "insertedCount",
    get: function get() {
      return this.cursorPos - this.startChangePos;
    }
    /**
      Inserted symbols
      @readonly
    */

  }, {
    key: "inserted",
    get: function get() {
      return this.value.substr(this.startChangePos, this.insertedCount);
    }
    /**
      Removed symbols count
      @readonly
    */

  }, {
    key: "removedCount",
    get: function get() {
      // Math.max for opposite operation
      return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
      this.oldValue.length - this.value.length, 0);
    }
    /**
      Removed symbols
      @readonly
    */

  }, {
    key: "removed",
    get: function get() {
      return this.oldValue.substr(this.startChangePos, this.removedCount);
    }
    /**
      Unchanged head symbols
      @readonly
    */

  }, {
    key: "head",
    get: function get() {
      return this.value.substring(0, this.startChangePos);
    }
    /**
      Unchanged tail symbols
      @readonly
    */

  }, {
    key: "tail",
    get: function get() {
      return this.value.substring(this.startChangePos + this.insertedCount);
    }
    /**
      Remove direction
      @readonly
    */

  }, {
    key: "removeDirection",
    get: function get() {
      if (!this.removedCount || this.insertedCount) return DIRECTION.NONE; // align right if delete at right

      return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
      this.oldSelection.end === this.oldSelection.start ? DIRECTION.RIGHT : DIRECTION.LEFT;
    }
  }]);

  return ActionDetails;
}();



;// ../../node_modules/imask/esm/core/continuous-tail-details.js


/** Provides details of continuous extracted tail */
var ContinuousTailDetails = /*#__PURE__*/function () {
  /** Tail value as string */

  /** Tail start position */

  /** Start position */
  function ContinuousTailDetails() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var stop = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, ContinuousTailDetails);

    this.value = value;
    this.from = from;
    this.stop = stop;
  }

  _createClass(ContinuousTailDetails, [{
    key: "toString",
    value: function toString() {
      return this.value;
    }
  }, {
    key: "extend",
    value: function extend(tail) {
      this.value += String(tail);
    }
  }, {
    key: "appendTo",
    value: function appendTo(masked) {
      return masked.append(this.toString(), {
        tail: true
      }).aggregate(masked._appendPlaceholder());
    }
  }, {
    key: "state",
    get: function get() {
      return {
        value: this.value,
        from: this.from,
        stop: this.stop
      };
    },
    set: function set(state) {
      Object.assign(this, state);
    }
  }, {
    key: "unshift",
    value: function unshift(beforePos) {
      if (!this.value.length || beforePos != null && this.from >= beforePos) return '';
      var shiftChar = this.value[0];
      this.value = this.value.slice(1);
      return shiftChar;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (!this.value.length) return '';
      var shiftChar = this.value[this.value.length - 1];
      this.value = this.value.slice(0, -1);
      return shiftChar;
    }
  }]);

  return ContinuousTailDetails;
}();



;// ../../node_modules/imask/esm/core/holder.js
/**
 * Applies mask on element.
 * @constructor
 * @param {HTMLInputElement|HTMLTextAreaElement|MaskElement} el - Element to apply mask
 * @param {Object} opts - Custom mask options
 * @return {InputMask}
 */
function IMask(el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // currently available only for input-like elements
  return new IMask.InputMask(el, opts);
}



;// ../../node_modules/imask/esm/masked/base.js






/** Supported mask type */

/** Provides common masking stuff */
var Masked = /*#__PURE__*/function () {
  // $Shape<MaskedOptions>; TODO after fix https://github.com/facebook/flow/issues/4773

  /** @type {Mask} */

  /** */
  // $FlowFixMe no ideas

  /** Transforms value before mask processing */

  /** Validates if value is acceptable */

  /** Does additional processing in the end of editing */

  /** Format typed value to string */

  /** Parse strgin to get typed value */

  /** Enable characters overwriting */

  /** */

  /** */
  function Masked(opts) {
    _classCallCheck(this, Masked);

    this._value = '';

    this._update(Object.assign({}, Masked.DEFAULTS, opts));

    this.isInitialized = true;
  }
  /** Sets and applies new options */


  _createClass(Masked, [{
    key: "updateOptions",
    value: function updateOptions(opts) {
      if (!Object.keys(opts).length) return; // $FlowFixMe

      this.withValueRefresh(this._update.bind(this, opts));
    }
    /**
      Sets new options
      @protected
    */

  }, {
    key: "_update",
    value: function _update(opts) {
      Object.assign(this, opts);
    }
    /** Mask state */

  }, {
    key: "state",
    get: function get() {
      return {
        _value: this.value
      };
    },
    set: function set(state) {
      this._value = state._value;
    }
    /** Resets value */

  }, {
    key: "reset",
    value: function reset() {
      this._value = '';
    }
    /** */

  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set(value) {
      this.resolve(value);
    }
    /** Resolve new value */

  }, {
    key: "resolve",
    value: function resolve(value) {
      this.reset();
      this.append(value, {
        input: true
      }, '');
      this.doCommit();
      return this.value;
    }
    /** */

  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      this.reset();
      this.append(value, {}, '');
      this.doCommit();
    }
    /** */

  }, {
    key: "typedValue",
    get: function get() {
      return this.doParse(this.value);
    },
    set: function set(value) {
      this.value = this.doFormat(value);
    }
    /** Value that includes raw user input */

  }, {
    key: "rawInputValue",
    get: function get() {
      return this.extractInput(0, this.value.length, {
        raw: true
      });
    },
    set: function set(value) {
      this.reset();
      this.append(value, {
        raw: true
      }, '');
      this.doCommit();
    }
    /** */

  }, {
    key: "isComplete",
    get: function get() {
      return true;
    }
    /** */

  }, {
    key: "isFilled",
    get: function get() {
      return this.isComplete;
    }
    /** Finds nearest input position in direction */

  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos, direction) {
      return cursorPos;
    }
    /** Extracts value in range considering flags */

  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      return this.value.slice(fromPos, toPos);
    }
    /** Extracts tail in range */

  }, {
    key: "extractTail",
    value: function extractTail() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
    }
    /** Appends tail */
    // $FlowFixMe no ideas

  }, {
    key: "appendTail",
    value: function appendTail(tail) {
      if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
      return tail.appendTo(this);
    }
    /** Appends char */

  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      if (!ch) return new ChangeDetails();
      this._value += ch;
      return new ChangeDetails({
        inserted: ch,
        rawInserted: ch
      });
    }
    /** Appends char */

  }, {
    key: "_appendChar",
    value: function _appendChar(ch) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var checkTail = arguments.length > 2 ? arguments[2] : undefined;
      var consistentState = this.state;
      var details;

      var _normalizePrepare = normalizePrepare(this.doPrepare(ch, flags));

      var _normalizePrepare2 = _slicedToArray(_normalizePrepare, 2);

      ch = _normalizePrepare2[0];
      details = _normalizePrepare2[1];
      details = details.aggregate(this._appendCharRaw(ch, flags));

      if (details.inserted) {
        var consistentTail;
        var appended = this.doValidate(flags) !== false;

        if (appended && checkTail != null) {
          // validation ok, check tail
          var beforeTailState = this.state;

          if (this.overwrite === true) {
            consistentTail = checkTail.state;
            checkTail.unshift(this.value.length);
          }

          var tailDetails = this.appendTail(checkTail);
          appended = tailDetails.rawInserted === checkTail.toString(); // not ok, try shift

          if (!(appended && tailDetails.inserted) && this.overwrite === 'shift') {
            this.state = beforeTailState;
            consistentTail = checkTail.state;
            checkTail.shift();
            tailDetails = this.appendTail(checkTail);
            appended = tailDetails.rawInserted === checkTail.toString();
          } // if ok, rollback state after tail


          if (appended && tailDetails.inserted) this.state = beforeTailState;
        } // revert all if something went wrong


        if (!appended) {
          details = new ChangeDetails();
          this.state = consistentState;
          if (checkTail && consistentTail) checkTail.state = consistentTail;
        }
      }

      return details;
    }
    /** Appends optional placeholder at end */

  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      return new ChangeDetails();
    }
    /** Appends optional eager placeholder at end */

  }, {
    key: "_appendEager",
    value: function _appendEager() {
      return new ChangeDetails();
    }
    /** Appends symbols considering flags */
    // $FlowFixMe no ideas

  }, {
    key: "append",
    value: function append(str, flags, tail) {
      if (!isString(str)) throw new Error('value should be string');
      var details = new ChangeDetails();
      var checkTail = isString(tail) ? new ContinuousTailDetails(String(tail)) : tail;
      if (flags !== null && flags !== void 0 && flags.tail) flags._beforeTailState = this.state;

      for (var ci = 0; ci < str.length; ++ci) {
        details.aggregate(this._appendChar(str[ci], flags, checkTail));
      } // append tail but aggregate only tailShift


      if (checkTail != null) {
        details.tailShift += this.appendTail(checkTail).tailShift; // TODO it's a good idea to clear state after appending ends
        // but it causes bugs when one append calls another (when dynamic dispatch set rawInputValue)
        // this._resetBeforeTailState();
      }

      if (this.eager && flags !== null && flags !== void 0 && flags.input && str) {
        details.aggregate(this._appendEager());
      }

      return details;
    }
    /** */

  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      this._value = this.value.slice(0, fromPos) + this.value.slice(toPos);
      return new ChangeDetails();
    }
    /** Calls function and reapplies current value */

  }, {
    key: "withValueRefresh",
    value: function withValueRefresh(fn) {
      if (this._refreshing || !this.isInitialized) return fn();
      this._refreshing = true;
      var rawInput = this.rawInputValue;
      var value = this.value;
      var ret = fn();
      this.rawInputValue = rawInput; // append lost trailing chars at end

      if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
        this.append(value.slice(this.value.length), {}, '');
      }

      delete this._refreshing;
      return ret;
    }
    /** */

  }, {
    key: "runIsolated",
    value: function runIsolated(fn) {
      if (this._isolated || !this.isInitialized) return fn(this);
      this._isolated = true;
      var state = this.state;
      var ret = fn(this);
      this.state = state;
      delete this._isolated;
      return ret;
    }
    /**
      Prepares string before mask processing
      @protected
    */

  }, {
    key: "doPrepare",
    value: function doPrepare(str) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.prepare ? this.prepare(str, this, flags) : str;
    }
    /**
      Validates if value is acceptable
      @protected
    */

  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
    }
    /**
      Does additional processing in the end of editing
      @protected
    */

  }, {
    key: "doCommit",
    value: function doCommit() {
      if (this.commit) this.commit(this.value, this);
    }
    /** */

  }, {
    key: "doFormat",
    value: function doFormat(value) {
      return this.format ? this.format(value, this) : value;
    }
    /** */

  }, {
    key: "doParse",
    value: function doParse(str) {
      return this.parse ? this.parse(str, this) : str;
    }
    /** */

  }, {
    key: "splice",
    value: function splice(start, deleteCount, inserted, removeDirection) {
      var flags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        input: true
      };
      var tailPos = start + deleteCount;
      var tail = this.extractTail(tailPos);
      var oldRawValue;

      if (this.eager) {
        removeDirection = forceDirection(removeDirection);
        oldRawValue = this.extractInput(0, tailPos, {
          raw: true
        });
      }

      var startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !this.eager ? DIRECTION.NONE : removeDirection);
      var details = new ChangeDetails({
        tailShift: startChangePos - start // adjust tailShift if start was aligned

      }).aggregate(this.remove(startChangePos));

      if (this.eager && removeDirection !== DIRECTION.NONE && oldRawValue === this.rawInputValue) {
        if (removeDirection === DIRECTION.FORCE_LEFT) {
          var valLength;

          while (oldRawValue === this.rawInputValue && (valLength = this.value.length)) {
            details.aggregate(new ChangeDetails({
              tailShift: -1
            })).aggregate(this.remove(valLength - 1));
          }
        } else if (removeDirection === DIRECTION.FORCE_RIGHT) {
          tail.unshift();
        }
      }

      return details.aggregate(this.append(inserted, flags, tail));
    }
  }, {
    key: "maskEquals",
    value: function maskEquals(mask) {
      return this.mask === mask;
    }
  }, {
    key: "typedValueEquals",
    value: function typedValueEquals(value) {
      var tval = this.typedValue;
      return value === tval || Masked.EMPTY_VALUES.includes(value) && Masked.EMPTY_VALUES.includes(tval) || this.doFormat(value) === this.doFormat(this.typedValue);
    }
  }]);

  return Masked;
}();
Masked.DEFAULTS = {
  format: function format(v) {
    return v;
  },
  parse: function parse(v) {
    return v;
  }
};
Masked.EMPTY_VALUES = [undefined, null, ''];
IMask.Masked = Masked;



;// ../../node_modules/imask/esm/masked/factory.js





/** Get Masked class by mask type */

function maskedClass(mask) {
  if (mask == null) {
    throw new Error('mask property should be defined');
  } // $FlowFixMe


  if (mask instanceof RegExp) return IMask.MaskedRegExp; // $FlowFixMe

  if (isString(mask)) return IMask.MaskedPattern; // $FlowFixMe

  if (mask instanceof Date || mask === Date) return IMask.MaskedDate; // $FlowFixMe

  if (mask instanceof Number || typeof mask === 'number' || mask === Number) return IMask.MaskedNumber; // $FlowFixMe

  if (Array.isArray(mask) || mask === Array) return IMask.MaskedDynamic; // $FlowFixMe

  if (IMask.Masked && mask.prototype instanceof IMask.Masked) return mask; // $FlowFixMe

  if (mask instanceof IMask.Masked) return mask.constructor; // $FlowFixMe

  if (mask instanceof Function) return IMask.MaskedFunction;
  console.warn('Mask not found for mask', mask); // eslint-disable-line no-console
  // $FlowFixMe

  return IMask.Masked;
}
/** Creates new {@link Masked} depending on mask type */

function createMask(opts) {
  // $FlowFixMe
  if (IMask.Masked && opts instanceof IMask.Masked) return opts;
  opts = Object.assign({}, opts);
  var mask = opts.mask; // $FlowFixMe

  if (IMask.Masked && mask instanceof IMask.Masked) return mask;
  var MaskedClass = maskedClass(mask);
  if (!MaskedClass) throw new Error('Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.');
  return new MaskedClass(opts);
}
IMask.createMask = createMask;



;// ../../node_modules/imask/esm/masked/pattern/input-definition.js






var _excluded = ["mask"];
var DEFAULT_INPUT_DEFINITIONS = {
  '0': /\d/,
  'a': /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  '*': /./
};
/** */

var PatternInputDefinition = /*#__PURE__*/function () {
  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  /** */
  function PatternInputDefinition(opts) {
    _classCallCheck(this, PatternInputDefinition);

    var mask = opts.mask,
        blockOpts = _objectWithoutProperties(opts, _excluded);

    this.masked = createMask({
      mask: mask
    });
    Object.assign(this, blockOpts);
  }

  _createClass(PatternInputDefinition, [{
    key: "reset",
    value: function reset() {
      this.isFilled = false;
      this.masked.reset();
    }
  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

      if (fromPos === 0 && toPos >= 1) {
        this.isFilled = false;
        return this.masked.remove(fromPos, toPos);
      }

      return new ChangeDetails();
    }
  }, {
    key: "value",
    get: function get() {
      return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : '');
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.masked.unmaskedValue;
    }
  }, {
    key: "isComplete",
    get: function get() {
      return Boolean(this.masked.value) || this.isOptional;
    }
  }, {
    key: "_appendChar",
    value: function _appendChar(ch) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.isFilled) return new ChangeDetails();
      var state = this.masked.state; // simulate input

      var details = this.masked._appendChar(ch, flags);

      if (details.inserted && this.doValidate(flags) === false) {
        details.inserted = details.rawInserted = '';
        this.masked.state = state;
      }

      if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) {
        details.inserted = this.placeholderChar;
      }

      details.skip = !details.inserted && !this.isOptional;
      this.isFilled = Boolean(details.inserted);
      return details;
    }
  }, {
    key: "append",
    value: function append() {
      var _this$masked;

      // TODO probably should be done via _appendChar
      return (_this$masked = this.masked).append.apply(_this$masked, arguments);
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      var details = new ChangeDetails();
      if (this.isFilled || this.isOptional) return details;
      this.isFilled = true;
      details.inserted = this.placeholderChar;
      return details;
    }
  }, {
    key: "_appendEager",
    value: function _appendEager() {
      return new ChangeDetails();
    }
  }, {
    key: "extractTail",
    value: function extractTail() {
      var _this$masked2;

      return (_this$masked2 = this.masked).extractTail.apply(_this$masked2, arguments);
    }
  }, {
    key: "appendTail",
    value: function appendTail() {
      var _this$masked3;

      return (_this$masked3 = this.masked).appendTail.apply(_this$masked3, arguments);
    }
  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      var flags = arguments.length > 2 ? arguments[2] : undefined;
      return this.masked.extractInput(fromPos, toPos, flags);
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos) {
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
      var minPos = 0;
      var maxPos = this.value.length;
      var boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);

      switch (direction) {
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT:
          return this.isComplete ? boundPos : minPos;

        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT:
          return this.isComplete ? boundPos : maxPos;

        case DIRECTION.NONE:
        default:
          return boundPos;
      }
    }
  }, {
    key: "doValidate",
    value: function doValidate() {
      var _this$masked4, _this$parent;

      return (_this$masked4 = this.masked).doValidate.apply(_this$masked4, arguments) && (!this.parent || (_this$parent = this.parent).doValidate.apply(_this$parent, arguments));
    }
  }, {
    key: "doCommit",
    value: function doCommit() {
      this.masked.doCommit();
    }
  }, {
    key: "state",
    get: function get() {
      return {
        masked: this.masked.state,
        isFilled: this.isFilled
      };
    },
    set: function set(state) {
      this.masked.state = state.masked;
      this.isFilled = state.isFilled;
    }
  }]);

  return PatternInputDefinition;
}();



;// ../../node_modules/imask/esm/masked/pattern/fixed-definition.js





var PatternFixedDefinition = /*#__PURE__*/function () {
  /** */

  /** */

  /** */

  /** */

  /** */

  /** */
  function PatternFixedDefinition(opts) {
    _classCallCheck(this, PatternFixedDefinition);

    Object.assign(this, opts);
    this._value = '';
    this.isFixed = true;
  }

  _createClass(PatternFixedDefinition, [{
    key: "value",
    get: function get() {
      return this._value;
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.isUnmasking ? this.value : '';
    }
  }, {
    key: "reset",
    value: function reset() {
      this._isRawInput = false;
      this._value = '';
    }
  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
      this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
      if (!this._value) this._isRawInput = false;
      return new ChangeDetails();
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos) {
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
      var minPos = 0;
      var maxPos = this._value.length;

      switch (direction) {
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT:
          return minPos;

        case DIRECTION.NONE:
        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT:
        default:
          return maxPos;
      }
    }
  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
      var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || '';
    }
  }, {
    key: "isComplete",
    get: function get() {
      return true;
    }
  }, {
    key: "isFilled",
    get: function get() {
      return Boolean(this._value);
    }
  }, {
    key: "_appendChar",
    value: function _appendChar(ch) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var details = new ChangeDetails();
      if (this._value) return details;
      var appended = this.char === ch;
      var isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !this.eager) && !flags.tail;
      if (isResolved) details.rawInserted = this.char;
      this._value = details.inserted = this.char;
      this._isRawInput = isResolved && (flags.raw || flags.input);
      return details;
    }
  }, {
    key: "_appendEager",
    value: function _appendEager() {
      return this._appendChar(this.char, {
        tail: true
      });
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      var details = new ChangeDetails();
      if (this._value) return details;
      this._value = details.inserted = this.char;
      return details;
    }
  }, {
    key: "extractTail",
    value: function extractTail() {
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      return new ContinuousTailDetails('');
    } // $FlowFixMe no ideas

  }, {
    key: "appendTail",
    value: function appendTail(tail) {
      if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
      return tail.appendTo(this);
    }
  }, {
    key: "append",
    value: function append(str, flags, tail) {
      var details = this._appendChar(str[0], flags);

      if (tail != null) {
        details.tailShift += this.appendTail(tail).tailShift;
      }

      return details;
    }
  }, {
    key: "doCommit",
    value: function doCommit() {}
  }, {
    key: "state",
    get: function get() {
      return {
        _value: this._value,
        _isRawInput: this._isRawInput
      };
    },
    set: function set(state) {
      Object.assign(this, state);
    }
  }]);

  return PatternFixedDefinition;
}();



;// ../../node_modules/imask/esm/masked/pattern/chunk-tail-details.js






var chunk_tail_details_excluded = ["chunks"];

var ChunksTailDetails = /*#__PURE__*/function () {
  /** */
  function ChunksTailDetails() {
    var chunks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, ChunksTailDetails);

    this.chunks = chunks;
    this.from = from;
  }

  _createClass(ChunksTailDetails, [{
    key: "toString",
    value: function toString() {
      return this.chunks.map(String).join('');
    } // $FlowFixMe no ideas

  }, {
    key: "extend",
    value: function extend(tailChunk) {
      if (!String(tailChunk)) return;
      if (isString(tailChunk)) tailChunk = new ContinuousTailDetails(String(tailChunk));
      var lastChunk = this.chunks[this.chunks.length - 1];
      var extendLast = lastChunk && ( // if stops are same or tail has no stop
      lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
      tailChunk.from === lastChunk.from + lastChunk.toString().length;

      if (tailChunk instanceof ContinuousTailDetails) {
        // check the ability to extend previous chunk
        if (extendLast) {
          // extend previous chunk
          lastChunk.extend(tailChunk.toString());
        } else {
          // append new chunk
          this.chunks.push(tailChunk);
        }
      } else if (tailChunk instanceof ChunksTailDetails) {
        if (tailChunk.stop == null) {
          // unwrap floating chunks to parent, keeping `from` pos
          var firstTailChunk;

          while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
            firstTailChunk = tailChunk.chunks.shift();
            firstTailChunk.from += tailChunk.from;
            this.extend(firstTailChunk);
          }
        } // if tail chunk still has value


        if (tailChunk.toString()) {
          // if chunks contains stops, then popup stop to container
          tailChunk.stop = tailChunk.blockIndex;
          this.chunks.push(tailChunk);
        }
      }
    }
  }, {
    key: "appendTo",
    value: function appendTo(masked) {
      // $FlowFixMe
      if (!(masked instanceof IMask.MaskedPattern)) {
        var tail = new ContinuousTailDetails(this.toString());
        return tail.appendTo(masked);
      }

      var details = new ChangeDetails();

      for (var ci = 0; ci < this.chunks.length && !details.skip; ++ci) {
        var chunk = this.chunks[ci];

        var lastBlockIter = masked._mapPosToBlock(masked.value.length);

        var stop = chunk.stop;
        var chunkBlock = void 0;

        if (stop != null && ( // if block not found or stop is behind lastBlock
        !lastBlockIter || lastBlockIter.index <= stop)) {
          if (chunk instanceof ChunksTailDetails || // for continuous block also check if stop is exist
          masked._stops.indexOf(stop) >= 0) {
            details.aggregate(masked._appendPlaceholder(stop));
          }

          chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop];
        }

        if (chunkBlock) {
          var tailDetails = chunkBlock.appendTail(chunk);
          tailDetails.skip = false; // always ignore skip, it will be set on last

          details.aggregate(tailDetails);
          masked._value += tailDetails.inserted; // get not inserted chars

          var remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
          if (remainChars) details.aggregate(masked.append(remainChars, {
            tail: true
          }));
        } else {
          details.aggregate(masked.append(chunk.toString(), {
            tail: true
          }));
        }
      }
      return details;
    }
  }, {
    key: "state",
    get: function get() {
      return {
        chunks: this.chunks.map(function (c) {
          return c.state;
        }),
        from: this.from,
        stop: this.stop,
        blockIndex: this.blockIndex
      };
    },
    set: function set(state) {
      var chunks = state.chunks,
          props = _objectWithoutProperties(state, chunk_tail_details_excluded);

      Object.assign(this, props);
      this.chunks = chunks.map(function (cstate) {
        var chunk = "chunks" in cstate ? new ChunksTailDetails() : new ContinuousTailDetails(); // $FlowFixMe already checked above

        chunk.state = cstate;
        return chunk;
      });
    }
  }, {
    key: "unshift",
    value: function unshift(beforePos) {
      if (!this.chunks.length || beforePos != null && this.from >= beforePos) return '';
      var chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
      var ci = 0;

      while (ci < this.chunks.length) {
        var chunk = this.chunks[ci];
        var shiftChar = chunk.unshift(chunkShiftPos);

        if (chunk.toString()) {
          // chunk still contains value
          // but not shifted - means no more available chars to shift
          if (!shiftChar) break;
          ++ci;
        } else {
          // clean if chunk has no value
          this.chunks.splice(ci, 1);
        }

        if (shiftChar) return shiftChar;
      }

      return '';
    }
  }, {
    key: "shift",
    value: function shift() {
      if (!this.chunks.length) return '';
      var ci = this.chunks.length - 1;

      while (0 <= ci) {
        var chunk = this.chunks[ci];
        var shiftChar = chunk.shift();

        if (chunk.toString()) {
          // chunk still contains value
          // but not shifted - means no more available chars to shift
          if (!shiftChar) break;
          --ci;
        } else {
          // clean if chunk has no value
          this.chunks.splice(ci, 1);
        }

        if (shiftChar) return shiftChar;
      }

      return '';
    }
  }]);

  return ChunksTailDetails;
}();



;// ../../node_modules/imask/esm/masked/pattern/cursor.js




var PatternCursor = /*#__PURE__*/function () {
  function PatternCursor(masked, pos) {
    _classCallCheck(this, PatternCursor);

    this.masked = masked;
    this._log = [];

    var _ref = masked._mapPosToBlock(pos) || (pos < 0 ? // first
    {
      index: 0,
      offset: 0
    } : // last
    {
      index: this.masked._blocks.length,
      offset: 0
    }),
        offset = _ref.offset,
        index = _ref.index;

    this.offset = offset;
    this.index = index;
    this.ok = false;
  }

  _createClass(PatternCursor, [{
    key: "block",
    get: function get() {
      return this.masked._blocks[this.index];
    }
  }, {
    key: "pos",
    get: function get() {
      return this.masked._blockStartPos(this.index) + this.offset;
    }
  }, {
    key: "state",
    get: function get() {
      return {
        index: this.index,
        offset: this.offset,
        ok: this.ok
      };
    },
    set: function set(s) {
      Object.assign(this, s);
    }
  }, {
    key: "pushState",
    value: function pushState() {
      this._log.push(this.state);
    }
  }, {
    key: "popState",
    value: function popState() {
      var s = this._log.pop();

      this.state = s;
      return s;
    }
  }, {
    key: "bindBlock",
    value: function bindBlock() {
      if (this.block) return;

      if (this.index < 0) {
        this.index = 0;
        this.offset = 0;
      }

      if (this.index >= this.masked._blocks.length) {
        this.index = this.masked._blocks.length - 1;
        this.offset = this.block.value.length;
      }
    }
  }, {
    key: "_pushLeft",
    value: function _pushLeft(fn) {
      this.pushState();

      for (this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) === null || _this$block === void 0 ? void 0 : _this$block.value.length) || 0) {
        var _this$block;

        if (fn()) return this.ok = true;
      }

      return this.ok = false;
    }
  }, {
    key: "_pushRight",
    value: function _pushRight(fn) {
      this.pushState();

      for (this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0) {
        if (fn()) return this.ok = true;
      }

      return this.ok = false;
    }
  }, {
    key: "pushLeftBeforeFilled",
    value: function pushLeftBeforeFilled() {
      var _this = this;

      return this._pushLeft(function () {
        if (_this.block.isFixed || !_this.block.value) return;
        _this.offset = _this.block.nearestInputPos(_this.offset, DIRECTION.FORCE_LEFT);
        if (_this.offset !== 0) return true;
      });
    }
  }, {
    key: "pushLeftBeforeInput",
    value: function pushLeftBeforeInput() {
      var _this2 = this;

      // cases:
      // filled input: 00|
      // optional empty input: 00[]|
      // nested block: XX<[]>|
      return this._pushLeft(function () {
        if (_this2.block.isFixed) return;
        _this2.offset = _this2.block.nearestInputPos(_this2.offset, DIRECTION.LEFT);
        return true;
      });
    }
  }, {
    key: "pushLeftBeforeRequired",
    value: function pushLeftBeforeRequired() {
      var _this3 = this;

      return this._pushLeft(function () {
        if (_this3.block.isFixed || _this3.block.isOptional && !_this3.block.value) return;
        _this3.offset = _this3.block.nearestInputPos(_this3.offset, DIRECTION.LEFT);
        return true;
      });
    }
  }, {
    key: "pushRightBeforeFilled",
    value: function pushRightBeforeFilled() {
      var _this4 = this;

      return this._pushRight(function () {
        if (_this4.block.isFixed || !_this4.block.value) return;
        _this4.offset = _this4.block.nearestInputPos(_this4.offset, DIRECTION.FORCE_RIGHT);
        if (_this4.offset !== _this4.block.value.length) return true;
      });
    }
  }, {
    key: "pushRightBeforeInput",
    value: function pushRightBeforeInput() {
      var _this5 = this;

      return this._pushRight(function () {
        if (_this5.block.isFixed) return; // const o = this.offset;

        _this5.offset = _this5.block.nearestInputPos(_this5.offset, DIRECTION.NONE); // HACK cases like (STILL DOES NOT WORK FOR NESTED)
        // aa|X
        // aa<X|[]>X_    - this will not work
        // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;

        return true;
      });
    }
  }, {
    key: "pushRightBeforeRequired",
    value: function pushRightBeforeRequired() {
      var _this6 = this;

      return this._pushRight(function () {
        if (_this6.block.isFixed || _this6.block.isOptional && !_this6.block.value) return; // TODO check |[*]XX_

        _this6.offset = _this6.block.nearestInputPos(_this6.offset, DIRECTION.NONE);
        return true;
      });
    }
  }]);

  return PatternCursor;
}();



;// ../../node_modules/imask/esm/masked/regexp.js







/** Masking by RegExp */

var MaskedRegExp = /*#__PURE__*/function (_Masked) {
  _inherits(MaskedRegExp, _Masked);

  var _super = _createSuper(MaskedRegExp);

  function MaskedRegExp() {
    _classCallCheck(this, MaskedRegExp);

    return _super.apply(this, arguments);
  }

  _createClass(MaskedRegExp, [{
    key: "_update",
    value:
    /**
      @override
      @param {Object} opts
    */
    function _update(opts) {
      if (opts.mask) opts.validate = function (value) {
        return value.search(opts.mask) >= 0;
      };

      _get(_getPrototypeOf(MaskedRegExp.prototype), "_update", this).call(this, opts);
    }
  }]);

  return MaskedRegExp;
}(Masked);
IMask.MaskedRegExp = MaskedRegExp;



;// ../../node_modules/imask/esm/masked/pattern.js













var pattern_excluded = ["_blocks"];

/**
  Pattern mask
  @param {Object} opts
  @param {Object} opts.blocks
  @param {Object} opts.definitions
  @param {string} opts.placeholderChar
  @param {boolean} opts.lazy
*/
var MaskedPattern = /*#__PURE__*/function (_Masked) {
  _inherits(MaskedPattern, _Masked);

  var _super = _createSuper(MaskedPattern);

  /** */

  /** */

  /** Single char for empty input */

  /** Show placeholder only when needed */
  function MaskedPattern() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MaskedPattern);

    // TODO type $Shape<MaskedPatternOptions>={} does not work
    opts.definitions = Object.assign({}, DEFAULT_INPUT_DEFINITIONS, opts.definitions);
    return _super.call(this, Object.assign({}, MaskedPattern.DEFAULTS, opts));
  }
  /**
    @override
    @param {Object} opts
  */


  _createClass(MaskedPattern, [{
    key: "_update",
    value: function _update() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      opts.definitions = Object.assign({}, this.definitions, opts.definitions);

      _get(_getPrototypeOf(MaskedPattern.prototype), "_update", this).call(this, opts);

      this._rebuildMask();
    }
    /** */

  }, {
    key: "_rebuildMask",
    value: function _rebuildMask() {
      var _this = this;

      var defs = this.definitions;
      this._blocks = [];
      this._stops = [];
      this._maskedBlocks = {};
      var pattern = this.mask;
      if (!pattern || !defs) return;
      var unmaskingBlock = false;
      var optionalBlock = false;

      for (var i = 0; i < pattern.length; ++i) {
        if (this.blocks) {
          var _ret = function () {
            var p = pattern.slice(i);
            var bNames = Object.keys(_this.blocks).filter(function (bName) {
              return p.indexOf(bName) === 0;
            }); // order by key length

            bNames.sort(function (a, b) {
              return b.length - a.length;
            }); // use block name with max length

            var bName = bNames[0];

            if (bName) {
              // $FlowFixMe no ideas
              var maskedBlock = createMask(Object.assign({
                parent: _this,
                lazy: _this.lazy,
                eager: _this.eager,
                placeholderChar: _this.placeholderChar,
                overwrite: _this.overwrite
              }, _this.blocks[bName]));

              if (maskedBlock) {
                _this._blocks.push(maskedBlock); // store block index


                if (!_this._maskedBlocks[bName]) _this._maskedBlocks[bName] = [];

                _this._maskedBlocks[bName].push(_this._blocks.length - 1);
              }

              i += bName.length - 1;
              return "continue";
            }
          }();

          if (_ret === "continue") continue;
        }

        var char = pattern[i];
        var isInput = (char in defs);

        if (char === MaskedPattern.STOP_CHAR) {
          this._stops.push(this._blocks.length);

          continue;
        }

        if (char === '{' || char === '}') {
          unmaskingBlock = !unmaskingBlock;
          continue;
        }

        if (char === '[' || char === ']') {
          optionalBlock = !optionalBlock;
          continue;
        }

        if (char === MaskedPattern.ESCAPE_CHAR) {
          ++i;
          char = pattern[i];
          if (!char) break;
          isInput = false;
        }

        var def = isInput ? new PatternInputDefinition({
          parent: this,
          lazy: this.lazy,
          eager: this.eager,
          placeholderChar: this.placeholderChar,
          mask: defs[char],
          isOptional: optionalBlock
        }) : new PatternFixedDefinition({
          char: char,
          eager: this.eager,
          isUnmasking: unmaskingBlock
        });

        this._blocks.push(def);
      }
    }
    /**
      @override
    */

  }, {
    key: "state",
    get: function get() {
      return Object.assign({}, _get(_getPrototypeOf(MaskedPattern.prototype), "state", this), {
        _blocks: this._blocks.map(function (b) {
          return b.state;
        })
      });
    },
    set: function set(state) {
      var _blocks = state._blocks,
          maskedState = _objectWithoutProperties(state, pattern_excluded);

      this._blocks.forEach(function (b, bi) {
        return b.state = _blocks[bi];
      });

      _set(_getPrototypeOf(MaskedPattern.prototype), "state", maskedState, this, true);
    }
    /**
      @override
    */

  }, {
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(MaskedPattern.prototype), "reset", this).call(this);

      this._blocks.forEach(function (b) {
        return b.reset();
      });
    }
    /**
      @override
    */

  }, {
    key: "isComplete",
    get: function get() {
      return this._blocks.every(function (b) {
        return b.isComplete;
      });
    }
    /**
      @override
    */

  }, {
    key: "isFilled",
    get: function get() {
      return this._blocks.every(function (b) {
        return b.isFilled;
      });
    }
  }, {
    key: "isFixed",
    get: function get() {
      return this._blocks.every(function (b) {
        return b.isFixed;
      });
    }
  }, {
    key: "isOptional",
    get: function get() {
      return this._blocks.every(function (b) {
        return b.isOptional;
      });
    }
    /**
      @override
    */

  }, {
    key: "doCommit",
    value: function doCommit() {
      this._blocks.forEach(function (b) {
        return b.doCommit();
      });

      _get(_getPrototypeOf(MaskedPattern.prototype), "doCommit", this).call(this);
    }
    /**
      @override
    */

  }, {
    key: "unmaskedValue",
    get: function get() {
      return this._blocks.reduce(function (str, b) {
        return str += b.unmaskedValue;
      }, '');
    },
    set: function set(unmaskedValue) {
      _set(_getPrototypeOf(MaskedPattern.prototype), "unmaskedValue", unmaskedValue, this, true);
    }
    /**
      @override
    */

  }, {
    key: "value",
    get: function get() {
      // TODO return _value when not in change?
      return this._blocks.reduce(function (str, b) {
        return str += b.value;
      }, '');
    },
    set: function set(value) {
      _set(_getPrototypeOf(MaskedPattern.prototype), "value", value, this, true);
    }
    /**
      @override
    */

  }, {
    key: "appendTail",
    value: function appendTail(tail) {
      return _get(_getPrototypeOf(MaskedPattern.prototype), "appendTail", this).call(this, tail).aggregate(this._appendPlaceholder());
    }
    /**
      @override
    */

  }, {
    key: "_appendEager",
    value: function _appendEager() {
      var _this$_mapPosToBlock;

      var details = new ChangeDetails();
      var startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.value.length)) === null || _this$_mapPosToBlock === void 0 ? void 0 : _this$_mapPosToBlock.index;
      if (startBlockIndex == null) return details; // TODO test if it works for nested pattern masks

      if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;

      for (var bi = startBlockIndex; bi < this._blocks.length; ++bi) {
        var d = this._blocks[bi]._appendEager();

        if (!d.inserted) break;
        details.aggregate(d);
      }

      return details;
    }
    /**
      @override
    */

  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var blockIter = this._mapPosToBlock(this.value.length);

      var details = new ChangeDetails();
      if (!blockIter) return details;

      for (var bi = blockIter.index;; ++bi) {
        var _flags$_beforeTailSta, _flags$_beforeTailSta2;

        var _block = this._blocks[bi];
        if (!_block) break;

        var blockDetails = _block._appendChar(ch, Object.assign({}, flags, {
          _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : (_flags$_beforeTailSta2 = _flags$_beforeTailSta._blocks) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2[bi]
        }));

        var skip = blockDetails.skip;
        details.aggregate(blockDetails);
        if (skip || blockDetails.rawInserted) break; // go next char
      }

      return details;
    }
    /**
      @override
    */

  }, {
    key: "extractTail",
    value: function extractTail() {
      var _this2 = this;

      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      var chunkTail = new ChunksTailDetails();
      if (fromPos === toPos) return chunkTail;

      this._forEachBlocksInRange(fromPos, toPos, function (b, bi, bFromPos, bToPos) {
        var blockChunk = b.extractTail(bFromPos, bToPos);
        blockChunk.stop = _this2._findStopBefore(bi);
        blockChunk.from = _this2._blockStartPos(bi);
        if (blockChunk instanceof ChunksTailDetails) blockChunk.blockIndex = bi;
        chunkTail.extend(blockChunk);
      });

      return chunkTail;
    }
    /**
      @override
    */

  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (fromPos === toPos) return '';
      var input = '';

      this._forEachBlocksInRange(fromPos, toPos, function (b, _, fromPos, toPos) {
        input += b.extractInput(fromPos, toPos, flags);
      });

      return input;
    }
  }, {
    key: "_findStopBefore",
    value: function _findStopBefore(blockIndex) {
      var stopBefore;

      for (var si = 0; si < this._stops.length; ++si) {
        var stop = this._stops[si];
        if (stop <= blockIndex) stopBefore = stop;else break;
      }

      return stopBefore;
    }
    /** Appends placeholder depending on laziness */

  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder(toBlockIndex) {
      var _this3 = this;

      var details = new ChangeDetails();
      if (this.lazy && toBlockIndex == null) return details;

      var startBlockIter = this._mapPosToBlock(this.value.length);

      if (!startBlockIter) return details;
      var startBlockIndex = startBlockIter.index;
      var endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;

      this._blocks.slice(startBlockIndex, endBlockIndex).forEach(function (b) {
        if (!b.lazy || toBlockIndex != null) {
          // $FlowFixMe `_blocks` may not be present
          var args = b._blocks != null ? [b._blocks.length] : [];

          var bDetails = b._appendPlaceholder.apply(b, args);

          _this3._value += bDetails.inserted;
          details.aggregate(bDetails);
        }
      });

      return details;
    }
    /** Finds block in pos */

  }, {
    key: "_mapPosToBlock",
    value: function _mapPosToBlock(pos) {
      var accVal = '';

      for (var bi = 0; bi < this._blocks.length; ++bi) {
        var _block2 = this._blocks[bi];
        var blockStartPos = accVal.length;
        accVal += _block2.value;

        if (pos <= accVal.length) {
          return {
            index: bi,
            offset: pos - blockStartPos
          };
        }
      }
    }
    /** */

  }, {
    key: "_blockStartPos",
    value: function _blockStartPos(blockIndex) {
      return this._blocks.slice(0, blockIndex).reduce(function (pos, b) {
        return pos += b.value.length;
      }, 0);
    }
    /** */

  }, {
    key: "_forEachBlocksInRange",
    value: function _forEachBlocksInRange(fromPos) {
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      var fn = arguments.length > 2 ? arguments[2] : undefined;

      var fromBlockIter = this._mapPosToBlock(fromPos);

      if (fromBlockIter) {
        var toBlockIter = this._mapPosToBlock(toPos); // process first block


        var isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
        var fromBlockStartPos = fromBlockIter.offset;
        var fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].value.length;
        fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);

        if (toBlockIter && !isSameBlock) {
          // process intermediate blocks
          for (var bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
            fn(this._blocks[bi], bi, 0, this._blocks[bi].value.length);
          } // process last block


          fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
        }
      }
    }
    /**
      @override
    */

  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

      var removeDetails = _get(_getPrototypeOf(MaskedPattern.prototype), "remove", this).call(this, fromPos, toPos);

      this._forEachBlocksInRange(fromPos, toPos, function (b, _, bFromPos, bToPos) {
        removeDetails.aggregate(b.remove(bFromPos, bToPos));
      });

      return removeDetails;
    }
    /**
      @override
    */

  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos) {
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
      if (!this._blocks.length) return 0;
      var cursor = new PatternCursor(this, cursorPos);

      if (direction === DIRECTION.NONE) {
        // -------------------------------------------------
        // NONE should only go out from fixed to the right!
        // -------------------------------------------------
        if (cursor.pushRightBeforeInput()) return cursor.pos;
        cursor.popState();
        if (cursor.pushLeftBeforeInput()) return cursor.pos;
        return this.value.length;
      } // FORCE is only about a|* otherwise is 0


      if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
        // try to break fast when *|a
        if (direction === DIRECTION.LEFT) {
          cursor.pushRightBeforeFilled();
          if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
          cursor.popState();
        } // forward flow


        cursor.pushLeftBeforeInput();
        cursor.pushLeftBeforeRequired();
        cursor.pushLeftBeforeFilled(); // backward flow

        if (direction === DIRECTION.LEFT) {
          cursor.pushRightBeforeInput();
          cursor.pushRightBeforeRequired();
          if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
          cursor.popState();
          if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
          cursor.popState();
        }

        if (cursor.ok) return cursor.pos;
        if (direction === DIRECTION.FORCE_LEFT) return 0;
        cursor.popState();
        if (cursor.ok) return cursor.pos;
        cursor.popState();
        if (cursor.ok) return cursor.pos; // cursor.popState();
        // if (
        //   cursor.pushRightBeforeInput() &&
        //   // TODO HACK for lazy if has aligned left inside fixed and has came to the start - use start position
        //   (!this.lazy || this.extractInput())
        // ) return cursor.pos;

        return 0;
      }

      if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
        // forward flow
        cursor.pushRightBeforeInput();
        cursor.pushRightBeforeRequired();
        if (cursor.pushRightBeforeFilled()) return cursor.pos;
        if (direction === DIRECTION.FORCE_RIGHT) return this.value.length; // backward flow

        cursor.popState();
        if (cursor.ok) return cursor.pos;
        cursor.popState();
        if (cursor.ok) return cursor.pos;
        return this.nearestInputPos(cursorPos, DIRECTION.LEFT);
      }

      return cursorPos;
    }
    /** Get block by name */

  }, {
    key: "maskedBlock",
    value: function maskedBlock(name) {
      return this.maskedBlocks(name)[0];
    }
    /** Get all blocks by name */

  }, {
    key: "maskedBlocks",
    value: function maskedBlocks(name) {
      var _this4 = this;

      var indices = this._maskedBlocks[name];
      if (!indices) return [];
      return indices.map(function (gi) {
        return _this4._blocks[gi];
      });
    }
  }]);

  return MaskedPattern;
}(Masked);
MaskedPattern.DEFAULTS = {
  lazy: true,
  placeholderChar: '_'
};
MaskedPattern.STOP_CHAR = '`';
MaskedPattern.ESCAPE_CHAR = '\\';
MaskedPattern.InputDefinition = PatternInputDefinition;
MaskedPattern.FixedDefinition = PatternFixedDefinition;
IMask.MaskedPattern = MaskedPattern;



;// ../../node_modules/imask/esm/masked/range.js














/** Pattern which accepts ranges */

var MaskedRange = /*#__PURE__*/function (_MaskedPattern) {
  _inherits(MaskedRange, _MaskedPattern);

  var _super = _createSuper(MaskedRange);

  function MaskedRange() {
    _classCallCheck(this, MaskedRange);

    return _super.apply(this, arguments);
  }

  _createClass(MaskedRange, [{
    key: "_matchFrom",
    get:
    /**
      Optionally sets max length of pattern.
      Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
    */

    /** Min bound */

    /** Max bound */

    /** */
    function get() {
      return this.maxLength - String(this.from).length;
    }
    /**
      @override
    */

  }, {
    key: "_update",
    value: function _update(opts) {
      // TODO type
      opts = Object.assign({
        to: this.to || 0,
        from: this.from || 0,
        maxLength: this.maxLength || 0
      }, opts);
      var maxLength = String(opts.to).length;
      if (opts.maxLength != null) maxLength = Math.max(maxLength, opts.maxLength);
      opts.maxLength = maxLength;
      var fromStr = String(opts.from).padStart(maxLength, '0');
      var toStr = String(opts.to).padStart(maxLength, '0');
      var sameCharsCount = 0;

      while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) {
        ++sameCharsCount;
      }

      opts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(maxLength - sameCharsCount);

      _get(_getPrototypeOf(MaskedRange.prototype), "_update", this).call(this, opts);
    }
    /**
      @override
    */

  }, {
    key: "isComplete",
    get: function get() {
      return _get(_getPrototypeOf(MaskedRange.prototype), "isComplete", this) && Boolean(this.value);
    }
  }, {
    key: "boundaries",
    value: function boundaries(str) {
      var minstr = '';
      var maxstr = '';

      var _ref = str.match(/^(\D*)(\d*)(\D*)/) || [],
          _ref2 = _slicedToArray(_ref, 3),
          placeholder = _ref2[1],
          num = _ref2[2];

      if (num) {
        minstr = '0'.repeat(placeholder.length) + num;
        maxstr = '9'.repeat(placeholder.length) + num;
      }

      minstr = minstr.padEnd(this.maxLength, '0');
      maxstr = maxstr.padEnd(this.maxLength, '9');
      return [minstr, maxstr];
    } // TODO str is a single char everytime

    /**
      @override
    */

  }, {
    key: "doPrepare",
    value: function doPrepare(ch) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var details;

      var _normalizePrepare = normalizePrepare(_get(_getPrototypeOf(MaskedRange.prototype), "doPrepare", this).call(this, ch.replace(/\D/g, ''), flags));

      var _normalizePrepare2 = _slicedToArray(_normalizePrepare, 2);

      ch = _normalizePrepare2[0];
      details = _normalizePrepare2[1];
      if (!this.autofix || !ch) return ch;
      var fromStr = String(this.from).padStart(this.maxLength, '0');
      var toStr = String(this.to).padStart(this.maxLength, '0');
      var nextVal = this.value + ch;
      if (nextVal.length > this.maxLength) return '';

      var _this$boundaries = this.boundaries(nextVal),
          _this$boundaries2 = _slicedToArray(_this$boundaries, 2),
          minstr = _this$boundaries2[0],
          maxstr = _this$boundaries2[1];

      if (Number(maxstr) < this.from) return fromStr[nextVal.length - 1];

      if (Number(minstr) > this.to) {
        if (this.autofix === 'pad' && nextVal.length < this.maxLength) {
          return ['', details.aggregate(this.append(fromStr[nextVal.length - 1] + ch, flags))];
        }

        return toStr[nextVal.length - 1];
      }

      return ch;
    }
    /**
      @override
    */

  }, {
    key: "doValidate",
    value: function doValidate() {
      var _get2;

      var str = this.value;
      var firstNonZero = str.search(/[^0]/);
      if (firstNonZero === -1 && str.length <= this._matchFrom) return true;

      var _this$boundaries3 = this.boundaries(str),
          _this$boundaries4 = _slicedToArray(_this$boundaries3, 2),
          minstr = _this$boundaries4[0],
          maxstr = _this$boundaries4[1];

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.from <= Number(maxstr) && Number(minstr) <= this.to && (_get2 = _get(_getPrototypeOf(MaskedRange.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args));
    }
  }]);

  return MaskedRange;
}(MaskedPattern);
IMask.MaskedRange = MaskedRange;



;// ../../node_modules/imask/esm/masked/date.js















/** Date mask */

var MaskedDate = /*#__PURE__*/function (_MaskedPattern) {
  _inherits(MaskedDate, _MaskedPattern);

  var _super = _createSuper(MaskedDate);

  /** Pattern mask for date according to {@link MaskedDate#format} */

  /** Start date */

  /** End date */

  /** */

  /**
    @param {Object} opts
  */
  function MaskedDate(opts) {
    _classCallCheck(this, MaskedDate);

    return _super.call(this, Object.assign({}, MaskedDate.DEFAULTS, opts));
  }
  /**
    @override
  */


  _createClass(MaskedDate, [{
    key: "_update",
    value: function _update(opts) {
      if (opts.mask === Date) delete opts.mask;
      if (opts.pattern) opts.mask = opts.pattern;
      var blocks = opts.blocks;
      opts.blocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS()); // adjust year block

      if (opts.min) opts.blocks.Y.from = opts.min.getFullYear();
      if (opts.max) opts.blocks.Y.to = opts.max.getFullYear();

      if (opts.min && opts.max && opts.blocks.Y.from === opts.blocks.Y.to) {
        opts.blocks.m.from = opts.min.getMonth() + 1;
        opts.blocks.m.to = opts.max.getMonth() + 1;

        if (opts.blocks.m.from === opts.blocks.m.to) {
          opts.blocks.d.from = opts.min.getDate();
          opts.blocks.d.to = opts.max.getDate();
        }
      }

      Object.assign(opts.blocks, this.blocks, blocks); // add autofix

      Object.keys(opts.blocks).forEach(function (bk) {
        var b = opts.blocks[bk];
        if (!('autofix' in b) && 'autofix' in opts) b.autofix = opts.autofix;
      });

      _get(_getPrototypeOf(MaskedDate.prototype), "_update", this).call(this, opts);
    }
    /**
      @override
    */

  }, {
    key: "doValidate",
    value: function doValidate() {
      var _get2;

      var date = this.date;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_get2 = _get(_getPrototypeOf(MaskedDate.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args)) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
    }
    /** Checks if date is exists */

  }, {
    key: "isDateExist",
    value: function isDateExist(str) {
      return this.format(this.parse(str, this), this).indexOf(str) >= 0;
    }
    /** Parsed Date */

  }, {
    key: "date",
    get: function get() {
      return this.typedValue;
    },
    set: function set(date) {
      this.typedValue = date;
    }
    /**
      @override
    */

  }, {
    key: "typedValue",
    get: function get() {
      return this.isComplete ? _get(_getPrototypeOf(MaskedDate.prototype), "typedValue", this) : null;
    },
    set: function set(value) {
      _set(_getPrototypeOf(MaskedDate.prototype), "typedValue", value, this, true);
    }
    /**
      @override
    */

  }, {
    key: "maskEquals",
    value: function maskEquals(mask) {
      return mask === Date || _get(_getPrototypeOf(MaskedDate.prototype), "maskEquals", this).call(this, mask);
    }
  }]);

  return MaskedDate;
}(MaskedPattern);
MaskedDate.DEFAULTS = {
  pattern: 'd{.}`m{.}`Y',
  format: function format(date) {
    if (!date) return '';
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    return [day, month, year].join('.');
  },
  parse: function parse(str) {
    var _str$split = str.split('.'),
        _str$split2 = _slicedToArray(_str$split, 3),
        day = _str$split2[0],
        month = _str$split2[1],
        year = _str$split2[2];

    return new Date(year, month - 1, day);
  }
};

MaskedDate.GET_DEFAULT_BLOCKS = function () {
  return {
    d: {
      mask: MaskedRange,
      from: 1,
      to: 31,
      maxLength: 2
    },
    m: {
      mask: MaskedRange,
      from: 1,
      to: 12,
      maxLength: 2
    },
    Y: {
      mask: MaskedRange,
      from: 1900,
      to: 9999
    }
  };
};

IMask.MaskedDate = MaskedDate;



;// ../../node_modules/imask/esm/controls/mask-element.js



/**
  Generic element API to use with mask
  @interface
*/
var MaskElement = /*#__PURE__*/function () {
  function MaskElement() {
    _classCallCheck(this, MaskElement);
  }

  _createClass(MaskElement, [{
    key: "selectionStart",
    get:
    /** */

    /** */

    /** */

    /** Safely returns selection start */
    function get() {
      var start;

      try {
        start = this._unsafeSelectionStart;
      } catch (e) {}

      return start != null ? start : this.value.length;
    }
    /** Safely returns selection end */

  }, {
    key: "selectionEnd",
    get: function get() {
      var end;

      try {
        end = this._unsafeSelectionEnd;
      } catch (e) {}

      return end != null ? end : this.value.length;
    }
    /** Safely sets element selection */

  }, {
    key: "select",
    value: function select(start, end) {
      if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;

      try {
        this._unsafeSelect(start, end);
      } catch (e) {}
    }
    /** Should be overriden in subclasses */

  }, {
    key: "_unsafeSelect",
    value: function _unsafeSelect(start, end) {}
    /** Should be overriden in subclasses */

  }, {
    key: "isActive",
    get: function get() {
      return false;
    }
    /** Should be overriden in subclasses */

  }, {
    key: "bindEvents",
    value: function bindEvents(handlers) {}
    /** Should be overriden in subclasses */

  }, {
    key: "unbindEvents",
    value: function unbindEvents() {}
  }]);

  return MaskElement;
}();
IMask.MaskElement = MaskElement;



;// ../../node_modules/imask/esm/controls/html-mask-element.js




/** Bridge between HTMLElement and {@link Masked} */

var HTMLMaskElement = /*#__PURE__*/function (_MaskElement) {
  _inherits(HTMLMaskElement, _MaskElement);

  var _super = _createSuper(HTMLMaskElement);

  /** Mapping between HTMLElement events and mask internal events */

  /** HTMLElement to use mask on */

  /**
    @param {HTMLInputElement|HTMLTextAreaElement} input
  */
  function HTMLMaskElement(input) {
    var _this;

    _classCallCheck(this, HTMLMaskElement);

    _this = _super.call(this);
    _this.input = input;
    _this._handlers = {};
    return _this;
  }
  /** */
  // $FlowFixMe https://github.com/facebook/flow/issues/2839


  _createClass(HTMLMaskElement, [{
    key: "rootElement",
    get: function get() {
      var _this$input$getRootNo, _this$input$getRootNo2, _this$input;

      return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) === null || _this$input$getRootNo2 === void 0 ? void 0 : _this$input$getRootNo2.call(_this$input)) !== null && _this$input$getRootNo !== void 0 ? _this$input$getRootNo : document;
    }
    /**
      Is element in focus
      @readonly
    */

  }, {
    key: "isActive",
    get: function get() {
      //$FlowFixMe
      return this.input === this.rootElement.activeElement;
    }
    /**
      Returns HTMLElement selection start
      @override
    */

  }, {
    key: "_unsafeSelectionStart",
    get: function get() {
      return this.input.selectionStart;
    }
    /**
      Returns HTMLElement selection end
      @override
    */

  }, {
    key: "_unsafeSelectionEnd",
    get: function get() {
      return this.input.selectionEnd;
    }
    /**
      Sets HTMLElement selection
      @override
    */

  }, {
    key: "_unsafeSelect",
    value: function _unsafeSelect(start, end) {
      this.input.setSelectionRange(start, end);
    }
    /**
      HTMLElement value
      @override
    */

  }, {
    key: "value",
    get: function get() {
      return this.input.value;
    },
    set: function set(value) {
      this.input.value = value;
    }
    /**
      Binds HTMLElement events to mask internal events
      @override
    */

  }, {
    key: "bindEvents",
    value: function bindEvents(handlers) {
      var _this2 = this;

      Object.keys(handlers).forEach(function (event) {
        return _this2._toggleEventHandler(HTMLMaskElement.EVENTS_MAP[event], handlers[event]);
      });
    }
    /**
      Unbinds HTMLElement events to mask internal events
      @override
    */

  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      var _this3 = this;

      Object.keys(this._handlers).forEach(function (event) {
        return _this3._toggleEventHandler(event);
      });
    }
    /** */

  }, {
    key: "_toggleEventHandler",
    value: function _toggleEventHandler(event, handler) {
      if (this._handlers[event]) {
        this.input.removeEventListener(event, this._handlers[event]);
        delete this._handlers[event];
      }

      if (handler) {
        this.input.addEventListener(event, handler);
        this._handlers[event] = handler;
      }
    }
  }]);

  return HTMLMaskElement;
}(MaskElement);
HTMLMaskElement.EVENTS_MAP = {
  selectionChange: 'keydown',
  input: 'input',
  drop: 'drop',
  click: 'click',
  focus: 'focus',
  commit: 'blur'
};
IMask.HTMLMaskElement = HTMLMaskElement;



;// ../../node_modules/imask/esm/controls/html-contenteditable-mask-element.js





var HTMLContenteditableMaskElement = /*#__PURE__*/function (_HTMLMaskElement) {
  _inherits(HTMLContenteditableMaskElement, _HTMLMaskElement);

  var _super = _createSuper(HTMLContenteditableMaskElement);

  function HTMLContenteditableMaskElement() {
    _classCallCheck(this, HTMLContenteditableMaskElement);

    return _super.apply(this, arguments);
  }

  _createClass(HTMLContenteditableMaskElement, [{
    key: "_unsafeSelectionStart",
    get:
    /**
      Returns HTMLElement selection start
      @override
    */
    function get() {
      var root = this.rootElement;
      var selection = root.getSelection && root.getSelection();
      var anchorOffset = selection && selection.anchorOffset;
      var focusOffset = selection && selection.focusOffset;

      if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) {
        return anchorOffset;
      }

      return focusOffset;
    }
    /**
      Returns HTMLElement selection end
      @override
    */

  }, {
    key: "_unsafeSelectionEnd",
    get: function get() {
      var root = this.rootElement;
      var selection = root.getSelection && root.getSelection();
      var anchorOffset = selection && selection.anchorOffset;
      var focusOffset = selection && selection.focusOffset;

      if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) {
        return anchorOffset;
      }

      return focusOffset;
    }
    /**
      Sets HTMLElement selection
      @override
    */

  }, {
    key: "_unsafeSelect",
    value: function _unsafeSelect(start, end) {
      if (!this.rootElement.createRange) return;
      var range = this.rootElement.createRange();
      range.setStart(this.input.firstChild || this.input, start);
      range.setEnd(this.input.lastChild || this.input, end);
      var root = this.rootElement;
      var selection = root.getSelection && root.getSelection();

      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
    /**
      HTMLElement value
      @override
    */

  }, {
    key: "value",
    get: function get() {
      // $FlowFixMe
      return this.input.textContent;
    },
    set: function set(value) {
      this.input.textContent = value;
    }
  }]);

  return HTMLContenteditableMaskElement;
}(HTMLMaskElement);
IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;



;// ../../node_modules/imask/esm/controls/input.js




















var input_excluded = ["mask"];
/** Listens to element events and controls changes between element and {@link Masked} */

var InputMask = /*#__PURE__*/function () {
  /**
    View element
    @readonly
  */

  /**
    Internal {@link Masked} model
    @readonly
  */

  /**
    @param {MaskElement|HTMLInputElement|HTMLTextAreaElement} el
    @param {Object} opts
  */
  function InputMask(el, opts) {
    _classCallCheck(this, InputMask);

    this.el = el instanceof MaskElement ? el : el.isContentEditable && el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA' ? new HTMLContenteditableMaskElement(el) : new HTMLMaskElement(el);
    this.masked = createMask(opts);
    this._listeners = {};
    this._value = '';
    this._unmaskedValue = '';
    this._saveSelection = this._saveSelection.bind(this);
    this._onInput = this._onInput.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onDrop = this._onDrop.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onClick = this._onClick.bind(this);
    this.alignCursor = this.alignCursor.bind(this);
    this.alignCursorFriendly = this.alignCursorFriendly.bind(this);

    this._bindEvents(); // refresh


    this.updateValue();

    this._onChange();
  }
  /** Read or update mask */


  _createClass(InputMask, [{
    key: "mask",
    get: function get() {
      return this.masked.mask;
    },
    set: function set(mask) {
      if (this.maskEquals(mask)) return; // $FlowFixMe No ideas ... after update

      if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
        this.masked.updateOptions({
          mask: mask
        });
        return;
      }

      var masked = createMask({
        mask: mask
      });
      masked.unmaskedValue = this.masked.unmaskedValue;
      this.masked = masked;
    }
    /** Raw value */

  }, {
    key: "maskEquals",
    value: function maskEquals(mask) {
      var _this$masked;

      return mask == null || ((_this$masked = this.masked) === null || _this$masked === void 0 ? void 0 : _this$masked.maskEquals(mask));
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set(str) {
      if (this.value === str) return;
      this.masked.value = str;
      this.updateControl();
      this.alignCursor();
    }
    /** Unmasked value */

  }, {
    key: "unmaskedValue",
    get: function get() {
      return this._unmaskedValue;
    },
    set: function set(str) {
      if (this.unmaskedValue === str) return;
      this.masked.unmaskedValue = str;
      this.updateControl();
      this.alignCursor();
    }
    /** Typed unmasked value */

  }, {
    key: "typedValue",
    get: function get() {
      return this.masked.typedValue;
    },
    set: function set(val) {
      if (this.masked.typedValueEquals(val)) return;
      this.masked.typedValue = val;
      this.updateControl();
      this.alignCursor();
    }
    /**
      Starts listening to element events
      @protected
    */

  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      this.el.bindEvents({
        selectionChange: this._saveSelection,
        input: this._onInput,
        drop: this._onDrop,
        click: this._onClick,
        focus: this._onFocus,
        commit: this._onChange
      });
    }
    /**
      Stops listening to element events
      @protected
     */

  }, {
    key: "_unbindEvents",
    value: function _unbindEvents() {
      if (this.el) this.el.unbindEvents();
    }
    /**
      Fires custom event
      @protected
     */

  }, {
    key: "_fireEvent",
    value: function _fireEvent(ev) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var listeners = this._listeners[ev];
      if (!listeners) return;
      listeners.forEach(function (l) {
        return l.apply(void 0, args);
      });
    }
    /**
      Current selection start
      @readonly
    */

  }, {
    key: "selectionStart",
    get: function get() {
      return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
    }
    /** Current cursor position */

  }, {
    key: "cursorPos",
    get: function get() {
      return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
    },
    set: function set(pos) {
      if (!this.el || !this.el.isActive) return;
      this.el.select(pos, pos);

      this._saveSelection();
    }
    /**
      Stores current selection
      @protected
    */

  }, {
    key: "_saveSelection",
    value: function
      /* ev */
    _saveSelection() {
      if (this.value !== this.el.value) {
        console.warn('Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.'); // eslint-disable-line no-console
      }

      this._selection = {
        start: this.selectionStart,
        end: this.cursorPos
      };
    }
    /** Syncronizes model value from view */

  }, {
    key: "updateValue",
    value: function updateValue() {
      this.masked.value = this.el.value;
      this._value = this.masked.value;
    }
    /** Syncronizes view from model value, fires change events */

  }, {
    key: "updateControl",
    value: function updateControl() {
      var newUnmaskedValue = this.masked.unmaskedValue;
      var newValue = this.masked.value;
      var isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue;
      this._unmaskedValue = newUnmaskedValue;
      this._value = newValue;
      if (this.el.value !== newValue) this.el.value = newValue;
      if (isChanged) this._fireChangeEvents();
    }
    /** Updates options with deep equal check, recreates @{link Masked} model if mask type changes */

  }, {
    key: "updateOptions",
    value: function updateOptions(opts) {
      var mask = opts.mask,
          restOpts = _objectWithoutProperties(opts, input_excluded);

      var updateMask = !this.maskEquals(mask);
      var updateOpts = !objectIncludes(this.masked, restOpts);
      if (updateMask) this.mask = mask;
      if (updateOpts) this.masked.updateOptions(restOpts);
      if (updateMask || updateOpts) this.updateControl();
    }
    /** Updates cursor */

  }, {
    key: "updateCursor",
    value: function updateCursor(cursorPos) {
      if (cursorPos == null) return;
      this.cursorPos = cursorPos; // also queue change cursor for mobile browsers

      this._delayUpdateCursor(cursorPos);
    }
    /**
      Delays cursor update to support mobile browsers
      @private
    */

  }, {
    key: "_delayUpdateCursor",
    value: function _delayUpdateCursor(cursorPos) {
      var _this = this;

      this._abortUpdateCursor();

      this._changingCursorPos = cursorPos;
      this._cursorChanging = setTimeout(function () {
        if (!_this.el) return; // if was destroyed

        _this.cursorPos = _this._changingCursorPos;

        _this._abortUpdateCursor();
      }, 10);
    }
    /**
      Fires custom events
      @protected
    */

  }, {
    key: "_fireChangeEvents",
    value: function _fireChangeEvents() {
      this._fireEvent('accept', this._inputEvent);

      if (this.masked.isComplete) this._fireEvent('complete', this._inputEvent);
    }
    /**
      Aborts delayed cursor update
      @private
    */

  }, {
    key: "_abortUpdateCursor",
    value: function _abortUpdateCursor() {
      if (this._cursorChanging) {
        clearTimeout(this._cursorChanging);
        delete this._cursorChanging;
      }
    }
    /** Aligns cursor to nearest available position */

  }, {
    key: "alignCursor",
    value: function alignCursor() {
      this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT));
    }
    /** Aligns cursor only if selection is empty */

  }, {
    key: "alignCursorFriendly",
    value: function alignCursorFriendly() {
      if (this.selectionStart !== this.cursorPos) return; // skip if range is selected

      this.alignCursor();
    }
    /** Adds listener on custom event */

  }, {
    key: "on",
    value: function on(ev, handler) {
      if (!this._listeners[ev]) this._listeners[ev] = [];

      this._listeners[ev].push(handler);

      return this;
    }
    /** Removes custom event listener */

  }, {
    key: "off",
    value: function off(ev, handler) {
      if (!this._listeners[ev]) return this;

      if (!handler) {
        delete this._listeners[ev];
        return this;
      }

      var hIndex = this._listeners[ev].indexOf(handler);

      if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
      return this;
    }
    /** Handles view input event */

  }, {
    key: "_onInput",
    value: function _onInput(e) {
      this._inputEvent = e;

      this._abortUpdateCursor(); // fix strange IE behavior


      if (!this._selection) return this.updateValue();
      var details = new ActionDetails( // new state
      this.el.value, this.cursorPos, // old state
      this.value, this._selection);
      var oldRawValue = this.masked.rawInputValue;
      var offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
        input: true,
        raw: true
      }).offset; // force align in remove direction only if no input chars were removed
      // otherwise we still need to align with NONE (to get out from fixed symbols for instance)

      var removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
      var cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
      if (removeDirection !== DIRECTION.NONE) cursorPos = this.masked.nearestInputPos(cursorPos, DIRECTION.NONE);
      this.updateControl();
      this.updateCursor(cursorPos);
      delete this._inputEvent;
    }
    /** Handles view change event and commits model value */

  }, {
    key: "_onChange",
    value: function _onChange() {
      if (this.value !== this.el.value) {
        this.updateValue();
      }

      this.masked.doCommit();
      this.updateControl();

      this._saveSelection();
    }
    /** Handles view drop event, prevents by default */

  }, {
    key: "_onDrop",
    value: function _onDrop(ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }
    /** Restore last selection on focus */

  }, {
    key: "_onFocus",
    value: function _onFocus(ev) {
      this.alignCursorFriendly();
    }
    /** Restore last selection on focus */

  }, {
    key: "_onClick",
    value: function _onClick(ev) {
      this.alignCursorFriendly();
    }
    /** Unbind view events and removes element reference */

  }, {
    key: "destroy",
    value: function destroy() {
      this._unbindEvents(); // $FlowFixMe why not do so?


      this._listeners.length = 0; // $FlowFixMe

      delete this.el;
    }
  }]);

  return InputMask;
}();
IMask.InputMask = InputMask;



;// ../../node_modules/imask/esm/masked/enum.js














/** Pattern which validates enum values */

var MaskedEnum = /*#__PURE__*/function (_MaskedPattern) {
  _inherits(MaskedEnum, _MaskedPattern);

  var _super = _createSuper(MaskedEnum);

  function MaskedEnum() {
    _classCallCheck(this, MaskedEnum);

    return _super.apply(this, arguments);
  }

  _createClass(MaskedEnum, [{
    key: "_update",
    value:
    /**
      @override
      @param {Object} opts
    */
    function _update(opts) {
      // TODO type
      if (opts.enum) opts.mask = '*'.repeat(opts.enum[0].length);

      _get(_getPrototypeOf(MaskedEnum.prototype), "_update", this).call(this, opts);
    }
    /**
      @override
    */

  }, {
    key: "doValidate",
    value: function doValidate() {
      var _this = this,
          _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.enum.some(function (e) {
        return e.indexOf(_this.unmaskedValue) >= 0;
      }) && (_get2 = _get(_getPrototypeOf(MaskedEnum.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args));
    }
  }]);

  return MaskedEnum;
}(MaskedPattern);
IMask.MaskedEnum = MaskedEnum;



;// ../../node_modules/imask/esm/masked/number.js







/**
  Number mask
  @param {Object} opts
  @param {string} opts.radix - Single char
  @param {string} opts.thousandsSeparator - Single char
  @param {Array<string>} opts.mapToRadix - Array of single chars
  @param {number} opts.min
  @param {number} opts.max
  @param {number} opts.scale - Digits after point
  @param {boolean} opts.signed - Allow negative
  @param {boolean} opts.normalizeZeros - Flag to remove leading and trailing zeros in the end of editing
  @param {boolean} opts.padFractionalZeros - Flag to pad trailing zeros after point in the end of editing
*/
var MaskedNumber = /*#__PURE__*/function (_Masked) {
  _inherits(MaskedNumber, _Masked);

  var _super = _createSuper(MaskedNumber);

  /** Single char */

  /** Single char */

  /** Array of single chars */

  /** */

  /** */

  /** Digits after point */

  /** */

  /** Flag to remove leading and trailing zeros in the end of editing */

  /** Flag to pad trailing zeros after point in the end of editing */
  function MaskedNumber(opts) {
    _classCallCheck(this, MaskedNumber);

    return _super.call(this, Object.assign({}, MaskedNumber.DEFAULTS, opts));
  }
  /**
    @override
  */


  _createClass(MaskedNumber, [{
    key: "_update",
    value: function _update(opts) {
      _get(_getPrototypeOf(MaskedNumber.prototype), "_update", this).call(this, opts);

      this._updateRegExps();
    }
    /** */

  }, {
    key: "_updateRegExps",
    value: function _updateRegExps() {
      // use different regexp to process user input (more strict, input suffix) and tail shifting
      var start = '^' + (this.allowNegative ? '[+|\\-]?' : '');
      var midInput = '(0|([1-9]+\\d*))?';
      var mid = '\\d*';
      var end = (this.scale ? '(' + escapeRegExp(this.radix) + '\\d{0,' + this.scale + '})?' : '') + '$';
      this._numberRegExpInput = new RegExp(start + midInput + end);
      this._numberRegExp = new RegExp(start + mid + end);
      this._mapToRadixRegExp = new RegExp('[' + this.mapToRadix.map(escapeRegExp).join('') + ']', 'g');
      this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), 'g');
    }
    /** */

  }, {
    key: "_removeThousandsSeparators",
    value: function _removeThousandsSeparators(value) {
      return value.replace(this._thousandsSeparatorRegExp, '');
    }
    /** */

  }, {
    key: "_insertThousandsSeparators",
    value: function _insertThousandsSeparators(value) {
      // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
      var parts = value.split(this.radix);
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
      return parts.join(this.radix);
    }
    /**
      @override
    */

  }, {
    key: "doPrepare",
    value: function doPrepare(ch) {
      var _get2;

      ch = ch.replace(this._mapToRadixRegExp, this.radix);

      var noSepCh = this._removeThousandsSeparators(ch);

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var _normalizePrepare = normalizePrepare((_get2 = _get(_getPrototypeOf(MaskedNumber.prototype), "doPrepare", this)).call.apply(_get2, [this, noSepCh].concat(args))),
          _normalizePrepare2 = _slicedToArray(_normalizePrepare, 2),
          prepCh = _normalizePrepare2[0],
          details = _normalizePrepare2[1];

      if (ch && !noSepCh) details.skip = true;
      return [prepCh, details];
    }
    /** */

  }, {
    key: "_separatorsCount",
    value: function _separatorsCount(to) {
      var extendOnSeparators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var count = 0;

      for (var pos = 0; pos < to; ++pos) {
        if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
          ++count;
          if (extendOnSeparators) to += this.thousandsSeparator.length;
        }
      }

      return count;
    }
    /** */

  }, {
    key: "_separatorsCountFromSlice",
    value: function _separatorsCountFromSlice() {
      var slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._value;
      return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
    }
    /**
      @override
    */

  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      var flags = arguments.length > 2 ? arguments[2] : undefined;

      var _this$_adjustRangeWit = this._adjustRangeWithSeparators(fromPos, toPos);

      var _this$_adjustRangeWit2 = _slicedToArray(_this$_adjustRangeWit, 2);

      fromPos = _this$_adjustRangeWit2[0];
      toPos = _this$_adjustRangeWit2[1];
      return this._removeThousandsSeparators(_get(_getPrototypeOf(MaskedNumber.prototype), "extractInput", this).call(this, fromPos, toPos, flags));
    }
    /**
      @override
    */

  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.thousandsSeparator) return _get(_getPrototypeOf(MaskedNumber.prototype), "_appendCharRaw", this).call(this, ch, flags);
      var prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;

      var prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);

      this._value = this._removeThousandsSeparators(this.value);

      var appendDetails = _get(_getPrototypeOf(MaskedNumber.prototype), "_appendCharRaw", this).call(this, ch, flags);

      this._value = this._insertThousandsSeparators(this._value);
      var beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;

      var beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);

      appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
      appendDetails.skip = !appendDetails.rawInserted && ch === this.thousandsSeparator;
      return appendDetails;
    }
    /** */

  }, {
    key: "_findSeparatorAround",
    value: function _findSeparatorAround(pos) {
      if (this.thousandsSeparator) {
        var searchFrom = pos - this.thousandsSeparator.length + 1;
        var separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
        if (separatorPos <= pos) return separatorPos;
      }

      return -1;
    }
  }, {
    key: "_adjustRangeWithSeparators",
    value: function _adjustRangeWithSeparators(from, to) {
      var separatorAroundFromPos = this._findSeparatorAround(from);

      if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;

      var separatorAroundToPos = this._findSeparatorAround(to);

      if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
      return [from, to];
    }
    /**
      @override
    */

  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

      var _this$_adjustRangeWit3 = this._adjustRangeWithSeparators(fromPos, toPos);

      var _this$_adjustRangeWit4 = _slicedToArray(_this$_adjustRangeWit3, 2);

      fromPos = _this$_adjustRangeWit4[0];
      toPos = _this$_adjustRangeWit4[1];
      var valueBeforePos = this.value.slice(0, fromPos);
      var valueAfterPos = this.value.slice(toPos);

      var prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);

      this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));

      var beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);

      return new ChangeDetails({
        tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
      });
    }
    /**
      @override
    */

  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos, direction) {
      if (!this.thousandsSeparator) return cursorPos;

      switch (direction) {
        case DIRECTION.NONE:
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT:
          {
            var separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);

            if (separatorAtLeftPos >= 0) {
              var separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;

              if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) {
                return separatorAtLeftPos;
              }
            }

            break;
          }

        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT:
          {
            var separatorAtRightPos = this._findSeparatorAround(cursorPos);

            if (separatorAtRightPos >= 0) {
              return separatorAtRightPos + this.thousandsSeparator.length;
            }
          }
      }

      return cursorPos;
    }
    /**
      @override
    */

  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      var regexp = flags.input ? this._numberRegExpInput : this._numberRegExp; // validate as string

      var valid = regexp.test(this._removeThousandsSeparators(this.value));

      if (valid) {
        // validate as number
        var number = this.number;
        valid = valid && !isNaN(number) && ( // check min bound for negative values
        this.min == null || this.min >= 0 || this.min <= this.number) && ( // check max bound for positive values
        this.max == null || this.max <= 0 || this.number <= this.max);
      }

      return valid && _get(_getPrototypeOf(MaskedNumber.prototype), "doValidate", this).call(this, flags);
    }
    /**
      @override
    */

  }, {
    key: "doCommit",
    value: function doCommit() {
      if (this.value) {
        var number = this.number;
        var validnum = number; // check bounds

        if (this.min != null) validnum = Math.max(validnum, this.min);
        if (this.max != null) validnum = Math.min(validnum, this.max);
        if (validnum !== number) this.unmaskedValue = String(validnum);
        var formatted = this.value;
        if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
        if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
        this._value = formatted;
      }

      _get(_getPrototypeOf(MaskedNumber.prototype), "doCommit", this).call(this);
    }
    /** */

  }, {
    key: "_normalizeZeros",
    value: function _normalizeZeros(value) {
      var parts = this._removeThousandsSeparators(value).split(this.radix); // remove leading zeros


      parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, function (match, sign, zeros, num) {
        return sign + num;
      }); // add leading zero

      if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + '0';

      if (parts.length > 1) {
        parts[1] = parts[1].replace(/0*$/, ''); // remove trailing zeros

        if (!parts[1].length) parts.length = 1; // remove fractional
      }

      return this._insertThousandsSeparators(parts.join(this.radix));
    }
    /** */

  }, {
    key: "_padFractionalZeros",
    value: function _padFractionalZeros(value) {
      if (!value) return value;
      var parts = value.split(this.radix);
      if (parts.length < 2) parts.push('');
      parts[1] = parts[1].padEnd(this.scale, '0');
      return parts.join(this.radix);
    }
    /**
      @override
    */

  }, {
    key: "unmaskedValue",
    get: function get() {
      return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, '.');
    },
    set: function set(unmaskedValue) {
      _set(_getPrototypeOf(MaskedNumber.prototype), "unmaskedValue", unmaskedValue.replace('.', this.radix), this, true);
    }
    /**
      @override
    */

  }, {
    key: "typedValue",
    get: function get() {
      return Number(this.unmaskedValue);
    },
    set: function set(n) {
      _set(_getPrototypeOf(MaskedNumber.prototype), "unmaskedValue", String(n), this, true);
    }
    /** Parsed Number */

  }, {
    key: "number",
    get: function get() {
      return this.typedValue;
    },
    set: function set(number) {
      this.typedValue = number;
    }
    /**
      Is negative allowed
      @readonly
    */

  }, {
    key: "allowNegative",
    get: function get() {
      return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
    }
    /**
      @override
    */

  }, {
    key: "typedValueEquals",
    value: function typedValueEquals(value) {
      // handle  0 -> '' case (typed = 0 even if value = '')
      // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
      return (_get(_getPrototypeOf(MaskedNumber.prototype), "typedValueEquals", this).call(this, value) || MaskedNumber.EMPTY_VALUES.includes(value) && MaskedNumber.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === '');
    }
  }]);

  return MaskedNumber;
}(Masked);
MaskedNumber.DEFAULTS = {
  radix: ',',
  thousandsSeparator: '',
  mapToRadix: ['.'],
  scale: 2,
  signed: false,
  normalizeZeros: true,
  padFractionalZeros: false
};
MaskedNumber.EMPTY_VALUES = [].concat(_toConsumableArray(Masked.EMPTY_VALUES), [0]);
IMask.MaskedNumber = MaskedNumber;



;// ../../node_modules/imask/esm/masked/function.js







/** Masking by custom Function */

var MaskedFunction = /*#__PURE__*/function (_Masked) {
  _inherits(MaskedFunction, _Masked);

  var _super = _createSuper(MaskedFunction);

  function MaskedFunction() {
    _classCallCheck(this, MaskedFunction);

    return _super.apply(this, arguments);
  }

  _createClass(MaskedFunction, [{
    key: "_update",
    value:
    /**
      @override
      @param {Object} opts
    */
    function _update(opts) {
      if (opts.mask) opts.validate = opts.mask;

      _get(_getPrototypeOf(MaskedFunction.prototype), "_update", this).call(this, opts);
    }
  }]);

  return MaskedFunction;
}(Masked);
IMask.MaskedFunction = MaskedFunction;



;// ../../node_modules/imask/esm/masked/dynamic.js








var dynamic_excluded = ["compiledMasks", "currentMaskRef", "currentMask"];

/** Dynamic mask for choosing apropriate mask in run-time */
var MaskedDynamic = /*#__PURE__*/function (_Masked) {
  _inherits(MaskedDynamic, _Masked);

  var _super = _createSuper(MaskedDynamic);

  /** Currently chosen mask */

  /** Compliled {@link Masked} options */

  /** Chooses {@link Masked} depending on input value */

  /**
    @param {Object} opts
  */
  function MaskedDynamic(opts) {
    var _this;

    _classCallCheck(this, MaskedDynamic);

    _this = _super.call(this, Object.assign({}, MaskedDynamic.DEFAULTS, opts));
    _this.currentMask = null;
    return _this;
  }
  /**
    @override
  */


  _createClass(MaskedDynamic, [{
    key: "_update",
    value: function _update(opts) {
      _get(_getPrototypeOf(MaskedDynamic.prototype), "_update", this).call(this, opts);

      if ('mask' in opts) {
        // mask could be totally dynamic with only `dispatch` option
        this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map(function (m) {
          return createMask(m);
        }) : [];
      }
    }
    /**
      @override
    */

  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var details = this._applyDispatch(ch, flags);

      if (this.currentMask) {
        details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
      }

      return details;
    }
  }, {
    key: "_applyDispatch",
    value: function _applyDispatch() {
      var appended = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
      var inputValue = this.rawInputValue;
      var insertValue = flags.tail && flags._beforeTailState != null ? // $FlowFixMe - tired to fight with type system
      flags._beforeTailState._rawInputValue : inputValue;
      var tailValue = inputValue.slice(insertValue.length);
      var prevMask = this.currentMask;
      var details = new ChangeDetails();
      var prevMaskState = prevMask === null || prevMask === void 0 ? void 0 : prevMask.state; // clone flags to prevent overwriting `_beforeTailState`

      this.currentMask = this.doDispatch(appended, Object.assign({}, flags)); // restore state after dispatch

      if (this.currentMask) {
        if (this.currentMask !== prevMask) {
          // if mask changed reapply input
          this.currentMask.reset();

          if (insertValue) {
            // $FlowFixMe - it's ok, we don't change current mask above
            var d = this.currentMask.append(insertValue, {
              raw: true
            });
            details.tailShift = d.inserted.length - prevValueBeforeTail.length;
          }

          if (tailValue) {
            // $FlowFixMe - it's ok, we don't change current mask above
            details.tailShift += this.currentMask.append(tailValue, {
              raw: true,
              tail: true
            }).tailShift;
          }
        } else {
          // Dispatch can do something bad with state, so
          // restore prev mask state
          this.currentMask.state = prevMaskState;
        }
      }

      return details;
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      var details = this._applyDispatch.apply(this, arguments);

      if (this.currentMask) {
        details.aggregate(this.currentMask._appendPlaceholder());
      }

      return details;
    }
    /**
     @override
    */

  }, {
    key: "_appendEager",
    value: function _appendEager() {
      var details = this._applyDispatch.apply(this, arguments);

      if (this.currentMask) {
        details.aggregate(this.currentMask._appendEager());
      }

      return details;
    }
  }, {
    key: "currentMaskFlags",
    value: function currentMaskFlags(flags) {
      var _flags$_beforeTailSta, _flags$_beforeTailSta2;

      return Object.assign({}, flags, {
        _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
      });
    }
    /**
      @override
    */

  }, {
    key: "doDispatch",
    value: function doDispatch(appended) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.dispatch(appended, this, flags);
    }
    /**
      @override
    */

  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      return _get(_getPrototypeOf(MaskedDynamic.prototype), "doValidate", this).call(this, flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
    }
    /**
      @override
    */

  }, {
    key: "doPrepare",
    value: function doPrepare(str) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _normalizePrepare = normalizePrepare(_get(_getPrototypeOf(MaskedDynamic.prototype), "doPrepare", this).call(this, str, flags)),
          _normalizePrepare2 = _slicedToArray(_normalizePrepare, 2),
          s = _normalizePrepare2[0],
          details = _normalizePrepare2[1];

      if (this.currentMask) {
        var currentDetails;

        var _normalizePrepare3 = normalizePrepare(_get(_getPrototypeOf(MaskedDynamic.prototype), "doPrepare", this).call(this, s, this.currentMaskFlags(flags)));

        var _normalizePrepare4 = _slicedToArray(_normalizePrepare3, 2);

        s = _normalizePrepare4[0];
        currentDetails = _normalizePrepare4[1];
        details = details.aggregate(currentDetails);
      }

      return [s, details];
    }
    /**
      @override
    */

  }, {
    key: "reset",
    value: function reset() {
      var _this$currentMask;

      (_this$currentMask = this.currentMask) === null || _this$currentMask === void 0 ? void 0 : _this$currentMask.reset();
      this.compiledMasks.forEach(function (m) {
        return m.reset();
      });
    }
    /**
      @override
    */

  }, {
    key: "value",
    get: function get() {
      return this.currentMask ? this.currentMask.value : '';
    },
    set: function set(value) {
      _set(_getPrototypeOf(MaskedDynamic.prototype), "value", value, this, true);
    }
    /**
      @override
    */

  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.currentMask ? this.currentMask.unmaskedValue : '';
    },
    set: function set(unmaskedValue) {
      _set(_getPrototypeOf(MaskedDynamic.prototype), "unmaskedValue", unmaskedValue, this, true);
    }
    /**
      @override
    */

  }, {
    key: "typedValue",
    get: function get() {
      return this.currentMask ? this.currentMask.typedValue : '';
    } // probably typedValue should not be used with dynamic
    ,
    set: function set(value) {
      var unmaskedValue = String(value); // double check it

      if (this.currentMask) {
        this.currentMask.typedValue = value;
        unmaskedValue = this.currentMask.unmaskedValue;
      }

      this.unmaskedValue = unmaskedValue;
    }
    /**
      @override
    */

  }, {
    key: "isComplete",
    get: function get() {
      var _this$currentMask2;

      return Boolean((_this$currentMask2 = this.currentMask) === null || _this$currentMask2 === void 0 ? void 0 : _this$currentMask2.isComplete);
    }
    /**
      @override
    */

  }, {
    key: "isFilled",
    get: function get() {
      var _this$currentMask3;

      return Boolean((_this$currentMask3 = this.currentMask) === null || _this$currentMask3 === void 0 ? void 0 : _this$currentMask3.isFilled);
    }
    /**
      @override
    */

  }, {
    key: "remove",
    value: function remove() {
      var details = new ChangeDetails();

      if (this.currentMask) {
        var _this$currentMask4;

        details.aggregate((_this$currentMask4 = this.currentMask).remove.apply(_this$currentMask4, arguments)) // update with dispatch
        .aggregate(this._applyDispatch());
      }

      return details;
    }
    /**
      @override
    */

  }, {
    key: "state",
    get: function get() {
      var _this$currentMask5;

      return Object.assign({}, _get(_getPrototypeOf(MaskedDynamic.prototype), "state", this), {
        _rawInputValue: this.rawInputValue,
        compiledMasks: this.compiledMasks.map(function (m) {
          return m.state;
        }),
        currentMaskRef: this.currentMask,
        currentMask: (_this$currentMask5 = this.currentMask) === null || _this$currentMask5 === void 0 ? void 0 : _this$currentMask5.state
      });
    },
    set: function set(state) {
      var compiledMasks = state.compiledMasks,
          currentMaskRef = state.currentMaskRef,
          currentMask = state.currentMask,
          maskedState = _objectWithoutProperties(state, dynamic_excluded);

      this.compiledMasks.forEach(function (m, mi) {
        return m.state = compiledMasks[mi];
      });

      if (currentMaskRef != null) {
        this.currentMask = currentMaskRef;
        this.currentMask.state = currentMask;
      }

      _set(_getPrototypeOf(MaskedDynamic.prototype), "state", maskedState, this, true);
    }
    /**
      @override
    */

  }, {
    key: "extractInput",
    value: function extractInput() {
      var _this$currentMask6;

      return this.currentMask ? (_this$currentMask6 = this.currentMask).extractInput.apply(_this$currentMask6, arguments) : '';
    }
    /**
      @override
    */

  }, {
    key: "extractTail",
    value: function extractTail() {
      var _this$currentMask7, _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.currentMask ? (_this$currentMask7 = this.currentMask).extractTail.apply(_this$currentMask7, args) : (_get2 = _get(_getPrototypeOf(MaskedDynamic.prototype), "extractTail", this)).call.apply(_get2, [this].concat(args));
    }
    /**
      @override
    */

  }, {
    key: "doCommit",
    value: function doCommit() {
      if (this.currentMask) this.currentMask.doCommit();

      _get(_getPrototypeOf(MaskedDynamic.prototype), "doCommit", this).call(this);
    }
    /**
      @override
    */

  }, {
    key: "nearestInputPos",
    value: function nearestInputPos() {
      var _this$currentMask8, _get3;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.currentMask ? (_this$currentMask8 = this.currentMask).nearestInputPos.apply(_this$currentMask8, args) : (_get3 = _get(_getPrototypeOf(MaskedDynamic.prototype), "nearestInputPos", this)).call.apply(_get3, [this].concat(args));
    }
  }, {
    key: "overwrite",
    get: function get() {
      return this.currentMask ? this.currentMask.overwrite : _get(_getPrototypeOf(MaskedDynamic.prototype), "overwrite", this);
    },
    set: function set(overwrite) {
      console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
    }
  }, {
    key: "eager",
    get: function get() {
      return this.currentMask ? this.currentMask.eager : _get(_getPrototypeOf(MaskedDynamic.prototype), "eager", this);
    },
    set: function set(eager) {
      console.warn('"eager" option is not available in dynamic mask, use this option in siblings');
    }
    /**
      @override
    */

  }, {
    key: "maskEquals",
    value: function maskEquals(mask) {
      return Array.isArray(mask) && this.compiledMasks.every(function (m, mi) {
        var _mask$mi;

        return m.maskEquals((_mask$mi = mask[mi]) === null || _mask$mi === void 0 ? void 0 : _mask$mi.mask);
      });
    }
    /**
      @override
    */

  }, {
    key: "typedValueEquals",
    value: function typedValueEquals(value) {
      var _this$currentMask9;

      return Boolean((_this$currentMask9 = this.currentMask) === null || _this$currentMask9 === void 0 ? void 0 : _this$currentMask9.typedValueEquals(value));
    }
  }]);

  return MaskedDynamic;
}(Masked);
MaskedDynamic.DEFAULTS = {
  dispatch: function dispatch(appended, masked, flags) {
    if (!masked.compiledMasks.length) return;
    var inputValue = masked.rawInputValue; // simulate input

    var inputs = masked.compiledMasks.map(function (m, index) {
      m.reset();
      m.append(inputValue, {
        raw: true
      });
      m.append(appended, masked.currentMaskFlags(flags));
      var weight = m.rawInputValue.length;
      return {
        weight: weight,
        index: index
      };
    }); // pop masks with longer values first

    inputs.sort(function (i1, i2) {
      return i2.weight - i1.weight;
    });
    return masked.compiledMasks[inputs[0].index];
  }
};
IMask.MaskedDynamic = MaskedDynamic;



;// ../../node_modules/imask/esm/masked/pipe.js






/** Mask pipe source and destination types */

var PIPE_TYPE = {
  MASKED: 'value',
  UNMASKED: 'unmaskedValue',
  TYPED: 'typedValue'
};
/** Creates new pipe function depending on mask type, source and destination options */

function createPipe(mask) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PIPE_TYPE.MASKED;
  var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PIPE_TYPE.MASKED;
  var masked = createMask(mask);
  return function (value) {
    return masked.runIsolated(function (m) {
      m[from] = value;
      return m[to];
    });
  };
}
/** Pipes value through mask depending on mask type, source and destination options */

function pipe(value) {
  for (var _len = arguments.length, pipeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    pipeArgs[_key - 1] = arguments[_key];
  }

  return createPipe.apply(void 0, pipeArgs)(value);
}
IMask.PIPE_TYPE = PIPE_TYPE;
IMask.createPipe = createPipe;
IMask.pipe = pipe;



;// ../../node_modules/imask/esm/index.js



























try {
  globalThis.IMask = IMask;
} catch (e) {}

;// ./src/directives/imask.ts


const imask = {
  async mounted(el, {
    value: options
  }) {
    if (!options) {
      return;
    }
    await initMask(el, options);
  },
  async updated(el, {
    value: options
  }) {
    if (options) {
      if (el.maskRef) {
        el.maskRef.updateOptions(options);
        // eslint-disable-next-line max-depth
        if (el.value !== el.maskRef.value) {
          // eslint-disable-next-line no-underscore-dangle
          el.maskRef._onChange();
        }
      } else {
        await initMask(el, options);
      }
    } else {
      destroyMask(el);
    }
  },
  unmounted(el) {
    destroyMask(el);
  }
};
function fireEvent(el, eventName, data) {
  const event = document.createEvent('CustomEvent');
  event.initCustomEvent(eventName, true, true, data);
  el.dispatchEvent(event);
}
async function initMask(el, opts) {
  el.maskRef = new InputMask(el, opts).on('accept', () => {
    fireEvent(el, 'accept', el.maskRef);
  }).on('complete', () => {
    fireEvent(el, 'complete', el.maskRef);
  });
  await (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)();
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (el.maskRef) {
    el.maskRef.updateValue();
    el.maskRef.updateControl();
  }
}
function destroyMask(el) {
  if (el.maskRef) {
    el.maskRef.destroy();
    delete el.maskRef;
  }
}

;// ./src/components/atoms/input/types.ts
var DtgInputView;
(function (DtgInputView) {
  DtgInputView["regular"] = "regular";
  DtgInputView["compact"] = "compact";
})(DtgInputView || (DtgInputView = {}));
var DtgInputType;
(function (DtgInputType) {
  DtgInputType["email"] = "email";
  // number = 'number' // Use dtg-input-number
  DtgInputType["password"] = "password";
  DtgInputType["search"] = "search";
  DtgInputType["tel"] = "tel";
  DtgInputType["text"] = "text";
  DtgInputType["url"] = "url";
})(DtgInputType || (DtgInputType = {}));
var DtgInputMode;
(function (DtgInputMode) {
  DtgInputMode["none"] = "none";
  DtgInputMode["text"] = "text";
  DtgInputMode["decimal"] = "decimal";
  DtgInputMode["numeric"] = "numeric";
  DtgInputMode["tel"] = "tel";
  DtgInputMode["search"] = "search";
  DtgInputMode["email"] = "email";
  DtgInputMode["url"] = "url";
})(DtgInputMode || (DtgInputMode = {}));
;// ./src/components/atoms/input/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const input_style_module = ({"dtg-input_view_compact":"lib_dtg-input_view_compact_MqhKA","dtg-input_focused":"lib_dtg-input_focused_how6r","dtg-input_view_regular":"lib_dtg-input_view_regular_NMbzT","dtg-input":"lib_dtg-input_Ye7D5","dtg-input_action":"lib_dtg-input_action_cM6nF","dtg-input_disabled":"lib_dtg-input_disabled_iy8eK","dtg-input__input":"lib_dtg-input__input_mWx9V","dtg-input_icon":"lib_dtg-input_icon_wkRzr","dtg-input__placeholder":"lib_dtg-input__placeholder_CnBVv","dtg-input__icon":"lib_dtg-input__icon_Z89Lq","dtg-input__action":"lib_dtg-input__action_WXWdr","dtg-input__extra":"lib_dtg-input__extra_gp0ej","dtg-input__unit":"lib_dtg-input__unit_CzS9P"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input/component.vue?vue&type=script&lang=ts











/* harmony default export */ const input_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(input_style_module),
  components: {
    DtgIcon: icon_component
  },
  directives: {
    imask: imask
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    view: {
      type: String,
      default: DtgInputView.regular,
      validator: inRecord(DtgInputView)
    },
    icon: {
      type: String,
      default: null,
      validator: inArray(iconNames)
    },
    type: {
      type: String,
      default: DtgInputType.text,
      validator: inRecord(DtgInputType)
    },
    mode: {
      type: String,
      default: DtgInputMode.text,
      validator: inRecord(DtgInputMode)
    },
    mask: {
      type: [String, Object, RegExp],
      default: null
    },
    unmasked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    autowidth: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: [String, Number],
      default: 0
    },
    selectAllOnFocus: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    // Determines if the click event should be fired when the focus function is called on component
    noClickToFocus: {
      type: Boolean,
      default: false
    }
  },
  emits: events(['update:modelValue', 'maskValues', 'maskCompleteValues'])(),
  setup(props, {
    attrs,
    emit,
    slots
  }) {
    const splitAttrs = useSplitAttrs(attrs);
    const maskInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        mask
      } = props;
      if (!mask) {
        return null;
      }
      if (typeof mask === 'string') {
        return {
          mask
        };
      }
      if (mask instanceof RegExp) {
        return {
          mask
        };
      }
      return mask;
    });
    const modelValueInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
      get() {
        return props.modelValue;
      },
      set(value) {
        if (!maskInternal.value && props.modelValue !== value) {
          emit('update:modelValue', value);
        }
      }
    });
    const inputRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const {
      focused,
      focus,
      blur
    } = useFocus(inputRef, {
      autoFocus: props.autofocus,
      selectOnFocus: props.selectAllOnFocus,
      clickToFocus: !props.noClickToFocus
    });
    const empty = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => !modelValueInternal.value);
    const autocompleteInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.autocomplete ? null : 'off');
    const tabindexInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.disabled ? -1 : props.tabindex);
    const inputStyle = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const widthCh = props.autowidth ? modelValueInternal.value.length : null;
      const width = widthCh === null ? null : `${Math.max(widthCh, 3)}ch`;
      return {
        width
      };
    });
    const placeholderShown = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        placeholder,
        readonly
      } = props;
      return Boolean(placeholder) && empty.value && (!focused.value || readonly);
    });
    function getMods() {
      const {
        view,
        disabled,
        icon
      } = props;
      return {
        view,
        disabled,
        focused: focused.value,
        action: 'action' in slots,
        icon: (0,truthy_.truthy)(icon)
      };
    }
    function onAccept(event) {
      const mask = event.detail;
      const {
        value,
        typedValue,
        unmaskedValue
      } = mask;
      const {
        unmasked
      } = props;
      const valueToEmit = unmasked ? unmaskedValue : value;
      emit('update:modelValue', valueToEmit);
      emit('maskValues', {
        value,
        typedValue,
        unmaskedValue
      });
    }
    // Fired when the mask value is completely filled
    function onComplete(event) {
      const mask = event.detail;
      const {
        value,
        typedValue,
        unmaskedValue
      } = mask;
      emit('maskCompleteValues', {
        value,
        typedValue,
        unmaskedValue
      });
    }
    return {
      b: useBem(input_style_module),
      splitAttrs,
      modelValueInternal,
      inputStyle,
      maskInternal,
      autocompleteInternal,
      tabindexInternal,
      placeholderShown,
      inputRef,
      getMods,
      onAccept,
      onComplete,
      /** @public */
      focus,
      /** @public */
      blur
    };
  }
}));
;// ./src/components/atoms/input/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/input/component.vue




;
const input_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(input_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_acbb8a42_ts_true_render]])

/* harmony default export */ const input_component = (input_component_exports_);
;// ./src/components/atoms/input/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-color/component.vue?vue&type=template&id=1d357109&ts=true

function componentvue_type_template_id_1d357109_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_color_picker = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("color-picker");
  const _component_focus_trap = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("focus-trap");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    ref: "inputRef"
  }, _ctx.$attrs, {
    modelValue: _ctx.modelValueInternal,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.modelValueInternal = $event),
    mask: _ctx.mask,
    placeholder: _ctx.placeholder,
    name: _ctx.name
  }), {
    action: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
      ref: "actionRef",
      disabled: _ctx.disabled,
      icon: "grid",
      view: "inverted",
      size: "s",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.onInputActionClick())
    }, null, 8, ["disabled"])]),
    _: 1
  }, 16, ["modelValue", "mask", "placeholder", "name"]), _ctx.shownPicker ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_focus_trap, {
    key: 0,
    active: _ctx.shownPicker,
    "onUpdate:active": _cache[3] || (_cache[3] = $event => _ctx.shownPicker = $event),
    "click-outside-deactivates": _ctx.clickOutsideDeactivates
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_color_picker, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('picker')),
      style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.style),
      color: _ctx.modelValueInternal,
      "colors-default": _ctx.defaultColors,
      theme: "light",
      onChangeColor: _cache[2] || (_cache[2] = $event => _ctx.onPickerChangeColor($event))
    }, null, 8, ["class", "style", "color", "colors-default"])]),
    _: 1
  }, 8, ["active", "click-outside-deactivates"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// ./src/components/atoms/input-color/component.vue?vue&type=template&id=1d357109&ts=true

;// ../../node_modules/tabbable/dist/index.esm.js
/*!
* tabbable 6.4.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var candidateSelectors = ['input:not([inert]):not([inert] *)', 'select:not([inert]):not([inert] *)', 'textarea:not([inert]):not([inert] *)', 'a[href]:not([inert]):not([inert] *)', 'button:not([inert]):not([inert] *)', '[tabindex]:not(slot):not([inert]):not([inert] *)', 'audio[controls]:not([inert]):not([inert] *)', 'video[controls]:not([inert]):not([inert] *)', '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', 'details>summary:first-of-type:not([inert]):not([inert] *)', 'details:not([inert]):not([inert] *)'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var index_esm_matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var _isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  var result = inert || lookUp && node && (
  // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  typeof node.closest === 'function' ? node.closest('[inert]') : _isInert(node.parentNode));
  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert (either by itself or via its parent), then all its children are inert
  if (_isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && index_esm_matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var _getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (_isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = _getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = index_esm_matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = _getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};

/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */
var hasTabIndex = function hasTabIndex(node) {
  return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};

/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */
var getTabIndex = function getTabIndex(node) {
  if (!node) {
    throw new Error('No node provided');
  }
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};

/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */
var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  if (displayCheck === 'full-native') {
    if ('checkVisibility' in node) {
      // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
      // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
      var visible = node.checkVisibility({
        // Checking opacity might be desirable for some use cases, but natively,
        // opacity zero elements _are_ focusable and tabbable.
        checkOpacity: false,
        opacityProperty: false,
        contentVisibilityAuto: true,
        visibilityProperty: true,
        // This is an alias for `visibilityProperty`. Contemporary browsers
        // support both. However, this alias has wider browser support (Chrome
        // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
        // we include it anyway.
        checkVisibilityCSS: true
      });
      return !visible;
    }
    // Fall through to manual visibility checks
  }

  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = index_esm_matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (index_esm_matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' ||
  // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  displayCheck === 'full-native' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return index_esm_matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var _sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? _sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = _getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return _sortByOrder(candidates);
};
var focusable = function focusable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = _getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (index_esm_matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var isFocusable = function isFocusable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (index_esm_matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map

;// ../../node_modules/focus-trap/dist/focus-trap.esm.js
/*!
* focus-trap 7.1.0
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      focus_trap_esm_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function focus_trap_esm_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var rooTrapStack = [];
var activeFocusTraps = {
  activateTrap: function activateTrap(trapStack, trap) {
    if (trapStack.length > 0) {
      var activeTrap = trapStack[trapStack.length - 1];
      if (activeTrap !== trap) {
        activeTrap.pause();
      }
    }
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex === -1) {
      trapStack.push(trap);
    } else {
      // move this existing trap to the front of the queue
      trapStack.splice(trapIndex, 1);
      trapStack.push(trap);
    }
  },
  deactivateTrap: function deactivateTrap(trapStack, trap) {
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex !== -1) {
      trapStack.splice(trapIndex, 1);
    }
    if (trapStack.length > 0) {
      trapStack[trapStack.length - 1].unpause();
    }
  }
};
var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};
var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};
var delay = function delay(fn) {
  return setTimeout(fn, 0);
};

// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });

  return idx;
};

/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */
var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};
var createFocusTrap = function createFocusTrap(elements, userOptions) {
  // SSR: a live trap shouldn't be created in this type of environment so this
  //  should be safe code to execute if the `document` option isn't specified
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || rooTrapStack;
  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);
  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list

    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */
  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };

  /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */
  var findContainerIndex = function findContainerIndex(element) {
    // NOTE: search `containerGroups` because it's possible a group contains no tabbable
    //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
    //  and we still need to find the element in there
    return state.containerGroups.findIndex(function (_ref) {
      var container = _ref.container,
        tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) ||
      // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      tabbableNodes.find(function (node) {
        return node === element;
      });
    });
  };

  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */
  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (optionValue === true) {
      optionValue = undefined; // use default value
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      }
      // else, empty string (invalid), null (invalid), 0 (invalid)

      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails
      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus');

    // false explicitly indicates we want no initialFocus at all
    if (node === false) {
      return false;
    }
    if (node === undefined) {
      // option not specified: use fallback options
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;

        // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }
    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes() {
    state.containerGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions);

      // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
      //  are a superset of tabbable nodes
      var focusableNodes = focusable(container, config.tabbableOptions);
      return {
        container: container,
        tabbableNodes: tabbableNodes,
        focusableNodes: focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          // NOTE: If tabindex is positive (in order to manipulate the tab order separate
          //  from the DOM order), this __will not work__ because the list of focusableNodes,
          //  while it contains tabbable nodes, does not sort its nodes in any order other
          //  than DOM order, because it can't: Where would you place focusable (but not
          //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
          // Support for positive tabindex is already broken and hard to manage (possibly
          //  not supportable, TBD), so this isn't going to make things worse than they
          //  already are, and at least makes things better for the majority of cases where
          //  tabindex is either 0/unset or negative.
          // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
          var nodeIdx = focusableNodes.findIndex(function (n) {
            return n === node;
          });
          if (nodeIdx < 0) {
            return undefined;
          }
          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function (n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }
          return focusableNodes.slice(0, nodeIdx).reverse().find(function (n) {
            return isTabbable(n, config.tabbableOptions);
          });
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function (group) {
      return group.tabbableNodes.length > 0;
    });

    // throw if no groups have tabbable nodes and we don't have a fallback focus node either
    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };
  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }
    if (node === doc.activeElement) {
      return;
    }
    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  };

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      // allow the click since it ocurred inside the trap
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
      });
      return;
    }

    // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)
    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    }

    // otherwise, prevent the click
    e.preventDefault();
  };

  // In case focus escapes the trap for some strange reason, pull it back in.
  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = findContainerIndex(target) >= 0;

    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  };

  // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  var checkTab = function checkTab(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's focusable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findContainerIndex(target);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE

        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          // an exception case where the target is either the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD

        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          // an exception case where the target is the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }
    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    }
    // else, let the browser take care of [shift+]tab and move the focus
  };

  var checkKey = function checkKey(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };
  var checkClick = function checkClick(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };

  //
  // EVENT LISTENERS
  //

  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    }

    // There can be only one listening focus trap at a time
    activeFocusTraps.activateTrap(trapStack, trap);

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };
  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  };

  //
  // TRAP DEFINITION
  //

  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      if (onActivate) {
        onActivate();
      }
      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        if (onPostActivate) {
          onPostActivate();
        }
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);
      clearTimeout(state.delayInitialFocusTimer); // noop if undefined
      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trapStack, trap);
      var onDeactivate = getOption(options, 'onDeactivate');
      var onPostDeactivate = getOption(options, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
      var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
      if (onDeactivate) {
        onDeactivate();
      }
      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }
      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }
      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      return this;
    }
  };

  // initialize container elements
  trap.updateContainerElements(elements);
  return trap;
};


//# sourceMappingURL=focus-trap.esm.js.map

;// ../../node_modules/focus-trap-vue/dist/focus-trap-vue.esm-browser.js
/*!
  * focus-trap-vue v3.3.0
  * (c) 2022 Eduardo San Martin Morote
  * @license MIT
  */



function defineFocusTrapProps(props) {
    return props;
}
const FocusTrapProps = defineFocusTrapProps({
    escapeDeactivates: {
        type: Boolean,
        default: true,
    },
    returnFocusOnDeactivate: {
        type: Boolean,
        default: true,
    },
    allowOutsideClick: {
        type: [Boolean, Function],
        default: true,
    },
    clickOutsideDeactivates: [Boolean, Function],
    initialFocus: [String, Function, Boolean],
    fallbackFocus: [String, Function],
    checkCanFocusTrap: Function,
    checkCanReturnFocus: Function,
    delayInitialFocus: { type: Boolean, default: true },
    document: Object,
    preventScroll: Boolean,
    setReturnFocus: [Object, String, Boolean, Function],
});
const FocusTrap = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    props: Object.assign({
        active: {
            // TODO: could be options for activate but what about the options for deactivating?
            type: Boolean,
            default: true,
        },
    }, FocusTrapProps),
    emits: [
        'update:active',
        'activate',
        'postActivate',
        'deactivate',
        'postDeactivate',
    ],
    render() {
        return this.renderImpl();
    },
    setup(props, { slots, emit }) {
        let trap;
        const wrapperEl = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
        const el = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
            const innerElement = wrapperEl.value;
            return (innerElement &&
                (innerElement instanceof HTMLElement ? innerElement : innerElement.$el));
        });
        const ensureTrap = () => {
            if (trap) {
                return trap;
            }
            return (trap = createFocusTrap(el.value, {
                escapeDeactivates: props.escapeDeactivates,
                allowOutsideClick: props.allowOutsideClick,
                returnFocusOnDeactivate: props.returnFocusOnDeactivate,
                clickOutsideDeactivates: props.clickOutsideDeactivates,
                onActivate: () => {
                    emit('update:active', true);
                    emit('activate');
                },
                onDeactivate: () => {
                    emit('update:active', false);
                    emit('deactivate');
                },
                onPostActivate: () => emit('postActivate'),
                onPostDeactivate: () => emit('postDeactivate'),
                initialFocus: props.initialFocus,
                fallbackFocus: props.fallbackFocus,
            }));
        };
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.active, active => {
                if (active && el.value) {
                    // has no effect if already activated
                    ensureTrap().activate();
                }
                else if (trap) {
                    trap.deactivate();
                    // this allows v-if blocks to work by invalidating the trap
                    // and forcing a new one to be created
                    if (!el.value || el.value.nodeType === Node.COMMENT_NODE) {
                        trap = null;
                    }
                }
            }, { immediate: true, flush: 'post' });
        });
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onUnmounted)(() => {
            if (trap)
                trap.deactivate();
            trap = null;
        });
        // Use object-return for setup so that we can expose the 'activate'
        // and 'deactivate' methods without making use of the 'expose({ ... })'
        // method as the ExposeProxy system is problematic for users migrating
        // from Vue2 -> Vue3 due to the ExposeProxy (correctly) preventing child
        // components from reading the internal state of their $parent. This is
        // problematic for migrating users because the the Vue2-based VueRouter
        // _requires_ that functionality as it does $parent._routerRoot to set
        // the $router and $route properties on components.
        return {
            activate() {
                ensureTrap();
                // @ts-ignore
                trap.activate();
            },
            deactivate() {
                trap && trap.deactivate();
            },
            renderImpl() {
                if (!slots.default)
                    return null;
                const vNodes = slots.default().filter(vnode => vnode.type !== external_commonjs_vue_commonjs2_vue_root_Vue_.Comment);
                if (!vNodes || !vNodes.length || vNodes.length > 1) {
                    {
                        console.error('[focus-trap-vue]: FocusTrap requires exactly one child.');
                    }
                    return vNodes;
                }
                const vnode = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.cloneVNode)(vNodes[0], { ref: wrapperEl });
                return vnode;
            },
        };
    },
});



;// ../../node_modules/vue-color-kit/dist/vue-color-kit.esm-bundler.js
/*!
  * vue-color-kit v1.0.4
  * (c) 2021 
  * @license MIT
  */


function setColorValue(color) {
    let rgba = { r: 0, g: 0, b: 0, a: 1 };
    if (/#/.test(color)) {
        rgba = hex2rgb(color);
    }
    else if (/rgb/.test(color)) {
        rgba = rgb2rgba(color);
    }
    else if (typeof color === 'string') {
        rgba = rgb2rgba(`rgba(${color})`);
    }
    else if (Object.prototype.toString.call(color) === '[object Object]') {
        rgba = color;
    }
    const { r, g, b, a } = rgba;
    const { h, s, v } = rgb2hsv(rgba);
    return { r, g, b, a: a === undefined ? 1 : a, h, s, v };
}
function createAlphaSquare(size) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const doubleSize = size * 2;
    canvas.width = doubleSize;
    canvas.height = doubleSize;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, doubleSize, doubleSize);
    ctx.fillStyle = '#ccd5db';
    ctx.fillRect(0, 0, size, size);
    ctx.fillRect(size, size, size, size);
    return canvas;
}
function createLinearGradient(direction, ctx, width, height, color1, color2) {
    // l horizontal p vertical
    const isL = direction === 'l';
    const gradient = ctx.createLinearGradient(0, 0, isL ? width : 0, isL ? 0 : height);
    gradient.addColorStop(0.01, color1);
    gradient.addColorStop(0.99, color2);
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);
}
function rgb2hex({ r, g, b }, toUpper) {
    const change = (val) => ('0' + Number(val).toString(16)).slice(-2);
    const color = `#${change(r)}${change(g)}${change(b)}`;
    return toUpper ? color.toUpperCase() : color;
}
function hex2rgb(hex) {
    hex = hex.slice(1);
    const change = (val) => parseInt(val, 16) || 0; // Avoid NaN situations
    return {
        r: change(hex.slice(0, 2)),
        g: change(hex.slice(2, 4)),
        b: change(hex.slice(4, 6)),
    };
}
function rgb2rgba(rgba) {
    if (typeof rgba === 'string') {
        rgba = (/rgba?\((.*?)\)/.exec(rgba) || ['', '0,0,0,1'])[1].split(',');
        return {
            r: Number(rgba[0]) || 0,
            g: Number(rgba[1]) || 0,
            b: Number(rgba[2]) || 0,
            a: Number(rgba[3] ? rgba[3] : 1),
        };
    }
    else {
        return rgba;
    }
}
function rgb2hsv({ r, g, b }) {
    r = r / 255;
    g = g / 255;
    b = b / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;
    let h = 0;
    if (max === min) {
        h = 0;
    }
    else if (max === r) {
        if (g >= b) {
            h = (60 * (g - b)) / delta;
        }
        else {
            h = (60 * (g - b)) / delta + 360;
        }
    }
    else if (max === g) {
        h = (60 * (b - r)) / delta + 120;
    }
    else if (max === b) {
        h = (60 * (r - g)) / delta + 240;
    }
    h = Math.floor(h);
    let s = parseFloat((max === 0 ? 0 : 1 - min / max).toFixed(2));
    let v = parseFloat(max.toFixed(2));
    return { h, s, v };
}

var script = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        hsv: {
            type: Object,
            default: null,
        },
        size: {
            type: Number,
            default: 152,
        },
    },
    emits: ['selectSaturation'],
    data() {
        return {
            slideSaturationStyle: {},
        };
    },
    // Can’t monitor, otherwise the color will change when you change yourself
    // watch: {
    //     color() {
    //         this.renderColor()
    //     }
    // },
    mounted() {
        this.renderColor();
        this.renderSlide();
    },
    methods: {
        renderColor() {
            const canvas = this.$refs.canvasSaturation;
            const size = this.size;
            const ctx = canvas.getContext('2d');
            canvas.width = size;
            canvas.height = size;
            ctx.fillStyle = this.color;
            ctx.fillRect(0, 0, size, size);
            createLinearGradient('l', ctx, size, size, '#FFFFFF', 'rgba(255,255,255,0)');
            createLinearGradient('p', ctx, size, size, 'rgba(0,0,0,0)', '#000000');
        },
        renderSlide() {
            this.slideSaturationStyle = {
                left: this.hsv.s * this.size - 5 + 'px',
                top: (1 - this.hsv.v) * this.size - 5 + 'px',
            };
        },
        selectSaturation(e) {
            const { top: saturationTop, left: saturationLeft, } = this.$el.getBoundingClientRect();
            const ctx = e.target.getContext('2d');
            const mousemove = (e) => {
                let x = e.clientX - saturationLeft;
                let y = e.clientY - saturationTop;
                if (x < 0) {
                    x = 0;
                }
                if (y < 0) {
                    y = 0;
                }
                if (x > this.size) {
                    x = this.size;
                }
                if (y > this.size) {
                    y = this.size;
                }
                // Do not modify the dom by monitoring data changes, otherwise when the color is #ffffff, the slide will go to the lower left corner
                this.slideSaturationStyle = {
                    left: x - 5 + 'px',
                    top: y - 5 + 'px',
                };
                // If you use the maximum value, the selected pixel will be empty, and the empty default is black
                const imgData = ctx.getImageData(Math.min(x, this.size - 1), Math.min(y, this.size - 1), 1, 1);
                const [r, g, b] = imgData.data;
                this.$emit('selectSaturation', { r, g, b });
            };
            mousemove(e);
            const mouseup = () => {
                document.removeEventListener('mousemove', mousemove);
                document.removeEventListener('mouseup', mouseup);
            };
            document.addEventListener('mousemove', mousemove);
            document.addEventListener('mouseup', mouseup);
        },
    },
});

const vue_color_kit_esm_bundler_hoisted_1 = { ref: "canvasSaturation" };

function vue_color_kit_esm_bundler_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("div", {
    class: "saturation",
    onMousedown: _cache[1] || (_cache[1] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => (_ctx.selectSaturation && _ctx.selectSaturation(...args)), ["prevent","stop"]))
  }, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("canvas", vue_color_kit_esm_bundler_hoisted_1, null, 512 /* NEED_PATCH */),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("div", {
      style: _ctx.slideSaturationStyle,
      class: "slide"
    }, null, 4 /* STYLE */)
  ], 32 /* HYDRATE_EVENTS */))
}

script.render = vue_color_kit_esm_bundler_render;
script.__file = "src/color/Saturation.vue";

var script$1 = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    props: {
        hsv: {
            type: Object,
            default: null,
        },
        width: {
            type: Number,
            default: 15,
        },
        height: {
            type: Number,
            default: 152,
        },
    },
    emits: ['selectHue'],
    data() {
        return {
            slideHueStyle: {},
        };
    },
    mounted() {
        this.renderColor();
        this.renderSlide();
    },
    methods: {
        renderColor() {
            const canvas = this.$refs.canvasHue;
            const width = this.width;
            const height = this.height;
            const ctx = canvas.getContext('2d');
            canvas.width = width;
            canvas.height = height;
            const gradient = ctx.createLinearGradient(0, 0, 0, height);
            gradient.addColorStop(0, '#FF0000'); // red
            gradient.addColorStop(0.17 * 1, '#FF00FF'); // purple
            gradient.addColorStop(0.17 * 2, '#0000FF'); // blue
            gradient.addColorStop(0.17 * 3, '#00FFFF'); // green
            gradient.addColorStop(0.17 * 4, '#00FF00'); // green
            gradient.addColorStop(0.17 * 5, '#FFFF00'); // yellow
            gradient.addColorStop(1, '#FF0000'); // red
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, width, height);
        },
        renderSlide() {
            this.slideHueStyle = {
                top: (1 - this.hsv.h / 360) * this.height - 2 + 'px',
            };
        },
        selectHue(e) {
            const { top: hueTop } = this.$el.getBoundingClientRect();
            const ctx = e.target.getContext('2d');
            const mousemove = (e) => {
                let y = e.clientY - hueTop;
                if (y < 0) {
                    y = 0;
                }
                if (y > this.height) {
                    y = this.height;
                }
                this.slideHueStyle = {
                    top: y - 2 + 'px',
                };
                // If you use the maximum value, the selected pixel will be empty, and the empty default is black
                const imgData = ctx.getImageData(0, Math.min(y, this.height - 1), 1, 1);
                const [r, g, b] = imgData.data;
                this.$emit('selectHue', { r, g, b });
            };
            mousemove(e);
            const mouseup = () => {
                document.removeEventListener('mousemove', mousemove);
                document.removeEventListener('mouseup', mouseup);
            };
            document.addEventListener('mousemove', mousemove);
            document.addEventListener('mouseup', mouseup);
        },
    },
});

const _hoisted_1$1 = { ref: "canvasHue" };

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("div", {
    class: "hue",
    onMousedown: _cache[1] || (_cache[1] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => (_ctx.selectHue && _ctx.selectHue(...args)), ["prevent","stop"]))
  }, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("canvas", _hoisted_1$1, null, 512 /* NEED_PATCH */),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("div", {
      style: _ctx.slideHueStyle,
      class: "slide"
    }, null, 4 /* STYLE */)
  ], 32 /* HYDRATE_EVENTS */))
}

script$1.render = render$1;
script$1.__file = "src/color/Hue.vue";

var script$2 = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        rgba: {
            type: Object,
            default: null,
        },
        width: {
            type: Number,
            default: 15,
        },
        height: {
            type: Number,
            default: 152,
        },
    },
    emits: ['selectAlpha'],
    data() {
        return {
            slideAlphaStyle: {},
            alphaSize: 5,
        };
    },
    watch: {
        color() {
            this.renderColor();
        },
        'rgba.a'() {
            this.renderSlide();
        },
    },
    mounted() {
        this.renderColor();
        this.renderSlide();
    },
    methods: {
        renderColor() {
            const canvas = this.$refs.canvasAlpha;
            const width = this.width;
            const height = this.height;
            const size = this.alphaSize;
            const canvasSquare = createAlphaSquare(size);
            const ctx = canvas.getContext('2d');
            canvas.width = width;
            canvas.height = height;
            ctx.fillStyle = ctx.createPattern(canvasSquare, 'repeat');
            ctx.fillRect(0, 0, width, height);
            createLinearGradient('p', ctx, width, height, 'rgba(255,255,255,0)', this.color);
        },
        renderSlide() {
            this.slideAlphaStyle = {
                top: this.rgba.a * this.height - 2 + 'px',
            };
        },
        selectAlpha(e) {
            const { top: hueTop } = this.$el.getBoundingClientRect();
            const mousemove = (e) => {
                let y = e.clientY - hueTop;
                if (y < 0) {
                    y = 0;
                }
                if (y > this.height) {
                    y = this.height;
                }
                let a = parseFloat((y / this.height).toFixed(2));
                this.$emit('selectAlpha', a);
            };
            mousemove(e);
            const mouseup = () => {
                document.removeEventListener('mousemove', mousemove);
                document.removeEventListener('mouseup', mouseup);
            };
            document.addEventListener('mousemove', mousemove);
            document.addEventListener('mouseup', mouseup);
        },
    },
});

const _hoisted_1$2 = { ref: "canvasAlpha" };

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("div", {
    class: "color-alpha",
    onMousedown: _cache[1] || (_cache[1] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => (_ctx.selectAlpha && _ctx.selectAlpha(...args)), ["prevent","stop"]))
  }, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("canvas", _hoisted_1$2, null, 512 /* NEED_PATCH */),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("div", {
      style: _ctx.slideAlphaStyle,
      class: "slide"
    }, null, 4 /* STYLE */)
  ], 32 /* HYDRATE_EVENTS */))
}

script$2.render = render$2;
script$2.__file = "src/color/Alpha.vue";

var script$3 = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        width: {
            type: Number,
            default: 100,
        },
        height: {
            type: Number,
            default: 30,
        },
    },
    data() {
        return {
            alphaSize: 5,
        };
    },
    watch: {
        color() {
            this.renderColor();
        },
    },
    mounted() {
        this.renderColor();
    },
    methods: {
        renderColor() {
            const canvas = this.$el;
            const width = this.width;
            const height = this.height;
            const size = this.alphaSize;
            const canvasSquare = createAlphaSquare(size);
            const ctx = canvas.getContext('2d');
            canvas.width = width;
            canvas.height = height;
            ctx.fillStyle = ctx.createPattern(canvasSquare, 'repeat');
            ctx.fillRect(0, 0, width, height);
            ctx.fillStyle = this.color;
            ctx.fillRect(0, 0, width, height);
        },
    },
});

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("canvas"))
}

script$3.render = render$3;
script$3.__file = "src/color/Preview.vue";

// import imgSucker from '../img/sucker.png'
var script$4 = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    props: {
        suckerCanvas: {
            type: Object,
            default: null,
        },
        suckerArea: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isOpenSucker: false,
            suckerPreview: null,
            isSucking: false,
        };
    },
    watch: {
        suckerCanvas(newVal) {
            this.isSucking = false;
            this.suckColor(newVal);
            // newVal.style.cursor = `url('../img/sucker.png') 0 32, default`
            //TODO
        },
    },
    methods: {
        openSucker() {
            if (!this.isOpenSucker) {
                this.isOpenSucker = true;
                this.isSucking = true;
                this.$emit('openSucker', true);
                document.addEventListener('keydown', this.keydownHandler);
            }
            else {
                // The processing logic is the same as pressing the esc key
                this.keydownHandler({ keyCode: 27 });
            }
        },
        keydownHandler(e) {
            // esc
            if (e.keyCode === 27) {
                this.isOpenSucker = false;
                this.isSucking = false;
                this.$emit('openSucker', false);
                document.removeEventListener('keydown', this.keydownHandler);
                document.removeEventListener('mousemove', this.mousemoveHandler);
                document.removeEventListener('mouseup', this.mousemoveHandler);
                if (this.suckerPreview) {
                    // @ts-ignore
                    document.body.removeChild(this.suckerPreview);
                    this.suckerPreview = null;
                }
            }
        },
        mousemoveHandler(e) {
            const { clientX, clientY } = e;
            const { top: domTop, left: domLeft, width, height, } = this.suckerCanvas.getBoundingClientRect();
            const x = clientX - domLeft;
            const y = clientY - domTop;
            const ctx = this.suckerCanvas.getContext('2d');
            const imgData = ctx.getImageData(Math.min(x, width - 1), Math.min(y, height - 1), 1, 1);
            let [r, g, b, a] = imgData.data;
            a = parseFloat((a / 255).toFixed(2));
            // @ts-ignore
            const style = this.suckerPreview.style;
            Object.assign(style, {
                position: 'absolute',
                left: clientX + 20 + 'px',
                top: clientY - 36 + 'px',
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                border: '2px solid #fff',
                boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.16)',
                background: `rgba(${r}, ${g}, ${b}, ${a})`,
                zIndex: 95,
            });
            if (this.suckerArea.length &&
                // @ts-ignore
                clientX >= this.suckerArea[0] &&
                // @ts-ignore
                clientY >= this.suckerArea[1] &&
                // @ts-ignore
                clientX <= this.suckerArea[2] &&
                // @ts-ignore
                clientY <= this.suckerArea[3]) {
                // @ts-ignore
                style.display = '';
            }
            else {
                // @ts-ignore
                style.display = 'none';
            }
        },
        suckColor(dom) {
            if (dom && dom.tagName !== 'CANVAS') {
                return;
            }
            // @ts-ignore
            this.suckerPreview = document.createElement('div');
            // @ts-ignore
            if (this.suckerPreview)
                document.body.appendChild(this.suckerPreview);
            document.addEventListener('mousemove', this.mousemoveHandler);
            document.addEventListener('mouseup', this.mousemoveHandler);
            dom.addEventListener('click', (e) => {
                const { clientX, clientY } = e;
                const { top, left, width, height } = dom.getBoundingClientRect();
                const x = clientX - left;
                const y = clientY - top;
                const ctx = dom.getContext('2d');
                const imgData = ctx.getImageData(Math.min(x, width - 1), Math.min(y, height - 1), 1, 1);
                let [r, g, b, a] = imgData.data;
                a = parseFloat((a / 255).toFixed(2));
                this.$emit('selectSucker', { r, g, b, a });
            });
        },
    },
});

const _hoisted_1$3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("path", { d: "M13.1,8.2l5.6,5.6c0.4,0.4,0.5,1.1,0.1,1.5s-1.1,0.5-1.5,0.1c0,0-0.1,0-0.1-0.1l-1.4-1.4l-7.7,7.7C7.9,21.9,7.6,22,7.3,22H3.1C2.5,22,2,21.5,2,20.9l0,0v-4.2c0-0.3,0.1-0.6,0.3-0.8l5.8-5.8C8.5,9.7,9.2,9.6,9.7,10s0.5,1.1,0.1,1.5c0,0,0,0.1-0.1,0.1l-5.5,5.5v2.7h2.7l7.4-7.4L8.7,6.8c-0.5-0.4-0.5-1-0.1-1.5s1.1-0.5,1.5-0.1c0,0,0.1,0,0.1,0.1l1.4,1.4l3.5-3.5c1.6-1.6,4.1-1.6,5.8-0.1c1.6,1.6,1.6,4.1,0.1,5.8L20.9,9l-3.6,3.6c-0.4,0.4-1.1,0.5-1.5,0.1" }, null, -1 /* HOISTED */);
const vue_color_kit_esm_bundler_hoisted_2 = {
  key: 1,
  class: "sucker",
  viewBox: "-16 -16 68 68",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#9099a4"
};
const _hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("g", {
    transform: "translate(1 1)",
    "stroke-width": "4"
  }, [
    /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("circle", {
      "stroke-opacity": ".5",
      cx: "18",
      cy: "18",
      r: "18"
    }),
    /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("path", { d: "M36 18c0-9.94-8.06-18-18-18" }, [
      /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 18 18",
        to: "360 18 18",
        dur: "1s",
        repeatCount: "indefinite"
      })
    ])
  ])
], -1 /* HOISTED */);

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("div", null, [
    (!_ctx.isSucking)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("svg", {
          key: 0,
          class: [{ active: _ctx.isOpenSucker }, "sucker"],
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-12 -12 48 48",
          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.openSucker && _ctx.openSucker(...args)))
        }, [
          _hoisted_1$3
        ], 2 /* CLASS */))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("v-if", true),
    (_ctx.isSucking)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("svg", vue_color_kit_esm_bundler_hoisted_2, [
          _hoisted_3
        ]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("v-if", true)
  ]))
}

script$4.render = render$4;
script$4.__file = "src/color/Sucker.vue";

var script$5 = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    props: {
        name: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: '',
        },
    },
    emits: ['inputColor'],
    setup(props, { emit }) {
        const modelColor = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
            get() {
                return props.color || '';
            },
            set(val) {
                emit('inputColor', val);
            },
        });
        return {
            modelColor,
        };
    },
});

const _hoisted_1$4 = { class: "color-type" };
const _hoisted_2$1 = { class: "name" };

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("div", _hoisted_1$4, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("span", _hoisted_2$1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.name), 1 /* TEXT */),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.modelColor = $event)),
      class: "value"
    }, null, 512 /* NEED_PATCH */), [
      [external_commonjs_vue_commonjs2_vue_root_Vue_.vModelText, _ctx.modelColor]
    ])
  ]))
}

script$5.render = render$5;
script$5.__file = "src/color/Box.vue";

var script$6 = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    name: 'ColorPicker',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        colorsDefault: {
            type: Array,
            default: () => [],
        },
        colorsHistoryKey: {
            type: String,
            default: '',
        },
    },
    emits: ['selectColor'],
    setup(props, { emit }) {
        const color = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
        const colorsHistory = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
        const imgAlphaBase64 = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
        if (props.colorsHistoryKey && localStorage) {
            colorsHistory.value =
                JSON.parse(localStorage.getItem(props.colorsHistoryKey)) || [];
        }
        imgAlphaBase64.value = createAlphaSquare(4).toDataURL();
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onUnmounted)(() => {
            setColorsHistory(color.value);
        });
        function setColorsHistory(color) {
            if (!color) {
                return;
            }
            const colors = colorsHistory.value || [];
            // @ts-ignore
            const index = colors.indexOf(color);
            if (index >= 0) {
                colors.splice(index, 1);
            }
            if (colors.length >= 8) {
                colors.length = 7;
            }
            // @ts-ignore
            colors.unshift(color);
            colorsHistory.value = colors || [];
            if (localStorage && props.colorsHistoryKey)
                localStorage.setItem(props.colorsHistoryKey, JSON.stringify(colors));
        }
        function selectColor(color) {
            emit('selectColor', color);
        }
        return {
            setColorsHistory,
            colorsHistory,
            color,
            imgAlphaBase64,
            selectColor,
        };
    },
});

const _hoisted_1$5 = { class: "colors" };
const _hoisted_2$2 = {
  key: 0,
  class: "colors history"
};

function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("div", null, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("ul", _hoisted_1$5, [
      ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.colorsDefault, (item) => {
        return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("li", {
          key: item,
          class: "item",
          onClick: $event => (_ctx.selectColor(item))
        }, [
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("div", {
            style: { background: `url(${_ctx.imgAlphaBase64})` },
            class: "alpha"
          }, null, 4 /* STYLE */),
          (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("div", {
            style: { background: item },
            class: "color"
          }, null, 4 /* STYLE */)
        ], 8 /* PROPS */, ["onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (_ctx.colorsHistory.length)
      ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("ul", _hoisted_2$2, [
          ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.colorsHistory, (item) => {
            return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("li", {
              key: item,
              class: "item",
              onClick: $event => (_ctx.selectColor(item))
            }, [
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("div", {
                style: { background: `url(${_ctx.imgAlphaBase64})` },
                class: "alpha"
              }, null, 4 /* STYLE */),
              (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("div", {
                style: { background: item },
                class: "color"
              }, null, 4 /* STYLE */)
            ], 8 /* PROPS */, ["onClick"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("v-if", true)
  ]))
}

script$6.render = render$6;
script$6.__file = "src/color/Colors.vue";

var script$7 = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    components: {
        Saturation: script,
        Hue: script$1,
        Alpha: script$2,
        Preview: script$3,
        Sucker: script$4,
        Box: script$5,
        Colors: script$6,
    },
    emits: ['changeColor', 'openSucker'],
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        theme: {
            type: String,
            default: 'dark',
        },
        suckerHide: {
            type: Boolean,
            default: true,
        },
        suckerCanvas: {
            type: null,
            default: null,
        },
        suckerArea: {
            type: Array,
            default: () => [],
        },
        colorsDefault: {
            type: Array,
            default: () => [
                '#000000',
                '#FFFFFF',
                '#FF1900',
                '#F47365',
                '#FFB243',
                '#FFE623',
                '#6EFF2A',
                '#1BC7B1',
                '#00BEFF',
                '#2E81FF',
                '#5D61FF',
                '#FF89CF',
                '#FC3CAD',
                '#BF3DCE',
                '#8E00A7',
                'rgba(0,0,0,0)',
            ],
        },
        colorsHistoryKey: {
            type: String,
            default: 'vue-colorpicker-history',
        },
    },
    data() {
        return {
            hueWidth: 15,
            hueHeight: 152,
            previewHeight: 30,
            modelRgba: '',
            modelHex: '',
            r: 0,
            g: 0,
            b: 0,
            a: 1,
            h: 0,
            s: 0,
            v: 0,
        };
    },
    computed: {
        isLightTheme() {
            return this.theme === 'light';
        },
        totalWidth() {
            return this.hueHeight + (this.hueWidth + 8) * 2;
        },
        previewWidth() {
            return this.totalWidth - (this.suckerHide ? 0 : this.previewHeight);
        },
        rgba() {
            return {
                r: this.r,
                g: this.g,
                b: this.b,
                a: this.a,
            };
        },
        hsv() {
            return {
                h: this.h,
                s: this.s,
                v: this.v,
            };
        },
        rgbString() {
            return `rgb(${this.r}, ${this.g}, ${this.b})`;
        },
        rgbaStringShort() {
            return `${this.r}, ${this.g}, ${this.b}, ${this.a}`;
        },
        rgbaString() {
            return `rgba(${this.rgbaStringShort})`;
        },
        hexString() {
            return rgb2hex(this.rgba, true);
        },
    },
    created() {
        Object.assign(this, setColorValue(this.color));
        this.setText();
        this.$watch('rgba', () => {
            this.$emit('changeColor', {
                rgba: this.rgba,
                hsv: this.hsv,
                hex: this.modelHex,
            });
        });
    },
    methods: {
        selectSaturation(color) {
            const { r, g, b, h, s, v } = setColorValue(color);
            Object.assign(this, { r, g, b, h, s, v });
            this.setText();
        },
        selectHue(color) {
            const { r, g, b, h, s, v } = setColorValue(color);
            Object.assign(this, { r, g, b, h, s, v });
            this.setText();
            this.$nextTick(() => {
                // @ts-ignore
                this.$refs.saturation.renderColor();
                // @ts-ignore
                this.$refs.saturation.renderSlide();
            });
        },
        selectAlpha(a) {
            this.a = a;
            this.setText();
        },
        inputHex(color) {
            const { r, g, b, a, h, s, v } = setColorValue(color);
            Object.assign(this, { r, g, b, a, h, s, v });
            this.modelHex = color;
            this.modelRgba = this.rgbaStringShort;
            this.$nextTick(() => {
                // @ts-ignore
                this.$refs.saturation.renderColor();
                // @ts-ignore
                this.$refs.saturation.renderSlide();
                // @ts-ignore
                this.$refs.hue.renderSlide();
            });
        },
        inputRgba(color) {
            const { r, g, b, a, h, s, v } = setColorValue(color);
            Object.assign(this, { r, g, b, a, h, s, v });
            this.modelHex = this.hexString;
            this.modelRgba = color;
            this.$nextTick(() => {
                // @ts-ignore
                this.$refs.saturation.renderColor();
                // @ts-ignore
                this.$refs.saturation.renderSlide();
                // @ts-ignore
                this.$refs.hue.renderSlide();
            });
        },
        setText() {
            this.modelHex = this.hexString;
            this.modelRgba = this.rgbaStringShort;
        },
        openSucker(isOpen) {
            this.$emit('openSucker', isOpen);
        },
        selectSucker(color) {
            const { r, g, b, a, h, s, v } = setColorValue(color);
            Object.assign(this, { r, g, b, a, h, s, v });
            this.setText();
            this.$nextTick(() => {
                // @ts-ignore
                this.$refs.saturation.renderColor();
                // @ts-ignore
                this.$refs.saturation.renderSlide();
                // @ts-ignore
                this.$refs.hue.renderSlide();
            });
        },
        selectColor(color) {
            const { r, g, b, a, h, s, v } = setColorValue(color);
            Object.assign(this, { r, g, b, a, h, s, v });
            this.setText();
            this.$nextTick(() => {
                // @ts-ignore
                this.$refs.saturation.renderColor();
                // @ts-ignore
                this.$refs.saturation.renderSlide();
                // @ts-ignore
                this.$refs.hue.renderSlide();
            });
        },
    },
});

const _hoisted_1$6 = { class: "color-set" };

function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Saturation = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("Saturation");
  const _component_Hue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("Hue");
  const _component_Alpha = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("Alpha");
  const _component_Preview = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("Preview");
  const _component_Sucker = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("Sucker");
  const _component_Box = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("Box");
  const _component_Colors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("Colors");

  return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)("div", {
    class: ["hu-color-picker", { light: _ctx.isLightTheme }],
    style: { width: _ctx.totalWidth + 'px' }
  }, [
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("div", _hoisted_1$6, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_Saturation, {
        ref: "saturation",
        color: _ctx.rgbString,
        hsv: _ctx.hsv,
        size: _ctx.hueHeight,
        onSelectSaturation: _ctx.selectSaturation
      }, null, 8 /* PROPS */, ["color", "hsv", "size", "onSelectSaturation"]),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_Hue, {
        ref: "hue",
        hsv: _ctx.hsv,
        width: _ctx.hueWidth,
        height: _ctx.hueHeight,
        onSelectHue: _ctx.selectHue
      }, null, 8 /* PROPS */, ["hsv", "width", "height", "onSelectHue"]),
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_Alpha, {
        ref: "alpha",
        color: _ctx.rgbString,
        rgba: _ctx.rgba,
        width: _ctx.hueWidth,
        height: _ctx.hueHeight,
        onSelectAlpha: _ctx.selectAlpha
      }, null, 8 /* PROPS */, ["color", "rgba", "width", "height", "onSelectAlpha"])
    ]),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)("div", {
      style: { height: _ctx.previewHeight + 'px' },
      class: "color-show"
    }, [
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_Preview, {
        color: _ctx.rgbaString,
        width: _ctx.previewWidth,
        height: _ctx.previewHeight
      }, null, 8 /* PROPS */, ["color", "width", "height"]),
      (!_ctx.suckerHide)
        ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_Sucker, {
            key: 0,
            "sucker-canvas": _ctx.suckerCanvas,
            "sucker-area": _ctx.suckerArea,
            onOpenSucker: _ctx.openSucker,
            onSelectSucker: _ctx.selectSucker
          }, null, 8 /* PROPS */, ["sucker-canvas", "sucker-area", "onOpenSucker", "onSelectSucker"]))
        : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("v-if", true)
    ], 4 /* STYLE */),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_Box, {
      name: "HEX",
      color: _ctx.modelHex,
      onInputColor: _ctx.inputHex
    }, null, 8 /* PROPS */, ["color", "onInputColor"]),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_Box, {
      name: "RGBA",
      color: _ctx.modelRgba,
      onInputColor: _ctx.inputRgba
    }, null, 8 /* PROPS */, ["color", "onInputColor"]),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_Colors, {
      color: _ctx.rgbaString,
      "colors-default": _ctx.colorsDefault,
      "colors-history-key": _ctx.colorsHistoryKey,
      onSelectColor: _ctx.selectColor
    }, null, 8 /* PROPS */, ["color", "colors-default", "colors-history-key", "onSelectColor"]),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)(" custom options "),
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")
  ], 6 /* CLASS, STYLE */))
}

script$7.render = render$7;
script$7.__file = "src/color/ColorPicker.vue";

script$7.install = (Vue) => {
    Vue.component(script$7.name, script$7);
};

function install(Vue) {
    Vue.component(script$7.name, script$7);
}
var index = { install };

/* harmony default export */ const vue_color_kit_esm_bundler = ((/* unused pure expression or super */ null && (index)));


;// ./src/components/atoms/input-color/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const input_color_style_module = ({"dtg-input-color":"lib_dtg-input-color_qWMXp","dtg-input-color__picker":"lib_dtg-input-color__picker_AGTOw"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-color/component.vue?vue&type=script&lang=ts











/* harmony default export */ const input_color_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(input_color_style_module),
  components: {
    ColorPicker: script$7,
    FocusTrap: FocusTrap,
    DtgInput: input_component,
    DtgButton: button_component
  },
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    },
    align: {
      type: String,
      default: 'bottom right',
      validator: value => {
        const [vertical, horizontal] = value.split(' ');
        return (0,array_.arrayIncludes)(['top', 'bottom'], vertical) && (0,array_.arrayIncludes)(['left', 'right'], horizontal);
      }
    },
    placeholder: {
      type: String,
      default: 'Ex: #FFFFFF'
    },
    defaultColors: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const shownPicker = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const modelValueInternal = propInternal(props, 'modelValue', emit);
    const actionRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const mask = {
      mask: '#FFFFFF',
      definitions: {
        F: /[0-9a-fA-F]/
      }
    };
    const style = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const [vertical, horizontal] = props.align.split(' ');
      return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [vertical]: '100%',
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [horizontal]: 0
      };
    });
    function onInputActionClick() {
      shownPicker.value = !shownPicker.value;
    }
    function onPickerChangeColor({
      hex
    }) {
      modelValueInternal.value = hex;
    }
    function clickOutsideDeactivates(event) {
      const actionEl = (0,get_element_from_ref_.getElementFromRef)(actionRef.value);
      if (!actionEl) {
        return true;
      }
      const target = event.target;
      const shouldIgnoreClick = actionEl === target || actionEl.contains(target);
      return !shouldIgnoreClick;
    }
    return {
      b: useBem(input_color_style_module),
      actionRef,
      style,
      shownPicker,
      modelValueInternal,
      mask,
      onInputActionClick,
      onPickerChangeColor,
      clickOutsideDeactivates,
      ...useFocusPropagation()
    };
  }
}));
;// ./src/components/atoms/input-color/component.vue?vue&type=script&lang=ts
 
;// ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-color/component.vue?vue&type=style&index=0&id=1d357109&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const componentvue_type_style_index_0_id_1d357109_lang_scss = ({});
;// ./src/components/atoms/input-color/component.vue?vue&type=style&index=0&id=1d357109&lang=scss

;// ./src/components/atoms/input-color/component.vue




;


const input_color_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(input_color_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_1d357109_ts_true_render]])

/* harmony default export */ const input_color_component = (input_color_component_exports_);
;// ./src/components/atoms/input-color/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-currency/component.vue?vue&type=template&id=23efd87c&ts=true

function componentvue_type_template_id_23efd87c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_input_number = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-number");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_input_number, {
    ref: "inputRef",
    precision: _ctx.precision,
    "no-controls": !_ctx.withControls
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
    _: 2
  }, [_ctx.currency && !_ctx.noCurrency ? {
    name: "unit",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.currency), 1)]),
    key: "0"
  } : undefined]), 1032, ["precision", "no-controls"]);
}
;// ./src/components/atoms/input-currency/component.vue?vue&type=template&id=23efd87c&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-number/component.vue?vue&type=template&id=6695d59f&ts=true

function componentvue_type_template_id_6695d59f_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _directive_long_click = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("long-click");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_input, {
    ref: "inputRef",
    "model-value": _ctx.inputValue,
    mode: _ctx.mode,
    mask: _ctx.mask,
    disabled: _ctx.disabled,
    name: _ctx.name,
    unmasked: "",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.onUnmaskedValue($event)),
    onMaskValues: _cache[5] || (_cache[5] = $event => _ctx.onMaskValues($event)),
    onKeydown: [_cache[6] || (_cache[6] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => _ctx.onKeyDown(1), ["prevent"]), ["up"])), _cache[7] || (_cache[7] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => _ctx.onKeyDown(-1), ["prevent"]), ["down"]))],
    onKeyup: _cache[8] || (_cache[8] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)($event => _ctx.onKeyUp(), ["up", "down"]))
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
    _: 2
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.$slots, (_, slot) => {
    return {
      name: slot,
      fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, slot)])
    };
  }), !_ctx.noControls ? {
    name: "extra",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('controls'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('step', {
        up: true,
        active: _ctx.stepUpActive
      })),
      disabled: _ctx.disabled || _ctx.stepUpDisabled,
      tabindex: "-1",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.onStepClick(1)),
      onLongClick: _cache[1] || (_cache[1] = $event => _ctx.onStepClick(1))
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('step-icon')),
        name: "chevron"
      }, null, 8, ["class"])]),
      _: 1
    }, 8, ["class", "disabled"])), [[_directive_long_click]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('step', {
        active: _ctx.stepDownActive
      })),
      disabled: _ctx.disabled || _ctx.stepDownDisabled,
      tabindex: "-1",
      onClick: _cache[2] || (_cache[2] = $event => _ctx.onStepClick(-1)),
      onLongClick: _cache[3] || (_cache[3] = $event => _ctx.onStepClick(-1))
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('step-icon')),
        name: "chevron"
      }, null, 8, ["class"])]),
      _: 1
    }, 8, ["class", "disabled"])), [[_directive_long_click]])], 2)]),
    key: "0"
  } : undefined]), 1032, ["model-value", "mode", "mask", "disabled", "name"]);
}
;// ./src/components/atoms/input-number/component.vue?vue&type=template&id=6695d59f&ts=true

// EXTERNAL MODULE: external "dtg-shared/utils/number"
var number_ = __webpack_require__(2249);
// EXTERNAL MODULE: external "dtg-shared/utils/event-to-prop-name"
var event_to_prop_name_ = __webpack_require__(1600);
;// ./src/utils/vue-emit.ts

function vueEmit(vnode, name, data) {
  const propName = (0,event_to_prop_name_.eventToPropName)(name);
  const handler = vnode.props?.[propName];
  if (handler && typeof handler === 'function') {
    handler(data);
  }
}
;// ./src/directives/long-click/composables/use-long-click-handlers.ts

const EVENT_NAME = 'long-click';
function useLongClickHandlers(vnode, {
  interval = 50,
  delay = 400
} = {}) {
  let pressTimer = -1;
  let pressInterval = -1;
  let isLongClicking = false;
  function start(event) {
    if (isClickEvent(event) && event.button !== 0) {
      return;
    }
    window.clearTimeout(pressTimer);
    window.clearInterval(pressInterval);
    pressTimer = window.setTimeout(() => {
      isLongClicking = true;
      if (interval !== false) {
        pressInterval = window.setInterval(() => {
          emit(event);
        }, interval);
      }
      emit(event);
    }, delay);
  }
  function stop(event) {
    if (isLongClicking && event) {
      event.preventDefault();
      event.stopPropagation();
    }
    isLongClicking = false;
    window.clearTimeout(pressTimer);
    window.clearInterval(pressInterval);
  }
  function emit(event) {
    vueEmit(vnode, EVENT_NAME, event);
  }
  function isClickEvent(event) {
    return event.type === 'click';
  }
  return {
    start,
    stop
  };
}
;// ./src/directives/long-click/directive.ts


const START_EVENT_NAMES = ['mousedown', 'touchstart'];
const CANCEL_EVENT_NAMES = ['click', 'pointerleave', 'mouseleave', 'touchend', 'touchcancel'];
const handlersMap = new WeakMap();
const longClick = {
  mounted(el, binding, vnode) {
    const handlers = useLongClickHandlers(vnode, binding.value);
    addHandlers(el, handlers);
  },
  updated(el, binding, vnode) {
    if (isEqual_default()(binding.value, binding.oldValue)) {
      return;
    }
    removeHandlers(el);
    const handlers = useLongClickHandlers(vnode, binding.value);
    addHandlers(el, handlers);
  },
  unmounted(el) {
    removeHandlers(el);
  }
};
function addHandlers(el, handlers) {
  START_EVENT_NAMES.forEach(eventName => {
    el.addEventListener(eventName, handlers.start, {
      passive: true
    });
  });
  CANCEL_EVENT_NAMES.forEach(event => {
    el.addEventListener(event, handlers.stop, {
      capture: true
    });
  });
  handlersMap.set(el, handlers);
}
function removeHandlers(el) {
  const handlers = handlersMap.get(el);
  if (!handlers) {
    return;
  }
  START_EVENT_NAMES.forEach(eventName => {
    el.removeEventListener(eventName, handlers.start);
  });
  CANCEL_EVENT_NAMES.forEach(event => {
    el.removeEventListener(event, handlers.stop, {
      capture: true
    });
  });
  handlers.stop();
  handlersMap.delete(el);
}

;// ./src/directives/long-click/index.ts



;// ./src/components/atoms/input-number/composables/use-steps.ts


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useSteps({
  value,
  min,
  max,
  step,
  precision
}) {
  const stepUpActive = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
  const stepDownActive = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
  const stepUpDisabled = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => isLimitReached(value.value, max.value, 1));
  const stepDownDisabled = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => isLimitReached(value.value, min.value, -1));
  function isLimitReached(value, limit, modifier) {
    const numberValue = value ?? 0;
    return limit !== null && numberValue * modifier >= limit * modifier;
  }
  function isLimitExceeded(value, limit, modifier) {
    if (value === null || limit === null) {
      return false;
    }
    return value * modifier > limit * modifier;
  }
  function stepValue(direction) {
    const diff = step.value * direction;
    const valueWithDiff = value.value === null ? diff : value.value + diff;
    const fixedValue = parseFloat(valueWithDiff.toFixed(precision.value));
    value.value = (0,number_.clamp)(fixedValue, min.value ?? -Infinity, max.value ?? Infinity);
  }
  function activateStep(direction) {
    deactivateSteps();
    const step = direction > 0 ? stepUpActive : stepDownActive;
    step.value = true;
  }
  function deactivateSteps() {
    stepDownActive.value = false;
    stepUpActive.value = false;
  }
  function onStepClick(direction) {
    stepValue(direction);
  }
  function onKeyDown(direction) {
    activateStep(direction);
    stepValue(direction);
  }
  function onKeyUp() {
    deactivateSteps();
  }
  return {
    stepUpActive,
    stepDownActive,
    stepUpDisabled,
    stepDownDisabled,
    onStepClick,
    onKeyDown,
    onKeyUp,
    isLimitExceeded
  };
}
;// ./src/components/atoms/input-number/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const input_number_style_module = ({"dtg-input-number__controls":"lib_dtg-input-number__controls_9PGSk","dtg-input-number__step":"lib_dtg-input-number__step_qu5pK","dtg-input-number__step-icon":"lib_dtg-input-number__step-icon_gz1ZU","dtg-input-number__step_active":"lib_dtg-input-number__step_active_qe7PO","dtg-input-number__step_up":"lib_dtg-input-number__step_up_Xkmsc"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-number/component.vue?vue&type=script&lang=ts












/* harmony default export */ const input_number_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(input_number_style_module),
  components: {
    DtgInput: input_component,
    DtgAction: action_component,
    DtgIcon: icon_component
  },
  directives: {
    longClick: longClick
  },
  props: {
    name: {
      type: String,
      required: true
    },
    modelValue: {
      type: Number,
      default: null
    },
    precision: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    step: {
      type: Number,
      default: 1
    },
    noControls: {
      type: Boolean,
      default: false
    },
    nonNullable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const propRefs = (0,refs_.toReadonlyRefs)(props);
    const inputValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        modelValue
      } = props;
      return modelValue === null ? '' : String(modelValue);
    });
    const value = propInternal(props, 'modelValue', emit, equalityCheck);
    const mode = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.precision > 0 ? DtgInputMode.decimal : DtgInputMode.numeric);
    const mask = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        min,
        max,
        precision: scale
      } = props;
      const signed = min !== 0;
      return {
        mask: Number,
        // eslint-disable-next-line no-undefined
        min: min ?? undefined,
        // eslint-disable-next-line no-undefined
        max: max ?? undefined,
        signed,
        scale
      };
    });
    const {
      isLimitExceeded,
      ...steps
    } = useSteps({
      value,
      ...propRefs
    });
    function onUnmaskedValue(unmaskedValue) {
      // We have to manually handle the case where the value starts with zero, e.g. 02
      // That input is not considered valid by our mask, and isn't emitted
      if (!/^0[1-9]+$/.exec(unmaskedValue)) {
        return;
      }
      const typedValue = parseFloat(unmaskedValue);
      if (isOutsideBounds(typedValue) || Number.isNaN(typedValue)) {
        return;
      }
      value.value = typedValue;
    }
    function onMaskValues(values) {
      const {
        value: stringValue,
        typedValue
      } = values;
      // In this case typedValue is -0, which gets converted to 0, erasing the -
      if (stringValue === '-') {
        return;
      }
      if (stringValue === '') {
        resetValue();
        return;
      }
      if (isOutsideBounds(typedValue)) {
        return;
      }
      value.value = typedValue;
    }
    function equalityCheck(a, b) {
      if (a === b) {
        return true;
      }
      if (a === null || b === null) {
        return false;
      }
      const {
        precision
      } = props;
      const aRounded = (0,number_.roundToPrecision)(a, precision);
      const bRounded = (0,number_.roundToPrecision)(b, precision);
      return (0,number_.areFloatsEqual)(aRounded, bRounded);
    }
    function resetValue() {
      const {
        nonNullable,
        min,
        max
      } = props;
      if (nonNullable) {
        value.value = (0,number_.clamp)(0, min ?? 0, max ?? 0);
      } else {
        value.value = null;
      }
    }
    function isOutsideBounds(typedValue) {
      const {
        min,
        max
      } = props;
      return isLimitExceeded(typedValue, min, -1) || isLimitExceeded(typedValue, max, 1);
    }
    return {
      b: useBem(input_number_style_module),
      inputValue,
      mode,
      mask,
      onMaskValues,
      onUnmaskedValue,
      ...steps,
      ...useFocusPropagation()
    };
  }
}));
;// ./src/components/atoms/input-number/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/input-number/component.vue




;
const input_number_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(input_number_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_6695d59f_ts_true_render]])

/* harmony default export */ const input_number_component = (input_number_component_exports_);
;// ./src/components/atoms/input-number/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-currency/component.vue?vue&type=script&lang=ts



/* harmony default export */ const input_currency_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-input-currency',
  components: {
    DtgInputNumber: input_number_component
  },
  props: {
    precision: {
      type: Number,
      default: 2
    },
    withControls: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: '€'
    },
    noCurrency: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      ...useFocusPropagation()
    };
  }
}));
;// ./src/components/atoms/input-currency/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/input-currency/component.vue




;
const input_currency_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(input_currency_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_23efd87c_ts_true_render]])

/* harmony default export */ const input_currency_component = (input_currency_component_exports_);
;// ./src/components/atoms/input-currency/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-date/component.vue?vue&type=template&id=6e8ba066&ts=true

function componentvue_type_template_id_6e8ba066_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_input_date_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-date-base");
  const _component_dtg_datepicker_popup = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-datepicker-popup");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_datepicker_popup, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.splitAttrs.root, {
    modelValue: _ctx.modelValueInternal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.modelValueInternal = $event),
    visible: _ctx.pickerVisible,
    "onUpdate:visible": _cache[3] || (_cache[3] = $event => _ctx.pickerVisible = $event),
    align: _ctx.align,
    "click-outside-ignore": _ctx.clickOutsideIgnore,
    onSelect: _cache[4] || (_cache[4] = $event => _ctx.onSelectDate())
  }), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_date_base, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
      ref: "inputRef"
    }, {
      ..._ctx.splitAttrs.attrs,
      ..._ctx.splitAttrs.listeners
    }, {
      modelValue: _ctx.modelValueInternal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.modelValueInternal = $event),
      name: _ctx.name,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      "display-format": _ctx.displayFormat
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
      _: 2
    }, [!_ctx.noPicker ? {
      name: "action",
      fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        ref: "actionRef",
        disabled: _ctx.disabled,
        icon: "calendar",
        view: "inverted",
        size: "s",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onActionClick())
      }, null, 8, ["disabled"])]),
      key: "0"
    } : undefined]), 1040, ["modelValue", "name", "placeholder", "disabled", "display-format"])]),
    _: 1
  }, 16, ["modelValue", "visible", "align", "click-outside-ignore"]);
}
;// ./src/components/atoms/input-date/component.vue?vue&type=template&id=6e8ba066&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker-popup/component.vue?vue&type=template&id=8a9636d0&ts=true

function componentvue_type_template_id_8a9636d0_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_datepicker = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-datepicker");
  const _component_focus_trap = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("focus-trap");
  const _component_dtg_transition_stack = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-transition-stack");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: _ctx.b()
  }, _ctx.splitAttrs.root), [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    ref: "slotRef",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('slot'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_transition_stack, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.visibleInternal ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('picker-wrapper')),
      style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.style)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_focus_trap, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('picker')),
      active: _ctx.visibleInternal,
      "onUpdate:active": _cache[0] || (_cache[0] = $event => _ctx.visibleInternal = $event),
      "click-outside-deactivates": _ctx.clickOutsideDeactivates,
      "fallback-focus": () => _ctx.slotRef,
      "escape-deactivates": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_datepicker, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)({
        ..._ctx.splitAttrs.attrs,
        ..._ctx.splitAttrs.listeners
      })), null, 16)]),
      _: 1
    }, 8, ["class", "active", "click-outside-deactivates", "fallback-focus"])], 6)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 1
  })], 16);
}
;// ./src/components/atoms/datepicker-popup/component.vue?vue&type=template&id=8a9636d0&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/transition-stack/component.vue?vue&type=template&id=59d59d80&ts=true

function componentvue_type_template_id_59d59d80_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Transition, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.disabled ? {} : _ctx.listeners, {
    name: _ctx.disabled ? '' : _ctx.b()
  }), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    _: 3
  }, 16, ["name"]);
}
;// ./src/components/atoms/transition-stack/component.vue?vue&type=template&id=59d59d80&ts=true

;// ./src/composables/use-height-transition.ts


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useHeightTransition(between = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false), transitionResetTimeout = 500) {
  const lastHeight = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(0);
  let transitionResetTimeoutId = -1;
  function onLeave(el) {
    if (between.value) {
      lastHeight.value = el.clientHeight;
    } else {
      const from = el.clientHeight;
      const to = 0;
      lastHeight.value = 0;
      void transitionHeight(el, from, to);
    }
  }
  async function onEnter(el) {
    const from = lastHeight.value;
    const to = await getClientHeight(el);
    void transitionHeight(el, from, to);
  }
  function onAfterLeave(el) {
    void resetTransition(el);
  }
  function onAfterEnter(el) {
    void resetTransition(el);
    lastHeight.value = 0;
  }
  async function transitionHeight(el, from, to) {
    el.style.height = `${from}px`;
    el.style.overflow = 'hidden';
    setPaddings(el, from === 0 ? '0' : '');
    await (0,double_raf_.doubleRAF)();
    // eslint-disable-next-line require-atomic-updates
    el.style.height = `${to}px`;
    setPaddings(el, to === 0 ? '0' : '');
    // Reset height after Xms in case the onAfter callback is not called
    resetTransitionFallback(el);
  }
  function resetTransitionFallback(el) {
    window.clearTimeout(transitionResetTimeoutId);
    transitionResetTimeoutId = window.setTimeout(async () => {
      await resetTransition(el);
    }, transitionResetTimeout);
  }
  async function resetTransition(el) {
    // Delay for when onAfterEnter happens in the same frame as onEnter
    await (0,double_raf_.doubleRAF)();
    showElement(el);
  }
  async function getClientHeight(el) {
    hideElement(el);
    await (0,double_raf_.doubleRAF)();
    showElement(el);
    return el.clientHeight;
  }
  function setPaddings(el, value) {
    Object.assign(el, {
      paddingTop: value,
      paddingBottom: value,
      marginTop: value,
      marginBottom: value
    });
  }
  function hideElement(el) {
    el.style.height = '0';
    el.style.overflow = 'hidden';
    setPaddings(el, '0');
  }
  function showElement(el) {
    el.style.height = '';
    el.style.overflow = '';
    setPaddings(el, '');
  }
  return {
    onEnter,
    onLeave,
    onAfterEnter,
    onAfterLeave
  };
}
;// ./src/components/atoms/transition-stack/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const transition_stack_style_module = ({"dtg-transition-stack":"lib_dtg-transition-stack_h485i"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/transition-stack/component.vue?vue&type=script&lang=ts




/* harmony default export */ const transition_stack_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(transition_stack_style_module),
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      b: useBem(transition_stack_style_module),
      listeners: useHeightTransition()
    };
  }
}));
;// ./src/components/atoms/transition-stack/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/transition-stack/component.vue




;
const transition_stack_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(transition_stack_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_59d59d80_ts_true_render]])

/* harmony default export */ const transition_stack_component = (transition_stack_component_exports_);
;// ./src/components/atoms/transition-stack/index.ts


;// ./src/components/atoms/datepicker-popup/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const datepicker_popup_style_module = ({"dtg-datepicker-popup":"lib_dtg-datepicker-popup_YmRRA","dtg-datepicker-popup__slot":"lib_dtg-datepicker-popup__slot_Tkz6B","dtg-datepicker-popup__picker-wrapper":"lib_dtg-datepicker-popup__picker-wrapper_VdLEi","dtg-datepicker-popup__picker":"lib_dtg-datepicker-popup__picker_r4s7T"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/datepicker-popup/component.vue?vue&type=script&lang=ts









/* harmony default export */ const datepicker_popup_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(datepicker_popup_style_module),
  components: {
    FocusTrap: FocusTrap,
    DtgDatepicker: datepicker_component,
    DtgTransitionStack: transition_stack_component
  },
  inheritAttrs: false,
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    align: {
      type: String,
      default: 'top right',
      validator: value => {
        const [vertical, horizontal] = value.split(' ');
        return (0,array_.arrayIncludes)(['top', 'bottom'], vertical) && (0,array_.arrayIncludes)(['left', 'right'], horizontal);
      }
    },
    clickOutsideIgnore: {
      type: Function,
      default: () => false
    }
  },
  emits: ['update:visible'],
  setup(props, {
    attrs,
    emit
  }) {
    const visibleInternal = propInternal(props, 'visible', emit);
    const splitAttrs = useSplitAttrs(attrs);
    const slotRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const style = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const [vertical, horizontal] = props.align.split(' ');
      return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [vertical]: '100%',
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [horizontal]: '-10px'
      };
    });
    function clickOutsideDeactivates(event) {
      return !props.clickOutsideIgnore(event);
    }
    return {
      b: useBem(datepicker_popup_style_module),
      slotRef,
      splitAttrs,
      style,
      visibleInternal,
      clickOutsideDeactivates
    };
  }
}));
;// ./src/components/atoms/datepicker-popup/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/datepicker-popup/component.vue




;
const datepicker_popup_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(datepicker_popup_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_8a9636d0_ts_true_render]])

/* harmony default export */ const datepicker_popup_component = (datepicker_popup_component_exports_);
;// ./src/components/atoms/datepicker-popup/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-date/elems/input-date-base/component.vue?vue&type=template&id=2605b15a&ts=true

function componentvue_type_template_id_2605b15a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_input, {
    ref: "inputRef",
    modelValue: _ctx.modelValueInternal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
    mask: _ctx.mask,
    onFocus: _cache[1] || (_cache[1] = $event => _ctx.onFocus()),
    onBlur: _cache[2] || (_cache[2] = $event => _ctx.onBlur()),
    onMaskValues: _cache[3] || (_cache[3] = $event => _ctx.onInput($event)),
    onMaskCompleteValues: _cache[4] || (_cache[4] = $event => _ctx.onInputComplete($event))
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
    _: 2
  }, [_ctx.$slots.action ? {
    name: "action",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "action")]),
    key: "0"
  } : undefined]), 1032, ["modelValue", "mask"]);
}
;// ./src/components/atoms/input-date/elems/input-date-base/component.vue?vue&type=template&id=2605b15a&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-date/elems/input-date-base/component.vue?vue&type=script&lang=ts






/* harmony default export */ const input_date_base_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-input-date-base',
  components: {
    DtgInput: input_component
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    displayFormat: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue', 'focus', 'blur'],
  setup(props, {
    emit
  }) {
    const {
      modelValue
    } = (0,refs_.toReadonlyRefs)(props);
    const focused = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const modelValueMasked = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)('');
    const modelValueInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
      get: () => {
        return focused.value ? modelValueMasked.value : formatDisplayDate(modelValue.value);
      },
      set: value => {
        if (focused.value) {
          modelValueMasked.value = value;
        }
      }
    });
    const inputFormat = 'DD/MM/YYYY';
    const mask = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      if (!focused.value) {
        return null;
      }
      return {
        mask: Date,
        pattern: '`DD/`MM/`YYYY',
        blocks: {
          DD: {
            mask: MaskedRange,
            from: 1,
            to: 31,
            maxLength: 2
          },
          MM: {
            mask: MaskedRange,
            from: 1,
            to: 12,
            maxLength: 2,
            autofix: 'pad'
          },
          YYYY: {
            mask: MaskedRange,
            from: 1000,
            to: 9999
          }
        },
        parse: parseDate,
        format: formatMaskedDate,
        lazy: false,
        eager: true,
        overwrite: true
      };
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)([modelValue, focused], ([value, focused]) => {
      if (!focused) {
        modelValueMasked.value = value ? formatMaskedDate(value) : '';
      }
    }, {
      immediate: true
    });
    function parseDate(dateStr) {
      return (0,date_.createUtcDate)(dateStr, inputFormat, true).toDate();
    }
    function formatMaskedDate(date) {
      return (0,date_.formatDate)((0,date_.createUtcDate)(date), inputFormat);
    }
    function formatDisplayDate(date) {
      return date ? (0,date_.formatDate)(date, props.displayFormat) : '';
    }
    function onInput({
      unmaskedValue
    }) {
      if (!unmaskedValue) {
        emit('update:modelValue', null);
      }
    }
    function onInputComplete({
      typedValue
    }) {
      emit('update:modelValue', typedValue.toISOString());
    }
    function onBlur() {
      focused.value = false;
      emit('blur');
    }
    function onFocus() {
      focused.value = true;
      emit('focus');
    }
    return {
      modelValueInternal,
      mask,
      onBlur,
      onFocus,
      onInput,
      onInputComplete,
      ...useFocusPropagation()
    };
  }
}));
;// ./src/components/atoms/input-date/elems/input-date-base/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/input-date/elems/input-date-base/component.vue




;
const input_date_base_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(input_date_base_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_2605b15a_ts_true_render]])

/* harmony default export */ const input_date_base_component = (input_date_base_component_exports_);
;// ./src/components/atoms/input-date/elems/input-date-base/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-date/component.vue?vue&type=script&lang=ts








/* harmony default export */ const input_date_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-input-date',
  components: {
    DtgInputDateBase: input_date_base_component,
    DtgDatepickerPopup: datepicker_popup_component,
    DtgButton: button_component
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: '__/__/____'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    displayFormat: {
      type: String,
      default: 'DD/MM/YYYY'
    },
    noPicker: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      // eslint-disable-next-line no-undefined
      default: undefined
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    attrs,
    emit
  }) {
    const actionRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const splitAttrs = useSplitAttrs(attrs);
    const modelValueInternal = propInternal(props, 'modelValue', emit);
    const pickerVisible = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      if (!props.disabled && typeof props.modelValue === 'number') {
        // eslint-disable-next-line no-console
        console.error(`
                    DtgDatepicker: numeric modelValue will be changed to string once user selects a date.
                    Numeric modelValue is only supported in disabled state.
                `);
      }
    });
    function clickOutsideIgnore(event) {
      const actionEl = (0,get_element_from_ref_.getElementFromRef)(actionRef.value);
      if (!actionEl) {
        return true;
      }
      const target = event.target;
      return actionEl === target || actionEl.contains(target);
    }
    function onActionClick() {
      pickerVisible.value = !pickerVisible.value;
    }
    function onSelectDate() {
      pickerVisible.value = false;
    }
    return {
      actionRef,
      modelValueInternal,
      pickerVisible,
      splitAttrs,
      clickOutsideIgnore,
      onActionClick,
      onSelectDate,
      ...useFocusPropagation()
    };
  }
}));
;// ./src/components/atoms/input-date/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/input-date/component.vue




;
const input_date_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(input_date_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_6e8ba066_ts_true_render]])

/* harmony default export */ const input_date_component = (input_date_component_exports_);
;// ./src/components/atoms/input-date/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-email/component.vue?vue&type=template&id=9f4f03f0&ts=true

function componentvue_type_template_id_9f4f03f0_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_input, {
    modelValue: _ctx.modelValueInternal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
    name: _ctx.name,
    disabled: _ctx.disabled,
    mode: "email"
  }, {
    action: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
      "no-interaction": !_ctx.disabled,
      disabled: _ctx.disabled,
      icon: "mail",
      view: "inverted",
      size: "s"
    }, null, 8, ["no-interaction", "disabled"])]),
    _: 1
  }, 8, ["modelValue", "name", "disabled"]);
}
;// ./src/components/atoms/input-email/component.vue?vue&type=template&id=9f4f03f0&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-email/component.vue?vue&type=script&lang=ts




/* harmony default export */ const input_email_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-input-email',
  components: {
    DtgInput: input_component,
    DtgButton: button_component
  },
  props: {
    name: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const modelValueInternal = propInternal(props, 'modelValue', emit);
    return {
      modelValueInternal
    };
  }
}));
;// ./src/components/atoms/input-email/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/input-email/component.vue




;
const input_email_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(input_email_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_9f4f03f0_ts_true_render]])

/* harmony default export */ const input_email_component = (input_email_component_exports_);
;// ./src/components/atoms/input-email/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-file/component.vue?vue&type=template&id=289c60dc&ts=true

function componentvue_type_template_id_289c60dc_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_file_chooser = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-file-chooser");
  const _component_dtg_progress = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-progress");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('file-wrapper'))
  }, [_ctx.selectable ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_file_chooser, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    key: 0
  }, {
    ..._ctx.splitAttrs.attrs
  }, {
    max: 1,
    accept: _ctx.accept,
    format: _ctx.format,
    name: _ctx.name,
    onFile: _cache[0] || (_cache[0] = $event => _ctx.onFile($event)),
    onError: _cache[1] || (_cache[1] = $event => _ctx.onError($event))
  }), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(({
      openFileChooser,
      processing
    }) => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
      ref: "inputRef"
    }, {
      ..._ctx.splitAttrs.root,
      ..._ctx.splitAttrs.listeners
    }, {
      "model-value": _ctx.fileName,
      name: _ctx.inputName,
      disabled: _ctx.disabled,
      placeholder: _ctx.placeholder,
      readonly: "",
      "no-click-to-focus": "",
      onClick: $event => _ctx.onClickInternal(openFileChooser),
      onKeydown: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)($event => _ctx.onClickInternal(openFileChooser), ["enter"])
    }), {
      action: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        icon: _ctx.inputIcon,
        disabled: _ctx.disabled,
        "no-interaction": processing,
        view: "inverted",
        size: "s",
        onClick: $event => _ctx.onInputAction(openFileChooser)
      }, null, 8, ["icon", "disabled", "no-interaction", "onClick"])]),
      _: 2
    }, 1040, ["model-value", "name", "disabled", "placeholder", "onClick", "onKeydown"])]),
    _: 1
  }, 16, ["accept", "format", "name"])) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('file'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('file-name')),
    "model-value": _ctx.filename,
    name: "filename",
    disabled: ""
  }, null, 8, ["class", "model-value"])], 2)), _ctx.uploading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_progress, {
    key: 2,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('progress')),
    value: _ctx.uploadProgress
  }, null, 8, ["class", "value"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), _ctx.replaceable || _ctx.$slots.fileActions && !_ctx.selectable ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('actions'))
  }, [_ctx.$slots.fileActions && !_ctx.selectable ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "fileActions", {
    key: 0
  }) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.replaceable ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_button, {
    key: 1,
    disabled: _ctx.disabled,
    icon: _ctx.iconReplace,
    onClick: _cache[2] || (_cache[2] = $event => _ctx.onReplaceClick())
  }, null, 8, ["disabled", "icon"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// ./src/components/atoms/input-file/component.vue?vue&type=template&id=289c60dc&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/progress/component.vue?vue&type=template&id=28c9c648&ts=true

function componentvue_type_template_id_28c9c648_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      size: _ctx.size,
      reversed: _ctx.reversed,
      disabled: _ctx.disabled
    }))
  }, [_ctx.type === _ctx.DtgProgressType.indeterminate ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('progress-buffer-bar'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('indeterminate-bar-primary'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('progress-indeterminate'))
  }, null, 2)], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('indeterminate-bar-secondary'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('progress-indeterminate'))
  }, null, 2)], 2)], 2)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('progress')),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      transform: `scaleX(${_ctx.valueInternal})`
    })
  }, null, 6), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('buffer-circles-wrapper')),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      transform: `translateX(${_ctx.bufferInternal * 100}%)`
    })
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('buffer-circles-wrapper')),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      transform: `translateX(-${_ctx.bufferInternal * 100}%)`
    })
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('buffer-circles'))
  }, null, 2)], 6)], 6), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.bufferInternal !== 1]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('progress-buffer-bar')),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      transform: `scaleX(${_ctx.bufferInternal})`
    })
  }, null, 6)], 64)), _ctx.percentVisible ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 2,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('percent'))
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.percent) + " %", 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// ./src/components/atoms/progress/component.vue?vue&type=template&id=28c9c648&ts=true

;// ./src/components/atoms/progress/types.ts
var DtgProgressType;
(function (DtgProgressType) {
  DtgProgressType["determinate"] = "determinate";
  DtgProgressType["indeterminate"] = "indeterminate";
})(DtgProgressType || (DtgProgressType = {}));
var DtgProgressSize;
(function (DtgProgressSize) {
  DtgProgressSize["s"] = "s";
  DtgProgressSize["l"] = "l";
})(DtgProgressSize || (DtgProgressSize = {}));
;// ./src/components/atoms/progress/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const progress_style_module = ({"dtg-progress":"lib_dtg-progress_Hch5L","dtg-progress_size_s":"lib_dtg-progress_size_s_Izsnj","dtg-progress_size_l":"lib_dtg-progress_size_l_pu7Eo","dtg-progress_reversed":"lib_dtg-progress_reversed_mGDvA","dtg-progress__progress":"lib_dtg-progress__progress_TFBAZ","dtg-progress__progress-indeterminate":"lib_dtg-progress__progress-indeterminate_v6r33","dtg-progress__indeterminate-bar-primary":"lib_dtg-progress__indeterminate-bar-primary_trfrM","dtg-progress__indeterminate-bar-secondary":"lib_dtg-progress__indeterminate-bar-secondary_w2aTI","dtg-progress__progress-buffer-bar":"lib_dtg-progress__progress-buffer-bar_TLqid","dtg-progress__buffer-circles-wrapper":"lib_dtg-progress__buffer-circles-wrapper_FCcgg","dtg-progress__buffer-circles":"lib_dtg-progress__buffer-circles_K1OK0","buffering":"lib_buffering_qPhj4","primary-indeterminate-translate":"lib_primary-indeterminate-translate_LwUYT","primary-indeterminate-scale":"lib_primary-indeterminate-scale_NJKsq","secondary-indeterminate-translate":"lib_secondary-indeterminate-translate_rrf3s","secondary-indeterminate-scale":"lib_secondary-indeterminate-scale_e0uWD","dtg-progress_disabled":"lib_dtg-progress_disabled_yfq9S","dtg-progress__percent":"lib_dtg-progress__percent_ER906"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/progress/component.vue?vue&type=script&lang=ts






/* harmony default export */ const progress_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(progress_style_module),
  props: {
    type: {
      type: String,
      default: DtgProgressType.determinate,
      validator: inRecord(DtgProgressType)
    },
    value: {
      type: Number,
      default: 0
    },
    buffer: {
      type: Number,
      default: 1
    },
    reversed: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: DtgProgressSize.s,
      validator: inRecord(DtgProgressSize)
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const valueInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => (0,number_.clamp)(0, props.value, 1));
    const bufferInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => (0,number_.clamp)(0, props.buffer, 1));
    const percent = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => Math.round(valueInternal.value * 100));
    const percentVisible = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.size === DtgProgressSize.l && props.type === DtgProgressType.determinate && bufferInternal.value === 1;
    });
    return {
      b: useBem(progress_style_module),
      percent,
      percentVisible,
      valueInternal,
      bufferInternal,
      DtgProgressType: DtgProgressType
    };
  }
}));
;// ./src/components/atoms/progress/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/progress/component.vue




;
const progress_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(progress_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_28c9c648_ts_true_render]])

/* harmony default export */ const progress_component = (progress_component_exports_);
;// ./src/components/atoms/progress/index.ts



;// ./src/components/atoms/input-file/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const input_file_style_module = ({"dtg-input-file":"lib_dtg-input-file_mJFKX","dtg-input-file__file-wrapper":"lib_dtg-input-file__file-wrapper_vgcnq","dtg-input-file__file":"lib_dtg-input-file__file_DHduA","dtg-input-file__file-name":"lib_dtg-input-file__file-name_oUr51","dtg-input-file__actions":"lib_dtg-input-file__actions_q2RvC","dtg-input-file__progress":"lib_dtg-input-file__progress_KQkOV"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-file/component.vue?vue&type=script&lang=ts












/* harmony default export */ const input_file_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(input_file_style_module),
  components: {
    DtgFileChooser: file_chooser_component,
    DtgButton: button_component,
    DtgInput: input_component,
    DtgProgress: progress_component
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Choisir un fichier'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: '*'
    },
    format: {
      type: String,
      default: read_blob_.BlobFormat.binaryString
    },
    nonReplaceable: {
      type: Boolean,
      default: false
    },
    replaced: {
      type: Boolean,
      default: false
    },
    existingFile: {
      type: Object,
      default: null
    },
    uploadProgress: {
      type: Number,
      default: 0
    },
    uploading: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function,
      // eslint-disable-next-line no-undefined
      default: undefined
    }
  },
  emits: ['update:modelValue', 'update:replaced', 'delete', 'add'],
  setup(props, {
    emit,
    attrs
  }) {
    const modelValueInternal = propInternal(props, 'modelValue', emit);
    const replacedInternal = propInternal(props, 'replaced', emit);
    const splitAttrs = useSplitAttrs(attrs);
    const fileName = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return modelValueInternal.value?.name ?? '';
    });
    const inputName = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => `${props.name}-input`);
    const inputIcon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => modelValueInternal.value ? 'closeCircle' : 'folder');
    const replaceable = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        existingFile,
        nonReplaceable
      } = props;
      return existingFile && !nonReplaceable;
    });
    const selectable = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        existingFile,
        nonReplaceable
      } = props;
      return !existingFile || !nonReplaceable && replacedInternal.value;
    });
    const filename = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.existingFile?.name ?? '');
    const iconReplace = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return selectable.value ? 'reload' : 'closeCircle';
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(replacedInternal, value => {
      if (!value) {
        modelValueInternal.value = null;
      }
    });
    function onFile(file) {
      modelValueInternal.value = file;
      emit('add', file);
    }
    function onInputAction(openFileChooser) {
      if (props.uploading) {
        return;
      }
      if (modelValueInternal.value) {
        modelValueInternal.value = null;
      } else {
        onOpenFileChooser(openFileChooser);
      }
    }
    function onClickInternal(openFileChooser) {
      if (!props.uploading && !props.modelValue) {
        onOpenFileChooser(openFileChooser);
      }
    }
    function onOpenFileChooser(openFileChooser) {
      if (props.onClick) {
        props.onClick(openFileChooser);
      } else {
        openFileChooser();
      }
    }
    function onReplaceClick() {
      replacedInternal.value = !replacedInternal.value;
      emit('delete');
    }
    function onError(message) {
      void openToast(message);
    }
    return {
      b: useBem(input_file_style_module),
      replaceable,
      selectable,
      filename,
      iconReplace,
      splitAttrs,
      fileName,
      inputName,
      inputIcon,
      onReplaceClick,
      onFile,
      onInputAction,
      onClickInternal,
      onError,
      ...useFocusPropagation()
    };
  }
}));
;// ./src/components/atoms/input-file/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/input-file/component.vue




;
const input_file_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(input_file_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_289c60dc_ts_true_render]])

/* harmony default export */ const input_file_component = (input_file_component_exports_);
;// ./src/components/atoms/input-file/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-free-date/component.vue?vue&type=template&id=62f9e349&ts=true

function componentvue_type_template_id_62f9e349_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_datepicker_popup = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-datepicker-popup");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_datepicker_popup, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.splitAttrs.root, {
    modelValue: _ctx.pickerDate,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.pickerDate = $event),
    visible: _ctx.pickerVisible,
    "onUpdate:visible": _cache[5] || (_cache[5] = $event => _ctx.pickerVisible = $event),
    align: _ctx.align,
    "allow-select-on": _ctx.allowSelectOn,
    "starting-view": _ctx.startingView,
    "click-outside-ignore": _ctx.clickOutsideIgnore,
    "limit-selection-visibility": "",
    onSelect: _cache[6] || (_cache[6] = $event => _ctx.onSelectDate($event)),
    onSelectPartial: _cache[7] || (_cache[7] = $event => _ctx.onSelectPartialDate($event))
  }), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
      ..._ctx.splitAttrs.attrs,
      ..._ctx.splitAttrs.listeners
    }, {
      modelValue: _ctx.modelValueInternal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.modelValueInternal = $event),
      name: _ctx.name,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      onFocus: _cache[2] || (_cache[2] = $event => _ctx.onFocus()),
      onBlur: _cache[3] || (_cache[3] = $event => _ctx.onBlur())
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
      _: 2
    }, [!_ctx.noPicker ? {
      name: "action",
      fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        ref: "actionRef",
        disabled: _ctx.disabled,
        icon: "calendar",
        view: "inverted",
        size: "s",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onActionClick())
      }, null, 8, ["disabled"])]),
      key: "0"
    } : undefined]), 1040, ["modelValue", "name", "placeholder", "disabled"])]),
    _: 1
  }, 16, ["modelValue", "visible", "align", "allow-select-on", "starting-view", "click-outside-ignore"]);
}
;// ./src/components/atoms/input-free-date/component.vue?vue&type=template&id=62f9e349&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-free-date/component.vue?vue&type=script&lang=ts











/* harmony default export */ const input_free_date_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-input-free-date',
  components: {
    DtgInput: input_component,
    DtgDatepickerPopup: datepicker_popup_component,
    DtgButton: button_component
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Ex: 14/06/1967'
    },
    possibleCombinations: {
      type: Array,
      default: () => ['dmy']
    },
    noPicker: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      // eslint-disable-next-line no-undefined
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    attrs,
    emit
  }) {
    const actionRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const {
      modelValue
    } = (0,refs_.toReadonlyRefs)(props);
    const splitAttrs = useSplitAttrs(attrs);
    const modelValueInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)('');
    const focused = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const pickerVisible = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const allowSelectOn = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      // eslint-disable-next-line array-callback-return
      return props.possibleCombinations.map(option => {
        switch (option) {
          case 'dmy':
            return 'day';
          case 'my':
            return 'month';
          case 'y':
            return 'year';
        }
      });
    });
    const pickerDate = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    const formats = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        possibleCombinations
      } = props;
      return [possibleCombinations.includes('dmy') && {
        fields: {},
        format: ['D M YYYY', 'DD M YYYY', 'D MM YYYY', 'DD MM YYYY', 'D MMM YYYY', 'DD MMM YYYY', 'D MMMM YYYY', 'DD MMMM YYYY']
      }, possibleCombinations.includes('my') && {
        fields: {
          day: null
        },
        format: ['M YYYY', 'MM YYYY', 'MMM YYYY', 'MMMM YYYY']
      }, possibleCombinations.includes('y') && {
        fields: {
          day: null,
          month: null
        },
        format: ['YYYY']
      }].filter(truthy_.truthy);
    });
    const startingView = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        day,
        month
      } = modelValue.value ?? {};
      switch (true) {
        case typeof day === 'number':
          return 'day';
        case typeof month === 'number':
          return 'month';
        default:
          return 'year';
      }
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)([modelValue, focused], ([value, focused]) => {
      if (!focused) {
        modelValueInternal.value = (0,date_.formatFreeDate)(value, ['DD', 'MM', 'YYYY'], '/');
        pickerDate.value = value ? (0,date_.parseFreeDate)(value).toISOString() : null;
      }
    }, {
      immediate: true
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(modelValueInternal, async value => {
      const freeDate = parseDate(value);
      if (!value || !focused.value || freeDate) {
        // Ensure we don't update modelValue in the same tick that modelValueInternal is updated
        await (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)();
        emit('update:modelValue', freeDate);
      }
    });
    function parseDate(date) {
      // Remove accents, trim, normalize delimiters
      // and replace accidental multiple delimiters with single spaces
      const normalizedDate = (0,string_.normalizeString)(date).replace(/[-\\/.]/g, ' ').replace(/\s+/g, ' ');
      for (const {
        fields,
        format
      } of formats.value) {
        const locale = 'fr-normalized';
        // Disallows weird inputs like 14th month
        // and prevents incorrectly entered months from being treated as delimiters
        const strict = true;
        const parsedDate = external_dayjs_default()(normalizedDate, format, locale, strict);
        if (parsedDate.isValid()) {
          return {
            day: parsedDate.date(),
            month: parsedDate.month(),
            year: parsedDate.year(),
            ...fields
          };
        }
      }
      return null;
    }
    function onFocus() {
      focused.value = true;
    }
    function onBlur() {
      focused.value = false;
    }
    function onActionClick() {
      pickerVisible.value = !pickerVisible.value;
    }
    function onSelectDate(date) {
      if (date) {
        pickerVisible.value = false;
      } else {
        modelValueInternal.value = '';
      }
    }
    function onSelectPartialDate({
      unit,
      date,
      confirmed
    }) {
      const dateObj = (0,date_.createUtcDate)(date);
      const day = unit === 'day' ? dateObj.date() : null;
      const month = unit === 'day' || unit === 'month' ? dateObj.month() : null;
      const year = dateObj.year();
      emit('update:modelValue', {
        day,
        month,
        year
      });
      if (confirmed) {
        pickerVisible.value = false;
        pickerDate.value = null;
      }
    }
    function clickOutsideIgnore(event) {
      const actionEl = (0,get_element_from_ref_.getElementFromRef)(actionRef.value);
      if (!actionEl) {
        return true;
      }
      const target = event.target;
      return actionEl === target || actionEl.contains(target);
    }
    return {
      actionRef,
      splitAttrs,
      modelValueInternal,
      pickerVisible,
      pickerDate,
      allowSelectOn,
      startingView,
      onFocus,
      onBlur,
      onActionClick,
      onSelectDate,
      onSelectPartialDate,
      clickOutsideIgnore
    };
  }
}));
;// ./src/components/atoms/input-free-date/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/input-free-date/component.vue




;
const input_free_date_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(input_free_date_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_62f9e349_ts_true_render]])

/* harmony default export */ const input_free_date_component = (input_free_date_component_exports_);
;// ./src/components/atoms/input-free-date/index.ts
/*
 * Allows inputting date with various specificities,
 * i.e. just the year or just the year and the month
 */



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-password/component.vue?vue&type=template&id=22c6e606&ts=true

function componentvue_type_template_id_22c6e606_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_input, {
    ref: "inputRef",
    type: _ctx.type,
    disabled: _ctx.disabled,
    name: _ctx.name
  }, {
    action: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
      icon: _ctx.icon,
      disabled: _ctx.disabled,
      view: "inverted",
      size: "s",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.onActionClick())
    }, null, 8, ["icon", "disabled"])]),
    _: 1
  }, 8, ["type", "disabled", "name"]);
}
;// ./src/components/atoms/input-password/component.vue?vue&type=template&id=22c6e606&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-password/component.vue?vue&type=script&lang=ts




/* harmony default export */ const input_password_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-input-password',
  components: {
    DtgInput: input_component,
    DtgButton: button_component
  },
  props: {
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const {
      inputRef,
      focus,
      blur
    } = useFocusPropagation();
    const passwordVisible = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const type = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => passwordVisible.value ? 'text' : 'password');
    const icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => passwordVisible.value ? 'eyeCrossed' : 'eye');
    function onActionClick() {
      passwordVisible.value = !passwordVisible.value;
      focus();
    }
    return {
      inputRef,
      type,
      icon,
      onActionClick,
      /** @public */
      focus,
      /** @public */
      blur
    };
  }
}));
;// ./src/components/atoms/input-password/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/input-password/component.vue




;
const input_password_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(input_password_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_22c6e606_ts_true_render]])

/* harmony default export */ const input_password_component = (input_password_component_exports_);
;// ./src/components/atoms/input-password/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-tel/component.vue?vue&type=template&id=f3a52c32&ts=true

function componentvue_type_template_id_f3a52c32_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_input, {
    modelValue: _ctx.modelValueInternal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
    mask: _ctx.mask,
    name: _ctx.name,
    disabled: _ctx.disabled,
    mode: "tel",
    type: "tel",
    unmasked: ""
  }, {
    action: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
      "no-interaction": !_ctx.disabled,
      disabled: _ctx.disabled,
      icon: "call",
      view: "inverted",
      size: "s"
    }, null, 8, ["no-interaction", "disabled"])]),
    _: 1
  }, 8, ["modelValue", "mask", "name", "disabled"]);
}
;// ./src/components/atoms/input-tel/component.vue?vue&type=template&id=f3a52c32&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/input-tel/component.vue?vue&type=script&lang=ts




/* harmony default export */ const input_tel_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-input-tel',
  components: {
    DtgInput: input_component,
    DtgButton: button_component
  },
  props: {
    name: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const modelValueInternal = propInternal(props, 'modelValue', emit);
    const mask = {
      mask: '00 00 00 00 00'
    };
    return {
      modelValueInternal,
      mask
    };
  }
}));
;// ./src/components/atoms/input-tel/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/input-tel/component.vue




;
const input_tel_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(input_tel_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_f3a52c32_ts_true_render]])

/* harmony default export */ const input_tel_component = (input_tel_component_exports_);
;// ./src/components/atoms/input-tel/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/link/component.vue?vue&type=template&id=76cf9d42&ts=true

function componentvue_type_template_id_76cf9d42_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      disabled: _ctx.disabled
    })),
    disabled: _ctx.disabled
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    _: 3
  }, 8, ["class", "disabled"]);
}
;// ./src/components/atoms/link/component.vue?vue&type=template&id=76cf9d42&ts=true

;// ./src/components/atoms/link/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const link_style_module = ({"dtg-link":"lib_dtg-link_RcVOg","dtg-link_disabled":"lib_dtg-link_disabled_cfiFl"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/link/component.vue?vue&type=script&lang=ts




/* harmony default export */ const link_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(link_style_module),
  components: {
    DtgAction: action_component
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      b: useBem(link_style_module)
    };
  }
}));
;// ./src/components/atoms/link/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/link/component.vue




;
const link_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(link_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_76cf9d42_ts_true_render]])

/* harmony default export */ const link_component = (link_component_exports_);
;// ./src/components/atoms/link/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/radio/component.vue?vue&type=template&id=1937c8b5&ts=true

function componentvue_type_template_id_1937c8b5_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_choice = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-choice");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_choice, {
    ref: "inputRef",
    modelValue: _ctx.modelValueInternal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
    disabled: _ctx.disabled,
    name: _ctx.name,
    value: _ctx.value,
    type: "radio"
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
    _: 2
  }, [_ctx.$slots.default ? {
    name: "default",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    key: "0"
  } : undefined]), 1032, ["modelValue", "disabled", "name", "value"]);
}
;// ./src/components/atoms/radio/component.vue?vue&type=template&id=1937c8b5&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/radio/component.vue?vue&type=script&lang=ts




/* harmony default export */ const radio_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-radio',
  components: {
    DtgChoice: choice_component
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: null
    },
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: false
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const modelValueInternal = propInternal(props, 'modelValue', emit);
    return {
      modelValueInternal,
      ...useFocusPropagation()
    };
  }
}));
;// ./src/components/atoms/radio/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/radio/component.vue




;
const radio_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(radio_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_1937c8b5_ts_true_render]])

/* harmony default export */ const radio_component = (radio_component_exports_);
;// ./src/components/atoms/radio/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/radio-button/component.vue?vue&type=template&id=686c709c&ts=true

function componentvue_type_template_id_686c709c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button-base");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_button_base, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      active: _ctx.active,
      fullwidth: _ctx.fullwidth
    })),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onButtonClick())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.value), 1)])]),
    _: 3
  }, 8, ["class"]);
}
;// ./src/components/atoms/radio-button/component.vue?vue&type=template&id=686c709c&ts=true

;// ./src/components/atoms/radio-button/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const radio_button_style_module = ({"dtg-radio-button":"lib_dtg-radio-button_aMWrJ","dtg-radio-button_active":"lib_dtg-radio-button_active_smqdp","dtg-radio-button_fullwidth":"lib_dtg-radio-button_fullwidth_COjW4"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/radio-button/component.vue?vue&type=script&lang=ts




/* harmony default export */ const radio_button_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(radio_button_style_module),
  components: {
    DtgButtonBase: component
  },
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      default: null
    },
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    fullwidth: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const active = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.modelValue === props.value);
    function onButtonClick() {
      emit('update:modelValue', props.value);
    }
    return {
      b: useBem(radio_button_style_module),
      active,
      onButtonClick
    };
  }
}));
;// ./src/components/atoms/radio-button/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/radio-button/component.vue




;
const radio_button_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(radio_button_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_686c709c_ts_true_render]])

/* harmony default export */ const radio_button_component = (radio_button_component_exports_);
;// ./src/components/atoms/radio-button/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/radio-group/component.vue?vue&type=template&id=28901db3&ts=true

function componentvue_type_template_id_28901db3_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_radio = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-radio");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_grid, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.splitAttrs.root, {
    align: "flex-start center"
  }), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.options, option => {
        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
          key: option.id,
          size: _ctx.size
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_radio, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
            ref_for: true,
            ref: _ctx.setRef,
            class: option.cssClass ?? null
          }, {
            ..._ctx.splitAttrs.attrs,
            ..._ctx.splitAttrs.listeners
          }, {
            modelValue: _ctx.modelValueInternal,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
            value: _ctx.getValue(option),
            name: _ctx.name,
            disabled: _ctx.disabled || option.disabled
          }), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(option.value), 1)]),
            _: 2
          }, 1040, ["class", "modelValue", "value", "name", "disabled"])]),
          _: 2
        }, 1032, ["size"]);
      }), 128))]),
      _: 1
    })]),
    _: 1
  }, 16);
}
;// ./src/components/atoms/radio-group/component.vue?vue&type=template&id=28901db3&ts=true

;// ./src/components/atoms/radio-group/types.ts
var DtgRadioGroupView;
(function (DtgRadioGroupView) {
  DtgRadioGroupView["inline"] = "inline";
  DtgRadioGroupView["multiline"] = "multiline";
})(DtgRadioGroupView || (DtgRadioGroupView = {}));
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/radio-group/component.vue?vue&type=script&lang=ts








/* harmony default export */ const radio_group_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-radio-group',
  components: {
    DtgGrid: grid,
    DtgRow: row,
    DtgCol: col,
    DtgRadio: radio_component
  },
  inheritAttrs: false,
  props: {
    view: {
      type: String,
      default: DtgRadioGroupView.inline,
      validator: inRecord(DtgRadioGroupView)
    },
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    trackByValue: {
      type: Boolean,
      default: false
    },
    object: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    attrs,
    emit
  }) {
    const {
      refs,
      setRef
    } = useTemplateRefsArray();
    const splitAttrs = useSplitAttrs(attrs);
    const size = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.view === DtgRadioGroupView.inline ? 'auto' : 12;
    });
    const modelValueInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
      get: () => {
        return getCurrentModelValue(props.modelValue);
      },
      set: value => {
        emit('update:modelValue', getUpdatedModelValue(value));
      }
    });
    function getUpdatedModelValue(value) {
      if (!props.object || value === null) {
        return value;
      }
      return props.options.find(option => getValue(option) === value) ?? null;
    }
    function getCurrentModelValue(value) {
      return value !== null && typeof value === 'object' ? getValue(value) : value;
    }
    function getValue(option) {
      return props.trackByValue ? option.value : option.id;
    }
    return {
      setRef,
      splitAttrs,
      modelValueInternal,
      size,
      getValue,
      ...useFocusPropagation(refs)
    };
  }
}));
;// ./src/components/atoms/radio-group/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/radio-group/component.vue




;
const radio_group_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(radio_group_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_28901db3_ts_true_render]])

/* harmony default export */ const radio_group_component = (radio_group_component_exports_);
;// ./src/components/atoms/radio-group/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/scrollable/component.vue?vue&type=template&id=3d52503c&ts=true

function componentvue_type_template_id_3d52503c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      horizontal: _ctx.horizontal
    }))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "arrowBack", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)({
    disabled: _ctx.isStart,
    visible: _ctx.isOverflowed,
    scroll: _ctx.goPrev
  }))), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    ref: "scrollable",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('scrollable')),
    onScroll: _cache[0] || (_cache[0] = $event => _ctx.onScroll())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 34), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "arrowForward", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)({
    disabled: _ctx.isEnd,
    visible: _ctx.isOverflowed,
    scroll: _ctx.goNext
  })))], 2);
}
;// ./src/components/atoms/scrollable/component.vue?vue&type=template&id=3d52503c&ts=true

;// ./src/components/atoms/scrollable/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const scrollable_style_module = ({"dtg-scrollable":"lib_dtg-scrollable_CmcD7","dtg-scrollable__scrollable":"lib_dtg-scrollable__scrollable_TzvKo","dtg-scrollable_horizontal":"lib_dtg-scrollable_horizontal_WfCPY"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/scrollable/component.vue?vue&type=script&lang=ts





const NAV_DISABLE_THRESHOLD = 10;
/* harmony default export */ const scrollable_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(scrollable_style_module),
  props: {
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  emits: ['resize'],
  setup(props, {
    emit
  }) {
    const scrollable = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const observer = new ResizeObserver(() => {
      emit('resize');
      if (scrollable.value) {
        updateIsOverflowed(scrollable.value);
        updateIsStart(scrollable.value);
        updateIsEnd(scrollable.value);
      }
    });
    const isOverflowed = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const isStart = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const isEnd = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      (0,double_raf_.doubleRAF)(() => {
        if (scrollable.value) {
          observer.observe(scrollable.value);
        }
      });
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeUnmount)(() => {
      if (scrollable.value) {
        observer.unobserve(scrollable.value);
      }
    });
    function updateIsOverflowed(el) {
      if (props.horizontal) {
        isOverflowed.value = el.scrollWidth > el.offsetWidth;
      } else {
        isOverflowed.value = el.scrollHeight > el.offsetHeight;
      }
    }
    function updateIsStart(el) {
      if (props.horizontal) {
        isStart.value = el.scrollLeft <= NAV_DISABLE_THRESHOLD;
      } else {
        isStart.value = el.scrollTop <= NAV_DISABLE_THRESHOLD;
      }
    }
    function updateIsEnd(el) {
      if (props.horizontal) {
        isEnd.value = el.scrollLeft >= el.scrollWidth - el.offsetWidth - NAV_DISABLE_THRESHOLD;
      } else {
        isEnd.value = el.scrollTop >= el.scrollHeight - el.offsetHeight - NAV_DISABLE_THRESHOLD;
      }
    }
    function scroll(direction) {
      const scrollableEl = scrollable.value;
      if (!scrollableEl) {
        return;
      }
      if (props.horizontal) {
        (0,scroll_.scrollBy)(scrollableEl, {
          left: direction * scrollableEl.clientWidth
        });
      } else {
        (0,scroll_.scrollBy)(scrollableEl, {
          top: direction * scrollableEl.clientHeight
        });
      }
    }
    function goNext() {
      scroll(1);
    }
    function goPrev() {
      scroll(-1);
    }
    function onScroll() {
      if (scrollable.value) {
        updateIsStart(scrollable.value);
        updateIsEnd(scrollable.value);
      }
    }
    return {
      b: useBem(scrollable_style_module),
      scrollable,
      isStart,
      isEnd,
      isOverflowed,
      goNext,
      goPrev,
      onScroll
    };
  }
}));
;// ./src/components/atoms/scrollable/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/scrollable/component.vue




;
const scrollable_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(scrollable_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_3d52503c_ts_true_render]])

/* harmony default export */ const scrollable_component = (scrollable_component_exports_);
;// ./src/components/atoms/scrollable/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/select/component.vue?vue&type=template&id=456eb9ec&ts=true

const componentvue_type_template_id_456eb9ec_ts_true_hoisted_1 = ["innerHTML"];
function componentvue_type_template_id_456eb9ec_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_tag = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-tag");
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_spinner = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-spinner");
  const _component_multiselect = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("multiselect");
  const _component_dtg_button_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button-base");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_multiselect, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.combinedProps, {
    ref: "multiselectRef",
    modelValue: _ctx.values,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.values = $event),
    options: _ctx.options,
    onOpen: _cache[2] || (_cache[2] = $event => _ctx.onOpen()),
    onClose: _cache[3] || (_cache[3] = $event => _ctx.onClose()),
    onSelect: _cache[4] || (_cache[4] = $event => _ctx.onSelect($event)),
    onDeselect: _cache[5] || (_cache[5] = $event => _ctx.onDeselect($event)),
    onSearchChange: _cache[6] || (_cache[6] = $event => _ctx.onSearchChange($event)),
    onTag: _cache[7] || (_cache[7] = $event => _ctx.onAddFreeOption($event))
  }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
    multiplelabel: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(({
      values: labelValues
    }) => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text-inner'))
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.multipleLabel(labelValues)), 3)], 2)]),
    placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([_ctx.b('text'), _ctx.b('placeholder')])
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text-inner'))
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.placeholder), 3)], 2)]),
    tag: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(({
      option,
      disabled: tagDisabled,
      handleTagRemove,
      handleTagUpdate
    }) => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_tag, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('tag')),
      text: option.value,
      disabled: tagDisabled || _ctx.disabled || _ctx.noDeselect,
      editable: _ctx.freeOption,
      "max-length": _ctx.maxLength,
      "emit-on-edit": _ctx.freeOptionEmitOnEdit,
      onRemove: $event => handleTagRemove(option),
      onEdit: $event => handleTagUpdate(option, $event),
      onEditClick: $event => _ctx.onEditClick(option.value),
      onKeydown: _cache[0] || (_cache[0] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)(() => {}, ["stop"]))
    }, null, 8, ["class", "text", "disabled", "editable", "max-length", "emit-on-edit", "onRemove", "onEdit", "onEditClick"])]),
    option: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(({
      option,
      isCreatedTag
    }) => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('option'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      name: "checkmarkCircle",
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('option-icon'))
    }, null, 8, ["class"]), isCreatedTag ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('option-text'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Ajouter "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("b", null, "« " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(option.value) + " »", 1)], 2)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('option-text')),
      innerHTML: _ctx.makeSearchTextBold(option.value)
    }, null, 10, componentvue_type_template_id_456eb9ec_ts_true_hoisted_1))], 2)]),
    spinner: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_spinner, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('spinner'))
    }, null, 8, ["class"])]),
    _: 2
  }, [_ctx.clearButtonVisible ? {
    name: "clear",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      name: "close"
    })]),
    key: "0"
  } : undefined]), 1040, ["modelValue", "options"]), _ctx.caret && _ctx.caretShown ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_button_base, {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('caret')),
    tabindex: "-1",
    onMousedown: _cache[8] || (_cache[8] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => _ctx.onCaretClick(), ["prevent"]))
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('caret-icon')),
      name: "chevron"
    }, null, 8, ["class"])]),
    _: 1
  }, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// ./src/components/atoms/select/component.vue?vue&type=template&id=456eb9ec&ts=true

// EXTERNAL MODULE: external "lodash/escape"
var escape_ = __webpack_require__(4297);
var escape_default = /*#__PURE__*/__webpack_require__.n(escape_);
// EXTERNAL MODULE: external "lodash/escapeRegExp"
var escapeRegExp_ = __webpack_require__(1460);
var escapeRegExp_default = /*#__PURE__*/__webpack_require__.n(escapeRegExp_);
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/tag/component.vue?vue&type=template&id=e8123d6a&ts=true

const componentvue_type_template_id_e8123d6a_ts_true_hoisted_1 = ["title"];
function componentvue_type_template_id_e8123d6a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_text_editable = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-text-editable");
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b()),
    title: _ctx.text
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_text_editable, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text')),
    "model-value": _ctx.text,
    disabled: _ctx.disabled || !_ctx.editable,
    "max-length": _ctx.maxLength,
    "emit-on-edit": _ctx.emitOnEdit,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.onUpdateText($event)),
    onEditClick: _cache[1] || (_cache[1] = $event => _ctx.onEditClick())
  }, null, 8, ["class", "model-value", "disabled", "max-length", "emit-on-edit"]), _ctx.isRemoveButtonVisible ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('action')),
    onClick: _cache[2] || (_cache[2] = $event => _ctx.onRemoveClick())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('action-icon')),
      name: "closeCircle"
    }, null, 8, ["class"])]),
    _: 1
  }, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 10, componentvue_type_template_id_e8123d6a_ts_true_hoisted_1);
}
;// ./src/components/atoms/tag/component.vue?vue&type=template&id=e8123d6a&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/text-editable/component.vue?vue&type=template&id=33a55804&ts=true

function componentvue_type_template_id_33a55804_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_form = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-form");
  const _component_dtg_spinner = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-spinner");
  const _component_dtg_icon_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon-action");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: _ctx.b({
      iconLeft: _ctx.iconLeft
    })
  }, _ctx.splitAttrs.root), [_ctx.editing ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_form, {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('form')),
    onSubmit: _cache[3] || (_cache[3] = $event => _ctx.onSubmit())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDynamicComponent)(_ctx.controlComponentsByType[_ctx.type]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
      ref: "inputRef",
      modelValue: _ctx.editedValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.editedValue = $event),
      "max-length": _ctx.maxLength,
      precision: _ctx.precision
    }, {
      ..._ctx.splitAttrs.attrs,
      ..._ctx.splitAttrs.listeners
    }, {
      view: "compact",
      name: "text",
      autowidth: "",
      "no-controls": "",
      "no-currency": "",
      onBlur: _cache[1] || (_cache[1] = $event => _ctx.onSubmit()),
      onKeydown: _cache[2] || (_cache[2] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)($event => _ctx.onKeydownEsc(), ["esc"]))
    }), null, 16, ["modelValue", "max-length", "precision"]))]),
    _: 1
  }, 8, ["class"])) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text')),
    onDblclick: _cache[4] || (_cache[4] = $event => _ctx.onDoubleClick())
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.textToDisplay), 35), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_spinner, {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('spinner'))
  }, null, 8, ["class"])) : !_ctx.disabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_icon_action, {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('action')),
    disabled: _ctx.disabled,
    name: "edit",
    onClick: _cache[5] || (_cache[5] = $event => _ctx.onEditClick($event))
  }, null, 8, ["class", "disabled"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64))], 16);
}
;// ./src/components/atoms/text-editable/component.vue?vue&type=template&id=33a55804&ts=true

// EXTERNAL MODULE: external "dtg-shared/utils/price"
var price_ = __webpack_require__(5213);
;// ./src/components/atoms/text-editable/types.ts
var DtgTextEditableValueType;
(function (DtgTextEditableValueType) {
  DtgTextEditableValueType["text"] = "text";
  DtgTextEditableValueType["number"] = "number";
  DtgTextEditableValueType["currency"] = "currency";
})(DtgTextEditableValueType || (DtgTextEditableValueType = {}));
;// ./src/components/atoms/text-editable/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const text_editable_style_module = ({"dtg-text-editable":"lib_dtg-text-editable_H5IRC","dtg-text-editable__form":"lib_dtg-text-editable__form_t_oW1","dtg-text-editable__text":"lib_dtg-text-editable__text_hzfE7","dtg-text-editable__action":"lib_dtg-text-editable__action_bQz2_","dtg-text-editable__spinner":"lib_dtg-text-editable__spinner_lu3dW","dtg-text-editable_iconLeft":"lib_dtg-text-editable_iconLeft_y7Dyx"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/text-editable/component.vue?vue&type=script&lang=ts
















/* harmony default export */ const text_editable_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(text_editable_style_module),
  components: {
    DtgAction: action_component,
    DtgIcon: icon_component,
    DtgInput: input_component,
    DtgInputNumber: input_number_component,
    DtgInputCurrency: input_currency_component,
    DtgForm: form_component,
    DtgSpinner: spinner_component,
    DtgIconAction: icon_action_component
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      default: DtgTextEditableValueType.text,
      validator: inRecord(DtgTextEditableValueType)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    emitOnEdit: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null
    },
    iconLeft: {
      type: Boolean,
      default: false
    },
    format: {
      type: Function,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'editClick'],
  setup(props, {
    emit,
    attrs
  }) {
    const splitAttrs = useSplitAttrs(attrs);
    const controlComponentsByType = {
      [DtgTextEditableValueType.number]: 'dtg-input-number',
      [DtgTextEditableValueType.currency]: 'dtg-input-currency',
      [DtgTextEditableValueType.text]: 'dtg-input'
    };
    const {
      disabled
    } = (0,refs_.toReadonlyRefs)(props);
    const editing = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const editedValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    const precision = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.type === DtgTextEditableValueType.currency ? 2 : 0);
    const inputRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const formatInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        format,
        type
      } = props;
      const precisionValue = precision.value;
      if (format) {
        return format;
      }
      return type === DtgTextEditableValueType.currency ? value => (0,price_.formatPrice)(Number(value), precisionValue) : String;
    });
    const textToDisplay = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        modelValue
      } = props;
      const isEmpty = modelValue === null || String(modelValue).length === 0;
      const format = formatInternal.value;
      return isEmpty ? '-' : format(modelValue);
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(disabled, disabled => {
      if (disabled) {
        setEditing(false);
      }
    });
    function setEditing(value) {
      editedValue.value = props.type === DtgTextEditableValueType.text ? props.modelValue ?? '' : props.modelValue;
      editing.value = value;
      void (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)().then(() => {
        if (value) {
          inputRef.value?.focus();
        }
      });
    }
    function onDoubleClick() {
      if (!disabled.value) {
        setEditing(true);
      }
    }
    function onEditClick(event) {
      event.stopPropagation();
      if (props.emitOnEdit) {
        emit('editClick');
      } else {
        setEditing(true);
      }
    }
    function onKeydownEsc() {
      setEditing(false);
    }
    function onSubmit() {
      if (!editing.value) {
        return;
      }
      const newText = editedValue.value;
      if (newText !== props.modelValue) {
        emit('update:modelValue', newText);
      }
      setEditing(false);
    }
    return {
      b: useBem(text_editable_style_module),
      controlComponentsByType,
      inputRef,
      editing,
      editedValue,
      textToDisplay,
      splitAttrs,
      precision,
      onDoubleClick,
      onEditClick,
      onKeydownEsc,
      onSubmit
    };
  }
}));
;// ./src/components/atoms/text-editable/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/text-editable/component.vue




;
const text_editable_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(text_editable_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_33a55804_ts_true_render]])

/* harmony default export */ const text_editable_component = (text_editable_component_exports_);
;// ./src/components/atoms/text-editable/index.ts



;// ./src/components/atoms/tag/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const tag_style_module = ({"dtg-tag":"lib_dtg-tag_Hqmet","dtg-tag__text":"lib_dtg-tag__text_bkguX","dtg-tag__action":"lib_dtg-tag__action_g3VzE","dtg-tag__action-icon":"lib_dtg-tag__action-icon_HRvua"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/tag/component.vue?vue&type=script&lang=ts






/* harmony default export */ const tag_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(tag_style_module),
  components: {
    DtgTextEditable: text_editable_component,
    DtgAction: action_component,
    DtgIcon: icon_component
  },
  props: {
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    emitOnEdit: {
      type: Boolean,
      default: false
    },
    noRemove: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null
    }
  },
  emits: ['remove', 'edit', 'editClick'],
  setup(props, {
    emit
  }) {
    const isRemoveButtonVisible = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        disabled,
        noRemove
      } = props;
      return !noRemove && !disabled;
    });
    function onRemoveClick() {
      emit('remove');
    }
    function onUpdateText(text) {
      const {
        noRemove
      } = props;
      if (text) {
        emit('edit', text);
      } else if (!noRemove) {
        emit('remove');
      }
    }
    function onEditClick() {
      emit('editClick');
    }
    return {
      b: useBem(tag_style_module),
      isRemoveButtonVisible,
      onRemoveClick,
      onUpdateText,
      onEditClick
    };
  }
}));
;// ./src/components/atoms/tag/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/tag/component.vue




;
const tag_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(tag_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_e8123d6a_ts_true_render]])

/* harmony default export */ const tag_component = (tag_component_exports_);
;// ./src/components/atoms/tag/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/vendor/vueform-multiselect/Multiselect.vue?vue&type=template&id=00a53342

const Multiselectvue_type_template_id_00a53342_hoisted_1 = ["id"];
const Multiselectvue_type_template_id_00a53342_hoisted_2 = ["tabindex"];
const Multiselectvue_type_template_id_00a53342_hoisted_3 = {
  class: "multiselect-multiple-label"
};
const _hoisted_4 = {
  key: 1,
  class: "multiselect-search"
};
const _hoisted_5 = ["modelValue", "value", "maxlength"];
const _hoisted_6 = {
  key: 2,
  class: "multiselect-tags"
};
const _hoisted_7 = {
  class: "multiselect-multiple-label"
};
const _hoisted_8 = {
  class: "multiselect-tag"
};
const _hoisted_9 = ["onMousedown"];
const _hoisted_10 = ["value", "maxlength"];
const _hoisted_11 = {
  class: "multiselect-placeholder"
};
const _hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
  class: "multiselect-caret"
}, null, -1);
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
  class: "multiselect-spinner"
}, null, -1);
const _hoisted_15 = ["onMouseenter", "onClick"];
const _hoisted_16 = {
  class: "multiselect-no-options"
};
const _hoisted_17 = {
  class: "multiselect-no-results"
};
function Multiselectvue_type_template_id_00a53342_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    id: $props.id,
    ref: "multiselect",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["multiselect", [`is-${$props.mode}`, {
      'is-open': _ctx.isOpen,
      'is-searchable': $props.searchable,
      'is-disabled': $props.disabled,
      'no-caret': !$props.caret,
      'open-top': $props.openDirection === 'top'
    }]]),
    onKeydown: _cache[29] || (_cache[29] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)(() => {}, ["prevent"]), ["enter"]))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: "multiselect-input",
    tabindex: _ctx.tabindex,
    onMousedown: _cache[20] || (_cache[20] = (...args) => _ctx.handleInputMousedown && _ctx.handleInputMousedown(...args)),
    onFocus: _cache[21] || (_cache[21] = (...args) => _ctx.openDropdown && _ctx.openDropdown(...args)),
    onBlur: _cache[22] || (_cache[22] = (...args) => _ctx.closeDropdown && _ctx.closeDropdown(...args)),
    onKeydown: [_cache[23] || (_cache[23] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((...args) => _ctx.handleEsc && _ctx.handleEsc(...args), ["esc"])), _cache[24] || (_cache[24] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((...args) => _ctx.selectPointer && _ctx.selectPointer(...args), ["enter"])), _cache[25] || (_cache[25] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => _ctx.handleBackspace && _ctx.handleBackspace(...args), ["prevent"]), ["delete"])), _cache[26] || (_cache[26] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => $props.openDirection === 'top' ? _ctx.forwardPointer() : _ctx.backwardPointer(), ["prevent"]), ["up"])), _cache[27] || (_cache[27] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => $props.openDirection === 'top' ? _ctx.backwardPointer() : _ctx.forwardPointer(), ["prevent"]), ["down"]))]
  }, [$props.mode == 'multiple' && _ctx.hasSelected && !$setup.hiddenSelectedValue ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "multiplelabel", {
    key: 0,
    values: _ctx.iv
  }, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Multiselectvue_type_template_id_00a53342_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.multipleLabelText), 1)]) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), $props.mode !== 'tags' && $props.searchable && !$props.disabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
    ref: "input",
    modelValue: _ctx.search,
    value: _ctx.search,
    maxlength: $props.searchMaxLength === -1 ? '' : $props.searchMaxLength,
    onFocus: _cache[0] || (_cache[0] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => $setup.handleSearchFocus && $setup.handleSearchFocus(...args), ["stop"])),
    onBlur: _cache[1] || (_cache[1] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => _ctx.closeDropdown && _ctx.closeDropdown(...args), ["stop"])),
    onKeydown: [_cache[2] || (_cache[2] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => _ctx.handleEsc && _ctx.handleEsc(...args), ["stop"]), ["esc"])), _cache[3] || (_cache[3] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => _ctx.selectPointer && _ctx.selectPointer(...args), ["stop"]), ["enter"])), _cache[4] || (_cache[4] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((...args) => _ctx.handleSearchBackspace && _ctx.handleSearchBackspace(...args), ["delete"])), _cache[5] || (_cache[5] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => $props.openDirection === 'top' ? _ctx.forwardPointer() : _ctx.backwardPointer(), ["stop"]), ["up"])), _cache[6] || (_cache[6] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => $props.openDirection === 'top' ? _ctx.backwardPointer() : _ctx.forwardPointer(), ["stop"]), ["down"]))],
    onInput: _cache[7] || (_cache[7] = (...args) => _ctx.handleSearchInput && _ctx.handleSearchInput(...args))
  }, null, 40, _hoisted_5)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), $props.mode == 'tags' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_6, [!$props.tag && _ctx.hasSelected && !$setup.hiddenSelectedValue ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "multiplelabel", {
    key: 0,
    values: _ctx.iv
  }, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_7, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.multipleLabelText), 1)]) : $props.tag ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.iv, (option, i, key) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
      key: key
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "tag", {
      option: option,
      handleTagRemove: _ctx.handleTagRemove,
      handleTagUpdate: _ctx.handleTagUpdate,
      disabled: $props.disabled || _ctx.isOptionDisabled(option)
    }, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(option[$props.label]) + " ", 1), !$props.disabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("i", {
      key: 0,
      onClick: _cache[8] || (_cache[8] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)(() => {}, ["prevent"])),
      onMousedown: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => _ctx.handleTagRemove(option), ["prevent", "stop"])
    }, null, 40, _hoisted_9)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])]);
  }), 128)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), $props.searchable && !$props.disabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 2,
    class: "multiselect-search",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      width: _ctx.tagsSearchWidth
    })
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
    ref: "input",
    value: _ctx.search,
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      width: _ctx.tagsSearchWidth
    }),
    maxlength: $props.searchMaxLength === -1 ? '' : $props.searchMaxLength,
    onFocus: _cache[9] || (_cache[9] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => $setup.handleSearchFocus && $setup.handleSearchFocus(...args), ["stop"])),
    onBlur: _cache[10] || (_cache[10] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => $setup.handleBlur && $setup.handleBlur(...args), ["stop"])),
    onKeydown: [_cache[11] || (_cache[11] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => _ctx.handleEsc && _ctx.handleEsc(...args), ["stop"]), ["esc"])), _cache[12] || (_cache[12] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => _ctx.handleAddTag && _ctx.handleAddTag(...args), ["stop"]), ["enter"])), _cache[13] || (_cache[13] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => _ctx.handleAddTag && _ctx.handleAddTag(...args), ["stop"]), ["space"])), _cache[14] || (_cache[14] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((...args) => _ctx.handleSearchBackspace && _ctx.handleSearchBackspace(...args), ["delete"])), _cache[15] || (_cache[15] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => $props.openDirection === 'top' ? _ctx.forwardPointer() : _ctx.backwardPointer(), ["stop"]), ["up"])), _cache[16] || (_cache[16] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => $props.openDirection === 'top' ? _ctx.backwardPointer() : _ctx.forwardPointer(), ["stop"]), ["down"]))],
    onInput: _cache[17] || (_cache[17] = (...args) => _ctx.handleSearchInput && _ctx.handleSearchInput(...args))
  }, null, 44, _hoisted_10)], 4)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), $props.placeholder && (!_ctx.hasSelected || $setup.hiddenSelectedValue) && !_ctx.search ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "placeholder", {
    key: 3
  }, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_11, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.placeholder), 1)]) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.hasSelected && $props.caret && !_ctx.busy ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "caret", {
    key: 4
  }, () => [_hoisted_12]) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.clear && _ctx.hasSelected && !$props.disabled && !_ctx.busy && $props.canDeselect && (!_ctx.search || _ctx.search?.length === 0) ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("a", {
    key: 5,
    class: "multiselect-clear",
    onClick: _cache[18] || (_cache[18] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)((...args) => _ctx.clear && _ctx.clear(...args), ["prevent", "stop"])),
    onMousedown: _cache[19] || (_cache[19] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)(() => {}, ["prevent", "stop"]))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "clear")], 32)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(external_commonjs_vue_commonjs2_vue_root_Vue_.Transition, {
    name: "multiselect-loading"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.busy ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_13, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "spinner", {}, () => [_hoisted_14])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 3
  })], 40, Multiselectvue_type_template_id_00a53342_hoisted_2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(external_commonjs_vue_commonjs2_vue_root_Vue_.Transition, {
    name: "multiselect",
    onAfterLeave: _ctx.clearSearch
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: "multiselect-options",
      style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
        maxHeight: _ctx.contentMaxHeight
      })
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "beforelist"), !_ctx.resolving ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: 0
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.fo, (option, i, key) => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
        key: key,
        tabindex: -1,
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["multiselect-option", {
          'is-pointed': _ctx.isPointed(option),
          'is-selected': _ctx.isSelected(option),
          'is-disabled': _ctx.isDisabled(option)
        }]),
        onMousedown: _cache[28] || (_cache[28] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)(() => {}, ["prevent", "stop"])),
        onMouseenter: $event => _ctx.setPointer(option),
        onClick: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => _ctx.handleOptionClick(option), ["stop", "prevent"])
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "option", {
        option: option,
        search: _ctx.search,
        isCreatedTag: _ctx.isCreatedTag(option)
      }, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(option[$props.label]), 1)])], 42, _hoisted_15);
    }), 128)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "nooptions", {}, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_16, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.noOptionsText), 1)])], 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.noOptions]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "noresults", {}, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_17, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.noResultsText), 1)])], 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.noResults]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "afterlist")], 4), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.isOpen && $props.showOptions]])]),
    _: 3
  }, 8, ["onAfterLeave"])], 42, Multiselectvue_type_template_id_00a53342_hoisted_1);
}
;// ./src/components/vendor/vueform-multiselect/Multiselect.vue?vue&type=template&id=00a53342

;// ./src/components/vendor/vueform-multiselect/composables/useData.js

function useData(props, context, dep) {
  const {
    object,
    valueProp
  } = (0,refs_.toReadonlyRefs)(props);

  // ============ DEPENDENCIES ============

  const {
    iv
  } = dep;

  // =============== METHODS ==============

  const update = val => {
    // Setting object(s) as internal value
    iv.value = val;

    // Setting object(s) or plain value as external
    // value based on `option` setting
    const externalVal = makeExternal(val);
    context.emit('change', externalVal);
    context.emit('input', externalVal);
    context.emit('update:modelValue', externalVal);
  };

  // no export
  const makeExternal = val => {
    // If external value should be object
    // no transformation is required
    if (object.value) {
      return val;
    }

    // If external should be plain transform
    // value object to plain values
    return !Array.isArray(val) ? val[valueProp.value] : val.map(v => v[valueProp.value]);
  };
  return {
    update
  };
}
;// ./src/components/vendor/vueform-multiselect/composables/useValue.js


function useValue(props) {
  const {
    modelValue,
    valueProp
  } = (0,refs_.toReadonlyRefs)(props);

  // ================ DATA ================

  // internalValue
  const iv = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);

  // ============== COMPUTED ==============

  /* istanbul ignore next */
  // externalValue
  const ev = modelValue;
  const plainValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return iv.value.map(v => v[valueProp.value]);
  });
  const textValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return iv.value.map(v => v[valueProp.value]).join(',');
  });
  return {
    iv,
    internalValue: iv,
    ev,
    externalValue: ev,
    textValue,
    plainValue
  };
}
;// ./src/components/vendor/vueform-multiselect/composables/useSearch.js


function useSearch(props, context, dep) {
  const {
    searchable,
    mode,
    continuousSearch,
    modelValue,
    object,
    max
  } = (0,refs_.toReadonlyRefs)(props);

  // ============ DEPENDENCIES ============

  const {
    iv
  } = dep;

  // ================ DATA ================

  const search = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
  const input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);

  // ============== COMPUTED ==============

  const tagsSearchWidth = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    if (search.value) {
      return `${search.value.length}ch`;
    }
    if (mode.value !== 'tags' || !iv.value.length) {
      return '100%';
    }
    return '1ch';
  });

  // =============== METHODS ==============

  const clearSearch = () => {
    search.value = '';
  };
  const focusSearch = () => {
    if (!searchable.value) {
      return;
    }
    input.value.focus();
  };
  const blurSearch = () => {
    if (!searchable.value) {
      return;
    }
    input.value.blur();
  };
  const onSearchFocus = () => {
    if (!continuousSearch.value) {
      return;
    }
    const [selected] = modelValue.value ?? [];
    search.value = getSearchFromModelValue(selected);
  };

  // ============== WATCHERS ==============

  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(search, val => {
    context.emit('search-change', val);
  });

  // ============== HELPERS ==============
  function getSearchFromModelValue(modelValue) {
    if (!modelValue || max.value > 1) {
      return '';
    }
    return object.value ? modelValue.value : modelValue;
  }
  return {
    search,
    input,
    tagsSearchWidth,
    clearSearch,
    focusSearch,
    blurSearch,
    onSearchFocus
  };
}
;// ./src/components/vendor/vueform-multiselect/composables/usePointer.js

function usePointer(props, context, dep) {
  // ================ DATA ================

  const pointer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
  return {
    pointer
  };
}
;// ./src/components/vendor/vueform-multiselect/utils/arraysEqual.js
function arraysEqual(array1, array2) {
  const array2Sorted = array2.slice().sort();
  return array1.length === array2.length && array1.slice().sort().every((value, index) => {
    return value === array2Sorted[index];
  });
}
;// ./src/components/vendor/vueform-multiselect/composables/useOptions.js




function useOptions(props, context, dep) {
  const {
    options,
    mode,
    trackBy,
    limit,
    hideSelected,
    createTag,
    label,
    onlyEmitOnSelect,
    onlyEmitOnDeselect,
    appendNewTag,
    selectNewTag,
    multipleLabel,
    object,
    loading,
    delay,
    resolveOnLoad,
    minChars,
    filterResults,
    clearOnSelect,
    valueProp,
    canDeselect,
    max
  } = (0,refs_.toReadonlyRefs)(props);

  // ============ DEPENDENCIES ============

  const {
    iv
  } = dep;
  const {
    ev
  } = dep;
  const {
    search
  } = dep;
  const {
    clearSearch
  } = dep;
  const {
    update
  } = dep;
  const {
    pointer
  } = dep;

  // ================ DATA ================

  // no export
  // appendedOptions
  const ap = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);

  // no export
  // resolvedOptions
  const ro = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
  const resolving = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);

  // ============== COMPUTED ==============

  // no export
  // extendedOptions
  const eo = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    let eo = ro.value || [];

    // Transforming an object to an array of objects
    if (eo && typeof eo === 'object' && !Array.isArray(eo)) {
      eo = Object.keys(eo).map(key => {
        const val = eo[key];
        return {
          [valueProp.value]: key,
          [trackBy.value]: val,
          [label.value]: val
        };
      });
    }

    // Transforming an plain arrays to an array of objects
    eo = eo.map((val, key) => {
      return typeof val === 'object' ? val : {
        [valueProp.value]: val,
        [trackBy.value]: val,
        [label.value]: val
      };
    });
    if (ap.value.length) {
      eo = eo.concat(ap.value);
    }
    return eo;
  });

  // filteredOptions
  const fo = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    let fo = eo.value;
    if (createdTag.value.length) {
      fo = createdTag.value.concat(fo);
    }
    if (search.value && filterResults.value) {
      fo = fo.filter(option => {
        return (0,string_.normalizeString)(option[trackBy.value]).includes((0,string_.normalizeString)(search.value));
      });
    }
    if (hideSelected.value) {
      fo = fo.filter(option => !shouldHideOption(option));
    }
    if (limit.value > 0) {
      fo = fo.slice(0, limit.value);
    }
    return fo;
  });
  const hasSelected = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return iv.value.length > 0;
  });
  const multipleLabelText = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return multipleLabel !== undefined && multipleLabel.value !== undefined ? multipleLabel.value(iv.value) : iv.value.length > 1 ? `${iv.value.length} options selected` : '1 option selected';
  });
  const noOptions = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return !eo.value.length && !resolving.value;
  });
  const noResults = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return eo.value.length > 0 && fo.value.length === 0;
  });

  // no export
  const createdTag = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    if (createTag.value === false || !search.value || getOptionIndexByTrackBy(search.value) !== -1) {
      return [];
    }
    return [createOptionFromValue(search.value)];
  });

  // no export
  const nullValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return [];
  });
  const busy = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return loading.value || resolving.value;
  });

  // no export
  const canDeselectInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return iv.value.length === 1 ? canDeselect.value : true;
  });

  // =============== METHODS ==============

  const select = (option, index = -1) => {
    if (typeof option !== 'object') {
      option = getOption(option);
    }
    if (!onlyEmitOnSelect.value) {
      if (max.value === 1 && iv.value.length > 0) {
        iv.value.forEach(option => deselect(option));
      }
      let updatedValue;
      if (index === -1) {
        updatedValue = iv.value.concat(option);
      } else {
        updatedValue = iv.value.slice();
        updatedValue.splice(index, 0, option);
      }
      update(updatedValue);
    }
    context.emit('select', finalValue(option), option);
  };
  const deselect = option => {
    if (typeof option !== 'object') {
      option = getOption(option);
    }
    if (!onlyEmitOnDeselect.value) {
      update(iv.value.filter(val => val[valueProp.value] != option[valueProp.value]));
    }
    context.emit('deselect', finalValue(option), option);
  };

  // no export
  const finalValue = option => {
    return object.value ? option : option[valueProp.value];
  };
  const remove = option => {
    deselect(option);
  };
  const handleTagRemove = option => {
    remove(option);
  };

  // Replaces a selected option with a new one at the same index
  // If an option with the new option's text already exists, it is selected instead,
  // unless it is disabled or already selected
  const handleTagUpdate = (oldOption, value) => {
    const newOption = createOptionFromValue(value);
    const existingOption = eo.value[getOptionIndexByTrackBy(newOption[trackBy.value])];
    if (existingOption && existingOption.disabled === true) {
      return;
    }
    const selectedOptionIndex = getSelectedOptionIndex(oldOption);
    remove(oldOption);
    if (isSelectedByTrackBy(newOption)) {
      return;
    }
    if (existingOption) {
      select(existingOption, selectedOptionIndex);
    } else {
      context.emit('tag', newOption[valueProp.value]);
      if (appendNewTag.value) {
        appendOption(newOption);
      }
      if (selectNewTag.value) {
        select(newOption, selectedOptionIndex);
      }
    }
  };
  const clear = () => {
    context.emit('clear');
    update(nullValue.value);
  };
  const isSelected = option => {
    return getSelectedOptionIndex(option) !== -1;
  };
  const isSelectedByTrackBy = option => {
    return iv.value.map(o => o[trackBy.value]).indexOf(option[trackBy.value]) !== -1;
  };
  const getSelectedOptionIndex = option => {
    return iv.value.map(o => o[valueProp.value]).indexOf(option[valueProp.value]);
  };
  const isDisabled = option => {
    if (isOptionDisabled(option)) {
      return true;
    }
    const maxSelected = max.value !== 1 && isMax();
    const canDeselect = isSelected(option) && canDeselectInternal.value;
    return maxSelected && !canDeselect;
  };
  const isOptionDisabled = option => {
    return option.disabled === true;
  };
  const isMax = () => {
    if (max === undefined || max.value === -1 || !hasSelected.value && max.value > 0) {
      return false;
    }
    return iv.value.length >= max.value;
  };
  const handleOptionClick = option => {
    if (isDisabled(option)) {
      return;
    }
    switch (mode.value) {
      case 'multiple':
        if (isSelected(option)) {
          if (canDeselectInternal.value) {
            deselect(option);
          }
          return;
        }
        select(option);
        if (clearOnSelect.value) {
          clearSearch();
        }
        break;
      case 'tags':
        if (isSelected(option)) {
          if (canDeselectInternal.value) {
            deselect(option);
          }
          return;
        }
        if (getOption(option[valueProp.value]) || !createTag.value) {
          if (clearOnSelect.value) {
            clearSearch();
          }
          select(option);
        } else {
          context.emit('tag', option[valueProp.value]);
          if (appendNewTag.value) {
            appendOption(option);
          }
          clearSearch();
          if (selectNewTag.value) {
            select(option);
          }
        }
        break;
    }
  };
  const getOption = val => {
    return eo.value[eo.value.map(o => String(o[valueProp.value])).indexOf(String(val))];
  };

  // no export
  const getOptionIndexByTrackBy = val => {
    return eo.value.map(o => (0,string_.normalizeString)(o[trackBy.value])).indexOf((0,string_.normalizeString)(val));
  };

  // no export
  const shouldHideOption = option => {
    return mode.value === 'tags' && hideSelected.value && isSelected(option);
  };

  // no export
  const appendOption = option => {
    ap.value.push(option);
  };

  // no export
  const initInternalValue = () => {
    iv.value = makeInternal(ev.value);
  };
  const resolveOptions = callback => {
    resolving.value = true;
    options.value(search.value).then(response => {
      ro.value = response;
      if (typeof callback === 'function') {
        callback(response);
      }
      resolving.value = false;
    });
  };

  // no export
  const refreshLabels = () => {
    if (!hasSelected.value) {
      return;
    }
    iv.value.forEach((val, i) => {
      const newLabel = getOption(iv.value[i][valueProp.value])[label.value];
      iv.value[i][label.value] = newLabel;
      if (object.value) {
        ev.value[i][label.value] = newLabel;
      }
    });
  };
  const refreshOptions = callback => {
    resolveOptions(callback);
  };

  // no export
  const makeInternal = val => {
    if (object.value) {
      return val;
    }
    if (createTag.value && appendNewTag.value) {
      const extraneousOptions = val.filter(v => !getOption(v));
      extraneousOptions.forEach(value => {
        appendOption(createOptionFromValue(value));
      });
    }
    return val.filter(v => Boolean(getOption(v))).map(v => getOption(v));
  };
  const createOptionFromValue = value => {
    return {
      [valueProp.value]: value,
      [label.value]: value,
      [trackBy.value]: value
    };
  };
  const getCreatedTagOption = () => {
    return createdTag.value.length > 0 ? createdTag.value[0] : null;
  };
  const isCreatedTag = option => {
    const createdTag = getCreatedTagOption();
    return createdTag && createdTag[valueProp.value] === option[valueProp.value];
  };
  const getSearchOption = () => {
    if (!search.value) {
      return null;
    }
    const optionIndex = getOptionIndexByTrackBy(search.value);
    return optionIndex === -1 ? null : eo.value[optionIndex];
  };

  // ================ HOOKS ===============

  if (options && typeof options.value === 'function') {
    if (resolveOnLoad.value) {
      resolveOptions(initInternalValue);
    } else if (object.value == true) {
      initInternalValue();
    }
  } else {
    ro.value = options.value;
    initInternalValue();
  }

  // ============== WATCHERS ==============

  if (delay.value > -1) {
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(search, query => {
      if (query.length < minChars.value) {
        return;
      }
      resolving.value = true;
      setTimeout(() => {
        if (query != search.value) {
          return;
        }
        options.value(search.value).then(response => {
          if (query == search.value) {
            ro.value = response;
            pointer.value = fo.value.filter(o => o.disabled !== true)[0] || null;
            resolving.value = false;
          }
        });
      }, delay.value);
    }, {
      flush: 'sync'
    });
  }
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(ev, newValue => {
    if (!arraysEqual(object.value ? newValue.map(o => o[valueProp.value]) : newValue, iv.value.map(o => o[valueProp.value]))) {
      iv.value = makeInternal(newValue);
    }
  }, {
    deep: true
  });
  if (typeof props.options !== 'function') {
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(options, (n, o) => {
      ro.value = props.options;
      if (!Object.keys(iv.value).length) {
        initInternalValue();
      }
      refreshLabels();
    });
  }
  return {
    fo,
    filteredOptions: fo,
    hasSelected,
    multipleLabelText,
    eo,
    extendedOptions: eo,
    noOptions,
    noResults,
    resolving,
    busy,
    select,
    deselect,
    remove,
    clear,
    isSelected,
    isDisabled,
    isOptionDisabled,
    isMax,
    getOption,
    handleOptionClick,
    handleTagRemove,
    handleTagUpdate,
    refreshOptions,
    resolveOptions,
    getCreatedTagOption,
    isCreatedTag,
    getSearchOption
  };
}
;// ./src/components/vendor/vueform-multiselect/composables/usePointerAction.js


function usePointerAction(props, context, dep) {
  const {
    id,
    valueProp
  } = (0,refs_.toReadonlyRefs)(props);

  // ============ DEPENDENCIES ============

  const {
    fo
  } = dep;
  const {
    handleOptionClick
  } = dep;
  const {
    search
  } = dep;
  const {
    pointer
  } = dep;

  // ============== COMPUTED ==============

  // no export
  const options = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return fo.value.filter(o => o.disabled !== true);
  });

  // =============== METHODS ==============

  const isPointed = option => {
    return Boolean(pointer.value) && pointer.value[valueProp.value] == option[valueProp.value];
  };
  const setPointer = option => {
    pointer.value = option;
  };
  const setPointerFirst = () => {
    pointer.value = options.value[0] || null;
  };
  const clearPointer = () => {
    pointer.value = null;
  };
  const selectPointer = () => {
    if (!pointer.value || pointer.value.disabled === true) {
      clearPointer();
      return;
    }
    handleOptionClick(pointer.value);
    clearPointer();
  };
  const forwardPointer = () => {
    if (pointer.value === null) {
      setPointer(options.value[0] || null);
    } else {
      let next = options.value.map(o => o[valueProp.value]).indexOf(pointer.value[valueProp.value]) + 1;
      if (options.value.length <= next) {
        next = 0;
      }
      setPointer(options.value[next] || null);
    }
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)(() => {
      adjustWrapperScrollToPointer();
    });
  };
  const backwardPointer = () => {
    if (pointer.value === null) {
      setPointer(options.value[options.value.length - 1] || null);
    } else {
      let prevIndex = options.value.map(o => o[valueProp.value]).indexOf(pointer.value[valueProp.value]) - 1;
      if (prevIndex < 0) {
        prevIndex = options.value.length - 1;
      }
      setPointer(options.value[prevIndex] || null);
    }
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)(() => {
      adjustWrapperScrollToPointer();
    });
  };

  // no export
  /* istanbul ignore next */
  const adjustWrapperScrollToPointer = () => {
    const pointedOption = document.getElementById(id.value).querySelector('.is-pointed');
    if (!pointedOption) {
      return;
    }
    const wrapper = pointedOption.parentElement;
    if (pointedOption.offsetTop + pointedOption.offsetHeight > wrapper.clientHeight + wrapper.scrollTop) {
      wrapper.scrollTop = pointedOption.offsetTop + pointedOption.offsetHeight - wrapper.clientHeight;
    }
    if (pointedOption.offsetTop < wrapper.scrollTop) {
      wrapper.scrollTop = pointedOption.offsetTop;
    }
  };

  // ============== WATCHERS ==============

  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(search, val => {
    setPointerFirst();
  });
  return {
    pointer,
    isPointed,
    setPointer,
    setPointerFirst,
    clearPointer,
    selectPointer,
    forwardPointer,
    backwardPointer
  };
}
;// ./src/components/vendor/vueform-multiselect/composables/useDropdown.js


function useDropdown(props, context, dep) {
  const {
    maxHeight,
    disabled,
    searchable
  } = (0,refs_.toReadonlyRefs)(props);

  // ============ DEPENDENCIES ============

  const {
    multiselect
  } = dep;
  const {
    blurInput
  } = dep;
  const {
    blurSearch
  } = dep;
  const {
    focusInput
  } = dep;
  const {
    focusSearch
  } = dep;

  // ================ DATA ================

  const isOpen = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);

  // ============== COMPUTED ==============

  const contentMaxHeight = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return `${maxHeight.value}px`;
  });

  // =============== METHODS ==============

  const openDropdown = () => {
    if (disabled.value) {
      return;
    }
    isOpen.value = true;
    context.emit('open');
  };
  const closeDropdown = () => {
    isOpen.value = false;
    context.emit('close');
  };
  const open = () => {
    if (searchable && searchable.value) {
      focusSearch();
    } else {
      focusInput();
    }
  };
  const close = () => {
    if (searchable && searchable.value) {
      blurSearch();
    } else {
      blurInput();
    }
  };
  const handleInputMousedown = e => {
    if (isOpen.value && !searchable.value) {
      multiselect.value.querySelector('.multiselect-input').dispatchEvent(new Event('blur'));
      multiselect.value.querySelector('.multiselect-input').blur();
      e.preventDefault();
    }
  };
  return {
    isOpen,
    contentMaxHeight,
    openDropdown,
    closeDropdown,
    open,
    close,
    handleInputMousedown
  };
}
;// ./src/components/vendor/vueform-multiselect/composables/useMultiselect.js


function useMultiselect(props, context, dep) {
  const {
    searchable,
    id
  } = (0,refs_.toReadonlyRefs)(props);

  // ================ DATA ================

  const multiselect = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);

  // ============== COMPUTED ==============

  const tabindex = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return searchable.value ? -1 : 0;
  });

  // =============== METHODS ==============

  const focusInput = () => {
    multiselect.value.querySelector('.multiselect-input').focus();
  };
  const blurInput = () => {
    multiselect.value.querySelector('.multiselect-input').blur();
  };
  return {
    multiselect,
    tabindex,
    focusInput,
    blurInput
  };
}
;// ./src/components/vendor/vueform-multiselect/composables/useKeyboard.js


function useKeyboard(props, context, dep) {
  const {
    addTagOn,
    createTag
  } = (0,refs_.toReadonlyRefs)(props);

  // ============ DEPENDENCIES ============

  const {
    iv
  } = dep;
  const {
    update
  } = dep;
  const {
    closeDropdown
  } = dep;
  const {
    clearPointer
  } = dep;
  const {
    search
  } = dep;
  const {
    selectPointer
  } = dep;

  // =============== METHODS ==============

  const handleBackspace = e => {
    update([...iv.value].slice(0, -1));
  };
  const handleEsc = e => {
    closeDropdown();
    clearPointer();
    e.target.blur();
  };
  const handleSearchBackspace = e => {
    if (search.value !== '') {
      e.stopPropagation();
    }
  };
  const handleSearchInput = e => {
    search.value = e.target.value;
  };
  const handleAddTag = e => {
    if (e.keyCode === 13 && (addTagOn.value.indexOf('enter') !== -1 || !createTag.value)) {
      selectPointer();
    } else if (e.keyCode === 32 && addTagOn.value.indexOf('space') !== -1 && createTag.value) {
      search.value = search.value.trim();
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)(() => {
        selectPointer();
      });
    }
  };
  return {
    handleBackspace,
    handleEsc,
    handleSearchBackspace,
    handleSearchInput,
    handleAddTag
  };
}
;// ./src/components/vendor/vueform-multiselect/default.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const vueform_multiselect_default = ({});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/vendor/vueform-multiselect/Multiselect.vue?vue&type=script&lang=js











/* harmony default export */ const Multiselectvue_type_script_lang_js = ({
  name: 'Multiselect',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    options: {
      type: [Array, Object, Function],
      required: false,
      default: () => []
    },
    id: {
      type: [String, Number],
      required: false,
      default: 'multiselect'
    },
    name: {
      type: [String, Number],
      required: false,
      default: 'multiselect'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: 'label'
    },
    trackBy: {
      type: String,
      required: false,
      default: 'label'
    },
    valueProp: {
      type: String,
      required: false,
      default: 'value'
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    mode: {
      type: String,
      required: false,
      default: 'multiple' // multiple|tags
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false
    },
    searchMaxLength: {
      type: Number,
      required: false,
      default: -1
    },
    limit: {
      type: Number,
      required: false,
      default: -1
    },
    maxHeight: {
      type: Number,
      required: false,
      default: 160
    },
    hideSelected: {
      type: Boolean,
      required: false,
      default: true
    },
    createTag: {
      type: Boolean,
      required: false,
      default: false
    },
    onlyEmitOnSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    onlyEmitOnDeselect: {
      type: Boolean,
      required: false,
      default: false
    },
    appendNewTag: {
      type: Boolean,
      required: false,
      default: true
    },
    selectNewTag: {
      type: Boolean,
      required: false,
      default: true
    },
    caret: {
      type: Boolean,
      required: false,
      default: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    noOptionsText: {
      type: String,
      required: false,
      default: 'Aucun résultat pour cette recherche'
    },
    noResultsText: {
      type: String,
      required: false,
      default: 'Aucun résultat pour cette recherche'
    },
    multipleLabel: {
      type: Function,
      required: false
    },
    object: {
      type: Boolean,
      required: false,
      default: false
    },
    delay: {
      type: Number,
      required: false,
      default: -1
    },
    minChars: {
      type: Number,
      required: false,
      default: 0
    },
    resolveOnLoad: {
      type: Boolean,
      required: false,
      default: true
    },
    filterResults: {
      type: Boolean,
      required: false,
      default: true
    },
    clearOnSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    canDeselect: {
      type: Boolean,
      required: false,
      default: true
    },
    max: {
      type: Number,
      required: false,
      default: -1
    },
    showOptions: {
      type: Boolean,
      required: false,
      default: true
    },
    addTagOn: {
      type: Array,
      required: false,
      default: () => ['enter']
    },
    openDirection: {
      type: String,
      required: false,
      default: 'bottom'
    },
    tag: {
      type: Boolean,
      required: false,
      default: false
    },
    continuousSearch: {
      type: Boolean,
      default: false
    }
  },
  emits: ['open', 'close', 'select', 'deselect', 'input', 'search-change', 'tag', 'update:modelValue', 'change', 'clear'],
  setup(props, context) {
    const value = useValue(props);
    const multiselect = useMultiselect(props, context);
    const pointer = usePointer(props, context);
    const data = useData(props, context, {
      iv: value.iv
    });
    const search = useSearch(props, context, {
      iv: value.iv
    });
    const dropdown = useDropdown(props, context, {
      multiselect: multiselect.multiselect,
      blurInput: multiselect.blurInput,
      blurSearch: search.blurSearch,
      focusInput: multiselect.focusInput,
      focusSearch: search.focusSearch
    });
    const options = useOptions(props, context, {
      ev: value.ev,
      iv: value.iv,
      search: search.search,
      blurSearch: search.blurSearch,
      clearSearch: search.clearSearch,
      update: data.update,
      blurInput: multiselect.blurInput,
      pointer: pointer.pointer
    });
    const pointerAction = usePointerAction(props, context, {
      fo: options.fo,
      handleOptionClick: options.handleOptionClick,
      search: search.search,
      pointer: pointer.pointer
    });
    const keyboard = useKeyboard(props, context, {
      iv: value.iv,
      update: data.update,
      closeDropdown: dropdown.closeDropdown,
      clearPointer: pointerAction.clearPointer,
      search: search.search,
      selectPointer: pointerAction.selectPointer
    });
    function handleSearchFocus() {
      search.onSearchFocus();
      dropdown.openDropdown();
    }
    async function handleBlur() {
      // Wait for possible handleOptionClick
      await (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)();
      const searchOption = options.getCreatedTagOption() || options.getSearchOption();
      if (searchOption && !options.isSelected(searchOption) && !options.isDisabled(searchOption)) {
        pointerAction.setPointer(searchOption);
        pointerAction.selectPointer();
      }
      dropdown.closeDropdown();
    }
    const hiddenSelectedValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        tag,
        searchable,
        createTag,
        continuousSearch
      } = props;
      const isOpen = dropdown.isOpen.value;
      const hasSearchQuery = Boolean(search.search.value);
      const shouldHideWhenOpened = createTag || continuousSearch;
      const shouldHide = shouldHideWhenOpened && isOpen || hasSearchQuery;
      return !tag && searchable && shouldHide;
    });
    return {
      ...value,
      ...dropdown,
      ...multiselect,
      ...pointer,
      ...data,
      ...search,
      ...options,
      ...pointerAction,
      ...keyboard,
      hiddenSelectedValue,
      handleBlur,
      handleSearchFocus
    };
  }
});
;// ./src/components/vendor/vueform-multiselect/Multiselect.vue?vue&type=script&lang=js
 
;// ./src/components/vendor/vueform-multiselect/Multiselect.vue




;
const Multiselect_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(Multiselectvue_type_script_lang_js, [['render',Multiselectvue_type_template_id_00a53342_render]])

/* harmony default export */ const Multiselect = (Multiselect_exports_);
;// ./src/components/atoms/select/composables/use-multiselect.ts

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function use_multiselect_useMultiselect({
  disabled,
  noDeselect
}) {
  const multiselectRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
  const isOpen = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
  function onOpen() {
    isOpen.value = true;
  }
  function onClose() {
    isOpen.value = false;
  }
  function toggle(value) {
    if (disabled.value) {
      return;
    }
    const actualValue = value ?? !isOpen.value;
    if (actualValue === isOpen.value) {
      return;
    }
    if (actualValue) {
      open();
    } else {
      close();
    }
  }
  function open() {
    multiselectRef.value?.open();
  }
  function close() {
    const multiselect = multiselectRef.value;
    if (multiselect && isOpen.value) {
      multiselect.close();
      // In some cases calling close isn't enough ¯\_(ツ)_/¯
      multiselect.closeDropdown();
    }
  }
  function clear() {
    if (!noDeselect.value) {
      multiselectRef.value?.clear();
    }
  }
  function focus() {
    toggle(true);
  }
  function blur() {
    toggle(false);
  }
  return {
    multiselectRef,
    isOpen,
    onOpen,
    onClose,
    toggle,
    open,
    close,
    clear,
    focus,
    blur
  };
}
;// ./src/components/atoms/select/utils/value.ts


function normalizeValue(target, source) {
  const shouldArrayify = Array.isArray(source);
  return shouldArrayify ? (0,array_.arrayify)(target) : (0,array_.deArrayify)(target);
}
function normalizeEmptyValue(value, shouldStringify) {
  if ((0,truthy_.truthy)(value)) {
    return value;
  }
  return shouldStringify ? '' : null;
}
;// ./src/components/atoms/select/composables/use-values.ts



// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useValues({
  modelValue,
  shouldStringifyEmptyValue
}, {
  emit
}) {
  const values = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
    get() {
      return normalizeInternalValue(modelValue.value);
    },
    set(value) {
      emit('update:modelValue', normalizeExternalValue(value));
    }
  });
  function normalizeInternalValue(value) {
    return (0,array_.arrayify)(value);
  }
  function normalizeExternalValue(value) {
    const normalizedValue = normalizeValue(value, modelValue.value);
    return normalizeEmptyValue(normalizedValue, shouldStringifyEmptyValue.value);
  }
  return {
    values
  };
}
;// ./src/components/atoms/select/types.ts
var DtgSelectType;
(function (DtgSelectType) {
  DtgSelectType["single"] = "single";
  DtgSelectType["multiple"] = "multiple";
  DtgSelectType["suggestions"] = "suggestions";
})(DtgSelectType || (DtgSelectType = {}));
var DtgSelectSelectBehavior;
(function (DtgSelectSelectBehavior) {
  DtgSelectSelectBehavior["emit"] = "emit";
  DtgSelectSelectBehavior["select"] = "select";
})(DtgSelectSelectBehavior || (DtgSelectSelectBehavior = {}));
var DtgSelectFreeOptionBehavior;
(function (DtgSelectFreeOptionBehavior) {
  DtgSelectFreeOptionBehavior["emit"] = "emit";
  DtgSelectFreeOptionBehavior["select"] = "select";
  DtgSelectFreeOptionBehavior["append"] = "append";
})(DtgSelectFreeOptionBehavior || (DtgSelectFreeOptionBehavior = {}));
const dtgSelectEvents = ['update:modelValue', 'open', 'close', 'blur', 'freeOption', 'editOption', 'select', 'deselect'];
// We aren't using single mode because it breaks when switching toggling freeOption prop
var MultiselectMode;
(function (MultiselectMode) {
  MultiselectMode["multiple"] = "multiple";
  MultiselectMode["tags"] = "tags";
})(MultiselectMode || (MultiselectMode = {}));
;// ./src/components/atoms/select/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const select_style_module = ({"dtg-select":"lib_dtg-select_y4oFW","dtg-select__text":"lib_dtg-select__text_wVq2q","dtg-select__text-inner":"lib_dtg-select__text-inner_fRzC5","dtg-select__placeholder":"lib_dtg-select__placeholder_Th3Bj","dtg-select__tag":"lib_dtg-select__tag_leofi","dtg-select__caret":"lib_dtg-select__caret_UE0Sy","dtg-select__caret-icon":"lib_dtg-select__caret-icon_eKFVP","dtg-select__spinner":"lib_dtg-select__spinner_D3IPR","dtg-select__option":"lib_dtg-select__option_Dtt4W","dtg-select__option-icon":"lib_dtg-select__option-icon_jRtnN","dtg-select__option-text":"lib_dtg-select__option-text_vcCeI"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/select/component.vue?vue&type=script&lang=ts
















const PROP_OVERRIDES_BY_TYPE = {
  [DtgSelectType.single]: {
    mode: MultiselectMode.tags,
    caret: true,
    max: 1
  },
  [DtgSelectType.multiple]: {
    mode: MultiselectMode.tags,
    caret: true
  },
  [DtgSelectType.suggestions]: {
    mode: MultiselectMode.multiple,
    filterResults: false,
    minChars: 1,
    resolveOnLoad: false,
    delay: 200,
    searchable: true,
    caret: false,
    max: 1
  }
};
/* harmony default export */ const select_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(select_style_module),
  components: {
    Multiselect: Multiselect,
    DtgIcon: icon_component,
    DtgTag: tag_component,
    DtgButtonBase: component,
    DtgSpinner: spinner_component
  },
  props: {
    modelValue: {
      type: [String, Object, Array],
      default: null
    },
    nonNullable: {
      type: Boolean,
      default: false
    },
    type: {
      value: String,
      default: DtgSelectType.single,
      validator: inRecord(DtgSelectType)
    },
    options: {
      type: [Array, Function],
      default: () => []
    },
    selectBehavior: {
      type: String,
      default: DtgSelectSelectBehavior.select,
      validator: inRecord(DtgSelectSelectBehavior)
    },
    deselectBehavior: {
      type: String,
      default: DtgSelectSelectBehavior.select,
      validator: inRecord(DtgSelectSelectBehavior)
    },
    freeOption: {
      type: Boolean,
      default: false
    },
    freeOptionBehavior: {
      type: String,
      default: DtgSelectFreeOptionBehavior.append,
      validator: inRecord(DtgSelectFreeOptionBehavior)
    },
    freeOptionEmitOnEdit: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null
    },
    trackByValue: {
      type: Boolean,
      default: null
    },
    max: {
      type: Number,
      default: 1
    },
    searchable: {
      type: Boolean,
      default: false
    },
    noDeselect: {
      type: Boolean,
      default: false
    },
    clearButtonVisible: {
      type: Boolean,
      default: false
    },
    tag: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    object: {
      type: Boolean,
      default: false
    },
    continuousSearch: {
      type: Boolean,
      default: false
    }
  },
  emits: events(dtgSelectEvents)(),
  setup(props, context) {
    const valueProp = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const isValue = props.trackByValue ?? props.freeOption;
      return isValue ? 'value' : 'id';
    });
    const searchValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)('');
    const typeProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        caret,
        mode,
        ...rest
      } = PROP_OVERRIDES_BY_TYPE[props.type];
      return {
        // Options reimplemented by our component
        custom: {
          mode,
          caret
        },
        // Options handled by multiselect component
        multiselect: rest
      };
    });
    const mode = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        freeOption,
        disabled,
        tag
      } = props;
      const {
        mode
      } = typeProps.value.custom;
      if (freeOption && !disabled) {
        return MultiselectMode.tags;
      } else if (disabled || !tag) {
        return MultiselectMode.multiple;
      }
      return mode;
    });
    const {
      modelValue,
      disabled,
      noDeselect
    } = (0,refs_.toReadonlyRefs)(props);
    const caret = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => typeProps.value.custom.caret);
    const caretShown = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.modelValue === null || !props.clearButtonVisible);
    const shouldStringifyEmptyValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.nonNullable && !props.object && valueProp.value === 'value';
    });
    const {
      values
    } = useValues({
      modelValue,
      shouldStringifyEmptyValue
    }, context);
    const combinedProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        selectBehavior,
        deselectBehavior,
        freeOption,
        freeOptionBehavior,
        placeholder,
        searchable,
        disabled,
        object,
        noDeselect,
        maxLength,
        tag,
        max,
        continuousSearch
      } = props;
      const onlyEmitOnSelect = selectBehavior === DtgSelectSelectBehavior.emit;
      const onlyEmitOnDeselect = deselectBehavior === DtgSelectSelectBehavior.emit;
      const appendNewTag = freeOptionBehavior === DtgSelectFreeOptionBehavior.append;
      const selectNewTag = appendNewTag || freeOptionBehavior === DtgSelectFreeOptionBehavior.select;
      const {
        multiselect: typePropsMultiselect
      } = typeProps.value;
      const dynamicProps = {
        mode: mode.value,
        valueProp: valueProp.value,
        onlyEmitOnSelect,
        onlyEmitOnDeselect,
        createTag: freeOption,
        appendNewTag,
        selectNewTag,
        searchable: searchable || freeOption,
        canDeselect: !noDeselect,
        searchMaxLength: maxLength === null ? -1 : maxLength,
        placeholder,
        disabled,
        object,
        tag,
        max,
        continuousSearch
      };
      const trackBy = 'value';
      const label = 'value';
      const staticProps = {
        trackBy,
        label,
        hideSelected: false,
        maxHeight: 260,
        caret: false,
        multipleLabel
      };
      return {
        ...dynamicProps,
        ...staticProps,
        ...typePropsMultiselect
      };
    });
    const {
      multiselectRef,
      isOpen,
      onOpen,
      onClose,
      ...publicMethods
    } = use_multiselect_useMultiselect({
      disabled,
      noDeselect
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(isOpen, value => {
      if (value) {
        context.emit('open');
      } else {
        context.emit('close');
        context.emit('blur');
      }
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(values, value => {
      const isSelectionComplete = !Array.isArray(value) || value.length > 0;
      if (isSelectionComplete) {
        publicMethods.close();
      } else if (!isOpen.value) {
        context.emit('blur');
      }
    });
    function onSelect(value) {
      context.emit('select', value);
      if (props.selectBehavior === DtgSelectSelectBehavior.emit) {
        publicMethods.close();
      }
    }
    function onDeselect(value) {
      context.emit('deselect', value);
    }
    function onCaretClick() {
      publicMethods.toggle();
    }
    function onAddFreeOption(value) {
      context.emit('freeOption', value);
      if (props.freeOptionBehavior === DtgSelectFreeOptionBehavior.emit) {
        publicMethods.close();
      }
    }
    function onEditClick(value) {
      context.emit('editOption', value);
    }
    function multipleLabel(values) {
      return values.map(value => value.value).join(', ');
    }
    function onSearchChange(data) {
      searchValue.value = data;
    }
    function makeSearchTextBold(text) {
      return boldQuery(text, searchValue.value);
    }
    function boldQuery(text, query) {
      const escapedQuery = escapeRegExp_default()(escape_default()(query.trim()));
      const escapedText = escape_default()(text);
      if (!escapedQuery) {
        return escapedText;
      }
      const substring = new RegExp(escapedQuery, 'gi');
      return escapedText.replace(substring, match => {
        return `<b>${match}</b>`;
      });
    }
    return {
      b: useBem(select_style_module),
      values,
      combinedProps,
      caret,
      caretShown,
      multiselectRef,
      multipleLabel,
      onOpen,
      onClose,
      onSelect,
      onDeselect,
      onCaretClick,
      onAddFreeOption,
      onEditClick,
      makeSearchTextBold,
      onSearchChange,
      ...publicMethods
    };
  }
}));
;// ./src/components/atoms/select/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/select/component.vue




;
const select_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(select_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_456eb9ec_ts_true_render]])

/* harmony default export */ const select_component = (select_component_exports_);
;// ./src/components/atoms/select/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/textarea/component.vue?vue&type=template&id=bbd1efda&ts=true

const componentvue_type_template_id_bbd1efda_ts_true_hoisted_1 = ["name", "disabled", "maxlength", "rows", "cols"];
function componentvue_type_template_id_bbd1efda_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.splitAttrs.root, {
    class: _ctx.b({
      disabled: _ctx.disabled,
      focused: _ctx.focused
    })
  }), [_ctx.placeholder && _ctx.empty && !_ctx.focused ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('placeholder'))
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.placeholder), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("textarea", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    ref: "textareaRef",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
    class: _ctx.b('textarea'),
    name: _ctx.name,
    disabled: _ctx.disabled,
    maxlength: _ctx.maxLength,
    rows: _ctx.rows,
    cols: _ctx.cols,
    autocorrect: "off",
    spellcheck: "false",
    autocapitalize: "off"
  }, {
    ..._ctx.splitAttrs.attrs,
    ..._ctx.splitAttrs.listeners
  }), null, 16, componentvue_type_template_id_bbd1efda_ts_true_hoisted_1), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vModelText, _ctx.modelValueInternal]])], 16);
}
;// ./src/components/atoms/textarea/component.vue?vue&type=template&id=bbd1efda&ts=true

;// ./src/components/atoms/textarea/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const textarea_style_module = ({"dtg-textarea":"lib_dtg-textarea_m9jTi","dtg-textarea_focused":"lib_dtg-textarea_focused_Ciu6g","dtg-textarea_disabled":"lib_dtg-textarea_disabled_pzUDG","dtg-textarea__textarea":"lib_dtg-textarea__textarea_RAITL","dtg-textarea__placeholder":"lib_dtg-textarea__placeholder_IutLy"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/textarea/component.vue?vue&type=script&lang=ts





/* harmony default export */ const textarea_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(textarea_style_module),
  inheritAttrs: false,
  props: {
    modelValue: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null
    },
    rows: {
      type: [Number, String],
      default: null
    },
    cols: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    attrs,
    emit
  }) {
    const splitAttrs = useSplitAttrs(attrs);
    const modelValueInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
      get() {
        return props.modelValue;
      },
      set(value) {
        emit('update:modelValue', value);
      }
    });
    const textareaRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const {
      focused,
      focus,
      blur
    } = useFocus(textareaRef, {
      autoFocus: props.autofocus
    });
    const empty = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => !modelValueInternal.value);
    return {
      b: useBem(textarea_style_module),
      modelValueInternal,
      splitAttrs,
      focused,
      empty,
      textareaRef,
      /** @public */
      focus,
      /** @public */
      blur
    };
  }
}));
;// ./src/components/atoms/textarea/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/textarea/component.vue




;
const textarea_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(textarea_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_bbd1efda_ts_true_render]])

/* harmony default export */ const textarea_component = (textarea_component_exports_);
;// ./src/components/atoms/textarea/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/toggle/component.vue?vue&type=template&id=724ee93f&ts=true

function componentvue_type_template_id_724ee93f_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_button_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button-base");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      defaultText: !_ctx.$slots.textRight && !_ctx.noText,
      disabled: _ctx.disabled,
      focusVisible: _ctx.focusVisible
    }))
  }, [_ctx.$slots.default ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text-left'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button_base, {
    ref: "toggleRef",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('track')),
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onToggle())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('track-inner'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('handle', {
        state: _ctx.state
      }))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('handle-icon')),
      name: _ctx.icon
    }, null, 8, ["class", "name"])], 2)], 2)]),
    _: 1
  }, 8, ["class", "disabled"]), !_ctx.noText ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text-right'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "textRight", {}, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.textRight), 1)])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// ./src/components/atoms/toggle/component.vue?vue&type=template&id=724ee93f&ts=true

;// ./src/components/atoms/toggle/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const toggle_style_module = ({"dtg-toggle":"lib_dtg-toggle_pus8R","dtg-toggle__track":"lib_dtg-toggle__track_GA3vZ","dtg-toggle__track-inner":"lib_dtg-toggle__track-inner_c8Njy","dtg-toggle__handle":"lib_dtg-toggle__handle_wtrrX","dtg-toggle__handle_state_off":"lib_dtg-toggle__handle_state_off_Q8AF4","dtg-toggle__handle_state_undecided":"lib_dtg-toggle__handle_state_undecided_NjU9F","dtg-toggle__handle_state_on":"lib_dtg-toggle__handle_state_on_qNzpa","dtg-toggle_disabled":"lib_dtg-toggle_disabled_Cn1aM","dtg-toggle_focusVisible":"lib_dtg-toggle_focusVisible_CPjtH","dtg-toggle__handle-icon":"lib_dtg-toggle__handle-icon_Icc4u","dtg-toggle__text-right":"lib_dtg-toggle__text-right_HdORJ","dtg-toggle_defaultText":"lib_dtg-toggle_defaultText_aR8cs","dtg-toggle__text-left":"lib_dtg-toggle__text-left_bMpYn"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/toggle/component.vue?vue&type=script&lang=ts







/* harmony default export */ const toggle_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(toggle_style_module),
  components: {
    DtgButtonBase: component,
    DtgIcon: icon_component
  },
  props: {
    modelValue: {
      type: Boolean,
      default: null
    },
    noText: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const toggleRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const {
      focus,
      blur,
      focusVisible
    } = useFocus(toggleRef, {
      clickToFocus: false
    });
    const modelValueInternal = propInternal(props, 'modelValue', emit);
    const state = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      switch (modelValueInternal.value) {
        case true:
          return 'on';
        case false:
          return 'off';
        default:
          return 'undecided';
      }
    });
    const textRight = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      switch (modelValueInternal.value) {
        case true:
          return 'Oui';
        case false:
          return 'Non';
        default:
          return '???';
      }
    });
    const icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return modelValueInternal.value ? 'checkmark' : 'close';
    });
    function onToggle() {
      modelValueInternal.value = !modelValueInternal.value;
    }
    return {
      b: useBem(toggle_style_module),
      toggleRef,
      textRight,
      state,
      focusVisible,
      icon,
      onToggle,
      /** @public */
      focus,
      /** @public */
      blur
    };
  }
}));
;// ./src/components/atoms/toggle/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/toggle/component.vue




;
const toggle_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(toggle_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_724ee93f_ts_true_render]])

/* harmony default export */ const toggle_component = (toggle_component_exports_);
;// ./src/components/atoms/toggle/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/transition-group-stack/component.vue?vue&type=template&id=02de7408&ts=true

function componentvue_type_template_id_02de7408_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.TransitionGroup, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.disabled ? {} : _ctx.listeners, {
    name: _ctx.disabled ? '' : _ctx.b()
  }), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    _: 3
  }, 16, ["name"]);
}
;// ./src/components/atoms/transition-group-stack/component.vue?vue&type=template&id=02de7408&ts=true

;// ./src/components/atoms/transition-group-stack/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const transition_group_stack_style_module = ({"dtg-transition-group-stack":"lib_dtg-transition-group-stack_PCJeQ"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/transition-group-stack/component.vue?vue&type=script&lang=ts




/* harmony default export */ const transition_group_stack_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(transition_group_stack_style_module),
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      b: useBem(transition_group_stack_style_module),
      listeners: useHeightTransition()
    };
  }
}));
;// ./src/components/atoms/transition-group-stack/component.vue?vue&type=script&lang=ts
 
;// ./src/components/atoms/transition-group-stack/component.vue




;
const transition_group_stack_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(transition_group_stack_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_02de7408_ts_true_render]])

/* harmony default export */ const transition_group_stack_component = (transition_group_stack_component_exports_);
;// ./src/components/atoms/transition-group-stack/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/button-add/component.vue?vue&type=template&id=8ff1e1c6&ts=true

function componentvue_type_template_id_8ff1e1c6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_button_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button-base");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_button_base, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      view: _ctx.view
    }))
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon')),
      name: "add"
    }, null, 8, ["class"]), _ctx.$slots.default ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 3
  }, 8, ["class"]);
}
;// ./src/components/molecules/button-add/component.vue?vue&type=template&id=8ff1e1c6&ts=true

;// ./src/components/molecules/button-add/types.ts
var DtgButtonAddView;
(function (DtgButtonAddView) {
  DtgButtonAddView["big"] = "big";
  DtgButtonAddView["small"] = "small";
})(DtgButtonAddView || (DtgButtonAddView = {}));
;// ./src/components/molecules/button-add/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const button_add_style_module = ({"dtg-button-add_view_big":"lib_dtg-button-add_view_big_wUUQo","dtg-button-add__icon":"lib_dtg-button-add__icon_XXV7y","dtg-button-add__text":"lib_dtg-button-add__text_fbKaG","dtg-button-add_view_small":"lib_dtg-button-add_view_small_rWkVC","dtg-button-add":"lib_dtg-button-add_VCLRI"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/button-add/component.vue?vue&type=script&lang=ts







/* harmony default export */ const button_add_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(button_add_style_module),
  components: {
    DtgButtonBase: component,
    DtgIcon: icon_component
  },
  props: {
    view: {
      type: String,
      default: DtgButtonAddView.big,
      validator: inRecord(DtgButtonAddView)
    }
  },
  setup() {
    return {
      b: useBem(button_add_style_module)
    };
  }
}));
;// ./src/components/molecules/button-add/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/button-add/component.vue




;
const button_add_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(button_add_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_8ff1e1c6_ts_true_render]])

/* harmony default export */ const button_add_component = (button_add_component_exports_);
;// ./src/components/molecules/button-add/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/button-element/component.vue?vue&type=template&id=8f38bda6&ts=true

function componentvue_type_template_id_8f38bda6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_mark = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-mark");
  const _component_dtg_counter = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-counter");
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b(_ctx.mods)),
    disabled: _ctx.disabled
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.withMark ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_mark, {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('active')),
      view: _ctx.viewInternal,
      size: "s",
      border: ""
    }, null, 8, ["class", "view"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.counter ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_counter, {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('counter')),
      counter: _ctx.counter
    }, null, 8, ["class", "counter"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('inner'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon-wrapper'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon')),
      name: _ctx.iconInternal,
      "fallback-name": _ctx.fallbackIcon
    }, null, 8, ["class", "name", "fallback-name"]), _ctx.indicatorIcon ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_icon, {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('indicator')),
      name: _ctx.indicatorIcon
    }, null, 8, ["class", "name"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), _ctx.$slots.default || _ctx.invalid && _ctx.icon ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text-wrapper'))
    }, [_ctx.invalid && _ctx.icon ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_mark, {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('mark')),
      view: "warning",
      size: "s"
    }, null, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.default ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text-inner'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)]),
    _: 3
  }, 8, ["class", "disabled"]);
}
;// ./src/components/molecules/button-element/component.vue?vue&type=template&id=8f38bda6&ts=true

;// ./src/components/molecules/button-element/types.ts
var DtgButtonElementView;
(function (DtgButtonElementView) {
  DtgButtonElementView["horizontal"] = "horizontal";
  DtgButtonElementView["vertical"] = "vertical";
})(DtgButtonElementView || (DtgButtonElementView = {}));
var DtgButtonElementSize;
(function (DtgButtonElementSize) {
  DtgButtonElementSize["s"] = "s";
  DtgButtonElementSize["m"] = "m";
})(DtgButtonElementSize || (DtgButtonElementSize = {}));
var DtgButtonElementAlign;
(function (DtgButtonElementAlign) {
  DtgButtonElementAlign["left"] = "left";
  DtgButtonElementAlign["center"] = "center";
})(DtgButtonElementAlign || (DtgButtonElementAlign = {}));
;// ./src/components/molecules/button-element/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const button_element_style_module = ({"dtg-button-element_size_s":"lib_dtg-button-element_size_s_NlSuC","dtg-button-element":"lib_dtg-button-element__3U_X","dtg-button-element_active":"lib_dtg-button-element_active_sEXnk","dtg-button-element__inner":"lib_dtg-button-element__inner_Uw7lp","dtg-button-element__mark":"lib_dtg-button-element__mark_hauNi","dtg-button-element_size_m":"lib_dtg-button-element_size_m_ahGP_","dtg-button-element__text-wrapper":"lib_dtg-button-element__text-wrapper_OgKPX","dtg-button-element_view_horizontal":"lib_dtg-button-element_view_horizontal_GsGjx","dtg-button-element__active":"lib_dtg-button-element__active_c8U9B","dtg-button-element_view_vertical":"lib_dtg-button-element_view_vertical_KPxtH","dtg-button-element__indicator":"lib_dtg-button-element__indicator_Qtoe6","dtg-button-element_disabled":"lib_dtg-button-element_disabled__nTTO","dtg-button-element_align_center":"lib_dtg-button-element_align_center_uNMNr","dtg-button-element__icon-wrapper":"lib_dtg-button-element__icon-wrapper_iaJ5g","dtg-button-element__icon":"lib_dtg-button-element__icon_H3e1h","dtg-button-element_notice":"lib_dtg-button-element_notice_qf7bj","dtg-button-element_defaultIcon":"lib_dtg-button-element_defaultIcon_t38Lx","dtg-button-element_invalid":"lib_dtg-button-element_invalid_TxYlA","dtg-button-element__counter":"lib_dtg-button-element__counter_TNuPn","dtg-button-element__text":"lib_dtg-button-element__text_PVlQP","dtg-button-element__text-inner":"lib_dtg-button-element__text-inner_yKGHL"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/button-element/component.vue?vue&type=script&lang=ts









/* harmony default export */ const button_element_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(button_element_style_module),
  components: {
    DtgAction: action_component,
    DtgIcon: icon_component,
    DtgMark: mark_component,
    DtgCounter: counter_component
  },
  props: {
    view: {
      type: String,
      default: DtgButtonElementView.horizontal,
      validator: inRecord(DtgButtonElementView)
    },
    size: {
      type: String,
      default: DtgButtonElementSize.s,
      validator: inRecord(DtgButtonElementSize)
    },
    icon: {
      type: String,
      default: null,
      validator: inArray(iconNames)
    },
    indicatorIcon: {
      type: String,
      default: null,
      validator: inArray(iconNames)
    },
    fallbackIcon: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    noMark: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    counter: {
      type: Number,
      default: null
    },
    notice: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: DtgButtonElementAlign.left,
      validator: inRecord(DtgButtonElementAlign)
    }
  },
  setup(props) {
    const mods = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        view,
        size,
        disabled,
        active,
        invalid,
        icon,
        notice,
        align
      } = props;
      return {
        view,
        size,
        disabled,
        active,
        invalid,
        defaultIcon: !icon,
        notice,
        align
      };
    });
    const iconInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        icon,
        invalid
      } = props;
      if (icon) {
        return icon;
      }
      return invalid ? 'warning' : 'checkmarkCircle';
    });
    const viewInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.notice ? DtgMarkView.notice : DtgMarkView.neutral;
    });
    const withMark = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        active,
        noMark
      } = props;
      return active && !noMark;
    });
    return {
      b: useBem(button_element_style_module),
      mods,
      iconInternal,
      viewInternal,
      withMark
    };
  }
}));
;// ./src/components/molecules/button-element/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/button-element/component.vue




;
const button_element_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(button_element_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_8f38bda6_ts_true_render]])

/* harmony default export */ const button_element_component = (button_element_component_exports_);
;// ./src/components/molecules/button-element/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/building-selector/component.vue?vue&type=template&id=7ee5eb50&ts=true

function componentvue_type_template_id_7ee5eb50_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button_element = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button-element");
  const _component_dtg_element_list = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-element-list");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_element_list, {
    ref: "rootRef",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      view: _ctx.view
    })),
    horizontal: _ctx.view === 'horizontal',
    onResize: _cache[0] || (_cache[0] = $event => _ctx.onResize())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.buildings, (building, index) => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_button_element, {
        key: index,
        ref_for: true,
        ref: _ctx.setRef,
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('item')),
        active: _ctx.isBuildingSelected(building.id),
        invalid: !building.valid,
        icon: building.icon,
        disabled: _ctx.disabled,
        view: _ctx.view === 'horizontal' ? 'vertical' : 'horizontal',
        size: _ctx.size,
        "fallback-icon": "home",
        onClick: $event => _ctx.onBuildingClick(building.id)
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(building.name), 1)]),
        _: 2
      }, 1032, ["class", "active", "invalid", "icon", "disabled", "view", "size", "onClick"]);
    }), 128))]),
    _: 1
  }, 8, ["class", "horizontal"]);
}
;// ./src/components/molecules/building-selector/component.vue?vue&type=template&id=7ee5eb50&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/element-list/component.vue?vue&type=template&id=7de8eef6&ts=true

function componentvue_type_template_id_7de8eef6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  const _component_dtg_scrollable = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-scrollable");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_scrollable, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      horizontal: _ctx.horizontal
    })),
    horizontal: _ctx.horizontal
  }, {
    arrowBack: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(({
      visible,
      disabled,
      scroll
    }) => [visible ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('nav', {
        prev: true
      })),
      disabled: disabled,
      onClick: $event => scroll()
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('nav-icon')),
        name: "chevron"
      }, null, 8, ["class"])]),
      _: 2
    }, 1032, ["class", "disabled", "onClick"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    arrowForward: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(({
      visible,
      disabled,
      scroll
    }) => [visible ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('nav', {
        next: true
      })),
      disabled: disabled,
      onClick: $event => scroll()
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('nav-icon')),
        name: "chevron"
      }, null, 8, ["class"])]),
      _: 2
    }, 1032, ["class", "disabled", "onClick"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('items'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)]),
    _: 3
  }, 8, ["class", "horizontal"]);
}
;// ./src/components/molecules/element-list/component.vue?vue&type=template&id=7de8eef6&ts=true

;// ./src/components/molecules/element-list/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const element_list_style_module = ({"dtg-element-list__nav":"lib_dtg-element-list__nav_i6GHM","dtg-element-list__nav-icon":"lib_dtg-element-list__nav-icon_mxvXB","dtg-element-list__nav_prev":"lib_dtg-element-list__nav_prev_fnEND","dtg-element-list__nav_next":"lib_dtg-element-list__nav_next_BstBg","dtg-element-list__items":"lib_dtg-element-list__items_Pm2ku","dtg-element-list_horizontal":"lib_dtg-element-list_horizontal_9eKEF","dtg-element-list":"lib_dtg-element-list_IJ2tv"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/element-list/component.vue?vue&type=script&lang=ts






/* harmony default export */ const element_list_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(element_list_style_module),
  components: {
    DtgIcon: icon_component,
    DtgAction: action_component,
    DtgScrollable: scrollable_component
  },
  props: {
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      b: useBem(element_list_style_module)
    };
  }
}));
;// ./src/components/molecules/element-list/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/element-list/component.vue




;
const element_list_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(element_list_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_7de8eef6_ts_true_render]])

/* harmony default export */ const element_list_component = (element_list_component_exports_);
;// ./src/components/molecules/element-list/index.ts


;// ./src/components/molecules/building-selector/types.ts
var DtgBuildingSelectorView;
(function (DtgBuildingSelectorView) {
  DtgBuildingSelectorView["vertical"] = "vertical";
  DtgBuildingSelectorView["horizontal"] = "horizontal";
})(DtgBuildingSelectorView || (DtgBuildingSelectorView = {}));
var DtgBuildingSelectorSize;
(function (DtgBuildingSelectorSize) {
  DtgBuildingSelectorSize["s"] = "s";
  DtgBuildingSelectorSize["m"] = "m";
})(DtgBuildingSelectorSize || (DtgBuildingSelectorSize = {}));
;// ./src/components/molecules/building-selector/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const building_selector_style_module = ({"dtg-building-selector_view_horizontal":"lib_dtg-building-selector_view_horizontal_coziO","dtg-building-selector__item":"lib_dtg-building-selector__item_orm7m","dtg-building-selector_view_vertical":"lib_dtg-building-selector_view_vertical_Oogek"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/building-selector/component.vue?vue&type=script&lang=ts












/* harmony default export */ const building_selector_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(building_selector_style_module),
  components: {
    DtgElementList: element_list_component,
    DtgButtonElement: button_element_component
  },
  props: {
    modelValue: {
      type: [String, Array],
      default: null
    },
    buildings: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: DtgBuildingSelectorView.horizontal,
      validator: inRecord(DtgBuildingSelectorView)
    },
    size: {
      type: String,
      default: DtgBuildingSelectorSize.m,
      validator: inRecord(DtgBuildingSelectorSize)
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const rootRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const {
      buildings
    } = (0,refs_.toReadonlyRefs)(props);
    const {
      refs,
      setRef
    } = useTemplateRefsArray();
    const modelValueInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
      get: () => (0,array_.arrayify)(props.modelValue),
      set: value => {
        const normalizedValue = Array.isArray(props.modelValue) ? value : (0,array_.deArrayify)(value);
        emit('update:modelValue', normalizedValue);
      }
    });
    const currentBuildingIndex = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const selectedBuildingIds = modelValueInternal.value;
      if (selectedBuildingIds.length === 0) {
        return 0;
      }
      const lastSelectedBuilding = selectedBuildingIds[selectedBuildingIds.length - 1];
      return buildings.value.findIndex(({
        id
      }) => {
        return lastSelectedBuilding === id;
      });
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onActivated)(() => {
      void scrollBuildingIntoView();
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(currentBuildingIndex, scrollBuildingIntoView);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(buildings, () => {
      void scrollBuildingIntoView();
    });
    async function scrollBuildingIntoView() {
      await (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)();
      await (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)();
      const templateRef = refs.value[currentBuildingIndex.value];
      void (0,scroll_.scrollIntoView)(templateRef, {
        boundary: (0,get_element_from_ref_.getElementFromRef)(rootRef.value)
      });
    }
    function getUpdatedValue(id) {
      const currentIds = modelValueInternal.value;
      if (isBuildingSelected(id)) {
        return props.multiple ? currentIds.filter(otherId => otherId !== id) : currentIds;
      }
      return props.multiple ? [...currentIds, id] : [id];
    }
    function isBuildingSelected(id) {
      return modelValueInternal.value.includes(id);
    }
    function onBuildingClick(id) {
      modelValueInternal.value = getUpdatedValue(id);
    }
    function onResize() {
      void scrollBuildingIntoView();
    }
    return {
      b: useBem(building_selector_style_module),
      rootRef,
      setRef,
      onBuildingClick,
      onResize,
      isBuildingSelected
    };
  }
}));
;// ./src/components/molecules/building-selector/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/building-selector/component.vue




;
const building_selector_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(building_selector_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_7ee5eb50_ts_true_render]])

/* harmony default export */ const building_selector_component = (building_selector_component_exports_);
;// ./src/components/molecules/building-selector/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/card/component.vue?vue&type=template&id=39770410&ts=true

function componentvue_type_template_id_39770410_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content'))
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    _: 3
  }, 8, ["class"])], 2);
}
;// ./src/components/molecules/card/component.vue?vue&type=template&id=39770410&ts=true

;// ./src/components/molecules/card/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_style_module = ({"dtg-card":"lib_dtg-card_c0Gja","dtg-card__content":"lib_dtg-card__content_wJw7J"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/card/component.vue?vue&type=script&lang=ts




/* harmony default export */ const card_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_style_module),
  components: {
    DtgGrid: grid
  },
  setup() {
    return {
      b: useBem(card_style_module)
    };
  }
}));
;// ./src/components/molecules/card/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/card/component.vue




;
const card_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_39770410_ts_true_render]])

/* harmony default export */ const card_component = (card_component_exports_);
;// ./src/components/molecules/card/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/card-action/component.vue?vue&type=template&id=5525c8d0&ts=true

function componentvue_type_template_id_5525c8d0_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
    class: _ctx.b({
      view: _ctx.view,
      muted: _ctx.muted,
      active: _ctx.active,
      markView: _ctx.markView
    })
  }, {
    ..._ctx.splitAttrs.root,
    ..._ctx.splitAttrs.attrs
  }), {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('inner'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
      class: _ctx.b('action')
    }, _ctx.splitAttrs.listeners, {
      icon: _ctx.icon,
      "color-text": _ctx.colorText,
      marked: _ctx.marked,
      "mark-view": _ctx.markView,
      disabled: _ctx.disabled,
      view: _ctx.buttonView,
      "icon-left": "",
      fullwidth: ""
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
      _: 2
    }, [_ctx.$slots.default ? {
      name: "default",
      fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
      key: "0"
    } : undefined]), 1040, ["class", "icon", "color-text", "marked", "mark-view", "disabled", "view"])], 2)]),
    _: 3
  }, 16, ["class"]);
}
;// ./src/components/molecules/card-action/component.vue?vue&type=template&id=5525c8d0&ts=true

;// ./src/components/molecules/card-action/types.ts
var DtgCardActionView;
(function (DtgCardActionView) {
  DtgCardActionView["regular"] = "regular";
  DtgCardActionView["notice"] = "notice";
  DtgCardActionView["success"] = "success";
})(DtgCardActionView || (DtgCardActionView = {}));
;// ./src/components/molecules/card-action/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_action_style_module = ({"dtg-card-action__inner":"lib_dtg-card-action__inner_EfRH3","dtg-card-action":"lib_dtg-card-action_E2dSq","dtg-card-action__action":"lib_dtg-card-action__action_WgrT1","dtg-card-action_muted":"lib_dtg-card-action_muted_ZTmkC","dtg-card-action_view_regular":"lib_dtg-card-action_view_regular_tzpr6","dtg-card-action_active":"lib_dtg-card-action_active_yAfUy","dtg-card-action_view_notice":"lib_dtg-card-action_view_notice__AWeM","dtg-card-action_view_success":"lib_dtg-card-action_view_success_C5Mg3","dtg-card-action_markView_warning":"lib_dtg-card-action_markView_warning_gHHIW"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/card-action/component.vue?vue&type=script&lang=ts










/* harmony default export */ const card_action_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_action_style_module),
  components: {
    DtgCol: col,
    DtgButton: button_component
  },
  inheritAttrs: false,
  props: {
    view: {
      type: String,
      default: DtgCardActionView.regular,
      validator: inRecord(DtgCardActionView)
    },
    icon: {
      type: String,
      default: null,
      validator: inArray(iconNames)
    },
    muted: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    marked: {
      type: Boolean,
      default: false
    },
    markView: {
      type: String,
      default: DtgMarkView.notice,
      validator: inRecord(DtgMarkView)
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    attrs
  }) {
    const splitAttrs = useSplitAttrs(attrs);
    const colorText = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        active,
        view
      } = props;
      return active && view !== DtgCardActionView.regular;
    });
    const buttonView = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        active,
        view
      } = props;
      return active && view === DtgCardActionView.regular ? DtgButtonView.inverted : DtgButtonView.clear;
    });
    return {
      b: useBem(card_action_style_module),
      splitAttrs,
      colorText,
      buttonView
    };
  }
}));
;// ./src/components/molecules/card-action/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/card-action/component.vue




;
const card_action_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_action_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_5525c8d0_ts_true_render]])

/* harmony default export */ const card_action_component = (card_action_component_exports_);
;// ./src/components/molecules/card-action/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/card-line/component.vue?vue&type=template&id=f76c46e6&ts=true

function componentvue_type_template_id_f76c46e6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_card_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-card-base");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_base, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, {
      "outer-padding": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
        _: 3
      })]),
      _: 3
    })]),
    _: 3
  }, 8, ["class"]);
}
;// ./src/components/molecules/card-line/component.vue?vue&type=template&id=f76c46e6&ts=true

;// ./src/components/molecules/card-line/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_line_style_module = ({"dtg-card-line":"lib_dtg-card-line_qBiWg"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/card-line/component.vue?vue&type=script&lang=ts





/* harmony default export */ const card_line_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_line_style_module),
  components: {
    DtgCardBase: card_base_component,
    DtgGrid: grid,
    DtgRow: row
  },
  setup() {
    return {
      b: useBem(card_line_style_module)
    };
  }
}));
;// ./src/components/molecules/card-line/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/card-line/component.vue




;
const card_line_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_line_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_f76c46e6_ts_true_render]])

/* harmony default export */ const card_line_component = (card_line_component_exports_);
;// ./src/components/molecules/card-line/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/card-mosaic/component.vue?vue&type=template&id=287df999&ts=true

function componentvue_type_template_id_287df999_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_mark = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-mark");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      view: _ctx.view
    }))
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.icon ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon-wrapper'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon')),
      name: _ctx.icon
    }, null, 8, ["class", "name"]), _ctx.markView ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_mark, {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('mark')),
      view: _ctx.markView,
      icon: _ctx.markIcon,
      border: ""
    }, null, 8, ["class", "view", "icon"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)]),
    _: 3
  }, 8, ["class"]);
}
;// ./src/components/molecules/card-mosaic/component.vue?vue&type=template&id=287df999&ts=true

;// ./src/components/molecules/card-mosaic/types.ts
var DtgCardMosaicView;
(function (DtgCardMosaicView) {
  DtgCardMosaicView["regular"] = "regular";
  DtgCardMosaicView["success"] = "success";
  DtgCardMosaicView["warning"] = "warning";
})(DtgCardMosaicView || (DtgCardMosaicView = {}));
;// ./src/components/molecules/card-mosaic/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_mosaic_style_module = ({"dtg-card-mosaic":"lib_dtg-card-mosaic_sfDeG","dtg-card-mosaic_view_warning":"lib_dtg-card-mosaic_view_warning_fmBfu","dtg-card-mosaic__icon-wrapper":"lib_dtg-card-mosaic__icon-wrapper_wW9nv","dtg-card-mosaic__mark":"lib_dtg-card-mosaic__mark_JM2Qf","dtg-card-mosaic__icon":"lib_dtg-card-mosaic__icon_cJMDS","dtg-card-mosaic__content":"lib_dtg-card-mosaic__content_cMuW7"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/card-mosaic/component.vue?vue&type=script&lang=ts








const MARK_VIEW = {
  [DtgCardMosaicView.regular]: null,
  [DtgCardMosaicView.success]: DtgMarkView.neutral,
  [DtgCardMosaicView.warning]: DtgMarkView.warning
};
const MARK_ICON = {
  [DtgCardMosaicView.regular]: null,
  [DtgCardMosaicView.success]: 'checkmark',
  [DtgCardMosaicView.warning]: null
};
/* harmony default export */ const card_mosaic_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_mosaic_style_module),
  components: {
    DtgAction: action_component,
    DtgIcon: icon_component,
    DtgMark: mark_component
  },
  props: {
    view: {
      type: String,
      default: DtgCardMosaicView.regular,
      validator: inRecord(DtgCardMosaicView)
    },
    icon: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const markView = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => MARK_VIEW[props.view]);
    const markIcon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => MARK_ICON[props.view]);
    return {
      b: useBem(card_mosaic_style_module),
      markView,
      markIcon
    };
  }
}));
;// ./src/components/molecules/card-mosaic/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/card-mosaic/component.vue




;
const card_mosaic_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_mosaic_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_287df999_ts_true_render]])

/* harmony default export */ const card_mosaic_component = (card_mosaic_component_exports_);
;// ./src/components/molecules/card-mosaic/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/card-tile/component.vue?vue&type=template&id=1785faf1&ts=true

function componentvue_type_template_id_1785faf1_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_card_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-card-base");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_base, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.$slots.additionalActions ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('additional-actions'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "additionalActions")]),
        _: 3
      })]),
      _: 3
    })], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.content ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('row', {
        content: true
      }))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "content")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.actions ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 2,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('row', {
        actions: true
      }))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, {
      padding: "none"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "actions")]),
        _: 3
      })]),
      _: 3
    })], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.afterActions ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 3,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('row', {
        afterActions: true
      }))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "afterActions")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 3
  }, 8, ["class"]);
}
;// ./src/components/molecules/card-tile/component.vue?vue&type=template&id=1785faf1&ts=true

;// ./src/components/molecules/card-tile/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_tile_style_module = ({"dtg-card-tile":"lib_dtg-card-tile_en8IN","dtg-card-tile__row":"lib_dtg-card-tile__row_JplWQ","dtg-card-tile__row_content":"lib_dtg-card-tile__row_content_q0EBA","dtg-card-tile__row_actions":"lib_dtg-card-tile__row_actions_AEOa9","dtg-card-tile__row_afterActions":"lib_dtg-card-tile__row_afterActions_tz2MW","dtg-card-tile__additional-actions":"lib_dtg-card-tile__additional-actions_RiKeR"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/card-tile/component.vue?vue&type=script&lang=ts





/* harmony default export */ const card_tile_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_tile_style_module),
  components: {
    DtgCardBase: card_base_component,
    DtgGrid: grid,
    DtgRow: row
  },
  setup() {
    return {
      b: useBem(card_tile_style_module)
    };
  }
}));
;// ./src/components/molecules/card-tile/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/card-tile/component.vue




;
const card_tile_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_tile_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_1785faf1_ts_true_render]])

/* harmony default export */ const card_tile_component = (card_tile_component_exports_);
;// ./src/components/molecules/card-tile/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/document-file/component.vue?vue&type=template&id=7c8148a6&ts=true

function componentvue_type_template_id_7c8148a6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_icon_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon-action");
  const _component_dtg_progress = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-progress");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('file'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      name: "facture"
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('name'))
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.name), 3), !_ctx.readonly ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: 0
    }, [_ctx.errorMessage ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_icon_action, {
      key: 0,
      disabled: _ctx.disabled || _ctx.uploading,
      name: "reload",
      onClick: _cache[0] || (_cache[0] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => _ctx.onRetryClick(), ["stop"]))
    }, null, 8, ["disabled"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon_action, {
      disabled: _ctx.disabled || _ctx.uploading,
      name: "closeCircle",
      onClick: _cache[1] || (_cache[1] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => _ctx.onDeleteClick(), ["stop"]))
    }, null, 8, ["disabled"])], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), _ctx.uploading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_progress, {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('progress')),
      value: _ctx.uploadingProgress
    }, null, 8, ["class", "value"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.errorMessage ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('error'))
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.errorMessage), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 1
  }, 8, ["class"]);
}
;// ./src/components/molecules/document-file/component.vue?vue&type=template&id=7c8148a6&ts=true

;// ./src/components/molecules/document-file/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const document_file_style_module = ({"dtg-document-file":"lib_dtg-document-file_gRaZz","dtg-document-file__file":"lib_dtg-document-file__file_jw8JK","dtg-document-file__name":"lib_dtg-document-file__name_Ax8Hy","dtg-document-file__progress":"lib_dtg-document-file__progress_r_Kcn","dtg-document-file__error":"lib_dtg-document-file__error_zz72D"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/document-file/component.vue?vue&type=script&lang=ts







/* harmony default export */ const document_file_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(document_file_style_module),
  components: {
    DtgAction: action_component,
    DtgIcon: icon_component,
    DtgIconAction: icon_action_component,
    DtgProgress: progress_component
  },
  props: {
    name: {
      type: String,
      required: true
    },
    uploading: {
      type: Boolean,
      default: false
    },
    uploadingProgress: {
      type: Number,
      default: 0
    },
    errorMessage: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete', 'retry'],
  setup(props, {
    emit
  }) {
    function onDeleteClick() {
      emit('delete');
    }
    function onRetryClick() {
      emit('retry');
    }
    return {
      b: useBem(document_file_style_module),
      onDeleteClick,
      onRetryClick
    };
  }
}));
;// ./src/components/molecules/document-file/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/document-file/component.vue




;
const document_file_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(document_file_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_7c8148a6_ts_true_render]])

/* harmony default export */ const document_file_component = (document_file_component_exports_);
;// ./src/components/molecules/document-file/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/fieldset-header/component.vue?vue&type=template&id=e3fc906e&ts=true

function componentvue_type_template_id_e3fc906e_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  const _component_dtg_divider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-divider");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [_ctx.$slots.title ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_title, {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('title')),
    view: "4"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "title")]),
    _: 3
  }, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_divider, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('divider'))
  }, null, 8, ["class"]), _ctx.$slots.actions ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('actions'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "actions")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// ./src/components/molecules/fieldset-header/component.vue?vue&type=template&id=e3fc906e&ts=true

;// ./src/components/molecules/fieldset-header/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const fieldset_header_style_module = ({"dtg-fieldset-header":"lib_dtg-fieldset-header_Udc_D","dtg-fieldset-header__title":"lib_dtg-fieldset-header__title_b47A4","dtg-fieldset-header__divider":"lib_dtg-fieldset-header__divider_tdydW","dtg-fieldset-header__actions":"lib_dtg-fieldset-header__actions_yfcFH"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/fieldset-header/component.vue?vue&type=script&lang=ts





/* harmony default export */ const fieldset_header_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(fieldset_header_style_module),
  components: {
    DtgDivider: divider_component,
    DtgTitle: title_component
  },
  setup() {
    return {
      b: useBem(fieldset_header_style_module)
    };
  }
}));
;// ./src/components/molecules/fieldset-header/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/fieldset-header/component.vue




;
const fieldset_header_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(fieldset_header_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_e3fc906e_ts_true_render]])

/* harmony default export */ const fieldset_header_component = (fieldset_header_component_exports_);
;// ./src/components/molecules/fieldset-header/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/fieldset-spoiler/component.vue?vue&type=template&id=623cef41&ts=true

const componentvue_type_template_id_623cef41_ts_true_hoisted_1 = {
  key: 0
};
function componentvue_type_template_id_623cef41_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_divider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-divider");
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  const _component_dtg_transition_stack = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-transition-stack");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      opened: _ctx.openedInternal,
      reversed: _ctx.reversed
    }))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_action, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('action')),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onToggleClick())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('description-wrapper', {
        withDescription: _ctx.withDescription
      }))
    }, [_ctx.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('description'))
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_divider, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('divider'))
    }, null, 8, ["class"])], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('toggle'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('title'))
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 3), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('toggle-icon')),
      name: "chevron"
    }, null, 8, ["class"])], 2)]),
    _: 1
  }, 8, ["class"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_transition_stack, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.openedInternal ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", componentvue_type_template_id_623cef41_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content-inner'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 3
  })], 2);
}
;// ./src/components/molecules/fieldset-spoiler/component.vue?vue&type=template&id=623cef41&ts=true

;// ./src/components/molecules/fieldset-spoiler/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const fieldset_spoiler_style_module = ({"dtg-fieldset-header":"lib_dtg-fieldset-header_hyET4","dtg-fieldset-header__action":"lib_dtg-fieldset-header__action_UpCbj","dtg-fieldset-header__description-wrapper":"lib_dtg-fieldset-header__description-wrapper_TOg3A","dtg-fieldset-header__description-wrapper_withDescription":"lib_dtg-fieldset-header__description-wrapper_withDescription_fSyDb","dtg-fieldset-header__description":"lib_dtg-fieldset-header__description_ZP5WV","dtg-fieldset-header__divider":"lib_dtg-fieldset-header__divider_b2QvO","dtg-fieldset-header__toggle":"lib_dtg-fieldset-header__toggle_GrY5E","dtg-fieldset-header__toggle-icon":"lib_dtg-fieldset-header__toggle-icon_NlEfO","dtg-fieldset-header__title":"lib_dtg-fieldset-header__title_owPUG","dtg-fieldset-header_opened":"lib_dtg-fieldset-header_opened_McCV9","dtg-fieldset-header__content-inner":"lib_dtg-fieldset-header__content-inner_eZvIT","dtg-fieldset-header_reversed":"lib_dtg-fieldset-header_reversed_xKCWs"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/fieldset-spoiler/component.vue?vue&type=script&lang=ts







/* harmony default export */ const fieldset_spoiler_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(fieldset_spoiler_style_module),
  components: {
    DtgIcon: icon_component,
    DtgDivider: divider_component,
    DtgAction: action_component,
    DtgTransitionStack: transition_stack_component
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    opened: {
      type: Boolean,
      default: false
    },
    reversed: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:opened'],
  setup(props, {
    emit
  }) {
    const openedInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.opened);
    const withDescription = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => Boolean(props.description));
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.opened, value => {
      openedInternal.value = value;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(openedInternal, value => {
      if (props.opened !== value) {
        emit('update:opened', value);
      }
    });
    function onToggleClick() {
      openedInternal.value = !openedInternal.value;
    }
    return {
      b: useBem(fieldset_spoiler_style_module),
      openedInternal,
      withDescription,
      onToggleClick
    };
  }
}));
;// ./src/components/molecules/fieldset-spoiler/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/fieldset-spoiler/component.vue




;
const fieldset_spoiler_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(fieldset_spoiler_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_623cef41_ts_true_render]])

/* harmony default export */ const fieldset_spoiler_component = (fieldset_spoiler_component_exports_);
;// ./src/components/molecules/fieldset-spoiler/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/file-dropzone/component.vue?vue&type=template&id=594691d2&ts=true

const componentvue_type_template_id_594691d2_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("b", null, "parcourir", -1);
function componentvue_type_template_id_594691d2_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_spinner = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-spinner");
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-link");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  const _component_dtg_file_chooser = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-file-chooser");
  const _component_dtg_dropzone = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-dropzone");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_dropzone, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      fullwidth: _ctx.fullwidth
    })),
    accept: _ctx.accept,
    format: _ctx.format,
    max: _ctx.max,
    disabled: _ctx.disabled,
    onFiles: _cache[1] || (_cache[1] = $event => _ctx.onFiles($event))
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(({
      dropTarget,
      processing: processingDrop
    }) => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_file_chooser, {
      name: _ctx.name,
      accept: _ctx.accept,
      format: _ctx.format,
      max: _ctx.max,
      onFiles: _cache[0] || (_cache[0] = $event => _ctx.onFiles($event))
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(({
        openFileChooser,
        processing
      }) => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_action, {
        disabled: _ctx.disabled,
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('action', {
          dropTarget
        })),
        tabindex: "-1",
        onClick: $event => openFileChooser()
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [processing || processingDrop ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_spinner, {
          key: 0,
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('spinner'))
        }, null, 8, ["class"])) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_icon, {
          key: 1,
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('icon')),
          name: "download"
        }, null, 8, ["class"])), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
        }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Déposer le fichier ici ou "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [componentvue_type_template_id_594691d2_ts_true_hoisted_1]),
          _: 1
        })], 2)]),
        _: 2
      }, 1032, ["disabled", "class", "onClick"])]),
      _: 2
    }, 1032, ["name", "accept", "format", "max"])]),
    _: 1
  }, 8, ["class", "accept", "format", "max", "disabled"]);
}
;// ./src/components/molecules/file-dropzone/component.vue?vue&type=template&id=594691d2&ts=true

;// ./src/components/molecules/file-dropzone/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const file_dropzone_style_module = ({"dtg-file-dropzone_fullwidth":"lib_dtg-file-dropzone_fullwidth_icTg0","dtg-file-dropzone__action":"lib_dtg-file-dropzone__action_Faz0A","dtg-file-dropzone__action_dropTarget":"lib_dtg-file-dropzone__action_dropTarget_hiMJf","dtg-file-dropzone__spinner":"lib_dtg-file-dropzone__spinner_xlCYh","dtg-file-dropzone__icon":"lib_dtg-file-dropzone__icon_RKsZE","dtg-file-dropzone__text":"lib_dtg-file-dropzone__text_dsDze"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/file-dropzone/component.vue?vue&type=script&lang=ts











/* harmony default export */ const file_dropzone_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(file_dropzone_style_module),
  components: {
    DtgIcon: icon_component,
    DtgLink: link_component,
    DtgAction: action_component,
    DtgDropzone: dropzone_component,
    DtgFileChooser: file_chooser_component,
    DtgSpinner: spinner_component
  },
  props: {
    name: {
      type: String,
      required: true
    },
    format: {
      type: String,
      default: read_blob_.BlobFormat.dataUrl,
      validator: inRecord(read_blob_.BlobFormat)
    },
    accept: {
      type: String,
      default: null
    },
    max: {
      type: Number,
      default: Infinity
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullwidth: {
      type: Boolean,
      default: false
    }
  },
  emits: ['files'],
  setup(props, {
    emit
  }) {
    function onFiles(files) {
      emit('files', files);
    }
    return {
      b: useBem(file_dropzone_style_module),
      onFiles
    };
  }
}));
;// ./src/components/molecules/file-dropzone/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/file-dropzone/component.vue




;
const file_dropzone_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(file_dropzone_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_594691d2_ts_true_render]])

/* harmony default export */ const file_dropzone_component = (file_dropzone_component_exports_);
;// ./src/components/molecules/file-dropzone/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/map/component.vue?vue&type=template&id=9eaabc2e

function componentvue_type_template_id_9eaabc2e_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    ref: "map",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('map'))
  }, null, 2), _ctx.$slots.buttons ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("aside", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('buttons'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "buttons")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// ./src/components/molecules/map/component.vue?vue&type=template&id=9eaabc2e

// EXTERNAL MODULE: external "lodash/debounce"
var debounce_ = __webpack_require__(5257);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
// EXTERNAL MODULE: external "lodash/merge"
var merge_ = __webpack_require__(9374);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
;// ./src/composables/use-gmaps/utils/wrap-map-ready.ts
async function wrapMapReady(map, callback) {
  const container = map.getDiv();
  container.style.visibility = 'hidden';
  // Workaround for fitBounds not working until first map idle
  await nextMapIdle(map);
  // If callback returns false that means no actions were performed on the map that we need to wait for
  const shouldWait = await callback();
  // Workaround for initial fitBounds animation
  if (shouldWait) {
    await nextMapIdle(map);
  }
  container.style.visibility = '';
}
async function nextMapIdle(map) {
  return new Promise(resolve => {
    google.maps.event.addListenerOnce(map, 'idle', resolve);
  });
}
;// ../../node_modules/@googlemaps/js-api-loader/dist/index.esm.js
// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ID = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */
var LoaderStatus;
(function (LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */
class Loader {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */
    constructor({ apiKey, authReferrerPolicy, channel, client, id = DEFAULT_ID, language, libraries = [], mapIds, nonce, region, retries = 3, url = "https://maps.googleapis.com/maps/api/js", version, }) {
        this.CALLBACK = "__googleMapsCallback";
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || DEFAULT_ID; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if (Loader.instance) {
            if (!fastDeepEqual(this.options, Loader.instance.options)) {
                throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Loader.instance.options)}`);
            }
            return Loader.instance;
        }
        Loader.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy,
        };
    }
    get status() {
        if (this.errors.length) {
            return LoaderStatus.FAILURE;
        }
        if (this.done) {
            return LoaderStatus.SUCCESS;
        }
        if (this.loading) {
            return LoaderStatus.LOADING;
        }
        return LoaderStatus.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     */
    createUrl() {
        let url = this.url;
        url += `?callback=${this.CALLBACK}`;
        if (this.apiKey) {
            url += `&key=${this.apiKey}`;
        }
        if (this.channel) {
            url += `&channel=${this.channel}`;
        }
        if (this.client) {
            url += `&client=${this.client}`;
        }
        if (this.libraries.length > 0) {
            url += `&libraries=${this.libraries.join(",")}`;
        }
        if (this.language) {
            url += `&language=${this.language}`;
        }
        if (this.region) {
            url += `&region=${this.region}`;
        }
        if (this.version) {
            url += `&v=${this.version}`;
        }
        if (this.mapIds) {
            url += `&map_ids=${this.mapIds.join(",")}`;
        }
        if (this.authReferrerPolicy) {
            url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        }
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) {
            script.remove();
        }
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     */
    load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     */
    loadPromise() {
        return new Promise((resolve, reject) => {
            this.loadCallback((err) => {
                if (!err) {
                    resolve(window.google);
                }
                else {
                    reject(err.error);
                }
            });
        });
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     */
    loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */
    setScript() {
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const url = this.createUrl();
        const script = document.createElement("script");
        script.id = this.id;
        script.type = "text/javascript";
        script.src = url;
        script.onerror = this.loadErrorCallback.bind(this);
        script.defer = true;
        script.async = true;
        if (this.nonce) {
            script.nonce = this.nonce;
        }
        document.head.appendChild(script);
    }
    /**
     * Reset the loader state.
     */
    reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) {
            this.reset();
        }
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.log(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(() => {
                this.deleteScript();
                this.setScript();
            }, delay);
        }
        else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    setCallback() {
        window.__googleMapsCallback = this.callback.bind(this);
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb) => {
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) {
            this.callback();
        }
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader." +
                    "This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setCallback();
                this.setScript();
            }
        }
    }
}


//# sourceMappingURL=index.esm.js.map

;// ./src/composables/use-gmaps/use-gmaps-config.ts
let config = {
  apiKey: '',
  version: 'weekly',
  libraries: ['geometry', 'places'],
  language: 'fr',
  region: 'FR'
};
function getGmapsApiConfig() {
  return config;
}
function setGmapsApiConfig(newConfig) {
  config = {
    ...config,
    ...newConfig
  };
}
;// ./src/composables/use-gmaps/use-gmaps-api.ts



const {
  promise: gmapsPromise,
  resolve,
  reject
} = (0,deferred_.createDeferred)();
function useGmapsApi() {
  const config = getGmapsApiConfig();
  new Loader(config).load().then(google => {
    resolve(google.maps);
  }, reject);
  return {
    gmapsPromise
  };
}
async function getGmapsPromise() {
  return gmapsPromise;
}
;// ./src/composables/use-gmaps/consts.ts
const DEFAULT_POSITION = {
  lat: 48.864716,
  lng: 2.349014
};
const MAP_ID = '889b7f2cfa338388';
;// ./src/composables/use-gmaps/index.ts





;// ./src/components/molecules/map/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const map_style_module = ({"dtg-map":"lib_dtg-map_v9BzL","dtg-map__buttons":"lib_dtg-map__buttons_FpXZa","dtg-map__map":"lib_dtg-map__map_mPqYI"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/map/component.vue?vue&type=script&lang=js
/* @ts-nocheck written without typescript */
/* eslint-disable */







const defaultOptions = {
  disableDefaultUI: true,
  clickableIcons: false,
  mapId: '889b7f2cfa338388',
  gestureHandling: 'auto'
};
const defaultIcons = {};
const defaultZoomLevels = {
  min: 4,
  max: null,
  singleMarker: 14
};
const defaultLabel = {};
const BOUNDS_CHANGED_DEBOUNCE = 300;
/* harmony default export */ const componentvue_type_script_lang_js = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(map_style_module),
  props: {
    /* Reactive */
    options: {
      type: Object,
      default: () => ({})
    },
    center: {
      type: Object,
      required: true,
      validator: center => ['lat', 'lng'].every(prop => prop in center)
    },
    markers: {
      type: Array,
      required: true,
      validator: markers => markers.every(marker => ['lat', 'lng', 'id'].every(prop => prop in marker))
    },
    selectedId: {
      type: Number,
      default: null
    },
    zoom: {
      type: Number,
      default: 10
    },
    zoomControls: {
      type: Boolean,
      default: false
    },
    markersClickable: {
      type: Boolean,
      default: false
    },
    exactMatchDistance: {
      type: Number,
      default: 100
    },
    shown: {
      type: Boolean,
      default: true
    },
    /* Non-reactive */
    zoomLevels: {
      type: Object,
      default: () => ({})
    },
    icons: {
      type: Object,
      default: () => ({})
    },
    label: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:selected-id', 'update:zoom', 'interaction', 'selected-marker-in-view', 'click', 'bounds'],
  data() {
    return {
      selectedIdInternal: null
    };
  },
  computed: {
    selectedMarker() {
      const id = this.selectedIdInternal;
      return id && this._markers.find(marker => marker.dataId === id) || null;
    }
  },
  watch: {
    selectedIdInternal(value) {
      this.$emit('update:selected-id', value);
    }
  },
  created() {
    this._icons = merge_default()({}, defaultIcons, this.icons);
    this._label = {
      ...defaultLabel,
      ...this.label
    };
    this._zoomLevels = {
      ...defaultZoomLevels,
      ...this.zoomLevels
    };
    this._mapPromise = new Promise(resolve => {
      this._resolveMapPromise = resolve;
    });
    const {
      gmapsPromise
    } = useGmapsApi();
    this.gmapsPromise = gmapsPromise;
  },
  mounted() {
    this.gmapsPromise.then(gmaps => this.initGmap(gmaps)).then(map => this.initMap(map));
  },
  methods: {
    b: useBem(map_style_module),
    getMap() {
      return this._mapPromise;
    },
    getMergedOptions() {
      return {
        minZoom: this._zoomLevels.min,
        maxZoom: this._zoomLevels.max,
        ...defaultOptions,
        ...this.options
      };
    },
    async initGmap(gmaps) {
      this.gmaps = gmaps;
      return new Promise(resolve => {
        const unwatchMapRef = this.$watch(() => this.$refs.map, element => {
          if (element) {
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)().then(() => unwatchMapRef());
            resolve(this.createMap(element));
          }
        }, {
          immediate: true
        });
      });
    },
    createMap(element) {
      const options = {
        ...this.getMergedOptions(),
        center: this.center
      };
      return new this.gmaps.Map(element, options);
    },
    initMap(map) {
      this.map = map;
      this._resolveMapPromise(map);
      this._markers = [];
      this.resetViewport();
      this.initWatch();
      this.initEvents();
      this.setMarkers(this.markers);
      this.selectMarkerById(this.selectedId);
    },
    initWatch() {
      this.$watch('options', () => this.map.setOptions(this.getMergedOptions()));
      this.$watch('markers', markers => {
        this.setMarkers(markers);
      });
      this.$watch('center', () => {
        this.updateCenter();
      });
      this.$watch('zoom', () => {
        this.updateZoom();
      });
      this.$watch('shown', () => {
        this.resetViewport();
      });
      this.$watch('markersClickable', () => {
        this.setMarkers(this.markers);
      });
      this.$watch('selectedId', id => {
        this.selectMarkerById(id);
      });
    },
    initEvents() {
      this.map.addListener('bounds_changed', debounce_default()(() => {
        this.onBoundsChanged();
      }, BOUNDS_CHANGED_DEBOUNCE));
      this.$emit('bounds', this.map.getBounds());
      this.map.addListener('click', event => {
        const position = event.latLng;
        this.onMapClick({
          lat: position.lat(),
          lng: position.lng()
        });
      });
      this.map.addListener('zoom_changed', () => {
        this.onZoomChanged();
      });
      this.map.addListener('click', () => this.$emit('interaction'));
      this.map.addListener('center_changed', () => this.$emit('interaction'));
    },
    setMarkers(markers) {
      this.clearMarkers();
      markers.forEach(options => {
        this.addMarker(options);
      });
      this.updateInViewMarkers();
    },
    addMarker(options) {
      const position = new this.gmaps.LatLng(options);
      const marker = this.createMarker(position, options);
      if (this.markersClickable) {
        this.addMarkerListeners(marker);
      }
      if (options.label) {
        this.addMarkerLabel(marker, options.label);
      }
      this._markers.push(marker);
      marker.setMap(this.map);
    },
    createMarker(position, options) {
      const {
        disabled,
        icon: iconKey = disabled ? 'disabled' : 'default',
        iconActive: iconKeyActive = 'active',
        id
      } = options;
      const clickable = this.markersClickable;
      const cursor = disabled ? 'default' : 'pointer';
      const icon = this.createMarkerIcon(iconKey);
      const marker = new this.gmaps.Marker({
        position,
        clickable,
        cursor,
        icon
      });
      Object.assign(marker, {
        disabled,
        iconKey,
        iconKeyDefault: iconKey,
        iconKeyActive,
        dataId: id,
        data: options
      });
      return marker;
    },
    createMarkerIcon(iconKey, hasLabel) {
      const icon = this._icons[iconKey];
      if (!icon) {
        return undefined;
      }
      if (typeof icon === 'string') {
        return icon;
      }
      const origin = hasLabel ? icon.originWithLabel : icon.origin;
      return {
        url: icon.url,
        labelOrigin: new this.gmaps.Point(...origin),
        scaledSize: new this.gmaps.Size(...icon.size)
      };
    },
    addMarkerListeners(marker) {
      marker.addListener('click', () => {
        this.onMarkerClick(marker);
      });
      marker.addListener('mouseover', () => {
        this.onMarkerMouseover(marker);
      });
      marker.addListener('mouseout', () => {
        this.onMarkerMouseout(marker);
      });
    },
    addMarkerLabel(marker, text) {
      marker.hasLabel = true;
      const label = {
        ...this._label,
        text
      };
      marker.setLabel(label);
      this.setMarkerIcon(marker, marker.iconKeyDefault);
    },
    clearMarkers() {
      this._markers.forEach(marker => marker.setMap(null));
      this._markers.length = 0;
      this.updateInViewMarkers();
    },
    isMarkerInView(marker) {
      const bounds = this.map.getBounds();
      const position = marker.getPosition();
      return bounds ? bounds.contains(position) : false;
    },
    selectMarker(marker) {
      this.focusMarker(marker);
      if (this.selectedMarker === marker) {
        return;
      }
      this.deselectMarker();
      this.setMarkerIcon(marker, marker.iconKeyActive);
      marker.isSelected = true;
      this.selectedIdInternal = marker.dataId;
      this.updateInViewMarkers();
    },
    focusMarker(marker) {
      if (this.map.getZoom() < this._zoomLevels.singleMarker) {
        this.map.setZoom(this._zoomLevels.singleMarker);
      }
      if (!this.map.getCenter().equals(marker.getPosition())) {
        this.map.panTo(marker.getPosition());
      }
    },
    selectMarkerById(id) {
      if (id === null) {
        this.deselectMarker();
        return;
      }
      if (this.selectedIdInternal === id) {
        return;
      }
      const marker = this._markers.find(m => m.dataId === id);
      if (marker) {
        this.selectMarker(marker);
      } else {
        this.deselectMarker();
      }
    },
    refocusSelectedMarker() {
      if (this.selectedMarker) {
        this.focusMarker(this.selectedMarker);
      }
    },
    deselectMarker() {
      const marker = this.selectedMarker;
      if (!marker) {
        return;
      }
      this.setMarkerIcon(marker, marker.iconKeyDefault);
      marker.isSelected = false;
      this.selectedIdInternal = null;
    },
    setMarkerIcon(marker, icon) {
      if (marker.iconKey === icon && !marker.hasLabel) {
        return;
      }
      marker.iconKey = icon;
      const iconConfig = this.createMarkerIcon(icon, marker.hasLabel);
      if (iconConfig) {
        marker.setIcon(iconConfig);
      }
    },
    onMarkerClick(marker) {
      this.$emit('interaction');
      if (!marker.disabled) {
        this.selectMarker(marker);
      }
    },
    onMarkerMouseover(marker) {
      if (marker === this.selectedMarker || marker.disabled) {
        return;
      }
      this.setMarkerIcon(marker, marker.iconKeyActive);
    },
    onMarkerMouseout(marker) {
      if (marker === this.selectedMarker || marker.disabled) {
        return;
      }
      this.setMarkerIcon(marker, marker.iconKeyDefault);
    },
    onMapClick(position) {
      this.deselectMarker();
      this.$emit('click', position);
    },
    onBoundsChanged() {
      this.updateInViewMarkers();
      this.$emit('bounds', this.map.getBounds());
    },
    onZoomChanged() {
      const newZoom = this.map.getZoom();
      this.$emit('update:zoom', newZoom);
    },
    updateInViewMarkers() {
      const selectedMarkerInView = this.selectedMarker ? this.isMarkerInView(this.selectedMarker) : false;
      this.$emit('selected-marker-in-view', selectedMarkerInView);
    },
    zoomIn() {
      this.map.setZoom(this.map.getZoom() + 1);
    },
    zoomOut() {
      this.map.setZoom(this.map.getZoom() - 1);
    },
    resetViewportLazy() {
      if (this.zoom === this.lastZoom && this.center.lat === this.lastCenter.lat && this.center.lng === this.lastCenter.lng) {
        return;
      }
      this.resetViewport();
    },
    resetViewport() {
      this.lastCenter = {
        ...this.center
      };
      const newCenter = this.center;
      const newZoom = this.updateLastZoom();
      this.map.setZoom(newZoom);
      this.map.setCenter(newCenter);
    },
    updateCenter() {
      const newCenter = this.center;
      this.map.setCenter(newCenter);
    },
    updateZoom() {
      const newZoom = this.updateLastZoom();
      this.map.setZoom(newZoom);
    },
    updateLastZoom() {
      this.lastZoom = this.shown ? this.zoom : this.map.getZoom();
      return this.shown ? this.zoom : this.lastZoom;
    }
  }
}));
;// ./src/components/molecules/map/component.vue?vue&type=script&lang=js
 
;// ./src/components/molecules/map/component.vue




;
const map_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(componentvue_type_script_lang_js, [['render',componentvue_type_template_id_9eaabc2e_render]])

/* harmony default export */ const map_component = (map_component_exports_);
;// ./src/components/molecules/map/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/modal-content/component.vue?vue&type=template&id=012a9e7c&ts=true

function componentvue_type_template_id_012a9e7c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_button_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button-base");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [!_ctx.noHeader ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row_col, {
      key: 0
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('header'))
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('title')),
        view: _ctx.titleView
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "title")]),
        _: 3
      }, 8, ["class", "view"]), !_ctx.noClose ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_button_base, {
        key: 0,
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('close')),
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onCloseClick())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('close-icon')),
          name: "closeCircle"
        }, null, 8, ["class"])]),
        _: 1
      }, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)]),
      _: 3
    })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content'))
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content-inner'))
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["class"])]),
      _: 3
    }, 8, ["class"]), _ctx.$slots.actions ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row, {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('actions-inner', {
        align: _ctx.actionsAlign
      }))
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "actions")]),
      _: 3
    }, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 3
  })], 2);
}
;// ./src/components/molecules/modal-content/component.vue?vue&type=template&id=012a9e7c&ts=true

;// ./src/components/molecules/modal-content/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_content_style_module = ({"dtg-modal-content":"lib_dtg-modal-content_mq9gx","dtg-modal-content__header":"lib_dtg-modal-content__header_bTj0i","dtg-modal-content__title":"lib_dtg-modal-content__title_Gve2I","dtg-modal-content__close":"lib_dtg-modal-content__close_YQ6qb","dtg-modal-content__close-icon":"lib_dtg-modal-content__close-icon_PryQL","dtg-modal-content__content":"lib_dtg-modal-content__content_KCDJ7","dtg-modal-content__content-inner":"lib_dtg-modal-content__content-inner_dPxo9","dtg-modal-content__actions-inner_align_left":"lib_dtg-modal-content__actions-inner_align_left_s6erp","dtg-modal-content__actions-inner_align_right":"lib_dtg-modal-content__actions-inner_align_right_t27Ot","dtg-modal-content__actions-inner_align_center":"lib_dtg-modal-content__actions-inner_align_center_Vzx_u","dtg-modal-content__actions-inner_align_space-between":"lib_dtg-modal-content__actions-inner_align_space-between_XEWzX"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/modal-content/component.vue?vue&type=script&lang=ts









/* harmony default export */ const modal_content_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(modal_content_style_module),
  components: {
    DtgTitle: title_component,
    DtgButtonBase: component,
    DtgIcon: icon_component,
    DtgGrid: grid,
    DtgRowCol: row_col,
    DtgRow: row,
    DtgCol: col
  },
  props: {
    noHeader: {
      type: Boolean,
      default: false
    },
    noClose: {
      type: Boolean,
      default: false
    },
    titleView: {
      type: [String, Number],
      default: 3
    },
    actionsAlign: {
      type: String,
      default: 'right',
      validator: inArray(['left', 'center', 'right', 'space-between'])
    }
  },
  emits: ['willClose', 'didClose'],
  setup(_, {
    emit
  }) {
    const overlay = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const overlayPromise = useOverlayElement();
    void overlayPromise.then(overlayToSet => {
      void overlayToSet.onWillDismiss().then(() => {
        emit('willClose');
      });
      void overlayToSet.onDidDismiss().then(() => {
        emit('didClose');
      });
      overlay.value = overlayToSet;
    });
    function onCloseClick() {
      void overlay.value?.dismiss();
    }
    return {
      b: useBem(modal_content_style_module),
      onCloseClick
    };
  }
}));
;// ./src/components/molecules/modal-content/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/modal-content/component.vue




;
const modal_content_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(modal_content_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_012a9e7c_ts_true_render]])

/* harmony default export */ const modal_content_component = (modal_content_component_exports_);
;// ./src/components/molecules/modal-content/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/modal-content-scrollable/component.vue?vue&type=template&id=f5e5e48c&ts=true

function componentvue_type_template_id_f5e5e48c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2);
}
;// ./src/components/molecules/modal-content-scrollable/component.vue?vue&type=template&id=f5e5e48c&ts=true

;// ./src/components/molecules/modal-content-scrollable/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_content_scrollable_style_module = ({"dtg-modal-content-scrollable":"lib_dtg-modal-content-scrollable_VKkMB"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/modal-content-scrollable/component.vue?vue&type=script&lang=ts



/* harmony default export */ const modal_content_scrollable_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(modal_content_scrollable_style_module),
  setup() {
    return {
      b: useBem(modal_content_scrollable_style_module)
    };
  }
}));
;// ./src/components/molecules/modal-content-scrollable/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/modal-content-scrollable/component.vue




;
const modal_content_scrollable_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(modal_content_scrollable_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_f5e5e48c_ts_true_render]])

/* harmony default export */ const modal_content_scrollable_component = (modal_content_scrollable_component_exports_);
;// ./src/components/molecules/modal-content-scrollable/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/obligation-filter/component.vue?vue&type=template&id=a5daaa2e&ts=true

function componentvue_type_template_id_a5daaa2e_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_divider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-divider");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_grid, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.options, option => {
        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
          key: option.id,
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('col')),
          size: "auto"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
            view: _ctx.getOptionView(option.id),
            marked: _ctx.getOptionValid(option.id),
            "mark-view": "warning",
            onClick: $event => _ctx.onOptionClick(option.id)
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(option.value), 1)]),
            _: 2
          }, 1032, ["view", "marked", "onClick"]), option.id === null ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_divider, {
            key: 0,
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('divider')),
            view: "vertical"
          }, null, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
          _: 2
        }, 1032, ["class"]);
      }), 128))]),
      _: 1
    })]),
    _: 1
  });
}
;// ./src/components/molecules/obligation-filter/component.vue?vue&type=template&id=a5daaa2e&ts=true

// EXTERNAL MODULE: external "dtg-firebase/modules/legal-obligation"
var legal_obligation_ = __webpack_require__(1152);
;// ./src/components/molecules/obligation-filter/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const obligation_filter_style_module = ({"dtg-obligation-filter__col":"lib_dtg-obligation-filter__col_xreWJ","dtg-obligation-filter__divider":"lib_dtg-obligation-filter__divider_EJhE6"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/obligation-filter/component.vue?vue&type=script&lang=ts









/* harmony default export */ const obligation_filter_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(obligation_filter_style_module),
  components: {
    DtgGrid: grid,
    DtgRow: row,
    DtgCol: col,
    DtgButton: button_component,
    DtgDivider: divider_component
  },
  props: {
    modelValue: {
      type: String,
      default: null,
      validator: inArray([...(0,object_.objValues)(legal_obligation_.LegalObligationType), null])
    },
    invalid: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const options = [{
      id: null,
      value: 'Toutes'
    }, {
      id: legal_obligation_.LegalObligationType.mobileApp,
      value: 'Terrain'
    }];
    function getOptionView(type) {
      return props.modelValue === type ? DtgButtonView.inverted : DtgButtonView.regular;
    }
    function getOptionValid(type) {
      return type === null ? props.invalid.length > 0 : props.invalid.includes(type);
    }
    function onOptionClick(type) {
      emit('update:modelValue', type);
    }
    return {
      b: useBem(obligation_filter_style_module),
      options,
      onOptionClick,
      getOptionView,
      getOptionValid
    };
  }
}));
;// ./src/components/molecules/obligation-filter/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/obligation-filter/component.vue




;
const obligation_filter_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(obligation_filter_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_a5daaa2e_ts_true_render]])

/* harmony default export */ const obligation_filter_component = (obligation_filter_component_exports_);
;// ./src/components/molecules/obligation-filter/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/parcels-map/component.vue?vue&type=template&id=bd93cbb4&ts=true

function componentvue_type_template_id_bd93cbb4_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_parcels_map_map = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-parcels-map-map");
  return _ctx.active && _ctx.gmapsRef ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_parcels_map_map, {
    key: 0,
    gmaps: _ctx.gmapsRef,
    offline: _ctx.offline
  }, null, 8, ["gmaps", "offline"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// ./src/components/molecules/parcels-map/component.vue?vue&type=template&id=bd93cbb4&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/parcels-map/elems/map/component.vue?vue&type=template&id=0dc0cada&ts=true

function componentvue_type_template_id_0dc0cada_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_info_box = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-info-box");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [_ctx.offline ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_info_box, {
    key: 0,
    color: "notice",
    view: "filled"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" La carte n'est pas disponible hors ligne ")]),
    _: 1
  })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    ref: "map",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('map'))
  }, null, 2), _ctx.$slots.actions ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('actions'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "actions")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64))], 2);
}
;// ./src/components/molecules/parcels-map/elems/map/component.vue?vue&type=template&id=0dc0cada&ts=true

// EXTERNAL MODULE: external "@deck.gl/geo-layers"
var geo_layers_ = __webpack_require__(8529);
// EXTERNAL MODULE: external "@deck.gl/google-maps"
var google_maps_ = __webpack_require__(7684);
;// ../api/classes/ApiModule.ts
function ApiModule_defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class ApiModule {
  constructor() {
    ApiModule_defineProperty(this, "api", void 0);
    ApiModule_defineProperty(this, "logger", void 0);
  }
  setApi(api) {
    this.api = api;
  }
  setLogger(logger) {
    this.logger = logger;
  }
  async throwIfErrors(promise) {
    return this.api.throwIfErrors(promise);
  }
  static all(responses) {
    const error = this.combineErrors(responses);
    if (error.length === 0) {
      return {
        ok: true,
        result: null
      };
    }
    return {
      ok: false,
      error
    };
  }
  static combineErrors(responses) {
    return responses.flatMap(response => response.ok ? null : response.error).filter(truthy_.truthy);
  }
}
;// ../api/modules/parcel/builders.ts
function buildParcelDataFromCadastralEntry({
  entry,
  gmaps,
  position,
  onError
}) {
  const {
    cadastre_id: cadastralId,
    cadastre_type: cadastreType,
    feature_id: featureId,
    geom_centroid: geomCentroid,
    city_id: cityId,
    extra,
    name,
    category,
    value,
    layerName,
    order,
    id
  } = entry.properties;
  const bounds = new gmaps.LatLngBounds();
  entry.geometry.coordinates.flat().map(buildLatLngLiteral).forEach(point => bounds.extend(point));
  const center = bounds.getCenter();
  const ne = bounds.getNorthEast();
  const sw = bounds.getSouthWest();
  const coordinates = {
    center: {
      lat: center.lat(),
      lng: center.lng()
    },
    bounds: [{
      lat: ne.lat(),
      lng: ne.lng()
    }, {
      lat: sw.lat(),
      lng: sw.lng()
    }]
  };
  try {
    const {
      number,
      prefix,
      section
    } = JSON.parse(entry.properties.extra);
    return {
      createdTimestamp: Date.now(),
      meta: {
        coordinates,
        position: position ?? coordinates.center,
        cadastralId,
        cadastreType,
        featureId,
        extra,
        name,
        geomCentroid,
        cityId,
        category,
        value,
        layerName,
        order,
        id
      },
      number,
      prefix,
      section,
      valid: true
    };
  } catch {
    onError(buildParseError(entry));
    // use cadastral_id to guess parcel's fields
    const number = cadastralId.slice(-4);
    const section = cadastralId.replaceAll(/\d/g, '');
    return {
      createdTimestamp: Date.now(),
      meta: {
        coordinates,
        position: position ?? coordinates.center,
        cadastralId,
        cadastreType,
        featureId,
        extra,
        name,
        geomCentroid,
        cityId,
        category,
        value,
        layerName,
        order,
        id
      },
      section,
      number,
      prefix: '',
      valid: true
    };
  }
}
function buildLatLngLiteral(coordinates) {
  const [lng, lat] = coordinates;
  return {
    lat,
    lng
  };
}
function buildParseError(entry) {
  const {
    cadastre_type: type,
    cadastre_id: id,
    extra
  } = entry.properties;
  const message = `
        Cadastral entry parse error.
        Tried to parse ${type} ${id}: ${extra}`;
  return new Error(message);
}
;// ../api/modules/parcel/routes.ts
const API_PARCEL_FIND_ROUTE = '/api/parcel';
;// ../api/modules/parcel/module.ts
function module_defineProperty(e, r, t) { return (r = module_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function module_toPropertyKey(t) { var i = module_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function module_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class ApiParcelModule extends ApiModule {
  constructor(gmaps) {
    super();
    module_defineProperty(this, "gmaps", void 0);
    this.gmaps = gmaps;
  }
  async findParcel(params) {
    const response = await this.api.get(API_PARCEL_FIND_ROUTE, {
      params,
      raw: {
        response: true
      }
    });
    if (response.ok) {
      return {
        ok: true,
        result: buildParcelDataFromCadastralEntry({
          entry: response.result,
          gmaps: await this.gmaps,
          onError: this.logger
        })
      };
    }
    return response;
  }
}
;// ../api/modules/parcel/types.ts
var ApiParcelFindErrorCodes;
(function (ApiParcelFindErrorCodes) {
  ApiParcelFindErrorCodes["notFound"] = "parcel/not-found";
})(ApiParcelFindErrorCodes || (ApiParcelFindErrorCodes = {}));
;// ../api/modules/parcel/index.ts




// EXTERNAL MODULE: external "@deck.gl/core"
var external_deck_gl_core_ = __webpack_require__(5360);
// EXTERNAL MODULE: external "@deck.gl/layers"
var layers_ = __webpack_require__(9241);
;// ../../node_modules/@turf/helpers/dist/es/index.js
/**
 * @module helpers
 */
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */
var earthRadius = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 *
 * @memberof helpers
 * @type {Object}
 */
var factors = {
    centimeters: earthRadius * 100,
    centimetres: earthRadius * 100,
    degrees: earthRadius / 111325,
    feet: earthRadius * 3.28084,
    inches: earthRadius * 39.37,
    kilometers: earthRadius / 1000,
    kilometres: earthRadius / 1000,
    meters: earthRadius,
    metres: earthRadius,
    miles: earthRadius / 1609.344,
    millimeters: earthRadius * 1000,
    millimetres: earthRadius * 1000,
    nauticalmiles: earthRadius / 1852,
    radians: 1,
    yards: earthRadius * 1.0936,
};
/**
 * Units of measurement factors based on 1 meter.
 *
 * @memberof helpers
 * @type {Object}
 */
var unitsFactors = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 1 / 1000,
    kilometres: 1 / 1000,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / earthRadius,
    yards: 1.0936133,
};
/**
 * Area of measurement factors based on 1 square meter.
 *
 * @memberof helpers
 * @type {Object}
 */
var areaFactors = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046,
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */
function feature(geom, properties, options) {
    if (options === void 0) { options = {}; }
    var feat = { type: "Feature" };
    if (options.id === 0 || options.id) {
        feat.id = options.id;
    }
    if (options.bbox) {
        feat.bbox = options.bbox;
    }
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<any>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = "Point";
 * var coordinates = [110, 50];
 * var geometry = turf.geometry(type, coordinates);
 * // => geometry
 */
function geometry(type, coordinates, _options) {
    if (_options === void 0) { _options = {}; }
    switch (type) {
        case "Point":
            return point(coordinates).geometry;
        case "LineString":
            return lineString(coordinates).geometry;
        case "Polygon":
            return polygon(coordinates).geometry;
        case "MultiPoint":
            return multiPoint(coordinates).geometry;
        case "MultiLineString":
            return multiLineString(coordinates).geometry;
        case "MultiPolygon":
            return multiPolygon(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */
function point(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    if (!coordinates) {
        throw new Error("coordinates is required");
    }
    if (!Array.isArray(coordinates)) {
        throw new Error("coordinates must be an Array");
    }
    if (coordinates.length < 2) {
        throw new Error("coordinates must be at least 2 numbers long");
    }
    if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) {
        throw new Error("coordinates must contain numbers");
    }
    var geom = {
        type: "Point",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */
function points(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return point(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */
function polygon(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
        var ring = coordinates_1[_i];
        if (ring.length < 4) {
            throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        }
        for (var j = 0; j < ring[ring.length - 1].length; j++) {
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) {
                throw new Error("First and last Position are not equivalent.");
            }
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */
function polygons(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return polygon(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */
function lineString(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    if (coordinates.length < 2) {
        throw new Error("coordinates must be an array of two or more positions");
    }
    var geom = {
        type: "LineString",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */
function lineStrings(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return lineString(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */
function featureCollection(features, options) {
    if (options === void 0) { options = {}; }
    var fc = { type: "FeatureCollection" };
    if (options.id) {
        fc.id = options.id;
    }
    if (options.bbox) {
        fc.bbox = options.bbox;
    }
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */
function multiLineString(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */
function multiPoint(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */
function multiPolygon(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = turf.geometry("Point", [100, 0]);
 * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
 * var collection = turf.geometryCollection([pt, line]);
 *
 * // => collection
 */
function geometryCollection(geometries, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "GeometryCollection",
        geometries: geometries,
    };
    return feature(geom, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */
function round(num, precision) {
    if (precision === void 0) { precision = 0; }
    if (precision && !(precision >= 0)) {
        throw new Error("precision must be a positive number");
    }
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} distance
 */
function radiansToLength(radians, units) {
    if (units === void 0) { units = "kilometers"; }
    var factor = factors[units];
    if (!factor) {
        throw new Error(units + " units is invalid");
    }
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} radians
 */
function lengthToRadians(distance, units) {
    if (units === void 0) { units = "kilometers"; }
    var factor = factors[units];
    if (!factor) {
        throw new Error(units + " units is invalid");
    }
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} degrees
 */
function lengthToDegrees(distance, units) {
    return radiansToDegrees(lengthToRadians(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */
function bearingToAzimuth(bearing) {
    var angle = bearing % 360;
    if (angle < 0) {
        angle += 360;
    }
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */
function radiansToDegrees(radians) {
    var degrees = radians % (2 * Math.PI);
    return (degrees * 180) / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */
function degreesToRadians(degrees) {
    var radians = degrees % 360;
    return (radians * Math.PI) / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {Units} [originalUnit="kilometers"] of the length
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted length
 */
function convertLength(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) { originalUnit = "kilometers"; }
    if (finalUnit === void 0) { finalUnit = "kilometers"; }
    if (!(length >= 0)) {
        throw new Error("length must be a positive number");
    }
    return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches, hectares
 * @param {number} area to be converted
 * @param {Units} [originalUnit="meters"] of the distance
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted area
 */
function convertArea(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) { originalUnit = "meters"; }
    if (finalUnit === void 0) { finalUnit = "kilometers"; }
    if (!(area >= 0)) {
        throw new Error("area must be a positive number");
    }
    var startFactor = areaFactors[originalUnit];
    if (!startFactor) {
        throw new Error("invalid original units");
    }
    var finalFactor = areaFactors[finalUnit];
    if (!finalFactor) {
        throw new Error("invalid final units");
    }
    return (area / startFactor) * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */
function isNumber(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */
function isObject(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */
function validateBBox(bbox) {
    if (!bbox) {
        throw new Error("bbox is required");
    }
    if (!Array.isArray(bbox)) {
        throw new Error("bbox must be an Array");
    }
    if (bbox.length !== 4 && bbox.length !== 6) {
        throw new Error("bbox must be an Array of 4 or 6 numbers");
    }
    bbox.forEach(function (num) {
        if (!isNumber(num)) {
            throw new Error("bbox must only contain numbers");
        }
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */
function validateId(id) {
    if (!id) {
        throw new Error("id is required");
    }
    if (["string", "number"].indexOf(typeof id) === -1) {
        throw new Error("id must be a number or a string");
    }
}

;// ../../node_modules/@turf/meta/dist/es/index.js
/* unused harmony import specifier */ var es_lineString;
/* unused harmony import specifier */ var es_isObject;
/* unused harmony import specifier */ var es_point;


/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */

/**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */
function coordEach(geojson, callback, excludeWrapCoord) {
  // Handles null Geometry -- Skips this GeoJSON
  if (geojson === null) return;
  var j,
    k,
    l,
    geometry,
    stopG,
    coords,
    geometryMaybeCollection,
    wrapShrink = 0,
    coordIndex = 0,
    isGeometryCollection,
    type = geojson.type,
    isFeatureCollection = type === "FeatureCollection",
    isFeature = type === "Feature",
    stop = isFeatureCollection ? geojson.features.length : 1;

  // This logic may look a little weird. The reason why it is that way
  // is because it's trying to be fast. GeoJSON supports multiple kinds
  // of objects at its root: FeatureCollection, Features, Geometries.
  // This function has the responsibility of handling all of them, and that
  // means that some of the `for` loops you see below actually just don't apply
  // to certain inputs. For instance, if you give this just a
  // Point geometry, then both loops are short-circuited and all we do
  // is gradually rename the input until it's called 'geometry'.
  //
  // This also aims to allocate as few resources as possible: just a
  // few numbers and booleans, rather than any temporary arrays as would
  // be required with the normalization approach.
  for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
    geometryMaybeCollection = isFeatureCollection
      ? geojson.features[featureIndex].geometry
      : isFeature
      ? geojson.geometry
      : geojson;
    isGeometryCollection = geometryMaybeCollection
      ? geometryMaybeCollection.type === "GeometryCollection"
      : false;
    stopG = isGeometryCollection
      ? geometryMaybeCollection.geometries.length
      : 1;

    for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
      var multiFeatureIndex = 0;
      var geometryIndex = 0;
      geometry = isGeometryCollection
        ? geometryMaybeCollection.geometries[geomIndex]
        : geometryMaybeCollection;

      // Handles null Geometry -- Skips this geometry
      if (geometry === null) continue;
      coords = geometry.coordinates;
      var geomType = geometry.type;

      wrapShrink =
        excludeWrapCoord &&
        (geomType === "Polygon" || geomType === "MultiPolygon")
          ? 1
          : 0;

      switch (geomType) {
        case null:
          break;
        case "Point":
          if (
            callback(
              coords,
              coordIndex,
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false
          )
            return false;
          coordIndex++;
          multiFeatureIndex++;
          break;
        case "LineString":
        case "MultiPoint":
          for (j = 0; j < coords.length; j++) {
            if (
              callback(
                coords[j],
                coordIndex,
                featureIndex,
                multiFeatureIndex,
                geometryIndex
              ) === false
            )
              return false;
            coordIndex++;
            if (geomType === "MultiPoint") multiFeatureIndex++;
          }
          if (geomType === "LineString") multiFeatureIndex++;
          break;
        case "Polygon":
        case "MultiLineString":
          for (j = 0; j < coords.length; j++) {
            for (k = 0; k < coords[j].length - wrapShrink; k++) {
              if (
                callback(
                  coords[j][k],
                  coordIndex,
                  featureIndex,
                  multiFeatureIndex,
                  geometryIndex
                ) === false
              )
                return false;
              coordIndex++;
            }
            if (geomType === "MultiLineString") multiFeatureIndex++;
            if (geomType === "Polygon") geometryIndex++;
          }
          if (geomType === "Polygon") multiFeatureIndex++;
          break;
        case "MultiPolygon":
          for (j = 0; j < coords.length; j++) {
            geometryIndex = 0;
            for (k = 0; k < coords[j].length; k++) {
              for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
                if (
                  callback(
                    coords[j][k][l],
                    coordIndex,
                    featureIndex,
                    multiFeatureIndex,
                    geometryIndex
                  ) === false
                )
                  return false;
                coordIndex++;
              }
              geometryIndex++;
            }
            multiFeatureIndex++;
          }
          break;
        case "GeometryCollection":
          for (j = 0; j < geometry.geometries.length; j++)
            if (
              coordEach(geometry.geometries[j], callback, excludeWrapCoord) ===
              false
            )
              return false;
          break;
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
  }
}

/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */

/**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */
function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
  var previousValue = initialValue;
  coordEach(
    geojson,
    function (
      currentCoord,
      coordIndex,
      featureIndex,
      multiFeatureIndex,
      geometryIndex
    ) {
      if (coordIndex === 0 && initialValue === undefined)
        previousValue = currentCoord;
      else
        previousValue = callback(
          previousValue,
          currentCoord,
          coordIndex,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    },
    excludeWrapCoord
  );
  return previousValue;
}

/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */
function propEach(geojson, callback) {
  var i;
  switch (geojson.type) {
    case "FeatureCollection":
      for (i = 0; i < geojson.features.length; i++) {
        if (callback(geojson.features[i].properties, i) === false) break;
      }
      break;
    case "Feature":
      callback(geojson.properties, 0);
      break;
  }
}

/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */
function propReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  propEach(geojson, function (currentProperties, featureIndex) {
    if (featureIndex === 0 && initialValue === undefined)
      previousValue = currentProperties;
    else
      previousValue = callback(previousValue, currentProperties, featureIndex);
  });
  return previousValue;
}

/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */
function featureEach(geojson, callback) {
  if (geojson.type === "Feature") {
    callback(geojson, 0);
  } else if (geojson.type === "FeatureCollection") {
    for (var i = 0; i < geojson.features.length; i++) {
      if (callback(geojson.features[i], i) === false) break;
    }
  }
}

/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */
function featureReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  featureEach(geojson, function (currentFeature, featureIndex) {
    if (featureIndex === 0 && initialValue === undefined)
      previousValue = currentFeature;
    else previousValue = callback(previousValue, currentFeature, featureIndex);
  });
  return previousValue;
}

/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */
function coordAll(geojson) {
  var coords = [];
  coordEach(geojson, function (coord) {
    coords.push(coord);
  });
  return coords;
}

/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */

/**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */
function geomEach(geojson, callback) {
  var i,
    j,
    g,
    geometry,
    stopG,
    geometryMaybeCollection,
    isGeometryCollection,
    featureProperties,
    featureBBox,
    featureId,
    featureIndex = 0,
    isFeatureCollection = geojson.type === "FeatureCollection",
    isFeature = geojson.type === "Feature",
    stop = isFeatureCollection ? geojson.features.length : 1;

  // This logic may look a little weird. The reason why it is that way
  // is because it's trying to be fast. GeoJSON supports multiple kinds
  // of objects at its root: FeatureCollection, Features, Geometries.
  // This function has the responsibility of handling all of them, and that
  // means that some of the `for` loops you see below actually just don't apply
  // to certain inputs. For instance, if you give this just a
  // Point geometry, then both loops are short-circuited and all we do
  // is gradually rename the input until it's called 'geometry'.
  //
  // This also aims to allocate as few resources as possible: just a
  // few numbers and booleans, rather than any temporary arrays as would
  // be required with the normalization approach.
  for (i = 0; i < stop; i++) {
    geometryMaybeCollection = isFeatureCollection
      ? geojson.features[i].geometry
      : isFeature
      ? geojson.geometry
      : geojson;
    featureProperties = isFeatureCollection
      ? geojson.features[i].properties
      : isFeature
      ? geojson.properties
      : {};
    featureBBox = isFeatureCollection
      ? geojson.features[i].bbox
      : isFeature
      ? geojson.bbox
      : undefined;
    featureId = isFeatureCollection
      ? geojson.features[i].id
      : isFeature
      ? geojson.id
      : undefined;
    isGeometryCollection = geometryMaybeCollection
      ? geometryMaybeCollection.type === "GeometryCollection"
      : false;
    stopG = isGeometryCollection
      ? geometryMaybeCollection.geometries.length
      : 1;

    for (g = 0; g < stopG; g++) {
      geometry = isGeometryCollection
        ? geometryMaybeCollection.geometries[g]
        : geometryMaybeCollection;

      // Handle null Geometry
      if (geometry === null) {
        if (
          callback(
            null,
            featureIndex,
            featureProperties,
            featureBBox,
            featureId
          ) === false
        )
          return false;
        continue;
      }
      switch (geometry.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (
            callback(
              geometry,
              featureIndex,
              featureProperties,
              featureBBox,
              featureId
            ) === false
          )
            return false;
          break;
        }
        case "GeometryCollection": {
          for (j = 0; j < geometry.geometries.length; j++) {
            if (
              callback(
                geometry.geometries[j],
                featureIndex,
                featureProperties,
                featureBBox,
                featureId
              ) === false
            )
              return false;
          }
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    // Only increase `featureIndex` per each feature
    featureIndex++;
  }
}

/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */

/**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */
function geomReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  geomEach(
    geojson,
    function (
      currentGeometry,
      featureIndex,
      featureProperties,
      featureBBox,
      featureId
    ) {
      if (featureIndex === 0 && initialValue === undefined)
        previousValue = currentGeometry;
      else
        previousValue = callback(
          previousValue,
          currentGeometry,
          featureIndex,
          featureProperties,
          featureBBox,
          featureId
        );
    }
  );
  return previousValue;
}

/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */

/**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */
function flattenEach(geojson, callback) {
  geomEach(geojson, function (geometry, featureIndex, properties, bbox, id) {
    // Callback for single geometry
    var type = geometry === null ? null : geometry.type;
    switch (type) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        if (
          callback(
            feature(geometry, properties, { bbox: bbox, id: id }),
            featureIndex,
            0
          ) === false
        )
          return false;
        return;
    }

    var geomType;

    // Callback for multi-geometry
    switch (type) {
      case "MultiPoint":
        geomType = "Point";
        break;
      case "MultiLineString":
        geomType = "LineString";
        break;
      case "MultiPolygon":
        geomType = "Polygon";
        break;
    }

    for (
      var multiFeatureIndex = 0;
      multiFeatureIndex < geometry.coordinates.length;
      multiFeatureIndex++
    ) {
      var coordinate = geometry.coordinates[multiFeatureIndex];
      var geom = {
        type: geomType,
        coordinates: coordinate,
      };
      if (
        callback(feature(geom, properties), featureIndex, multiFeatureIndex) ===
        false
      )
        return false;
    }
  });
}

/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */

/**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */
function flattenReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  flattenEach(
    geojson,
    function (currentFeature, featureIndex, multiFeatureIndex) {
      if (
        featureIndex === 0 &&
        multiFeatureIndex === 0 &&
        initialValue === undefined
      )
        previousValue = currentFeature;
      else
        previousValue = callback(
          previousValue,
          currentFeature,
          featureIndex,
          multiFeatureIndex
        );
    }
  );
  return previousValue;
}

/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */

/**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */
function segmentEach(geojson, callback) {
  flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
    var segmentIndex = 0;

    // Exclude null Geometries
    if (!feature.geometry) return;
    // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
    var type = feature.geometry.type;
    if (type === "Point" || type === "MultiPoint") return;

    // Generate 2-vertex line segments
    var previousCoords;
    var previousFeatureIndex = 0;
    var previousMultiIndex = 0;
    var prevGeomIndex = 0;
    if (
      coordEach(
        feature,
        function (
          currentCoord,
          coordIndex,
          featureIndexCoord,
          multiPartIndexCoord,
          geometryIndex
        ) {
          // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
          if (
            previousCoords === undefined ||
            featureIndex > previousFeatureIndex ||
            multiPartIndexCoord > previousMultiIndex ||
            geometryIndex > prevGeomIndex
          ) {
            previousCoords = currentCoord;
            previousFeatureIndex = featureIndex;
            previousMultiIndex = multiPartIndexCoord;
            prevGeomIndex = geometryIndex;
            segmentIndex = 0;
            return;
          }
          var currentSegment = es_lineString(
            [previousCoords, currentCoord],
            feature.properties
          );
          if (
            callback(
              currentSegment,
              featureIndex,
              multiFeatureIndex,
              geometryIndex,
              segmentIndex
            ) === false
          )
            return false;
          segmentIndex++;
          previousCoords = currentCoord;
        }
      ) === false
    )
      return false;
  });
}

/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */

/**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentIndex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */
function segmentReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  var started = false;
  segmentEach(
    geojson,
    function (
      currentSegment,
      featureIndex,
      multiFeatureIndex,
      geometryIndex,
      segmentIndex
    ) {
      if (started === false && initialValue === undefined)
        previousValue = currentSegment;
      else
        previousValue = callback(
          previousValue,
          currentSegment,
          featureIndex,
          multiFeatureIndex,
          geometryIndex,
          segmentIndex
        );
      started = true;
    }
  );
  return previousValue;
}

/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */

/**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */
function lineEach(geojson, callback) {
  // validation
  if (!geojson) throw new Error("geojson is required");

  flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
    if (feature.geometry === null) return;
    var type = feature.geometry.type;
    var coords = feature.geometry.coordinates;
    switch (type) {
      case "LineString":
        if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false)
          return false;
        break;
      case "Polygon":
        for (
          var geometryIndex = 0;
          geometryIndex < coords.length;
          geometryIndex++
        ) {
          if (
            callback(
              es_lineString(coords[geometryIndex], feature.properties),
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false
          )
            return false;
        }
        break;
    }
  });
}

/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */

/**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */
function lineReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  lineEach(
    geojson,
    function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
      if (featureIndex === 0 && initialValue === undefined)
        previousValue = currentLine;
      else
        previousValue = callback(
          previousValue,
          currentLine,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    }
  );
  return previousValue;
}

/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */
function findSegment(geojson, options) {
  // Optional Parameters
  options = options || {};
  if (!es_isObject(options)) throw new Error("options is invalid");
  var featureIndex = options.featureIndex || 0;
  var multiFeatureIndex = options.multiFeatureIndex || 0;
  var geometryIndex = options.geometryIndex || 0;
  var segmentIndex = options.segmentIndex || 0;

  // Find FeatureIndex
  var properties = options.properties;
  var geometry;

  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }

  // Find SegmentIndex
  if (geometry === null) return null;
  var coords = geometry.coordinates;
  switch (geometry.type) {
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
      if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
      return es_lineString(
        [coords[segmentIndex], coords[segmentIndex + 1]],
        properties,
        options
      );
    case "Polygon":
      if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
      return es_lineString(
        [
          coords[geometryIndex][segmentIndex],
          coords[geometryIndex][segmentIndex + 1],
        ],
        properties,
        options
      );
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
      return es_lineString(
        [
          coords[multiFeatureIndex][segmentIndex],
          coords[multiFeatureIndex][segmentIndex + 1],
        ],
        properties,
        options
      );
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex =
          coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
      return es_lineString(
        [
          coords[multiFeatureIndex][geometryIndex][segmentIndex],
          coords[multiFeatureIndex][geometryIndex][segmentIndex + 1],
        ],
        properties,
        options
      );
  }
  throw new Error("geojson is invalid");
}

/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */
function findPoint(geojson, options) {
  // Optional Parameters
  options = options || {};
  if (!es_isObject(options)) throw new Error("options is invalid");
  var featureIndex = options.featureIndex || 0;
  var multiFeatureIndex = options.multiFeatureIndex || 0;
  var geometryIndex = options.geometryIndex || 0;
  var coordIndex = options.coordIndex || 0;

  // Find FeatureIndex
  var properties = options.properties;
  var geometry;

  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }

  // Find Coord Index
  if (geometry === null) return null;
  var coords = geometry.coordinates;
  switch (geometry.type) {
    case "Point":
      return es_point(coords, properties, options);
    case "MultiPoint":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      return es_point(coords[multiFeatureIndex], properties, options);
    case "LineString":
      if (coordIndex < 0) coordIndex = coords.length + coordIndex;
      return es_point(coords[coordIndex], properties, options);
    case "Polygon":
      if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
      if (coordIndex < 0)
        coordIndex = coords[geometryIndex].length + coordIndex;
      return es_point(coords[geometryIndex][coordIndex], properties, options);
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (coordIndex < 0)
        coordIndex = coords[multiFeatureIndex].length + coordIndex;
      return es_point(coords[multiFeatureIndex][coordIndex], properties, options);
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (coordIndex < 0)
        coordIndex =
          coords[multiFeatureIndex][geometryIndex].length - coordIndex;
      return es_point(
        coords[multiFeatureIndex][geometryIndex][coordIndex],
        properties,
        options
      );
  }
  throw new Error("geojson is invalid");
}



;// ../../node_modules/@turf/bbox/dist/es/index.js

/**
 * Takes a set of features, calculates the bbox of all input features, and returns a bounding box.
 *
 * @name bbox
 * @param {GeoJSON} geojson any GeoJSON object
 * @returns {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @example
 * var line = turf.lineString([[-74, 40], [-78, 42], [-82, 35]]);
 * var bbox = turf.bbox(line);
 * var bboxPolygon = turf.bboxPolygon(bbox);
 *
 * //addToMap
 * var addToMap = [line, bboxPolygon]
 */
function bbox(geojson) {
    var result = [Infinity, Infinity, -Infinity, -Infinity];
    coordEach(geojson, function (coord) {
        if (result[0] > coord[0]) {
            result[0] = coord[0];
        }
        if (result[1] > coord[1]) {
            result[1] = coord[1];
        }
        if (result[2] < coord[0]) {
            result[2] = coord[0];
        }
        if (result[3] < coord[1]) {
            result[3] = coord[1];
        }
    });
    return result;
}
bbox["default"] = bbox;
/* harmony default export */ const es = (bbox);

;// ../../node_modules/@turf/invariant/dist/es/index.js
/* unused harmony import specifier */ var es_isNumber;

/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */
function getCoord(coord) {
    if (!coord) {
        throw new Error("coord is required");
    }
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" &&
            coord.geometry !== null &&
            coord.geometry.type === "Point") {
            return coord.geometry.coordinates;
        }
        if (coord.type === "Point") {
            return coord.coordinates;
        }
    }
    if (Array.isArray(coord) &&
        coord.length >= 2 &&
        !Array.isArray(coord[0]) &&
        !Array.isArray(coord[1])) {
        return coord;
    }
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */
function getCoords(coords) {
    if (Array.isArray(coords)) {
        return coords;
    }
    // Feature
    if (coords.type === "Feature") {
        if (coords.geometry !== null) {
            return coords.geometry.coordinates;
        }
    }
    else {
        // Geometry
        if (coords.coordinates) {
            return coords.coordinates;
        }
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */
function containsNumber(coordinates) {
    if (coordinates.length > 1 &&
        es_isNumber(coordinates[0]) &&
        es_isNumber(coordinates[1])) {
        return true;
    }
    if (Array.isArray(coordinates[0]) && coordinates[0].length) {
        return containsNumber(coordinates[0]);
    }
    throw new Error("coordinates must only contain numbers");
}
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */
function geojsonType(value, type, name) {
    if (!type || !name) {
        throw new Error("type and name required");
    }
    if (!value || value.type !== type) {
        throw new Error("Invalid input to " +
            name +
            ": must be a " +
            type +
            ", given " +
            value.type);
    }
}
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */
function featureOf(feature, type, name) {
    if (!feature) {
        throw new Error("No feature passed");
    }
    if (!name) {
        throw new Error(".featureOf() requires a name");
    }
    if (!feature || feature.type !== "Feature" || !feature.geometry) {
        throw new Error("Invalid input to " + name + ", Feature with geometry required");
    }
    if (!feature.geometry || feature.geometry.type !== type) {
        throw new Error("Invalid input to " +
            name +
            ": must be a " +
            type +
            ", given " +
            feature.geometry.type);
    }
}
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */
function collectionOf(featureCollection, type, name) {
    if (!featureCollection) {
        throw new Error("No featureCollection passed");
    }
    if (!name) {
        throw new Error(".collectionOf() requires a name");
    }
    if (!featureCollection || featureCollection.type !== "FeatureCollection") {
        throw new Error("Invalid input to " + name + ", FeatureCollection required");
    }
    for (var _i = 0, _a = featureCollection.features; _i < _a.length; _i++) {
        var feature = _a[_i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) {
            throw new Error("Invalid input to " + name + ", Feature with geometry required");
        }
        if (!feature.geometry || feature.geometry.type !== type) {
            throw new Error("Invalid input to " +
                name +
                ": must be a " +
                type +
                ", given " +
                feature.geometry.type);
        }
    }
}
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */
function getGeom(geojson) {
    if (geojson.type === "Feature") {
        return geojson.geometry;
    }
    return geojson;
}
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message (unused)
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */
function getType(geojson, _name) {
    if (geojson.type === "FeatureCollection") {
        return "FeatureCollection";
    }
    if (geojson.type === "GeometryCollection") {
        return "GeometryCollection";
    }
    if (geojson.type === "Feature" && geojson.geometry !== null) {
        return geojson.geometry.type;
    }
    return geojson.type;
}

// EXTERNAL MODULE: ../../node_modules/object-assign/index.js
var object_assign = __webpack_require__(1513);
;// ../../node_modules/@turf/isolines/dist/es/index.js
/* unused harmony import specifier */ var es_bbox;
/* unused harmony import specifier */ var es_featureEach;
/* unused harmony import specifier */ var es_coordEach;
/* unused harmony import specifier */ var es_collectionOf;
/* unused harmony import specifier */ var es_getCoords;
/* unused harmony import specifier */ var dist_es_isObject;
/* unused harmony import specifier */ var es_featureCollection;
/* unused harmony import specifier */ var es_multiLineString;
/* unused harmony import specifier */ var objectAssign;






/**
 * @license GNU Affero General Public License.
 * Copyright (c) 2015, 2015 Ronny Lorenz <ronny@tbi.univie.ac.at>
 * v. 1.2.0
 * https://github.com/RaumZeit/MarchingSquares.js
 *
 * MarchingSquaresJS is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MarchingSquaresJS is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * As additional permission under GNU Affero General Public License version 3
 * section 7, third-party projects (personal or commercial) may distribute,
 * include, or link against UNMODIFIED VERSIONS of MarchingSquaresJS without the
 * requirement that said third-party project for that reason alone becomes
 * subject to any requirement of the GNU Affero General Public License version 3.
 * Any modifications to MarchingSquaresJS, however, must be shared with the public
 * and made available.
 *
 * In summary this:
 * - allows you to use MarchingSquaresJS at no cost
 * - allows you to use MarchingSquaresJS for both personal and commercial purposes
 * - allows you to distribute UNMODIFIED VERSIONS of MarchingSquaresJS under any
 *   license as long as this license notice is included
 * - enables you to keep the source code of your program that uses MarchingSquaresJS
 *   undisclosed
 * - forces you to share any modifications you have made to MarchingSquaresJS,
 *   e.g. bug-fixes
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with MarchingSquaresJS.  If not, see <http://www.gnu.org/licenses/>.
 */

/**
 * Compute the isocontour(s) of a scalar 2D field given
 * a certain threshold by applying the Marching Squares
 * Algorithm. The function returns a list of path coordinates
 */
var defaultSettings = {
  successCallback: null,
  verbose: false,
};

var settings = {};

function isoContours(data, threshold, options) {
  /* process options */
  options = options ? options : {};

  var optionKeys = Object.keys(defaultSettings);

  for (var i = 0; i < optionKeys.length; i++) {
    var key = optionKeys[i];
    var val = options[key];
    val =
      typeof val !== "undefined" && val !== null ? val : defaultSettings[key];

    settings[key] = val;
  }

  if (settings.verbose)
    console.log(
      "MarchingSquaresJS-isoContours: computing isocontour for " + threshold
    );

  var ret = contourGrid2Paths(computeContourGrid(data, threshold));

  if (typeof settings.successCallback === "function")
    settings.successCallback(ret);

  return ret;
}

/*
  Thats all for the public interface, below follows the actual
  implementation
*/

/*
################################
Isocontour implementation below
################################
*/

/* assume that x1 == 1 &&  x0 == 0 */
function interpolateX(y, y0, y1) {
  return (y - y0) / (y1 - y0);
}

/* compute the isocontour 4-bit grid */
function computeContourGrid(data, threshold) {
  var rows = data.length - 1;
  var cols = data[0].length - 1;
  var ContourGrid = { rows: rows, cols: cols, cells: [] };

  for (var j = 0; j < rows; ++j) {
    ContourGrid.cells[j] = [];
    for (var i = 0; i < cols; ++i) {
      /* compose the 4-bit corner representation */
      var cval = 0;

      var tl = data[j + 1][i];
      var tr = data[j + 1][i + 1];
      var br = data[j][i + 1];
      var bl = data[j][i];

      if (isNaN(tl) || isNaN(tr) || isNaN(br) || isNaN(bl)) {
        continue;
      }
      cval |= tl >= threshold ? 8 : 0;
      cval |= tr >= threshold ? 4 : 0;
      cval |= br >= threshold ? 2 : 0;
      cval |= bl >= threshold ? 1 : 0;

      /* resolve ambiguity for cval == 5 || 10 via averaging */
      var flipped = false;
      if (cval === 5 || cval === 10) {
        var average = (tl + tr + br + bl) / 4;
        if (cval === 5 && average < threshold) {
          cval = 10;
          flipped = true;
        } else if (cval === 10 && average < threshold) {
          cval = 5;
          flipped = true;
        }
      }

      /* add cell to ContourGrid if it contains edges */
      if (cval !== 0 && cval !== 15) {
        var top, bottom, left, right;
        top = bottom = left = right = 0.5;
        /* interpolate edges of cell */
        if (cval === 1) {
          left = 1 - interpolateX(threshold, tl, bl);
          bottom = 1 - interpolateX(threshold, br, bl);
        } else if (cval === 2) {
          bottom = interpolateX(threshold, bl, br);
          right = 1 - interpolateX(threshold, tr, br);
        } else if (cval === 3) {
          left = 1 - interpolateX(threshold, tl, bl);
          right = 1 - interpolateX(threshold, tr, br);
        } else if (cval === 4) {
          top = interpolateX(threshold, tl, tr);
          right = interpolateX(threshold, br, tr);
        } else if (cval === 5) {
          top = interpolateX(threshold, tl, tr);
          right = interpolateX(threshold, br, tr);
          bottom = 1 - interpolateX(threshold, br, bl);
          left = 1 - interpolateX(threshold, tl, bl);
        } else if (cval === 6) {
          bottom = interpolateX(threshold, bl, br);
          top = interpolateX(threshold, tl, tr);
        } else if (cval === 7) {
          left = 1 - interpolateX(threshold, tl, bl);
          top = interpolateX(threshold, tl, tr);
        } else if (cval === 8) {
          left = interpolateX(threshold, bl, tl);
          top = 1 - interpolateX(threshold, tr, tl);
        } else if (cval === 9) {
          bottom = 1 - interpolateX(threshold, br, bl);
          top = 1 - interpolateX(threshold, tr, tl);
        } else if (cval === 10) {
          top = 1 - interpolateX(threshold, tr, tl);
          right = 1 - interpolateX(threshold, tr, br);
          bottom = interpolateX(threshold, bl, br);
          left = interpolateX(threshold, bl, tl);
        } else if (cval === 11) {
          top = 1 - interpolateX(threshold, tr, tl);
          right = 1 - interpolateX(threshold, tr, br);
        } else if (cval === 12) {
          left = interpolateX(threshold, bl, tl);
          right = interpolateX(threshold, br, tr);
        } else if (cval === 13) {
          bottom = 1 - interpolateX(threshold, br, bl);
          right = interpolateX(threshold, br, tr);
        } else if (cval === 14) {
          left = interpolateX(threshold, bl, tl);
          bottom = interpolateX(threshold, bl, br);
        } else {
          console.log(
            "MarchingSquaresJS-isoContours: Illegal cval detected: " + cval
          );
        }
        ContourGrid.cells[j][i] = {
          cval: cval,
          flipped: flipped,
          top: top,
          right: right,
          bottom: bottom,
          left: left,
        };
      }
    }
  }

  return ContourGrid;
}

function isSaddle(cell) {
  return cell.cval === 5 || cell.cval === 10;
}

function isTrivial(cell) {
  return cell.cval === 0 || cell.cval === 15;
}

function clearCell(cell) {
  if (!isTrivial(cell) && cell.cval !== 5 && cell.cval !== 10) {
    cell.cval = 15;
  }
}

function getXY(cell, edge) {
  if (edge === "top") {
    return [cell.top, 1.0];
  } else if (edge === "bottom") {
    return [cell.bottom, 0.0];
  } else if (edge === "right") {
    return [1.0, cell.right];
  } else if (edge === "left") {
    return [0.0, cell.left];
  }
}

function contourGrid2Paths(grid) {
  var paths = [];
  var path_idx = 0;
  var epsilon = 1e-7;

  grid.cells.forEach(function (g, j) {
    g.forEach(function (gg, i) {
      if (typeof gg !== "undefined" && !isSaddle(gg) && !isTrivial(gg)) {
        var p = tracePath(grid.cells, j, i);
        var merged = false;
        /* we may try to merge paths at this point */
        if (p.info === "mergeable") {
          /*
            search backwards through the path array to find an entry
            that starts with where the current path ends...
          */
          var x = p.path[p.path.length - 1][0],
            y = p.path[p.path.length - 1][1];

          for (var k = path_idx - 1; k >= 0; k--) {
            if (
              Math.abs(paths[k][0][0] - x) <= epsilon &&
              Math.abs(paths[k][0][1] - y) <= epsilon
            ) {
              for (var l = p.path.length - 2; l >= 0; --l) {
                paths[k].unshift(p.path[l]);
              }
              merged = true;
              break;
            }
          }
        }
        if (!merged) paths[path_idx++] = p.path;
      }
    });
  });

  return paths;
}

/*
  construct consecutive line segments from starting cell by
  walking arround the enclosed area clock-wise
  */
function tracePath(grid, j, i) {
  var maxj = grid.length;
  var p = [];
  var dxContour = [0, 0, 1, 1, 0, 0, 0, 0, -1, 0, 1, 1, -1, 0, -1, 0];
  var dyContour = [0, -1, 0, 0, 1, 1, 1, 1, 0, -1, 0, 0, 0, -1, 0, 0];
  var dx, dy;
  var startEdge = [
    "none",
    "left",
    "bottom",
    "left",
    "right",
    "none",
    "bottom",
    "left",
    "top",
    "top",
    "none",
    "top",
    "right",
    "right",
    "bottom",
    "none",
  ];
  var nextEdge = [
    "none",
    "bottom",
    "right",
    "right",
    "top",
    "top",
    "top",
    "top",
    "left",
    "bottom",
    "right",
    "right",
    "left",
    "bottom",
    "left",
    "none",
  ];
  var edge;

  var currentCell = grid[j][i];

  var cval = currentCell.cval;
  var edge = startEdge[cval];

  var pt = getXY(currentCell, edge);

  /* push initial segment */
  p.push([i + pt[0], j + pt[1]]);
  edge = nextEdge[cval];
  pt = getXY(currentCell, edge);
  p.push([i + pt[0], j + pt[1]]);
  clearCell(currentCell);

  /* now walk arround the enclosed area in clockwise-direction */
  var k = i + dxContour[cval];
  var l = j + dyContour[cval];
  var prev_cval = cval;

  while (k >= 0 && l >= 0 && l < maxj && (k != i || l != j)) {
    currentCell = grid[l][k];
    if (typeof currentCell === "undefined") {
      /* path ends here */
      //console.log(k + " " + l + " is undefined, stopping path!");
      break;
    }
    cval = currentCell.cval;
    if (cval === 0 || cval === 15) {
      return { path: p, info: "mergeable" };
    }
    edge = nextEdge[cval];
    dx = dxContour[cval];
    dy = dyContour[cval];
    if (cval === 5 || cval === 10) {
      /* select upper or lower band, depending on previous cells cval */
      if (cval === 5) {
        if (currentCell.flipped) {
          /* this is actually a flipped case 10 */
          if (dyContour[prev_cval] === -1) {
            edge = "left";
            dx = -1;
            dy = 0;
          } else {
            edge = "right";
            dx = 1;
            dy = 0;
          }
        } else {
          /* real case 5 */
          if (dxContour[prev_cval] === -1) {
            edge = "bottom";
            dx = 0;
            dy = -1;
          }
        }
      } else if (cval === 10) {
        if (currentCell.flipped) {
          /* this is actually a flipped case 5 */
          if (dxContour[prev_cval] === -1) {
            edge = "top";
            dx = 0;
            dy = 1;
          } else {
            edge = "bottom";
            dx = 0;
            dy = -1;
          }
        } else {
          /* real case 10 */
          if (dyContour[prev_cval] === 1) {
            edge = "left";
            dx = -1;
            dy = 0;
          }
        }
      }
    }
    pt = getXY(currentCell, edge);
    p.push([k + pt[0], l + pt[1]]);
    clearCell(currentCell);
    k += dx;
    l += dy;
    prev_cval = cval;
  }

  return { path: p, info: "closed" };
}

/**
 * Takes a {@link Point} grid and returns a correspondent matrix {Array<Array<number>>}
 * of the 'property' values
 *
 * @name gridToMatrix
 * @param {FeatureCollection<Point>} grid of points
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.zProperty='elevation'] the property name in `points` from which z-values will be pulled
 * @param {boolean} [options.flip=false] returns the matrix upside-down
 * @param {boolean} [options.flags=false] flags, adding a `matrixPosition` array field ([row, column]) to its properties,
 * the grid points with coordinates on the matrix
 * @returns {Array<Array<number>>} matrix of property values
 * @example
 *   var extent = [-70.823364, -33.553984, -70.473175, -33.302986];
 *   var cellSize = 3;
 *   var grid = turf.pointGrid(extent, cellSize);
 *   // add a random property to each point between 0 and 60
 *   for (var i = 0; i < grid.features.length; i++) {
 *     grid.features[i].properties.elevation = (Math.random() * 60);
 *   }
 *   gridToMatrix(grid);
 *   //= [
 *     [ 1, 13, 10,  9, 10, 13, 18],
 *     [34,  8,  5,  4,  5,  8, 13],
 *     [10,  5,  2,  1,  2,  5,  4],
 *     [ 0,  4, 56, 19,  1,  4,  9],
 *     [10,  5,  2,  1,  2,  5, 10],
 *     [57,  8,  5,  4,  5,  0, 57],
 *     [ 3, 13, 10,  9,  5, 13, 18],
 *     [18, 13, 10,  9, 78, 13, 18]
 *   ]
 */
function gridToMatrix(grid, options) {
  // Optional parameters
  options = options || {};
  if (!dist_es_isObject(options)) throw new Error("options is invalid");
  var zProperty = options.zProperty || "elevation";
  var flip = options.flip;
  var flags = options.flags;

  // validation
  es_collectionOf(grid, "Point", "input must contain Points");

  var pointsMatrix = sortPointsByLatLng(grid, flip);

  var matrix = [];
  // create property matrix from sorted points
  // looping order matters here
  for (var r = 0; r < pointsMatrix.length; r++) {
    var pointRow = pointsMatrix[r];
    var row = [];
    for (var c = 0; c < pointRow.length; c++) {
      var point = pointRow[c];
      // Check if zProperty exist
      if (point.properties[zProperty]) row.push(point.properties[zProperty]);
      else row.push(0);
      // add flags
      if (flags === true) point.properties.matrixPosition = [r, c];
    }
    matrix.push(row);
  }

  return matrix;
}

/**
 * Sorts points by latitude and longitude, creating a 2-dimensional array of points
 *
 * @private
 * @param {FeatureCollection<Point>} points GeoJSON Point features
 * @param {boolean} [flip=false] returns the matrix upside-down
 * @returns {Array<Array<Point>>} points ordered by latitude and longitude
 */
function sortPointsByLatLng(points, flip) {
  var pointsByLatitude = {};

  // divide points by rows with the same latitude
  es_featureEach(points, function (point) {
    var lat = es_getCoords(point)[1];
    if (!pointsByLatitude[lat]) pointsByLatitude[lat] = [];
    pointsByLatitude[lat].push(point);
  });

  // sort points (with the same latitude) by longitude
  var orderedRowsByLatitude = Object.keys(pointsByLatitude).map(function (lat) {
    var row = pointsByLatitude[lat];
    var rowOrderedByLongitude = row.sort(function (a, b) {
      return es_getCoords(a)[0] - es_getCoords(b)[0];
    });
    return rowOrderedByLongitude;
  });

  // sort rows (of points with the same latitude) by latitude
  var pointMatrix = orderedRowsByLatitude.sort(function (a, b) {
    if (flip) return es_getCoords(a[0])[1] - es_getCoords(b[0])[1];
    else return es_getCoords(b[0])[1] - es_getCoords(a[0])[1];
  });

  return pointMatrix;
}

/**
 * Takes a grid {@link FeatureCollection} of {@link Point} features with z-values and an array of
 * value breaks and generates [isolines](https://en.wikipedia.org/wiki/Contour_line).
 *
 * @name isolines
 * @param {FeatureCollection<Point>} pointGrid input points
 * @param {Array<number>} breaks values of `zProperty` where to draw isolines
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.zProperty='elevation'] the property name in `points` from which z-values will be pulled
 * @param {Object} [options.commonProperties={}] GeoJSON properties passed to ALL isolines
 * @param {Array<Object>} [options.breaksProperties=[]] GeoJSON properties passed, in order, to the correspondent isoline;
 * the breaks array will define the order in which the isolines are created
 * @returns {FeatureCollection<MultiLineString>} a FeatureCollection of {@link MultiLineString} features representing isolines
 * @example
 * // create a grid of points with random z-values in their properties
 * var extent = [0, 30, 20, 50];
 * var cellWidth = 100;
 * var pointGrid = turf.pointGrid(extent, cellWidth, {units: 'miles'});
 *
 * for (var i = 0; i < pointGrid.features.length; i++) {
 *     pointGrid.features[i].properties.temperature = Math.random() * 10;
 * }
 * var breaks = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
 *
 * var lines = turf.isolines(pointGrid, breaks, {zProperty: 'temperature'});
 *
 * //addToMap
 * var addToMap = [lines];
 */
function isolines(pointGrid, breaks, options) {
  // Optional parameters
  options = options || {};
  if (!dist_es_isObject(options)) throw new Error("options is invalid");
  var zProperty = options.zProperty || "elevation";
  var commonProperties = options.commonProperties || {};
  var breaksProperties = options.breaksProperties || [];

  // Input validation
  es_collectionOf(pointGrid, "Point", "Input must contain Points");
  if (!breaks) throw new Error("breaks is required");
  if (!Array.isArray(breaks)) throw new Error("breaks must be an Array");
  if (!dist_es_isObject(commonProperties))
    throw new Error("commonProperties must be an Object");
  if (!Array.isArray(breaksProperties))
    throw new Error("breaksProperties must be an Array");

  // Isoline methods
  var matrix = gridToMatrix(pointGrid, { zProperty: zProperty, flip: true });
  var createdIsoLines = createIsoLines(
    matrix,
    breaks,
    zProperty,
    commonProperties,
    breaksProperties
  );
  var scaledIsolines = rescaleIsolines(createdIsoLines, matrix, pointGrid);

  return es_featureCollection(scaledIsolines);
}

/**
 * Creates the isolines lines (featuresCollection of MultiLineString features) from the 2D data grid
 *
 * Marchingsquares process the grid data as a 3D representation of a function on a 2D plane, therefore it
 * assumes the points (x-y coordinates) are one 'unit' distance. The result of the isolines function needs to be
 * rescaled, with turfjs, to the original area and proportions on the map
 *
 * @private
 * @param {Array<Array<number>>} matrix Grid Data
 * @param {Array<number>} breaks Breaks
 * @param {string} zProperty name of the z-values property
 * @param {Object} [commonProperties={}] GeoJSON properties passed to ALL isolines
 * @param {Object} [breaksProperties=[]] GeoJSON properties passed to the correspondent isoline
 * @returns {Array<MultiLineString>} isolines
 */
function createIsoLines(
  matrix,
  breaks,
  zProperty,
  commonProperties,
  breaksProperties
) {
  var results = [];
  for (var i = 1; i < breaks.length; i++) {
    var threshold = +breaks[i]; // make sure it's a number

    var properties = objectAssign({}, commonProperties, breaksProperties[i]);
    properties[zProperty] = threshold;
    var isoline = es_multiLineString(isoContours(matrix, threshold), properties);

    results.push(isoline);
  }
  return results;
}

/**
 * Translates and scales isolines
 *
 * @private
 * @param {Array<MultiLineString>} createdIsoLines to be rescaled
 * @param {Array<Array<number>>} matrix Grid Data
 * @param {Object} points Points by Latitude
 * @returns {Array<MultiLineString>} isolines
 */
function rescaleIsolines(createdIsoLines, matrix, points) {
  // get dimensions (on the map) of the original grid
  var gridBbox = es_bbox(points); // [ minX, minY, maxX, maxY ]
  var originalWidth = gridBbox[2] - gridBbox[0];
  var originalHeigth = gridBbox[3] - gridBbox[1];

  // get origin, which is the first point of the last row on the rectangular data on the map
  var x0 = gridBbox[0];
  var y0 = gridBbox[1];

  // get number of cells per side
  var matrixWidth = matrix[0].length - 1;
  var matrixHeight = matrix.length - 1;

  // calculate the scaling factor between matrix and rectangular grid on the map
  var scaleX = originalWidth / matrixWidth;
  var scaleY = originalHeigth / matrixHeight;

  var resize = function (point) {
    point[0] = point[0] * scaleX + x0;
    point[1] = point[1] * scaleY + y0;
  };

  // resize and shift each point/line of the createdIsoLines
  createdIsoLines.forEach(function (isoline) {
    es_coordEach(isoline, resize);
  });
  return createdIsoLines;
}

/* harmony default export */ const dist_es = ((/* unused pure expression or super */ null && (isolines)));

;// ../../node_modules/concaveman/node_modules/quickselect/index.js

/**
 * Rearranges items so that all items in the [left, k] are the smallest.
 * The k-th element will have the (k - left + 1)-th smallest value in [left, right].
 *
 * @template T
 * @param {T[]} arr the array to partially sort (in place)
 * @param {number} k middle index for partial sorting (as defined above)
 * @param {number} [left=0] left index of the range to sort
 * @param {number} [right=arr.length-1] right index
 * @param {(a: T, b: T) => number} [compare = (a, b) => a - b] compare function
 */
function quickselect(arr, k, left = 0, right = arr.length - 1, compare = defaultCompare) {

    while (right > left) {
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(arr, k, newLeft, newRight, compare);
        }

        const t = arr[k];
        let i = left;
        /** @type {number} */
        let j = right;

        swap(arr, left, k);
        if (compare(arr[right], t) > 0) swap(arr, left, right);

        while (i < j) {
            swap(arr, i, j);
            i++;
            j--;
            while (compare(arr[i], t) < 0) i++;
            while (compare(arr[j], t) > 0) j--;
        }

        if (compare(arr[left], t) === 0) swap(arr, left, j);
        else {
            j++;
            swap(arr, j, right);
        }

        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}

/**
 * @template T
 * @param {T[]} arr
 * @param {number} i
 * @param {number} j
 */
function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}

/**
 * @template T
 * @param {T} a
 * @param {T} b
 * @returns {number}
 */
function defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

;// ../../node_modules/concaveman/node_modules/rbush/index.js


class RBush {
    constructor(maxEntries = 9) {
        // max entries in a node is 9 by default; min node fill is 40% for best performance
        this._maxEntries = Math.max(4, maxEntries);
        this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
        this.clear();
    }

    all() {
        return this._all(this.data, []);
    }

    search(bbox) {
        let node = this.data;
        const result = [];

        if (!intersects(bbox, node)) return result;

        const toBBox = this.toBBox;
        const nodesToSearch = [];

        while (node) {
            for (let i = 0; i < node.children.length; i++) {
                const child = node.children[i];
                const childBBox = node.leaf ? toBBox(child) : child;

                if (intersects(bbox, childBBox)) {
                    if (node.leaf) result.push(child);
                    else if (contains(bbox, childBBox)) this._all(child, result);
                    else nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }

        return result;
    }

    collides(bbox) {
        let node = this.data;

        if (!intersects(bbox, node)) return false;

        const nodesToSearch = [];
        while (node) {
            for (let i = 0; i < node.children.length; i++) {
                const child = node.children[i];
                const childBBox = node.leaf ? this.toBBox(child) : child;

                if (intersects(bbox, childBBox)) {
                    if (node.leaf || contains(bbox, childBBox)) return true;
                    nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }

        return false;
    }

    load(data) {
        if (!(data && data.length)) return this;

        if (data.length < this._minEntries) {
            for (let i = 0; i < data.length; i++) {
                this.insert(data[i]);
            }
            return this;
        }

        // recursively build the tree with the given data from scratch using OMT algorithm
        let node = this._build(data.slice(), 0, data.length - 1, 0);

        if (!this.data.children.length) {
            // save as is if tree is empty
            this.data = node;

        } else if (this.data.height === node.height) {
            // split root if trees have the same height
            this._splitRoot(this.data, node);

        } else {
            if (this.data.height < node.height) {
                // swap trees if inserted one is bigger
                const tmpNode = this.data;
                this.data = node;
                node = tmpNode;
            }

            // insert the small tree into the large tree at appropriate level
            this._insert(node, this.data.height - node.height - 1, true);
        }

        return this;
    }

    insert(item) {
        if (item) this._insert(item, this.data.height - 1);
        return this;
    }

    clear() {
        this.data = createNode([]);
        return this;
    }

    remove(item, equalsFn) {
        if (!item) return this;

        let node = this.data;
        const bbox = this.toBBox(item);
        const path = [];
        const indexes = [];
        let i, parent, goingUp;

        // depth-first iterative tree traversal
        while (node || path.length) {

            if (!node) { // go up
                node = path.pop();
                parent = path[path.length - 1];
                i = indexes.pop();
                goingUp = true;
            }

            if (node.leaf) { // check current node
                const index = findItem(item, node.children, equalsFn);

                if (index !== -1) {
                    // item found, remove the item and condense tree upwards
                    node.children.splice(index, 1);
                    path.push(node);
                    this._condense(path);
                    return this;
                }
            }

            if (!goingUp && !node.leaf && contains(node, bbox)) { // go down
                path.push(node);
                indexes.push(i);
                i = 0;
                parent = node;
                node = node.children[0];

            } else if (parent) { // go right
                i++;
                node = parent.children[i];
                goingUp = false;

            } else node = null; // nothing found
        }

        return this;
    }

    toBBox(item) { return item; }

    compareMinX(a, b) { return a.minX - b.minX; }
    compareMinY(a, b) { return a.minY - b.minY; }

    toJSON() { return this.data; }

    fromJSON(data) {
        this.data = data;
        return this;
    }

    _all(node, result) {
        const nodesToSearch = [];
        while (node) {
            if (node.leaf) result.push(...node.children);
            else nodesToSearch.push(...node.children);

            node = nodesToSearch.pop();
        }
        return result;
    }

    _build(items, left, right, height) {

        const N = right - left + 1;
        let M = this._maxEntries;
        let node;

        if (N <= M) {
            // reached leaf level; return leaf
            node = createNode(items.slice(left, right + 1));
            calcBBox(node, this.toBBox);
            return node;
        }

        if (!height) {
            // target height of the bulk-loaded tree
            height = Math.ceil(Math.log(N) / Math.log(M));

            // target number of root entries to maximize storage utilization
            M = Math.ceil(N / Math.pow(M, height - 1));
        }

        node = createNode([]);
        node.leaf = false;
        node.height = height;

        // split the items into M mostly square tiles

        const N2 = Math.ceil(N / M);
        const N1 = N2 * Math.ceil(Math.sqrt(M));

        multiSelect(items, left, right, N1, this.compareMinX);

        for (let i = left; i <= right; i += N1) {

            const right2 = Math.min(i + N1 - 1, right);

            multiSelect(items, i, right2, N2, this.compareMinY);

            for (let j = i; j <= right2; j += N2) {

                const right3 = Math.min(j + N2 - 1, right2);

                // pack each entry recursively
                node.children.push(this._build(items, j, right3, height - 1));
            }
        }

        calcBBox(node, this.toBBox);

        return node;
    }

    _chooseSubtree(bbox, node, level, path) {
        while (true) {
            path.push(node);

            if (node.leaf || path.length - 1 === level) break;

            let minArea = Infinity;
            let minEnlargement = Infinity;
            let targetNode;

            for (let i = 0; i < node.children.length; i++) {
                const child = node.children[i];
                const area = bboxArea(child);
                const enlargement = enlargedArea(bbox, child) - area;

                // choose entry with the least area enlargement
                if (enlargement < minEnlargement) {
                    minEnlargement = enlargement;
                    minArea = area < minArea ? area : minArea;
                    targetNode = child;

                } else if (enlargement === minEnlargement) {
                    // otherwise choose one with the smallest area
                    if (area < minArea) {
                        minArea = area;
                        targetNode = child;
                    }
                }
            }

            node = targetNode || node.children[0];
        }

        return node;
    }

    _insert(item, level, isNode) {
        const bbox = isNode ? item : this.toBBox(item);
        const insertPath = [];

        // find the best node for accommodating the item, saving all nodes along the path too
        const node = this._chooseSubtree(bbox, this.data, level, insertPath);

        // put the item into the node
        node.children.push(item);
        extend(node, bbox);

        // split on node overflow; propagate upwards if necessary
        while (level >= 0) {
            if (insertPath[level].children.length > this._maxEntries) {
                this._split(insertPath, level);
                level--;
            } else break;
        }

        // adjust bboxes along the insertion path
        this._adjustParentBBoxes(bbox, insertPath, level);
    }

    // split overflowed node into two
    _split(insertPath, level) {
        const node = insertPath[level];
        const M = node.children.length;
        const m = this._minEntries;

        this._chooseSplitAxis(node, m, M);

        const splitIndex = this._chooseSplitIndex(node, m, M);

        const newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
        newNode.height = node.height;
        newNode.leaf = node.leaf;

        calcBBox(node, this.toBBox);
        calcBBox(newNode, this.toBBox);

        if (level) insertPath[level - 1].children.push(newNode);
        else this._splitRoot(node, newNode);
    }

    _splitRoot(node, newNode) {
        // split root node
        this.data = createNode([node, newNode]);
        this.data.height = node.height + 1;
        this.data.leaf = false;
        calcBBox(this.data, this.toBBox);
    }

    _chooseSplitIndex(node, m, M) {
        let index;
        let minOverlap = Infinity;
        let minArea = Infinity;

        for (let i = m; i <= M - m; i++) {
            const bbox1 = distBBox(node, 0, i, this.toBBox);
            const bbox2 = distBBox(node, i, M, this.toBBox);

            const overlap = intersectionArea(bbox1, bbox2);
            const area = bboxArea(bbox1) + bboxArea(bbox2);

            // choose distribution with minimum overlap
            if (overlap < minOverlap) {
                minOverlap = overlap;
                index = i;

                minArea = area < minArea ? area : minArea;

            } else if (overlap === minOverlap) {
                // otherwise choose distribution with minimum area
                if (area < minArea) {
                    minArea = area;
                    index = i;
                }
            }
        }

        return index || M - m;
    }

    // sorts node children by the best axis for split
    _chooseSplitAxis(node, m, M) {
        const compareMinX = node.leaf ? this.compareMinX : compareNodeMinX;
        const compareMinY = node.leaf ? this.compareMinY : compareNodeMinY;
        const xMargin = this._allDistMargin(node, m, M, compareMinX);
        const yMargin = this._allDistMargin(node, m, M, compareMinY);

        // if total distributions margin value is minimal for x, sort by minX,
        // otherwise it's already sorted by minY
        if (xMargin < yMargin) node.children.sort(compareMinX);
    }

    // total margin of all possible split distributions where each node is at least m full
    _allDistMargin(node, m, M, compare) {
        node.children.sort(compare);

        const toBBox = this.toBBox;
        const leftBBox = distBBox(node, 0, m, toBBox);
        const rightBBox = distBBox(node, M - m, M, toBBox);
        let margin = bboxMargin(leftBBox) + bboxMargin(rightBBox);

        for (let i = m; i < M - m; i++) {
            const child = node.children[i];
            extend(leftBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(leftBBox);
        }

        for (let i = M - m - 1; i >= m; i--) {
            const child = node.children[i];
            extend(rightBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(rightBBox);
        }

        return margin;
    }

    _adjustParentBBoxes(bbox, path, level) {
        // adjust bboxes along the given tree path
        for (let i = level; i >= 0; i--) {
            extend(path[i], bbox);
        }
    }

    _condense(path) {
        // go through the path, removing empty nodes and updating bboxes
        for (let i = path.length - 1, siblings; i >= 0; i--) {
            if (path[i].children.length === 0) {
                if (i > 0) {
                    siblings = path[i - 1].children;
                    siblings.splice(siblings.indexOf(path[i]), 1);

                } else this.clear();

            } else calcBBox(path[i], this.toBBox);
        }
    }
}

function findItem(item, items, equalsFn) {
    if (!equalsFn) return items.indexOf(item);

    for (let i = 0; i < items.length; i++) {
        if (equalsFn(item, items[i])) return i;
    }
    return -1;
}

// calculate node's bbox from bboxes of its children
function calcBBox(node, toBBox) {
    distBBox(node, 0, node.children.length, toBBox, node);
}

// min bounding rectangle of node children from k to p-1
function distBBox(node, k, p, toBBox, destNode) {
    if (!destNode) destNode = createNode(null);
    destNode.minX = Infinity;
    destNode.minY = Infinity;
    destNode.maxX = -Infinity;
    destNode.maxY = -Infinity;

    for (let i = k; i < p; i++) {
        const child = node.children[i];
        extend(destNode, node.leaf ? toBBox(child) : child);
    }

    return destNode;
}

function extend(a, b) {
    a.minX = Math.min(a.minX, b.minX);
    a.minY = Math.min(a.minY, b.minY);
    a.maxX = Math.max(a.maxX, b.maxX);
    a.maxY = Math.max(a.maxY, b.maxY);
    return a;
}

function compareNodeMinX(a, b) { return a.minX - b.minX; }
function compareNodeMinY(a, b) { return a.minY - b.minY; }

function bboxArea(a)   { return (a.maxX - a.minX) * (a.maxY - a.minY); }
function bboxMargin(a) { return (a.maxX - a.minX) + (a.maxY - a.minY); }

function enlargedArea(a, b) {
    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) *
           (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
}

function intersectionArea(a, b) {
    const minX = Math.max(a.minX, b.minX);
    const minY = Math.max(a.minY, b.minY);
    const maxX = Math.min(a.maxX, b.maxX);
    const maxY = Math.min(a.maxY, b.maxY);

    return Math.max(0, maxX - minX) *
           Math.max(0, maxY - minY);
}

function contains(a, b) {
    return a.minX <= b.minX &&
           a.minY <= b.minY &&
           b.maxX <= a.maxX &&
           b.maxY <= a.maxY;
}

function intersects(a, b) {
    return b.minX <= a.maxX &&
           b.minY <= a.maxY &&
           b.maxX >= a.minX &&
           b.maxY >= a.minY;
}

function createNode(children) {
    return {
        children,
        height: 1,
        leaf: true,
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity
    };
}

// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
// combines selection algorithm with binary divide & conquer approach

function multiSelect(arr, left, right, n, compare) {
    const stack = [left, right];

    while (stack.length) {
        right = stack.pop();
        left = stack.pop();

        if (right - left <= n) continue;

        const mid = left + Math.ceil((right - left) / n / 2) * n;
        quickselect(arr, mid, left, right, compare);

        stack.push(left, mid, mid, right);
    }
}

;// ../../node_modules/tinyqueue/index.js

class TinyQueue {
    constructor(data = [], compare = (a, b) => (a < b ? -1 : a > b ? 1 : 0)) {
        this.data = data;
        this.length = this.data.length;
        this.compare = compare;

        if (this.length > 0) {
            for (let i = (this.length >> 1) - 1; i >= 0; i--) this._down(i);
        }
    }

    push(item) {
        this.data.push(item);
        this._up(this.length++);
    }

    pop() {
        if (this.length === 0) return undefined;

        const top = this.data[0];
        const bottom = this.data.pop();

        if (--this.length > 0) {
            this.data[0] = bottom;
            this._down(0);
        }

        return top;
    }

    peek() {
        return this.data[0];
    }

    _up(pos) {
        const {data, compare} = this;
        const item = data[pos];

        while (pos > 0) {
            const parent = (pos - 1) >> 1;
            const current = data[parent];
            if (compare(item, current) >= 0) break;
            data[pos] = current;
            pos = parent;
        }

        data[pos] = item;
    }

    _down(pos) {
        const {data, compare} = this;
        const halfLength = this.length >> 1;
        const item = data[pos];

        while (pos < halfLength) {
            let bestChild = (pos << 1) + 1; // initially it is the left child
            const right = bestChild + 1;

            if (right < this.length && compare(data[right], data[bestChild]) < 0) {
                bestChild = right;
            }
            if (compare(data[bestChild], item) >= 0) break;

            data[pos] = data[bestChild];
            pos = bestChild;
        }

        data[pos] = item;
    }
}

// EXTERNAL MODULE: ../../node_modules/point-in-polygon/index.js
var point_in_polygon = __webpack_require__(3071);
;// ../../node_modules/robust-predicates/esm/util.js
const epsilon = 1.1102230246251565e-16;
const splitter = 134217729;
const resulterrbound = (3 + 8 * epsilon) * epsilon;

// fast_expansion_sum_zeroelim routine from original code
function sum(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if ((fnow > enow) === (fnow > -enow)) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if ((fnow > enow) === (fnow > -enow)) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) {
            h[hindex++] = hh;
        }
        while (eindex < elen && findex < flen) {
            if ((fnow > enow) === (fnow > -enow)) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) {
                h[hindex++] = hh;
            }
        }
    }
    while (eindex < elen) {
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) {
            h[hindex++] = hh;
        }
    }
    while (findex < flen) {
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) {
            h[hindex++] = hh;
        }
    }
    if (Q !== 0 || hindex === 0) {
        h[hindex++] = Q;
    }
    return hindex;
}

function sum_three(alen, a, blen, b, clen, c, tmp, out) {
    return sum(sum(alen, a, blen, b, tmp), tmp, clen, c, out);
}

// scale_expansion_zeroelim routine from oritinal code
function scale(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;

    c = splitter * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = splitter * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) {
        h[hindex++] = hh;
    }
    for (let i = 1; i < elen; i++) {
        enow = e[i];
        product1 = enow * b;
        c = splitter * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) {
            h[hindex++] = hh;
        }
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) {
            h[hindex++] = hh;
        }
    }
    if (Q !== 0 || hindex === 0) {
        h[hindex++] = Q;
    }
    return hindex;
}

function negate(elen, e) {
    for (let i = 0; i < elen; i++) e[i] = -e[i];
    return elen;
}

function estimate(elen, e) {
    let Q = e[0];
    for (let i = 1; i < elen; i++) Q += e[i];
    return Q;
}

function vec(n) {
    return new Float64Array(n);
}

;// ../../node_modules/robust-predicates/esm/orient2d.js


const ccwerrboundA = (3 + 16 * epsilon) * epsilon;
const ccwerrboundB = (2 + 12 * epsilon) * epsilon;
const ccwerrboundC = (9 + 64 * epsilon) * epsilon * epsilon;

const B = vec(4);
const C1 = vec(8);
const C2 = vec(12);
const D = vec(16);
const u = vec(4);

function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;

    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;

    s1 = acx * bcy;
    c = splitter * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = splitter * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = splitter * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = splitter * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    B[3] = u3;

    let det = estimate(4, B);
    let errbound = ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) {
        return det;
    }

    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);

    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) {
        return det;
    }

    errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
    det += (acx * bcytail + bcy * acxtail) - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;

    s1 = acxtail * bcy;
    c = splitter * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = splitter * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = splitter * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = splitter * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C1len = sum(4, B, 4, u, C1);

    s1 = acx * bcytail;
    c = splitter * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = splitter * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = splitter * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = splitter * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C2len = sum(C1len, C1, 4, u, C2);

    s1 = acxtail * bcytail;
    c = splitter * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = splitter * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = splitter * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = splitter * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const Dlen = sum(C2len, C2, 4, u, D);

    return D[Dlen - 1];
}

function orient2d(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;

    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= ccwerrboundA * detsum) return det;

    return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}

function orient2dfast(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}

;// ../../node_modules/robust-predicates/esm/orient3d.js
/* unused harmony import specifier */ var orient3d_sum;
/* unused harmony import specifier */ var orient3d_splitter;
/* unused harmony import specifier */ var orient3d_scale;
/* unused harmony import specifier */ var orient3d_estimate;
/* unused harmony import specifier */ var orient3d_resulterrbound;


const o3derrboundA = (7 + 56 * epsilon) * epsilon;
const o3derrboundB = (3 + 28 * epsilon) * epsilon;
const o3derrboundC = (26 + 288 * epsilon) * epsilon * epsilon;

const bc = vec(4);
const ca = vec(4);
const ab = vec(4);
const at_b = vec(4);
const at_c = vec(4);
const bt_c = vec(4);
const bt_a = vec(4);
const ct_a = vec(4);
const ct_b = vec(4);
const bct = vec(8);
const cat = vec(8);
const abt = vec(8);
const orient3d_u = vec(4);

const _8 = vec(8);
const _8b = vec(8);
const _16 = vec(16);
const _12 = vec(12);

let fin = vec(192);
let fin2 = vec(192);

function finadd(finlen, alen, a) {
    finlen = orient3d_sum(finlen, fin, alen, a, fin2);
    const tmp = fin; fin = fin2; fin2 = tmp;
    return finlen;
}

function tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        }
        negate = -ytail;
        s1 = negate * ax;
        c = orient3d_splitter * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = orient3d_splitter * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        s1 = ytail * bx;
        c = orient3d_splitter * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = orient3d_splitter * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    }
    if (ytail === 0) {
        s1 = xtail * ay;
        c = orient3d_splitter * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = orient3d_splitter * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = orient3d_splitter * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = orient3d_splitter * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    }
    s1 = xtail * ay;
    c = orient3d_splitter * xtail;
    ahi = c - (c - xtail);
    alo = xtail - ahi;
    c = orient3d_splitter * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ytail * ax;
    c = orient3d_splitter * ytail;
    ahi = c - (c - ytail);
    alo = ytail - ahi;
    c = orient3d_splitter * ax;
    bhi = c - (c - ax);
    blo = ax - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    a[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    a[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    a[2] = _j - (u3 - bvirt) + (_i - bvirt);
    a[3] = u3;
    s1 = ytail * bx;
    c = orient3d_splitter * ytail;
    ahi = c - (c - ytail);
    alo = ytail - ahi;
    c = orient3d_splitter * bx;
    bhi = c - (c - bx);
    blo = bx - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = xtail * by;
    c = orient3d_splitter * xtail;
    ahi = c - (c - xtail);
    alo = xtail - ahi;
    c = orient3d_splitter * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    b[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    b[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    b[2] = _j - (u3 - bvirt) + (_i - bvirt);
    b[3] = u3;
    return 4;
}

function tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = orient3d_splitter * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = orient3d_splitter * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = orient3d_splitter * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = orient3d_splitter * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    orient3d_u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = orient3d_splitter * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    orient3d_u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    orient3d_u[2] = _k - (u3 - _j);
    orient3d_u[3] = u3;
    finlen = finadd(finlen, 4, orient3d_u);
    if (z !== 0) {
        c = orient3d_splitter * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = orient3d_splitter * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        orient3d_u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = orient3d_splitter * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        orient3d_u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        orient3d_u[2] = _k - (u3 - _j);
        orient3d_u[3] = u3;
        finlen = finadd(finlen, 4, orient3d_u);
    }
    return finlen;
}

function orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;

    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;

    s1 = bdx * cdy;
    c = orient3d_splitter * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = orient3d_splitter * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = orient3d_splitter * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = orient3d_splitter * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cdx * ady;
    c = orient3d_splitter * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = orient3d_splitter * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = orient3d_splitter * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = orient3d_splitter * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ca[3] = u3;
    s1 = adx * bdy;
    c = orient3d_splitter * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = orient3d_splitter * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = orient3d_splitter * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = orient3d_splitter * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;

    finlen = orient3d_sum(
        orient3d_sum(
            orient3d_scale(4, bc, adz, _8), _8,
            orient3d_scale(4, ca, bdz, _8b), _8b, _16), _16,
        orient3d_scale(4, ab, cdz, _8), _8, fin);

    let det = orient3d_estimate(finlen, fin);
    let errbound = o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) {
        return det;
    }

    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);

    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 &&
        adytail === 0 && bdytail === 0 && cdytail === 0 &&
        adztail === 0 && bdztail === 0 && cdztail === 0) {
        return det;
    }

    errbound = o3derrboundC * permanent + orient3d_resulterrbound * Math.abs(det);
    det +=
        adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) +
        bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) +
        cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) {
        return det;
    }

    const at_len = tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, at_b, at_c);
    const bt_len = tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, bt_c, bt_a);
    const ct_len = tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, ct_a, ct_b);

    const bctlen = orient3d_sum(bt_len, bt_c, ct_len, ct_b, bct);
    finlen = finadd(finlen, orient3d_scale(bctlen, bct, adz, _16), _16);

    const catlen = orient3d_sum(ct_len, ct_a, at_len, at_c, cat);
    finlen = finadd(finlen, orient3d_scale(catlen, cat, bdz, _16), _16);

    const abtlen = orient3d_sum(at_len, at_b, bt_len, bt_a, abt);
    finlen = finadd(finlen, orient3d_scale(abtlen, abt, cdz, _16), _16);

    if (adztail !== 0) {
        finlen = finadd(finlen, orient3d_scale(4, bc, adztail, _12), _12);
        finlen = finadd(finlen, orient3d_scale(bctlen, bct, adztail, _16), _16);
    }
    if (bdztail !== 0) {
        finlen = finadd(finlen, orient3d_scale(4, ca, bdztail, _12), _12);
        finlen = finadd(finlen, orient3d_scale(catlen, cat, bdztail, _16), _16);
    }
    if (cdztail !== 0) {
        finlen = finadd(finlen, orient3d_scale(4, ab, cdztail, _12), _12);
        finlen = finadd(finlen, orient3d_scale(abtlen, abt, cdztail, _16), _16);
    }

    if (adxtail !== 0) {
        if (bdytail !== 0) {
            finlen = tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        }
        if (cdytail !== 0) {
            finlen = tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
        }
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) {
            finlen = tailadd(finlen, bdxtail, cdytail, adz, adztail);
        }
        if (adytail !== 0) {
            finlen = tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
        }
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) {
            finlen = tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        }
        if (bdytail !== 0) {
            finlen = tailadd(finlen, -cdxtail, bdytail, adz, adztail);
        }
    }

    return fin[finlen - 1];
}

function orient3d(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;

    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;

    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;

    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;

    const det =
        adz * (bdxcdy - cdxbdy) +
        bdz * (cdxady - adxcdy) +
        cdz * (adxbdy - bdxady);

    const permanent =
        (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) +
        (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) +
        (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);

    const errbound = o3derrboundA * permanent;
    if (det > errbound || -det > errbound) {
        return det;
    }

    return orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}

function orient3dfast(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;

    return adx * (bdy * cdz - bdz * cdy) +
        bdx * (cdy * adz - cdz * ady) +
        cdx * (ady * bdz - adz * bdy);
}

;// ../../node_modules/robust-predicates/esm/incircle.js
/* unused harmony import specifier */ var incircle_sum;
/* unused harmony import specifier */ var incircle_splitter;
/* unused harmony import specifier */ var incircle_scale;
/* unused harmony import specifier */ var incircle_estimate;
/* unused harmony import specifier */ var incircle_resulterrbound;
/* unused harmony import specifier */ var incircle_sum_three;


const iccerrboundA = (10 + 96 * epsilon) * epsilon;
const iccerrboundB = (4 + 48 * epsilon) * epsilon;
const iccerrboundC = (44 + 576 * epsilon) * epsilon * epsilon;

const incircle_bc = vec(4);
const incircle_ca = vec(4);
const incircle_ab = vec(4);
const aa = vec(4);
const bb = vec(4);
const cc = vec(4);
const incircle_u = vec(4);
const v = vec(4);
const axtbc = vec(8);
const aytbc = vec(8);
const bxtca = vec(8);
const bytca = vec(8);
const cxtab = vec(8);
const cytab = vec(8);
const incircle_abt = vec(8);
const incircle_bct = vec(8);
const incircle_cat = vec(8);
const abtt = vec(4);
const bctt = vec(4);
const catt = vec(4);

const incircle_8 = vec(8);
const incircle_16 = vec(16);
const _16b = vec(16);
const _16c = vec(16);
const _32 = vec(32);
const _32b = vec(32);
const _48 = vec(48);
const _64 = vec(64);

let incircle_fin = vec(1152);
let incircle_fin2 = vec(1152);

function incircle_finadd(finlen, a, alen) {
    finlen = incircle_sum(finlen, incircle_fin, a, alen, incircle_fin2);
    const tmp = incircle_fin; incircle_fin = incircle_fin2; incircle_fin2 = tmp;
    return finlen;
}

function incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;

    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;

    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;

    s1 = bdx * cdy;
    c = incircle_splitter * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = incircle_splitter * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = incircle_splitter * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = incircle_splitter * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    incircle_bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    incircle_bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    incircle_bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    incircle_bc[3] = u3;
    s1 = cdx * ady;
    c = incircle_splitter * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = incircle_splitter * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = incircle_splitter * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = incircle_splitter * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    incircle_ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    incircle_ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    incircle_ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    incircle_ca[3] = u3;
    s1 = adx * bdy;
    c = incircle_splitter * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = incircle_splitter * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = incircle_splitter * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = incircle_splitter * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    incircle_ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    incircle_ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    incircle_ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    incircle_ab[3] = u3;

    finlen = incircle_sum(
        incircle_sum(
            incircle_sum(
                incircle_scale(incircle_scale(4, incircle_bc, adx, incircle_8), incircle_8, adx, incircle_16), incircle_16,
                incircle_scale(incircle_scale(4, incircle_bc, ady, incircle_8), incircle_8, ady, _16b), _16b, _32), _32,
            incircle_sum(
                incircle_scale(incircle_scale(4, incircle_ca, bdx, incircle_8), incircle_8, bdx, incircle_16), incircle_16,
                incircle_scale(incircle_scale(4, incircle_ca, bdy, incircle_8), incircle_8, bdy, _16b), _16b, _32b), _32b, _64), _64,
        incircle_sum(
            incircle_scale(incircle_scale(4, incircle_ab, cdx, incircle_8), incircle_8, cdx, incircle_16), incircle_16,
            incircle_scale(incircle_scale(4, incircle_ab, cdy, incircle_8), incircle_8, cdy, _16b), _16b, _32), _32, incircle_fin);

    let det = incircle_estimate(finlen, incircle_fin);
    let errbound = iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) {
        return det;
    }

    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) {
        return det;
    }

    errbound = iccerrboundC * permanent + incircle_resulterrbound * Math.abs(det);
    det += ((adx * adx + ady * ady) * ((bdx * cdytail + cdy * bdxtail) - (bdy * cdxtail + cdx * bdytail)) +
        2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx)) +
        ((bdx * bdx + bdy * bdy) * ((cdx * adytail + ady * cdxtail) - (cdy * adxtail + adx * cdytail)) +
        2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) +
        ((cdx * cdx + cdy * cdy) * ((adx * bdytail + bdy * adxtail) - (ady * bdxtail + bdx * adytail)) +
        2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));

    if (det >= errbound || -det >= errbound) {
        return det;
    }

    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = incircle_splitter * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = incircle_splitter * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = incircle_splitter * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = incircle_splitter * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = incircle_splitter * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = incircle_splitter * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        cc[3] = u3;
    }

    if (adxtail !== 0) {
        axtbclen = incircle_scale(4, incircle_bc, adxtail, axtbc);
        finlen = incircle_finadd(finlen, incircle_sum_three(
            incircle_scale(axtbclen, axtbc, 2 * adx, incircle_16), incircle_16,
            incircle_scale(incircle_scale(4, cc, adxtail, incircle_8), incircle_8, bdy, _16b), _16b,
            incircle_scale(incircle_scale(4, bb, adxtail, incircle_8), incircle_8, -cdy, _16c), _16c, _32, _48), _48);
    }
    if (adytail !== 0) {
        aytbclen = incircle_scale(4, incircle_bc, adytail, aytbc);
        finlen = incircle_finadd(finlen, incircle_sum_three(
            incircle_scale(aytbclen, aytbc, 2 * ady, incircle_16), incircle_16,
            incircle_scale(incircle_scale(4, bb, adytail, incircle_8), incircle_8, cdx, _16b), _16b,
            incircle_scale(incircle_scale(4, cc, adytail, incircle_8), incircle_8, -bdx, _16c), _16c, _32, _48), _48);
    }
    if (bdxtail !== 0) {
        bxtcalen = incircle_scale(4, incircle_ca, bdxtail, bxtca);
        finlen = incircle_finadd(finlen, incircle_sum_three(
            incircle_scale(bxtcalen, bxtca, 2 * bdx, incircle_16), incircle_16,
            incircle_scale(incircle_scale(4, aa, bdxtail, incircle_8), incircle_8, cdy, _16b), _16b,
            incircle_scale(incircle_scale(4, cc, bdxtail, incircle_8), incircle_8, -ady, _16c), _16c, _32, _48), _48);
    }
    if (bdytail !== 0) {
        bytcalen = incircle_scale(4, incircle_ca, bdytail, bytca);
        finlen = incircle_finadd(finlen, incircle_sum_three(
            incircle_scale(bytcalen, bytca, 2 * bdy, incircle_16), incircle_16,
            incircle_scale(incircle_scale(4, cc, bdytail, incircle_8), incircle_8, adx, _16b), _16b,
            incircle_scale(incircle_scale(4, aa, bdytail, incircle_8), incircle_8, -cdx, _16c), _16c, _32, _48), _48);
    }
    if (cdxtail !== 0) {
        cxtablen = incircle_scale(4, incircle_ab, cdxtail, cxtab);
        finlen = incircle_finadd(finlen, incircle_sum_three(
            incircle_scale(cxtablen, cxtab, 2 * cdx, incircle_16), incircle_16,
            incircle_scale(incircle_scale(4, bb, cdxtail, incircle_8), incircle_8, ady, _16b), _16b,
            incircle_scale(incircle_scale(4, aa, cdxtail, incircle_8), incircle_8, -bdy, _16c), _16c, _32, _48), _48);
    }
    if (cdytail !== 0) {
        cytablen = incircle_scale(4, incircle_ab, cdytail, cytab);
        finlen = incircle_finadd(finlen, incircle_sum_three(
            incircle_scale(cytablen, cytab, 2 * cdy, incircle_16), incircle_16,
            incircle_scale(incircle_scale(4, aa, cdytail, incircle_8), incircle_8, bdx, _16b), _16b,
            incircle_scale(incircle_scale(4, bb, cdytail, incircle_8), incircle_8, -adx, _16c), _16c, _32, _48), _48);
    }

    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = incircle_splitter * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = incircle_splitter * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = incircle_splitter * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = incircle_splitter * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            incircle_u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            incircle_u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            incircle_u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            incircle_u[3] = u3;
            s1 = cdxtail * -bdy;
            c = incircle_splitter * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = incircle_splitter * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = incircle_splitter * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = incircle_splitter * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            bctlen = incircle_sum(4, incircle_u, 4, v, incircle_bct);
            s1 = bdxtail * cdytail;
            c = incircle_splitter * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = incircle_splitter * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = incircle_splitter * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = incircle_splitter * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            bctt[3] = u3;
            bcttlen = 4;
        } else {
            incircle_bct[0] = 0;
            bctlen = 1;
            bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = incircle_scale(bctlen, incircle_bct, adxtail, _16c);
            finlen = incircle_finadd(finlen, incircle_sum(
                incircle_scale(axtbclen, axtbc, adxtail, incircle_16), incircle_16,
                incircle_scale(len, _16c, 2 * adx, _32), _32, _48), _48);

            const len2 = incircle_scale(bcttlen, bctt, adxtail, incircle_8);
            finlen = incircle_finadd(finlen, incircle_sum_three(
                incircle_scale(len2, incircle_8, 2 * adx, incircle_16), incircle_16,
                incircle_scale(len2, incircle_8, adxtail, _16b), _16b,
                incircle_scale(len, _16c, adxtail, _32), _32, _32b, _64), _64);

            if (bdytail !== 0) {
                finlen = incircle_finadd(finlen, incircle_scale(incircle_scale(4, cc, adxtail, incircle_8), incircle_8, bdytail, incircle_16), incircle_16);
            }
            if (cdytail !== 0) {
                finlen = incircle_finadd(finlen, incircle_scale(incircle_scale(4, bb, -adxtail, incircle_8), incircle_8, cdytail, incircle_16), incircle_16);
            }
        }
        if (adytail !== 0) {
            const len = incircle_scale(bctlen, incircle_bct, adytail, _16c);
            finlen = incircle_finadd(finlen, incircle_sum(
                incircle_scale(aytbclen, aytbc, adytail, incircle_16), incircle_16,
                incircle_scale(len, _16c, 2 * ady, _32), _32, _48), _48);

            const len2 = incircle_scale(bcttlen, bctt, adytail, incircle_8);
            finlen = incircle_finadd(finlen, incircle_sum_three(
                incircle_scale(len2, incircle_8, 2 * ady, incircle_16), incircle_16,
                incircle_scale(len2, incircle_8, adytail, _16b), _16b,
                incircle_scale(len, _16c, adytail, _32), _32, _32b, _64), _64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = incircle_splitter * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = incircle_splitter * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = incircle_splitter * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = incircle_splitter * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            incircle_u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            incircle_u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            incircle_u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            incircle_u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = incircle_splitter * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = incircle_splitter * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = incircle_splitter * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = incircle_splitter * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            catlen = incircle_sum(4, incircle_u, 4, v, incircle_cat);
            s1 = cdxtail * adytail;
            c = incircle_splitter * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = incircle_splitter * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = incircle_splitter * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = incircle_splitter * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            catt[3] = u3;
            cattlen = 4;
        } else {
            incircle_cat[0] = 0;
            catlen = 1;
            catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = incircle_scale(catlen, incircle_cat, bdxtail, _16c);
            finlen = incircle_finadd(finlen, incircle_sum(
                incircle_scale(bxtcalen, bxtca, bdxtail, incircle_16), incircle_16,
                incircle_scale(len, _16c, 2 * bdx, _32), _32, _48), _48);

            const len2 = incircle_scale(cattlen, catt, bdxtail, incircle_8);
            finlen = incircle_finadd(finlen, incircle_sum_three(
                incircle_scale(len2, incircle_8, 2 * bdx, incircle_16), incircle_16,
                incircle_scale(len2, incircle_8, bdxtail, _16b), _16b,
                incircle_scale(len, _16c, bdxtail, _32), _32, _32b, _64), _64);

            if (cdytail !== 0) {
                finlen = incircle_finadd(finlen, incircle_scale(incircle_scale(4, aa, bdxtail, incircle_8), incircle_8, cdytail, incircle_16), incircle_16);
            }
            if (adytail !== 0) {
                finlen = incircle_finadd(finlen, incircle_scale(incircle_scale(4, cc, -bdxtail, incircle_8), incircle_8, adytail, incircle_16), incircle_16);
            }
        }
        if (bdytail !== 0) {
            const len = incircle_scale(catlen, incircle_cat, bdytail, _16c);
            finlen = incircle_finadd(finlen, incircle_sum(
                incircle_scale(bytcalen, bytca, bdytail, incircle_16), incircle_16,
                incircle_scale(len, _16c, 2 * bdy, _32), _32, _48), _48);

            const len2 = incircle_scale(cattlen, catt, bdytail, incircle_8);
            finlen = incircle_finadd(finlen, incircle_sum_three(
                incircle_scale(len2, incircle_8, 2 * bdy, incircle_16), incircle_16,
                incircle_scale(len2, incircle_8, bdytail, _16b), _16b,
                incircle_scale(len, _16c, bdytail, _32), _32,  _32b, _64), _64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = incircle_splitter * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = incircle_splitter * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = incircle_splitter * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = incircle_splitter * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            incircle_u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            incircle_u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            incircle_u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            incircle_u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = incircle_splitter * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = incircle_splitter * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = incircle_splitter * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = incircle_splitter * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            abtlen = incircle_sum(4, incircle_u, 4, v, incircle_abt);
            s1 = adxtail * bdytail;
            c = incircle_splitter * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = incircle_splitter * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = incircle_splitter * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = incircle_splitter * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            abtt[3] = u3;
            abttlen = 4;
        } else {
            incircle_abt[0] = 0;
            abtlen = 1;
            abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = incircle_scale(abtlen, incircle_abt, cdxtail, _16c);
            finlen = incircle_finadd(finlen, incircle_sum(
                incircle_scale(cxtablen, cxtab, cdxtail, incircle_16), incircle_16,
                incircle_scale(len, _16c, 2 * cdx, _32), _32, _48), _48);

            const len2 = incircle_scale(abttlen, abtt, cdxtail, incircle_8);
            finlen = incircle_finadd(finlen, incircle_sum_three(
                incircle_scale(len2, incircle_8, 2 * cdx, incircle_16), incircle_16,
                incircle_scale(len2, incircle_8, cdxtail, _16b), _16b,
                incircle_scale(len, _16c, cdxtail, _32), _32, _32b, _64), _64);

            if (adytail !== 0) {
                finlen = incircle_finadd(finlen, incircle_scale(incircle_scale(4, bb, cdxtail, incircle_8), incircle_8, adytail, incircle_16), incircle_16);
            }
            if (bdytail !== 0) {
                finlen = incircle_finadd(finlen, incircle_scale(incircle_scale(4, aa, -cdxtail, incircle_8), incircle_8, bdytail, incircle_16), incircle_16);
            }
        }
        if (cdytail !== 0) {
            const len = incircle_scale(abtlen, incircle_abt, cdytail, _16c);
            finlen = incircle_finadd(finlen, incircle_sum(
                incircle_scale(cytablen, cytab, cdytail, incircle_16), incircle_16,
                incircle_scale(len, _16c, 2 * cdy, _32), _32, _48), _48);

            const len2 = incircle_scale(abttlen, abtt, cdytail, incircle_8);
            finlen = incircle_finadd(finlen, incircle_sum_three(
                incircle_scale(len2, incircle_8, 2 * cdy, incircle_16), incircle_16,
                incircle_scale(len2, incircle_8, cdytail, _16b), _16b,
                incircle_scale(len, _16c, cdytail, _32), _32, _32b, _64), _64);
        }
    }

    return incircle_fin[finlen - 1];
}

function incircle(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;

    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;

    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;

    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;

    const det =
        alift * (bdxcdy - cdxbdy) +
        blift * (cdxady - adxcdy) +
        clift * (adxbdy - bdxady);

    const permanent =
        (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift +
        (Math.abs(cdxady) + Math.abs(adxcdy)) * blift +
        (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;

    const errbound = iccerrboundA * permanent;

    if (det > errbound || -det > errbound) {
        return det;
    }
    return incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}

function incirclefast(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;

    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;

    return alift * bcdet + blift * cadet + clift * abdet;
}

;// ../../node_modules/robust-predicates/esm/insphere.js
/* unused harmony import specifier */ var insphere_sum_three;
/* unused harmony import specifier */ var insphere_scale;
/* unused harmony import specifier */ var insphere_sum;
/* unused harmony import specifier */ var insphere_negate;
/* unused harmony import specifier */ var insphere_splitter;
/* unused harmony import specifier */ var insphere_estimate;
/* unused harmony import specifier */ var insphere_resulterrbound;


const isperrboundA = (16 + 224 * epsilon) * epsilon;
const isperrboundB = (5 + 72 * epsilon) * epsilon;
const isperrboundC = (71 + 1408 * epsilon) * epsilon * epsilon;

const insphere_ab = vec(4);
const insphere_bc = vec(4);
const cd = vec(4);
const de = vec(4);
const ea = vec(4);
const ac = vec(4);
const bd = vec(4);
const ce = vec(4);
const da = vec(4);
const eb = vec(4);

const abc = vec(24);
const bcd = vec(24);
const cde = vec(24);
const dea = vec(24);
const eab = vec(24);
const abd = vec(24);
const bce = vec(24);
const cda = vec(24);
const deb = vec(24);
const eac = vec(24);

const adet = vec(1152);
const bdet = vec(1152);
const cdet = vec(1152);
const ddet = vec(1152);
const edet = vec(1152);
const abdet = vec(2304);
const cddet = vec(2304);
const cdedet = vec(3456);
const deter = vec(5760);

const insphere_8 = vec(8);
const insphere_8b = vec(8);
const _8c = vec(8);
const insphere_16 = vec(16);
const _24 = vec(24);
const insphere_48 = vec(48);
const _48b = vec(48);
const _96 = vec(96);
const _192 = vec(192);
const _384x = vec(384);
const _384y = vec(384);
const _384z = vec(384);
const _768 = vec(768);

function sum_three_scale(a, b, c, az, bz, cz, out) {
    return insphere_sum_three(
        insphere_scale(4, a, az, insphere_8), insphere_8,
        insphere_scale(4, b, bz, insphere_8b), insphere_8b,
        insphere_scale(4, c, cz, _8c), _8c, insphere_16, out);
}

function liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = insphere_sum(
        insphere_sum(alen, a, blen, b, insphere_48), insphere_48,
        insphere_negate(insphere_sum(clen, c, dlen, d, _48b), _48b), _48b, _96);

    return insphere_sum_three(
        insphere_scale(insphere_scale(len, _96, x, _192), _192, x, _384x), _384x,
        insphere_scale(insphere_scale(len, _96, y, _192), _192, y, _384y), _384y,
        insphere_scale(insphere_scale(len, _96, z, _192), _192, z, _384z), _384z, _768, out);
}

function insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;

    s1 = ax * by;
    c = insphere_splitter * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = insphere_splitter * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = insphere_splitter * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = insphere_splitter * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    insphere_ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    insphere_ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    insphere_ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    insphere_ab[3] = u3;
    s1 = bx * cy;
    c = insphere_splitter * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = insphere_splitter * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = insphere_splitter * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = insphere_splitter * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    insphere_bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    insphere_bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    insphere_bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    insphere_bc[3] = u3;
    s1 = cx * dy;
    c = insphere_splitter * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = insphere_splitter * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = insphere_splitter * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = insphere_splitter * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    cd[3] = u3;
    s1 = dx * ey;
    c = insphere_splitter * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = insphere_splitter * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = insphere_splitter * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = insphere_splitter * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    de[3] = u3;
    s1 = ex * ay;
    c = insphere_splitter * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = insphere_splitter * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = insphere_splitter * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = insphere_splitter * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ea[3] = u3;
    s1 = ax * cy;
    c = insphere_splitter * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = insphere_splitter * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = insphere_splitter * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = insphere_splitter * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ac[3] = u3;
    s1 = bx * dy;
    c = insphere_splitter * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = insphere_splitter * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = insphere_splitter * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = insphere_splitter * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bd[3] = u3;
    s1 = cx * ey;
    c = insphere_splitter * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = insphere_splitter * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = insphere_splitter * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = insphere_splitter * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ce[3] = u3;
    s1 = dx * ay;
    c = insphere_splitter * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = insphere_splitter * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = insphere_splitter * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = insphere_splitter * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    da[3] = u3;
    s1 = ex * by;
    c = insphere_splitter * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = insphere_splitter * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = insphere_splitter * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = insphere_splitter * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    eb[3] = u3;

    const abclen = sum_three_scale(insphere_ab, insphere_bc, ac, cz, az, -bz, abc);
    const bcdlen = sum_three_scale(insphere_bc, cd, bd, dz, bz, -cz, bcd);
    const cdelen = sum_three_scale(cd, de, ce, ez, cz, -dz, cde);
    const dealen = sum_three_scale(de, ea, da, az, dz, -ez, dea);
    const eablen = sum_three_scale(ea, insphere_ab, eb, bz, ez, -az, eab);
    const abdlen = sum_three_scale(insphere_ab, bd, da, dz, az, bz, abd);
    const bcelen = sum_three_scale(insphere_bc, ce, eb, ez, bz, cz, bce);
    const cdalen = sum_three_scale(cd, da, ac, az, cz, dz, cda);
    const deblen = sum_three_scale(de, eb, bd, bz, dz, ez, deb);
    const eaclen = sum_three_scale(ea, ac, ce, cz, ez, az, eac);

    const deterlen = insphere_sum_three(
        liftexact(cdelen, cde, bcelen, bce, deblen, deb, bcdlen, bcd, ax, ay, az, adet), adet,
        liftexact(dealen, dea, cdalen, cda, eaclen, eac, cdelen, cde, bx, by, bz, bdet), bdet,
        insphere_sum_three(
            liftexact(eablen, eab, deblen, deb, abdlen, abd, dealen, dea, cx, cy, cz, cdet), cdet,
            liftexact(abclen, abc, eaclen, eac, bcelen, bce, eablen, eab, dx, dy, dz, ddet), ddet,
            liftexact(bcdlen, bcd, abdlen, abd, cdalen, cda, abclen, abc, ex, ey, ez, edet), edet, cddet, cdedet), cdedet, abdet, deter);

    return deter[deterlen - 1];
}

const xdet = vec(96);
const ydet = vec(96);
const zdet = vec(96);
const insphere_fin = vec(1152);

function liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = sum_three_scale(a, b, c, az, bz, cz, _24);
    return insphere_sum_three(
        insphere_scale(insphere_scale(len, _24, x, insphere_48), insphere_48, x, xdet), xdet,
        insphere_scale(insphere_scale(len, _24, y, insphere_48), insphere_48, y, ydet), ydet,
        insphere_scale(insphere_scale(len, _24, z, insphere_48), insphere_48, z, zdet), zdet, _192, out);
}

function insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;

    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;

    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;

    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;

    s1 = aex * bey;
    c = insphere_splitter * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = insphere_splitter * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = insphere_splitter * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = insphere_splitter * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    insphere_ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    insphere_ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    insphere_ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    insphere_ab[3] = ab3;
    s1 = bex * cey;
    c = insphere_splitter * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = insphere_splitter * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = insphere_splitter * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = insphere_splitter * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    insphere_bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    insphere_bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    insphere_bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    insphere_bc[3] = bc3;
    s1 = cex * dey;
    c = insphere_splitter * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = insphere_splitter * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = insphere_splitter * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = insphere_splitter * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    cd[3] = cd3;
    s1 = dex * aey;
    c = insphere_splitter * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = insphere_splitter * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = insphere_splitter * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = insphere_splitter * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    da[3] = da3;
    s1 = aex * cey;
    c = insphere_splitter * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = insphere_splitter * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = insphere_splitter * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = insphere_splitter * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    ac[3] = ac3;
    s1 = bex * dey;
    c = insphere_splitter * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = insphere_splitter * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = insphere_splitter * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = insphere_splitter * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    bd[3] = bd3;

    const finlen = insphere_sum(
        insphere_sum(
            insphere_negate(liftadapt(insphere_bc, cd, bd, dez, bez, -cez, aex, aey, aez, adet), adet), adet,
            liftadapt(cd, da, ac, aez, cez, dez, bex, bey, bez, bdet), bdet, abdet), abdet,
        insphere_sum(
            insphere_negate(liftadapt(da, insphere_ab, bd, bez, dez, aez, cex, cey, cez, cdet), cdet), cdet,
            liftadapt(insphere_ab, insphere_bc, ac, cez, aez, -bez, dex, dey, dez, ddet), ddet, cddet), cddet, insphere_fin);

    let det = insphere_estimate(finlen, insphere_fin);
    let errbound = isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) {
        return det;
    }

    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 &&
        bextail === 0 && beytail === 0 && beztail === 0 &&
        cextail === 0 && ceytail === 0 && ceztail === 0 &&
        dextail === 0 && deytail === 0 && deztail === 0) {
        return det;
    }

    errbound = isperrboundC * permanent + insphere_resulterrbound * Math.abs(det);

    const abeps = (aex * beytail + bey * aextail) - (aey * bextail + bex * aeytail);
    const bceps = (bex * ceytail + cey * bextail) - (bey * cextail + cex * beytail);
    const cdeps = (cex * deytail + dey * cextail) - (cey * dextail + dex * ceytail);
    const daeps = (dex * aeytail + aey * dextail) - (dey * aextail + aex * deytail);
    const aceps = (aex * ceytail + cey * aextail) - (aey * cextail + cex * aeytail);
    const bdeps = (bex * deytail + dey * bextail) - (bey * dextail + dex * beytail);
    det +=
        (((bex * bex + bey * bey + bez * bez) * ((cez * daeps + dez * aceps + aez * cdeps) +
        (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) *
        ((aez * bceps - bez * aceps + cez * abeps) + (aeztail * bc3 - beztail * ac3 + ceztail * ab3))) -
        ((aex * aex + aey * aey + aez * aez) * ((bez * cdeps - cez * bdeps + dez * bceps) +
        (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) *
        ((dez * abeps + aez * bdeps + bez * daeps) + (deztail * ab3 + aeztail * bd3 + beztail * da3)))) +
        2 * (((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) +
        (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3)) -
        ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) +
        (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));

    if (det >= errbound || -det >= errbound) {
        return det;
    }

    return insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}

function insphere(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;

    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;

    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;

    const det =
        (clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab)) +
        (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));

    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent =
        (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift +
        (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift +
        (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift +
        (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;

    const errbound = isperrboundA * permanent;
    if (det > errbound || -det > errbound) {
        return det;
    }
    return -insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}

function inspherefast(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;

    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;

    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;

    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;

    return (clift * dab - dlift * abc) + (alift * bcd - blift * cda);
}

;// ../../node_modules/robust-predicates/index.js






;// ../../node_modules/concaveman/index.js






function concaveman(points, concavity, lengthThreshold) {
    // a relative measure of concavity; higher value means simpler hull
    concavity = Math.max(0, concavity === undefined ? 2 : concavity);

    // when a segment goes below this length threshold, it won't be drilled down further
    lengthThreshold = lengthThreshold || 0;

    // start with a convex hull of the points
    const hull = fastConvexHull(points);

    // index the points with an R-tree
    const tree = new RBush(16);
    tree.toBBox = function (a) {
        return {
            minX: a[0],
            minY: a[1],
            maxX: a[0],
            maxY: a[1]
        };
    };
    tree.compareMinX = function (a, b) { return a[0] - b[0]; };
    tree.compareMinY = function (a, b) { return a[1] - b[1]; };

    tree.load(points);

    // turn the convex hull into a linked list and populate the initial edge queue with the nodes
    const queue = [];
    let last;
    for (let i = 0; i < hull.length; i++) {
        const p = hull[i];
        tree.remove(p);
        last = insertNode(p, last);
        queue.push(last);
    }

    // index the segments with an R-tree (for intersection checks)
    const segTree = new RBush(16);
    for (let i = 0; i < queue.length; i++) segTree.insert(updateBBox(queue[i]));

    const sqConcavity = concavity * concavity;
    const sqLenThreshold = lengthThreshold * lengthThreshold;

    // process edges one by one
    while (queue.length) {
        const node = queue.shift();
        const a = node.p;
        const b = node.next.p;

        // skip the edge if it's already short enough
        const sqLen = getSqDist(a, b);
        if (sqLen < sqLenThreshold) continue;

        const maxSqLen = sqLen / sqConcavity;

        // find the best connection point for the current edge to flex inward to
        const p = findCandidate(tree, node.prev.p, a, b, node.next.next.p, maxSqLen, segTree);

        // if we found a connection and it satisfies our concavity measure
        if (p && Math.min(getSqDist(p, a), getSqDist(p, b)) <= maxSqLen) {
            // connect the edge endpoints through this point and add 2 new edges to the queue
            queue.push(node);
            queue.push(insertNode(p, node));

            // update point and segment indexes
            tree.remove(p);
            segTree.remove(node);
            segTree.insert(updateBBox(node));
            segTree.insert(updateBBox(node.next));
        }
    }

    // convert the resulting hull linked list to an array of points
    let node = last;
    const concave = [];
    do {
        concave.push(node.p);
        node = node.next;
    } while (node !== last);

    concave.push(node.p);

    return concave;
}

function findCandidate(tree, a, b, c, d, maxDist, segTree) {
    const queue = new TinyQueue([], compareDist);
    let node = tree.data;

    // search through the point R-tree with a depth-first search using a priority queue
    // in the order of distance to the edge (b, c)
    while (node) {
        for (let i = 0; i < node.children.length; i++) {
            const child = node.children[i];

            const dist = node.leaf ? sqSegDist(child, b, c) : sqSegBoxDist(b, c, child);
            if (dist > maxDist) continue; // skip the node if it's farther than we ever need

            queue.push({
                node: child,
                dist
            });
        }

        while (queue.length && !queue.peek().node.children) {
            const item = queue.pop();
            const p = item.node;

            // skip all points that are as close to adjacent edges (a,b) and (c,d),
            // and points that would introduce self-intersections when connected
            const d0 = sqSegDist(p, a, b);
            const d1 = sqSegDist(p, c, d);
            if (item.dist < d0 && item.dist < d1 &&
                noIntersections(b, p, segTree) &&
                noIntersections(c, p, segTree)) return p;
        }

        node = queue.pop();
        if (node) node = node.node;
    }

    return null;
}

function compareDist(a, b) {
    return a.dist - b.dist;
}

// square distance from a segment bounding box to the given one
function sqSegBoxDist(a, b, bbox) {
    if (inside(a, bbox) || inside(b, bbox)) return 0;
    const d1 = sqSegSegDist(a[0], a[1], b[0], b[1], bbox.minX, bbox.minY, bbox.maxX, bbox.minY);
    if (d1 === 0) return 0;
    const d2 = sqSegSegDist(a[0], a[1], b[0], b[1], bbox.minX, bbox.minY, bbox.minX, bbox.maxY);
    if (d2 === 0) return 0;
    const d3 = sqSegSegDist(a[0], a[1], b[0], b[1], bbox.maxX, bbox.minY, bbox.maxX, bbox.maxY);
    if (d3 === 0) return 0;
    const d4 = sqSegSegDist(a[0], a[1], b[0], b[1], bbox.minX, bbox.maxY, bbox.maxX, bbox.maxY);
    if (d4 === 0) return 0;
    return Math.min(d1, d2, d3, d4);
}

function inside(a, bbox) {
    return a[0] >= bbox.minX &&
           a[0] <= bbox.maxX &&
           a[1] >= bbox.minY &&
           a[1] <= bbox.maxY;
}

// check if the edge (a,b) doesn't intersect any other edges
function noIntersections(a, b, segTree) {
    const minX = Math.min(a[0], b[0]);
    const minY = Math.min(a[1], b[1]);
    const maxX = Math.max(a[0], b[0]);
    const maxY = Math.max(a[1], b[1]);

    const edges = segTree.search({minX, minY, maxX, maxY});
    for (let i = 0; i < edges.length; i++) {
        if (concaveman_intersects(edges[i].p, edges[i].next.p, a, b)) return false;
    }
    return true;
}

function cross(p1, p2, p3) {
    return orient2d(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

// check if the edges (p1,q1) and (p2,q2) intersect
function concaveman_intersects(p1, q1, p2, q2) {
    return p1 !== q2 && q1 !== p2 &&
        cross(p1, q1, p2) > 0 !== cross(p1, q1, q2) > 0 &&
        cross(p2, q2, p1) > 0 !== cross(p2, q2, q1) > 0;
}

// update the bounding box of a node's edge
function updateBBox(node) {
    const p1 = node.p;
    const p2 = node.next.p;
    node.minX = Math.min(p1[0], p2[0]);
    node.minY = Math.min(p1[1], p2[1]);
    node.maxX = Math.max(p1[0], p2[0]);
    node.maxY = Math.max(p1[1], p2[1]);
    return node;
}

// speed up convex hull by filtering out points inside quadrilateral formed by 4 extreme points
function fastConvexHull(points) {
    let left = points[0];
    let top = points[0];
    let right = points[0];
    let bottom = points[0];

    // find the leftmost, rightmost, topmost and bottommost points
    for (let i = 0; i < points.length; i++) {
        const p = points[i];
        if (p[0] < left[0]) left = p;
        if (p[0] > right[0]) right = p;
        if (p[1] < top[1]) top = p;
        if (p[1] > bottom[1]) bottom = p;
    }

    // filter out points that are inside the resulting quadrilateral
    const cull = [left, top, right, bottom];
    const filtered = cull.slice();
    for (let i = 0; i < points.length; i++) {
        if (!point_in_polygon(points[i], cull)) filtered.push(points[i]);
    }

    // get convex hull around the filtered points
    return convexHull(filtered);
}

// create a new node in a doubly linked list
function insertNode(p, prev) {
    const node = {
        p,
        prev: null,
        next: null,
        minX: 0,
        minY: 0,
        maxX: 0,
        maxY: 0
    };

    if (!prev) {
        node.prev = node;
        node.next = node;

    } else {
        node.next = prev.next;
        node.prev = prev;
        prev.next.prev = node;
        prev.next = node;
    }
    return node;
}

// square distance between 2 points
function getSqDist(p1, p2) {

    const dx = p1[0] - p2[0],
        dy = p1[1] - p2[1];

    return dx * dx + dy * dy;
}

// square distance from a point to a segment
function sqSegDist(p, p1, p2) {

    let x = p1[0],
        y = p1[1],
        dx = p2[0] - x,
        dy = p2[1] - y;

    if (dx !== 0 || dy !== 0) {

        const t = ((p[0] - x) * dx + (p[1] - y) * dy) / (dx * dx + dy * dy);

        if (t > 1) {
            x = p2[0];
            y = p2[1];

        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }

    dx = p[0] - x;
    dy = p[1] - y;

    return dx * dx + dy * dy;
}

// segment to segment distance, ported from http://geomalgorithms.com/a07-_distance.html by Dan Sunday
function sqSegSegDist(x0, y0, x1, y1, x2, y2, x3, y3) {
    const ux = x1 - x0;
    const uy = y1 - y0;
    const vx = x3 - x2;
    const vy = y3 - y2;
    const wx = x0 - x2;
    const wy = y0 - y2;
    const a = ux * ux + uy * uy;
    const b = ux * vx + uy * vy;
    const c = vx * vx + vy * vy;
    const d = ux * wx + uy * wy;
    const e = vx * wx + vy * wy;
    const D = a * c - b * b;

    let sN, tN;
    let sD = D;
    let tD = D;

    if (D === 0) {
        sN = 0;
        sD = 1;
        tN = e;
        tD = c;
    } else {
        sN = b * e - c * d;
        tN = a * e - b * d;
        if (sN < 0) {
            sN = 0;
            tN = e;
            tD = c;
        } else if (sN > sD) {
            sN = sD;
            tN = e + b;
            tD = c;
        }
    }

    if (tN < 0.0) {
        tN = 0.0;
        if (-d < 0.0) sN = 0.0;
        else if (-d > a) sN = sD;
        else {
            sN = -d;
            sD = a;
        }
    } else if (tN > tD) {
        tN = tD;
        if ((-d + b) < 0.0) sN = 0;
        else if (-d + b > a) sN = sD;
        else {
            sN = -d + b;
            sD = a;
        }
    }

    const sc = sN === 0 ? 0 : sN / sD;
    const tc = tN === 0 ? 0 : tN / tD;

    const cx = (1 - sc) * x0 + sc * x1;
    const cy = (1 - sc) * y0 + sc * y1;
    const cx2 = (1 - tc) * x2 + tc * x3;
    const cy2 = (1 - tc) * y2 + tc * y3;
    const dx = cx2 - cx;
    const dy = cy2 - cy;

    return dx * dx + dy * dy;
}

function compareByX(a, b) {
    return a[0] === b[0] ? a[1] - b[1] : a[0] - b[0];
}

function convexHull(points) {
    points.sort(compareByX);

    const lower = [];
    for (let i = 0; i < points.length; i++) {
        while (lower.length >= 2 && cross(lower[lower.length - 2], lower[lower.length - 1], points[i]) <= 0) {
            lower.pop();
        }
        lower.push(points[i]);
    }

    const upper = [];
    for (let ii = points.length - 1; ii >= 0; ii--) {
        while (upper.length >= 2 && cross(upper[upper.length - 2], upper[upper.length - 1], points[ii]) <= 0) {
            upper.pop();
        }
        upper.push(points[ii]);
    }

    upper.pop();
    lower.pop();
    return lower.concat(upper);
}

;// ../../node_modules/@turf/convex/dist/es/index.js



/**
 * Takes a {@link Feature} or a {@link FeatureCollection} and returns a convex hull {@link Polygon}.
 *
 * Internally this uses
 * the [convex-hull](https://github.com/mikolalysenko/convex-hull) module that implements a
 * [monotone chain hull](http://en.wikibooks.org/wiki/Algorithm_Implementation/Geometry/Convex_hull/Monotone_chain).
 *
 * @name convex
 * @param {GeoJSON} geojson input Feature or FeatureCollection
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.concavity=Infinity] 1 - thin shape. Infinity - convex hull.
 * @param {Object} [options.properties={}] Translate Properties to Feature
 * @returns {Feature<Polygon>} a convex hull
 * @example
 * var points = turf.featureCollection([
 *   turf.point([10.195312, 43.755225]),
 *   turf.point([10.404052, 43.8424511]),
 *   turf.point([10.579833, 43.659924]),
 *   turf.point([10.360107, 43.516688]),
 *   turf.point([10.14038, 43.588348]),
 *   turf.point([10.195312, 43.755225])
 * ]);
 *
 * var hull = turf.convex(points);
 *
 * //addToMap
 * var addToMap = [points, hull]
 */
function convex(geojson, options) {
    if (options === void 0) { options = {}; }
    // Default parameters
    options.concavity = options.concavity || Infinity;
    // Container
    var points = [];
    // Convert all points to flat 2D coordinate Array
    coordEach(geojson, function (coord) {
        points.push([coord[0], coord[1]]);
    });
    if (!points.length) {
        return null;
    }
    var convexHull = concaveman(points, options.concavity);
    // Convex hull should have at least 3 different vertices in order to create a valid polygon
    if (convexHull.length > 3) {
        return polygon([convexHull]);
    }
    return null;
}

;// ../../node_modules/@turf/boolean-point-in-polygon/dist/es/index.js

// http://en.wikipedia.org/wiki/Even%E2%80%93odd_rule
// modified from: https://github.com/substack/point-in-polygon/blob/master/index.js
// which was modified from http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html
/**
 * Takes a {@link Point} and a {@link Polygon} or {@link MultiPolygon} and determines if the point
 * resides inside the polygon. The polygon can be convex or concave. The function accounts for holes.
 *
 * @name booleanPointInPolygon
 * @param {Coord} point input point
 * @param {Feature<Polygon|MultiPolygon>} polygon input polygon or multipolygon
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.ignoreBoundary=false] True if polygon boundary should be ignored when determining if
 * the point is inside the polygon otherwise false.
 * @returns {boolean} `true` if the Point is inside the Polygon; `false` if the Point is not inside the Polygon
 * @example
 * var pt = turf.point([-77, 44]);
 * var poly = turf.polygon([[
 *   [-81, 41],
 *   [-81, 47],
 *   [-72, 47],
 *   [-72, 41],
 *   [-81, 41]
 * ]]);
 *
 * turf.booleanPointInPolygon(pt, poly);
 * //= true
 */
function booleanPointInPolygon(point, polygon, options) {
    if (options === void 0) { options = {}; }
    // validation
    if (!point) {
        throw new Error("point is required");
    }
    if (!polygon) {
        throw new Error("polygon is required");
    }
    var pt = getCoord(point);
    var geom = getGeom(polygon);
    var type = geom.type;
    var bbox = polygon.bbox;
    var polys = geom.coordinates;
    // Quick elimination if point is not inside bbox
    if (bbox && inBBox(pt, bbox) === false) {
        return false;
    }
    // normalize to multipolygon
    if (type === "Polygon") {
        polys = [polys];
    }
    var insidePoly = false;
    for (var i = 0; i < polys.length && !insidePoly; i++) {
        // check if it is in the outer ring first
        if (inRing(pt, polys[i][0], options.ignoreBoundary)) {
            var inHole = false;
            var k = 1;
            // check for the point in any of the holes
            while (k < polys[i].length && !inHole) {
                if (inRing(pt, polys[i][k], !options.ignoreBoundary)) {
                    inHole = true;
                }
                k++;
            }
            if (!inHole) {
                insidePoly = true;
            }
        }
    }
    return insidePoly;
}
/**
 * inRing
 *
 * @private
 * @param {Array<number>} pt [x,y]
 * @param {Array<Array<number>>} ring [[x,y], [x,y],..]
 * @param {boolean} ignoreBoundary ignoreBoundary
 * @returns {boolean} inRing
 */
function inRing(pt, ring, ignoreBoundary) {
    var isInside = false;
    if (ring[0][0] === ring[ring.length - 1][0] &&
        ring[0][1] === ring[ring.length - 1][1]) {
        ring = ring.slice(0, ring.length - 1);
    }
    for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        var xi = ring[i][0];
        var yi = ring[i][1];
        var xj = ring[j][0];
        var yj = ring[j][1];
        var onBoundary = pt[1] * (xi - xj) + yi * (xj - pt[0]) + yj * (pt[0] - xi) === 0 &&
            (xi - pt[0]) * (xj - pt[0]) <= 0 &&
            (yi - pt[1]) * (yj - pt[1]) <= 0;
        if (onBoundary) {
            return !ignoreBoundary;
        }
        var intersect = yi > pt[1] !== yj > pt[1] &&
            pt[0] < ((xj - xi) * (pt[1] - yi)) / (yj - yi) + xi;
        if (intersect) {
            isInside = !isInside;
        }
    }
    return isInside;
}
/**
 * inBBox
 *
 * @private
 * @param {Position} pt point [x,y]
 * @param {BBox} bbox BBox [west, south, east, north]
 * @returns {boolean} true/false if point is inside BBox
 */
function inBBox(pt, bbox) {
    return (bbox[0] <= pt[0] && bbox[1] <= pt[1] && bbox[2] >= pt[0] && bbox[3] >= pt[1]);
}

;// ../../node_modules/@turf/points-within-polygon/dist/es/index.js
/* unused harmony import specifier */ var pointInPolygon;
/* unused harmony import specifier */ var es_multiPoint;
/* unused harmony import specifier */ var dist_es_featureCollection;
/* unused harmony import specifier */ var dist_es_featureEach;
/* unused harmony import specifier */ var es_geomEach;
/* unused harmony import specifier */ var dist_es_coordEach;




/**
 * Finds {@link Points} or {@link MultiPoint} coordinate positions that fall within {@link (Multi)Polygon(s)}.
 *
 * @name pointsWithinPolygon
 * @param {Feature|FeatureCollection<Point|MultiPoint>} points Point(s) or MultiPoint(s) as input search
 * @param {FeatureCollection|Geometry|Feature<Polygon|MultiPolygon>} polygons (Multi)Polygon(s) to check if points are within
 * @returns {FeatureCollection<Point|MultiPoint>} Point(s) or MultiPoint(s) with positions that land within at least one polygon.  The geometry type will match what was passsed in
 * @example
 * var points = turf.points([
 *     [-46.6318, -23.5523],
 *     [-46.6246, -23.5325],
 *     [-46.6062, -23.5513],
 *     [-46.663, -23.554],
 *     [-46.643, -23.557]
 * ]);
 *
 * var searchWithin = turf.polygon([[
 *     [-46.653,-23.543],
 *     [-46.634,-23.5346],
 *     [-46.613,-23.543],
 *     [-46.614,-23.559],
 *     [-46.631,-23.567],
 *     [-46.653,-23.560],
 *     [-46.653,-23.543]
 * ]]);
 *
 * var ptsWithin = turf.pointsWithinPolygon(points, searchWithin);
 *
 * //addToMap
 * var addToMap = [points, searchWithin, ptsWithin]
 * turf.featureEach(ptsWithin, function (currentFeature) {
 *   currentFeature.properties['marker-size'] = 'large';
 *   currentFeature.properties['marker-color'] = '#000';
 * });
 */
function pointsWithinPolygon(points, polygons) {
  var results = [];
  dist_es_featureEach(points, function (point) {
    var contained = false;
    if (point.geometry.type === "Point") {
      es_geomEach(polygons, function (polygon) {
        if (pointInPolygon(point, polygon)) contained = true;
      });
      if (contained) {
        results.push(point);
      }
    } else if (point.geometry.type === "MultiPoint") {
      var pointsWithin = [];
      es_geomEach(polygons, function (polygon) {
        dist_es_coordEach(point, function (pointCoord) {
          if (pointInPolygon(pointCoord, polygon)) {
            contained = true;
            pointsWithin.push(pointCoord);
          }
        });
      });
      if (contained) {
        results.push(es_multiPoint(pointsWithin));
      }
    } else {
      throw new Error("Input geometry must be a Point or MultiPoint");
    }
  });
  return dist_es_featureCollection(results);
}

/* harmony default export */ const points_within_polygon_dist_es = ((/* unused pure expression or super */ null && (pointsWithinPolygon)));

;// ../../node_modules/@turf/distance/dist/es/index.js
/* unused harmony import specifier */ var es_getCoord;
/* unused harmony import specifier */ var es_degreesToRadians;
/* unused harmony import specifier */ var es_radiansToLength;


//http://en.wikipedia.org/wiki/Haversine_formula
//http://www.movable-type.co.uk/scripts/latlong.html
/**
 * Calculates the distance between two {@link Point|points} in degrees, radians, miles, or kilometers.
 * This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula) to account for global curvature.
 *
 * @name distance
 * @param {Coord | Point} from origin point or coordinate
 * @param {Coord | Point} to destination point or coordinate
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
 * @returns {number} distance between the two points
 * @example
 * var from = turf.point([-75.343, 39.984]);
 * var to = turf.point([-75.534, 39.123]);
 * var options = {units: 'miles'};
 *
 * var distance = turf.distance(from, to, options);
 *
 * //addToMap
 * var addToMap = [from, to];
 * from.properties.distance = distance;
 * to.properties.distance = distance;
 */
function distance(from, to, options) {
    if (options === void 0) { options = {}; }
    var coordinates1 = es_getCoord(from);
    var coordinates2 = es_getCoord(to);
    var dLat = es_degreesToRadians(coordinates2[1] - coordinates1[1]);
    var dLon = es_degreesToRadians(coordinates2[0] - coordinates1[0]);
    var lat1 = es_degreesToRadians(coordinates1[1]);
    var lat2 = es_degreesToRadians(coordinates2[1]);
    var a = Math.pow(Math.sin(dLat / 2), 2) +
        Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    return es_radiansToLength(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)), options.units);
}
/* harmony default export */ const distance_dist_es = ((/* unused pure expression or super */ null && (distance)));

;// ../../node_modules/@turf/tin/dist/es/index.js
/* unused harmony import specifier */ var tin_dist_es_featureCollection;
/* unused harmony import specifier */ var es_polygon;
// http://en.wikipedia.org/wiki/Delaunay_triangulation
// https://github.com/ironwallaby/delaunay

/**
 * Takes a set of {@link Point|points} and creates a
 * [Triangulated Irregular Network](http://en.wikipedia.org/wiki/Triangulated_irregular_network),
 * or a TIN for short, returned as a collection of Polygons. These are often used
 * for developing elevation contour maps or stepped heat visualizations.
 *
 * If an optional z-value property is provided then it is added as properties called `a`, `b`,
 * and `c` representing its value at each of the points that represent the corners of the
 * triangle.
 *
 * @name tin
 * @param {FeatureCollection<Point>} points input points
 * @param {String} [z] name of the property from which to pull z values
 * This is optional: if not given, then there will be no extra data added to the derived triangles.
 * @returns {FeatureCollection<Polygon>} TIN output
 * @example
 * // generate some random point data
 * var points = turf.randomPoint(30, {bbox: [50, 30, 70, 50]});
 *
 * // add a random property to each point between 0 and 9
 * for (var i = 0; i < points.features.length; i++) {
 *   points.features[i].properties.z = ~~(Math.random() * 9);
 * }
 * var tin = turf.tin(points, 'z');
 *
 * //addToMap
 * var addToMap = [tin, points]
 * for (var i = 0; i < tin.features.length; i++) {
 *   var properties  = tin.features[i].properties;
 *   properties.fill = '#' + properties.a + properties.b + properties.c;
 * }
 */
function tin(points, z) {
    // break down points
    var isPointZ = false;
    return tin_dist_es_featureCollection(triangulate(points.features.map(function (p) {
        var point = {
            x: p.geometry.coordinates[0],
            y: p.geometry.coordinates[1],
        };
        if (z) {
            point.z = p.properties[z];
        }
        else if (p.geometry.coordinates.length === 3) {
            isPointZ = true;
            point.z = p.geometry.coordinates[2];
        }
        return point;
    })).map(function (triangle) {
        var a = [triangle.a.x, triangle.a.y];
        var b = [triangle.b.x, triangle.b.y];
        var c = [triangle.c.x, triangle.c.y];
        var properties = {};
        // Add z coordinates to triangle points if user passed
        // them in that way otherwise add it as a property.
        if (isPointZ) {
            a.push(triangle.a.z);
            b.push(triangle.b.z);
            c.push(triangle.c.z);
        }
        else {
            properties = {
                a: triangle.a.z,
                b: triangle.b.z,
                c: triangle.c.z,
            };
        }
        return es_polygon([[a, b, c, a]], properties);
    }));
}
var Triangle = /** @class */ (function () {
    function Triangle(a, b, c) {
        this.a = a;
        this.b = b;
        this.c = c;
        var A = b.x - a.x;
        var B = b.y - a.y;
        var C = c.x - a.x;
        var D = c.y - a.y;
        var E = A * (a.x + b.x) + B * (a.y + b.y);
        var F = C * (a.x + c.x) + D * (a.y + c.y);
        var G = 2 * (A * (c.y - b.y) - B * (c.x - b.x));
        var dx;
        var dy;
        // If the points of the triangle are collinear, then just find the
        // extremes and use the midpoint as the center of the circumcircle.
        this.x = (D * E - B * F) / G;
        this.y = (A * F - C * E) / G;
        dx = this.x - a.x;
        dy = this.y - a.y;
        this.r = dx * dx + dy * dy;
    }
    return Triangle;
}());
function byX(a, b) {
    return b.x - a.x;
}
function dedup(edges) {
    var j = edges.length;
    var a;
    var b;
    var i;
    var m;
    var n;
    outer: while (j) {
        b = edges[--j];
        a = edges[--j];
        i = j;
        while (i) {
            n = edges[--i];
            m = edges[--i];
            if ((a === m && b === n) || (a === n && b === m)) {
                edges.splice(j, 2);
                edges.splice(i, 2);
                j -= 2;
                continue outer;
            }
        }
    }
}
function triangulate(vertices) {
    // Bail if there aren't enough vertices to form any triangles.
    if (vertices.length < 3) {
        return [];
    }
    // Ensure the vertex array is in order of descending X coordinate
    // (which is needed to ensure a subquadratic runtime), and then find
    // the bounding box around the points.
    vertices.sort(byX);
    var i = vertices.length - 1;
    var xmin = vertices[i].x;
    var xmax = vertices[0].x;
    var ymin = vertices[i].y;
    var ymax = ymin;
    var epsilon = 1e-12;
    var a;
    var b;
    var c;
    var A;
    var B;
    var G;
    while (i--) {
        if (vertices[i].y < ymin) {
            ymin = vertices[i].y;
        }
        if (vertices[i].y > ymax) {
            ymax = vertices[i].y;
        }
    }
    // Find a supertriangle, which is a triangle that surrounds all the
    // vertices. This is used like something of a sentinel value to remove
    // cases in the main algorithm, and is removed before we return any
    // results.
    // Once found, put it in the "open" list. (The "open" list is for
    // triangles who may still need to be considered; the "closed" list is
    // for triangles which do not.)
    var dx = xmax - xmin;
    var dy = ymax - ymin;
    var dmax = dx > dy ? dx : dy;
    var xmid = (xmax + xmin) * 0.5;
    var ymid = (ymax + ymin) * 0.5;
    var open = [
        new Triangle({
            __sentinel: true,
            x: xmid - 20 * dmax,
            y: ymid - dmax,
        }, {
            __sentinel: true,
            x: xmid,
            y: ymid + 20 * dmax,
        }, {
            __sentinel: true,
            x: xmid + 20 * dmax,
            y: ymid - dmax,
        }),
    ];
    var closed = [];
    var edges = [];
    var j;
    // Incrementally add each vertex to the mesh.
    i = vertices.length;
    while (i--) {
        // For each open triangle, check to see if the current point is
        // inside it's circumcircle. If it is, remove the triangle and add
        // it's edges to an edge list.
        edges.length = 0;
        j = open.length;
        while (j--) {
            // If this point is to the right of this triangle's circumcircle,
            // then this triangle should never get checked again. Remove it
            // from the open list, add it to the closed list, and skip.
            dx = vertices[i].x - open[j].x;
            if (dx > 0 && dx * dx > open[j].r) {
                closed.push(open[j]);
                open.splice(j, 1);
                continue;
            }
            // If not, skip this triangle.
            dy = vertices[i].y - open[j].y;
            if (dx * dx + dy * dy > open[j].r) {
                continue;
            }
            // Remove the triangle and add it's edges to the edge list.
            edges.push(open[j].a, open[j].b, open[j].b, open[j].c, open[j].c, open[j].a);
            open.splice(j, 1);
        }
        // Remove any doubled edges.
        dedup(edges);
        // Add a new triangle for each edge.
        j = edges.length;
        while (j) {
            b = edges[--j];
            a = edges[--j];
            c = vertices[i];
            // Avoid adding colinear triangles (which have error-prone
            // circumcircles)
            A = b.x - a.x;
            B = b.y - a.y;
            G = 2 * (A * (c.y - b.y) - B * (c.x - b.x));
            if (Math.abs(G) > epsilon) {
                open.push(new Triangle(a, b, c));
            }
        }
    }
    // Copy any remaining open triangles to the closed list, and then
    // remove any triangles that share a vertex with the supertriangle.
    Array.prototype.push.apply(closed, open);
    i = closed.length;
    while (i--) {
        if (closed[i].a.__sentinel ||
            closed[i].b.__sentinel ||
            closed[i].c.__sentinel) {
            closed.splice(i, 1);
        }
    }
    return closed;
}

;// ../../node_modules/@turf/concave/dist/es/lib/turf-line-dissolve.js
/* unused harmony import specifier */ var clone;
/* unused harmony import specifier */ var turf_line_dissolve_isObject;
/* unused harmony import specifier */ var turf_line_dissolve_multiLineString;
/* unused harmony import specifier */ var turf_line_dissolve_lineString;
/* unused harmony import specifier */ var turf_line_dissolve_getType;
/* unused harmony import specifier */ var turf_line_dissolve_lineReduce;




/**
 * Merges all connected (non-forking, non-junctioning) line strings into single lineStrings.
 * [LineString] -> LineString|MultiLineString
 *
 * @param {FeatureCollection<LineString|MultiLineString>} geojson Lines to dissolve
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.mutate=false] Prevent input mutation
 * @returns {Feature<LineString|MultiLineString>} Dissolved lines
 */
function lineDissolve(geojson, options) {
    if (options === void 0) { options = {}; }
    // Optional parameters
    options = options || {};
    if (!turf_line_dissolve_isObject(options)) {
        throw new Error("options is invalid");
    }
    var mutate = options.mutate;
    // Validation
    if (turf_line_dissolve_getType(geojson) !== "FeatureCollection") {
        throw new Error("geojson must be a FeatureCollection");
    }
    if (!geojson.features.length) {
        throw new Error("geojson is empty");
    }
    // Clone geojson to avoid side effects
    if (mutate === false || mutate === undefined) {
        geojson = clone(geojson);
    }
    var result = [];
    var lastLine = turf_line_dissolve_lineReduce(geojson, function (previousLine, currentLine) {
        // Attempt to merge this LineString with the other LineStrings, updating
        // the reference as it is merged with others and grows.
        var merged = mergeLineStrings(previousLine, currentLine);
        // Accumulate the merged LineString
        if (merged) {
            return merged;
            // Put the unmerged LineString back into the list
        }
        else {
            result.push(previousLine);
            return currentLine;
        }
    });
    // Append the last line
    if (lastLine) {
        result.push(lastLine);
    }
    // Return null if no lines were dissolved
    if (!result.length) {
        return null;
        // Return LineString if only 1 line was dissolved
    }
    else if (result.length === 1) {
        return result[0];
        // Return MultiLineString if multiple lines were dissolved with gaps
    }
    else {
        return turf_line_dissolve_multiLineString(result.map(function (line) {
            return line.coordinates;
        }));
    }
}
// [Number, Number] -> String
function coordId(coord) {
    return coord[0].toString() + "," + coord[1].toString();
}
/**
 * LineString, LineString -> LineString
 *
 * @private
 * @param {Feature<LineString>} a line1
 * @param {Feature<LineString>} b line2
 * @returns {Feature<LineString>|null} Merged LineString
 */
function mergeLineStrings(a, b) {
    var coords1 = a.geometry.coordinates;
    var coords2 = b.geometry.coordinates;
    var s1 = coordId(coords1[0]);
    var e1 = coordId(coords1[coords1.length - 1]);
    var s2 = coordId(coords2[0]);
    var e2 = coordId(coords2[coords2.length - 1]);
    // TODO: handle case where more than one of these is true!
    var coords;
    if (s1 === e2) {
        coords = coords2.concat(coords1.slice(1));
    }
    else if (s2 === e1) {
        coords = coords1.concat(coords2.slice(1));
    }
    else if (s1 === s2) {
        coords = coords1.slice(1).reverse().concat(coords2);
    }
    else if (e1 === e2) {
        coords = coords1.concat(coords2.reverse().slice(1));
    }
    else {
        return null;
    }
    return turf_line_dissolve_lineString(coords);
}
/* harmony default export */ const turf_line_dissolve = ((/* unused pure expression or super */ null && (lineDissolve)));

;// ../../node_modules/topojson-server/src/object.js
var object_hasOwnProperty = Object.prototype.hasOwnProperty;

;// ../../node_modules/topojson-server/src/bounds.js
Object.defineProperty(bounds, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var bounds_hasOwnProperty;


// Computes the bounding box of the specified hash of GeoJSON objects.
/* harmony default export */ function bounds(objects) {
  var x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  function boundGeometry(geometry) {
    if (geometry != null && bounds_hasOwnProperty.call(boundGeometryType, geometry.type)) boundGeometryType[geometry.type](geometry);
  }

  var boundGeometryType = {
    GeometryCollection: function(o) { o.geometries.forEach(boundGeometry); },
    Point: function(o) { boundPoint(o.coordinates); },
    MultiPoint: function(o) { o.coordinates.forEach(boundPoint); },
    LineString: function(o) { boundLine(o.arcs); },
    MultiLineString: function(o) { o.arcs.forEach(boundLine); },
    Polygon: function(o) { o.arcs.forEach(boundLine); },
    MultiPolygon: function(o) { o.arcs.forEach(boundMultiLine); }
  };

  function boundPoint(coordinates) {
    var x = coordinates[0],
        y = coordinates[1];
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  function boundLine(coordinates) {
    coordinates.forEach(boundPoint);
  }

  function boundMultiLine(coordinates) {
    coordinates.forEach(boundLine);
  }

  for (var key in objects) {
    boundGeometry(objects[key]);
  }

  return x1 >= x0 && y1 >= y0 ? [x0, y0, x1, y1] : undefined;
}

;// ../../node_modules/topojson-server/src/hash/point-hash.js
Object.defineProperty(point_hash, "name", { value: "default", configurable: true });
// TODO if quantized, use simpler Int32 hashing?

var buffer = new ArrayBuffer(16),
    floats = new Float64Array(buffer),
    uints = new Uint32Array(buffer);

/* harmony default export */ function point_hash(point) {
  floats[0] = point[0];
  floats[1] = point[1];
  var hash = uints[0] ^ uints[1];
  hash = hash << 5 ^ hash >> 7 ^ uints[2] ^ uints[3];
  return hash & 0x7fffffff;
}

;// ../../node_modules/topojson-server/src/join.js
Object.defineProperty(join, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var hashset;
/* unused harmony import specifier */ var hashmap;
/* unused harmony import specifier */ var equalPoint;
/* unused harmony import specifier */ var hashPoint;





// Given an extracted (pre-)topology, identifies all of the junctions. These are
// the points at which arcs (lines or rings) will need to be cut so that each
// arc is represented uniquely.
//
// A junction is a point where at least one arc deviates from another arc going
// through the same point. For example, consider the point B. If there is a arc
// through ABC and another arc through CBA, then B is not a junction because in
// both cases the adjacent point pairs are {A,C}. However, if there is an
// additional arc ABD, then {A,D} != {A,C}, and thus B becomes a junction.
//
// For a closed ring ABCA, the first point A’s adjacent points are the second
// and last point {B,C}. For a line, the first and last point are always
// considered junctions, even if the line is closed; this ensures that a closed
// line is never rotated.
/* harmony default export */ function join(topology) {
  var coordinates = topology.coordinates,
      lines = topology.lines,
      rings = topology.rings,
      indexes = index(),
      visitedByIndex = new Int32Array(coordinates.length),
      leftByIndex = new Int32Array(coordinates.length),
      rightByIndex = new Int32Array(coordinates.length),
      junctionByIndex = new Int8Array(coordinates.length),
      junctionCount = 0, // upper bound on number of junctions
      i, n,
      previousIndex,
      currentIndex,
      nextIndex;

  for (i = 0, n = coordinates.length; i < n; ++i) {
    visitedByIndex[i] = leftByIndex[i] = rightByIndex[i] = -1;
  }

  for (i = 0, n = lines.length; i < n; ++i) {
    var line = lines[i],
        lineStart = line[0],
        lineEnd = line[1];
    currentIndex = indexes[lineStart];
    nextIndex = indexes[++lineStart];
    ++junctionCount, junctionByIndex[currentIndex] = 1; // start
    while (++lineStart <= lineEnd) {
      sequence(i, previousIndex = currentIndex, currentIndex = nextIndex, nextIndex = indexes[lineStart]);
    }
    ++junctionCount, junctionByIndex[nextIndex] = 1; // end
  }

  for (i = 0, n = coordinates.length; i < n; ++i) {
    visitedByIndex[i] = -1;
  }

  for (i = 0, n = rings.length; i < n; ++i) {
    var ring = rings[i],
        ringStart = ring[0] + 1,
        ringEnd = ring[1];
    previousIndex = indexes[ringEnd - 1];
    currentIndex = indexes[ringStart - 1];
    nextIndex = indexes[ringStart];
    sequence(i, previousIndex, currentIndex, nextIndex);
    while (++ringStart <= ringEnd) {
      sequence(i, previousIndex = currentIndex, currentIndex = nextIndex, nextIndex = indexes[ringStart]);
    }
  }

  function sequence(i, previousIndex, currentIndex, nextIndex) {
    if (visitedByIndex[currentIndex] === i) return; // ignore self-intersection
    visitedByIndex[currentIndex] = i;
    var leftIndex = leftByIndex[currentIndex];
    if (leftIndex >= 0) {
      var rightIndex = rightByIndex[currentIndex];
      if ((leftIndex !== previousIndex || rightIndex !== nextIndex)
        && (leftIndex !== nextIndex || rightIndex !== previousIndex)) {
        ++junctionCount, junctionByIndex[currentIndex] = 1;
      }
    } else {
      leftByIndex[currentIndex] = previousIndex;
      rightByIndex[currentIndex] = nextIndex;
    }
  }

  function index() {
    var indexByPoint = hashmap(coordinates.length * 1.4, hashIndex, equalIndex, Int32Array, -1, Int32Array),
        indexes = new Int32Array(coordinates.length);

    for (var i = 0, n = coordinates.length; i < n; ++i) {
      indexes[i] = indexByPoint.maybeSet(i, i);
    }

    return indexes;
  }

  function hashIndex(i) {
    return hashPoint(coordinates[i]);
  }

  function equalIndex(i, j) {
    return equalPoint(coordinates[i], coordinates[j]);
  }

  visitedByIndex = leftByIndex = rightByIndex = null;

  var junctionByPoint = hashset(junctionCount * 1.4, hashPoint, equalPoint), j;

  // Convert back to a standard hashset by point for caller convenience.
  for (i = 0, n = coordinates.length; i < n; ++i) {
    if (junctionByIndex[j = indexes[i]]) {
      junctionByPoint.add(coordinates[j]);
    }
  }

  return junctionByPoint;
}

;// ../../node_modules/topojson-server/src/cut.js
Object.defineProperty(cut, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var cut_join;


// Given an extracted (pre-)topology, cuts (or rotates) arcs so that all shared
// point sequences are identified. The topology can then be subsequently deduped
// to remove exact duplicate arcs.
/* harmony default export */ function cut(topology) {
  var junctions = cut_join(topology),
      coordinates = topology.coordinates,
      lines = topology.lines,
      rings = topology.rings,
      next,
      i, n;

  for (i = 0, n = lines.length; i < n; ++i) {
    var line = lines[i],
        lineMid = line[0],
        lineEnd = line[1];
    while (++lineMid < lineEnd) {
      if (junctions.has(coordinates[lineMid])) {
        next = {0: lineMid, 1: line[1]};
        line[1] = lineMid;
        line = line.next = next;
      }
    }
  }

  for (i = 0, n = rings.length; i < n; ++i) {
    var ring = rings[i],
        ringStart = ring[0],
        ringMid = ringStart,
        ringEnd = ring[1],
        ringFixed = junctions.has(coordinates[ringStart]);
    while (++ringMid < ringEnd) {
      if (junctions.has(coordinates[ringMid])) {
        if (ringFixed) {
          next = {0: ringMid, 1: ring[1]};
          ring[1] = ringMid;
          ring = ring.next = next;
        } else { // For the first junction, we can rotate rather than cut.
          rotateArray(coordinates, ringStart, ringEnd, ringEnd - ringMid);
          coordinates[ringEnd] = coordinates[ringStart];
          ringFixed = true;
          ringMid = ringStart; // restart; we may have skipped junctions
        }
      }
    }
  }

  return topology;
}

function rotateArray(array, start, end, offset) {
  reverse(array, start, end);
  reverse(array, start, start + offset);
  reverse(array, start + offset, end);
}

function reverse(array, start, end) {
  for (var mid = start + ((end-- - start) >> 1), t; start < mid; ++start, --end) {
    t = array[start], array[start] = array[end], array[end] = t;
  }
}

;// ../../node_modules/topojson-server/src/dedup.js
Object.defineProperty(src_dedup, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var dedup_hashmap;
/* unused harmony import specifier */ var dedup_equalPoint;
/* unused harmony import specifier */ var dedup_hashPoint;




// Given a cut topology, combines duplicate arcs.
/* harmony default export */ function src_dedup(topology) {
  var coordinates = topology.coordinates,
      lines = topology.lines, line,
      rings = topology.rings, ring,
      arcCount = lines.length + rings.length,
      i, n;

  delete topology.lines;
  delete topology.rings;

  // Count the number of (non-unique) arcs to initialize the hashmap safely.
  for (i = 0, n = lines.length; i < n; ++i) {
    line = lines[i]; while (line = line.next) ++arcCount;
  }
  for (i = 0, n = rings.length; i < n; ++i) {
    ring = rings[i]; while (ring = ring.next) ++arcCount;
  }

  var arcsByEnd = dedup_hashmap(arcCount * 2 * 1.4, dedup_hashPoint, dedup_equalPoint),
      arcs = topology.arcs = [];

  for (i = 0, n = lines.length; i < n; ++i) {
    line = lines[i];
    do {
      dedupLine(line);
    } while (line = line.next);
  }

  for (i = 0, n = rings.length; i < n; ++i) {
    ring = rings[i];
    if (ring.next) { // arc is no longer closed
      do {
        dedupLine(ring);
      } while (ring = ring.next);
    } else {
      dedupRing(ring);
    }
  }

  function dedupLine(arc) {
    var startPoint,
        endPoint,
        startArcs, startArc,
        endArcs, endArc,
        i, n;

    // Does this arc match an existing arc in order?
    if (startArcs = arcsByEnd.get(startPoint = coordinates[arc[0]])) {
      for (i = 0, n = startArcs.length; i < n; ++i) {
        startArc = startArcs[i];
        if (equalLine(startArc, arc)) {
          arc[0] = startArc[0];
          arc[1] = startArc[1];
          return;
        }
      }
    }

    // Does this arc match an existing arc in reverse order?
    if (endArcs = arcsByEnd.get(endPoint = coordinates[arc[1]])) {
      for (i = 0, n = endArcs.length; i < n; ++i) {
        endArc = endArcs[i];
        if (reverseEqualLine(endArc, arc)) {
          arc[1] = endArc[0];
          arc[0] = endArc[1];
          return;
        }
      }
    }

    if (startArcs) startArcs.push(arc); else arcsByEnd.set(startPoint, [arc]);
    if (endArcs) endArcs.push(arc); else arcsByEnd.set(endPoint, [arc]);
    arcs.push(arc);
  }

  function dedupRing(arc) {
    var endPoint,
        endArcs,
        endArc,
        i, n;

    // Does this arc match an existing line in order, or reverse order?
    // Rings are closed, so their start point and end point is the same.
    if (endArcs = arcsByEnd.get(endPoint = coordinates[arc[0]])) {
      for (i = 0, n = endArcs.length; i < n; ++i) {
        endArc = endArcs[i];
        if (equalRing(endArc, arc)) {
          arc[0] = endArc[0];
          arc[1] = endArc[1];
          return;
        }
        if (reverseEqualRing(endArc, arc)) {
          arc[0] = endArc[1];
          arc[1] = endArc[0];
          return;
        }
      }
    }

    // Otherwise, does this arc match an existing ring in order, or reverse order?
    if (endArcs = arcsByEnd.get(endPoint = coordinates[arc[0] + findMinimumOffset(arc)])) {
      for (i = 0, n = endArcs.length; i < n; ++i) {
        endArc = endArcs[i];
        if (equalRing(endArc, arc)) {
          arc[0] = endArc[0];
          arc[1] = endArc[1];
          return;
        }
        if (reverseEqualRing(endArc, arc)) {
          arc[0] = endArc[1];
          arc[1] = endArc[0];
          return;
        }
      }
    }

    if (endArcs) endArcs.push(arc); else arcsByEnd.set(endPoint, [arc]);
    arcs.push(arc);
  }

  function equalLine(arcA, arcB) {
    var ia = arcA[0], ib = arcB[0],
        ja = arcA[1], jb = arcB[1];
    if (ia - ja !== ib - jb) return false;
    for (; ia <= ja; ++ia, ++ib) if (!dedup_equalPoint(coordinates[ia], coordinates[ib])) return false;
    return true;
  }

  function reverseEqualLine(arcA, arcB) {
    var ia = arcA[0], ib = arcB[0],
        ja = arcA[1], jb = arcB[1];
    if (ia - ja !== ib - jb) return false;
    for (; ia <= ja; ++ia, --jb) if (!dedup_equalPoint(coordinates[ia], coordinates[jb])) return false;
    return true;
  }

  function equalRing(arcA, arcB) {
    var ia = arcA[0], ib = arcB[0],
        ja = arcA[1], jb = arcB[1],
        n = ja - ia;
    if (n !== jb - ib) return false;
    var ka = findMinimumOffset(arcA),
        kb = findMinimumOffset(arcB);
    for (var i = 0; i < n; ++i) {
      if (!dedup_equalPoint(coordinates[ia + (i + ka) % n], coordinates[ib + (i + kb) % n])) return false;
    }
    return true;
  }

  function reverseEqualRing(arcA, arcB) {
    var ia = arcA[0], ib = arcB[0],
        ja = arcA[1], jb = arcB[1],
        n = ja - ia;
    if (n !== jb - ib) return false;
    var ka = findMinimumOffset(arcA),
        kb = n - findMinimumOffset(arcB);
    for (var i = 0; i < n; ++i) {
      if (!dedup_equalPoint(coordinates[ia + (i + ka) % n], coordinates[jb - (i + kb) % n])) return false;
    }
    return true;
  }

  // Rings are rotated to a consistent, but arbitrary, start point.
  // This is necessary to detect when a ring and a rotated copy are dupes.
  function findMinimumOffset(arc) {
    var start = arc[0],
        end = arc[1],
        mid = start,
        minimum = mid,
        minimumPoint = coordinates[mid];
    while (++mid < end) {
      var point = coordinates[mid];
      if (point[0] < minimumPoint[0] || point[0] === minimumPoint[0] && point[1] < minimumPoint[1]) {
        minimum = mid;
        minimumPoint = point;
      }
    }
    return minimum - start;
  }

  return topology;
}

;// ../../node_modules/topojson-server/src/extract.js
Object.defineProperty(extract, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var extract_hasOwnProperty;


// Extracts the lines and rings from the specified hash of geometry objects.
//
// Returns an object with three properties:
//
// * coordinates - shared buffer of [x, y] coordinates
// * lines - lines extracted from the hash, of the form [start, end]
// * rings - rings extracted from the hash, of the form [start, end]
//
// For each ring or line, start and end represent inclusive indexes into the
// coordinates buffer. For rings (and closed lines), coordinates[start] equals
// coordinates[end].
//
// For each line or polygon geometry in the input hash, including nested
// geometries as in geometry collections, the `coordinates` array is replaced
// with an equivalent `arcs` array that, for each line (for line string
// geometries) or ring (for polygon geometries), points to one of the above
// lines or rings.
/* harmony default export */ function extract(objects) {
  var index = -1,
      lines = [],
      rings = [],
      coordinates = [];

  function extractGeometry(geometry) {
    if (geometry && extract_hasOwnProperty.call(extractGeometryType, geometry.type)) extractGeometryType[geometry.type](geometry);
  }

  var extractGeometryType = {
    GeometryCollection: function(o) { o.geometries.forEach(extractGeometry); },
    LineString: function(o) { o.arcs = extractLine(o.arcs); },
    MultiLineString: function(o) { o.arcs = o.arcs.map(extractLine); },
    Polygon: function(o) { o.arcs = o.arcs.map(extractRing); },
    MultiPolygon: function(o) { o.arcs = o.arcs.map(extractMultiRing); }
  };

  function extractLine(line) {
    for (var i = 0, n = line.length; i < n; ++i) coordinates[++index] = line[i];
    var arc = {0: index - n + 1, 1: index};
    lines.push(arc);
    return arc;
  }

  function extractRing(ring) {
    for (var i = 0, n = ring.length; i < n; ++i) coordinates[++index] = ring[i];
    var arc = {0: index - n + 1, 1: index};
    rings.push(arc);
    return arc;
  }

  function extractMultiRing(rings) {
    return rings.map(extractRing);
  }

  for (var key in objects) {
    extractGeometry(objects[key]);
  }

  return {
    type: "Topology",
    coordinates: coordinates,
    lines: lines,
    rings: rings,
    objects: objects
  };
}

;// ../../node_modules/topojson-server/src/prequantize.js
Object.defineProperty(prequantize, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var prequantize_hasOwnProperty;


/* harmony default export */ function prequantize(objects, bbox, n) {
  var x0 = bbox[0],
      y0 = bbox[1],
      x1 = bbox[2],
      y1 = bbox[3],
      kx = x1 - x0 ? (n - 1) / (x1 - x0) : 1,
      ky = y1 - y0 ? (n - 1) / (y1 - y0) : 1;

  function quantizePoint(input) {
    return [Math.round((input[0] - x0) * kx), Math.round((input[1] - y0) * ky)];
  }

  function quantizePoints(input, m) {
    var i = -1,
        j = 0,
        n = input.length,
        output = new Array(n), // pessimistic
        pi,
        px,
        py,
        x,
        y;

    while (++i < n) {
      pi = input[i];
      x = Math.round((pi[0] - x0) * kx);
      y = Math.round((pi[1] - y0) * ky);
      if (x !== px || y !== py) output[j++] = [px = x, py = y]; // non-coincident points
    }

    output.length = j;
    while (j < m) j = output.push([output[0][0], output[0][1]]);
    return output;
  }

  function quantizeLine(input) {
    return quantizePoints(input, 2);
  }

  function quantizeRing(input) {
    return quantizePoints(input, 4);
  }

  function quantizePolygon(input) {
    return input.map(quantizeRing);
  }

  function quantizeGeometry(o) {
    if (o != null && prequantize_hasOwnProperty.call(quantizeGeometryType, o.type)) quantizeGeometryType[o.type](o);
  }

  var quantizeGeometryType = {
    GeometryCollection: function(o) { o.geometries.forEach(quantizeGeometry); },
    Point: function(o) { o.coordinates = quantizePoint(o.coordinates); },
    MultiPoint: function(o) { o.coordinates = o.coordinates.map(quantizePoint); },
    LineString: function(o) { o.arcs = quantizeLine(o.arcs); },
    MultiLineString: function(o) { o.arcs = o.arcs.map(quantizeLine); },
    Polygon: function(o) { o.arcs = quantizePolygon(o.arcs); },
    MultiPolygon: function(o) { o.arcs = o.arcs.map(quantizePolygon); }
  };

  for (var key in objects) {
    quantizeGeometry(objects[key]);
  }

  return {
    scale: [1 / kx, 1 / ky],
    translate: [x0, y0]
  };
}

;// ../../node_modules/topojson-server/src/topology.js
Object.defineProperty(topology, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var topology_bounds;
/* unused harmony import specifier */ var topology_cut;
/* unused harmony import specifier */ var topology_dedup;
/* unused harmony import specifier */ var delta;
/* unused harmony import specifier */ var topology_extract;
/* unused harmony import specifier */ var topology_geometry;
/* unused harmony import specifier */ var topology_hashmap;
/* unused harmony import specifier */ var topology_hasOwnProperty;
/* unused harmony import specifier */ var topology_prequantize;










// Constructs the TopoJSON Topology for the specified hash of features.
// Each object in the specified hash must be a GeoJSON object,
// meaning FeatureCollection, a Feature or a geometry object.
/* harmony default export */ function topology(objects, quantization) {
  var bbox = topology_bounds(objects = topology_geometry(objects)),
      transform = quantization > 0 && bbox && topology_prequantize(objects, bbox, quantization),
      topology = topology_dedup(topology_cut(topology_extract(objects))),
      coordinates = topology.coordinates,
      indexByArc = topology_hashmap(topology.arcs.length * 1.4, hashArc, equalArc);

  objects = topology.objects; // for garbage collection
  topology.bbox = bbox;
  topology.arcs = topology.arcs.map(function(arc, i) {
    indexByArc.set(arc, i);
    return coordinates.slice(arc[0], arc[1] + 1);
  });

  delete topology.coordinates;
  coordinates = null;

  function indexGeometry(geometry) {
    if (geometry && topology_hasOwnProperty.call(indexGeometryType, geometry.type)) indexGeometryType[geometry.type](geometry);
  }

  var indexGeometryType = {
    GeometryCollection: function(o) { o.geometries.forEach(indexGeometry); },
    LineString: function(o) { o.arcs = indexArcs(o.arcs); },
    MultiLineString: function(o) { o.arcs = o.arcs.map(indexArcs); },
    Polygon: function(o) { o.arcs = o.arcs.map(indexArcs); },
    MultiPolygon: function(o) { o.arcs = o.arcs.map(indexMultiArcs); }
  };

  function indexArcs(arc) {
    var indexes = [];
    do {
      var index = indexByArc.get(arc);
      indexes.push(arc[0] < arc[1] ? index : ~index);
    } while (arc = arc.next);
    return indexes;
  }

  function indexMultiArcs(arcs) {
    return arcs.map(indexArcs);
  }

  for (var key in objects) {
    indexGeometry(objects[key]);
  }

  if (transform) {
    topology.transform = transform;
    topology.arcs = delta(topology.arcs);
  }

  return topology;
}

function hashArc(arc) {
  var i = arc[0], j = arc[1], t;
  if (j < i) t = i, i = j, j = t;
  return i + 31 * j;
}

function equalArc(arcA, arcB) {
  var ia = arcA[0], ja = arcA[1],
      ib = arcB[0], jb = arcB[1], t;
  if (ja < ia) t = ia, ia = ja, ja = t;
  if (jb < ib) t = ib, ib = jb, jb = t;
  return ia === ib && ja === jb;
}

;// ../../node_modules/topojson-server/src/index.js


;// ../../node_modules/@turf/concave/dist/es/lib/turf-polygon-dissolve.js
/* unused harmony import specifier */ var turf_polygon_dissolve_clone;
/* unused harmony import specifier */ var turf_polygon_dissolve_geometryCollection;
/* unused harmony import specifier */ var turf_polygon_dissolve_getType;
/* unused harmony import specifier */ var turf_polygon_dissolve_flattenEach;
/* unused harmony import specifier */ var merge;
/* unused harmony import specifier */ var turf_polygon_dissolve_topology;






/**
 * Dissolves all overlapping (Multi)Polygon
 *
 * @param {FeatureCollection<Polygon|MultiPolygon>} geojson Polygons to dissolve
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.mutate=false] Prevent input mutation
 * @returns {Feature<Polygon|MultiPolygon>} Dissolved Polygons
 */
function polygonDissolve(geojson, options) {
    if (options === void 0) { options = {}; }
    // Validation
    if (turf_polygon_dissolve_getType(geojson) !== "FeatureCollection") {
        throw new Error("geojson must be a FeatureCollection");
    }
    if (!geojson.features.length) {
        throw new Error("geojson is empty");
    }
    // Clone geojson to avoid side effects
    // Topojson modifies in place, so we need to deep clone first
    if (options.mutate === false || options.mutate === undefined) {
        geojson = turf_polygon_dissolve_clone(geojson);
    }
    var geoms = [];
    turf_polygon_dissolve_flattenEach(geojson, function (feature) {
        geoms.push(feature.geometry);
    });
    var topo = turf_polygon_dissolve_topology({ geoms: turf_polygon_dissolve_geometryCollection(geoms).geometry });
    var merged = merge(topo, topo.objects.geoms.geometries);
    return merged;
}

;// ../../node_modules/@turf/concave/dist/es/lib/turf-dissolve.js
/* unused harmony import specifier */ var turf_dissolve_clone;
/* unused harmony import specifier */ var turf_dissolve_isObject;
/* unused harmony import specifier */ var turf_dissolve_getType;
/* unused harmony import specifier */ var turf_dissolve_flattenEach;
/* unused harmony import specifier */ var turf_dissolve_lineDissolve;
/* unused harmony import specifier */ var turf_dissolve_polygonDissolve;






/**
 * Transform function: attempts to dissolve geojson objects where possible
 * [GeoJSON] -> GeoJSON geometry
 *
 * @private
 * @param {FeatureCollection<LineString|MultiLineString|Polygon|MultiPolygon>} geojson Features to dissolved
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.mutate=false] Prevent input mutation
 * @returns {Feature<MultiLineString|MultiPolygon>} Dissolved Features
 */
function dissolve(geojson, options) {
    if (options === void 0) { options = {}; }
    // Optional parameters
    options = options || {};
    if (!turf_dissolve_isObject(options)) {
        throw new Error("options is invalid");
    }
    var mutate = options.mutate;
    // Validation
    if (turf_dissolve_getType(geojson) !== "FeatureCollection") {
        throw new Error("geojson must be a FeatureCollection");
    }
    if (!geojson.features.length) {
        throw new Error("geojson is empty");
    }
    // Clone geojson to avoid side effects
    // Topojson modifies in place, so we need to deep clone first
    if (mutate === false || mutate === undefined) {
        geojson = turf_dissolve_clone(geojson);
    }
    // Assert homogenity
    var type = getHomogenousType(geojson);
    if (!type) {
        throw new Error("geojson must be homogenous");
    }
    // Data => Typescript hack
    var data = geojson;
    switch (type) {
        case "LineString":
            return turf_dissolve_lineDissolve(data, options);
        case "Polygon":
            return turf_dissolve_polygonDissolve(data, options);
        default:
            throw new Error(type + " is not supported");
    }
}
/**
 * Checks if GeoJSON is Homogenous
 *
 * @private
 * @param {GeoJSON} geojson GeoJSON
 * @returns {string|null} Homogenous type or null if multiple types
 */
function getHomogenousType(geojson) {
    var types = {};
    turf_dissolve_flattenEach(geojson, function (feature) {
        types[feature.geometry.type] = true;
    });
    var keys = Object.keys(types);
    if (keys.length === 1) {
        return keys[0];
    }
    return null;
}
/* harmony default export */ const turf_dissolve = ((/* unused pure expression or super */ null && (dissolve)));

;// ../../node_modules/@turf/concave/dist/es/index.js
/* unused harmony import specifier */ var es_distance;
/* unused harmony import specifier */ var es_feature;
/* unused harmony import specifier */ var concave_dist_es_featureCollection;
/* unused harmony import specifier */ var concave_dist_es_featureEach;
/* unused harmony import specifier */ var es_tin;
/* unused harmony import specifier */ var es_dissolve;





/**
 * Takes a set of {@link Point|points} and returns a concave hull Polygon or MultiPolygon.
 * Internally, this uses [turf-tin](https://github.com/Turfjs/turf-tin) to generate geometries.
 *
 * @name concave
 * @param {FeatureCollection<Point>} points input points
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.maxEdge=Infinity] the length (in 'units') of an edge necessary for part of the
 * hull to become concave.
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
 * @returns {Feature<(Polygon|MultiPolygon)>|null} a concave hull (null value is returned if unable to compute hull)
 * @example
 * var points = turf.featureCollection([
 *   turf.point([-63.601226, 44.642643]),
 *   turf.point([-63.591442, 44.651436]),
 *   turf.point([-63.580799, 44.648749]),
 *   turf.point([-63.573589, 44.641788]),
 *   turf.point([-63.587665, 44.64533]),
 *   turf.point([-63.595218, 44.64765])
 * ]);
 * var options = {units: 'miles', maxEdge: 1};
 *
 * var hull = turf.concave(points, options);
 *
 * //addToMap
 * var addToMap = [points, hull]
 */
function concave(points, options) {
    if (options === void 0) { options = {}; }
    var maxEdge = options.maxEdge || Infinity;
    var cleaned = removeDuplicates(points);
    var tinPolys = es_tin(cleaned);
    // calculate length of all edges and area of all triangles
    // and remove triangles that fail the max length test
    tinPolys.features = tinPolys.features.filter(function (triangle) {
        var pt1 = triangle.geometry.coordinates[0][0];
        var pt2 = triangle.geometry.coordinates[0][1];
        var pt3 = triangle.geometry.coordinates[0][2];
        var dist1 = es_distance(pt1, pt2, options);
        var dist2 = es_distance(pt2, pt3, options);
        var dist3 = es_distance(pt1, pt3, options);
        return dist1 <= maxEdge && dist2 <= maxEdge && dist3 <= maxEdge;
    });
    if (tinPolys.features.length < 1) {
        return null;
    }
    // merge the adjacent triangles
    var dissolved = es_dissolve(tinPolys);
    // geojson-dissolve always returns a MultiPolygon
    if (dissolved.coordinates.length === 1) {
        dissolved.coordinates = dissolved.coordinates[0];
        dissolved.type = "Polygon";
    }
    return es_feature(dissolved);
}
/**
 * Removes duplicated points in a collection returning a new collection
 *
 * @private
 * @param {FeatureCollection<Point>} points to be cleaned
 * @returns {FeatureCollection<Point>} cleaned set of points
 */
function removeDuplicates(points) {
    var cleaned = [];
    var existing = {};
    concave_dist_es_featureEach(points, function (pt) {
        if (!pt.geometry) {
            return;
        }
        var key = pt.geometry.coordinates.join("-");
        if (!Object.prototype.hasOwnProperty.call(existing, key)) {
            cleaned.push(pt);
            existing[key] = true;
        }
    });
    return concave_dist_es_featureCollection(cleaned);
}
/* harmony default export */ const concave_dist_es = ((/* unused pure expression or super */ null && (concave)));

// EXTERNAL MODULE: ../../node_modules/rbush/index.js
var rbush = __webpack_require__(4026);
;// ../../node_modules/@turf/collect/dist/es/index.js
/* unused harmony import specifier */ var turfbbox;
/* unused harmony import specifier */ var es_booleanPointInPolygon;
/* unused harmony import specifier */ var es_rbush;



/**
 * Merges a specified property from a FeatureCollection of points into a
 * FeatureCollection of polygons. Given an `inProperty` on points and an `outProperty`
 * for polygons, this finds every point that lies within each polygon, collects the
 * `inProperty` values from those points, and adds them as an array to `outProperty`
 * on the polygon.
 *
 * @name collect
 * @param {FeatureCollection<Polygon>} polygons polygons with values on which to aggregate
 * @param {FeatureCollection<Point>} points points to be aggregated
 * @param {string} inProperty property to be nested from
 * @param {string} outProperty property to be nested into
 * @returns {FeatureCollection<Polygon>} polygons with properties listed based on `outField`
 * @example
 * var poly1 = turf.polygon([[[0,0],[10,0],[10,10],[0,10],[0,0]]]);
 * var poly2 = turf.polygon([[[10,0],[20,10],[20,20],[20,0],[10,0]]]);
 * var polyFC = turf.featureCollection([poly1, poly2]);
 * var pt1 = turf.point([5,5], {population: 200});
 * var pt2 = turf.point([1,3], {population: 600});
 * var pt3 = turf.point([14,2], {population: 100});
 * var pt4 = turf.point([13,1], {population: 200});
 * var pt5 = turf.point([19,7], {population: 300});
 * var pointFC = turf.featureCollection([pt1, pt2, pt3, pt4, pt5]);
 * var collected = turf.collect(polyFC, pointFC, 'population', 'values');
 * var values = collected.features[0].properties.values
 * //=values => [200, 600]
 *
 * //addToMap
 * var addToMap = [pointFC, collected]
 */
function collect(polygons, points, inProperty, outProperty) {
    var rtree = es_rbush(6);
    var treeItems = points.features.map(function (item) {
        var _a;
        return {
            minX: item.geometry.coordinates[0],
            minY: item.geometry.coordinates[1],
            maxX: item.geometry.coordinates[0],
            maxY: item.geometry.coordinates[1],
            property: (_a = item.properties) === null || _a === void 0 ? void 0 : _a[inProperty],
        };
    });
    rtree.load(treeItems);
    polygons.features.forEach(function (poly) {
        if (!poly.properties) {
            poly.properties = {};
        }
        var bbox = turfbbox(poly);
        var potentialPoints = rtree.search({
            minX: bbox[0],
            minY: bbox[1],
            maxX: bbox[2],
            maxY: bbox[3],
        });
        var values = [];
        potentialPoints.forEach(function (pt) {
            if (es_booleanPointInPolygon([pt.minX, pt.minY], poly)) {
                values.push(pt.property);
            }
        });
        poly.properties[outProperty] = values;
    });
    return polygons;
}
/* harmony default export */ const collect_dist_es = ((/* unused pure expression or super */ null && (collect)));

;// ../../node_modules/@turf/flip/dist/es/index.js
/* unused harmony import specifier */ var flip_dist_es_coordEach;
/* unused harmony import specifier */ var flip_dist_es_isObject;
/* unused harmony import specifier */ var es_clone;




/**
 * Takes input features and flips all of their coordinates from `[x, y]` to `[y, x]`.
 *
 * @name flip
 * @param {GeoJSON} geojson input features
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} a feature or set of features of the same type as `input` with flipped coordinates
 * @example
 * var serbia = turf.point([20.566406, 43.421008]);
 *
 * var saudiArabia = turf.flip(serbia);
 *
 * //addToMap
 * var addToMap = [serbia, saudiArabia];
 */
function flip(geojson, options) {
  // Optional parameters
  options = options || {};
  if (!flip_dist_es_isObject(options)) throw new Error("options is invalid");
  var mutate = options.mutate;

  if (!geojson) throw new Error("geojson is required");
  // ensure that we don't modify features in-place and changes to the
  // output do not change the previous feature, including changes to nested
  // properties.
  if (mutate === false || mutate === undefined) geojson = es_clone(geojson);

  flip_dist_es_coordEach(geojson, function (coord) {
    var x = coord[0];
    var y = coord[1];
    coord[0] = y;
    coord[1] = x;
  });
  return geojson;
}

/* harmony default export */ const flip_dist_es = ((/* unused pure expression or super */ null && (flip)));

;// ../../node_modules/@turf/clean-coords/dist/es/index.js
/* unused harmony import specifier */ var dist_es_feature;
/* unused harmony import specifier */ var es_getType;
/* unused harmony import specifier */ var dist_es_getCoords;


// To-Do => Improve Typescript GeoJSON handling
/**
 * Removes redundant coordinates from any GeoJSON Geometry.
 *
 * @name cleanCoords
 * @param {Geometry|Feature} geojson Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated
 * @returns {Geometry|Feature} the cleaned input Feature/Geometry
 * @example
 * var line = turf.lineString([[0, 0], [0, 2], [0, 5], [0, 8], [0, 8], [0, 10]]);
 * var multiPoint = turf.multiPoint([[0, 0], [0, 0], [2, 2]]);
 *
 * turf.cleanCoords(line).geometry.coordinates;
 * //= [[0, 0], [0, 10]]
 *
 * turf.cleanCoords(multiPoint).geometry.coordinates;
 * //= [[0, 0], [2, 2]]
 */
function cleanCoords(geojson, options) {
    if (options === void 0) { options = {}; }
    // Backwards compatible with v4.0
    var mutate = typeof options === "object" ? options.mutate : options;
    if (!geojson)
        throw new Error("geojson is required");
    var type = es_getType(geojson);
    // Store new "clean" points in this Array
    var newCoords = [];
    switch (type) {
        case "LineString":
            newCoords = cleanLine(geojson);
            break;
        case "MultiLineString":
        case "Polygon":
            dist_es_getCoords(geojson).forEach(function (line) {
                newCoords.push(cleanLine(line));
            });
            break;
        case "MultiPolygon":
            dist_es_getCoords(geojson).forEach(function (polygons) {
                var polyPoints = [];
                polygons.forEach(function (ring) {
                    polyPoints.push(cleanLine(ring));
                });
                newCoords.push(polyPoints);
            });
            break;
        case "Point":
            return geojson;
        case "MultiPoint":
            var existing = {};
            dist_es_getCoords(geojson).forEach(function (coord) {
                var key = coord.join("-");
                if (!Object.prototype.hasOwnProperty.call(existing, key)) {
                    newCoords.push(coord);
                    existing[key] = true;
                }
            });
            break;
        default:
            throw new Error(type + " geometry not supported");
    }
    // Support input mutation
    if (geojson.coordinates) {
        if (mutate === true) {
            geojson.coordinates = newCoords;
            return geojson;
        }
        return { type: type, coordinates: newCoords };
    }
    else {
        if (mutate === true) {
            geojson.geometry.coordinates = newCoords;
            return geojson;
        }
        return dist_es_feature({ type: type, coordinates: newCoords }, geojson.properties, {
            bbox: geojson.bbox,
            id: geojson.id,
        });
    }
}
/**
 * Clean Coords
 *
 * @private
 * @param {Array<number>|LineString} line Line
 * @returns {Array<number>} Cleaned coordinates
 */
function cleanLine(line) {
    var points = dist_es_getCoords(line);
    // handle "clean" segment
    if (points.length === 2 && !equals(points[0], points[1]))
        return points;
    var newPoints = [];
    var secondToLast = points.length - 1;
    var newPointsLength = newPoints.length;
    newPoints.push(points[0]);
    for (var i = 1; i < secondToLast; i++) {
        var prevAddedPoint = newPoints[newPoints.length - 1];
        if (points[i][0] === prevAddedPoint[0] &&
            points[i][1] === prevAddedPoint[1])
            continue;
        else {
            newPoints.push(points[i]);
            newPointsLength = newPoints.length;
            if (newPointsLength > 2) {
                if (isPointOnLineSegment(newPoints[newPointsLength - 3], newPoints[newPointsLength - 1], newPoints[newPointsLength - 2]))
                    newPoints.splice(newPoints.length - 2, 1);
            }
        }
    }
    newPoints.push(points[points.length - 1]);
    newPointsLength = newPoints.length;
    if (equals(points[0], points[points.length - 1]) && newPointsLength < 4)
        throw new Error("invalid polygon");
    if (isPointOnLineSegment(newPoints[newPointsLength - 3], newPoints[newPointsLength - 1], newPoints[newPointsLength - 2]))
        newPoints.splice(newPoints.length - 2, 1);
    return newPoints;
}
/**
 * Compares two points and returns if they are equals
 *
 * @private
 * @param {Position} pt1 point
 * @param {Position} pt2 point
 * @returns {boolean} true if they are equals
 */
function equals(pt1, pt2) {
    return pt1[0] === pt2[0] && pt1[1] === pt2[1];
}
/**
 * Returns if `point` is on the segment between `start` and `end`.
 * Borrowed from `@turf/boolean-point-on-line` to speed up the evaluation (instead of using the module as dependency)
 *
 * @private
 * @param {Position} start coord pair of start of line
 * @param {Position} end coord pair of end of line
 * @param {Position} point coord pair of point to check
 * @returns {boolean} true/false
 */
function isPointOnLineSegment(start, end, point) {
    var x = point[0], y = point[1];
    var startX = start[0], startY = start[1];
    var endX = end[0], endY = end[1];
    var dxc = x - startX;
    var dyc = y - startY;
    var dxl = endX - startX;
    var dyl = endY - startY;
    var cross = dxc * dyl - dyc * dxl;
    if (cross !== 0)
        return false;
    else if (Math.abs(dxl) >= Math.abs(dyl))
        return dxl > 0 ? startX <= x && x <= endX : endX <= x && x <= startX;
    else
        return dyl > 0 ? startY <= y && y <= endY : endY <= y && y <= startY;
}
/* harmony default export */ const clean_coords_dist_es = ((/* unused pure expression or super */ null && (cleanCoords)));

;// ../../node_modules/@turf/simplify/dist/es/index.js
/* unused harmony import specifier */ var es_cleanCoords;
/* unused harmony import specifier */ var dist_es_clone;
/* unused harmony import specifier */ var dist_es_geomEach;
/* unused harmony import specifier */ var simplify_dist_es_isObject;





/*
 (c) 2013, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js
*/

// to suit your point format, run search/replace for '.x' and '.y';
// for 3D version, see 3d branch (configurability would draw significant performance overhead)

// square distance between 2 points
function es_getSqDist(p1, p2) {
  var dx = p1.x - p2.x,
    dy = p1.y - p2.y;

  return dx * dx + dy * dy;
}

// square distance from a point to a segment
function getSqSegDist(p, p1, p2) {
  var x = p1.x,
    y = p1.y,
    dx = p2.x - x,
    dy = p2.y - y;

  if (dx !== 0 || dy !== 0) {
    var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);

    if (t > 1) {
      x = p2.x;
      y = p2.y;
    } else if (t > 0) {
      x += dx * t;
      y += dy * t;
    }
  }

  dx = p.x - x;
  dy = p.y - y;

  return dx * dx + dy * dy;
}
// rest of the code doesn't care about point format

// basic distance-based simplification
function simplifyRadialDist(points, sqTolerance) {
  var prevPoint = points[0],
    newPoints = [prevPoint],
    point;

  for (var i = 1, len = points.length; i < len; i++) {
    point = points[i];

    if (es_getSqDist(point, prevPoint) > sqTolerance) {
      newPoints.push(point);
      prevPoint = point;
    }
  }

  if (prevPoint !== point) newPoints.push(point);

  return newPoints;
}

function simplifyDPStep(points, first, last, sqTolerance, simplified) {
  var maxSqDist = sqTolerance,
    index;

  for (var i = first + 1; i < last; i++) {
    var sqDist = getSqSegDist(points[i], points[first], points[last]);

    if (sqDist > maxSqDist) {
      index = i;
      maxSqDist = sqDist;
    }
  }

  if (maxSqDist > sqTolerance) {
    if (index - first > 1)
      simplifyDPStep(points, first, index, sqTolerance, simplified);
    simplified.push(points[index]);
    if (last - index > 1)
      simplifyDPStep(points, index, last, sqTolerance, simplified);
  }
}

// simplification using Ramer-Douglas-Peucker algorithm
function simplifyDouglasPeucker(points, sqTolerance) {
  var last = points.length - 1;

  var simplified = [points[0]];
  simplifyDPStep(points, 0, last, sqTolerance, simplified);
  simplified.push(points[last]);

  return simplified;
}

// both algorithms combined for awesome performance
function simplify(points, tolerance, highestQuality) {
  if (points.length <= 2) return points;

  var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;

  points = highestQuality ? points : simplifyRadialDist(points, sqTolerance);
  points = simplifyDouglasPeucker(points, sqTolerance);

  return points;
}

/**
 * Takes a {@link GeoJSON} object and returns a simplified version. Internally uses
 * [simplify-js](http://mourner.github.io/simplify-js/) to perform simplification using the Ramer-Douglas-Peucker algorithm.
 *
 * @name simplify
 * @param {GeoJSON} geojson object to be simplified
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.tolerance=1] simplification tolerance
 * @param {boolean} [options.highQuality=false] whether or not to spend more time to create a higher-quality simplification with a different algorithm
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} a simplified GeoJSON
 * @example
 * var geojson = turf.polygon([[
 *   [-70.603637, -33.399918],
 *   [-70.614624, -33.395332],
 *   [-70.639343, -33.392466],
 *   [-70.659942, -33.394759],
 *   [-70.683975, -33.404504],
 *   [-70.697021, -33.419406],
 *   [-70.701141, -33.434306],
 *   [-70.700454, -33.446339],
 *   [-70.694274, -33.458369],
 *   [-70.682601, -33.465816],
 *   [-70.668869, -33.472117],
 *   [-70.646209, -33.473835],
 *   [-70.624923, -33.472117],
 *   [-70.609817, -33.468107],
 *   [-70.595397, -33.458369],
 *   [-70.587158, -33.442901],
 *   [-70.587158, -33.426283],
 *   [-70.590591, -33.414248],
 *   [-70.594711, -33.406224],
 *   [-70.603637, -33.399918]
 * ]]);
 * var options = {tolerance: 0.01, highQuality: false};
 * var simplified = turf.simplify(geojson, options);
 *
 * //addToMap
 * var addToMap = [geojson, simplified]
 */
function simplify$1(geojson, options) {
  // Optional parameters
  options = options || {};
  if (!simplify_dist_es_isObject(options)) throw new Error("options is invalid");
  var tolerance = options.tolerance !== undefined ? options.tolerance : 1;
  var highQuality = options.highQuality || false;
  var mutate = options.mutate || false;

  if (!geojson) throw new Error("geojson is required");
  if (tolerance && tolerance < 0) throw new Error("invalid tolerance");

  // Clone geojson to avoid side effects
  if (mutate !== true) geojson = dist_es_clone(geojson);

  dist_es_geomEach(geojson, function (geom) {
    simplifyGeom(geom, tolerance, highQuality);
  });
  return geojson;
}

/**
 * Simplifies a feature's coordinates
 *
 * @private
 * @param {Geometry} geometry to be simplified
 * @param {number} [tolerance=1] simplification tolerance
 * @param {boolean} [highQuality=false] whether or not to spend more time to create a higher-quality simplification with a different algorithm
 * @returns {Geometry} output
 */
function simplifyGeom(geometry, tolerance, highQuality) {
  var type = geometry.type;

  // "unsimplyfiable" geometry types
  if (type === "Point" || type === "MultiPoint") return geometry;

  // Remove any extra coordinates
  es_cleanCoords(geometry, true);

  var coordinates = geometry.coordinates;
  switch (type) {
    case "LineString":
      geometry["coordinates"] = simplifyLine(
        coordinates,
        tolerance,
        highQuality
      );
      break;
    case "MultiLineString":
      geometry["coordinates"] = coordinates.map(function (lines) {
        return simplifyLine(lines, tolerance, highQuality);
      });
      break;
    case "Polygon":
      geometry["coordinates"] = simplifyPolygon(
        coordinates,
        tolerance,
        highQuality
      );
      break;
    case "MultiPolygon":
      geometry["coordinates"] = coordinates.map(function (rings) {
        return simplifyPolygon(rings, tolerance, highQuality);
      });
  }
  return geometry;
}

/**
 * Simplifies the coordinates of a LineString with simplify-js
 *
 * @private
 * @param {Array<number>} coordinates to be processed
 * @param {number} tolerance simplification tolerance
 * @param {boolean} highQuality whether or not to spend more time to create a higher-quality
 * @returns {Array<Array<number>>} simplified coords
 */
function simplifyLine(coordinates, tolerance, highQuality) {
  return simplify(
    coordinates.map(function (coord) {
      return { x: coord[0], y: coord[1], z: coord[2] };
    }),
    tolerance,
    highQuality
  ).map(function (coords) {
    return coords.z ? [coords.x, coords.y, coords.z] : [coords.x, coords.y];
  });
}

/**
 * Simplifies the coordinates of a Polygon with simplify-js
 *
 * @private
 * @param {Array<number>} coordinates to be processed
 * @param {number} tolerance simplification tolerance
 * @param {boolean} highQuality whether or not to spend more time to create a higher-quality
 * @returns {Array<Array<Array<number>>>} simplified coords
 */
function simplifyPolygon(coordinates, tolerance, highQuality) {
  return coordinates.map(function (ring) {
    var pts = ring.map(function (coord) {
      return { x: coord[0], y: coord[1] };
    });
    if (pts.length < 4) {
      throw new Error("invalid polygon");
    }
    var simpleRing = simplify(pts, tolerance, highQuality).map(function (
      coords
    ) {
      return [coords.x, coords.y];
    });
    //remove 1 percent of tolerance until enough points to make a triangle
    while (!checkValidity(simpleRing)) {
      tolerance -= tolerance * 0.01;
      simpleRing = simplify(pts, tolerance, highQuality).map(function (
        coords
      ) {
        return [coords.x, coords.y];
      });
    }
    if (
      simpleRing[simpleRing.length - 1][0] !== simpleRing[0][0] ||
      simpleRing[simpleRing.length - 1][1] !== simpleRing[0][1]
    ) {
      simpleRing.push(simpleRing[0]);
    }
    return simpleRing;
  });
}

/**
 * Returns true if ring has at least 3 coordinates and its first coordinate is the same as its last
 *
 * @private
 * @param {Array<number>} ring coordinates to be checked
 * @returns {boolean} true if valid
 */
function checkValidity(ring) {
  if (ring.length < 3) return false;
  //if the last point is the same as the first, it's not a triangle
  return !(
    ring.length === 3 &&
    ring[2][0] === ring[0][0] &&
    ring[2][1] === ring[0][1]
  );
}

/* harmony default export */ const simplify_dist_es = ((/* unused pure expression or super */ null && (simplify$1)));

;// ../../node_modules/@turf/bezier-spline/dist/es/lib/spline.js
/**
 * BezierSpline
 * https://github.com/leszekr/bezier-spline-js
 *
 * @private
 * @copyright
 * Copyright (c) 2013 Leszek Rybicki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var Spline = /** @class */ (function () {
    function Spline(options) {
        this.points = options.points || [];
        this.duration = options.duration || 10000;
        this.sharpness = options.sharpness || 0.85;
        this.centers = [];
        this.controls = [];
        this.stepLength = options.stepLength || 60;
        this.length = this.points.length;
        this.delay = 0;
        // this is to ensure compatibility with the 2d version
        for (var i = 0; i < this.length; i++) {
            this.points[i].z = this.points[i].z || 0;
        }
        for (var i = 0; i < this.length - 1; i++) {
            var p1 = this.points[i];
            var p2 = this.points[i + 1];
            this.centers.push({
                x: (p1.x + p2.x) / 2,
                y: (p1.y + p2.y) / 2,
                z: (p1.z + p2.z) / 2,
            });
        }
        this.controls.push([this.points[0], this.points[0]]);
        for (var i = 0; i < this.centers.length - 1; i++) {
            var dx = this.points[i + 1].x - (this.centers[i].x + this.centers[i + 1].x) / 2;
            var dy = this.points[i + 1].y - (this.centers[i].y + this.centers[i + 1].y) / 2;
            var dz = this.points[i + 1].z - (this.centers[i].y + this.centers[i + 1].z) / 2;
            this.controls.push([
                {
                    x: (1.0 - this.sharpness) * this.points[i + 1].x +
                        this.sharpness * (this.centers[i].x + dx),
                    y: (1.0 - this.sharpness) * this.points[i + 1].y +
                        this.sharpness * (this.centers[i].y + dy),
                    z: (1.0 - this.sharpness) * this.points[i + 1].z +
                        this.sharpness * (this.centers[i].z + dz),
                },
                {
                    x: (1.0 - this.sharpness) * this.points[i + 1].x +
                        this.sharpness * (this.centers[i + 1].x + dx),
                    y: (1.0 - this.sharpness) * this.points[i + 1].y +
                        this.sharpness * (this.centers[i + 1].y + dy),
                    z: (1.0 - this.sharpness) * this.points[i + 1].z +
                        this.sharpness * (this.centers[i + 1].z + dz),
                },
            ]);
        }
        this.controls.push([
            this.points[this.length - 1],
            this.points[this.length - 1],
        ]);
        this.steps = this.cacheSteps(this.stepLength);
        return this;
    }
    /**
     * Caches an array of equidistant (more or less) points on the curve.
     */
    Spline.prototype.cacheSteps = function (mindist) {
        var steps = [];
        var laststep = this.pos(0);
        steps.push(0);
        for (var t = 0; t < this.duration; t += 10) {
            var step = this.pos(t);
            var dist = Math.sqrt((step.x - laststep.x) * (step.x - laststep.x) +
                (step.y - laststep.y) * (step.y - laststep.y) +
                (step.z - laststep.z) * (step.z - laststep.z));
            if (dist > mindist) {
                steps.push(t);
                laststep = step;
            }
        }
        return steps;
    };
    /**
     * returns angle and speed in the given point in the curve
     */
    Spline.prototype.vector = function (t) {
        var p1 = this.pos(t + 10);
        var p2 = this.pos(t - 10);
        return {
            angle: (180 * Math.atan2(p1.y - p2.y, p1.x - p2.x)) / 3.14,
            speed: Math.sqrt((p2.x - p1.x) * (p2.x - p1.x) +
                (p2.y - p1.y) * (p2.y - p1.y) +
                (p2.z - p1.z) * (p2.z - p1.z)),
        };
    };
    /**
     * Gets the position of the point, given time.
     *
     * WARNING: The speed is not constant. The time it takes between control points is constant.
     *
     * For constant speed, use Spline.steps[i];
     */
    Spline.prototype.pos = function (time) {
        var t = time - this.delay;
        if (t < 0) {
            t = 0;
        }
        if (t > this.duration) {
            t = this.duration - 1;
        }
        // t = t-this.delay;
        var t2 = t / this.duration;
        if (t2 >= 1) {
            return this.points[this.length - 1];
        }
        var n = Math.floor((this.points.length - 1) * t2);
        var t1 = (this.length - 1) * t2 - n;
        return bezier(t1, this.points[n], this.controls[n][1], this.controls[n + 1][0], this.points[n + 1]);
    };
    return Spline;
}());
/* harmony default export */ const spline = ((/* unused pure expression or super */ null && (Spline)));
function bezier(t, p1, c1, c2, p2) {
    var b = spline_B(t);
    var pos = {
        x: p2.x * b[0] + c2.x * b[1] + c1.x * b[2] + p1.x * b[3],
        y: p2.y * b[0] + c2.y * b[1] + c1.y * b[2] + p1.y * b[3],
        z: p2.z * b[0] + c2.z * b[1] + c1.z * b[2] + p1.z * b[3],
    };
    return pos;
}
function spline_B(t) {
    var t2 = t * t;
    var t3 = t2 * t;
    return [
        t3,
        3 * t2 * (1 - t),
        3 * t * (1 - t) * (1 - t),
        (1 - t) * (1 - t) * (1 - t),
    ];
}

;// ../../node_modules/@turf/bezier-spline/dist/es/index.js
/* unused harmony import specifier */ var dist_es_lineString;
/* unused harmony import specifier */ var es_getGeom;
/* unused harmony import specifier */ var es_Spline;



/**
 * Takes a {@link LineString|line} and returns a curved version
 * by applying a [Bezier spline](http://en.wikipedia.org/wiki/B%C3%A9zier_spline)
 * algorithm.
 *
 * The bezier spline implementation is by [Leszek Rybicki](http://leszek.rybicki.cc/).
 *
 * @name bezierSpline
 * @param {Feature<LineString>} line input LineString
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] Translate properties to output
 * @param {number} [options.resolution=10000] time in milliseconds between points
 * @param {number} [options.sharpness=0.85] a measure of how curvy the path should be between splines
 * @returns {Feature<LineString>} curved line
 * @example
 * var line = turf.lineString([
 *   [-76.091308, 18.427501],
 *   [-76.695556, 18.729501],
 *   [-76.552734, 19.40443],
 *   [-74.61914, 19.134789],
 *   [-73.652343, 20.07657],
 *   [-73.157958, 20.210656]
 * ]);
 *
 * var curved = turf.bezierSpline(line);
 *
 * //addToMap
 * var addToMap = [line, curved]
 * curved.properties = { stroke: '#0F0' };
 */
function es_bezier(line, options) {
    if (options === void 0) { options = {}; }
    // Optional params
    var resolution = options.resolution || 10000;
    var sharpness = options.sharpness || 0.85;
    var coords = [];
    var points = es_getGeom(line).coordinates.map(function (pt) {
        return { x: pt[0], y: pt[1] };
    });
    var spline = new es_Spline({
        duration: resolution,
        points: points,
        sharpness: sharpness,
    });
    var pushCoord = function (time) {
        var pos = spline.pos(time);
        if (Math.floor(time / 100) % 2 === 0) {
            coords.push([pos.x, pos.y]);
        }
    };
    for (var i = 0; i < spline.duration; i += 10) {
        pushCoord(i);
    }
    pushCoord(spline.duration);
    return dist_es_lineString(coords, options.properties);
}
/* harmony default export */ const bezier_spline_dist_es = ((/* unused pure expression or super */ null && (es_bezier)));

;// ../../node_modules/@turf/tag/dist/es/index.js
/* unused harmony import specifier */ var dist_es_booleanPointInPolygon;
/* unused harmony import specifier */ var tag_dist_es_clone;
/* unused harmony import specifier */ var tag_dist_es_featureEach;




/**
 * Takes a set of {@link Point|points} and a set of {@link Polygon|polygons} and/or {@link MultiPolygon|multipolygons} and performs a spatial join.
 *
 * @name tag
 * @param {FeatureCollection<Point>} points input points
 * @param {FeatureCollection<Polygon|MultiPolygon>} polygons input (multi)polygons
 * @param {string} field property in `polygons` to add to joined {<Point>} features
 * @param {string} outField property in `points` in which to store joined property from `polygons`
 * @returns {FeatureCollection<Point>} points with `containingPolyId` property containing values from `polyId`
 * @example
 * var pt1 = turf.point([-77, 44]);
 * var pt2 = turf.point([-77, 38]);
 * var poly1 = turf.polygon([[
 *   [-81, 41],
 *   [-81, 47],
 *   [-72, 47],
 *   [-72, 41],
 *   [-81, 41]
 * ]], {pop: 3000});
 * var poly2 = turf.polygon([[
 *   [-81, 35],
 *   [-81, 41],
 *   [-72, 41],
 *   [-72, 35],
 *   [-81, 35]
 * ]], {pop: 1000});
 *
 * var points = turf.featureCollection([pt1, pt2]);
 * var polygons = turf.featureCollection([poly1, poly2]);
 *
 * var tagged = turf.tag(points, polygons, 'pop', 'population');
 *
 * //addToMap
 * var addToMap = [tagged, polygons]
 */
function tag(points, polygons, field, outField) {
  // prevent mutations
  points = tag_dist_es_clone(points);
  polygons = tag_dist_es_clone(polygons);
  tag_dist_es_featureEach(points, function (pt) {
    if (!pt.properties) pt.properties = {};
    tag_dist_es_featureEach(polygons, function (poly) {
      if (pt.properties[outField] === undefined) {
        if (dist_es_booleanPointInPolygon(pt, poly))
          pt.properties[outField] = poly.properties[field];
      }
    });
  });
  return points;
}

/* harmony default export */ const tag_dist_es = ((/* unused pure expression or super */ null && (tag)));

;// ../../node_modules/@turf/sample/dist/es/index.js
/* unused harmony import specifier */ var sample_dist_es_featureCollection;


// http://stackoverflow.com/questions/11935175/sampling-a-random-subset-from-an-array

/**
 * Takes a {@link FeatureCollection} and returns a FeatureCollection with given number of {@link Feature|features} at random.
 *
 * @name sample
 * @param {FeatureCollection} featurecollection set of input features
 * @param {number} num number of features to select
 * @returns {FeatureCollection} a FeatureCollection with `n` features
 * @example
 * var points = turf.randomPoint(100, {bbox: [-80, 30, -60, 60]});
 *
 * var sample = turf.sample(points, 5);
 *
 * //addToMap
 * var addToMap = [points, sample]
 * turf.featureEach(sample, function (currentFeature) {
 *   currentFeature.properties['marker-size'] = 'large';
 *   currentFeature.properties['marker-color'] = '#000';
 * });
 */
function sample(featurecollection, num) {
  if (!featurecollection) throw new Error("featurecollection is required");
  if (num === null || num === undefined) throw new Error("num is required");
  if (typeof num !== "number") throw new Error("num must be a number");

  var outFC = sample_dist_es_featureCollection(
    getRandomSubarray(featurecollection.features, num)
  );
  return outFC;
}

function getRandomSubarray(arr, size) {
  var shuffled = arr.slice(0),
    i = arr.length,
    min = i - size,
    temp,
    index;
  while (i-- > min) {
    index = Math.floor((i + 1) * Math.random());
    temp = shuffled[index];
    shuffled[index] = shuffled[i];
    shuffled[i] = temp;
  }
  return shuffled.slice(min);
}

/* harmony default export */ const sample_dist_es = ((/* unused pure expression or super */ null && (sample)));

;// ../../node_modules/@turf/bbox-polygon/dist/es/index.js

/**
 * Takes a bbox and returns an equivalent {@link Polygon|polygon}.
 *
 * @name bboxPolygon
 * @param {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @param {Object} [options={}] Optional parameters
 * @param {Properties} [options.properties={}] Translate properties to Polygon
 * @param {string|number} [options.id={}] Translate Id to Polygon
 * @returns {Feature<Polygon>} a Polygon representation of the bounding box
 * @example
 * var bbox = [0, 0, 10, 10];
 *
 * var poly = turf.bboxPolygon(bbox);
 *
 * //addToMap
 * var addToMap = [poly]
 */
function bboxPolygon(bbox, options) {
    if (options === void 0) { options = {}; }
    // Convert BBox positions to Numbers
    // No performance loss for including Number()
    // https://github.com/Turfjs/turf/issues/1119
    var west = Number(bbox[0]);
    var south = Number(bbox[1]);
    var east = Number(bbox[2]);
    var north = Number(bbox[3]);
    if (bbox.length === 6) {
        throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
    }
    var lowLeft = [west, south];
    var topLeft = [west, north];
    var topRight = [east, north];
    var lowRight = [east, south];
    return polygon([[lowLeft, lowRight, topRight, topLeft, lowLeft]], options.properties, { bbox: bbox, id: options.id });
}

;// ../../node_modules/@turf/envelope/dist/es/index.js



/**
 * Takes any number of features and returns a rectangular {@link Polygon} that encompasses all vertices.
 *
 * @name envelope
 * @param {GeoJSON} geojson input features
 * @returns {Feature<Polygon>} a rectangular Polygon feature that encompasses all vertices
 * @example
 * var features = turf.featureCollection([
 *   turf.point([-75.343, 39.984], {"name": "Location A"}),
 *   turf.point([-75.833, 39.284], {"name": "Location B"}),
 *   turf.point([-75.534, 39.123], {"name": "Location C"})
 * ]);
 *
 * var enveloped = turf.envelope(features);
 *
 * //addToMap
 * var addToMap = [features, enveloped];
 */
function envelope(geojson) {
  return bboxPolygon(es(geojson));
}

/* harmony default export */ const envelope_dist_es = (envelope);

;// ../../node_modules/@turf/square/dist/es/index.js
/* unused harmony import specifier */ var dist_es_distance;


/**
 * Takes a bounding box and calculates the minimum square bounding box that
 * would contain the input.
 *
 * @name square
 * @param {BBox} bbox extent in [west, south, east, north] order
 * @returns {BBox} a square surrounding `bbox`
 * @example
 * var bbox = [-20, -20, -15, 0];
 * var squared = turf.square(bbox);
 *
 * //addToMap
 * var addToMap = [turf.bboxPolygon(bbox), turf.bboxPolygon(squared)]
 */
function square(bbox) {
  var west = bbox[0];
  var south = bbox[1];
  var east = bbox[2];
  var north = bbox[3];

  var horizontalDistance = dist_es_distance(bbox.slice(0, 2), [east, south]);
  var verticalDistance = dist_es_distance(bbox.slice(0, 2), [west, north]);
  if (horizontalDistance >= verticalDistance) {
    var verticalMidpoint = (south + north) / 2;
    return [
      west,
      verticalMidpoint - (east - west) / 2,
      east,
      verticalMidpoint + (east - west) / 2,
    ];
  } else {
    var horizontalMidpoint = (west + east) / 2;
    return [
      horizontalMidpoint - (north - south) / 2,
      south,
      horizontalMidpoint + (north - south) / 2,
      north,
    ];
  }
}

/* harmony default export */ const square_dist_es = ((/* unused pure expression or super */ null && (square)));

;// ../../node_modules/@turf/destination/dist/es/index.js
/* unused harmony import specifier */ var dist_es_degreesToRadians;
/* unused harmony import specifier */ var es_lengthToRadians;
/* unused harmony import specifier */ var es_radiansToDegrees;
/* unused harmony import specifier */ var dist_es_point;
/* unused harmony import specifier */ var dist_es_getCoord;
// http://en.wikipedia.org/wiki/Haversine_formula
// http://www.movable-type.co.uk/scripts/latlong.html


/**
 * Takes a {@link Point} and calculates the location of a destination point given a distance in
 * degrees, radians, miles, or kilometers; and bearing in degrees.
 * This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula) to account for global curvature.
 *
 * @name destination
 * @param {Coord} origin starting point
 * @param {number} distance distance from the origin point
 * @param {number} bearing ranging from -180 to 180
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] miles, kilometers, degrees, or radians
 * @param {Object} [options.properties={}] Translate properties to Point
 * @returns {Feature<Point>} destination point
 * @example
 * var point = turf.point([-75.343, 39.984]);
 * var distance = 50;
 * var bearing = 90;
 * var options = {units: 'miles'};
 *
 * var destination = turf.destination(point, distance, bearing, options);
 *
 * //addToMap
 * var addToMap = [point, destination]
 * destination.properties['marker-color'] = '#f00';
 * point.properties['marker-color'] = '#0f0';
 */
function destination(origin, distance, bearing, options) {
    if (options === void 0) { options = {}; }
    // Handle input
    var coordinates1 = dist_es_getCoord(origin);
    var longitude1 = dist_es_degreesToRadians(coordinates1[0]);
    var latitude1 = dist_es_degreesToRadians(coordinates1[1]);
    var bearingRad = dist_es_degreesToRadians(bearing);
    var radians = es_lengthToRadians(distance, options.units);
    // Main
    var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians) +
        Math.cos(latitude1) * Math.sin(radians) * Math.cos(bearingRad));
    var longitude2 = longitude1 +
        Math.atan2(Math.sin(bearingRad) * Math.sin(radians) * Math.cos(latitude1), Math.cos(radians) - Math.sin(latitude1) * Math.sin(latitude2));
    var lng = es_radiansToDegrees(longitude2);
    var lat = es_radiansToDegrees(latitude2);
    return dist_es_point([lng, lat], options.properties);
}

;// ../../node_modules/@turf/circle/dist/es/index.js
/* unused harmony import specifier */ var es_destination;
/* unused harmony import specifier */ var dist_es_polygon;


/**
 * Takes a {@link Point} and calculates the circle polygon given a radius in degrees, radians, miles, or kilometers; and steps for precision.
 *
 * @name circle
 * @param {Feature<Point>|number[]} center center point
 * @param {number} radius radius of the circle
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.steps=64] number of steps
 * @param {string} [options.units='kilometers'] miles, kilometers, degrees, or radians
 * @param {Object} [options.properties={}] properties
 * @returns {Feature<Polygon>} circle polygon
 * @example
 * var center = [-75.343, 39.984];
 * var radius = 5;
 * var options = {steps: 10, units: 'kilometers', properties: {foo: 'bar'}};
 * var circle = turf.circle(center, radius, options);
 *
 * //addToMap
 * var addToMap = [turf.point(center), circle]
 */
function circle(center, radius, options) {
    if (options === void 0) { options = {}; }
    // default params
    var steps = options.steps || 64;
    var properties = options.properties
        ? options.properties
        : !Array.isArray(center) && center.type === "Feature" && center.properties
            ? center.properties
            : {};
    // main
    var coordinates = [];
    for (var i = 0; i < steps; i++) {
        coordinates.push(es_destination(center, radius, (i * -360) / steps, options).geometry
            .coordinates);
    }
    coordinates.push(coordinates[0]);
    return dist_es_polygon([coordinates], properties);
}
/* harmony default export */ const circle_dist_es = ((/* unused pure expression or super */ null && (circle)));

;// ../../node_modules/@turf/bearing/dist/es/index.js
/* unused harmony import specifier */ var bearing_dist_es_degreesToRadians;
/* unused harmony import specifier */ var dist_es_radiansToDegrees;
/* unused harmony import specifier */ var bearing_dist_es_getCoord;


// http://en.wikipedia.org/wiki/Haversine_formula
// http://www.movable-type.co.uk/scripts/latlong.html
/**
 * Takes two {@link Point|points} and finds the geographic bearing between them,
 * i.e. the angle measured in degrees from the north line (0 degrees)
 *
 * @name bearing
 * @param {Coord} start starting Point
 * @param {Coord} end ending Point
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.final=false] calculates the final bearing if true
 * @returns {number} bearing in decimal degrees, between -180 and 180 degrees (positive clockwise)
 * @example
 * var point1 = turf.point([-75.343, 39.984]);
 * var point2 = turf.point([-75.534, 39.123]);
 *
 * var bearing = turf.bearing(point1, point2);
 *
 * //addToMap
 * var addToMap = [point1, point2]
 * point1.properties['marker-color'] = '#f00'
 * point2.properties['marker-color'] = '#0f0'
 * point1.properties.bearing = bearing
 */
function bearing(start, end, options) {
    if (options === void 0) { options = {}; }
    // Reverse calculation
    if (options.final === true) {
        return calculateFinalBearing(start, end);
    }
    var coordinates1 = bearing_dist_es_getCoord(start);
    var coordinates2 = bearing_dist_es_getCoord(end);
    var lon1 = bearing_dist_es_degreesToRadians(coordinates1[0]);
    var lon2 = bearing_dist_es_degreesToRadians(coordinates2[0]);
    var lat1 = bearing_dist_es_degreesToRadians(coordinates1[1]);
    var lat2 = bearing_dist_es_degreesToRadians(coordinates2[1]);
    var a = Math.sin(lon2 - lon1) * Math.cos(lat2);
    var b = Math.cos(lat1) * Math.sin(lat2) -
        Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
    return dist_es_radiansToDegrees(Math.atan2(a, b));
}
/**
 * Calculates Final Bearing
 *
 * @private
 * @param {Coord} start starting Point
 * @param {Coord} end ending Point
 * @returns {number} bearing
 */
function calculateFinalBearing(start, end) {
    // Swap start & end
    var bear = bearing(end, start);
    bear = (bear + 180) % 360;
    return bear;
}

;// ../../node_modules/@turf/midpoint/dist/es/index.js
/* unused harmony import specifier */ var es_bearing;
/* unused harmony import specifier */ var dist_es_destination;
/* unused harmony import specifier */ var midpoint_dist_es_distance;




/**
 * Takes two {@link Point|points} and returns a point midway between them.
 * The midpoint is calculated geodesically, meaning the curvature of the earth is taken into account.
 *
 * @name midpoint
 * @param {Coord} point1 first point
 * @param {Coord} point2 second point
 * @returns {Feature<Point>} a point midway between `pt1` and `pt2`
 * @example
 * var point1 = turf.point([144.834823, -37.771257]);
 * var point2 = turf.point([145.14244, -37.830937]);
 *
 * var midpoint = turf.midpoint(point1, point2);
 *
 * //addToMap
 * var addToMap = [point1, point2, midpoint];
 * midpoint.properties['marker-color'] = '#f00';
 */
function midpoint(point1, point2) {
  var dist = midpoint_dist_es_distance(point1, point2);
  var heading = es_bearing(point1, point2);
  var midpoint = dist_es_destination(point1, dist / 2, heading);

  return midpoint;
}

/* harmony default export */ const midpoint_dist_es = ((/* unused pure expression or super */ null && (midpoint)));

;// ../../node_modules/@turf/center/dist/es/index.js
/* unused harmony import specifier */ var dist_es_bbox;
/* unused harmony import specifier */ var center_dist_es_point;


/**
 * Takes a {@link Feature} or {@link FeatureCollection} and returns the absolute center point of all features.
 *
 * @name center
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] Translate GeoJSON Properties to Point
 * @param {Object} [options.bbox={}] Translate GeoJSON BBox to Point
 * @param {Object} [options.id={}] Translate GeoJSON Id to Point
 * @returns {Feature<Point>} a Point feature at the absolute center point of all input features
 * @example
 * var features = turf.points([
 *   [-97.522259, 35.4691],
 *   [-97.502754, 35.463455],
 *   [-97.508269, 35.463245]
 * ]);
 *
 * var center = turf.center(features);
 *
 * //addToMap
 * var addToMap = [features, center]
 * center.properties['marker-size'] = 'large';
 * center.properties['marker-color'] = '#000';
 */
function center(geojson, options) {
    if (options === void 0) { options = {}; }
    var ext = dist_es_bbox(geojson);
    var x = (ext[0] + ext[2]) / 2;
    var y = (ext[1] + ext[3]) / 2;
    return center_dist_es_point([x, y], options.properties, options);
}
/* harmony default export */ const center_dist_es = ((/* unused pure expression or super */ null && (center)));

;// ../../node_modules/@turf/centroid/dist/es/index.js


/**
 * Takes one or more features and calculates the centroid using the mean of all vertices.
 * This lessens the effect of small islands and artifacts when calculating the centroid of a set of polygons.
 *
 * @name centroid
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [options={}] Optional Parameters
 * @param {Object} [options.properties={}] an Object that is used as the {@link Feature}'s properties
 * @returns {Feature<Point>} the centroid of the input features
 * @example
 * var polygon = turf.polygon([[[-81, 41], [-88, 36], [-84, 31], [-80, 33], [-77, 39], [-81, 41]]]);
 *
 * var centroid = turf.centroid(polygon);
 *
 * //addToMap
 * var addToMap = [polygon, centroid]
 */
function centroid(geojson, options) {
    if (options === void 0) { options = {}; }
    var xSum = 0;
    var ySum = 0;
    var len = 0;
    coordEach(geojson, function (coord) {
        xSum += coord[0];
        ySum += coord[1];
        len++;
    }, true);
    return point([xSum / len, ySum / len], options.properties);
}
/* harmony default export */ const centroid_dist_es = (centroid);

;// ../../node_modules/@turf/center-of-mass/dist/es/index.js





/**
 * Takes any {@link Feature} or a {@link FeatureCollection} and returns its [center of mass](https://en.wikipedia.org/wiki/Center_of_mass) using this formula: [Centroid of Polygon](https://en.wikipedia.org/wiki/Centroid#Centroid_of_polygon).
 *
 * @name centerOfMass
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [options={}] Optional Parameters
 * @param {Object} [options.properties={}] Translate Properties to Feature
 * @returns {Feature<Point>} the center of mass
 * @example
 * var polygon = turf.polygon([[[-81, 41], [-88, 36], [-84, 31], [-80, 33], [-77, 39], [-81, 41]]]);
 *
 * var center = turf.centerOfMass(polygon);
 *
 * //addToMap
 * var addToMap = [polygon, center]
 */
function centerOfMass(geojson, options) {
    if (options === void 0) { options = {}; }
    switch (getType(geojson)) {
        case "Point":
            return point(getCoord(geojson), options.properties);
        case "Polygon":
            var coords = [];
            coordEach(geojson, function (coord) {
                coords.push(coord);
            });
            // First, we neutralize the feature (set it around coordinates [0,0]) to prevent rounding errors
            // We take any point to translate all the points around 0
            var centre = centroid_dist_es(geojson, { properties: options.properties });
            var translation = centre.geometry.coordinates;
            var sx = 0;
            var sy = 0;
            var sArea = 0;
            var i, pi, pj, xi, xj, yi, yj, a;
            var neutralizedPoints = coords.map(function (point) {
                return [point[0] - translation[0], point[1] - translation[1]];
            });
            for (i = 0; i < coords.length - 1; i++) {
                // pi is the current point
                pi = neutralizedPoints[i];
                xi = pi[0];
                yi = pi[1];
                // pj is the next point (pi+1)
                pj = neutralizedPoints[i + 1];
                xj = pj[0];
                yj = pj[1];
                // a is the common factor to compute the signed area and the final coordinates
                a = xi * yj - xj * yi;
                // sArea is the sum used to compute the signed area
                sArea += a;
                // sx and sy are the sums used to compute the final coordinates
                sx += (xi + xj) * a;
                sy += (yi + yj) * a;
            }
            // Shape has no area: fallback on turf.centroid
            if (sArea === 0) {
                return centre;
            }
            else {
                // Compute the signed area, and factorize 1/6A
                var area = sArea * 0.5;
                var areaFactor = 1 / (6 * area);
                // Compute the final coordinates, adding back the values that have been neutralized
                return point([translation[0] + areaFactor * sx, translation[1] + areaFactor * sy], options.properties);
            }
        default:
            // Not a polygon: Compute the convex hull and work with that
            var hull = convex(geojson);
            if (hull)
                return centerOfMass(hull, { properties: options.properties });
            // Hull is empty: fallback on the centroid
            else
                return centroid_dist_es(geojson, { properties: options.properties });
    }
}
/* harmony default export */ const center_of_mass_dist_es = (centerOfMass);

;// ../../node_modules/@turf/combine/dist/es/index.js
/* unused harmony import specifier */ var combine_dist_es_featureCollection;
/* unused harmony import specifier */ var combine_dist_es_feature;
/* unused harmony import specifier */ var combine_dist_es_featureEach;


/**
 * Combines a {@link FeatureCollection} of {@link Point}, {@link LineString}, or {@link Polygon} features
 * into {@link MultiPoint}, {@link MultiLineString}, or {@link MultiPolygon} features.
 *
 * @name combine
 * @param {FeatureCollection<Point|LineString|Polygon>} fc a FeatureCollection of any type
 * @returns {FeatureCollection<MultiPoint|MultiLineString|MultiPolygon>} a FeatureCollection of corresponding type to input
 * @example
 * var fc = turf.featureCollection([
 *   turf.point([19.026432, 47.49134]),
 *   turf.point([19.074497, 47.509548])
 * ]);
 *
 * var combined = turf.combine(fc);
 *
 * //addToMap
 * var addToMap = [combined]
 */
function combine(fc) {
    var groups = {
        MultiPoint: {
            coordinates: [],
            properties: [],
        },
        MultiLineString: {
            coordinates: [],
            properties: [],
        },
        MultiPolygon: {
            coordinates: [],
            properties: [],
        },
    };
    combine_dist_es_featureEach(fc, function (feature) {
        var _a, _b, _c;
        var _d;
        switch ((_d = feature.geometry) === null || _d === void 0 ? void 0 : _d.type) {
            case "Point":
                groups.MultiPoint.coordinates.push(feature.geometry.coordinates);
                groups.MultiPoint.properties.push(feature.properties);
                break;
            case "MultiPoint":
                (_a = groups.MultiPoint.coordinates).push.apply(_a, feature.geometry.coordinates);
                groups.MultiPoint.properties.push(feature.properties);
                break;
            case "LineString":
                groups.MultiLineString.coordinates.push(feature.geometry.coordinates);
                groups.MultiLineString.properties.push(feature.properties);
                break;
            case "MultiLineString":
                (_b = groups.MultiLineString.coordinates).push.apply(_b, feature.geometry.coordinates);
                groups.MultiLineString.properties.push(feature.properties);
                break;
            case "Polygon":
                groups.MultiPolygon.coordinates.push(feature.geometry.coordinates);
                groups.MultiPolygon.properties.push(feature.properties);
                break;
            case "MultiPolygon":
                (_c = groups.MultiPolygon.coordinates).push.apply(_c, feature.geometry.coordinates);
                groups.MultiPolygon.properties.push(feature.properties);
                break;
            default:
                break;
        }
    });
    return combine_dist_es_featureCollection(Object.keys(groups)
        .filter(function (key) {
        return groups[key].coordinates.length;
    })
        .sort()
        .map(function (key) {
        var geometry = { type: key, coordinates: groups[key].coordinates };
        var properties = { collectedProperties: groups[key].properties };
        return combine_dist_es_feature(geometry, properties);
    }));
}
/* harmony default export */ const combine_dist_es = ((/* unused pure expression or super */ null && (combine)));

;// ../../node_modules/@turf/explode/dist/es/index.js
/* unused harmony import specifier */ var explode_dist_es_featureEach;
/* unused harmony import specifier */ var explode_dist_es_coordEach;
/* unused harmony import specifier */ var explode_dist_es_point;
/* unused harmony import specifier */ var explode_dist_es_featureCollection;



/**
 * Takes a feature or set of features and returns all positions as {@link Point|points}.
 *
 * @name explode
 * @param {GeoJSON} geojson input features
 * @returns {FeatureCollection<point>} points representing the exploded input features
 * @throws {Error} if it encounters an unknown geometry type
 * @example
 * var polygon = turf.polygon([[[-81, 41], [-88, 36], [-84, 31], [-80, 33], [-77, 39], [-81, 41]]]);
 *
 * var explode = turf.explode(polygon);
 *
 * //addToMap
 * var addToMap = [polygon, explode]
 */
function explode(geojson) {
  var points = [];
  if (geojson.type === "FeatureCollection") {
    explode_dist_es_featureEach(geojson, function (feature) {
      explode_dist_es_coordEach(feature, function (coord) {
        points.push(explode_dist_es_point(coord, feature.properties));
      });
    });
  } else {
    explode_dist_es_coordEach(geojson, function (coord) {
      points.push(explode_dist_es_point(coord, geojson.properties));
    });
  }
  return explode_dist_es_featureCollection(points);
}

/* harmony default export */ const explode_dist_es = ((/* unused pure expression or super */ null && (explode)));

// EXTERNAL MODULE: ../../node_modules/earcut/src/earcut.js
var earcut = __webpack_require__(1767);
;// ../../node_modules/@turf/tesselate/dist/es/index.js
/* unused harmony import specifier */ var es_earcut;
/* unused harmony import specifier */ var tesselate_dist_es_polygon;



/**
 * Tesselates a {@link Feature<Polygon>} into a {@link FeatureCollection<Polygon>} of triangles
 * using [earcut](https://github.com/mapbox/earcut).
 *
 * @name tesselate
 * @param {Feature<Polygon>} poly the polygon to tesselate
 * @returns {FeatureCollection<Polygon>} a geometrycollection feature
 * @example
 * var poly = turf.polygon([[[11, 0], [22, 4], [31, 0], [31, 11], [21, 15], [11, 11], [11, 0]]]);
 * var triangles = turf.tesselate(poly);
 *
 * //addToMap
 * var addToMap = [poly, triangles]
 */
function tesselate(poly) {
  if (
    !poly.geometry ||
    (poly.geometry.type !== "Polygon" && poly.geometry.type !== "MultiPolygon")
  ) {
    throw new Error("input must be a Polygon or MultiPolygon");
  }

  var fc = { type: "FeatureCollection", features: [] };

  if (poly.geometry.type === "Polygon") {
    fc.features = processPolygon(poly.geometry.coordinates);
  } else {
    poly.geometry.coordinates.forEach(function (coordinates) {
      fc.features = fc.features.concat(processPolygon(coordinates));
    });
  }

  return fc;
}

function processPolygon(coordinates) {
  var data = flattenCoords(coordinates);
  var dim = 2;
  var result = es_earcut(data.vertices, data.holes, dim);

  var features = [];
  var vertices = [];

  result.forEach(function (vert, i) {
    var index = result[i];
    vertices.push([data.vertices[index * dim], data.vertices[index * dim + 1]]);
  });

  for (var i = 0; i < vertices.length; i += 3) {
    var coords = vertices.slice(i, i + 3);
    coords.push(vertices[i]);
    features.push(tesselate_dist_es_polygon([coords]));
  }

  return features;
}

function flattenCoords(data) {
  var dim = data[0][0].length,
    result = { vertices: [], holes: [], dimensions: dim },
    holeIndex = 0;

  for (var i = 0; i < data.length; i++) {
    for (var j = 0; j < data[i].length; j++) {
      for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
    }
    if (i > 0) {
      holeIndex += data[i - 1].length;
      result.holes.push(holeIndex);
    }
  }

  return result;
}

/* harmony default export */ const tesselate_dist_es = ((/* unused pure expression or super */ null && (tesselate)));

;// ../../node_modules/@turf/nearest-point/dist/es/index.js
/* unused harmony import specifier */ var nearest_point_dist_es_clone;
/* unused harmony import specifier */ var nearest_point_dist_es_distance;
/* unused harmony import specifier */ var nearest_point_dist_es_featureEach;



/**
 * Takes a reference {@link Point|point} and a FeatureCollection of Features
 * with Point geometries and returns the
 * point from the FeatureCollection closest to the reference. This calculation
 * is geodesic.
 *
 * @name nearestPoint
 * @param {Coord} targetPoint the reference point
 * @param {FeatureCollection<Point>} points against input point set
 * @returns {Feature<Point>} the closest point in the set to the reference point
 * @example
 * var targetPoint = turf.point([28.965797, 41.010086], {"marker-color": "#0F0"});
 * var points = turf.featureCollection([
 *     turf.point([28.973865, 41.011122]),
 *     turf.point([28.948459, 41.024204]),
 *     turf.point([28.938674, 41.013324])
 * ]);
 *
 * var nearest = turf.nearestPoint(targetPoint, points);
 *
 * //addToMap
 * var addToMap = [targetPoint, points, nearest];
 * nearest.properties['marker-color'] = '#F00';
 */
function nearestPoint(targetPoint, points) {
    // Input validation
    if (!targetPoint)
        throw new Error("targetPoint is required");
    if (!points)
        throw new Error("points is required");
    var nearest;
    var minDist = Infinity;
    var bestFeatureIndex = 0;
    nearest_point_dist_es_featureEach(points, function (pt, featureIndex) {
        var distanceToPoint = nearest_point_dist_es_distance(targetPoint, pt);
        if (distanceToPoint < minDist) {
            bestFeatureIndex = featureIndex;
            minDist = distanceToPoint;
        }
    });
    nearest = nearest_point_dist_es_clone(points.features[bestFeatureIndex]);
    nearest.properties.featureIndex = bestFeatureIndex;
    nearest.properties.distanceToPoint = minDist;
    return nearest;
}
/* harmony default export */ const nearest_point_dist_es = ((/* unused pure expression or super */ null && (nearestPoint)));

;// ../../node_modules/@turf/line-segment/dist/es/index.js
/* unused harmony import specifier */ var line_segment_dist_es_featureCollection;
/* unused harmony import specifier */ var line_segment_dist_es_lineString;
/* unused harmony import specifier */ var line_segment_dist_es_getCoords;
/* unused harmony import specifier */ var es_flattenEach;



/**
 * Creates a {@link FeatureCollection} of 2-vertex {@link LineString} segments from a
 * {@link LineString|(Multi)LineString} or {@link Polygon|(Multi)Polygon}.
 *
 * @name lineSegment
 * @param {GeoJSON} geojson GeoJSON Polygon or LineString
 * @returns {FeatureCollection<LineString>} 2-vertex line segments
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 * var segments = turf.lineSegment(polygon);
 *
 * //addToMap
 * var addToMap = [polygon, segments]
 */
function lineSegment(geojson) {
    if (!geojson) {
        throw new Error("geojson is required");
    }
    var results = [];
    es_flattenEach(geojson, function (feature) {
        lineSegmentFeature(feature, results);
    });
    return line_segment_dist_es_featureCollection(results);
}
/**
 * Line Segment
 *
 * @private
 * @param {Feature<LineString|Polygon>} geojson Line or polygon feature
 * @param {Array} results push to results
 * @returns {void}
 */
function lineSegmentFeature(geojson, results) {
    var coords = [];
    var geometry = geojson.geometry;
    if (geometry !== null) {
        switch (geometry.type) {
            case "Polygon":
                coords = line_segment_dist_es_getCoords(geometry);
                break;
            case "LineString":
                coords = [line_segment_dist_es_getCoords(geometry)];
        }
        coords.forEach(function (coord) {
            var segments = createSegments(coord, geojson.properties);
            segments.forEach(function (segment) {
                segment.id = results.length;
                results.push(segment);
            });
        });
    }
}
/**
 * Create Segments from LineString coordinates
 *
 * @private
 * @param {Array<Array<number>>} coords LineString coordinates
 * @param {*} properties GeoJSON properties
 * @returns {Array<Feature<LineString>>} line segments
 */
function createSegments(coords, properties) {
    var segments = [];
    coords.reduce(function (previousCoords, currentCoords) {
        var segment = line_segment_dist_es_lineString([previousCoords, currentCoords], properties);
        segment.bbox = line_segment_dist_es_bbox(previousCoords, currentCoords);
        segments.push(segment);
        return currentCoords;
    });
    return segments;
}
/**
 * Create BBox between two coordinates (faster than @turf/bbox)
 *
 * @private
 * @param {Array<number>} coords1 Point coordinate
 * @param {Array<number>} coords2 Point coordinate
 * @returns {BBox} [west, south, east, north]
 */
function line_segment_dist_es_bbox(coords1, coords2) {
    var x1 = coords1[0];
    var y1 = coords1[1];
    var x2 = coords2[0];
    var y2 = coords2[1];
    var west = x1 < x2 ? x1 : x2;
    var south = y1 < y2 ? y1 : y2;
    var east = x1 > x2 ? x1 : x2;
    var north = y1 > y2 ? y1 : y2;
    return [west, south, east, north];
}
/* harmony default export */ const line_segment_dist_es = ((/* unused pure expression or super */ null && (lineSegment)));

// EXTERNAL MODULE: ../../node_modules/geojson-rbush/index.js
var geojson_rbush = __webpack_require__(6032);
;// ../../node_modules/@turf/line-intersect/dist/es/index.js
/* unused harmony import specifier */ var line_intersect_dist_es_feature;
/* unused harmony import specifier */ var line_intersect_dist_es_featureCollection;
/* unused harmony import specifier */ var line_intersect_dist_es_point;
/* unused harmony import specifier */ var line_intersect_dist_es_getCoords;
/* unused harmony import specifier */ var es_lineSegment;
/* unused harmony import specifier */ var line_intersect_dist_es_featureEach;
/* unused harmony import specifier */ var dist_es_rbush;





/**
 * Takes any LineString or Polygon GeoJSON and returns the intersecting point(s).
 *
 * @name lineIntersect
 * @param {GeoJSON} line1 any LineString or Polygon
 * @param {GeoJSON} line2 any LineString or Polygon
 * @returns {FeatureCollection<Point>} point(s) that intersect both
 * @example
 * var line1 = turf.lineString([[126, -11], [129, -21]]);
 * var line2 = turf.lineString([[123, -18], [131, -14]]);
 * var intersects = turf.lineIntersect(line1, line2);
 *
 * //addToMap
 * var addToMap = [line1, line2, intersects]
 */
function lineIntersect(line1, line2) {
    var unique = {};
    var results = [];
    // First, normalize geometries to features
    // Then, handle simple 2-vertex segments
    if (line1.type === "LineString") {
        line1 = line_intersect_dist_es_feature(line1);
    }
    if (line2.type === "LineString") {
        line2 = line_intersect_dist_es_feature(line2);
    }
    if (line1.type === "Feature" &&
        line2.type === "Feature" &&
        line1.geometry !== null &&
        line2.geometry !== null &&
        line1.geometry.type === "LineString" &&
        line2.geometry.type === "LineString" &&
        line1.geometry.coordinates.length === 2 &&
        line2.geometry.coordinates.length === 2) {
        var intersect = es_intersects(line1, line2);
        if (intersect) {
            results.push(intersect);
        }
        return line_intersect_dist_es_featureCollection(results);
    }
    // Handles complex GeoJSON Geometries
    var tree = dist_es_rbush();
    tree.load(es_lineSegment(line2));
    line_intersect_dist_es_featureEach(es_lineSegment(line1), function (segment) {
        line_intersect_dist_es_featureEach(tree.search(segment), function (match) {
            var intersect = es_intersects(segment, match);
            if (intersect) {
                // prevent duplicate points https://github.com/Turfjs/turf/issues/688
                var key = line_intersect_dist_es_getCoords(intersect).join(",");
                if (!unique[key]) {
                    unique[key] = true;
                    results.push(intersect);
                }
            }
        });
    });
    return line_intersect_dist_es_featureCollection(results);
}
/**
 * Find a point that intersects LineStrings with two coordinates each
 *
 * @private
 * @param {Feature<LineString>} line1 GeoJSON LineString (Must only contain 2 coordinates)
 * @param {Feature<LineString>} line2 GeoJSON LineString (Must only contain 2 coordinates)
 * @returns {Feature<Point>} intersecting GeoJSON Point
 */
function es_intersects(line1, line2) {
    var coords1 = line_intersect_dist_es_getCoords(line1);
    var coords2 = line_intersect_dist_es_getCoords(line2);
    if (coords1.length !== 2) {
        throw new Error("<intersects> line1 must only contain 2 coordinates");
    }
    if (coords2.length !== 2) {
        throw new Error("<intersects> line2 must only contain 2 coordinates");
    }
    var x1 = coords1[0][0];
    var y1 = coords1[0][1];
    var x2 = coords1[1][0];
    var y2 = coords1[1][1];
    var x3 = coords2[0][0];
    var y3 = coords2[0][1];
    var x4 = coords2[1][0];
    var y4 = coords2[1][1];
    var denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
    var numeA = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
    var numeB = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
    if (denom === 0) {
        if (numeA === 0 && numeB === 0) {
            return null;
        }
        return null;
    }
    var uA = numeA / denom;
    var uB = numeB / denom;
    if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
        var x = x1 + uA * (x2 - x1);
        var y = y1 + uA * (y2 - y1);
        return line_intersect_dist_es_point([x, y]);
    }
    return null;
}
/* harmony default export */ const line_intersect_dist_es = ((/* unused pure expression or super */ null && (lineIntersect)));

;// ../../node_modules/@turf/nearest-point-on-line/dist/es/index.js
/* unused harmony import specifier */ var dist_es_bearing;
/* unused harmony import specifier */ var nearest_point_on_line_dist_es_distance;
/* unused harmony import specifier */ var nearest_point_on_line_dist_es_destination;
/* unused harmony import specifier */ var lineIntersects;
/* unused harmony import specifier */ var dist_es_flattenEach;
/* unused harmony import specifier */ var nearest_point_on_line_dist_es_point;
/* unused harmony import specifier */ var nearest_point_on_line_dist_es_lineString;
/* unused harmony import specifier */ var nearest_point_on_line_dist_es_getCoords;







/**
 * Takes a {@link Point} and a {@link LineString} and calculates the closest Point on the (Multi)LineString.
 *
 * @name nearestPointOnLine
 * @param {Geometry|Feature<LineString|MultiLineString>} lines lines to snap to
 * @param {Geometry|Feature<Point>|number[]} pt point to snap from
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
 * @returns {Feature<Point>} closest point on the `line` to `point`. The properties object will contain three values: `index`: closest point was found on nth line part, `dist`: distance between pt and the closest point, `location`: distance along the line between start and the closest point.
 * @example
 * var line = turf.lineString([
 *     [-77.031669, 38.878605],
 *     [-77.029609, 38.881946],
 *     [-77.020339, 38.884084],
 *     [-77.025661, 38.885821],
 *     [-77.021884, 38.889563],
 *     [-77.019824, 38.892368]
 * ]);
 * var pt = turf.point([-77.037076, 38.884017]);
 *
 * var snapped = turf.nearestPointOnLine(line, pt, {units: 'miles'});
 *
 * //addToMap
 * var addToMap = [line, pt, snapped];
 * snapped.properties['marker-color'] = '#00f';
 */
function nearestPointOnLine(lines, pt, options) {
    if (options === void 0) { options = {}; }
    var closestPt = nearest_point_on_line_dist_es_point([Infinity, Infinity], {
        dist: Infinity,
    });
    var length = 0.0;
    dist_es_flattenEach(lines, function (line) {
        var coords = nearest_point_on_line_dist_es_getCoords(line);
        for (var i = 0; i < coords.length - 1; i++) {
            //start
            var start = nearest_point_on_line_dist_es_point(coords[i]);
            start.properties.dist = nearest_point_on_line_dist_es_distance(pt, start, options);
            //stop
            var stop_1 = nearest_point_on_line_dist_es_point(coords[i + 1]);
            stop_1.properties.dist = nearest_point_on_line_dist_es_distance(pt, stop_1, options);
            // sectionLength
            var sectionLength = nearest_point_on_line_dist_es_distance(start, stop_1, options);
            //perpendicular
            var heightDistance = Math.max(start.properties.dist, stop_1.properties.dist);
            var direction = dist_es_bearing(start, stop_1);
            var perpendicularPt1 = nearest_point_on_line_dist_es_destination(pt, heightDistance, direction + 90, options);
            var perpendicularPt2 = nearest_point_on_line_dist_es_destination(pt, heightDistance, direction - 90, options);
            var intersect = lineIntersects(nearest_point_on_line_dist_es_lineString([
                perpendicularPt1.geometry.coordinates,
                perpendicularPt2.geometry.coordinates,
            ]), nearest_point_on_line_dist_es_lineString([start.geometry.coordinates, stop_1.geometry.coordinates]));
            var intersectPt = null;
            if (intersect.features.length > 0) {
                intersectPt = intersect.features[0];
                intersectPt.properties.dist = nearest_point_on_line_dist_es_distance(pt, intersectPt, options);
                intersectPt.properties.location =
                    length + nearest_point_on_line_dist_es_distance(start, intersectPt, options);
            }
            if (start.properties.dist < closestPt.properties.dist) {
                closestPt = start;
                closestPt.properties.index = i;
                closestPt.properties.location = length;
            }
            if (stop_1.properties.dist < closestPt.properties.dist) {
                closestPt = stop_1;
                closestPt.properties.index = i + 1;
                closestPt.properties.location = length + sectionLength;
            }
            if (intersectPt &&
                intersectPt.properties.dist < closestPt.properties.dist) {
                closestPt = intersectPt;
                closestPt.properties.index = i;
            }
            // update length
            length += sectionLength;
        }
    });
    return closestPt;
}
/* harmony default export */ const nearest_point_on_line_dist_es = ((/* unused pure expression or super */ null && (nearestPointOnLine)));

;// ../../node_modules/@turf/rhumb-distance/dist/es/index.js
/* unused harmony import specifier */ var es_convertLength;
/* unused harmony import specifier */ var es_earthRadius;
/* unused harmony import specifier */ var rhumb_distance_dist_es_getCoord;
// https://en.wikipedia.org/wiki/Rhumb_line


/**
 * Calculates the distance along a rhumb line between two {@link Point|points} in degrees, radians,
 * miles, or kilometers.
 *
 * @name rhumbDistance
 * @param {Coord} from origin point
 * @param {Coord} to destination point
 * @param {Object} [options] Optional parameters
 * @param {string} [options.units="kilometers"] can be degrees, radians, miles, or kilometers
 * @returns {number} distance between the two points
 * @example
 * var from = turf.point([-75.343, 39.984]);
 * var to = turf.point([-75.534, 39.123]);
 * var options = {units: 'miles'};
 *
 * var distance = turf.rhumbDistance(from, to, options);
 *
 * //addToMap
 * var addToMap = [from, to];
 * from.properties.distance = distance;
 * to.properties.distance = distance;
 */
function rhumbDistance(from, to, options) {
    if (options === void 0) { options = {}; }
    var origin = rhumb_distance_dist_es_getCoord(from);
    var destination = rhumb_distance_dist_es_getCoord(to);
    // compensate the crossing of the 180th meridian (https://macwright.org/2016/09/26/the-180th-meridian.html)
    // solution from https://github.com/mapbox/mapbox-gl-js/issues/3250#issuecomment-294887678
    destination[0] +=
        destination[0] - origin[0] > 180
            ? -360
            : origin[0] - destination[0] > 180
                ? 360
                : 0;
    var distanceInMeters = calculateRhumbDistance(origin, destination);
    var distance = es_convertLength(distanceInMeters, "meters", options.units);
    return distance;
}
/**
 * Returns the distance travelling from ‘this’ point to destination point along a rhumb line.
 * Adapted from Geodesy: https://github.com/chrisveness/geodesy/blob/master/latlon-spherical.js
 *
 * @private
 * @param   {Array<number>} origin point.
 * @param   {Array<number>} destination point.
 * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
 * @returns {number} Distance in km between this point and destination point (same units as radius).
 *
 * @example
 *     var p1 = new LatLon(51.127, 1.338);
 *     var p2 = new LatLon(50.964, 1.853);
 *     var d = p1.distanceTo(p2); // 40.31 km
 */
function calculateRhumbDistance(origin, destination, radius) {
    // φ => phi
    // λ => lambda
    // ψ => psi
    // Δ => Delta
    // δ => delta
    // θ => theta
    radius = radius === undefined ? es_earthRadius : Number(radius);
    // see www.edwilliams.org/avform.htm#Rhumb
    var R = radius;
    var phi1 = (origin[1] * Math.PI) / 180;
    var phi2 = (destination[1] * Math.PI) / 180;
    var DeltaPhi = phi2 - phi1;
    var DeltaLambda = (Math.abs(destination[0] - origin[0]) * Math.PI) / 180;
    // if dLon over 180° take shorter rhumb line across the anti-meridian:
    if (DeltaLambda > Math.PI) {
        DeltaLambda -= 2 * Math.PI;
    }
    // on Mercator projection, longitude distances shrink by latitude; q is the 'stretch factor'
    // q becomes ill-conditioned along E-W line (0/0); use empirical tolerance to avoid it
    var DeltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
    var q = Math.abs(DeltaPsi) > 10e-12 ? DeltaPhi / DeltaPsi : Math.cos(phi1);
    // distance is pythagoras on 'stretched' Mercator projection
    var delta = Math.sqrt(DeltaPhi * DeltaPhi + q * q * DeltaLambda * DeltaLambda); // angular distance in radians
    var dist = delta * R;
    return dist;
}
/* harmony default export */ const rhumb_distance_dist_es = ((/* unused pure expression or super */ null && (rhumbDistance)));

;// ../../node_modules/@turf/point-to-line-distance/dist/es/index.js
/* unused harmony import specifier */ var getDistance;
/* unused harmony import specifier */ var point_to_line_distance_dist_es_point;
/* unused harmony import specifier */ var point_to_line_distance_dist_es_feature;
/* unused harmony import specifier */ var point_to_line_distance_dist_es_lineString;
/* unused harmony import specifier */ var dist_es_convertLength;
/* unused harmony import specifier */ var es_featureOf;
/* unused harmony import specifier */ var es_segmentEach;
/* unused harmony import specifier */ var getPlanarDistance;
// Taken from http://geomalgorithms.com/a02-_lines.html





/**
 * Returns the minimum distance between a {@link Point} and a {@link LineString}, being the distance from a line the
 * minimum distance between the point and any segment of the `LineString`.
 *
 * @name pointToLineDistance
 * @param {Feature<Point>|Array<number>} pt Feature or Geometry
 * @param {Feature<LineString>} line GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units="kilometers"] can be anything supported by turf/convertLength
 * (ex: degrees, radians, miles, or kilometers)
 * @param {string} [options.method="geodesic"] wether to calculate the distance based on geodesic (spheroid) or
 * planar (flat) method. Valid options are 'geodesic' or 'planar'.
 * @returns {number} distance between point and line
 * @example
 * var pt = turf.point([0, 0]);
 * var line = turf.lineString([[1, 1],[-1, 1]]);
 *
 * var distance = turf.pointToLineDistance(pt, line, {units: 'miles'});
 * //=69.11854715938406
 */
function pointToLineDistance(pt, line, options) {
    if (options === void 0) { options = {}; }
    // Optional parameters
    if (!options.method) {
        options.method = "geodesic";
    }
    if (!options.units) {
        options.units = "kilometers";
    }
    // validation
    if (!pt) {
        throw new Error("pt is required");
    }
    if (Array.isArray(pt)) {
        pt = point_to_line_distance_dist_es_point(pt);
    }
    else if (pt.type === "Point") {
        pt = point_to_line_distance_dist_es_feature(pt);
    }
    else {
        es_featureOf(pt, "Point", "point");
    }
    if (!line) {
        throw new Error("line is required");
    }
    if (Array.isArray(line)) {
        line = point_to_line_distance_dist_es_lineString(line);
    }
    else if (line.type === "LineString") {
        line = point_to_line_distance_dist_es_feature(line);
    }
    else {
        es_featureOf(line, "LineString", "line");
    }
    var distance = Infinity;
    var p = pt.geometry.coordinates;
    es_segmentEach(line, function (segment) {
        var a = segment.geometry.coordinates[0];
        var b = segment.geometry.coordinates[1];
        var d = distanceToSegment(p, a, b, options);
        if (d < distance) {
            distance = d;
        }
    });
    return dist_es_convertLength(distance, "degrees", options.units);
}
/**
 * Returns the distance between a point P on a segment AB.
 *
 * @private
 * @param {Array<number>} p external point
 * @param {Array<number>} a first segment point
 * @param {Array<number>} b second segment point
 * @param {Object} [options={}] Optional parameters
 * @returns {number} distance
 */
function distanceToSegment(p, a, b, options) {
    var v = [b[0] - a[0], b[1] - a[1]];
    var w = [p[0] - a[0], p[1] - a[1]];
    var c1 = dot(w, v);
    if (c1 <= 0) {
        return calcDistance(p, a, { method: options.method, units: "degrees" });
    }
    var c2 = dot(v, v);
    if (c2 <= c1) {
        return calcDistance(p, b, { method: options.method, units: "degrees" });
    }
    var b2 = c1 / c2;
    var Pb = [a[0] + b2 * v[0], a[1] + b2 * v[1]];
    return calcDistance(p, Pb, { method: options.method, units: "degrees" });
}
function dot(u, v) {
    return u[0] * v[0] + u[1] * v[1];
}
function calcDistance(a, b, options) {
    return options.method === "planar"
        ? getPlanarDistance(a, b, options)
        : getDistance(a, b, options);
}
/* harmony default export */ const point_to_line_distance_dist_es = ((/* unused pure expression or super */ null && (pointToLineDistance)));

;// ../../node_modules/@turf/nearest-point-to-line/dist/es/index.js
/* unused harmony import specifier */ var dist_es_getType;
/* unused harmony import specifier */ var nearest_point_to_line_dist_es_featureEach;
/* unused harmony import specifier */ var nearest_point_to_line_dist_es_geomEach;
/* unused harmony import specifier */ var es_pointToLineDistance;
/* unused harmony import specifier */ var es_objectAssign;




/**
 * Returns the closest {@link Point|point}, of a {@link FeatureCollection|collection} of points,
 * to a {@link LineString|line}. The returned point has a `dist` property indicating its distance to the line.
 *
 * @name nearestPointToLine
 * @param {FeatureCollection|GeometryCollection<Point>} points Point Collection
 * @param {Feature|Geometry<LineString>} line Line Feature
 * @param {Object} [options] Optional parameters
 * @param {string} [options.units='kilometers'] unit of the output distance property
 * (eg: degrees, radians, miles, or kilometers)
 * @param {Object} [options.properties={}] Translate Properties to Point
 * @returns {Feature<Point>} the closest point
 * @example
 * var pt1 = turf.point([0, 0]);
 * var pt2 = turf.point([0.5, 0.5]);
 * var points = turf.featureCollection([pt1, pt2]);
 * var line = turf.lineString([[1,1], [-1,1]]);
 *
 * var nearest = turf.nearestPointToLine(points, line);
 *
 * //addToMap
 * var addToMap = [nearest, line];
 */
function nearestPointToLine(points, line, options) {
    if (options === void 0) { options = {}; }
    var units = options.units;
    var properties = options.properties || {};
    // validation
    var pts = normalize(points);
    if (!pts.features.length) {
        throw new Error("points must contain features");
    }
    if (!line) {
        throw new Error("line is required");
    }
    if (dist_es_getType(line) !== "LineString") {
        throw new Error("line must be a LineString");
    }
    var dist = Infinity;
    var pt = null;
    nearest_point_to_line_dist_es_featureEach(pts, function (point) {
        var d = es_pointToLineDistance(point, line, { units: units });
        if (d < dist) {
            dist = d;
            pt = point;
        }
    });
    /**
     * Translate Properties to final Point, priorities:
     * 1. options.properties
     * 2. inherent Point properties
     * 3. dist custom properties created by NearestPointToLine
     */
    if (pt) {
        pt.properties = es_objectAssign({ dist: dist }, pt.properties, properties);
    }
    // if (pt) { pt.properties = objectAssign({dist}, pt.properties, properties); }
    return pt;
}
/**
 * Convert Collection to FeatureCollection
 *
 * @private
 * @param {FeatureCollection|GeometryCollection} points Points
 * @returns {FeatureCollection<Point>} points
 */
function normalize(points) {
    var features = [];
    var type = points.geometry ? points.geometry.type : points.type;
    switch (type) {
        case "GeometryCollection":
            nearest_point_to_line_dist_es_geomEach(points, function (geom) {
                if (geom.type === "Point") {
                    features.push({ type: "Feature", properties: {}, geometry: geom });
                }
            });
            return { type: "FeatureCollection", features: features };
        case "FeatureCollection":
            points.features = points.features.filter(function (feature) {
                return feature.geometry.type === "Point";
            });
            return points;
        default:
            throw new Error("points must be a Point Collection");
    }
}
/* harmony default export */ const nearest_point_to_line_dist_es = ((/* unused pure expression or super */ null && (nearestPointToLine)));

;// ../../node_modules/@turf/planepoint/dist/es/index.js
/* unused harmony import specifier */ var planepoint_dist_es_getCoord;
/* unused harmony import specifier */ var dist_es_getGeom;


/**
 * Takes a triangular plane as a {@link Polygon}
 * and a {@link Point} within that triangle and returns the z-value
 * at that point. The Polygon should have properties `a`, `b`, and `c`
 * that define the values at its three corners. Alternatively, the z-values
 * of each triangle point can be provided by their respective 3rd coordinate
 * if their values are not provided as properties.
 *
 * @name planepoint
 * @param {Coord} point the Point for which a z-value will be calculated
 * @param {Feature<Polygon>} triangle a Polygon feature with three vertices
 * @returns {number} the z-value for `interpolatedPoint`
 * @example
 * var point = turf.point([-75.3221, 39.529]);
 * // "a", "b", and "c" values represent the values of the coordinates in order.
 * var triangle = turf.polygon([[
 *   [-75.1221, 39.57],
 *   [-75.58, 39.18],
 *   [-75.97, 39.86],
 *   [-75.1221, 39.57]
 * ]], {
 *   "a": 11,
 *   "b": 122,
 *   "c": 44
 * });
 *
 * var zValue = turf.planepoint(point, triangle);
 * point.properties.zValue = zValue;
 *
 * //addToMap
 * var addToMap = [triangle, point];
 */
function planepoint(point, triangle) {
  // Normalize input
  var coord = planepoint_dist_es_getCoord(point);
  var geom = dist_es_getGeom(triangle);
  var coords = geom.coordinates;
  var outer = coords[0];
  if (outer.length < 4)
    throw new Error("OuterRing of a Polygon must have 4 or more Positions.");
  var properties = triangle.properties || {};
  var a = properties.a;
  var b = properties.b;
  var c = properties.c;

  // Planepoint
  var x = coord[0];
  var y = coord[1];
  var x1 = outer[0][0];
  var y1 = outer[0][1];
  var z1 = a !== undefined ? a : outer[0][2];
  var x2 = outer[1][0];
  var y2 = outer[1][1];
  var z2 = b !== undefined ? b : outer[1][2];
  var x3 = outer[2][0];
  var y3 = outer[2][1];
  var z3 = c !== undefined ? c : outer[2][2];
  var z =
    (z3 * (x - x1) * (y - y2) +
      z1 * (x - x2) * (y - y3) +
      z2 * (x - x3) * (y - y1) -
      z2 * (x - x1) * (y - y3) -
      z3 * (x - x2) * (y - y1) -
      z1 * (x - x3) * (y - y2)) /
    ((x - x1) * (y - y2) +
      (x - x2) * (y - y3) +
      (x - x3) * (y - y1) -
      (x - x1) * (y - y3) -
      (x - x2) * (y - y1) -
      (x - x3) * (y - y2));

  return z;
}

/* harmony default export */ const planepoint_dist_es = ((/* unused pure expression or super */ null && (planepoint)));

;// ../../node_modules/@turf/kinks/dist/es/index.js
/* unused harmony import specifier */ var kinks_dist_es_point;

/**
 * Takes a {@link LineString|linestring}, {@link MultiLineString|multi-linestring},
 * {@link MultiPolygon|multi-polygon} or {@link Polygon|polygon} and
 * returns {@link Point|points} at all self-intersections.
 *
 * @name kinks
 * @param {Feature<LineString|MultiLineString|MultiPolygon|Polygon>} featureIn input feature
 * @returns {FeatureCollection<Point>} self-intersections
 * @example
 * var poly = turf.polygon([[
 *   [-12.034835, 8.901183],
 *   [-12.060413, 8.899826],
 *   [-12.03638, 8.873199],
 *   [-12.059383, 8.871418],
 *   [-12.034835, 8.901183]
 * ]]);
 *
 * var kinks = turf.kinks(poly);
 *
 * //addToMap
 * var addToMap = [poly, kinks]
 */
function kinks(featureIn) {
    var coordinates;
    var feature;
    var results = {
        type: "FeatureCollection",
        features: [],
    };
    if (featureIn.type === "Feature") {
        feature = featureIn.geometry;
    }
    else {
        feature = featureIn;
    }
    if (feature.type === "LineString") {
        coordinates = [feature.coordinates];
    }
    else if (feature.type === "MultiLineString") {
        coordinates = feature.coordinates;
    }
    else if (feature.type === "MultiPolygon") {
        coordinates = [].concat.apply([], feature.coordinates);
    }
    else if (feature.type === "Polygon") {
        coordinates = feature.coordinates;
    }
    else {
        throw new Error("Input must be a LineString, MultiLineString, " +
            "Polygon, or MultiPolygon Feature or Geometry");
    }
    coordinates.forEach(function (line1) {
        coordinates.forEach(function (line2) {
            for (var i = 0; i < line1.length - 1; i++) {
                // start iteration at i, intersections for k < i have already
                // been checked in previous outer loop iterations
                for (var k = i; k < line2.length - 1; k++) {
                    if (line1 === line2) {
                        // segments are adjacent and always share a vertex, not a kink
                        if (Math.abs(i - k) === 1) {
                            continue;
                        }
                        // first and last segment in a closed lineString or ring always share a vertex, not a kink
                        if (
                        // segments are first and last segment of lineString
                        i === 0 &&
                            k === line1.length - 2 &&
                            // lineString is closed
                            line1[i][0] === line1[line1.length - 1][0] &&
                            line1[i][1] === line1[line1.length - 1][1]) {
                            continue;
                        }
                    }
                    var intersection = es_lineIntersects(line1[i][0], line1[i][1], line1[i + 1][0], line1[i + 1][1], line2[k][0], line2[k][1], line2[k + 1][0], line2[k + 1][1]);
                    if (intersection) {
                        results.features.push(kinks_dist_es_point([intersection[0], intersection[1]]));
                    }
                }
            }
        });
    });
    return results;
}
// modified from http://jsfiddle.net/justin_c_rounds/Gd2S2/light/
function es_lineIntersects(line1StartX, line1StartY, line1EndX, line1EndY, line2StartX, line2StartY, line2EndX, line2EndY) {
    // if the lines intersect, the result contains the x and y of the
    // intersection (treating the lines as infinite) and booleans for whether
    // line segment 1 or line segment 2 contain the point
    var denominator;
    var a;
    var b;
    var numerator1;
    var numerator2;
    var result = {
        x: null,
        y: null,
        onLine1: false,
        onLine2: false,
    };
    denominator =
        (line2EndY - line2StartY) * (line1EndX - line1StartX) -
            (line2EndX - line2StartX) * (line1EndY - line1StartY);
    if (denominator === 0) {
        if (result.x !== null && result.y !== null) {
            return result;
        }
        else {
            return false;
        }
    }
    a = line1StartY - line2StartY;
    b = line1StartX - line2StartX;
    numerator1 = (line2EndX - line2StartX) * a - (line2EndY - line2StartY) * b;
    numerator2 = (line1EndX - line1StartX) * a - (line1EndY - line1StartY) * b;
    a = numerator1 / denominator;
    b = numerator2 / denominator;
    // if we cast these lines infinitely in both directions, they intersect here:
    result.x = line1StartX + a * (line1EndX - line1StartX);
    result.y = line1StartY + a * (line1EndY - line1StartY);
    // if line1 is a segment and line2 is infinite, they intersect if:
    if (a >= 0 && a <= 1) {
        result.onLine1 = true;
    }
    // if line2 is a segment and line1 is infinite, they intersect if:
    if (b >= 0 && b <= 1) {
        result.onLine2 = true;
    }
    // if line1 and line2 are segments, they intersect if both of the above are true
    if (result.onLine1 && result.onLine2) {
        return [result.x, result.y];
    }
    else {
        return false;
    }
}

;// ../../node_modules/@turf/point-on-feature/dist/es/index.js
/* unused harmony import specifier */ var es_explode;
/* unused harmony import specifier */ var es_centroid;
/* unused harmony import specifier */ var es_nearestPoint;
/* unused harmony import specifier */ var point_on_feature_dist_es_booleanPointInPolygon;
/* unused harmony import specifier */ var point_on_feature_dist_es_featureCollection;
/* unused harmony import specifier */ var point_on_feature_dist_es_point;
/* unused harmony import specifier */ var point_on_feature_dist_es_feature;






/**
 * Takes a Feature or FeatureCollection and returns a {@link Point} guaranteed to be on the surface of the feature.
 *
 * * Given a {@link Polygon}, the point will be in the area of the polygon
 * * Given a {@link LineString}, the point will be along the string
 * * Given a {@link Point}, the point will the same as the input
 *
 * @name pointOnFeature
 * @param {GeoJSON} geojson any Feature or FeatureCollection
 * @returns {Feature<Point>} a point on the surface of `input`
 * @example
 * var polygon = turf.polygon([[
 *   [116, -36],
 *   [131, -32],
 *   [146, -43],
 *   [155, -25],
 *   [133, -9],
 *   [111, -22],
 *   [116, -36]
 * ]]);
 *
 * var pointOnPolygon = turf.pointOnFeature(polygon);
 *
 * //addToMap
 * var addToMap = [polygon, pointOnPolygon];
 */
function pointOnFeature(geojson) {
  // normalize
  var fc = es_normalize(geojson);

  // get centroid
  var cent = es_centroid(fc);

  // check to see if centroid is on surface
  var onSurface = false;
  var i = 0;
  while (!onSurface && i < fc.features.length) {
    var geom = fc.features[i].geometry;
    var x, y, x1, y1, x2, y2, k;
    var onLine = false;
    if (geom.type === "Point") {
      if (
        cent.geometry.coordinates[0] === geom.coordinates[0] &&
        cent.geometry.coordinates[1] === geom.coordinates[1]
      ) {
        onSurface = true;
      }
    } else if (geom.type === "MultiPoint") {
      var onMultiPoint = false;
      k = 0;
      while (!onMultiPoint && k < geom.coordinates.length) {
        if (
          cent.geometry.coordinates[0] === geom.coordinates[k][0] &&
          cent.geometry.coordinates[1] === geom.coordinates[k][1]
        ) {
          onSurface = true;
          onMultiPoint = true;
        }
        k++;
      }
    } else if (geom.type === "LineString") {
      k = 0;
      while (!onLine && k < geom.coordinates.length - 1) {
        x = cent.geometry.coordinates[0];
        y = cent.geometry.coordinates[1];
        x1 = geom.coordinates[k][0];
        y1 = geom.coordinates[k][1];
        x2 = geom.coordinates[k + 1][0];
        y2 = geom.coordinates[k + 1][1];
        if (pointOnSegment(x, y, x1, y1, x2, y2)) {
          onLine = true;
          onSurface = true;
        }
        k++;
      }
    } else if (geom.type === "MultiLineString") {
      var j = 0;
      while (j < geom.coordinates.length) {
        onLine = false;
        k = 0;
        var line = geom.coordinates[j];
        while (!onLine && k < line.length - 1) {
          x = cent.geometry.coordinates[0];
          y = cent.geometry.coordinates[1];
          x1 = line[k][0];
          y1 = line[k][1];
          x2 = line[k + 1][0];
          y2 = line[k + 1][1];
          if (pointOnSegment(x, y, x1, y1, x2, y2)) {
            onLine = true;
            onSurface = true;
          }
          k++;
        }
        j++;
      }
    } else if (geom.type === "Polygon" || geom.type === "MultiPolygon") {
      if (point_on_feature_dist_es_booleanPointInPolygon(cent, geom)) {
        onSurface = true;
      }
    }
    i++;
  }
  if (onSurface) {
    return cent;
  } else {
    var vertices = point_on_feature_dist_es_featureCollection([]);
    for (i = 0; i < fc.features.length; i++) {
      vertices.features = vertices.features.concat(
        es_explode(fc.features[i]).features
      );
    }
    // Remove distanceToPoint properties from nearestPoint()
    return point_on_feature_dist_es_point(es_nearestPoint(cent, vertices).geometry.coordinates);
  }
}

/**
 * Normalizes any GeoJSON to a FeatureCollection
 *
 * @private
 * @name normalize
 * @param {GeoJSON} geojson Any GeoJSON
 * @returns {FeatureCollection} FeatureCollection
 */
function es_normalize(geojson) {
  if (geojson.type !== "FeatureCollection") {
    if (geojson.type !== "Feature") {
      return point_on_feature_dist_es_featureCollection([point_on_feature_dist_es_feature(geojson)]);
    }
    return point_on_feature_dist_es_featureCollection([geojson]);
  }
  return geojson;
}

function pointOnSegment(x, y, x1, y1, x2, y2) {
  var ab = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
  var ap = Math.sqrt((x - x1) * (x - x1) + (y - y1) * (y - y1));
  var pb = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y));
  return ab === ap + pb;
}

/* harmony default export */ const point_on_feature_dist_es = ((/* unused pure expression or super */ null && (pointOnFeature)));

;// ../../node_modules/@turf/area/dist/es/index.js
/* unused harmony import specifier */ var es_geomReduce;

// Note: change RADIUS => earthRadius
var RADIUS = 6378137;
/**
 * Takes one or more features and returns their area in square meters.
 *
 * @name area
 * @param {GeoJSON} geojson input GeoJSON feature(s)
 * @returns {number} area in square meters
 * @example
 * var polygon = turf.polygon([[[125, -15], [113, -22], [154, -27], [144, -15], [125, -15]]]);
 *
 * var area = turf.area(polygon);
 *
 * //addToMap
 * var addToMap = [polygon]
 * polygon.properties.area = area
 */
function es_area(geojson) {
    return es_geomReduce(geojson, function (value, geom) {
        return value + calculateArea(geom);
    }, 0);
}
/**
 * Calculate Area
 *
 * @private
 * @param {Geometry} geom GeoJSON Geometries
 * @returns {number} area
 */
function calculateArea(geom) {
    var total = 0;
    var i;
    switch (geom.type) {
        case "Polygon":
            return polygonArea(geom.coordinates);
        case "MultiPolygon":
            for (i = 0; i < geom.coordinates.length; i++) {
                total += polygonArea(geom.coordinates[i]);
            }
            return total;
        case "Point":
        case "MultiPoint":
        case "LineString":
        case "MultiLineString":
            return 0;
    }
    return 0;
}
function polygonArea(coords) {
    var total = 0;
    if (coords && coords.length > 0) {
        total += Math.abs(ringArea(coords[0]));
        for (var i = 1; i < coords.length; i++) {
            total -= Math.abs(ringArea(coords[i]));
        }
    }
    return total;
}
/**
 * @private
 * Calculate the approximate area of the polygon were it projected onto the earth.
 * Note that this area will be positive if ring is oriented clockwise, otherwise it will be negative.
 *
 * Reference:
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for Polygons on a Sphere",
 * JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007 https://trs.jpl.nasa.gov/handle/2014/40409
 *
 * @param {Array<Array<number>>} coords Ring Coordinates
 * @returns {number} The approximate signed geodesic area of the polygon in square meters.
 */
function ringArea(coords) {
    var p1;
    var p2;
    var p3;
    var lowerIndex;
    var middleIndex;
    var upperIndex;
    var i;
    var total = 0;
    var coordsLength = coords.length;
    if (coordsLength > 2) {
        for (i = 0; i < coordsLength; i++) {
            if (i === coordsLength - 2) {
                // i = N-2
                lowerIndex = coordsLength - 2;
                middleIndex = coordsLength - 1;
                upperIndex = 0;
            }
            else if (i === coordsLength - 1) {
                // i = N-1
                lowerIndex = coordsLength - 1;
                middleIndex = 0;
                upperIndex = 1;
            }
            else {
                // i = 0 to N-3
                lowerIndex = i;
                middleIndex = i + 1;
                upperIndex = i + 2;
            }
            p1 = coords[lowerIndex];
            p2 = coords[middleIndex];
            p3 = coords[upperIndex];
            total += (rad(p3[0]) - rad(p1[0])) * Math.sin(rad(p2[1]));
        }
        total = (total * RADIUS * RADIUS) / 2;
    }
    return total;
}
function rad(num) {
    return (num * Math.PI) / 180;
}

;// ../../node_modules/@turf/along/dist/es/index.js
/* unused harmony import specifier */ var along_dist_es_bearing;
/* unused harmony import specifier */ var along_dist_es_destination;
/* unused harmony import specifier */ var measureDistance;
/* unused harmony import specifier */ var along_dist_es_point;
/* unused harmony import specifier */ var along_dist_es_getGeom;





/**
 * Takes a {@link LineString} and returns a {@link Point} at a specified distance along the line.
 *
 * @name along
 * @param {Feature<LineString>} line input line
 * @param {number} distance distance along the line
 * @param {Object} [options] Optional parameters
 * @param {string} [options.units="kilometers"] can be degrees, radians, miles, or kilometers
 * @returns {Feature<Point>} Point `distance` `units` along the line
 * @example
 * var line = turf.lineString([[-83, 30], [-84, 36], [-78, 41]]);
 * var options = {units: 'miles'};
 *
 * var along = turf.along(line, 200, options);
 *
 * //addToMap
 * var addToMap = [along, line]
 */
function along(line, distance, options) {
    if (options === void 0) { options = {}; }
    // Get Coords
    var geom = along_dist_es_getGeom(line);
    var coords = geom.coordinates;
    var travelled = 0;
    for (var i = 0; i < coords.length; i++) {
        if (distance >= travelled && i === coords.length - 1) {
            break;
        }
        else if (travelled >= distance) {
            var overshot = distance - travelled;
            if (!overshot) {
                return along_dist_es_point(coords[i]);
            }
            else {
                var direction = along_dist_es_bearing(coords[i], coords[i - 1]) - 180;
                var interpolated = along_dist_es_destination(coords[i], overshot, direction, options);
                return interpolated;
            }
        }
        else {
            travelled += measureDistance(coords[i], coords[i + 1], options);
        }
    }
    return along_dist_es_point(coords[coords.length - 1]);
}

;// ../../node_modules/@turf/length/dist/es/index.js
/* unused harmony import specifier */ var length_dist_es_distance;
/* unused harmony import specifier */ var es_segmentReduce;


/**
 * Takes a {@link GeoJSON} and measures its length in the specified units, {@link (Multi)Point}'s distance are ignored.
 *
 * @name length
 * @param {Feature<LineString|MultiLineString>} geojson GeoJSON to measure
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units=kilometers] can be degrees, radians, miles, or kilometers
 * @returns {number} length of GeoJSON
 * @example
 * var line = turf.lineString([[115, -32], [131, -22], [143, -25], [150, -34]]);
 * var length = turf.length(line, {units: 'miles'});
 *
 * //addToMap
 * var addToMap = [line];
 * line.properties.distance = length;
 */
function es_length(geojson, options) {
    if (options === void 0) { options = {}; }
    // Calculate distance from 2-vertex line segments
    return es_segmentReduce(geojson, function (previousValue, segment) {
        var coords = segment.geometry.coordinates;
        return previousValue + length_dist_es_distance(coords[0], coords[1], options);
    }, 0);
}

;// ../../node_modules/@turf/line-slice/dist/es/index.js
/* unused harmony import specifier */ var line_slice_dist_es_getCoords;
/* unused harmony import specifier */ var line_slice_dist_es_getType;
/* unused harmony import specifier */ var line_slice_dist_es_lineString;
/* unused harmony import specifier */ var es_nearestPointOnLine;




/**
 * Takes a {@link LineString|line}, a start {@link Point}, and a stop point
 * and returns a subsection of the line in-between those points.
 * The start & stop points don't need to fall exactly on the line.
 *
 * This can be useful for extracting only the part of a route between waypoints.
 *
 * @name lineSlice
 * @param {Coord} startPt starting point
 * @param {Coord} stopPt stopping point
 * @param {Feature<LineString>|LineString} line line to slice
 * @returns {Feature<LineString>} sliced line
 * @example
 * var line = turf.lineString([
 *     [-77.031669, 38.878605],
 *     [-77.029609, 38.881946],
 *     [-77.020339, 38.884084],
 *     [-77.025661, 38.885821],
 *     [-77.021884, 38.889563],
 *     [-77.019824, 38.892368]
 * ]);
 * var start = turf.point([-77.029609, 38.881946]);
 * var stop = turf.point([-77.021884, 38.889563]);
 *
 * var sliced = turf.lineSlice(start, stop, line);
 *
 * //addToMap
 * var addToMap = [start, stop, line]
 */
function lineSlice(startPt, stopPt, line) {
  // Validation
  var coords = line_slice_dist_es_getCoords(line);
  if (line_slice_dist_es_getType(line) !== "LineString")
    throw new Error("line must be a LineString");

  var startVertex = es_nearestPointOnLine(line, startPt);
  var stopVertex = es_nearestPointOnLine(line, stopPt);
  var ends;
  if (startVertex.properties.index <= stopVertex.properties.index) {
    ends = [startVertex, stopVertex];
  } else {
    ends = [stopVertex, startVertex];
  }
  var clipCoords = [ends[0].geometry.coordinates];
  for (
    var i = ends[0].properties.index + 1;
    i < ends[1].properties.index + 1;
    i++
  ) {
    clipCoords.push(coords[i]);
  }
  clipCoords.push(ends[1].geometry.coordinates);
  return line_slice_dist_es_lineString(clipCoords, line.properties);
}

/* harmony default export */ const line_slice_dist_es = ((/* unused pure expression or super */ null && (lineSlice)));

;// ../../node_modules/@turf/line-slice-along/dist/es/index.js
/* unused harmony import specifier */ var line_slice_along_dist_es_bearing;
/* unused harmony import specifier */ var line_slice_along_dist_es_distance;
/* unused harmony import specifier */ var line_slice_along_dist_es_destination;
/* unused harmony import specifier */ var line_slice_along_dist_es_isObject;
/* unused harmony import specifier */ var line_slice_along_dist_es_lineString;





/**
 * Takes a {@link LineString|line}, a specified distance along the line to a start {@link Point},
 * and a specified  distance along the line to a stop point
 * and returns a subsection of the line in-between those points.
 *
 * This can be useful for extracting only the part of a route between two distances.
 *
 * @name lineSliceAlong
 * @param {Feature<LineString>|LineString} line input line
 * @param {number} startDist distance along the line to starting point
 * @param {number} stopDist distance along the line to ending point
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
 * @returns {Feature<LineString>} sliced line
 * @example
 * var line = turf.lineString([[7, 45], [9, 45], [14, 40], [14, 41]]);
 * var start = 12.5;
 * var stop = 25;
 * var sliced = turf.lineSliceAlong(line, start, stop, {units: 'miles'});
 *
 * //addToMap
 * var addToMap = [line, start, stop, sliced]
 */
function lineSliceAlong(line, startDist, stopDist, options) {
  // Optional parameters
  options = options || {};
  if (!line_slice_along_dist_es_isObject(options)) throw new Error("options is invalid");

  var coords;
  var slice = [];

  // Validation
  if (line.type === "Feature") coords = line.geometry.coordinates;
  else if (line.type === "LineString") coords = line.coordinates;
  else throw new Error("input must be a LineString Feature or Geometry");
  var origCoordsLength = coords.length;
  var travelled = 0;
  var overshot, direction, interpolated;
  for (var i = 0; i < coords.length; i++) {
    if (startDist >= travelled && i === coords.length - 1) break;
    else if (travelled > startDist && slice.length === 0) {
      overshot = startDist - travelled;
      if (!overshot) {
        slice.push(coords[i]);
        return line_slice_along_dist_es_lineString(slice);
      }
      direction = line_slice_along_dist_es_bearing(coords[i], coords[i - 1]) - 180;
      interpolated = line_slice_along_dist_es_destination(coords[i], overshot, direction, options);
      slice.push(interpolated.geometry.coordinates);
    }

    if (travelled >= stopDist) {
      overshot = stopDist - travelled;
      if (!overshot) {
        slice.push(coords[i]);
        return line_slice_along_dist_es_lineString(slice);
      }
      direction = line_slice_along_dist_es_bearing(coords[i], coords[i - 1]) - 180;
      interpolated = line_slice_along_dist_es_destination(coords[i], overshot, direction, options);
      slice.push(interpolated.geometry.coordinates);
      return line_slice_along_dist_es_lineString(slice);
    }

    if (travelled >= startDist) {
      slice.push(coords[i]);
    }

    if (i === coords.length - 1) {
      return line_slice_along_dist_es_lineString(slice);
    }

    travelled += line_slice_along_dist_es_distance(coords[i], coords[i + 1], options);
  }

  if (travelled < startDist && coords.length === origCoordsLength)
    throw new Error("Start position is beyond line");

  var last = coords[coords.length - 1];
  return line_slice_along_dist_es_lineString([last, last]);
}

/* harmony default export */ const line_slice_along_dist_es = ((/* unused pure expression or super */ null && (lineSliceAlong)));

;// ../../node_modules/@turf/boolean-point-on-line/dist/es/index.js
/* unused harmony import specifier */ var boolean_point_on_line_dist_es_getCoord;
/* unused harmony import specifier */ var boolean_point_on_line_dist_es_getCoords;

/**
 * Returns true if a point is on a line. Accepts a optional parameter to ignore the
 * start and end vertices of the linestring.
 *
 * @name booleanPointOnLine
 * @param {Coord} pt GeoJSON Point
 * @param {Feature<LineString>} line GeoJSON LineString
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.ignoreEndVertices=false] whether to ignore the start and end vertices.
 * @param {number} [options.epsilon] Fractional number to compare with the cross product result. Useful for dealing with floating points such as lng/lat points
 * @returns {boolean} true/false
 * @example
 * var pt = turf.point([0, 0]);
 * var line = turf.lineString([[-1, -1],[1, 1],[1.5, 2.2]]);
 * var isPointOnLine = turf.booleanPointOnLine(pt, line);
 * //=true
 */
function booleanPointOnLine(pt, line, options) {
    if (options === void 0) { options = {}; }
    // Normalize inputs
    var ptCoords = boolean_point_on_line_dist_es_getCoord(pt);
    var lineCoords = boolean_point_on_line_dist_es_getCoords(line);
    // Main
    for (var i = 0; i < lineCoords.length - 1; i++) {
        var ignoreBoundary = false;
        if (options.ignoreEndVertices) {
            if (i === 0) {
                ignoreBoundary = "start";
            }
            if (i === lineCoords.length - 2) {
                ignoreBoundary = "end";
            }
            if (i === 0 && i + 1 === lineCoords.length - 1) {
                ignoreBoundary = "both";
            }
        }
        if (es_isPointOnLineSegment(lineCoords[i], lineCoords[i + 1], ptCoords, ignoreBoundary, typeof options.epsilon === "undefined" ? null : options.epsilon)) {
            return true;
        }
    }
    return false;
}
// See http://stackoverflow.com/a/4833823/1979085
// See https://stackoverflow.com/a/328122/1048847
/**
 * @private
 * @param {Position} lineSegmentStart coord pair of start of line
 * @param {Position} lineSegmentEnd coord pair of end of line
 * @param {Position} pt coord pair of point to check
 * @param {boolean|string} excludeBoundary whether the point is allowed to fall on the line ends.
 * @param {number} epsilon Fractional number to compare with the cross product result. Useful for dealing with floating points such as lng/lat points
 * If true which end to ignore.
 * @returns {boolean} true/false
 */
function es_isPointOnLineSegment(lineSegmentStart, lineSegmentEnd, pt, excludeBoundary, epsilon) {
    var x = pt[0];
    var y = pt[1];
    var x1 = lineSegmentStart[0];
    var y1 = lineSegmentStart[1];
    var x2 = lineSegmentEnd[0];
    var y2 = lineSegmentEnd[1];
    var dxc = pt[0] - x1;
    var dyc = pt[1] - y1;
    var dxl = x2 - x1;
    var dyl = y2 - y1;
    var cross = dxc * dyl - dyc * dxl;
    if (epsilon !== null) {
        if (Math.abs(cross) > epsilon) {
            return false;
        }
    }
    else if (cross !== 0) {
        return false;
    }
    if (!excludeBoundary) {
        if (Math.abs(dxl) >= Math.abs(dyl)) {
            return dxl > 0 ? x1 <= x && x <= x2 : x2 <= x && x <= x1;
        }
        return dyl > 0 ? y1 <= y && y <= y2 : y2 <= y && y <= y1;
    }
    else if (excludeBoundary === "start") {
        if (Math.abs(dxl) >= Math.abs(dyl)) {
            return dxl > 0 ? x1 < x && x <= x2 : x2 <= x && x < x1;
        }
        return dyl > 0 ? y1 < y && y <= y2 : y2 <= y && y < y1;
    }
    else if (excludeBoundary === "end") {
        if (Math.abs(dxl) >= Math.abs(dyl)) {
            return dxl > 0 ? x1 <= x && x < x2 : x2 < x && x <= x1;
        }
        return dyl > 0 ? y1 <= y && y < y2 : y2 < y && y <= y1;
    }
    else if (excludeBoundary === "both") {
        if (Math.abs(dxl) >= Math.abs(dyl)) {
            return dxl > 0 ? x1 < x && x < x2 : x2 < x && x < x1;
        }
        return dyl > 0 ? y1 < y && y < y2 : y2 < y && y < y1;
    }
    return false;
}
/* harmony default export */ const boolean_point_on_line_dist_es = ((/* unused pure expression or super */ null && (booleanPointOnLine)));

;// ../../node_modules/@turf/boolean-within/dist/es/index.js
/* unused harmony import specifier */ var calcBbox;
/* unused harmony import specifier */ var es_booleanPointOnLine;
/* unused harmony import specifier */ var boolean_within_dist_es_booleanPointInPolygon;
/* unused harmony import specifier */ var boolean_within_dist_es_getGeom;




/**
 * Boolean-within returns true if the first geometry is completely within the second geometry.
 * The interiors of both geometries must intersect and, the interior and boundary of the primary (geometry a)
 * must not intersect the exterior of the secondary (geometry b).
 * Boolean-within returns the exact opposite result of the `@turf/boolean-contains`.
 *
 * @name booleanWithin
 * @param {Geometry|Feature<any>} feature1 GeoJSON Feature or Geometry
 * @param {Geometry|Feature<any>} feature2 GeoJSON Feature or Geometry
 * @returns {boolean} true/false
 * @example
 * var line = turf.lineString([[1, 1], [1, 2], [1, 3], [1, 4]]);
 * var point = turf.point([1, 2]);
 *
 * turf.booleanWithin(point, line);
 * //=true
 */
function booleanWithin(feature1, feature2) {
    var geom1 = boolean_within_dist_es_getGeom(feature1);
    var geom2 = boolean_within_dist_es_getGeom(feature2);
    var type1 = geom1.type;
    var type2 = geom2.type;
    switch (type1) {
        case "Point":
            switch (type2) {
                case "MultiPoint":
                    return isPointInMultiPoint(geom1, geom2);
                case "LineString":
                    return es_booleanPointOnLine(geom1, geom2, { ignoreEndVertices: true });
                case "Polygon":
                case "MultiPolygon":
                    return boolean_within_dist_es_booleanPointInPolygon(geom1, geom2, { ignoreBoundary: true });
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "MultiPoint":
            switch (type2) {
                case "MultiPoint":
                    return isMultiPointInMultiPoint(geom1, geom2);
                case "LineString":
                    return isMultiPointOnLine(geom1, geom2);
                case "Polygon":
                case "MultiPolygon":
                    return isMultiPointInPoly(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "LineString":
            switch (type2) {
                case "LineString":
                    return isLineOnLine(geom1, geom2);
                case "Polygon":
                case "MultiPolygon":
                    return isLineInPoly(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "Polygon":
            switch (type2) {
                case "Polygon":
                case "MultiPolygon":
                    return isPolyInPoly(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        default:
            throw new Error("feature1 " + type1 + " geometry not supported");
    }
}
function isPointInMultiPoint(point, multiPoint) {
    var i;
    var output = false;
    for (i = 0; i < multiPoint.coordinates.length; i++) {
        if (compareCoords(multiPoint.coordinates[i], point.coordinates)) {
            output = true;
            break;
        }
    }
    return output;
}
function isMultiPointInMultiPoint(multiPoint1, multiPoint2) {
    for (var i = 0; i < multiPoint1.coordinates.length; i++) {
        var anyMatch = false;
        for (var i2 = 0; i2 < multiPoint2.coordinates.length; i2++) {
            if (compareCoords(multiPoint1.coordinates[i], multiPoint2.coordinates[i2])) {
                anyMatch = true;
            }
        }
        if (!anyMatch) {
            return false;
        }
    }
    return true;
}
function isMultiPointOnLine(multiPoint, lineString) {
    var foundInsidePoint = false;
    for (var i = 0; i < multiPoint.coordinates.length; i++) {
        if (!es_booleanPointOnLine(multiPoint.coordinates[i], lineString)) {
            return false;
        }
        if (!foundInsidePoint) {
            foundInsidePoint = es_booleanPointOnLine(multiPoint.coordinates[i], lineString, { ignoreEndVertices: true });
        }
    }
    return foundInsidePoint;
}
function isMultiPointInPoly(multiPoint, polygon) {
    var output = true;
    var oneInside = false;
    var isInside = false;
    for (var i = 0; i < multiPoint.coordinates.length; i++) {
        isInside = boolean_within_dist_es_booleanPointInPolygon(multiPoint.coordinates[1], polygon);
        if (!isInside) {
            output = false;
            break;
        }
        if (!oneInside) {
            isInside = boolean_within_dist_es_booleanPointInPolygon(multiPoint.coordinates[1], polygon, {
                ignoreBoundary: true,
            });
        }
    }
    return output && isInside;
}
function isLineOnLine(lineString1, lineString2) {
    for (var i = 0; i < lineString1.coordinates.length; i++) {
        if (!es_booleanPointOnLine(lineString1.coordinates[i], lineString2)) {
            return false;
        }
    }
    return true;
}
function isLineInPoly(linestring, polygon) {
    var polyBbox = calcBbox(polygon);
    var lineBbox = calcBbox(linestring);
    if (!doBBoxOverlap(polyBbox, lineBbox)) {
        return false;
    }
    var foundInsidePoint = false;
    for (var i = 0; i < linestring.coordinates.length - 1; i++) {
        if (!boolean_within_dist_es_booleanPointInPolygon(linestring.coordinates[i], polygon)) {
            return false;
        }
        if (!foundInsidePoint) {
            foundInsidePoint = boolean_within_dist_es_booleanPointInPolygon(linestring.coordinates[i], polygon, { ignoreBoundary: true });
        }
        if (!foundInsidePoint) {
            var midpoint = getMidpoint(linestring.coordinates[i], linestring.coordinates[i + 1]);
            foundInsidePoint = boolean_within_dist_es_booleanPointInPolygon(midpoint, polygon, {
                ignoreBoundary: true,
            });
        }
    }
    return foundInsidePoint;
}
/**
 * Is Polygon2 in Polygon1
 * Only takes into account outer rings
 *
 * @private
 * @param {Polygon} geometry1
 * @param {Polygon|MultiPolygon} geometry2
 * @returns {boolean} true/false
 */
function isPolyInPoly(geometry1, geometry2) {
    var poly1Bbox = calcBbox(geometry1);
    var poly2Bbox = calcBbox(geometry2);
    if (!doBBoxOverlap(poly2Bbox, poly1Bbox)) {
        return false;
    }
    for (var i = 0; i < geometry1.coordinates[0].length; i++) {
        if (!boolean_within_dist_es_booleanPointInPolygon(geometry1.coordinates[0][i], geometry2)) {
            return false;
        }
    }
    return true;
}
function doBBoxOverlap(bbox1, bbox2) {
    if (bbox1[0] > bbox2[0])
        return false;
    if (bbox1[2] < bbox2[2])
        return false;
    if (bbox1[1] > bbox2[1])
        return false;
    if (bbox1[3] < bbox2[3])
        return false;
    return true;
}
/**
 * compareCoords
 *
 * @private
 * @param {Position} pair1 point [x,y]
 * @param {Position} pair2 point [x,y]
 * @returns {boolean} true/false if coord pairs match
 */
function compareCoords(pair1, pair2) {
    return pair1[0] === pair2[0] && pair1[1] === pair2[1];
}
/**
 * getMidpoint
 *
 * @private
 * @param {Position} pair1 point [x,y]
 * @param {Position} pair2 point [x,y]
 * @returns {Position} midpoint of pair1 and pair2
 */
function getMidpoint(pair1, pair2) {
    return [(pair1[0] + pair2[0]) / 2, (pair1[1] + pair2[1]) / 2];
}
/* harmony default export */ const boolean_within_dist_es = ((/* unused pure expression or super */ null && (booleanWithin)));

;// ../../node_modules/@turf/point-grid/dist/es/index.js
/* unused harmony import specifier */ var within;
/* unused harmony import specifier */ var point_grid_dist_es_distance;
/* unused harmony import specifier */ var point_grid_dist_es_point;
/* unused harmony import specifier */ var point_grid_dist_es_featureCollection;



/**
 * Creates a {@link Point} grid from a bounding box, {@link FeatureCollection} or {@link Feature}.
 *
 * @name pointGrid
 * @param {Array<number>} bbox extent in [minX, minY, maxX, maxY] order
 * @param {number} cellSide the distance between points, in units
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] used in calculating cellSide, can be degrees, radians, miles, or kilometers
 * @param {Feature<Polygon|MultiPolygon>} [options.mask] if passed a Polygon or MultiPolygon, the grid Points will be created only inside it
 * @param {Object} [options.properties={}] passed to each point of the grid
 * @returns {FeatureCollection<Point>} grid of points
 * @example
 * var extent = [-70.823364, -33.553984, -70.473175, -33.302986];
 * var cellSide = 3;
 * var options = {units: 'miles'};
 *
 * var grid = turf.pointGrid(extent, cellSide, options);
 *
 * //addToMap
 * var addToMap = [grid];
 */
function pointGrid(bbox, cellSide, options) {
    if (options === void 0) { options = {}; }
    // Default parameters
    if (options.mask && !options.units)
        options.units = "kilometers";
    // Containers
    var results = [];
    // Typescript handles the Type Validation
    // if (cellSide === null || cellSide === undefined) throw new Error('cellSide is required');
    // if (!isNumber(cellSide)) throw new Error('cellSide is invalid');
    // if (!bbox) throw new Error('bbox is required');
    // if (!Array.isArray(bbox)) throw new Error('bbox must be array');
    // if (bbox.length !== 4) throw new Error('bbox must contain 4 numbers');
    // if (mask && ['Polygon', 'MultiPolygon'].indexOf(getType(mask)) === -1) throw new Error('options.mask must be a (Multi)Polygon');
    var west = bbox[0];
    var south = bbox[1];
    var east = bbox[2];
    var north = bbox[3];
    var xFraction = cellSide / point_grid_dist_es_distance([west, south], [east, south], options);
    var cellWidth = xFraction * (east - west);
    var yFraction = cellSide / point_grid_dist_es_distance([west, south], [west, north], options);
    var cellHeight = yFraction * (north - south);
    var bboxWidth = east - west;
    var bboxHeight = north - south;
    var columns = Math.floor(bboxWidth / cellWidth);
    var rows = Math.floor(bboxHeight / cellHeight);
    // adjust origin of the grid
    var deltaX = (bboxWidth - columns * cellWidth) / 2;
    var deltaY = (bboxHeight - rows * cellHeight) / 2;
    var currentX = west + deltaX;
    while (currentX <= east) {
        var currentY = south + deltaY;
        while (currentY <= north) {
            var cellPt = point_grid_dist_es_point([currentX, currentY], options.properties);
            if (options.mask) {
                if (within(cellPt, options.mask))
                    results.push(cellPt);
            }
            else {
                results.push(cellPt);
            }
            currentY += cellHeight;
        }
        currentX += cellWidth;
    }
    return point_grid_dist_es_featureCollection(results);
}
/* harmony default export */ const point_grid_dist_es = ((/* unused pure expression or super */ null && (pointGrid)));

;// ../../node_modules/@turf/truncate/dist/es/index.js
/* unused harmony import specifier */ var truncate_dist_es_coordEach;

/**
 * Takes a GeoJSON Feature or FeatureCollection and truncates the precision of the geometry.
 *
 * @name truncate
 * @param {GeoJSON} geojson any GeoJSON Feature, FeatureCollection, Geometry or GeometryCollection.
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.precision=6] coordinate decimal precision
 * @param {number} [options.coordinates=3] maximum number of coordinates (primarly used to remove z coordinates)
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} layer with truncated geometry
 * @example
 * var point = turf.point([
 *     70.46923055566859,
 *     58.11088890802906,
 *     1508
 * ]);
 * var options = {precision: 3, coordinates: 2};
 * var truncated = turf.truncate(point, options);
 * //=truncated.geometry.coordinates => [70.469, 58.111]
 *
 * //addToMap
 * var addToMap = [truncated];
 */
function truncate(geojson, options) {
    if (options === void 0) { options = {}; }
    // Optional parameters
    var precision = options.precision;
    var coordinates = options.coordinates;
    var mutate = options.mutate;
    // default params
    precision =
        precision === undefined || precision === null || isNaN(precision)
            ? 6
            : precision;
    coordinates =
        coordinates === undefined || coordinates === null || isNaN(coordinates)
            ? 3
            : coordinates;
    // validation
    if (!geojson)
        throw new Error("<geojson> is required");
    if (typeof precision !== "number")
        throw new Error("<precision> must be a number");
    if (typeof coordinates !== "number")
        throw new Error("<coordinates> must be a number");
    // prevent input mutation
    if (mutate === false || mutate === undefined)
        geojson = JSON.parse(JSON.stringify(geojson));
    var factor = Math.pow(10, precision);
    // Truncate Coordinates
    truncate_dist_es_coordEach(geojson, function (coords) {
        truncateCoords(coords, factor, coordinates);
    });
    return geojson;
}
/**
 * Truncate Coordinates - Mutates coordinates in place
 *
 * @private
 * @param {Array<any>} coords Geometry Coordinates
 * @param {number} factor rounding factor for coordinate decimal precision
 * @param {number} coordinates maximum number of coordinates (primarly used to remove z coordinates)
 * @returns {Array<any>} mutated coordinates
 */
function truncateCoords(coords, factor, coordinates) {
    // Remove extra coordinates (usually elevation coordinates and more)
    if (coords.length > coordinates)
        coords.splice(coordinates, coords.length);
    // Truncate coordinate decimals
    for (var i = 0; i < coords.length; i++) {
        coords[i] = Math.round(coords[i] * factor) / factor;
    }
    return coords;
}
/* harmony default export */ const truncate_dist_es = ((/* unused pure expression or super */ null && (truncate)));

;// ../../node_modules/@turf/flatten/dist/es/index.js
/* unused harmony import specifier */ var flatten_dist_es_flattenEach;
/* unused harmony import specifier */ var flatten_dist_es_featureCollection;



/**
 * Flattens any {@link GeoJSON} to a {@link FeatureCollection} inspired by [geojson-flatten](https://github.com/tmcw/geojson-flatten).
 *
 * @name flatten
 * @param {GeoJSON} geojson any valid GeoJSON Object
 * @returns {FeatureCollection<any>} all Multi-Geometries are flattened into single Features
 * @example
 * var multiGeometry = turf.multiPolygon([
 *   [[[102.0, 2.0], [103.0, 2.0], [103.0, 3.0], [102.0, 3.0], [102.0, 2.0]]],
 *   [[[100.0, 0.0], [101.0, 0.0], [101.0, 1.0], [100.0, 1.0], [100.0, 0.0]],
 *   [[100.2, 0.2], [100.8, 0.2], [100.8, 0.8], [100.2, 0.8], [100.2, 0.2]]]
 * ]);
 *
 * var flatten = turf.flatten(multiGeometry);
 *
 * //addToMap
 * var addToMap = [flatten]
 */
function flatten(geojson) {
  if (!geojson) throw new Error("geojson is required");

  var results = [];
  flatten_dist_es_flattenEach(geojson, function (feature) {
    results.push(feature);
  });
  return flatten_dist_es_featureCollection(results);
}

/* harmony default export */ const flatten_dist_es = ((/* unused pure expression or super */ null && (flatten)));

;// ../../node_modules/@turf/line-chunk/dist/es/index.js
/* unused harmony import specifier */ var dist_es_length;
/* unused harmony import specifier */ var es_lineSliceAlong;
/* unused harmony import specifier */ var line_chunk_dist_es_flattenEach;
/* unused harmony import specifier */ var line_chunk_dist_es_isObject;
/* unused harmony import specifier */ var line_chunk_dist_es_featureCollection;





/**
 * Divides a {@link LineString} into chunks of a specified length.
 * If the line is shorter than the segment length then the original line is returned.
 *
 * @name lineChunk
 * @param {FeatureCollection|Geometry|Feature<LineString|MultiLineString>} geojson the lines to split
 * @param {number} segmentLength how long to make each segment
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] units can be degrees, radians, miles, or kilometers
 * @param {boolean} [options.reverse=false] reverses coordinates to start the first chunked segment at the end
 * @returns {FeatureCollection<LineString>} collection of line segments
 * @example
 * var line = turf.lineString([[-95, 40], [-93, 45], [-85, 50]]);
 *
 * var chunk = turf.lineChunk(line, 15, {units: 'miles'});
 *
 * //addToMap
 * var addToMap = [chunk];
 */
function lineChunk(geojson, segmentLength, options) {
  // Optional parameters
  options = options || {};
  if (!line_chunk_dist_es_isObject(options)) throw new Error("options is invalid");
  var units = options.units;
  var reverse = options.reverse;

  // Validation
  if (!geojson) throw new Error("geojson is required");
  if (segmentLength <= 0)
    throw new Error("segmentLength must be greater than 0");

  // Container
  var results = [];

  // Flatten each feature to simple LineString
  line_chunk_dist_es_flattenEach(geojson, function (feature) {
    // reverses coordinates to start the first chunked segment at the end
    if (reverse)
      feature.geometry.coordinates = feature.geometry.coordinates.reverse();

    sliceLineSegments(feature, segmentLength, units, function (segment) {
      results.push(segment);
    });
  });
  return line_chunk_dist_es_featureCollection(results);
}

/**
 * Slice Line Segments
 *
 * @private
 * @param {Feature<LineString>} line GeoJSON LineString
 * @param {number} segmentLength how long to make each segment
 * @param {string}[units='kilometers'] units can be degrees, radians, miles, or kilometers
 * @param {Function} callback iterate over sliced line segments
 * @returns {void}
 */
function sliceLineSegments(line, segmentLength, units, callback) {
  var lineLength = dist_es_length(line, { units: units });

  // If the line is shorter than the segment length then the orginal line is returned.
  if (lineLength <= segmentLength) return callback(line);

  var numberOfSegments = lineLength / segmentLength;

  // If numberOfSegments is integer, no need to plus 1
  if (!Number.isInteger(numberOfSegments)) {
    numberOfSegments = Math.floor(numberOfSegments) + 1;
  }

  for (var i = 0; i < numberOfSegments; i++) {
    var outline = es_lineSliceAlong(
      line,
      segmentLength * i,
      segmentLength * (i + 1),
      { units: units }
    );
    callback(outline, i);
  }
}

/* harmony default export */ const line_chunk_dist_es = ((/* unused pure expression or super */ null && (lineChunk)));

;// ../../node_modules/@turf/unkink-polygon/dist/es/index.js
/* unused harmony import specifier */ var unkink_polygon_dist_es_flattenEach;
/* unused harmony import specifier */ var unkink_polygon_dist_es_featureEach;
/* unused harmony import specifier */ var unkink_polygon_dist_es_polygon;
/* unused harmony import specifier */ var unkink_polygon_dist_es_featureCollection;
/* unused harmony import specifier */ var unkink_polygon_dist_es_rbush;
/* unused harmony import specifier */ var dist_es_area;
/* unused harmony import specifier */ var unkink_polygon_dist_es_booleanPointInPolygon;






// Find self-intersections in geojson polygon (possibly with interior rings)

function isects (feature, filterFn, useSpatialIndex) {
  if (feature.geometry.type !== "Polygon")
    throw new Error("The input feature must be a Polygon");
  if (useSpatialIndex === undefined) useSpatialIndex = 1;

  var coord = feature.geometry.coordinates;

  var output = [];
  var seen = {};

  if (useSpatialIndex) {
    var allEdgesAsRbushTreeItems = [];
    for (var ring0 = 0; ring0 < coord.length; ring0++) {
      for (var edge0 = 0; edge0 < coord[ring0].length - 1; edge0++) {
        allEdgesAsRbushTreeItems.push(rbushTreeItem(ring0, edge0));
      }
    }
    var tree = unkink_polygon_dist_es_rbush();
    tree.load(allEdgesAsRbushTreeItems);
  }

  for (var ringA = 0; ringA < coord.length; ringA++) {
    for (var edgeA = 0; edgeA < coord[ringA].length - 1; edgeA++) {
      if (useSpatialIndex) {
        var bboxOverlaps = tree.search(rbushTreeItem(ringA, edgeA));
        bboxOverlaps.forEach(function (bboxIsect) {
          var ring1 = bboxIsect.ring;
          var edge1 = bboxIsect.edge;
          ifIsectAddToOutput(ringA, edgeA, ring1, edge1);
        });
      } else {
        for (var ring1 = 0; ring1 < coord.length; ring1++) {
          for (var edge1 = 0; edge1 < coord[ring1].length - 1; edge1++) {
            // TODO: speedup possible if only interested in unique: start last two loops at ringA and edgeA+1
            ifIsectAddToOutput(ringA, edgeA, ring1, edge1);
          }
        }
      }
    }
  }

  if (!filterFn)
    output = {
      type: "Feature",
      geometry: { type: "MultiPoint", coordinates: output },
    };
  return output;

  // Function to check if two edges intersect and add the intersection to the output
  function ifIsectAddToOutput(ring0, edge0, ring1, edge1) {
    var start0 = coord[ring0][edge0];
    var end0 = coord[ring0][edge0 + 1];
    var start1 = coord[ring1][edge1];
    var end1 = coord[ring1][edge1 + 1];

    var isect = intersect(start0, end0, start1, end1);

    if (isect === null) return; // discard parallels and coincidence
    var frac0;
    var frac1;
    if (end0[0] !== start0[0]) {
      frac0 = (isect[0] - start0[0]) / (end0[0] - start0[0]);
    } else {
      frac0 = (isect[1] - start0[1]) / (end0[1] - start0[1]);
    }
    if (end1[0] !== start1[0]) {
      frac1 = (isect[0] - start1[0]) / (end1[0] - start1[0]);
    } else {
      frac1 = (isect[1] - start1[1]) / (end1[1] - start1[1]);
    }
    if (frac0 >= 1 || frac0 <= 0 || frac1 >= 1 || frac1 <= 0) return; // require segment intersection

    var key = isect;
    var unique = !seen[key];
    if (unique) {
      seen[key] = true;
    }

    if (filterFn) {
      output.push(
        filterFn(
          isect,
          ring0,
          edge0,
          start0,
          end0,
          frac0,
          ring1,
          edge1,
          start1,
          end1,
          frac1,
          unique
        )
      );
    } else {
      output.push(isect);
    }
  }

  // Function to return a rbush tree item given an ring and edge number
  function rbushTreeItem(ring, edge) {
    var start = coord[ring][edge];
    var end = coord[ring][edge + 1];
    var minX;
    var maxX;
    var minY;
    var maxY;
    if (start[0] < end[0]) {
      minX = start[0];
      maxX = end[0];
    } else {
      minX = end[0];
      maxX = start[0];
    }
    if (start[1] < end[1]) {
      minY = start[1];
      maxY = end[1];
    } else {
      minY = end[1];
      maxY = start[1];
    }
    return {
      minX: minX,
      minY: minY,
      maxX: maxX,
      maxY: maxY,
      ring: ring,
      edge: edge,
    };
  }
}

// Function to compute where two lines (not segments) intersect. From https://en.wikipedia.org/wiki/Line%E2%80%93line_intersection
function intersect(start0, end0, start1, end1) {
  if (
    equalArrays(start0, start1) ||
    equalArrays(start0, end1) ||
    equalArrays(end0, start1) ||
    equalArrays(end1, start1)
  )
    return null;
  var x0 = start0[0],
    y0 = start0[1],
    x1 = end0[0],
    y1 = end0[1],
    x2 = start1[0],
    y2 = start1[1],
    x3 = end1[0],
    y3 = end1[1];
  var denom = (x0 - x1) * (y2 - y3) - (y0 - y1) * (x2 - x3);
  if (denom === 0) return null;
  var x4 =
    ((x0 * y1 - y0 * x1) * (x2 - x3) - (x0 - x1) * (x2 * y3 - y2 * x3)) / denom;
  var y4 =
    ((x0 * y1 - y0 * x1) * (y2 - y3) - (y0 - y1) * (x2 * y3 - y2 * x3)) / denom;
  return [x4, y4];
}

// Function to compare Arrays of numbers. From http://stackoverflow.com/questions/7837456/how-to-compare-arrays-in-javascript
function equalArrays(array1, array2) {
  // if the other array is a falsy value, return
  if (!array1 || !array2) return false;

  // compare lengths - can save a lot of time
  if (array1.length !== array2.length) return false;

  for (var i = 0, l = array1.length; i < l; i++) {
    // Check if we have nested arrays
    if (array1[i] instanceof Array && array2[i] instanceof Array) {
      // recurse into the nested arrays
      if (!equalArrays(array1[i], array2[i])) return false;
    } else if (array1[i] !== array2[i]) {
      // Warning - two different object instances will never be equal: {x:20} !== {x:20}
      return false;
    }
  }
  return true;
}

/**
 * Takes a complex (i.e. self-intersecting) geojson polygon, and breaks it down into its composite simple, non-self-intersecting one-ring polygons.
 *
 * @module simplepolygon
 * @param {Feature} feature Input polygon. This polygon may be unconform the {@link https://en.wikipedia.org/wiki/Simple_Features|Simple Features standard} in the sense that it's inner and outer rings may cross-intersect or self-intersect, that the outer ring must not contain the optional inner rings and that the winding number must not be positive for the outer and negative for the inner rings.
 * @return {FeatureCollection} Feature collection containing the simple, non-self-intersecting one-ring polygon features that the complex polygon is composed of. These simple polygons have properties such as their parent polygon, winding number and net winding number.
 *
 * @example
 * var poly = {
 *   "type": "Feature",
 *   "geometry": {
 *     "type": "Polygon",
 *     "coordinates": [[[0,0],[2,0],[0,2],[2,2],[0,0]]]
 *   }
 * };
 *
 * var result = simplepolygon(poly);
 *
 * // =result
 * // which will be a featureCollection of two polygons, one with coordinates [[[0,0],[2,0],[1,1],[0,0]]], parent -1, winding 1 and net winding 1, and one with coordinates [[[1,1],[0,2],[2,2],[1,1]]], parent -1, winding -1 and net winding -1
 */
function simplepolygon (feature) {
  // Check input
  if (feature.type != "Feature")
    throw new Error("The input must a geojson object of type Feature");
  if (feature.geometry === undefined || feature.geometry == null)
    throw new Error(
      "The input must a geojson object with a non-empty geometry"
    );
  if (feature.geometry.type != "Polygon")
    throw new Error("The input must be a geojson Polygon");

  // Process input
  var numRings = feature.geometry.coordinates.length;
  var vertices = [];
  for (var i = 0; i < numRings; i++) {
    var ring = feature.geometry.coordinates[i];
    if (!equalArrays$1(ring[0], ring[ring.length - 1])) {
      ring.push(ring[0]); // Close input ring if it is not
    }
    vertices.push.apply(vertices, ring.slice(0, ring.length - 1));
  }
  if (!isUnique(vertices))
    throw new Error(
      "The input polygon may not have duplicate vertices (except for the first and last vertex of each ring)"
    );
  var numvertices = vertices.length; // number of input ring vertices, with the last closing vertices not counted

  // Compute self-intersections
  var selfIsectsData = isects(
    feature,
    function filterFn(
      isect,
      ring0,
      edge0,
      start0,
      end0,
      frac0,
      ring1,
      edge1,
      start1,
      end1,
      frac1,
      unique
    ) {
      return [
        isect,
        ring0,
        edge0,
        start0,
        end0,
        frac0,
        ring1,
        edge1,
        start1,
        end1,
        frac1,
        unique,
      ];
    }
  );
  var numSelfIsect = selfIsectsData.length;

  // If no self-intersections are found, the input rings are the output rings. Hence, we must only compute their winding numbers, net winding numbers and (since ohers rings could lie outside the first ring) parents.
  if (numSelfIsect == 0) {
    var outputFeatureArray = [];
    for (var i = 0; i < numRings; i++) {
      outputFeatureArray.push(
        unkink_polygon_dist_es_polygon([feature.geometry.coordinates[i]], {
          parent: -1,
          winding: windingOfRing(feature.geometry.coordinates[i]),
        })
      );
    }
    var output = unkink_polygon_dist_es_featureCollection(outputFeatureArray);
    determineParents();
    setNetWinding();

    return output;
  }

  // If self-intersections are found, we will compute the output rings with the help of two intermediate variables
  // First, we build the pseudo vertex list and intersection list
  // The Pseudo vertex list is an array with for each ring an array with for each edge an array containing the pseudo-vertices (as made by their constructor) that have this ring and edge as ringAndEdgeIn, sorted for each edge by their fractional distance on this edge. It's length hence equals numRings.
  var pseudoVtxListByRingAndEdge = [];
  // The intersection list is an array containing intersections (as made by their constructor). First all numvertices ring-vertex-intersections, then all self-intersections (intra- and inter-ring). The order of the latter is not important but is permanent once given.
  var isectList = [];
  // Adding ring-pseudo-vertices to pseudoVtxListByRingAndEdge and ring-vertex-intersections to isectList
  for (var i = 0; i < numRings; i++) {
    pseudoVtxListByRingAndEdge.push([]);
    for (var j = 0; j < feature.geometry.coordinates[i].length - 1; j++) {
      // Each edge will feature one ring-pseudo-vertex in its array, on the last position. i.e. edge j features the ring-pseudo-vertex of the ring vertex j+1, which has ringAndEdgeIn = [i,j], on the last position.
      pseudoVtxListByRingAndEdge[i].push([
        new PseudoVtx(
          feature.geometry.coordinates[i][
            modulo(j + 1, feature.geometry.coordinates[i].length - 1)
          ],
          1,
          [i, j],
          [i, modulo(j + 1, feature.geometry.coordinates[i].length - 1)],
          undefined
        ),
      ]);
      // The first numvertices elements in isectList correspond to the ring-vertex-intersections
      isectList.push(
        new Isect(
          feature.geometry.coordinates[i][j],
          [i, modulo(j - 1, feature.geometry.coordinates[i].length - 1)],
          [i, j],
          undefined,
          undefined,
          false,
          true
        )
      );
    }
  }
  // Adding intersection-pseudo-vertices to pseudoVtxListByRingAndEdge and self-intersections to isectList
  for (var i = 0; i < numSelfIsect; i++) {
    // Adding intersection-pseudo-vertices made using selfIsectsData to pseudoVtxListByRingAndEdge's array corresponding to the incomming ring and edge
    pseudoVtxListByRingAndEdge[selfIsectsData[i][1]][selfIsectsData[i][2]].push(
      new PseudoVtx(
        selfIsectsData[i][0],
        selfIsectsData[i][5],
        [selfIsectsData[i][1], selfIsectsData[i][2]],
        [selfIsectsData[i][6], selfIsectsData[i][7]],
        undefined
      )
    );
    // selfIsectsData contains double mentions of each intersection, but we only want to add them once to isectList
    if (selfIsectsData[i][11])
      isectList.push(
        new Isect(
          selfIsectsData[i][0],
          [selfIsectsData[i][1], selfIsectsData[i][2]],
          [selfIsectsData[i][6], selfIsectsData[i][7]],
          undefined,
          undefined,
          true,
          true
        )
      );
  }
  var numIsect = isectList.length;
  // Sort edge arrays of pseudoVtxListByRingAndEdge by the fractional distance 'param'
  for (var i = 0; i < pseudoVtxListByRingAndEdge.length; i++) {
    for (var j = 0; j < pseudoVtxListByRingAndEdge[i].length; j++) {
      pseudoVtxListByRingAndEdge[i][j].sort(function (a, b) {
        return a.param < b.param ? -1 : 1;
      });
    }
  }

  // Make a spatial index of intersections, in preperation for the following two steps
  var allIsectsAsIsectRbushTreeItem = [];
  for (var i = 0; i < numIsect; i++) {
    allIsectsAsIsectRbushTreeItem.push({
      minX: isectList[i].coord[0],
      minY: isectList[i].coord[1],
      maxX: isectList[i].coord[0],
      maxY: isectList[i].coord[1],
      index: i,
    }); // could pass isect: isectList[i], but not necessary
  }
  var isectRbushTree = unkink_polygon_dist_es_rbush();
  isectRbushTree.load(allIsectsAsIsectRbushTreeItem);

  // Now we will teach each intersection in isectList which is the next intersection along both it's [ring, edge]'s, in two steps.
  // First, we find the next intersection for each pseudo-vertex in pseudoVtxListByRingAndEdge:
  // For each pseudovertex in pseudoVtxListByRingAndEdge (3 loops) look at the next pseudovertex on that edge and find the corresponding intersection by comparing coordinates
  for (var i = 0; i < pseudoVtxListByRingAndEdge.length; i++) {
    for (var j = 0; j < pseudoVtxListByRingAndEdge[i].length; j++) {
      for (var k = 0; k < pseudoVtxListByRingAndEdge[i][j].length; k++) {
        var coordToFind;
        if (k == pseudoVtxListByRingAndEdge[i][j].length - 1) {
          // If it's the last pseudoVertex on that edge, then the next pseudoVertex is the first one on the next edge of that ring.
          coordToFind =
            pseudoVtxListByRingAndEdge[i][
              modulo(j + 1, feature.geometry.coordinates[i].length - 1)
            ][0].coord;
        } else {
          coordToFind = pseudoVtxListByRingAndEdge[i][j][k + 1].coord;
        }
        var IsectRbushTreeItemFound = isectRbushTree.search({
          minX: coordToFind[0],
          minY: coordToFind[1],
          maxX: coordToFind[0],
          maxY: coordToFind[1],
        })[0]; // We can take [0] of the result, because there is only one isect correponding to a pseudo-vertex
        pseudoVtxListByRingAndEdge[i][j][k].nxtIsectAlongEdgeIn =
          IsectRbushTreeItemFound.index;
      }
    }
  }

  // Second, we port this knowledge of the next intersection over to the intersections in isectList, by finding the intersection corresponding to each pseudo-vertex and copying the pseudo-vertex' knownledge of the next-intersection over to the intersection
  for (var i = 0; i < pseudoVtxListByRingAndEdge.length; i++) {
    for (var j = 0; j < pseudoVtxListByRingAndEdge[i].length; j++) {
      for (var k = 0; k < pseudoVtxListByRingAndEdge[i][j].length; k++) {
        var coordToFind = pseudoVtxListByRingAndEdge[i][j][k].coord;
        var IsectRbushTreeItemFound = isectRbushTree.search({
          minX: coordToFind[0],
          minY: coordToFind[1],
          maxX: coordToFind[0],
          maxY: coordToFind[1],
        })[0]; // We can take [0] of the result, because there is only one isect correponding to a pseudo-vertex
        var l = IsectRbushTreeItemFound.index;
        if (l < numvertices) {
          // Special treatment at ring-vertices: we correct the misnaming that happened in the previous block, since ringAndEdgeOut = ringAndEdge2 for ring vertices.
          isectList[l].nxtIsectAlongRingAndEdge2 =
            pseudoVtxListByRingAndEdge[i][j][k].nxtIsectAlongEdgeIn;
        } else {
          // Port the knowledge of the next intersection from the pseudo-vertices to the intersections, depending on how the edges are labeled in the pseudo-vertex and intersection.
          if (
            equalArrays$1(
              isectList[l].ringAndEdge1,
              pseudoVtxListByRingAndEdge[i][j][k].ringAndEdgeIn
            )
          ) {
            isectList[l].nxtIsectAlongRingAndEdge1 =
              pseudoVtxListByRingAndEdge[i][j][k].nxtIsectAlongEdgeIn;
          } else {
            isectList[l].nxtIsectAlongRingAndEdge2 =
              pseudoVtxListByRingAndEdge[i][j][k].nxtIsectAlongEdgeIn;
          }
        }
      }
    }
  }
  // This explains why, eventhough when we will walk away from an intersection, we will walk way from the corresponding pseudo-vertex along edgeOut, pseudo-vertices have the property 'nxtIsectAlongEdgeIn' in stead of some propery 'nxtPseudoVtxAlongEdgeOut'. This is because this property (which is easy to find out) is used in the above for nxtIsectAlongRingAndEdge1 and nxtIsectAlongRingAndEdge2!

  // Before we start walking over the intersections to build the output rings, we prepare a queue that stores information on intersections we still have to deal with, and put at least one intersection in it.
  // This queue will contain information on intersections where we can start walking from once the current walk is finished, and its parent output ring (the smallest output ring it lies within, -1 if no parent or parent unknown yet) and its winding number (which we can already determine).
  var queue = [];
  // For each output ring, add the ring-vertex-intersection with the smalles x-value (i.e. the left-most) as a start intersection. By choosing such an extremal intersections, we are sure to start at an intersection that is a convex vertex of its output ring. By adding them all to the queue, we are sure that no rings will be forgotten. If due to ring-intersections such an intersection will be encountered while walking, it will be removed from the queue.
  var i = 0;
  for (var j = 0; j < numRings; j++) {
    var leftIsect = i;
    for (var k = 0; k < feature.geometry.coordinates[j].length - 1; k++) {
      if (isectList[i].coord[0] < isectList[leftIsect].coord[0]) {
        leftIsect = i;
      }
      i++;
    }
    // Compute winding at this left-most ring-vertex-intersection. We thus this by using our knowledge that this extremal vertex must be a convex vertex.
    // We first find the intersection before and after it, and then use them to determine the winding number of the corresponding output ring, since we know that an extremal vertex of a simple, non-self-intersecting ring is always convex, so the only reason it would not be is because the winding number we use to compute it is wrong
    var isectAfterLeftIsect = isectList[leftIsect].nxtIsectAlongRingAndEdge2;
    for (var k = 0; k < isectList.length; k++) {
      if (
        isectList[k].nxtIsectAlongRingAndEdge1 == leftIsect ||
        isectList[k].nxtIsectAlongRingAndEdge2 == leftIsect
      ) {
        var isectBeforeLeftIsect = k;
        break;
      }
    }
    var windingAtIsect = isConvex(
      [
        isectList[isectBeforeLeftIsect].coord,
        isectList[leftIsect].coord,
        isectList[isectAfterLeftIsect].coord,
      ],
      true
    )
      ? 1
      : -1;

    queue.push({ isect: leftIsect, parent: -1, winding: windingAtIsect });
  }
  // Sort the queue by the same criterion used to find the leftIsect: the left-most leftIsect must be last in the queue, such that it will be popped first, such that we will work from out to in regarding input rings. This assumtion is used when predicting the winding number and parent of a new queue member.
  queue.sort(function (a, b) {
    return isectList[a.isect].coord > isectList[b.isect].coord ? -1 : 1;
  });

  // Initialise output
  var outputFeatureArray = [];

  // While the queue is not empty, take the last object (i.e. its intersection) out and start making an output ring by walking in the direction that has not been walked away over yet.
  while (queue.length > 0) {
    // Get the last object out of the queue
    var popped = queue.pop();
    var startIsect = popped.isect;
    var currentOutputRingParent = popped.parent;
    var currentOutputRingWinding = popped.winding;
    // Make new output ring and add vertex from starting intersection
    var currentOutputRing = outputFeatureArray.length;
    var currentOutputRingCoords = [isectList[startIsect].coord];
    // Set up the variables used while walking over intersections: 'currentIsect', 'nxtIsect' and 'walkingRingAndEdge'
    var currentIsect = startIsect;
    if (isectList[startIsect].ringAndEdge1Walkable) {
      var walkingRingAndEdge = isectList[startIsect].ringAndEdge1;
      var nxtIsect = isectList[startIsect].nxtIsectAlongRingAndEdge1;
    } else {
      var walkingRingAndEdge = isectList[startIsect].ringAndEdge2;
      var nxtIsect = isectList[startIsect].nxtIsectAlongRingAndEdge2;
    }
    // While we have not arrived back at the same intersection, keep walking
    while (
      !equalArrays$1(isectList[startIsect].coord, isectList[nxtIsect].coord)
    ) {
      currentOutputRingCoords.push(isectList[nxtIsect].coord);
      // If the next intersection is queued, we can remove it, because we will go there now.
      var nxtIsectInQueue = undefined;
      for (var i = 0; i < queue.length; i++) {
        if (queue[i].isect == nxtIsect) {
          nxtIsectInQueue = i;
          break;
        }
      }
      if (nxtIsectInQueue != undefined) {
        queue.splice(nxtIsectInQueue, 1);
      }
      // Arriving at this new intersection, we know which will be our next walking ring and edge (if we came from 1 we will walk away from 2 and vice versa),
      // So we can set it as our new walking ring and intersection and remember that we (will) have walked over it
      // If we have never walked away from this new intersection along the other ring and edge then we will soon do, add the intersection (and the parent wand winding number) to the queue
      // (We can predict the winding number and parent as follows: if the edge is convex, the other output ring started from there will have the alternate winding and lie outside of the current one, and thus have the same parent ring as the current ring. Otherwise, it will have the same winding number and lie inside of the current ring. We are, however, only sure of this of an output ring started from there does not enclose the current ring. This is why the initial queue's intersections must be sorted such that outer ones come out first.)
      // We then update the other two walking variables.
      if (equalArrays$1(walkingRingAndEdge, isectList[nxtIsect].ringAndEdge1)) {
        walkingRingAndEdge = isectList[nxtIsect].ringAndEdge2;
        isectList[nxtIsect].ringAndEdge2Walkable = false;
        if (isectList[nxtIsect].ringAndEdge1Walkable) {
          var pushing = { isect: nxtIsect };
          if (
            isConvex(
              [
                isectList[currentIsect].coord,
                isectList[nxtIsect].coord,
                isectList[isectList[nxtIsect].nxtIsectAlongRingAndEdge2].coord,
              ],
              currentOutputRingWinding == 1
            )
          ) {
            pushing.parent = currentOutputRingParent;
            pushing.winding = -currentOutputRingWinding;
          } else {
            pushing.parent = currentOutputRing;
            pushing.winding = currentOutputRingWinding;
          }
          queue.push(pushing);
        }
        currentIsect = nxtIsect;
        nxtIsect = isectList[nxtIsect].nxtIsectAlongRingAndEdge2;
      } else {
        walkingRingAndEdge = isectList[nxtIsect].ringAndEdge1;
        isectList[nxtIsect].ringAndEdge1Walkable = false;
        if (isectList[nxtIsect].ringAndEdge2Walkable) {
          var pushing = { isect: nxtIsect };
          if (
            isConvex(
              [
                isectList[currentIsect].coord,
                isectList[nxtIsect].coord,
                isectList[isectList[nxtIsect].nxtIsectAlongRingAndEdge1].coord,
              ],
              currentOutputRingWinding == 1
            )
          ) {
            pushing.parent = currentOutputRingParent;
            pushing.winding = -currentOutputRingWinding;
          } else {
            pushing.parent = currentOutputRing;
            pushing.winding = currentOutputRingWinding;
          }
          queue.push(pushing);
        }
        currentIsect = nxtIsect;
        nxtIsect = isectList[nxtIsect].nxtIsectAlongRingAndEdge1;
      }
    }
    // Close output ring
    currentOutputRingCoords.push(isectList[nxtIsect].coord);
    // Push output ring to output
    outputFeatureArray.push(
      unkink_polygon_dist_es_polygon([currentOutputRingCoords], {
        index: currentOutputRing,
        parent: currentOutputRingParent,
        winding: currentOutputRingWinding,
        netWinding: undefined,
      })
    );
  }

  var output = unkink_polygon_dist_es_featureCollection(outputFeatureArray);

  determineParents();

  setNetWinding();

  // These functions are also used if no intersections are found
  function determineParents() {
    var featuresWithoutParent = [];
    for (var i = 0; i < output.features.length; i++) {
      if (output.features[i].properties.parent == -1)
        featuresWithoutParent.push(i);
    }
    if (featuresWithoutParent.length > 1) {
      for (var i = 0; i < featuresWithoutParent.length; i++) {
        var parent = -1;
        var parentArea = Infinity;
        for (var j = 0; j < output.features.length; j++) {
          if (featuresWithoutParent[i] == j) continue;
          if (
            unkink_polygon_dist_es_booleanPointInPolygon(
              output.features[featuresWithoutParent[i]].geometry
                .coordinates[0][0],
              output.features[j],
              { ignoreBoundary: true }
            )
          ) {
            if (dist_es_area(output.features[j]) < parentArea) {
              parent = j;
            }
          }
        }
        output.features[featuresWithoutParent[i]].properties.parent = parent;
      }
    }
  }

  function setNetWinding() {
    for (var i = 0; i < output.features.length; i++) {
      if (output.features[i].properties.parent == -1) {
        var netWinding = output.features[i].properties.winding;
        output.features[i].properties.netWinding = netWinding;
        setNetWindingOfChildren(i, netWinding);
      }
    }
  }

  function setNetWindingOfChildren(parent, ParentNetWinding) {
    for (var i = 0; i < output.features.length; i++) {
      if (output.features[i].properties.parent == parent) {
        var netWinding =
          ParentNetWinding + output.features[i].properties.winding;
        output.features[i].properties.netWinding = netWinding;
        setNetWindingOfChildren(i, netWinding);
      }
    }
  }

  return output;
}

// Constructor for (ring- or intersection-) pseudo-vertices.
var PseudoVtx = function (
  coord,
  param,
  ringAndEdgeIn,
  ringAndEdgeOut,
  nxtIsectAlongEdgeIn
) {
  this.coord = coord; // [x,y] of this pseudo-vertex
  this.param = param; // fractional distance of this intersection on incomming edge
  this.ringAndEdgeIn = ringAndEdgeIn; // [ring index, edge index] of incomming edge
  this.ringAndEdgeOut = ringAndEdgeOut; // [ring index, edge index] of outgoing edge
  this.nxtIsectAlongEdgeIn = nxtIsectAlongEdgeIn; // The next intersection when following the incomming edge (so not when following ringAndEdgeOut!)
};

// Constructor for an intersection. There are two intersection-pseudo-vertices per self-intersection and one ring-pseudo-vertex per ring-vertex-intersection. Their labels 1 and 2 are not assigned a particular meaning but are permanent once given.
var Isect = function (
  coord,
  ringAndEdge1,
  ringAndEdge2,
  nxtIsectAlongRingAndEdge1,
  nxtIsectAlongRingAndEdge2,
  ringAndEdge1Walkable,
  ringAndEdge2Walkable
) {
  this.coord = coord; // [x,y] of this intersection
  this.ringAndEdge1 = ringAndEdge1; // first edge of this intersection
  this.ringAndEdge2 = ringAndEdge2; // second edge of this intersection
  this.nxtIsectAlongRingAndEdge1 = nxtIsectAlongRingAndEdge1; // the next intersection when following ringAndEdge1
  this.nxtIsectAlongRingAndEdge2 = nxtIsectAlongRingAndEdge2; // the next intersection when following ringAndEdge2
  this.ringAndEdge1Walkable = ringAndEdge1Walkable; // May we (still) walk away from this intersection over ringAndEdge1?
  this.ringAndEdge2Walkable = ringAndEdge2Walkable; // May we (still) walk away from this intersection over ringAndEdge2?
};

// Function to determine if three consecutive points of a simple, non-self-intersecting ring make up a convex vertex, assuming the ring is right- or lefthanded
function isConvex(pts, righthanded) {
  // 'pts' is an [x,y] pair
  // 'righthanded' is a boolean
  if (typeof righthanded === "undefined") righthanded = true;
  if (pts.length != 3)
    throw new Error("This function requires an array of three points [x,y]");
  var d =
    (pts[1][0] - pts[0][0]) * (pts[2][1] - pts[0][1]) -
    (pts[1][1] - pts[0][1]) * (pts[2][0] - pts[0][0]);
  return d >= 0 == righthanded;
}

// Function to compute winding of simple, non-self-intersecting ring
function windingOfRing(ring) {
  // 'ring' is an array of [x,y] pairs with the last equal to the first
  // Compute the winding number based on the vertex with the smallest x-value, it precessor and successor. An extremal vertex of a simple, non-self-intersecting ring is always convex, so the only reason it is not is because the winding number we use to compute it is wrong
  var leftVtx = 0;
  for (var i = 0; i < ring.length - 1; i++) {
    if (ring[i][0] < ring[leftVtx][0]) leftVtx = i;
  }
  if (
    isConvex(
      [
        ring[modulo(leftVtx - 1, ring.length - 1)],
        ring[leftVtx],
        ring[modulo(leftVtx + 1, ring.length - 1)],
      ],
      true
    )
  ) {
    var winding = 1;
  } else {
    var winding = -1;
  }
  return winding;
}

// Function to compare Arrays of numbers. From http://stackoverflow.com/questions/7837456/how-to-compare-arrays-in-javascript
function equalArrays$1(array1, array2) {
  // if the other array is a falsy value, return
  if (!array1 || !array2) return false;

  // compare lengths - can save a lot of time
  if (array1.length != array2.length) return false;

  for (var i = 0, l = array1.length; i < l; i++) {
    // Check if we have nested arrays
    if (array1[i] instanceof Array && array2[i] instanceof Array) {
      // recurse into the nested arrays
      if (!equalArrays$1(array1[i], array2[i])) return false;
    } else if (array1[i] != array2[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
}

// Fix Javascript modulo for negative number. From http://stackoverflow.com/questions/4467539/javascript-modulo-not-behaving
function modulo(n, m) {
  return ((n % m) + m) % m;
}

// Function to check if array is unique (i.e. all unique elements, i.e. no duplicate elements)
function isUnique(array) {
  var u = {};
  var isUnique = 1;
  for (var i = 0, l = array.length; i < l; ++i) {
    if (Object.prototype.hasOwnProperty.call(u, array[i])) {
      isUnique = 0;
      break;
    }
    u[array[i]] = 1;
  }
  return isUnique;
}

/**
 * Takes a kinked polygon and returns a feature collection of polygons that have no kinks.
 * Uses [simplepolygon](https://github.com/mclaeysb/simplepolygon) internally.
 *
 * @name unkinkPolygon
 * @param {FeatureCollection|Feature<Polygon|MultiPolygon>} geojson GeoJSON Polygon or MultiPolygon
 * @returns {FeatureCollection<Polygon>} Unkinked polygons
 * @example
 * var poly = turf.polygon([[[0, 0], [2, 0], [0, 2], [2, 2], [0, 0]]]);
 *
 * var result = turf.unkinkPolygon(poly);
 *
 * //addToMap
 * var addToMap = [poly, result]
 */
function unkinkPolygon(geojson) {
  var features = [];
  unkink_polygon_dist_es_flattenEach(geojson, function (feature) {
    if (feature.geometry.type !== "Polygon") return;
    unkink_polygon_dist_es_featureEach(simplepolygon(feature), function (poly) {
      features.push(unkink_polygon_dist_es_polygon(poly.geometry.coordinates, feature.properties));
    });
  });
  return unkink_polygon_dist_es_featureCollection(features);
}

/* harmony default export */ const unkink_polygon_dist_es = ((/* unused pure expression or super */ null && (unkinkPolygon)));

;// ../../node_modules/@turf/great-circle/dist/es/index.js
/* unused harmony import specifier */ var great_circle_dist_es_getCoord;


var D2R = Math.PI / 180;
var R2D = 180 / Math.PI;

var Coord = function (lon, lat) {
  this.lon = lon;
  this.lat = lat;
  this.x = D2R * lon;
  this.y = D2R * lat;
};

Coord.prototype.view = function () {
  return String(this.lon).slice(0, 4) + "," + String(this.lat).slice(0, 4);
};

Coord.prototype.antipode = function () {
  var anti_lat = -1 * this.lat;
  var anti_lon = this.lon < 0 ? 180 + this.lon : (180 - this.lon) * -1;
  return new Coord(anti_lon, anti_lat);
};

var LineString = function () {
  this.coords = [];
  this.length = 0;
};

LineString.prototype.move_to = function (coord) {
  this.length++;
  this.coords.push(coord);
};

var Arc = function (properties) {
  this.properties = properties || {};
  this.geometries = [];
};

Arc.prototype.json = function () {
  if (this.geometries.length <= 0) {
    return {
      geometry: { type: "LineString", coordinates: null },
      type: "Feature",
      properties: this.properties,
    };
  } else if (this.geometries.length === 1) {
    return {
      geometry: { type: "LineString", coordinates: this.geometries[0].coords },
      type: "Feature",
      properties: this.properties,
    };
  } else {
    var multiline = [];
    for (var i = 0; i < this.geometries.length; i++) {
      multiline.push(this.geometries[i].coords);
    }
    return {
      geometry: { type: "MultiLineString", coordinates: multiline },
      type: "Feature",
      properties: this.properties,
    };
  }
};

// TODO - output proper multilinestring
Arc.prototype.wkt = function () {
  var wkt_string = "";
  var wkt = "LINESTRING(";
  var collect = function (c) {
    wkt += c[0] + " " + c[1] + ",";
  };
  for (var i = 0; i < this.geometries.length; i++) {
    if (this.geometries[i].coords.length === 0) {
      return "LINESTRING(empty)";
    } else {
      var coords = this.geometries[i].coords;
      coords.forEach(collect);
      wkt_string += wkt.substring(0, wkt.length - 1) + ")";
    }
  }
  return wkt_string;
};

/*
 * http://en.wikipedia.org/wiki/Great-circle_distance
 *
 */
var GreatCircle = function (start, end, properties) {
  if (!start || start.x === undefined || start.y === undefined) {
    throw new Error(
      "GreatCircle constructor expects two args: start and end objects with x and y properties"
    );
  }
  if (!end || end.x === undefined || end.y === undefined) {
    throw new Error(
      "GreatCircle constructor expects two args: start and end objects with x and y properties"
    );
  }
  this.start = new Coord(start.x, start.y);
  this.end = new Coord(end.x, end.y);
  this.properties = properties || {};

  var w = this.start.x - this.end.x;
  var h = this.start.y - this.end.y;
  var z =
    Math.pow(Math.sin(h / 2.0), 2) +
    Math.cos(this.start.y) *
      Math.cos(this.end.y) *
      Math.pow(Math.sin(w / 2.0), 2);
  this.g = 2.0 * Math.asin(Math.sqrt(z));

  if (this.g === Math.PI) {
    throw new Error(
      "it appears " +
        start.view() +
        " and " +
        end.view() +
        " are 'antipodal', e.g diametrically opposite, thus there is no single route but rather infinite"
    );
  } else if (isNaN(this.g)) {
    throw new Error(
      "could not calculate great circle between " + start + " and " + end
    );
  }
};

/*
 * http://williams.best.vwh.net/avform.htm#Intermediate
 */
GreatCircle.prototype.interpolate = function (f) {
  var A = Math.sin((1 - f) * this.g) / Math.sin(this.g);
  var B = Math.sin(f * this.g) / Math.sin(this.g);
  var x =
    A * Math.cos(this.start.y) * Math.cos(this.start.x) +
    B * Math.cos(this.end.y) * Math.cos(this.end.x);
  var y =
    A * Math.cos(this.start.y) * Math.sin(this.start.x) +
    B * Math.cos(this.end.y) * Math.sin(this.end.x);
  var z = A * Math.sin(this.start.y) + B * Math.sin(this.end.y);
  var lat = R2D * Math.atan2(z, Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)));
  var lon = R2D * Math.atan2(y, x);
  return [lon, lat];
};

/*
 * Generate points along the great circle
 */
GreatCircle.prototype.Arc = function (npoints, options) {
  var first_pass = [];
  if (!npoints || npoints <= 2) {
    first_pass.push([this.start.lon, this.start.lat]);
    first_pass.push([this.end.lon, this.end.lat]);
  } else {
    var delta = 1.0 / (npoints - 1);
    for (var i = 0; i < npoints; ++i) {
      var step = delta * i;
      var pair = this.interpolate(step);
      first_pass.push(pair);
    }
  }
  /* partial port of dateline handling from:
      gdal/ogr/ogrgeometryfactory.cpp

      TODO - does not handle all wrapping scenarios yet
    */
  var bHasBigDiff = false;
  var dfMaxSmallDiffLong = 0;
  // from http://www.gdal.org/ogr2ogr.html
  // -datelineoffset:
  // (starting with GDAL 1.10) offset from dateline in degrees (default long. = +/- 10deg, geometries within 170deg to -170deg will be splited)
  var dfDateLineOffset = options && options.offset ? options.offset : 10;
  var dfLeftBorderX = 180 - dfDateLineOffset;
  var dfRightBorderX = -180 + dfDateLineOffset;
  var dfDiffSpace = 360 - dfDateLineOffset;

  // https://github.com/OSGeo/gdal/blob/7bfb9c452a59aac958bff0c8386b891edf8154ca/gdal/ogr/ogrgeometryfactory.cpp#L2342
  for (var j = 1; j < first_pass.length; ++j) {
    var dfPrevX = first_pass[j - 1][0];
    var dfX = first_pass[j][0];
    var dfDiffLong = Math.abs(dfX - dfPrevX);
    if (
      dfDiffLong > dfDiffSpace &&
      ((dfX > dfLeftBorderX && dfPrevX < dfRightBorderX) ||
        (dfPrevX > dfLeftBorderX && dfX < dfRightBorderX))
    ) {
      bHasBigDiff = true;
    } else if (dfDiffLong > dfMaxSmallDiffLong) {
      dfMaxSmallDiffLong = dfDiffLong;
    }
  }

  var poMulti = [];
  if (bHasBigDiff && dfMaxSmallDiffLong < dfDateLineOffset) {
    var poNewLS = [];
    poMulti.push(poNewLS);
    for (var k = 0; k < first_pass.length; ++k) {
      var dfX0 = parseFloat(first_pass[k][0]);
      if (k > 0 && Math.abs(dfX0 - first_pass[k - 1][0]) > dfDiffSpace) {
        var dfX1 = parseFloat(first_pass[k - 1][0]);
        var dfY1 = parseFloat(first_pass[k - 1][1]);
        var dfX2 = parseFloat(first_pass[k][0]);
        var dfY2 = parseFloat(first_pass[k][1]);
        if (
          dfX1 > -180 &&
          dfX1 < dfRightBorderX &&
          dfX2 === 180 &&
          k + 1 < first_pass.length &&
          first_pass[k - 1][0] > -180 &&
          first_pass[k - 1][0] < dfRightBorderX
        ) {
          poNewLS.push([-180, first_pass[k][1]]);
          k++;
          poNewLS.push([first_pass[k][0], first_pass[k][1]]);
          continue;
        } else if (
          dfX1 > dfLeftBorderX &&
          dfX1 < 180 &&
          dfX2 === -180 &&
          k + 1 < first_pass.length &&
          first_pass[k - 1][0] > dfLeftBorderX &&
          first_pass[k - 1][0] < 180
        ) {
          poNewLS.push([180, first_pass[k][1]]);
          k++;
          poNewLS.push([first_pass[k][0], first_pass[k][1]]);
          continue;
        }

        if (dfX1 < dfRightBorderX && dfX2 > dfLeftBorderX) {
          // swap dfX1, dfX2
          var tmpX = dfX1;
          dfX1 = dfX2;
          dfX2 = tmpX;
          // swap dfY1, dfY2
          var tmpY = dfY1;
          dfY1 = dfY2;
          dfY2 = tmpY;
        }
        if (dfX1 > dfLeftBorderX && dfX2 < dfRightBorderX) {
          dfX2 += 360;
        }

        if (dfX1 <= 180 && dfX2 >= 180 && dfX1 < dfX2) {
          var dfRatio = (180 - dfX1) / (dfX2 - dfX1);
          var dfY = dfRatio * dfY2 + (1 - dfRatio) * dfY1;
          poNewLS.push([
            first_pass[k - 1][0] > dfLeftBorderX ? 180 : -180,
            dfY,
          ]);
          poNewLS = [];
          poNewLS.push([
            first_pass[k - 1][0] > dfLeftBorderX ? -180 : 180,
            dfY,
          ]);
          poMulti.push(poNewLS);
        } else {
          poNewLS = [];
          poMulti.push(poNewLS);
        }
        poNewLS.push([dfX0, first_pass[k][1]]);
      } else {
        poNewLS.push([first_pass[k][0], first_pass[k][1]]);
      }
    }
  } else {
    // add normally
    var poNewLS0 = [];
    poMulti.push(poNewLS0);
    for (var l = 0; l < first_pass.length; ++l) {
      poNewLS0.push([first_pass[l][0], first_pass[l][1]]);
    }
  }

  var arc = new Arc(this.properties);
  for (var m = 0; m < poMulti.length; ++m) {
    var line = new LineString();
    arc.geometries.push(line);
    var points = poMulti[m];
    for (var j0 = 0; j0 < points.length; ++j0) {
      line.move_to(points[j0]);
    }
  }
  return arc;
};

/**
 * Calculate great circles routes as {@link LineString} or {@link MultiLineString}.
 * If the `start` and `end` points span the antimeridian, the resulting feature will
 * be split into a `MultiLineString`.
 *
 * @name greatCircle
 * @param {Coord} start source point feature
 * @param {Coord} end destination point feature
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] line feature properties
 * @param {number} [options.npoints=100] number of points
 * @param {number} [options.offset=10] offset controls the likelyhood that lines will
 * be split which cross the dateline. The higher the number the more likely.
 * @returns {Feature<LineString | MultiLineString>} great circle line feature
 * @example
 * var start = turf.point([-122, 48]);
 * var end = turf.point([-77, 39]);
 *
 * var greatCircle = turf.greatCircle(start, end, {properties: {name: 'Seattle to DC'}});
 *
 * //addToMap
 * var addToMap = [start, end, greatCircle]
 */
function greatCircle(start, end, options) {
  // Optional parameters
  options = options || {};
  if (typeof options !== "object") throw new Error("options is invalid");
  var properties = options.properties;
  var npoints = options.npoints;
  var offset = options.offset;

  start = great_circle_dist_es_getCoord(start);
  end = great_circle_dist_es_getCoord(end);
  properties = properties || {};
  npoints = npoints || 100;
  offset = offset || 10;

  var generator = new GreatCircle(
    { x: start[0], y: start[1] },
    { x: end[0], y: end[1] },
    properties
  );

  var line = generator.Arc(npoints, { offset: offset });

  return line.json();
}

/* harmony default export */ const great_circle_dist_es = ((/* unused pure expression or super */ null && (greatCircle)));

;// ../../node_modules/@turf/line-split/dist/es/index.js
/* unused harmony import specifier */ var line_split_dist_es_rbush;
/* unused harmony import specifier */ var es_square;
/* unused harmony import specifier */ var line_split_dist_es_bbox;
/* unused harmony import specifier */ var es_truncate;
/* unused harmony import specifier */ var dist_es_lineSegment;
/* unused harmony import specifier */ var es_lineIntersect;
/* unused harmony import specifier */ var dist_es_nearestPointOnLine;
/* unused harmony import specifier */ var line_split_dist_es_getType;
/* unused harmony import specifier */ var line_split_dist_es_getCoords;
/* unused harmony import specifier */ var line_split_dist_es_getCoord;
/* unused harmony import specifier */ var line_split_dist_es_flattenEach;
/* unused harmony import specifier */ var line_split_dist_es_featureEach;
/* unused harmony import specifier */ var es_featureReduce;
/* unused harmony import specifier */ var line_split_dist_es_featureCollection;
/* unused harmony import specifier */ var line_split_dist_es_lineString;











/**
 * Split a LineString by another GeoJSON Feature.
 *
 * @name lineSplit
 * @param {Feature<LineString>} line LineString Feature to split
 * @param {Feature<any>} splitter Feature used to split line
 * @returns {FeatureCollection<LineString>} Split LineStrings
 * @example
 * var line = turf.lineString([[120, -25], [145, -25]]);
 * var splitter = turf.lineString([[130, -15], [130, -35]]);
 *
 * var split = turf.lineSplit(line, splitter);
 *
 * //addToMap
 * var addToMap = [line, splitter]
 */
function lineSplit(line, splitter) {
  if (!line) throw new Error("line is required");
  if (!splitter) throw new Error("splitter is required");

  var lineType = line_split_dist_es_getType(line);
  var splitterType = line_split_dist_es_getType(splitter);

  if (lineType !== "LineString") throw new Error("line must be LineString");
  if (splitterType === "FeatureCollection")
    throw new Error("splitter cannot be a FeatureCollection");
  if (splitterType === "GeometryCollection")
    throw new Error("splitter cannot be a GeometryCollection");

  // remove excessive decimals from splitter
  // to avoid possible approximation issues in rbush
  var truncatedSplitter = es_truncate(splitter, { precision: 7 });

  switch (splitterType) {
    case "Point":
      return splitLineWithPoint(line, truncatedSplitter);
    case "MultiPoint":
      return splitLineWithPoints(line, truncatedSplitter);
    case "LineString":
    case "MultiLineString":
    case "Polygon":
    case "MultiPolygon":
      return splitLineWithPoints(line, es_lineIntersect(line, truncatedSplitter));
  }
}

/**
 * Split LineString with MultiPoint
 *
 * @private
 * @param {Feature<LineString>} line LineString
 * @param {FeatureCollection<Point>} splitter Point
 * @returns {FeatureCollection<LineString>} split LineStrings
 */
function splitLineWithPoints(line, splitter) {
  var results = [];
  var tree = line_split_dist_es_rbush();

  line_split_dist_es_flattenEach(splitter, function (point) {
    // Add index/id to features (needed for filter)
    results.forEach(function (feature, index) {
      feature.id = index;
    });
    // First Point - doesn't need to handle any previous line results
    if (!results.length) {
      results = splitLineWithPoint(line, point).features;

      // Add Square BBox to each feature for GeoJSON-RBush
      results.forEach(function (feature) {
        if (!feature.bbox) feature.bbox = es_square(line_split_dist_es_bbox(feature));
      });
      tree.load(line_split_dist_es_featureCollection(results));
      // Split with remaining points - lines might needed to be split multiple times
    } else {
      // Find all lines that are within the splitter's bbox
      var search = tree.search(point);

      if (search.features.length) {
        // RBush might return multiple lines - only process the closest line to splitter
        var closestLine = findClosestFeature(point, search);

        // Remove closest line from results since this will be split into two lines
        // This removes any duplicates inside the results & index
        results = results.filter(function (feature) {
          return feature.id !== closestLine.id;
        });
        tree.remove(closestLine);

        // Append the two newly split lines into the results
        line_split_dist_es_featureEach(splitLineWithPoint(closestLine, point), function (line) {
          results.push(line);
          tree.insert(line);
        });
      }
    }
  });
  return line_split_dist_es_featureCollection(results);
}

/**
 * Split LineString with Point
 *
 * @private
 * @param {Feature<LineString>} line LineString
 * @param {Feature<Point>} splitter Point
 * @returns {FeatureCollection<LineString>} split LineStrings
 */
function splitLineWithPoint(line, splitter) {
  var results = [];

  // handle endpoints
  var startPoint = line_split_dist_es_getCoords(line)[0];
  var endPoint = line_split_dist_es_getCoords(line)[line.geometry.coordinates.length - 1];
  if (
    pointsEquals(startPoint, line_split_dist_es_getCoord(splitter)) ||
    pointsEquals(endPoint, line_split_dist_es_getCoord(splitter))
  )
    return line_split_dist_es_featureCollection([line]);

  // Create spatial index
  var tree = line_split_dist_es_rbush();
  var segments = dist_es_lineSegment(line);
  tree.load(segments);

  // Find all segments that are within bbox of splitter
  var search = tree.search(splitter);

  // Return itself if point is not within spatial index
  if (!search.features.length) return line_split_dist_es_featureCollection([line]);

  // RBush might return multiple lines - only process the closest line to splitter
  var closestSegment = findClosestFeature(splitter, search);

  // Initial value is the first point of the first segments (beginning of line)
  var initialValue = [startPoint];
  var lastCoords = es_featureReduce(
    segments,
    function (previous, current, index) {
      var currentCoords = line_split_dist_es_getCoords(current)[1];
      var splitterCoords = line_split_dist_es_getCoord(splitter);

      // Location where segment intersects with line
      if (index === closestSegment.id) {
        previous.push(splitterCoords);
        results.push(line_split_dist_es_lineString(previous));
        // Don't duplicate splitter coordinate (Issue #688)
        if (pointsEquals(splitterCoords, currentCoords))
          return [splitterCoords];
        return [splitterCoords, currentCoords];

        // Keep iterating over coords until finished or intersection is found
      } else {
        previous.push(currentCoords);
        return previous;
      }
    },
    initialValue
  );
  // Append last line to final split results
  if (lastCoords.length > 1) {
    results.push(line_split_dist_es_lineString(lastCoords));
  }
  return line_split_dist_es_featureCollection(results);
}

/**
 * Find Closest Feature
 *
 * @private
 * @param {Feature<Point>} point Feature must be closest to this point
 * @param {FeatureCollection<LineString>} lines Collection of Features
 * @returns {Feature<LineString>} closest LineString
 */
function findClosestFeature(point, lines) {
  if (!lines.features.length) throw new Error("lines must contain features");
  // Filter to one segment that is the closest to the line
  if (lines.features.length === 1) return lines.features[0];

  var closestFeature;
  var closestDistance = Infinity;
  line_split_dist_es_featureEach(lines, function (segment) {
    var pt = dist_es_nearestPointOnLine(segment, point);
    var dist = pt.properties.dist;
    if (dist < closestDistance) {
      closestFeature = segment;
      closestDistance = dist;
    }
  });
  return closestFeature;
}

/**
 * Compares two points and returns if they are equals
 *
 * @private
 * @param {Array<number>} pt1 point
 * @param {Array<number>} pt2 point
 * @returns {boolean} true if they are equals
 */
function pointsEquals(pt1, pt2) {
  return pt1[0] === pt2[0] && pt1[1] === pt2[1];
}

/* harmony default export */ const line_split_dist_es = ((/* unused pure expression or super */ null && (lineSplit)));

;// ../../node_modules/@turf/line-arc/dist/es/index.js
/* unused harmony import specifier */ var es_circle;
/* unused harmony import specifier */ var line_arc_dist_es_destination;
/* unused harmony import specifier */ var line_arc_dist_es_lineString;



/**
 * Creates a circular arc, of a circle of the given radius and center point, between bearing1 and bearing2;
 * 0 bearing is North of center point, positive clockwise.
 *
 * @name lineArc
 * @param {Coord} center center point
 * @param {number} radius radius of the circle
 * @param {number} bearing1 angle, in decimal degrees, of the first radius of the arc
 * @param {number} bearing2 angle, in decimal degrees, of the second radius of the arc
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.steps=64] number of steps
 * @param {string} [options.units='kilometers'] miles, kilometers, degrees, or radians
 * @returns {Feature<LineString>} line arc
 * @example
 * var center = turf.point([-75, 40]);
 * var radius = 5;
 * var bearing1 = 25;
 * var bearing2 = 47;
 *
 * var arc = turf.lineArc(center, radius, bearing1, bearing2);
 *
 * //addToMap
 * var addToMap = [center, arc]
 */
function lineArc(center, radius, bearing1, bearing2, options) {
    if (options === void 0) { options = {}; }
    // default params
    var steps = options.steps || 64;
    var angle1 = convertAngleTo360(bearing1);
    var angle2 = convertAngleTo360(bearing2);
    var properties = !Array.isArray(center) && center.type === "Feature"
        ? center.properties
        : {};
    // handle angle parameters
    if (angle1 === angle2) {
        return line_arc_dist_es_lineString(es_circle(center, radius, options).geometry.coordinates[0], properties);
    }
    var arcStartDegree = angle1;
    var arcEndDegree = angle1 < angle2 ? angle2 : angle2 + 360;
    var alfa = arcStartDegree;
    var coordinates = [];
    var i = 0;
    while (alfa < arcEndDegree) {
        coordinates.push(line_arc_dist_es_destination(center, radius, alfa, options).geometry.coordinates);
        i++;
        alfa = arcStartDegree + (i * 360) / steps;
    }
    if (alfa > arcEndDegree) {
        coordinates.push(line_arc_dist_es_destination(center, radius, arcEndDegree, options).geometry.coordinates);
    }
    return line_arc_dist_es_lineString(coordinates, properties);
}
/**
 * Takes any angle in  degrees
 * and returns a valid angle between 0-360 degrees
 *
 * @private
 * @param {number} alfa angle between -180-180 degrees
 * @returns {number} angle between 0-360 degrees
 */
function convertAngleTo360(alfa) {
    var beta = alfa % 360;
    if (beta < 0) {
        beta += 360;
    }
    return beta;
}

;// ../../node_modules/@turf/polygon-to-line/dist/es/index.js
Object.defineProperty(polygon_to_line_dist_es, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var polygon_to_line_dist_es_featureCollection;
/* unused harmony import specifier */ var dist_es_multiLineString;
/* unused harmony import specifier */ var polygon_to_line_dist_es_lineString;
/* unused harmony import specifier */ var polygon_to_line_dist_es_getGeom;


/**
 * Converts a {@link Polygon} to {@link LineString|(Multi)LineString} or {@link MultiPolygon} to a
 * {@link FeatureCollection} of {@link LineString|(Multi)LineString}.
 *
 * @name polygonToLine
 * @param {Feature<Polygon|MultiPolygon>} poly Feature to convert
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] translates GeoJSON properties to Feature
 * @returns {FeatureCollection|Feature<LineString|MultiLinestring>} converted (Multi)Polygon to (Multi)LineString
 * @example
 * var poly = turf.polygon([[[125, -30], [145, -30], [145, -20], [125, -20], [125, -30]]]);
 *
 * var line = turf.polygonToLine(poly);
 *
 * //addToMap
 * var addToMap = [line];
 */
/* harmony default export */ function polygon_to_line_dist_es(poly, options) {
    if (options === void 0) { options = {}; }
    var geom = polygon_to_line_dist_es_getGeom(poly);
    if (!options.properties && poly.type === "Feature") {
        options.properties = poly.properties;
    }
    switch (geom.type) {
        case "Polygon":
            return polygonToLine(geom, options);
        case "MultiPolygon":
            return multiPolygonToLine(geom, options);
        default:
            throw new Error("invalid poly");
    }
}
/**
 * @private
 */
function polygonToLine(poly, options) {
    if (options === void 0) { options = {}; }
    var geom = polygon_to_line_dist_es_getGeom(poly);
    var coords = geom.coordinates;
    var properties = options.properties
        ? options.properties
        : poly.type === "Feature"
            ? poly.properties
            : {};
    return coordsToLine(coords, properties);
}
/**
 * @private
 */
function multiPolygonToLine(multiPoly, options) {
    if (options === void 0) { options = {}; }
    var geom = polygon_to_line_dist_es_getGeom(multiPoly);
    var coords = geom.coordinates;
    var properties = options.properties
        ? options.properties
        : multiPoly.type === "Feature"
            ? multiPoly.properties
            : {};
    var lines = [];
    coords.forEach(function (coord) {
        lines.push(coordsToLine(coord, properties));
    });
    return polygon_to_line_dist_es_featureCollection(lines);
}
/**
 * @private
 */
function coordsToLine(coords, properties) {
    if (coords.length > 1) {
        return dist_es_multiLineString(coords, properties);
    }
    return polygon_to_line_dist_es_lineString(coords[0], properties);
}

;// ../../node_modules/@turf/line-to-polygon/dist/es/index.js
/* unused harmony import specifier */ var turfBBox;
/* unused harmony import specifier */ var line_to_polygon_dist_es_getCoords;
/* unused harmony import specifier */ var line_to_polygon_dist_es_getGeom;
/* unused harmony import specifier */ var es_multiPolygon;
/* unused harmony import specifier */ var line_to_polygon_dist_es_polygon;
/* unused harmony import specifier */ var line_to_polygon_dist_es_lineString;
/* unused harmony import specifier */ var line_to_polygon_dist_es_clone;




/**
 * Converts (Multi)LineString(s) to Polygon(s).
 *
 * @name lineToPolygon
 * @param {FeatureCollection|Feature<LineString|MultiLineString>} lines Features to convert
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] translates GeoJSON properties to Feature
 * @param {boolean} [options.autoComplete=true] auto complete linestrings (matches first & last coordinates)
 * @param {boolean} [options.orderCoords=true] sorts linestrings to place outer ring at the first position of the coordinates
 * @param {boolean} [options.mutate=false] mutate the original linestring using autoComplete (matches first & last coordinates)
 * @returns {Feature<Polygon|MultiPolygon>} converted to Polygons
 * @example
 * var line = turf.lineString([[125, -30], [145, -30], [145, -20], [125, -20], [125, -30]]);
 *
 * var polygon = turf.lineToPolygon(line);
 *
 * //addToMap
 * var addToMap = [polygon];
 */
function lineToPolygon(lines, options) {
    if (options === void 0) { options = {}; }
    var _a, _b, _c;
    // Optional parameters
    var properties = options.properties;
    var autoComplete = (_a = options.autoComplete) !== null && _a !== void 0 ? _a : true;
    var orderCoords = (_b = options.orderCoords) !== null && _b !== void 0 ? _b : true;
    var mutate = (_c = options.mutate) !== null && _c !== void 0 ? _c : false;
    if (!mutate) {
        lines = line_to_polygon_dist_es_clone(lines);
    }
    switch (lines.type) {
        case "FeatureCollection":
            var coords = [];
            lines.features.forEach(function (line) {
                coords.push(line_to_polygon_dist_es_getCoords(lineStringToPolygon(line, {}, autoComplete, orderCoords)));
            });
            return es_multiPolygon(coords, properties);
        default:
            return lineStringToPolygon(lines, properties, autoComplete, orderCoords);
    }
}
/**
 * LineString to Polygon
 *
 * @private
 * @param {Feature<LineString|MultiLineString>} line line
 * @param {Object} [properties] translates GeoJSON properties to Feature
 * @param {boolean} [autoComplete=true] auto complete linestrings
 * @param {boolean} [orderCoords=true] sorts linestrings to place outer ring at the first position of the coordinates
 * @returns {Feature<Polygon>} line converted to Polygon
 */
function lineStringToPolygon(line, properties, autoComplete, orderCoords) {
    properties = properties
        ? properties
        : line.type === "Feature"
            ? line.properties
            : {};
    var geom = line_to_polygon_dist_es_getGeom(line);
    var coords = geom.coordinates;
    var type = geom.type;
    if (!coords.length)
        throw new Error("line must contain coordinates");
    switch (type) {
        case "LineString":
            if (autoComplete)
                coords = autoCompleteCoords(coords);
            return line_to_polygon_dist_es_polygon([coords], properties);
        case "MultiLineString":
            var multiCoords = [];
            var largestArea = 0;
            coords.forEach(function (coord) {
                if (autoComplete)
                    coord = autoCompleteCoords(coord);
                // Largest LineString to be placed in the first position of the coordinates array
                if (orderCoords) {
                    var area = es_calculateArea(turfBBox(line_to_polygon_dist_es_lineString(coord)));
                    if (area > largestArea) {
                        multiCoords.unshift(coord);
                        largestArea = area;
                    }
                    else
                        multiCoords.push(coord);
                }
                else {
                    multiCoords.push(coord);
                }
            });
            return line_to_polygon_dist_es_polygon(multiCoords, properties);
        default:
            throw new Error("geometry type " + type + " is not supported");
    }
}
/**
 * Auto Complete Coords - matches first & last coordinates
 *
 * @private
 * @param {Array<Array<number>>} coords Coordinates
 * @returns {Array<Array<number>>} auto completed coordinates
 */
function autoCompleteCoords(coords) {
    var first = coords[0];
    var x1 = first[0];
    var y1 = first[1];
    var last = coords[coords.length - 1];
    var x2 = last[0];
    var y2 = last[1];
    if (x1 !== x2 || y1 !== y2) {
        coords.push(first);
    }
    return coords;
}
/**
 * area - quick approximate area calculation (used to sort)
 *
 * @private
 * @param {Array<number>} bbox BBox [west, south, east, north]
 * @returns {number} very quick area calculation
 */
function es_calculateArea(bbox) {
    var west = bbox[0];
    var south = bbox[1];
    var east = bbox[2];
    var north = bbox[3];
    return Math.abs(west - east) * Math.abs(south - north);
}
/* harmony default export */ const line_to_polygon_dist_es = ((/* unused pure expression or super */ null && (lineToPolygon)));

;// ../../node_modules/@turf/bbox-clip/dist/es/index.js
/* unused harmony import specifier */ var bbox_clip_dist_es_lineString;
/* unused harmony import specifier */ var bbox_clip_dist_es_multiLineString;
/* unused harmony import specifier */ var bbox_clip_dist_es_polygon;
/* unused harmony import specifier */ var dist_es_multiPolygon;
/* unused harmony import specifier */ var bbox_clip_dist_es_getGeom;
/* unused harmony import specifier */ var lineclip;
/* unused harmony import specifier */ var polygonclip;



/**
 * Takes a {@link Feature} and a bbox and clips the feature to the bbox using
 * [lineclip](https://github.com/mapbox/lineclip).
 * May result in degenerate edges when clipping Polygons.
 *
 * @name bboxClip
 * @param {Feature<LineString|MultiLineString|Polygon|MultiPolygon>} feature feature to clip to the bbox
 * @param {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @returns {Feature<LineString|MultiLineString|Polygon|MultiPolygon>} clipped Feature
 * @example
 * var bbox = [0, 0, 10, 10];
 * var poly = turf.polygon([[[2, 2], [8, 4], [12, 8], [3, 7], [2, 2]]]);
 *
 * var clipped = turf.bboxClip(poly, bbox);
 *
 * //addToMap
 * var addToMap = [bbox, poly, clipped]
 */
function bboxClip(feature, bbox) {
    var geom = bbox_clip_dist_es_getGeom(feature);
    var type = geom.type;
    var properties = feature.type === "Feature" ? feature.properties : {};
    var coords = geom.coordinates;
    switch (type) {
        case "LineString":
        case "MultiLineString": {
            var lines_1 = [];
            if (type === "LineString") {
                coords = [coords];
            }
            coords.forEach(function (line) {
                lineclip(line, bbox, lines_1);
            });
            if (lines_1.length === 1) {
                return bbox_clip_dist_es_lineString(lines_1[0], properties);
            }
            return bbox_clip_dist_es_multiLineString(lines_1, properties);
        }
        case "Polygon":
            return bbox_clip_dist_es_polygon(clipPolygon(coords, bbox), properties);
        case "MultiPolygon":
            return dist_es_multiPolygon(coords.map(function (poly) {
                return clipPolygon(poly, bbox);
            }), properties);
        default:
            throw new Error("geometry " + type + " not supported");
    }
}
function clipPolygon(rings, bbox) {
    var outRings = [];
    for (var _i = 0, rings_1 = rings; _i < rings_1.length; _i++) {
        var ring = rings_1[_i];
        var clipped = polygonclip(ring, bbox);
        if (clipped.length > 0) {
            if (clipped[0][0] !== clipped[clipped.length - 1][0] ||
                clipped[0][1] !== clipped[clipped.length - 1][1]) {
                clipped.push(clipped[0]);
            }
            if (clipped.length >= 4) {
                outRings.push(clipped);
            }
        }
    }
    return outRings;
}

// EXTERNAL MODULE: ../../node_modules/deep-equal/index.js
var deep_equal = __webpack_require__(4969);
;// ../../node_modules/@turf/line-overlap/dist/es/index.js
/* unused harmony import specifier */ var line_overlap_dist_es_rbush;
/* unused harmony import specifier */ var line_overlap_dist_es_lineSegment;
/* unused harmony import specifier */ var line_overlap_dist_es_nearestPointOnLine;
/* unused harmony import specifier */ var dist_es_booleanPointOnLine;
/* unused harmony import specifier */ var line_overlap_dist_es_getCoords;
/* unused harmony import specifier */ var dist_es_segmentEach;
/* unused harmony import specifier */ var line_overlap_dist_es_featureEach;
/* unused harmony import specifier */ var line_overlap_dist_es_isObject;
/* unused harmony import specifier */ var line_overlap_dist_es_featureCollection;
/* unused harmony import specifier */ var equal;








/**
 * Takes any LineString or Polygon and returns the overlapping lines between both features.
 *
 * @name lineOverlap
 * @param {Geometry|Feature<LineString|MultiLineString|Polygon|MultiPolygon>} line1 any LineString or Polygon
 * @param {Geometry|Feature<LineString|MultiLineString|Polygon|MultiPolygon>} line2 any LineString or Polygon
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.tolerance=0] Tolerance distance to match overlapping line segments (in kilometers)
 * @returns {FeatureCollection<LineString>} lines(s) that are overlapping between both features
 * @example
 * var line1 = turf.lineString([[115, -35], [125, -30], [135, -30], [145, -35]]);
 * var line2 = turf.lineString([[115, -25], [125, -30], [135, -30], [145, -25]]);
 *
 * var overlapping = turf.lineOverlap(line1, line2);
 *
 * //addToMap
 * var addToMap = [line1, line2, overlapping]
 */
function lineOverlap(line1, line2, options) {
    if (options === void 0) { options = {}; }
    // Optional parameters
    options = options || {};
    if (!line_overlap_dist_es_isObject(options))
        throw new Error("options is invalid");
    var tolerance = options.tolerance || 0;
    // Containers
    var features = [];
    // Create Spatial Index
    var tree = line_overlap_dist_es_rbush();
    // To-Do -- HACK way to support typescript
    var line = line_overlap_dist_es_lineSegment(line1);
    tree.load(line);
    var overlapSegment;
    // Line Intersection
    // Iterate over line segments
    dist_es_segmentEach(line2, function (segment) {
        var doesOverlaps = false;
        if (!segment) {
            return;
        }
        // Iterate over each segments which falls within the same bounds
        line_overlap_dist_es_featureEach(tree.search(segment), function (match) {
            if (doesOverlaps === false) {
                var coordsSegment = line_overlap_dist_es_getCoords(segment).sort();
                var coordsMatch = line_overlap_dist_es_getCoords(match).sort();
                // Segment overlaps feature
                if (equal(coordsSegment, coordsMatch)) {
                    doesOverlaps = true;
                    // Overlaps already exists - only append last coordinate of segment
                    if (overlapSegment)
                        overlapSegment = concatSegment(overlapSegment, segment);
                    else
                        overlapSegment = segment;
                    // Match segments which don't share nodes (Issue #901)
                }
                else if (tolerance === 0
                    ? dist_es_booleanPointOnLine(coordsSegment[0], match) &&
                        dist_es_booleanPointOnLine(coordsSegment[1], match)
                    : line_overlap_dist_es_nearestPointOnLine(match, coordsSegment[0]).properties.dist <=
                        tolerance &&
                        line_overlap_dist_es_nearestPointOnLine(match, coordsSegment[1]).properties.dist <=
                            tolerance) {
                    doesOverlaps = true;
                    if (overlapSegment)
                        overlapSegment = concatSegment(overlapSegment, segment);
                    else
                        overlapSegment = segment;
                }
                else if (tolerance === 0
                    ? dist_es_booleanPointOnLine(coordsMatch[0], segment) &&
                        dist_es_booleanPointOnLine(coordsMatch[1], segment)
                    : line_overlap_dist_es_nearestPointOnLine(segment, coordsMatch[0]).properties.dist <=
                        tolerance &&
                        line_overlap_dist_es_nearestPointOnLine(segment, coordsMatch[1]).properties.dist <=
                            tolerance) {
                    // Do not define (doesOverlap = true) since more matches can occur within the same segment
                    // doesOverlaps = true;
                    if (overlapSegment)
                        overlapSegment = concatSegment(overlapSegment, match);
                    else
                        overlapSegment = match;
                }
            }
        });
        // Segment doesn't overlap - add overlaps to results & reset
        if (doesOverlaps === false && overlapSegment) {
            features.push(overlapSegment);
            overlapSegment = undefined;
        }
    });
    // Add last segment if exists
    if (overlapSegment)
        features.push(overlapSegment);
    return line_overlap_dist_es_featureCollection(features);
}
/**
 * Concat Segment
 *
 * @private
 * @param {Feature<LineString>} line LineString
 * @param {Feature<LineString>} segment 2-vertex LineString
 * @returns {Feature<LineString>} concat linestring
 */
function concatSegment(line, segment) {
    var coords = line_overlap_dist_es_getCoords(segment);
    var lineCoords = line_overlap_dist_es_getCoords(line);
    var start = lineCoords[0];
    var end = lineCoords[lineCoords.length - 1];
    var geom = line.geometry.coordinates;
    if (equal(coords[0], start))
        geom.unshift(coords[1]);
    else if (equal(coords[0], end))
        geom.push(coords[1]);
    else if (equal(coords[1], start))
        geom.unshift(coords[0]);
    else if (equal(coords[1], end))
        geom.push(coords[0]);
    return line;
}
/* harmony default export */ const line_overlap_dist_es = ((/* unused pure expression or super */ null && (lineOverlap)));

;// ../../node_modules/@turf/sector/dist/es/index.js
/* unused harmony import specifier */ var dist_es_circle;
/* unused harmony import specifier */ var es_lineArc;
/* unused harmony import specifier */ var sector_dist_es_coordEach;
/* unused harmony import specifier */ var sector_dist_es_isObject;
/* unused harmony import specifier */ var sector_dist_es_polygon;
/* unused harmony import specifier */ var sector_dist_es_getCoords;






/**
 * Creates a circular sector of a circle of given radius and center {@link Point},
 * between (clockwise) bearing1 and bearing2; 0 bearing is North of center point, positive clockwise.
 *
 * @name sector
 * @param {Coord} center center point
 * @param {number} radius radius of the circle
 * @param {number} bearing1 angle, in decimal degrees, of the first radius of the sector
 * @param {number} bearing2 angle, in decimal degrees, of the second radius of the sector
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] miles, kilometers, degrees, or radians
 * @param {number} [options.steps=64] number of steps
 * @param {Properties} [options.properties={}] Translate properties to Feature Polygon
 * @returns {Feature<Polygon>} sector polygon
 * @example
 * var center = turf.point([-75, 40]);
 * var radius = 5;
 * var bearing1 = 25;
 * var bearing2 = 45;
 *
 * var sector = turf.sector(center, radius, bearing1, bearing2);
 *
 * //addToMap
 * var addToMap = [center, sector];
 */
function sector(center, radius, bearing1, bearing2, options) {
  // Optional parameters
  options = options || {};
  if (!sector_dist_es_isObject(options)) throw new Error("options is invalid");
  var properties = options.properties;

  // validation
  if (!center) throw new Error("center is required");
  if (bearing1 === undefined || bearing1 === null)
    throw new Error("bearing1 is required");
  if (bearing2 === undefined || bearing2 === null)
    throw new Error("bearing2 is required");
  if (!radius) throw new Error("radius is required");
  if (typeof options !== "object") throw new Error("options must be an object");

  if (es_convertAngleTo360(bearing1) === es_convertAngleTo360(bearing2)) {
    return dist_es_circle(center, radius, options);
  }
  var coords = sector_dist_es_getCoords(center);
  var arc = es_lineArc(center, radius, bearing1, bearing2, options);
  var sliceCoords = [[coords]];
  sector_dist_es_coordEach(arc, function (currentCoords) {
    sliceCoords[0].push(currentCoords);
  });
  sliceCoords[0].push(coords);

  return sector_dist_es_polygon(sliceCoords, properties);
}

/**
 * Takes any angle in degrees
 * and returns a valid angle between 0-360 degrees
 *
 * @private
 * @param {number} alfa angle between -180-180 degrees
 * @returns {number} angle between 0-360 degrees
 */
function es_convertAngleTo360(alfa) {
  var beta = alfa % 360;
  if (beta < 0) beta += 360;
  return beta;
}

/* harmony default export */ const sector_dist_es = ((/* unused pure expression or super */ null && (sector)));

;// ../../node_modules/@turf/rhumb-bearing/dist/es/index.js
/* unused harmony import specifier */ var rhumb_bearing_dist_es_degreesToRadians;
/* unused harmony import specifier */ var rhumb_bearing_dist_es_radiansToDegrees;
/* unused harmony import specifier */ var rhumb_bearing_dist_es_getCoord;
// https://en.wikipedia.org/wiki/Rhumb_line


/**
 * Takes two {@link Point|points} and finds the bearing angle between them along a Rhumb line
 * i.e. the angle measured in degrees start the north line (0 degrees)
 *
 * @name rhumbBearing
 * @param {Coord} start starting Point
 * @param {Coord} end ending Point
 * @param {Object} [options] Optional parameters
 * @param {boolean} [options.final=false] calculates the final bearing if true
 * @returns {number} bearing from north in decimal degrees, between -180 and 180 degrees (positive clockwise)
 * @example
 * var point1 = turf.point([-75.343, 39.984], {"marker-color": "#F00"});
 * var point2 = turf.point([-75.534, 39.123], {"marker-color": "#00F"});
 *
 * var bearing = turf.rhumbBearing(point1, point2);
 *
 * //addToMap
 * var addToMap = [point1, point2];
 * point1.properties.bearing = bearing;
 * point2.properties.bearing = bearing;
 */
function rhumbBearing(start, end, options) {
    if (options === void 0) { options = {}; }
    var bear360;
    if (options.final) {
        bear360 = calculateRhumbBearing(rhumb_bearing_dist_es_getCoord(end), rhumb_bearing_dist_es_getCoord(start));
    }
    else {
        bear360 = calculateRhumbBearing(rhumb_bearing_dist_es_getCoord(start), rhumb_bearing_dist_es_getCoord(end));
    }
    var bear180 = bear360 > 180 ? -(360 - bear360) : bear360;
    return bear180;
}
/**
 * Returns the bearing from ‘this’ point to destination point along a rhumb line.
 * Adapted from Geodesy: https://github.com/chrisveness/geodesy/blob/master/latlon-spherical.js
 *
 * @private
 * @param   {Array<number>} from - origin point.
 * @param   {Array<number>} to - destination point.
 * @returns {number} Bearing in degrees from north.
 * @example
 * var p1 = new LatLon(51.127, 1.338);
 * var p2 = new LatLon(50.964, 1.853);
 * var d = p1.rhumbBearingTo(p2); // 116.7 m
 */
function calculateRhumbBearing(from, to) {
    // φ => phi
    // Δλ => deltaLambda
    // Δψ => deltaPsi
    // θ => theta
    var phi1 = rhumb_bearing_dist_es_degreesToRadians(from[1]);
    var phi2 = rhumb_bearing_dist_es_degreesToRadians(to[1]);
    var deltaLambda = rhumb_bearing_dist_es_degreesToRadians(to[0] - from[0]);
    // if deltaLambdaon over 180° take shorter rhumb line across the anti-meridian:
    if (deltaLambda > Math.PI) {
        deltaLambda -= 2 * Math.PI;
    }
    if (deltaLambda < -Math.PI) {
        deltaLambda += 2 * Math.PI;
    }
    var deltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
    var theta = Math.atan2(deltaLambda, deltaPsi);
    return (rhumb_bearing_dist_es_radiansToDegrees(theta) + 360) % 360;
}
/* harmony default export */ const rhumb_bearing_dist_es = ((/* unused pure expression or super */ null && (rhumbBearing)));

;// ../../node_modules/@turf/rhumb-destination/dist/es/index.js
/* unused harmony import specifier */ var rhumb_destination_dist_es_convertLength;
/* unused harmony import specifier */ var rhumb_destination_dist_es_point;
/* unused harmony import specifier */ var dist_es_earthRadius;
/* unused harmony import specifier */ var rhumb_destination_dist_es_degreesToRadians;
/* unused harmony import specifier */ var rhumb_destination_dist_es_getCoord;
// https://en.wikipedia.org/wiki/Rhumb_line


/**
 * Returns the destination {@link Point} having travelled the given distance along a Rhumb line from the
 * origin Point with the (varant) given bearing.
 *
 * @name rhumbDestination
 * @param {Coord} origin starting point
 * @param {number} distance distance from the starting point
 * @param {number} bearing varant bearing angle ranging from -180 to 180 degrees from north
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
 * @param {Object} [options.properties={}] translate properties to destination point
 * @returns {Feature<Point>} Destination point.
 * @example
 * var pt = turf.point([-75.343, 39.984], {"marker-color": "F00"});
 * var distance = 50;
 * var bearing = 90;
 * var options = {units: 'miles'};
 *
 * var destination = turf.rhumbDestination(pt, distance, bearing, options);
 *
 * //addToMap
 * var addToMap = [pt, destination]
 * destination.properties['marker-color'] = '#00F';
 */
function rhumbDestination(origin, distance, bearing, options) {
    if (options === void 0) { options = {}; }
    var wasNegativeDistance = distance < 0;
    var distanceInMeters = rhumb_destination_dist_es_convertLength(Math.abs(distance), options.units, "meters");
    if (wasNegativeDistance)
        distanceInMeters = -Math.abs(distanceInMeters);
    var coords = rhumb_destination_dist_es_getCoord(origin);
    var destination = calculateRhumbDestination(coords, distanceInMeters, bearing);
    // compensate the crossing of the 180th meridian (https://macwright.org/2016/09/26/the-180th-meridian.html)
    // solution from https://github.com/mapbox/mapbox-gl-js/issues/3250#issuecomment-294887678
    destination[0] +=
        destination[0] - coords[0] > 180
            ? -360
            : coords[0] - destination[0] > 180
                ? 360
                : 0;
    return rhumb_destination_dist_es_point(destination, options.properties);
}
/**
 * Returns the destination point having travelled along a rhumb line from origin point the given
 * distance on the  given bearing.
 * Adapted from Geodesy: http://www.movable-type.co.uk/scripts/latlong.html#rhumblines
 *
 * @private
 * @param   {Array<number>} origin - point
 * @param   {number} distance - Distance travelled, in same units as earth radius (default: metres).
 * @param   {number} bearing - Bearing in degrees from north.
 * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
 * @returns {Array<number>} Destination point.
 */
function calculateRhumbDestination(origin, distance, bearing, radius) {
    // φ => phi
    // λ => lambda
    // ψ => psi
    // Δ => Delta
    // δ => delta
    // θ => theta
    radius = radius === undefined ? dist_es_earthRadius : Number(radius);
    var delta = distance / radius; // angular distance in radians
    var lambda1 = (origin[0] * Math.PI) / 180; // to radians, but without normalize to 𝜋
    var phi1 = rhumb_destination_dist_es_degreesToRadians(origin[1]);
    var theta = rhumb_destination_dist_es_degreesToRadians(bearing);
    var DeltaPhi = delta * Math.cos(theta);
    var phi2 = phi1 + DeltaPhi;
    // check for some daft bugger going past the pole, normalise latitude if so
    if (Math.abs(phi2) > Math.PI / 2) {
        phi2 = phi2 > 0 ? Math.PI - phi2 : -Math.PI - phi2;
    }
    var DeltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
    // E-W course becomes ill-conditioned with 0/0
    var q = Math.abs(DeltaPsi) > 10e-12 ? DeltaPhi / DeltaPsi : Math.cos(phi1);
    var DeltaLambda = (delta * Math.sin(theta)) / q;
    var lambda2 = lambda1 + DeltaLambda;
    return [
        (((lambda2 * 180) / Math.PI + 540) % 360) - 180,
        (phi2 * 180) / Math.PI,
    ]; // normalise to −180..+180°
}
/* harmony default export */ const rhumb_destination_dist_es = ((/* unused pure expression or super */ null && (rhumbDestination)));

;// ../../node_modules/@turf/polygon-tangents/dist/es/index.js
/* unused harmony import specifier */ var polygon_tangents_dist_es_getCoords;
/* unused harmony import specifier */ var polygon_tangents_dist_es_getType;
/* unused harmony import specifier */ var polygon_tangents_dist_es_featureCollection;
/* unused harmony import specifier */ var polygon_tangents_dist_es_point;
/* unused harmony import specifier */ var es_calcBbox;
/* unused harmony import specifier */ var dist_es_explode;
/* unused harmony import specifier */ var dist_es_nearestPoint;






/**
 * Finds the tangents of a {@link Polygon|(Multi)Polygon} from a {@link Point}.
 *
 * @name polygonTangents
 * @param {Coord} pt to calculate the tangent points from
 * @param {Feature<Polygon|MultiPolygon>} polygon to get tangents from
 * @returns {FeatureCollection<Point>} Feature Collection containing the two tangent points
 * @example
 * var polygon = turf.polygon([[[11, 0], [22, 4], [31, 0], [31, 11], [21, 15], [11, 11], [11, 0]]]);
 * var point = turf.point([61, 5]);
 *
 * var tangents = turf.polygonTangents(point, polygon)
 *
 * //addToMap
 * var addToMap = [tangents, point, polygon];
 */
function polygonTangents(pt, polygon) {
  var pointCoords = polygon_tangents_dist_es_getCoords(pt);
  var polyCoords = polygon_tangents_dist_es_getCoords(polygon);

  var rtan;
  var ltan;
  var enext;
  var eprev;
  var bbox = es_calcBbox(polygon);
  var nearestPtIndex = 0;
  var nearest = null;

  // If the point lies inside the polygon bbox then we need to be a bit trickier
  // otherwise points lying inside reflex angles on concave polys can have issues
  if (
    pointCoords[0] > bbox[0] &&
    pointCoords[0] < bbox[2] &&
    pointCoords[1] > bbox[1] &&
    pointCoords[1] < bbox[3]
  ) {
    nearest = dist_es_nearestPoint(pt, dist_es_explode(polygon));
    nearestPtIndex = nearest.properties.featureIndex;
  }
  var type = polygon_tangents_dist_es_getType(polygon);
  switch (type) {
    case "Polygon":
      rtan = polyCoords[0][nearestPtIndex];
      ltan = polyCoords[0][0];
      if (nearest !== null) {
        if (nearest.geometry.coordinates[1] < pointCoords[1])
          ltan = polyCoords[0][nearestPtIndex];
      }
      eprev = isLeft(
        polyCoords[0][0],
        polyCoords[0][polyCoords[0].length - 1],
        pointCoords
      );
      var out = es_processPolygon(
        polyCoords[0],
        pointCoords,
        eprev,
        enext,
        rtan,
        ltan);
      rtan = out[0];
      ltan = out[1];
      break;
    case "MultiPolygon":
      var closestFeature = 0;
      var closestVertex = 0;
      var verticesCounted = 0;
      for (var i = 0; i < polyCoords[0].length; i++) {
        closestFeature = i;
        var verticeFound = false;
        for (var i2 = 0; i2 < polyCoords[0][i].length; i2++) {
          closestVertex = i2;
          if (verticesCounted === nearestPtIndex) {
            verticeFound = true;
            break;
          }
          verticesCounted++;
        }
        if (verticeFound) break;
      }
      rtan = polyCoords[0][closestFeature][closestVertex];
      ltan = polyCoords[0][closestFeature][closestVertex];
      eprev = isLeft(
        polyCoords[0][0][0],
        polyCoords[0][0][polyCoords[0][0].length - 1],
        pointCoords
      );
      polyCoords.forEach(function (ring) {
        var out = es_processPolygon(
          ring[0],
          pointCoords,
          eprev,
          enext,
          rtan,
          ltan);
        rtan = out[0];
        ltan = out[1];
      });
      break;
  }
  return polygon_tangents_dist_es_featureCollection([polygon_tangents_dist_es_point(rtan), polygon_tangents_dist_es_point(ltan)]);
}

function es_processPolygon(polygonCoords, ptCoords, eprev, enext, rtan, ltan) {
  for (var i = 0; i < polygonCoords.length; i++) {
    var currentCoords = polygonCoords[i];
    var nextCoordPair = polygonCoords[i + 1];
    if (i === polygonCoords.length - 1) {
      nextCoordPair = polygonCoords[0];
    }
    enext = isLeft(currentCoords, nextCoordPair, ptCoords);
    if (eprev <= 0 && enext > 0) {
      if (!isBelow(ptCoords, currentCoords, rtan)) {
        rtan = currentCoords;
      }
    } else if (eprev > 0 && enext <= 0) {
      if (!isAbove(ptCoords, currentCoords, ltan)) {
        ltan = currentCoords;
      }
    }
    eprev = enext;
  }
  return [rtan, ltan];
}

function isAbove(point1, point2, point3) {
  return isLeft(point1, point2, point3) > 0;
}

function isBelow(point1, point2, point3) {
  return isLeft(point1, point2, point3) < 0;
}

function isLeft(point1, point2, point3) {
  return (
    (point2[0] - point1[0]) * (point3[1] - point1[1]) -
    (point3[0] - point1[0]) * (point2[1] - point1[1])
  );
}

/* harmony default export */ const polygon_tangents_dist_es = ((/* unused pure expression or super */ null && (polygonTangents)));

;// ../../node_modules/@turf/boolean-clockwise/dist/es/index.js
/* unused harmony import specifier */ var boolean_clockwise_dist_es_getCoords;

/**
 * Takes a ring and return true or false whether or not the ring is clockwise or counter-clockwise.
 *
 * @name booleanClockwise
 * @param {Feature<LineString>|LineString|Array<Array<number>>} line to be evaluated
 * @returns {boolean} true/false
 * @example
 * var clockwiseRing = turf.lineString([[0,0],[1,1],[1,0],[0,0]]);
 * var counterClockwiseRing = turf.lineString([[0,0],[1,0],[1,1],[0,0]]);
 *
 * turf.booleanClockwise(clockwiseRing)
 * //=true
 * turf.booleanClockwise(counterClockwiseRing)
 * //=false
 */
function booleanClockwise(line) {
    var ring = boolean_clockwise_dist_es_getCoords(line);
    var sum = 0;
    var i = 1;
    var prev;
    var cur;
    while (i < ring.length) {
        prev = cur || ring[0];
        cur = ring[i];
        sum += (cur[0] - prev[0]) * (cur[1] + prev[1]);
        i++;
    }
    return sum > 0;
}

;// ../../node_modules/@turf/rewind/dist/es/index.js
/* unused harmony import specifier */ var rewind_dist_es_clone;
/* unused harmony import specifier */ var es_booleanClockwise;
/* unused harmony import specifier */ var rewind_dist_es_geomEach;
/* unused harmony import specifier */ var rewind_dist_es_featureEach;
/* unused harmony import specifier */ var rewind_dist_es_getCoords;
/* unused harmony import specifier */ var rewind_dist_es_isObject;
/* unused harmony import specifier */ var rewind_dist_es_featureCollection;






/**
 * Rewind {@link LineString|(Multi)LineString} or {@link Polygon|(Multi)Polygon} outer ring counterclockwise and inner rings clockwise (Uses {@link http://en.wikipedia.org/wiki/Shoelace_formula|Shoelace Formula}).
 *
 * @name rewind
 * @param {GeoJSON} geojson input GeoJSON Polygon
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.reverse=false] enable reverse winding
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} rewind Polygon
 * @example
 * var polygon = turf.polygon([[[121, -29], [138, -29], [138, -18], [121, -18], [121, -29]]]);
 *
 * var rewind = turf.rewind(polygon);
 *
 * //addToMap
 * var addToMap = [rewind];
 */
function rewind(geojson, options) {
  // Optional parameters
  options = options || {};
  if (!rewind_dist_es_isObject(options)) throw new Error("options is invalid");
  var reverse = options.reverse || false;
  var mutate = options.mutate || false;

  // validation
  if (!geojson) throw new Error("<geojson> is required");
  if (typeof reverse !== "boolean")
    throw new Error("<reverse> must be a boolean");
  if (typeof mutate !== "boolean")
    throw new Error("<mutate> must be a boolean");

  // prevent input mutation
  if (mutate === false) geojson = rewind_dist_es_clone(geojson);

  // Support Feature Collection or Geometry Collection
  var results = [];
  switch (geojson.type) {
    case "GeometryCollection":
      rewind_dist_es_geomEach(geojson, function (geometry) {
        rewindFeature(geometry, reverse);
      });
      return geojson;
    case "FeatureCollection":
      rewind_dist_es_featureEach(geojson, function (feature) {
        rewind_dist_es_featureEach(rewindFeature(feature, reverse), function (result) {
          results.push(result);
        });
      });
      return rewind_dist_es_featureCollection(results);
  }
  // Support Feature or Geometry Objects
  return rewindFeature(geojson, reverse);
}

/**
 * Rewind
 *
 * @private
 * @param {Geometry|Feature<any>} geojson Geometry or Feature
 * @param {Boolean} [reverse=false] enable reverse winding
 * @returns {Geometry|Feature<any>} rewind Geometry or Feature
 */
function rewindFeature(geojson, reverse) {
  var type = geojson.type === "Feature" ? geojson.geometry.type : geojson.type;

  // Support all GeoJSON Geometry Objects
  switch (type) {
    case "GeometryCollection":
      rewind_dist_es_geomEach(geojson, function (geometry) {
        rewindFeature(geometry, reverse);
      });
      return geojson;
    case "LineString":
      rewindLineString(rewind_dist_es_getCoords(geojson), reverse);
      return geojson;
    case "Polygon":
      rewindPolygon(rewind_dist_es_getCoords(geojson), reverse);
      return geojson;
    case "MultiLineString":
      rewind_dist_es_getCoords(geojson).forEach(function (lineCoords) {
        rewindLineString(lineCoords, reverse);
      });
      return geojson;
    case "MultiPolygon":
      rewind_dist_es_getCoords(geojson).forEach(function (lineCoords) {
        rewindPolygon(lineCoords, reverse);
      });
      return geojson;
    case "Point":
    case "MultiPoint":
      return geojson;
  }
}

/**
 * Rewind LineString - outer ring clockwise
 *
 * @private
 * @param {Array<Array<number>>} coords GeoJSON LineString geometry coordinates
 * @param {Boolean} [reverse=false] enable reverse winding
 * @returns {void} mutates coordinates
 */
function rewindLineString(coords, reverse) {
  if (es_booleanClockwise(coords) === reverse) coords.reverse();
}

/**
 * Rewind Polygon - outer ring counterclockwise and inner rings clockwise.
 *
 * @private
 * @param {Array<Array<Array<number>>>} coords GeoJSON Polygon geometry coordinates
 * @param {Boolean} [reverse=false] enable reverse winding
 * @returns {void} mutates coordinates
 */
function rewindPolygon(coords, reverse) {
  // outer ring
  if (es_booleanClockwise(coords[0]) !== reverse) {
    coords[0].reverse();
  }
  // inner rings
  for (var i = 1; i < coords.length; i++) {
    if (es_booleanClockwise(coords[i]) === reverse) {
      coords[i].reverse();
    }
  }
}

/* harmony default export */ const rewind_dist_es = ((/* unused pure expression or super */ null && (rewind)));

;// ../../node_modules/@turf/isobands/dist/es/index.js
/* unused harmony import specifier */ var isobands_dist_es_bbox;
/* unused harmony import specifier */ var isobands_dist_es_area;
/* unused harmony import specifier */ var isobands_dist_es_booleanPointInPolygon;
/* unused harmony import specifier */ var isobands_dist_es_explode;
/* unused harmony import specifier */ var dist_es_collectionOf;
/* unused harmony import specifier */ var isobands_dist_es_getCoords;
/* unused harmony import specifier */ var isobands_dist_es_isObject;
/* unused harmony import specifier */ var isobands_dist_es_multiPolygon;
/* unused harmony import specifier */ var isobands_dist_es_featureCollection;
/* unused harmony import specifier */ var isobands_dist_es_polygon;
/* unused harmony import specifier */ var dist_es_objectAssign;
/* unused harmony import specifier */ var isobands_dist_es_featureEach;









/**
 * Takes a {@link Point} grid and returns a correspondent matrix {Array<Array<number>>}
 * of the 'property' values
 *
 * @name gridToMatrix
 * @param {FeatureCollection<Point>} grid of points
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.zProperty='elevation'] the property name in `points` from which z-values will be pulled
 * @param {boolean} [options.flip=false] returns the matrix upside-down
 * @param {boolean} [options.flags=false] flags, adding a `matrixPosition` array field ([row, column]) to its properties,
 * the grid points with coordinates on the matrix
 * @returns {Array<Array<number>>} matrix of property values
 * @example
 *   var extent = [-70.823364, -33.553984, -70.473175, -33.302986];
 *   var cellSize = 3;
 *   var grid = turf.pointGrid(extent, cellSize);
 *   // add a random property to each point between 0 and 60
 *   for (var i = 0; i < grid.features.length; i++) {
 *     grid.features[i].properties.elevation = (Math.random() * 60);
 *   }
 *   gridToMatrix(grid);
 *   //= [
 *     [ 1, 13, 10,  9, 10, 13, 18],
 *     [34,  8,  5,  4,  5,  8, 13],
 *     [10,  5,  2,  1,  2,  5,  4],
 *     [ 0,  4, 56, 19,  1,  4,  9],
 *     [10,  5,  2,  1,  2,  5, 10],
 *     [57,  8,  5,  4,  5,  0, 57],
 *     [ 3, 13, 10,  9,  5, 13, 18],
 *     [18, 13, 10,  9, 78, 13, 18]
 *   ]
 */
function es_gridToMatrix(grid, options) {
  // Optional parameters
  options = options || {};
  if (!isobands_dist_es_isObject(options)) throw new Error("options is invalid");
  var zProperty = options.zProperty || "elevation";
  var flip = options.flip;
  var flags = options.flags;

  // validation
  dist_es_collectionOf(grid, "Point", "input must contain Points");

  var pointsMatrix = es_sortPointsByLatLng(grid, flip);

  var matrix = [];
  // create property matrix from sorted points
  // looping order matters here
  for (var r = 0; r < pointsMatrix.length; r++) {
    var pointRow = pointsMatrix[r];
    var row = [];
    for (var c = 0; c < pointRow.length; c++) {
      var point = pointRow[c];
      // Check if zProperty exist
      if (point.properties[zProperty]) row.push(point.properties[zProperty]);
      else row.push(0);
      // add flags
      if (flags === true) point.properties.matrixPosition = [r, c];
    }
    matrix.push(row);
  }

  return matrix;
}

/**
 * Sorts points by latitude and longitude, creating a 2-dimensional array of points
 *
 * @private
 * @param {FeatureCollection<Point>} points GeoJSON Point features
 * @param {boolean} [flip=false] returns the matrix upside-down
 * @returns {Array<Array<Point>>} points ordered by latitude and longitude
 */
function es_sortPointsByLatLng(points, flip) {
  var pointsByLatitude = {};

  // divide points by rows with the same latitude
  isobands_dist_es_featureEach(points, function (point) {
    var lat = isobands_dist_es_getCoords(point)[1];
    if (!pointsByLatitude[lat]) pointsByLatitude[lat] = [];
    pointsByLatitude[lat].push(point);
  });

  // sort points (with the same latitude) by longitude
  var orderedRowsByLatitude = Object.keys(pointsByLatitude).map(function (lat) {
    var row = pointsByLatitude[lat];
    var rowOrderedByLongitude = row.sort(function (a, b) {
      return isobands_dist_es_getCoords(a)[0] - isobands_dist_es_getCoords(b)[0];
    });
    return rowOrderedByLongitude;
  });

  // sort rows (of points with the same latitude) by latitude
  var pointMatrix = orderedRowsByLatitude.sort(function (a, b) {
    if (flip) return isobands_dist_es_getCoords(a[0])[1] - isobands_dist_es_getCoords(b[0])[1];
    else return isobands_dist_es_getCoords(b[0])[1] - isobands_dist_es_getCoords(a[0])[1];
  });

  return pointMatrix;
}

/*!
 * @license GNU Affero General Public License.
 * Copyright (c) 2015, 2015 Ronny Lorenz <ronny@tbi.univie.ac.at>
 * v. 1.2.0
 * https://github.com/RaumZeit/MarchingSquares.js
 *
 * MarchingSquaresJS is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MarchingSquaresJS is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * As additional permission under GNU Affero General Public License version 3
 * section 7, third-party projects (personal or commercial) may distribute,
 * include, or link against UNMODIFIED VERSIONS of MarchingSquaresJS without the
 * requirement that said third-party project for that reason alone becomes
 * subject to any requirement of the GNU Affero General Public License version 3.
 * Any modifications to MarchingSquaresJS, however, must be shared with the public
 * and made available.
 *
 * In summary this:
 * - allows you to use MarchingSquaresJS at no cost
 * - allows you to use MarchingSquaresJS for both personal and commercial purposes
 * - allows you to distribute UNMODIFIED VERSIONS of MarchingSquaresJS under any
 *   license as long as this license notice is included
 * - enables you to keep the source code of your program that uses MarchingSquaresJS
 *   undisclosed
 * - forces you to share any modifications you have made to MarchingSquaresJS,
 *   e.g. bug-fixes
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with MarchingSquaresJS.  If not, see <http://www.gnu.org/licenses/>.
 */
var es_defaultSettings = {
  successCallback: null,
  verbose: false,
  polygons: false,
};

var es_settings = {};

/*
  Compute isobands(s) of a scalar 2D field given a certain
  threshold and a bandwidth by applying the Marching Squares
  Algorithm. The function returns a list of path coordinates
  either for individual polygons within each grid cell, or the
  outline of connected polygons.
*/
function isoBands(data, minV, bandwidth, options) {
  /* process options */
  options = options ? options : {};

  var optionKeys = Object.keys(es_defaultSettings);

  for (var i = 0; i < optionKeys.length; i++) {
    var key = optionKeys[i];
    var val = options[key];
    val =
      typeof val !== "undefined" && val !== null ? val : es_defaultSettings[key];

    es_settings[key] = val;
  }

  if (es_settings.verbose)
    console.log(
      "MarchingSquaresJS-isoBands: computing isobands for [" +
        minV +
        ":" +
        (minV + bandwidth) +
        "]"
    );

  var grid = computeBandGrid(data, minV, bandwidth);

  var ret;
  if (es_settings.polygons) {
    if (es_settings.verbose)
      console.log(
        "MarchingSquaresJS-isoBands: returning single polygons for each grid cell"
      );
    ret = BandGrid2Areas(grid);
  } else {
    if (es_settings.verbose)
      console.log(
        "MarchingSquaresJS-isoBands: returning polygon paths for entire data grid"
      );
    ret = BandGrid2AreaPaths(grid);
  }

  if (typeof es_settings.successCallback === "function")
    es_settings.successCallback(ret);

  return ret;
}

/*
  Thats all for the public interface, below follows the actual
  implementation
*/

/* Some private variables */
var Node0 = 64,
  Node1 = 16,
  Node2 = 4,
  Node3 = 1;

/*
  The look-up tables for tracing back the contour path
  of isoBands
*/

var isoBandNextXTL = [];
var isoBandNextYTL = [];
var isoBandNextOTL = [];

var isoBandNextXTR = [];
var isoBandNextYTR = [];
var isoBandNextOTR = [];

var isoBandNextXRT = [];
var isoBandNextYRT = [];
var isoBandNextORT = [];

var isoBandNextXRB = [];
var isoBandNextYRB = [];
var isoBandNextORB = [];

var isoBandNextXBL = [];
var isoBandNextYBL = [];
var isoBandNextOBL = [];

var isoBandNextXBR = [];
var isoBandNextYBR = [];
var isoBandNextOBR = [];

var isoBandNextXLT = [];
var isoBandNextYLT = [];
var isoBandNextOLT = [];

var isoBandNextXLB = [];
var isoBandNextYLB = [];
var isoBandNextOLB = [];

isoBandNextXRT[85] = isoBandNextXRB[85] = -1;
isoBandNextYRT[85] = isoBandNextYRB[85] = 0;
isoBandNextORT[85] = isoBandNextORB[85] = 1;
isoBandNextXLT[85] = isoBandNextXLB[85] = 1;
isoBandNextYLT[85] = isoBandNextYLB[85] = 0;
isoBandNextOLT[85] = isoBandNextOLB[85] = 1;

isoBandNextXTL[85] = isoBandNextXTR[85] = 0;
isoBandNextYTL[85] = isoBandNextYTR[85] = -1;
isoBandNextOTL[85] = isoBandNextOBL[85] = 0;
isoBandNextXBR[85] = isoBandNextXBL[85] = 0;
isoBandNextYBR[85] = isoBandNextYBL[85] = 1;
isoBandNextOTR[85] = isoBandNextOBR[85] = 1;

/* triangle cases */
isoBandNextXLB[1] = isoBandNextXLB[169] = 0;
isoBandNextYLB[1] = isoBandNextYLB[169] = -1;
isoBandNextOLB[1] = isoBandNextOLB[169] = 0;
isoBandNextXBL[1] = isoBandNextXBL[169] = -1;
isoBandNextYBL[1] = isoBandNextYBL[169] = 0;
isoBandNextOBL[1] = isoBandNextOBL[169] = 0;

isoBandNextXRB[4] = isoBandNextXRB[166] = 0;
isoBandNextYRB[4] = isoBandNextYRB[166] = -1;
isoBandNextORB[4] = isoBandNextORB[166] = 1;
isoBandNextXBR[4] = isoBandNextXBR[166] = 1;
isoBandNextYBR[4] = isoBandNextYBR[166] = 0;
isoBandNextOBR[4] = isoBandNextOBR[166] = 0;

isoBandNextXRT[16] = isoBandNextXRT[154] = 0;
isoBandNextYRT[16] = isoBandNextYRT[154] = 1;
isoBandNextORT[16] = isoBandNextORT[154] = 1;
isoBandNextXTR[16] = isoBandNextXTR[154] = 1;
isoBandNextYTR[16] = isoBandNextYTR[154] = 0;
isoBandNextOTR[16] = isoBandNextOTR[154] = 1;

isoBandNextXLT[64] = isoBandNextXLT[106] = 0;
isoBandNextYLT[64] = isoBandNextYLT[106] = 1;
isoBandNextOLT[64] = isoBandNextOLT[106] = 0;
isoBandNextXTL[64] = isoBandNextXTL[106] = -1;
isoBandNextYTL[64] = isoBandNextYTL[106] = 0;
isoBandNextOTL[64] = isoBandNextOTL[106] = 1;

/* single trapezoid cases */
isoBandNextXLT[2] = isoBandNextXLT[168] = 0;
isoBandNextYLT[2] = isoBandNextYLT[168] = -1;
isoBandNextOLT[2] = isoBandNextOLT[168] = 1;
isoBandNextXLB[2] = isoBandNextXLB[168] = 0;
isoBandNextYLB[2] = isoBandNextYLB[168] = -1;
isoBandNextOLB[2] = isoBandNextOLB[168] = 0;
isoBandNextXBL[2] = isoBandNextXBL[168] = -1;
isoBandNextYBL[2] = isoBandNextYBL[168] = 0;
isoBandNextOBL[2] = isoBandNextOBL[168] = 0;
isoBandNextXBR[2] = isoBandNextXBR[168] = -1;
isoBandNextYBR[2] = isoBandNextYBR[168] = 0;
isoBandNextOBR[2] = isoBandNextOBR[168] = 1;

isoBandNextXRT[8] = isoBandNextXRT[162] = 0;
isoBandNextYRT[8] = isoBandNextYRT[162] = -1;
isoBandNextORT[8] = isoBandNextORT[162] = 0;
isoBandNextXRB[8] = isoBandNextXRB[162] = 0;
isoBandNextYRB[8] = isoBandNextYRB[162] = -1;
isoBandNextORB[8] = isoBandNextORB[162] = 1;
isoBandNextXBL[8] = isoBandNextXBL[162] = 1;
isoBandNextYBL[8] = isoBandNextYBL[162] = 0;
isoBandNextOBL[8] = isoBandNextOBL[162] = 1;
isoBandNextXBR[8] = isoBandNextXBR[162] = 1;
isoBandNextYBR[8] = isoBandNextYBR[162] = 0;
isoBandNextOBR[8] = isoBandNextOBR[162] = 0;

isoBandNextXRT[32] = isoBandNextXRT[138] = 0;
isoBandNextYRT[32] = isoBandNextYRT[138] = 1;
isoBandNextORT[32] = isoBandNextORT[138] = 1;
isoBandNextXRB[32] = isoBandNextXRB[138] = 0;
isoBandNextYRB[32] = isoBandNextYRB[138] = 1;
isoBandNextORB[32] = isoBandNextORB[138] = 0;
isoBandNextXTL[32] = isoBandNextXTL[138] = 1;
isoBandNextYTL[32] = isoBandNextYTL[138] = 0;
isoBandNextOTL[32] = isoBandNextOTL[138] = 0;
isoBandNextXTR[32] = isoBandNextXTR[138] = 1;
isoBandNextYTR[32] = isoBandNextYTR[138] = 0;
isoBandNextOTR[32] = isoBandNextOTR[138] = 1;

isoBandNextXLB[128] = isoBandNextXLB[42] = 0;
isoBandNextYLB[128] = isoBandNextYLB[42] = 1;
isoBandNextOLB[128] = isoBandNextOLB[42] = 1;
isoBandNextXLT[128] = isoBandNextXLT[42] = 0;
isoBandNextYLT[128] = isoBandNextYLT[42] = 1;
isoBandNextOLT[128] = isoBandNextOLT[42] = 0;
isoBandNextXTL[128] = isoBandNextXTL[42] = -1;
isoBandNextYTL[128] = isoBandNextYTL[42] = 0;
isoBandNextOTL[128] = isoBandNextOTL[42] = 1;
isoBandNextXTR[128] = isoBandNextXTR[42] = -1;
isoBandNextYTR[128] = isoBandNextYTR[42] = 0;
isoBandNextOTR[128] = isoBandNextOTR[42] = 0;

/* single rectangle cases */
isoBandNextXRB[5] = isoBandNextXRB[165] = -1;
isoBandNextYRB[5] = isoBandNextYRB[165] = 0;
isoBandNextORB[5] = isoBandNextORB[165] = 0;
isoBandNextXLB[5] = isoBandNextXLB[165] = 1;
isoBandNextYLB[5] = isoBandNextYLB[165] = 0;
isoBandNextOLB[5] = isoBandNextOLB[165] = 0;

isoBandNextXBR[20] = isoBandNextXBR[150] = 0;
isoBandNextYBR[20] = isoBandNextYBR[150] = 1;
isoBandNextOBR[20] = isoBandNextOBR[150] = 1;
isoBandNextXTR[20] = isoBandNextXTR[150] = 0;
isoBandNextYTR[20] = isoBandNextYTR[150] = -1;
isoBandNextOTR[20] = isoBandNextOTR[150] = 1;

isoBandNextXRT[80] = isoBandNextXRT[90] = -1;
isoBandNextYRT[80] = isoBandNextYRT[90] = 0;
isoBandNextORT[80] = isoBandNextORT[90] = 1;
isoBandNextXLT[80] = isoBandNextXLT[90] = 1;
isoBandNextYLT[80] = isoBandNextYLT[90] = 0;
isoBandNextOLT[80] = isoBandNextOLT[90] = 1;

isoBandNextXBL[65] = isoBandNextXBL[105] = 0;
isoBandNextYBL[65] = isoBandNextYBL[105] = 1;
isoBandNextOBL[65] = isoBandNextOBL[105] = 0;
isoBandNextXTL[65] = isoBandNextXTL[105] = 0;
isoBandNextYTL[65] = isoBandNextYTL[105] = -1;
isoBandNextOTL[65] = isoBandNextOTL[105] = 0;

isoBandNextXRT[160] = isoBandNextXRT[10] = -1;
isoBandNextYRT[160] = isoBandNextYRT[10] = 0;
isoBandNextORT[160] = isoBandNextORT[10] = 1;
isoBandNextXRB[160] = isoBandNextXRB[10] = -1;
isoBandNextYRB[160] = isoBandNextYRB[10] = 0;
isoBandNextORB[160] = isoBandNextORB[10] = 0;
isoBandNextXLB[160] = isoBandNextXLB[10] = 1;
isoBandNextYLB[160] = isoBandNextYLB[10] = 0;
isoBandNextOLB[160] = isoBandNextOLB[10] = 0;
isoBandNextXLT[160] = isoBandNextXLT[10] = 1;
isoBandNextYLT[160] = isoBandNextYLT[10] = 0;
isoBandNextOLT[160] = isoBandNextOLT[10] = 1;

isoBandNextXBR[130] = isoBandNextXBR[40] = 0;
isoBandNextYBR[130] = isoBandNextYBR[40] = 1;
isoBandNextOBR[130] = isoBandNextOBR[40] = 1;
isoBandNextXBL[130] = isoBandNextXBL[40] = 0;
isoBandNextYBL[130] = isoBandNextYBL[40] = 1;
isoBandNextOBL[130] = isoBandNextOBL[40] = 0;
isoBandNextXTL[130] = isoBandNextXTL[40] = 0;
isoBandNextYTL[130] = isoBandNextYTL[40] = -1;
isoBandNextOTL[130] = isoBandNextOTL[40] = 0;
isoBandNextXTR[130] = isoBandNextXTR[40] = 0;
isoBandNextYTR[130] = isoBandNextYTR[40] = -1;
isoBandNextOTR[130] = isoBandNextOTR[40] = 1;

/* single hexagon cases */
isoBandNextXRB[37] = isoBandNextXRB[133] = 0;
isoBandNextYRB[37] = isoBandNextYRB[133] = 1;
isoBandNextORB[37] = isoBandNextORB[133] = 1;
isoBandNextXLB[37] = isoBandNextXLB[133] = 0;
isoBandNextYLB[37] = isoBandNextYLB[133] = 1;
isoBandNextOLB[37] = isoBandNextOLB[133] = 0;
isoBandNextXTL[37] = isoBandNextXTL[133] = -1;
isoBandNextYTL[37] = isoBandNextYTL[133] = 0;
isoBandNextOTL[37] = isoBandNextOTL[133] = 0;
isoBandNextXTR[37] = isoBandNextXTR[133] = 1;
isoBandNextYTR[37] = isoBandNextYTR[133] = 0;
isoBandNextOTR[37] = isoBandNextOTR[133] = 0;

isoBandNextXBR[148] = isoBandNextXBR[22] = -1;
isoBandNextYBR[148] = isoBandNextYBR[22] = 0;
isoBandNextOBR[148] = isoBandNextOBR[22] = 0;
isoBandNextXLB[148] = isoBandNextXLB[22] = 0;
isoBandNextYLB[148] = isoBandNextYLB[22] = -1;
isoBandNextOLB[148] = isoBandNextOLB[22] = 1;
isoBandNextXLT[148] = isoBandNextXLT[22] = 0;
isoBandNextYLT[148] = isoBandNextYLT[22] = 1;
isoBandNextOLT[148] = isoBandNextOLT[22] = 1;
isoBandNextXTR[148] = isoBandNextXTR[22] = -1;
isoBandNextYTR[148] = isoBandNextYTR[22] = 0;
isoBandNextOTR[148] = isoBandNextOTR[22] = 1;

isoBandNextXRT[82] = isoBandNextXRT[88] = 0;
isoBandNextYRT[82] = isoBandNextYRT[88] = -1;
isoBandNextORT[82] = isoBandNextORT[88] = 1;
isoBandNextXBR[82] = isoBandNextXBR[88] = 1;
isoBandNextYBR[82] = isoBandNextYBR[88] = 0;
isoBandNextOBR[82] = isoBandNextOBR[88] = 1;
isoBandNextXBL[82] = isoBandNextXBL[88] = -1;
isoBandNextYBL[82] = isoBandNextYBL[88] = 0;
isoBandNextOBL[82] = isoBandNextOBL[88] = 1;
isoBandNextXLT[82] = isoBandNextXLT[88] = 0;
isoBandNextYLT[82] = isoBandNextYLT[88] = -1;
isoBandNextOLT[82] = isoBandNextOLT[88] = 0;

isoBandNextXRT[73] = isoBandNextXRT[97] = 0;
isoBandNextYRT[73] = isoBandNextYRT[97] = 1;
isoBandNextORT[73] = isoBandNextORT[97] = 0;
isoBandNextXRB[73] = isoBandNextXRB[97] = 0;
isoBandNextYRB[73] = isoBandNextYRB[97] = -1;
isoBandNextORB[73] = isoBandNextORB[97] = 0;
isoBandNextXBL[73] = isoBandNextXBL[97] = 1;
isoBandNextYBL[73] = isoBandNextYBL[97] = 0;
isoBandNextOBL[73] = isoBandNextOBL[97] = 0;
isoBandNextXTL[73] = isoBandNextXTL[97] = 1;
isoBandNextYTL[73] = isoBandNextYTL[97] = 0;
isoBandNextOTL[73] = isoBandNextOTL[97] = 1;

isoBandNextXRT[145] = isoBandNextXRT[25] = 0;
isoBandNextYRT[145] = isoBandNextYRT[25] = -1;
isoBandNextORT[145] = isoBandNextORT[25] = 0;
isoBandNextXBL[145] = isoBandNextXBL[25] = 1;
isoBandNextYBL[145] = isoBandNextYBL[25] = 0;
isoBandNextOBL[145] = isoBandNextOBL[25] = 1;
isoBandNextXLB[145] = isoBandNextXLB[25] = 0;
isoBandNextYLB[145] = isoBandNextYLB[25] = 1;
isoBandNextOLB[145] = isoBandNextOLB[25] = 1;
isoBandNextXTR[145] = isoBandNextXTR[25] = -1;
isoBandNextYTR[145] = isoBandNextYTR[25] = 0;
isoBandNextOTR[145] = isoBandNextOTR[25] = 0;

isoBandNextXRB[70] = isoBandNextXRB[100] = 0;
isoBandNextYRB[70] = isoBandNextYRB[100] = 1;
isoBandNextORB[70] = isoBandNextORB[100] = 0;
isoBandNextXBR[70] = isoBandNextXBR[100] = -1;
isoBandNextYBR[70] = isoBandNextYBR[100] = 0;
isoBandNextOBR[70] = isoBandNextOBR[100] = 1;
isoBandNextXLT[70] = isoBandNextXLT[100] = 0;
isoBandNextYLT[70] = isoBandNextYLT[100] = -1;
isoBandNextOLT[70] = isoBandNextOLT[100] = 1;
isoBandNextXTL[70] = isoBandNextXTL[100] = 1;
isoBandNextYTL[70] = isoBandNextYTL[100] = 0;
isoBandNextOTL[70] = isoBandNextOTL[100] = 0;

/* single pentagon cases */
isoBandNextXRB[101] = isoBandNextXRB[69] = 0;
isoBandNextYRB[101] = isoBandNextYRB[69] = 1;
isoBandNextORB[101] = isoBandNextORB[69] = 0;
isoBandNextXTL[101] = isoBandNextXTL[69] = 1;
isoBandNextYTL[101] = isoBandNextYTL[69] = 0;
isoBandNextOTL[101] = isoBandNextOTL[69] = 0;

isoBandNextXLB[149] = isoBandNextXLB[21] = 0;
isoBandNextYLB[149] = isoBandNextYLB[21] = 1;
isoBandNextOLB[149] = isoBandNextOLB[21] = 1;
isoBandNextXTR[149] = isoBandNextXTR[21] = -1;
isoBandNextYTR[149] = isoBandNextYTR[21] = 0;
isoBandNextOTR[149] = isoBandNextOTR[21] = 0;

isoBandNextXBR[86] = isoBandNextXBR[84] = -1;
isoBandNextYBR[86] = isoBandNextYBR[84] = 0;
isoBandNextOBR[86] = isoBandNextOBR[84] = 1;
isoBandNextXLT[86] = isoBandNextXLT[84] = 0;
isoBandNextYLT[86] = isoBandNextYLT[84] = -1;
isoBandNextOLT[86] = isoBandNextOLT[84] = 1;

isoBandNextXRT[89] = isoBandNextXRT[81] = 0;
isoBandNextYRT[89] = isoBandNextYRT[81] = -1;
isoBandNextORT[89] = isoBandNextORT[81] = 0;
isoBandNextXBL[89] = isoBandNextXBL[81] = 1;
isoBandNextYBL[89] = isoBandNextYBL[81] = 0;
isoBandNextOBL[89] = isoBandNextOBL[81] = 1;

isoBandNextXRT[96] = isoBandNextXRT[74] = 0;
isoBandNextYRT[96] = isoBandNextYRT[74] = 1;
isoBandNextORT[96] = isoBandNextORT[74] = 0;
isoBandNextXRB[96] = isoBandNextXRB[74] = -1;
isoBandNextYRB[96] = isoBandNextYRB[74] = 0;
isoBandNextORB[96] = isoBandNextORB[74] = 1;
isoBandNextXLT[96] = isoBandNextXLT[74] = 1;
isoBandNextYLT[96] = isoBandNextYLT[74] = 0;
isoBandNextOLT[96] = isoBandNextOLT[74] = 0;
isoBandNextXTL[96] = isoBandNextXTL[74] = 1;
isoBandNextYTL[96] = isoBandNextYTL[74] = 0;
isoBandNextOTL[96] = isoBandNextOTL[74] = 1;

isoBandNextXRT[24] = isoBandNextXRT[146] = 0;
isoBandNextYRT[24] = isoBandNextYRT[146] = -1;
isoBandNextORT[24] = isoBandNextORT[146] = 1;
isoBandNextXBR[24] = isoBandNextXBR[146] = 1;
isoBandNextYBR[24] = isoBandNextYBR[146] = 0;
isoBandNextOBR[24] = isoBandNextOBR[146] = 1;
isoBandNextXBL[24] = isoBandNextXBL[146] = 0;
isoBandNextYBL[24] = isoBandNextYBL[146] = 1;
isoBandNextOBL[24] = isoBandNextOBL[146] = 1;
isoBandNextXTR[24] = isoBandNextXTR[146] = 0;
isoBandNextYTR[24] = isoBandNextYTR[146] = -1;
isoBandNextOTR[24] = isoBandNextOTR[146] = 0;

isoBandNextXRB[6] = isoBandNextXRB[164] = -1;
isoBandNextYRB[6] = isoBandNextYRB[164] = 0;
isoBandNextORB[6] = isoBandNextORB[164] = 1;
isoBandNextXBR[6] = isoBandNextXBR[164] = -1;
isoBandNextYBR[6] = isoBandNextYBR[164] = 0;
isoBandNextOBR[6] = isoBandNextOBR[164] = 0;
isoBandNextXLB[6] = isoBandNextXLB[164] = 0;
isoBandNextYLB[6] = isoBandNextYLB[164] = -1;
isoBandNextOLB[6] = isoBandNextOLB[164] = 1;
isoBandNextXLT[6] = isoBandNextXLT[164] = 1;
isoBandNextYLT[6] = isoBandNextYLT[164] = 0;
isoBandNextOLT[6] = isoBandNextOLT[164] = 0;

isoBandNextXBL[129] = isoBandNextXBL[41] = 0;
isoBandNextYBL[129] = isoBandNextYBL[41] = 1;
isoBandNextOBL[129] = isoBandNextOBL[41] = 1;
isoBandNextXLB[129] = isoBandNextXLB[41] = 0;
isoBandNextYLB[129] = isoBandNextYLB[41] = 1;
isoBandNextOLB[129] = isoBandNextOLB[41] = 0;
isoBandNextXTL[129] = isoBandNextXTL[41] = -1;
isoBandNextYTL[129] = isoBandNextYTL[41] = 0;
isoBandNextOTL[129] = isoBandNextOTL[41] = 0;
isoBandNextXTR[129] = isoBandNextXTR[41] = 0;
isoBandNextYTR[129] = isoBandNextYTR[41] = -1;
isoBandNextOTR[129] = isoBandNextOTR[41] = 0;

isoBandNextXBR[66] = isoBandNextXBR[104] = 0;
isoBandNextYBR[66] = isoBandNextYBR[104] = 1;
isoBandNextOBR[66] = isoBandNextOBR[104] = 0;
isoBandNextXBL[66] = isoBandNextXBL[104] = -1;
isoBandNextYBL[66] = isoBandNextYBL[104] = 0;
isoBandNextOBL[66] = isoBandNextOBL[104] = 1;
isoBandNextXLT[66] = isoBandNextXLT[104] = 0;
isoBandNextYLT[66] = isoBandNextYLT[104] = -1;
isoBandNextOLT[66] = isoBandNextOLT[104] = 0;
isoBandNextXTL[66] = isoBandNextXTL[104] = 0;
isoBandNextYTL[66] = isoBandNextYTL[104] = -1;
isoBandNextOTL[66] = isoBandNextOTL[104] = 1;

isoBandNextXRT[144] = isoBandNextXRT[26] = -1;
isoBandNextYRT[144] = isoBandNextYRT[26] = 0;
isoBandNextORT[144] = isoBandNextORT[26] = 0;
isoBandNextXLB[144] = isoBandNextXLB[26] = 1;
isoBandNextYLB[144] = isoBandNextYLB[26] = 0;
isoBandNextOLB[144] = isoBandNextOLB[26] = 1;
isoBandNextXLT[144] = isoBandNextXLT[26] = 0;
isoBandNextYLT[144] = isoBandNextYLT[26] = 1;
isoBandNextOLT[144] = isoBandNextOLT[26] = 1;
isoBandNextXTR[144] = isoBandNextXTR[26] = -1;
isoBandNextYTR[144] = isoBandNextYTR[26] = 0;
isoBandNextOTR[144] = isoBandNextOTR[26] = 1;

isoBandNextXRB[36] = isoBandNextXRB[134] = 0;
isoBandNextYRB[36] = isoBandNextYRB[134] = 1;
isoBandNextORB[36] = isoBandNextORB[134] = 1;
isoBandNextXBR[36] = isoBandNextXBR[134] = 0;
isoBandNextYBR[36] = isoBandNextYBR[134] = 1;
isoBandNextOBR[36] = isoBandNextOBR[134] = 0;
isoBandNextXTL[36] = isoBandNextXTL[134] = 0;
isoBandNextYTL[36] = isoBandNextYTL[134] = -1;
isoBandNextOTL[36] = isoBandNextOTL[134] = 1;
isoBandNextXTR[36] = isoBandNextXTR[134] = 1;
isoBandNextYTR[36] = isoBandNextYTR[134] = 0;
isoBandNextOTR[36] = isoBandNextOTR[134] = 0;

isoBandNextXRT[9] = isoBandNextXRT[161] = -1;
isoBandNextYRT[9] = isoBandNextYRT[161] = 0;
isoBandNextORT[9] = isoBandNextORT[161] = 0;
isoBandNextXRB[9] = isoBandNextXRB[161] = 0;
isoBandNextYRB[9] = isoBandNextYRB[161] = -1;
isoBandNextORB[9] = isoBandNextORB[161] = 0;
isoBandNextXBL[9] = isoBandNextXBL[161] = 1;
isoBandNextYBL[9] = isoBandNextYBL[161] = 0;
isoBandNextOBL[9] = isoBandNextOBL[161] = 0;
isoBandNextXLB[9] = isoBandNextXLB[161] = 1;
isoBandNextYLB[9] = isoBandNextYLB[161] = 0;
isoBandNextOLB[9] = isoBandNextOLB[161] = 1;

/* 8-sided cases */
isoBandNextXRT[136] = 0;
isoBandNextYRT[136] = 1;
isoBandNextORT[136] = 1;
isoBandNextXRB[136] = 0;
isoBandNextYRB[136] = 1;
isoBandNextORB[136] = 0;
isoBandNextXBR[136] = -1;
isoBandNextYBR[136] = 0;
isoBandNextOBR[136] = 1;
isoBandNextXBL[136] = -1;
isoBandNextYBL[136] = 0;
isoBandNextOBL[136] = 0;
isoBandNextXLB[136] = 0;
isoBandNextYLB[136] = -1;
isoBandNextOLB[136] = 0;
isoBandNextXLT[136] = 0;
isoBandNextYLT[136] = -1;
isoBandNextOLT[136] = 1;
isoBandNextXTL[136] = 1;
isoBandNextYTL[136] = 0;
isoBandNextOTL[136] = 0;
isoBandNextXTR[136] = 1;
isoBandNextYTR[136] = 0;
isoBandNextOTR[136] = 1;

isoBandNextXRT[34] = 0;
isoBandNextYRT[34] = -1;
isoBandNextORT[34] = 0;
isoBandNextXRB[34] = 0;
isoBandNextYRB[34] = -1;
isoBandNextORB[34] = 1;
isoBandNextXBR[34] = 1;
isoBandNextYBR[34] = 0;
isoBandNextOBR[34] = 0;
isoBandNextXBL[34] = 1;
isoBandNextYBL[34] = 0;
isoBandNextOBL[34] = 1;
isoBandNextXLB[34] = 0;
isoBandNextYLB[34] = 1;
isoBandNextOLB[34] = 1;
isoBandNextXLT[34] = 0;
isoBandNextYLT[34] = 1;
isoBandNextOLT[34] = 0;
isoBandNextXTL[34] = -1;
isoBandNextYTL[34] = 0;
isoBandNextOTL[34] = 1;
isoBandNextXTR[34] = -1;
isoBandNextYTR[34] = 0;
isoBandNextOTR[34] = 0;

isoBandNextXRT[35] = 0;
isoBandNextYRT[35] = 1;
isoBandNextORT[35] = 1;
isoBandNextXRB[35] = 0;
isoBandNextYRB[35] = -1;
isoBandNextORB[35] = 1;
isoBandNextXBR[35] = 1;
isoBandNextYBR[35] = 0;
isoBandNextOBR[35] = 0;
isoBandNextXBL[35] = -1;
isoBandNextYBL[35] = 0;
isoBandNextOBL[35] = 0;
isoBandNextXLB[35] = 0;
isoBandNextYLB[35] = -1;
isoBandNextOLB[35] = 0;
isoBandNextXLT[35] = 0;
isoBandNextYLT[35] = 1;
isoBandNextOLT[35] = 0;
isoBandNextXTL[35] = -1;
isoBandNextYTL[35] = 0;
isoBandNextOTL[35] = 1;
isoBandNextXTR[35] = 1;
isoBandNextYTR[35] = 0;
isoBandNextOTR[35] = 1;

/* 6-sided cases */
isoBandNextXRT[153] = 0;
isoBandNextYRT[153] = 1;
isoBandNextORT[153] = 1;
isoBandNextXBL[153] = -1;
isoBandNextYBL[153] = 0;
isoBandNextOBL[153] = 0;
isoBandNextXLB[153] = 0;
isoBandNextYLB[153] = -1;
isoBandNextOLB[153] = 0;
isoBandNextXTR[153] = 1;
isoBandNextYTR[153] = 0;
isoBandNextOTR[153] = 1;

isoBandNextXRB[102] = 0;
isoBandNextYRB[102] = -1;
isoBandNextORB[102] = 1;
isoBandNextXBR[102] = 1;
isoBandNextYBR[102] = 0;
isoBandNextOBR[102] = 0;
isoBandNextXLT[102] = 0;
isoBandNextYLT[102] = 1;
isoBandNextOLT[102] = 0;
isoBandNextXTL[102] = -1;
isoBandNextYTL[102] = 0;
isoBandNextOTL[102] = 1;

isoBandNextXRT[155] = 0;
isoBandNextYRT[155] = -1;
isoBandNextORT[155] = 0;
isoBandNextXBL[155] = 1;
isoBandNextYBL[155] = 0;
isoBandNextOBL[155] = 1;
isoBandNextXLB[155] = 0;
isoBandNextYLB[155] = 1;
isoBandNextOLB[155] = 1;
isoBandNextXTR[155] = -1;
isoBandNextYTR[155] = 0;
isoBandNextOTR[155] = 0;

isoBandNextXRB[103] = 0;
isoBandNextYRB[103] = 1;
isoBandNextORB[103] = 0;
isoBandNextXBR[103] = -1;
isoBandNextYBR[103] = 0;
isoBandNextOBR[103] = 1;
isoBandNextXLT[103] = 0;
isoBandNextYLT[103] = -1;
isoBandNextOLT[103] = 1;
isoBandNextXTL[103] = 1;
isoBandNextYTL[103] = 0;
isoBandNextOTL[103] = 0;

/* 7-sided cases */
isoBandNextXRT[152] = 0;
isoBandNextYRT[152] = 1;
isoBandNextORT[152] = 1;
isoBandNextXBR[152] = -1;
isoBandNextYBR[152] = 0;
isoBandNextOBR[152] = 1;
isoBandNextXBL[152] = -1;
isoBandNextYBL[152] = 0;
isoBandNextOBL[152] = 0;
isoBandNextXLB[152] = 0;
isoBandNextYLB[152] = -1;
isoBandNextOLB[152] = 0;
isoBandNextXLT[152] = 0;
isoBandNextYLT[152] = -1;
isoBandNextOLT[152] = 1;
isoBandNextXTR[152] = 1;
isoBandNextYTR[152] = 0;
isoBandNextOTR[152] = 1;

isoBandNextXRT[156] = 0;
isoBandNextYRT[156] = -1;
isoBandNextORT[156] = 1;
isoBandNextXBR[156] = 1;
isoBandNextYBR[156] = 0;
isoBandNextOBR[156] = 1;
isoBandNextXBL[156] = -1;
isoBandNextYBL[156] = 0;
isoBandNextOBL[156] = 0;
isoBandNextXLB[156] = 0;
isoBandNextYLB[156] = -1;
isoBandNextOLB[156] = 0;
isoBandNextXLT[156] = 0;
isoBandNextYLT[156] = 1;
isoBandNextOLT[156] = 1;
isoBandNextXTR[156] = -1;
isoBandNextYTR[156] = 0;
isoBandNextOTR[156] = 1;

isoBandNextXRT[137] = 0;
isoBandNextYRT[137] = 1;
isoBandNextORT[137] = 1;
isoBandNextXRB[137] = 0;
isoBandNextYRB[137] = 1;
isoBandNextORB[137] = 0;
isoBandNextXBL[137] = -1;
isoBandNextYBL[137] = 0;
isoBandNextOBL[137] = 0;
isoBandNextXLB[137] = 0;
isoBandNextYLB[137] = -1;
isoBandNextOLB[137] = 0;
isoBandNextXTL[137] = 1;
isoBandNextYTL[137] = 0;
isoBandNextOTL[137] = 0;
isoBandNextXTR[137] = 1;
isoBandNextYTR[137] = 0;
isoBandNextOTR[137] = 1;

isoBandNextXRT[139] = 0;
isoBandNextYRT[139] = 1;
isoBandNextORT[139] = 1;
isoBandNextXRB[139] = 0;
isoBandNextYRB[139] = -1;
isoBandNextORB[139] = 0;
isoBandNextXBL[139] = 1;
isoBandNextYBL[139] = 0;
isoBandNextOBL[139] = 0;
isoBandNextXLB[139] = 0;
isoBandNextYLB[139] = 1;
isoBandNextOLB[139] = 0;
isoBandNextXTL[139] = -1;
isoBandNextYTL[139] = 0;
isoBandNextOTL[139] = 0;
isoBandNextXTR[139] = 1;
isoBandNextYTR[139] = 0;
isoBandNextOTR[139] = 1;

isoBandNextXRT[98] = 0;
isoBandNextYRT[98] = -1;
isoBandNextORT[98] = 0;
isoBandNextXRB[98] = 0;
isoBandNextYRB[98] = -1;
isoBandNextORB[98] = 1;
isoBandNextXBR[98] = 1;
isoBandNextYBR[98] = 0;
isoBandNextOBR[98] = 0;
isoBandNextXBL[98] = 1;
isoBandNextYBL[98] = 0;
isoBandNextOBL[98] = 1;
isoBandNextXLT[98] = 0;
isoBandNextYLT[98] = 1;
isoBandNextOLT[98] = 0;
isoBandNextXTL[98] = -1;
isoBandNextYTL[98] = 0;
isoBandNextOTL[98] = 1;

isoBandNextXRT[99] = 0;
isoBandNextYRT[99] = 1;
isoBandNextORT[99] = 0;
isoBandNextXRB[99] = 0;
isoBandNextYRB[99] = -1;
isoBandNextORB[99] = 1;
isoBandNextXBR[99] = 1;
isoBandNextYBR[99] = 0;
isoBandNextOBR[99] = 0;
isoBandNextXBL[99] = -1;
isoBandNextYBL[99] = 0;
isoBandNextOBL[99] = 1;
isoBandNextXLT[99] = 0;
isoBandNextYLT[99] = -1;
isoBandNextOLT[99] = 0;
isoBandNextXTL[99] = 1;
isoBandNextYTL[99] = 0;
isoBandNextOTL[99] = 1;

isoBandNextXRB[38] = 0;
isoBandNextYRB[38] = -1;
isoBandNextORB[38] = 1;
isoBandNextXBR[38] = 1;
isoBandNextYBR[38] = 0;
isoBandNextOBR[38] = 0;
isoBandNextXLB[38] = 0;
isoBandNextYLB[38] = 1;
isoBandNextOLB[38] = 1;
isoBandNextXLT[38] = 0;
isoBandNextYLT[38] = 1;
isoBandNextOLT[38] = 0;
isoBandNextXTL[38] = -1;
isoBandNextYTL[38] = 0;
isoBandNextOTL[38] = 1;
isoBandNextXTR[38] = -1;
isoBandNextYTR[38] = 0;
isoBandNextOTR[38] = 0;

isoBandNextXRB[39] = 0;
isoBandNextYRB[39] = 1;
isoBandNextORB[39] = 1;
isoBandNextXBR[39] = -1;
isoBandNextYBR[39] = 0;
isoBandNextOBR[39] = 0;
isoBandNextXLB[39] = 0;
isoBandNextYLB[39] = -1;
isoBandNextOLB[39] = 1;
isoBandNextXLT[39] = 0;
isoBandNextYLT[39] = 1;
isoBandNextOLT[39] = 0;
isoBandNextXTL[39] = -1;
isoBandNextYTL[39] = 0;
isoBandNextOTL[39] = 1;
isoBandNextXTR[39] = 1;
isoBandNextYTR[39] = 0;
isoBandNextOTR[39] = 0;

/*
  Define helper functions for the polygon_table
  */

/* triangle cases */
var p00 = function (cell) {
  return [
    [cell.bottomleft, 0],
    [0, 0],
    [0, cell.leftbottom],
  ];
};
var p01 = function (cell) {
  return [
    [1, cell.rightbottom],
    [1, 0],
    [cell.bottomright, 0],
  ];
};
var p02 = function (cell) {
  return [
    [cell.topright, 1],
    [1, 1],
    [1, cell.righttop],
  ];
};
var p03 = function (cell) {
  return [
    [0, cell.lefttop],
    [0, 1],
    [cell.topleft, 1],
  ];
};
/* trapezoid cases */
var p04 = function (cell) {
  return [
    [cell.bottomright, 0],
    [cell.bottomleft, 0],
    [0, cell.leftbottom],
    [0, cell.lefttop],
  ];
};
var p05 = function (cell) {
  return [
    [cell.bottomright, 0],
    [cell.bottomleft, 0],
    [1, cell.righttop],
    [1, cell.rightbottom],
  ];
};
var p06 = function (cell) {
  return [
    [1, cell.righttop],
    [1, cell.rightbottom],
    [cell.topleft, 1],
    [cell.topright, 1],
  ];
};
var p07 = function (cell) {
  return [
    [0, cell.leftbottom],
    [0, cell.lefttop],
    [cell.topleft, 1],
    [cell.topright, 1],
  ];
};
/* rectangle cases */
var p08 = function (cell) {
  return [
    [0, 0],
    [0, cell.leftbottom],
    [1, cell.rightbottom],
    [1, 0],
  ];
};
var p09 = function (cell) {
  return [
    [1, 0],
    [cell.bottomright, 0],
    [cell.topright, 1],
    [1, 1],
  ];
};
var p10 = function (cell) {
  return [
    [1, 1],
    [1, cell.righttop],
    [0, cell.lefttop],
    [0, 1],
  ];
};
var p11 = function (cell) {
  return [
    [cell.bottomleft, 0],
    [0, 0],
    [0, 1],
    [cell.topleft, 1],
  ];
};
var p12 = function (cell) {
  return [
    [1, cell.righttop],
    [1, cell.rightbottom],
    [0, cell.leftbottom],
    [0, cell.lefttop],
  ];
};
var p13 = function (cell) {
  return [
    [cell.topleft, 1],
    [cell.topright, 1],
    [cell.bottomright, 0],
    [cell.bottomleft, 0],
  ];
};
/* square case */
var p14 = function () {
  return [
    [0, 0],
    [0, 1],
    [1, 1],
    [1, 0],
  ];
};
/* pentagon cases */
var p15 = function (cell) {
  return [
    [1, cell.rightbottom],
    [1, 0],
    [0, 0],
    [0, 1],
    [cell.topleft, 1],
  ];
};
/* 1211 || 1011 */
var p16 = function (cell) {
  return [
    [cell.topright, 1],
    [1, 1],
    [1, 0],
    [0, 0],
    [0, cell.leftbottom],
  ];
};
/* 2111 || 0111 */
var p17 = function (cell) {
  return [
    [1, 0],
    [cell.bottomright, 0],
    [0, cell.lefttop],
    [0, 1],
    [1, 1],
  ];
};
/* 1112 || 1110 */
var p18 = function (cell) {
  return [
    [1, 1],
    [1, cell.righttop],
    [cell.bottomleft, 0],
    [0, 0],
    [0, 1],
  ];
};
/* 1121 || 1101 */
var p19 = function (cell) {
  return [
    [1, cell.righttop],
    [1, cell.rightbottom],
    [0, cell.lefttop],
    [0, 1],
    [cell.topleft, 1],
  ];
};
/* 1200 || 1022 */
var p20 = function (cell) {
  return [
    [1, 1],
    [1, cell.righttop],
    [cell.bottomright, 0],
    [cell.bottomleft, 0],
    [cell.topright, 1],
  ];
};
/* 0120 || 2102 */
var p21 = function (cell) {
  return [
    [1, cell.rightbottom],
    [1, 0],
    [cell.bottomright, 0],
    [0, cell.leftbottom],
    [0, cell.lefttop],
  ];
};
/* 0012 || 2210 */
var p22 = function (cell) {
  return [
    [cell.topright, 1],
    [cell.bottomleft, 0],
    [0, 0],
    [0, cell.leftbottom],
    [cell.topleft, 1],
  ];
};
/* 2001 || 0221 */
var p23 = function (cell) {
  return [
    [cell.bottomright, 0],
    [cell.bottomleft, 0],
    [0, cell.lefttop],
    [0, 1],
    [cell.topleft, 1],
  ];
};
/* 1002 || 1220 */
var p24 = function (cell) {
  return [
    [1, 1],
    [1, cell.righttop],
    [0, cell.leftbottom],
    [0, cell.lefttop],
    [cell.topright, 1],
  ];
};
/* 2100 || 0122 */
var p25 = function (cell) {
  return [
    [1, cell.rightbottom],
    [1, 0],
    [cell.bottomright, 0],
    [cell.topleft, 1],
    [cell.topright, 1],
  ];
};
/* 0210 || 2012 */
var p26 = function (cell) {
  return [
    [1, cell.righttop],
    [1, cell.rightbottom],
    [cell.bottomleft, 0],
    [0, 0],
    [0, cell.leftbottom],
  ];
};
/* 0021 || 2201 */
/*hexagon cases */
var p27 = function (cell) {
  return [
    [1, cell.rightbottom],
    [1, 0],
    [0, 0],
    [0, cell.leftbottom],
    [cell.topleft, 1],
    [cell.topright, 1],
  ];
};
/* 0211 || 2011 */
var p28 = function (cell) {
  return [
    [1, 1],
    [1, 0],
    [cell.bottomright, 0],
    [0, cell.leftbottom],
    [0, cell.lefttop],
    [cell.topright, 1],
  ];
};
/* 2110 || 0112 */
var p29 = function (cell) {
  return [
    [1, 1],
    [1, cell.righttop],
    [cell.bottomright, 0],
    [cell.bottomleft, 0],
    [0, cell.lefttop],
    [0, 1],
  ];
};
/* 1102 || 1120 */
var p30 = function (cell) {
  return [
    [1, cell.righttop],
    [1, cell.rightbottom],
    [cell.bottomleft, 0],
    [0, 0],
    [0, 1],
    [cell.topleft, 1],
  ];
};
/* 1021 || 1201 */
var p31 = function (cell) {
  return [
    [1, 1],
    [1, cell.righttop],
    [cell.bottomleft, 0],
    [0, 0],
    [0, cell.leftbottom],
    [cell.topright, 1],
  ];
};
/* 2101 || 0121 */
var p32 = function (cell) {
  return [
    [1, cell.rightbottom],
    [1, 0],
    [cell.bottomright, 0],
    [0, cell.lefttop],
    [0, 1],
    [cell.topleft, 1],
  ];
};
/* 1012 || 1210 */
/* 8-sided cases */
var p33 = function (cell) {
  return [
    [1, cell.righttop],
    [1, cell.rightbottom],
    [cell.bottomright, 0],
    [cell.bottomleft, 0],
    [0, cell.leftbottom],
    [0, cell.lefttop],
    [cell.topleft, 1],
    [cell.topright, 1],
  ];
};
/* flipped == 1 state for 0202 and 2020 */
/* 6-sided cases */
var p34 = function (cell) {
  return [
    [1, 1],
    [1, cell.righttop],
    [cell.bottomleft, 0],
    [0, 0],
    [0, cell.leftbottom],
    [cell.topright, 1],
  ];
};
/* 0101 with flipped == 1 || 2121 with flipped == 1 */
var p35 = function (cell) {
  return [
    [1, cell.rightbottom],
    [1, 0],
    [cell.bottomright, 0],
    [0, cell.lefttop],
    [0, 1],
    [cell.topleft, 1],
  ];
};
/* 1010 with flipped == 1 || 1212 with flipped == 1 */
/* 7-sided cases */
var p36 = function (cell) {
  return [
    [1, 1],
    [1, cell.righttop],
    [cell.bottomright, 0],
    [cell.bottomleft, 0],
    [0, cell.leftbottom],
    [0, cell.lefttop],
    [cell.topright, 1],
  ];
};
/* 2120 with flipped == 1 || 0102 with flipped == 1 */
var p37 = function (cell) {
  return [
    [1, cell.righttop],
    [1, cell.rightbottom],
    [cell.bottomleft, 0],
    [0, 0],
    [0, cell.leftbottom],
    [cell.topleft, 1],
    [cell.topright, 1],
  ];
};
/* 2021 with flipped == 1 || 0201 with flipped == 1 */
var p38 = function (cell) {
  return [
    [1, cell.righttop],
    [1, cell.rightbottom],
    [cell.bottomright, 0],
    [cell.bottomleft, 0],
    [0, cell.lefttop],
    [0, 1],
    [cell.topleft, 1],
  ];
};
/* 1202 with flipped == 1 || 1020 with flipped == 1 */
var p39 = function (cell) {
  return [
    [1, cell.rightbottom],
    [1, 0],
    [cell.bottomright, 0],
    [0, cell.leftbottom],
    [0, cell.lefttop],
    [cell.topleft, 1],
    [cell.topright, 1],
  ];
};
/* 0212 with flipped == 1 || 2010 with flipped == 1 */

/*
  The lookup tables for edge number given the polygon
  is entered at a specific location
*/

var isoBandEdgeRT = [];
var isoBandEdgeRB = [];
var isoBandEdgeBR = [];
var isoBandEdgeBL = [];
var isoBandEdgeLB = [];
var isoBandEdgeLT = [];
var isoBandEdgeTL = [];
var isoBandEdgeTR = [];

/* triangle cases */
isoBandEdgeBL[1] = isoBandEdgeLB[1] = 18;
isoBandEdgeBL[169] = isoBandEdgeLB[169] = 18;
isoBandEdgeBR[4] = isoBandEdgeRB[4] = 12;
isoBandEdgeBR[166] = isoBandEdgeRB[166] = 12;
isoBandEdgeRT[16] = isoBandEdgeTR[16] = 4;
isoBandEdgeRT[154] = isoBandEdgeTR[154] = 4;
isoBandEdgeLT[64] = isoBandEdgeTL[64] = 22;
isoBandEdgeLT[106] = isoBandEdgeTL[106] = 22;

/* trapezoid cases */
isoBandEdgeBR[2] = isoBandEdgeLT[2] = 17;
isoBandEdgeBL[2] = isoBandEdgeLB[2] = 18;
isoBandEdgeBR[168] = isoBandEdgeLT[168] = 17;
isoBandEdgeBL[168] = isoBandEdgeLB[168] = 18;
isoBandEdgeRT[8] = isoBandEdgeBL[8] = 9;
isoBandEdgeRB[8] = isoBandEdgeBR[8] = 12;
isoBandEdgeRT[162] = isoBandEdgeBL[162] = 9;
isoBandEdgeRB[162] = isoBandEdgeBR[162] = 12;
isoBandEdgeRT[32] = isoBandEdgeTR[32] = 4;
isoBandEdgeRB[32] = isoBandEdgeTL[32] = 1;
isoBandEdgeRT[138] = isoBandEdgeTR[138] = 4;
isoBandEdgeRB[138] = isoBandEdgeTL[138] = 1;
isoBandEdgeLB[128] = isoBandEdgeTR[128] = 21;
isoBandEdgeLT[128] = isoBandEdgeTL[128] = 22;
isoBandEdgeLB[42] = isoBandEdgeTR[42] = 21;
isoBandEdgeLT[42] = isoBandEdgeTL[42] = 22;

/* rectangle cases */
isoBandEdgeRB[5] = isoBandEdgeLB[5] = 14;
isoBandEdgeRB[165] = isoBandEdgeLB[165] = 14;
isoBandEdgeBR[20] = isoBandEdgeTR[20] = 6;
isoBandEdgeBR[150] = isoBandEdgeTR[150] = 6;
isoBandEdgeRT[80] = isoBandEdgeLT[80] = 11;
isoBandEdgeRT[90] = isoBandEdgeLT[90] = 11;
isoBandEdgeBL[65] = isoBandEdgeTL[65] = 3;
isoBandEdgeBL[105] = isoBandEdgeTL[105] = 3;
isoBandEdgeRT[160] = isoBandEdgeLT[160] = 11;
isoBandEdgeRB[160] = isoBandEdgeLB[160] = 14;
isoBandEdgeRT[10] = isoBandEdgeLT[10] = 11;
isoBandEdgeRB[10] = isoBandEdgeLB[10] = 14;
isoBandEdgeBR[130] = isoBandEdgeTR[130] = 6;
isoBandEdgeBL[130] = isoBandEdgeTL[130] = 3;
isoBandEdgeBR[40] = isoBandEdgeTR[40] = 6;
isoBandEdgeBL[40] = isoBandEdgeTL[40] = 3;

/* pentagon cases */
isoBandEdgeRB[101] = isoBandEdgeTL[101] = 1;
isoBandEdgeRB[69] = isoBandEdgeTL[69] = 1;
isoBandEdgeLB[149] = isoBandEdgeTR[149] = 21;
isoBandEdgeLB[21] = isoBandEdgeTR[21] = 21;
isoBandEdgeBR[86] = isoBandEdgeLT[86] = 17;
isoBandEdgeBR[84] = isoBandEdgeLT[84] = 17;
isoBandEdgeRT[89] = isoBandEdgeBL[89] = 9;
isoBandEdgeRT[81] = isoBandEdgeBL[81] = 9;
isoBandEdgeRT[96] = isoBandEdgeTL[96] = 0;
isoBandEdgeRB[96] = isoBandEdgeLT[96] = 15;
isoBandEdgeRT[74] = isoBandEdgeTL[74] = 0;
isoBandEdgeRB[74] = isoBandEdgeLT[74] = 15;
isoBandEdgeRT[24] = isoBandEdgeBR[24] = 8;
isoBandEdgeBL[24] = isoBandEdgeTR[24] = 7;
isoBandEdgeRT[146] = isoBandEdgeBR[146] = 8;
isoBandEdgeBL[146] = isoBandEdgeTR[146] = 7;
isoBandEdgeRB[6] = isoBandEdgeLT[6] = 15;
isoBandEdgeBR[6] = isoBandEdgeLB[6] = 16;
isoBandEdgeRB[164] = isoBandEdgeLT[164] = 15;
isoBandEdgeBR[164] = isoBandEdgeLB[164] = 16;
isoBandEdgeBL[129] = isoBandEdgeTR[129] = 7;
isoBandEdgeLB[129] = isoBandEdgeTL[129] = 20;
isoBandEdgeBL[41] = isoBandEdgeTR[41] = 7;
isoBandEdgeLB[41] = isoBandEdgeTL[41] = 20;
isoBandEdgeBR[66] = isoBandEdgeTL[66] = 2;
isoBandEdgeBL[66] = isoBandEdgeLT[66] = 19;
isoBandEdgeBR[104] = isoBandEdgeTL[104] = 2;
isoBandEdgeBL[104] = isoBandEdgeLT[104] = 19;
isoBandEdgeRT[144] = isoBandEdgeLB[144] = 10;
isoBandEdgeLT[144] = isoBandEdgeTR[144] = 23;
isoBandEdgeRT[26] = isoBandEdgeLB[26] = 10;
isoBandEdgeLT[26] = isoBandEdgeTR[26] = 23;
isoBandEdgeRB[36] = isoBandEdgeTR[36] = 5;
isoBandEdgeBR[36] = isoBandEdgeTL[36] = 2;
isoBandEdgeRB[134] = isoBandEdgeTR[134] = 5;
isoBandEdgeBR[134] = isoBandEdgeTL[134] = 2;
isoBandEdgeRT[9] = isoBandEdgeLB[9] = 10;
isoBandEdgeRB[9] = isoBandEdgeBL[9] = 13;
isoBandEdgeRT[161] = isoBandEdgeLB[161] = 10;
isoBandEdgeRB[161] = isoBandEdgeBL[161] = 13;

/* hexagon cases */
isoBandEdgeRB[37] = isoBandEdgeTR[37] = 5;
isoBandEdgeLB[37] = isoBandEdgeTL[37] = 20;
isoBandEdgeRB[133] = isoBandEdgeTR[133] = 5;
isoBandEdgeLB[133] = isoBandEdgeTL[133] = 20;
isoBandEdgeBR[148] = isoBandEdgeLB[148] = 16;
isoBandEdgeLT[148] = isoBandEdgeTR[148] = 23;
isoBandEdgeBR[22] = isoBandEdgeLB[22] = 16;
isoBandEdgeLT[22] = isoBandEdgeTR[22] = 23;
isoBandEdgeRT[82] = isoBandEdgeBR[82] = 8;
isoBandEdgeBL[82] = isoBandEdgeLT[82] = 19;
isoBandEdgeRT[88] = isoBandEdgeBR[88] = 8;
isoBandEdgeBL[88] = isoBandEdgeLT[88] = 19;
isoBandEdgeRT[73] = isoBandEdgeTL[73] = 0;
isoBandEdgeRB[73] = isoBandEdgeBL[73] = 13;
isoBandEdgeRT[97] = isoBandEdgeTL[97] = 0;
isoBandEdgeRB[97] = isoBandEdgeBL[97] = 13;
isoBandEdgeRT[145] = isoBandEdgeBL[145] = 9;
isoBandEdgeLB[145] = isoBandEdgeTR[145] = 21;
isoBandEdgeRT[25] = isoBandEdgeBL[25] = 9;
isoBandEdgeLB[25] = isoBandEdgeTR[25] = 21;
isoBandEdgeRB[70] = isoBandEdgeTL[70] = 1;
isoBandEdgeBR[70] = isoBandEdgeLT[70] = 17;
isoBandEdgeRB[100] = isoBandEdgeTL[100] = 1;
isoBandEdgeBR[100] = isoBandEdgeLT[100] = 17;

/* 8-sided cases */
isoBandEdgeRT[34] = isoBandEdgeBL[34] = 9;
isoBandEdgeRB[34] = isoBandEdgeBR[34] = 12;
isoBandEdgeLB[34] = isoBandEdgeTR[34] = 21;
isoBandEdgeLT[34] = isoBandEdgeTL[34] = 22;
isoBandEdgeRT[136] = isoBandEdgeTR[136] = 4;
isoBandEdgeRB[136] = isoBandEdgeTL[136] = 1;
isoBandEdgeBR[136] = isoBandEdgeLT[136] = 17;
isoBandEdgeBL[136] = isoBandEdgeLB[136] = 18;
isoBandEdgeRT[35] = isoBandEdgeTR[35] = 4;
isoBandEdgeRB[35] = isoBandEdgeBR[35] = 12;
isoBandEdgeBL[35] = isoBandEdgeLB[35] = 18;
isoBandEdgeLT[35] = isoBandEdgeTL[35] = 22;

/* 6-sided cases */
isoBandEdgeRT[153] = isoBandEdgeTR[153] = 4;
isoBandEdgeBL[153] = isoBandEdgeLB[153] = 18;
isoBandEdgeRB[102] = isoBandEdgeBR[102] = 12;
isoBandEdgeLT[102] = isoBandEdgeTL[102] = 22;
isoBandEdgeRT[155] = isoBandEdgeBL[155] = 9;
isoBandEdgeLB[155] = isoBandEdgeTR[155] = 23;
isoBandEdgeRB[103] = isoBandEdgeTL[103] = 1;
isoBandEdgeBR[103] = isoBandEdgeLT[103] = 17;

/* 7-sided cases */
isoBandEdgeRT[152] = isoBandEdgeTR[152] = 4;
isoBandEdgeBR[152] = isoBandEdgeLT[152] = 17;
isoBandEdgeBL[152] = isoBandEdgeLB[152] = 18;
isoBandEdgeRT[156] = isoBandEdgeBR[156] = 8;
isoBandEdgeBL[156] = isoBandEdgeLB[156] = 18;
isoBandEdgeLT[156] = isoBandEdgeTR[156] = 23;
isoBandEdgeRT[137] = isoBandEdgeTR[137] = 4;
isoBandEdgeRB[137] = isoBandEdgeTL[137] = 1;
isoBandEdgeBL[137] = isoBandEdgeLB[137] = 18;
isoBandEdgeRT[139] = isoBandEdgeTR[139] = 4;
isoBandEdgeRB[139] = isoBandEdgeBL[139] = 13;
isoBandEdgeLB[139] = isoBandEdgeTL[139] = 20;
isoBandEdgeRT[98] = isoBandEdgeBL[98] = 9;
isoBandEdgeRB[98] = isoBandEdgeBR[98] = 12;
isoBandEdgeLT[98] = isoBandEdgeTL[98] = 22;
isoBandEdgeRT[99] = isoBandEdgeTL[99] = 0;
isoBandEdgeRB[99] = isoBandEdgeBR[99] = 12;
isoBandEdgeBL[99] = isoBandEdgeLT[99] = 19;
isoBandEdgeRB[38] = isoBandEdgeBR[38] = 12;
isoBandEdgeLB[38] = isoBandEdgeTR[38] = 21;
isoBandEdgeLT[38] = isoBandEdgeTL[38] = 22;
isoBandEdgeRB[39] = isoBandEdgeTR[39] = 5;
isoBandEdgeBR[39] = isoBandEdgeLB[39] = 16;
isoBandEdgeLT[39] = isoBandEdgeTL[39] = 22;

/*
  The lookup tables for all different polygons that
  may appear within a grid cell
*/

var polygon_table = [];

/* triangle cases */
polygon_table[1] = polygon_table[169] = p00; /* 2221 || 0001 */
polygon_table[4] = polygon_table[166] = p01; /* 2212 || 0010 */
polygon_table[16] = polygon_table[154] = p02; /* 2122 || 0100 */
polygon_table[64] = polygon_table[106] = p03; /* 1222 || 1000 */

/* trapezoid cases */
polygon_table[168] = polygon_table[2] = p04; /* 2220 || 0002 */
polygon_table[162] = polygon_table[8] = p05; /* 2202 || 0020 */
polygon_table[138] = polygon_table[32] = p06; /* 2022 || 0200 */
polygon_table[42] = polygon_table[128] = p07; /* 0222 || 2000 */

/* rectangle cases */
polygon_table[5] = polygon_table[165] = p08; /* 0011 || 2211 */
polygon_table[20] = polygon_table[150] = p09; /* 0110 || 2112 */
polygon_table[80] = polygon_table[90] = p10; /* 1100 || 1122 */
polygon_table[65] = polygon_table[105] = p11; /* 1001 || 1221 */
polygon_table[160] = polygon_table[10] = p12; /* 2200 || 0022 */
polygon_table[130] = polygon_table[40] = p13; /* 2002 || 0220 */

/* square case */
polygon_table[85] = p14; /* 1111 */

/* pentagon cases */
polygon_table[101] = polygon_table[69] = p15; /* 1211 || 1011 */
polygon_table[149] = polygon_table[21] = p16; /* 2111 || 0111 */
polygon_table[86] = polygon_table[84] = p17; /* 1112 || 1110 */
polygon_table[89] = polygon_table[81] = p18; /* 1121 || 1101 */
polygon_table[96] = polygon_table[74] = p19; /* 1200 || 1022 */
polygon_table[24] = polygon_table[146] = p20; /* 0120 || 2102 */
polygon_table[6] = polygon_table[164] = p21; /* 0012 || 2210 */
polygon_table[129] = polygon_table[41] = p22; /* 2001 || 0221 */
polygon_table[66] = polygon_table[104] = p23; /* 1002 || 1220 */
polygon_table[144] = polygon_table[26] = p24; /* 2100 || 0122 */
polygon_table[36] = polygon_table[134] = p25; /* 0210 || 2012 */
polygon_table[9] = polygon_table[161] = p26; /* 0021 || 2201 */

/* hexagon cases */
polygon_table[37] = polygon_table[133] = p27; /* 0211 || 2011 */
polygon_table[148] = polygon_table[22] = p28; /* 2110 || 0112 */
polygon_table[82] = polygon_table[88] = p29; /* 1102 || 1120 */
polygon_table[73] = polygon_table[97] = p30; /* 1021 || 1201 */
polygon_table[145] = polygon_table[25] = p31; /* 2101 || 0121 */
polygon_table[70] = polygon_table[100] = p32; /* 1012 || 1210 */

/* 8-sided cases */
polygon_table[34] = function (c) {
  return [p07(c), p05(c)];
}; /* 0202 || 2020 with flipped == 0 */
polygon_table[35] = p33; /* flipped == 1 state for 0202 and 2020 */
polygon_table[136] = function (c) {
  return [p06(c), p04(c)];
}; /* 2020 || 0202 with flipped == 0 */

/* 6-sided cases */
polygon_table[153] = function (c) {
  return [p02(c), p00(c)];
}; /* 0101 with flipped == 0 || 2121 with flipped == 2 */
polygon_table[102] = function (c) {
  return [p01(c), p03(c)];
}; /* 1010 with flipped == 0 || 1212 with flipped == 2 */
polygon_table[155] = p34; /* 0101 with flipped == 1 || 2121 with flipped == 1 */
polygon_table[103] = p35; /* 1010 with flipped == 1 || 1212 with flipped == 1 */

/* 7-sided cases */
polygon_table[152] = function (c) {
  return [p02(c), p04(c)];
}; /* 2120 with flipped == 2 || 0102 with flipped == 0 */
polygon_table[156] = p36; /* 2120 with flipped == 1 || 0102 with flipped == 1 */
polygon_table[137] = function (c) {
  return [p06(c), p00(c)];
}; /* 2021 with flipped == 2 || 0201 with flipped == 0 */
polygon_table[139] = p37; /* 2021 with flipped == 1 || 0201 with flipped == 1 */
polygon_table[98] = function (c) {
  return [p05(c), p03(c)];
}; /* 1202 with flipped == 2 || 1020 with flipped == 0 */
polygon_table[99] = p38; /* 1202 with flipped == 1 || 1020 with flipped == 1 */
polygon_table[38] = function (c) {
  return [p01(c), p07(c)];
}; /* 0212 with flipped == 2 || 2010 with flipped == 0 */
polygon_table[39] = p39; /* 0212 with flipped == 1 || 2010 with flipped == 1 */

/*
####################################
Some small helper functions
####################################
*/

/* assume that x1 == 1 &&  x0 == 0 */
function es_interpolateX(y, y0, y1) {
  return (y - y0) / (y1 - y0);
}

function isArray(myArray) {
  return myArray.constructor.toString().indexOf("Array") > -1;
}

/*
####################################
Below is the actual Marching Squares implementation
####################################
*/

function computeBandGrid(data, minV, bandwidth) {
  var rows = data.length - 1;
  var cols = data[0].length - 1;
  var BandGrid = { rows: rows, cols: cols, cells: [] };

  var maxV = minV + Math.abs(bandwidth);

  for (var j = 0; j < rows; ++j) {
    BandGrid.cells[j] = [];
    for (var i = 0; i < cols; ++i) {
      /*  compose the 4-trit corner representation */
      var cval = 0;

      var tl = data[j + 1][i];
      var tr = data[j + 1][i + 1];
      var br = data[j][i + 1];
      var bl = data[j][i];

      if (isNaN(tl) || isNaN(tr) || isNaN(br) || isNaN(bl)) {
        continue;
      }

      cval |= tl < minV ? 0 : tl > maxV ? 128 : 64;
      cval |= tr < minV ? 0 : tr > maxV ? 32 : 16;
      cval |= br < minV ? 0 : br > maxV ? 8 : 4;
      cval |= bl < minV ? 0 : bl > maxV ? 2 : 1;

      var cval_real = +cval;

      /* resolve ambiguity via averaging */
      var flipped = 0;
      if (
        cval === 17 /* 0101 */ ||
        cval === 18 /* 0102 */ ||
        cval === 33 /* 0201 */ ||
        cval === 34 /* 0202 */ ||
        cval === 38 /* 0212 */ ||
        cval === 68 /* 1010 */ ||
        cval === 72 /* 1020 */ ||
        cval === 98 /* 1202 */ ||
        cval === 102 /* 1212 */ ||
        cval === 132 /* 2010 */ ||
        cval === 136 /* 2020 */ ||
        cval === 137 /* 2021 */ ||
        cval === 152 /* 2120 */ ||
        cval === 153 /* 2121 */
      ) {
        var average = (tl + tr + br + bl) / 4;
        /* set flipped state */
        flipped = average > maxV ? 2 : average < minV ? 0 : 1;

        /* adjust cval for flipped cases */

        /* 8-sided cases */
        if (cval === 34) {
          if (flipped === 1) {
            cval = 35;
          } else if (flipped === 0) {
            cval = 136;
          }
        } else if (cval === 136) {
          if (flipped === 1) {
            cval = 35;
            flipped = 4;
          } else if (flipped === 0) {
            cval = 34;
          }
        } else if (cval === 17) {
          /* 6-sided polygon cases */
          if (flipped === 1) {
            cval = 155;
            flipped = 4;
          } else if (flipped === 0) {
            cval = 153;
          }
        } else if (cval === 68) {
          if (flipped === 1) {
            cval = 103;
            flipped = 4;
          } else if (flipped === 0) {
            cval = 102;
          }
        } else if (cval === 153) {
          if (flipped === 1) cval = 155;
        } else if (cval === 102) {
          if (flipped === 1) cval = 103;
        } else if (cval === 152) {
          /* 7-sided polygon cases */
          if (flipped < 2) {
            cval = 156;
            flipped = 1;
          }
        } else if (cval === 137) {
          if (flipped < 2) {
            cval = 139;
            flipped = 1;
          }
        } else if (cval === 98) {
          if (flipped < 2) {
            cval = 99;
            flipped = 1;
          }
        } else if (cval === 38) {
          if (flipped < 2) {
            cval = 39;
            flipped = 1;
          }
        } else if (cval === 18) {
          if (flipped > 0) {
            cval = 156;
            flipped = 4;
          } else {
            cval = 152;
          }
        } else if (cval === 33) {
          if (flipped > 0) {
            cval = 139;
            flipped = 4;
          } else {
            cval = 137;
          }
        } else if (cval === 72) {
          if (flipped > 0) {
            cval = 99;
            flipped = 4;
          } else {
            cval = 98;
          }
        } else if (cval === 132) {
          if (flipped > 0) {
            cval = 39;
            flipped = 4;
          } else {
            cval = 38;
          }
        }
      }

      /* add cell to BandGrid if it contains at least one polygon-side */
      if (cval != 0 && cval != 170) {
        var topleft,
          topright,
          bottomleft,
          bottomright,
          righttop,
          rightbottom,
          lefttop,
          leftbottom;

        topleft = topright = bottomleft = bottomright = righttop = rightbottom = lefttop = leftbottom = 0.5;

        var edges = [];

        /* do interpolation here */
        /* 1st Triangles */
        if (cval === 1) {
          /* 0001 */
          bottomleft = 1 - es_interpolateX(minV, br, bl);
          leftbottom = 1 - es_interpolateX(minV, tl, bl);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 169) {
          /* 2221 */
          bottomleft = es_interpolateX(maxV, bl, br);
          leftbottom = es_interpolateX(maxV, bl, tl);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 4) {
          /* 0010 */
          rightbottom = 1 - es_interpolateX(minV, tr, br);
          bottomright = es_interpolateX(minV, bl, br);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 166) {
          /* 2212 */
          rightbottom = es_interpolateX(maxV, br, tr);
          bottomright = 1 - es_interpolateX(maxV, br, bl);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 16) {
          /* 0100 */
          righttop = es_interpolateX(minV, br, tr);
          topright = es_interpolateX(minV, tl, tr);
          edges.push(isoBandEdgeRT[cval]);
        } else if (cval === 154) {
          /* 2122 */
          righttop = 1 - es_interpolateX(maxV, tr, br);
          topright = 1 - es_interpolateX(maxV, tr, tl);
          edges.push(isoBandEdgeRT[cval]);
        } else if (cval === 64) {
          /* 1000 */
          lefttop = es_interpolateX(minV, bl, tl);
          topleft = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 106) {
          /* 1222 */
          lefttop = 1 - es_interpolateX(maxV, tl, bl);
          topleft = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 168) {
          /* 2nd Trapezoids */
          /* 2220 */
          bottomright = es_interpolateX(maxV, bl, br);
          bottomleft = es_interpolateX(minV, bl, br);
          leftbottom = es_interpolateX(minV, bl, tl);
          lefttop = es_interpolateX(maxV, bl, tl);
          edges.push(isoBandEdgeBR[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 2) {
          /* 0002 */
          bottomright = 1 - es_interpolateX(minV, br, bl);
          bottomleft = 1 - es_interpolateX(maxV, br, bl);
          leftbottom = 1 - es_interpolateX(maxV, tl, bl);
          lefttop = 1 - es_interpolateX(minV, tl, bl);
          edges.push(isoBandEdgeBR[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 162) {
          /* 2202 */
          righttop = es_interpolateX(maxV, br, tr);
          rightbottom = es_interpolateX(minV, br, tr);
          bottomright = 1 - es_interpolateX(minV, br, bl);
          bottomleft = 1 - es_interpolateX(maxV, br, bl);
          edges.push(isoBandEdgeBR[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 8) {
          /* 0020 */
          righttop = 1 - es_interpolateX(minV, tr, br);
          rightbottom = 1 - es_interpolateX(maxV, tr, br);
          bottomright = es_interpolateX(maxV, bl, br);
          bottomleft = es_interpolateX(minV, bl, br);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 138) {
          /* 2022 */
          righttop = 1 - es_interpolateX(minV, tr, br);
          rightbottom = 1 - es_interpolateX(maxV, tr, br);
          topleft = 1 - es_interpolateX(maxV, tr, tl);
          topright = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 32) {
          /* 0200 */
          righttop = es_interpolateX(maxV, br, tr);
          rightbottom = es_interpolateX(minV, br, tr);
          topleft = es_interpolateX(minV, tl, tr);
          topright = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 42) {
          /* 0222 */
          leftbottom = 1 - es_interpolateX(maxV, tl, bl);
          lefttop = 1 - es_interpolateX(minV, tl, bl);
          topleft = es_interpolateX(minV, tl, tr);
          topright = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeLB[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 128) {
          /* 2000 */
          leftbottom = es_interpolateX(minV, bl, tl);
          lefttop = es_interpolateX(maxV, bl, tl);
          topleft = 1 - es_interpolateX(maxV, tr, tl);
          topright = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeLB[cval]);
          edges.push(isoBandEdgeLT[cval]);
        }

        /* 3rd rectangle cases */
        if (cval === 5) {
          /* 0011 */
          rightbottom = 1 - es_interpolateX(minV, tr, br);
          leftbottom = 1 - es_interpolateX(minV, tl, bl);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 165) {
          /* 2211 */
          rightbottom = es_interpolateX(maxV, br, tr);
          leftbottom = es_interpolateX(maxV, bl, tl);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 20) {
          /* 0110 */
          bottomright = es_interpolateX(minV, bl, br);
          topright = es_interpolateX(minV, tl, tr);
          edges.push(isoBandEdgeBR[cval]);
        } else if (cval === 150) {
          /* 2112 */
          bottomright = 1 - es_interpolateX(maxV, br, bl);
          topright = 1 - es_interpolateX(maxV, tr, tl);
          edges.push(isoBandEdgeBR[cval]);
        } else if (cval === 80) {
          /* 1100 */
          righttop = es_interpolateX(minV, br, tr);
          lefttop = es_interpolateX(minV, bl, tl);
          edges.push(isoBandEdgeRT[cval]);
        } else if (cval === 90) {
          /* 1122 */
          righttop = 1 - es_interpolateX(maxV, tr, br);
          lefttop = 1 - es_interpolateX(maxV, tl, bl);
          edges.push(isoBandEdgeRT[cval]);
        } else if (cval === 65) {
          /* 1001 */
          bottomleft = 1 - es_interpolateX(minV, br, bl);
          topleft = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 105) {
          /* 1221 */
          bottomleft = es_interpolateX(maxV, bl, br);
          topleft = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 160) {
          /* 2200 */
          righttop = es_interpolateX(maxV, br, tr);
          rightbottom = es_interpolateX(minV, br, tr);
          leftbottom = es_interpolateX(minV, bl, tl);
          lefttop = es_interpolateX(maxV, bl, tl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 10) {
          /* 0022 */
          righttop = 1 - es_interpolateX(minV, tr, br);
          rightbottom = 1 - es_interpolateX(maxV, tr, br);
          leftbottom = 1 - es_interpolateX(maxV, tl, bl);
          lefttop = 1 - es_interpolateX(minV, tl, bl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 130) {
          /* 2002 */
          bottomright = 1 - es_interpolateX(minV, br, bl);
          bottomleft = 1 - es_interpolateX(maxV, br, bl);
          topleft = 1 - es_interpolateX(maxV, tr, tl);
          topright = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeBR[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 40) {
          /* 0220 */
          bottomright = es_interpolateX(maxV, bl, br);
          bottomleft = es_interpolateX(minV, bl, br);
          topleft = es_interpolateX(minV, tl, tr);
          topright = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeBR[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 101) {
          /* 4th single pentagon cases */
          /* 1211 */
          rightbottom = es_interpolateX(maxV, br, tr);
          topleft = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 69) {
          /* 1011 */
          rightbottom = 1 - es_interpolateX(minV, tr, br);
          topleft = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 149) {
          /* 2111 */
          leftbottom = es_interpolateX(maxV, bl, tl);
          topright = 1 - es_interpolateX(maxV, tr, tl);
          edges.push(isoBandEdgeLB[cval]);
        } else if (cval === 21) {
          /* 0111 */
          leftbottom = 1 - es_interpolateX(minV, tl, bl);
          topright = es_interpolateX(minV, tl, tr);
          edges.push(isoBandEdgeLB[cval]);
        } else if (cval === 86) {
          /* 1112 */
          bottomright = 1 - es_interpolateX(maxV, br, bl);
          lefttop = 1 - es_interpolateX(maxV, tl, bl);
          edges.push(isoBandEdgeBR[cval]);
        } else if (cval === 84) {
          /* 1110 */
          bottomright = es_interpolateX(minV, bl, br);
          lefttop = es_interpolateX(minV, bl, tl);
          edges.push(isoBandEdgeBR[cval]);
        } else if (cval === 89) {
          /* 1121 */
          righttop = 1 - es_interpolateX(maxV, tr, br);
          bottomleft = es_interpolateX(maxV, bl, br);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 81) {
          /* 1101 */
          righttop = es_interpolateX(minV, br, tr);
          bottomleft = 1 - es_interpolateX(minV, br, bl);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 96) {
          /* 1200 */
          righttop = es_interpolateX(maxV, br, tr);
          rightbottom = es_interpolateX(minV, br, tr);
          lefttop = es_interpolateX(minV, bl, tl);
          topleft = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 74) {
          /* 1022 */
          righttop = 1 - es_interpolateX(minV, tr, br);
          rightbottom = 1 - es_interpolateX(maxV, tr, br);
          lefttop = 1 - es_interpolateX(maxV, tl, bl);
          topleft = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 24) {
          /* 0120 */
          righttop = 1 - es_interpolateX(maxV, tr, br);
          bottomright = es_interpolateX(maxV, bl, br);
          bottomleft = es_interpolateX(minV, bl, br);
          topright = es_interpolateX(minV, tl, tr);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 146) {
          /* 2102 */
          righttop = es_interpolateX(minV, br, tr);
          bottomright = 1 - es_interpolateX(minV, br, bl);
          bottomleft = 1 - es_interpolateX(maxV, br, bl);
          topright = 1 - es_interpolateX(maxV, tr, tl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 6) {
          /* 0012 */
          rightbottom = 1 - es_interpolateX(minV, tr, br);
          bottomright = 1 - es_interpolateX(maxV, br, bl);
          leftbottom = 1 - es_interpolateX(maxV, tl, bl);
          lefttop = 1 - es_interpolateX(minV, tl, bl);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeBR[cval]);
        } else if (cval === 164) {
          /* 2210 */
          rightbottom = es_interpolateX(maxV, br, tr);
          bottomright = es_interpolateX(minV, bl, br);
          leftbottom = es_interpolateX(minV, bl, tl);
          lefttop = es_interpolateX(maxV, bl, tl);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeBR[cval]);
        } else if (cval === 129) {
          /* 2001 */
          bottomleft = 1 - es_interpolateX(minV, br, bl);
          leftbottom = es_interpolateX(maxV, bl, tl);
          topleft = 1 - es_interpolateX(maxV, tr, tl);
          topright = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeBL[cval]);
          edges.push(isoBandEdgeLB[cval]);
        } else if (cval === 41) {
          /* 0221 */
          bottomleft = es_interpolateX(maxV, bl, br);
          leftbottom = 1 - es_interpolateX(minV, tl, bl);
          topleft = es_interpolateX(minV, tl, tr);
          topright = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeBL[cval]);
          edges.push(isoBandEdgeLB[cval]);
        } else if (cval === 66) {
          /* 1002 */
          bottomright = 1 - es_interpolateX(minV, br, bl);
          bottomleft = 1 - es_interpolateX(maxV, br, bl);
          lefttop = 1 - es_interpolateX(maxV, tl, bl);
          topleft = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeBR[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 104) {
          /* 1220 */
          bottomright = es_interpolateX(maxV, bl, br);
          bottomleft = es_interpolateX(minV, bl, br);
          lefttop = es_interpolateX(minV, bl, tl);
          topleft = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeBL[cval]);
          edges.push(isoBandEdgeTL[cval]);
        } else if (cval === 144) {
          /* 2100 */
          righttop = es_interpolateX(minV, br, tr);
          leftbottom = es_interpolateX(minV, bl, tl);
          lefttop = es_interpolateX(maxV, bl, tl);
          topright = 1 - es_interpolateX(maxV, tr, tl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 26) {
          /* 0122 */
          righttop = 1 - es_interpolateX(maxV, tr, br);
          leftbottom = 1 - es_interpolateX(maxV, tl, bl);
          lefttop = 1 - es_interpolateX(minV, tl, bl);
          topright = es_interpolateX(minV, tl, tr);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 36) {
          /* 0210 */
          rightbottom = es_interpolateX(maxV, br, tr);
          bottomright = es_interpolateX(minV, bl, br);
          topleft = es_interpolateX(minV, tl, tr);
          topright = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeBR[cval]);
        } else if (cval === 134) {
          /* 2012 */
          rightbottom = 1 - es_interpolateX(minV, tr, br);
          bottomright = 1 - es_interpolateX(maxV, br, bl);
          topleft = 1 - es_interpolateX(maxV, tr, tl);
          topright = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeBR[cval]);
        } else if (cval === 9) {
          /* 0021 */
          righttop = 1 - es_interpolateX(minV, tr, br);
          rightbottom = 1 - es_interpolateX(maxV, tr, br);
          bottomleft = es_interpolateX(maxV, bl, br);
          leftbottom = 1 - es_interpolateX(minV, tl, bl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 161) {
          /* 2201 */
          righttop = es_interpolateX(maxV, br, tr);
          rightbottom = es_interpolateX(minV, br, tr);
          bottomleft = 1 - es_interpolateX(minV, br, bl);
          leftbottom = es_interpolateX(maxV, bl, tl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 37) {
          /* 5th single hexagon cases */
          /* 0211 */
          rightbottom = es_interpolateX(maxV, br, tr);
          leftbottom = 1 - es_interpolateX(minV, tl, bl);
          topleft = es_interpolateX(minV, tl, tr);
          topright = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeLB[cval]);
        } else if (cval === 133) {
          /* 2011 */
          rightbottom = 1 - es_interpolateX(minV, tr, br);
          leftbottom = es_interpolateX(maxV, bl, tl);
          topleft = 1 - es_interpolateX(maxV, tr, tl);
          topright = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeLB[cval]);
        } else if (cval === 148) {
          /* 2110 */
          bottomright = es_interpolateX(minV, bl, br);
          leftbottom = es_interpolateX(minV, bl, tl);
          lefttop = es_interpolateX(maxV, bl, tl);
          topright = 1 - es_interpolateX(maxV, tr, tl);
          edges.push(isoBandEdgeBR[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 22) {
          /* 0112 */
          bottomright = 1 - es_interpolateX(maxV, br, bl);
          leftbottom = 1 - es_interpolateX(maxV, tl, bl);
          lefttop = 1 - es_interpolateX(minV, tl, bl);
          topright = es_interpolateX(minV, tl, tr);
          edges.push(isoBandEdgeBR[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 82) {
          /* 1102 */
          righttop = es_interpolateX(minV, br, tr);
          bottomright = 1 - es_interpolateX(minV, br, bl);
          bottomleft = 1 - es_interpolateX(maxV, br, bl);
          lefttop = 1 - es_interpolateX(maxV, tl, bl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 88) {
          /* 1120 */
          righttop = 1 - es_interpolateX(maxV, tr, br);
          bottomright = es_interpolateX(maxV, bl, br);
          bottomleft = es_interpolateX(minV, bl, br);
          lefttop = es_interpolateX(minV, bl, tl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 73) {
          /* 1021 */
          righttop = 1 - es_interpolateX(minV, tr, br);
          rightbottom = 1 - es_interpolateX(maxV, tr, br);
          bottomleft = es_interpolateX(maxV, bl, br);
          topleft = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 97) {
          /* 1201 */
          righttop = es_interpolateX(maxV, br, tr);
          rightbottom = es_interpolateX(minV, br, tr);
          bottomleft = 1 - es_interpolateX(minV, br, bl);
          topleft = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
        } else if (cval === 145) {
          /* 2101 */
          righttop = es_interpolateX(minV, br, tr);
          bottomleft = 1 - es_interpolateX(minV, br, bl);
          leftbottom = es_interpolateX(maxV, bl, tl);
          topright = 1 - es_interpolateX(maxV, tr, tl);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeLB[cval]);
        } else if (cval === 25) {
          /* 0121 */
          righttop = 1 - es_interpolateX(maxV, tr, br);
          bottomleft = es_interpolateX(maxV, bl, br);
          leftbottom = 1 - es_interpolateX(minV, tl, bl);
          topright = es_interpolateX(minV, tl, tr);
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeLB[cval]);
        } else if (cval === 70) {
          /* 1012 */
          rightbottom = 1 - es_interpolateX(minV, tr, br);
          bottomright = 1 - es_interpolateX(maxV, br, bl);
          lefttop = 1 - es_interpolateX(maxV, tl, bl);
          topleft = 1 - es_interpolateX(minV, tr, tl);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeBR[cval]);
        } else if (cval === 100) {
          /* 1210 */
          rightbottom = es_interpolateX(maxV, br, tr);
          bottomright = es_interpolateX(minV, bl, br);
          lefttop = es_interpolateX(minV, bl, tl);
          topleft = es_interpolateX(maxV, tl, tr);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeBR[cval]);
        } else if (cval === 34) {
          /* 8-sided cases */
          /* 0202 || 2020 with flipped == 0 */
          if (flipped === 0) {
            righttop = 1 - es_interpolateX(minV, tr, br);
            rightbottom = 1 - es_interpolateX(maxV, tr, br);
            bottomright = es_interpolateX(maxV, bl, br);
            bottomleft = es_interpolateX(minV, bl, br);
            leftbottom = es_interpolateX(minV, bl, tl);
            lefttop = es_interpolateX(maxV, bl, tl);
            topleft = 1 - es_interpolateX(maxV, tr, tl);
            topright = 1 - es_interpolateX(minV, tr, tl);
          } else {
            righttop = es_interpolateX(maxV, br, tr);
            rightbottom = es_interpolateX(minV, br, tr);
            bottomright = 1 - es_interpolateX(minV, br, bl);
            bottomleft = 1 - es_interpolateX(maxV, br, bl);
            leftbottom = 1 - es_interpolateX(maxV, tl, bl);
            lefttop = 1 - es_interpolateX(minV, tl, bl);
            topleft = es_interpolateX(minV, tl, tr);
            topright = es_interpolateX(maxV, tl, tr);
          }
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeLB[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 35) {
          /* flipped == 1 state for 0202, and 2020 with flipped == 4*/
          if (flipped === 4) {
            righttop = 1 - es_interpolateX(minV, tr, br);
            rightbottom = 1 - es_interpolateX(maxV, tr, br);
            bottomright = es_interpolateX(maxV, bl, br);
            bottomleft = es_interpolateX(minV, bl, br);
            leftbottom = es_interpolateX(minV, bl, tl);
            lefttop = es_interpolateX(maxV, bl, tl);
            topleft = 1 - es_interpolateX(maxV, tr, tl);
            topright = 1 - es_interpolateX(minV, tr, tl);
          } else {
            righttop = es_interpolateX(maxV, br, tr);
            rightbottom = es_interpolateX(minV, br, tr);
            bottomright = 1 - es_interpolateX(minV, br, bl);
            bottomleft = 1 - es_interpolateX(maxV, br, bl);
            leftbottom = 1 - es_interpolateX(maxV, tl, bl);
            lefttop = 1 - es_interpolateX(minV, tl, bl);
            topleft = es_interpolateX(minV, tl, tr);
            topright = es_interpolateX(maxV, tl, tr);
          }
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeBL[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 136) {
          /* 2020 || 0202 with flipped == 0 */
          if (flipped === 0) {
            righttop = es_interpolateX(maxV, br, tr);
            rightbottom = es_interpolateX(minV, br, tr);
            bottomright = 1 - es_interpolateX(minV, br, bl);
            bottomleft = 1 - es_interpolateX(maxV, br, bl);
            leftbottom = 1 - es_interpolateX(maxV, tl, bl);
            lefttop = 1 - es_interpolateX(minV, tl, bl);
            topleft = es_interpolateX(minV, tl, tr);
            topright = es_interpolateX(maxV, tl, tr);
          } else {
            righttop = 1 - es_interpolateX(minV, tr, br);
            rightbottom = 1 - es_interpolateX(maxV, tr, br);
            bottomright = es_interpolateX(maxV, bl, br);
            bottomleft = es_interpolateX(minV, bl, br);
            leftbottom = es_interpolateX(minV, bl, tl);
            lefttop = es_interpolateX(maxV, bl, tl);
            topleft = 1 - es_interpolateX(maxV, tr, tl);
            topright = 1 - es_interpolateX(minV, tr, tl);
          }
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeLB[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 153) {
          /* 6-sided polygon cases */
          /* 0101 with flipped == 0 || 2121 with flipped == 2 */
          if (flipped === 0) {
            righttop = es_interpolateX(minV, br, tr);
            bottomleft = 1 - es_interpolateX(minV, br, bl);
            leftbottom = 1 - es_interpolateX(minV, tl, bl);
            topright = es_interpolateX(minV, tl, tr);
          } else {
            righttop = 1 - es_interpolateX(maxV, tr, br);
            bottomleft = es_interpolateX(maxV, bl, br);
            leftbottom = es_interpolateX(maxV, bl, tl);
            topright = 1 - es_interpolateX(maxV, tr, tl);
          }
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 102) {
          /* 1010 with flipped == 0 || 1212 with flipped == 2 */
          if (flipped === 0) {
            rightbottom = 1 - es_interpolateX(minV, tr, br);
            bottomright = es_interpolateX(minV, bl, br);
            lefttop = es_interpolateX(minV, bl, tl);
            topleft = 1 - es_interpolateX(minV, tr, tl);
          } else {
            rightbottom = es_interpolateX(maxV, br, tr);
            bottomright = 1 - es_interpolateX(maxV, br, bl);
            lefttop = 1 - es_interpolateX(maxV, tl, bl);
            topleft = es_interpolateX(maxV, tl, tr);
          }
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 155) {
          /* 0101 with flipped == 4 || 2121 with flipped == 1 */
          if (flipped === 4) {
            righttop = es_interpolateX(minV, br, tr);
            bottomleft = 1 - es_interpolateX(minV, br, bl);
            leftbottom = 1 - es_interpolateX(minV, tl, bl);
            topright = es_interpolateX(minV, tl, tr);
          } else {
            righttop = 1 - es_interpolateX(maxV, tr, br);
            bottomleft = es_interpolateX(maxV, bl, br);
            leftbottom = es_interpolateX(maxV, bl, tl);
            topright = 1 - es_interpolateX(maxV, tr, tl);
          }
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeLB[cval]);
        } else if (cval === 103) {
          /* 1010 with flipped == 4 || 1212 with flipped == 1 */
          if (flipped === 4) {
            rightbottom = 1 - es_interpolateX(minV, tr, br);
            bottomright = es_interpolateX(minV, bl, br);
            lefttop = es_interpolateX(minV, bl, tl);
            topleft = 1 - es_interpolateX(minV, tr, tl);
          } else {
            rightbottom = es_interpolateX(maxV, br, tr);
            bottomright = 1 - es_interpolateX(maxV, br, bl);
            lefttop = 1 - es_interpolateX(maxV, tl, bl);
            topleft = es_interpolateX(maxV, tl, tr);
          }
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeBR[cval]);
        } else if (cval === 152) {
          /* 7-sided polygon cases */
          /* 2120 with flipped == 2 || 0102 with flipped == 0 */
          if (flipped === 0) {
            righttop = es_interpolateX(minV, br, tr);
            bottomright = 1 - es_interpolateX(minV, br, bl);
            bottomleft = 1 - es_interpolateX(maxV, br, bl);
            leftbottom = 1 - es_interpolateX(maxV, tl, bl);
            lefttop = 1 - es_interpolateX(minV, tl, bl);
            topright = es_interpolateX(minV, tl, tr);
          } else {
            righttop = 1 - es_interpolateX(maxV, tr, br);
            bottomright = es_interpolateX(maxV, bl, br);
            bottomleft = es_interpolateX(minV, bl, br);
            leftbottom = es_interpolateX(minV, bl, tl);
            lefttop = es_interpolateX(maxV, bl, tl);
            topright = 1 - es_interpolateX(maxV, tr, tl);
          }
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeBR[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 156) {
          /* 2120 with flipped == 1 || 0102 with flipped == 4 */
          if (flipped === 4) {
            righttop = es_interpolateX(minV, br, tr);
            bottomright = 1 - es_interpolateX(minV, br, bl);
            bottomleft = 1 - es_interpolateX(maxV, br, bl);
            leftbottom = 1 - es_interpolateX(maxV, tl, bl);
            lefttop = 1 - es_interpolateX(minV, tl, bl);
            topright = es_interpolateX(minV, tl, tr);
          } else {
            righttop = 1 - es_interpolateX(maxV, tr, br);
            bottomright = es_interpolateX(maxV, bl, br);
            bottomleft = es_interpolateX(minV, bl, br);
            leftbottom = es_interpolateX(minV, bl, tl);
            lefttop = es_interpolateX(maxV, bl, tl);
            topright = 1 - es_interpolateX(maxV, tr, tl);
          }
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeBL[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 137) {
          /* 2021 with flipped == 2 || 0201 with flipped == 0 */
          if (flipped === 0) {
            righttop = es_interpolateX(maxV, br, tr);
            rightbottom = es_interpolateX(minV, br, tr);
            bottomleft = 1 - es_interpolateX(minV, br, bl);
            leftbottom = 1 - es_interpolateX(minV, tl, bl);
            topleft = es_interpolateX(minV, tl, tr);
            topright = es_interpolateX(maxV, tl, tr);
          } else {
            righttop = 1 - es_interpolateX(minV, tr, br);
            rightbottom = 1 - es_interpolateX(maxV, tr, br);
            bottomleft = es_interpolateX(maxV, bl, br);
            leftbottom = es_interpolateX(maxV, bl, tl);
            topleft = 1 - es_interpolateX(maxV, tr, tl);
            topright = 1 - es_interpolateX(minV, tr, tl);
          }
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 139) {
          /* 2021 with flipped == 1 || 0201 with flipped == 4 */
          if (flipped === 4) {
            righttop = es_interpolateX(maxV, br, tr);
            rightbottom = es_interpolateX(minV, br, tr);
            bottomleft = 1 - es_interpolateX(minV, br, bl);
            leftbottom = 1 - es_interpolateX(minV, tl, bl);
            topleft = es_interpolateX(minV, tl, tr);
            topright = es_interpolateX(maxV, tl, tr);
          } else {
            righttop = 1 - es_interpolateX(minV, tr, br);
            rightbottom = 1 - es_interpolateX(maxV, tr, br);
            bottomleft = es_interpolateX(maxV, bl, br);
            leftbottom = es_interpolateX(maxV, bl, tl);
            topleft = 1 - es_interpolateX(maxV, tr, tl);
            topright = 1 - es_interpolateX(minV, tr, tl);
          }
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeLB[cval]);
        } else if (cval === 98) {
          /* 1202 with flipped == 2 || 1020 with flipped == 0 */
          if (flipped === 0) {
            righttop = 1 - es_interpolateX(minV, tr, br);
            rightbottom = 1 - es_interpolateX(maxV, tr, br);
            bottomright = es_interpolateX(maxV, bl, br);
            bottomleft = es_interpolateX(minV, bl, br);
            lefttop = es_interpolateX(minV, bl, tl);
            topleft = 1 - es_interpolateX(minV, tr, tl);
          } else {
            righttop = es_interpolateX(maxV, br, tr);
            rightbottom = es_interpolateX(minV, br, tr);
            bottomright = 1 - es_interpolateX(minV, br, bl);
            bottomleft = 1 - es_interpolateX(maxV, br, bl);
            lefttop = 1 - es_interpolateX(maxV, tl, bl);
            topleft = es_interpolateX(maxV, tl, tr);
          }
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 99) {
          /* 1202 with flipped == 1 || 1020 with flipped == 4 */
          if (flipped === 4) {
            righttop = 1 - es_interpolateX(minV, tr, br);
            rightbottom = 1 - es_interpolateX(maxV, tr, br);
            bottomright = es_interpolateX(maxV, bl, br);
            bottomleft = es_interpolateX(minV, bl, br);
            lefttop = es_interpolateX(minV, bl, tl);
            topleft = 1 - es_interpolateX(minV, tr, tl);
          } else {
            righttop = es_interpolateX(maxV, br, tr);
            rightbottom = es_interpolateX(minV, br, tr);
            bottomright = 1 - es_interpolateX(minV, br, bl);
            bottomleft = 1 - es_interpolateX(maxV, br, bl);
            lefttop = 1 - es_interpolateX(maxV, tl, bl);
            topleft = es_interpolateX(maxV, tl, tr);
          }
          edges.push(isoBandEdgeRT[cval]);
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeBL[cval]);
        } else if (cval === 38) {
          /* 0212 with flipped == 2 || 2010 with flipped == 0 */
          if (flipped === 0) {
            rightbottom = 1 - es_interpolateX(minV, tr, br);
            bottomright = es_interpolateX(minV, bl, br);
            leftbottom = es_interpolateX(minV, bl, tl);
            lefttop = es_interpolateX(maxV, bl, tl);
            topleft = 1 - es_interpolateX(maxV, tr, tl);
            topright = 1 - es_interpolateX(minV, tr, tl);
          } else {
            rightbottom = es_interpolateX(maxV, br, tr);
            bottomright = 1 - es_interpolateX(maxV, br, bl);
            leftbottom = 1 - es_interpolateX(maxV, tl, bl);
            lefttop = 1 - es_interpolateX(minV, tl, bl);
            topleft = es_interpolateX(minV, tl, tr);
            topright = es_interpolateX(maxV, tl, tr);
          }
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeLB[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 39) {
          /* 0212 with flipped == 1 || 2010 with flipped == 4 */
          if (flipped === 4) {
            rightbottom = 1 - es_interpolateX(minV, tr, br);
            bottomright = es_interpolateX(minV, bl, br);
            leftbottom = es_interpolateX(minV, bl, tl);
            lefttop = es_interpolateX(maxV, bl, tl);
            topleft = 1 - es_interpolateX(maxV, tr, tl);
            topright = 1 - es_interpolateX(minV, tr, tl);
          } else {
            rightbottom = es_interpolateX(maxV, br, tr);
            bottomright = 1 - es_interpolateX(maxV, br, bl);
            leftbottom = 1 - es_interpolateX(maxV, tl, bl);
            lefttop = 1 - es_interpolateX(minV, tl, bl);
            topleft = es_interpolateX(minV, tl, tr);
            topright = es_interpolateX(maxV, tl, tr);
          }
          edges.push(isoBandEdgeRB[cval]);
          edges.push(isoBandEdgeBR[cval]);
          edges.push(isoBandEdgeLT[cval]);
        } else if (cval === 85) {
          righttop = 1;
          rightbottom = 0;
          bottomright = 1;
          bottomleft = 0;
          leftbottom = 0;
          lefttop = 1;
          topleft = 0;
          topright = 1;
        }

        if (
          topleft < 0 ||
          topleft > 1 ||
          topright < 0 ||
          topright > 1 ||
          righttop < 0 ||
          righttop > 1 ||
          bottomright < 0 ||
          bottomright > 1 ||
          leftbottom < 0 ||
          leftbottom > 1 ||
          lefttop < 0 ||
          lefttop > 1
        ) {
          console.log(
            "MarchingSquaresJS-isoBands: " +
              cval +
              " " +
              cval_real +
              " " +
              tl +
              "," +
              tr +
              "," +
              br +
              "," +
              bl +
              " " +
              flipped +
              " " +
              topleft +
              " " +
              topright +
              " " +
              righttop +
              " " +
              rightbottom +
              " " +
              bottomright +
              " " +
              bottomleft +
              " " +
              leftbottom +
              " " +
              lefttop
          );
        }

        BandGrid.cells[j][i] = {
          cval: cval,
          cval_real: cval_real,
          flipped: flipped,
          topleft: topleft,
          topright: topright,
          righttop: righttop,
          rightbottom: rightbottom,
          bottomright: bottomright,
          bottomleft: bottomleft,
          leftbottom: leftbottom,
          lefttop: lefttop,
          edges: edges,
        };
      }
    }
  }

  return BandGrid;
}

function BandGrid2AreaPaths(grid) {
  var areas = [];
  var rows = grid.rows;
  var cols = grid.cols;
  var currentPolygon = [];

  for (var j = 0; j < rows; j++) {
    for (var i = 0; i < cols; i++) {
      if (
        typeof grid.cells[j][i] !== "undefined" &&
        grid.cells[j][i].edges.length > 0
      ) {
        /* trace back polygon path starting from this cell */

        var cell = grid.cells[j][i];

        /* get start coordinates */

        var prev = getStartXY(cell),
          next = null,
          p = i,
          q = j;

        if (prev !== null) {
          currentPolygon.push([prev.p[0] + p, prev.p[1] + q]);
          //console.log(cell);
          //console.log("coords: " + (prev.p[0] + p) + " " + (prev.p[1] + q));
        }

        do {
          //console.log(p + "," + q);
          //console.log(grid.cells[q][p]);
          //console.log(grid.cells[q][p].edges);
          //console.log("from : " + prev.x + " " + prev.y + " " + prev.o);

          next = getExitXY(grid.cells[q][p], prev.x, prev.y, prev.o);
          if (next !== null) {
            //console.log("coords: " + (next.p[0] + p) + " " + (next.p[1] + q));
            currentPolygon.push([next.p[0] + p, next.p[1] + q]);
            p += next.x;
            q += next.y;
            prev = next;
          } else {
            //console.log("getExitXY() returned null!");
            break;
          }
          //console.log("to : " + next.x + " " + next.y + " " + next.o);
          /* special case, where we've reached the grid boundaries */
          if (
            q < 0 ||
            q >= rows ||
            p < 0 ||
            p >= cols ||
            typeof grid.cells[q][p] === "undefined"
          ) {
            /* to create a closed path, we need to trace our way
                arround the missing data, until we find an entry
                point again
            */

            /* set back coordinates of current cell */
            p -= next.x;
            q -= next.y;

            //console.log("reached boundary at " + p + " " + q);

            var missing = traceOutOfGridPath(
              grid,
              p,
              q,
              next.x,
              next.y,
              next.o
            );
            if (missing !== null) {
              missing.path.forEach(function (pp) {
                //console.log("coords: " + (pp[0]) + " " + (pp[1]));
                currentPolygon.push(pp);
              });
              p = missing.i;
              q = missing.j;
              prev = missing;
            } else {
              break;
            }
            //console.log(grid.cells[q][p]);
          }
        } while (
          typeof grid.cells[q][p] !== "undefined" &&
          grid.cells[q][p].edges.length > 0
        );

        areas.push(currentPolygon);
        //console.log("next polygon");
        //console.log(currentPolygon);
        currentPolygon = [];
        if (grid.cells[j][i].edges.length > 0) i--;
      }
    }
  }
  return areas;
}

function traceOutOfGridPath(grid, i, j, d_x, d_y, d_o) {
  var cell = grid.cells[j][i];
  var cval = cell.cval_real;
  var p = i + d_x,
    q = j + d_y;
  var path = [];
  var closed = false;

  while (!closed) {
    //console.log("processing cell " + p + "," + q + " " + d_x + " " + d_y + " " + d_o);
    if (
      typeof grid.cells[q] === "undefined" ||
      typeof grid.cells[q][p] === "undefined"
    ) {
      //console.log("which is undefined");
      /* we can't move on, so we have to change direction to proceed further */

      /* go back to previous cell */
      q -= d_y;
      p -= d_x;
      cell = grid.cells[q][p];
      cval = cell.cval_real;

      /* check where we've left defined cells of the grid... */
      if (d_y === -1) {
        /* we came from top */
        if (d_o === 0) {
          /* exit left */
          if (cval & Node3) {
            /* lower left node is within range, so we move left */
            path.push([p, q]);
            d_x = -1;
            d_y = 0;
            d_o = 0;
          } else if (cval & Node2) {
            /* lower right node is within range, so we move right */
            path.push([p + 1, q]);
            d_x = 1;
            d_y = 0;
            d_o = 0;
          } else {
            /* close the path */
            path.push([p + cell.bottomright, q]);
            d_x = 0;
            d_y = 1;
            d_o = 1;
            closed = true;
            break;
          }
        } else if (cval & Node3) {
          path.push([p, q]);
          d_x = -1;
          d_y = 0;
          d_o = 0;
        } else if (cval & Node2) {
          path.push([p + cell.bottomright, q]);
          d_x = 0;
          d_y = 1;
          d_o = 1;
          closed = true;
          break;
        } else {
          path.push([p + cell.bottomleft, q]);
          d_x = 0;
          d_y = 1;
          d_o = 0;
          closed = true;
          break;
        }
      } else if (d_y === 1) {
        /* we came from bottom */
        //console.log("we came from bottom and hit a non-existing cell " + (p + d_x) + "," + (q + d_y) + "!");
        if (d_o === 0) {
          /* exit left */
          if (cval & Node1) {
            /* top right node is within range, so we move right */
            path.push([p + 1, q + 1]);
            d_x = 1;
            d_y = 0;
            d_o = 1;
          } else if (!(cval & Node0)) {
            /* found entry within same cell */
            path.push([p + cell.topright, q + 1]);
            d_x = 0;
            d_y = -1;
            d_o = 1;
            closed = true;
            //console.log("found entry from bottom at " + p + "," + q);
            break;
          } else {
            path.push([p + cell.topleft, q + 1]);
            d_x = 0;
            d_y = -1;
            d_o = 0;
            closed = true;
            break;
          }
        } else if (cval & Node1) {
          path.push([p + 1, q + 1]);
          d_x = 1;
          d_y = 0;
          d_o = 1;
        } else {
          /* move right */
          path.push([p + 1, q + 1]);
          d_x = 1;
          d_y = 0;
          d_o = 1;
          //console.log("wtf");
          //break;
        }
      } else if (d_x === -1) {
        /* we came from right */
        //console.log("we came from right and hit a non-existing cell at " + (p + d_x) + "," + (q + d_y) + "!");
        if (d_o === 0) {
          //console.log("continue at bottom");
          if (cval & Node0) {
            path.push([p, q + 1]);
            d_x = 0;
            d_y = 1;
            d_o = 0;
            //console.log("moving upwards to " + (p + d_x) + "," + (q + d_y) + "!");
          } else if (!(cval & Node3)) {
            /* there has to be an entry into the regular grid again! */
            //console.log("exiting top");
            path.push([p, q + cell.lefttop]);
            d_x = 1;
            d_y = 0;
            d_o = 1;
            closed = true;
            break;
          } else {
            //console.log("exiting bottom");
            path.push([p, q + cell.leftbottom]);
            d_x = 1;
            d_y = 0;
            d_o = 0;
            closed = true;
            break;
          }
        } else {
          //console.log("continue at top");
          if (cval & Node0) {
            path.push([p, q + 1]);
            d_x = 0;
            d_y = 1;
            d_o = 0;
            //console.log("moving upwards to " + (p + d_x) + "," + (q + d_y) + "!");
          } else {
            /* */
            console.log("MarchingSquaresJS-isoBands: wtf");
            break;
          }
        }
      } else if (d_x === 1) {
        /* we came from left */
        //console.log("we came from left and hit a non-existing cell " + (p + d_x) + "," + (q + d_y) + "!");
        if (d_o === 0) {
          /* exit bottom */
          if (cval & Node2) {
            path.push([p + 1, q]);
            d_x = 0;
            d_y = -1;
            d_o = 1;
          } else {
            path.push([p + 1, q + cell.rightbottom]);
            d_x = -1;
            d_y = 0;
            d_o = 0;
            closed = true;
            break;
          }
        } else {
          /* exit top */
          if (cval & Node2) {
            path.push([p + 1, q]);
            d_x = 0;
            d_y = -1;
            d_o = 1;
          } else if (!(cval & Node1)) {
            path.push([p + 1, q + cell.rightbottom]);
            d_x = -1;
            d_y = 0;
            d_o = 0;
            closed = true;
            break;
          } else {
            path.push([p + 1, q + cell.righttop]);
            d_x = -1;
            d_y = 0;
            d_o = 1;
            break;
          }
        }
      } else {
        /* we came from the same cell */
        console.log("MarchingSquaresJS-isoBands: we came from nowhere!");
        break;
      }
    } else {
      /* try to find an entry into the regular grid again! */
      cell = grid.cells[q][p];
      cval = cell.cval_real;
      //console.log("which is defined");

      if (d_x === -1) {
        if (d_o === 0) {
          /* try to go downwards */
          if (
            typeof grid.cells[q - 1] !== "undefined" &&
            typeof grid.cells[q - 1][p] !== "undefined"
          ) {
            d_x = 0;
            d_y = -1;
            d_o = 1;
          } else if (cval & Node3) {
            /* proceed searching in x-direction */
            //console.log("proceeding in x-direction!");
            path.push([p, q]);
          } else {
            /* we must have found an entry into the regular grid */
            path.push([p + cell.bottomright, q]);
            d_x = 0;
            d_y = 1;
            d_o = 1;
            closed = true;
            //console.log("found entry from bottom at " + p + "," + q);
            break;
          }
        } else if (cval & Node0) {
          /* proceed searchin in x-direction */
          console.log("MarchingSquaresJS-isoBands: proceeding in x-direction!");
        } else {
          /* we must have found an entry into the regular grid */
          console.log(
            "MarchingSquaresJS-isoBands: found entry from top at " + p + "," + q
          );
          break;
        }
      } else if (d_x === 1) {
        if (d_o === 0) {
          console.log("MarchingSquaresJS-isoBands: wtf");
          break;
        } else {
          /* try to go upwards */
          if (
            typeof grid.cells[q + 1] !== "undefined" &&
            typeof grid.cells[q + 1][p] !== "undefined"
          ) {
            d_x = 0;
            d_y = 1;
            d_o = 0;
          } else if (cval & Node1) {
            path.push([p + 1, q + 1]);
            d_x = 1;
            d_y = 0;
            d_o = 1;
          } else {
            /* found an entry point into regular grid! */
            path.push([p + cell.topleft, q + 1]);
            d_x = 0;
            d_y = -1;
            d_o = 0;
            closed = true;
            //console.log("found entry from bottom at " + p + "," + q);
            break;
          }
        }
      } else if (d_y === -1) {
        if (d_o === 1) {
          /* try to go right */
          if (typeof grid.cells[q][p + 1] !== "undefined") {
            d_x = 1;
            d_y = 0;
            d_o = 1;
          } else if (cval & Node2) {
            path.push([p + 1, q]);
            d_x = 0;
            d_y = -1;
            d_o = 1;
          } else {
            /* found entry into regular grid! */
            path.push([p + 1, q + cell.righttop]);
            d_x = -1;
            d_y = 0;
            d_o = 1;
            closed = true;
            //console.log("found entry from top at " + p + "," + q);
            break;
          }
        } else {
          console.log("MarchingSquaresJS-isoBands: wtf");
          break;
        }
      } else if (d_y === 1) {
        if (d_o === 0) {
          //console.log("we came from bottom left and proceed to the left");
          /* try to go left */
          if (typeof grid.cells[q][p - 1] !== "undefined") {
            d_x = -1;
            d_y = 0;
            d_o = 0;
          } else if (cval & Node0) {
            path.push([p, q + 1]);
            d_x = 0;
            d_y = 1;
            d_o = 0;
          } else {
            /* found an entry point into regular grid! */
            path.push([p, q + cell.leftbottom]);
            d_x = 1;
            d_y = 0;
            d_o = 0;
            closed = true;
            //console.log("found entry from bottom at " + p + "," + q);
            break;
          }
        } else {
          //console.log("we came from bottom right and proceed to the right");
          console.log("MarchingSquaresJS-isoBands: wtf");
          break;
        }
      } else {
        console.log("MarchingSquaresJS-isoBands: where did we came from???");
        break;
      }
    }

    p += d_x;
    q += d_y;
    //console.log("going on to  " + p + "," + q + " via " + d_x + " " + d_y + " " + d_o);

    if (p === i && q === j) {
      /* bail out, once we've closed a circle path */
      break;
    }
  }

  //console.log("exit with " + p + "," + q + " " + d_x + " " + d_y + " " + d_o);
  return { path: path, i: p, j: q, x: d_x, y: d_y, o: d_o };
}

function deleteEdge(cell, edgeIdx) {
  delete cell.edges[edgeIdx];
  for (var k = edgeIdx + 1; k < cell.edges.length; k++) {
    cell.edges[k - 1] = cell.edges[k];
  }
  cell.edges.pop();
}

function getStartXY(cell) {
  if (cell.edges.length > 0) {
    var e = cell.edges[cell.edges.length - 1];
    //console.log("starting with edge " + e);
    var cval = cell.cval_real;
    switch (e) {
      case 0:
        if (cval & Node1) {
          /* node 1 within range */
          return { p: [1, cell.righttop], x: -1, y: 0, o: 1 };
        } else {
          /* node 1 below or above threshold */
          return { p: [cell.topleft, 1], x: 0, y: -1, o: 0 };
        }
      case 1:
        if (cval & Node2) {
          return { p: [cell.topleft, 1], x: 0, y: -1, o: 0 };
        } else {
          return { p: [1, cell.rightbottom], x: -1, y: 0, o: 0 };
        }
      case 2:
        if (cval & Node2) {
          return { p: [cell.bottomright, 0], x: 0, y: 1, o: 1 };
        } else {
          return { p: [cell.topleft, 1], x: 0, y: -1, o: 0 };
        }
      case 3:
        if (cval & Node3) {
          return { p: [cell.topleft, 1], x: 0, y: -1, o: 0 };
        } else {
          return { p: [cell.bottomleft, 0], x: 0, y: 1, o: 0 };
        }
      case 4:
        if (cval & Node1) {
          return { p: [1, cell.righttop], x: -1, y: 0, o: 1 };
        } else {
          return { p: [cell.topright, 1], x: 0, y: -1, o: 1 };
        }
      case 5:
        if (cval & Node2) {
          return { p: [cell.topright, 1], x: 0, y: -1, o: 1 };
        } else {
          return { p: [1, cell.rightbottom], x: -1, y: 0, o: 0 };
        }
      case 6:
        if (cval & Node2) {
          return { p: [cell.bottomright, 0], x: 0, y: 1, o: 1 };
        } else {
          return { p: [cell.topright, 1], x: 0, y: -1, o: 1 };
        }
      case 7:
        if (cval & Node3) {
          return { p: [cell.topright, 1], x: 0, y: -1, o: 1 };
        } else {
          return { p: [cell.bottomleft, 0], x: 0, y: 1, o: 0 };
        }
      case 8:
        if (cval & Node2) {
          return { p: [cell.bottomright, 0], x: 0, y: 1, o: 1 };
        } else {
          return { p: [1, cell.righttop], x: -1, y: 0, o: 1 };
        }
      case 9:
        if (cval & Node3) {
          return { p: [1, cell.righttop], x: -1, y: 0, o: 1 };
        } else {
          return { p: [cell.bottomleft, 0], x: 0, y: 1, o: 0 };
        }
      case 10:
        if (cval & Node3) {
          return { p: [0, cell.leftbottom], x: 1, y: 0, o: 0 };
        } else {
          return { p: [1, cell.righttop], x: -1, y: 0, o: 1 };
        }
      case 11:
        if (cval & Node0) {
          return { p: [1, cell.righttop], x: -1, y: 0, o: 1 };
        } else {
          return { p: [0, cell.lefttop], x: 1, y: 0, o: 1 };
        }
      case 12:
        if (cval & Node2) {
          return { p: [cell.bottomright, 0], x: 0, y: 1, o: 1 };
        } else {
          return { p: [1, cell.rightbottom], x: -1, y: 0, o: 0 };
        }
      case 13:
        if (cval & Node3) {
          return { p: [1, cell.rightbottom], x: -1, y: 0, o: 0 };
        } else {
          return { p: [cell.bottomleft, 0], x: 0, y: 1, o: 0 };
        }
      case 14:
        if (cval & Node3) {
          return { p: [0, cell.leftbottom], x: 1, y: 0, o: 0 };
        } else {
          return { p: [1, cell.rightbottom], x: -1, y: 0, o: 0 };
        }
      case 15:
        if (cval & Node0) {
          return { p: [1, cell.rightbottom], x: -1, y: 0, o: 0 };
        } else {
          return { p: [0, cell.lefttop], x: 1, y: 0, o: 1 };
        }
      case 16:
        if (cval & Node2) {
          return { p: [cell.bottomright, 0], x: 0, y: 1, o: 1 };
        } else {
          return { p: [0, cell.leftbottom], x: 1, y: 0, o: 0 };
        }
      case 17:
        if (cval & Node0) {
          return { p: [cell.bottomright, 0], x: 0, y: 1, o: 1 };
        } else {
          return { p: [0, cell.lefttop], x: 1, y: 0, o: 1 };
        }
      case 18:
        if (cval & Node3) {
          return { p: [0, cell.leftbottom], x: 1, y: 0, o: 0 };
        } else {
          return { p: [cell.bottomleft, 0], x: 0, y: 1, o: 0 };
        }
      case 19:
        if (cval & Node0) {
          return { p: [cell.bottomleft, 0], x: 0, y: 1, o: 0 };
        } else {
          return { p: [0, cell.lefttop], x: 1, y: 0, o: 1 };
        }
      case 20:
        if (cval & Node0) {
          return { p: [cell.topleft, 1], x: 0, y: -1, o: 0 };
        } else {
          return { p: [0, cell.leftbottom], x: 1, y: 0, o: 0 };
        }
      case 21:
        if (cval & Node1) {
          return { p: [0, cell.leftbottom], x: 1, y: 0, o: 0 };
        } else {
          return { p: [cell.topright, 1], x: 0, y: -1, o: 1 };
        }
      case 22:
        if (cval & Node0) {
          return { p: [cell.topleft, 1], x: 0, y: -1, o: 0 };
        } else {
          return { p: [0, cell.lefttop], x: 1, y: 0, o: 1 };
        }
      case 23:
        if (cval & Node1) {
          return { p: [0, cell.lefttop], x: 1, y: 0, o: 1 };
        } else {
          return { p: [cell.topright, 1], x: 0, y: -1, o: 1 };
        }
      default:
        console.log("MarchingSquaresJS-isoBands: edge index out of range!");
        console.log(cell);
        break;
    }
  }

  return null;
}

function getExitXY(cell, x, y, o) {
  var e,
    id_x,
    d_x,
    d_y,
    cval = cell.cval;
  var d_o;

  switch (x) {
    case -1:
      switch (o) {
        case 0:
          e = isoBandEdgeRB[cval];
          d_x = isoBandNextXRB[cval];
          d_y = isoBandNextYRB[cval];
          d_o = isoBandNextORB[cval];
          break;
        default:
          e = isoBandEdgeRT[cval];
          d_x = isoBandNextXRT[cval];
          d_y = isoBandNextYRT[cval];
          d_o = isoBandNextORT[cval];
          break;
      }
      break;
    case 1:
      switch (o) {
        case 0:
          e = isoBandEdgeLB[cval];
          d_x = isoBandNextXLB[cval];
          d_y = isoBandNextYLB[cval];
          d_o = isoBandNextOLB[cval];
          break;
        default:
          e = isoBandEdgeLT[cval];
          d_x = isoBandNextXLT[cval];
          d_y = isoBandNextYLT[cval];
          d_o = isoBandNextOLT[cval];
          break;
      }
      break;
    default:
      switch (y) {
        case -1:
          switch (o) {
            case 0:
              e = isoBandEdgeTL[cval];
              d_x = isoBandNextXTL[cval];
              d_y = isoBandNextYTL[cval];
              d_o = isoBandNextOTL[cval];
              break;
            default:
              e = isoBandEdgeTR[cval];
              d_x = isoBandNextXTR[cval];
              d_y = isoBandNextYTR[cval];
              d_o = isoBandNextOTR[cval];
              break;
          }
          break;
        case 1:
          switch (o) {
            case 0:
              e = isoBandEdgeBL[cval];
              d_x = isoBandNextXBL[cval];
              d_y = isoBandNextYBL[cval];
              d_o = isoBandNextOBL[cval];
              break;
            default:
              e = isoBandEdgeBR[cval];
              d_x = isoBandNextXBR[cval];
              d_y = isoBandNextYBR[cval];
              d_o = isoBandNextOBR[cval];
              break;
          }
          break;
      }
      break;
  }

  id_x = cell.edges.indexOf(e);
  if (typeof cell.edges[id_x] !== "undefined") {
    deleteEdge(cell, id_x);
  } else {
    //console.log("wrong edges...");
    //console.log(x + " " + y + " " + o);
    //console.log(cell);
    return null;
  }

  cval = cell.cval_real;

  switch (e) {
    case 0:
      if (cval & Node1) {
        /* node 1 within range */
        x = cell.topleft;
        y = 1;
      } else {
        /* node 1 below or above threshold */
        x = 1;
        y = cell.righttop;
      }
      break;
    case 1:
      if (cval & Node2) {
        x = 1;
        y = cell.rightbottom;
      } else {
        x = cell.topleft;
        y = 1;
      }
      break;
    case 2:
      if (cval & Node2) {
        x = cell.topleft;
        y = 1;
      } else {
        x = cell.bottomright;
        y = 0;
      }
      break;
    case 3:
      if (cval & Node3) {
        x = cell.bottomleft;
        y = 0;
      } else {
        x = cell.topleft;
        y = 1;
      }
      break;
    case 4:
      if (cval & Node1) {
        x = cell.topright;
        y = 1;
      } else {
        x = 1;
        y = cell.righttop;
      }
      break;
    case 5:
      if (cval & Node2) {
        x = 1;
        y = cell.rightbottom;
      } else {
        x = cell.topright;
        y = 1;
      }
      break;
    case 6:
      if (cval & Node2) {
        x = cell.topright;
        y = 1;
      } else {
        x = cell.bottomright;
        y = 0;
      }
      break;
    case 7:
      if (cval & Node3) {
        x = cell.bottomleft;
        y = 0;
      } else {
        x = cell.topright;
        y = 1;
      }
      break;
    case 8:
      if (cval & Node2) {
        x = 1;
        y = cell.righttop;
      } else {
        x = cell.bottomright;
        y = 0;
      }
      break;
    case 9:
      if (cval & Node3) {
        x = cell.bottomleft;
        y = 0;
      } else {
        x = 1;
        y = cell.righttop;
      }
      break;
    case 10:
      if (cval & Node3) {
        x = 1;
        y = cell.righttop;
      } else {
        x = 0;
        y = cell.leftbottom;
      }
      break;
    case 11:
      if (cval & Node0) {
        x = 0;
        y = cell.lefttop;
      } else {
        x = 1;
        y = cell.righttop;
      }
      break;
    case 12:
      if (cval & Node2) {
        x = 1;
        y = cell.rightbottom;
      } else {
        x = cell.bottomright;
        y = 0;
      }
      break;
    case 13:
      if (cval & Node3) {
        x = cell.bottomleft;
        y = 0;
      } else {
        x = 1;
        y = cell.rightbottom;
      }
      break;
    case 14:
      if (cval & Node3) {
        x = 1;
        y = cell.rightbottom;
      } else {
        x = 0;
        y = cell.leftbottom;
      }
      break;
    case 15:
      if (cval & Node0) {
        x = 0;
        y = cell.lefttop;
      } else {
        x = 1;
        y = cell.rightbottom;
      }
      break;
    case 16:
      if (cval & Node2) {
        x = 0;
        y = cell.leftbottom;
      } else {
        x = cell.bottomright;
        y = 0;
      }
      break;
    case 17:
      if (cval & Node0) {
        x = 0;
        y = cell.lefttop;
      } else {
        x = cell.bottomright;
        y = 0;
      }
      break;
    case 18:
      if (cval & Node3) {
        x = cell.bottomleft;
        y = 0;
      } else {
        x = 0;
        y = cell.leftbottom;
      }
      break;
    case 19:
      if (cval & Node0) {
        x = 0;
        y = cell.lefttop;
      } else {
        x = cell.bottomleft;
        y = 0;
      }
      break;
    case 20:
      if (cval & Node0) {
        x = 0;
        y = cell.leftbottom;
      } else {
        x = cell.topleft;
        y = 1;
      }
      break;
    case 21:
      if (cval & Node1) {
        x = cell.topright;
        y = 1;
      } else {
        x = 0;
        y = cell.leftbottom;
      }
      break;
    case 22:
      if (cval & Node0) {
        x = 0;
        y = cell.lefttop;
      } else {
        x = cell.topleft;
        y = 1;
      }
      break;
    case 23:
      if (cval & Node1) {
        x = cell.topright;
        y = 1;
      } else {
        x = 0;
        y = cell.lefttop;
      }
      break;
    default:
      console.log("MarchingSquaresJS-isoBands: edge index out of range!");
      console.log(cell);
      return null;
  }

  if (
    typeof x === "undefined" ||
    typeof y === "undefined" ||
    typeof d_x === "undefined" ||
    typeof d_y === "undefined" ||
    typeof d_o === "undefined"
  ) {
    console.log("MarchingSquaresJS-isoBands: undefined value!");
    console.log(cell);
    console.log(x + " " + y + " " + d_x + " " + d_y + " " + d_o);
  }
  return { p: [x, y], x: d_x, y: d_y, o: d_o };
}

function BandGrid2Areas(grid) {
  var areas = [];
  var area_idx = 0;

  grid.cells.forEach(function (g, j) {
    g.forEach(function (gg, i) {
      if (typeof gg !== "undefined") {
        var a = polygon_table[gg.cval](gg);
        if (typeof a === "object" && isArray(a)) {
          if (typeof a[0] === "object" && isArray(a[0])) {
            if (typeof a[0][0] === "object" && isArray(a[0][0])) {
              a.forEach(function (aa) {
                aa.forEach(function (aaa) {
                  aaa[0] += i;
                  aaa[1] += j;
                });
                areas[area_idx++] = aa;
              });
            } else {
              a.forEach(function (aa) {
                aa[0] += i;
                aa[1] += j;
              });
              areas[area_idx++] = a;
            }
          } else {
            console.log(
              "MarchingSquaresJS-isoBands: bandcell polygon with malformed coordinates"
            );
          }
        } else {
          console.log(
            "MarchingSquaresJS-isoBands: bandcell polygon with null coordinates"
          );
        }
      }
    });
  });

  return areas;
}

/**
 * Takes a square or rectangular grid {@link FeatureCollection} of {@link Point} features with z-values and an array of
 * value breaks and generates filled contour isobands.
 *
 * @name isobands
 * @param {FeatureCollection<Point>} pointGrid input points - must be square or rectangular
 * @param {Array<number>} breaks where to draw contours
 * @param {Object} [options={}] options on output
 * @param {string} [options.zProperty='elevation'] the property name in `points` from which z-values will be pulled
 * @param {Object} [options.commonProperties={}] GeoJSON properties passed to ALL isobands
 * @param {Array<Object>} [options.breaksProperties=[]] GeoJSON properties passed, in order, to the correspondent isoband (order defined by breaks)
 * @returns {FeatureCollection<MultiPolygon>} a FeatureCollection of {@link MultiPolygon} features representing isobands
 */
function isobands(pointGrid, breaks, options) {
  // Optional parameters
  options = options || {};
  if (!isobands_dist_es_isObject(options)) throw new Error("options is invalid");
  var zProperty = options.zProperty || "elevation";
  var commonProperties = options.commonProperties || {};
  var breaksProperties = options.breaksProperties || [];

  // Validation
  dist_es_collectionOf(pointGrid, "Point", "Input must contain Points");
  if (!breaks) throw new Error("breaks is required");
  if (!Array.isArray(breaks)) throw new Error("breaks is not an Array");
  if (!isobands_dist_es_isObject(commonProperties))
    throw new Error("commonProperties is not an Object");
  if (!Array.isArray(breaksProperties))
    throw new Error("breaksProperties is not an Array");

  // Isoband methods
  var matrix = es_gridToMatrix(pointGrid, { zProperty: zProperty, flip: true });
  var contours = createContourLines(matrix, breaks, zProperty);
  contours = rescaleContours(contours, matrix, pointGrid);

  var multipolygons = contours.map(function (contour, index) {
    if (breaksProperties[index] && !isobands_dist_es_isObject(breaksProperties[index])) {
      throw new Error("Each mappedProperty is required to be an Object");
    }
    // collect all properties
    var contourProperties = dist_es_objectAssign(
      {},
      commonProperties,
      breaksProperties[index]
    );
    contourProperties[zProperty] = contour[zProperty];
    var multiP = isobands_dist_es_multiPolygon(contour.groupedRings, contourProperties);
    return multiP;
  });

  return isobands_dist_es_featureCollection(multipolygons);
}

/**
 * Creates the contours lines (featuresCollection of polygon features) from the 2D data grid
 *
 * Marchingsquares process the grid data as a 3D representation of a function on a 2D plane, therefore it
 * assumes the points (x-y coordinates) are one 'unit' distance. The result of the IsoBands function needs to be
 * rescaled, with turfjs, to the original area and proportions on the map
 *
 * @private
 * @param {Array<Array<number>>} matrix Grid Data
 * @param {Array<number>} breaks Breaks
 * @param {string} [property='elevation'] Property
 * @returns {Array<any>} contours
 */
function createContourLines(matrix, breaks, property) {
  var contours = [];
  for (var i = 1; i < breaks.length; i++) {
    var lowerBand = +breaks[i - 1]; // make sure the breaks value is a number
    var upperBand = +breaks[i];

    var isobandsCoords = isoBands(matrix, lowerBand, upperBand - lowerBand);
    // as per GeoJson rules for creating a Polygon, make sure the first element
    // in the array of LinearRings represents the exterior ring (i.e. biggest area),
    // and any subsequent elements represent interior rings (i.e. smaller area);
    // this avoids rendering issues of the MultiPolygons on the map
    var nestedRings = orderByArea(isobandsCoords);
    var groupedRings = groupNestedRings(nestedRings);
    var obj = {};
    obj["groupedRings"] = groupedRings;
    obj[property] = lowerBand + "-" + upperBand;
    contours.push(obj);
  }
  return contours;
}

/**
 * Transform isobands of 2D grid to polygons for the map
 *
 * @private
 * @param {Array<any>} contours Contours
 * @param {Array<Array<number>>} matrix Grid Data
 * @param {Object} points Points by Latitude
 * @returns {Array<any>} contours
 */
function rescaleContours(contours, matrix, points) {
  // get dimensions (on the map) of the original grid
  var gridBbox = isobands_dist_es_bbox(points); // [ minX, minY, maxX, maxY ]
  var originalWidth = gridBbox[2] - gridBbox[0];
  var originalHeigth = gridBbox[3] - gridBbox[1];

  // get origin, which is the first point of the last row on the rectangular data on the map
  var x0 = gridBbox[0];
  var y0 = gridBbox[1];
  // get number of cells per side
  var matrixWidth = matrix[0].length - 1;
  var matrixHeight = matrix.length - 1;
  // calculate the scaling factor between matrix and rectangular grid on the map
  var scaleX = originalWidth / matrixWidth;
  var scaleY = originalHeigth / matrixHeight;

  var resize = function (point) {
    point[0] = point[0] * scaleX + x0;
    point[1] = point[1] * scaleY + y0;
  };

  // resize and shift each point/line of the isobands
  contours.forEach(function (contour) {
    contour.groupedRings.forEach(function (lineRingSet) {
      lineRingSet.forEach(function (lineRing) {
        lineRing.forEach(resize);
      });
    });
  });
  return contours;
}

/*  utility functions */

/**
 * Returns an array of coordinates (of LinearRings) in descending order by area
 *
 * @private
 * @param {Array<LineString>} ringsCoords array of closed LineString
 * @returns {Array} array of the input LineString ordered by area
 */
function orderByArea(ringsCoords) {
  var ringsWithArea = [];
  var areas = [];
  ringsCoords.forEach(function (coords) {
    // var poly = polygon([points]);
    var ringArea = isobands_dist_es_area(isobands_dist_es_polygon([coords]));
    // create an array of areas value
    areas.push(ringArea);
    // associate each lineRing with its area
    ringsWithArea.push({ ring: coords, area: ringArea });
  });
  areas.sort(function (a, b) {
    // bigger --> smaller
    return b - a;
  });
  // create a new array of linearRings coordinates ordered by their area
  var orderedByArea = [];
  areas.forEach(function (area) {
    for (var lr = 0; lr < ringsWithArea.length; lr++) {
      if (ringsWithArea[lr].area === area) {
        orderedByArea.push(ringsWithArea[lr].ring);
        ringsWithArea.splice(lr, 1);
        break;
      }
    }
  });
  return orderedByArea;
}

/**
 * Returns an array of arrays of coordinates, each representing
 * a set of (coordinates of) nested LinearRings,
 * i.e. the first ring contains all the others
 *
 * @private
 * @param {Array} orderedLinearRings array of coordinates (of LinearRings) in descending order by area
 * @returns {Array<Array>} Array of coordinates of nested LinearRings
 */
function groupNestedRings(orderedLinearRings) {
  // create a list of the (coordinates of) LinearRings
  var lrList = orderedLinearRings.map(function (lr) {
    return { lrCoordinates: lr, grouped: false };
  });
  var groupedLinearRingsCoords = [];
  while (!allGrouped(lrList)) {
    for (var i = 0; i < lrList.length; i++) {
      if (!lrList[i].grouped) {
        // create new group starting with the larger not already grouped ring
        var group = [];
        group.push(lrList[i].lrCoordinates);
        lrList[i].grouped = true;
        var outerMostPoly = isobands_dist_es_polygon([lrList[i].lrCoordinates]);
        // group all the rings contained by the outermost ring
        for (var j = i + 1; j < lrList.length; j++) {
          if (!lrList[j].grouped) {
            var lrPoly = isobands_dist_es_polygon([lrList[j].lrCoordinates]);
            if (isInside(lrPoly, outerMostPoly)) {
              group.push(lrList[j].lrCoordinates);
              lrList[j].grouped = true;
            }
          }
        }
        // insert the new group
        groupedLinearRingsCoords.push(group);
      }
    }
  }
  return groupedLinearRingsCoords;
}

/**
 * @private
 * @param {Polygon} testPolygon polygon of interest
 * @param {Polygon} targetPolygon polygon you want to compare with
 * @returns {boolean} true if test-Polygon is inside target-Polygon
 */
function isInside(testPolygon, targetPolygon) {
  var points = isobands_dist_es_explode(testPolygon);
  for (var i = 0; i < points.features.length; i++) {
    if (!isobands_dist_es_booleanPointInPolygon(points.features[i], targetPolygon)) {
      return false;
    }
  }
  return true;
}

/**
 * @private
 * @param {Array<Object>} list list of objects which might contain the 'group' attribute
 * @returns {boolean} true if all the objects in the list are marked as grouped
 */
function allGrouped(list) {
  for (var i = 0; i < list.length; i++) {
    if (list[i].grouped === false) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ const isobands_dist_es = ((/* unused pure expression or super */ null && (isobands)));

;// ../../node_modules/@turf/transform-rotate/dist/es/index.js
/* unused harmony import specifier */ var dist_es_centroid;
/* unused harmony import specifier */ var es_rhumbBearing;
/* unused harmony import specifier */ var es_rhumbDistance;
/* unused harmony import specifier */ var es_rhumbDestination;
/* unused harmony import specifier */ var transform_rotate_dist_es_clone;
/* unused harmony import specifier */ var transform_rotate_dist_es_coordEach;
/* unused harmony import specifier */ var transform_rotate_dist_es_getCoords;
/* unused harmony import specifier */ var transform_rotate_dist_es_isObject;









/**
 * Rotates any geojson Feature or Geometry of a specified angle, around its `centroid` or a given `pivot` point.
 *
 * @name transformRotate
 * @param {GeoJSON} geojson object to be rotated
 * @param {number} angle of rotation in decimal degrees, positive clockwise
 * @param {Object} [options={}] Optional parameters
 * @param {Coord} [options.pivot='centroid'] point around which the rotation will be performed
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} the rotated GeoJSON feature
 * @example
 * var poly = turf.polygon([[[0,29],[3.5,29],[2.5,32],[0,29]]]);
 * var options = {pivot: [0, 25]};
 * var rotatedPoly = turf.transformRotate(poly, 10, options);
 *
 * //addToMap
 * var addToMap = [poly, rotatedPoly];
 * rotatedPoly.properties = {stroke: '#F00', 'stroke-width': 4};
 */
function transformRotate(geojson, angle, options) {
  // Optional parameters
  options = options || {};
  if (!transform_rotate_dist_es_isObject(options)) throw new Error("options is invalid");
  var pivot = options.pivot;
  var mutate = options.mutate;

  // Input validation
  if (!geojson) throw new Error("geojson is required");
  if (angle === undefined || angle === null || isNaN(angle))
    throw new Error("angle is required");

  // Shortcut no-rotation
  if (angle === 0) return geojson;

  // Use centroid of GeoJSON if pivot is not provided
  if (!pivot) pivot = dist_es_centroid(geojson);

  // Clone geojson to avoid side effects
  if (mutate === false || mutate === undefined) geojson = transform_rotate_dist_es_clone(geojson);

  // Rotate each coordinate
  transform_rotate_dist_es_coordEach(geojson, function (pointCoords) {
    var initialAngle = es_rhumbBearing(pivot, pointCoords);
    var finalAngle = initialAngle + angle;
    var distance = es_rhumbDistance(pivot, pointCoords);
    var newCoords = transform_rotate_dist_es_getCoords(es_rhumbDestination(pivot, distance, finalAngle));
    pointCoords[0] = newCoords[0];
    pointCoords[1] = newCoords[1];
  });
  return geojson;
}

/* harmony default export */ const transform_rotate_dist_es = ((/* unused pure expression or super */ null && (transformRotate)));

;// ../../node_modules/@turf/transform-scale/dist/es/index.js
/* unused harmony import specifier */ var transform_scale_dist_es_clone;
/* unused harmony import specifier */ var es_center;
/* unused harmony import specifier */ var transform_scale_dist_es_centroid;
/* unused harmony import specifier */ var es_turfBBox;
/* unused harmony import specifier */ var dist_es_rhumbBearing;
/* unused harmony import specifier */ var dist_es_rhumbDistance;
/* unused harmony import specifier */ var dist_es_rhumbDestination;
/* unused harmony import specifier */ var transform_scale_dist_es_featureEach;
/* unused harmony import specifier */ var transform_scale_dist_es_coordEach;
/* unused harmony import specifier */ var transform_scale_dist_es_isObject;
/* unused harmony import specifier */ var transform_scale_dist_es_point;
/* unused harmony import specifier */ var transform_scale_dist_es_getType;
/* unused harmony import specifier */ var transform_scale_dist_es_getCoords;
/* unused harmony import specifier */ var transform_scale_dist_es_getCoord;











/**
 * Scale a GeoJSON from a given point by a factor of scaling (ex: factor=2 would make the GeoJSON 200% larger).
 * If a FeatureCollection is provided, the origin point will be calculated based on each individual Feature.
 *
 * @name transformScale
 * @param {GeoJSON} geojson GeoJSON to be scaled
 * @param {number} factor of scaling, positive or negative values greater than 0
 * @param {Object} [options={}] Optional parameters
 * @param {string|Coord} [options.origin='centroid'] Point from which the scaling will occur (string options: sw/se/nw/ne/center/centroid)
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} scaled GeoJSON
 * @example
 * var poly = turf.polygon([[[0,29],[3.5,29],[2.5,32],[0,29]]]);
 * var scaledPoly = turf.transformScale(poly, 3);
 *
 * //addToMap
 * var addToMap = [poly, scaledPoly];
 * scaledPoly.properties = {stroke: '#F00', 'stroke-width': 4};
 */
function transformScale(geojson, factor, options) {
  // Optional parameters
  options = options || {};
  if (!transform_scale_dist_es_isObject(options)) throw new Error("options is invalid");
  var origin = options.origin;
  var mutate = options.mutate;

  // Input validation
  if (!geojson) throw new Error("geojson required");
  if (typeof factor !== "number" || factor === 0)
    throw new Error("invalid factor");
  var originIsPoint = Array.isArray(origin) || typeof origin === "object";

  // Clone geojson to avoid side effects
  if (mutate !== true) geojson = transform_scale_dist_es_clone(geojson);

  // Scale each Feature separately
  if (geojson.type === "FeatureCollection" && !originIsPoint) {
    transform_scale_dist_es_featureEach(geojson, function (feature, index) {
      geojson.features[index] = es_scale(feature, factor, origin);
    });
    return geojson;
  }
  // Scale Feature/Geometry
  return es_scale(geojson, factor, origin);
}

/**
 * Scale Feature/Geometry
 *
 * @private
 * @param {Feature|Geometry} feature GeoJSON Feature/Geometry
 * @param {number} factor of scaling, positive or negative values greater than 0
 * @param {string|Coord} [origin="centroid"] Point from which the scaling will occur (string options: sw/se/nw/ne/center/centroid)
 * @returns {Feature|Geometry} scaled GeoJSON Feature/Geometry
 */
function es_scale(feature, factor, origin) {
  // Default params
  var isPoint = transform_scale_dist_es_getType(feature) === "Point";
  origin = defineOrigin(feature, origin);

  // Shortcut no-scaling
  if (factor === 1 || isPoint) return feature;

  // Scale each coordinate
  transform_scale_dist_es_coordEach(feature, function (coord) {
    var originalDistance = dist_es_rhumbDistance(origin, coord);
    var bearing = dist_es_rhumbBearing(origin, coord);
    var newDistance = originalDistance * factor;
    var newCoord = transform_scale_dist_es_getCoords(dist_es_rhumbDestination(origin, newDistance, bearing));
    coord[0] = newCoord[0];
    coord[1] = newCoord[1];
    if (coord.length === 3) coord[2] *= factor;
  });

  return feature;
}

/**
 * Define Origin
 *
 * @private
 * @param {GeoJSON} geojson GeoJSON
 * @param {string|Coord} origin sw/se/nw/ne/center/centroid
 * @returns {Feature<Point>} Point origin
 */
function defineOrigin(geojson, origin) {
  // Default params
  if (origin === undefined || origin === null) origin = "centroid";

  // Input Coord
  if (Array.isArray(origin) || typeof origin === "object")
    return transform_scale_dist_es_getCoord(origin);

  // Define BBox
  var bbox = geojson.bbox ? geojson.bbox : es_turfBBox(geojson);
  var west = bbox[0];
  var south = bbox[1];
  var east = bbox[2];
  var north = bbox[3];

  switch (origin) {
    case "sw":
    case "southwest":
    case "westsouth":
    case "bottomleft":
      return transform_scale_dist_es_point([west, south]);
    case "se":
    case "southeast":
    case "eastsouth":
    case "bottomright":
      return transform_scale_dist_es_point([east, south]);
    case "nw":
    case "northwest":
    case "westnorth":
    case "topleft":
      return transform_scale_dist_es_point([west, north]);
    case "ne":
    case "northeast":
    case "eastnorth":
    case "topright":
      return transform_scale_dist_es_point([east, north]);
    case "center":
      return es_center(geojson);
    case undefined:
    case null:
    case "centroid":
      return transform_scale_dist_es_centroid(geojson);
    default:
      throw new Error("invalid origin");
  }
}

/* harmony default export */ const transform_scale_dist_es = ((/* unused pure expression or super */ null && (transformScale)));

;// ../../node_modules/@turf/transform-translate/dist/es/index.js
/* unused harmony import specifier */ var transform_translate_dist_es_coordEach;
/* unused harmony import specifier */ var transform_translate_dist_es_isObject;
/* unused harmony import specifier */ var transform_translate_dist_es_getCoords;
/* unused harmony import specifier */ var transform_translate_dist_es_clone;
/* unused harmony import specifier */ var transform_translate_dist_es_rhumbDestination;






/**
 * Moves any geojson Feature or Geometry of a specified distance along a Rhumb Line
 * on the provided direction angle.
 *
 * @name transformTranslate
 * @param {GeoJSON} geojson object to be translated
 * @param {number} distance length of the motion; negative values determine motion in opposite direction
 * @param {number} direction of the motion; angle from North in decimal degrees, positive clockwise
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] in which `distance` will be express; miles, kilometers, degrees, or radians
 * @param {number} [options.zTranslation=0] length of the vertical motion, same unit of distance
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} the translated GeoJSON object
 * @example
 * var poly = turf.polygon([[[0,29],[3.5,29],[2.5,32],[0,29]]]);
 * var translatedPoly = turf.transformTranslate(poly, 100, 35);
 *
 * //addToMap
 * var addToMap = [poly, translatedPoly];
 * translatedPoly.properties = {stroke: '#F00', 'stroke-width': 4};
 */
function transformTranslate(geojson, distance, direction, options) {
  // Optional parameters
  options = options || {};
  if (!transform_translate_dist_es_isObject(options)) throw new Error("options is invalid");
  var units = options.units;
  var zTranslation = options.zTranslation;
  var mutate = options.mutate;

  // Input validation
  if (!geojson) throw new Error("geojson is required");
  if (distance === undefined || distance === null || isNaN(distance))
    throw new Error("distance is required");
  if (zTranslation && typeof zTranslation !== "number" && isNaN(zTranslation))
    throw new Error("zTranslation is not a number");

  // Shortcut no-motion
  zTranslation = zTranslation !== undefined ? zTranslation : 0;
  if (distance === 0 && zTranslation === 0) return geojson;

  if (direction === undefined || direction === null || isNaN(direction))
    throw new Error("direction is required");

  // Invert with negative distances
  if (distance < 0) {
    distance = -distance;
    direction = direction + 180;
  }

  // Clone geojson to avoid side effects
  if (mutate === false || mutate === undefined) geojson = transform_translate_dist_es_clone(geojson);

  // Translate each coordinate
  transform_translate_dist_es_coordEach(geojson, function (pointCoords) {
    var newCoords = transform_translate_dist_es_getCoords(
      transform_translate_dist_es_rhumbDestination(pointCoords, distance, direction, { units: units })
    );
    pointCoords[0] = newCoords[0];
    pointCoords[1] = newCoords[1];
    if (zTranslation && pointCoords.length === 3)
      pointCoords[2] += zTranslation;
  });
  return geojson;
}

/* harmony default export */ const transform_translate_dist_es = ((/* unused pure expression or super */ null && (transformTranslate)));

;// ../../node_modules/@turf/line-offset/dist/es/index.js
/* unused harmony import specifier */ var line_offset_dist_es_flattenEach;
/* unused harmony import specifier */ var line_offset_dist_es_getType;
/* unused harmony import specifier */ var line_offset_dist_es_getCoords;
/* unused harmony import specifier */ var line_offset_dist_es_isObject;
/* unused harmony import specifier */ var line_offset_dist_es_multiLineString;
/* unused harmony import specifier */ var es_lengthToDegrees;
/* unused harmony import specifier */ var line_offset_dist_es_lineString;




/**
 * https://github.com/rook2pawn/node-intersection
 *
 * Author @rook2pawn
 */

/**
 * AB
 *
 * @private
 * @param {Array<Array<number>>} segment - 2 vertex line segment
 * @returns {Array<number>} coordinates [x, y]
 */
function es_ab(segment) {
  var start = segment[0];
  var end = segment[1];
  return [end[0] - start[0], end[1] - start[1]];
}

/**
 * Cross Product
 *
 * @private
 * @param {Array<number>} v1 coordinates [x, y]
 * @param {Array<number>} v2 coordinates [x, y]
 * @returns {Array<number>} Cross Product
 */
function crossProduct(v1, v2) {
  return v1[0] * v2[1] - v2[0] * v1[1];
}

/**
 * Add
 *
 * @private
 * @param {Array<number>} v1 coordinates [x, y]
 * @param {Array<number>} v2 coordinates [x, y]
 * @returns {Array<number>} Add
 */
function add(v1, v2) {
  return [v1[0] + v2[0], v1[1] + v2[1]];
}

/**
 * Sub
 *
 * @private
 * @param {Array<number>} v1 coordinates [x, y]
 * @param {Array<number>} v2 coordinates [x, y]
 * @returns {Array<number>} Sub
 */
function sub(v1, v2) {
  return [v1[0] - v2[0], v1[1] - v2[1]];
}

/**
 * scalarMult
 *
 * @private
 * @param {number} s scalar
 * @param {Array<number>} v coordinates [x, y]
 * @returns {Array<number>} scalarMult
 */
function scalarMult(s, v) {
  return [s * v[0], s * v[1]];
}

/**
 * Intersect Segments
 *
 * @private
 * @param {Array<number>} a coordinates [x, y]
 * @param {Array<number>} b coordinates [x, y]
 * @returns {Array<number>} intersection
 */
function intersectSegments(a, b) {
  var p = a[0];
  var r = es_ab(a);
  var q = b[0];
  var s = es_ab(b);

  var cross = crossProduct(r, s);
  var qmp = sub(q, p);
  var numerator = crossProduct(qmp, s);
  var t = numerator / cross;
  var intersection = add(p, scalarMult(t, r));
  return intersection;
}

/**
 * Is Parallel
 *
 * @private
 * @param {Array<number>} a coordinates [x, y]
 * @param {Array<number>} b coordinates [x, y]
 * @returns {boolean} true if a and b are parallel (or co-linear)
 */
function isParallel(a, b) {
  var r = es_ab(a);
  var s = es_ab(b);
  return crossProduct(r, s) === 0;
}

/**
 * Intersection
 *
 * @private
 * @param {Array<number>} a coordinates [x, y]
 * @param {Array<number>} b coordinates [x, y]
 * @returns {Array<number>|boolean} true if a and b are parallel (or co-linear)
 */
function intersection(a, b) {
  if (isParallel(a, b)) return false;
  return intersectSegments(a, b);
}

/**
 * Takes a {@link LineString|line} and returns a {@link LineString|line} at offset by the specified distance.
 *
 * @name lineOffset
 * @param {Geometry|Feature<LineString|MultiLineString>} geojson input GeoJSON
 * @param {number} distance distance to offset the line (can be of negative value)
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, kilometers, inches, yards, meters
 * @returns {Feature<LineString|MultiLineString>} Line offset from the input line
 * @example
 * var line = turf.lineString([[-83, 30], [-84, 36], [-78, 41]], { "stroke": "#F00" });
 *
 * var offsetLine = turf.lineOffset(line, 2, {units: 'miles'});
 *
 * //addToMap
 * var addToMap = [offsetLine, line]
 * offsetLine.properties.stroke = "#00F"
 */
function lineOffset(geojson, distance, options) {
  // Optional parameters
  options = options || {};
  if (!line_offset_dist_es_isObject(options)) throw new Error("options is invalid");
  var units = options.units;

  // Valdiation
  if (!geojson) throw new Error("geojson is required");
  if (distance === undefined || distance === null || isNaN(distance))
    throw new Error("distance is required");

  var type = line_offset_dist_es_getType(geojson);
  var properties = geojson.properties;

  switch (type) {
    case "LineString":
      return lineOffsetFeature(geojson, distance, units);
    case "MultiLineString":
      var coords = [];
      line_offset_dist_es_flattenEach(geojson, function (feature) {
        coords.push(
          lineOffsetFeature(feature, distance, units).geometry.coordinates
        );
      });
      return line_offset_dist_es_multiLineString(coords, properties);
    default:
      throw new Error("geometry " + type + " is not supported");
  }
}

/**
 * Line Offset
 *
 * @private
 * @param {Geometry|Feature<LineString>} line input line
 * @param {number} distance distance to offset the line (can be of negative value)
 * @param {string} [units=kilometers] units
 * @returns {Feature<LineString>} Line offset from the input line
 */
function lineOffsetFeature(line, distance, units) {
  var segments = [];
  var offsetDegrees = es_lengthToDegrees(distance, units);
  var coords = line_offset_dist_es_getCoords(line);
  var finalCoords = [];
  coords.forEach(function (currentCoords, index) {
    if (index !== coords.length - 1) {
      var segment = processSegment(
        currentCoords,
        coords[index + 1],
        offsetDegrees
      );
      segments.push(segment);
      if (index > 0) {
        var seg2Coords = segments[index - 1];
        var intersects = intersection(segment, seg2Coords);

        // Handling for line segments that aren't straight
        if (intersects !== false) {
          seg2Coords[1] = intersects;
          segment[0] = intersects;
        }

        finalCoords.push(seg2Coords[0]);
        if (index === coords.length - 2) {
          finalCoords.push(segment[0]);
          finalCoords.push(segment[1]);
        }
      }
      // Handling for lines that only have 1 segment
      if (coords.length === 2) {
        finalCoords.push(segment[0]);
        finalCoords.push(segment[1]);
      }
    }
  });
  return line_offset_dist_es_lineString(finalCoords, line.properties);
}

/**
 * Process Segment
 * Inspiration taken from http://stackoverflow.com/questions/2825412/draw-a-parallel-line
 *
 * @private
 * @param {Array<number>} point1 Point coordinates
 * @param {Array<number>} point2 Point coordinates
 * @param {number} offset Offset
 * @returns {Array<Array<number>>} offset points
 */
function processSegment(point1, point2, offset) {
  var L = Math.sqrt(
    (point1[0] - point2[0]) * (point1[0] - point2[0]) +
      (point1[1] - point2[1]) * (point1[1] - point2[1])
  );

  var out1x = point1[0] + (offset * (point2[1] - point1[1])) / L;
  var out2x = point2[0] + (offset * (point2[1] - point1[1])) / L;
  var out1y = point1[1] + (offset * (point1[0] - point2[0])) / L;
  var out2y = point2[1] + (offset * (point1[0] - point2[0])) / L;
  return [
    [out1x, out1y],
    [out2x, out2y],
  ];
}

/* harmony default export */ const line_offset_dist_es = ((/* unused pure expression or super */ null && (lineOffset)));

;// ../../node_modules/@turf/polygonize/dist/es/lib/util.js


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign#Polyfill
function mathSign(x) {
    return ((x > 0) - (x < 0) || +x);
}
/**
 * Returns the direction of the point q relative to the vector p1 -> p2.
 *
 * Implementation of geos::algorithm::CGAlgorithm::orientationIndex()
 * (same as geos::algorithm::CGAlgorithm::computeOrientation())
 *
 * @param {number[]} p1 - the origin point of the vector
 * @param {number[]} p2 - the final point of the vector
 * @param {number[]} q - the point to compute the direction to
 *
 * @returns {number} - 1 if q is ccw (left) from p1->p2,
 *    -1 if q is cw (right) from p1->p2,
 *     0 if q is colinear with p1->p2
 */
function orientationIndex(p1, p2, q) {
    var dx1 = p2[0] - p1[0], dy1 = p2[1] - p1[1], dx2 = q[0] - p2[0], dy2 = q[1] - p2[1];
    return mathSign(dx1 * dy2 - dx2 * dy1);
}
/**
 * Checks if two envelopes are equal.
 *
 * The function assumes that the arguments are envelopes, i.e.: Rectangular polygon
 *
 * @param {Feature<Polygon>} env1 - Envelope
 * @param {Feature<Polygon>} env2 - Envelope
 * @returns {boolean} - True if the envelopes are equal
 */
function envelopeIsEqual(env1, env2) {
    var envX1 = env1.geometry.coordinates[0].map(function (c) { return c[0]; }), envY1 = env1.geometry.coordinates[0].map(function (c) { return c[1]; }), envX2 = env2.geometry.coordinates[0].map(function (c) { return c[0]; }), envY2 = env2.geometry.coordinates[0].map(function (c) { return c[1]; });
    return (Math.max.apply(null, envX1) === Math.max.apply(null, envX2) &&
        Math.max.apply(null, envY1) === Math.max.apply(null, envY2) &&
        Math.min.apply(null, envX1) === Math.min.apply(null, envX2) &&
        Math.min.apply(null, envY1) === Math.min.apply(null, envY2));
}
/**
 * Check if a envelope is contained in other one.
 *
 * The function assumes that the arguments are envelopes, i.e.: Convex polygon
 * XXX: Envelopes are rectangular, checking if a point is inside a rectangule is something easy,
 * this could be further improved.
 *
 * @param {Feature<Polygon>} self - Envelope
 * @param {Feature<Polygon>} env - Envelope
 * @returns {boolean} - True if env is contained in self
 */
function envelopeContains(self, env) {
    return env.geometry.coordinates[0].every(function (c) {
        return booleanPointInPolygon(point(c), self);
    });
}
/**
 * Checks if two coordinates are equal.
 *
 * @param {number[]} coord1 - First coordinate
 * @param {number[]} coord2 - Second coordinate
 * @returns {boolean} - True if coordinates are equal
 */
function coordinatesEqual(coord1, coord2) {
    return coord1[0] === coord2[0] && coord1[1] === coord2[1];
}

;// ../../node_modules/@turf/polygonize/dist/es/lib/Node.js

/**
 * Node
 */
var Node_Node = /** @class */ (function () {
    function Node(coordinates) {
        this.id = Node.buildId(coordinates);
        this.coordinates = coordinates; //< {Number[]}
        this.innerEdges = []; //< {Edge[]}
        // We wil store to (out) edges in an CCW order as geos::planargraph::DirectedEdgeStar does
        this.outerEdges = []; //< {Edge[]}
        this.outerEdgesSorted = false; //< {Boolean} flag that stores if the outer Edges had been sorted
    }
    Node.buildId = function (coordinates) {
        return coordinates.join(",");
    };
    Node.prototype.removeInnerEdge = function (edge) {
        this.innerEdges = this.innerEdges.filter(function (e) { return e.from.id !== edge.from.id; });
    };
    Node.prototype.removeOuterEdge = function (edge) {
        this.outerEdges = this.outerEdges.filter(function (e) { return e.to.id !== edge.to.id; });
    };
    /**
     * Outer edges are stored CCW order.
     *
     * @memberof Node
     * @param {Edge} edge - Edge to add as an outerEdge.
     */
    Node.prototype.addOuterEdge = function (edge) {
        this.outerEdges.push(edge);
        this.outerEdgesSorted = false;
    };
    /**
     * Sorts outer edges in CCW way.
     *
     * @memberof Node
     * @private
     */
    Node.prototype.sortOuterEdges = function () {
        var _this = this;
        if (!this.outerEdgesSorted) {
            //this.outerEdges.sort((a, b) => a.compareTo(b));
            // Using this comparator in order to be deterministic
            this.outerEdges.sort(function (a, b) {
                var aNode = a.to, bNode = b.to;
                if (aNode.coordinates[0] - _this.coordinates[0] >= 0 &&
                    bNode.coordinates[0] - _this.coordinates[0] < 0)
                    return 1;
                if (aNode.coordinates[0] - _this.coordinates[0] < 0 &&
                    bNode.coordinates[0] - _this.coordinates[0] >= 0)
                    return -1;
                if (aNode.coordinates[0] - _this.coordinates[0] === 0 &&
                    bNode.coordinates[0] - _this.coordinates[0] === 0) {
                    if (aNode.coordinates[1] - _this.coordinates[1] >= 0 ||
                        bNode.coordinates[1] - _this.coordinates[1] >= 0)
                        return aNode.coordinates[1] - bNode.coordinates[1];
                    return bNode.coordinates[1] - aNode.coordinates[1];
                }
                var det = orientationIndex(_this.coordinates, aNode.coordinates, bNode.coordinates);
                if (det < 0)
                    return 1;
                if (det > 0)
                    return -1;
                var d1 = Math.pow(aNode.coordinates[0] - _this.coordinates[0], 2) +
                    Math.pow(aNode.coordinates[1] - _this.coordinates[1], 2), d2 = Math.pow(bNode.coordinates[0] - _this.coordinates[0], 2) +
                    Math.pow(bNode.coordinates[1] - _this.coordinates[1], 2);
                return d1 - d2;
            });
            this.outerEdgesSorted = true;
        }
    };
    /**
     * Retrieves outer edges.
     *
     * They are sorted if they aren't in the CCW order.
     *
     * @memberof Node
     * @returns {Edge[]} - List of outer edges sorted in a CCW order.
     */
    Node.prototype.getOuterEdges = function () {
        this.sortOuterEdges();
        return this.outerEdges;
    };
    Node.prototype.getOuterEdge = function (i) {
        this.sortOuterEdges();
        return this.outerEdges[i];
    };
    Node.prototype.addInnerEdge = function (edge) {
        this.innerEdges.push(edge);
    };
    return Node;
}());
/* harmony default export */ const lib_Node = (Node_Node);

;// ../../node_modules/@turf/polygonize/dist/es/lib/Edge.js


/**
 * This class is inspired by GEOS's geos::operation::polygonize::PolygonizeDirectedEdge
 */
var Edge = /** @class */ (function () {
    /**
     * @param {Node} from - start node of the Edge
     * @param {Node} to - end node of the edge
     */
    function Edge(from, to) {
        this.from = from; //< start
        this.to = to; //< End
        this.next = undefined; //< The edge to be computed after
        this.label = undefined; //< Used in order to detect Cut Edges (Bridges)
        this.symetric = undefined; //< The symetric edge of this
        this.ring = undefined; //< EdgeRing in which the Edge is
        this.from.addOuterEdge(this);
        this.to.addInnerEdge(this);
    }
    /**
     * Creates or get the symetric Edge.
     *
     * @returns {Edge} - Symetric Edge.
     */
    Edge.prototype.getSymetric = function () {
        if (!this.symetric) {
            this.symetric = new Edge(this.to, this.from);
            this.symetric.symetric = this;
        }
        return this.symetric;
    };
    /**
     * Removes edge from from and to nodes.
     */
    Edge.prototype.deleteEdge = function () {
        this.from.removeOuterEdge(this);
        this.to.removeInnerEdge(this);
    };
    /**
     * Compares Edge equallity.
     *
     * An edge is equal to another, if the from and to nodes are the same.
     *
     * @param {Edge} edge - Another Edge
     * @returns {boolean} - True if Edges are equal, False otherwise
     */
    Edge.prototype.isEqual = function (edge) {
        return this.from.id === edge.from.id && this.to.id === edge.to.id;
    };
    Edge.prototype.toString = function () {
        return "Edge { " + this.from.id + " -> " + this.to.id + " }";
    };
    /**
     * Returns a LineString representation of the Edge
     *
     * @returns {Feature<LineString>} - LineString representation of the Edge
     */
    Edge.prototype.toLineString = function () {
        return lineString([this.from.coordinates, this.to.coordinates]);
    };
    /**
     * Comparator of two edges.
     *
     * Implementation of geos::planargraph::DirectedEdge::compareTo.
     *
     * @param {Edge} edge - Another edge to compare with this one
     * @returns {number} -1 if this Edge has a greater angle with the positive x-axis than b,
     *          0 if the Edges are colinear,
     *          1 otherwise
     */
    Edge.prototype.compareTo = function (edge) {
        return orientationIndex(edge.from.coordinates, edge.to.coordinates, this.to.coordinates);
    };
    return Edge;
}());
/* harmony default export */ const lib_Edge = (Edge);

;// ../../node_modules/@turf/polygonize/dist/es/lib/EdgeRing.js




/**
 * Ring of edges which form a polygon.
 *
 * The ring may be either an outer shell or a hole.
 *
 * This class is inspired in GEOS's geos::operation::polygonize::EdgeRing
 */
var EdgeRing = /** @class */ (function () {
    function EdgeRing() {
        this.edges = [];
        this.polygon = undefined; //< Caches Polygon representation
        this.envelope = undefined; //< Caches Envelope representation
    }
    /**
     * Add an edge to the ring, inserting it in the last position.
     *
     * @memberof EdgeRing
     * @param {Edge} edge - Edge to be inserted
     */
    EdgeRing.prototype.push = function (edge) {
        this.edges.push(edge);
        this.polygon = this.envelope = undefined;
    };
    /**
     * Get Edge.
     *
     * @memberof EdgeRing
     * @param {number} i - Index
     * @returns {Edge} - Edge in the i position
     */
    EdgeRing.prototype.get = function (i) {
        return this.edges[i];
    };
    Object.defineProperty(EdgeRing.prototype, "length", {
        /**
         * Getter of length property.
         *
         * @memberof EdgeRing
         * @returns {number} - Length of the edge ring.
         */
        get: function () {
            return this.edges.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Similar to Array.prototype.forEach for the list of Edges in the EdgeRing.
     *
     * @memberof EdgeRing
     * @param {Function} f - The same function to be passed to Array.prototype.forEach
     */
    EdgeRing.prototype.forEach = function (f) {
        this.edges.forEach(f);
    };
    /**
     * Similar to Array.prototype.map for the list of Edges in the EdgeRing.
     *
     * @memberof EdgeRing
     * @param {Function} f - The same function to be passed to Array.prototype.map
     * @returns {Array} - The mapped values in the function
     */
    EdgeRing.prototype.map = function (f) {
        return this.edges.map(f);
    };
    /**
     * Similar to Array.prototype.some for the list of Edges in the EdgeRing.
     *
     * @memberof EdgeRing
     * @param {Function} f - The same function to be passed to Array.prototype.some
     * @returns {boolean} - True if an Edge check the condition
     */
    EdgeRing.prototype.some = function (f) {
        return this.edges.some(f);
    };
    /**
     * Check if the ring is valid in geomtry terms.
     *
     * A ring must have either 0 or 4 or more points. The first and the last must be
     * equal (in 2D)
     * geos::geom::LinearRing::validateConstruction
     *
     * @memberof EdgeRing
     * @returns {boolean} - Validity of the EdgeRing
     */
    EdgeRing.prototype.isValid = function () {
        // TODO: stub
        return true;
    };
    /**
     * Tests whether this ring is a hole.
     *
     * A ring is a hole if it is oriented counter-clockwise.
     * Similar implementation of geos::algorithm::CGAlgorithms::isCCW
     *
     * @memberof EdgeRing
     * @returns {boolean} - true: if it is a hole
     */
    EdgeRing.prototype.isHole = function () {
        var _this = this;
        // XXX: Assuming Ring is valid
        // Find highest point
        var hiIndex = this.edges.reduce(function (high, edge, i) {
            if (edge.from.coordinates[1] > _this.edges[high].from.coordinates[1])
                high = i;
            return high;
        }, 0), iPrev = (hiIndex === 0 ? this.length : hiIndex) - 1, iNext = (hiIndex + 1) % this.length, disc = orientationIndex(this.edges[iPrev].from.coordinates, this.edges[hiIndex].from.coordinates, this.edges[iNext].from.coordinates);
        if (disc === 0)
            return (this.edges[iPrev].from.coordinates[0] >
                this.edges[iNext].from.coordinates[0]);
        return disc > 0;
    };
    /**
     * Creates a MultiPoint representing the EdgeRing (discarts edges directions).
     *
     * @memberof EdgeRing
     * @returns {Feature<MultiPoint>} - Multipoint representation of the EdgeRing
     */
    EdgeRing.prototype.toMultiPoint = function () {
        return multiPoint(this.edges.map(function (edge) { return edge.from.coordinates; }));
    };
    /**
     * Creates a Polygon representing the EdgeRing.
     *
     * @memberof EdgeRing
     * @returns {Feature<Polygon>} - Polygon representation of the Edge Ring
     */
    EdgeRing.prototype.toPolygon = function () {
        if (this.polygon)
            return this.polygon;
        var coordinates = this.edges.map(function (edge) { return edge.from.coordinates; });
        coordinates.push(this.edges[0].from.coordinates);
        return (this.polygon = polygon([coordinates]));
    };
    /**
     * Calculates the envelope of the EdgeRing.
     *
     * @memberof EdgeRing
     * @returns {Feature<Polygon>} - envelope
     */
    EdgeRing.prototype.getEnvelope = function () {
        if (this.envelope)
            return this.envelope;
        return (this.envelope = envelope_dist_es(this.toPolygon()));
    };
    /**
     * `geos::operation::polygonize::EdgeRing::findEdgeRingContaining`
     *
     * @param {EdgeRing} testEdgeRing - EdgeRing to look in the list
     * @param {EdgeRing[]} shellList - List of EdgeRing in which to search
     *
     * @returns {EdgeRing} - EdgeRing which contains the testEdgeRing
     */
    EdgeRing.findEdgeRingContaining = function (testEdgeRing, shellList) {
        var testEnvelope = testEdgeRing.getEnvelope();
        var minEnvelope, minShell;
        shellList.forEach(function (shell) {
            var tryEnvelope = shell.getEnvelope();
            if (minShell)
                minEnvelope = minShell.getEnvelope();
            // the hole envelope cannot equal the shell envelope
            if (envelopeIsEqual(tryEnvelope, testEnvelope))
                return;
            if (envelopeContains(tryEnvelope, testEnvelope)) {
                var testEdgeRingCoordinates = testEdgeRing.map(function (edge) { return edge.from.coordinates; });
                var testPoint = void 0;
                var _loop_1 = function (pt) {
                    if (!shell.some(function (edge) { return coordinatesEqual(pt, edge.from.coordinates); })) {
                        testPoint = pt;
                    }
                };
                for (var _i = 0, testEdgeRingCoordinates_1 = testEdgeRingCoordinates; _i < testEdgeRingCoordinates_1.length; _i++) {
                    var pt = testEdgeRingCoordinates_1[_i];
                    _loop_1(pt);
                }
                if (testPoint && shell.inside(point(testPoint))) {
                    if (!minShell || envelopeContains(minEnvelope, tryEnvelope))
                        minShell = shell;
                }
            }
        });
        return minShell;
    };
    /**
     * Checks if the point is inside the edgeRing
     *
     * @param {Feature<Point>} pt - Point to check if it is inside the edgeRing
     * @returns {boolean} - True if it is inside, False otherwise
     */
    EdgeRing.prototype.inside = function (pt) {
        return booleanPointInPolygon(pt, this.toPolygon());
    };
    return EdgeRing;
}());
/* harmony default export */ const lib_EdgeRing = (EdgeRing);

;// ../../node_modules/@turf/polygonize/dist/es/lib/Graph.js





/**
 * Validates the geoJson.
 *
 * @param {GeoJSON} geoJson - input geoJson.
 * @throws {Error} if geoJson is invalid.
 */
function validateGeoJson(geoJson) {
    if (!geoJson)
        throw new Error("No geojson passed");
    if (geoJson.type !== "FeatureCollection" &&
        geoJson.type !== "GeometryCollection" &&
        geoJson.type !== "MultiLineString" &&
        geoJson.type !== "LineString" &&
        geoJson.type !== "Feature")
        throw new Error("Invalid input type '" + geoJson.type + "'. Geojson must be FeatureCollection, GeometryCollection, LineString, MultiLineString or Feature");
}
/**
 * Represents a planar graph of edges and nodes that can be used to compute a polygonization.
 *
 * Although, this class is inspired by GEOS's `geos::operation::polygonize::PolygonizeGraph`,
 * it isn't a rewrite. As regards algorithm, this class implements the same logic, but it
 * isn't a javascript transcription of the C++ source.
 *
 * This graph is directed (both directions are created)
 */
var Graph = /** @class */ (function () {
    function Graph() {
        this.edges = []; //< {Edge[]} dirEdges
        // The key is the `id` of the Node (ie: coordinates.join(','))
        this.nodes = {};
    }
    /**
     * Creates a graph from a GeoJSON.
     *
     * @param {FeatureCollection<LineString>} geoJson - it must comply with the restrictions detailed in the index
     * @returns {Graph} - The newly created graph
     * @throws {Error} if geoJson is invalid.
     */
    Graph.fromGeoJson = function (geoJson) {
        validateGeoJson(geoJson);
        var graph = new Graph();
        flattenEach(geoJson, function (feature) {
            featureOf(feature, "LineString", "Graph::fromGeoJson");
            // When a LineString if formed by many segments, split them
            coordReduce(feature, function (prev, cur) {
                if (prev) {
                    var start = graph.getNode(prev), end = graph.getNode(cur);
                    graph.addEdge(start, end);
                }
                return cur;
            });
        });
        return graph;
    };
    /**
     * Creates or get a Node.
     *
     * @param {number[]} coordinates - Coordinates of the node
     * @returns {Node} - The created or stored node
     */
    Graph.prototype.getNode = function (coordinates) {
        var id = lib_Node.buildId(coordinates);
        var node = this.nodes[id];
        if (!node)
            node = this.nodes[id] = new lib_Node(coordinates);
        return node;
    };
    /**
     * Adds an Edge and its symetricall.
     *
     * Edges are added symetrically, i.e.: we also add its symetric
     *
     * @param {Node} from - Node which starts the Edge
     * @param {Node} to - Node which ends the Edge
     */
    Graph.prototype.addEdge = function (from, to) {
        var edge = new lib_Edge(from, to), symetricEdge = edge.getSymetric();
        this.edges.push(edge);
        this.edges.push(symetricEdge);
    };
    /**
     * Removes Dangle Nodes (nodes with grade 1).
     */
    Graph.prototype.deleteDangles = function () {
        var _this = this;
        Object.keys(this.nodes)
            .map(function (id) { return _this.nodes[id]; })
            .forEach(function (node) { return _this._removeIfDangle(node); });
    };
    /**
     * Check if node is dangle, if so, remove it.
     *
     * It calls itself recursively, removing a dangling node might cause another dangling node
     *
     * @param {Node} node - Node to check if it's a dangle
     */
    Graph.prototype._removeIfDangle = function (node) {
        var _this = this;
        // As edges are directed and symetrical, we count only innerEdges
        if (node.innerEdges.length <= 1) {
            var outerNodes = node.getOuterEdges().map(function (e) { return e.to; });
            this.removeNode(node);
            outerNodes.forEach(function (n) { return _this._removeIfDangle(n); });
        }
    };
    /**
     * Delete cut-edges (bridge edges).
     *
     * The graph will be traversed, all the edges will be labeled according the ring
     * in which they are. (The label is a number incremented by 1). Edges with the same
     * label are cut-edges.
     */
    Graph.prototype.deleteCutEdges = function () {
        var _this = this;
        this._computeNextCWEdges();
        this._findLabeledEdgeRings();
        // Cut-edges (bridges) are edges where both edges have the same label
        this.edges.forEach(function (edge) {
            if (edge.label === edge.symetric.label) {
                _this.removeEdge(edge.symetric);
                _this.removeEdge(edge);
            }
        });
    };
    /**
     * Set the `next` property of each Edge.
     *
     * The graph will be transversed in a CW form, so, we set the next of the symetrical edge as the previous one.
     * OuterEdges are sorted CCW.
     *
     * @param {Node} [node] - If no node is passed, the function calls itself for every node in the Graph
     */
    Graph.prototype._computeNextCWEdges = function (node) {
        var _this = this;
        if (typeof node === "undefined") {
            Object.keys(this.nodes).forEach(function (id) {
                return _this._computeNextCWEdges(_this.nodes[id]);
            });
        }
        else {
            node.getOuterEdges().forEach(function (edge, i) {
                node.getOuterEdge((i === 0 ? node.getOuterEdges().length : i) - 1).symetric.next = edge;
            });
        }
    };
    /**
     * Computes the next edge pointers going CCW around the given node, for the given edgering label.
     *
     * This algorithm has the effect of converting maximal edgerings into minimal edgerings
     *
     * XXX: method literally transcribed from `geos::operation::polygonize::PolygonizeGraph::computeNextCCWEdges`,
     * could be written in a more javascript way.
     *
     * @param {Node} node - Node
     * @param {number} label - Ring's label
     */
    Graph.prototype._computeNextCCWEdges = function (node, label) {
        var edges = node.getOuterEdges();
        var firstOutDE, prevInDE;
        for (var i = edges.length - 1; i >= 0; --i) {
            var de = edges[i], sym = de.symetric, outDE = void 0, inDE = void 0;
            if (de.label === label)
                outDE = de;
            if (sym.label === label)
                inDE = sym;
            if (!outDE || !inDE)
                // This edge is not in edgering
                continue;
            if (inDE)
                prevInDE = inDE;
            if (outDE) {
                if (prevInDE) {
                    prevInDE.next = outDE;
                    prevInDE = undefined;
                }
                if (!firstOutDE)
                    firstOutDE = outDE;
            }
        }
        if (prevInDE)
            prevInDE.next = firstOutDE;
    };
    /**
     * Finds rings and labels edges according to which rings are.
     *
     * The label is a number which is increased for each ring.
     *
     * @returns {Edge[]} edges that start rings
     */
    Graph.prototype._findLabeledEdgeRings = function () {
        var edgeRingStarts = [];
        var label = 0;
        this.edges.forEach(function (edge) {
            if (edge.label >= 0)
                return;
            edgeRingStarts.push(edge);
            var e = edge;
            do {
                e.label = label;
                e = e.next;
            } while (!edge.isEqual(e));
            label++;
        });
        return edgeRingStarts;
    };
    /**
     * Computes the EdgeRings formed by the edges in this graph.
     *
     * @returns {EdgeRing[]} - A list of all the EdgeRings in the graph.
     */
    Graph.prototype.getEdgeRings = function () {
        var _this = this;
        this._computeNextCWEdges();
        // Clear labels
        this.edges.forEach(function (edge) {
            edge.label = undefined;
        });
        this._findLabeledEdgeRings().forEach(function (edge) {
            // convertMaximalToMinimalEdgeRings
            _this._findIntersectionNodes(edge).forEach(function (node) {
                _this._computeNextCCWEdges(node, edge.label);
            });
        });
        var edgeRingList = [];
        // find all edgerings
        this.edges.forEach(function (edge) {
            if (edge.ring)
                return;
            edgeRingList.push(_this._findEdgeRing(edge));
        });
        return edgeRingList;
    };
    /**
     * Find all nodes in a Maxima EdgeRing which are self-intersection nodes.
     *
     * @param {Node} startEdge - Start Edge of the Ring
     * @returns {Node[]} - intersection nodes
     */
    Graph.prototype._findIntersectionNodes = function (startEdge) {
        var intersectionNodes = [];
        var edge = startEdge;
        var _loop_1 = function () {
            // getDegree
            var degree = 0;
            edge.from.getOuterEdges().forEach(function (e) {
                if (e.label === startEdge.label)
                    ++degree;
            });
            if (degree > 1)
                intersectionNodes.push(edge.from);
            edge = edge.next;
        };
        do {
            _loop_1();
        } while (!startEdge.isEqual(edge));
        return intersectionNodes;
    };
    /**
     * Get the edge-ring which starts from the provided Edge.
     *
     * @param {Edge} startEdge - starting edge of the edge ring
     * @returns {EdgeRing} - EdgeRing which start Edge is the provided one.
     */
    Graph.prototype._findEdgeRing = function (startEdge) {
        var edge = startEdge;
        var edgeRing = new lib_EdgeRing();
        do {
            edgeRing.push(edge);
            edge.ring = edgeRing;
            edge = edge.next;
        } while (!startEdge.isEqual(edge));
        return edgeRing;
    };
    /**
     * Removes a node from the Graph.
     *
     * It also removes edges asociated to that node
     * @param {Node} node - Node to be removed
     */
    Graph.prototype.removeNode = function (node) {
        var _this = this;
        node.getOuterEdges().forEach(function (edge) { return _this.removeEdge(edge); });
        node.innerEdges.forEach(function (edge) { return _this.removeEdge(edge); });
        delete this.nodes[node.id];
    };
    /**
     * Remove edge from the graph and deletes the edge.
     *
     * @param {Edge} edge - Edge to be removed
     */
    Graph.prototype.removeEdge = function (edge) {
        this.edges = this.edges.filter(function (e) { return !e.isEqual(edge); });
        edge.deleteEdge();
    };
    return Graph;
}());
/* harmony default export */ const lib_Graph = ((/* unused pure expression or super */ null && (Graph)));

;// ../../node_modules/@turf/polygonize/dist/es/index.js
/* unused harmony import specifier */ var polygonize_dist_es_featureCollection;
/* unused harmony import specifier */ var es_Graph;
/* unused harmony import specifier */ var es_EdgeRing;



/**
 * Polygonizes {@link LineString|(Multi)LineString(s)} into {@link Polygons}.
 *
 * Implementation of GEOSPolygonize function (`geos::operation::polygonize::Polygonizer`).
 *
 * Polygonizes a set of lines that represents edges in a planar graph. Edges must be correctly
 * noded, i.e., they must only meet at their endpoints.
 *
 * The implementation correctly handles:
 *
 * - Dangles: edges which have one or both ends which are not incident on another edge endpoint.
 * - Cut Edges (bridges): edges that are connected at both ends but which do not form part of a polygon.
 *
 * @name polygonize
 * @param {FeatureCollection|Geometry|Feature<LineString|MultiLineString>} geoJson Lines in order to polygonize
 * @returns {FeatureCollection<Polygon>} Polygons created
 * @throws {Error} if geoJson is invalid.
 */
function polygonize(geoJson) {
    var graph = es_Graph.fromGeoJson(geoJson);
    // 1. Remove dangle node
    graph.deleteDangles();
    // 2. Remove cut-edges (bridge edges)
    graph.deleteCutEdges();
    // 3. Get all holes and shells
    var holes = [], shells = [];
    graph
        .getEdgeRings()
        .filter(function (edgeRing) { return edgeRing.isValid(); })
        .forEach(function (edgeRing) {
        if (edgeRing.isHole())
            holes.push(edgeRing);
        else
            shells.push(edgeRing);
    });
    // 4. Assign Holes to Shells
    holes.forEach(function (hole) {
        if (es_EdgeRing.findEdgeRingContaining(hole, shells))
            shells.push(hole);
    });
    // 5. EdgeRings to Polygons
    return polygonize_dist_es_featureCollection(shells.map(function (shell) { return shell.toPolygon(); }));
}

;// ../../node_modules/@turf/boolean-disjoint/dist/es/index.js
/* unused harmony import specifier */ var boolean_disjoint_dist_es_booleanPointInPolygon;
/* unused harmony import specifier */ var dist_es_lineIntersect;
/* unused harmony import specifier */ var boolean_disjoint_dist_es_flattenEach;
/* unused harmony import specifier */ var es_polygonToLine;




/**
 * Boolean-disjoint returns (TRUE) if the intersection of the two geometries is an empty set.
 *
 * @name booleanDisjoint
 * @param {Geometry|Feature<any>} feature1 GeoJSON Feature or Geometry
 * @param {Geometry|Feature<any>} feature2 GeoJSON Feature or Geometry
 * @returns {boolean} true/false
 * @example
 * var point = turf.point([2, 2]);
 * var line = turf.lineString([[1, 1], [1, 2], [1, 3], [1, 4]]);
 *
 * turf.booleanDisjoint(line, point);
 * //=true
 */
function booleanDisjoint(feature1, feature2) {
    var bool = true;
    boolean_disjoint_dist_es_flattenEach(feature1, function (flatten1) {
        boolean_disjoint_dist_es_flattenEach(feature2, function (flatten2) {
            if (bool === false) {
                return false;
            }
            bool = disjoint(flatten1.geometry, flatten2.geometry);
        });
    });
    return bool;
}
/**
 * Disjoint operation for simple Geometries (Point/LineString/Polygon)
 *
 * @private
 * @param {Geometry<any>} geom1 GeoJSON Geometry
 * @param {Geometry<any>} geom2 GeoJSON Geometry
 * @returns {boolean} true/false
 */
function disjoint(geom1, geom2) {
    switch (geom1.type) {
        case "Point":
            switch (geom2.type) {
                case "Point":
                    return !es_compareCoords(geom1.coordinates, geom2.coordinates);
                case "LineString":
                    return !isPointOnLine(geom2, geom1);
                case "Polygon":
                    return !boolean_disjoint_dist_es_booleanPointInPolygon(geom1, geom2);
            }
            /* istanbul ignore next */
            break;
        case "LineString":
            switch (geom2.type) {
                case "Point":
                    return !isPointOnLine(geom1, geom2);
                case "LineString":
                    return !es_isLineOnLine(geom1, geom2);
                case "Polygon":
                    return !es_isLineInPoly(geom2, geom1);
            }
            /* istanbul ignore next */
            break;
        case "Polygon":
            switch (geom2.type) {
                case "Point":
                    return !boolean_disjoint_dist_es_booleanPointInPolygon(geom2, geom1);
                case "LineString":
                    return !es_isLineInPoly(geom1, geom2);
                case "Polygon":
                    return !es_isPolyInPoly(geom2, geom1);
            }
    }
    return false;
}
// http://stackoverflow.com/a/11908158/1979085
function isPointOnLine(lineString, pt) {
    for (var i = 0; i < lineString.coordinates.length - 1; i++) {
        if (dist_es_isPointOnLineSegment(lineString.coordinates[i], lineString.coordinates[i + 1], pt.coordinates)) {
            return true;
        }
    }
    return false;
}
function es_isLineOnLine(lineString1, lineString2) {
    var doLinesIntersect = dist_es_lineIntersect(lineString1, lineString2);
    if (doLinesIntersect.features.length > 0) {
        return true;
    }
    return false;
}
function es_isLineInPoly(polygon, lineString) {
    for (var _i = 0, _a = lineString.coordinates; _i < _a.length; _i++) {
        var coord = _a[_i];
        if (boolean_disjoint_dist_es_booleanPointInPolygon(coord, polygon)) {
            return true;
        }
    }
    var doLinesIntersect = dist_es_lineIntersect(lineString, es_polygonToLine(polygon));
    if (doLinesIntersect.features.length > 0) {
        return true;
    }
    return false;
}
/**
 * Is Polygon (geom1) in Polygon (geom2)
 * Only takes into account outer rings
 * See http://stackoverflow.com/a/4833823/1979085
 *
 * @private
 * @param {Geometry|Feature<Polygon>} feature1 Polygon1
 * @param {Geometry|Feature<Polygon>} feature2 Polygon2
 * @returns {boolean} true/false
 */
function es_isPolyInPoly(feature1, feature2) {
    for (var _i = 0, _a = feature1.coordinates[0]; _i < _a.length; _i++) {
        var coord1 = _a[_i];
        if (boolean_disjoint_dist_es_booleanPointInPolygon(coord1, feature2)) {
            return true;
        }
    }
    for (var _b = 0, _c = feature2.coordinates[0]; _b < _c.length; _b++) {
        var coord2 = _c[_b];
        if (boolean_disjoint_dist_es_booleanPointInPolygon(coord2, feature1)) {
            return true;
        }
    }
    var doLinesIntersect = dist_es_lineIntersect(es_polygonToLine(feature1), es_polygonToLine(feature2));
    if (doLinesIntersect.features.length > 0) {
        return true;
    }
    return false;
}
function dist_es_isPointOnLineSegment(lineSegmentStart, lineSegmentEnd, pt) {
    var dxc = pt[0] - lineSegmentStart[0];
    var dyc = pt[1] - lineSegmentStart[1];
    var dxl = lineSegmentEnd[0] - lineSegmentStart[0];
    var dyl = lineSegmentEnd[1] - lineSegmentStart[1];
    var cross = dxc * dyl - dyc * dxl;
    if (cross !== 0) {
        return false;
    }
    if (Math.abs(dxl) >= Math.abs(dyl)) {
        if (dxl > 0) {
            return lineSegmentStart[0] <= pt[0] && pt[0] <= lineSegmentEnd[0];
        }
        else {
            return lineSegmentEnd[0] <= pt[0] && pt[0] <= lineSegmentStart[0];
        }
    }
    else if (dyl > 0) {
        return lineSegmentStart[1] <= pt[1] && pt[1] <= lineSegmentEnd[1];
    }
    else {
        return lineSegmentEnd[1] <= pt[1] && pt[1] <= lineSegmentStart[1];
    }
}
/**
 * compareCoords
 *
 * @private
 * @param {Position} pair1 point [x,y]
 * @param {Position} pair2 point [x,y]
 * @returns {boolean} true/false if coord pairs match
 */
function es_compareCoords(pair1, pair2) {
    return pair1[0] === pair2[0] && pair1[1] === pair2[1];
}
/* harmony default export */ const boolean_disjoint_dist_es = ((/* unused pure expression or super */ null && (booleanDisjoint)));

;// ../../node_modules/@turf/boolean-contains/dist/es/index.js
/* unused harmony import specifier */ var dist_es_calcBbox;
/* unused harmony import specifier */ var boolean_contains_dist_es_booleanPointInPolygon;
/* unused harmony import specifier */ var es_isPointOnLine;
/* unused harmony import specifier */ var boolean_contains_dist_es_getGeom;




/**
 * Boolean-contains returns True if the second geometry is completely contained by the first geometry.
 * The interiors of both geometries must intersect and, the interior and boundary of the secondary (geometry b)
 * must not intersect the exterior of the primary (geometry a).
 * Boolean-contains returns the exact opposite result of the `@turf/boolean-within`.
 *
 * @name booleanContains
 * @param {Geometry|Feature<any>} feature1 GeoJSON Feature or Geometry
 * @param {Geometry|Feature<any>} feature2 GeoJSON Feature or Geometry
 * @returns {boolean} true/false
 * @example
 * var line = turf.lineString([[1, 1], [1, 2], [1, 3], [1, 4]]);
 * var point = turf.point([1, 2]);
 *
 * turf.booleanContains(line, point);
 * //=true
 */
function booleanContains(feature1, feature2) {
    var geom1 = boolean_contains_dist_es_getGeom(feature1);
    var geom2 = boolean_contains_dist_es_getGeom(feature2);
    var type1 = geom1.type;
    var type2 = geom2.type;
    var coords1 = geom1.coordinates;
    var coords2 = geom2.coordinates;
    switch (type1) {
        case "Point":
            switch (type2) {
                case "Point":
                    return dist_es_compareCoords(coords1, coords2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "MultiPoint":
            switch (type2) {
                case "Point":
                    return es_isPointInMultiPoint(geom1, geom2);
                case "MultiPoint":
                    return es_isMultiPointInMultiPoint(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "LineString":
            switch (type2) {
                case "Point":
                    return es_isPointOnLine(geom2, geom1, { ignoreEndVertices: true });
                case "LineString":
                    return dist_es_isLineOnLine(geom1, geom2);
                case "MultiPoint":
                    return es_isMultiPointOnLine(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "Polygon":
            switch (type2) {
                case "Point":
                    return boolean_contains_dist_es_booleanPointInPolygon(geom2, geom1, { ignoreBoundary: true });
                case "LineString":
                    return dist_es_isLineInPoly(geom1, geom2);
                case "Polygon":
                    return dist_es_isPolyInPoly(geom1, geom2);
                case "MultiPoint":
                    return es_isMultiPointInPoly(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        default:
            throw new Error("feature1 " + type1 + " geometry not supported");
    }
}
function es_isPointInMultiPoint(multiPoint, pt) {
    var i;
    var output = false;
    for (i = 0; i < multiPoint.coordinates.length; i++) {
        if (dist_es_compareCoords(multiPoint.coordinates[i], pt.coordinates)) {
            output = true;
            break;
        }
    }
    return output;
}
function es_isMultiPointInMultiPoint(multiPoint1, multiPoint2) {
    for (var _i = 0, _a = multiPoint2.coordinates; _i < _a.length; _i++) {
        var coord2 = _a[_i];
        var matchFound = false;
        for (var _b = 0, _c = multiPoint1.coordinates; _b < _c.length; _b++) {
            var coord1 = _c[_b];
            if (dist_es_compareCoords(coord2, coord1)) {
                matchFound = true;
                break;
            }
        }
        if (!matchFound) {
            return false;
        }
    }
    return true;
}
function es_isMultiPointOnLine(lineString, multiPoint) {
    var haveFoundInteriorPoint = false;
    for (var _i = 0, _a = multiPoint.coordinates; _i < _a.length; _i++) {
        var coord = _a[_i];
        if (es_isPointOnLine(coord, lineString, { ignoreEndVertices: true })) {
            haveFoundInteriorPoint = true;
        }
        if (!es_isPointOnLine(coord, lineString)) {
            return false;
        }
    }
    if (haveFoundInteriorPoint) {
        return true;
    }
    return false;
}
function es_isMultiPointInPoly(polygon, multiPoint) {
    for (var _i = 0, _a = multiPoint.coordinates; _i < _a.length; _i++) {
        var coord = _a[_i];
        if (!boolean_contains_dist_es_booleanPointInPolygon(coord, polygon, { ignoreBoundary: true })) {
            return false;
        }
    }
    return true;
}
function dist_es_isLineOnLine(lineString1, lineString2) {
    var haveFoundInteriorPoint = false;
    for (var _i = 0, _a = lineString2.coordinates; _i < _a.length; _i++) {
        var coords = _a[_i];
        if (es_isPointOnLine({ type: "Point", coordinates: coords }, lineString1, {
            ignoreEndVertices: true,
        })) {
            haveFoundInteriorPoint = true;
        }
        if (!es_isPointOnLine({ type: "Point", coordinates: coords }, lineString1, {
            ignoreEndVertices: false,
        })) {
            return false;
        }
    }
    return haveFoundInteriorPoint;
}
function dist_es_isLineInPoly(polygon, linestring) {
    var output = false;
    var i = 0;
    var polyBbox = dist_es_calcBbox(polygon);
    var lineBbox = dist_es_calcBbox(linestring);
    if (!es_doBBoxOverlap(polyBbox, lineBbox)) {
        return false;
    }
    for (i; i < linestring.coordinates.length - 1; i++) {
        var midPoint = es_getMidpoint(linestring.coordinates[i], linestring.coordinates[i + 1]);
        if (boolean_contains_dist_es_booleanPointInPolygon({ type: "Point", coordinates: midPoint }, polygon, {
            ignoreBoundary: true,
        })) {
            output = true;
            break;
        }
    }
    return output;
}
/**
 * Is Polygon2 in Polygon1
 * Only takes into account outer rings
 *
 * @private
 * @param {Geometry|Feature<Polygon>} feature1 Polygon1
 * @param {Geometry|Feature<Polygon>} feature2 Polygon2
 * @returns {boolean} true/false
 */
function dist_es_isPolyInPoly(feature1, feature2) {
    // Handle Nulls
    if (feature1.type === "Feature" && feature1.geometry === null) {
        return false;
    }
    if (feature2.type === "Feature" && feature2.geometry === null) {
        return false;
    }
    var poly1Bbox = dist_es_calcBbox(feature1);
    var poly2Bbox = dist_es_calcBbox(feature2);
    if (!es_doBBoxOverlap(poly1Bbox, poly2Bbox)) {
        return false;
    }
    var coords = boolean_contains_dist_es_getGeom(feature2).coordinates;
    for (var _i = 0, coords_1 = coords; _i < coords_1.length; _i++) {
        var ring = coords_1[_i];
        for (var _a = 0, ring_1 = ring; _a < ring_1.length; _a++) {
            var coord = ring_1[_a];
            if (!boolean_contains_dist_es_booleanPointInPolygon(coord, feature1)) {
                return false;
            }
        }
    }
    return true;
}
function es_doBBoxOverlap(bbox1, bbox2) {
    if (bbox1[0] > bbox2[0]) {
        return false;
    }
    if (bbox1[2] < bbox2[2]) {
        return false;
    }
    if (bbox1[1] > bbox2[1]) {
        return false;
    }
    if (bbox1[3] < bbox2[3]) {
        return false;
    }
    return true;
}
/**
 * compareCoords
 *
 * @private
 * @param {Position} pair1 point [x,y]
 * @param {Position} pair2 point [x,y]
 * @returns {boolean} true/false if coord pairs match
 */
function dist_es_compareCoords(pair1, pair2) {
    return pair1[0] === pair2[0] && pair1[1] === pair2[1];
}
function es_getMidpoint(pair1, pair2) {
    return [(pair1[0] + pair2[0]) / 2, (pair1[1] + pair2[1]) / 2];
}

;// ../../node_modules/@turf/boolean-crosses/dist/es/index.js
/* unused harmony import specifier */ var boolean_crosses_dist_es_lineIntersect;
/* unused harmony import specifier */ var dist_es_polygonToLine;
/* unused harmony import specifier */ var boolean_crosses_dist_es_booleanPointInPolygon;
/* unused harmony import specifier */ var boolean_crosses_dist_es_getGeom;
/* unused harmony import specifier */ var boolean_crosses_dist_es_point;





/**
 * Boolean-Crosses returns True if the intersection results in a geometry whose dimension is one less than
 * the maximum dimension of the two source geometries and the intersection set is interior to
 * both source geometries.
 *
 * Boolean-Crosses returns t (TRUE) for only multipoint/polygon, multipoint/linestring, linestring/linestring, linestring/polygon, and linestring/multipolygon comparisons.
 *
 * @name booleanCrosses
 * @param {Geometry|Feature<any>} feature1 GeoJSON Feature or Geometry
 * @param {Geometry|Feature<any>} feature2 GeoJSON Feature or Geometry
 * @returns {boolean} true/false
 * @example
 * var line1 = turf.lineString([[-2, 2], [4, 2]]);
 * var line2 = turf.lineString([[1, 1], [1, 2], [1, 3], [1, 4]]);
 *
 * var cross = turf.booleanCrosses(line1, line2);
 * //=true
 */
function booleanCrosses(feature1, feature2) {
    var geom1 = boolean_crosses_dist_es_getGeom(feature1);
    var geom2 = boolean_crosses_dist_es_getGeom(feature2);
    var type1 = geom1.type;
    var type2 = geom2.type;
    switch (type1) {
        case "MultiPoint":
            switch (type2) {
                case "LineString":
                    return doMultiPointAndLineStringCross(geom1, geom2);
                case "Polygon":
                    return doesMultiPointCrossPoly(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "LineString":
            switch (type2) {
                case "MultiPoint": // An inverse operation
                    return doMultiPointAndLineStringCross(geom2, geom1);
                case "LineString":
                    return doLineStringsCross(geom1, geom2);
                case "Polygon":
                    return doLineStringAndPolygonCross(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "Polygon":
            switch (type2) {
                case "MultiPoint": // An inverse operation
                    return doesMultiPointCrossPoly(geom2, geom1);
                case "LineString": // An inverse operation
                    return doLineStringAndPolygonCross(geom2, geom1);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        default:
            throw new Error("feature1 " + type1 + " geometry not supported");
    }
}
function doMultiPointAndLineStringCross(multiPoint, lineString) {
    var foundIntPoint = false;
    var foundExtPoint = false;
    var pointLength = multiPoint.coordinates.length;
    var i = 0;
    while (i < pointLength && !foundIntPoint && !foundExtPoint) {
        for (var i2 = 0; i2 < lineString.coordinates.length - 1; i2++) {
            var incEndVertices = true;
            if (i2 === 0 || i2 === lineString.coordinates.length - 2) {
                incEndVertices = false;
            }
            if (boolean_crosses_dist_es_isPointOnLineSegment(lineString.coordinates[i2], lineString.coordinates[i2 + 1], multiPoint.coordinates[i], incEndVertices)) {
                foundIntPoint = true;
            }
            else {
                foundExtPoint = true;
            }
        }
        i++;
    }
    return foundIntPoint && foundExtPoint;
}
function doLineStringsCross(lineString1, lineString2) {
    var doLinesIntersect = boolean_crosses_dist_es_lineIntersect(lineString1, lineString2);
    if (doLinesIntersect.features.length > 0) {
        for (var i = 0; i < lineString1.coordinates.length - 1; i++) {
            for (var i2 = 0; i2 < lineString2.coordinates.length - 1; i2++) {
                var incEndVertices = true;
                if (i2 === 0 || i2 === lineString2.coordinates.length - 2) {
                    incEndVertices = false;
                }
                if (boolean_crosses_dist_es_isPointOnLineSegment(lineString1.coordinates[i], lineString1.coordinates[i + 1], lineString2.coordinates[i2], incEndVertices)) {
                    return true;
                }
            }
        }
    }
    return false;
}
function doLineStringAndPolygonCross(lineString, polygon) {
    var line = dist_es_polygonToLine(polygon);
    var doLinesIntersect = boolean_crosses_dist_es_lineIntersect(lineString, line);
    if (doLinesIntersect.features.length > 0) {
        return true;
    }
    return false;
}
function doesMultiPointCrossPoly(multiPoint, polygon) {
    var foundIntPoint = false;
    var foundExtPoint = false;
    var pointLength = multiPoint.coordinates.length;
    for (var i = 0; i < pointLength && (!foundIntPoint || !foundExtPoint); i++) {
        if (boolean_crosses_dist_es_booleanPointInPolygon(boolean_crosses_dist_es_point(multiPoint.coordinates[i]), polygon)) {
            foundIntPoint = true;
        }
        else {
            foundExtPoint = true;
        }
    }
    return foundExtPoint && foundIntPoint;
}
/**
 * Is a point on a line segment
 * Only takes into account outer rings
 * See http://stackoverflow.com/a/4833823/1979085
 *
 * @private
 * @param {number[]} lineSegmentStart coord pair of start of line
 * @param {number[]} lineSegmentEnd coord pair of end of line
 * @param {number[]} pt coord pair of point to check
 * @param {boolean} incEnd whether the point is allowed to fall on the line ends
 * @returns {boolean} true/false
 */
function boolean_crosses_dist_es_isPointOnLineSegment(lineSegmentStart, lineSegmentEnd, pt, incEnd) {
    var dxc = pt[0] - lineSegmentStart[0];
    var dyc = pt[1] - lineSegmentStart[1];
    var dxl = lineSegmentEnd[0] - lineSegmentStart[0];
    var dyl = lineSegmentEnd[1] - lineSegmentStart[1];
    var cross = dxc * dyl - dyc * dxl;
    if (cross !== 0) {
        return false;
    }
    if (incEnd) {
        if (Math.abs(dxl) >= Math.abs(dyl)) {
            return dxl > 0
                ? lineSegmentStart[0] <= pt[0] && pt[0] <= lineSegmentEnd[0]
                : lineSegmentEnd[0] <= pt[0] && pt[0] <= lineSegmentStart[0];
        }
        return dyl > 0
            ? lineSegmentStart[1] <= pt[1] && pt[1] <= lineSegmentEnd[1]
            : lineSegmentEnd[1] <= pt[1] && pt[1] <= lineSegmentStart[1];
    }
    else {
        if (Math.abs(dxl) >= Math.abs(dyl)) {
            return dxl > 0
                ? lineSegmentStart[0] < pt[0] && pt[0] < lineSegmentEnd[0]
                : lineSegmentEnd[0] < pt[0] && pt[0] < lineSegmentStart[0];
        }
        return dyl > 0
            ? lineSegmentStart[1] < pt[1] && pt[1] < lineSegmentEnd[1]
            : lineSegmentEnd[1] < pt[1] && pt[1] < lineSegmentStart[1];
    }
}
/* harmony default export */ const boolean_crosses_dist_es = ((/* unused pure expression or super */ null && (booleanCrosses)));

// EXTERNAL MODULE: ../../node_modules/geojson-equality/index.js
var geojson_equality = __webpack_require__(3084);
;// ../../node_modules/@turf/boolean-overlap/dist/es/index.js
/* unused harmony import specifier */ var boolean_overlap_dist_es_segmentEach;
/* unused harmony import specifier */ var boolean_overlap_dist_es_getGeom;
/* unused harmony import specifier */ var es_lineOverlap;
/* unused harmony import specifier */ var boolean_overlap_dist_es_lineIntersect;
/* unused harmony import specifier */ var GeojsonEquality;





/**
 * Compares two geometries of the same dimension and returns true if their intersection set results in a geometry
 * different from both but of the same dimension. It applies to Polygon/Polygon, LineString/LineString,
 * Multipoint/Multipoint, MultiLineString/MultiLineString and MultiPolygon/MultiPolygon.
 *
 * In other words, it returns true if the two geometries overlap, provided that neither completely contains the other.
 *
 * @name booleanOverlap
 * @param  {Geometry|Feature<LineString|MultiLineString|Polygon|MultiPolygon>} feature1 input
 * @param  {Geometry|Feature<LineString|MultiLineString|Polygon|MultiPolygon>} feature2 input
 * @returns {boolean} true/false
 * @example
 * var poly1 = turf.polygon([[[0,0],[0,5],[5,5],[5,0],[0,0]]]);
 * var poly2 = turf.polygon([[[1,1],[1,6],[6,6],[6,1],[1,1]]]);
 * var poly3 = turf.polygon([[[10,10],[10,15],[15,15],[15,10],[10,10]]]);
 *
 * turf.booleanOverlap(poly1, poly2)
 * //=true
 * turf.booleanOverlap(poly2, poly3)
 * //=false
 */
function booleanOverlap(feature1, feature2) {
    var geom1 = boolean_overlap_dist_es_getGeom(feature1);
    var geom2 = boolean_overlap_dist_es_getGeom(feature2);
    var type1 = geom1.type;
    var type2 = geom2.type;
    if ((type1 === "MultiPoint" && type2 !== "MultiPoint") ||
        ((type1 === "LineString" || type1 === "MultiLineString") &&
            type2 !== "LineString" &&
            type2 !== "MultiLineString") ||
        ((type1 === "Polygon" || type1 === "MultiPolygon") &&
            type2 !== "Polygon" &&
            type2 !== "MultiPolygon")) {
        throw new Error("features must be of the same type");
    }
    if (type1 === "Point")
        throw new Error("Point geometry not supported");
    // features must be not equal
    var equality = new GeojsonEquality({ precision: 6 });
    if (equality.compare(feature1, feature2))
        return false;
    var overlap = 0;
    switch (type1) {
        case "MultiPoint":
            for (var i = 0; i < geom1.coordinates.length; i++) {
                for (var j = 0; j < geom2.coordinates.length; j++) {
                    var coord1 = geom1.coordinates[i];
                    var coord2 = geom2.coordinates[j];
                    if (coord1[0] === coord2[0] && coord1[1] === coord2[1]) {
                        return true;
                    }
                }
            }
            return false;
        case "LineString":
        case "MultiLineString":
            boolean_overlap_dist_es_segmentEach(feature1, function (segment1) {
                boolean_overlap_dist_es_segmentEach(feature2, function (segment2) {
                    if (es_lineOverlap(segment1, segment2).features.length)
                        overlap++;
                });
            });
            break;
        case "Polygon":
        case "MultiPolygon":
            boolean_overlap_dist_es_segmentEach(feature1, function (segment1) {
                boolean_overlap_dist_es_segmentEach(feature2, function (segment2) {
                    if (boolean_overlap_dist_es_lineIntersect(segment1, segment2).features.length)
                        overlap++;
                });
            });
            break;
    }
    return overlap > 0;
}

;// ../../node_modules/@turf/boolean-equal/dist/es/index.js
/* unused harmony import specifier */ var es_GeojsonEquality;
/* unused harmony import specifier */ var dist_es_cleanCoords;
/* unused harmony import specifier */ var boolean_equal_dist_es_getGeom;



/**
 * Determine whether two geometries of the same type have identical X,Y coordinate values.
 * See http://edndoc.esri.com/arcsde/9.0/general_topics/understand_spatial_relations.htm
 *
 * @name booleanEqual
 * @param {Geometry|Feature} feature1 GeoJSON input
 * @param {Geometry|Feature} feature2 GeoJSON input
 * @returns {boolean} true if the objects are equal, false otherwise
 * @example
 * var pt1 = turf.point([0, 0]);
 * var pt2 = turf.point([0, 0]);
 * var pt3 = turf.point([1, 1]);
 *
 * turf.booleanEqual(pt1, pt2);
 * //= true
 * turf.booleanEqual(pt2, pt3);
 * //= false
 */
function booleanEqual(feature1, feature2) {
    var type1 = boolean_equal_dist_es_getGeom(feature1).type;
    var type2 = boolean_equal_dist_es_getGeom(feature2).type;
    if (type1 !== type2)
        return false;
    var equality = new es_GeojsonEquality({ precision: 6 });
    return equality.compare(dist_es_cleanCoords(feature1), dist_es_cleanCoords(feature2));
}
/* harmony default export */ const boolean_equal_dist_es = ((/* unused pure expression or super */ null && (booleanEqual)));

;// ../../node_modules/@turf/boolean-intersects/dist/es/index.js
/* unused harmony import specifier */ var es_booleanDisjoint;
/* unused harmony import specifier */ var boolean_intersects_dist_es_flattenEach;


/**
 * Boolean-intersects returns (TRUE) two geometries intersect.
 *
 * @name booleanIntersects
 * @param {Geometry|Feature<any>} feature1 GeoJSON Feature or Geometry
 * @param {Geometry|Feature<any>} feature2 GeoJSON Feature or Geometry
 * @returns {boolean} true/false
 * @example
 * var point = turf.point([2, 2]);
 * var line = turf.lineString([[1, 1], [1, 2], [1, 3], [1, 4]]);
 *
 * turf.booleanIntersects(line, point);
 * //=true
 */
function booleanIntersects(feature1, feature2) {
    var bool = false;
    boolean_intersects_dist_es_flattenEach(feature1, function (flatten1) {
        boolean_intersects_dist_es_flattenEach(feature2, function (flatten2) {
            if (bool === true) {
                return true;
            }
            bool = !es_booleanDisjoint(flatten1.geometry, flatten2.geometry);
        });
    });
    return bool;
}

// EXTERNAL MODULE: ../../node_modules/density-clustering/lib/index.js
var lib = __webpack_require__(1631);
;// ../../node_modules/@turf/clusters-dbscan/dist/es/index.js
/* unused harmony import specifier */ var clusters_dbscan_dist_es_clone;
/* unused harmony import specifier */ var clusters_dbscan_dist_es_distance;
/* unused harmony import specifier */ var es_coordAll;
/* unused harmony import specifier */ var clusters_dbscan_dist_es_convertLength;
/* unused harmony import specifier */ var clustering;





/**
 * Takes a set of {@link Point|points} and partition them into clusters according to {@link DBSCAN's|https://en.wikipedia.org/wiki/DBSCAN} data clustering algorithm.
 *
 * @name clustersDbscan
 * @param {FeatureCollection<Point>} points to be clustered
 * @param {number} maxDistance Maximum Distance between any point of the cluster to generate the clusters (kilometers only)
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units="kilometers"] in which `maxDistance` is expressed, can be degrees, radians, miles, or kilometers
 * @param {boolean} [options.mutate=false] Allows GeoJSON input to be mutated
 * @param {number} [options.minPoints=3] Minimum number of points to generate a single cluster,
 * points which do not meet this requirement will be classified as an 'edge' or 'noise'.
 * @returns {FeatureCollection<Point>} Clustered Points with an additional two properties associated to each Feature:
 * - {number} cluster - the associated clusterId
 * - {string} dbscan - type of point it has been classified as ('core'|'edge'|'noise')
 * @example
 * // create random points with random z-values in their properties
 * var points = turf.randomPoint(100, {bbox: [0, 30, 20, 50]});
 * var maxDistance = 100;
 * var clustered = turf.clustersDbscan(points, maxDistance);
 *
 * //addToMap
 * var addToMap = [clustered];
 */
function clustersDbscan(points, maxDistance, options) {
    // Input validation being handled by Typescript
    // collectionOf(points, 'Point', 'points must consist of a FeatureCollection of only Points');
    // if (maxDistance === null || maxDistance === undefined) throw new Error('maxDistance is required');
    // if (!(Math.sign(maxDistance) > 0)) throw new Error('maxDistance is invalid');
    // if (!(minPoints === undefined || minPoints === null || Math.sign(minPoints) > 0)) throw new Error('options.minPoints is invalid');
    if (options === void 0) { options = {}; }
    // Clone points to prevent any mutations
    if (options.mutate !== true)
        points = clusters_dbscan_dist_es_clone(points);
    // Defaults
    options.minPoints = options.minPoints || 3;
    // create clustered ids
    var dbscan = new clustering.DBSCAN();
    var clusteredIds = dbscan.run(es_coordAll(points), clusters_dbscan_dist_es_convertLength(maxDistance, options.units), options.minPoints, clusters_dbscan_dist_es_distance);
    // Tag points to Clusters ID
    var clusterId = -1;
    clusteredIds.forEach(function (clusterIds) {
        clusterId++;
        // assign cluster ids to input points
        clusterIds.forEach(function (idx) {
            var clusterPoint = points.features[idx];
            if (!clusterPoint.properties)
                clusterPoint.properties = {};
            clusterPoint.properties.cluster = clusterId;
            clusterPoint.properties.dbscan = "core";
        });
    });
    // handle noise points, if any
    // edges points are tagged by DBSCAN as both 'noise' and 'cluster' as they can "reach" less than 'minPoints' number of points
    dbscan.noise.forEach(function (noiseId) {
        var noisePoint = points.features[noiseId];
        if (!noisePoint.properties)
            noisePoint.properties = {};
        if (noisePoint.properties.cluster)
            noisePoint.properties.dbscan = "edge";
        else
            noisePoint.properties.dbscan = "noise";
    });
    return points;
}
/* harmony default export */ const clusters_dbscan_dist_es = ((/* unused pure expression or super */ null && (clustersDbscan)));

// EXTERNAL MODULE: ../../node_modules/skmeans/dist/node/main.js
var main = __webpack_require__(3883);
;// ../../node_modules/@turf/clusters-kmeans/dist/es/index.js
/* unused harmony import specifier */ var clusters_kmeans_dist_es_clone;
/* unused harmony import specifier */ var dist_es_coordAll;
/* unused harmony import specifier */ var clusters_kmeans_dist_es_featureEach;
/* unused harmony import specifier */ var skmeans;



/**
 * Takes a set of {@link Point|points} and partition them into clusters using the k-mean .
 * It uses the [k-means algorithm](https://en.wikipedia.org/wiki/K-means_clustering)
 *
 * @name clustersKmeans
 * @param {FeatureCollection<Point>} points to be clustered
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.numberOfClusters=Math.sqrt(numberOfPoints/2)] numberOfClusters that will be generated
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {FeatureCollection<Point>} Clustered Points with an additional two properties associated to each Feature:
 * - {number} cluster - the associated clusterId
 * - {[number, number]} centroid - Centroid of the cluster [Longitude, Latitude]
 * @example
 * // create random points with random z-values in their properties
 * var points = turf.randomPoint(100, {bbox: [0, 30, 20, 50]});
 * var options = {numberOfClusters: 7};
 * var clustered = turf.clustersKmeans(points, options);
 *
 * //addToMap
 * var addToMap = [clustered];
 */
function clustersKmeans(points, options) {
    if (options === void 0) { options = {}; }
    // Default Params
    var count = points.features.length;
    options.numberOfClusters =
        options.numberOfClusters || Math.round(Math.sqrt(count / 2));
    // numberOfClusters can't be greater than the number of points
    // fallbacks to count
    if (options.numberOfClusters > count)
        options.numberOfClusters = count;
    // Clone points to prevent any mutations (enabled by default)
    if (options.mutate !== true)
        points = clusters_kmeans_dist_es_clone(points);
    // collect points coordinates
    var data = dist_es_coordAll(points);
    // create seed to avoid skmeans to drift
    var initialCentroids = data.slice(0, options.numberOfClusters);
    // create skmeans clusters
    var skmeansResult = skmeans(data, options.numberOfClusters, initialCentroids);
    // store centroids {clusterId: [number, number]}
    var centroids = {};
    skmeansResult.centroids.forEach(function (coord, idx) {
        centroids[idx] = coord;
    });
    // add associated cluster number
    clusters_kmeans_dist_es_featureEach(points, function (point, index) {
        var clusterId = skmeansResult.idxs[index];
        point.properties.cluster = clusterId;
        point.properties.centroid = centroids[clusterId];
    });
    return points;
}
/* harmony default export */ const clusters_kmeans_dist_es = ((/* unused pure expression or super */ null && (clustersKmeans)));

;// ../../node_modules/@turf/boolean-parallel/dist/es/index.js
/* unused harmony import specifier */ var boolean_parallel_dist_es_cleanCoords;
/* unused harmony import specifier */ var boolean_parallel_dist_es_lineSegment;
/* unused harmony import specifier */ var boolean_parallel_dist_es_rhumbBearing;
/* unused harmony import specifier */ var es_bearingToAzimuth;




/**
 * Boolean-Parallel returns True if each segment of `line1` is parallel to the correspondent segment of `line2`
 *
 * @name booleanParallel
 * @param {Geometry|Feature<LineString>} line1 GeoJSON Feature or Geometry
 * @param {Geometry|Feature<LineString>} line2 GeoJSON Feature or Geometry
 * @returns {boolean} true/false if the lines are parallel
 * @example
 * var line1 = turf.lineString([[0, 0], [0, 1]]);
 * var line2 = turf.lineString([[1, 0], [1, 1]]);
 *
 * turf.booleanParallel(line1, line2);
 * //=true
 */
function booleanParallel(line1, line2) {
    // validation
    if (!line1)
        throw new Error("line1 is required");
    if (!line2)
        throw new Error("line2 is required");
    var type1 = boolean_parallel_dist_es_getType(line1, "line1");
    if (type1 !== "LineString")
        throw new Error("line1 must be a LineString");
    var type2 = boolean_parallel_dist_es_getType(line2, "line2");
    if (type2 !== "LineString")
        throw new Error("line2 must be a LineString");
    var segments1 = boolean_parallel_dist_es_lineSegment(boolean_parallel_dist_es_cleanCoords(line1)).features;
    var segments2 = boolean_parallel_dist_es_lineSegment(boolean_parallel_dist_es_cleanCoords(line2)).features;
    for (var i = 0; i < segments1.length; i++) {
        var segment1 = segments1[i].geometry.coordinates;
        if (!segments2[i])
            break;
        var segment2 = segments2[i].geometry.coordinates;
        if (!es_isParallel(segment1, segment2))
            return false;
    }
    return true;
}
/**
 * Compares slopes and return result
 *
 * @private
 * @param {Geometry|Feature<LineString>} segment1 Geometry or Feature
 * @param {Geometry|Feature<LineString>} segment2 Geometry or Feature
 * @returns {boolean} if slopes are equal
 */
function es_isParallel(segment1, segment2) {
    var slope1 = es_bearingToAzimuth(boolean_parallel_dist_es_rhumbBearing(segment1[0], segment1[1]));
    var slope2 = es_bearingToAzimuth(boolean_parallel_dist_es_rhumbBearing(segment2[0], segment2[1]));
    return slope1 === slope2;
}
/**
 * Returns Feature's type
 *
 * @private
 * @param {Geometry|Feature<any>} geojson Geometry or Feature
 * @param {string} name of the variable
 * @returns {string} Feature's type
 */
function boolean_parallel_dist_es_getType(geojson, name) {
    if (geojson.geometry && geojson.geometry.type)
        return geojson.geometry.type;
    if (geojson.type)
        return geojson.type; // if GeoJSON geometry
    throw new Error("Invalid GeoJSON object for " + name);
}
/* harmony default export */ const boolean_parallel_dist_es = ((/* unused pure expression or super */ null && (booleanParallel)));

;// ../../node_modules/@turf/shortest-path/dist/es/index.js
/* unused harmony import specifier */ var shortest_path_dist_es_bbox;
/* unused harmony import specifier */ var shortest_path_dist_es_booleanPointInPolygon;
/* unused harmony import specifier */ var shortest_path_dist_es_distance;
/* unused harmony import specifier */ var dist_es_scale;
/* unused harmony import specifier */ var shortest_path_dist_es_cleanCoords;
/* unused harmony import specifier */ var es_bboxPolygon;
/* unused harmony import specifier */ var shortest_path_dist_es_getCoord;
/* unused harmony import specifier */ var shortest_path_dist_es_getType;
/* unused harmony import specifier */ var shortest_path_dist_es_getGeom;
/* unused harmony import specifier */ var shortest_path_dist_es_isObject;
/* unused harmony import specifier */ var shortest_path_dist_es_featureCollection;
/* unused harmony import specifier */ var dist_es_isNumber;
/* unused harmony import specifier */ var shortest_path_dist_es_point;
/* unused harmony import specifier */ var shortest_path_dist_es_lineString;
/* unused harmony import specifier */ var shortest_path_dist_es_feature;









// javascript-astar 0.4.1
// http://github.com/bgrins/javascript-astar
// Freely distributable under the MIT License.
// Implements the astar search algorithm in javascript using a Binary Heap.
// Includes Binary Heap (with modifications) from Marijn Haverbeke.
// http://eloquentjavascript.net/appendix2.html

function pathTo(node) {
  var curr = node,
    path = [];
  while (curr.parent) {
    path.unshift(curr);
    curr = curr.parent;
  }
  return path;
}

function getHeap() {
  return new BinaryHeap(function (node) {
    return node.f;
  });
}

/**
 * Astar
 * @private
 */
var astar = {
  /**
   * Perform an A* Search on a graph given a start and end node.
   *
   * @private
   * @memberof astar
   * @param {Graph} graph Graph
   * @param {GridNode} start Start
   * @param {GridNode} end End
   * @param {Object} [options] Options
   * @param {bool} [options.closest] Specifies whether to return the path to the closest node if the target is unreachable.
   * @param {Function} [options.heuristic] Heuristic function (see astar.heuristics).
   * @returns {Object} Search
   */
  search: function (graph, start, end, options) {
    graph.cleanDirty();
    options = options || {};
    var heuristic = options.heuristic || astar.heuristics.manhattan,
      closest = options.closest || false;

    var openHeap = getHeap(),
      closestNode = start; // set the start node to be the closest if required

    start.h = heuristic(start, end);

    openHeap.push(start);

    while (openHeap.size() > 0) {
      // Grab the lowest f(x) to process next.  Heap keeps this sorted for us.
      var currentNode = openHeap.pop();

      // End case -- result has been found, return the traced path.
      if (currentNode === end) {
        return pathTo(currentNode);
      }

      // Normal case -- move currentNode from open to closed, process each of its neighbors.
      currentNode.closed = true;

      // Find all neighbors for the current node.
      var neighbors = graph.neighbors(currentNode);

      for (var i = 0, il = neighbors.length; i < il; ++i) {
        var neighbor = neighbors[i];

        if (neighbor.closed || neighbor.isWall()) {
          // Not a valid node to process, skip to next neighbor.
          continue;
        }

        // The g score is the shortest distance from start to current node.
        // We need to check if the path we have arrived at this neighbor is the shortest one we have seen yet.
        var gScore = currentNode.g + neighbor.getCost(currentNode),
          beenVisited = neighbor.visited;

        if (!beenVisited || gScore < neighbor.g) {
          // Found an optimal (so far) path to this node.  Take score for node to see how good it is.
          neighbor.visited = true;
          neighbor.parent = currentNode;
          neighbor.h = neighbor.h || heuristic(neighbor, end);
          neighbor.g = gScore;
          neighbor.f = neighbor.g + neighbor.h;
          graph.markDirty(neighbor);
          if (closest) {
            // If the neighbour is closer than the current closestNode or if it's equally close but has
            // a cheaper path than the current closest node then it becomes the closest node
            if (
              neighbor.h < closestNode.h ||
              (neighbor.h === closestNode.h && neighbor.g < closestNode.g)
            ) {
              closestNode = neighbor;
            }
          }

          if (!beenVisited) {
            // Pushing to heap will put it in proper place based on the 'f' value.
            openHeap.push(neighbor);
          } else {
            // Already seen the node, but since it has been rescored we need to reorder it in the heap
            openHeap.rescoreElement(neighbor);
          }
        }
      }
    }

    if (closest) {
      return pathTo(closestNode);
    }

    // No result was found - empty array signifies failure to find path.
    return [];
  },
  // See list of heuristics: http://theory.stanford.edu/~amitp/GameProgramming/Heuristics.html
  heuristics: {
    manhattan: function (pos0, pos1) {
      var d1 = Math.abs(pos1.x - pos0.x);
      var d2 = Math.abs(pos1.y - pos0.y);
      return d1 + d2;
    },
    diagonal: function (pos0, pos1) {
      var D = 1;
      var D2 = Math.sqrt(2);
      var d1 = Math.abs(pos1.x - pos0.x);
      var d2 = Math.abs(pos1.y - pos0.y);
      return D * (d1 + d2) + (D2 - 2 * D) * Math.min(d1, d2);
    },
  },
  cleanNode: function (node) {
    node.f = 0;
    node.g = 0;
    node.h = 0;
    node.visited = false;
    node.closed = false;
    node.parent = null;
  },
};

/**
 * A graph memory structure
 *
 * @private
 * @param {Array} gridIn 2D array of input weights
 * @param {Object} [options] Options
 * @param {boolean} [options.diagonal] Specifies whether diagonal moves are allowed
 * @returns {void} Graph
 */
function dist_es_Graph(gridIn, options) {
  options = options || {};
  this.nodes = [];
  this.diagonal = !!options.diagonal;
  this.grid = [];
  for (var x = 0; x < gridIn.length; x++) {
    this.grid[x] = [];

    for (var y = 0, row = gridIn[x]; y < row.length; y++) {
      var node = new GridNode(x, y, row[y]);
      this.grid[x][y] = node;
      this.nodes.push(node);
    }
  }
  this.init();
}

dist_es_Graph.prototype.init = function () {
  this.dirtyNodes = [];
  for (var i = 0; i < this.nodes.length; i++) {
    astar.cleanNode(this.nodes[i]);
  }
};

dist_es_Graph.prototype.cleanDirty = function () {
  for (var i = 0; i < this.dirtyNodes.length; i++) {
    astar.cleanNode(this.dirtyNodes[i]);
  }
  this.dirtyNodes = [];
};

dist_es_Graph.prototype.markDirty = function (node) {
  this.dirtyNodes.push(node);
};

dist_es_Graph.prototype.neighbors = function (node) {
  var ret = [],
    x = node.x,
    y = node.y,
    grid = this.grid;

  // West
  if (grid[x - 1] && grid[x - 1][y]) {
    ret.push(grid[x - 1][y]);
  }

  // East
  if (grid[x + 1] && grid[x + 1][y]) {
    ret.push(grid[x + 1][y]);
  }

  // South
  if (grid[x] && grid[x][y - 1]) {
    ret.push(grid[x][y - 1]);
  }

  // North
  if (grid[x] && grid[x][y + 1]) {
    ret.push(grid[x][y + 1]);
  }

  if (this.diagonal) {
    // Southwest
    if (grid[x - 1] && grid[x - 1][y - 1]) {
      ret.push(grid[x - 1][y - 1]);
    }

    // Southeast
    if (grid[x + 1] && grid[x + 1][y - 1]) {
      ret.push(grid[x + 1][y - 1]);
    }

    // Northwest
    if (grid[x - 1] && grid[x - 1][y + 1]) {
      ret.push(grid[x - 1][y + 1]);
    }

    // Northeast
    if (grid[x + 1] && grid[x + 1][y + 1]) {
      ret.push(grid[x + 1][y + 1]);
    }
  }

  return ret;
};

dist_es_Graph.prototype.toString = function () {
  var graphString = [],
    nodes = this.grid, // when using grid
    rowDebug,
    row,
    y,
    l;
  for (var x = 0, len = nodes.length; x < len; x++) {
    rowDebug = [];
    row = nodes[x];
    for (y = 0, l = row.length; y < l; y++) {
      rowDebug.push(row[y].weight);
    }
    graphString.push(rowDebug.join(" "));
  }
  return graphString.join("\n");
};

function GridNode(x, y, weight) {
  this.x = x;
  this.y = y;
  this.weight = weight;
}

GridNode.prototype.toString = function () {
  return "[" + this.x + " " + this.y + "]";
};

GridNode.prototype.getCost = function (fromNeighbor) {
  // Take diagonal weight into consideration.
  if (fromNeighbor && fromNeighbor.x !== this.x && fromNeighbor.y !== this.y) {
    return this.weight * 1.41421;
  }
  return this.weight;
};

GridNode.prototype.isWall = function () {
  return this.weight === 0;
};

function BinaryHeap(scoreFunction) {
  this.content = [];
  this.scoreFunction = scoreFunction;
}

BinaryHeap.prototype = {
  push: function (element) {
    // Add the new element to the end of the array.
    this.content.push(element);

    // Allow it to sink down.
    this.sinkDown(this.content.length - 1);
  },
  pop: function () {
    // Store the first element so we can return it later.
    var result = this.content[0];
    // Get the element at the end of the array.
    var end = this.content.pop();
    // If there are any elements left, put the end element at the
    // start, and let it bubble up.
    if (this.content.length > 0) {
      this.content[0] = end;
      this.bubbleUp(0);
    }
    return result;
  },
  remove: function (node) {
    var i = this.content.indexOf(node);

    // When it is found, the process seen in 'pop' is repeated
    // to fill up the hole.
    var end = this.content.pop();

    if (i !== this.content.length - 1) {
      this.content[i] = end;

      if (this.scoreFunction(end) < this.scoreFunction(node)) {
        this.sinkDown(i);
      } else {
        this.bubbleUp(i);
      }
    }
  },
  size: function () {
    return this.content.length;
  },
  rescoreElement: function (node) {
    this.sinkDown(this.content.indexOf(node));
  },
  sinkDown: function (n) {
    // Fetch the element that has to be sunk.
    var element = this.content[n];

    // When at 0, an element can not sink any further.
    while (n > 0) {
      // Compute the parent element's index, and fetch it.
      var parentN = ((n + 1) >> 1) - 1,
        parent = this.content[parentN];
      // Swap the elements if the parent is greater.
      if (this.scoreFunction(element) < this.scoreFunction(parent)) {
        this.content[parentN] = element;
        this.content[n] = parent;
        // Update 'n' to continue at the new position.
        n = parentN;
        // Found a parent that is less, no need to sink any further.
      } else {
        break;
      }
    }
  },
  bubbleUp: function (n) {
    // Look up the target element and its score.
    var length = this.content.length,
      element = this.content[n],
      elemScore = this.scoreFunction(element);

    while (true) {
      // Compute the indices of the child elements.
      var child2N = (n + 1) << 1,
        child1N = child2N - 1;
      // This is used to store the new position of the element, if any.
      var swap = null,
        child1Score;
      // If the first child exists (is inside the array)...
      if (child1N < length) {
        // Look it up and compute its score.
        var child1 = this.content[child1N];
        child1Score = this.scoreFunction(child1);

        // If the score is less than our element's, we need to swap.
        if (child1Score < elemScore) {
          swap = child1N;
        }
      }

      // Do the same checks for the other child.
      if (child2N < length) {
        var child2 = this.content[child2N],
          child2Score = this.scoreFunction(child2);
        if (child2Score < (swap === null ? elemScore : child1Score)) {
          swap = child2N;
        }
      }

      // If the element needs to be moved, swap it, and continue.
      if (swap !== null) {
        this.content[n] = this.content[swap];
        this.content[swap] = element;
        n = swap;
        // Otherwise, we are done.
      } else {
        break;
      }
    }
  },
};

/**
 * Returns the shortest {@link LineString|path} from {@link Point|start} to {@link Point|end} without colliding with
 * any {@link Feature} in {@link FeatureCollection<Polygon>| obstacles}
 *
 * @name shortestPath
 * @param {Coord} start point
 * @param {Coord} end point
 * @param {Object} [options={}] optional parameters
 * @param {Geometry|Feature|FeatureCollection<Polygon>} [options.obstacles] areas which path cannot travel
 * @param {number} [options.minDistance] minimum distance between shortest path and obstacles
 * @param {string} [options.units='kilometers'] unit in which resolution & minimum distance will be expressed in; it can be degrees, radians, miles, kilometers, ...
 * @param {number} [options.resolution=100] distance between matrix points on which the path will be calculated
 * @returns {Feature<LineString>} shortest path between start and end
 * @example
 * var start = [-5, -6];
 * var end = [9, -6];
 * var options = {
 *   obstacles: turf.polygon([[[0, -7], [5, -7], [5, -3], [0, -3], [0, -7]]])
 * };
 *
 * var path = turf.shortestPath(start, end, options);
 *
 * //addToMap
 * var addToMap = [start, end, options.obstacles, path];
 */
function shortestPath(start, end, options) {
  // Optional parameters
  options = options || {};
  if (!shortest_path_dist_es_isObject(options)) throw new Error("options is invalid");
  var resolution = options.resolution;
  var minDistance = options.minDistance;
  var obstacles = options.obstacles || shortest_path_dist_es_featureCollection([]);

  // validation
  if (!start) throw new Error("start is required");
  if (!end) throw new Error("end is required");
  if ((resolution && !dist_es_isNumber(resolution)) || resolution <= 0)
    throw new Error("options.resolution must be a number, greater than 0");
  if (minDistance)
    throw new Error("options.minDistance is not yet implemented");

  // Normalize Inputs
  var startCoord = shortest_path_dist_es_getCoord(start);
  var endCoord = shortest_path_dist_es_getCoord(end);
  start = shortest_path_dist_es_point(startCoord);
  end = shortest_path_dist_es_point(endCoord);

  // Handle obstacles
  switch (shortest_path_dist_es_getType(obstacles)) {
    case "FeatureCollection":
      if (obstacles.features.length === 0)
        return shortest_path_dist_es_lineString([startCoord, endCoord]);
      break;
    case "Polygon":
      obstacles = shortest_path_dist_es_featureCollection([shortest_path_dist_es_feature(shortest_path_dist_es_getGeom(obstacles))]);
      break;
    default:
      throw new Error("invalid obstacles");
  }

  // define path grid area
  var collection = obstacles;
  collection.features.push(start);
  collection.features.push(end);
  var box = shortest_path_dist_es_bbox(dist_es_scale(es_bboxPolygon(shortest_path_dist_es_bbox(collection)), 1.15)); // extend 15%
  if (!resolution) {
    var width = shortest_path_dist_es_distance([box[0], box[1]], [box[2], box[1]], options);
    resolution = width / 100;
  }
  collection.features.pop();
  collection.features.pop();

  var west = box[0];
  var south = box[1];
  var east = box[2];
  var north = box[3];

  var xFraction = resolution / shortest_path_dist_es_distance([west, south], [east, south], options);
  var cellWidth = xFraction * (east - west);
  var yFraction = resolution / shortest_path_dist_es_distance([west, south], [west, north], options);
  var cellHeight = yFraction * (north - south);

  var bboxHorizontalSide = east - west;
  var bboxVerticalSide = north - south;
  var columns = Math.floor(bboxHorizontalSide / cellWidth);
  var rows = Math.floor(bboxVerticalSide / cellHeight);
  // adjust origin of the grid
  var deltaX = (bboxHorizontalSide - columns * cellWidth) / 2;
  var deltaY = (bboxVerticalSide - rows * cellHeight) / 2;

  // loop through points only once to speed up process
  // define matrix grid for A-star algorithm
  var pointMatrix = [];
  var matrix = [];

  var closestToStart = [];
  var closestToEnd = [];
  var minDistStart = Infinity;
  var minDistEnd = Infinity;
  var currentY = north - deltaY;
  var r = 0;
  while (currentY >= south) {
    // var currentY = south + deltaY;
    var matrixRow = [];
    var pointMatrixRow = [];
    var currentX = west + deltaX;
    var c = 0;
    while (currentX <= east) {
      var pt = shortest_path_dist_es_point([currentX, currentY]);
      var isInsideObstacle = es_isInside(pt, obstacles);
      // feed obstacles matrix
      matrixRow.push(isInsideObstacle ? 0 : 1); // with javascript-astar
      // matrixRow.push(isInsideObstacle ? 1 : 0); // with astar-andrea
      // map point's coords
      pointMatrixRow.push(currentX + "|" + currentY);
      // set closest points
      var distStart = shortest_path_dist_es_distance(pt, start);
      // if (distStart < minDistStart) {
      if (!isInsideObstacle && distStart < minDistStart) {
        minDistStart = distStart;
        closestToStart = { x: c, y: r };
      }
      var distEnd = shortest_path_dist_es_distance(pt, end);
      // if (distEnd < minDistEnd) {
      if (!isInsideObstacle && distEnd < minDistEnd) {
        minDistEnd = distEnd;
        closestToEnd = { x: c, y: r };
      }
      currentX += cellWidth;
      c++;
    }
    matrix.push(matrixRow);
    pointMatrix.push(pointMatrixRow);
    currentY -= cellHeight;
    r++;
  }

  // find path on matrix grid

  // javascript-astar ----------------------
  var graph = new dist_es_Graph(matrix, { diagonal: true });
  var startOnMatrix = graph.grid[closestToStart.y][closestToStart.x];
  var endOnMatrix = graph.grid[closestToEnd.y][closestToEnd.x];
  var result = astar.search(graph, startOnMatrix, endOnMatrix);

  var path = [startCoord];
  result.forEach(function (coord) {
    var coords = pointMatrix[coord.x][coord.y].split("|");
    path.push([+coords[0], +coords[1]]); // make sure coords are numbers
  });
  path.push(endCoord);
  // ---------------------------------------

  // astar-andrea ------------------------
  // var result = aStar(matrix, [closestToStart.x, closestToStart.y], [closestToEnd.x, closestToEnd.y], 'DiagonalFree');
  // var path = [start.geometry.coordinates];
  // result.forEach(function (coord) {
  //     var coords = pointMatrix[coord[1]][coord[0]].split('|');
  //     path.push([+coords[0], +coords[1]]); // make sure coords are numbers
  // });
  // path.push(end.geometry.coordinates);
  // ---------------------------------------

  return shortest_path_dist_es_cleanCoords(shortest_path_dist_es_lineString(path));
}

/**
 * Checks if Point is inside any of the Polygons
 *
 * @private
 * @param {Feature<Point>} pt to check
 * @param {FeatureCollection<Polygon>} polygons features
 * @returns {boolean} if inside or not
 */
function es_isInside(pt, polygons) {
  for (var i = 0; i < polygons.features.length; i++) {
    if (shortest_path_dist_es_booleanPointInPolygon(pt, polygons.features[i])) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ const shortest_path_dist_es = ((/* unused pure expression or super */ null && (shortestPath)));

;// ../../node_modules/d3-voronoi/src/RedBlackTree.js
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

/* harmony default export */ const src_RedBlackTree = (RedBlackTree);

;// ../../node_modules/d3-voronoi/src/Edge.js


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = edges.push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  cells[left.index].halfedges.push(index);
  cells[right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = edges.length,
      edge;

  while (i--) {
    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > Diagram_epsilon
            || Math.abs(edge[0][1] - edge[1][1]) > Diagram_epsilon)) {
      delete edges[i];
    }
  }
}

;// ../../node_modules/d3-voronoi/src/Cell.js



function createCell(site) {
  return cells[site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = cells.length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!edges[halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > Diagram_epsilon || Math.abs(endY - startY) > Diagram_epsilon) {
          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
              Math.abs(endX - x0) < Diagram_epsilon && y1 - endY > Diagram_epsilon ? [x0, Math.abs(startX - x0) < Diagram_epsilon ? startY : y1]
              : Math.abs(endY - y1) < Diagram_epsilon && x1 - endX > Diagram_epsilon ? [Math.abs(startY - y1) < Diagram_epsilon ? startX : x1, y1]
              : Math.abs(endX - x1) < Diagram_epsilon && endY - y0 > Diagram_epsilon ? [x1, Math.abs(startX - x1) < Diagram_epsilon ? startY : y0]
              : Math.abs(endY - y0) < Diagram_epsilon && endX - x0 > Diagram_epsilon ? [Math.abs(startY - y0) < Diagram_epsilon ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = cells[iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
        edges.push(createBorderEdge(site, v01, v11)) - 1,
        edges.push(createBorderEdge(site, v11, v10)) - 1,
        edges.push(createBorderEdge(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      if (!cell.halfedges.length) {
        delete cells[iCell];
      }
    }
  }
}

;// ../../node_modules/d3-voronoi/src/Circle.js



var circlePool = [];

var firstCircle;

function Circle() {
  RedBlackNode(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -epsilon2) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = circles._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  circles.insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    circles.remove(circle);
    circlePool.push(circle);
    RedBlackNode(circle);
    arc.circle = null;
  }
}

;// ../../node_modules/d3-voronoi/src/Beach.js






var beachPool = [];

function Beach() {
  RedBlackNode(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  detachCircle(beach);
  beaches.remove(beach);
  beachPool.push(beach);
  RedBlackNode(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < Diagram_epsilon
      && Math.abs(y - lArc.circle.cy) < Diagram_epsilon) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  detachCircle(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < Diagram_epsilon
      && Math.abs(y - rArc.circle.cy) < Diagram_epsilon) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  detachCircle(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);

  attachCircle(lArc);
  attachCircle(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = beaches._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > Diagram_epsilon) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > Diagram_epsilon) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -Diagram_epsilon) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -Diagram_epsilon) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  createCell(site);
  var newArc = createBeach(site);
  beaches.insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    detachCircle(lArc);
    rArc = createBeach(lArc.site);
    beaches.insert(newArc, rArc);
    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
    attachCircle(lArc);
    attachCircle(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = createEdge(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  detachCircle(lArc);
  detachCircle(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
  newArc.edge = createEdge(lSite, site, null, vertex);
  rArc.edge = createEdge(site, rSite, null, vertex);
  attachCircle(lArc);
  attachCircle(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}

;// ../../node_modules/d3-voronoi/src/Diagram.js






var Diagram_epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new src_RedBlackTree;
  circles = new src_RedBlackTree;

  while (true) {
    circle = firstCircle;
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        addBeach(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      removeBeach(circle.arc);
    } else {
      break;
    }
  }

  sortCellHalfedges();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    clipEdges(x0, y0, x1, y1);
    clipCells(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
}

;// ../../node_modules/d3-voronoi/src/voronoi.js
Object.defineProperty(voronoi, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var constant;
/* unused harmony import specifier */ var pointX;
/* unused harmony import specifier */ var pointY;
/* unused harmony import specifier */ var voronoi_Diagram;
/* unused harmony import specifier */ var voronoi_epsilon;




/* harmony default export */ function voronoi() {
  var x = pointX,
      y = pointY,
      extent = null;

  function voronoi(data) {
    return new voronoi_Diagram(data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / voronoi_epsilon) * voronoi_epsilon, Math.round(y(d, i, data) / voronoi_epsilon) * voronoi_epsilon];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
}

;// ../../node_modules/d3-voronoi/index.js


;// ../../node_modules/@turf/voronoi/dist/es/index.js
/* unused harmony import specifier */ var voronoi_dist_es_polygon;
/* unused harmony import specifier */ var voronoi_dist_es_isObject;
/* unused harmony import specifier */ var voronoi_dist_es_featureCollection;
/* unused harmony import specifier */ var voronoi_dist_es_collectionOf;
/* unused harmony import specifier */ var voronoi$1;




/**
 * @private
 * @param {Array<Array<number>>} coords representing a polygon
 * @returns {Feature<Polygon>} polygon
 */
function coordsToPolygon(coords) {
  coords = coords.slice();
  coords.push(coords[0]);
  return voronoi_dist_es_polygon([coords]);
}

/**
 * Takes a FeatureCollection of points, and a bounding box, and returns a FeatureCollection
 * of Voronoi polygons.
 *
 * The Voronoi algorithim used comes from the d3-voronoi package.
 *
 * @name voronoi
 * @param {FeatureCollection<Point>} points to find the Voronoi polygons around.
 * @param {Object} [options={}] Optional parameters
 * @param {number[]} [options.bbox=[-180, -85, 180, -85]] clipping rectangle, in [minX, minY, maxX, MaxY] order.
 * @returns {FeatureCollection<Polygon>} a set of polygons, one per input point.
 * @example
 * var options = {
 *   bbox: [-70, 40, -60, 60]
 * };
 * var points = turf.randomPoint(100, options);
 * var voronoiPolygons = turf.voronoi(points, options);
 *
 * //addToMap
 * var addToMap = [voronoiPolygons, points];
 */
function es_voronoi(points, options) {
  // Optional params
  options = options || {};
  if (!voronoi_dist_es_isObject(options)) throw new Error("options is invalid");
  var bbox = options.bbox || [-180, -85, 180, 85];

  // Input Validation
  if (!points) throw new Error("points is required");
  if (!Array.isArray(bbox)) throw new Error("bbox is invalid");
  voronoi_dist_es_collectionOf(points, "Point", "points");

  // Main
  return voronoi_dist_es_featureCollection(
    voronoi$1()
      .x(function (feature) {
        return feature.geometry.coordinates[0];
      })
      .y(function (feature) {
        return feature.geometry.coordinates[1];
      })
      .extent([
        [bbox[0], bbox[1]],
        [bbox[2], bbox[3]],
      ])
      .polygons(points.features)
      .map(coordsToPolygon)
  );
}

/* harmony default export */ const voronoi_dist_es = ((/* unused pure expression or super */ null && (es_voronoi)));

;// ../../node_modules/@turf/ellipse/dist/es/index.js
/* unused harmony import specifier */ var ellipse_dist_es_isObject;
/* unused harmony import specifier */ var ellipse_dist_es_isNumber;
/* unused harmony import specifier */ var ellipse_dist_es_degreesToRadians;
/* unused harmony import specifier */ var ellipse_dist_es_polygon;
/* unused harmony import specifier */ var ellipse_dist_es_rhumbDestination;
/* unused harmony import specifier */ var es_transformRotate;
/* unused harmony import specifier */ var ellipse_dist_es_getCoord;





/**
 * Takes a {@link Point} and calculates the ellipse polygon given two semi-axes expressed in variable units and steps for precision.
 *
 * @param {Coord} center center point
 * @param {number} xSemiAxis semi (major) axis of the ellipse along the x-axis
 * @param {number} ySemiAxis semi (minor) axis of the ellipse along the y-axis
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.angle=0] angle of rotation in decimal degrees, positive clockwise
 * @param {Coord} [options.pivot='origin'] point around which the rotation will be performed
 * @param {number} [options.steps=64] number of steps
 * @param {string} [options.units='kilometers'] unit of measurement for axes
 * @param {Object} [options.properties={}] properties
 * @returns {Feature<Polygon>} ellipse polygon
 * @example
 * var center = [-75, 40];
 * var xSemiAxis = 5;
 * var ySemiAxis = 2;
 * var ellipse = turf.ellipse(center, xSemiAxis, ySemiAxis);
 *
 * //addToMap
 * var addToMap = [turf.point(center), ellipse]
 */
function ellipse(center, xSemiAxis, ySemiAxis, options) {
  // Optional params
  options = options || {};
  var steps = options.steps || 64;
  var units = options.units || "kilometers";
  var angle = options.angle || 0;
  var pivot = options.pivot || center;
  var properties = options.properties || center.properties || {};

  // validation
  if (!center) throw new Error("center is required");
  if (!xSemiAxis) throw new Error("xSemiAxis is required");
  if (!ySemiAxis) throw new Error("ySemiAxis is required");
  if (!ellipse_dist_es_isObject(options)) throw new Error("options must be an object");
  if (!ellipse_dist_es_isNumber(steps)) throw new Error("steps must be a number");
  if (!ellipse_dist_es_isNumber(angle)) throw new Error("angle must be a number");

  var centerCoords = ellipse_dist_es_getCoord(center);
  if (units === "degrees") {
    var angleRad = ellipse_dist_es_degreesToRadians(angle);
  } else {
    xSemiAxis = ellipse_dist_es_rhumbDestination(center, xSemiAxis, 90, { units: units });
    ySemiAxis = ellipse_dist_es_rhumbDestination(center, ySemiAxis, 0, { units: units });
    xSemiAxis = ellipse_dist_es_getCoord(xSemiAxis)[0] - centerCoords[0];
    ySemiAxis = ellipse_dist_es_getCoord(ySemiAxis)[1] - centerCoords[1];
  }

  var coordinates = [];
  for (var i = 0; i < steps; i += 1) {
    var stepAngle = (i * -360) / steps;
    var x =
      (xSemiAxis * ySemiAxis) /
      Math.sqrt(
        Math.pow(ySemiAxis, 2) +
          Math.pow(xSemiAxis, 2) * Math.pow(getTanDeg(stepAngle), 2)
      );
    var y =
      (xSemiAxis * ySemiAxis) /
      Math.sqrt(
        Math.pow(xSemiAxis, 2) +
          Math.pow(ySemiAxis, 2) / Math.pow(getTanDeg(stepAngle), 2)
      );

    if (stepAngle < -90 && stepAngle >= -270) x = -x;
    if (stepAngle < -180 && stepAngle >= -360) y = -y;
    if (units === "degrees") {
      var newx = x * Math.cos(angleRad) + y * Math.sin(angleRad);
      var newy = y * Math.cos(angleRad) - x * Math.sin(angleRad);
      x = newx;
      y = newy;
    }

    coordinates.push([x + centerCoords[0], y + centerCoords[1]]);
  }
  coordinates.push(coordinates[0]);
  if (units === "degrees") {
    return ellipse_dist_es_polygon([coordinates], properties);
  } else {
    return es_transformRotate(ellipse_dist_es_polygon([coordinates], properties), angle, {
      pivot: pivot,
    });
  }
}

/**
 * Get Tan Degrees
 *
 * @private
 * @param {number} deg Degrees
 * @returns {number} Tan Degrees
 */
function getTanDeg(deg) {
  var rad = (deg * Math.PI) / 180;
  return Math.tan(rad);
}

/* harmony default export */ const ellipse_dist_es = ((/* unused pure expression or super */ null && (ellipse)));

;// ../../node_modules/@turf/center-mean/dist/es/index.js
/* unused harmony import specifier */ var center_mean_dist_es_geomEach;
/* unused harmony import specifier */ var center_mean_dist_es_coordEach;
/* unused harmony import specifier */ var center_mean_dist_es_isNumber;
/* unused harmony import specifier */ var center_mean_dist_es_point;


/**
 * Takes a {@link Feature} or {@link FeatureCollection} and returns the mean center. Can be weighted.
 *
 * @name centerMean
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] Translate GeoJSON Properties to Point
 * @param {Object} [options.bbox={}] Translate GeoJSON BBox to Point
 * @param {Object} [options.id={}] Translate GeoJSON Id to Point
 * @param {string} [options.weight] the property name used to weight the center
 * @returns {Feature<Point>} a Point feature at the mean center point of all input features
 * @example
 * var features = turf.featureCollection([
 *   turf.point([-97.522259, 35.4691], {value: 10}),
 *   turf.point([-97.502754, 35.463455], {value: 3}),
 *   turf.point([-97.508269, 35.463245], {value: 5})
 * ]);
 *
 * var options = {weight: "value"}
 * var mean = turf.centerMean(features, options);
 *
 * //addToMap
 * var addToMap = [features, mean]
 * mean.properties['marker-size'] = 'large';
 * mean.properties['marker-color'] = '#000';
 */
function centerMean(geojson, // To-Do include Typescript AllGeoJSON
options) {
    if (options === void 0) { options = {}; }
    var sumXs = 0;
    var sumYs = 0;
    var sumNs = 0;
    center_mean_dist_es_geomEach(geojson, function (geom, featureIndex, properties) {
        var weight = options.weight ? properties === null || properties === void 0 ? void 0 : properties[options.weight] : undefined;
        weight = weight === undefined || weight === null ? 1 : weight;
        if (!center_mean_dist_es_isNumber(weight))
            throw new Error("weight value must be a number for feature index " + featureIndex);
        weight = Number(weight);
        if (weight > 0) {
            center_mean_dist_es_coordEach(geom, function (coord) {
                sumXs += coord[0] * weight;
                sumYs += coord[1] * weight;
                sumNs += weight;
            });
        }
    });
    return center_mean_dist_es_point([sumXs / sumNs, sumYs / sumNs], options.properties, options);
}
/* harmony default export */ const center_mean_dist_es = ((/* unused pure expression or super */ null && (centerMean)));

;// ../../node_modules/@turf/center-median/dist/es/index.js
/* unused harmony import specifier */ var es_centerMean;
/* unused harmony import specifier */ var center_median_dist_es_distance;
/* unused harmony import specifier */ var center_median_dist_es_centroid;
/* unused harmony import specifier */ var center_median_dist_es_isObject;
/* unused harmony import specifier */ var center_median_dist_es_isNumber;
/* unused harmony import specifier */ var center_median_dist_es_featureCollection;
/* unused harmony import specifier */ var center_median_dist_es_point;
/* unused harmony import specifier */ var center_median_dist_es_featureEach;





/**
 * Takes a {@link FeatureCollection} of points and calculates the median center,
 * algorithimically. The median center is understood as the point that is
 * requires the least total travel from all other points.
 *
 * Turfjs has four different functions for calculating the center of a set of
 * data. Each is useful depending on circumstance.
 *
 * `@turf/center` finds the simple center of a dataset, by finding the
 * midpoint between the extents of the data. That is, it divides in half the
 * farthest east and farthest west point as well as the farthest north and
 * farthest south.
 *
 * `@turf/center-of-mass` imagines that the dataset is a sheet of paper.
 * The center of mass is where the sheet would balance on a fingertip.
 *
 * `@turf/center-mean` takes the averages of all the coordinates and
 * produces a value that respects that. Unlike `@turf/center`, it is
 * sensitive to clusters and outliers. It lands in the statistical middle of a
 * dataset, not the geographical. It can also be weighted, meaning certain
 * points are more important than others.
 *
 * `@turf/center-median` takes the mean center and tries to find, iteratively,
 * a new point that requires the least amount of travel from all the points in
 * the dataset. It is not as sensitive to outliers as `@turf/center-mean`, but it is
 * attracted to clustered data. It, too, can be weighted.
 *
 * **Bibliography**
 *
 * Harold W. Kuhn and Robert E. Kuenne, “An Efficient Algorithm for the
 * Numerical Solution of the Generalized Weber Problem in Spatial
 * Economics,” _Journal of Regional Science_ 4, no. 2 (1962): 21–33,
 * doi:{@link https://doi.org/10.1111/j.1467-9787.1962.tb00902.x}.
 *
 * James E. Burt, Gerald M. Barber, and David L. Rigby, _Elementary
 * Statistics for Geographers_, 3rd ed., New York: The Guilford
 * Press, 2009, 150–151.
 *
 * @name centerMedian
 * @param {FeatureCollection<any>} features Any GeoJSON Feature Collection
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.weight] the property name used to weight the center
 * @param {number} [options.tolerance=0.001] the difference in distance between candidate medians at which point the algorighim stops iterating.
 * @param {number} [options.counter=10] how many attempts to find the median, should the tolerance be insufficient.
 * @returns {Feature<Point>} The median center of the collection
 * @example
 * var points = turf.points([[0, 0], [1, 0], [0, 1], [5, 8]]);
 * var medianCenter = turf.centerMedian(points);
 *
 * //addToMap
 * var addToMap = [points, medianCenter]
 */
function centerMedian(features, options) {
    if (options === void 0) { options = {}; }
    // Optional params
    options = options || {};
    if (!center_median_dist_es_isObject(options))
        throw new Error("options is invalid");
    var counter = options.counter || 10;
    if (!center_median_dist_es_isNumber(counter))
        throw new Error("counter must be a number");
    var weightTerm = options.weight;
    // Calculate mean center:
    var meanCenter = es_centerMean(features, { weight: options.weight });
    // Calculate center of every feature:
    var centroids = center_median_dist_es_featureCollection([]);
    center_median_dist_es_featureEach(features, function (feature) {
        var _a;
        centroids.features.push(center_median_dist_es_centroid(feature, {
            properties: { weight: (_a = feature.properties) === null || _a === void 0 ? void 0 : _a[weightTerm] },
        }));
    });
    var properties = {
        tolerance: options.tolerance,
        medianCandidates: [],
    };
    return findMedian(meanCenter.geometry.coordinates, [0, 0], centroids, properties, counter);
}
/**
 * Recursive function to find new candidate medians.
 *
 * @private
 * @param {Position} candidateMedian current candidate median
 * @param {Position} previousCandidate the previous candidate median
 * @param {FeatureCollection<Point>} centroids the collection of centroids whose median we are determining
 * @param {number} counter how many attempts to try before quitting.
 * @returns {Feature<Point>} the median center of the dataset.
 */
function findMedian(candidateMedian, previousCandidate, centroids, properties, counter) {
    var tolerance = properties.tolerance || 0.001;
    var candidateXsum = 0;
    var candidateYsum = 0;
    var kSum = 0;
    var centroidCount = 0;
    center_median_dist_es_featureEach(centroids, function (theCentroid) {
        var _a;
        var weightValue = (_a = theCentroid.properties) === null || _a === void 0 ? void 0 : _a.weight;
        var weight = weightValue === undefined || weightValue === null ? 1 : weightValue;
        weight = Number(weight);
        if (!center_median_dist_es_isNumber(weight))
            throw new Error("weight value must be a number");
        if (weight > 0) {
            centroidCount += 1;
            var distanceFromCandidate = weight * center_median_dist_es_distance(theCentroid, candidateMedian);
            if (distanceFromCandidate === 0)
                distanceFromCandidate = 1;
            var k = weight / distanceFromCandidate;
            candidateXsum += theCentroid.geometry.coordinates[0] * k;
            candidateYsum += theCentroid.geometry.coordinates[1] * k;
            kSum += k;
        }
    });
    if (centroidCount < 1)
        throw new Error("no features to measure");
    var candidateX = candidateXsum / kSum;
    var candidateY = candidateYsum / kSum;
    if (centroidCount === 1 ||
        counter === 0 ||
        (Math.abs(candidateX - previousCandidate[0]) < tolerance &&
            Math.abs(candidateY - previousCandidate[1]) < tolerance)) {
        return center_median_dist_es_point([candidateX, candidateY], {
            medianCandidates: properties.medianCandidates,
        });
    }
    else {
        properties.medianCandidates.push([candidateX, candidateY]);
        return findMedian([candidateX, candidateY], candidateMedian, centroids, properties, counter - 1);
    }
}
/* harmony default export */ const center_median_dist_es = ((/* unused pure expression or super */ null && (centerMedian)));

;// ../../node_modules/@turf/standard-deviational-ellipse/dist/es/index.js
/* unused harmony import specifier */ var standard_deviational_ellipse_dist_es_coordAll;
/* unused harmony import specifier */ var standard_deviational_ellipse_dist_es_featureEach;
/* unused harmony import specifier */ var standard_deviational_ellipse_dist_es_getCoords;
/* unused harmony import specifier */ var standard_deviational_ellipse_dist_es_isObject;
/* unused harmony import specifier */ var standard_deviational_ellipse_dist_es_isNumber;
/* unused harmony import specifier */ var standard_deviational_ellipse_dist_es_featureCollection;
/* unused harmony import specifier */ var dist_es_centerMean;
/* unused harmony import specifier */ var es_pointsWithinPolygon;
/* unused harmony import specifier */ var es_ellipse;







/**
 * Takes a {@link FeatureCollection} and returns a standard deviational ellipse,
 * also known as a “directional distribution.” The standard deviational ellipse
 * aims to show the direction and the distribution of a dataset by drawing
 * an ellipse that contains about one standard deviation’s worth (~ 70%) of the
 * data.
 *
 * This module mirrors the functionality of [Directional Distribution](http://desktop.arcgis.com/en/arcmap/10.3/tools/spatial-statistics-toolbox/directional-distribution.htm)
 * in ArcGIS and the [QGIS Standard Deviational Ellipse Plugin](http://arken.nmbu.no/~havatv/gis/qgisplugins/SDEllipse/)
 *
 * **Bibliography**
 *
 * • Robert S. Yuill, “The Standard Deviational Ellipse; An Updated Tool for
 * Spatial Description,” _Geografiska Annaler_ 53, no. 1 (1971): 28–39,
 * doi:{@link https://doi.org/10.2307/490885|10.2307/490885}.
 *
 * • Paul Hanly Furfey, “A Note on Lefever’s “Standard Deviational Ellipse,”
 * _American Journal of Sociology_ 33, no. 1 (1927): 94—98,
 * doi:{@link https://doi.org/10.1086/214336|10.1086/214336}.
 *
 *
 * @name standardDeviationalEllipse
 * @param {FeatureCollection<Point>} points GeoJSON points
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.weight] the property name used to weight the center
 * @param {number} [options.steps=64] number of steps for the polygon
 * @param {Object} [options.properties={}] properties to pass to the resulting ellipse
 * @returns {Feature<Polygon>} an elliptical Polygon that includes approximately 1 SD of the dataset within it.
 * @example
 *
 * var bbox = [-74, 40.72, -73.98, 40.74];
 * var points = turf.randomPoint(400, {bbox: bbox});
 * var sdEllipse = turf.standardDeviationalEllipse(points);
 *
 * //addToMap
 * var addToMap = [points, sdEllipse];
 *
 */
function standardDeviationalEllipse(points, options) {
  // Optional params
  options = options || {};
  if (!standard_deviational_ellipse_dist_es_isObject(options)) throw new Error("options is invalid");
  var steps = options.steps || 64;
  var weightTerm = options.weight;
  var properties = options.properties || {};

  // Validation:
  if (!standard_deviational_ellipse_dist_es_isNumber(steps)) throw new Error("steps must be a number");
  if (!standard_deviational_ellipse_dist_es_isObject(properties)) throw new Error("properties must be a number");

  // Calculate mean center & number of features:
  var numberOfFeatures = standard_deviational_ellipse_dist_es_coordAll(points).length;
  var meanCenter = dist_es_centerMean(points, { weight: weightTerm });

  // Calculate angle of rotation:
  // [X, Y] = mean center of all [x, y].
  // theta = arctan( (A + B) / C )
  // A = sum((x - X)^2) - sum((y - Y)^2)
  // B = sqrt(A^2 + 4(sum((x - X)(y - Y))^2))
  // C = 2(sum((x - X)(y - Y)))

  var xDeviationSquaredSum = 0;
  var yDeviationSquaredSum = 0;
  var xyDeviationSum = 0;

  standard_deviational_ellipse_dist_es_featureEach(points, function (point) {
    var weight = point.properties[weightTerm] || 1;
    var deviation = getDeviations(standard_deviational_ellipse_dist_es_getCoords(point), standard_deviational_ellipse_dist_es_getCoords(meanCenter));
    xDeviationSquaredSum += Math.pow(deviation.x, 2) * weight;
    yDeviationSquaredSum += Math.pow(deviation.y, 2) * weight;
    xyDeviationSum += deviation.x * deviation.y * weight;
  });

  var bigA = xDeviationSquaredSum - yDeviationSquaredSum;
  var bigB = Math.sqrt(Math.pow(bigA, 2) + 4 * Math.pow(xyDeviationSum, 2));
  var bigC = 2 * xyDeviationSum;
  var theta = Math.atan((bigA + bigB) / bigC);
  var thetaDeg = (theta * 180) / Math.PI;

  // Calculate axes:
  // sigmaX = sqrt((1 / n - 2) * sum((((x - X) * cos(theta)) - ((y - Y) * sin(theta)))^2))
  // sigmaY = sqrt((1 / n - 2) * sum((((x - X) * sin(theta)) - ((y - Y) * cos(theta)))^2))
  var sigmaXsum = 0;
  var sigmaYsum = 0;
  var weightsum = 0;
  standard_deviational_ellipse_dist_es_featureEach(points, function (point) {
    var weight = point.properties[weightTerm] || 1;
    var deviation = getDeviations(standard_deviational_ellipse_dist_es_getCoords(point), standard_deviational_ellipse_dist_es_getCoords(meanCenter));
    sigmaXsum +=
      Math.pow(
        deviation.x * Math.cos(theta) - deviation.y * Math.sin(theta),
        2
      ) * weight;
    sigmaYsum +=
      Math.pow(
        deviation.x * Math.sin(theta) + deviation.y * Math.cos(theta),
        2
      ) * weight;
    weightsum += weight;
  });

  var sigmaX = Math.sqrt((2 * sigmaXsum) / weightsum);
  var sigmaY = Math.sqrt((2 * sigmaYsum) / weightsum);

  var theEllipse = es_ellipse(meanCenter, sigmaX, sigmaY, {
    units: "degrees",
    angle: thetaDeg,
    steps: steps,
    properties: properties,
  });
  var pointsWithinEllipse = es_pointsWithinPolygon(
    points,
    standard_deviational_ellipse_dist_es_featureCollection([theEllipse])
  );
  var standardDeviationalEllipseProperties = {
    meanCenterCoordinates: standard_deviational_ellipse_dist_es_getCoords(meanCenter),
    semiMajorAxis: sigmaX,
    semiMinorAxis: sigmaY,
    numberOfFeatures: numberOfFeatures,
    angle: thetaDeg,
    percentageWithinEllipse:
      (100 * standard_deviational_ellipse_dist_es_coordAll(pointsWithinEllipse).length) / numberOfFeatures,
  };
  theEllipse.properties.standardDeviationalEllipse = standardDeviationalEllipseProperties;

  return theEllipse;
}

/**
 * Get x_i - X and y_i - Y
 *
 * @private
 * @param {Array} coordinates Array of [x_i, y_i]
 * @param {Array} center Array of [X, Y]
 * @returns {Object} { x: n, y: m }
 */
function getDeviations(coordinates, center) {
  return {
    x: coordinates[0] - center[0],
    y: coordinates[1] - center[1],
  };
}

/* harmony default export */ const standard_deviational_ellipse_dist_es = ((/* unused pure expression or super */ null && (standardDeviationalEllipse)));

;// ../../node_modules/@turf/angle/dist/es/index.js
/* unused harmony import specifier */ var angle_dist_es_bearing;
/* unused harmony import specifier */ var angle_dist_es_isObject;
/* unused harmony import specifier */ var dist_es_bearingToAzimuth;
/* unused harmony import specifier */ var angle_dist_es_rhumbBearing;



/**
 * Finds the angle formed by two adjacent segments defined by 3 points. The result will be the (positive clockwise)
 * angle with origin on the `startPoint-midPoint` segment, or its explementary angle if required.
 *
 * @name angle
 * @param {Coord} startPoint Start Point Coordinates
 * @param {Coord} midPoint Mid Point Coordinates
 * @param {Coord} endPoint End Point Coordinates
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.explementary=false] Returns the explementary angle instead (360 - angle)
 * @param {boolean} [options.mercator=false] if calculations should be performed over Mercator or WGS84 projection
 * @returns {number} Angle between the provided points, or its explementary.
 * @example
 * turf.angle([5, 5], [5, 6], [3, 4]);
 * //=45
 */
function angle(startPoint, midPoint, endPoint, options) {
    if (options === void 0) { options = {}; }
    // Optional Parameters
    if (!angle_dist_es_isObject(options)) {
        throw new Error("options is invalid");
    }
    // Validation
    if (!startPoint) {
        throw new Error("startPoint is required");
    }
    if (!midPoint) {
        throw new Error("midPoint is required");
    }
    if (!endPoint) {
        throw new Error("endPoint is required");
    }
    // Rename to shorter variables
    var A = startPoint;
    var O = midPoint;
    var B = endPoint;
    // Main
    var azimuthAO = dist_es_bearingToAzimuth(options.mercator !== true ? angle_dist_es_bearing(A, O) : angle_dist_es_rhumbBearing(A, O));
    var azimuthBO = dist_es_bearingToAzimuth(options.mercator !== true ? angle_dist_es_bearing(B, O) : angle_dist_es_rhumbBearing(B, O));
    var angleAO = Math.abs(azimuthAO - azimuthBO);
    // Explementary angle
    if (options.explementary === true) {
        return 360 - angleAO;
    }
    return angleAO;
}
/* harmony default export */ const angle_dist_es = ((/* unused pure expression or super */ null && (angle)));

;// ../../node_modules/@turf/polygon-smooth/dist/es/index.js
/* unused harmony import specifier */ var polygon_smooth_dist_es_geomEach;
/* unused harmony import specifier */ var polygon_smooth_dist_es_coordEach;
/* unused harmony import specifier */ var polygon_smooth_dist_es_polygon;
/* unused harmony import specifier */ var polygon_smooth_dist_es_multiPolygon;
/* unused harmony import specifier */ var polygon_smooth_dist_es_featureCollection;



/**
 * Smooths a {@link Polygon} or {@link MultiPolygon}. Based on [Chaikin's algorithm](http://graphics.cs.ucdavis.edu/education/CAGDNotes/Chaikins-Algorithm/Chaikins-Algorithm.html).
 * Warning: may create degenerate polygons.
 *
 * @name polygonSmooth
 * @param {FeatureCollection|Feature<Polygon|MultiPolygon>} inputPolys (Multi)Polygon(s) to smooth
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.iterations=1] THe number of times to smooth the polygon. A higher value means a smoother polygon.
 * @returns {FeatureCollection<Polygon>} FeatureCollection containing the smoothed polygon/poylgons
 * @example
 * var polygon = turf.polygon([[[11, 0], [22, 4], [31, 0], [31, 11], [21, 15], [11, 11], [11, 0]]]);
 *
 * var smoothed = turf.polygonSmooth(polygon, {iterations: 3})
 *
 * //addToMap
 * var addToMap = [smoothed, polygon];
 */
function polygonSmooth(inputPolys, options) {
  var outPolys = [];
  // Optional parameters
  var iterations = options.iterations || 1;
  if (!inputPolys) throw new Error("inputPolys is required");

  polygon_smooth_dist_es_geomEach(inputPolys, function (geom, geomIndex, properties) {
    var outCoords;
    var poly;
    var tempOutput;

    switch (geom.type) {
      case "Polygon":
        outCoords = [[]];
        for (var i = 0; i < iterations; i++) {
          tempOutput = [[]];
          poly = geom;
          if (i > 0) poly = polygon_smooth_dist_es_polygon(outCoords).geometry;
          dist_es_processPolygon(poly, tempOutput);
          outCoords = tempOutput.slice(0);
        }
        outPolys.push(polygon_smooth_dist_es_polygon(outCoords, properties));
        break;
      case "MultiPolygon":
        outCoords = [[[]]];
        for (var y = 0; y < iterations; y++) {
          tempOutput = [[[]]];
          poly = geom;
          if (y > 0) poly = polygon_smooth_dist_es_multiPolygon(outCoords).geometry;
          processMultiPolygon(poly, tempOutput);
          outCoords = tempOutput.slice(0);
        }
        outPolys.push(polygon_smooth_dist_es_multiPolygon(outCoords, properties));
        break;
      default:
        throw new Error("geometry is invalid, must be Polygon or MultiPolygon");
    }
  });
  return polygon_smooth_dist_es_featureCollection(outPolys);
}

/**
 * @param {poly} poly to process
 * @param {poly} tempOutput to place the results in
 * @private
 */
function dist_es_processPolygon(poly, tempOutput) {
  var prevGeomIndex = 0;
  var subtractCoordIndex = 0;

  polygon_smooth_dist_es_coordEach(
    poly,
    function (
      currentCoord,
      coordIndex,
      featureIndex,
      multiFeatureIndex,
      geometryIndex
    ) {
      if (geometryIndex > prevGeomIndex) {
        prevGeomIndex = geometryIndex;
        subtractCoordIndex = coordIndex;
        tempOutput.push([]);
      }
      var realCoordIndex = coordIndex - subtractCoordIndex;
      var p1 = poly.coordinates[geometryIndex][realCoordIndex + 1];
      var p0x = currentCoord[0];
      var p0y = currentCoord[1];
      var p1x = p1[0];
      var p1y = p1[1];
      tempOutput[geometryIndex].push([
        0.75 * p0x + 0.25 * p1x,
        0.75 * p0y + 0.25 * p1y,
      ]);
      tempOutput[geometryIndex].push([
        0.25 * p0x + 0.75 * p1x,
        0.25 * p0y + 0.75 * p1y,
      ]);
    },
    true
  );
  tempOutput.forEach(function (ring) {
    ring.push(ring[0]);
  });
}

/**
 * @param {poly} poly to process
 * @param {poly} tempOutput to place the results in
 * @private
 */
function processMultiPolygon(poly, tempOutput) {
  var prevGeomIndex = 0;
  var subtractCoordIndex = 0;
  var prevMultiIndex = 0;

  polygon_smooth_dist_es_coordEach(
    poly,
    function (
      currentCoord,
      coordIndex,
      featureIndex,
      multiFeatureIndex,
      geometryIndex
    ) {
      if (multiFeatureIndex > prevMultiIndex) {
        prevMultiIndex = multiFeatureIndex;
        subtractCoordIndex = coordIndex;
        tempOutput.push([[]]);
      }
      if (geometryIndex > prevGeomIndex) {
        prevGeomIndex = geometryIndex;
        subtractCoordIndex = coordIndex;
        tempOutput[multiFeatureIndex].push([]);
      }
      var realCoordIndex = coordIndex - subtractCoordIndex;
      var p1 =
        poly.coordinates[multiFeatureIndex][geometryIndex][realCoordIndex + 1];
      var p0x = currentCoord[0];
      var p0y = currentCoord[1];
      var p1x = p1[0];
      var p1y = p1[1];
      tempOutput[multiFeatureIndex][geometryIndex].push([
        0.75 * p0x + 0.25 * p1x,
        0.75 * p0y + 0.25 * p1y,
      ]);
      tempOutput[multiFeatureIndex][geometryIndex].push([
        0.25 * p0x + 0.75 * p1x,
        0.25 * p0y + 0.75 * p1y,
      ]);
    },
    true
  );

  tempOutput.forEach(function (poly) {
    poly.forEach(function (ring) {
      ring.push(ring[0]);
    });
  });
}

/* harmony default export */ const polygon_smooth_dist_es = ((/* unused pure expression or super */ null && (polygonSmooth)));

;// ../../node_modules/@turf/distance-weight/dist/es/index.js
/* unused harmony import specifier */ var distance_weight_dist_es_centroid;
/* unused harmony import specifier */ var distance_weight_dist_es_getCoord;
/* unused harmony import specifier */ var distance_weight_dist_es_featureEach;



/**
 * calcualte the Minkowski p-norm distance between two features.
 * @param feature1 point feature
 * @param feature2 point feature
 * @param p p-norm 1=<p<=infinity 1: Manhattan distance 2: Euclidean distance
 */
function pNormDistance(feature1, feature2, p) {
    if (p === void 0) { p = 2; }
    var coordinate1 = distance_weight_dist_es_getCoord(feature1);
    var coordinate2 = distance_weight_dist_es_getCoord(feature2);
    var xDiff = coordinate1[0] - coordinate2[0];
    var yDiff = coordinate1[1] - coordinate2[1];
    if (p === 1) {
        return Math.abs(xDiff) + Math.abs(yDiff);
    }
    return Math.pow(Math.pow(xDiff, p) + Math.pow(yDiff, p), 1 / p);
}
/**
 *
 *
 * @name distanceWeight
 * @param {FeatureCollection<any>} fc FeatureCollection.
 * @param {Object} [options] option object.
 * @param {number} [options.threshold=10000] If the distance between neighbor and
 * target features is greater than threshold, the weight of that neighbor is 0.
 * @param {number} [options.p=2] Minkowski p-norm distance parameter.
 * 1: Manhattan distance. 2: Euclidean distance. 1=<p<=infinity.
 * @param {boolean} [options.binary=false] If true, weight=1 if d <= threshold otherwise weight=0.
 *  If false, weight=Math.pow(d, alpha).
 * @param {number} [options.alpha=-1] distance decay parameter.
 * A big value means the weight decay quickly as distance increases.
 * @param {boolean} [options.standardization=false] row standardization.
 * @returns {Array<Array<number>>} distance weight matrix.
 * @example
 *
 * var bbox = [-65, 40, -63, 42];
 * var dataset = turf.randomPoint(100, { bbox: bbox });
 * var result = turf.distanceWeight(dataset);
 */
function distanceWeight(fc, options) {
    options = options || {};
    var threshold = options.threshold || 10000;
    var p = options.p || 2;
    var binary = options.binary || false;
    var alpha = options.alpha || -1;
    var rowTransform = options.standardization || false;
    var features = [];
    distance_weight_dist_es_featureEach(fc, function (feature) {
        features.push(distance_weight_dist_es_centroid(feature));
    });
    // computing the distance between the features
    var weights = [];
    for (var i = 0; i < features.length; i++) {
        weights[i] = [];
    }
    for (var i = 0; i < features.length; i++) {
        for (var j = i; j < features.length; j++) {
            if (i === j) {
                weights[i][j] = 0;
            }
            var dis = pNormDistance(features[i], features[j], p);
            weights[i][j] = dis;
            weights[j][i] = dis;
        }
    }
    // binary or distance decay
    for (var i = 0; i < features.length; i++) {
        for (var j = 0; j < features.length; j++) {
            var dis = weights[i][j];
            if (dis === 0) {
                continue;
            }
            if (binary) {
                if (dis <= threshold) {
                    weights[i][j] = 1.0;
                }
                else {
                    weights[i][j] = 0.0;
                }
            }
            else {
                if (dis <= threshold) {
                    weights[i][j] = Math.pow(dis, alpha);
                }
                else {
                    weights[i][j] = 0.0;
                }
            }
        }
    }
    if (rowTransform) {
        for (var i = 0; i < features.length; i++) {
            var rowSum = weights[i].reduce(function (sum, currentVal) {
                return sum + currentVal;
            }, 0);
            for (var j = 0; j < features.length; j++) {
                weights[i][j] = weights[i][j] / rowSum;
            }
        }
    }
    return weights;
}

;// ../../node_modules/@turf/moran-index/dist/es/index.js
Object.defineProperty(moran_index_dist_es, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var spatialWeight;
/* unused harmony import specifier */ var moran_index_dist_es_featureEach;


/**
 * Moran's I measures patterns of attribute values associated with features.
 * The method reveal whether similar values tend to occur near each other,
 * or whether high or low values are interspersed.
 *
 * Moran's I > 0 means a clusterd pattern.
 * Moran's I < 0 means a dispersed pattern.
 * Moran's I = 0 means a random pattern.
 *
 * In order to test the significance of the result. The z score is calculated.
 * A positive enough z-score (ex. >1.96) indicates clustering,
 * while a negative enough z-score (ex. <-1.96) indicates a dispersed pattern.
 *
 * the z-score can be calculated based on a normal or random assumption.
 *
 * **Bibliography***
 *
 * 1. [Moran's I](https://en.wikipedia.org/wiki/Moran%27s_I)
 *
 * 2. [pysal](http://pysal.readthedocs.io/en/latest/index.html)
 *
 * 3. Andy Mitchell, The ESRI Guide to GIS Analysis Volume 2: Spatial Measurements & Statistics.
 *
 * @name moranIndex
 * @param {FeatureCollection<any>} fc
 * @param {Object} options
 * @param {string} options.inputField the property name, must contain numeric values
 * @param {number} [options.threshold=100000] the distance threshold
 * @param {number} [options.p=2] the Minkowski p-norm distance parameter
 * @param {boolean} [options.binary=false] whether transfrom the distance to binary
 * @param {number} [options.alpha=-1] the distance decay parameter
 * @param {boolean} [options.standardization=true] wheter row standardization the distance
 * @returns {MoranIndex}
 * @example
 *
 * const bbox = [-65, 40, -63, 42];
 * const dataset = turf.randomPoint(100, { bbox: bbox });
 *
 * const result = turf.moranIndex(dataset, {
 *   inputField: 'CRIME',
 * });
 */
/* harmony default export */ function moran_index_dist_es(fc, options) {
    var inputField = options.inputField;
    var threshold = options.threshold || 100000;
    var p = options.p || 2;
    var binary = options.binary || false;
    var alpha = options.alpha || -1;
    var standardization = options.standardization || true;
    var weight = spatialWeight(fc, {
        alpha: alpha,
        binary: binary,
        p: p,
        standardization: standardization,
        threshold: threshold,
    });
    var y = [];
    moran_index_dist_es_featureEach(fc, function (feature) {
        var feaProperties = feature.properties || {};
        // validate inputField exists
        y.push(feaProperties[inputField]);
    });
    var yMean = mean(y);
    var yVar = variance(y);
    var weightSum = 0;
    var s0 = 0;
    var s1 = 0;
    var s2 = 0;
    var n = weight.length;
    // validate y.length is the same as weight.length
    for (var i = 0; i < n; i++) {
        var subS2 = 0;
        for (var j = 0; j < n; j++) {
            weightSum += weight[i][j] * (y[i] - yMean) * (y[j] - yMean);
            s0 += weight[i][j];
            s1 += Math.pow(weight[i][j] + weight[j][i], 2);
            subS2 += weight[i][j] + weight[j][i];
        }
        s2 += Math.pow(subS2, 2);
    }
    s1 = 0.5 * s1;
    var moranIndex = weightSum / s0 / yVar;
    var expectedMoranIndex = -1 / (n - 1);
    var vNum = n * n * s1 - n * s2 + 3 * (s0 * s0);
    var vDen = (n - 1) * (n + 1) * (s0 * s0);
    var vNorm = vNum / vDen - expectedMoranIndex * expectedMoranIndex;
    var stdNorm = Math.sqrt(vNorm);
    var zNorm = (moranIndex - expectedMoranIndex) / stdNorm;
    return {
        expectedMoranIndex: expectedMoranIndex,
        moranIndex: moranIndex,
        stdNorm: stdNorm,
        zNorm: zNorm,
    };
}
/**
 * get mean of a list
 * @param {number[]} y
 * @returns {number}
 *
 */
function mean(y) {
    var sum = 0;
    for (var _i = 0, y_1 = y; _i < y_1.length; _i++) {
        var item = y_1[_i];
        sum += item;
    }
    return sum / y.length;
}
/**
 * get variance of a list
 * @param {number[]} y
 * @returns {number}
 *
 */
function variance(y) {
    var yMean = mean(y);
    var sum = 0;
    for (var _i = 0, y_2 = y; _i < y_2.length; _i++) {
        var item = y_2[_i];
        sum += Math.pow(item - yMean, 2);
    }
    return sum / y.length;
}
/**
 * @typedef {Object} MoranIndex
 * @property {number} moranIndex the moran's Index of the observed feature set
 * @property {number} expectedMoranIndex the moran's Index of the random distribution
 * @property {number} stdNorm the standard devitaion of the random distribution
 * @property {number} zNorm the z-score of the observe samples with regard to the random distribution
 */

;// ../../node_modules/@turf/projection/dist/es/index.js
/* unused harmony import specifier */ var projection_dist_es_coordEach;
/* unused harmony import specifier */ var projection_dist_es_isNumber;
/* unused harmony import specifier */ var projection_dist_es_clone;



/**
 * Converts a WGS84 GeoJSON object into Mercator (EPSG:900913) projection
 *
 * @name toMercator
 * @param {GeoJSON|Position} geojson WGS84 GeoJSON object
 * @param {Object} [options] Optional parameters
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} Projected GeoJSON
 * @example
 * var pt = turf.point([-71,41]);
 * var converted = turf.toMercator(pt);
 *
 * //addToMap
 * var addToMap = [pt, converted];
 */
function toMercator(geojson, options) {
    if (options === void 0) { options = {}; }
    return convert(geojson, "mercator", options);
}
/**
 * Converts a Mercator (EPSG:900913) GeoJSON object into WGS84 projection
 *
 * @name toWgs84
 * @param {GeoJSON|Position} geojson Mercator GeoJSON object
 * @param {Object} [options] Optional parameters
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} Projected GeoJSON
 * @example
 * var pt = turf.point([-7903683.846322424, 5012341.663847514]);
 * var converted = turf.toWgs84(pt);
 *
 * //addToMap
 * var addToMap = [pt, converted];
 */
function toWgs84(geojson, options) {
    if (options === void 0) { options = {}; }
    return convert(geojson, "wgs84", options);
}
/**
 * Converts a GeoJSON coordinates to the defined `projection`
 *
 * @private
 * @param {GeoJSON} geojson GeoJSON Feature or Geometry
 * @param {string} projection defines the projection system to convert the coordinates to
 * @param {Object} [options] Optional parameters
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} Converted GeoJSON
 */
function convert(geojson, projection, options) {
    if (options === void 0) { options = {}; }
    // Optional parameters
    options = options || {};
    var mutate = options.mutate;
    // Validation
    if (!geojson)
        throw new Error("geojson is required");
    // Handle Position
    if (Array.isArray(geojson) && projection_dist_es_isNumber(geojson[0]))
        geojson =
            projection === "mercator"
                ? convertToMercator(geojson)
                : convertToWgs84(geojson);
    // Handle GeoJSON
    else {
        // Handle possible data mutation
        if (mutate !== true)
            geojson = projection_dist_es_clone(geojson);
        projection_dist_es_coordEach(geojson, function (coord) {
            var newCoord = projection === "mercator"
                ? convertToMercator(coord)
                : convertToWgs84(coord);
            coord[0] = newCoord[0];
            coord[1] = newCoord[1];
        });
    }
    return geojson;
}
/**
 * Convert lon/lat values to 900913 x/y.
 * (from https://github.com/mapbox/sphericalmercator)
 *
 * @private
 * @param {Array<number>} lonLat WGS84 point
 * @returns {Array<number>} Mercator [x, y] point
 */
function convertToMercator(lonLat) {
    var D2R = Math.PI / 180, 
    // 900913 properties
    A = 6378137.0, MAXEXTENT = 20037508.342789244;
    // compensate longitudes passing the 180th meridian
    // from https://github.com/proj4js/proj4js/blob/master/lib/common/adjust_lon.js
    var adjusted = Math.abs(lonLat[0]) <= 180 ? lonLat[0] : lonLat[0] - sign(lonLat[0]) * 360;
    var xy = [
        A * adjusted * D2R,
        A * Math.log(Math.tan(Math.PI * 0.25 + 0.5 * lonLat[1] * D2R)),
    ];
    // if xy value is beyond maxextent (e.g. poles), return maxextent
    if (xy[0] > MAXEXTENT)
        xy[0] = MAXEXTENT;
    if (xy[0] < -MAXEXTENT)
        xy[0] = -MAXEXTENT;
    if (xy[1] > MAXEXTENT)
        xy[1] = MAXEXTENT;
    if (xy[1] < -MAXEXTENT)
        xy[1] = -MAXEXTENT;
    return xy;
}
/**
 * Convert 900913 x/y values to lon/lat.
 * (from https://github.com/mapbox/sphericalmercator)
 *
 * @private
 * @param {Array<number>} xy Mercator [x, y] point
 * @returns {Array<number>} WGS84 [lon, lat] point
 */
function convertToWgs84(xy) {
    // 900913 properties.
    var R2D = 180 / Math.PI;
    var A = 6378137.0;
    return [
        (xy[0] * R2D) / A,
        (Math.PI * 0.5 - 2.0 * Math.atan(Math.exp(-xy[1] / A))) * R2D,
    ];
}
/**
 * Returns the sign of the input, or zero
 *
 * @private
 * @param {number} x input
 * @returns {number} -1|0|1 output
 */
function sign(x) {
    return x < 0 ? -1 : x > 0 ? 1 : 0;
}

;// ../../node_modules/@turf/random/dist/es/index.js
/* unused harmony import specifier */ var random_dist_es_point;
/* unused harmony import specifier */ var random_dist_es_featureCollection;
/* unused harmony import specifier */ var random_dist_es_isNumber;
/* unused harmony import specifier */ var random_dist_es_polygon;
/* unused harmony import specifier */ var random_dist_es_isObject;
/* unused harmony import specifier */ var random_dist_es_lineString;
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

/**
 * Returns a random position within a {@link bounding box}.
 *
 * @name randomPosition
 * @param {Array<number>} [bbox=[-180, -90, 180, 90]] a bounding box inside of which positions are placed.
 * @returns {Array<number>} Position [longitude, latitude]
 * @example
 * var position = turf.randomPosition([-180, -90, 180, 90])
 * // => position
 */
function randomPosition(bbox) {
    if (Array.isArray(bbox)) {
        return coordInBBox(bbox);
    }
    if (bbox && bbox.bbox) {
        return coordInBBox(bbox.bbox);
    }
    return [lon(), lat()];
}
/**
 * Returns a random {@link point}.
 *
 * @name randomPoint
 * @param {number} [count=1] how many geometries will be generated
 * @param {Object} [options={}] Optional parameters
 * @param {Array<number>} [options.bbox=[-180, -90, 180, 90]] a bounding box inside of which geometries are placed.
 * @returns {FeatureCollection<Point>} GeoJSON FeatureCollection of points
 * @example
 * var points = turf.randomPoint(25, {bbox: [-180, -90, 180, 90]})
 * // => points
 */
function randomPoint(count, options) {
    if (options === void 0) { options = {}; }
    if (count === undefined || count === null) {
        count = 1;
    }
    var features = [];
    for (var i = 0; i < count; i++) {
        features.push(random_dist_es_point(randomPosition(options.bbox)));
    }
    return random_dist_es_featureCollection(features);
}
/**
 * Returns a random {@link polygon}.
 *
 * @name randomPolygon
 * @param {number} [count=1] how many geometries will be generated
 * @param {Object} [options={}] Optional parameters
 * @param {Array<number>} [options.bbox=[-180, -90, 180, 90]] a bounding box inside of which geometries are placed.
 * @param {number} [options.num_vertices=10] is how many coordinates each LineString will contain.
 * @param {number} [options.max_radial_length=10] is the maximum number of decimal degrees latitude or longitude that a
 * vertex can reach out of the center of the Polygon.
 * @returns {FeatureCollection<Polygon>} GeoJSON FeatureCollection of polygons
 * @example
 * var polygons = turf.randomPolygon(25, {bbox: [-180, -90, 180, 90]})
 * // => polygons
 */
function randomPolygon(count, options) {
    if (options === void 0) { options = {}; }
    // Default param
    if (count === undefined || count === null) {
        count = 1;
    }
    if (!random_dist_es_isNumber(options.num_vertices) || options.num_vertices === undefined) {
        options.num_vertices = 10;
    }
    if (!random_dist_es_isNumber(options.max_radial_length) ||
        options.max_radial_length === undefined) {
        options.max_radial_length = 10;
    }
    var features = [];
    var _loop_1 = function (i) {
        var vertices = [];
        var circleOffsets = __spreadArrays(Array(options.num_vertices + 1)).map(Math.random);
        // Sum Offsets
        circleOffsets.forEach(function (cur, index, arr) {
            arr[index] = index > 0 ? cur + arr[index - 1] : cur;
        });
        // scaleOffsets
        circleOffsets.forEach(function (cur) {
            cur = (cur * 2 * Math.PI) / circleOffsets[circleOffsets.length - 1];
            var radialScaler = Math.random();
            vertices.push([
                radialScaler * (options.max_radial_length || 10) * Math.sin(cur),
                radialScaler * (options.max_radial_length || 10) * Math.cos(cur),
            ]);
        });
        vertices[vertices.length - 1] = vertices[0]; // close the ring
        // center the polygon around something
        vertices = vertices.map(vertexToCoordinate(randomPosition(options.bbox)));
        features.push(random_dist_es_polygon([vertices]));
    };
    for (var i = 0; i < count; i++) {
        _loop_1(i);
    }
    return random_dist_es_featureCollection(features);
}
/**
 * Returns a random {@link linestring}.
 *
 * @name randomLineString
 * @param {number} [count=1] how many geometries will be generated
 * @param {Object} [options={}] Optional parameters
 * @param {Array<number>} [options.bbox=[-180, -90, 180, 90]] a bounding box inside of which geometries are placed.
 * @param {number} [options.num_vertices=10] is how many coordinates each LineString will contain.
 * @param {number} [options.max_length=0.0001] is the maximum number of decimal degrees that a
 * vertex can be from its predecessor
 * @param {number} [options.max_rotation=Math.PI / 8] is the maximum number of radians that a
 * line segment can turn from the previous segment.
 * @returns {FeatureCollection<LineString>} GeoJSON FeatureCollection of linestrings
 * @example
 * var lineStrings = turf.randomLineString(25, {bbox: [-180, -90, 180, 90]})
 * // => lineStrings
 */
function randomLineString(count, options) {
    if (options === void 0) { options = {}; }
    // Optional parameters
    options = options || {};
    if (!random_dist_es_isObject(options)) {
        throw new Error("options is invalid");
    }
    var bbox = options.bbox;
    var num_vertices = options.num_vertices;
    var max_length = options.max_length;
    var max_rotation = options.max_rotation;
    if (count === undefined || count === null) {
        count = 1;
    }
    // Default parameters
    if (!random_dist_es_isNumber(num_vertices) ||
        num_vertices === undefined ||
        num_vertices < 2) {
        num_vertices = 10;
    }
    if (!random_dist_es_isNumber(max_length) || max_length === undefined) {
        max_length = 0.0001;
    }
    if (!random_dist_es_isNumber(max_rotation) || max_rotation === undefined) {
        max_rotation = Math.PI / 8;
    }
    var features = [];
    for (var i = 0; i < count; i++) {
        var startingPoint = randomPosition(bbox);
        var vertices = [startingPoint];
        for (var j = 0; j < num_vertices - 1; j++) {
            var priorAngle = j === 0
                ? Math.random() * 2 * Math.PI
                : Math.tan((vertices[j][1] - vertices[j - 1][1]) /
                    (vertices[j][0] - vertices[j - 1][0]));
            var angle = priorAngle + (Math.random() - 0.5) * max_rotation * 2;
            var distance = Math.random() * max_length;
            vertices.push([
                vertices[j][0] + distance * Math.cos(angle),
                vertices[j][1] + distance * Math.sin(angle),
            ]);
        }
        features.push(random_dist_es_lineString(vertices));
    }
    return random_dist_es_featureCollection(features);
}
function vertexToCoordinate(hub) {
    return function (cur) {
        return [cur[0] + hub[0], cur[1] + hub[1]];
    };
}
function rnd() {
    return Math.random() - 0.5;
}
function lon() {
    return rnd() * 360;
}
function lat() {
    return rnd() * 180;
}
function coordInBBox(bbox) {
    return [
        Math.random() * (bbox[2] - bbox[0]) + bbox[0],
        Math.random() * (bbox[3] - bbox[1]) + bbox[1],
    ];
}

;// ../../node_modules/@turf/clusters/dist/es/index.js
/* unused harmony import specifier */ var clusters_dist_es_featureEach;
/* unused harmony import specifier */ var clusters_dist_es_featureCollection;


/**
 * Get Cluster
 *
 * @name getCluster
 * @param {FeatureCollection} geojson GeoJSON Features
 * @param {*} filter Filter used on GeoJSON properties to get Cluster
 * @returns {FeatureCollection} Single Cluster filtered by GeoJSON Properties
 * @example
 * var geojson = turf.featureCollection([
 *     turf.point([0, 0], {'marker-symbol': 'circle'}),
 *     turf.point([2, 4], {'marker-symbol': 'star'}),
 *     turf.point([3, 6], {'marker-symbol': 'star'}),
 *     turf.point([5, 1], {'marker-symbol': 'square'}),
 *     turf.point([4, 2], {'marker-symbol': 'circle'})
 * ]);
 *
 * // Create a cluster using K-Means (adds `cluster` to GeoJSON properties)
 * var clustered = turf.clustersKmeans(geojson);
 *
 * // Retrieve first cluster (0)
 * var cluster = turf.getCluster(clustered, {cluster: 0});
 * //= cluster
 *
 * // Retrieve cluster based on custom properties
 * turf.getCluster(clustered, {'marker-symbol': 'circle'}).length;
 * //= 2
 * turf.getCluster(clustered, {'marker-symbol': 'square'}).length;
 * //= 1
 */
function getCluster(geojson, filter) {
    // Validation
    if (!geojson)
        throw new Error("geojson is required");
    if (geojson.type !== "FeatureCollection")
        throw new Error("geojson must be a FeatureCollection");
    if (filter === undefined || filter === null)
        throw new Error("filter is required");
    // Filter Features
    var features = [];
    clusters_dist_es_featureEach(geojson, function (feature) {
        if (applyFilter(feature.properties, filter))
            features.push(feature);
    });
    return clusters_dist_es_featureCollection(features);
}
/**
 * Callback for clusterEach
 *
 * @callback clusterEachCallback
 * @param {FeatureCollection} [cluster] The current cluster being processed.
 * @param {*} [clusterValue] Value used to create cluster being processed.
 * @param {number} [currentIndex] The index of the current element being processed in the array.Starts at index 0
 * @returns {void}
 */
/**
 * clusterEach
 *
 * @name clusterEach
 * @param {FeatureCollection} geojson GeoJSON Features
 * @param {string|number} property GeoJSON property key/value used to create clusters
 * @param {Function} callback a method that takes (cluster, clusterValue, currentIndex)
 * @returns {void}
 * @example
 * var geojson = turf.featureCollection([
 *     turf.point([0, 0]),
 *     turf.point([2, 4]),
 *     turf.point([3, 6]),
 *     turf.point([5, 1]),
 *     turf.point([4, 2])
 * ]);
 *
 * // Create a cluster using K-Means (adds `cluster` to GeoJSON properties)
 * var clustered = turf.clustersKmeans(geojson);
 *
 * // Iterate over each cluster
 * turf.clusterEach(clustered, 'cluster', function (cluster, clusterValue, currentIndex) {
 *     //= cluster
 *     //= clusterValue
 *     //= currentIndex
 * })
 *
 * // Calculate the total number of clusters
 * var total = 0
 * turf.clusterEach(clustered, 'cluster', function () {
 *     total++;
 * });
 *
 * // Create an Array of all the values retrieved from the 'cluster' property
 * var values = []
 * turf.clusterEach(clustered, 'cluster', function (cluster, clusterValue) {
 *     values.push(clusterValue);
 * });
 */
function clusterEach(geojson, property, callback) {
    // Validation
    if (!geojson)
        throw new Error("geojson is required");
    if (geojson.type !== "FeatureCollection")
        throw new Error("geojson must be a FeatureCollection");
    if (property === undefined || property === null)
        throw new Error("property is required");
    // Create clusters based on property values
    var bins = createBins(geojson, property);
    var values = Object.keys(bins);
    for (var index = 0; index < values.length; index++) {
        var value = values[index];
        var bin = bins[value];
        var features = [];
        for (var i = 0; i < bin.length; i++) {
            features.push(geojson.features[bin[i]]);
        }
        callback(clusters_dist_es_featureCollection(features), value, index);
    }
}
/**
 * Callback for clusterReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback clusterReduceCallback
 * @param {*} [previousValue] The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {FeatureCollection} [cluster] The current cluster being processed.
 * @param {*} [clusterValue] Value used to create cluster being processed.
 * @param {number} [currentIndex] The index of the current element being processed in the
 * array. Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 */
/**
 * Reduce clusters in GeoJSON Features, similar to Array.reduce()
 *
 * @name clusterReduce
 * @param {FeatureCollection} geojson GeoJSON Features
 * @param {string|number} property GeoJSON property key/value used to create clusters
 * @param {Function} callback a method that takes (previousValue, cluster, clusterValue, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var geojson = turf.featureCollection([
 *     turf.point([0, 0]),
 *     turf.point([2, 4]),
 *     turf.point([3, 6]),
 *     turf.point([5, 1]),
 *     turf.point([4, 2])
 * ]);
 *
 * // Create a cluster using K-Means (adds `cluster` to GeoJSON properties)
 * var clustered = turf.clustersKmeans(geojson);
 *
 * // Iterate over each cluster and perform a calculation
 * var initialValue = 0
 * turf.clusterReduce(clustered, 'cluster', function (previousValue, cluster, clusterValue, currentIndex) {
 *     //=previousValue
 *     //=cluster
 *     //=clusterValue
 *     //=currentIndex
 *     return previousValue++;
 * }, initialValue);
 *
 * // Calculate the total number of clusters
 * var total = turf.clusterReduce(clustered, 'cluster', function (previousValue) {
 *     return previousValue++;
 * }, 0);
 *
 * // Create an Array of all the values retrieved from the 'cluster' property
 * var values = turf.clusterReduce(clustered, 'cluster', function (previousValue, cluster, clusterValue) {
 *     return previousValue.concat(clusterValue);
 * }, []);
 */
function clusterReduce(geojson, property, callback, initialValue) {
    var previousValue = initialValue;
    clusterEach(geojson, property, function (cluster, clusterValue, currentIndex) {
        if (currentIndex === 0 && initialValue === undefined)
            previousValue = cluster;
        else
            previousValue = callback(previousValue, cluster, clusterValue, currentIndex);
    });
    return previousValue;
}
/**
 * Create Bins
 *
 * @private
 * @param {FeatureCollection} geojson GeoJSON Features
 * @param {string|number} property Property values are used to create bins
 * @returns {Object} bins with Feature IDs
 * @example
 * var geojson = turf.featureCollection([
 *     turf.point([0, 0], {cluster: 0, foo: 'null'}),
 *     turf.point([2, 4], {cluster: 1, foo: 'bar'}),
 *     turf.point([5, 1], {0: 'foo'}),
 *     turf.point([3, 6], {cluster: 1}),
 * ]);
 * createBins(geojson, 'cluster');
 * //= { '0': [ 0 ], '1': [ 1, 3 ] }
 */
function createBins(geojson, property) {
    var bins = {};
    clusters_dist_es_featureEach(geojson, function (feature, i) {
        var properties = feature.properties || {};
        if (Object.prototype.hasOwnProperty.call(properties, String(property))) {
            var value = properties[property];
            if (Object.prototype.hasOwnProperty.call(bins, value))
                bins[value].push(i);
            else
                bins[value] = [i];
        }
    });
    return bins;
}
/**
 * Apply Filter
 *
 * @private
 * @param {*} properties Properties
 * @param {*} filter Filter
 * @returns {boolean} applied Filter to properties
 */
function applyFilter(properties, filter) {
    if (properties === undefined)
        return false;
    var filterType = typeof filter;
    // String & Number
    if (filterType === "number" || filterType === "string")
        return Object.prototype.hasOwnProperty.call(properties, filter);
    // Array
    else if (Array.isArray(filter)) {
        for (var i = 0; i < filter.length; i++) {
            if (!applyFilter(properties, filter[i]))
                return false;
        }
        return true;
        // Object
    }
    else {
        return propertiesContainsFilter(properties, filter);
    }
}
/**
 * Properties contains filter (does not apply deepEqual operations)
 *
 * @private
 * @param {*} properties Properties
 * @param {Object} filter Filter
 * @returns {boolean} does filter equal Properties
 * @example
 * propertiesContainsFilter({foo: 'bar', cluster: 0}, {cluster: 0})
 * //= true
 * propertiesContainsFilter({foo: 'bar', cluster: 0}, {cluster: 1})
 * //= false
 */
function propertiesContainsFilter(properties, filter) {
    var keys = Object.keys(filter);
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (properties[key] !== filter[key])
            return false;
    }
    return true;
}
/**
 * Filter Properties
 *
 * @private
 * @param {*} properties Properties
 * @param {Array<string>} keys Used to filter Properties
 * @returns {*} filtered Properties
 * @example
 * filterProperties({foo: 'bar', cluster: 0}, ['cluster'])
 * //= {cluster: 0}
 */
function filterProperties(properties, keys) {
    if (!keys)
        return {};
    if (!keys.length)
        return {};
    var newProperties = {};
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (Object.prototype.hasOwnProperty.call(properties, key))
            newProperties[key] = properties[key];
    }
    return newProperties;
}

// EXTERNAL MODULE: ../../node_modules/polygon-clipping/dist/polygon-clipping.umd.js
var polygon_clipping_umd = __webpack_require__(2235);
;// ../../node_modules/@turf/difference/dist/es/index.js
/* unused harmony import specifier */ var polygonClipping;
/* unused harmony import specifier */ var difference_dist_es_polygon;
/* unused harmony import specifier */ var difference_dist_es_multiPolygon;
/* unused harmony import specifier */ var difference_dist_es_getGeom;




/**
 * Finds the difference between two {@link Polygon|polygons} by clipping the second polygon from the first.
 *
 * @name difference
 * @param {Feature<Polygon|MultiPolygon>} polygon1 input Polygon feature
 * @param {Feature<Polygon|MultiPolygon>} polygon2 Polygon feature to difference from polygon1
 * @returns {Feature<Polygon|MultiPolygon>|null} a Polygon or MultiPolygon feature showing the area of `polygon1` excluding the area of `polygon2` (if empty returns `null`)
 * @example
 * var polygon1 = turf.polygon([[
 *   [128, -26],
 *   [141, -26],
 *   [141, -21],
 *   [128, -21],
 *   [128, -26]
 * ]], {
 *   "fill": "#F00",
 *   "fill-opacity": 0.1
 * });
 * var polygon2 = turf.polygon([[
 *   [126, -28],
 *   [140, -28],
 *   [140, -20],
 *   [126, -20],
 *   [126, -28]
 * ]], {
 *   "fill": "#00F",
 *   "fill-opacity": 0.1
 * });
 *
 * var difference = turf.difference(polygon1, polygon2);
 *
 * //addToMap
 * var addToMap = [polygon1, polygon2, difference];
 */
function difference(polygon1, polygon2) {
  var geom1 = difference_dist_es_getGeom(polygon1);
  var geom2 = difference_dist_es_getGeom(polygon2);
  var properties = polygon1.properties || {};

  var differenced = polygonClipping.difference(
    geom1.coordinates,
    geom2.coordinates
  );
  if (differenced.length === 0) return null;
  if (differenced.length === 1) return difference_dist_es_polygon(differenced[0], properties);
  return difference_dist_es_multiPolygon(differenced, properties);
}

/* harmony default export */ const difference_dist_es = ((/* unused pure expression or super */ null && (difference)));

// EXTERNAL MODULE: ../../node_modules/turf-jsts/jsts.min.js
var jsts_min = __webpack_require__(4712);
;// ../../node_modules/d3-geo/src/adder.js
Object.defineProperty(adder, "name", { value: "default", configurable: true });
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ function adder() {
  return new Adder;
}

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    adder_add(temp, y, this.t);
    adder_add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function adder_add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}

;// ../../node_modules/d3-geo/src/math.js
var math_epsilon = 1e-6;
var math_epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var math_sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}

;// ../../node_modules/d3-geo/src/noop.js
function noop() {}

;// ../../node_modules/d3-geo/src/stream.js
Object.defineProperty(stream, "name", { value: "default", configurable: true });
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ function stream(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
}

;// ../../node_modules/d3-geo/src/area.js
Object.defineProperty(src_area, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var area_stream;





var areaRingSum = adder();

var areaSum = adder(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: noop,
  lineStart: noop,
  lineEnd: noop,
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? tau + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = noop;
  },
  sphere: function() {
    areaSum.add(tau);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= radians, phi *= radians;
  lambda0 = lambda, cosPhi0 = cos(phi = phi / 2 + quarterPi), sinPhi0 = sin(phi);
}

function areaPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  phi = phi / 2 + quarterPi; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = cos(phi),
      sinPhi = sin(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * cos(adLambda),
      v = k * sdLambda * sin(adLambda);
  areaRingSum.add(atan2(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* harmony default export */ function src_area(object) {
  areaSum.reset();
  area_stream(object, areaStream);
  return areaSum * 2;
}

;// ../../node_modules/d3-geo/src/cartesian.js


function spherical(cartesian) {
  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = cos(phi);
  return [cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}

;// ../../node_modules/d3-geo/src/bounds.js
Object.defineProperty(src_bounds, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var bounds_stream;






var bounds_lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    bounds_lambda00, bounds_phi00, // first point
    p0, // previous 3D point
    deltaSum = adder(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    areaStream.polygonStart();
  },
  polygonEnd: function() {
    areaStream.polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (areaRingSum < 0) bounds_lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > math_epsilon) phi1 = 90;
    else if (deltaSum < -math_epsilon) phi0 = -90;
    range[0] = bounds_lambda0, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [bounds_lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = cartesian([lambda * radians, phi * radians]);
  if (p0) {
    var normal = cartesianCross(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = cartesianCross(equatorial, normal);
    cartesianNormalizeInPlace(inflection);
    inflection = spherical(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * degrees * sign,
        phii,
        antimeridian = abs(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * degrees;
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * degrees;
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (bounds_angle(bounds_lambda0, lambda) > bounds_angle(bounds_lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (bounds_angle(lambda, lambda1) > bounds_angle(bounds_lambda0, lambda1)) bounds_lambda0 = lambda;
      }
    } else {
      if (lambda1 >= bounds_lambda0) {
        if (lambda < bounds_lambda0) bounds_lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (bounds_angle(bounds_lambda0, lambda) > bounds_angle(bounds_lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (bounds_angle(lambda, lambda1) > bounds_angle(bounds_lambda0, lambda1)) bounds_lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [bounds_lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = bounds_lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    bounds_lambda00 = lambda, bounds_phi00 = phi;
  }
  areaStream.point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  areaStream.lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(bounds_lambda00, bounds_phi00);
  areaStream.lineEnd();
  if (abs(deltaSum) > math_epsilon) bounds_lambda0 = -(lambda1 = 180);
  range[0] = bounds_lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function bounds_angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* harmony default export */ function src_bounds(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(bounds_lambda0 = phi0 = Infinity);
  ranges = [];
  bounds_stream(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (bounds_angle(a[0], b[1]) > bounds_angle(a[0], a[1])) a[1] = b[1];
        if (bounds_angle(b[0], a[1]) > bounds_angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = bounds_angle(a[1], b[0])) > deltaMax) deltaMax = delta, bounds_lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return bounds_lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[bounds_lambda0, phi0], [lambda1, phi1]];
}

;// ../../node_modules/d3-geo/src/centroid.js
Object.defineProperty(src_centroid, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var centroid_epsilon2;
/* unused harmony import specifier */ var centroid_epsilon;
/* unused harmony import specifier */ var centroid_atan2;
/* unused harmony import specifier */ var centroid_degrees;
/* unused harmony import specifier */ var centroid_asin;
/* unused harmony import specifier */ var centroid_sqrt;
/* unused harmony import specifier */ var centroid_stream;




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    centroid_lambda00, centroid_phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: noop,
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi);
  centroidPointCartesian(cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi);
  x0 = cosPhi * cos(lambda);
  y0 = cosPhi * sin(lambda);
  z0 = sin(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi),
      x = cosPhi * cos(lambda),
      y = cosPhi * sin(lambda),
      z = sin(phi),
      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(centroid_lambda00, centroid_phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  centroid_lambda00 = lambda, centroid_phi00 = phi;
  lambda *= radians, phi *= radians;
  centroidStream.point = centroidRingPoint;
  var cosPhi = cos(phi);
  x0 = cosPhi * cos(lambda);
  y0 = cosPhi * sin(lambda);
  z0 = sin(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi),
      x = cosPhi * cos(lambda),
      y = cosPhi * sin(lambda),
      z = sin(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = sqrt(cx * cx + cy * cy + cz * cz),
      w = asin(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* harmony default export */ function src_centroid(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  centroid_stream(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < centroid_epsilon2) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < centroid_epsilon) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < centroid_epsilon2) return [NaN, NaN];
  }

  return [centroid_atan2(y, x) * centroid_degrees, centroid_asin(z / centroid_sqrt(m)) * centroid_degrees];
}

;// ../../node_modules/d3-geo/src/rotation.js
Object.defineProperty(rotation, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var compose;
/* unused harmony import specifier */ var rotation_tau;
/* unused harmony import specifier */ var rotation_pi;
/* unused harmony import specifier */ var rotation_cos;
/* unused harmony import specifier */ var rotation_sin;
/* unused harmony import specifier */ var rotation_atan2;
/* unused harmony import specifier */ var rotation_asin;
/* unused harmony import specifier */ var rotation_radians;
/* unused harmony import specifier */ var rotation_degrees;



function rotationIdentity(lambda, phi) {
  return [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= rotation_tau) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > rotation_pi ? lambda - rotation_tau : lambda < -rotation_pi ? lambda + rotation_tau : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = rotation_cos(deltaPhi),
      sinDeltaPhi = rotation_sin(deltaPhi),
      cosDeltaGamma = rotation_cos(deltaGamma),
      sinDeltaGamma = rotation_sin(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = rotation_cos(phi),
        x = rotation_cos(lambda) * cosPhi,
        y = rotation_sin(lambda) * cosPhi,
        z = rotation_sin(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      rotation_atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      rotation_asin(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = rotation_cos(phi),
        x = rotation_cos(lambda) * cosPhi,
        y = rotation_sin(lambda) * cosPhi,
        z = rotation_sin(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      rotation_atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      rotation_asin(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ function rotation(rotate) {
  rotate = rotateRadians(rotate[0] * rotation_radians, rotate[1] * rotation_radians, rotate.length > 2 ? rotate[2] * rotation_radians : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * rotation_radians, coordinates[1] * rotation_radians);
    return coordinates[0] *= rotation_degrees, coordinates[1] *= rotation_degrees, coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * rotation_radians, coordinates[1] * rotation_radians);
    return coordinates[0] *= rotation_degrees, coordinates[1] *= rotation_degrees, coordinates;
  };

  return forward;
}

;// ../../node_modules/d3-geo/src/circle.js
Object.defineProperty(src_circle, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var circle_spherical;
/* unused harmony import specifier */ var circle_cartesian;
/* unused harmony import specifier */ var circle_cartesianNormalizeInPlace;
/* unused harmony import specifier */ var circle_constant;
/* unused harmony import specifier */ var circle_cos;
/* unused harmony import specifier */ var circle_sin;
/* unused harmony import specifier */ var circle_tau;
/* unused harmony import specifier */ var circle_acos;
/* unused harmony import specifier */ var circle_epsilon;
/* unused harmony import specifier */ var circle_degrees;
/* unused harmony import specifier */ var circle_radians;
/* unused harmony import specifier */ var circle_rotateRadians;





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = circle_cos(radius),
      sinRadius = circle_sin(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * circle_tau;
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * circle_tau;
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = circle_spherical([cosRadius, -sinRadius * circle_cos(t), -sinRadius * circle_sin(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = circle_cartesian(point), point[0] -= cosRadius;
  circle_cartesianNormalizeInPlace(point);
  var radius = circle_acos(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + circle_tau - circle_epsilon) % circle_tau;
}

/* harmony default export */ function src_circle() {
  var center = circle_constant([0, 0]),
      radius = circle_constant(90),
      precision = circle_constant(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= circle_degrees, x[1] *= circle_degrees;
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * circle_radians,
        p = precision.apply(this, arguments) * circle_radians;
    ring = [];
    rotate = circle_rotateRadians(-c[0] * circle_radians, -c[1] * circle_radians, 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : circle_constant([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : circle_constant(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : circle_constant(+_), circle) : precision;
  };

  return circle;
}

;// ../../node_modules/d3-geo/src/pointEqual.js
Object.defineProperty(pointEqual, "name", { value: "default", configurable: true });


/* harmony default export */ function pointEqual(a, b) {
  return abs(a[0] - b[0]) < math_epsilon && abs(a[1] - b[1]) < math_epsilon;
}

;// ../../node_modules/d3-geo/src/clip/polygon.js
Object.defineProperty(clip_polygon, "name", { value: "default", configurable: true });


function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ function clip_polygon(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (pointEqual(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  polygon_link(subject);
  polygon_link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
}

function polygon_link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}

;// ../../node_modules/d3-geo/node_modules/d3-array/src/ascending.js
Object.defineProperty(ascending, "name", { value: "default", configurable: true });
/* harmony default export */ function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

;// ../../node_modules/d3-geo/node_modules/d3-array/src/bisector.js
Object.defineProperty(bisector, "name", { value: "default", configurable: true });


/* harmony default export */ function bisector(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
}

function ascendingComparator(f) {
  return function(d, x) {
    return ascending(f(d), x);
  };
}

;// ../../node_modules/d3-geo/node_modules/d3-array/src/bisect.js



var ascendingBisect = bisector(ascending);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ const bisect = ((/* unused pure expression or super */ null && (bisectRight)));

;// ../../node_modules/d3-geo/node_modules/d3-array/src/array.js
var array = Array.prototype;

var slice = array.slice;
var map = array.map;

;// ../../node_modules/d3-geo/node_modules/d3-array/src/ticks.js
Object.defineProperty(ticks, "name", { value: "default", configurable: true });
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

;// ../../node_modules/d3-geo/node_modules/d3-array/src/histogram.js
Object.defineProperty(histogram, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var histogram_slice;
/* unused harmony import specifier */ var histogram_bisect;
/* unused harmony import specifier */ var histogram_constant;
/* unused harmony import specifier */ var extent;
/* unused harmony import specifier */ var identity;
/* unused harmony import specifier */ var histogram_range;
/* unused harmony import specifier */ var histogram_tickStep;
/* unused harmony import specifier */ var sturges;









/* harmony default export */ function histogram() {
  var value = identity,
      domain = extent,
      threshold = sturges;

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = histogram_tickStep(x0, x1, tz);
      tz = histogram_range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[histogram_bisect(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : histogram_constant(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : histogram_constant([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? histogram_constant(histogram_slice.call(_)) : histogram_constant(_), histogram) : threshold;
  };

  return histogram;
}

;// ../../node_modules/d3-geo/node_modules/d3-array/src/threshold/freedmanDiaconis.js
Object.defineProperty(freedmanDiaconis, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var freedmanDiaconis_map;
/* unused harmony import specifier */ var freedmanDiaconis_ascending;
/* unused harmony import specifier */ var number;
/* unused harmony import specifier */ var quantile;





/* harmony default export */ function freedmanDiaconis(values, min, max) {
  values = freedmanDiaconis_map.call(values, number).sort(freedmanDiaconis_ascending);
  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

;// ../../node_modules/d3-geo/node_modules/d3-array/src/merge.js
Object.defineProperty(src_merge, "name", { value: "default", configurable: true });
/* harmony default export */ function src_merge(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
}

;// ../../node_modules/d3-geo/node_modules/d3-array/src/index.js




























;// ../../node_modules/d3-geo/src/clip/extent.js
Object.defineProperty(clip_extent, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var extent_abs;
/* unused harmony import specifier */ var extent_epsilon;
/* unused harmony import specifier */ var clipBuffer;
/* unused harmony import specifier */ var clipLine;
/* unused harmony import specifier */ var extent_clipPolygon;
/* unused harmony import specifier */ var extent_merge;






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipExtent(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return extent_abs(p[0] - x0) < extent_epsilon ? direction > 0 ? 0 : 3
        : extent_abs(p[0] - x1) < extent_epsilon ? direction > 0 ? 2 : 1
        : extent_abs(p[1] - y0) < extent_epsilon ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = clipBuffer(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = extent_merge(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          extent_clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (clipLine(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}

/* harmony default export */ function clip_extent() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
}

;// ../../node_modules/d3-geo/src/polygonContains.js
Object.defineProperty(polygonContains, "name", { value: "default", configurable: true });




var polygonContains_sum = adder();

/* harmony default export */ function polygonContains(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [sin(lambda), -cos(lambda), 0],
      angle = 0,
      winding = 0;

  polygonContains_sum.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + quarterPi,
        sinPhi0 = sin(phi0),
        cosPhi0 = cos(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + quarterPi,
          sinPhi1 = sin(phi1),
          cosPhi1 = cos(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > pi,
          k = sinPhi0 * sinPhi1;

      polygonContains_sum.add(atan2(k * sign * sin(absDelta), cosPhi0 * cosPhi1 + k * cos(absDelta)));
      angle += antimeridian ? delta + sign * tau : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -math_epsilon || angle < math_epsilon && polygonContains_sum < -math_epsilon) ^ (winding & 1);
}

;// ../../node_modules/d3-geo/src/length.js
Object.defineProperty(src_length, "name", { value: "default", configurable: true });





var lengthSum = adder(),
    length_lambda0,
    length_sinPhi0,
    length_cosPhi0;

var lengthStream = {
  sphere: noop,
  point: noop,
  lineStart: lengthLineStart,
  lineEnd: noop,
  polygonStart: noop,
  polygonEnd: noop
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = noop;
}

function lengthPointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  length_lambda0 = lambda, length_sinPhi0 = sin(phi), length_cosPhi0 = cos(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var sinPhi = sin(phi),
      cosPhi = cos(phi),
      delta = abs(lambda - length_lambda0),
      cosDelta = cos(delta),
      sinDelta = sin(delta),
      x = cosPhi * sinDelta,
      y = length_cosPhi0 * sinPhi - length_sinPhi0 * cosPhi * cosDelta,
      z = length_sinPhi0 * sinPhi + length_cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(atan2(sqrt(x * x + y * y), z));
  length_lambda0 = lambda, length_sinPhi0 = sinPhi, length_cosPhi0 = cosPhi;
}

/* harmony default export */ function src_length(object) {
  lengthSum.reset();
  stream(object, lengthStream);
  return +lengthSum;
}

;// ../../node_modules/d3-geo/src/distance.js
Object.defineProperty(src_distance, "name", { value: "default", configurable: true });


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ function src_distance(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return src_length(object);
}

;// ../../node_modules/d3-geo/src/contains.js
Object.defineProperty(src_contains, "name", { value: "default", configurable: true });




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return src_distance(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = src_distance(coordinates[0], coordinates[1]),
      ao = src_distance(coordinates[0], point),
      ob = src_distance(point, coordinates[1]);
  return ao + ob <= ab + math_epsilon;
}

function containsPolygon(coordinates, point) {
  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * radians, point[1] * radians];
}

/* harmony default export */ function src_contains(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
}

;// ../../node_modules/d3-geo/src/graticule.js
/* unused harmony import specifier */ var graticule_range;
/* unused harmony import specifier */ var graticule_epsilon;
/* unused harmony import specifier */ var graticule_ceil;
/* unused harmony import specifier */ var graticule_abs;



function graticuleX(y0, y1, dy) {
  var y = graticule_range(y0, y1 - graticule_epsilon, dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = graticule_range(x0, x1 - graticule_epsilon, dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return graticule_range(graticule_ceil(X0 / DX) * DX, X1, DX).map(X)
        .concat(graticule_range(graticule_ceil(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(graticule_range(graticule_ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return graticule_abs(x % DX) > graticule_epsilon; }).map(x))
        .concat(graticule_range(graticule_ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return graticule_abs(y % DY) > graticule_epsilon; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + graticule_epsilon], [180, 90 - graticule_epsilon]])
      .extentMinor([[-180, -80 - graticule_epsilon], [180, 80 + graticule_epsilon]]);
}

function graticule10() {
  return graticule()();
}

;// ../../node_modules/d3-geo/src/interpolate.js
Object.defineProperty(interpolate, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var interpolate_radians;
/* unused harmony import specifier */ var interpolate_cos;
/* unused harmony import specifier */ var interpolate_sin;
/* unused harmony import specifier */ var interpolate_asin;
/* unused harmony import specifier */ var interpolate_sqrt;
/* unused harmony import specifier */ var interpolate_haversin;
/* unused harmony import specifier */ var interpolate_atan2;
/* unused harmony import specifier */ var interpolate_degrees;


/* harmony default export */ function interpolate(a, b) {
  var x0 = a[0] * interpolate_radians,
      y0 = a[1] * interpolate_radians,
      x1 = b[0] * interpolate_radians,
      y1 = b[1] * interpolate_radians,
      cy0 = interpolate_cos(y0),
      sy0 = interpolate_sin(y0),
      cy1 = interpolate_cos(y1),
      sy1 = interpolate_sin(y1),
      kx0 = cy0 * interpolate_cos(x0),
      ky0 = cy0 * interpolate_sin(x0),
      kx1 = cy1 * interpolate_cos(x1),
      ky1 = cy1 * interpolate_sin(x1),
      d = 2 * interpolate_asin(interpolate_sqrt(interpolate_haversin(y1 - y0) + cy0 * cy1 * interpolate_haversin(x1 - x0))),
      k = interpolate_sin(d);

  var interpolate = d ? function(t) {
    var B = interpolate_sin(t *= d) / k,
        A = interpolate_sin(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      interpolate_atan2(y, x) * interpolate_degrees,
      interpolate_atan2(z, interpolate_sqrt(x * x + y * y)) * interpolate_degrees
    ];
  } : function() {
    return [x0 * interpolate_degrees, y0 * interpolate_degrees];
  };

  interpolate.distance = d;

  return interpolate;
}

;// ../../node_modules/d3-geo/src/path/area.js




var area_areaSum = adder(),
    area_areaRingSum = adder(),
    x00,
    y00,
    area_x0,
    area_y0;

var area_areaStream = {
  point: noop,
  lineStart: noop,
  lineEnd: noop,
  polygonStart: function() {
    area_areaStream.lineStart = area_areaRingStart;
    area_areaStream.lineEnd = area_areaRingEnd;
  },
  polygonEnd: function() {
    area_areaStream.lineStart = area_areaStream.lineEnd = area_areaStream.point = noop;
    area_areaSum.add(abs(area_areaRingSum));
    area_areaRingSum.reset();
  },
  result: function() {
    var area = area_areaSum / 2;
    area_areaSum.reset();
    return area;
  }
};

function area_areaRingStart() {
  area_areaStream.point = area_areaPointFirst;
}

function area_areaPointFirst(x, y) {
  area_areaStream.point = area_areaPoint;
  x00 = area_x0 = x, y00 = area_y0 = y;
}

function area_areaPoint(x, y) {
  area_areaRingSum.add(area_y0 * x - area_x0 * y);
  area_x0 = x, area_y0 = y;
}

function area_areaRingEnd() {
  area_areaPoint(x00, y00);
}

/* harmony default export */ const path_area = ((/* unused pure expression or super */ null && (area_areaStream)));

;// ../../node_modules/d3-geo/src/path/bounds.js


var bounds_x0 = Infinity,
    bounds_y0 = bounds_x0,
    x1 = -bounds_x0,
    y1 = x1;

var bounds_boundsStream = {
  point: bounds_boundsPoint,
  lineStart: noop,
  lineEnd: noop,
  polygonStart: noop,
  polygonEnd: noop,
  result: function() {
    var bounds = [[bounds_x0, bounds_y0], [x1, y1]];
    x1 = y1 = -(bounds_y0 = bounds_x0 = Infinity);
    return bounds;
  }
};

function bounds_boundsPoint(x, y) {
  if (x < bounds_x0) bounds_x0 = x;
  if (x > x1) x1 = x;
  if (y < bounds_y0) bounds_y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ const path_bounds = ((/* unused pure expression or super */ null && (bounds_boundsStream)));

;// ../../node_modules/d3-geo/src/path/centroid.js


// TODO Enforce positive area for exterior, negative area for interior?

var centroid_X0 = 0,
    centroid_Y0 = 0,
    centroid_Z0 = 0,
    centroid_X1 = 0,
    centroid_Y1 = 0,
    centroid_Z1 = 0,
    centroid_X2 = 0,
    centroid_Y2 = 0,
    centroid_Z2 = 0,
    centroid_x00,
    centroid_y00,
    centroid_x0,
    centroid_y0;

var centroid_centroidStream = {
  point: centroid_centroidPoint,
  lineStart: centroid_centroidLineStart,
  lineEnd: centroid_centroidLineEnd,
  polygonStart: function() {
    centroid_centroidStream.lineStart = centroid_centroidRingStart;
    centroid_centroidStream.lineEnd = centroid_centroidRingEnd;
  },
  polygonEnd: function() {
    centroid_centroidStream.point = centroid_centroidPoint;
    centroid_centroidStream.lineStart = centroid_centroidLineStart;
    centroid_centroidStream.lineEnd = centroid_centroidLineEnd;
  },
  result: function() {
    var centroid = centroid_Z2 ? [centroid_X2 / centroid_Z2, centroid_Y2 / centroid_Z2]
        : centroid_Z1 ? [centroid_X1 / centroid_Z1, centroid_Y1 / centroid_Z1]
        : centroid_Z0 ? [centroid_X0 / centroid_Z0, centroid_Y0 / centroid_Z0]
        : [NaN, NaN];
    centroid_X0 = centroid_Y0 = centroid_Z0 =
    centroid_X1 = centroid_Y1 = centroid_Z1 =
    centroid_X2 = centroid_Y2 = centroid_Z2 = 0;
    return centroid;
  }
};

function centroid_centroidPoint(x, y) {
  centroid_X0 += x;
  centroid_Y0 += y;
  ++centroid_Z0;
}

function centroid_centroidLineStart() {
  centroid_centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroid_centroidStream.point = centroidPointLine;
  centroid_centroidPoint(centroid_x0 = x, centroid_y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - centroid_x0, dy = y - centroid_y0, z = sqrt(dx * dx + dy * dy);
  centroid_X1 += z * (centroid_x0 + x) / 2;
  centroid_Y1 += z * (centroid_y0 + y) / 2;
  centroid_Z1 += z;
  centroid_centroidPoint(centroid_x0 = x, centroid_y0 = y);
}

function centroid_centroidLineEnd() {
  centroid_centroidStream.point = centroid_centroidPoint;
}

function centroid_centroidRingStart() {
  centroid_centroidStream.point = centroidPointFirstRing;
}

function centroid_centroidRingEnd() {
  centroidPointRing(centroid_x00, centroid_y00);
}

function centroidPointFirstRing(x, y) {
  centroid_centroidStream.point = centroidPointRing;
  centroid_centroidPoint(centroid_x00 = centroid_x0 = x, centroid_y00 = centroid_y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - centroid_x0,
      dy = y - centroid_y0,
      z = sqrt(dx * dx + dy * dy);

  centroid_X1 += z * (centroid_x0 + x) / 2;
  centroid_Y1 += z * (centroid_y0 + y) / 2;
  centroid_Z1 += z;

  z = centroid_y0 * x - centroid_x0 * y;
  centroid_X2 += z * (centroid_x0 + x);
  centroid_Y2 += z * (centroid_y0 + y);
  centroid_Z2 += z * 3;
  centroid_centroidPoint(centroid_x0 = x, centroid_y0 = y);
}

/* harmony default export */ const path_centroid = ((/* unused pure expression or super */ null && (centroid_centroidStream)));

;// ../../node_modules/d3-geo/src/path/context.js



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, tau);
        break;
      }
    }
  },
  result: noop
};

;// ../../node_modules/d3-geo/src/path/measure.js




var measure_lengthSum = adder(),
    lengthRing,
    measure_x00,
    measure_y00,
    measure_x0,
    measure_y0;

var measure_lengthStream = {
  point: noop,
  lineStart: function() {
    measure_lengthStream.point = measure_lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) measure_lengthPoint(measure_x00, measure_y00);
    measure_lengthStream.point = noop;
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +measure_lengthSum;
    measure_lengthSum.reset();
    return length;
  }
};

function measure_lengthPointFirst(x, y) {
  measure_lengthStream.point = measure_lengthPoint;
  measure_x00 = measure_x0 = x, measure_y00 = measure_y0 = y;
}

function measure_lengthPoint(x, y) {
  measure_x0 -= x, measure_y0 -= y;
  measure_lengthSum.add(sqrt(measure_x0 * measure_x0 + measure_y0 * measure_y0));
  measure_x0 = x, measure_y0 = y;
}

/* harmony default export */ const measure = ((/* unused pure expression or super */ null && (measure_lengthStream)));

;// ../../node_modules/d3-geo/src/path/string.js
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: string_circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = string_circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function string_circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}

;// ../../node_modules/d3-geo/src/path/index.js
Object.defineProperty(path, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var path_identity;
/* unused harmony import specifier */ var path_stream;
/* unused harmony import specifier */ var pathArea;
/* unused harmony import specifier */ var pathBounds;
/* unused harmony import specifier */ var pathCentroid;
/* unused harmony import specifier */ var path_PathContext;
/* unused harmony import specifier */ var pathMeasure;
/* unused harmony import specifier */ var path_PathString;









/* harmony default export */ function path(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      path_stream(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    path_stream(object, projectionStream(pathArea));
    return pathArea.result();
  };

  path.measure = function(object) {
    path_stream(object, projectionStream(pathMeasure));
    return pathMeasure.result();
  };

  path.bounds = function(object) {
    path_stream(object, projectionStream(pathBounds));
    return pathBounds.result();
  };

  path.centroid = function(object) {
    path_stream(object, projectionStream(pathCentroid));
    return pathCentroid.result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, path_identity) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new path_PathString) : new path_PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
}

;// ../../node_modules/d3-geo/src/clip/buffer.js
Object.defineProperty(clip_buffer, "name", { value: "default", configurable: true });


/* harmony default export */ function clip_buffer() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop,
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
}

;// ../../node_modules/d3-geo/src/clip/index.js
Object.defineProperty(clip, "name", { value: "default", configurable: true });






/* harmony default export */ function clip(pointVisible, clipLine, interpolate, start) {
  return function(rotate, sink) {
    var line = clipLine(sink),
        rotatedStart = rotate.invert(start[0], start[1]),
        ringBuffer = clip_buffer(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = src_merge(segments);
        var startInside = polygonContains(polygon, rotatedStart);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          clip_polygon(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      var point = rotate(lambda, phi);
      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      var point = rotate(lambda, phi);
      line.point(point[0], point[1]);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      var point = rotate(lambda, phi);
      ringSink.point(point[0], point[1]);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
}

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - halfPi - math_epsilon : halfPi - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - halfPi - math_epsilon : halfPi - b[1]);
}

;// ../../node_modules/d3-geo/src/clip/antimeridian.js



/* harmony default export */ const antimeridian = (clip(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-pi, -halfPi]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? pi : -pi,
          delta = abs(lambda1 - lambda0);
      if (abs(delta - pi) < math_epsilon) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi : -halfPi);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi) { // line crosses antimeridian
        if (abs(lambda0 - sign0) < math_epsilon) lambda0 -= sign0 * math_epsilon; // handle degeneracies
        if (abs(lambda1 - sign1) < math_epsilon) lambda1 -= sign1 * math_epsilon;
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = sin(lambda0 - lambda1);
  return abs(sinLambda0Lambda1) > math_epsilon
      ? atan((sin(phi0) * (cosPhi1 = cos(phi1)) * sin(lambda1)
          - sin(phi1) * (cosPhi0 = cos(phi0)) * sin(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * halfPi;
    stream.point(-pi, phi);
    stream.point(0, phi);
    stream.point(pi, phi);
    stream.point(pi, 0);
    stream.point(pi, -phi);
    stream.point(0, -phi);
    stream.point(-pi, -phi);
    stream.point(-pi, 0);
    stream.point(-pi, phi);
  } else if (abs(from[0] - to[0]) > math_epsilon) {
    var lambda = from[0] < to[0] ? pi : -pi;
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}

;// ../../node_modules/d3-geo/src/clip/circle.js
Object.defineProperty(clip_circle, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var clip_circle_cartesian;
/* unused harmony import specifier */ var circle_cartesianCross;
/* unused harmony import specifier */ var circle_cartesianDot;
/* unused harmony import specifier */ var circle_cartesianScale;
/* unused harmony import specifier */ var circle_cartesianAddInPlace;
/* unused harmony import specifier */ var clip_circle_spherical;
/* unused harmony import specifier */ var circle_circleStream;
/* unused harmony import specifier */ var clip_circle_cos;
/* unused harmony import specifier */ var circle_abs;
/* unused harmony import specifier */ var clip_circle_epsilon;
/* unused harmony import specifier */ var circle_pi;
/* unused harmony import specifier */ var circle_sqrt;
/* unused harmony import specifier */ var circle_pointEqual;
/* unused harmony import specifier */ var circle_clip;






/* harmony default export */ function clip_circle(radius, delta) {
  var cr = clip_circle_cos(radius),
      smallRadius = cr > 0,
      notHemisphere = circle_abs(cr) > clip_circle_epsilon; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    circle_circleStream(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return clip_circle_cos(lambda) * clip_circle_cos(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? circle_pi : -circle_pi), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || circle_pointEqual(point0, point2) || circle_pointEqual(point1, point2)) {
            point1[0] += clip_circle_epsilon;
            point1[1] += clip_circle_epsilon;
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !circle_pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = clip_circle_cartesian(a),
        pb = clip_circle_cartesian(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = circle_cartesianCross(pa, pb),
        n2n2 = circle_cartesianDot(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = circle_cartesianCross(n1, n2),
        A = circle_cartesianScale(n1, c1),
        B = circle_cartesianScale(n2, c2);
    circle_cartesianAddInPlace(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = circle_cartesianDot(A, u),
        uu = circle_cartesianDot(u, u),
        t2 = w * w - uu * (circle_cartesianDot(A, A) - 1);

    if (t2 < 0) return;

    var t = circle_sqrt(t2),
        q = circle_cartesianScale(u, (-w - t) / uu);
    circle_cartesianAddInPlace(q, A);
    q = clip_circle_spherical(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = circle_abs(delta - circle_pi) < clip_circle_epsilon,
        meridian = polar || delta < clip_circle_epsilon;

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (circle_abs(q[0] - lambda0) < clip_circle_epsilon ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > circle_pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = circle_cartesianScale(u, (-w + t) / uu);
      circle_cartesianAddInPlace(q1, A);
      return [q, clip_circle_spherical(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : circle_pi - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return circle_clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-circle_pi, radius - circle_pi]);
}

;// ../../node_modules/d3-geo/src/transform.js
Object.defineProperty(transform, "name", { value: "default", configurable: true });
/* harmony default export */ function transform(methods) {
  return {
    stream: transformer(methods)
  };
}

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};

;// ../../node_modules/d3-geo/src/projection/fit.js
/* unused harmony import specifier */ var geoStream;
/* unused harmony import specifier */ var fit_boundsStream;



function fitExtent(projection, extent, object) {
  var w = extent[1][0] - extent[0][0],
      h = extent[1][1] - extent[0][1],
      clip = projection.clipExtent && projection.clipExtent();

  projection
      .scale(150)
      .translate([0, 0]);

  if (clip != null) projection.clipExtent(null);

  geoStream(object, projection.stream(fit_boundsStream));

  var b = fit_boundsStream.result(),
      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;

  if (clip != null) projection.clipExtent(clip);

  return projection
      .scale(k * 150)
      .translate([x, y]);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

;// ../../node_modules/d3-geo/src/projection/resample.js
Object.defineProperty(resample, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var resample_cartesian;
/* unused harmony import specifier */ var resample_sqrt;
/* unused harmony import specifier */ var resample_asin;
/* unused harmony import specifier */ var resample_abs;
/* unused harmony import specifier */ var resample_epsilon;
/* unused harmony import specifier */ var resample_atan2;
/* unused harmony import specifier */ var resample_transformer;




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = cos(30 * radians); // cos(minimum angular distance)

/* harmony default export */ function resample(project, delta2) {
  return +delta2 ? resample_resample(project, delta2) : resampleNone(project);
}

function resampleNone(project) {
  return resample_transformer({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample_resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = resample_sqrt(a * a + b * b + c * c),
          phi2 = resample_asin(c /= m),
          lambda2 = resample_abs(resample_abs(c) - 1) < resample_epsilon || resample_abs(lambda0 - lambda1) < resample_epsilon ? (lambda0 + lambda1) / 2 : resample_atan2(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || resample_abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = resample_cartesian([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}

;// ../../node_modules/d3-geo/src/projection/index.js
/* unused harmony import specifier */ var clipAntimeridian;
/* unused harmony import specifier */ var clipCircle;
/* unused harmony import specifier */ var projection_clipExtent;
/* unused harmony import specifier */ var projection_compose;
/* unused harmony import specifier */ var projection_identity;
/* unused harmony import specifier */ var projection_radians;
/* unused harmony import specifier */ var projection_degrees;
/* unused harmony import specifier */ var projection_sqrt;
/* unused harmony import specifier */ var projection_rotateRadians;
/* unused harmony import specifier */ var projection_fitExtent;
/* unused harmony import specifier */ var projection_fitSize;
/* unused harmony import specifier */ var projection_resample;











var transformRadians = transformer({
  point: function(x, y) {
    this.stream.point(x * radians, y * radians);
  }
});

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = clipAntimeridian, // clip angle
      x0 = null, y0, x1, y1, postclip = projection_identity, // clip extent
      delta2 = 0.5, projectResample = projection_resample(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * projection_radians, point[1] * projection_radians);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * projection_degrees, point[1] * projection_degrees];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * projection_radians, 6 * projection_radians) : (theta = null, clipAntimeridian), reset()) : theta * projection_degrees;
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, projection_identity) : projection_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * projection_radians, phi = _[1] % 360 * projection_radians, recenter()) : [lambda * projection_degrees, phi * projection_degrees];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * projection_radians, deltaPhi = _[1] % 360 * projection_radians, deltaGamma = _.length > 2 ? _[2] % 360 * projection_radians : 0, recenter()) : [deltaLambda * projection_degrees, deltaPhi * projection_degrees, deltaGamma * projection_degrees];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = projection_resample(projectTransform, delta2 = _ * _), reset()) : projection_sqrt(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return projection_fitExtent(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return projection_fitSize(projection, size, object);
  };

  function recenter() {
    projectRotate = projection_compose(rotate = projection_rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}

;// ../../node_modules/d3-geo/src/projection/conic.js
/* unused harmony import specifier */ var conic_pi;
/* unused harmony import specifier */ var conic_radians;
/* unused harmony import specifier */ var conic_degrees;
/* unused harmony import specifier */ var conic_projectionMutator;



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = conic_pi / 3,
      m = conic_projectionMutator(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * conic_radians, phi1 = _[1] * conic_radians) : [phi0 * conic_degrees, phi1 * conic_degrees];
  };

  return p;
}

;// ../../node_modules/d3-geo/src/projection/cylindricalEqualArea.js
/* unused harmony import specifier */ var cylindricalEqualArea_cos;
/* unused harmony import specifier */ var cylindricalEqualArea_sin;
/* unused harmony import specifier */ var cylindricalEqualArea_asin;


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = cylindricalEqualArea_cos(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, cylindricalEqualArea_sin(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, cylindricalEqualArea_asin(y * cosPhi0)];
  };

  return forward;
}

;// ../../node_modules/d3-geo/src/projection/conicEqualArea.js
Object.defineProperty(conicEqualArea, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var conicEqualArea_sin;
/* unused harmony import specifier */ var conicEqualArea_abs;
/* unused harmony import specifier */ var conicEqualArea_epsilon;
/* unused harmony import specifier */ var conicEqualArea_sqrt;
/* unused harmony import specifier */ var conicEqualArea_cos;
/* unused harmony import specifier */ var conicEqualArea_atan2;
/* unused harmony import specifier */ var conicEqualArea_sign;
/* unused harmony import specifier */ var conicEqualArea_asin;
/* unused harmony import specifier */ var conicEqualArea_conicProjection;
/* unused harmony import specifier */ var conicEqualArea_cylindricalEqualAreaRaw;




function conicEqualAreaRaw(y0, y1) {
  var sy0 = conicEqualArea_sin(y0), n = (sy0 + conicEqualArea_sin(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (conicEqualArea_abs(n) < conicEqualArea_epsilon) return conicEqualArea_cylindricalEqualAreaRaw(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = conicEqualArea_sqrt(c) / n;

  function project(x, y) {
    var r = conicEqualArea_sqrt(c - 2 * n * conicEqualArea_sin(y)) / n;
    return [r * conicEqualArea_sin(x *= n), r0 - r * conicEqualArea_cos(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [conicEqualArea_atan2(x, conicEqualArea_abs(r0y)) / n * conicEqualArea_sign(r0y), conicEqualArea_asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ function conicEqualArea() {
  return conicEqualArea_conicProjection(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
}

;// ../../node_modules/d3-geo/src/projection/albers.js
Object.defineProperty(albers, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var albers_conicEqualArea;


/* harmony default export */ function albers() {
  return albers_conicEqualArea()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
}

;// ../../node_modules/d3-geo/src/projection/albersUsa.js
Object.defineProperty(albersUsa, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var albersUsa_epsilon;
/* unused harmony import specifier */ var albersUsa_albers;
/* unused harmony import specifier */ var albersUsa_conicEqualArea;
/* unused harmony import specifier */ var albersUsa_fitExtent;
/* unused harmony import specifier */ var albersUsa_fitSize;





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* harmony default export */ function albersUsa() {
  var cache,
      cacheStream,
      lower48 = albersUsa_albers(), lower48Point,
      alaska = albersUsa_conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = albersUsa_conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + albersUsa_epsilon, y + 0.120 * k + albersUsa_epsilon], [x - 0.214 * k - albersUsa_epsilon, y + 0.234 * k - albersUsa_epsilon]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + albersUsa_epsilon, y + 0.166 * k + albersUsa_epsilon], [x - 0.115 * k - albersUsa_epsilon, y + 0.234 * k - albersUsa_epsilon]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return albersUsa_fitExtent(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return albersUsa_fitSize(albersUsa, size, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
}

;// ../../node_modules/d3-geo/src/projection/azimuthal.js


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = cos(x),
        cy = cos(y),
        k = scale(cx * cy);
    return [
      k * cy * sin(x),
      k * sin(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = sqrt(x * x + y * y),
        c = angle(z),
        sc = sin(c),
        cc = cos(c);
    return [
      atan2(x * sc, z * cc),
      asin(z && y * sc / z)
    ];
  }
}

;// ../../node_modules/d3-geo/src/projection/azimuthalEqualArea.js
Object.defineProperty(azimuthalEqualArea, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var azimuthalEqualArea_projection;




var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
  return sqrt(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
  return 2 * asin(z / 2);
});

/* harmony default export */ function azimuthalEqualArea() {
  return azimuthalEqualArea_projection(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
}

;// ../../node_modules/d3-geo/src/projection/azimuthalEquidistant.js
Object.defineProperty(azimuthalEquidistant, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var azimuthalEquidistant_projection;




var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
  return (c = acos(c)) && c / sin(c);
});

azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
  return z;
});

/* harmony default export */ function azimuthalEquidistant() {
  return azimuthalEquidistant_projection(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
}

;// ../../node_modules/d3-geo/src/projection/mercator.js
Object.defineProperty(mercator, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var mercator_tau;
/* unused harmony import specifier */ var mercator_pi;
/* unused harmony import specifier */ var mercator_rotation;
/* unused harmony import specifier */ var mercator_projection;




function mercatorRaw(lambda, phi) {
  return [lambda, log(tan((halfPi + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * atan(exp(y)) - halfPi];
};

/* harmony default export */ function mercator() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / mercator_tau);
}

function mercatorProjection(project) {
  var m = mercator_projection(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = mercator_pi * scale(),
        t = m(mercator_rotation(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}

;// ../../node_modules/d3-geo/src/projection/conicConformal.js
Object.defineProperty(conicConformal, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var conicConformal_tan;
/* unused harmony import specifier */ var conicConformal_halfPi;
/* unused harmony import specifier */ var conicConformal_cos;
/* unused harmony import specifier */ var conicConformal_sin;
/* unused harmony import specifier */ var conicConformal_log;
/* unused harmony import specifier */ var conicConformal_pow;
/* unused harmony import specifier */ var conicConformal_epsilon;
/* unused harmony import specifier */ var conicConformal_sign;
/* unused harmony import specifier */ var conicConformal_sqrt;
/* unused harmony import specifier */ var conicConformal_atan2;
/* unused harmony import specifier */ var conicConformal_abs;
/* unused harmony import specifier */ var conicConformal_atan;
/* unused harmony import specifier */ var conicConformal_conicProjection;
/* unused harmony import specifier */ var conicConformal_mercatorRaw;




function tany(y) {
  return conicConformal_tan((conicConformal_halfPi + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = conicConformal_cos(y0),
      n = y0 === y1 ? conicConformal_sin(y0) : conicConformal_log(cy0 / conicConformal_cos(y1)) / conicConformal_log(tany(y1) / tany(y0)),
      f = cy0 * conicConformal_pow(tany(y0), n) / n;

  if (!n) return conicConformal_mercatorRaw;

  function project(x, y) {
    if (f > 0) { if (y < -conicConformal_halfPi + conicConformal_epsilon) y = -conicConformal_halfPi + conicConformal_epsilon; }
    else { if (y > conicConformal_halfPi - conicConformal_epsilon) y = conicConformal_halfPi - conicConformal_epsilon; }
    var r = f / conicConformal_pow(tany(y), n);
    return [r * conicConformal_sin(n * x), f - r * conicConformal_cos(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = conicConformal_sign(n) * conicConformal_sqrt(x * x + fy * fy);
    return [conicConformal_atan2(x, conicConformal_abs(fy)) / n * conicConformal_sign(fy), 2 * conicConformal_atan(conicConformal_pow(f / r, 1 / n)) - conicConformal_halfPi];
  };

  return project;
}

/* harmony default export */ function conicConformal() {
  return conicConformal_conicProjection(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
}

;// ../../node_modules/d3-geo/src/projection/equirectangular.js
Object.defineProperty(equirectangular, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var equirectangular_projection;


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* harmony default export */ function equirectangular() {
  return equirectangular_projection(equirectangularRaw)
      .scale(152.63);
}

;// ../../node_modules/d3-geo/src/projection/conicEquidistant.js
Object.defineProperty(conicEquidistant, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var conicEquidistant_cos;
/* unused harmony import specifier */ var conicEquidistant_sin;
/* unused harmony import specifier */ var conicEquidistant_abs;
/* unused harmony import specifier */ var conicEquidistant_epsilon;
/* unused harmony import specifier */ var conicEquidistant_atan2;
/* unused harmony import specifier */ var conicEquidistant_sign;
/* unused harmony import specifier */ var conicEquidistant_sqrt;
/* unused harmony import specifier */ var conicEquidistant_conicProjection;
/* unused harmony import specifier */ var conicEquidistant_equirectangularRaw;




function conicEquidistantRaw(y0, y1) {
  var cy0 = conicEquidistant_cos(y0),
      n = y0 === y1 ? conicEquidistant_sin(y0) : (cy0 - conicEquidistant_cos(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (conicEquidistant_abs(n) < conicEquidistant_epsilon) return conicEquidistant_equirectangularRaw;

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * conicEquidistant_sin(nx), g - gy * conicEquidistant_cos(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [conicEquidistant_atan2(x, conicEquidistant_abs(gy)) / n * conicEquidistant_sign(gy), g - conicEquidistant_sign(n) * conicEquidistant_sqrt(x * x + gy * gy)];
  };

  return project;
}

/* harmony default export */ function conicEquidistant() {
  return conicEquidistant_conicProjection(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
}

;// ../../node_modules/d3-geo/src/projection/gnomonic.js
Object.defineProperty(gnomonic, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var gnomonic_projection;




function gnomonicRaw(x, y) {
  var cy = cos(y), k = cos(x) * cy;
  return [cy * sin(x) / k, sin(y) / k];
}

gnomonicRaw.invert = azimuthalInvert(atan);

/* harmony default export */ function gnomonic() {
  return gnomonic_projection(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
}

;// ../../node_modules/d3-geo/src/projection/identity.js
Object.defineProperty(src_projection_identity, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var identity_clipExtent;
/* unused harmony import specifier */ var identity_identity;
/* unused harmony import specifier */ var identity_transformer;
/* unused harmony import specifier */ var identity_fitExtent;
/* unused harmony import specifier */ var identity_fitSize;





function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity_identity : identity_transformer({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

/* harmony default export */ function src_projection_identity() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = identity_identity, // scale, translate and reflect
      x0 = null, y0, x1, y1, clip = identity_identity, // clip extent
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
    },
    clipExtent: function(_) {
      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, identity_identity) : identity_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return identity_fitExtent(projection, extent, object);
    },
    fitSize: function(size, object) {
      return identity_fitSize(projection, size, object);
    }
  };
}

;// ../../node_modules/d3-geo/src/projection/naturalEarth1.js
Object.defineProperty(naturalEarth1, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var naturalEarth1_projection;



function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (abs(delta) > math_epsilon && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

/* harmony default export */ function naturalEarth1() {
  return naturalEarth1_projection(naturalEarth1Raw)
      .scale(175.295);
}

;// ../../node_modules/d3-geo/src/projection/orthographic.js
Object.defineProperty(orthographic, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var orthographic_epsilon;
/* unused harmony import specifier */ var orthographic_projection;




function orthographicRaw(x, y) {
  return [cos(y) * sin(x), sin(y)];
}

orthographicRaw.invert = azimuthalInvert(asin);

/* harmony default export */ function orthographic() {
  return orthographic_projection(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + orthographic_epsilon);
}

;// ../../node_modules/d3-geo/src/projection/stereographic.js
Object.defineProperty(stereographic, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var stereographic_projection;




function stereographicRaw(x, y) {
  var cy = cos(y), k = 1 + cos(x) * cy;
  return [cy * sin(x) / k, sin(y) / k];
}

stereographicRaw.invert = azimuthalInvert(function(z) {
  return 2 * atan(z);
});

/* harmony default export */ function stereographic() {
  return stereographic_projection(stereographicRaw)
      .scale(250)
      .clipAngle(142);
}

;// ../../node_modules/d3-geo/src/projection/transverseMercator.js
Object.defineProperty(transverseMercator, "name", { value: "default", configurable: true });
/* unused harmony import specifier */ var transverseMercator_mercatorProjection;



function transverseMercatorRaw(lambda, phi) {
  return [log(tan((halfPi + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * atan(exp(x)) - halfPi];
};

/* harmony default export */ function transverseMercator() {
  var m = transverseMercator_mercatorProjection(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
}

;// ../../node_modules/d3-geo/index.js




 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).


























;// ../../node_modules/@turf/buffer/dist/es/index.js
/* unused harmony import specifier */ var dist_es_center;
/* unused harmony import specifier */ var GeoJSONReader;
/* unused harmony import specifier */ var BufferOp;
/* unused harmony import specifier */ var GeoJSONWriter;
/* unused harmony import specifier */ var buffer_dist_es_geomEach;
/* unused harmony import specifier */ var buffer_dist_es_featureEach;
/* unused harmony import specifier */ var geoAzimuthalEquidistant;
/* unused harmony import specifier */ var buffer_dist_es_featureCollection;
/* unused harmony import specifier */ var dist_es_radiansToLength;
/* unused harmony import specifier */ var dist_es_lengthToRadians;
/* unused harmony import specifier */ var buffer_dist_es_feature;
/* unused harmony import specifier */ var buffer_dist_es_earthRadius;






/**
 * Calculates a buffer for input features for a given radius. Units supported are miles, kilometers, and degrees.
 *
 * When using a negative radius, the resulting geometry may be invalid if
 * it's too small compared to the radius magnitude. If the input is a
 * FeatureCollection, only valid members will be returned in the output
 * FeatureCollection - i.e., the output collection may have fewer members than
 * the input, or even be empty.
 *
 * @name buffer
 * @param {FeatureCollection|Geometry|Feature<any>} geojson input to be buffered
 * @param {number} radius distance to draw the buffer (negative values are allowed)
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units="kilometers"] any of the options supported by turf units
 * @param {number} [options.steps=8] number of steps
 * @returns {FeatureCollection|Feature<Polygon|MultiPolygon>|undefined} buffered features
 * @example
 * var point = turf.point([-90.548630, 14.616599]);
 * var buffered = turf.buffer(point, 500, {units: 'miles'});
 *
 * //addToMap
 * var addToMap = [point, buffered]
 */
function es_buffer(geojson, radius, options) {
  // Optional params
  options = options || {};

  // use user supplied options or default values
  var units = options.units || "kilometers";
  var steps = options.steps || 8;

  // validation
  if (!geojson) throw new Error("geojson is required");
  if (typeof options !== "object") throw new Error("options must be an object");
  if (typeof steps !== "number") throw new Error("steps must be an number");

  // Allow negative buffers ("erosion") or zero-sized buffers ("repair geometry")
  if (radius === undefined) throw new Error("radius is required");
  if (steps <= 0) throw new Error("steps must be greater than 0");

  var results = [];
  switch (geojson.type) {
    case "GeometryCollection":
      buffer_dist_es_geomEach(geojson, function (geometry) {
        var buffered = bufferFeature(geometry, radius, units, steps);
        if (buffered) results.push(buffered);
      });
      return buffer_dist_es_featureCollection(results);
    case "FeatureCollection":
      buffer_dist_es_featureEach(geojson, function (feature) {
        var multiBuffered = bufferFeature(feature, radius, units, steps);
        if (multiBuffered) {
          buffer_dist_es_featureEach(multiBuffered, function (buffered) {
            if (buffered) results.push(buffered);
          });
        }
      });
      return buffer_dist_es_featureCollection(results);
  }
  return bufferFeature(geojson, radius, units, steps);
}

/**
 * Buffer single Feature/Geometry
 *
 * @private
 * @param {Feature<any>} geojson input to be buffered
 * @param {number} radius distance to draw the buffer
 * @param {string} [units='kilometers'] any of the options supported by turf units
 * @param {number} [steps=8] number of steps
 * @returns {Feature<Polygon|MultiPolygon>} buffered feature
 */
function bufferFeature(geojson, radius, units, steps) {
  var properties = geojson.properties || {};
  var geometry = geojson.type === "Feature" ? geojson.geometry : geojson;

  // Geometry Types faster than jsts
  if (geometry.type === "GeometryCollection") {
    var results = [];
    buffer_dist_es_geomEach(geojson, function (geometry) {
      var buffered = bufferFeature(geometry, radius, units, steps);
      if (buffered) results.push(buffered);
    });
    return buffer_dist_es_featureCollection(results);
  }

  // Project GeoJSON to Azimuthal Equidistant projection (convert to Meters)
  var projection = defineProjection(geometry);
  var projected = {
    type: geometry.type,
    coordinates: projectCoords(geometry.coordinates, projection),
  };

  // JSTS buffer operation
  var reader = new GeoJSONReader();
  var geom = reader.read(projected);
  var distance = dist_es_radiansToLength(dist_es_lengthToRadians(radius, units), "meters");
  var buffered = BufferOp.bufferOp(geom, distance, steps);
  var writer = new GeoJSONWriter();
  buffered = writer.write(buffered);

  // Detect if empty geometries
  if (coordsIsNaN(buffered.coordinates)) return undefined;

  // Unproject coordinates (convert to Degrees)
  var result = {
    type: buffered.type,
    coordinates: unprojectCoords(buffered.coordinates, projection),
  };

  return buffer_dist_es_feature(result, properties);
}

/**
 * Coordinates isNaN
 *
 * @private
 * @param {Array<any>} coords GeoJSON Coordinates
 * @returns {boolean} if NaN exists
 */
function coordsIsNaN(coords) {
  if (Array.isArray(coords[0])) return coordsIsNaN(coords[0]);
  return isNaN(coords[0]);
}

/**
 * Project coordinates to projection
 *
 * @private
 * @param {Array<any>} coords to project
 * @param {GeoProjection} proj D3 Geo Projection
 * @returns {Array<any>} projected coordinates
 */
function projectCoords(coords, proj) {
  if (typeof coords[0] !== "object") return proj(coords);
  return coords.map(function (coord) {
    return projectCoords(coord, proj);
  });
}

/**
 * Un-Project coordinates to projection
 *
 * @private
 * @param {Array<any>} coords to un-project
 * @param {GeoProjection} proj D3 Geo Projection
 * @returns {Array<any>} un-projected coordinates
 */
function unprojectCoords(coords, proj) {
  if (typeof coords[0] !== "object") return proj.invert(coords);
  return coords.map(function (coord) {
    return unprojectCoords(coord, proj);
  });
}

/**
 * Define Azimuthal Equidistant projection
 *
 * @private
 * @param {Geometry|Feature<any>} geojson Base projection on center of GeoJSON
 * @returns {GeoProjection} D3 Geo Azimuthal Equidistant Projection
 */
function defineProjection(geojson) {
  var coords = dist_es_center(geojson).geometry.coordinates;
  var rotation = [-coords[0], -coords[1]];
  return geoAzimuthalEquidistant().rotate(rotation).scale(buffer_dist_es_earthRadius);
}

/* harmony default export */ const buffer_dist_es = ((/* unused pure expression or super */ null && (es_buffer)));

;// ../../node_modules/@turf/union/dist/es/index.js
/* unused harmony import specifier */ var es_polygonClipping;
/* unused harmony import specifier */ var union_dist_es_getGeom;
/* unused harmony import specifier */ var union_dist_es_polygon;
/* unused harmony import specifier */ var union_dist_es_multiPolygon;



/**
 * Takes two {@link (Multi)Polygon(s)} and returns a combined polygon. If the input polygons are not contiguous, this function returns a {@link MultiPolygon} feature.
 *
 * @name union
 * @param {Feature<Polygon|MultiPolygon>} polygon1 input Polygon feature
 * @param {Feature<Polygon|MultiPolygon>} polygon2 Polygon feature to difference from polygon1
 * @param {Object} [options={}] Optional Parameters
 * @param {Object} [options.properties={}] Translate Properties to output Feature
 * @returns {Feature<(Polygon|MultiPolygon)>} a combined {@link Polygon} or {@link MultiPolygon} feature, or null if the inputs are empty
 * @example
 * var poly1 = turf.polygon([[
 *     [-82.574787, 35.594087],
 *     [-82.574787, 35.615581],
 *     [-82.545261, 35.615581],
 *     [-82.545261, 35.594087],
 *     [-82.574787, 35.594087]
 * ]], {"fill": "#0f0"});
 * var poly2 = turf.polygon([[
 *     [-82.560024, 35.585153],
 *     [-82.560024, 35.602602],
 *     [-82.52964, 35.602602],
 *     [-82.52964, 35.585153],
 *     [-82.560024, 35.585153]
 * ]], {"fill": "#00f"});
 *
 * var union = turf.union(poly1, poly2);
 *
 * //addToMap
 * var addToMap = [poly1, poly2, union];
 */
function union(poly1, poly2, options) {
    if (options === void 0) { options = {}; }
    var geom1 = union_dist_es_getGeom(poly1);
    var geom2 = union_dist_es_getGeom(poly2);
    var unioned = es_polygonClipping.union(geom1.coordinates, geom2.coordinates);
    if (unioned.length === 0)
        return null;
    if (unioned.length === 1)
        return union_dist_es_polygon(unioned[0], options.properties);
    else
        return union_dist_es_multiPolygon(unioned, options.properties);
}
/* harmony default export */ const union_dist_es = ((/* unused pure expression or super */ null && (union)));

;// ../../node_modules/@turf/intersect/dist/es/index.js
/* unused harmony import specifier */ var intersect_dist_es_polygon;
/* unused harmony import specifier */ var intersect_dist_es_multiPolygon;
/* unused harmony import specifier */ var intersect_dist_es_getGeom;
/* unused harmony import specifier */ var dist_es_polygonClipping;



/**
 * Takes two {@link Polygon|polygon} or {@link MultiPolygon|multi-polygon} geometries and
 * finds their polygonal intersection. If they don't intersect, returns null.
 *
 * @name intersect
 * @param {Feature<Polygon | MultiPolygon>} poly1 the first polygon or multipolygon
 * @param {Feature<Polygon | MultiPolygon>} poly2 the second polygon or multipolygon
 * @param {Object} [options={}] Optional Parameters
 * @param {Object} [options.properties={}] Translate GeoJSON Properties to Feature
 * @returns {Feature|null} returns a feature representing the area they share (either a {@link Polygon} or
 * {@link MultiPolygon}). If they do not share any area, returns `null`.
 * @example
 * var poly1 = turf.polygon([[
 *   [-122.801742, 45.48565],
 *   [-122.801742, 45.60491],
 *   [-122.584762, 45.60491],
 *   [-122.584762, 45.48565],
 *   [-122.801742, 45.48565]
 * ]]);
 *
 * var poly2 = turf.polygon([[
 *   [-122.520217, 45.535693],
 *   [-122.64038, 45.553967],
 *   [-122.720031, 45.526554],
 *   [-122.669906, 45.507309],
 *   [-122.723464, 45.446643],
 *   [-122.532577, 45.408574],
 *   [-122.487258, 45.477466],
 *   [-122.520217, 45.535693]
 * ]]);
 *
 * var intersection = turf.intersect(poly1, poly2);
 *
 * //addToMap
 * var addToMap = [poly1, poly2, intersection];
 */
function es_intersect(poly1, poly2, options) {
    if (options === void 0) { options = {}; }
    var geom1 = intersect_dist_es_getGeom(poly1);
    var geom2 = intersect_dist_es_getGeom(poly2);
    var intersection = dist_es_polygonClipping.intersection(geom1.coordinates, geom2.coordinates);
    if (intersection.length === 0)
        return null;
    if (intersection.length === 1)
        return intersect_dist_es_polygon(intersection[0], options.properties);
    return intersect_dist_es_multiPolygon(intersection, options.properties);
}

;// ../../node_modules/@turf/dissolve/dist/es/index.js
/* unused harmony import specifier */ var dissolve_dist_es_isObject;
/* unused harmony import specifier */ var dissolve_dist_es_multiPolygon;
/* unused harmony import specifier */ var dissolve_dist_es_featureCollection;
/* unused harmony import specifier */ var dissolve_dist_es_collectionOf;
/* unused harmony import specifier */ var dissolve_dist_es_featureEach;
/* unused harmony import specifier */ var es_flatten;
/* unused harmony import specifier */ var dissolve_dist_es_polygonClipping;






/**
 * Dissolves a FeatureCollection of {@link polygon} features, filtered by an optional property name:value.
 * Note that {@link mulitpolygon} features within the collection are not supported
 *
 * @name dissolve
 * @param {FeatureCollection<Polygon>} featureCollection input feature collection to be dissolved
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.propertyName] features with the same `propertyName` value will be dissolved.
 * @returns {FeatureCollection<Polygon>} a FeatureCollection containing the dissolved polygons
 * @example
 * var features = turf.featureCollection([
 *   turf.polygon([[[0, 0], [0, 1], [1, 1], [1, 0], [0, 0]]], {combine: 'yes'}),
 *   turf.polygon([[[0, -1], [0, 0], [1, 0], [1, -1], [0,-1]]], {combine: 'yes'}),
 *   turf.polygon([[[1,-1],[1, 0], [2, 0], [2, -1], [1, -1]]], {combine: 'no'}),
 * ]);
 *
 * var dissolved = turf.dissolve(features, {propertyName: 'combine'});
 *
 * //addToMap
 * var addToMap = [features, dissolved]
 */
function dist_es_dissolve(fc, options) {
  // Optional parameters
  options = options || {};
  if (!dissolve_dist_es_isObject(options)) throw new Error("options is invalid");
  var propertyName = options.propertyName;

  // Input validation
  dissolve_dist_es_collectionOf(fc, "Polygon", "dissolve");

  // Main
  var outFeatures = [];
  if (!options.propertyName) {
    return es_flatten(
      dissolve_dist_es_multiPolygon(
        dissolve_dist_es_polygonClipping.union.apply(
          null,
          fc.features.map(function (f) {
            return f.geometry.coordinates;
          })
        )
      )
    );
  } else {
    var uniquePropertyVals = {};
    dissolve_dist_es_featureEach(fc, function (feature) {
      if (
        !Object.prototype.hasOwnProperty.call(
          uniquePropertyVals,
          feature.properties[propertyName]
        )
      ) {
        uniquePropertyVals[feature.properties[propertyName]] = [];
      }
      uniquePropertyVals[feature.properties[propertyName]].push(feature);
    });
    var vals = Object.keys(uniquePropertyVals);
    for (var i = 0; i < vals.length; i++) {
      var mp = dissolve_dist_es_multiPolygon(
        dissolve_dist_es_polygonClipping.union.apply(
          null,
          uniquePropertyVals[vals[i]].map(function (f) {
            return f.geometry.coordinates;
          })
        )
      );
      mp.properties[propertyName] = vals[i];
      outFeatures.push(mp);
    }
  }

  return es_flatten(dissolve_dist_es_featureCollection(outFeatures));
}

/* harmony default export */ const dissolve_dist_es = ((/* unused pure expression or super */ null && (dist_es_dissolve)));

;// ../../node_modules/@turf/hex-grid/dist/es/index.js
/* unused harmony import specifier */ var hex_grid_dist_es_distance;
/* unused harmony import specifier */ var dist_es_intersect;
/* unused harmony import specifier */ var hex_grid_dist_es_featureCollection;
/* unused harmony import specifier */ var hex_grid_dist_es_polygon;



/**
 * Takes a bounding box and the diameter of the cell and returns a {@link FeatureCollection} of flat-topped
 * hexagons or triangles ({@link Polygon} features) aligned in an "odd-q" vertical grid as
 * described in [Hexagonal Grids](http://www.redblobgames.com/grids/hexagons/).
 *
 * @name hexGrid
 * @param {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @param {number} cellSide length of the side of the the hexagons or triangles, in units. It will also coincide with the
 * radius of the circumcircle of the hexagons.
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] used in calculating cell size, can be degrees, radians, miles, or kilometers
 * @param {Object} [options.properties={}] passed to each hexagon or triangle of the grid
 * @param {Feature<Polygon>} [options.mask] if passed a Polygon or MultiPolygon, the grid Points will be created only inside it
 * @param {boolean} [options.triangles=false] whether to return as triangles instead of hexagons
 * @returns {FeatureCollection<Polygon>} a hexagonal grid
 * @example
 * var bbox = [-96,31,-84,40];
 * var cellSide = 50;
 * var options = {units: 'miles'};
 *
 * var hexgrid = turf.hexGrid(bbox, cellSide, options);
 *
 * //addToMap
 * var addToMap = [hexgrid];
 */
function hexGrid(bbox, cellSide, options) {
    if (options === void 0) { options = {}; }
    // Issue => https://github.com/Turfjs/turf/issues/1284
    var clonedProperties = JSON.stringify(options.properties || {});
    var west = bbox[0], south = bbox[1], east = bbox[2], north = bbox[3];
    var centerY = (south + north) / 2;
    var centerX = (west + east) / 2;
    // https://github.com/Turfjs/turf/issues/758
    var xFraction = (cellSide * 2) / hex_grid_dist_es_distance([west, centerY], [east, centerY], options);
    var cellWidth = xFraction * (east - west);
    var yFraction = (cellSide * 2) / hex_grid_dist_es_distance([centerX, south], [centerX, north], options);
    var cellHeight = yFraction * (north - south);
    var radius = cellWidth / 2;
    var hex_width = radius * 2;
    var hex_height = (Math.sqrt(3) / 2) * cellHeight;
    var box_width = east - west;
    var box_height = north - south;
    var x_interval = (3 / 4) * hex_width;
    var y_interval = hex_height;
    // adjust box_width so all hexagons will be inside the bbox
    var x_span = (box_width - hex_width) / (hex_width - radius / 2);
    var x_count = Math.floor(x_span);
    var x_adjust = (x_count * x_interval - radius / 2 - box_width) / 2 -
        radius / 2 +
        x_interval / 2;
    // adjust box_height so all hexagons will be inside the bbox
    var y_count = Math.floor((box_height - hex_height) / hex_height);
    var y_adjust = (box_height - y_count * hex_height) / 2;
    var hasOffsetY = y_count * hex_height - box_height > hex_height / 2;
    if (hasOffsetY) {
        y_adjust -= hex_height / 4;
    }
    // Precompute cosines and sines of angles used in hexagon creation for performance gain
    var cosines = [];
    var sines = [];
    for (var i = 0; i < 6; i++) {
        var angle = ((2 * Math.PI) / 6) * i;
        cosines.push(Math.cos(angle));
        sines.push(Math.sin(angle));
    }
    var results = [];
    for (var x = 0; x <= x_count; x++) {
        for (var y = 0; y <= y_count; y++) {
            var isOdd = x % 2 === 1;
            if (y === 0 && isOdd)
                continue;
            if (y === 0 && hasOffsetY)
                continue;
            var center_x = x * x_interval + west - x_adjust;
            var center_y = y * y_interval + south + y_adjust;
            if (isOdd) {
                center_y -= hex_height / 2;
            }
            if (options.triangles === true) {
                hexTriangles([center_x, center_y], cellWidth / 2, cellHeight / 2, JSON.parse(clonedProperties), cosines, sines).forEach(function (triangle) {
                    if (options.mask) {
                        if (dist_es_intersect(options.mask, triangle))
                            results.push(triangle);
                    }
                    else {
                        results.push(triangle);
                    }
                });
            }
            else {
                var hex = hexagon([center_x, center_y], cellWidth / 2, cellHeight / 2, JSON.parse(clonedProperties), cosines, sines);
                if (options.mask) {
                    if (dist_es_intersect(options.mask, hex))
                        results.push(hex);
                }
                else {
                    results.push(hex);
                }
            }
        }
    }
    return hex_grid_dist_es_featureCollection(results);
}
/**
 * Creates hexagon
 *
 * @private
 * @param {Array<number>} center of the hexagon
 * @param {number} rx half hexagon width
 * @param {number} ry half hexagon height
 * @param {Object} properties passed to each hexagon
 * @param {Array<number>} cosines precomputed
 * @param {Array<number>} sines precomputed
 * @returns {Feature<Polygon>} hexagon
 */
function hexagon(center, rx, ry, properties, cosines, sines) {
    var vertices = [];
    for (var i = 0; i < 6; i++) {
        var x = center[0] + rx * cosines[i];
        var y = center[1] + ry * sines[i];
        vertices.push([x, y]);
    }
    //first and last vertex must be the same
    vertices.push(vertices[0].slice());
    return hex_grid_dist_es_polygon([vertices], properties);
}
/**
 * Creates triangles composing an hexagon
 *
 * @private
 * @param {Array<number>} center of the hexagon
 * @param {number} rx half triangle width
 * @param {number} ry half triangle height
 * @param {Object} properties passed to each triangle
 * @param {Array<number>} cosines precomputed
 * @param {Array<number>} sines precomputed
 * @returns {Array<Feature<Polygon>>} triangles
 */
function hexTriangles(center, rx, ry, properties, cosines, sines) {
    var triangles = [];
    for (var i = 0; i < 6; i++) {
        var vertices = [];
        vertices.push(center);
        vertices.push([center[0] + rx * cosines[i], center[1] + ry * sines[i]]);
        vertices.push([
            center[0] + rx * cosines[(i + 1) % 6],
            center[1] + ry * sines[(i + 1) % 6],
        ]);
        vertices.push(center);
        triangles.push(hex_grid_dist_es_polygon([vertices], properties));
    }
    return triangles;
}
/* harmony default export */ const hex_grid_dist_es = ((/* unused pure expression or super */ null && (hexGrid)));

;// ../../node_modules/@turf/mask/dist/es/index.js
/* unused harmony import specifier */ var mask_dist_es_multiPolygon;
/* unused harmony import specifier */ var mask_dist_es_polygon;
/* unused harmony import specifier */ var mask_dist_es_polygonClipping;



/**
 * Takes any type of {@link Polygon|polygon} and an optional mask and returns a {@link Polygon|polygon} exterior ring with holes.
 *
 * @name mask
 * @param {FeatureCollection|Feature<Polygon|MultiPolygon>} polygon GeoJSON Polygon used as interior rings or holes.
 * @param {Feature<Polygon>} [mask] GeoJSON Polygon used as the exterior ring (if undefined, the world extent is used)
 * @returns {Feature<Polygon>} Masked Polygon (exterior ring with holes).
 * @example
 * var polygon = turf.polygon([[[112, -21], [116, -36], [146, -39], [153, -24], [133, -10], [112, -21]]]);
 * var mask = turf.polygon([[[90, -55], [170, -55], [170, 10], [90, 10], [90, -55]]]);
 *
 * var masked = turf.mask(polygon, mask);
 *
 * //addToMap
 * var addToMap = [masked]
 */
function mask(polygon, mask) {
  // Define mask
  var maskPolygon = es_createMask(mask);

  var polygonOuters = null;
  if (polygon.type === "FeatureCollection") polygonOuters = unionFc(polygon);
  else
    polygonOuters = createGeomFromPolygonClippingOutput(
      mask_dist_es_polygonClipping.union(polygon.geometry.coordinates)
    );

  polygonOuters.geometry.coordinates.forEach(function (contour) {
    maskPolygon.geometry.coordinates.push(contour[0]);
  });

  return maskPolygon;
}

function unionFc(fc) {
  var unioned =
    fc.features.length === 2
      ? mask_dist_es_polygonClipping.union(
          fc.features[0].geometry.coordinates,
          fc.features[1].geometry.coordinates
        )
      : mask_dist_es_polygonClipping.union.apply(
          mask_dist_es_polygonClipping,
          fc.features.map(function (f) {
            return f.geometry.coordinates;
          })
        );
  return createGeomFromPolygonClippingOutput(unioned);
}

function createGeomFromPolygonClippingOutput(unioned) {
  return mask_dist_es_multiPolygon(unioned);
}

/**
 * Create Mask Coordinates
 *
 * @private
 * @param {Feature<Polygon>} [mask] default to world if undefined
 * @returns {Feature<Polygon>} mask coordinate
 */
function es_createMask(mask) {
  var world = [
    [
      [180, 90],
      [-180, 90],
      [-180, -90],
      [180, -90],
      [180, 90],
    ],
  ];
  var coordinates = (mask && mask.geometry.coordinates) || world;
  return mask_dist_es_polygon(coordinates);
}

/* harmony default export */ const mask_dist_es = ((/* unused pure expression or super */ null && (mask)));

;// ../../node_modules/@turf/rectangle-grid/dist/es/index.js
/* unused harmony import specifier */ var rectangle_grid_dist_es_intersect;
/* unused harmony import specifier */ var rectangle_grid_dist_es_distance;
/* unused harmony import specifier */ var rectangle_grid_dist_es_polygon;
/* unused harmony import specifier */ var rectangle_grid_dist_es_featureCollection;



/**
 * Creates a grid of rectangles from a bounding box, {@link Feature} or {@link FeatureCollection}.
 *
 * @name rectangleGrid
 * @param {Array<number>} bbox extent in [minX, minY, maxX, maxY] order
 * @param {number} cellWidth of each cell, in units
 * @param {number} cellHeight of each cell, in units
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] units ("degrees", "radians", "miles", "kilometers") that the given cellWidth
 * and cellHeight are expressed in. Converted at the southern border.
 * @param {Feature<Polygon|MultiPolygon>} [options.mask] if passed a Polygon or MultiPolygon,
 * the grid Points will be created only inside it
 * @param {Object} [options.properties={}] passed to each point of the grid
 * @returns {FeatureCollection<Polygon>} a grid of polygons
 * @example
 * var bbox = [-95, 30 ,-85, 40];
 * var cellWidth = 50;
 * var cellHeight = 20;
 * var options = {units: 'miles'};
 *
 * var rectangleGrid = turf.rectangleGrid(bbox, cellWidth, cellHeight, options);
 *
 * //addToMap
 * var addToMap = [rectangleGrid]
 */
function rectangleGrid(bbox, cellWidth, cellHeight, options) {
    if (options === void 0) { options = {}; }
    // Containers
    var results = [];
    var west = bbox[0];
    var south = bbox[1];
    var east = bbox[2];
    var north = bbox[3];
    var xFraction = cellWidth / rectangle_grid_dist_es_distance([west, south], [east, south], options);
    var cellWidthDeg = xFraction * (east - west);
    var yFraction = cellHeight / rectangle_grid_dist_es_distance([west, south], [west, north], options);
    var cellHeightDeg = yFraction * (north - south);
    // rows & columns
    var bboxWidth = east - west;
    var bboxHeight = north - south;
    var columns = Math.floor(bboxWidth / cellWidthDeg);
    var rows = Math.floor(bboxHeight / cellHeightDeg);
    // if the grid does not fill the bbox perfectly, center it.
    var deltaX = (bboxWidth - columns * cellWidthDeg) / 2;
    var deltaY = (bboxHeight - rows * cellHeightDeg) / 2;
    // iterate over columns & rows
    var currentX = west + deltaX;
    for (var column = 0; column < columns; column++) {
        var currentY = south + deltaY;
        for (var row = 0; row < rows; row++) {
            var cellPoly = rectangle_grid_dist_es_polygon([
                [
                    [currentX, currentY],
                    [currentX, currentY + cellHeightDeg],
                    [currentX + cellWidthDeg, currentY + cellHeightDeg],
                    [currentX + cellWidthDeg, currentY],
                    [currentX, currentY],
                ],
            ], options.properties);
            if (options.mask) {
                if (rectangle_grid_dist_es_intersect(options.mask, cellPoly)) {
                    results.push(cellPoly);
                }
            }
            else {
                results.push(cellPoly);
            }
            currentY += cellHeightDeg;
        }
        currentX += cellWidthDeg;
    }
    return rectangle_grid_dist_es_featureCollection(results);
}
/* harmony default export */ const rectangle_grid_dist_es = ((/* unused pure expression or super */ null && (rectangleGrid)));

;// ../../node_modules/@turf/square-grid/dist/es/index.js
/* unused harmony import specifier */ var es_rectangleGrid;

/**
 * Creates a square grid from a bounding box.
 *
 * @name squareGrid
 * @param {Array<number>} bbox extent in [minX, minY, maxX, maxY] order
 * @param {number} cellSide of each cell, in units
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] used in calculating cellSide, can be degrees,
 * radians, miles, or kilometers
 * @param {Feature<Polygon|MultiPolygon>} [options.mask] if passed a Polygon or MultiPolygon,
 * the grid Points will be created only inside it
 * @param {Object} [options.properties={}] passed to each point of the grid
 * @returns {FeatureCollection<Polygon>} grid a grid of polygons
 * @example
 * var bbox = [-95, 30 ,-85, 40];
 * var cellSide = 50;
 * var options = {units: 'miles'};
 *
 * var squareGrid = turf.squareGrid(bbox, cellSide, options);
 *
 * //addToMap
 * var addToMap = [squareGrid]
 */
function squareGrid(bbox, cellSide, options) {
    if (options === void 0) { options = {}; }
    return es_rectangleGrid(bbox, cellSide, cellSide, options);
}

;// ../../node_modules/@turf/triangle-grid/dist/es/index.js
/* unused harmony import specifier */ var triangle_grid_dist_es_distance;
/* unused harmony import specifier */ var triangle_grid_dist_es_intersect;
/* unused harmony import specifier */ var triangle_grid_dist_es_polygon;
/* unused harmony import specifier */ var triangle_grid_dist_es_featureCollection;



/**
 * Takes a bounding box and a cell depth and returns a set of triangular {@link Polygon|polygons} in a grid.
 *
 * @name triangleGrid
 * @param {Array<number>} bbox extent in [minX, minY, maxX, maxY] order
 * @param {number} cellSide dimension of each cell
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] used in calculating cellSide, can be degrees, radians, miles, or kilometers
 * @param {Feature<Polygon>} [options.mask] if passed a Polygon or MultiPolygon, the grid Points will be created only inside it
 * @param {Object} [options.properties={}] passed to each point of the grid
 * @returns {FeatureCollection<Polygon>} grid of polygons
 * @example
 * var bbox = [-95, 30 ,-85, 40];
 * var cellSide = 50;
 * var options = {units: 'miles'};
 *
 * var triangleGrid = turf.triangleGrid(bbox, cellSide, options);
 *
 * //addToMap
 * var addToMap = [triangleGrid];
 */
function triangleGrid(bbox, cellSide, options) {
    if (options === void 0) { options = {}; }
    // Containers
    var results = [];
    // Input Validation is being handled by Typescript
    // if (cellSide === null || cellSide === undefined) throw new Error('cellSide is required');
    // if (!isNumber(cellSide)) throw new Error('cellSide is invalid');
    // if (!bbox) throw new Error('bbox is required');
    // if (!Array.isArray(bbox)) throw new Error('bbox must be array');
    // if (bbox.length !== 4) throw new Error('bbox must contain 4 numbers');
    // if (mask && ['Polygon', 'MultiPolygon'].indexOf(getType(mask)) === -1) throw new Error('options.mask must be a (Multi)Polygon');
    // Main
    var xFraction = cellSide / triangle_grid_dist_es_distance([bbox[0], bbox[1]], [bbox[2], bbox[1]], options);
    var cellWidth = xFraction * (bbox[2] - bbox[0]);
    var yFraction = cellSide / triangle_grid_dist_es_distance([bbox[0], bbox[1]], [bbox[0], bbox[3]], options);
    var cellHeight = yFraction * (bbox[3] - bbox[1]);
    var xi = 0;
    var currentX = bbox[0];
    while (currentX <= bbox[2]) {
        var yi = 0;
        var currentY = bbox[1];
        while (currentY <= bbox[3]) {
            var cellTriangle1 = null;
            var cellTriangle2 = null;
            if (xi % 2 === 0 && yi % 2 === 0) {
                cellTriangle1 = triangle_grid_dist_es_polygon([
                    [
                        [currentX, currentY],
                        [currentX, currentY + cellHeight],
                        [currentX + cellWidth, currentY],
                        [currentX, currentY],
                    ],
                ], options.properties);
                cellTriangle2 = triangle_grid_dist_es_polygon([
                    [
                        [currentX, currentY + cellHeight],
                        [currentX + cellWidth, currentY + cellHeight],
                        [currentX + cellWidth, currentY],
                        [currentX, currentY + cellHeight],
                    ],
                ], options.properties);
            }
            else if (xi % 2 === 0 && yi % 2 === 1) {
                cellTriangle1 = triangle_grid_dist_es_polygon([
                    [
                        [currentX, currentY],
                        [currentX + cellWidth, currentY + cellHeight],
                        [currentX + cellWidth, currentY],
                        [currentX, currentY],
                    ],
                ], options.properties);
                cellTriangle2 = triangle_grid_dist_es_polygon([
                    [
                        [currentX, currentY],
                        [currentX, currentY + cellHeight],
                        [currentX + cellWidth, currentY + cellHeight],
                        [currentX, currentY],
                    ],
                ], options.properties);
            }
            else if (yi % 2 === 0 && xi % 2 === 1) {
                cellTriangle1 = triangle_grid_dist_es_polygon([
                    [
                        [currentX, currentY],
                        [currentX, currentY + cellHeight],
                        [currentX + cellWidth, currentY + cellHeight],
                        [currentX, currentY],
                    ],
                ], options.properties);
                cellTriangle2 = triangle_grid_dist_es_polygon([
                    [
                        [currentX, currentY],
                        [currentX + cellWidth, currentY + cellHeight],
                        [currentX + cellWidth, currentY],
                        [currentX, currentY],
                    ],
                ], options.properties);
            }
            else if (yi % 2 === 1 && xi % 2 === 1) {
                cellTriangle1 = triangle_grid_dist_es_polygon([
                    [
                        [currentX, currentY],
                        [currentX, currentY + cellHeight],
                        [currentX + cellWidth, currentY],
                        [currentX, currentY],
                    ],
                ], options.properties);
                cellTriangle2 = triangle_grid_dist_es_polygon([
                    [
                        [currentX, currentY + cellHeight],
                        [currentX + cellWidth, currentY + cellHeight],
                        [currentX + cellWidth, currentY],
                        [currentX, currentY + cellHeight],
                    ],
                ], options.properties);
            }
            if (options.mask) {
                if (triangle_grid_dist_es_intersect(options.mask, cellTriangle1))
                    results.push(cellTriangle1);
                if (triangle_grid_dist_es_intersect(options.mask, cellTriangle2))
                    results.push(cellTriangle2);
            }
            else {
                results.push(cellTriangle1);
                results.push(cellTriangle2);
            }
            currentY += cellHeight;
            yi++;
        }
        xi++;
        currentX += cellWidth;
    }
    return triangle_grid_dist_es_featureCollection(results);
}
/* harmony default export */ const triangle_grid_dist_es = ((/* unused pure expression or super */ null && (triangleGrid)));

;// ../../node_modules/@turf/interpolate/dist/es/index.js
/* unused harmony import specifier */ var interpolate_dist_es_bbox;
/* unused harmony import specifier */ var es_hexGrid;
/* unused harmony import specifier */ var es_pointGrid;
/* unused harmony import specifier */ var interpolate_dist_es_distance;
/* unused harmony import specifier */ var interpolate_dist_es_centroid;
/* unused harmony import specifier */ var es_squareGrid;
/* unused harmony import specifier */ var es_triangleGrid;
/* unused harmony import specifier */ var interpolate_dist_es_clone;
/* unused harmony import specifier */ var interpolate_dist_es_featureCollection;
/* unused harmony import specifier */ var interpolate_dist_es_featureEach;
/* unused harmony import specifier */ var interpolate_dist_es_collectionOf;












/**
 * Takes a set of points and estimates their 'property' values on a grid using the [Inverse Distance Weighting (IDW) method](https://en.wikipedia.org/wiki/Inverse_distance_weighting).
 *
 * @name interpolate
 * @param {FeatureCollection<Point>} points with known value
 * @param {number} cellSize the distance across each grid point
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.gridType='square'] defines the output format based on a Grid Type (options: 'square' | 'point' | 'hex' | 'triangle')
 * @param {string} [options.property='elevation'] the property name in `points` from which z-values will be pulled, zValue fallbacks to 3rd coordinate if no property exists.
 * @param {string} [options.units='kilometers'] used in calculating cellSize, can be degrees, radians, miles, or kilometers
 * @param {number} [options.weight=1] exponent regulating the distance-decay weighting
 * @returns {FeatureCollection<Point|Polygon>} grid of points or polygons with interpolated 'property'
 * @example
 * var points = turf.randomPoint(30, {bbox: [50, 30, 70, 50]});
 *
 * // add a random property to each point
 * turf.featureEach(points, function(point) {
 *     point.properties.solRad = Math.random() * 50;
 * });
 * var options = {gridType: 'points', property: 'solRad', units: 'miles'};
 * var grid = turf.interpolate(points, 100, options);
 *
 * //addToMap
 * var addToMap = [grid];
 */
function es_interpolate(points, cellSize, options) {
  // Optional parameters
  options = options || {};
  if (typeof options !== "object") throw new Error("options is invalid");
  var gridType = options.gridType;
  var property = options.property;
  var weight = options.weight;

  // validation
  if (!points) throw new Error("points is required");
  interpolate_dist_es_collectionOf(points, "Point", "input must contain Points");
  if (!cellSize) throw new Error("cellSize is required");
  if (weight !== undefined && typeof weight !== "number")
    throw new Error("weight must be a number");

  // default values
  property = property || "elevation";
  gridType = gridType || "square";
  weight = weight || 1;

  var box = interpolate_dist_es_bbox(points);
  var grid;
  switch (gridType) {
    case "point":
    case "points":
      grid = es_pointGrid(box, cellSize, options);
      break;
    case "square":
    case "squares":
      grid = es_squareGrid(box, cellSize, options);
      break;
    case "hex":
    case "hexes":
      grid = es_hexGrid(box, cellSize, options);
      break;
    case "triangle":
    case "triangles":
      grid = es_triangleGrid(box, cellSize, options);
      break;
    default:
      throw new Error("invalid gridType");
  }
  var results = [];
  interpolate_dist_es_featureEach(grid, function (gridFeature) {
    var zw = 0;
    var sw = 0;
    // calculate the distance from each input point to the grid points
    interpolate_dist_es_featureEach(points, function (point) {
      var gridPoint =
        gridType === "point" ? gridFeature : interpolate_dist_es_centroid(gridFeature);
      var d = interpolate_dist_es_distance(gridPoint, point, options);
      var zValue;
      // property has priority for zValue, fallbacks to 3rd coordinate from geometry
      if (property !== undefined) zValue = point.properties[property];
      if (zValue === undefined) zValue = point.geometry.coordinates[2];
      if (zValue === undefined) throw new Error("zValue is missing");
      if (d === 0) zw = zValue;
      var w = 1.0 / Math.pow(d, weight);
      sw += w;
      zw += w * zValue;
    });
    // write interpolated value for each grid point
    var newFeature = interpolate_dist_es_clone(gridFeature);
    newFeature.properties[property] = zw / sw;
    results.push(newFeature);
  });
  return interpolate_dist_es_featureCollection(results);
}

/* harmony default export */ const interpolate_dist_es = ((/* unused pure expression or super */ null && (es_interpolate)));

;// ../../node_modules/@turf/turf/dist/es/index.js























































































































;// ./src/components/molecules/parcels-map/elems/map/LabeledGeoJsonLayer.ts
function LabeledGeoJsonLayer_defineProperty(e, r, t) { return (r = LabeledGeoJsonLayer_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function LabeledGeoJsonLayer_toPropertyKey(t) { var i = LabeledGeoJsonLayer_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function LabeledGeoJsonLayer_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





class LabeledGeoJsonLayer extends external_deck_gl_core_.CompositeLayer {
  constructor(props) {
    super(props);
    const layerProperties = this.props.data;
    layerProperties.polygons.properties.forEach((entry, i) => {
      switch (entry.layerName) {
        case 'departements':
          layerProperties.polygons.properties[i] = {
            ...entry,
            id: entry.code
          };
          break;
        case 'communes':
          layerProperties.polygons.properties[i] = {
            ...entry,
            id: entry.code
          };
          break;
        case 'sections':
          layerProperties.polygons.properties[i] = {
            ...entry,
            nom: entry.code
          };
          break;
        case 'parcelles':
          // eslint-disable-next-line no-case-declarations
          const parcel = entry;
          layerProperties.polygons.properties[i] = {
            ...parcel,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            cadastre_type: 'PARCEL',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            cadastre_id: parcel.id,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            feature_id: parcel.id,
            name: '',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            geom_centroid: '',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            city_id: parcel.id.substring(0, 5),
            category: '',
            layerName: 'parcelles',
            id: parcel.id,
            extra: JSON.stringify({
              prefix: parcel.prefixe.padStart(3, '0'),
              section: parcel.section.toUpperCase().padStart(2, '0'),
              number: parcel.numero.padStart(4, '0'),
              area: parcel.contenance
            })
          };
          break;
        default:
          layerProperties.polygons.properties.splice(i, 1);
          break;
      }
    });
    this.props.data = layerProperties;
  }
  updateState({
    changeFlags
  }) {
    const {
      data
    } = this.props;
    if (changeFlags.dataChanged && data && typeof data === 'object' && 'polygons' in data) {
      const labelsData = this.buildLabelsData();
      this.setState({
        labelsData
      });
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (this.props.tile?.zoom < 15) {
      this.setState({
        labelsData: []
      });
    }
  }
  renderLayers() {
    return [new layers_.GeoJsonLayer(this.getSubLayerProps({
      id: 'geometry',
      data: this.props.data,
      autoHighlight: this.props.autoHighlight,
      highlightColor: this.props.highlightColor,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      updateTriggers: this.props.updateTriggers,
      getLineWidth: this.props.getLineWidth,
      getFillColor: this.props.getFillColor,
      getLineColor: this.props.getLineColor,
      onClick: this.props.onClick
    })),
    // for some reason if we use `this.getSubLayerProps` TextLayer is not visible
    // probably because of some forwarded props
    new layers_.TextLayer({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      id: `${this.props.id}-text`,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment
      data: this.state.labelsData,
      getText: d => d.text,
      getPosition: d => d.position,
      getSize: d => {
        return (0,number_.clamp)(d.size, 9, 11);
      },
      fontFamily: 'Roboto, sans-serif',
      getTextAnchor: 'middle',
      getAlignmentBaseline: 'center'
    })];
  }
  buildLabelsData() {
    const features = new Map();
    this.props.tile?.dataInWGS84.forEach(feature => {
      if (feature.properties.layerName !== 'parcelles') {
        return;
      }
      const centroid = center_of_mass_dist_es(feature.geometry);
      features.set(`${feature.properties.id}`, {
        ...feature,
        position: [centroid.geometry.coordinates[0] ?? 0, centroid.geometry.coordinates[1] ?? 0],
        text: `${feature.properties.numero}`,
        size: 2 ** Math.log10(feature.properties.contenance)
      });
    });
    return Array.from(features.values());
  }
}
LabeledGeoJsonLayer_defineProperty(LabeledGeoJsonLayer, "layerName", 'LabeledGeoJsonLayer');
LabeledGeoJsonLayer_defineProperty(LabeledGeoJsonLayer, "defaultProps", {
  ...layers_.GeoJsonLayer.defaultProps,
  ...layers_.TextLayer.defaultProps
});
;// ./src/components/molecules/parcels-map/elems/map/utils.ts
function utils_buildParseError(entry) {
  const {
    cadastre_type: type,
    cadastre_id: id,
    extra
  } = entry.properties;
  const message = `
        [DtgParcelsMap]: cadastral entry parse error.
        Tried to parse ${type} ${id}: ${extra}`;
  return new Error(message);
}
function buildAbsentCoordinatesError(entry) {
  const {
    cadastre_type: type,
    cadastre_id: id
  } = entry.object.properties;
  const {
    x,
    y,
    index
  } = entry;
  const message = `
        [DtgParcelsMap]: no coordinates in ${type} ${id}.
        Tile is { x: ${x}, y: ${y}, index: ${index} }.
        `;
  return new Error(message);
}
;// ./src/components/molecules/parcels-map/elems/map/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const elems_map_style_module = ({"dtg-parcels-map-map":"lib_dtg-parcels-map-map_FM9nU","dtg-parcels-map-map__map":"lib_dtg-parcels-map-map__map_gkpvg","dtg-parcels-map-map__actions":"lib_dtg-parcels-map-map__actions_NAbYp"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/parcels-map/elems/map/component.vue?vue&type=script&lang=ts














const COLORS = {
  line: [51, 93, 149],
  fill: [237, 242, 249],
  hover: [7, 178, 193, 150],
  selectedParcel: [5, 204, 127],
  selectedArea: [106, 148, 204],
  transparent: [255, 255, 255, 0]
};
const MARKER_URL = '/assets/icon/marker.png';
const ZOOM = {
  city: 13,
  parcel: 18,
  minParcel: 16,
  /**
   * MVTLayer calculates its zoom level as Math.round(map.getZoom() - 1),
   * meaning that 8.5 is considered to be 9, while 9.5 is 10
   * Its minZoom param also checks with > instead of >= like the map does,
   * so if the map's zoom is exactly 9.51, the request for tiles is not going to be sent
   * Since we want to limit the map as well as the requests to the backend to zoom 9,
   * we have to limit the map to 9.51 (which is Math.round(9.51 - 1) = 9)
   * and limit the MVTLayer zoom at slightly less than that (which is Math.round(9.51 - 1 - 0.001) = 9)
   */
  min: 9.51,
  minLayer: 8.509,
  max: 20
};
const defaultMapConfig = {
  center: DEFAULT_POSITION,
  zoom: ZOOM.minParcel,
  minZoom: ZOOM.min,
  maxZoom: ZOOM.max,
  disableDefaultUI: true,
  fullscreenControl: true,
  clickableIcons: false,
  mapId: MAP_ID,
  gestureHandling: 'auto'
};
/* harmony default export */ const map_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(elems_map_style_module),
  components: {
    DtgInfoBox: info_box_component
  },
  props: {
    parcels: {
      type: Array,
      default: () => []
    },
    location: {
      type: Object,
      default: null
    },
    config: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    offline: {
      type: Boolean,
      default: false
    },
    noControls: {
      type: Boolean,
      default: false
    },
    preserveDrawingBuffer: {
      type: Boolean,
      default: false
    },
    gmaps: {
      type: Object,
      required: true
    },
    focusOnParcel: {
      type: Boolean,
      default: false
    }
  },
  emits: events(['deselectParcel', 'selectParcel', 'load', 'error'])(),
  // eslint-disable-next-line max-statements
  setup(props, {
    emit
  }) {
    const mapReady = (0,deferred_.createDeferred)();
    const parcelsLayerReady = (0,deferred_.createDeferred)();
    const renderFinished = (0,deferred_.createDeferred)();
    const initialized = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const mapEl = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    const selectedParcelsIds = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.parcels.map(({
        data
      }) => data.meta.cadastralId);
    });
    // eslint-disable-next-line vue/no-setup-props-destructure
    const {
      gmaps
    } = props;
    let map;
    let marker;
    let overlay;
    const watchers = [];
    const displayedLayers = ['parcelles', 'sections', 'communes', 'departements'];
    const zoomLevels = {
      parcelles: 14,
      sections: 13
    };
    const currentZoom = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(0);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeUnmount)(destroyMap);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    [mapEl, () => props.offline], async ([el, offline]) => {
      if (el && !offline) {
        await initializeMap(el);
      }
    }, {
      flush: 'post'
    });
    // TODO: refactor as a class, since we have gmaps, map, marker and overlay as shared state
    async function initializeMap(el) {
      if (initialized.value) {
        return;
      }
      initialized.value = true;
      void Promise.all([mapReady.promise, parcelsLayerReady.promise, renderFinished.promise]).then(() => {
        emit('load');
      });
      map = createMap(el);
      marker = createMarker();
      overlay = createParcelsOverlay();
      marker.setMap(map);
      overlay.setMap(map);
      watchers.push((0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.location, updateMapViewport));
      let tilesloadedTimer = null;
      // If no new tiles are loaded within 5 seconds, then we consider that all tiles have been loaded
      gmaps.event.addListener(map, 'tilesloaded', () => {
        if (tilesloadedTimer) {
          clearTimeout(tilesloadedTimer);
        }
        tilesloadedTimer = setTimeout(() => {
          mapReady.resolve();
        }, 5000);
      });
      gmaps.event.addListener(map, 'zoom_changed', () => {
        currentZoom.value = map.getZoom() ?? 0;
      });
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(currentZoom, () => {
        updateLayerVisibility();
      });
      await wrapMapReady(map, async () => {
        updateMapViewport();
        await nextMapIdle(map);
        return fixZoom();
      });
    }
    function updateLayerVisibility() {
      const zoom = Math.floor(currentZoom.value);
      const parcelVisibility = zoom >= zoomLevels.parcelles;
      const sectionVisibility = zoom >= zoomLevels.sections;
      const citiesVisibility = zoom <= zoomLevels.sections;
      // Assuming overlay.setProps can dynamically update layer options
      overlay.setProps({
        layers: [createParcelLayer(parcelVisibility), createSectionLayer(sectionVisibility), createLowZoomLayer(citiesVisibility)]
      });
    }
    // TODO: ensure map is properly garbage collected or use a pool of map instances
    function destroyMap() {
      try {
        watchers.forEach(unwatch => {
          unwatch();
        });
        if (initialized.value && mapEl.value) {
          gmaps.event.clearInstanceListeners(mapEl.value);
        }
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (overlay) {
          overlay.setProps({
            layers: []
          });
          overlay.finalize();
        }
      } catch (error) {
        emit('error', error);
      }
    }
    function createMap(el) {
      return new gmaps.Map(el, {
        ...defaultMapConfig,
        center: props.location?.location ?? DEFAULT_POSITION,
        fullscreenControl: !props.noControls
      });
    }
    function createMarker() {
      const marker = new gmaps.Marker({
        position: props.location?.location ?? DEFAULT_POSITION,
        visible: (0,truthy_.truthy)(props.location),
        clickable: false
      });
      marker.setIcon(MARKER_URL);
      watchers.push((0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.location, value => {
        if (value) {
          marker.setPosition(value.location);
          marker.setVisible(true);
        } else {
          marker.setVisible(false);
        }
      }));
      return marker;
    }
    function updateMapViewport() {
      if (props.parcels.length === 0) {
        centerMapOnMarker();
      } else {
        extendBounds();
      }
    }
    function centerMapOnMarker() {
      map.setCenter(marker.getPosition() ?? DEFAULT_POSITION);
      map.setZoom(ZOOM.minParcel);
    }
    function extendBounds() {
      const bounds = new gmaps.LatLngBounds();
      const points = props.parcels.flatMap(({
        data: {
          meta
        }
      }) => meta.coordinates.bounds);
      points.forEach(point => {
        bounds.extend(point);
      });
      const markerPosition = marker.getPosition();
      if (markerPosition) {
        bounds.extend(markerPosition);
      }
      map.fitBounds(bounds, 10);
      google.maps.event.addListenerOnce(map, 'zoom_changed', fixZoom);
    }
    function fixZoom() {
      const curZoom = map.getZoom();
      if (typeof curZoom !== 'number' || props.parcels.length === 0) {
        return false;
      }
      const fixedZoom = (0,number_.clamp)(curZoom, ZOOM.minParcel, ZOOM.parcel);
      if (curZoom === fixedZoom) {
        return false;
      }
      map.setZoom(fixedZoom);
      const position = props.focusOnParcel ? props.parcels[0]?.data.meta.coordinates.center : marker.getPosition();
      if (position) {
        map.setCenter(position);
      }
      return true;
    }
    function createParcelsOverlay() {
      // Initial visibility based on the current zoom level
      const zoom = Math.floor(currentZoom.value);
      const parcelVisible = zoom >= zoomLevels.parcelles;
      const sectionVisible = zoom >= zoomLevels.sections && zoom < zoomLevels.parcelles;
      const citiesVisible = zoom < zoomLevels.sections;
      const mvtLayer = createParcelLayer(parcelVisible);
      const mvtSectionLayer = createSectionLayer(sectionVisible);
      const mvtCitiesLayer = createLowZoomLayer(citiesVisible);
      let onAfterRenderTimer = null;
      const overlay = new google_maps_.GoogleMapsOverlay({
        glOptions: {
          /**
           * Needed for rendering inside the pdf.
           * Shouldn't be true in case map viewport will be rerendered.
           * See: https://github.com/visgl/deck.gl/issues/4436#issuecomment-610472868
           * https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
           */
          preserveDrawingBuffer: props.preserveDrawingBuffer
        },
        // Some renders can happen even after onViewportLoad
        // If a new render does not occur within 5 seconds, then we consider the render to be complete
        onAfterRender() {
          if (onAfterRenderTimer) {
            clearTimeout(onAfterRenderTimer);
          }
          onAfterRenderTimer = setTimeout(() => {
            renderFinished.resolve();
          }, 5000);
        },
        // TODO: use vue to display tooltip
        // GoogleMapsOverlay is drawn under the marker's layer
        // It's no way to display tooltip above marker using styles
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,complexity
        getTooltip: payload => {
          const {
            object
          } = payload;
          if (!object) {
            return null;
          }
          const type = object.properties.layerName;
          if (!displayedLayers.includes(type)) {
            return null;
          }
          if (type !== 'parcelles') {
            const obj = object.properties;
            const label = type === 'sections' ? 'Section' : 'Commune';
            return {
              html: `
                                <div class="tooltip">
                                  <div class="tooltip-id"><strong>${obj.id}</strong></div>
                                  <div class="tooltip-number">${label} : <strong>${obj.nom}</strong><div>
                                </div>
                            `
            };
          }
          try {
            const {
              number,
              prefix,
              section
            } = JSON.parse(object.properties.extra);
            const area = object.properties.contenance;
            return {
              html: `
                                <div class="tooltip">
                                    <div class="tooltip-id"><strong>${object.properties.id}</strong></div>
                                    ${prefix && prefix !== '000' ? `<div class="tooltip-prefix">Préfixe: <strong>${prefix}</strong></div>` : ''}
                                    <div class="tooltip-section">Section: <strong>${section}</strong></div>
                                    <div class="tooltip-number">Numéro: <strong>${number}</strong></div>
                                    ${area ? `<div class="tooltip-area">Surface: <strong>${new Intl.NumberFormat('fr-FR').format(area)} m²</strong></div>` : ''}
                                </div>
                            `
            };
          } catch {
            emit('error', utils_buildParseError(object));
            return null;
          }
        },
        layers: [mvtLayer, mvtSectionLayer, mvtCitiesLayer]
      });
      watchers.push((0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(selectedParcelsIds, () => {
        updateLayerVisibility();
      }));
      return overlay;
    }
    function onAreaClick({
      object,
      coordinates
    }) {
      const zoom = object.properties.cadastre_type === 'CITY' ? ZOOM.city : ZOOM.parcel;
      map.setZoom(zoom);
      map.setCenter(coordinates);
    }
    function onParcelClick({
      object,
      coordinates
    }) {
      const clickedId = object.properties.cadastre_id;
      const selectedParcel = props.parcels.find(({
        data: {
          meta
        }
      }) => meta.cadastralId === clickedId);
      if (selectedParcel) {
        emit('deselectParcel', selectedParcel.id);
      } else {
        emit('selectParcel', buildParcelDataFromCadastralEntry({
          entry: object,
          gmaps,
          position: coordinates,
          onError: error => {
            emit('error', error);
          }
        }));
      }
    }
    function createParcelLayer(isVisible) {
      return new geo_layers_.MVTLayer({
        id: 'parcels-layer',
        uniqueIdProperty: 'id',
        minZoom: 13,
        maxZoom: 16,
        autoHighlight: true,
        highlightColor: COLORS.hover,
        pickable: true,
        visible: isVisible,
        data: props.config.url,
        loadOptions: {
          fetch: {
            headers: {
              Authorization: `Bearer ${props.config.getAccessToken()}`
            }
          },
          mvt: {
            layers: ['parcelles']
          }
        },
        onViewportLoad: () => {
          parcelsLayerReady.resolve();
        },
        renderSubLayers(props) {
          return new LabeledGeoJsonLayer(props);
        },
        updateTriggers: {
          getFillColor: selectedParcelsIds.value
        },
        // @ts-expect-error missing in declaration
        getLineWidth,
        getLineColor: COLORS.line,
        getFillColor({
          properties
        }) {
          const isSelected = selectedParcelsIds.value.some(id => id.startsWith(properties.cadastre_id));
          return isSelected ? COLORS.selectedParcel : COLORS.fill;
        },
        onClick(entry) {
          if (props.disabled) {
            return;
          }
          const {
            coordinate,
            object
          } = entry;
          if (!coordinate) {
            emit('error', buildAbsentCoordinatesError(entry));
            return;
          }
          const [lng, lat] = coordinate;
          const coordinates = {
            lng,
            lat
          };
          onParcelClick({
            object,
            coordinates
          });
        }
      });
    }
    function createSectionLayer(isVisible) {
      const zoom = Math.floor(currentZoom.value);
      return new geo_layers_.MVTLayer({
        id: 'sections-layer',
        uniqueIdProperty: 'id',
        minZoom: 13,
        maxZoom: 15,
        autoHighlight: zoom >= zoomLevels.sections && zoom < zoomLevels.parcelles,
        highlightColor: zoom >= zoomLevels.sections && zoom < zoomLevels.parcelles ? COLORS.hover : COLORS.transparent,
        pickable: zoom >= zoomLevels.sections && zoom < zoomLevels.parcelles,
        visible: isVisible,
        data: props.config.url,
        loadOptions: {
          fetch: {
            headers: {
              Authorization: `Bearer ${props.config.getAccessToken()}`
            }
          },
          mvt: {
            layers: ['sections']
          }
        },
        renderSubLayers(props) {
          return new LabeledGeoJsonLayer(props);
        },
        // @ts-expect-error missing in declaration
        getLineWidth,
        getLineColor: COLORS.line,
        getFillColor() {
          return zoom >= zoomLevels.sections && zoom < zoomLevels.parcelles ? COLORS.fill : COLORS.transparent;
        },
        onClick(entry) {
          if (props.disabled) {
            return;
          }
          const {
            coordinate,
            object
          } = entry;
          if (!coordinate) {
            emit('error', buildAbsentCoordinatesError(entry));
            return;
          }
          const [lng, lat] = coordinate;
          const coordinates = {
            lng,
            lat
          };
          onAreaClick({
            object,
            coordinates
          });
        }
      });
    }
    function createLowZoomLayer(isVisible) {
      const zoom = Math.floor(currentZoom.value);
      return new geo_layers_.MVTLayer({
        id: 'cities-layer',
        uniqueIdProperty: 'id',
        minZoom: 8,
        maxZoom: 13,
        autoHighlight: false,
        highlightColor: COLORS.transparent,
        pickable: true,
        visible: isVisible,
        data: props.config.url,
        loadOptions: {
          fetch: {
            headers: {
              Authorization: `Bearer ${props.config.getAccessToken()}`
            }
          },
          mvt: {
            layers: ['communes', 'departements']
          }
        },
        renderSubLayers(props) {
          return new LabeledGeoJsonLayer(props);
        },
        // @ts-expect-error missing in declaration
        getLineWidth,
        getLineColor: COLORS.line,
        getFillColor() {
          return [11, 12].includes(zoom) ? COLORS.transparent : COLORS.fill;
        },
        onClick(entry) {
          if (props.disabled) {
            return;
          }
          const {
            coordinate,
            object
          } = entry;
          if (!coordinate) {
            emit('error', buildAbsentCoordinatesError(entry));
            return;
          }
          const [lng, lat] = coordinate;
          const coordinates = {
            lng,
            lat
          };
          onAreaClick({
            object,
            coordinates
          });
        }
      });
    }
    function getLineWidth(entry) {
      switch (entry.properties.layerName) {
        case 'parcelles':
          return 1;
        case 'sections':
          return 4;
        case 'communes':
          return 30;
        case 'departements':
          return 80;
        default:
          return 1;
      }
    }
    return {
      b: useBem(elems_map_style_module),
      map: mapEl
    };
  }
}));
;// ./src/components/molecules/parcels-map/elems/map/component.vue?vue&type=script&lang=ts
 
;// ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-12.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/parcels-map/elems/map/component.vue?vue&type=style&index=0&id=0dc0cada&lang=css
// extracted by mini-css-extract-plugin
/* harmony default export */ const componentvue_type_style_index_0_id_0dc0cada_lang_css = ({});
;// ./src/components/molecules/parcels-map/elems/map/component.vue?vue&type=style&index=0&id=0dc0cada&lang=css

;// ./src/components/molecules/parcels-map/elems/map/component.vue




;


const elems_map_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(map_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_0dc0cada_ts_true_render]])

/* harmony default export */ const elems_map_component = (elems_map_component_exports_);
;// ./src/components/molecules/parcels-map/elems/map/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/parcels-map/component.vue?vue&type=script&lang=ts



/* harmony default export */ const parcels_map_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-parcels-map',
  components: {
    DtgParcelsMapMap: elems_map_component
  },
  props: {
    offline: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const active = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(true);
    const {
      gmapsPromise
    } = useGmapsApi();
    const gmapsRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.offline, async offline => {
      if (!offline) {
        gmapsRef.value = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.markRaw)(await gmapsPromise);
      }
    }, {
      immediate: true
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onActivated)(() => {
      active.value = true;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onDeactivated)(() => {
      active.value = false;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeUnmount)(() => {
      active.value = false;
    });
    return {
      gmapsRef,
      active
    };
  }
}));
;// ./src/components/molecules/parcels-map/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/parcels-map/component.vue




;
const parcels_map_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(parcels_map_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_bd93cbb4_ts_true_render]])

/* harmony default export */ const parcels_map_component = (parcels_map_component_exports_);
;// ./src/components/molecules/parcels-map/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/password-requirements/component.vue?vue&type=template&id=4adc36d2&ts=true

function componentvue_type_template_id_4adc36d2_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('item', {
      title: true
    }))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('item-icon')),
    name: _ctx.getIconName(_ctx.isSecure)
  }, null, 8, ["class", "name"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Sécurité du mot de passe:   "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('item-text', {
      error: !_ctx.isSecure
    }))
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.passwordStatusText), 3)], 2), ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.checks, check => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: check.key,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('item', {
        valid: check.secure
      }))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('item-text'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('item-icon')),
      name: _ctx.getIconName(check.secure)
    }, null, 8, ["class", "name"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(check.label), 1)], 2)], 2);
  }), 128))], 2);
}
;// ./src/components/molecules/password-requirements/component.vue?vue&type=template&id=4adc36d2&ts=true

;// ./src/components/molecules/password-requirements/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const password_requirements_style_module = ({"dtg-password-requirements":"lib_dtg-password-requirements_b5kn3","dtg-password-requirements__item":"lib_dtg-password-requirements__item_Yn5pP","dtg-password-requirements__item-icon":"lib_dtg-password-requirements__item-icon_CvBwo","dtg-password-requirements__item-text_error":"lib_dtg-password-requirements__item-text_error_i6Brm","dtg-password-requirements__item_valid":"lib_dtg-password-requirements__item_valid_z9SkA","dtg-password-requirements__item-text":"lib_dtg-password-requirements__item-text_JLvZU","dtg-password-requirements__item_title":"lib_dtg-password-requirements__item_title_Zc_Vf"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/password-requirements/component.vue?vue&type=script&lang=ts





/* harmony default export */ const password_requirements_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(password_requirements_style_module),
  components: {
    DtgIcon: icon_component
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const checks = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        value
      } = props;
      return [{
        key: 'minLength',
        label: 'Minimum 8 caractères',
        secure: value.length >= validation_.passwordMinLength
      }, {
        key: 'lowerCase',
        label: 'Un caractère en minuscule',
        secure: validation_.regexHasLowerCase.test(value)
      }, {
        key: 'upperCase',
        label: 'Un caractère en majuscule',
        secure: validation_.regexHasUpperCase.test(value)
      }, {
        key: 'hasNumber',
        label: 'Une chiffre',
        secure: validation_.regexHasNumber.test(value)
      }, {
        key: 'hasSpecialChar',
        label: 'Un symbole',
        secure: validation_.regexHasSpecialChar.test(value)
      }];
    });
    const isSecure = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => checks.value.every(({
      secure
    }) => secure));
    const passwordStatusText = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => isSecure.value ? 'forte' : 'faible');
    function getIconName(secure) {
      return secure ? 'checkmark' : 'close';
    }
    return {
      b: useBem(password_requirements_style_module),
      checks,
      isSecure,
      passwordStatusText,
      getIconName
    };
  }
}));
;// ./src/components/molecules/password-requirements/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/password-requirements/component.vue




;
const password_requirements_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(password_requirements_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_4adc36d2_ts_true_render]])

/* harmony default export */ const password_requirements_component = (password_requirements_component_exports_);
;// ./src/components/molecules/password-requirements/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/pdf-preview/component.vue?vue&type=template&id=489cc630&ts=true

function componentvue_type_template_id_489cc630_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_spinner = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-spinner");
  const _component_dtg_info_box = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-info-box");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_grid, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("canvas", {
        ref: "canvasRef",
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('canvas'))
      }, null, 2), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, !_ctx.errorMessage && !_ctx.loading]]), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_spinner, {
        key: 0,
        view: "big"
      })) : _ctx.errorMessage ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_info_box, {
        key: 1,
        icon: "warning",
        color: "warning"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.errorMessage), 1)]),
        _: 1
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
      _: 1
    }), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row, {
      key: 0,
      align: "center center"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.errorMessage ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
        key: 0,
        size: "auto"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
          icon: "reload",
          onClick: _cache[0] || (_cache[0] = $event => _ctx.onReloadClick())
        })]),
        _: 1
      })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
        key: 1
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
        size: "auto"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
          disabled: _ctx.prevDisabled,
          icon: "arrowLeft",
          onClick: _cache[1] || (_cache[1] = $event => _ctx.onPrevClick())
        }, null, 8, ["disabled"])]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
        size: "auto"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.curPage) + " / " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.totalPages), 1)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
        size: "auto"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
          disabled: _ctx.nextDisabled,
          icon: "arrowRight",
          onClick: _cache[2] || (_cache[2] = $event => _ctx.onNextClick())
        }, null, 8, ["disabled"])]),
        _: 1
      })], 64))]),
      _: 1
    })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 1
  });
}
;// ./src/components/molecules/pdf-preview/component.vue?vue&type=template&id=489cc630&ts=true

// EXTERNAL MODULE: external "dtg-shared/pdfjs"
var pdfjs_ = __webpack_require__(1031);
// EXTERNAL MODULE: external "dtg-shared/utils/promise"
var promise_ = __webpack_require__(5661);
;// ./src/components/molecules/pdf-preview/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const pdf_preview_style_module = ({"dtg-pdf-preview__canvas":"lib_dtg-pdf-preview__canvas_bOgr1"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/pdf-preview/component.vue?vue&type=script&lang=ts










/* harmony default export */ const pdf_preview_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(pdf_preview_style_module),
  components: {
    DtgGrid: grid,
    DtgRow: row,
    DtgCol: col,
    DtgButton: button_component,
    DtgRowCol: row_col,
    DtgSpinner: spinner_component,
    DtgInfoBox: info_box_component
  },
  props: {
    url: {
      type: String,
      required: true
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  emits: ['error'],
  setup(props, {
    emit
  }) {
    const canvasRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const curPage = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(1);
    const totalPages = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(1);
    const loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(true);
    const errorMessage = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)('');
    const prevDisabled = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => curPage.value <= 1);
    const nextDisabled = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => curPage.value >= totalPages.value);
    let loadingTask = null;
    let renderTask = null;
    let pdf = null;
    let rendering = false;
    let pageNumPending = null;
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.url, loadPdf, {
        immediate: true
      });
    });
    async function loadPdf(url) {
      try {
        await (0,wrap_pending_.wrapPending)(loadPdfInner(url), loading);
      } catch (error) {
        emit('error', error);
        errorMessage.value = 'Impossible de rendre le PDF';
      }
      await queueRenderPage(1);
    }
    async function loadPdfInner(url) {
      if (loadingTask) {
        loadingTask.abort();
        loadingTask = null;
      }
      if (renderTask) {
        renderTask.cancel();
        renderTask = null;
      }
      errorMessage.value = '';
      loadingTask = new AbortController();
      pdf = await (0,promise_.abortablePromise)(loadingTask.signal, (resolve, reject) => {
        fetchPdf(url).then(resolve, reject);
      });
      totalPages.value = pdf.numPages;
    }
    async function fetchPdf(url) {
      return (0,pdfjs_.getDocument)(url).promise;
    }
    async function queueRenderPage(num) {
      if (rendering) {
        pageNumPending = num;
      } else {
        await renderPage(num);
      }
    }
    async function renderPage(num) {
      const canvas = canvasRef.value;
      const canvasContext = canvas?.getContext('2d');
      if (!canvas || !canvasContext || !pdf) {
        return;
      }
      rendering = true;
      const page = await pdf.getPage(num);
      const viewport = page.getViewport({
        scale: props.scale
      });
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      renderTask = page.render({
        canvasContext,
        viewport
      });
      await renderTask.promise;
      rendering = false;
      if (pageNumPending !== null) {
        const next = pageNumPending;
        pageNumPending = null;
        await renderPage(next);
      }
    }
    async function onPrevClick() {
      curPage.value -= 1;
      await queueRenderPage(curPage.value);
    }
    async function onNextClick() {
      curPage.value += 1;
      await queueRenderPage(curPage.value);
    }
    async function onReloadClick() {
      await loadPdf(props.url);
    }
    return {
      b: useBem(pdf_preview_style_module),
      canvasRef,
      curPage,
      totalPages,
      loading,
      errorMessage,
      prevDisabled,
      nextDisabled,
      onPrevClick,
      onNextClick,
      onReloadClick
    };
  }
}));
;// ./src/components/molecules/pdf-preview/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/pdf-preview/component.vue




;
const pdf_preview_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(pdf_preview_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_489cc630_ts_true_render]])

/* harmony default export */ const pdf_preview_component = (pdf_preview_component_exports_);
;// ./src/components/molecules/pdf-preview/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/section/component.vue?vue&type=template&id=eb5aa0f6&ts=true

function componentvue_type_template_id_eb5aa0f6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_divider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-divider");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('divider-wrapper'))
  }, [!_ctx.noDivider ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_divider, {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('divider')),
    view: "short"
  }, null, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)]);
}
;// ./src/components/molecules/section/component.vue?vue&type=template&id=eb5aa0f6&ts=true

;// ./src/components/molecules/section/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const section_style_module = ({"dtg-section__content":"lib_dtg-section__content_nrKZz","dtg-section__divider-wrapper":"lib_dtg-section__divider-wrapper_lNBuW","dtg-section__divider":"lib_dtg-section__divider_lxMon"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/section/component.vue?vue&type=script&lang=ts




/* harmony default export */ const section_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(section_style_module),
  components: {
    DtgDivider: divider_component
  },
  props: {
    noDivider: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      b: useBem(section_style_module)
    };
  }
}));
;// ./src/components/molecules/section/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/section/component.vue




;
const section_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(section_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_eb5aa0f6_ts_true_render]])

/* harmony default export */ const section_component = (section_component_exports_);
;// ./src/components/molecules/section/index.ts


// EXTERNAL MODULE: external "dtg-shared/utils/create-service"
var create_service_ = __webpack_require__(8334);
;// ./src/components/molecules/select-location/composables/use-address-suggestions-service.ts

const addressSuggestionsService = (0,create_service_.createInitlessService)('addressSuggestions');
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/select-location/component.vue?vue&type=template&id=d6e2f230&ts=true

function componentvue_type_template_id_d6e2f230_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_select, {
    ref: "inputRef",
    modelValue: _ctx.modelValueInternal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
    options: search => _ctx.service.fetchAddressSuggestions(search),
    type: "suggestions",
    object: "",
    "clear-button-visible": "",
    "continuous-search": ""
  }, null, 8, ["modelValue", "options"]);
}
;// ./src/components/molecules/select-location/component.vue?vue&type=template&id=d6e2f230&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/select-location/component.vue?vue&type=script&lang=ts





/* harmony default export */ const select_location_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-select-location',
  components: {
    DtgSelect: select_component
  },
  props: {
    modelValue: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const service = addressSuggestionsService.get();
    const modelValueInternal = propInternal(props, 'modelValue', emit);
    return {
      service,
      modelValueInternal,
      ...useFocusPropagation()
    };
  }
}));
;// ./src/components/molecules/select-location/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/select-location/component.vue




;
const select_location_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(select_location_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_d6e2f230_ts_true_render]])

/* harmony default export */ const select_location_component = (select_location_component_exports_);
;// ./src/components/molecules/select-location/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/select-yes-no/component.vue?vue&type=template&id=39185446&ts=true

function componentvue_type_template_id_39185446_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_select, {
    ref: "inputRef",
    modelValue: _ctx.modelValueInternal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
    options: _ctx.options,
    placeholder: _ctx.placeholder
  }, null, 8, ["modelValue", "options", "placeholder"]);
}
;// ./src/components/molecules/select-yes-no/component.vue?vue&type=template&id=39185446&ts=true

;// ./src/components/molecules/select-yes-no/types.ts
var YesNo;
(function (YesNo) {
  YesNo["yes"] = "yes";
  YesNo["no"] = "no";
})(YesNo || (YesNo = {}));
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/select-yes-no/component.vue?vue&type=script&lang=ts




/* harmony default export */ const select_yes_no_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-select-yes-no',
  components: {
    DtgSelect: select_component
  },
  props: {
    modelValue: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Choisir'
    },
    yesText: {
      type: String,
      default: 'Oui'
    },
    noText: {
      type: String,
      default: 'Non'
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const options = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => [{
      id: YesNo.yes,
      value: props.yesText
    }, {
      id: YesNo.no,
      value: props.noText
    }]);
    const modelValueInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
      get: () => getCurrentValue(props.modelValue),
      set: value => {
        emit('update:modelValue', getUpdatedValue(value));
      }
    });
    function getCurrentValue(value) {
      switch (value) {
        case true:
          return YesNo.yes;
        case false:
          return YesNo.no;
        default:
          return null;
      }
    }
    function getUpdatedValue(value) {
      switch (value) {
        case YesNo.yes:
          return true;
        case YesNo.no:
          return false;
        default:
          return null;
      }
    }
    return {
      modelValueInternal,
      options,
      ...useFocusPropagation()
    };
  }
}));
;// ./src/components/molecules/select-yes-no/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/select-yes-no/component.vue




;
const select_yes_no_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(select_yes_no_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_39185446_ts_true_render]])

/* harmony default export */ const select_yes_no_component = (select_yes_no_component_exports_);
;// ./src/components/molecules/select-yes-no/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/spoiler/component.vue?vue&type=template&id=30488ecc&ts=true

const componentvue_type_template_id_30488ecc_ts_true_hoisted_1 = {
  key: 0
};
function componentvue_type_template_id_30488ecc_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  const _component_dtg_transition_stack = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-transition-stack");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      opened: _ctx.openedInternal
    }))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_action, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('toggle')),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onToggleClick())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('toggle-icon')),
      name: "chevron"
    }, null, 8, ["class"])]),
    _: 1
  }, 8, ["class"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_transition_stack, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.openedInternal ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", componentvue_type_template_id_30488ecc_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content-inner'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 3
  })], 2);
}
;// ./src/components/molecules/spoiler/component.vue?vue&type=template&id=30488ecc&ts=true

;// ./src/components/molecules/spoiler/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const spoiler_style_module = ({"dtg-spoiler":"lib_dtg-spoiler_oqmxZ","dtg-spoiler__toggle":"lib_dtg-spoiler__toggle_PYPCn","dtg-spoiler__toggle-icon":"lib_dtg-spoiler__toggle-icon_yqvV0","dtg-spoiler_opened":"lib_dtg-spoiler_opened_zFsY0","dtg-spoiler__content-inner":"lib_dtg-spoiler__content-inner_VeXjD"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/spoiler/component.vue?vue&type=script&lang=ts






/* harmony default export */ const spoiler_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(spoiler_style_module),
  components: {
    DtgIcon: icon_component,
    DtgTransitionStack: transition_stack_component,
    DtgAction: action_component
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    opened: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:opened'],
  setup(props, {
    emit
  }) {
    const openedInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.opened);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.opened, value => {
      openedInternal.value = value;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(openedInternal, value => {
      if (props.opened !== value) {
        emit('update:opened', value);
      }
    });
    function onToggleClick() {
      openedInternal.value = !openedInternal.value;
    }
    return {
      b: useBem(spoiler_style_module),
      openedInternal,
      onToggleClick
    };
  }
}));
;// ./src/components/molecules/spoiler/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/spoiler/component.vue




;
const spoiler_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(spoiler_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_30488ecc_ts_true_render]])

/* harmony default export */ const spoiler_component = (spoiler_component_exports_);
;// ./src/components/molecules/spoiler/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/tabs/component.vue?vue&type=template&id=6462b886&ts=true

function componentvue_type_template_id_6462b886_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_mark = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-mark");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    ref: "root",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('tabs'))
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.tabs, (tab, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_action, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
      key: tab.title,
      ref_for: true,
      ref: _ctx.setRefByIndex(index),
      class: _ctx.b('tab-action', {
        active: tab.id === _ctx.modelValueInternal,
        disabled: tab.disabled
      }),
      "active-class": _ctx.routed ? _ctx.b('tab-action', {
        active: true
      }) : null,
      disabled: tab.disabled
    }, tab.props, {
      onClick: $event => _ctx.onTabClick(tab.id)
    }), {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [tab.marked ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_mark, {
        key: 0,
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('tab-action-mark')),
        view: "warning"
      }, null, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(tab.title), 1)]),
      _: 2
    }, 1040, ["class", "active-class", "disabled", "onClick"]);
  }), 128))], 2)], 2);
}
;// ./src/components/molecules/tabs/component.vue?vue&type=template&id=6462b886&ts=true

;// ./src/components/molecules/tabs/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const tabs_style_module = ({"dtg-tabs":"lib_dtg-tabs_vlu94","dtg-tabs__tabs":"lib_dtg-tabs__tabs_PVmoN","dtg-tabs__tab-action":"lib_dtg-tabs__tab-action_w2yzp","dtg-tabs__tab-action_active":"lib_dtg-tabs__tab-action_active_VOLxw","dtg-tabs__tab-action_disabled":"lib_dtg-tabs__tab-action_disabled_uM216","dtg-tabs__tab-action-mark":"lib_dtg-tabs__tab-action-mark_wgD6_"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/tabs/component.vue?vue&type=script&lang=ts











/* harmony default export */ const tabs_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(tabs_style_module),
  components: {
    DtgAction: action_component,
    DtgMark: mark_component
  },
  props: {
    modelValue: {
      type: String,
      default: null
    },
    tabs: {
      type: Array,
      required: true
    },
    preselect: {
      type: Boolean,
      default: false
    },
    routed: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const root = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const {
      modelValue,
      tabs,
      preselect
    } = (0,refs_.toReadonlyRefs)(props);
    const {
      refs,
      setRefByIndex
    } = useTemplateRefsArray();
    const modelValueInternal = propInternal(props, 'modelValue', emit);
    const firstId = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => tabs.value[0]?.id ?? null);
    const activeTab = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => tabs.value.find(({
      id
    }) => id === modelValue.value) ?? null);
    let currentActiveIndex = -1;
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(async () => {
      if (!activeTab.value) {
        return;
      }
      const activeIndex = tabs.value.indexOf(activeTab.value);
      const wasSet = currentActiveIndex !== -1;
      if (currentActiveIndex === activeIndex) {
        return;
      }
      currentActiveIndex = activeIndex;
      const ref = refs.value[activeIndex];
      if (!ref) {
        return;
      }
      await (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)();
      await (0,scroll_.scrollIntoView)(ref, {
        // eslint-disable-next-line no-undefined
        duration: wasSet ? undefined : 0,
        scrollMode: 'always',
        boundary: (0,get_element_from_ref_.getElementFromRef)(root.value)
      });
    }, {
      flush: 'post'
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)([tabs, modelValue],
    // eslint-disable-next-line complexity
    ([tabs, modelValue]) => {
      const shouldClear = (0,truthy_.truthy)(modelValue) && tabs.every(({
        id
      }) => modelValue !== id);
      const shouldPreselect = preselect.value && (shouldClear || !modelValue && (0,truthy_.truthy)(firstId.value));
      if (shouldPreselect) {
        modelValueInternal.value = firstId.value;
      } else if (shouldClear) {
        modelValueInternal.value = null;
      }
    }, {
      immediate: true
    });
    function onTabClick(id) {
      modelValueInternal.value = id;
    }
    return {
      b: useBem(tabs_style_module),
      root,
      setRefByIndex,
      modelValueInternal,
      onTabClick
    };
  }
}));
;// ./src/components/molecules/tabs/component.vue?vue&type=script&lang=ts
 
;// ./src/components/molecules/tabs/component.vue




;
const tabs_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(tabs_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_6462b886_ts_true_render]])

/* harmony default export */ const tabs_component = (tabs_component_exports_);
;// ./src/components/molecules/tabs/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/building-tabs/component.vue?vue&type=template&id=2ec36b8b&ts=true

function componentvue_type_template_id_2ec36b8b_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_tabs = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-tabs");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_tabs, {
    modelValue: _ctx.modelValueInternal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelValueInternal = $event),
    tabs: _ctx.tabs,
    preselect: ""
  }, null, 8, ["modelValue", "tabs"])), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.shown]]);
}
;// ./src/components/organisms/building-tabs/component.vue?vue&type=template&id=2ec36b8b&ts=true

// EXTERNAL MODULE: external "dtg-firebase/modules/building"
var building_ = __webpack_require__(1088);
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/building-tabs/component.vue?vue&type=script&lang=ts





/* harmony default export */ const building_tabs_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-building-tabs',
  components: {
    DtgTabs: tabs_component
  },
  props: {
    modelValue: {
      type: String,
      default: null
    },
    buildings: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    const modelValueInternal = propInternal(props, 'modelValue', emit);
    const filteredBuildings = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        buildings
      } = props;
      return buildings.filter(building => {
        const {
          type
        } = building;
        return type === building_.BuildingType.interior;
      });
    });
    const namesMap = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        buildings
      } = props;
      return (0,building_.buildBuildingNamesMap)(buildings);
    });
    const tabs = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return filteredBuildings.value.map(building => {
        const {
          id,
          valid
        } = building;
        const title = namesMap.value[id] ?? '';
        const marked = !valid;
        return {
          id,
          title,
          marked
        };
      }).filter(truthy_.truthy);
    });
    const shown = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return tabs.value.length > 1 || tabs.value.length === 1 && !modelValueInternal.value;
    });
    return {
      modelValueInternal,
      tabs,
      shown
    };
  }
}));
;// ./src/components/organisms/building-tabs/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/building-tabs/component.vue




;
const building_tabs_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(building_tabs_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_2ec36b8b_ts_true_render]])

/* harmony default export */ const building_tabs_component = (building_tabs_component_exports_);
;// ./src/components/organisms/building-tabs/index.ts



// EXTERNAL MODULE: external "dtg-firebase/modules/document"
var document_ = __webpack_require__(2161);
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-document/elems/modal-custom-document/component.vue?vue&type=template&id=61c6228d&ts=true

function componentvue_type_template_id_61c6228d_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_input_date = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-date");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_modal_content = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-modal-content");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_modal_content, {
    "title-view": "4"
  }, {
    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1)]),
    actions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "12"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        view: "inverted",
        icon: "checkmarkCircle",
        fullwidth: "",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onAcceptClick())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Valider ")]),
        _: 1
      })]),
      _: 1
    })]),
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.groupId.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.groupId.props, {
            options: _ctx.groups,
            placeholder: "Choisir une catégorie"
          }), null, 16, ["options"])]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.value.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.value.props, {
            "max-length": _ctx.max.value,
            placeholder: "Ex. Règlement de copropriété"
          }), null, 16, ["max-length"])]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.status.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.status.props, {
            options: _ctx.statusesInternal
          }), null, 16, ["options"])]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.madeBy.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.madeBy.props)), null, 16)]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.madeByDate.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_date, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.madeByDate.props, {
            align: "bottom right"
          }), null, 16)]),
          _: 1
        }, 16)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  });
}
;// ./src/components/organisms/card-document/elems/modal-custom-document/component.vue?vue&type=template&id=61c6228d&ts=true

// EXTERNAL MODULE: external "dtg-shared/composables/use-form"
var use_form_ = __webpack_require__(7165);
;// ./src/components/organisms/card-document/elems/modal-custom-document/props.ts

const props = {
  data: {
    type: Object,
    default: null
  },
  validationData: {
    type: Object,
    required: true
  },
  groups: {
    type: Array,
    required: true
  },
  editing: {
    type: Boolean,
    required: true
  },
  statuses: {
    type: Array,
    default: () => document_.DOCUMENT_STATUS_OPTIONS
  }
};
;// ./src/components/organisms/card-document/elems/modal-custom-document/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_custom_document_style_module = ({"dtg-modal-document__container":"lib_dtg-modal-document__container_irgDp"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-document/elems/modal-custom-document/component.vue?vue&type=script&lang=ts

















/* harmony default export */ const modal_custom_document_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(modal_custom_document_style_module),
  components: {
    DtgModalContent: modal_content_component,
    DtgGrid: grid,
    DtgRowCol: row_col,
    DtgCol: col,
    DtgInput: input_component,
    DtgButton: button_component,
    DtgSelect: select_component,
    DtgField: field_component,
    DtgInputDate: input_date_component
  },
  props: props,
  emits: events(['accept', 'close'])(),
  setup(props, {
    emit
  }) {
    const dataInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)((0,object_.objAssignExceptUndefined)({
      ...(0,document_.buildDocumentFormData)(),
      groupId: null,
      value: ''
    }, props.data ?? {}));
    const max = {
      value: 300
    };
    const baseSchema = (0,document_.documentValidationSchema)({
      ...props.validationData,
      selectedDtgType: null
    });
    const statusesInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.statuses.map(option => {
        const disabled = (0,array_.arrayIncludes)(baseSchema.disabledStatuses, option.id);
        return {
          ...option,
          disabled
        };
      });
    });
    const schema = {
      ...baseSchema,
      schema: baseSchema.schema.shape({
        groupId: (0,external_yup_.string)().label('Catégorie').nullable().required(),
        value: (0,external_yup_.string)().label('Nom du document').max(max.value).required()
      })
    };
    const {
      fields,
      validate
    } = (0,use_form_.useFormFields)({
      data: dataInternal,
      schema
    });
    const title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.editing ? 'Éditer le document' : 'Ajouter un document';
    });
    async function onAcceptClick() {
      const {
        valid
      } = await validate();
      if (valid) {
        emit('accept', schema.schema.validateSync(dataInternal.value));
        emit('close');
      }
    }
    return {
      fields,
      max,
      title,
      statusesInternal,
      onAcceptClick
    };
  }
}));
;// ./src/components/organisms/card-document/elems/modal-custom-document/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/card-document/elems/modal-custom-document/component.vue




;
const modal_custom_document_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(modal_custom_document_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_61c6228d_ts_true_render]])

/* harmony default export */ const modal_custom_document_component = (modal_custom_document_component_exports_);
;// ./src/components/organisms/card-document/elems/modal-custom-document/composables/use-modal-custom-obligation.ts




// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useModalCustomDocument() {
  const b = useBem(modal_custom_document_style_module);
  return useOverlay({
    component: modal_custom_document_component,
    cssClass: b('container')
  });
}
;// ./src/components/organisms/card-document/elems/modal-custom-document/index.ts




;// ./src/components/organisms/card-document/composables/use-custom-documents.ts


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useCustomDocuments({
  groupOptions,
  createCustomDocument,
  updateCustomDocument,
  scrollToEndOfGroup
}) {
  const modalCustomDocument = useModalCustomDocument();
  const customValidationData = {
    madeByFields: 'optional',
    dtgTypes: []
  };
  function createCustomDocumentInternal(groupId) {
    modalCustomDocument.open({
      editing: false,
      data: {
        groupId
      },
      groups: groupOptions.value,
      validationData: customValidationData,
      async onAccept(data) {
        const {
          groupId: groupIdUpdated,
          value,
          ...otherData
        } = data;
        const information = {
          ...customValidationData,
          value,
          disabledByDtgType: []
        };
        await createCustomDocument({
          data: {
            groupId: groupIdUpdated,
            information,
            ...otherData
          }
        });
        if (groupId !== groupIdUpdated) {
          await scrollToEndOfGroup(groupIdUpdated);
        }
      }
    });
  }
  function updateCustomDocumentInternal(item) {
    const {
      custom,
      information,
      groupId
    } = item.data;
    if (!custom || !information) {
      return;
    }
    const {
      value
    } = information;
    const data = {
      ...(0,document_.buildDocumentFormData)(item.data),
      groupId,
      value
    };
    modalCustomDocument.open({
      editing: true,
      data,
      validationData: information,
      groups: groupOptions.value,
      async onAccept(data) {
        const {
          groupId: groupIdUpdated,
          value,
          ...otherData
        } = data;
        const updatedInformation = {
          ...information,
          value
        };
        await updateCustomDocument({
          id: item.id,
          data: {
            groupId: groupIdUpdated,
            information: updatedInformation,
            ...otherData
          }
        });
        if (groupId !== groupIdUpdated) {
          await scrollToEndOfGroup(groupIdUpdated);
        }
      }
    });
  }
  return {
    createCustomDocument: createCustomDocumentInternal,
    updateCustomDocument: updateCustomDocumentInternal
  };
}
;// ./src/components/organisms/card-document/composables/use-document-disabled-by-dtg-type.ts

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useDocumentDisabledByDtgType({
  document,
  disabled,
  selectedDtgType
}) {
  const config = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return document.value.disabledByDtgType.find(({
      dtgType
    }) => dtgType === selectedDtgType.value);
  });
  const disabledByDtgType = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => Boolean(config.value && document.value.status));
  const disabledInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return disabled.value || disabledByDtgType.value;
  });
  const disabledMessage = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => config.value?.message ?? '');
  return {
    disabledByDtgType,
    disabled: disabledInternal,
    disabledMessage
  };
}
;// ./src/composables/use-paginated-array.ts

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function usePaginatedArray(array, pageSize = 1, prepush = true) {
  const curLength = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(prepush ? pageSize : 0);
  const paginatedArray = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => array.value.slice(0, curLength.value));
  const isLastPage = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return curLength.value >= array.value.length;
  });
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(array, () => {
    curLength.value = Math.min(array.value.length, curLength.value);
  });
  function pushNextPage(complete) {
    if (complete) {
      complete();
    }
    if (!isLastPage.value) {
      curLength.value = Math.min(array.value.length, curLength.value + pageSize);
    }
  }
  function pushAllPages() {
    if (!isLastPage.value) {
      curLength.value = array.value.length;
    }
  }
  function clearPages() {
    curLength.value = 0;
    if (prepush) {
      pushNextPage();
    }
  }
  return {
    paginatedArray,
    isLastPage,
    pushNextPage,
    clearPages,
    pushAllPages
  };
}
;// ./src/composables/use-list-item-pagination.ts





// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useListItemPagination({
  items,
  mapper,
  pageSize,
  duration = 300
}) {
  const groupOptions = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => items.value.map(mapper));
  const {
    paginatedArray,
    pushNextPage: onInfiniteScrollTrigger,
    pushAllPages: renderAllGroups,
    isLastPage
  } = usePaginatedArray(items, pageSize);
  const {
    refs,
    setRefByIndex
  } = useTemplateRefsArray();
  async function scrollToEndOfGroup(groupId) {
    renderAllGroups();
    await (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)();
    await (0,double_raf_.doubleRAF)();
    const index = groupOptions.value.findIndex(({
      id
    }) => groupId === id);
    const templateRef = refs.value[index];
    await (0,scroll_.scrollIntoView)(templateRef, {
      duration,
      scrollMode: 'always',
      block: 'end'
    });
  }
  return {
    paginatedArray,
    groupOptions,
    onInfiniteScrollTrigger,
    isLastPage,
    setRefByIndex,
    scrollToEndOfGroup
  };
}
;// ./src/components/organisms/card-document/composables/use-document-pagination.ts

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useDocumentPagination({
  documents
}) {
  return useListItemPagination({
    items: documents,
    mapper: ({
      id,
      value
    }) => ({
      id,
      value
    }),
    pageSize: 1
  });
}
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-document/component.vue?vue&type=template&id=00ee9d44&ts=true

function componentvue_type_template_id_00ee9d44_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_card_section = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-card-section");
  const _component_dtg_toggle = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-toggle");
  const _component_dtg_icon_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon-action");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_radio = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-radio");
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_mark = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-mark");
  const _component_dtg_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-action");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_input_date = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-date");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_card_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-card-base");
  const _component_dtg_divider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-divider");
  const _component_dtg_info_box = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-info-box");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_file_dropzone = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-file-dropzone");
  const _component_dtg_spoiler = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-spoiler");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_base, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('card'))
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, {
      "outer-padding": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_section, {
          "size-xs": "12",
          "size-md": "",
          align: "left"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.documentText), 1)]),
          _: 1
        }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_section, {
          align: "right",
          "size-xs": "12",
          "size-sm": "",
          "size-md": "auto",
          "no-divider": ""
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_toggle, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.visibleInReport.props)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Faire apparaitre dans le rapport ")]),
            _: 1
          }, 16)]),
          _: 1
        }), _ctx.editable ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
          key: 0
        }, [_ctx.tillSm ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_section, {
          key: 0,
          "no-divider": ""
        })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_section, {
          "no-divider": _ctx.tillSm,
          "size-xs": "2",
          "size-md": "1"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon_action, {
            disabled: _ctx.disabled,
            name: "edit",
            onClick: _cache[0] || (_cache[0] = $event => _ctx.onEditClick())
          }, null, 8, ["disabled"])]),
          _: 1
        }, 8, ["no-divider"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_section, {
          "size-xs": "2",
          "size-md": "1"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon_action, {
            disabled: _ctx.disabled,
            name: "trash",
            notice: "",
            onClick: _cache[1] || (_cache[1] = $event => _ctx.onDeleteClick())
          }, null, 8, ["disabled"])]),
          _: 1
        })], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.statusError ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_section, {
          key: 0,
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('status-error')),
          size: "12",
          align: "left",
          "no-divider": ""
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.statusError), 1)]),
          _: 1
        }, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.statusesInternal, ({
          status,
          label,
          disabled: statusDisabled
        }, index) => {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_section, {
            key: status,
            "no-divider": _ctx.getNoDivider(index),
            align: "left",
            "size-xs": "10",
            "size-md": "5.5",
            "size-xl": "2.75"
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_radio, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
              class: _ctx.b('status')
            }, _ctx.fields.status.props, {
              name: _ctx.document.id,
              value: status,
              disabled: statusDisabled
            }), {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(label), 1)]),
              _: 2
            }, 1040, ["class", "name", "value", "disabled"])]),
            _: 2
          }, 1032, ["no-divider"]);
        }), 128)), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_section, {
          "size-xs": "2",
          "size-md": "1"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_action, {
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('comment-action')),
            onClick: _cache[2] || (_cache[2] = $event => _ctx.toggleComment())
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
              name: "comment"
            }), _ctx.fields.comment.value ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_mark, {
              key: 0,
              class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('comment-mark')),
              view: "success"
            }, null, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
            _: 1
          }, 8, ["class"])]),
          _: 1
        }), _ctx.shownComment ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_section, {
          key: 0,
          align: "left",
          size: "12",
          "no-divider": ""
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
            class: _ctx.b('field')
          }, _ctx.fields.comment.fieldProps), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.comment.props, {
              autofocus: ""
            }), null, 16)]),
            _: 1
          }, 16, ["class"])]),
          _: 1
        })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.withMadeByFields ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
          key: 1
        }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_section, {
          align: "left",
          "size-xs": "12",
          "size-md": "5.5",
          "size-xl": "8.25",
          "no-divider": ""
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
            class: _ctx.b('field')
          }, _ctx.fields.madeBy.fieldProps), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.madeBy.props)), null, 16)]),
            _: 1
          }, 16, ["class"])]),
          _: 1
        }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_section, {
          "no-divider": _ctx.tillMd,
          align: "left",
          "size-xs": "12",
          "size-md": "6.5",
          "size-xl": "3.75"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
            class: _ctx.b('field')
          }, _ctx.fields.madeByDate.fieldProps), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_date, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.madeByDate.props)), null, 16)]),
            _: 1
          }, 16, ["class"])]),
          _: 1
        }, 8, ["no-divider"])], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["class"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_divider), !_ctx.readonlyFiles || _ctx.$slots.files || _ctx.warningText ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_base, {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('card'))
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, {
      "outer-padding": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.warningText ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row_col, {
        key: 0
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_info_box, {
          color: "warning",
          icon: "warning"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.warningText), 1)]),
          _: 1
        })]),
        _: 1
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.readonlyFiles || _ctx.$slots.files ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row, {
        key: 1
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [!_ctx.readonlyFiles ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_section, {
          key: 0,
          size: "12"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_file_dropzone, {
            accept: _ctx.acceptFiles,
            format: _ctx.formatFiles,
            max: _ctx.maxFiles,
            disabled: _ctx.disabled,
            name: "files",
            fullwidth: "",
            onFiles: _cache[3] || (_cache[3] = $event => _ctx.onDocumentFiles($event))
          }, null, 8, ["accept", "format", "max", "disabled"])]),
          _: 1
        })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.files ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_section, {
          key: 1,
          size: "12",
          "no-divider": ""
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_spoiler, {
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('files')),
            opened: _ctx.filesOpened,
            "onUpdate:opened": _cache[4] || (_cache[4] = $event => _ctx.filesOpened = $event),
            title: "Fichiers déposés"
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "files", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)({
                  disabled: _ctx.disabled,
                  readonly: _ctx.readonlyFiles
                })))]),
                _: 3
              })]),
              _: 3
            })]),
            _: 3
          }, 8, ["class", "opened"])]),
          _: 3
        })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
        _: 3
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.files ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row, {
        key: 2
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_section, {
          align: "right",
          "no-divider": ""
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_toggle, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.filesVisibleInReport.props)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Annexer au rapport ")]),
            _: 1
          }, 16)]),
          _: 1
        })]),
        _: 1
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
      _: 3
    })]),
    _: 3
  }, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// ./src/components/organisms/card-document/component.vue?vue&type=template&id=00ee9d44&ts=true

;// ./src/components/organisms/card-document/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_document_style_module = ({"dtg-card-document":"lib_dtg-card-document_rr8_g","dtg-card-document__card":"lib_dtg-card-document__card_hzUB7","dtg-card-document__status":"lib_dtg-card-document__status_WzWSr","dtg-card-document__comment-mark":"lib_dtg-card-document__comment-mark_PeEKo","dtg-card-document__comment-action":"lib_dtg-card-document__comment-action_k06ld","dtg-card-document__field":"lib_dtg-card-document__field_zNyiD","dtg-card-document__status-error":"lib_dtg-card-document__status-error_qEYTE","dtg-card-document__toggle-text":"lib_dtg-card-document__toggle-text_RzfYn","dtg-card-document__files":"lib_dtg-card-document__files_Msf38","dtg-card-document__add-files":"lib_dtg-card-document__add-files_Ik1pG","dtg-card-document__add-files-description":"lib_dtg-card-document__add-files-description_lNg9x"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-document/component.vue?vue&type=script&lang=ts
























/* harmony default export */ const card_document_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_document_style_module),
  components: {
    DtgCardSection: card_section_component,
    DtgInput: input_component,
    DtgAction: action_component,
    DtgRadio: radio_component,
    DtgMark: mark_component,
    DtgIcon: icon_component,
    DtgField: field_component,
    DtgInputDate: input_date_component,
    DtgDivider: divider_component,
    DtgIconAction: icon_action_component,
    DtgToggle: toggle_component,
    DtgSpoiler: spoiler_component,
    DtgGrid: grid,
    DtgRow: row,
    DtgRowCol: row_col,
    DtgFileDropzone: file_dropzone_component,
    DtgCardBase: card_base_component,
    DtgInfoBox: info_box_component
  },
  props: {
    document: {
      type: Object,
      required: true
    },
    fields: {
      type: Object,
      required: true
    },
    disabledStatuses: {
      type: Array,
      default: () => []
    },
    readonlyFiles: {
      type: Boolean,
      default: false
    },
    acceptFiles: {
      type: String,
      default: [DtgFileChooserAcceptedTypes.pdf, DtgFileChooserAcceptedTypes.image].join(',')
    },
    formatFiles: {
      type: String,
      default: read_blob_.BlobFormat.blob
    },
    maxFiles: {
      type: Number,
      default: 10
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    statuses: {
      type: Array,
      default: () => document_.DOCUMENT_STATUS_OPTIONS
    },
    warningText: {
      type: String,
      default: ''
    }
  },
  emits: ['edit', 'delete', 'filesAdd'],
  setup(props, {
    emit
  }) {
    const documentText = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.document.data.text);
    const shownComment = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const statusesInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.statuses.map(({
        id: status,
        value: label
      }) => {
        const disabled = (0,array_.arrayIncludes)(props.disabledStatuses, status) || props.disabled;
        return {
          status,
          label,
          disabled
        };
      });
    });
    const statusError = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        errorMessage = null,
        value
      } = props.fields.status;
      return value ? errorMessage : null;
    });
    const withMadeByFields = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.document.data.madeByFields !== 'none');
    const filesOpened = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const bp = useBp();
    const tillSm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => bp.till(bp.sm));
    const tillMd = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => bp.till(bp.md));
    const tillXl = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => bp.till(bp.xl));
    [props.fields.madeBy, props.fields.madeByDate].forEach(field => {
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => field.fieldProps.required, async required => {
        if (required) {
          await field.validateAndSetTouched();
        }
      }, {
        immediate: true
      });
    });
    function toggleComment() {
      shownComment.value = !shownComment.value;
    }
    function getNoDivider(index) {
      return index === 0 || tillXl.value && index % 2 === 0 || tillMd.value;
    }
    function onDeleteClick() {
      emit('delete');
    }
    function onEditClick() {
      emit('edit');
    }
    function onDocumentFiles(files) {
      emit('filesAdd', files);
      filesOpened.value = true;
    }
    return {
      b: useBem(card_document_style_module),
      documentText,
      shownComment,
      statusesInternal,
      statusError,
      withMadeByFields,
      filesOpened,
      tillMd,
      tillSm,
      toggleComment,
      getNoDivider,
      onDeleteClick,
      onEditClick,
      onDocumentFiles
    };
  }
}));
;// ./src/components/organisms/card-document/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/card-document/component.vue




;
const card_document_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_document_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_00ee9d44_ts_true_render]])

/* harmony default export */ const card_document_component = (card_document_component_exports_);
;// ./src/components/organisms/card-document/index.ts






;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-obligation/elems/modal-custom-obligation/component.vue?vue&type=template&id=001dfdc8&ts=true

function componentvue_type_template_id_001dfdc8_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_textarea = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-textarea");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_modal_content = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-modal-content");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_modal_content, {
    "title-view": "4"
  }, {
    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1)]),
    actions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "12"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        view: "inverted",
        icon: "checkmarkCircle",
        fullwidth: "",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onAcceptClick())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Valider ")]),
        _: 1
      })]),
      _: 1
    })]),
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-xs": "12",
          "size-sm": "6"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.groupId.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.groupId.props, {
              options: _ctx.groups,
              placeholder: "Choisir une catégorie"
            }), null, 16, ["options"])]),
            _: 1
          }, 16)]),
          _: 1
        }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-xs": "12",
          "size-sm": "6"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.type.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.type.props, {
              options: _ctx.types,
              placeholder: "Choisir lieu d'application"
            }), null, 16, ["options"])]),
            _: 1
          }, 16)]),
          _: 1
        })]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.title.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.title.props, {
            "max-length": _ctx.max.title,
            placeholder: "Ex. Assurance de copropriété"
          }), null, 16, ["max-length"])]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.reference.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.reference.props, {
            "max-length": _ctx.max.reference,
            placeholder: "Ex. Loi n° nn-nnn du jj/mm/aaaa: art. nn"
          }), null, 16, ["max-length"])]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.description.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_textarea, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.description.props, {
            "max-length": _ctx.max.description,
            rows: "5",
            placeholder: "Ex. Obligation de…"
          }), null, 16, ["max-length"])]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.situation.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.situation.props, {
            "max-length": _ctx.max.situation,
            placeholder: "Ex: Conforme"
          }), null, 16, ["max-length"])]),
          _: 1
        }, 16)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  });
}
;// ./src/components/organisms/card-obligation/elems/modal-custom-obligation/component.vue?vue&type=template&id=001dfdc8&ts=true

;// ./src/components/organisms/card-obligation/elems/modal-custom-obligation/props.ts
const props_props = {
  data: {
    type: Object,
    default: null
  },
  groups: {
    type: Array,
    required: true
  },
  editing: {
    type: Boolean,
    required: true
  },
  initialType: {
    type: String,
    default: null
  }
};
;// ./src/components/organisms/card-obligation/elems/modal-custom-obligation/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_custom_obligation_style_module = ({"dtg-modal-custom-obligation__container":"lib_dtg-modal-custom-obligation__container_udytL"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-obligation/elems/modal-custom-obligation/component.vue?vue&type=script&lang=ts

















/* harmony default export */ const modal_custom_obligation_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(modal_custom_obligation_style_module),
  components: {
    DtgModalContent: modal_content_component,
    DtgGrid: grid,
    DtgRowCol: row_col,
    DtgCol: col,
    DtgInput: input_component,
    DtgButton: button_component,
    DtgSelect: select_component,
    DtgField: field_component,
    DtgTextarea: textarea_component,
    DtgRow: row
  },
  props: props_props,
  emits: events(['accept', 'close'])(),
  setup(props, {
    emit
  }) {
    const dataInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)((0,object_.objAssignExceptUndefined)({
      groupId: null,
      title: '',
      reference: '',
      description: '',
      situation: '',
      type: props.initialType
    }, props.data ?? {}));
    const max = {
      title: 50,
      reference: 150,
      description: 300,
      situation: 50
    };
    const schema = (0,validation_.defineSchema)({
      groupId: (0,external_yup_.string)().label('Catégorie').nullable().required(),
      title: (0,external_yup_.string)().label('Nom de l’obligation').max(max.title).required(),
      reference: (0,external_yup_.string)().label("Référence de l'article ou de la loi").max(max.reference).defined(),
      description: (0,external_yup_.string)().label("Description de l'obligation").max(max.description).required(),
      situation: (0,external_yup_.string)().label('Situation').max(max.situation).defined(),
      type: (0,external_yup_.mixed)().label("Lieu d'application").oneOf([...(0,object_.objValues)(legal_obligation_.LegalObligationType), null]).required()
    });
    const {
      fields,
      validate
    } = (0,use_form_.useFormFields)({
      data: dataInternal,
      schema
    });
    const title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.editing ? "Éditer l'obligation légale" : 'Ajouter une obligation légale';
    });
    const types = [{
      id: legal_obligation_.LegalObligationType.mobileApp,
      value: 'Terrain'
    }, {
      id: legal_obligation_.LegalObligationType.backoffice,
      value: 'Manager'
    }];
    async function onAcceptClick() {
      const {
        valid
      } = await validate();
      if (valid) {
        emit('accept', schema.validateSync(dataInternal.value));
        emit('close');
      }
    }
    return {
      fields,
      max,
      title,
      types,
      onAcceptClick
    };
  }
}));
;// ./src/components/organisms/card-obligation/elems/modal-custom-obligation/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/card-obligation/elems/modal-custom-obligation/component.vue




;
const modal_custom_obligation_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(modal_custom_obligation_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_001dfdc8_ts_true_render]])

/* harmony default export */ const modal_custom_obligation_component = (modal_custom_obligation_component_exports_);
;// ./src/components/organisms/card-obligation/elems/modal-custom-obligation/composables/use-modal-custom-obligation.ts




// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useModalCustomObligation() {
  const b = useBem(modal_custom_obligation_style_module);
  return useOverlay({
    component: modal_custom_obligation_component,
    cssClass: b('container')
  });
}
;// ./src/components/organisms/card-obligation/elems/modal-custom-obligation/index.ts




;// ./src/components/organisms/card-obligation/composables/use-custom-obligations.ts


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useCustomObligations({
  groupOptions,
  createCustomObligation,
  updateCustomObligation,
  scrollToEndOfGroup,
  selectedType
}) {
  const modalCustomObligation = useModalCustomObligation();
  function createCustomObligationInternal(groupId) {
    modalCustomObligation.open({
      editing: false,
      data: {
        groupId
      },
      groups: groupOptions.value,
      initialType: selectedType.value,
      async onAccept(data) {
        const {
          groupId: groupIdUpdated,
          title,
          reference,
          description,
          situation,
          type
        } = data;
        const information = {
          title,
          reference,
          description,
          type
        };
        const additionalData = situation ? {
          situation
        } : null;
        const status = additionalData ? legal_obligation_.LegalObligationStatus.delivered : null;
        await createCustomObligation({
          data: {
            groupId: groupIdUpdated,
            information,
            additionalData,
            status
          }
        });
        if (selectedType.value && selectedType.value !== type) {
          selectedType.value = type;
        }
        if (groupId !== groupIdUpdated) {
          await scrollToEndOfGroup(groupIdUpdated);
        }
      }
    });
  }
  function updateCustomObligationInternal(item) {
    const {
      custom,
      groupId,
      information,
      additionalData: existingAdditionalData,
      status: existingStatus
    } = item.data;
    if (!custom || !information) {
      return;
    }
    const {
      title,
      reference,
      description,
      type
    } = information;
    const situation = existingAdditionalData?.situation ?? '';
    const existingData = {
      groupId,
      title,
      reference,
      description,
      situation,
      type
    };
    modalCustomObligation.open({
      editing: true,
      data: existingData,
      groups: groupOptions.value,
      initialType: selectedType.value,
      // eslint-disable-next-line complexity
      async onAccept(data) {
        const {
          groupId: groupIdUpdated,
          title,
          reference,
          description,
          situation,
          type
        } = data;
        const information = {
          title,
          reference,
          description,
          type
        };
        const additionalData = situation ? {
          ...existingAdditionalData,
          situation
        } : null;
        const status = additionalData && !existingStatus ? legal_obligation_.LegalObligationStatus.delivered : existingStatus;
        await updateCustomObligation({
          id: item.id,
          data: {
            groupId: groupIdUpdated,
            information,
            additionalData,
            status
          }
        });
        if (selectedType.value && selectedType.value !== type) {
          selectedType.value = type;
        }
        if (groupId !== groupIdUpdated) {
          await scrollToEndOfGroup(groupIdUpdated);
        }
      }
    });
  }
  return {
    createCustomObligation: createCustomObligationInternal,
    updateCustomObligation: updateCustomObligationInternal
  };
}
;// ./src/components/organisms/card-obligation/composables/use-obligation-disabled-by-dtg-type.ts

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useObligationDisabledByDtgType({
  disabledByDtgTypeConfigs,
  status,
  disabled,
  selectedDtgType
}) {
  const config = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return disabledByDtgTypeConfigs.value.find(({
      dtgType
    }) => dtgType === selectedDtgType.value);
  });
  const disabledByDtgType = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => Boolean(config.value && status.value));
  const disabledInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
    return disabled.value || disabledByDtgType.value;
  });
  const disabledMessage = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => config.value?.message ?? '');
  return {
    disabledByDtgType,
    disabled: disabledInternal,
    disabledMessage
  };
}
;// ./src/components/organisms/card-obligation/composables/use-obligations-pagination.ts

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useObligationsPagination({
  legalObligations
}) {
  return useListItemPagination({
    items: legalObligations,
    mapper: ({
      id,
      title
    }) => ({
      id,
      value: title
    }),
    pageSize: 1
  });
}
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-obligation/elems/modal-obligation-situation/component.vue?vue&type=template&id=2b857b32&ts=true

function componentvue_type_template_id_2b857b32_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_input_date = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-date");
  const _component_dtg_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_modal_content = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-modal-content");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_modal_content, null, {
    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1)]),
    actions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        icon: "arrowLeft",
        fullwidth: "",
        "icon-left": "",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onCancelClick())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Annuler ")]),
        _: 1
      })]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        disabled: _ctx.disabled || _ctx.empty,
        icon: "trash",
        fullwidth: "",
        notice: "",
        "icon-left": "",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.onClearClick())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Effacer ")]),
        _: 1
      }, 8, ["disabled"])]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "12"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        disabled: _ctx.disabled,
        view: "inverted",
        icon: "checkmarkCircle",
        fullwidth: "",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.onAcceptClick())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Valider ")]),
        _: 1
      }, 8, ["disabled"])]),
      _: 1
    })]),
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.fieldDefinitions, field => {
        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row_col, {
          key: field.key
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields[field.key].fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.isComponent(field, 'text') ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
              key: 0
            }, _ctx.fields[field.key].props, {
              placeholder: field.placeholder
            }), null, 16, ["placeholder"])) : _ctx.isComponent(field, 'date') ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_input_date, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
              key: 1
            }, _ctx.fields[field.key].props, {
              placeholder: field.placeholder,
              align: "bottom right"
            }), null, 16, ["placeholder"])) : _ctx.isComponent(field, 'situation-select') ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
              key: 2
            }, _ctx.fields[field.key].props, {
              options: _ctx.situations,
              placeholder: field.placeholder,
              "track-by-value": "",
              "free-option": "",
              "non-nullable": ""
            }), null, 16, ["options", "placeholder"])) : _ctx.isComponent(field, 'situation-text') ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
              key: 3
            }, _ctx.fields[field.key].props, {
              placeholder: field.placeholder
            }), null, 16, ["placeholder"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
            _: 2
          }, 1040)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  });
}
;// ./src/components/organisms/card-obligation/elems/modal-obligation-situation/component.vue?vue&type=template&id=2b857b32&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/modal-confirm/component.vue?vue&type=template&id=c2ee7684&ts=true

function componentvue_type_template_id_c2ee7684_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_modal_content = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-modal-content");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_modal_content, {
    "actions-align": _ctx.actionsAlign
  }, {
    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1)]),
    actions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "actions", {}, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "auto"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        icon: _ctx.declineIcon,
        size: "s",
        "icon-left": "",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onDecline())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.declineText), 1)]),
        _: 1
      }, 8, ["icon"])]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "auto"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        icon: _ctx.confirmIcon,
        view: "inverted",
        size: "s",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.onConfirm())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.confirmText), 1)]),
        _: 1
      }, 8, ["icon"])]),
      _: 1
    })])]),
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "text", {}, () => [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.textInternal, (text, index) => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", {
        key: index,
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(text), 3);
    }), 128))])], 2)]),
    _: 3
  }, 8, ["actions-align"]);
}
;// ./src/components/organisms/modal-confirm/component.vue?vue&type=template&id=c2ee7684&ts=true

;// ./src/components/organisms/modal-confirm/props.ts

const modal_confirm_props_props = {
  title: {
    type: String,
    default: ''
  },
  text: {
    type: [String, Array],
    default: ''
  },
  confirmText: {
    type: String,
    default: 'Oui'
  },
  confirmIcon: {
    type: String,
    default: 'checkmark'
  },
  declineText: {
    type: String,
    default: 'Non'
  },
  declineIcon: {
    type: String,
    default: 'close'
  },
  actionsAlign: {
    type: String,
    default: 'left',
    validator: inArray(['left', 'center', 'right', 'space-between'])
  }
};
;// ./src/components/organisms/modal-confirm/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_confirm_style_module = ({"dtg-modal-confirm__content":"lib_dtg-modal-confirm__content_f2ZRt","dtg-modal-confirm__text":"lib_dtg-modal-confirm__text_h2sUg","dtg-modal-confirm__container":"lib_dtg-modal-confirm__container_hdvt0"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/modal-confirm/component.vue?vue&type=script&lang=ts









/* harmony default export */ const modal_confirm_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(modal_confirm_style_module),
  components: {
    DtgModalContent: modal_content_component,
    DtgCol: col,
    DtgButton: button_component
  },
  props: modal_confirm_props_props,
  emits: events(['confirm', 'decline', 'close'])(),
  setup(props, {
    emit
  }) {
    const textInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => (0,array_.arrayify)(props.text));
    function onConfirm() {
      emit('confirm');
      emit('close');
    }
    function onDecline() {
      emit('decline');
      emit('close');
    }
    return {
      b: useBem(modal_confirm_style_module),
      textInternal,
      onDecline,
      onConfirm
    };
  }
}));
;// ./src/components/organisms/modal-confirm/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/modal-confirm/component.vue




;
const modal_confirm_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(modal_confirm_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_c2ee7684_ts_true_render]])

/* harmony default export */ const modal_confirm_component = (modal_confirm_component_exports_);
;// ./src/components/organisms/modal-confirm/utils/confirm.ts
async function confirm_confirm(openModal, props) {
  return new Promise(resolve => {
    let confirmed = false;
    openModal({
      ...props,
      onConfirm() {
        confirmed = true;
      },
      onDecline() {
        confirmed = false;
      },
      onCloseFully() {
        resolve(confirmed);
      }
    });
  });
}
;// ./src/components/organisms/modal-confirm/composables/use-modal-confirm.ts





// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useModalConfirm() {
  const b = useBem(modal_confirm_style_module);
  const modal = useOverlay({
    component: modal_confirm_component,
    cssClass: b('container')
  });
  async function confirmInternal(props) {
    return confirm_confirm(modal.open, props);
  }
  return {
    ...modal,
    confirm: confirmInternal
  };
}
;// ./src/components/organisms/modal-confirm/composables/use-modal-confirm-delete.ts




// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useModalConfirmDelete() {
  const b = useBem(modal_confirm_style_module);
  return useOverlay({
    component: modal_confirm_component,
    cssClass: b('container'),
    defaultProps: {
      title: 'Confirmer la suppression',
      confirmText: 'Oui, supprimer',
      confirmIcon: 'trash',
      declineText: 'Annuler',
      declineIcon: 'arrowLeft'
    }
  });
}
;// ./src/components/organisms/modal-confirm/index.ts





;// ./src/components/organisms/card-obligation/elems/modal-obligation-situation/props.ts
const modal_obligation_situation_props_props = {
  title: {
    type: String,
    required: true
  },
  situations: {
    type: Array,
    required: true
  },
  data: {
    type: Object,
    required: true
  },
  initialData: {
    type: Object,
    required: true
  },
  schema: {
    type: Object,
    required: true
  },
  fieldDefinitions: {
    type: Array,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
};
;// ./src/components/organisms/card-obligation/elems/modal-obligation-situation/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_obligation_situation_style_module = ({"dtg-modal-obligation-situation__container":"lib_dtg-modal-obligation-situation__container_cVxTQ"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-obligation/elems/modal-obligation-situation/component.vue?vue&type=script&lang=ts
















/* harmony default export */ const modal_obligation_situation_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(modal_obligation_situation_style_module),
  components: {
    DtgModalContent: modal_content_component,
    DtgGrid: grid,
    DtgRowCol: row_col,
    DtgCol: col,
    DtgInput: input_component,
    DtgButton: button_component,
    DtgSelect: select_component,
    DtgField: field_component,
    DtgInputDate: input_date_component
  },
  props: modal_obligation_situation_props_props,
  emits: events(['accept', 'close'])(),
  setup(props, {
    emit
  }) {
    const {
      disabled
    } = (0,refs_.toReadonlyRefs)(props);
    const dataInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.data);
    const {
      fields,
      validate
    } = (0,use_form_.useFormFields)({
      data: dataInternal,
      schema: props.schema,
      disabled
    });
    const modalConfirm = useModalConfirm();
    const empty = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => Object.values(dataInternal.value).every(value => !value));
    function isComponent(field, componentType) {
      if (field.type === legal_obligation_.LegalObligationFieldType.situation) {
        const noOptions = props.situations.length === 0;
        const isText = noOptions && componentType === 'situation-text';
        const isSelect = !noOptions && componentType === 'situation-select';
        return isText || isSelect;
      }
      return field.type === componentType;
    }
    function onCancelClick() {
      emit('close');
    }
    async function onClearClick() {
      const confirmed = await modalConfirm.confirm({
        title: 'Confirmer effacer',
        text: 'Saisir une situation est obligatoire, êtes-vous sure de vouloir effacer la saisie\xa0?',
        confirmText: 'Oui, effacer',
        declineText: 'Annuler',
        declineIcon: 'arrowLeft'
      });
      if (confirmed) {
        emit('accept', null);
        emit('close');
      }
    }
    async function onAcceptClick() {
      const {
        valid
      } = await validate();
      if (valid) {
        emit('accept', dataInternal.value);
        emit('close');
      }
    }
    return {
      fields,
      empty,
      onCancelClick,
      onClearClick,
      onAcceptClick,
      isComponent,
      ...legal_obligation_.LegalObligationFieldType
    };
  }
}));
;// ./src/components/organisms/card-obligation/elems/modal-obligation-situation/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/card-obligation/elems/modal-obligation-situation/component.vue




;
const modal_obligation_situation_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(modal_obligation_situation_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_2b857b32_ts_true_render]])

/* harmony default export */ const modal_obligation_situation_component = (modal_obligation_situation_component_exports_);
;// ./src/components/organisms/card-obligation/elems/modal-obligation-situation/composables/use-modal-obligation-situation.ts




// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useModalObligationSituation() {
  const b = useBem(modal_obligation_situation_style_module);
  return useOverlay({
    component: modal_obligation_situation_component,
    cssClass: b('container')
  });
}
;// ./src/components/organisms/card-obligation/elems/modal-obligation-situation/index.ts




;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-obligation/component.vue?vue&type=template&id=dcaaeefc&ts=true

function componentvue_type_template_id_dcaaeefc_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_toggle = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-toggle");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_card_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-card-action");
  const _component_dtg_transition_stack = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-transition-stack");
  const _component_dtg_info_box = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-info-box");
  const _component_dtg_icon_action = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon-action");
  const _component_dtg_file_dropzone = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-file-dropzone");
  const _component_dtg_spoiler = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-spoiler");
  const _component_dtg_card_tile = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-card-tile");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_tile, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
    content: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content'))
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.title ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row_col, {
        key: 0
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('title')),
          view: "4"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1)]),
          _: 1
        }, 8, ["class"])]),
        _: 1
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.reference ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row, {
        key: 1
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('reference'))
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.reference), 1)]),
          _: 1
        }, 8, ["class"])]),
        _: 1
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row_col, {
        key: 2
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 1)]),
        _: 1
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, {
        size: "auto",
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('toggle-row'))
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_toggle, {
          modelValue: _ctx.visibleInReportInternal,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.visibleInReportInternal = $event),
          disabled: _ctx.disabled
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Mentionner dans le rapport ")]),
          _: 1
        }, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["class"])]),
      _: 1
    }, 8, ["class"])]),
    actions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.cardActions, action => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_action, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
        key: action.status
      }, action, {
        disabled: _ctx.disabled,
        "size-xs": "12",
        "size-sm": "4"
      }), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(action.text), 1)]),
        _: 2
      }, 1040, ["disabled"]);
    }), 128)), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_transition_stack, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.isSituationButtonVisible ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card_action, {
        key: 0,
        "mark-view": _ctx.situationMarkView,
        title: _ctx.situationButtonText,
        size: "12",
        marked: "",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.onSituationClick())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.situationButtonText), 1)]),
        _: 1
      }, 8, ["mark-view", "title"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_transition_stack, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.warningText ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
        key: 0,
        size: "12"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_info_box, {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('warning')),
          color: "warning",
          icon: "warning"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.warningText), 1)]),
          _: 1
        }, 8, ["class"])]),
        _: 1
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_action, {
      marked: _ctx.hasComment,
      size: "12",
      icon: "comment",
      onClick: _cache[2] || (_cache[2] = $event => _ctx.onCommentClick())
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Commentaire ")]),
      _: 1
    }, 8, ["marked"])]),
    _: 2
  }, [_ctx.editable ? {
    name: "additionalActions",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon_action, {
        disabled: _ctx.disabled,
        name: "edit",
        onClick: _cache[3] || (_cache[3] = $event => _ctx.onEditClick())
      }, null, 8, ["disabled"])]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon_action, {
        disabled: _ctx.disabled,
        name: "trash",
        notice: "",
        onClick: _cache[4] || (_cache[4] = $event => _ctx.onDeleteClick())
      }, null, 8, ["disabled"])]),
      _: 1
    })]),
    key: "0"
  } : undefined, _ctx.$slots.files || !_ctx.readonlyFiles ? {
    name: "afterActions",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, {
      padding: "half"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [!_ctx.readonlyFiles ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_file_dropzone, {
          key: 0,
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('dropzone')),
          disabled: _ctx.disabled,
          accept: _ctx.acceptFiles,
          format: _ctx.formatFiles,
          max: _ctx.maxFiles,
          name: "files",
          fullwidth: "",
          onFiles: _cache[5] || (_cache[5] = $event => _ctx.onDocumentFiles($event))
        }, null, 8, ["class", "disabled", "accept", "format", "max"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
        _: 1
      }), _ctx.$slots.files ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row_col, {
        key: 0
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_spoiler, {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('files')),
          opened: _ctx.filesOpened,
          "onUpdate:opened": _cache[6] || (_cache[6] = $event => _ctx.filesOpened = $event),
          title: "Fichiers déposés"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "files", (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)({
                disabled: _ctx.disabled,
                readonly: _ctx.readonlyFiles
              })))]),
              _: 3
            })]),
            _: 3
          })]),
          _: 3
        }, 8, ["class", "opened"])]),
        _: 3
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.files ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row, {
        key: 1,
        align: "center flex-end"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          size: "auto"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_toggle, {
            modelValue: _ctx.filesVisibleInReportInternal,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.filesVisibleInReportInternal = $event),
            disabled: _ctx.disabled
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Annexer au rapport ")]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        })]),
        _: 1
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
      _: 3
    })]),
    key: "1"
  } : undefined]), 1032, ["class"]);
}
;// ./src/components/organisms/card-obligation/component.vue?vue&type=template&id=dcaaeefc&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/modal-comment/component.vue?vue&type=template&id=2200b906&ts=true

function componentvue_type_template_id_2200b906_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_textarea = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-textarea");
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_modal_content = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-modal-content");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_modal_content, null, {
    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1)]),
    actions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "auto"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        disabled: _ctx.disabled,
        view: "inverted",
        size: "s",
        icon: "checkmarkCircle",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.onConfirm())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.confirmText), 1)]),
        _: 1
      }, 8, ["disabled"])]),
      _: 1
    })]),
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_textarea, {
      modelValue: _ctx.commentInternal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.commentInternal = $event),
      disabled: _ctx.disabled,
      name: "comment",
      autofocus: ""
    }, null, 8, ["modelValue", "disabled"])]),
    _: 1
  });
}
;// ./src/components/organisms/modal-comment/component.vue?vue&type=template&id=2200b906&ts=true

;// ./src/components/organisms/modal-comment/props.ts
const modal_comment_props_props = {
  title: {
    type: String,
    default: 'Entrer un commentaire'
  },
  comment: {
    type: String,
    default: ''
  },
  confirmText: {
    type: String,
    default: 'Ok'
  },
  disabled: {
    type: Boolean,
    default: false
  }
};
;// ./src/components/organisms/modal-comment/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_comment_style_module = ({"dtg-modal-comment__container":"lib_dtg-modal-comment__container_JWtJo"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/modal-comment/component.vue?vue&type=script&lang=ts









/* harmony default export */ const modal_comment_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(modal_comment_style_module),
  components: {
    DtgModalContent: modal_content_component,
    DtgButton: button_component,
    DtgCol: col,
    DtgTextarea: textarea_component
  },
  props: modal_comment_props_props,
  emits: events(['confirm', 'close'])(),
  setup(props, {
    emit
  }) {
    const commentInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.comment);
    function onConfirm() {
      emit('confirm', commentInternal.value);
      emit('close');
    }
    return {
      commentInternal,
      onConfirm
    };
  }
}));
;// ./src/components/organisms/modal-comment/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/modal-comment/component.vue




;
const modal_comment_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(modal_comment_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_2200b906_ts_true_render]])

/* harmony default export */ const modal_comment_component = (modal_comment_component_exports_);
;// ./src/components/organisms/modal-comment/composables/use-modal-comment.ts




// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useModalComment() {
  const b = useBem(modal_comment_style_module);
  return useOverlay({
    component: modal_comment_component,
    cssClass: b('container')
  });
}
;// ./src/components/organisms/modal-comment/index.ts





;// ./src/components/organisms/card-obligation/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_obligation_style_module = ({"dtg-card-obligation__content":"lib_dtg-card-obligation__content_CIS90","dtg-card-obligation__title":"lib_dtg-card-obligation__title_WbuuS","dtg-card-obligation":"lib_dtg-card-obligation_q1FUd","dtg-card-obligation__reference":"lib_dtg-card-obligation__reference_nQjuD","dtg-card-obligation__toggle-row":"lib_dtg-card-obligation__toggle-row_TDkhP","dtg-card-obligation__dropzone":"lib_dtg-card-obligation__dropzone_uTdF1","dtg-card-obligation__files":"lib_dtg-card-obligation__files_Hp95D","dtg-card-obligation__warning":"lib_dtg-card-obligation__warning_JKFVn"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-obligation/component.vue?vue&type=script&lang=ts





















const ACTION_CONFIG = {
  [legal_obligation_.LegalObligationStatus.notApplicable]: {
    icon: null,
    view: DtgCardActionView.regular
  },
  [legal_obligation_.LegalObligationStatus.delivered]: {
    icon: 'checkmark',
    view: DtgCardActionView.success
  },
  [legal_obligation_.LegalObligationStatus.notDelivered]: {
    icon: 'close',
    view: DtgCardActionView.notice
  }
};
/* harmony default export */ const card_obligation_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_obligation_style_module),
  components: {
    DtgCardTile: card_tile_component,
    DtgCardAction: card_action_component,
    DtgGrid: grid,
    DtgRowCol: row_col,
    DtgRow: row,
    DtgCol: col,
    DtgTitle: title_component,
    DtgIconAction: icon_action_component,
    DtgToggle: toggle_component,
    DtgFileDropzone: file_dropzone_component,
    DtgSpoiler: spoiler_component,
    DtgTransitionStack: transition_stack_component,
    DtgInfoBox: info_box_component
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    reference: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: null
    },
    situationSelected: {
      type: Boolean,
      default: false
    },
    situationLabel: {
      type: String,
      required: true
    },
    comment: {
      type: String,
      default: ''
    },
    visibleInReport: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    readonlyFiles: {
      type: Boolean,
      default: false
    },
    acceptFiles: {
      type: String,
      default: [DtgFileChooserAcceptedTypes.pdf, DtgFileChooserAcceptedTypes.image].join(',')
    },
    formatFiles: {
      type: String,
      default: read_blob_.BlobFormat.blob
    },
    maxFiles: {
      type: Number,
      default: 10
    },
    filesVisibleInReport: {
      type: Boolean,
      default: false
    },
    warningText: {
      type: String,
      default: ''
    }
  },
  emits: ['update:status', 'update:comment', 'update:visibleInReport', 'update:filesVisibleInReport', 'situationClick', 'statusClick', 'delete', 'edit', 'filesAdd'],
  setup(props, {
    emit
  }) {
    const statusInternal = propInternal(props, 'status', emit);
    const commentInternal = propInternal(props, 'comment', emit);
    const visibleInReportInternal = propInternal(props, 'visibleInReport', emit);
    const filesVisibleInReportInternal = propInternal(props, 'filesVisibleInReport', emit);
    const filesOpened = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const cardActions = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        delivered,
        notDelivered,
        notApplicable
      } = legal_obligation_.LegalObligationStatus;
      return [notApplicable, notDelivered, delivered].map(status => {
        const active = status === statusInternal.value;
        const muted = (0,truthy_.truthy)(statusInternal.value) && !active;
        const text = legal_obligation_.LEGAL_OBLIGATION_STATUS_MAP[status];
        const config = ACTION_CONFIG[status];
        return {
          active,
          muted,
          status,
          text,
          ...config,
          onClick: () => {
            if (statusInternal.value === status) {
              statusInternal.value = null;
            } else {
              statusInternal.value = status;
            }
            emit('statusClick');
          }
        };
      });
    });
    const situationLabel = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const shouldShowLabel = (0,array_.arrayIncludes)([legal_obligation_.LegalObligationStatus.notDelivered, legal_obligation_.LegalObligationStatus.delivered], statusInternal.value);
      const {
        situationSelected,
        situationLabel
      } = props;
      return situationSelected && shouldShowLabel ? situationLabel : '';
    });
    const isSituationButtonVisible = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return isStatus(legal_obligation_.LegalObligationStatus.delivered) || isStatus(legal_obligation_.LegalObligationStatus.notDelivered);
    });
    const hasComment = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => (0,truthy_.truthy)(commentInternal.value));
    const situationButtonText = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      if (!props.situationSelected) {
        return 'Sélectionnez la situation';
      }
      return ['Situation', situationLabel.value].filter(truthy_.truthy).join(': ');
    });
    const situationMarkView = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.situationSelected ? DtgMarkView.success : DtgMarkView.warning;
    });
    const modalComment = useModalComment();
    function openCommentModal() {
      modalComment.open({
        comment: commentInternal.value,
        disabled: props.disabled,
        onConfirm: comment => {
          commentInternal.value = comment;
        }
      });
    }
    function isStatus(status) {
      return (0,truthy_.truthy)(statusInternal.value) && statusInternal.value === status;
    }
    function onCommentClick() {
      openCommentModal();
    }
    function onSituationClick() {
      emit('situationClick');
    }
    function onDeleteClick() {
      emit('delete');
    }
    function onEditClick() {
      emit('edit');
    }
    function onDocumentFiles(files) {
      emit('filesAdd', files);
      filesOpened.value = true;
      if (!statusInternal.value) {
        statusInternal.value = legal_obligation_.LegalObligationStatus.delivered;
      }
    }
    return {
      b: useBem(card_obligation_style_module),
      cardActions,
      isSituationButtonVisible,
      situationButtonText,
      hasComment,
      situationMarkView,
      visibleInReportInternal,
      filesOpened,
      filesVisibleInReportInternal,
      onSituationClick,
      onCommentClick,
      onDeleteClick,
      onEditClick,
      onDocumentFiles
    };
  }
}));
;// ./src/components/organisms/card-obligation/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/card-obligation/component.vue




;
const card_obligation_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_obligation_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_dcaaeefc_ts_true_render]])

/* harmony default export */ const card_obligation_component = (card_obligation_component_exports_);
;// ./src/components/organisms/card-obligation/index.ts








;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-support/component.vue?vue&type=template&id=18b27ab6&ts=true

const componentvue_type_template_id_18b27ab6_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("br", null, null, -1);
function componentvue_type_template_id_18b27ab6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_card_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-card-title");
  const _component_dtg_card_divider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-card-divider");
  const _component_dtg_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-icon");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_divider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-divider");
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_card = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-card");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_card, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_title, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('title'))
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Aide et assistance ")]),
      _: 1
    }, 8, ["class"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_card_divider), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('heading-icon'))
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_icon, {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('heading-icon-glyph')),
        name: "call"
      }, null, 8, ["class"])], 2)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Vous avez rencontré un problème technique avec l’un"), componentvue_type_template_id_18b27ab6_ts_true_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("de nos produits MyDTG ? ")], 2)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_divider, {
        view: "short"
      })]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
        view: 4
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Ecrivez-nous à: ")]),
        _: 1
      })]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('phone')),
        view: "inverted",
        href: "mailto:assistance@mydtg.fr"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" assistance@mydtg.fr ")]),
        _: 1
      }, 8, ["class"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["class"]);
}
;// ./src/components/organisms/card-support/component.vue?vue&type=template&id=18b27ab6&ts=true

;// ./src/components/organisms/card-support/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_support_style_module = ({"dtg-card-support":"lib_dtg-card-support_NRroU","dtg-card-support__title":"lib_dtg-card-support__title_jzUQ7","dtg-card-support__heading-icon":"lib_dtg-card-support__heading-icon_P0nnZ","dtg-card-support__heading-icon-glyph":"lib_dtg-card-support__heading-icon-glyph_XbXSR","dtg-card-support__text":"lib_dtg-card-support__text_poIix","dtg-card-support__phone":"lib_dtg-card-support__phone_eOatF","dtg-card-support__phone-icon":"lib_dtg-card-support__phone-icon_eT2Kl"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/card-support/component.vue?vue&type=script&lang=ts












/* harmony default export */ const card_support_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(card_support_style_module),
  components: {
    DtgAction: action_component,
    DtgTitle: title_component,
    DtgIcon: icon_component,
    DtgButton: button_component,
    DtgCard: card_component,
    DtgCardTitle: card_title_component,
    DtgRowCol: row_col,
    DtgDivider: divider_component,
    DtgCardDivider: card_divider_component
  },
  setup() {
    return {
      b: useBem(card_support_style_module)
    };
  }
}));
;// ./src/components/organisms/card-support/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/card-support/component.vue




;
const card_support_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(card_support_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_18b27ab6_ts_true_render]])

/* harmony default export */ const card_support_component = (card_support_component_exports_);
;// ./src/components/organisms/card-support/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-audit/component.vue?vue&type=template&id=169e34eb&ts=true

const componentvue_type_template_id_169e34eb_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("sup", null, "2", -1);
const componentvue_type_template_id_169e34eb_ts_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("sup", null, "2", -1);
const componentvue_type_template_id_169e34eb_ts_true_hoisted_3 = ["src"];
function componentvue_type_template_id_169e34eb_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('audit-wrap'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('diagram-wrap'))
  }, [_ctx.energyConsumptionValue !== null ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('arrow', {
      left: true
    })),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.consumptionArrowStyle)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('prefix'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("kWhEP/m"), componentvue_type_template_id_169e34eb_ts_true_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(".an ")], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('value', {
      left: true
    }))
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.energyConsumptionValue), 3), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('triangle'))
  }, null, 2)], 6)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.gasEmissionValue !== null ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('arrow', {
      right: true
    })),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.emissionArrowStyle)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('triangle'))
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('value', {
      right: true
    }))
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.gasEmissionValue), 3), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('prefix'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" KgéqCo2/m"), componentvue_type_template_id_169e34eb_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(".an")], 2)], 6)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
    src: _ctx.auditBackgroundImage,
    alt: ""
  }, null, 8, componentvue_type_template_id_169e34eb_ts_true_hoisted_3)], 2)], 2)], 2);
}
;// ./src/components/organisms/diagnostic-audit/component.vue?vue&type=template&id=169e34eb&ts=true

;// ./src/components/organisms/diagnostic-audit/utils/data.ts
const energyConsumptions = [{
  id: 0,
  title: '< 70',
  subTitle: 'A',
  valueDown: 0,
  valueUp: 69,
  color: '#329837',
  width: 70,
  top: 25,
  widthDot: 15,
  stepX: 22,
  stepYStart: 42,
  stepYEnd: 59
}, {
  id: 1,
  title: '70 à 110',
  subTitle: 'B',
  valueDown: 70,
  valueUp: 109,
  color: '#57af37',
  width: 90,
  top: 42,
  widthDot: 20,
  stepX: 45,
  stepYStart: 63,
  stepYEnd: 76
}, {
  id: 2,
  title: '110 à 180',
  subTitle: 'C',
  valueDown: 110,
  valueUp: 179,
  color: '#c6d300',
  width: 110,
  top: 66,
  widthDot: 26,
  stepX: 68,
  stepYStart: 80,
  stepYEnd: 102
}, {
  id: 3,
  title: '180 à 250',
  subTitle: 'D',
  valueDown: 180,
  valueUp: 249,
  color: '#f2e500',
  width: 130,
  top: 106,
  widthDot: 30,
  stepX: 91,
  stepYStart: 106,
  stepYEnd: 138
}, {
  id: 4,
  title: '250 à 330',
  subTitle: 'E',
  valueDown: 250,
  valueUp: 329,
  color: '#ffcb03',
  width: 150,
  top: 142,
  widthDot: 35,
  stepX: 115,
  stepYStart: 142,
  stepYEnd: 179
}, {
  id: 5,
  title: '330 à 420',
  subTitle: 'F',
  valueDown: 330,
  valueUp: 419,
  color: '#f39739',
  width: 170,
  top: 194,
  widthDot: 40,
  stepX: 138,
  stepYStart: 183,
  stepYEnd: 228
}, {
  id: 6,
  title: '>= 420',
  subTitle: 'G',
  valueDown: 420,
  valueUp: 510,
  color: '#e4251f',
  width: 190,
  top: 248,
  widthDot: 45,
  stepX: 161,
  stepYStart: 232,
  stepYEnd: 282
}];
const gasEmissions = [{
  id: 0,
  title: '< 6',
  subTitle: 'A',
  valueDown: 0,
  valueUp: 5,
  color: '#f4ebfb',
  width: 70,
  top: 25,
  widthDot: 15,
  stepX: 22,
  stepYStart: 42,
  stepYEnd: 59
}, {
  id: 1,
  title: '6 à 11',
  subTitle: 'B',
  valueDown: 6,
  valueUp: 10,
  color: '#dfc1f7',
  width: 90,
  top: 42,
  widthDot: 22,
  stepX: 45,
  stepYStart: 63,
  stepYEnd: 76
}, {
  id: 2,
  title: '11 à 30',
  subTitle: 'C',
  valueDown: 11,
  valueUp: 29,
  color: '#d6aaf4',
  width: 110,
  top: 66,
  widthDot: 26,
  stepX: 68,
  stepYStart: 80,
  stepYEnd: 102
}, {
  id: 3,
  title: '30 à 50',
  subTitle: 'D',
  valueDown: 30,
  valueUp: 49,
  color: '#cc93f4',
  width: 130,
  top: 106,
  widthDot: 31,
  stepX: 91,
  stepYStart: 106,
  stepYEnd: 138
}, {
  id: 4,
  title: '50 à 70',
  subTitle: 'E',
  valueDown: 50,
  valueUp: 69,
  color: '#bb72f3',
  width: 150,
  top: 142,
  widthDot: 36,
  stepX: 115,
  stepYStart: 142,
  stepYEnd: 179
}, {
  id: 5,
  title: '70 à 100',
  subTitle: 'F',
  valueDown: 70,
  valueUp: 99,
  color: '#a94cee',
  width: 170,
  top: 194,
  widthDot: 41,
  stepX: 138,
  stepYStart: 183,
  stepYEnd: 228
}, {
  id: 6,
  title: '> 100',
  subTitle: 'G',
  valueDown: 100,
  valueUp: 130,
  color: '#8b1ae1',
  width: 190,
  top: 248,
  widthDot: 46,
  stepX: 161,
  stepYStart: 232,
  stepYEnd: 282
}];
;// ./src/assets/audit.png
const audit_namespaceObject = "data:image/png;base64,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";
;// ./src/components/organisms/diagnostic-audit/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const diagnostic_audit_style_module = ({"dtg-diagnostic-audit":"lib_dtg-diagnostic-audit_VHfBu","dtg-diagnostic-audit__audit-wrap":"lib_dtg-diagnostic-audit__audit-wrap_vlk3N","dtg-diagnostic-audit__diagram-wrap":"lib_dtg-diagnostic-audit__diagram-wrap_VRe4C","dtg-diagnostic-audit__arrow":"lib_dtg-diagnostic-audit__arrow_WLuLT","dtg-diagnostic-audit__arrow_right":"lib_dtg-diagnostic-audit__arrow_right_jou0X","dtg-diagnostic-audit__arrow_left":"lib_dtg-diagnostic-audit__arrow_left_UyxBU","dtg-diagnostic-audit__triangle":"lib_dtg-diagnostic-audit__triangle_DcikF","dtg-diagnostic-audit__prefix":"lib_dtg-diagnostic-audit__prefix_bMc62","dtg-diagnostic-audit__value":"lib_dtg-diagnostic-audit__value_R4ZPR","dtg-diagnostic-audit__value_left":"lib_dtg-diagnostic-audit__value_left_ZKfms","dtg-diagnostic-audit__value_right":"lib_dtg-diagnostic-audit__value_right_HIJk3"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-audit/component.vue?vue&type=script&lang=ts







/* harmony default export */ const diagnostic_audit_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(diagnostic_audit_style_module),
  props: {
    energyConsumptionValue: {
      type: Number,
      default: null
    },
    gasEmissionValue: {
      type: Number,
      default: null
    }
  },
  setup(props) {
    const {
      energyConsumptionValue,
      gasEmissionValue
    } = (0,refs_.toReadonlyRefs)(props);
    const energyConsumption = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const lastConsumptionValue = energyConsumptions[energyConsumptions.length - 1].valueUp;
      const consumption = (0,number_.clamp)(energyConsumptionValue.value ?? 0, 0, lastConsumptionValue);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return energyConsumptions.find(info => isInRange(consumption, info));
    });
    const gasEmission = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const lastEmissionValue = gasEmissions[gasEmissions.length - 1].valueUp;
      const emission = (0,number_.clamp)(gasEmissionValue.value ?? 0, 0, lastEmissionValue);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return gasEmissions.find(info => isInRange(emission, info));
    });
    const consumptionArrowStyle = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        x,
        y
      } = getPosition(energyConsumption.value, props.energyConsumptionValue ?? 0);
      return {
        left: `${x}px`,
        bottom: `${y}px`
      };
    });
    const emissionArrowStyle = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        x,
        y
      } = getPosition(gasEmission.value, props.gasEmissionValue ?? 0);
      return {
        right: `${x}px`,
        bottom: `${y}px`
      };
    });
    function isInRange(value, {
      valueDown,
      valueUp
    }) {
      return valueDown <= value && value <= valueUp;
    }
    function getPosition(item, value) {
      const {
        stepX,
        stepYStart,
        stepYEnd,
        valueUp,
        valueDown
      } = item;
      const clampedValue = (0,number_.clamp)(value, valueDown, valueUp);
      const y = (0,number_.translateValue)(clampedValue, [valueDown, valueUp], [stepYStart, stepYEnd]);
      return {
        x: stepX,
        y: Math.round(y)
      };
    }
    return {
      b: useBem(diagnostic_audit_style_module),
      consumptionArrowStyle,
      emissionArrowStyle,
      auditBackgroundImage: audit_namespaceObject
    };
  }
}));
;// ./src/components/organisms/diagnostic-audit/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/diagnostic-audit/component.vue




;
const diagnostic_audit_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(diagnostic_audit_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_169e34eb_ts_true_render]])

/* harmony default export */ const diagnostic_audit_component = (diagnostic_audit_component_exports_);
;// ./src/components/organisms/diagnostic-audit/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-dpe/component.vue?vue&type=template&id=995d8cd8&ts=true

function componentvue_type_template_id_995d8cd8_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_consumption_chart = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-consumption-chart");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_emission_chart = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-emission-chart");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
    "size-lg": _ctx.hideEmissionChart ? '12' : '8',
    "size-xs": "12",
    "size-sm": "12"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_consumption_chart, {
      "active-class": _ctx.consumptionClass,
      items: _ctx.consumptionClasses,
      consumption: _ctx.consumption,
      emission: _ctx.emission,
      "show-only-active-row": _ctx.showOnlyActiveRow
    }, null, 8, ["active-class", "items", "consumption", "emission", "show-only-active-row"])]),
    _: 1
  }, 8, ["size-lg"]), !_ctx.hideEmissionChart ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
    key: 0,
    "size-lg": "4",
    "size-xs": "12",
    "size-sm": "12"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_emission_chart, {
      "active-class": _ctx.emissionClass,
      items: _ctx.emissionClasses,
      emission: _ctx.emission
    }, null, 8, ["active-class", "items", "emission"])]),
    _: 1
  })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// ./src/components/organisms/diagnostic-dpe/component.vue?vue&type=template&id=995d8cd8&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-dpe/elems/consumption-chart/component.vue?vue&type=template&id=1d469b97&ts=true

const componentvue_type_template_id_1d469b97_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("sup", null, "2", -1);
const componentvue_type_template_id_1d469b97_ts_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("sub", null, "2", -1);
const componentvue_type_template_id_1d469b97_ts_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("sup", null, "2", -1);
function componentvue_type_template_id_1d469b97_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_diagnostics_chart_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-diagnostics-chart-base");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_diagnostics_chart_base, {
    items: _ctx.items,
    "active-class": _ctx.activeClass,
    "show-only-active-row": _ctx.showOnlyActiveRow
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
    "active-prepend": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label'))
    }, [_ctx.consumption !== null ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label-item'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label-title'))
    }, "consommation", 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.consumption) + " ", 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label-unit'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("kWh/m"), componentvue_type_template_id_1d469b97_ts_true_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(".an")], 2)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.emission !== null ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label-item'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label-title'))
    }, "emissions", 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.emission) + " ", 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label-unit'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("kg CO"), componentvue_type_template_id_1d469b97_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("/m"), componentvue_type_template_id_1d469b97_ts_true_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(".an")], 2)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)]),
    _: 2
  }, [!_ctx.showOnlyActiveRow ? {
    name: "top-label",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('title'))
    }, " logement tres performant ", 2)]),
    key: "0"
  } : undefined, !_ctx.showOnlyActiveRow ? {
    name: "bottom-label",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('title'))
    }, " logement extrêmement consommateur d'energie ", 2)]),
    key: "1"
  } : undefined]), 1032, ["items", "active-class", "show-only-active-row"]);
}
;// ./src/components/organisms/diagnostic-dpe/elems/consumption-chart/component.vue?vue&type=template&id=1d469b97&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-base/component.vue?vue&type=template&id=0e07f71e&ts=true

function componentvue_type_template_id_0e07f71e_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_diagnostics_chart_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-diagnostics-chart-row");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.topLabelStyles)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "top-label")], 4), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('list'))
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.items, (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_diagnostics_chart_row, {
      key: item.label,
      minified: _ctx.minified,
      value: item,
      index: index,
      rounded: _ctx.rounded,
      active: _ctx.isItemActive(item),
      "no-styles": _ctx.showOnlyActiveRow
    }, {
      prepend: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "active-prepend")]),
      append: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.isItemActive(item) ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "active-append", {
        key: 0
      }) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
      _: 2
    }, 1032, ["minified", "value", "index", "rounded", "active", "no-styles"]);
  }), 128))], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.bottomLabelStyles)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "bottom-label")], 4)], 2);
}
;// ./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-base/component.vue?vue&type=template&id=0e07f71e&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-row/component.vue?vue&type=template&id=25847073&ts=true

const componentvue_type_template_id_25847073_ts_true_hoisted_1 = {
  key: 0
};
function componentvue_type_template_id_25847073_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b({
      active: _ctx.active,
      rounded: _ctx.rounded,
      sm: _ctx.minified
    })),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.noStyles ? undefined : _ctx.containerStyles)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('border'))
  }, [_ctx.$slots.prepend ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('prepand'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "prepend")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('pane')),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.paneStyles)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.value.label), 7)], 2), _ctx.$slots.append ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", componentvue_type_template_id_25847073_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "append")])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 6);
}
;// ./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-row/component.vue?vue&type=template&id=25847073&ts=true

;// ./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-row/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const diagnostics_chart_row_style_module = ({"dtg-diagnostics-chart-row":"lib_dtg-diagnostics-chart-row_RdxGp","dtg-diagnostics-chart-row__border":"lib_dtg-diagnostics-chart-row__border_eMeU_","dtg-diagnostics-chart-row__prepand":"lib_dtg-diagnostics-chart-row__prepand_PAqd5","dtg-diagnostics-chart-row__pane":"lib_dtg-diagnostics-chart-row__pane_lkkJU","dtg-diagnostics-chart-row_rounded":"lib_dtg-diagnostics-chart-row_rounded_FWYnz","dtg-diagnostics-chart-row_active":"lib_dtg-diagnostics-chart-row_active_GPgfD","dtg-diagnostics-chart-row_sm":"lib_dtg-diagnostics-chart-row_sm_O3tRw","dtg-diagnostics-chart-row__prepend":"lib_dtg-diagnostics-chart-row__prepend_mw3gv"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-row/component.vue?vue&type=script&lang=ts



/* harmony default export */ const diagnostics_chart_row_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(diagnostics_chart_row_style_module),
  props: {
    value: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    minified: {
      type: Boolean,
      default: false
    },
    rowCount: {
      type: Number,
      default: 7
    },
    noStyles: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const containerStyles = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
      paddingRight: `${(props.rowCount - (props.index + 1)) * 5}%`
    }));
    const paneStyles = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
      backgroundColor: props.value.color
    }));
    return {
      b: useBem(diagnostics_chart_row_style_module),
      containerStyles,
      paneStyles
    };
  }
}));
;// ./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-row/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-row/component.vue




;
const diagnostics_chart_row_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(diagnostics_chart_row_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_25847073_ts_true_render]])

/* harmony default export */ const diagnostics_chart_row_component = (diagnostics_chart_row_component_exports_);
;// ./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-row/index.ts


;// ./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-base/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const diagnostics_chart_base_style_module = ({"dtg-diagnostics-chart-base":"lib_dtg-diagnostics-chart-base_fSQny","dtg-diagnostics-chart-base__list":"lib_dtg-diagnostics-chart-base__list_WCfqm"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-base/component.vue?vue&type=script&lang=ts




/* harmony default export */ const diagnostics_chart_base_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(diagnostics_chart_base_style_module),
  components: {
    DtgDiagnosticsChartRow: diagnostics_chart_row_component
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    topLabel: {
      type: String,
      default: null
    },
    bottomLabel: {
      type: String,
      default: null
    },
    activeClass: {
      type: String,
      default: null
    },
    rounded: {
      type: Boolean,
      default: false
    },
    minified: {
      type: Boolean,
      default: false
    },
    showOnlyActiveRow: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const topLabelStyles = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      color: props.items[0].color
    }));
    const bottomLabelStyles = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      color: props.items[props.items.length - 1].color
    }));
    function isItemActive(item) {
      return item.label === props.activeClass;
    }
    return {
      b: useBem(diagnostics_chart_base_style_module),
      topLabelStyles,
      bottomLabelStyles,
      isItemActive
    };
  }
}));
;// ./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-base/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-base/component.vue




;
const diagnostics_chart_base_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(diagnostics_chart_base_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_0e07f71e_ts_true_render]])

/* harmony default export */ const diagnostics_chart_base_component = (diagnostics_chart_base_component_exports_);
;// ./src/components/organisms/diagnostic-dpe/elems/diagnostics-chart-base/index.ts


;// ./src/components/organisms/diagnostic-dpe/elems/consumption-chart/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const consumption_chart_style_module = ({"dtg-consumption-chart__title":"lib_dtg-consumption-chart__title_tAax5","dtg-consumption-chart__label":"lib_dtg-consumption-chart__label_zP7jJ","dtg-consumption-chart__label-item":"lib_dtg-consumption-chart__label-item_NzCL4","dtg-consumption-chart__label-title":"lib_dtg-consumption-chart__label-title_FKzpF","dtg-consumption-chart__label-unit":"lib_dtg-consumption-chart__label-unit_OUq64"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-dpe/elems/consumption-chart/component.vue?vue&type=script&lang=ts




/* harmony default export */ const consumption_chart_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(consumption_chart_style_module),
  components: {
    DtgDiagnosticsChartBase: diagnostics_chart_base_component
  },
  props: {
    emission: {
      type: Number,
      default: null
    },
    consumption: {
      type: Number,
      default: null
    },
    items: {
      type: Array,
      required: true
    },
    activeClass: {
      type: String,
      default: null
    },
    showOnlyActiveRow: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      b: useBem(consumption_chart_style_module)
    };
  }
}));
;// ./src/components/organisms/diagnostic-dpe/elems/consumption-chart/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/diagnostic-dpe/elems/consumption-chart/component.vue




;
const consumption_chart_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(consumption_chart_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_1d469b97_ts_true_render]])

/* harmony default export */ const consumption_chart_component = (consumption_chart_component_exports_);
;// ./src/components/organisms/diagnostic-dpe/elems/consumption-chart/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-dpe/elems/emission-chart/component.vue?vue&type=template&id=e8e3b798&ts=true

const componentvue_type_template_id_e8e3b798_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("sub", null, "2", -1);
const componentvue_type_template_id_e8e3b798_ts_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("sub", null, "2", -1);
const componentvue_type_template_id_e8e3b798_ts_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("sup", null, "2", -1);
const componentvue_type_template_id_e8e3b798_ts_true_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("sub", null, "2", -1);
function componentvue_type_template_id_e8e3b798_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_diagnostics_chart_base = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-diagnostics-chart-base");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('title'))
  }, " * Dont émissions de gaz à effet de serre ", 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_diagnostics_chart_base, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('chart')),
    items: _ctx.items,
    "active-class": _ctx.activeClass,
    minified: "",
    rounded: ""
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
    "top-label": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" peu d'emissions de CO"), componentvue_type_template_id_e8e3b798_ts_true_hoisted_1]),
    "bottom-label": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" emissions de CO"), componentvue_type_template_id_e8e3b798_ts_true_hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" tres importantes ")]),
    _: 2
  }, [_ctx.emission !== null ? {
    name: "active-append",
    fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.emission) + " ", 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('label-unit'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("kg CO"), componentvue_type_template_id_e8e3b798_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("/m"), componentvue_type_template_id_e8e3b798_ts_true_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(".an")], 2)], 2)]),
    key: "0"
  } : undefined]), 1032, ["class", "items", "active-class"])], 2);
}
;// ./src/components/organisms/diagnostic-dpe/elems/emission-chart/component.vue?vue&type=template&id=e8e3b798&ts=true

;// ./src/components/organisms/diagnostic-dpe/elems/emission-chart/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const emission_chart_style_module = ({"dtg-emission-chart":"lib_dtg-emission-chart_Mfk3C","dtg-emission-chart__title":"lib_dtg-emission-chart__title_Qj0_I","dtg-emission-chart__chart":"lib_dtg-emission-chart__chart_OHFux","dtg-emission-chart__label":"lib_dtg-emission-chart__label_rBssH","dtg-emission-chart__label-unit":"lib_dtg-emission-chart__label-unit_yXMF8"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-dpe/elems/emission-chart/component.vue?vue&type=script&lang=ts




/* harmony default export */ const emission_chart_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(emission_chart_style_module),
  components: {
    DtgDiagnosticsChartBase: diagnostics_chart_base_component
  },
  props: {
    emission: {
      type: Number,
      default: null
    },
    items: {
      type: Array,
      required: true
    },
    activeClass: {
      type: String,
      default: null
    }
  },
  setup() {
    return {
      b: useBem(emission_chart_style_module)
    };
  }
}));
;// ./src/components/organisms/diagnostic-dpe/elems/emission-chart/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/diagnostic-dpe/elems/emission-chart/component.vue




;
const emission_chart_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(emission_chart_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_e8e3b798_ts_true_render]])

/* harmony default export */ const emission_chart_component = (emission_chart_component_exports_);
;// ./src/components/organisms/diagnostic-dpe/elems/emission-chart/index.ts


;// ./src/components/organisms/diagnostic-dpe/consts.ts
const CONSUMPTION_CLASSES = [{
  label: 'A',
  interval: [0, 69],
  color: '#329837'
}, {
  label: 'B',
  interval: [70, 109],
  color: '#57af37'
}, {
  label: 'C',
  interval: [110, 179],
  color: '#c6d300'
}, {
  label: 'D',
  interval: [180, 249],
  color: '#f2e500'
}, {
  label: 'E',
  interval: [250, 329],
  color: '#ffcb03'
}, {
  label: 'F',
  interval: [330, 419],
  color: '#f39739'
}, {
  label: 'G',
  interval: [420, Infinity],
  color: '#e4251f'
}];
const EMISSION_CLASSES = [{
  label: 'A',
  interval: [0, 5],
  color: '#95d7f1'
}, {
  label: 'B',
  interval: [6, 10],
  color: '#7eadcd'
}, {
  label: 'C',
  interval: [11, 29],
  color: '#6a8aa8'
}, {
  label: 'D',
  interval: [30, 49],
  color: '#4e6786'
}, {
  label: 'E',
  interval: [50, 69],
  color: '#434a67'
}, {
  label: 'F',
  interval: [70, 99],
  color: '#312d44'
}, {
  label: 'G',
  interval: [100, Infinity],
  color: '#23162c'
}];
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/diagnostic-dpe/component.vue?vue&type=script&lang=ts





/* harmony default export */ const diagnostic_dpe_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-diagnostic-dpe',
  components: {
    DtgCol: col,
    DtgEmissionChart: emission_chart_component,
    DtgConsumptionChart: consumption_chart_component
  },
  props: {
    emission: {
      type: Number,
      default: null
    },
    emissionClass: {
      type: String,
      default: null
    },
    consumption: {
      type: Number,
      default: null
    },
    consumptionClass: {
      type: String,
      default: null
    },
    showOnlyActiveRow: {
      type: Boolean,
      default: false
    },
    hideEmissionChart: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const filteredConsumptionClasses = CONSUMPTION_CLASSES.filter(({
      label
    }) => !props.showOnlyActiveRow || label === props.consumptionClass);
    const filteredEmissionClasses = EMISSION_CLASSES.filter(({
      label
    }) => !props.showOnlyActiveRow || label === props.emissionClass);
    return {
      consumptionClasses: filteredConsumptionClasses,
      emissionClasses: filteredEmissionClasses
    };
  }
}));
;// ./src/components/organisms/diagnostic-dpe/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/diagnostic-dpe/component.vue




;
const diagnostic_dpe_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(diagnostic_dpe_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_995d8cd8_ts_true_render]])

/* harmony default export */ const diagnostic_dpe_component = (diagnostic_dpe_component_exports_);
;// ./src/components/organisms/diagnostic-dpe/index.ts




;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/document-page/component.vue?vue&type=template&id=6f598c53&ts=true

const componentvue_type_template_id_6f598c53_ts_true_hoisted_1 = ["title"];
function componentvue_type_template_id_6f598c53_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("section", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b()),
    title: _ctx.title
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1)]),
    _: 1
  }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 10, componentvue_type_template_id_6f598c53_ts_true_hoisted_1);
}
;// ./src/components/organisms/document-page/component.vue?vue&type=template&id=6f598c53&ts=true

;// ./src/components/organisms/document-page/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const document_page_style_module = ({"dtg-document-page":"lib_dtg-document-page_pc7m7"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/document-page/component.vue?vue&type=script&lang=ts




/* harmony default export */ const document_page_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(document_page_style_module),
  components: {
    DtgTitle: title_component
  },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  setup() {
    return {
      b: useBem(document_page_style_module)
    };
  }
}));
;// ./src/components/organisms/document-page/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/document-page/component.vue




;
const document_page_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(document_page_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_6f598c53_ts_true_render]])

/* harmony default export */ const document_page_component = (document_page_component_exports_);
;// ./src/components/organisms/document-page/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-energy-balance/component.vue?vue&type=template&id=10dc0b8e&ts=true

const componentvue_type_template_id_10dc0b8e_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("sup", null, "2", -1);
function componentvue_type_template_id_10dc0b8e_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  const _component_dtg_energy_balance_description = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-energy-balance-description");
  const _component_dtg_section = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-section");
  const _component_dtg_input_free_date = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-free-date");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_input_date = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-date");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_input_currency = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-currency");
  const _component_dtg_input_number = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-number");
  const _component_dtg_diagnostic_audit = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-diagnostic-audit");
  const _component_dtg_info_box = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-info-box");
  const _component_dtg_diagnostic_dpe = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-diagnostic-dpe");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
    view: "2"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Bilan énergétique ")]),
    _: 1
  }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_energy_balance_description), _ctx.$slots.default ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_section, {
    key: 0,
    "no-divider": ""
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    _: 3
  })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_section, {
    "no-divider": ""
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-xs": "12",
          "size-sm": "6",
          "size-lg": "4",
          "size-xl": "4.25"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.dateConstruction.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_free_date, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.dateConstruction.props)), null, 16)]),
            _: 1
          }, 16)]),
          _: 1
        }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-xs": "12",
          "size-sm": "6",
          "size-lg": "4",
          "size-xl": "4.25"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.yearConstruction.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.yearConstruction.props, {
              options: _ctx.constructionYearRanges
            }), null, 16, ["options"])]),
            _: 1
          }, 16)]),
          _: 1
        }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-xs": "12",
          "size-lg": "4",
          "size-xl": "3.5"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.wasAuditPerformed.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.wasAuditPerformed.props, {
              options: _ctx.auditStatusOptions,
              placeholder: "Choisir"
            }), null, 16, ["options"])]),
            _: 1
          }, 16)]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _ctx.hasAudit ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_section, {
    key: 1,
    "no-divider": ""
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Bilan énergétique à joindre au rapport DTG final ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-xs": "12",
          "size-sm": "5",
          "size-md": "5.5"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.auditType.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.auditType.props, {
              options: _ctx.auditTypes,
              placeholder: "Choisir"
            }), null, 16, ["options"])]),
            _: 1
          }, 16)]),
          _: 1
        }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-xs": "12",
          "size-sm": "7",
          "size-md": "6.5"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.auditProvidedBy.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.auditProvidedBy.props, {
              placeholder: "Entrez le référent de l'information"
            }), null, 16)]),
            _: 1
          }, 16)]),
          _: 1
        })]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.wasAuditFinished ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
          key: 0,
          "size-xs": "12",
          "size-sm": "5",
          "size-md": "5.5",
          "size-lg": "3"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.auditFile.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "auditFile")]),
            _: 3
          }, 16)]),
          _: 3
        })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.wasAuditFinished ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
          key: 1,
          "size-xs": "12",
          "size-sm": "7",
          "size-md": "6.5",
          "size-lg": "2.5"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.auditDate.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_date, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.auditDate.props)), null, 16)]),
            _: 1
          }, 16)]),
          _: 1
        })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-xs": "12",
          "size-sm": "12",
          "size-lg": _ctx.wasAuditFinished ? 6.5 : 12
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.auditAttendant.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.auditAttendant.props, {
              placeholder: "Ex : Copro Expertises - 80 route des lucioles, 06560 Valbonne"
            }), null, 16)]),
            _: 1
          }, 16)]),
          _: 1
        }, 8, ["size-lg"])]),
        _: 3
      })]),
      _: 3
    })]),
    _: 3
  })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.wasAuditTypeSelected ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_section, {
    key: 2,
    "no-divider": ""
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('type'))
        }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Nature du bilan énergétique : "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('type-value'))
        }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.diagnosticCase), 3)], 2)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, {
        align: "flex-end"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-xs": "12",
          "size-sm": "6",
          "size-lg": "2"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.energyCostsFrom.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_currency, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.energyCostsFrom.props, {
              precision: 0
            }), null, 16)]),
            _: 1
          }, 16)]),
          _: 1
        }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-xs": "12",
          "size-sm": "6",
          "size-lg": "2"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.energyCostsTo.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_currency, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.energyCostsTo.props, {
              precision: 0
            }), null, 16)]),
            _: 1
          }, 16)]),
          _: 1
        })]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-lg": "4",
          "size-sm": "6",
          "size-xs": "12"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.energyConsumption.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_number, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.energyConsumptionProps, {
              min: 0,
              precision: 2,
              "select-all-on-focus": ""
            }), {
              unit: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" kWhEP/m"), componentvue_type_template_id_10dc0b8e_ts_true_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(".an ")]),
              _: 1
            }, 16)]),
            _: 1
          }, 16)]),
          _: 1
        }), _ctx.isDpeMode ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
          key: 0,
          "size-lg": "2",
          "size-sm": "6",
          "size-xs": "12"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.energyConsumptionClass.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.energyConsumptionClass.props, {
              options: _ctx.consumptionClassOptions
            }), null, 16, ["options"])]),
            _: 1
          }, 16)]),
          _: 1
        })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-lg": "4",
          "size-sm": "6",
          "size-xs": "12"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.gasEmission.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_number, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.gasEmissionProps, {
              min: 0,
              precision: 2,
              "select-all-on-focus": ""
            }), {
              unit: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" KgéqCO2/m2.an ")]),
              _: 1
            }, 16)]),
            _: 1
          }, 16)]),
          _: 1
        }), _ctx.isDpeMode ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
          key: 1,
          "size-lg": "2",
          "size-sm": "6",
          "size-xs": "12"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.gasEmissionClass.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.gasEmissionClass.props, {
              options: _ctx.emissionClassOptions
            }), null, 16, ["options"])]),
            _: 1
          }, 16)]),
          _: 1
        })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
        _: 1
      }), _ctx.isAuditMode ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row_col, {
        key: 0
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('charts'))
        }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_diagnostic_audit, {
          "energy-consumption-value": _ctx.energyConsumptionValue,
          "gas-emission-value": _ctx.gasEmissionValue
        }, null, 8, ["energy-consumption-value", "gas-emission-value"])], 2)]),
        _: 1
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.isDpeMode ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
        key: 1
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_info_box, {
          color: "warning",
          icon: "warning"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Attention ! Vérifier que la note de classement correspond bien à la valeur de performance énergétique du diagnostic réalisé. Vous pouvez sélectionner la classe manuellement. ")]),
          _: 1
        })]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('charts'))
        }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_diagnostic_dpe, {
              "consumption-class": _ctx.fields.energyConsumptionClass.value,
              "emission-class": _ctx.fields.gasEmissionClass.value,
              consumption: _ctx.energyConsumptionValue,
              emission: _ctx.gasEmissionValue
            }, null, 8, ["consumption-class", "emission-class", "consumption", "emission"])]),
            _: 1
          })]),
          _: 1
        })], 2)]),
        _: 1
      })], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
      _: 1
    })]),
    _: 1
  })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// ./src/components/organisms/form-energy-balance/component.vue?vue&type=template&id=10dc0b8e&ts=true

;// ./src/components/organisms/form-energy-balance/composables/use-diagnostic-fields.ts


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useDiagnosticFields({
  fields
}) {
  const gasEmissionProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(fields.gasEmission.withReplacedModelValue((0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
    get: () => fields.gasEmission.value,
    set: onGasEmissionChange
  })));
  const energyConsumptionProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(fields.energyConsumption.withReplacedModelValue((0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
    get: () => fields.energyConsumption.value,
    set: onEnergyConsumptionChange
  })));
  const gasEmissionValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => fields.gasEmission.value ?? 0);
  const energyConsumptionValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => fields.energyConsumption.value ?? 0);
  function getMatchedClassIndex(classes, value) {
    return classes.findIndex(diagnosticsClass => {
      const [min, max] = diagnosticsClass.interval;
      return min <= value && value <= max;
    });
  }
  function onGasEmissionChange(value) {
    let updatedClass = null;
    if (typeof value === 'number') {
      const index = getMatchedClassIndex(EMISSION_CLASSES, value);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      updatedClass = EMISSION_CLASSES[index].label;
    }
    fields.gasEmissionClass.updateValue(updatedClass);
    fields.gasEmission.updateValue(value);
  }
  function onEnergyConsumptionChange(value) {
    let updatedClass = null;
    if (typeof value === 'number') {
      const index = getMatchedClassIndex(CONSUMPTION_CLASSES, value);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      updatedClass = CONSUMPTION_CLASSES[index].label;
    }
    fields.energyConsumptionClass.updateValue(updatedClass);
    fields.energyConsumption.updateValue(value);
  }
  return {
    energyConsumptionProps,
    gasEmissionProps,
    gasEmissionValue,
    energyConsumptionValue
  };
}
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-energy-balance/elems/energy-balance-description/component.vue?vue&type=template&id=02636e15&ts=true

const componentvue_type_template_id_02636e15_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Au titre de l’article L126-31 du Code de la Construction et de l’Habitation ci-après reproduit : ", -1);
const componentvue_type_template_id_02636e15_ts_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("br", null, null, -1);
const componentvue_type_template_id_02636e15_ts_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Nota : "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("br"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Se reporter aux conditions d’application prévues à l’article 158 de la loi n° 2021-1104 du 22 août 2021.” ")])], -1);
const componentvue_type_template_id_02636e15_ts_true_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Aussi, au regard de l’article 158 de la loi n° 2021-1104 du 22 août 2021, l’article L126-31 du CCH "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", null, " \"entre en vigueur le 1er janvier 2024. Par dérogation, pour les bâtiments relevant de la loi n° 65-557 du 10 juillet 1965 fixant le statut de la copropriété des immeubles bâtis et comprenant au plus deux cents lots à usage de logements, de bureaux ou de commerces, ces dispositions ne sont toutefois applicables que : ")], -1);
const componentvue_type_template_id_02636e15_ts_true_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", null, "1° Le 1er janvier 2025, pour les copropriétés entre cinquante et deux cents lots ;")]), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", null, "2° Le 1er janvier 2026, pour les copropriétés d’au plus cinquante lots.\"")])], -1);
const componentvue_type_template_id_02636e15_ts_true_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Si un DPE à l’Immeuble ou un Audit Energétique a été réalisé veuillez renseigner les champs suivants et déposer le document. ", -1);
function componentvue_type_template_id_02636e15_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-link");
  const _component_dtg_section = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-section");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_section, {
    "no-divider": ""
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [componentvue_type_template_id_02636e15_ts_true_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" “Tout bâtiment d’habitation collective dont le permis de construire a été déposé avant le 1er janvier 2013 dispose d’un diagnostic de performance énergétique réalisé dans les conditions prévues à l’article "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, {
      href: "https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006074096&idArticle=LEGIARTI000041565277&dateTexte=&categorieLien=cid",
      target: "_blank"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("L. 126-26")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(". "), componentvue_type_template_id_02636e15_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Ce diagnostic est renouvelé ou mis à jour tous les dix ans, sauf lorsqu’un diagnostic réalisé après le 1er juillet 2021 permet d’établir que le bâtiment appartient à la classe A, B ou C au sens de l’article "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, {
      href: "https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006074096&idArticle=LEGIARTI000043966496&dateTexte=&categorieLien=cid",
      target: "_blank"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("L. 173-1-1")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(". ")])]), componentvue_type_template_id_02636e15_ts_true_hoisted_3, componentvue_type_template_id_02636e15_ts_true_hoisted_4, componentvue_type_template_id_02636e15_ts_true_hoisted_5, componentvue_type_template_id_02636e15_ts_true_hoisted_6]),
    _: 1
  });
}
;// ./src/components/organisms/form-energy-balance/elems/energy-balance-description/component.vue?vue&type=template&id=02636e15&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-energy-balance/elems/energy-balance-description/component.vue?vue&type=script&lang=ts



/* harmony default export */ const energy_balance_description_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-energy-balance-description',
  components: {
    DtgLink: link_component,
    DtgSection: section_component
  }
}));
;// ./src/components/organisms/form-energy-balance/elems/energy-balance-description/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-energy-balance/elems/energy-balance-description/component.vue




;
const energy_balance_description_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(energy_balance_description_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_02636e15_ts_true_render]])

/* harmony default export */ const energy_balance_description_component = (energy_balance_description_component_exports_);
;// ./src/components/organisms/form-energy-balance/elems/energy-balance-description/index.ts


;// ./src/components/organisms/form-energy-balance/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const form_energy_balance_style_module = ({"dtg-form-energy-balance__type":"lib_dtg-form-energy-balance__type_Q1Fxp","dtg-form-energy-balance__type-value":"lib_dtg-form-energy-balance__type-value_poW1d","dtg-form-energy-balance__charts":"lib_dtg-form-energy-balance__charts_jN_vf"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-energy-balance/component.vue?vue&type=script&lang=ts




















/* harmony default export */ const form_energy_balance_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(form_energy_balance_style_module),
  components: {
    DtgSelect: select_component,
    DtgInput: input_component,
    DtgInputDate: input_date_component,
    DtgTitle: title_component,
    DtgGrid: grid,
    DtgRowCol: row_col,
    DtgRow: row,
    DtgCol: col,
    DtgField: field_component,
    DtgInputNumber: input_number_component,
    DtgDiagnosticAudit: diagnostic_audit_component,
    DtgDiagnosticDpe: diagnostic_dpe_component,
    DtgInfoBox: info_box_component,
    DtgSection: section_component,
    DtgEnergyBalanceDescription: energy_balance_description_component,
    DtgInputFreeDate: input_free_date_component,
    DtgInputCurrency: input_currency_component
  },
  props: {
    fields: {
      type: Object,
      required: true
    },
    constructionYearRanges: {
      type: Array,
      default: () => []
    },
    auditTypes: {
      type: Array,
      default: () => building_.BUILDING_AUDIT_TYPE_OPTIONS
    }
  },
  setup(props) {
    const {
      gasEmissionValue,
      energyConsumptionValue,
      gasEmissionProps,
      energyConsumptionProps
    } = useDiagnosticFields({
      fields: props.fields
    });
    const type = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.fields.auditType.value);
    const auditStatus = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.fields.wasAuditPerformed.value);
    const wasAuditFinished = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => auditStatus.value === building_.BuildingAuditStatus.performed);
    const wasAuditTypeSelected = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return auditStatus.value === building_.BuildingAuditStatus.performed && Boolean(props.fields.auditType);
    });
    const hasAudit = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const statuses = [building_.BuildingAuditStatus.performed, building_.BuildingAuditStatus.inProgress];
      return (0,array_.arrayIncludes)(statuses, auditStatus.value);
    });
    const auditLabels = {
      [building_.BuildingAuditType.audit]: 'Audit énergétique',
      [building_.BuildingAuditType.dpe]: "DPE à l'immeuble",
      [building_.BuildingAuditType.notConcerned]: 'Aucun diagnostic remis'
    };
    const auditStatusOptions = [{
      id: building_.BuildingAuditStatus.performed,
      value: 'Oui'
    }, {
      id: building_.BuildingAuditStatus.notPerformed,
      value: 'Non'
    }, {
      id: building_.BuildingAuditStatus.inProgress,
      value: 'En cours de réalisation'
    }];
    const isAuditMode = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => type.value === building_.BuildingAuditType.audit);
    const isDpeMode = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => type.value === building_.BuildingAuditType.dpe);
    const diagnosticCase = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return type.value ? auditLabels[type.value] : auditLabels[building_.BuildingAuditType.notConcerned];
    });
    const emissionClassOptions = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return EMISSION_CLASSES.map(({
        label
      }) => ({
        id: label,
        value: label
      }));
    });
    const consumptionClassOptions = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return CONSUMPTION_CLASSES.map(({
        label
      }) => ({
        id: label,
        value: label
      }));
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.fields.wasAuditPerformed.value, async () => {
      await props.fields.wasAuditPerformed.validateAndSetTouched();
    }, {
      immediate: true
    });
    return {
      b: useBem(form_energy_balance_style_module),
      gasEmissionValue,
      energyConsumptionValue,
      gasEmissionProps,
      energyConsumptionProps,
      isAuditMode,
      isDpeMode,
      diagnosticCase,
      emissionClassOptions,
      consumptionClassOptions,
      wasAuditTypeSelected,
      hasAudit,
      wasAuditFinished,
      auditStatusOptions
    };
  }
}));
;// ./src/components/organisms/form-energy-balance/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-energy-balance/component.vue




;
const form_energy_balance_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(form_energy_balance_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_10dc0b8e_ts_true_render]])

/* harmony default export */ const form_energy_balance_component = (form_energy_balance_component_exports_);
;// ./src/components/organisms/form-energy-balance/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-energy-scenario/component.vue?vue&type=template&id=05638316&ts=true

const componentvue_type_template_id_05638316_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("sup", null, "2", -1);
function componentvue_type_template_id_05638316_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_input_currency = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-currency");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_input_number = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-number");
  const _component_dtg_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select");
  const _component_dtg_info_box = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-info-box");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_diagnostic_dpe = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-diagnostic-dpe");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_grid, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, {
      align: "flex-end"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
        "size-xs": "12",
        "size-sm": "4",
        "size-lg": "6"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.label.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.label.props)), null, 16)]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
        "size-xs": "12",
        "size-sm": "4",
        "size-lg": "2"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.energyCostsFrom.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_currency, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.energyCostsFrom.props)), null, 16)]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
        "size-xs": "12",
        "size-sm": "4",
        "size-lg": "2"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.energyCostsTo.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_currency, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.energyCostsTo.props)), null, 16)]),
          _: 1
        }, 16)]),
        _: 1
      })]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
        "size-lg": "4",
        "size-sm": "6",
        "size-xs": "12"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.energyConsumption.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_number, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.energyConsumptionProps, {
            min: 0,
            precision: 2,
            "select-all-on-focus": ""
          }), {
            unit: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" kWhEP/m"), componentvue_type_template_id_05638316_ts_true_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(".an ")]),
            _: 1
          }, 16)]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
        "size-lg": "2",
        "size-sm": "6",
        "size-xs": "12"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.energyConsumptionClass.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.energyConsumptionClass.props, {
            options: _ctx.consumptionClassOptions
          }), null, 16, ["options"])]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
        "size-lg": "4",
        "size-sm": "6",
        "size-xs": "12"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.gasEmission.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_number, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.gasEmissionProps, {
            min: 0,
            precision: 2,
            "select-all-on-focus": ""
          }), {
            unit: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" KgéqCO2/m2.an ")]),
            _: 1
          }, 16)]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
        "size-lg": "2",
        "size-sm": "6",
        "size-xs": "12"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.gasEmissionClass.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.gasEmissionClass.props, {
            options: _ctx.emissionClassOptions
          }), null, 16, ["options"])]),
          _: 1
        }, 16)]),
        _: 1
      })]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_info_box, {
        color: "warning",
        icon: "warning"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Attention ! Vérifier que la note de classement correspond bien à la valeur de performance énergétique du diagnostic réalisé. Vous pouvez sélectionner la classe manuellement. ")]),
        _: 1
      })]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('charts'))
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_diagnostic_dpe, {
            "consumption-class": _ctx.fields.energyConsumptionClass.value,
            "emission-class": _ctx.fields.gasEmissionClass.value,
            consumption: _ctx.energyConsumptionValue,
            emission: _ctx.gasEmissionValue
          }, null, 8, ["consumption-class", "emission-class", "consumption", "emission"])]),
          _: 1
        })]),
        _: 1
      })], 2)]),
      _: 1
    })]),
    _: 1
  });
}
;// ./src/components/organisms/form-energy-scenario/component.vue?vue&type=template&id=05638316&ts=true

;// ./src/components/organisms/form-energy-scenario/composables/use-diagnostic-fields.ts


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function use_diagnostic_fields_useDiagnosticFields({
  fields
}) {
  const gasEmissionProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(fields.gasEmission.withReplacedModelValue((0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
    get: () => fields.gasEmission.value,
    set: onGasEmissionChange
  })));
  const energyConsumptionProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(fields.energyConsumption.withReplacedModelValue((0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
    get: () => fields.energyConsumption.value,
    set: onEnergyConsumptionChange
  })));
  const gasEmissionValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => fields.gasEmission.value ?? 0);
  const energyConsumptionValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => fields.energyConsumption.value ?? 0);
  function getMatchedClassIndex(classes, value) {
    return classes.findIndex(diagnosticsClass => {
      const [min, max] = diagnosticsClass.interval;
      return min <= value && value <= max;
    });
  }
  function onGasEmissionChange(value) {
    let updatedClass = null;
    if (typeof value === 'number') {
      const index = getMatchedClassIndex(EMISSION_CLASSES, value);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      updatedClass = EMISSION_CLASSES[index].label;
    }
    fields.gasEmissionClass.updateValue(updatedClass);
    fields.gasEmission.updateValue(value);
  }
  function onEnergyConsumptionChange(value) {
    let updatedClass = null;
    if (typeof value === 'number') {
      const index = getMatchedClassIndex(CONSUMPTION_CLASSES, value);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      updatedClass = CONSUMPTION_CLASSES[index].label;
    }
    fields.energyConsumptionClass.updateValue(updatedClass);
    fields.energyConsumption.updateValue(value);
  }
  return {
    energyConsumptionProps,
    gasEmissionProps,
    gasEmissionValue,
    energyConsumptionValue
  };
}
;// ./src/components/organisms/form-energy-scenario/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const form_energy_scenario_style_module = ({"dtg-form-energy-scenario__charts":"lib_dtg-form-energy-scenario__charts_d4SLm"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-energy-scenario/component.vue?vue&type=script&lang=ts












/* harmony default export */ const form_energy_scenario_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(form_energy_scenario_style_module),
  components: {
    DtgInput: input_component,
    DtgField: field_component,
    DtgCol: col,
    DtgGrid: grid,
    DtgRow: row,
    DtgRowCol: row_col,
    DtgInfoBox: info_box_component,
    DtgInputCurrency: input_currency_component,
    DtgInputNumber: input_number_component,
    DtgSelect: select_component,
    DtgDiagnosticDpe: diagnostic_dpe_component
  },
  props: {
    fields: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      gasEmissionValue,
      energyConsumptionValue,
      gasEmissionProps,
      energyConsumptionProps
    } = use_diagnostic_fields_useDiagnosticFields({
      fields: props.fields
    });
    const emissionClassOptions = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return EMISSION_CLASSES.map(({
        label
      }) => ({
        id: label,
        value: label
      }));
    });
    const consumptionClassOptions = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return CONSUMPTION_CLASSES.map(({
        label
      }) => ({
        id: label,
        value: label
      }));
    });
    return {
      b: useBem(form_energy_scenario_style_module),
      gasEmissionValue,
      energyConsumptionValue,
      energyConsumptionProps,
      gasEmissionProps,
      emissionClassOptions,
      consumptionClassOptions
    };
  }
}));
;// ./src/components/organisms/form-energy-scenario/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-energy-scenario/component.vue




;
const form_energy_scenario_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(form_energy_scenario_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_05638316_ts_true_render]])

/* harmony default export */ const form_energy_scenario_component = (form_energy_scenario_component_exports_);
;// ./src/components/organisms/form-energy-scenario/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-login/component.vue?vue&type=template&id=5a29d7a0&ts=true

function componentvue_type_template_id_5a29d7a0_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_input_password = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-password");
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_form = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-form");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_form, {
    onSubmit: _cache[0] || (_cache[0] = $event => _ctx.onSubmit())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.email.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.email.props, {
            mode: "email",
            autocomplete: ""
          }), null, 16)]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.password.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_password, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.password.props, {
            autocomplete: ""
          }), null, 16)]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('actions'))
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
            disabled: _ctx.submitting,
            loading: _ctx.submitting,
            view: "inverted",
            icon: "arrowRight",
            type: "submit"
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Connexion ")]),
            _: 1
          }, 8, ["disabled", "loading"])]),
          _: 1
        }, 8, ["class"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  });
}
;// ./src/components/organisms/form-login/component.vue?vue&type=template&id=5a29d7a0&ts=true

;// ./src/components/organisms/form-login/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const form_login_style_module = ({"dtg-form-login__actions":"lib_dtg-form-login__actions_gR0BI"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-login/component.vue?vue&type=script&lang=ts














/* harmony default export */ const form_login_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(form_login_style_module),
  components: {
    DtgButton: button_component,
    DtgCol: col,
    DtgField: field_component,
    DtgForm: form_component,
    DtgGrid: grid,
    DtgInput: input_component,
    DtgInputPassword: input_password_component,
    DtgRow: row,
    DtgRowCol: row_col
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    fieldErrors: {
      type: Object,
      default: () => ({})
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'submit'],
  setup(props, {
    emit
  }) {
    const {
      fieldErrors
    } = (0,refs_.toReadonlyRefs)(props);
    const data = propInternal(props, 'modelValue', emit);
    const schema = (0,validation_.defineSchema)({
      email: (0,validation_.email)().label('Votre email').required(),
      password: (0,external_yup_.string)().label('Votre mot de passe').required()
    });
    const {
      fields,
      validate
    } = (0,use_form_.useFormFields)({
      data,
      schema,
      fieldErrors
    });
    function onSubmit() {
      emit('submit', validate);
    }
    return {
      b: useBem(form_login_style_module),
      fields,
      onSubmit
    };
  }
}));
;// ./src/components/organisms/form-login/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-login/component.vue




;
const form_login_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(form_login_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_5a29d7a0_ts_true_render]])

/* harmony default export */ const form_login_component = (form_login_component_exports_);
;// ./src/components/organisms/form-login/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-password-choose/component.vue?vue&type=template&id=6191c906&ts=true

function componentvue_type_template_id_6191c906_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_input_password = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-password");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_password_requirements = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-password-requirements");
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_form = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-form");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_form, {
    onSubmit: _cache[0] || (_cache[0] = $event => _ctx.onSubmit())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
        }, " Veuillez choisir et indiquer un nouveau mot de passe ", 2)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.password.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_password, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.password.props, {
            autocomplete: ""
          }), null, 16)]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_password_requirements, {
          value: _ctx.fields.password.value
        }, null, 8, ["value"])]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('actions'))
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
            disabled: _ctx.submitting,
            loading: _ctx.submitting,
            view: "inverted",
            icon: "arrowRight",
            type: "submit"
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Réinitialiser le mot de passe ")]),
            _: 1
          }, 8, ["disabled", "loading"])]),
          _: 1
        }, 8, ["class"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  });
}
;// ./src/components/organisms/form-password-choose/component.vue?vue&type=template&id=6191c906&ts=true

;// ./src/components/organisms/form-password-choose/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const form_password_choose_style_module = ({"dtg-form-password-choose__text":"lib_dtg-form-password-choose__text_rDJZ8","dtg-form-password-choose__actions":"lib_dtg-form-password-choose__actions_sJzye"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-password-choose/component.vue?vue&type=script&lang=ts













/* harmony default export */ const form_password_choose_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(form_password_choose_style_module),
  components: {
    DtgButton: button_component,
    DtgCol: col,
    DtgField: field_component,
    DtgForm: form_component,
    DtgGrid: grid,
    DtgInputPassword: input_password_component,
    DtgPasswordRequirements: password_requirements_component,
    DtgRow: row,
    DtgRowCol: row_col
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    fieldErrors: {
      type: Object,
      default: () => ({})
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'submit'],
  setup(props, {
    emit
  }) {
    const {
      fieldErrors
    } = (0,refs_.toReadonlyRefs)(props);
    const data = propInternal(props, 'modelValue', emit);
    const schema = (0,validation_.defineSchema)({
      password: (0,validation_.password)().label('Nouveau mot de passe').required()
    });
    const {
      fields,
      validate
    } = (0,use_form_.useFormFields)({
      data,
      schema,
      fieldErrors
    });
    function onSubmit() {
      emit('submit', validate);
    }
    return {
      b: useBem(form_password_choose_style_module),
      fields,
      onSubmit
    };
  }
}));
;// ./src/components/organisms/form-password-choose/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-password-choose/component.vue




;
const form_password_choose_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(form_password_choose_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_6191c906_ts_true_render]])

/* harmony default export */ const form_password_choose_component = (form_password_choose_component_exports_);
;// ./src/components/organisms/form-password-choose/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-password-reset/component.vue?vue&type=template&id=3fe431c6&ts=true

function componentvue_type_template_id_3fe431c6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_form = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-form");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_form, {
    onSubmit: _cache[0] || (_cache[0] = $event => _ctx.onSubmit())
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
        }, " Demander la réinitialisation de votre mot de passe en completant le formulaire ci-dessous. ", 2)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
        }, " Une fois votre demande validée, vous allez recevoir par email les instructions à suivre pour choisir un nouveau mot de passe. ", 2)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.email.fieldProps)), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.email.props, {
            mode: "email",
            autocomplete: ""
          }), null, 16)]),
          _: 1
        }, 16)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('actions'))
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
            disabled: _ctx.submitting,
            loading: _ctx.submitting,
            view: "inverted",
            icon: "arrowRight",
            type: "submit"
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Envoyer les instructions ")]),
            _: 1
          }, 8, ["disabled", "loading"])]),
          _: 1
        }, 8, ["class"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  });
}
;// ./src/components/organisms/form-password-reset/component.vue?vue&type=template&id=3fe431c6&ts=true

;// ./src/components/organisms/form-password-reset/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const form_password_reset_style_module = ({"dtg-form-password-reset__text":"lib_dtg-form-password-reset__text_LG1NU","dtg-form-password-reset__actions":"lib_dtg-form-password-reset__actions_hZd6N"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-password-reset/component.vue?vue&type=script&lang=ts












/* harmony default export */ const form_password_reset_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(form_password_reset_style_module),
  components: {
    DtgButton: button_component,
    DtgCol: col,
    DtgField: field_component,
    DtgForm: form_component,
    DtgGrid: grid,
    DtgInput: input_component,
    DtgRow: row,
    DtgRowCol: row_col
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    fieldErrors: {
      type: Object,
      default: () => ({})
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'submit'],
  setup(props, {
    emit
  }) {
    const {
      fieldErrors
    } = (0,refs_.toReadonlyRefs)(props);
    const data = propInternal(props, 'modelValue', emit);
    const schema = (0,validation_.defineSchema)({
      email: (0,validation_.email)().label('').required()
    });
    const {
      fields,
      validate
    } = (0,use_form_.useFormFields)({
      data,
      schema,
      fieldErrors
    });
    function onSubmit() {
      emit('submit', validate);
    }
    return {
      b: useBem(form_password_reset_style_module),
      fields,
      onSubmit
    };
  }
}));
;// ./src/components/organisms/form-password-reset/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-password-reset/component.vue




;
const form_password_reset_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(form_password_reset_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_3fe431c6_ts_true_render]])

/* harmony default export */ const form_password_reset_component = (form_password_reset_component_exports_);
;// ./src/components/organisms/form-password-reset/index.ts



;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-buildings/component.vue?vue&type=template&id=5be484c2&ts=true

function componentvue_type_template_id_5be484c2_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button_add = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button-add");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_building_selector = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-building-selector");
  const _component_dtg_button_element = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button-element");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_form_building = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-form-building");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_section = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-section");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_section, {
    "no-divider": ""
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.buildings.length === 0 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row_col, {
        key: 0
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button_add, {
          disabled: _ctx.disabled,
          onClick: _cache[0] || (_cache[0] = $event => _ctx.onCreateBuildingClick())
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Ajouter un composant ")]),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row, {
        key: 1
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('aside', {
            horizontal: _ctx.tillLg
          })),
          style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
            top: `${_ctx.selectorTopOffset}px`
          }),
          size: _ctx.tillLg ? '12' : 'auto'
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_building_selector, {
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('selector')),
            modelValue: _ctx.selectedBuildingIdInternal,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.selectedBuildingIdInternal = $event),
            buildings: _ctx.buildings,
            view: _ctx.tillLg ? 'horizontal' : 'vertical'
          }, null, 8, ["class", "modelValue", "buildings", "view"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button_element, {
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('create-building-button')),
            disabled: _ctx.disabled,
            align: "center",
            icon: "addBuilding",
            size: _ctx.tillLg ? 's' : 'm',
            onClick: _cache[2] || (_cache[2] = $event => _ctx.onCreateBuildingClick())
          }, null, 8, ["class", "disabled", "size"])]),
          _: 1
        }, 8, ["class", "style", "size"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.fields ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_form_building, {
            key: 0,
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('form', {
              padded: !_ctx.tillLg
            })),
            fields: _ctx.fields,
            disabled: _ctx.disabled,
            "delete-disabled": _ctx.deleteDisabled,
            "heating-modes": _ctx.heatingModes,
            "construction-dates": _ctx.constructionDates,
            "building-types": _ctx.buildingTypes,
            "fire-safety-types": _ctx.fireSafetyTypes,
            "roof-types": _ctx.roofTypes,
            onDelete: _cache[3] || (_cache[3] = $event => _ctx.onBuildingDelete())
          }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
            _: 2
          }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.$slots, (_, name) => {
            return {
              name: name,
              fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, name)])
            };
          })]), 1032, ["class", "fields", "disabled", "delete-disabled", "heating-modes", "construction-dates", "building-types", "fire-safety-types", "roof-types"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
          _: 3
        })]),
        _: 3
      }))]),
      _: 3
    })]),
    _: 3
  });
}
;// ./src/components/organisms/form-buildings/component.vue?vue&type=template&id=5be484c2&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building/component.vue?vue&type=template&id=73988e19&ts=true

function componentvue_type_template_id_73988e19_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_fieldset_header = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-fieldset-header");
  const _component_dtg_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_fieldset = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-fieldset");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_fieldset, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_fieldset_header, null, {
      actions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        disabled: _ctx.disabled || _ctx.deleteDisabled,
        icon: "trash",
        notice: "",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onDeleteClick())
      }, null, 8, ["disabled"])]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.typeColProps, {
          "size-xs": "12"
        }), {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.type.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.type.props, {
              options: _ctx.buildingTypes,
              placeholder: "Choisir",
              "no-deselect": "",
              "non-nullable": ""
            }), null, 16, ["options"])]),
            _: 1
          }, 16)]),
          _: 1
        }, 16), _ctx.fireSafetyFieldEnabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
          key: 0,
          "size-lg": "2.75",
          "size-sm": "3",
          "size-xs": "12"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.fireSafetyType.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.fireSafetyType.props, {
              options: _ctx.fireSafetyTypes,
              placeholder: "Choisir"
            }), null, 16, ["options"])]),
            _: 1
          }, 16)]),
          _: 1
        })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-lg": "6.5",
          "size-sm": "6",
          "size-xs": "12"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.name.fieldProps, {
            "sub-label": `${_ctx.max.name?.characters} caractères`
          }), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.name.props, {
              placeholder: "Saisir",
              "max-length": _ctx.max.name?.characters
            }), null, 16, ["max-length"])]),
            _: 1
          }, 16, ["sub-label"])]),
          _: 1
        })]),
        _: 1
      }), ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDynamicComponent)(_ctx.dtgBuildingTypeForm), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)({
        fields: _ctx.fields,
        heatingModes: _ctx.heatingModes,
        roofTypes: _ctx.roofTypes,
        constructionDates: _ctx.constructionDates
      })), {
        "after-fields": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "building-plan-form")]),
        _: 3
      }, 16))]),
      _: 3
    })]),
    _: 3
  });
}
;// ./src/components/organisms/form-building/component.vue?vue&type=template&id=73988e19&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building/elems/basement/component.vue?vue&type=template&id=a6f4b7a6&ts=true

function componentvue_type_template_id_a6f4b7a6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_select_yes_no = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select-yes-no");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "2.5",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasLocalTrash.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasLocalTrash.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasGarage.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasGarage.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3.25",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasCellar.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasCellar.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3.25",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasLocalServices.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasLocalServices.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    })]),
    _: 1
  }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "2.5",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasTransformationStation.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasTransformationStation.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasBasementElevator.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasBasementElevator.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3.25",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.undergroundLevel.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.undergroundLevel.props, {
          placeholder: "Saisir"
        }), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3.25",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasBasementParking.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasBasementParking.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    })]),
    _: 1
  }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "after-fields")]),
    _: 3
  })], 64);
}
;// ./src/components/organisms/form-building/elems/basement/component.vue?vue&type=template&id=a6f4b7a6&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building/elems/basement/component.vue?vue&type=script&lang=ts





/* harmony default export */ const basement_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-exterior-building',
  components: {
    DtgField: field_component,
    DtgRow: row,
    DtgCol: col,
    DtgRowCol: row_col,
    DtgSelectYesNo: select_yes_no_component,
    DtgInput: input_component
  },
  props: {
    fields: {
      type: Object,
      required: true
    }
  }
}));
;// ./src/components/organisms/form-building/elems/basement/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-building/elems/basement/component.vue




;
const basement_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(basement_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_a6f4b7a6_ts_true_render]])

/* harmony default export */ const basement_component = (basement_component_exports_);
;// ./src/components/organisms/form-building/elems/basement/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building/elems/exterior/component.vue?vue&type=template&id=30f3fe06&ts=true

function componentvue_type_template_id_30f3fe06_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_select_yes_no = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select-yes-no");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "2.5",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasCirculation.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasCirculation.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasExteriorParking.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasExteriorParking.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3.25",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasOutbuilding.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasOutbuilding.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3.25",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasGate.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasGate.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    })]),
    _: 1
  }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "2.5",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasGarden.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasGarden.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasPool.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasPool.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    })]),
    _: 1
  }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "after-fields")]),
    _: 3
  })], 64);
}
;// ./src/components/organisms/form-building/elems/exterior/component.vue?vue&type=template&id=30f3fe06&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building/elems/exterior/component.vue?vue&type=script&lang=ts




/* harmony default export */ const exterior_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-exterior-building',
  components: {
    DtgField: field_component,
    DtgRow: row,
    DtgCol: col,
    DtgRowCol: row_col,
    DtgSelectYesNo: select_yes_no_component
  },
  props: {
    fields: {
      type: Object,
      required: true
    }
  }
}));
;// ./src/components/organisms/form-building/elems/exterior/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-building/elems/exterior/component.vue




;
const exterior_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(exterior_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_30f3fe06_ts_true_render]])

/* harmony default export */ const exterior_component = (exterior_component_exports_);
;// ./src/components/organisms/form-building/elems/exterior/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building/elems/interior/component.vue?vue&type=template&id=42dbfd99&ts=true

function componentvue_type_template_id_42dbfd99_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_input_free_date = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-free-date");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_input_number = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input-number");
  const _component_dtg_select_yes_no = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-select-yes-no");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_divider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-divider");
  const _component_dtg_exterior_building = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-exterior-building");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_fieldset_spoiler = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-fieldset-spoiler");
  const _component_dtg_basement_building = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-basement-building");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-xl": "2.75",
      "size-lg": "5.5",
      "size-sm": "6",
      "size-xs": "12"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.heatingMode.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.heatingMode.props, {
          options: _ctx.heatingModes,
          placeholder: "Choisir",
          "track-by-value": "",
          "non-nullable": ""
        }), null, 16, ["options"])]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-xl": "2.75",
      "size-lg": "6.5",
      "size-sm": "6",
      "size-xs": "12"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.level.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.level.props, {
          options: _ctx.levelOptions,
          "track-by-value": "",
          "non-nullable": "",
          placeholder: "Choisir"
        }), null, 16, ["options"])]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-xl": "3.5",
      "size-lg": "5.5",
      "size-sm": "6",
      "size-xs": "12"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.dateConstruction.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_free_date, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.dateConstruction.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-xl": "3",
      "size-lg": "6.5",
      "size-sm": "6",
      "size-xs": "12"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.yearConstruction.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.yearConstruction.props, {
          options: _ctx.constructionDates,
          placeholder: "Choisir"
        }), null, 16, ["options"])]),
        _: 1
      }, 16)]),
      _: 1
    })]),
    _: 1
  }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "5.5",
      "size-sm": "6",
      "size-xs": "12"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.entriesNumber.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input_number, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.entriesNumber.props, {
          min: 0,
          placeholder: "Saisir"
        }), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3.25",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasInteriorElevator.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasInteriorElevator.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "3.25",
      "size-sm": "3",
      "size-xs": "6"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasAttic.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select_yes_no, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.hasAttic.props)), null, 16)]),
        _: 1
      }, 16)]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      "size-lg": "5.5",
      "size-sm": "6",
      "size-xs": "12"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.roofType.fieldProps)), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_select, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.roofType.props, {
          options: _ctx.roofTypes,
          placeholder: "Choisir"
        }), null, 16, ["options"])]),
        _: 1
      }, 16)]),
      _: 1
    })]),
    _: 1
  }), _ctx.$slots['after-fields'] ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 0
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "after-fields")]),
    _: 3
  }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_divider, {
      view: "short"
    })]),
    _: 1
  })], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('spoilers'))
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "12"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_fieldset_spoiler, {
        opened: !_ctx.isExteriorInitial,
        description: "Traiter les extérieurs dans le Composant",
        title: "Informations Extérieur"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_exterior_building, {
            fields: _ctx.fields
          }, null, 8, ["fields"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["opened"])]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "12"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_fieldset_spoiler, {
        opened: !_ctx.isBasementInitial,
        description: "Traiter le sous-sol dans le Composant",
        title: "Informations Sous-sol"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_basement_building, {
            fields: _ctx.fields
          }, null, 8, ["fields"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["opened"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["class"])], 64);
}
;// ./src/components/organisms/form-building/elems/interior/component.vue?vue&type=template&id=42dbfd99&ts=true

;// ./src/components/organisms/form-building/elems/interior/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const interior_style_module = ({"dtg-interior-building__spoilers":"lib_dtg-interior-building__spoilers_bbbBv"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building/elems/interior/component.vue?vue&type=script&lang=ts














/* harmony default export */ const interior_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(interior_style_module),
  components: {
    DtgRowCol: row_col,
    DtgGrid: grid,
    DtgField: field_component,
    DtgRow: row,
    DtgCol: col,
    DtgSelectYesNo: select_yes_no_component,
    DtgSelect: select_component,
    DtgInputNumber: input_number_component,
    DtgInputFreeDate: input_free_date_component,
    DtgFieldsetSpoiler: fieldset_spoiler_component,
    DtgExteriorBuilding: exterior_component,
    DtgBasementBuilding: basement_component,
    DtgDivider: divider_component
  },
  props: {
    heatingModes: {
      type: Array,
      required: true
    },
    constructionDates: {
      type: Array,
      required: true
    },
    roofTypes: {
      type: Array,
      required: true
    },
    levelOptions: {
      type: Array,
      default: () => building_.LEVEL_OPTIONS
    },
    fields: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const initialData = (0,building_.buildBuildingFormData)();
    const isExteriorInitial = building_.exteriorBuildingFormDataKeys.every(isInitial);
    const isBasementInitial = building_.basementBuildingFormDataKeys.every(isInitial);
    function isInitial(key) {
      return props.fields[key].value === initialData[key];
    }
    return {
      b: useBem(interior_style_module),
      isExteriorInitial,
      isBasementInitial
    };
  }
}));
;// ./src/components/organisms/form-building/elems/interior/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-building/elems/interior/component.vue




;
const interior_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(interior_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_42dbfd99_ts_true_render]])

/* harmony default export */ const interior_component = (interior_component_exports_);
;// ./src/components/organisms/form-building/elems/interior/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building/component.vue?vue&type=script&lang=ts















/* harmony default export */ const form_building_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-form-building',
  components: {
    DtgFieldset: fieldset_component,
    DtgFieldsetHeader: fieldset_header_component,
    DtgField: field_component,
    DtgGrid: grid,
    DtgRow: row,
    DtgCol: col,
    DtgSelect: select_component,
    DtgSelectYesNo: select_yes_no_component,
    DtgInput: input_component,
    DtgButton: button_component,
    DtgInputNumber: input_number_component,
    DtgInputFreeDate: input_free_date_component
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    deleteDisabled: {
      type: Boolean,
      default: false
    },
    heatingModes: {
      type: Array,
      required: true
    },
    constructionDates: {
      type: Array,
      required: true
    },
    buildingTypes: {
      type: Array,
      default: () => building_.BUILDING_TYPE_OPTIONS
    },
    fireSafetyTypes: {
      type: Array,
      required: true
    },
    roofTypes: {
      type: Array,
      required: true
    },
    fields: {
      type: Object,
      required: true
    }
  },
  emits: ['delete'],
  setup(props, {
    emit
  }) {
    const max = {
      name: {
        characters: 25
      }
    };
    const fireSafetyFieldEnabled = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return props.fields.type.value === building_.BuildingType.interior;
    });
    const typeColProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return {
        sizeLg: fireSafetyFieldEnabled.value ? '2.75' : '5.5',
        sizeSm: fireSafetyFieldEnabled.value ? '3' : '6'
      };
    });
    const dtgBuildingTypeForm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      switch (props.fields.type.value) {
        case building_.BuildingType.exterior:
          return exterior_component;
        case building_.BuildingType.interior:
          return interior_component;
        case building_.BuildingType.basement:
          return basement_component;
        default:
          return null;
      }
    });
    function onDeleteClick() {
      emit('delete');
    }
    return {
      max,
      fireSafetyFieldEnabled,
      typeColProps,
      dtgBuildingTypeForm,
      onDeleteClick
    };
  }
}));
;// ./src/components/organisms/form-building/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-building/component.vue




;
const form_building_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(form_building_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_73988e19_ts_true_render]])

/* harmony default export */ const form_building_component = (form_building_component_exports_);
;// ./src/components/organisms/form-building/index.ts


;// ./src/components/organisms/form-buildings/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const form_buildings_style_module = ({"dtg-form-buildings__aside":"lib_dtg-form-buildings__aside_IfabL","dtg-form-buildings__aside_horizontal":"lib_dtg-form-buildings__aside_horizontal_PmaM3","dtg-form-buildings__create-building-button":"lib_dtg-form-buildings__create-building-button_Byad5","dtg-form-buildings__form_padded":"lib_dtg-form-buildings__form_padded_bCHOG"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-buildings/component.vue?vue&type=script&lang=ts












/* harmony default export */ const form_buildings_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(form_buildings_style_module),
  components: {
    DtgSection: section_component,
    DtgGrid: grid,
    DtgRow: row,
    DtgCol: col,
    DtgBuildingSelector: building_selector_component,
    DtgButtonElement: button_element_component,
    DtgFormBuilding: form_building_component,
    DtgRowCol: row_col,
    DtgButtonAdd: button_add_component
  },
  props: {
    fields: {
      type: Object,
      required: true
    },
    selectedBuildingId: {
      type: String,
      default: null
    },
    buildings: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    deleteDisabled: {
      type: Boolean,
      default: false
    },
    heatingModes: {
      type: Array,
      required: true
    },
    constructionDates: {
      type: Array,
      required: true
    },
    buildingTypes: {
      type: Array,
      default: () => building_.BUILDING_TYPE_OPTIONS
    },
    fireSafetyTypes: {
      type: Array,
      required: true
    },
    roofTypes: {
      type: Array,
      required: true
    },
    selectorTopOffset: {
      type: Number,
      default: 0
    }
  },
  emits: ['create', 'delete', 'update:selectedBuildingId'],
  setup(props, {
    emit
  }) {
    const bp = useBp();
    const selectedBuildingIdInternal = propInternal(props, 'selectedBuildingId', emit);
    const tillLg = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => bp.till(bp.lg));
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.buildings, buildings => {
        if (!selectedBuildingIdInternal.value && buildings[0]) {
          selectedBuildingIdInternal.value = buildings[0].id;
          return;
        }
        const chosenBuilding = buildings.find(building => building.id === selectedBuildingIdInternal.value);
        if (!chosenBuilding && buildings[0]) {
          selectedBuildingIdInternal.value = buildings[0].id;
        }
      }, {
        immediate: true
      });
    });
    function onCreateBuildingClick() {
      emit('create');
    }
    function onBuildingDelete() {
      emit('delete', props.selectedBuildingId);
    }
    return {
      b: useBem(form_buildings_style_module),
      selectedBuildingIdInternal,
      tillLg,
      onCreateBuildingClick,
      onBuildingDelete
    };
  }
}));
;// ./src/components/organisms/form-buildings/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-buildings/component.vue




;
const form_buildings_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(form_buildings_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_5be484c2_ts_true_render]])

/* harmony default export */ const form_buildings_component = (form_buildings_component_exports_);
;// ./src/components/organisms/form-buildings/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building-plans/component.vue?vue&type=template&id=294096aa&ts=true

function componentvue_type_template_id_294096aa_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button_add = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button-add");
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_building_selector = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-building-selector");
  const _component_dtg_button_element = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button-element");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_form_building_plan = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-form-building-plan");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_section = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-section");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_section, {
    "no-divider": ""
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.buildingPlans.length === 0 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row_col, {
        key: 0
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button_add, {
          disabled: _ctx.disabled,
          onClick: _cache[0] || (_cache[0] = $event => _ctx.onCreateBuildingPlanClick())
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Ajouter plan du composant ")]),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_row, {
        key: 1
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('aside')),
          size: "auto"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_building_selector, {
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('selector')),
            modelValue: _ctx.selectedBuildingPlanIdInternal,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.selectedBuildingPlanIdInternal = $event),
            buildings: _ctx.buildingPlans,
            size: "s",
            view: "vertical"
          }, null, 8, ["class", "modelValue", "buildings"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button_element, {
            class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('create-building-plan-button')),
            disabled: _ctx.disabled,
            icon: "add",
            size: "s",
            onClick: _cache[2] || (_cache[2] = $event => _ctx.onCreateBuildingPlanClick())
          }, null, 8, ["class", "disabled"])]),
          _: 1
        }, 8, ["class"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.fields ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_form_building_plan, {
            key: 0,
            fields: _ctx.fields,
            disabled: _ctx.disabled,
            "delete-disabled": _ctx.deleteDisabled,
            onDelete: _cache[3] || (_cache[3] = $event => _ctx.onBuildingPlanDelete())
          }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
            _: 2
          }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.$slots, (_, name) => {
            return {
              name: name,
              fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, name)])
            };
          })]), 1032, ["fields", "disabled", "delete-disabled"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
          _: 3
        })]),
        _: 3
      }))]),
      _: 3
    })]),
    _: 3
  });
}
;// ./src/components/organisms/form-building-plans/component.vue?vue&type=template&id=294096aa&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building-plan/component.vue?vue&type=template&id=6c7b75ca&ts=true

function componentvue_type_template_id_6c7b75ca_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_fieldset_header = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-fieldset-header");
  const _component_dtg_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-input");
  const _component_dtg_field = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-field");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_radio_group = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-radio-group");
  const _component_dtg_toggle = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-toggle");
  const _component_dtg_fieldset_spoiler = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-fieldset-spoiler");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_fieldset = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-fieldset");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_fieldset, null, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_fieldset_header, null, {
      actions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        disabled: _ctx.disabled || _ctx.deleteDisabled,
        icon: "trash",
        notice: "",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onDeleteClick())
      }, null, 8, ["disabled"])]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-md": "6",
          size: "12"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.name.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_input, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.name.props, {
              placeholder: "Saisir"
            }), null, 16)]),
            _: 1
          }, 16)]),
          _: 1
        }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          "size-md": "6",
          size: "12"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.file.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "planFile")]),
            _: 3
          }, 16)]),
          _: 3
        })]),
        _: 3
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_field, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.fields.orientation.fieldProps)), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_radio_group, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.fields.orientation.props, {
              disabled: _ctx.orientationRadioDisabled,
              options: _ctx.orientationOptions
            }), null, 16, ["disabled", "options"])]),
            _: 1
          }, 16)]),
          _: 1
        }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_toggle, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
            class: _ctx.b('toggle')
          }, _ctx.fields.visibleInReport.props), {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Faire apparaitre dans le rapport ")]),
            _: 1
          }, 16, ["class"])]),
          _: 1
        })]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
          size: "12"
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_fieldset_spoiler, {
            opened: _ctx.isSpoilerOpened,
            "onUpdate:opened": _cache[1] || (_cache[1] = $event => _ctx.isSpoilerOpened = $event),
            description: _ctx.spoilerDescription,
            reversed: ""
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "preview")]),
            _: 3
          }, 8, ["opened", "description"])]),
          _: 3
        })]),
        _: 3
      })]),
      _: 3
    })]),
    _: 3
  });
}
;// ./src/components/organisms/form-building-plan/component.vue?vue&type=template&id=6c7b75ca&ts=true

// EXTERNAL MODULE: external "dtg-shared-report"
var external_dtg_shared_report_ = __webpack_require__(8502);
;// ./src/components/organisms/form-building-plan/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const form_building_plan_style_module = ({"dtg-form-building-plan__toggle":"lib_dtg-form-building-plan__toggle_Fv71M"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building-plan/component.vue?vue&type=script&lang=ts













/* harmony default export */ const form_building_plan_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(form_building_plan_style_module),
  components: {
    DtgFieldset: fieldset_component,
    DtgFieldsetHeader: fieldset_header_component,
    DtgField: field_component,
    DtgGrid: grid,
    DtgRow: row,
    DtgCol: col,
    DtgInput: input_component,
    DtgButton: button_component,
    DtgFieldsetSpoiler: fieldset_spoiler_component,
    DtgToggle: toggle_component,
    DtgRadioGroup: radio_group_component
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    deleteDisabled: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Object,
      required: true
    }
  },
  emits: ['delete'],
  setup(props, {
    emit
  }) {
    const isSpoilerOpened = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const spoilerDescription = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return isSpoilerOpened.value ? 'Réduire pour masquer le plan' : 'Développer pour afficher le plan';
    });
    const orientationRadioDisabled = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      return props.fields.orientation.props.disabled || !props.fields.visibleInReport.value;
    });
    function onDeleteClick() {
      emit('delete');
    }
    return {
      b: useBem(form_building_plan_style_module),
      orientationOptions: [{
        id: external_dtg_shared_report_.PdfOrientation.portrait,
        value: 'Portrait'
      }, {
        id: external_dtg_shared_report_.PdfOrientation.landscape,
        value: 'Paysage'
      }],
      isSpoilerOpened,
      spoilerDescription,
      orientationRadioDisabled,
      onDeleteClick
    };
  }
}));
;// ./src/components/organisms/form-building-plan/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-building-plan/component.vue




;
const form_building_plan_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(form_building_plan_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_6c7b75ca_ts_true_render]])

/* harmony default export */ const form_building_plan_component = (form_building_plan_component_exports_);
;// ./src/components/organisms/form-building-plan/index.ts


;// ./src/components/organisms/form-building-plans/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const form_building_plans_style_module = ({"dtg-form-building-plans__aside":"lib_dtg-form-building-plans__aside_NL7h9","dtg-form-building-plans__aside_horizontal":"lib_dtg-form-building-plans__aside_horizontal_zMfqW","dtg-form-building-plans__create-building-plan-button":"lib_dtg-form-building-plans__create-building-plan-button_MWT6p"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/form-building-plans/component.vue?vue&type=script&lang=ts










/* harmony default export */ const form_building_plans_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(form_building_plans_style_module),
  components: {
    DtgSection: section_component,
    DtgGrid: grid,
    DtgRow: row,
    DtgCol: col,
    DtgBuildingSelector: building_selector_component,
    DtgButtonElement: button_element_component,
    DtgFormBuildingPlan: form_building_plan_component,
    DtgRowCol: row_col,
    DtgButtonAdd: button_add_component
  },
  props: {
    fields: {
      type: Object,
      required: true
    },
    selectedBuildingPlanId: {
      type: String,
      default: null
    },
    buildingPlans: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    deleteDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['create', 'delete', 'update:selectedBuildingPlanId'],
  setup(props, {
    emit
  }) {
    const selectedBuildingPlanIdInternal = propInternal(props, 'selectedBuildingPlanId', emit);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.buildingPlans, buildingPlans => {
        if (!selectedBuildingPlanIdInternal.value && buildingPlans[0]) {
          selectedBuildingPlanIdInternal.value = buildingPlans[0].id;
          return;
        }
        const chosenBuildingPlan = buildingPlans.find(buildingPlan => buildingPlan.id === selectedBuildingPlanIdInternal.value);
        if (!chosenBuildingPlan && buildingPlans[0]) {
          selectedBuildingPlanIdInternal.value = buildingPlans[0].id;
        }
      }, {
        immediate: true
      });
    });
    function onCreateBuildingPlanClick() {
      emit('create');
    }
    function onBuildingPlanDelete() {
      emit('delete', props.selectedBuildingPlanId);
    }
    return {
      b: useBem(form_building_plans_style_module),
      selectedBuildingPlanIdInternal,
      onCreateBuildingPlanClick,
      onBuildingPlanDelete
    };
  }
}));
;// ./src/components/organisms/form-building-plans/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/form-building-plans/component.vue




;
const form_building_plans_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(form_building_plans_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_294096aa_ts_true_render]])

/* harmony default export */ const form_building_plans_component = (form_building_plans_component_exports_);
;// ./src/components/organisms/form-building-plans/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/modal-message/component.vue?vue&type=template&id=1957e1ae&ts=true

function componentvue_type_template_id_1957e1ae_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_modal_content = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-modal-content");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_modal_content, null, {
    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1)]),
    actions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "auto"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        view: "inverted",
        size: "s",
        icon: "checkmarkCircle",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onConfirm())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.confirmText), 1)]),
        _: 1
      })]),
      _: 1
    })]),
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content'))
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.message), 3)]),
    _: 1
  });
}
;// ./src/components/organisms/modal-message/component.vue?vue&type=template&id=1957e1ae&ts=true

;// ./src/components/organisms/modal-message/props.ts
const modal_message_props_props = {
  title: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    default: ''
  },
  confirmText: {
    type: String,
    default: 'Ok'
  }
};
;// ./src/components/organisms/modal-message/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_message_style_module = ({"dtg-modal-message__content":"lib_dtg-modal-message__content_uCRa4","dtg-modal-message__actions":"lib_dtg-modal-message__actions_q1hLx","dtg-modal-message__container":"lib_dtg-modal-message__container_hr8LD"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/modal-message/component.vue?vue&type=script&lang=ts








/* harmony default export */ const modal_message_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(modal_message_style_module),
  components: {
    DtgModalContent: modal_content_component,
    DtgCol: col,
    DtgButton: button_component
  },
  props: modal_message_props_props,
  emits: events(['confirm', 'close'])(),
  setup(props, {
    emit
  }) {
    function onConfirm() {
      emit('confirm');
      emit('close');
    }
    return {
      b: useBem(modal_message_style_module),
      onConfirm
    };
  }
}));
;// ./src/components/organisms/modal-message/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/modal-message/component.vue




;
const modal_message_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(modal_message_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_1957e1ae_ts_true_render]])

/* harmony default export */ const modal_message_component = (modal_message_component_exports_);
;// ./src/components/organisms/modal-message/composables/use-modal-message.ts




// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useModalMessage() {
  const b = useBem(modal_message_style_module);
  return useOverlay({
    component: modal_message_component,
    cssClass: b('container')
  });
}
;// ./src/components/organisms/modal-message/index.ts




;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/modal-report/component.vue?vue&type=template&id=6a90c4e3&ts=true

const componentvue_type_template_id_6a90c4e3_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La génération peut prendre jusqu'à 2 minutes d'attente. ", -1);
function componentvue_type_template_id_6a90c4e3_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_row_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row-col");
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  const _component_dtg_info_box = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-info-box");
  const _component_dtg_progress = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-progress");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-row");
  const _component_dtg_grid = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-grid");
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_modal_content = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-modal-content");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_modal_content, {
    "no-close": _ctx.noClose,
    onWillClose: _cache[3] || (_cache[3] = $event => _ctx.onCancel())
  }, {
    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.content.title), 1)]),
    actions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [!_ctx.noClose ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_col, {
      key: 0,
      size: "4"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        "icon-left": "",
        icon: "arrowLeft",
        fullwidth: "",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onCancel())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Annuler ")]),
        _: 1
      })]),
      _: 1
    })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.hasError ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_button, {
        key: 0,
        icon: "reload",
        view: "inverted",
        fullwidth: "",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.onRetryClick())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Retry ")]),
        _: 1
      })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_button, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
        key: 1
      }, _ctx.downloadLinkProps, {
        title: `Télécharger DTG ${_ctx.dtgName}`,
        disabled: _ctx.downloadDisabled,
        icon: "download",
        view: "inverted",
        fullwidth: "",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.onDownloadClick($event))
      }), {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Télécharger ")]),
        _: 1
      }, 16, ["title", "disabled"]))]),
      _: 1
    })]),
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_grid, null, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [componentvue_type_template_id_6a90c4e3_ts_true_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.content.text), 1)]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row_col, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
          view: "4",
          "no-margin": ""
        }, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.dtgName), 1)]),
          _: 1
        })]),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_row, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, null, {
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.hasError ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_info_box, {
            key: 0,
            icon: "warning",
            view: "filled",
            size: "s",
            color: "notice"
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.errorMessage), 1)]),
            _: 1
          })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_progress, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)({
            key: 1,
            class: _ctx.b('progress')
          }, _ctx.progressProps, {
            size: "l"
          }), null, 16, ["class"]))]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["no-close"]);
}
;// ./src/components/organisms/modal-report/component.vue?vue&type=template&id=6a90c4e3&ts=true

// EXTERNAL MODULE: external "dtg-firebase/modules/report"
var report_ = __webpack_require__(422);
;// ./src/components/organisms/modal-report/props.ts



const modal_report_props_props = {
  dtgName: {
    type: String,
    required: true
  },
  status: {
    type: String,
    required: true,
    validator: inRecord(report_.ReportStatus)
  },
  errorMessage: {
    type: String,
    default: null
  },
  progress: {
    type: Number,
    default: 0
  },
  stalling: {
    type: Boolean,
    default: false
  },
  filename: {
    type: String,
    default: null
  },
  downloadUrl: {
    type: String,
    default: null
  },
  reportType: {
    type: String,
    default: external_dtg_shared_report_.PdfType.technique,
    validator: inArray([external_dtg_shared_report_.PdfType.trame, external_dtg_shared_report_.PdfType.technique, external_dtg_shared_report_.PdfType.pppt])
  },
  noClose: {
    type: Boolean,
    default: false
  }
};
;// ./src/components/organisms/modal-report/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_report_style_module = ({"dtg-modal-report__progress":"lib_dtg-modal-report__progress_FKdBm"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/modal-report/component.vue?vue&type=script&lang=ts













/* harmony default export */ const modal_report_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(modal_report_style_module),
  components: {
    DtgModalContent: modal_content_component,
    DtgCol: col,
    DtgGrid: grid,
    DtgRow: row,
    DtgRowCol: row_col,
    DtgButton: button_component,
    DtgProgress: progress_component,
    DtgTitle: title_component,
    DtgInfoBox: info_box_component
  },
  props: modal_report_props_props,
  emits: events(['close', 'cancel', 'retry', 'download'])(),
  setup(props, {
    emit
  }) {
    const downloadLinkProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        status,
        downloadUrl
      } = props;
      const ready = status === report_.ReportStatus.ready;
      return ready ? {
        href: downloadUrl
      } : {};
    });
    const downloadDisabled = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.status !== report_.ReportStatus.ready || !props.downloadUrl);
    const progressProps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      const {
        status,
        progress,
        stalling
      } = props;
      const pending = status === report_.ReportStatus.pending;
      const loading = [report_.ReportStatus.ready, report_.ReportStatus.error].includes(status);
      return {
        type: pending ? DtgProgressType.indeterminate : DtgProgressType.determinate,
        value: loading ? 1 : progress,
        buffer: stalling ? 0 : 1
      };
    });
    const hasError = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.status === report_.ReportStatus.error);
    const content = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      switch (props.reportType) {
        case external_dtg_shared_report_.PdfType.technique:
          return {
            text: "A l'issue de la génération de la fiche technique il vous sera possible  de la télécharger.",
            title: 'Génération de la fiche technique en cours...'
          };
        case external_dtg_shared_report_.PdfType.trame:
        default:
          return {
            text: 'A l’issue de la génération du rapport il vous sera possible de le télécharger.',
            title: 'Génération du rapport en cours...'
          };
      }
    });
    function onCancel() {
      emit('cancel');
      emit('close');
    }
    function onDownloadClick(event) {
      emit('download', event);
    }
    function onRetryClick() {
      emit('retry');
    }
    return {
      b: useBem(modal_report_style_module),
      progressProps,
      downloadLinkProps,
      downloadDisabled,
      content,
      hasError,
      onCancel,
      onDownloadClick,
      onRetryClick
    };
  }
}));
;// ./src/components/organisms/modal-report/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/modal-report/component.vue




;
const modal_report_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(modal_report_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_6a90c4e3_ts_true_render]])

/* harmony default export */ const modal_report_component = (modal_report_component_exports_);
;// ./src/components/organisms/modal-report/composables/use-modal-report.ts


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useModalReport() {
  return useOverlay({
    component: modal_report_component,
    backdropDismiss: false
  });
}
;// ./src/components/organisms/modal-report/index.ts




;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/modal-weak-credentials/component.vue?vue&type=template&id=653b91d0&ts=true

function componentvue_type_template_id_653b91d0_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-button");
  const _component_dtg_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-col");
  const _component_dtg_modal_content = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-modal-content");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_modal_content, null, {
    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Attention! ")]),
    actions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_col, {
      size: "auto"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_button, {
        icon: "arrowRight",
        view: "inverted",
        size: "s",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.onConfirm())
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Recevoir les instructions ")]),
        _: 1
      })]),
      _: 1
    })]),
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
    }, " Votre mot de passe ne répond pas aux exigences minimales de sécurité du mot de passe. ", 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('text'))
    }, " Veuillez suivre la procédure que vous recevrez par e-mail pour remplacer et renforcer votre mot de passe. ", 2)])]),
    _: 1
  });
}
;// ./src/components/organisms/modal-weak-credentials/component.vue?vue&type=template&id=653b91d0&ts=true

;// ./src/components/organisms/modal-weak-credentials/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_weak_credentials_style_module = ({"dtg-modal-weak-credentials__text":"lib_dtg-modal-weak-credentials__text_UNYOT"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/modal-weak-credentials/component.vue?vue&type=script&lang=ts







/* harmony default export */ const modal_weak_credentials_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(modal_weak_credentials_style_module),
  components: {
    DtgModalContent: modal_content_component,
    DtgCol: col,
    DtgButton: button_component
  },
  emits: events(['confirm', 'close'])(),
  setup(props, {
    emit
  }) {
    function onConfirm() {
      emit('confirm');
      emit('close');
    }
    return {
      b: useBem(modal_weak_credentials_style_module),
      onConfirm
    };
  }
}));
;// ./src/components/organisms/modal-weak-credentials/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/modal-weak-credentials/component.vue




;
const modal_weak_credentials_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(modal_weak_credentials_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_653b91d0_ts_true_render]])

/* harmony default export */ const modal_weak_credentials_component = (modal_weak_credentials_component_exports_);
;// ./src/components/organisms/modal-weak-credentials/composables/use-modal-weak-credentials.ts


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useModalWeakCredentials() {
  return useOverlay({
    component: modal_weak_credentials_component
  });
}
;// ./src/components/organisms/modal-weak-credentials/index.ts




;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/privacy-policy/component.vue?vue&type=template&id=61d8b7be&ts=true

const componentvue_type_template_id_61d8b7be_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La société GLOBAL'COPRO, immatriculée au Registre du Commerce et des Sociétés de Lille sous le n°929 673 937, rédacteur des présentes, met en œuvre des traitements de données à caractère personnel. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Sont exposés la manière dont les données sont collectées et le détail de l'utilisation qui en est faite. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les données à caractère personnel qui sont collectées varient en fonction de la façon dont les services sont utilisés. Les données à caractère personnel collectées ou détenues sont directement communiquées par la personne elle-même, ou proviennent de tiers ou sont collectées à partir de l'activité sur le site internet et de l'utilisation des services. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Sont collectées et traitées les informations suivantes : les coordonnées, telles que nom, prénom, numéro de téléphone, adresse électronique, fonction et nom de la société. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L'utilisation de ces informations constituant des données à caractère personnel a pour finalité : ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " D'envoyer des communications au sujet des produits et services, à des fins de prospection commerciale. Ces communications peuvent revêtir la forme d'un courrier électronique ou postal. Ces données sont conservées à des fins de prospection pendant une durée maximale de 2 ans ; ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Lorsque des données ont été collectées à l'occasion de la fourniture d'une prestation ou d'un service ou de demandes de renseignements, des informations sur des prestations ou services semblables ou ciblés en fonction des demandes précédentes peuvent être envoyées, sauf si la personne concernée demande de cesser l'envoi de ces communications commerciales ou choisi de ne pas recevoir celles-ci. Ces données sont conservées à des fins de prospection jusqu'à 2 ans après la collecte des données ; ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " L'utilisation des données et informations telle que décrite ci-dessus est autorisée par la réglementation applicable à la protection des données personnelles. Dans la plupart des cas, ce traitement des données à caractère personnel à des fins de prospection commerciale est fondé sur l'intérêt légitime de GLOBAL'COPRO. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_9 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Par ailleurs, lorsque la personne concernée y a consenti directement auprès de partenaires de la société GLOBAL'COPRO (tels que des compagnies d'assurance, des sites de comparateurs, des plateformes de réseaux sociaux, des agences marketing et plateformes d'affiliation, des moteurs de recherche, des sites d'annonces immobilières en ligne, les filiales), la société GLOBAL'COPRO peut recevoir ses données personnelles. L'utilisation de ces informations par la société GLOBAL'COPRO est alors possible afin de promouvoir ses prestations et services dans les conditions décrites ci-dessus. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Sont collectées et traitées les informations suivantes : adresse IP, code postal, numéro de téléphone, et le cas échéant les éléments fournis dans le questionnaire en ligne. L'utilisation de ces informations est faite uniquement afin d'établir un contact avec la personne ayant rempli le questionnaire en ligne et lui proposez un rendez-vous avec une personne habilitée de la société GLOBAL'COPRO pour établir un devis personnalisé sans engagement et en assurer le suivi à l'issue de la prise de contact. Ce contact sera établi par téléphone et/ou courrier électronique. Les données collectées à l'occasion de l'envoi du questionnaire en ligne complété, sont conservées pendant une durée maximale de 2 ans. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L'utilisation de ces informations telle que décrite ci-dessus est autorisée par la réglementation applicable à la protection des données personnelles. Le traitement de ces données à caractère personnel repose dans ce cas sur le consentement de la personne concernée. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le site de GLOBAL'COPRO utilise la technologie des cookies pour améliorer la navigation ainsi que l'expérience des utilisateurs du site. Lors de la consultation de celui-ci, ces cookies peuvent être enregistrés sur les navigateurs du support utilisé, quel que soit le terminal (ordinateur, tablette, Smartphone). Ils servent notamment lors de l'identification pour des analyses de la fréquentation et de l'utilisation des éléments du site. À tout moment, les visiteurs peuvent décider d'accepter ou de refuser l'utilisation des cookies ainsi que modifier leurs préférences. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le cookie possède une durée de validité qui varie en fonction du type de cookie et permet la reconnaissance du visiteur lors d'une prochaine utilisation du site internet. En tout état de cause, cette durée n'excède pas 13 mois. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les visiteurs peuvent décider d'accepter ou de refuser les cookies lors de leur navigation sur le Site. A cet effet, GLOBAL'COPRO fait apparaître, sur son Site, un bandeau d'information préalable invitant le visiteur à accepter les cookies. Tant que le visiteur n'a pas donné son consentement au recueil des cookies, aucun cookie ne pourra être déposé sur son terminal, à l'exception des cookies exemptés du recueil du consentement dans la mesure où ils sont strictement nécessaires à la fourniture d'un service expressément demandé par l'utilisateur. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Sont collectées et traitées les informations suivantes : nom, prénom, numéro(s) de téléphones, adresse électronique, fonction et société. ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_16 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " En outre, pour l'exécution de mesures précontractuelles ou du contrat avec GLOBAL'COPRO, lorsqu'il met en œuvre un traitement ayant pour finalité: ", -1);
const componentvue_type_template_id_61d8b7be_ts_true_hoisted_17 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " la prospection, la production, la gestion, le suivi des demandes et des dossiers de ses clients ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "la rédaction d'actes pour le compte de ses clients.")], -1);
const _hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " ainsi que dans le cadre du respect d'obligations légales et réglementaires lorsqu'il met en œuvre un traitement ayant pour finalité : ", -1);
const _hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " la prévention du blanchiment et du financement du terrorisme et la lutte contre la corruption ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "la facturation ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "la comptabilité.")], -1);
const _hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " sont collectées et traitées tous éléments nécessaires à ces finalités. ", -1);
const _hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Ces informations sont utilisées pour honorer les finalités liées aux prestations et services sollicités. ", -1);
const _hoisted_22 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Ces traitements sont autorisés par la réglementation applicable à la protection des données personnelles, et dans tous les cas reposent sur le fondement juridique du contrat liant les personnes concernées et GLOBAL'COPRO ou celui de l'intérêt légitime. Sauf disposition contraire, les informations visées ci-dessus sont nécessaires afin de remplir nos obligations contractuelles. ", -1);
const _hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les données à caractère personnel sont conservées pour les utiliser aux fins énumérées dans la présente Politique. ", -1);
const _hoisted_24 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Sauf indication contraire dans les paragraphes précédents, les données sont conservées aussi longtemps que la personne concernée entretiendra une relation contractuelle avec GLOBAL'COPRO. ", -1);
const _hoisted_25 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " En cas de rupture du contrat liant la personne concernée à la société GLOBAL'COPRO, comme au terme du service ou de la prestation sollicité, et s'il n'y a pas d'autre raison de poursuivre le traitement, les informations seront conservées pendant les périodes nécessaires pour se conformer à la réglementation et aux règles de prescription en vigueur notamment contractuelles, comptables et fiscales ou, le cas échéant, en vue de traiter toute réclamation ou demande afférente aux prestations ou services fournis. ", -1);
const _hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les données à caractère personnel des clients sont conservées pendant la durée des relations contractuelles augmentée de 2 ans à des fins d'animation et prospection, sans préjudice des obligations de conservation ou des délais de prescription. En matière de prévention du blanchiment et du financement du terrorisme, les données sont conservées 5 ans après la fin des relations avec GLOBAL'COPRO. ", -1);
const _hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Le droit d'accéder à ses données à caractère personnel ;", -1);
const _hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Le droit de corriger toute erreur figurant dans les fichiers ; ", -1);
const _hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Le droit de faire effacer ses données à caractère personnel, de limiter leur traitement ou de s'y opposer ; ", -1);
const _hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Le droit de retirer son consentement ;", -1);
const _hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Le droit de s'opposer à la réception de documents de prospection commerciale à l'avenir ; ", -1);
const _hoisted_32 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " et dans certaines circonstances, le droit de veiller à ce que ces informations soient transférées à la personne concernée ou soient transférées à un tiers ; ", -1);
const _hoisted_33 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Toute personne dispose d'une faculté de déposer une réclamation auprès de la CNIL. ", -1);
const _hoisted_34 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " DPO – GLOBAL'COPRO, Euralliance A - 2 avenue de Kaarst, 59110 LA MADELEINE. ", -1);
const _hoisted_35 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Toute demande d'exercice des droits d'accès, de rectification, de suppression ou de limitation du traitement, doit être accompagnée de la copie d'une pièce d'identité du demandeur. ", -1);
const _hoisted_36 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " GLOBAL'COPRO respecte le RGPD et la loi Informatique et Libertés en matière de sécurité et de confidentialité de vos données. ", -1);
const _hoisted_37 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Nous mettons en œuvre toutes les mesures techniques et organisationnelles nécessaires afin d’assurer la sécurité de nos traitements de données à caractère personnel et la confidentialité des données que nous collectons. ", -1);
const _hoisted_38 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " A ce titre, nous prenons toutes les précautions utiles, au regard de la nature des données et des risques présentés par les traitements pour en préserver la sécurité et, notamment, empêcher que les données soient déformées, endommagées, ou que des tiers non autorisés y aient accès (protection physique des locaux, protocole https sécurisé, journalisation et traçabilité des connexions aux logiciels déployés en interne). ", -1);
const _hoisted_39 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La présente Politique de confidentialité a été mise à jour en février 2025. ", -1);
const _hoisted_40 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Nous nous réservons le droit de la modifier à tout moment afin de fournir une information à jour sur la façon dont nous collectons et traitons les données. ", -1);
function componentvue_type_template_id_61d8b7be_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  const _component_dtg_link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-link");
  const _component_dtg_document_page = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-document-page");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_document_page, {
    title: "Politique de confidentialité"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "2",
      "no-margin": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 1 - Protection des données à caractère personnel ")]),
      _: 1
    }), componentvue_type_template_id_61d8b7be_ts_true_hoisted_1, componentvue_type_template_id_61d8b7be_ts_true_hoisted_2, componentvue_type_template_id_61d8b7be_ts_true_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "2",
      "no-margin": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 2. Prospection commerciale et marketing ")]),
      _: 1
    }), componentvue_type_template_id_61d8b7be_ts_true_hoisted_4, componentvue_type_template_id_61d8b7be_ts_true_hoisted_5, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [componentvue_type_template_id_61d8b7be_ts_true_hoisted_6, componentvue_type_template_id_61d8b7be_ts_true_hoisted_7, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Chaque fois qu'une communication électronique à des fins de prospection commerciale est adressée, le destinataire a la possibilité de choisir de ne plus en recevoir à l'avenir grâce à un lien de désinscription. En outre, il est possible, à tout moment, d'adresser un courrier électronique à l'adresse électronique suivante : "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, {
      href: "mailto:dpo@mydtg.fr"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" dpo@mydtg.fr ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" afin de demander de cesser l'envoi de ces communications commerciales ; ")]), componentvue_type_template_id_61d8b7be_ts_true_hoisted_8]), componentvue_type_template_id_61d8b7be_ts_true_hoisted_9, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "2",
      "no-margin": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 3. Questionnaire en ligne ")]),
      _: 1
    }), componentvue_type_template_id_61d8b7be_ts_true_hoisted_10, componentvue_type_template_id_61d8b7be_ts_true_hoisted_11, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "2",
      "no-margin": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 4. A partir de l'utilisation du site Internet ")]),
      _: 1
    }), componentvue_type_template_id_61d8b7be_ts_true_hoisted_12, componentvue_type_template_id_61d8b7be_ts_true_hoisted_13, componentvue_type_template_id_61d8b7be_ts_true_hoisted_14, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "2",
      "no-margin": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 5. Dans le cadre des prestations et services fournis ")]),
      _: 1
    }), componentvue_type_template_id_61d8b7be_ts_true_hoisted_15, componentvue_type_template_id_61d8b7be_ts_true_hoisted_16, componentvue_type_template_id_61d8b7be_ts_true_hoisted_17, _hoisted_18, _hoisted_19, _hoisted_20, _hoisted_21, _hoisted_22, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "2",
      "no-margin": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 6. Conservation des informations ")]),
      _: 1
    }), _hoisted_23, _hoisted_24, _hoisted_25, _hoisted_26, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [_hoisted_27, _hoisted_28, _hoisted_29, _hoisted_30, _hoisted_31, _hoisted_32, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Le droit de définir des directives générales et particulières définissant la manière dont les personnes concernées entendent que soient exercés, après leur décès, les droits mentionnés ci-dessus par courrier électronique à l'adresse suivante : "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, {
      href: "mailto:dpo@mydtg.fr"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" dpo@mydtg.fr ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ou par courrier postal à l'adresse suivante: A l’intention du DPO – GLOBAL'COPRO, Euralliance A - 2 avenue de Kaarst, 59110 LA MADELEINE, accompagné d'une copie d'un titre d'identité signé. ")])]), _hoisted_33, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "2",
      "no-margin": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 7. Contact et réclamations ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Toutes les questions soulevées dans la présente Politique, les demandes d'exercice des droits de la personne concernée, sont gérées par le Délégué à la Protection des Données qui peut être contacté de la façon suivante : "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, {
      href: "mailto:dpo@mydtg.fr"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" dpo@mydtg.fr ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(". ")]), _hoisted_34, _hoisted_35, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "2",
      "no-margin": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8. Sécurité ")]),
      _: 1
    }), _hoisted_36, _hoisted_37, _hoisted_38, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "2",
      "no-margin": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 9. Statut de la présente Politique de confidentialité ")]),
      _: 1
    }), _hoisted_39, _hoisted_40]),
    _: 1
  });
}
;// ./src/components/organisms/privacy-policy/component.vue?vue&type=template&id=61d8b7be&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/privacy-policy/component.vue?vue&type=script&lang=ts




/* harmony default export */ const privacy_policy_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "dtg-privacy-policy",
  components: {
    DtgDocumentPage: document_page_component,
    DtgTitle: title_component,
    DtgLink: link_component
  }
}));
;// ./src/components/organisms/privacy-policy/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/privacy-policy/component.vue




;
const privacy_policy_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(privacy_policy_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_61d8b7be_ts_true_render]])

/* harmony default export */ const privacy_policy_component = (privacy_policy_component_exports_);
;// ./src/components/organisms/privacy-policy/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/terms-of-sales/component.vue?vue&type=template&id=01ee386a&ts=true

const componentvue_type_template_id_01ee386a_ts_true_hoisted_1 = {
  "aria-labelledby": "section-1-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les présentes Conditions Générales de Vente constituent, conformément à l'article L 441-1 du Code du Commerce, le socle unique de la relation commerciale entre les parties. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Elles ont pour objet de définir les conditions dans lesquelles GLOBAL'COPRO (« Le Prestataire ») fournit aux Clients professionnels (« Les Clients ou le Client ») qui lui en font la demande, via le site internet du Prestataire, par contact direct ou via un support papier, les services suivants : L’outil MyDTG (« les Services »). ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " MyDTG est une application web et mobile permettant d'optimiser les prestations de Diagnostic Technique global et de Projets de Plan Pluriannuels de travaux. Elle est composée d'une application terrain nommée « MyDTG Terrain » (dans laquelle l’utilisateur saisit toutes les informations liées au DTG ou au PPPT lors de son intervention sur site) qui va lui permettre de générer automatiquement un rapport, complet et conforme. Elle est aussi composée d'une partie back-office nommée « MyDTG Manager » où toutes les informations sur l'intervention sont préalablement rentrées et où chaque utilisateur a un rôle défini. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Elles s'appliquent, sans restriction ni réserve, à tous les Services rendus par le Prestataire auprès des Clients de même catégorie, quelles que soit les clauses pouvant figurer sur les documents du Client, et notamment ses conditions générales d'achat. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Conformément à la réglementation en vigueur, ces Conditions Générales de Vente sont systématiquement communiquées à tout Client (hors grossistes) qui en fait la demande, pour lui permettre de passer commande auprès du Prestataire. Elles sont également communiquées à tout Client préalablement à la conclusion d'une convention unique visée aux articles L 441-3 et suivants du Code du Commerce, dans les délais légaux. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Toute commande de Services implique, de la part du Client, l'acceptation des présentes Conditions Générales de Vente et des conditions générales d'utilisation du site internet du Prestataire pour les commandes électroniques. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les renseignements figurant sur les catalogues, prospectus et tarifs du Prestataire sont donnés à titre indicatif et sont révisables à tout moment. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_9 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le Prestataire est en droit d'y apporter toutes modifications qui lui paraîtront utiles. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Conformément à la réglementation en vigueur, le Prestataire se réserve le droit de déroger à certaines clauses des présentes Conditions Générales de Vente, en fonction des négociations menées avec le Client, par l'établissement de Conditions de Vente Particulières. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_11 = {
  "aria-labelledby": "section-2-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_12 = {
  "aria-labelledby": "section-2-1-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les ventes de Services ne sont parfaites qu'après établissement d'un devis ou d’un bon de commande et acceptation expresse et par écrit de la commande du Client par le Prestataire, matérialisée par un accusé de réception émanant du Prestataire et acceptation du devis. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le Prestataire dispose de moyens de commande (y compris d'acceptation et de confirmation) électroniques (références des sites) permettant aux Clients de commander les Services dans les meilleures conditions de commodité et de rapidité. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La prise en compte de la commande et l'acceptation de celle-ci sont confirmées par l'envoi d'un mail. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_16 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les données enregistrées dans le système informatique du Prestataire constituent la preuve de l'ensemble des transactions conclues avec le Client. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_17 = {
  "aria-labelledby": "section-2-2-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les éventuelles modifications de la commande demandées par le Client ne seront prises en compte, dans la limite des possibilités du Prestataire, que si elles sont notifiées par écrit, dix jours au moins avant la date prévue pour la fourniture de Services commandés, après signature par le Client d'un bon de commande spécifique et ajustement éventuel du prix. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_19 = {
  "aria-labelledby": "section-2-3-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le client possède 14 jours pour annuler sa commande à partir du jour de l’acceptation de commande. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_21 = {
  "aria-labelledby": "section-3-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_22 = {
  "aria-labelledby": "section-3-1-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les prestations de services sont fournies aux tarifs du Prestataire en vigueur au jour de la passation de la commande, selon le barème du Prestataire le devis préalablement établi par le Prestataire et accepté par le Client, comme indiqué à l'article “ Commandes ” ci-dessus. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_24 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les tarifs s'entendent nets et HT. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_25 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Une facture est établie par le Prestataire et remise au Client lors de chaque fourniture de Services. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les conditions de détermination du coût des services dont le prix ne peut être connu a priori ni indiqué avec exactitude, ainsi que la méthode de calcul du prix permettant de vérifier ce dernier, seront communiquées au Client ou feront l'objet d'un devis détaillé, à la demande du Client conformément aux dispositions de l'article L 441-1,III du Code de commerce. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_27 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le Client pourra bénéficier de réductions de prix, remises et ristournes, en fonction du nombre en une seule fois et un seul lieu et de la fréquence, des Services commandées, ou de la régularité de ses commandes de Services, dans les conditions et selon les modalités décrites aux tarifs du Prestataire. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_28 = {
  "aria-labelledby": "section-4-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_29 = {
  "aria-labelledby": "section-4-1-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_30 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le prix est payable comptant, en totalité au jour de la fourniture des Services commandés, dans les conditions définies à l'article « Modalités de fourniture des Services » ci-après, et comme indiqué sur la facture remise au Client. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_31 = {
  "aria-labelledby": "section-4-2-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_32 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Conformément aux dispositions de l’article L. 441-10 du Code de commerce, tout retard de paiement fera courir, sans préavis et de plein droit, une indemnité forfaitaire de recouvrement telle que déterminée par décret et des intérêts de retard dont le taux correspondra au taux appliqué par la Banque Centrale Européenne lors de sa dernière opération de refinancement, majoré de DIX (10) points. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_33 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Nonobstant les intérêts de retard calculés selon les conditions précitées, tout défaut ou retard de paiement de l’une quelconque des factures dans les TRENTE (30) jours de leur exigibilité, entraîne pour le CLIENT, après mise en demeure par courrier recommandé avec accusé de réception restée sans effet, la suspension de toute concession de Licence et de support technique et de l’accès aux Services délivrés par GLOBAL'COPRO. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_34 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le retard de paiement entraînera l'exigibilité immédiate de la totalité des sommes dues au Prestataire par le Client, sans préjudice de toute autre action que le Prestataire serait en droit d'intenter, à ce titre, à l'encontre du Client. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_35 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " En cas de non-respect des conditions de paiement figurant ci-dessus, le Prestataire se réserve en outre le droit de suspendre d'annuler la fourniture des Services commandés par le Client, de suspendre l'exécution de ses obligations et de diminuer d'annuler les éventuelles remises accordées à ce dernier. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_36 = {
  "aria-labelledby": "section-4-3-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_37 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Sauf accord exprès, préalable et écrit du Prestataire, et à condition que les créances et dettes réciproques soient certaines, liquides et exigibles, aucune compensation ne pourra être valablement effectuée par le Client entre d'éventuelles pénalités pour retard dans la fourniture des Services commandés ou non-conformité à la commande, d'une part, et les sommes par le Client au Prestataire au titre de l'achat desdits Services, d'autre part. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_38 = {
  "aria-labelledby": "section-5-title"
};
const componentvue_type_template_id_01ee386a_ts_true_hoisted_39 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les Services demandés par le Client seront fournis dans un délai maximum de 15 jours à compter de la réception par le Prestataire du bon de commande correspondant dûment signé, accompagné de l'acompte exigible. ", -1);
const componentvue_type_template_id_01ee386a_ts_true_hoisted_40 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Ce délai ne constitue pas un délai de rigueur et le Prestataire ne pourra voir sa responsabilité engagée à l'égard du Client en cas de retard dans la fourniture des Services n'excédant pas 30 jours, le Client pourra demander la résolution de la vente. Les acomptes déjà versés lui seront alors restitués par le Prestataire. ", -1);
const _hoisted_41 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La responsabilité du Prestataire ne pourra en aucun cas être engagée en cas de retard ou de suspension de la fourniture de la prestation imputable au Client, ou en cas de force majeure. ", -1);
const _hoisted_42 = {
  "aria-labelledby": "section-6-title"
};
const _hoisted_43 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le Prestataire garantit, conformément aux dispositions légales, le Client, contre tout défaut de conformité des Services et tout vice caché, provenant d'un défaut de conception ou de fourniture desdits Services à l'exclusion de toute négligence ou faute du Client. ", -1);
const _hoisted_44 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La responsabilité du Prestataire ne peut être engagée qu'en cas de faute ou de négligence prouvée et est limitée aux préjudices directs à l'exclusion de tout préjudice indirect, de quelque nature que ce soit. ", -1);
const _hoisted_45 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Afin de faire valoir ses droits, le Client devra, sous peine de déchéance de toute action s'y rapportant, informer le Prestataire, par écrit, de l'existence des vices dans un délai maximum de deux ans à compter de leur découverte. ", -1);
const _hoisted_46 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le Prestataire rectifiera ou fera rectifier, à ses frais exclusifs, selon les modalités adéquates et agréées par le Client, les Services jugés défectueux. ", -1);
const _hoisted_47 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " En tout état de cause, au cas où la responsabilité du Prestataire serait retenue, la garantie du Prestataire serait limitée au montant HT payé par le Client pour la fourniture des Services. ", -1);
const _hoisted_48 = {
  "aria-labelledby": "section-7-title"
};
const _hoisted_49 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le Prestataire reste propriétaire de tous les droits de propriété intellectuelle sur les études, édition informatiques, dessins, modèles, prototypes, etc., réalisés (même à la demande du Client) en vue de la fourniture des services au Client. Le Client s'interdit donc toute reproduction ou exploitation desdites études, dessins, modèles et prototypes, etc., sans l'autorisation expresse, écrite et préalable du Prestataire qui peut la conditionner à une contrepartie financière. ", -1);
const _hoisted_50 = {
  "aria-labelledby": "section-8-title"
};
const _hoisted_51 = {
  "aria-labelledby": "section-8-1-title"
};
const _hoisted_52 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les données à caractère personnel qui sont collectées par GLOBAL'COPRO sont les suivantes: ", -1);
const _hoisted_53 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Pour la création du Compte Client les Données Personnelles suivantes seront collectées : ", -1);
const _hoisted_54 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Nom, prénom ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Fonction ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Société et adresse ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Téléphone portable ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Adresse email ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Formation ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Assurance professionnelle.")], -1);
const _hoisted_55 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Lors de la connexion de l’Utilisateur à la Solution MyDTG, celle-ci enregistre, notamment, ses noms, prénoms, données de connexion. ", -1);
const _hoisted_56 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les cookies sont utilisés, dans le cadre de l’utilisation des Sites. L’Utilisateur a la possibilité de désactiver les cookies à partir des paramètres de son navigateur. ", -1);
const _hoisted_57 = {
  "aria-labelledby": "section-8-2-title"
};
const _hoisted_58 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les Données Personnelles collectées auprès de l’Utilisateur ont pour objectif la mise à disposition des Services fournis par la Solution MyDTG, leur amélioration et le maintien d’un environnement sécurisé. ", -1);
const _hoisted_59 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Plus précisément, les utilisations sont les suivantes : ", -1);
const _hoisted_60 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Accès et utilisation du Logiciel par l’Utilisateur ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Vérification, identification et authentification des données transmises par l’Utilisateur ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Mise en œuvre d’une assistance utilisateur ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Envoi d’informations relatives à l'usage de la Solution MyDTG leurs mise à jour, évolutions, ou autre, par message personnel à l’Utilisateur. "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Proposition d'offres et de mise à jour dans le cadre de l'utilisation de la solution")], -1);
const _hoisted_61 = {
  "aria-labelledby": "section-8-3-title"
};
const _hoisted_62 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les Données Personnelles seront conservées par GLOBAL'COPRO deux ans après la fin du contrat pour la bonne continuité du service. Passé ce délai les données seront anonymisés. ", -1);
const _hoisted_63 = {
  "aria-labelledby": "section-8-4-title"
};
const _hoisted_64 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les Données Personnelles peuvent être partagées avec des sociétés tierces dans les cas suivants : ", -1);
const _hoisted_65 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Quand GLOBAL'COPRO recourt aux services de prestataires pour fournir l’assistance utilisateurs et la publicité. Ces prestataires disposent d’un accès limité aux Données Personnelles, dans le cadre de l’exécution de ces prestations et ont une obligation contractuelle de les utiliser en conformité avec les dispositions de la réglementation applicable en matière de protection de données à caractère personnel ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Si la loi l’exige, GLOBAL'COPRO peut effectuer la transmission de Données Personnelles pour donner suite aux réclamations présentées contre GLOBAL'COPRO et se conformer aux procédures administratives et judiciaires ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Si GLOBAL'COPRO est impliquée dans une opération de fusion, acquisition, cession d’actifs ou procédure de redressement judiciaire, elle pourra être amenée à céder ou partager tout ou partie de ses actifs, y compris les données à caractère personnel. Dans ce cas, le CLIENT sera informé, avant que les données à caractère personnel ne soient transférées à une tierce partie. ")], -1);
const _hoisted_66 = {
  "aria-labelledby": "section-8-5-title"
};
const _hoisted_67 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " GLOBAL'COPRO met en œuvre des mesures organisationnelles, techniques, logicielles et physiques en matière de sécurité du numérique pour protéger les Données Personnelles contre les altérations, destructions, et accès non autorisés. Toutefois, il est à signaler qu’internet n’est pas un environnement complétement sécurisé et qu’à ce titre GLOBAL'COPRO ne peut pas garantir la sécurité de la transmission ou du stockage des informations sur internet. ", -1);
const _hoisted_68 = {
  "aria-labelledby": "section-8-6-title"
};
const _hoisted_69 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Il est rappelé qu’il appartient à GLOBAL'COPRO, en tant que responsable du traitement, de recueillir tout consentement nécessaire auprès des personnes physiques concernées, en corrélation avec les finalités poursuivies. En outre, les personnes concernées disposent sur les Données Personnelles les concernant des droits d’accès, de rectification, d’effacement, de limitation, de portabilité et d’opposition, et peuvent à tout moment révoquer les consentements aux traitements. Les personnes concernées seront susceptibles de faire valoir leurs droits directement auprès de GLOBAL'COPRO, qui s’engage à y faire droit dans les délais réglementaires. ", -1);
const _hoisted_70 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Dans ce cadre, l’Utilisateur dispose des droits suivants : ", -1);
const _hoisted_71 = {
  "aria-labelledby": "section-8-7-title"
};
const _hoisted_72 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " GLOBAL'COPRO se réserve le droit d’apporter toute modification à la présente clause relative à la protection des Données Personnelles à tout moment. Si une modification est apportée à la présente clause, GLOBAL'COPRO s’engage à publier une nouvelle version des CGU sur ses Sites. GLOBAL'COPRO en informera également l’Utilisateur de la modification par messagerie électronique dans un délai minimum de quinze (15) jours avant la date d’effet. Si l’Utilisateur n’est pas d’accord avec les termes de la nouvelle rédactionde la clause de protection des données à caractère personnel, il a la possibilité de supprimer son Compte. ", -1);
const _hoisted_73 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Une réclamation auprès du délégué à la protection des données personnelles du Fournisseur de la Commission Nationale de l'Informatique et des Libertés. ", -1);
const _hoisted_74 = {
  "aria-labelledby": "section-9-title"
};
const _hoisted_75 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " En cas de changement de circonstances imprévisibles lors de la conclusion du contrat, conformément aux dispositions de l'article 1195 du Code civil, la Partie qui n'a pas accepté d'assumer un risque d'exécution excessivement onéreuse peut demander une renégociation du contrat à son cocontractant. ", -1);
const _hoisted_76 = {
  "aria-labelledby": "section-10-title"
};
const _hoisted_77 = {
  "aria-labelledby": "section-10-1-title"
};
const _hoisted_78 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La responsabilité de GLOBAL'COPRO à l’égard du CLIENT ne pourra être recherchée qu’en cas de manquement contractuel prouvé commis dans ou à l’occasion de l’exécution des prestations mises à sa charge au titre du Contrat. ", -1);
const _hoisted_79 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " GLOBAL'COPRO ne pourra être tenue responsable des dommages indirects, des pertes financières ou des pertes d’exploitation subis par le CLIENT ou par ses clients de ce fait. En conséquence, le CLIENT renonce à recours à l’encontre de GLOBAL'COPRO et contre ses assureurs au-delà de ces limites, tant en nature que sur les montants, et s’engage à faire renoncer à recours ses propres assureurs au-delà des mêmes limites. ", -1);
const _hoisted_80 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Si toutefois la responsabilité de GLOBAL'COPRO était retenue devant les tribunaux, le CLIENT ne pourrait prétendre à d'autres indemnités et dommages et intérêts ou règlement quelconque, toutes causes confondues, qu'au montant des règlements perçus ou effectués par cette dernière dans les DOUZE (12) mois précédant l’incident ayant provoqué ces dommages. ", -1);
const _hoisted_81 = {
  "aria-labelledby": "section-10-2-title"
};
const _hoisted_82 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " En toutes hypothèses, la responsabilité de GLOBAL'COPRO ne pourra en aucun cas être retenue et le CLIENT sera seul responsable en cas de dommages causés aux personnes et aux biens du fait des Services, sauf à ce qu’un dysfonctionnement de la Solution MyDTG directement en lien avec le dommage ne soit démontré. ", -1);
const _hoisted_83 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " En aucun cas GLOBAL'COPRO ne pourra être tenue responsable de l’usage fait par le CLIENT des informations obtenues à l’occasion des Services, notamment vis-à-vis des tiers. ", -1);
const _hoisted_84 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " GLOBAL'COPRO n’assume aucune responsabilité en relation avec les biens et services fournis par un tiers ou appartenant à un tiers, ou le comportement des tierces parties en général. ", -1);
const _hoisted_85 = {
  "aria-labelledby": "section-11-title"
};
const _hoisted_86 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Pour pouvoir bénéficier des stipulations du présent Article, la Partie souhaitant invoquer un cas de Force Majeure devra, sous peine de forclusion, le notifier à l'autre Partie par lettre recommandée avec demande d'avis de réception dès qu'elle aura connaissance de la survenance d'un tel événement et au plus tard, dans un délai de huit (8) jours calendaires à compter de l'apparition dudit événement, en justifiant le caractère imprévisible et irrésistible de l'événement la mettant selon elle dans l'impossibilité d'entreprendre ou de poursuivre l'exécution de ses obligations et en démontrant l'impact dudit événement sur l’inexécution de ses obligations. ", -1);
const _hoisted_87 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Pendant sa durée, l'événement de force majeure suspend pour la Partie s'en prévalant, l'exécution des obligations. ", -1);
const _hoisted_88 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Dans tous les cas, la Partie affectée par l'événement de force majeure devra faire tout ce qui est en son pouvoir afin d'éviter, éliminer ou réduire les causes du retard et reprendre l'exécution de ses obligations dès que l'événement invoqué aura disparu. ", -1);
const _hoisted_89 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Si le cas de force majeure venait à excéder QUINZE (15) jours à compter de la notification visée plus haut, la Partie affectée aura la faculté de résilier de plein droit et sans indemnité le Contrat sans autre formalité que l'envoi à l‘autre Partie d'une lettre recommandée avec demande d'avis de réception. ", -1);
const _hoisted_90 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " En tout état de cause, si l’empêchement est définitif, le Contrat sera résolu de plein droit dans les conditions prévues aux articles 1351 et 1351-1 du Code civil. ", -1);
const _hoisted_91 = {
  "aria-labelledby": "section-12-title"
};
const _hoisted_92 = {
  "aria-labelledby": "section-12-1-title"
};
const _hoisted_93 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " En cas de manquement d'une des Parties à une de ses obligations, l'autre Partie pourra, trente (30) jours francs à compter de la date de réception, ou à défaut de la date de première présentation d'une lettre de mise en demeure recommandée avec demande d'avis de réception restée infructueuse, prononcer la résiliation de plein droit du Contrat, sans préavis ni formalité judiciaire ou autre et sans préjudice de tous autres droits ou actions notamment en vue de solliciter tous dommages et intérêts auxquels elle pourrait prétendre. ", -1);
const _hoisted_94 = {
  "aria-labelledby": "section-12-2-title"
};
const _hoisted_95 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " En cas de résiliation, quelle qu’en soit la cause, la fourniture de tous les Services délivrés au titre des présentes cessera immédiatement. ", -1);
const _hoisted_96 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Toute obligation de versement qui serait née d’une prestation réalisée ou en cours antérieurement à la résiliation devra être acquittée par le CLIENT dans les plus brefs délais suivant ladite résiliation. Le cas échéant, en vue de faciliter les comptes entre les Parties, un rapport sur l’état des Services fournis sera établi par GLOBAL'COPRO et une copie sera remise au CLIENT. ", -1);
const _hoisted_97 = {
  "aria-labelledby": "section-13-title"
};
const _hoisted_98 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Tout différend relatif au présent Contrat, à son interprétation ou à son exécution, à défaut d’accord amiable entre les Parties dans les TRENTE (30) jours suivants la survenance du litige, sera de la compétence exclusive du Tribunal de commerce de Grasse. ", -1);
const _hoisted_99 = {
  "aria-labelledby": "section-13-1-title"
};
const _hoisted_100 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Tous les litiges auxquels le présent contrat et les accords qui en découlent pourraient donner lieu, concernant tant leur validité, leur interprétation, leur exécution, leur résolution, leurs conséquences et leurs suites seront soumis au tribunal de GRASSE. ", -1);
const _hoisted_101 = {
  "aria-labelledby": "section-14-title"
};
const _hoisted_102 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les présentes Conditions générales Définir la forme des conditions générales et les opérations qui en découlent sont régies par le droit français. ", -1);
const _hoisted_103 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Elles sont rédigées en langue française. Dans le cas où elles seraient traduites en une ou plusieurs langues, seul le texte français ferait foi en cas de litige. ", -1);
const _hoisted_104 = {
  "aria-labelledby": "section-15-title"
};
const _hoisted_105 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Pour l'exécution des présentes ainsi que de leurs suites, les Parties font respectivement élection de domicile en leurs sièges sociaux figurant, pour GLOBAL'COPRO, en tête des présentes, et pour le CLIENT, au Devis ou Bon de Commande. Toute modification du siège social ou de l'adresse de l'une des Parties ne sera opposable à l'autre Partie que huit (8) jours après lui avoir été dûment notifiée par lettre recommandée avec demande d’avis de réception ou par courriel signé numériquement. ", -1);
const _hoisted_106 = {
  "aria-labelledby": "section-16-title"
};
const _hoisted_107 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les présentes Conditions Générales de Vente sont expressément agréées et acceptées par le Client, qui déclare et reconnaît en avoir une parfaite connaissance, et renonce, de ce fait, à se prévaloir de tout document contradictoire et, notamment, ses propres conditions générales d'achat, qui seront inopposables au Prestataire, même s'il en a eu connaissance. ", -1);
function componentvue_type_template_id_01ee386a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  const _component_dtg_link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-link");
  const _component_dtg_document_page = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-document-page");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_document_page, {
    title: "CONDITIONS GENERALES DE VENTE (PRESTATIONS DE SERVICE) ENTRE PROFESSIONNELS"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-1-title",
      view: "2",
      "no-margin": ""
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 1 - Champ d'application ")]),
      _: 1
    }), componentvue_type_template_id_01ee386a_ts_true_hoisted_2, componentvue_type_template_id_01ee386a_ts_true_hoisted_3, componentvue_type_template_id_01ee386a_ts_true_hoisted_4, componentvue_type_template_id_01ee386a_ts_true_hoisted_5, componentvue_type_template_id_01ee386a_ts_true_hoisted_6, componentvue_type_template_id_01ee386a_ts_true_hoisted_7, componentvue_type_template_id_01ee386a_ts_true_hoisted_8, componentvue_type_template_id_01ee386a_ts_true_hoisted_9, componentvue_type_template_id_01ee386a_ts_true_hoisted_10]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_11, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-2-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 2 - Commandes ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_12, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-2-1-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 2-1 ")]),
      _: 1
    }), componentvue_type_template_id_01ee386a_ts_true_hoisted_13, componentvue_type_template_id_01ee386a_ts_true_hoisted_14, componentvue_type_template_id_01ee386a_ts_true_hoisted_15, componentvue_type_template_id_01ee386a_ts_true_hoisted_16]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_17, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-2-2-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 2-2 ")]),
      _: 1
    }), componentvue_type_template_id_01ee386a_ts_true_hoisted_18]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_19, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-2-3-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 2-3 ")]),
      _: 1
    }), componentvue_type_template_id_01ee386a_ts_true_hoisted_20])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_21, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-3-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 3 - Tarifs ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_22, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-3-1-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 3-1 ")]),
      _: 1
    }), componentvue_type_template_id_01ee386a_ts_true_hoisted_23, componentvue_type_template_id_01ee386a_ts_true_hoisted_24, componentvue_type_template_id_01ee386a_ts_true_hoisted_25, componentvue_type_template_id_01ee386a_ts_true_hoisted_26, componentvue_type_template_id_01ee386a_ts_true_hoisted_27])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_28, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-4-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 4 - Conditions de règlement ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_29, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-4-1-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 4-1. Délais de règlement ")]),
      _: 1
    }), componentvue_type_template_id_01ee386a_ts_true_hoisted_30]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_31, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-4-2-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 4-2. Pénalités de retard ")]),
      _: 1
    }), componentvue_type_template_id_01ee386a_ts_true_hoisted_32, componentvue_type_template_id_01ee386a_ts_true_hoisted_33, componentvue_type_template_id_01ee386a_ts_true_hoisted_34, componentvue_type_template_id_01ee386a_ts_true_hoisted_35]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_36, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-4-3-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 4-3. Absence de compensation ")]),
      _: 1
    }), componentvue_type_template_id_01ee386a_ts_true_hoisted_37])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_01ee386a_ts_true_hoisted_38, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-5-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 5 - Modalités de fourniture des Services ")]),
      _: 1
    }), componentvue_type_template_id_01ee386a_ts_true_hoisted_39, componentvue_type_template_id_01ee386a_ts_true_hoisted_40, _hoisted_41]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_42, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-6-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 6 - Responsabilité du Prestataire - Garantie ")]),
      _: 1
    }), _hoisted_43, _hoisted_44, _hoisted_45, _hoisted_46, _hoisted_47]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_48, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-7-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 7 - Droit de propriété intellectuelle ")]),
      _: 1
    }), _hoisted_49]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_50, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-8-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 8 - Données personnelles ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_51, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-8-1-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8.1. Collecte des Données Personnelles ")]),
      _: 1
    }), _hoisted_52, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "4"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8.1.1. Ouverture de Compte Client ")]),
      _: 1
    }), _hoisted_53, _hoisted_54, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "4"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8.1.2. Connexion ")]),
      _: 1
    }), _hoisted_55, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "4"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8.1.3. Cookies ")]),
      _: 1
    }), _hoisted_56]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_57, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-8-2-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8.2. Utilisation des Données Personnelles ")]),
      _: 1
    }), _hoisted_58, _hoisted_59, _hoisted_60]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_61, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-8-3-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8.3. Conservation des données ")]),
      _: 1
    }), _hoisted_62]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_63, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-8-4-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8.4. Partage des Données Personnelles avec des tiers ")]),
      _: 1
    }), _hoisted_64, _hoisted_65]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_66, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-8-5-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8.5. Sécurité et confidentialité ")]),
      _: 1
    }), _hoisted_67]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_68, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-8-6-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8.6. Mise en œuvre des droits des personnes concernées ")]),
      _: 1
    }), _hoisted_69, _hoisted_70, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Il peut supprimer son Compte, en écrivant à l’adresse suivante : "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, {
      href: "mailto:dpo@mydtg.fr"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" dpo@mydtg.fr ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("; ")]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Il peut exercer son droit d’accès, pour connaître les Données Personnelles le concernant, en écrivant à l’adresse électronique suivante : "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, {
      href: "mailto:dpo@mydtg.fr"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" dpo@mydtg.fr ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Dans ce cas, avant la mise en œuvre de ce droit, GLOBAL'COPRO peut demander une preuve de l’identité à l’Utilisateur afin d’en vérifier l’exactitude ; ")]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Si les Données Personnelles détenues par GLOBAL'COPRO sont inexactes, il peut demander la mise à jour des informations, en écrivant à l’adresse électronique suivante : "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, {
      href: "mailto:dpo@mydtg.fr"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" dpo@mydtg.fr ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("; ")]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Il peut demander la suppression de ses Données Personnelles, conformément aux lois applicables en matière de protection des données, en écrivant à l’adresse électronique suivante : "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, {
      href: "mailto:dpo@mydtg.fr"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" dpo@mydtg.fr ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(". ")])])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_71, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-8-7-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8.7. Evolution de la présente clause ")]),
      _: 1
    }), _hoisted_72, _hoisted_73])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_74, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-9-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 9 - Imprévision ")]),
      _: 1
    }), _hoisted_75]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_76, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-10-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 10 - Responsabilité ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_77, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-10-1-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 10.1. Responsabilité de GLOBAL'COPRO ")]),
      _: 1
    }), _hoisted_78, _hoisted_79, _hoisted_80]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_81, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-10-2-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 10.2. Limites ")]),
      _: 1
    }), _hoisted_82, _hoisted_83, _hoisted_84])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_85, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-11-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 11 - Force majeure ")]),
      _: 1
    }), _hoisted_86, _hoisted_87, _hoisted_88, _hoisted_89, _hoisted_90]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_91, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-12-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 12 - Résiliation ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_92, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-12-1-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 12.1. Prise d’effet de la résiliation ")]),
      _: 1
    }), _hoisted_93]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_94, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-12-2-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 12.2. Conséquences de la résiliation ")]),
      _: 1
    }), _hoisted_95, _hoisted_96])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_97, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-13-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 13 - Litiges ")]),
      _: 1
    }), _hoisted_98, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_99, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-13-1-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 13-2 - Attribution de juridiction ")]),
      _: 1
    }), _hoisted_100])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_101, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-14-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 14 - Langue du contrat - Droit applicable ")]),
      _: 1
    }), _hoisted_102, _hoisted_103]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_104, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-15-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 15 - ELECTION DE DOMICILE ")]),
      _: 1
    }), _hoisted_105]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", _hoisted_106, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-16-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" ARTICLE 16 - Acceptation du Client ")]),
      _: 1
    }), _hoisted_107])]),
    _: 1
  });
}
;// ./src/components/organisms/terms-of-sales/component.vue?vue&type=template&id=01ee386a&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/terms-of-sales/component.vue?vue&type=script&lang=ts




/* harmony default export */ const terms_of_sales_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-terms-of-sales',
  components: {
    DtgDocumentPage: document_page_component,
    DtgTitle: title_component,
    DtgLink: link_component
  }
}));
;// ./src/components/organisms/terms-of-sales/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/terms-of-sales/component.vue




;
const terms_of_sales_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(terms_of_sales_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_01ee386a_ts_true_render]])

/* harmony default export */ const terms_of_sales_component = (terms_of_sales_component_exports_);
;// ./src/components/organisms/terms-of-sales/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/terms-of-service/component.vue?vue&type=template&id=35d6a3d0&ts=true

const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’utilisation de la Solution éditée par la société GLOBAL'COPRO implique sans réserve l’acceptation des dispositions suivantes par tout Utilisateur désirant bénéficier des Services de la Solution, la dernière version en date faisant foi. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_2 = {
  "aria-labelledby": "section-1-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La Solution est éditée par la société La société GLOBAL'COPRO Immatriculée au RCS de LILLE sous le numéro 929 673 937 et dont le siège social est sis à La Madeleine (59110) Euralliance A - 2 avenue de Kaarst, représentée par EX'IM GROUPE, agissant en qualité de Président, ayant tout pouvoir à l’effet des présentes. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_4 = {
  "aria-labelledby": "section-2-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les termes suivants qu'ils soient employés au singulier ou au pluriel dans les présentes auront toujours la définition suivante : ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_6 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dt", null, " « Compte Utilisateur » ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dd", null, " Désigne le compte créé par chaque Utilisateur, conformément à la procédure décrite à l’article 7.1 des présentes, et à partir duquel l’Utilisateur peut bénéficier des Services offerts par la Solution, conformément à la Licence d’utilisation décrite à l’Article 9 des présentes ; ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_8 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dt", null, " « Données » ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_9 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dd", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dfn", null, "Données de l’Utilisateur:"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" désignent toutes les Données Personnelles de l’Utilisateur, hébergées par EX'IM EXPERTISES, ainsi que toutes données sur lesquelles il déteint un droit de propriété intellectuelle, renseignées par ce dernier dans le cadre de l’utilisation des Services délivrés ; ")], -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_10 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dd", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dfn", null, "Données Personnelles :"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" désignent tous types d’information, de donnée et de contenu, collectés et traités dans le cadre de l’utilisation des Services délivrés par GLOBAL'COPRO, hébergées par GLOBAL'COPRO, qui, au sens de la loi Informatique et Liberté du 6 janvier 1978 (modifiée par le décret du 4 novembre 1991 et par la loi du 6 août 2004 transposant la directive 95/46/CE) et du Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016, permettent de désigner ou d'identifier, directement ou indirectement, une personne physique ; ")], -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dt", null, " « Services » ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dd", null, " Désigne l’ensemble des services que GLOBAL'COPRO s’engage à fournir aux Utilisateurs grâce à la Solution, dans les conditions et modalités des présentes CGU ; ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_13 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dt", null, " « Site » ou « Site internet » ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_14 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dt", null, "« Solution »", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_15 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dd", null, " MyDTG est une application web et mobile permettant d'optimiser les prestations de Diagnostic Technique global et de Projets de Plan Pluriannuels de Travaux. Elle est composée d'une application terrain nommée « MyDTG Terrain » (dans laquelle l’utilisateur saisit toutes les informations liées au DTG / PPPT lors de son intervention sur site) qui va lui permettre de générer automatiquement un rapport, complet et conforme. Elle est aussi composée d'une partie back-office nommée « MyDTG Manager » où toutes les informations sur l'intervention sont préalablement rentrées et où chaque utilisateur a un rôle défini ; ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_16 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dt", null, "« DTG »", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_17 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dd", null, " Désigne le document appelé, Diagnostic Technique Global qui informe les EX'IMpriétaires sur la situation générale de l’immeuble et permet d’envisager d’éventuels travaux au titre des articles L731-1et suivant du Code de la construction et de l’habitation; ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_18 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dt", null, "« PPPT »", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_19 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dd", null, " Désigne le document appelé Projet de Plan Pluriannuel de Travaux qui informe les copropriétaires sur la situation générale de l’immeuble et propose des scénarios de travaux à réaliser dans les parties communes de l'immeuble. Il est établi en se basant sur une étude de la structure du bâtiment, de ses équipements et éventuellement du diagnostic de performance énergétique (DPE) et/ou du diagnostic technique global (DTG). Selon Dispositions applicables aux éléments (Articles L443-7 à L443-15-5) du Code de la construction et de l'habitation; ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_20 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dt", null, "« Utilisateur »", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_21 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dd", null, " Désigne la personne physique ou morale inscrite sur la Solution et disposant d’un Compte Utilisateur, bénéficiant à ce titre d’une licence l’autorisant à utiliser la Solution en vue de bénéficier des Services de GLOBAL'COPRO, conformément à l’article 9 des présentes; ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_22 = {
  "aria-labelledby": "section-3-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_23 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les présentes Conditions Générales d’Utilisation (ci-après désignées les « CGU ») sont expressément agréées et acceptées par l’Utilisateur, qui déclare et reconnaît en avoir une parfaite connaissance. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_24 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " En tout état de cause, toute création de compte par GLOBAL'COPRO dans l’utilisation des Services offerts par la Solution soumet l’Utilisateur aux présentes CGU. L’Utilisateur est dès lors réputé accepter l’intégralité des règles stipulées aux présentes, ainsi que celles qui seraient présentes dans tout document disponible sur la Solution, intégré aux présentes CGU par référence et qui régissent sa relation avec les tiers et GLOBAL'COPRO. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_25 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les présentes CGU sont opposables pendant toute la durée d'utilisation de la Solution et jusqu'à ce que de nouvelles CGU remplacent les présentes. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_26 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’Utilisateur reconnaît également avoir consulté les mentions légales figurant sur la Solution préalablement à toute utilisation des services offerts via cette dernière. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_27 = {
  "aria-labelledby": "section-4-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_28 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’Utilisateur reconnaît que les enregistrements et sauvegardes (en ce compris toute donnée de connexion) réalisés via la Solution (ci-après les « Documents Electroniques ») auront pleine valeur probante entre l’Utilisateur et GLOBAL'COPRO. Ainsi, les Documents Electroniques (y compris leur date et heure) feront foi entre les parties à tout litige. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_29 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’Utilisateur reconnaît par conséquent, dans ses relations contractuelles avec GLOBAL'COPRO, la validité et la force probante des courriers électroniques. De même, les notifications effectuées via la Solution sont opposables à l’Utilisateur en tant qu’éléments de preuve. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_30 = {
  "aria-labelledby": "section-5-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_31 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ol", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " GLOBAL'COPRO se réserve le droit de modifier les présentes CGU, selon l’évolution technique de la Solution ainsi que de ses offres de services, ou en raison de l’évolution de la législation, à sa seule discrétion ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " D’une manière générale, l’utilisation de la Solution par l’Utilisateur est toujours soumise à la version la plus récente des CGU accessible au moment de cette utilisation. Il appartient à l’Utilisateur de consulter aussi souvent que nécessaire les CGU accessibles à partir de son Compte. ")], -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_32 = {
  "aria-labelledby": "section-6-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_33 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Toute violation des présentes CGU autorise GLOBAL'COPRO à refuser pour l’avenir à l’Utilisateur auteur de la violation considérée l’accès à la souscription d’Abonnements proposés sur la Solution, ainsi qu’à clôturer tout Compte Utilisateur permettant d’accéder aux Services, sans préjudice des indemnités qui pourraient être réclamées à l’auteur de ladite violation par GLOBAL'COPRO. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_34 = {
  "aria-labelledby": "section-7-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_35 = {
  "aria-labelledby": "section-7-1-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_36 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’utilisateur devra transmettre de bonne foi les informations ci-dessous nécessaires à la création de son compte administrateur. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_37 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Nom, prénom ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Fonction ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Société et adresse ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Téléphone portable ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Adresse email ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Formation ;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "Assurance;")], -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_38 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La collecte de ces données a pour finalité la création du compte administrateur. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_39 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " A la suite de la création du compte, GLOBAL'COPRO adresse alors à l’Utilisateur un email confirmant la création de son Compte, lequel contient un lien pour créer son mot de passe. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_40 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Puis l’Utilisateur certifie avoir lu et accepter les présentes CGU ainsi que la Politique de Confidentialité en cliquant sur le bouton dédié à cet effet. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_41 = {
  "aria-labelledby": "section-7-2-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_42 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’Utilisateur peut accéder à son Compte Utilisateur en s’authentifiant sur la Solution grâce à ses paramètres de connexion. Depuis cet espace, l’Utilisateur peut bénéficier des fonctionnalités notamment: ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_43 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Créer les rapports (DTG/PPPT) et les affecter au technicien et/ou validateur ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Accéder aux données de référencement de la copropriété ou du bâtiment étudié ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Remplir les champs spécifiques aux points de contrôles du bâtiment, aux pathologies éventuelles du bâtiment et les recommandations d’intervention qu'en découlent ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Editer des fiches techniques de synthèse ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Éditer les rapports DTG et PPPT de façon automatique une fois tous les champs complétés. ")], -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_44 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Il appartient à l’Utilisateur de vérifier la validité des informations renseignées lors de son authentification sur la Solution, notamment de l’adresse e-mail communiquée, dans la mesure où ces informations permettent l’identification de son Compte. En cas d’informations erronées, il se peut que l’Utilisateur ne soit pas en mesure d’accéder à son Compte, sans que la responsabilité en incombe à GLOBAL'COPRO. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_45 = {
  "aria-labelledby": "section-7-3-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_46 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Il appartient à chaque Utilisateur de choisir, dès sa première connexion puis de modifier de manière régulière, le code confidentiel qu’il a choisi en s’assurant que son code est composé de 8 caractères, avec un minimum de trois sur quatre des recommandations remplies: une majuscule, une minuscule, un chiffre, un caractère spécial. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_47 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Chaque Utilisateur a également l’obligation de maintenir la confidentialité de ses paramètres de connexion. A ce titre, il est rappelé que les paramètres de connexion de chaque Utilisateur sont à usage unique et strictement personnel. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_48 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’Utilisateur est responsable de toutes leurs utilisations, qu’il les ait ou non effectivement ou expressément autorisées. Il est interdit à l’Utilisateur de céder, prêter ou transférer ses paramètres de connexion à tout tiers ou de permettre à tout tiers de se connecter à son Compte. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_49 = {
  "aria-labelledby": "section-8-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_50 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " GLOBAL'COPRO met à la disposition de ses Utilisateurs une solution d’aide à la rédaction des DTG/PPPT soit par une application web soit mobile. L’utilisateur pourra saisir les informations liées au DTG ce qui lui permettra de générer automatiquement un rapport didactique, complet et conforme au code de la construction et de l’Habitation. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_51 = {
  "aria-labelledby": "section-9-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_52 = {
  "aria-labelledby": "section-9-1-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_53 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " GLOBAL'COPRO octroie à l’Utilisateur qui l’accepte, pour la durée d’utilisation de la Solution, le droit non exclusif, non transférable et non cessible d’utiliser la Solution, dans la stricte limite du Domaine d’Utilisation ci-après défini, sur le Territoire, dans le strict respect des dispositions figurant aux présentes (ci-après la « Licence »). ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_54 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’Utilisateur reconnaît expressément que tous les droits afférents aux éléments de la Solution demeurent la propriété exclusive de GLOBAL'COPRO. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_55 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’Utilisateur ne pourra les vendre, céder, publier, présenter, divulguer ou les mettre à disposition de tiers d’une quelconque autre manière. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_56 = {
  "aria-labelledby": "section-9-2-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_57 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La présente Licence est expressément limitée aux actes exclusivement nécessaires à l’utilisation de la Solution par l’Utilisateur. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_58 = {
  "aria-labelledby": "section-9-3-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_59 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’utilisation de la Solution éditée par GLOBAL'COPRO et mise à la disposition des Utilisateurs est soumise aux limitations décrites ci-après. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_60 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La présente Licence est strictement personnelle et l’Utilisateur ne pourra céder, transmettre ni déléguer les droits ou obligations qu’il détient au titre de la présente Licence sans l’accord écrit et préalable de GLOBAL'COPRO. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_61 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " A titre indicatif, GLOBAL'COPRO interdit à tout Utilisateur, sans son autorisation écrite, d’effectuer l’une des opérations suivantes : ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_62 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " effectuer une quelconque copie de tout ou partie des éléments de la Solution ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " reproduire de façon permanente ou provisoire la Solution mis à disposition, en tout ou partie, par tout moyen et sous toute forme ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " pratiquer l’ingénierie à rebours, décompiler ou désassembler les éléments de la Solution, les programme(s) informatique(s) et solution(s) logicielles, à l’exception de ce qui est expressément autorisé par la législation en vigueur ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " modifier, altérer, adapter ou apporter quelque changement de quelque nature que ce soit à la présentation et au contenu de la Solution, des programme(s) informatique(s) et solution(s) logicielles ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " Céder, communiquer ou proposer ses codes d'accès personnelles à autrui. L'accès à la solution MyDTG restant strictement personnel à chaque utilisateurs souscripteur "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " marque, nom commercial, logos etc. apposés sur la Solution, leur présentation, soit supprimer les mentions d’identification et de propriété de la Solution, notamment les noms des contributeurs ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " traduire, adapter, arranger ou modifier en tout ou partie de la Solution ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " supprimer ou altérer tels qu'ils peuvent apparaître sur les présentations ou dans le contenu de la Solution, des programme(s) informatique(s) et solutio (s) logicielles ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " accéder aux codes sources des logiciels composant la Solution ; "), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, " publier, sauf accord préalable écrit de GLOBAL'COPRO, tout test ou analyse de performance ou d’évaluation relatifs à la Solution. ")], -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_63 = {
  "aria-labelledby": "section-9-4-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_64 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Une fois concédée, la présente Licence est octroyée pour la durée d’utilisation de la Solution. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_65 = {
  "aria-labelledby": "section-9-5-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_66 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La présente Licence est expressément limitée par les Parties aux territoires du Monde entier. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_67 = {
  "aria-labelledby": "section-10-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_68 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le recours et le maintien de tout équipement, informatique, téléphonique et autre équipement nécessaire pour accéder à la Solution est de la responsabilité de l’Utilisateur qui en supportera seul les coûts. GLOBAL'COPRO ne sera pas tenue responsable en cas de dommage à tout équipement dans le cadre de l’utilisation de la Solution. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_69 = {
  "aria-labelledby": "section-11-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_70 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Les engagements de GLOBAL'COPRO s’agissant de la collecte, du traitement, de la sécurisation, de la conservation des Données Personnelles de l’Utilisateur et les modalités de mise en œuvre des droits de ce dernier sont déterminés à la Politique de Confidentialité de EX'IM EXPERTISES, accessible sur le Site. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_71 = {
  "aria-labelledby": "section-12-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_72 = {
  "aria-labelledby": "section-12-1-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_73 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " GLOBAL'COPRO conserve la propriété de tous les droits de propriété intellectuelle qui sont utilisées pour faire fonctionner la Solution, et plus généralement tous les éléments reproduits ou utilisés sur la Solution sont protégés au titre de la propriété intellectuelle (les « Eléments »). ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_74 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Toute reproduction, représentation, utilisation ou adaptation, sous quelque forme que ce soit, de tout ou partie de ces Eléments, sans l'accord préalable et écrit de GLOBAL'COPRO, sont strictement interdites. Le fait pour GLOBAL'COPRO de ne pas engager de procédure dès la prise de connaissance de ces utilisations non autorisées ne vaut pas acceptation desdites utilisations et renonciation aux poursuites. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_75 = {
  "aria-labelledby": "section-12-2-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_76 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La Solution respecte le droit d'auteur, ainsi que les droits voisins (ci-après les « Droits d’Auteur »). Tous les Droits d’Auteur des œuvres protégées reproduites et communiquées sur la Solution sont réservés pour le monde entier. Sauf autorisation, toute utilisation des œuvres autres que la reproduction et la consultation individuelles et privées sont interdites. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_77 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La reproduction (impression) des pages de la Solution sur un support papier est autorisée pour un usage strictement privé et non commercial. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_78 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " La reproduction de tout ou partie de la Solution sur un support électronique est interdite. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_79 = {
  "aria-labelledby": "section-12-3-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_80 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Toutes les marques et autres droits de propriété intellectuelle sur tout contenu de la Solution (incluant notamment les informations, textes, images, droits d’auteur, dessins et modèles) et sur la structure de la Solution appartiennent à GLOBAL'COPRO. Aucune utilisation de ce contenu et des droits de propriété intellectuelle y afférant n'est autorisée sans avoir préalablement requis le consentement écrit et exprès de GLOBAL'COPRO. Tous ces droits sont expressément réservés. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_81 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’Utilisateur s'engage à respecter les droits de propriété intellectuelle de GLOBAL'COPRO sur chacun des éléments constituant la Solution de GLOBAL'COPRO et à faire respecter ces droits par les tiers. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_82 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’Utilisateur s'engage à informer sans délai EX'IM EXPERTISES de toute atteinte aux droits de propriété intellectuelle de ce dernier qu'il pourra éventuellement constater. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_83 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " L’Utilisateur reconnaît et accepte que l’accès à la Solution, et aux programme(s) informatique(s) et solution(s) logicielles mis à sa disposition par EX'IM EXPERTISES ne saurait emporter une quelconque cession ou concession des droits de propriété intellectuelle (droits sur les marques ou droits d’auteurs notamment) et autres droits au bénéfice de l’Utilisateur. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_84 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Il est donc strictement interdit de reproduire, distribuer, transmettre, publier, permettre l’accès par un lien ou un lien hypertexte, ou de modifier, adapter ou corriger la Solution de quelque façon que ce soit sans l’autorisation expresse écrite de GLOBAL'COPRO. Tout manquement à la présente clause peut engendrer une violation de droit d’auteur, de marque ou autre droit de propriété intellectuelle pouvant exposer l’Utilisateur à des sanctions civiles et/ou pénales. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_85 = {
  "aria-labelledby": "section-13-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_86 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Tous les préavis et notifications prévus dans ce Contrat devront être envoyés à l'adresse donnée en tête de ce document s’agissant de GLOBAL'COPRO, et à l’adresse renseignée par l’Utilisateur lors de son inscription à la Solution, régulièrement mise à jour le cas échéant, conformément aux prescriptions des présentes. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_87 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Toutes notifications effectuées en application des présentes seront valablement effectuées et seront considérées comme reçues dans les conditions suivantes: ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_88 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "e-mail - au jour d'envoi;"), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, "lettre recommandée AR - le lendemain de la date portée sur l’accusé de réception.")], -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_89 = {
  "aria-labelledby": "section-14-title"
};
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_90 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Le Contrat est soumis au droit Français. ", -1);
const componentvue_type_template_id_35d6a3d0_ts_true_hoisted_91 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, " Tous différends relatifs au présent Contrat seront portés à la connaissance du Tribunal de Commerce de LILLE. ", -1);
function componentvue_type_template_id_35d6a3d0_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  const _component_dtg_link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-link");
  const _component_dtg_document_page = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-document-page");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_document_page, {
    title: "CONDITIONS GENERALES D’UTILISATION"
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [componentvue_type_template_id_35d6a3d0_ts_true_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-1-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 1. Identification légale ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_3]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-2-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 2. Définitions ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_5, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dl", null, [componentvue_type_template_id_35d6a3d0_ts_true_hoisted_6, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_7, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_8, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_9, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_10, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_11, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_12, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_13, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("dd", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" Désigne le site internet localisé à l’URL "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, {
      href: "https://www.mydtg.fr/"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" https://www.mydtg.fr/ ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" pour le site vitrine et, "), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_link, {
      href: "https://app.mydtg.fr/"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" https://app.mydtg.fr/ ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" pour l’application MyDTG; ")]), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_14, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_15, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_16, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_17, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_18, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_19, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_20, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_21])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_22, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-3-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 3. Acceptation de l’Utilisateur - Mise en garde ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_23, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_24, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_25, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_26]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_27, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-4-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 4. Convention de preuve ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_28, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_29]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_30, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-5-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 5. Evolutions ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_31]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_32, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-6-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 6. Violation ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_33]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_34, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-7-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 7. Compte Utilisateur ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_35, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-7-1-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 7.1. Inscription ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_36, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_37, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_38, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_39, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_40]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_41, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-7-2-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 7.2. Mise à disposition du Compte Utilisateur ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_42, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_43, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_44]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_45, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-7-3-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 7.3. Responsabilité des paramètres de connexion ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_46, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_47, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_48])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_49, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-8-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 8. Description générale des Services ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_50]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_51, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-9-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 9. Licence d’utilisation des éléments de la Solution ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_52, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-9-1-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 9.1. Etendue des droits concédés ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_53, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_54, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_55]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_56, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-9-2-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 9.2. Domaine d’Utilisation ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_57]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_58, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-9-3-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 9.3. Restrictions à l’utilisation ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_59, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_60, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_61, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_62]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_63, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-9-4-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 9.4. Durée ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_64]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_65, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-9-5-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 9.5. Territoires ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_66])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_67, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-10-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 10. Equipements ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_68]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_69, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-11-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 11. Données Personnelles ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_70]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_71, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-12-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 12. Propriété intellectuelle ")]),
      _: 1
    }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_72, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-12-1-title\"",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 12.1. Respect des droits de propriété intellectuelle ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_73, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_74]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_75, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-12-2-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 12.2. Respect du Droit d’auteur - Copyright © - Liens (appartenant à GLOBAL'COPRO ou à ses partenaires) ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_76, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "4"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 12.2.1. Reproduction sur support papier ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_77, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      view: "4"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 12.2.2. Reproduction sur support électronique ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_78]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_79, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-12-3-title",
      view: "3"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 12.3. Limitations ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_80, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_81, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_82, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_83, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_84])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_85, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-13-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 13. Notifications ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_86, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_87, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_88]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("section", componentvue_type_template_id_35d6a3d0_ts_true_hoisted_89, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_title, {
      id: "section-14-title",
      view: "2"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" 14. Litige et juridiction ")]),
      _: 1
    }), componentvue_type_template_id_35d6a3d0_ts_true_hoisted_90, componentvue_type_template_id_35d6a3d0_ts_true_hoisted_91])]),
    _: 1
  });
}
;// ./src/components/organisms/terms-of-service/component.vue?vue&type=template&id=35d6a3d0&ts=true

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/organisms/terms-of-service/component.vue?vue&type=script&lang=ts




/* harmony default export */ const terms_of_service_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: 'dtg-terms-of-service',
  components: {
    DtgDocumentPage: document_page_component,
    DtgTitle: title_component,
    DtgLink: link_component
  }
}));
;// ./src/components/organisms/terms-of-service/component.vue?vue&type=script&lang=ts
 
;// ./src/components/organisms/terms-of-service/component.vue




;
const terms_of_service_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(terms_of_service_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_35d6a3d0_ts_true_render]])

/* harmony default export */ const terms_of_service_component = (terms_of_service_component_exports_);
;// ./src/components/organisms/terms-of-service/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/layouts/layout-auth/component.vue?vue&type=template&id=2ddcdabd&ts=true

const componentvue_type_template_id_2ddcdabd_ts_true_hoisted_1 = ["src"];
function componentvue_type_template_id_2ddcdabd_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_title = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-title");
  const _component_dtg_divider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-divider");
  const _component_dtg_content = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-content");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_content, {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b()),
    "scrollable-class": _ctx.b('scrollable')
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('inner'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "before-title", {}, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('logo-wrapper'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('logo')),
      src: _ctx.logoUrl,
      alt: "MyDTG Manager"
    }, null, 10, componentvue_type_template_id_2ddcdabd_ts_true_hoisted_1)], 2)]), _ctx.$slots.title ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_title, {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('title'))
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "title")]),
      _: 3
    }, 8, ["class"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default"), _ctx.$slots.footer ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: 1
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dtg_divider, {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('divider'))
    }, null, 8, ["class"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("footer", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('footer'))
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "footer")], 2)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)], 2)]),
    _: 3
  }, 8, ["class", "scrollable-class"]);
}
;// ./src/components/layouts/layout-auth/component.vue?vue&type=template&id=2ddcdabd&ts=true

;// ./src/components/layouts/layout-auth/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const layout_auth_style_module = ({"dtg-layout-auth__scrollable":"lib_dtg-layout-auth__scrollable_WEM1g","dtg-layout-auth__inner":"lib_dtg-layout-auth__inner_UMyEb","dtg-layout-auth__content":"lib_dtg-layout-auth__content_EVgWt","dtg-layout-auth__logo-wrapper":"lib_dtg-layout-auth__logo-wrapper_tijL_","dtg-layout-auth__logo":"lib_dtg-layout-auth__logo_G5cIv","dtg-layout-auth__title":"lib_dtg-layout-auth__title_jXWWj","dtg-layout-auth":"lib_dtg-layout-auth_QpRT1","dtg-layout-auth__divider":"lib_dtg-layout-auth__divider_Xk1J5","dtg-layout-auth__footer":"lib_dtg-layout-auth__footer_Zl3Cp"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/layouts/layout-auth/component.vue?vue&type=script&lang=ts






/* harmony default export */ const layout_auth_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(layout_auth_style_module),
  components: {
    DtgTitle: title_component,
    DtgDivider: divider_component,
    DtgContent: content_component
  },
  props: {
    logoUrl: {
      type: String,
      default: '/assets/icon/app_logo.svg'
    },
    logoAlt: {
      type: String,
      default: ''
    }
  },
  setup() {
    return {
      b: useBem(layout_auth_style_module)
    };
  }
}));
;// ./src/components/layouts/layout-auth/component.vue?vue&type=script&lang=ts
 
;// ./src/components/layouts/layout-auth/component.vue




;
const layout_auth_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(layout_auth_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_2ddcdabd_ts_true_render]])

/* harmony default export */ const layout_auth_component = (layout_auth_component_exports_);
;// ./src/components/layouts/layout-auth/index.ts


;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/layouts/layout-storybook/component.vue?vue&type=template&id=33b85447&ts=true

function componentvue_type_template_id_33b85447_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dtg_content = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dtg-content");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDynamicComponent)(_ctx.rootComponent), {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([_ctx.b(), _ctx.rootClass])
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [_ctx.noWrapper ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {
      key: 0
    }) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dtg_content, {
      key: 1
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('content-inner', {
          view: _ctx.view
        }))
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.b('story-wrapper'))
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)], 2)]),
      _: 3
    }))]),
    _: 3
  }, 8, ["class"]);
}
;// ./src/components/layouts/layout-storybook/component.vue?vue&type=template&id=33b85447&ts=true

// EXTERNAL MODULE: external "lodash/omit"
var omit_ = __webpack_require__(3895);
;// ../storybook/controls/types.ts
// https://storybook.js.org/docs/react/essentials/controls#annotation
var StoryControlType;
(function (StoryControlType) {
  StoryControlType["text"] = "text";
  StoryControlType["boolean"] = "boolean";
  StoryControlType["number"] = "number";
  StoryControlType["range"] = "range";
  StoryControlType["object"] = "object";
  StoryControlType["array"] = "array";
  StoryControlType["file"] = "file";
  StoryControlType["enum"] = "enum";
  StoryControlType["radio"] = "radio";
  StoryControlType["inlineRadio"] = "inline-radio";
  StoryControlType["check"] = "check";
  StoryControlType["inlineCheck"] = "inline-check";
  StoryControlType["select"] = "select";
  StoryControlType["multiSelect"] = "multi-select";
  StoryControlType["color"] = "color";
  StoryControlType["date"] = "date";
})(StoryControlType || (StoryControlType = {}));
;// ../design/styles/exports/_colors.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const _colors = ({"green":"#1e3758","turquoise":"#6a94cc","java":"#335d95","grey":"#333","whiteSmoke":"#f7f7f7","white":"#fff","blackPerl":"#0e1a1f","tangerine":"#f9ba21","speechRed":"#d12335","forest":"#05cc7f","lynch":"#757d83","zircon":"#d9e3e5"});
;// ../storybook/controls/index.ts
/* unused harmony import specifier */ var StoryCategory;
/* unused harmony import specifier */ var controls_StoryControlType;
/* unused harmony import specifier */ var colors;




function presetColorsControl() {
  const presetColors = Object.entries(colors).map(([label, color]) => ({
    label,
    color
  }));
  return {
    control: {
      type: controls_StoryControlType.color,
      presetColors
    }
  };
}
function enumControl(object, control = controls_StoryControlType.inlineRadio, labels) {
  return optionsControl(Object.values(object), control, labels);
}
function optionsControl(keys, control = controls_StoryControlType.select, labels) {
  return {
    options: keys,
    control: {
      type: control,
      labels
    }
  };
}
function disabledControl() {
  return {
    control: null
  };
}
function hiddenControl() {
  return {
    table: {
      disable: true
    }
  };
}
function slotControl(control = controls_StoryControlType.text) {
  return {
    control,
    table: {
      category: StoryCategory.slots
    }
  };
}
;// ../storybook/story/types.ts
/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/ban-types */
const storyViews = ['centered', 'centered-v', 'centered-h', 'fullscreen', 'padded', 'none', 'no-wrapper', 'no-app'];
var types_StoryCategory;
(function (StoryCategory) {
  StoryCategory["props"] = "props";
  StoryCategory["slots"] = "slots";
  StoryCategory["events"] = "events";
})(types_StoryCategory || (types_StoryCategory = {}));
;// ../storybook/story/index.ts
/* unused harmony import specifier */ var omit;
/* unused harmony import specifier */ var ref;
/* unused harmony import specifier */ var eventToPropName;
/* unused harmony import specifier */ var objFromEntries;
/* unused harmony import specifier */ var objEntries;
/* unused harmony import specifier */ var isPropValidator;
/* unused harmony import specifier */ var truthy;
/* unused harmony import specifier */ var story_disabledControl;
/* unused harmony import specifier */ var story_optionsControl;
/* unused harmony import specifier */ var story_enumControl;
/* unused harmony import specifier */ var story_StoryControlType;
/* unused harmony import specifier */ var story_hiddenControl;
/* unused harmony import specifier */ var story_StoryCategory;
/* eslint-disable @typescript-eslint/explicit-function-return-type,@typescript-eslint/ban-types */









function defineStory(options) {
  const template = 'wrapper' in options ? options.wrapper : defaultStoryWrapper(options);
  return {
    template: (args, context = {}) => {
      const story = template.bind({});
      Object.assign(story, {
        ...context,
        args
      });
      return story;
    },
    meta: storyMeta(options)
  };
}
// Makes it possible to infer nested props and events of a component that uses inheritAttrs: true
// The first component is the base one
function combineProps(components, omitProps) {
  const [baseComponent] = components;
  // We don't want to change the component's props and events, since that would break it
  // Instead, we save components, that the base component wraps, to use when inferring prop and event types
  baseComponent.combinedComponents = components.slice(1);
  baseComponent.omitProps = omitProps;
  // But for typescript we say that this component has the props of all of its wrapped components
  return baseComponent;
}
function defaultStoryWrapper({
  component,
  components,
  template
}) {
  const {
    name
  } = component;
  return args => ({
    components: {
      [name]: component,
      ...components
    },
    setup() {
      const modelValue = ref(args.modelValue);
      return {
        args,
        modelValue
      };
    },
    template: template ?? `<${name} v-bind="args" v-model="modelValue">
                 <template #default v-if="args.default">{{ args.default }}</template>
             </${name}>`
  });
}
function storyMeta({
  component,
  meta
}) {
  const components = [component, ...(component.combinedComponents ?? [])].reverse();
  const argTypes = components.reduce((argTypes, subComponent) => {
    const props = subComponent.props ?? {};
    const omitProps = component.omitProps ?? [];
    const emits = subComponent.emits;
    const propsWithoutOmitted = omit(props, ...omitProps);
    const actions = extractActions(emits);
    const propArgTypes = extractArgTypes(propsWithoutOmitted, meta.argTypes);
    Object.assign(argTypes, {
      ...propArgTypes,
      ...actions
    });
    return argTypes;
  }, {});
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const args = {
    ...meta.args,
    ...meta.extraArgs
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const decorators = meta.decorators;
  return {
    ...meta,
    decorators,
    args,
    component,
    argTypes
  };
}
function extractArgTypes(props, argTypes) {
  const propArgTypes = objFromEntries(objEntries(props).map(([key, prop]) => {
    const customArgType = argTypes?.[key];
    return [key, buildArgType(prop, customArgType)];
  }));
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return {
    ...argTypes,
    ...propArgTypes
  };
}
// eslint-disable-next-line complexity
function buildArgType(prop, custom) {
  // We only handle cases where props are fully defined ({ type, required/default, validator })
  if (Array.isArray(prop) || typeof prop !== 'object' || !prop.type || typeof prop.type === 'boolean') {
    return story_disabledControl();
  }
  const argType = custom ?? buildControl(prop);
  if ('default' in prop) {
    argType.table = {
      ...argType.table,
      defaultValue: argType.table?.defaultValue ?? {
        summary: JSON.stringify(prop.default)
      }
    };
  }
  return argType;
}
// eslint-disable-next-line complexity
function buildControl(prop) {
  if (isPropValidator(prop.validator)) {
    const {
      options
    } = prop.validator;
    if (Array.isArray(options)) {
      return story_optionsControl(options);
    } else if (typeof options === 'object' && truthy(options)) {
      return story_enumControl(options);
    }
  }
  const type = Array.isArray(prop.type) ? prop.type[0] : prop.type;
  switch (type) {
    case Boolean:
      return {
        control: story_StoryControlType.boolean
      };
    case Number:
      return {
        control: story_StoryControlType.number
      };
    case String:
      return {
        control: story_StoryControlType.text
      };
    case Object:
      return {
        control: story_StoryControlType.object
      };
    case Array:
      return {
        control: story_StoryControlType.array
      };
    case Date:
      return {
        control: story_StoryControlType.date
      };
    default:
      return story_disabledControl();
  }
}
function extractActions(emits) {
  if (!emits) {
    return {};
  }
  const events = Array.isArray(emits) ? emits : Object.keys(emits);
  const actions = events.map(event => {
    const propName = eventToPropName(event);
    // Configure a custom argType
    const argType = [propName, {
      name: event,
      action: event,
      table: {
        category: story_StoryCategory.events
      }
    }];
    // Disable inferred argType
    const artTypeOverride = [event, story_hiddenControl()];
    return [argType, artTypeOverride];
  });
  const actionEntries = actions.flat();
  return objFromEntries(actionEntries);
}
;// ../storybook/index.ts


;// ./src/components/layouts/layout-storybook/style.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const layout_storybook_style_module = ({"dtg-layout-storybook":"lib_dtg-layout-storybook_o1ozC","dtg-layout-storybook__content-inner":"lib_dtg-layout-storybook__content-inner_bPEi8","dtg-layout-storybook__content-inner_view_none":"lib_dtg-layout-storybook__content-inner_view_none_Wmst4","dtg-layout-storybook__story-wrapper":"lib_dtg-layout-storybook__story-wrapper_Z1Adu","dtg-layout-storybook__content-inner_view_centered":"lib_dtg-layout-storybook__content-inner_view_centered_tOjjb","dtg-layout-storybook__content-inner_view_centered-v":"lib_dtg-layout-storybook__content-inner_view_centered-v_SXM4t","dtg-layout-storybook__content-inner_view_centered-h":"lib_dtg-layout-storybook__content-inner_view_centered-h__9Fz4","dtg-layout-storybook__content-inner_view_padded":"lib_dtg-layout-storybook__content-inner_view_padded_JJRFW"});
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/babel-loader/lib/index.js!../../node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/layouts/layout-storybook/component.vue?vue&type=script&lang=ts







/* harmony default export */ const layout_storybook_componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: getName(layout_storybook_style_module),
  components: {
    IonApp: vue_.IonApp,
    DtgContent: content_component
  },
  props: {
    view: {
      type: String,
      default: 'centered',
      validator: inArray(storyViews)
    }
  },
  setup(props) {
    const noWrapper = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ['no-wrapper', 'no-app'].includes(props.view));
    const rootComponent = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.view === 'no-app' ? 'div' : 'ion-app');
    const rootClass = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.view === 'no-app' ? '' : 'ion-page');
    return {
      b: useBem(layout_storybook_style_module),
      noWrapper,
      rootComponent,
      rootClass
    };
  }
}));
;// ./src/components/layouts/layout-storybook/component.vue?vue&type=script&lang=ts
 
;// ./src/components/layouts/layout-storybook/component.vue




;
const layout_storybook_component_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(layout_storybook_componentvue_type_script_lang_ts, [['render',componentvue_type_template_id_33b85447_ts_true_render]])

/* harmony default export */ const layout_storybook_component = (layout_storybook_component_exports_);
;// ./src/components/layouts/layout-storybook/index.ts


;// ./src/composables/use-element-position.ts




// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useElementPosition() {
  const targetRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
  const targetTop = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(0);
  const targetBottom = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(0);
  const {
    scrollTop
  } = useScroll();
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(targetRef, async () => {
    await (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)();
    await (0,double_raf_.raf)();
    updateTargetPosition();
  }, {
    flush: 'post'
  });
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(scrollTop, updateTargetPosition);
  function updateTargetPosition() {
    const targetEl = (0,get_element_from_ref_.getElementFromRef)(targetRef.value);
    if (!targetEl) {
      return;
    }
    const rect = targetEl.getBoundingClientRect();
    targetTop.value = rect.top;
    targetBottom.value = rect.bottom;
  }
  return {
    targetRef,
    targetTop,
    targetBottom
  };
}
;// ./src/composables/use-hover.ts


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useHover(elementRef) {
  const hovered = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
  const elementRefInternal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => (0,get_element_from_ref_.getElementFromRef)(elementRef.value));
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
    const element = elementRefInternal.value;
    if (element) {
      element.addEventListener('mouseenter', onMouseEnter);
      element.addEventListener('mouseleave', onMouseLeave);
    }
  });
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onUnmounted)(() => {
    const element = elementRefInternal.value;
    if (element) {
      element.removeEventListener('mouseenter', onMouseEnter);
      element.removeEventListener('mouseleave', onMouseLeave);
    }
  });
  function onMouseEnter() {
    hovered.value = true;
  }
  function onMouseLeave() {
    hovered.value = false;
  }
  return {
    hovered: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.readonly)(hovered)
  };
}
// EXTERNAL MODULE: external "vue-router/dist/vue-router.mjs"
var vue_router_mjs_ = __webpack_require__(4076);
;// ./src/composables/use-navigation-guards.ts


let guardCounter = 0;
let guardChecks = [];
// eslint-disable-next-line func-style
const guardExternal = event => {
  if (guardChecks.some(check => check.value)) {
    event.preventDefault();
    event.returnValue = true;
  }
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useExternalNavigationGuard(shouldGuard) {
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
    guardChecks.push(shouldGuard);
    if (guardCounter === 0) {
      window.addEventListener('beforeunload', guardExternal);
    }
    guardCounter += 1;
  });
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeUnmount)(() => {
    guardChecks = guardChecks.filter(check => check !== shouldGuard);
    guardCounter = Math.max(guardCounter - 1, 0);
    if (guardCounter === 0) {
      window.removeEventListener('beforeunload', guardExternal);
    }
  });
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useInternalNavigationGuard(shouldGuard, onLeave = defaultOnLeave) {
  // eslint-disable-next-line func-style
  const guardInternal = (to, from) => {
    const shouldGuardResult = typeof shouldGuard === 'function' ? shouldGuard(to, from) : shouldGuard.value;
    return shouldGuardResult ? onLeave() : true;
  };
  (0,vue_router_mjs_.onBeforeRouteLeave)(guardInternal);
}
function defaultOnLeave() {
  // eslint-disable-next-line no-alert
  return window.confirm('Quitter cette page\xa0? Les modifications que vous avez apportées ne seront peut-être pas enregistrées.');
}
;// ./src/composables/use-scroll-restoration/composable.ts





const currentPosition = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(-1);
const storedScrollPositions = new Map();
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useScrollRestoration() {
  const {
    setScroll,
    scrollTop
  } = useScroll();
  const router = (0,vue_router_mjs_.useRouter)();
  let watchers = [];
  function init() {
    destroy();
    watchers = [router.beforeEach((to, from) => {
      saveScrollPosition(from.fullPath);
    }), router.afterEach(async (to, from) => {
      let position = -1;
      const {
        state
      } = window.history;
      if (typeof state === 'object' && (0,truthy_.truthy)(state)) {
        const parsedPosition = Number(state.position);
        position = isNaN(parsedPosition) ? -1 : parsedPosition;
      }
      currentPosition.value = position;
      const savedScroll = getSavedScrollPosition(to.fullPath, position);
      if (savedScroll || to.name !== from.name) {
        await (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)();
        await (0,double_raf_.raf)();
        setScroll({
          left: 0,
          top: savedScroll
        });
      }
    })];
  }
  function destroy() {
    watchers.forEach(unwatch => {
      unwatch();
    });
    watchers = [];
  }
  function buildKey(name, position) {
    return `${name}-${position.toString()}`;
  }
  function getSavedScrollPosition(name, position) {
    const key = buildKey(name, position);
    const scroll = storedScrollPositions.get(key);
    if (typeof scroll !== 'undefined') {
      storedScrollPositions.delete(key);
      return scroll;
    }
    return 0;
  }
  function saveScrollPosition(name) {
    if (scrollTop.value === 0) {
      return;
    }
    const key = buildKey(name, currentPosition.value);
    storedScrollPositions.set(key, scrollTop.value);
  }
  return {
    init,
    destroy
  };
}
;// ./src/composables/use-scroll-restoration/index.ts


;// ./src/composables/use-scroll-sidebar.ts




// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useScrollSidebar({
  scrollPosition,
  activeIndex,
  root
}) {
  const {
    refs,
    setRefByIndex
  } = useTemplateRefsArray();
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(async () => {
    await (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)();
    loadScroll();
    scrollToCurrentItem();
  });
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onActivated)(() => {
    loadScroll();
    scrollToCurrentItem();
  });
  function onScroll() {
    saveScroll();
  }
  function saveScroll() {
    if (root.value) {
      scrollPosition.value = {
        top: root.value.scrollTop,
        left: root.value.scrollLeft
      };
    }
  }
  function loadScroll() {
    if (root.value) {
      root.value.scrollTop = scrollPosition.value.top;
      root.value.scrollLeft = scrollPosition.value.left;
    }
  }
  function scrollToCurrentItem() {
    const ref = refs.value[activeIndex.value];
    if (ref) {
      void (0,scroll_.scrollIntoView)(ref, {
        boundary: (0,get_element_from_ref_.getElementFromRef)(root.value)
      });
    }
  }
  return {
    setRefByIndex,
    onScroll,
    scrollToCurrentItem
  };
}
;// ./src/index.ts

































































































































;// ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=dtg-components.umd.js.map